(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode('.ag-icon{font-family:var(--ag-icon-font-family);font-weight:var(--ag-icon-font-weight);color:var(--ag-icon-font-color);font-size:var(--ag-icon-size);line-height:var(--ag-icon-size);font-style:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:var(--ag-icon-size);height:var(--ag-icon-size);position:relative}.ag-icon:before{content:""}.ag-icon:after{background:transparent var(--ag-icon-image, none) center/contain no-repeat;display:var(--ag-icon-image-display);opacity:var(--ag-icon-image-opacity, .9);position:absolute;top:0;right:0;bottom:0;left:0;content:""}.ag-icon-aggregation{font-family:var(--ag-icon-font-family-aggregation, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-aggregation, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-aggregation, var(--ag-icon-font-color))}.ag-icon-aggregation:before{content:var(--ag-icon-font-code-aggregation, "");display:var(--ag-icon-font-display-aggregation, var(--ag-icon-font-display))}.ag-icon-aggregation:after{background-image:var(--ag-icon-image-aggregation, var(--ag-icon-image));display:var(--ag-icon-image-display-aggregation, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-aggregation, var(--ag-icon-image-opacity, .9))}.ag-icon-arrows{font-family:var(--ag-icon-font-family-arrows, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-arrows, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-arrows, var(--ag-icon-font-color))}.ag-icon-arrows:before{content:var(--ag-icon-font-code-arrows, "");display:var(--ag-icon-font-display-arrows, var(--ag-icon-font-display))}.ag-icon-arrows:after{background-image:var(--ag-icon-image-arrows, var(--ag-icon-image));display:var(--ag-icon-image-display-arrows, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-arrows, var(--ag-icon-image-opacity, .9))}.ag-icon-asc{font-family:var(--ag-icon-font-family-asc, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-asc, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-asc, var(--ag-icon-font-color))}.ag-icon-asc:before{content:var(--ag-icon-font-code-asc, "");display:var(--ag-icon-font-display-asc, var(--ag-icon-font-display))}.ag-icon-asc:after{background-image:var(--ag-icon-image-asc, var(--ag-icon-image));display:var(--ag-icon-image-display-asc, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-asc, var(--ag-icon-image-opacity, .9))}.ag-icon-cancel{font-family:var(--ag-icon-font-family-cancel, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-cancel, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-cancel, var(--ag-icon-font-color))}.ag-icon-cancel:before{content:var(--ag-icon-font-code-cancel, "");display:var(--ag-icon-font-display-cancel, var(--ag-icon-font-display))}.ag-icon-cancel:after{background-image:var(--ag-icon-image-cancel, var(--ag-icon-image));display:var(--ag-icon-image-display-cancel, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-cancel, var(--ag-icon-image-opacity, .9))}.ag-icon-chart{font-family:var(--ag-icon-font-family-chart, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-chart, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-chart, var(--ag-icon-font-color))}.ag-icon-chart:before{content:var(--ag-icon-font-code-chart, "");display:var(--ag-icon-font-display-chart, var(--ag-icon-font-display))}.ag-icon-chart:after{background-image:var(--ag-icon-image-chart, var(--ag-icon-image));display:var(--ag-icon-image-display-chart, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-chart, var(--ag-icon-image-opacity, .9))}.ag-icon-checkbox-checked{font-family:var(--ag-icon-font-family-checkbox-checked, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-checkbox-checked, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-checkbox-checked, var(--ag-icon-font-color))}.ag-icon-checkbox-checked:before{content:var(--ag-icon-font-code-checkbox-checked, "");display:var(--ag-icon-font-display-checkbox-checked, var(--ag-icon-font-display))}.ag-icon-checkbox-checked:after{background-image:var(--ag-icon-image-checkbox-checked, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-checked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-checked, var(--ag-icon-image-opacity, .9))}.ag-icon-checkbox-indeterminate{font-family:var(--ag-icon-font-family-checkbox-indeterminate, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-checkbox-indeterminate, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-checkbox-indeterminate, var(--ag-icon-font-color))}.ag-icon-checkbox-indeterminate:before{content:var(--ag-icon-font-code-checkbox-indeterminate, "");display:var(--ag-icon-font-display-checkbox-indeterminate, var(--ag-icon-font-display))}.ag-icon-checkbox-indeterminate:after{background-image:var(--ag-icon-image-checkbox-indeterminate, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-indeterminate, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-indeterminate, var(--ag-icon-image-opacity, .9))}.ag-icon-checkbox-unchecked{font-family:var(--ag-icon-font-family-checkbox-unchecked, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-checkbox-unchecked, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-checkbox-unchecked, var(--ag-icon-font-color))}.ag-icon-checkbox-unchecked:before{content:var(--ag-icon-font-code-checkbox-unchecked, "");display:var(--ag-icon-font-display-checkbox-unchecked, var(--ag-icon-font-display))}.ag-icon-checkbox-unchecked:after{background-image:var(--ag-icon-image-checkbox-unchecked, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-unchecked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-unchecked, var(--ag-icon-image-opacity, .9))}.ag-icon-color-picker{font-family:var(--ag-icon-font-family-color-picker, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-color-picker, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-color-picker, var(--ag-icon-font-color))}.ag-icon-color-picker:before{content:var(--ag-icon-font-code-color-picker, "");display:var(--ag-icon-font-display-color-picker, var(--ag-icon-font-display))}.ag-icon-color-picker:after{background-image:var(--ag-icon-image-color-picker, var(--ag-icon-image));display:var(--ag-icon-image-display-color-picker, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-color-picker, var(--ag-icon-image-opacity, .9))}.ag-icon-columns{font-family:var(--ag-icon-font-family-columns, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-columns, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-columns, var(--ag-icon-font-color))}.ag-icon-columns:before{content:var(--ag-icon-font-code-columns, "");display:var(--ag-icon-font-display-columns, var(--ag-icon-font-display))}.ag-icon-columns:after{background-image:var(--ag-icon-image-columns, var(--ag-icon-image));display:var(--ag-icon-image-display-columns, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-columns, var(--ag-icon-image-opacity, .9))}.ag-icon-contracted{font-family:var(--ag-icon-font-family-contracted, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-contracted, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-contracted, var(--ag-icon-font-color))}.ag-icon-contracted:before{content:var(--ag-icon-font-code-contracted, "");display:var(--ag-icon-font-display-contracted, var(--ag-icon-font-display))}.ag-icon-contracted:after{background-image:var(--ag-icon-image-contracted, var(--ag-icon-image));display:var(--ag-icon-image-display-contracted, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-contracted, var(--ag-icon-image-opacity, .9))}.ag-icon-copy{font-family:var(--ag-icon-font-family-copy, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-copy, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-copy, var(--ag-icon-font-color))}.ag-icon-copy:before{content:var(--ag-icon-font-code-copy, "");display:var(--ag-icon-font-display-copy, var(--ag-icon-font-display))}.ag-icon-copy:after{background-image:var(--ag-icon-image-copy, var(--ag-icon-image));display:var(--ag-icon-image-display-copy, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-copy, var(--ag-icon-image-opacity, .9))}.ag-icon-cross{font-family:var(--ag-icon-font-family-cross, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-cross, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-cross, var(--ag-icon-font-color))}.ag-icon-cross:before{content:var(--ag-icon-font-code-cross, "");display:var(--ag-icon-font-display-cross, var(--ag-icon-font-display))}.ag-icon-cross:after{background-image:var(--ag-icon-image-cross, var(--ag-icon-image));display:var(--ag-icon-image-display-cross, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-cross, var(--ag-icon-image-opacity, .9))}.ag-icon-csv{font-family:var(--ag-icon-font-family-csv, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-csv, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-csv, var(--ag-icon-font-color))}.ag-icon-csv:before{content:var(--ag-icon-font-code-csv, "");display:var(--ag-icon-font-display-csv, var(--ag-icon-font-display))}.ag-icon-csv:after{background-image:var(--ag-icon-image-csv, var(--ag-icon-image));display:var(--ag-icon-image-display-csv, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-csv, var(--ag-icon-image-opacity, .9))}.ag-icon-cut{font-family:var(--ag-icon-font-family-cut, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-cut, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-cut, var(--ag-icon-font-color))}.ag-icon-cut:before{content:var(--ag-icon-font-code-cut, "");display:var(--ag-icon-font-display-cut, var(--ag-icon-font-display))}.ag-icon-cut:after{background-image:var(--ag-icon-image-cut, var(--ag-icon-image));display:var(--ag-icon-image-display-cut, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-cut, var(--ag-icon-image-opacity, .9))}.ag-icon-desc{font-family:var(--ag-icon-font-family-desc, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-desc, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-desc, var(--ag-icon-font-color))}.ag-icon-desc:before{content:var(--ag-icon-font-code-desc, "");display:var(--ag-icon-font-display-desc, var(--ag-icon-font-display))}.ag-icon-desc:after{background-image:var(--ag-icon-image-desc, var(--ag-icon-image));display:var(--ag-icon-image-display-desc, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-desc, var(--ag-icon-image-opacity, .9))}.ag-icon-excel{font-family:var(--ag-icon-font-family-excel, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-excel, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-excel, var(--ag-icon-font-color))}.ag-icon-excel:before{content:var(--ag-icon-font-code-excel, "");display:var(--ag-icon-font-display-excel, var(--ag-icon-font-display))}.ag-icon-excel:after{background-image:var(--ag-icon-image-excel, var(--ag-icon-image));display:var(--ag-icon-image-display-excel, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-excel, var(--ag-icon-image-opacity, .9))}.ag-icon-expanded{font-family:var(--ag-icon-font-family-expanded, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-expanded, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-expanded, var(--ag-icon-font-color))}.ag-icon-expanded:before{content:var(--ag-icon-font-code-expanded, "");display:var(--ag-icon-font-display-expanded, var(--ag-icon-font-display))}.ag-icon-expanded:after{background-image:var(--ag-icon-image-expanded, var(--ag-icon-image));display:var(--ag-icon-image-display-expanded, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-expanded, var(--ag-icon-image-opacity, .9))}.ag-icon-eye-slash{font-family:var(--ag-icon-font-family-eye-slash, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-eye-slash, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-eye-slash, var(--ag-icon-font-color))}.ag-icon-eye-slash:before{content:var(--ag-icon-font-code-eye-slash, "");display:var(--ag-icon-font-display-eye-slash, var(--ag-icon-font-display))}.ag-icon-eye-slash:after{background-image:var(--ag-icon-image-eye-slash, var(--ag-icon-image));display:var(--ag-icon-image-display-eye-slash, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-eye-slash, var(--ag-icon-image-opacity, .9))}.ag-icon-eye{font-family:var(--ag-icon-font-family-eye, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-eye, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-eye, var(--ag-icon-font-color))}.ag-icon-eye:before{content:var(--ag-icon-font-code-eye, "");display:var(--ag-icon-font-display-eye, var(--ag-icon-font-display))}.ag-icon-eye:after{background-image:var(--ag-icon-image-eye, var(--ag-icon-image));display:var(--ag-icon-image-display-eye, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-eye, var(--ag-icon-image-opacity, .9))}.ag-icon-filter{font-family:var(--ag-icon-font-family-filter, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-filter, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-filter, var(--ag-icon-font-color))}.ag-icon-filter:before{content:var(--ag-icon-font-code-filter, "");display:var(--ag-icon-font-display-filter, var(--ag-icon-font-display))}.ag-icon-filter:after{background-image:var(--ag-icon-image-filter, var(--ag-icon-image));display:var(--ag-icon-image-display-filter, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-filter, var(--ag-icon-image-opacity, .9))}.ag-icon-first{font-family:var(--ag-icon-font-family-first, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-first, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-first, var(--ag-icon-font-color))}.ag-icon-first:before{content:var(--ag-icon-font-code-first, "");display:var(--ag-icon-font-display-first, var(--ag-icon-font-display))}.ag-icon-first:after{background-image:var(--ag-icon-image-first, var(--ag-icon-image));display:var(--ag-icon-image-display-first, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-first, var(--ag-icon-image-opacity, .9))}.ag-icon-grip{font-family:var(--ag-icon-font-family-grip, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-grip, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-grip, var(--ag-icon-font-color))}.ag-icon-grip:before{content:var(--ag-icon-font-code-grip, "");display:var(--ag-icon-font-display-grip, var(--ag-icon-font-display))}.ag-icon-grip:after{background-image:var(--ag-icon-image-grip, var(--ag-icon-image));display:var(--ag-icon-image-display-grip, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-grip, var(--ag-icon-image-opacity, .9))}.ag-icon-group{font-family:var(--ag-icon-font-family-group, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-group, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-group, var(--ag-icon-font-color))}.ag-icon-group:before{content:var(--ag-icon-font-code-group, "");display:var(--ag-icon-font-display-group, var(--ag-icon-font-display))}.ag-icon-group:after{background-image:var(--ag-icon-image-group, var(--ag-icon-image));display:var(--ag-icon-image-display-group, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-group, var(--ag-icon-image-opacity, .9))}.ag-icon-last{font-family:var(--ag-icon-font-family-last, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-last, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-last, var(--ag-icon-font-color))}.ag-icon-last:before{content:var(--ag-icon-font-code-last, "");display:var(--ag-icon-font-display-last, var(--ag-icon-font-display))}.ag-icon-last:after{background-image:var(--ag-icon-image-last, var(--ag-icon-image));display:var(--ag-icon-image-display-last, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-last, var(--ag-icon-image-opacity, .9))}.ag-icon-left{font-family:var(--ag-icon-font-family-left, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-left, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-left, var(--ag-icon-font-color))}.ag-icon-left:before{content:var(--ag-icon-font-code-left, "");display:var(--ag-icon-font-display-left, var(--ag-icon-font-display))}.ag-icon-left:after{background-image:var(--ag-icon-image-left, var(--ag-icon-image));display:var(--ag-icon-image-display-left, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-left, var(--ag-icon-image-opacity, .9))}.ag-icon-linked{font-family:var(--ag-icon-font-family-linked, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-linked, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-linked, var(--ag-icon-font-color))}.ag-icon-linked:before{content:var(--ag-icon-font-code-linked, "");display:var(--ag-icon-font-display-linked, var(--ag-icon-font-display))}.ag-icon-linked:after{background-image:var(--ag-icon-image-linked, var(--ag-icon-image));display:var(--ag-icon-image-display-linked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-linked, var(--ag-icon-image-opacity, .9))}.ag-icon-loading{font-family:var(--ag-icon-font-family-loading, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-loading, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-loading, var(--ag-icon-font-color))}.ag-icon-loading:before{content:var(--ag-icon-font-code-loading, "");display:var(--ag-icon-font-display-loading, var(--ag-icon-font-display))}.ag-icon-loading:after{background-image:var(--ag-icon-image-loading, var(--ag-icon-image));display:var(--ag-icon-image-display-loading, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-loading, var(--ag-icon-image-opacity, .9))}.ag-icon-maximize{font-family:var(--ag-icon-font-family-maximize, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-maximize, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-maximize, var(--ag-icon-font-color))}.ag-icon-maximize:before{content:var(--ag-icon-font-code-maximize, "");display:var(--ag-icon-font-display-maximize, var(--ag-icon-font-display))}.ag-icon-maximize:after{background-image:var(--ag-icon-image-maximize, var(--ag-icon-image));display:var(--ag-icon-image-display-maximize, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-maximize, var(--ag-icon-image-opacity, .9))}.ag-icon-menu{font-family:var(--ag-icon-font-family-menu, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-menu, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-menu, var(--ag-icon-font-color))}.ag-icon-menu:before{content:var(--ag-icon-font-code-menu, "");display:var(--ag-icon-font-display-menu, var(--ag-icon-font-display))}.ag-icon-menu:after{background-image:var(--ag-icon-image-menu, var(--ag-icon-image));display:var(--ag-icon-image-display-menu, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-menu, var(--ag-icon-image-opacity, .9))}.ag-icon-minimize{font-family:var(--ag-icon-font-family-minimize, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-minimize, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-minimize, var(--ag-icon-font-color))}.ag-icon-minimize:before{content:var(--ag-icon-font-code-minimize, "");display:var(--ag-icon-font-display-minimize, var(--ag-icon-font-display))}.ag-icon-minimize:after{background-image:var(--ag-icon-image-minimize, var(--ag-icon-image));display:var(--ag-icon-image-display-minimize, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-minimize, var(--ag-icon-image-opacity, .9))}.ag-icon-next{font-family:var(--ag-icon-font-family-next, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-next, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-next, var(--ag-icon-font-color))}.ag-icon-next:before{content:var(--ag-icon-font-code-next, "");display:var(--ag-icon-font-display-next, var(--ag-icon-font-display))}.ag-icon-next:after{background-image:var(--ag-icon-image-next, var(--ag-icon-image));display:var(--ag-icon-image-display-next, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-next, var(--ag-icon-image-opacity, .9))}.ag-icon-none{font-family:var(--ag-icon-font-family-none, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-none, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-none, var(--ag-icon-font-color))}.ag-icon-none:before{content:var(--ag-icon-font-code-none, "");display:var(--ag-icon-font-display-none, var(--ag-icon-font-display))}.ag-icon-none:after{background-image:var(--ag-icon-image-none, var(--ag-icon-image));display:var(--ag-icon-image-display-none, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-none, var(--ag-icon-image-opacity, .9))}.ag-icon-not-allowed{font-family:var(--ag-icon-font-family-not-allowed, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-not-allowed, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-not-allowed, var(--ag-icon-font-color))}.ag-icon-not-allowed:before{content:var(--ag-icon-font-code-not-allowed, "");display:var(--ag-icon-font-display-not-allowed, var(--ag-icon-font-display))}.ag-icon-not-allowed:after{background-image:var(--ag-icon-image-not-allowed, var(--ag-icon-image));display:var(--ag-icon-image-display-not-allowed, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-not-allowed, var(--ag-icon-image-opacity, .9))}.ag-icon-paste{font-family:var(--ag-icon-font-family-paste, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-paste, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-paste, var(--ag-icon-font-color))}.ag-icon-paste:before{content:var(--ag-icon-font-code-paste, "");display:var(--ag-icon-font-display-paste, var(--ag-icon-font-display))}.ag-icon-paste:after{background-image:var(--ag-icon-image-paste, var(--ag-icon-image));display:var(--ag-icon-image-display-paste, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-paste, var(--ag-icon-image-opacity, .9))}.ag-icon-pin{font-family:var(--ag-icon-font-family-pin, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-pin, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-pin, var(--ag-icon-font-color))}.ag-icon-pin:before{content:var(--ag-icon-font-code-pin, "");display:var(--ag-icon-font-display-pin, var(--ag-icon-font-display))}.ag-icon-pin:after{background-image:var(--ag-icon-image-pin, var(--ag-icon-image));display:var(--ag-icon-image-display-pin, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-pin, var(--ag-icon-image-opacity, .9))}.ag-icon-pivot{font-family:var(--ag-icon-font-family-pivot, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-pivot, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-pivot, var(--ag-icon-font-color))}.ag-icon-pivot:before{content:var(--ag-icon-font-code-pivot, "");display:var(--ag-icon-font-display-pivot, var(--ag-icon-font-display))}.ag-icon-pivot:after{background-image:var(--ag-icon-image-pivot, var(--ag-icon-image));display:var(--ag-icon-image-display-pivot, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-pivot, var(--ag-icon-image-opacity, .9))}.ag-icon-previous{font-family:var(--ag-icon-font-family-previous, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-previous, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-previous, var(--ag-icon-font-color))}.ag-icon-previous:before{content:var(--ag-icon-font-code-previous, "");display:var(--ag-icon-font-display-previous, var(--ag-icon-font-display))}.ag-icon-previous:after{background-image:var(--ag-icon-image-previous, var(--ag-icon-image));display:var(--ag-icon-image-display-previous, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-previous, var(--ag-icon-image-opacity, .9))}.ag-icon-radio-button-off{font-family:var(--ag-icon-font-family-radio-button-off, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-radio-button-off, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-radio-button-off, var(--ag-icon-font-color))}.ag-icon-radio-button-off:before{content:var(--ag-icon-font-code-radio-button-off, "");display:var(--ag-icon-font-display-radio-button-off, var(--ag-icon-font-display))}.ag-icon-radio-button-off:after{background-image:var(--ag-icon-image-radio-button-off, var(--ag-icon-image));display:var(--ag-icon-image-display-radio-button-off, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-radio-button-off, var(--ag-icon-image-opacity, .9))}.ag-icon-radio-button-on{font-family:var(--ag-icon-font-family-radio-button-on, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-radio-button-on, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-radio-button-on, var(--ag-icon-font-color))}.ag-icon-radio-button-on:before{content:var(--ag-icon-font-code-radio-button-on, "");display:var(--ag-icon-font-display-radio-button-on, var(--ag-icon-font-display))}.ag-icon-radio-button-on:after{background-image:var(--ag-icon-image-radio-button-on, var(--ag-icon-image));display:var(--ag-icon-image-display-radio-button-on, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-radio-button-on, var(--ag-icon-image-opacity, .9))}.ag-icon-right{font-family:var(--ag-icon-font-family-right, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-right, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-right, var(--ag-icon-font-color))}.ag-icon-right:before{content:var(--ag-icon-font-code-right, "");display:var(--ag-icon-font-display-right, var(--ag-icon-font-display))}.ag-icon-right:after{background-image:var(--ag-icon-image-right, var(--ag-icon-image));display:var(--ag-icon-image-display-right, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-right, var(--ag-icon-image-opacity, .9))}.ag-icon-save{font-family:var(--ag-icon-font-family-save, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-save, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-save, var(--ag-icon-font-color))}.ag-icon-save:before{content:var(--ag-icon-font-code-save, "");display:var(--ag-icon-font-display-save, var(--ag-icon-font-display))}.ag-icon-save:after{background-image:var(--ag-icon-image-save, var(--ag-icon-image));display:var(--ag-icon-image-display-save, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-save, var(--ag-icon-image-opacity, .9))}.ag-icon-small-down{font-family:var(--ag-icon-font-family-small-down, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-small-down, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-small-down, var(--ag-icon-font-color))}.ag-icon-small-down:before{content:var(--ag-icon-font-code-small-down, "");display:var(--ag-icon-font-display-small-down, var(--ag-icon-font-display))}.ag-icon-small-down:after{background-image:var(--ag-icon-image-small-down, var(--ag-icon-image));display:var(--ag-icon-image-display-small-down, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-small-down, var(--ag-icon-image-opacity, .9))}.ag-icon-small-left{font-family:var(--ag-icon-font-family-small-left, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-small-left, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-small-left, var(--ag-icon-font-color))}.ag-icon-small-left:before{content:var(--ag-icon-font-code-small-left, "");display:var(--ag-icon-font-display-small-left, var(--ag-icon-font-display))}.ag-icon-small-left:after{background-image:var(--ag-icon-image-small-left, var(--ag-icon-image));display:var(--ag-icon-image-display-small-left, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-small-left, var(--ag-icon-image-opacity, .9))}.ag-icon-small-right{font-family:var(--ag-icon-font-family-small-right, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-small-right, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-small-right, var(--ag-icon-font-color))}.ag-icon-small-right:before{content:var(--ag-icon-font-code-small-right, "");display:var(--ag-icon-font-display-small-right, var(--ag-icon-font-display))}.ag-icon-small-right:after{background-image:var(--ag-icon-image-small-right, var(--ag-icon-image));display:var(--ag-icon-image-display-small-right, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-small-right, var(--ag-icon-image-opacity, .9))}.ag-icon-small-up{font-family:var(--ag-icon-font-family-small-up, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-small-up, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-small-up, var(--ag-icon-font-color))}.ag-icon-small-up:before{content:var(--ag-icon-font-code-small-up, "");display:var(--ag-icon-font-display-small-up, var(--ag-icon-font-display))}.ag-icon-small-up:after{background-image:var(--ag-icon-image-small-up, var(--ag-icon-image));display:var(--ag-icon-image-display-small-up, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-small-up, var(--ag-icon-image-opacity, .9))}.ag-icon-tick{font-family:var(--ag-icon-font-family-tick, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-tick, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-tick, var(--ag-icon-font-color))}.ag-icon-tick:before{content:var(--ag-icon-font-code-tick, "");display:var(--ag-icon-font-display-tick, var(--ag-icon-font-display))}.ag-icon-tick:after{background-image:var(--ag-icon-image-tick, var(--ag-icon-image));display:var(--ag-icon-image-display-tick, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-tick, var(--ag-icon-image-opacity, .9))}.ag-icon-tree-closed{font-family:var(--ag-icon-font-family-tree-closed, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-tree-closed, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-tree-closed, var(--ag-icon-font-color))}.ag-icon-tree-closed:before{content:var(--ag-icon-font-code-tree-closed, "");display:var(--ag-icon-font-display-tree-closed, var(--ag-icon-font-display))}.ag-icon-tree-closed:after{background-image:var(--ag-icon-image-tree-closed, var(--ag-icon-image));display:var(--ag-icon-image-display-tree-closed, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-tree-closed, var(--ag-icon-image-opacity, .9))}.ag-icon-tree-indeterminate{font-family:var(--ag-icon-font-family-tree-indeterminate, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-tree-indeterminate, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-tree-indeterminate, var(--ag-icon-font-color))}.ag-icon-tree-indeterminate:before{content:var(--ag-icon-font-code-tree-indeterminate, "");display:var(--ag-icon-font-display-tree-indeterminate, var(--ag-icon-font-display))}.ag-icon-tree-indeterminate:after{background-image:var(--ag-icon-image-tree-indeterminate, var(--ag-icon-image));display:var(--ag-icon-image-display-tree-indeterminate, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-tree-indeterminate, var(--ag-icon-image-opacity, .9))}.ag-icon-tree-open{font-family:var(--ag-icon-font-family-tree-open, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-tree-open, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-tree-open, var(--ag-icon-font-color))}.ag-icon-tree-open:before{content:var(--ag-icon-font-code-tree-open, "");display:var(--ag-icon-font-display-tree-open, var(--ag-icon-font-display))}.ag-icon-tree-open:after{background-image:var(--ag-icon-image-tree-open, var(--ag-icon-image));display:var(--ag-icon-image-display-tree-open, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-tree-open, var(--ag-icon-image-opacity, .9))}.ag-icon-unlinked{font-family:var(--ag-icon-font-family-unlinked, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-unlinked, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-unlinked, var(--ag-icon-font-color))}.ag-icon-unlinked:before{content:var(--ag-icon-font-code-unlinked, "");display:var(--ag-icon-font-display-unlinked, var(--ag-icon-font-display))}.ag-icon-unlinked:after{background-image:var(--ag-icon-image-unlinked, var(--ag-icon-image));display:var(--ag-icon-image-display-unlinked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-unlinked, var(--ag-icon-image-opacity, .9))}.ag-icon-up{font-family:var(--ag-icon-font-family-up, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-up, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-up, var(--ag-icon-font-color))}.ag-icon-up:before{content:var(--ag-icon-font-code-up, "");display:var(--ag-icon-font-display-up, var(--ag-icon-font-display))}.ag-icon-up:after{background-image:var(--ag-icon-image-up, var(--ag-icon-image));display:var(--ag-icon-image-display-up, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-up, var(--ag-icon-image-opacity, .9))}.ag-icon-down{font-family:var(--ag-icon-font-family-down, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-down, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-down, var(--ag-icon-font-color))}.ag-icon-down:before{content:var(--ag-icon-font-code-down, "");display:var(--ag-icon-font-display-down, var(--ag-icon-font-display))}.ag-icon-down:after{background-image:var(--ag-icon-image-down, var(--ag-icon-image));display:var(--ag-icon-image-display-down, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-down, var(--ag-icon-image-opacity, .9))}.ag-icon-plus{font-family:var(--ag-icon-font-family-plus, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-plus, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-plus, var(--ag-icon-font-color))}.ag-icon-plus:before{content:var(--ag-icon-font-code-plus, "");display:var(--ag-icon-font-display-plus, var(--ag-icon-font-display))}.ag-icon-plus:after{background-image:var(--ag-icon-image-plus, var(--ag-icon-image));display:var(--ag-icon-image-display-plus, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-plus, var(--ag-icon-image-opacity, .9))}.ag-icon-minus{font-family:var(--ag-icon-font-family-minus, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-minus, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-minus, var(--ag-icon-font-color))}.ag-icon-minus:before{content:var(--ag-icon-font-code-minus, "");display:var(--ag-icon-font-display-minus, var(--ag-icon-font-display))}.ag-icon-minus:after{background-image:var(--ag-icon-image-minus, var(--ag-icon-image));display:var(--ag-icon-image-display-minus, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-minus, var(--ag-icon-image-opacity, .9))}.ag-icon-menu-alt{font-family:var(--ag-icon-font-family-menu-alt, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-menu-alt, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-menu-alt, var(--ag-icon-font-color))}.ag-icon-menu-alt:before{content:var(--ag-icon-font-code-menu-alt, "");display:var(--ag-icon-font-display-menu-alt, var(--ag-icon-font-display))}.ag-icon-menu-alt:after{background-image:var(--ag-icon-image-menu-alt, var(--ag-icon-image));display:var(--ag-icon-image-display-menu-alt, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-menu-alt, var(--ag-icon-image-opacity, .9))}.ag-icon-settings{font-family:var(--ag-icon-font-family-settings, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-settings, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-settings, var(--ag-icon-font-color))}.ag-icon-settings:before{content:var(--ag-icon-font-code-settings, "");display:var(--ag-icon-font-display-settings, var(--ag-icon-font-display))}.ag-icon-settings:after{background-image:var(--ag-icon-image-settings, var(--ag-icon-image));display:var(--ag-icon-image-display-settings, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-settings, var(--ag-icon-image-opacity, .9))}.ag-icon-row-drag:before{content:var(--ag-icon-font-code-grip)}.ag-left-arrow:before{content:var(--ag-icon-font-code-left)}.ag-right-arrow:before{content:var(--ag-icon-font-code-right)}[class*=ag-theme-]{--ag-foreground-color: #000;--ag-data-color: var(--ag-foreground-color);--ag-secondary-foreground-color: var(--ag-foreground-color);--ag-header-foreground-color: var(--ag-secondary-foreground-color);--ag-disabled-foreground-color: rgba(0, 0, 0, .5);--ag-background-color: #fff;--ag-header-background-color: transparent;--ag-tooltip-background-color: transparent;--ag-subheader-background-color: transparent;--ag-subheader-toolbar-background-color: transparent;--ag-control-panel-background-color: transparent;--ag-side-button-selected-background-color: var(--ag-control-panel-background-color);--ag-selected-row-background-color: #BBB;--ag-odd-row-background-color: var(--ag-background-color);--ag-modal-overlay-background-color: rgba(255, 255, 255, .66);--ag-menu-background-color: var(--ag-background-color);--ag-menu-border-color: var(--ag-border-color);--ag-panel-background-color: var(--ag-background-color);--ag-panel-border-color: var(--ag-border-color);--ag-row-hover-color: transparent;--ag-column-hover-color: transparent;--ag-range-selection-border-color: var(--ag-foreground-color);--ag-range-selection-border-style: solid;--ag-range-selection-background-color: rgba(0, 0, 0, .2);--ag-range-selection-background-color-2: var(--ag-range-selection-background-color);--ag-range-selection-background-color-3: var(--ag-range-selection-background-color);--ag-range-selection-background-color-4: var(--ag-range-selection-background-color);--ag-range-selection-highlight-color: var(--ag-range-selection-border-color);--ag-selected-tab-underline-color: var(--ag-range-selection-border-color);--ag-selected-tab-underline-width: 0;--ag-selected-tab-underline-transition-speed: 0s;--ag-range-selection-chart-category-background-color: rgba(0, 255, 132, .1);--ag-range-selection-chart-background-color: rgba(0, 88, 255, .1);--ag-header-cell-hover-background-color: transparent;--ag-header-cell-moving-background-color: var(--ag-background-color);--ag-value-change-value-highlight-background-color: rgba(22, 160, 133, .5);--ag-value-change-delta-up-color: #43a047;--ag-value-change-delta-down-color: #e53935;--ag-row-loading-skeleton-effect-color: rgba(66, 66, 66, .2);--ag-chip-background-color: transparent;--ag-chip-border-color: var(--ag-chip-background-color);--ag-borders: solid 1px;--ag-border-color: rgba(0, 0, 0, .25);--ag-borders-critical: var(--ag-borders);--ag-borders-secondary: var(--ag-borders);--ag-secondary-border-color: var(--ag-border-color);--ag-row-border-style: solid;--ag-row-border-width: 1px;--ag-cell-horizontal-border: solid transparent;--ag-borders-input: var(--ag-borders-secondary);--ag-input-border-color: var(--ag-secondary-border-color);--ag-borders-input-invalid: solid 2px;--ag-input-border-color-invalid: var(--ag-invalid-color);--ag-borders-side-button: var(--ag-borders);--ag-border-radius: 0px;--ag-wrapper-border-radius: var(--ag-border-radius);--ag-row-border-color: var(--ag-secondary-border-color);--ag-header-column-separator-display: none;--ag-header-column-separator-height: 100%;--ag-header-column-separator-width: 1px;--ag-header-column-separator-color: var(--ag-secondary-border-color);--ag-header-column-resize-handle-display: none;--ag-header-column-resize-handle-height: 50%;--ag-header-column-resize-handle-width: 1px;--ag-header-column-resize-handle-color: var(--ag-secondary-border-color);--ag-invalid-color: red;--ag-input-disabled-border-color: var(--ag-input-border-color);--ag-input-disabled-background-color: transparent;--ag-checkbox-background-color: transparent;--ag-checkbox-border-radius: var(--ag-border-radius);--ag-checkbox-checked-color: var(--ag-foreground-color);--ag-checkbox-unchecked-color: var(--ag-foreground-color);--ag-checkbox-indeterminate-color: var(--ag-checkbox-unchecked-color);--ag-toggle-button-off-border-color: var(--ag-checkbox-unchecked-color);--ag-toggle-button-off-background-color: var(--ag-checkbox-unchecked-color);--ag-toggle-button-on-border-color: var(--ag-checkbox-checked-color);--ag-toggle-button-on-background-color: var(--ag-checkbox-checked-color);--ag-toggle-button-switch-background-color: var(--ag-background-color);--ag-toggle-button-switch-border-color: var(--ag-toggle-button-off-border-color);--ag-toggle-button-border-width: 1px;--ag-toggle-button-height: var(--ag-icon-size);--ag-toggle-button-width: calc(var(--ag-toggle-button-height) * 2);--ag-input-focus-box-shadow: none;--ag-input-focus-border-color: none;--ag-minichart-selected-chart-color: var(--ag-checkbox-checked-color);--ag-minichart-selected-page-color: var(--ag-checkbox-checked-color);--ag-grid-size: 4px;--ag-icon-size: 12px;--ag-icon-font-weight: normal;--ag-icon-font-color: var(--ag-foreground-color);--ag-icon-image-display: block;--ag-widget-container-horizontal-padding: calc(var(--ag-grid-size) * 1.5);--ag-widget-container-vertical-padding: calc(var(--ag-grid-size) * 1.5);--ag-widget-horizontal-spacing: calc(var(--ag-grid-size) * 2);--ag-widget-vertical-spacing: var(--ag-grid-size);--ag-cell-horizontal-padding: calc(var(--ag-grid-size) * 3);--ag-cell-widget-spacing: var(--ag-cell-horizontal-padding);--ag-row-height: calc(var(--ag-grid-size) * 6 + 1px);--ag-header-height: var(--ag-row-height);--ag-list-item-height: calc(var(--ag-grid-size) * 5);--ag-column-select-indent-size: calc(var(--ag-grid-size) + var(--ag-icon-size));--ag-set-filter-indent-size: calc(var(--ag-grid-size) + var(--ag-icon-size));--ag-advanced-filter-builder-indent-size: calc(var(--ag-grid-size) * 2 + var(--ag-icon-size));--ag-row-group-indent-size: calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size));--ag-filter-tool-panel-group-indent: 16px;--ag-tab-min-width: 220px;--ag-menu-min-width: 181px;--ag-side-bar-panel-width: 200px;--ag-font-family: "Helvetica Neue", sans-serif;--ag-font-size: 14px;--ag-card-radius: var(--ag-border-radius);--ag-card-shadow: none;--ag-popup-shadow: 5px 5px 10px rgba(0, 0, 0, .3);--ag-advanced-filter-join-pill-color: #f08e8d;--ag-advanced-filter-column-pill-color: #a6e194;--ag-advanced-filter-option-pill-color: #f3c08b;--ag-advanced-filter-value-pill-color: #85c0e4}.ag-root-wrapper,.ag-sticky-top,.ag-sticky-bottom,.ag-dnd-ghost{background-color:var(--ag-background-color)}[class*=ag-theme-]{-webkit-font-smoothing:antialiased;font-family:var(--ag-font-family);font-size:var(--ag-font-size);line-height:normal;color:var(--ag-foreground-color)}ag-grid,ag-grid-angular,ag-grid-ng2,ag-grid-polymer,ag-grid-aurelia{display:block}.ag-aria-description-container{z-index:9999;border:0px;clip:rect(1px,1px,1px,1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap}.ag-hidden{display:none!important}.ag-invisible{visibility:hidden!important}.ag-no-transition{transition:none!important}.ag-drag-handle{cursor:grab}.ag-column-drop-wrapper{display:flex}.ag-column-drop-horizontal-half-width{display:inline-block;width:50%!important}.ag-unselectable{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-selectable{-moz-user-select:text;-webkit-user-select:text;-ms-user-select:text;user-select:text}.ag-tab{position:relative}.ag-tab-guard{position:absolute;width:0;height:0;display:block}.ag-select-agg-func-popup{position:absolute}.ag-input-wrapper,.ag-picker-field-wrapper{display:flex;flex:1 1 auto;align-items:center;line-height:normal;position:relative}.ag-shake-left-to-right{animation-direction:alternate;animation-duration:.2s;animation-iteration-count:infinite;animation-name:ag-shake-left-to-right}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.ag-root-wrapper{cursor:default;position:relative;display:flex;flex-direction:column;overflow:hidden;white-space:normal}.ag-root-wrapper.ag-layout-normal{height:100%}.ag-watermark{position:absolute;bottom:20px;right:25px;opacity:.7;transition:opacity 1s ease-out 3s;color:#9b9b9b}.ag-watermark:before{content:"";background-image:url(data:image/svg+xml;base64,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);background-repeat:no-repeat;background-size:170px 40px;display:block;height:40px;width:170px}.ag-watermark-text{opacity:.5;font-weight:700;font-family:Impact,sans-serif;font-size:19px;padding-left:.7rem}.ag-root-wrapper-body{display:flex;flex-direction:row}.ag-root-wrapper-body.ag-layout-normal{flex:1 1 auto;height:0;min-height:0}.ag-root{position:relative;display:flex;flex-direction:column}.ag-root.ag-layout-normal,.ag-root.ag-layout-auto-height{overflow:hidden;flex:1 1 auto;width:0}.ag-root.ag-layout-normal{height:100%}.ag-header-viewport,.ag-floating-top-viewport,.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-body-horizontal-scroll-viewport,.ag-body-vertical-scroll-viewport,.ag-virtual-list-viewport,.ag-sticky-top-viewport,.ag-sticky-bottom-viewport{position:relative;height:100%;min-width:0px;overflow:hidden;flex:1 1 auto}.ag-body-viewport,.ag-center-cols-viewport{-ms-overflow-style:none!important;scrollbar-width:none!important}.ag-body-viewport::-webkit-scrollbar,.ag-center-cols-viewport::-webkit-scrollbar{display:none!important}.ag-body-viewport{display:flex}.ag-body-viewport.ag-layout-normal{overflow-y:auto;-webkit-overflow-scrolling:touch}.ag-center-cols-viewport{min-height:100%;width:100%;overflow-x:auto}.ag-body-horizontal-scroll-viewport{overflow-x:scroll}.ag-body-vertical-scroll-viewport{overflow-y:scroll}.ag-virtual-list-viewport{overflow:auto;width:100%}.ag-header-container,.ag-floating-top-container,.ag-body-container,.ag-pinned-right-cols-container,.ag-center-cols-container,.ag-pinned-left-cols-container,.ag-floating-bottom-container,.ag-body-horizontal-scroll-container,.ag-body-vertical-scroll-container,.ag-full-width-container,.ag-floating-bottom-full-width-container,.ag-virtual-list-container,.ag-sticky-top-container,.ag-sticky-bottom-container{position:relative}.ag-header-container,.ag-floating-top-container,.ag-floating-bottom-container,.ag-sticky-top-container,.ag-sticky-bottom-container{height:100%;white-space:nowrap}.ag-center-cols-container,.ag-pinned-right-cols-container{display:block}.ag-body-horizontal-scroll-container{height:100%}.ag-body-vertical-scroll-container{width:100%}.ag-full-width-container,.ag-floating-top-full-width-container,.ag-floating-bottom-full-width-container,.ag-sticky-top-full-width-container,.ag-sticky-bottom-full-width-container{position:absolute;top:0;pointer-events:none}.ag-ltr .ag-full-width-container,.ag-ltr .ag-floating-top-full-width-container,.ag-ltr .ag-floating-bottom-full-width-container,.ag-ltr .ag-sticky-top-full-width-container,.ag-ltr .ag-sticky-bottom-full-width-container{left:0}.ag-rtl .ag-full-width-container,.ag-rtl .ag-floating-top-full-width-container,.ag-rtl .ag-floating-bottom-full-width-container,.ag-rtl .ag-sticky-top-full-width-container,.ag-rtl .ag-sticky-bottom-full-width-container{right:0}.ag-full-width-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{display:inline-block;overflow:hidden;height:100%;width:100%}.ag-virtual-list-container{overflow:hidden}.ag-body{position:relative;display:flex;flex:1 1 auto;flex-direction:row!important;min-height:0}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{min-height:0;min-width:0;display:flex;position:relative}.ag-body-horizontal-scroll.ag-scrollbar-invisible,.ag-body-vertical-scroll.ag-scrollbar-invisible{position:absolute;bottom:0}.ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar,.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar{opacity:0;transition:opacity .4s;visibility:hidden}.ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-scrolling,.ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-active,.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-scrolling,.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-active{visibility:visible;opacity:1}.ag-body-horizontal-scroll{width:100%}.ag-body-horizontal-scroll.ag-scrollbar-invisible{left:0;right:0}.ag-body-vertical-scroll{height:100%}.ag-body-vertical-scroll.ag-scrollbar-invisible{top:0;z-index:10}.ag-ltr .ag-body-vertical-scroll.ag-scrollbar-invisible{right:0}.ag-rtl .ag-body-vertical-scroll.ag-scrollbar-invisible{left:0}.ag-force-vertical-scroll{overflow-y:scroll!important}.ag-horizontal-left-spacer,.ag-horizontal-right-spacer{height:100%;min-width:0;overflow-x:scroll}.ag-horizontal-left-spacer.ag-scroller-corner,.ag-horizontal-right-spacer.ag-scroller-corner{overflow-x:hidden}.ag-header,.ag-pinned-left-header,.ag-pinned-right-header{display:inline-block;overflow:hidden;position:relative}.ag-header-cell-sortable .ag-header-cell-label{cursor:pointer}.ag-header{display:flex;width:100%;white-space:nowrap}.ag-pinned-left-header,.ag-pinned-right-header{height:100%}.ag-header-row{position:absolute}.ag-header-row:not(.ag-header-row-column-group){overflow:hidden}.ag-header.ag-header-allow-overflow .ag-header-row{overflow:visible}.ag-header-cell{display:inline-flex;align-items:center;position:absolute;height:100%}.ag-header-cell.ag-header-active .ag-header-cell-menu-button,.ag-header-cell-filter-button{opacity:1}.ag-header-cell-menu-button:not(.ag-header-menu-always-show){transition:opacity .2s;opacity:0}.ag-header-group-cell-label,.ag-header-cell-label{display:flex;flex:1 1 auto;align-self:stretch;align-items:center}.ag-header-cell-label{overflow:hidden;text-overflow:ellipsis}.ag-header-group-cell-label.ag-sticky-label{position:sticky;flex:none;max-width:100%}.ag-header-group-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-header-cell-text{overflow:hidden;text-overflow:ellipsis}.ag-header-cell:not(.ag-header-cell-auto-height) .ag-header-cell-comp-wrapper{height:100%;display:flex;align-items:center}.ag-header-cell-comp-wrapper{width:100%}.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper{white-space:normal}.ag-right-aligned-header .ag-header-cell-label{flex-direction:row-reverse}.ag-header-cell-resize{position:absolute;z-index:2;height:100%;width:8px;top:0;cursor:ew-resize}.ag-ltr .ag-header-cell-resize{right:-4px}.ag-rtl .ag-header-cell-resize{left:-4px}.ag-pinned-left-header .ag-header-cell-resize{right:-4px}.ag-pinned-right-header .ag-header-cell-resize{left:-4px}.ag-header-select-all{display:flex}.ag-header-cell-menu-button,.ag-header-cell-filter-button,.ag-side-button-button,.ag-panel-title-bar-button,.ag-floating-filter-button-button{cursor:pointer}.ag-column-moving .ag-cell,.ag-column-moving .ag-header-cell{transition:left .2s}.ag-column-moving .ag-header-group-cell{transition:left .2s,width .2s}.ag-column-panel{display:flex;flex-direction:column;overflow:hidden;flex:1 1 auto}.ag-column-select{position:relative;display:flex;flex-direction:column;overflow:hidden;flex:3 1 0px}.ag-column-select-header{position:relative;display:flex;flex:none}.ag-column-select-header-icon{position:relative}.ag-column-select-header-filter-wrapper{flex:1 1 auto}.ag-column-select-header-filter{width:100%}.ag-column-select-list{flex:1 1 0px;overflow:hidden}.ag-column-drop{position:relative;display:inline-flex;align-items:center;overflow:auto;width:100%}.ag-column-drop-list{display:flex;align-items:center}.ag-column-drop-cell{position:relative;display:flex;align-items:center}.ag-column-drop-cell-text{overflow:hidden;flex:1 1 auto;text-overflow:ellipsis;white-space:nowrap}.ag-column-drop-vertical{display:flex;flex-direction:column;overflow:hidden;align-items:stretch;flex:1 1 0px}.ag-column-drop-vertical-title-bar{display:flex;align-items:center;flex:none}.ag-column-drop-vertical-list{position:relative;align-items:stretch;flex-grow:1;flex-direction:column;overflow-x:auto}.ag-column-drop-vertical-list>*{flex:none}.ag-column-drop-empty .ag-column-drop-vertical-list{overflow:hidden}.ag-column-drop-vertical-empty-message{display:block}.ag-column-drop.ag-column-drop-horizontal{white-space:nowrap;overflow:hidden}.ag-column-drop-cell-button{cursor:pointer}.ag-filter-toolpanel{flex:1 1 0px;min-width:0}.ag-filter-toolpanel-header{position:relative}.ag-filter-toolpanel-header,.ag-filter-toolpanel-search{display:flex;align-items:center}.ag-filter-toolpanel-header>*,.ag-filter-toolpanel-search>*{display:flex;align-items:center}.ag-filter-apply-panel{display:flex;justify-content:flex-end;overflow:hidden}.ag-row-animation .ag-row{transition:transform .4s,top .4s}.ag-row-animation .ag-row.ag-after-created{transition:transform .4s,top .4s,height .4s}.ag-row-no-animation .ag-row{transition:none}.ag-row{white-space:nowrap;width:100%}.ag-row-loading{display:flex;align-items:center}.ag-row-position-absolute{position:absolute}.ag-row-position-relative{position:relative}.ag-full-width-row{overflow:hidden;pointer-events:all}.ag-row-inline-editing{z-index:1}.ag-row-dragging{z-index:2}.ag-stub-cell{display:flex;align-items:center}.ag-cell{display:inline-block;position:absolute;white-space:nowrap;height:100%}.ag-cell-value{flex:1 1 auto}.ag-cell-value,.ag-group-value{overflow:hidden;text-overflow:ellipsis}.ag-cell-wrap-text{white-space:normal}.ag-cell-wrapper{display:flex;align-items:center}.ag-cell-wrapper.ag-row-group{align-items:flex-start}.ag-sparkline-wrapper{position:absolute;height:100%;width:100%;left:0;top:0}.ag-full-width-row .ag-cell-wrapper.ag-row-group{height:100%;align-items:center}.ag-cell-inline-editing{z-index:1}.ag-cell-inline-editing .ag-cell-wrapper,.ag-cell-inline-editing .ag-cell-edit-wrapper,.ag-cell-inline-editing .ag-cell-editor,.ag-cell-inline-editing .ag-cell-editor .ag-wrapper,.ag-cell-inline-editing .ag-cell-editor input{height:100%;width:100%;line-height:normal}.ag-cell .ag-icon{display:inline-block;vertical-align:middle}.ag-set-filter-item{display:flex;align-items:center;height:100%}.ag-set-filter-item-checkbox{display:flex;width:100%;height:100%}.ag-set-filter-group-icons{display:block}.ag-set-filter-group-icons>*{cursor:pointer}.ag-filter-body-wrapper{display:flex;flex-direction:column}.ag-filter-filter{flex:1 1 0px}.ag-filter-condition{display:flex;justify-content:center}.ag-floating-filter-body{position:relative;display:flex;flex:1 1 auto;height:100%}.ag-floating-filter-full-body{display:flex;flex:1 1 auto;height:100%;width:100%;align-items:center;overflow:hidden}.ag-floating-filter-full-body>div{flex:1 1 auto}.ag-floating-filter-input{align-items:center;display:flex;width:100%}.ag-floating-filter-input>*{flex:1 1 auto}.ag-floating-filter-button{display:flex;flex:none}.ag-set-floating-filter-input input[disabled]{pointer-events:none}.ag-dnd-ghost{position:absolute;display:inline-flex;align-items:center;cursor:move;white-space:nowrap;z-index:9999}.ag-overlay{height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%;z-index:2}.ag-overlay-panel{display:flex;height:100%;width:100%}.ag-overlay-wrapper{display:flex;flex:none;width:100%;height:100%;align-items:center;justify-content:center;text-align:center}.ag-overlay-loading-wrapper{pointer-events:all}.ag-popup-child{z-index:5;top:0}.ag-popup-editor{position:absolute;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-large-text-input{display:block}.ag-virtual-list-item{position:absolute;width:100%}.ag-floating-top{overflow:hidden;white-space:nowrap;width:100%;position:relative;display:flex}.ag-pinned-left-floating-top,.ag-pinned-right-floating-top{display:inline-block;overflow:hidden;position:relative;min-width:0px}.ag-floating-bottom{overflow:hidden;white-space:nowrap;width:100%;position:relative;display:flex}.ag-pinned-left-floating-bottom,.ag-pinned-right-floating-bottom{display:inline-block;overflow:hidden;position:relative;min-width:0px}.ag-sticky-top,.ag-sticky-bottom{position:absolute;display:flex;width:100%}.ag-pinned-left-sticky-top,.ag-pinned-right-sticky-top{position:relative;height:100%;overflow:hidden}.ag-sticky-top-full-width-container,.ag-sticky-bottom-full-width-container{overflow:hidden;width:100%;height:100%}.ag-dialog,.ag-panel{display:flex;flex-direction:column;position:relative;overflow:hidden}.ag-panel-title-bar{display:flex;flex:none;align-items:center;cursor:default}.ag-panel-title-bar-title{flex:1 1 auto}.ag-panel-title-bar-buttons{display:flex}.ag-panel-title-bar-button{cursor:pointer}.ag-panel-content-wrapper{display:flex;flex:1 1 auto;position:relative;overflow:hidden}.ag-dialog{position:absolute}.ag-resizer{position:absolute;pointer-events:none;z-index:1;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-resizer.ag-resizer-topLeft{top:0;left:0;height:5px;width:5px;cursor:nwse-resize}.ag-resizer.ag-resizer-top{top:0;left:5px;right:5px;height:5px;cursor:ns-resize}.ag-resizer.ag-resizer-topRight{top:0;right:0;height:5px;width:5px;cursor:nesw-resize}.ag-resizer.ag-resizer-right{top:5px;right:0;bottom:5px;width:5px;cursor:ew-resize}.ag-resizer.ag-resizer-bottomRight{bottom:0;right:0;height:5px;width:5px;cursor:nwse-resize}.ag-resizer.ag-resizer-bottom{bottom:0;left:5px;right:5px;height:5px;cursor:ns-resize}.ag-resizer.ag-resizer-bottomLeft{bottom:0;left:0;height:5px;width:5px;cursor:nesw-resize}.ag-resizer.ag-resizer-left{left:0;top:5px;bottom:5px;width:5px;cursor:ew-resize}.ag-tooltip,.ag-tooltip-custom{position:absolute;z-index:99999}.ag-tooltip:not(.ag-tooltip-interactive),.ag-tooltip-custom:not(.ag-tooltip-interactive){pointer-events:none}.ag-value-slide-out{margin-right:5px;opacity:1;transition:opacity 3s,margin-right 3s;transition-timing-function:linear}.ag-value-slide-out-end{margin-right:10px;opacity:0}.ag-opacity-zero{opacity:0!important}.ag-menu{max-height:100%;overflow-y:auto;position:absolute;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-menu-column-select-wrapper{height:265px;overflow:auto}.ag-menu-column-select-wrapper .ag-column-select{height:100%}.ag-dialog .ag-panel-content-wrapper .ag-column-select{-webkit-user-select:none;user-select:none}.ag-menu-list{display:table;width:100%}.ag-menu-option,.ag-menu-separator{display:table-row}.ag-menu-option-part,.ag-menu-separator-part{display:table-cell;vertical-align:middle}.ag-menu-option-text{white-space:nowrap}.ag-menu-option-custom{display:contents}.ag-compact-menu-option{width:100%;display:flex;flex-wrap:nowrap}.ag-compact-menu-option-text{white-space:nowrap;flex:1 1 auto}.ag-rich-select{cursor:default;outline:none;height:100%}.ag-rich-select-value{display:flex;align-items:center;height:100%}.ag-rich-select-value .ag-picker-field-display{overflow:hidden;text-overflow:ellipsis}.ag-rich-select-value .ag-picker-field-display.ag-display-as-placeholder{opacity:.5}.ag-rich-select-list{position:relative}.ag-rich-select-list .ag-loading-text{min-height:2rem}.ag-rich-select-row{display:flex;flex:1 1 auto;align-items:center;white-space:nowrap;overflow:hidden;height:100%}.ag-rich-select-field-input{flex:1 1 auto}.ag-rich-select-field-input .ag-input-field-input{padding:0!important;border:none!important;box-shadow:none!important;text-overflow:ellipsis}.ag-rich-select-field-input .ag-input-field-input::placeholder{opacity:.8}.ag-autocomplete{align-items:center;display:flex}.ag-autocomplete>*{flex:1 1 auto}.ag-autocomplete-list-popup{position:absolute;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-autocomplete-list{position:relative}.ag-autocomplete-virtual-list-item{display:flex}.ag-autocomplete-row{display:flex;flex:1 1 auto;align-items:center;overflow:hidden}.ag-autocomplete-row-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ag-paging-panel{align-items:center;display:flex;justify-content:flex-end}.ag-paging-page-summary-panel{display:flex;align-items:center}.ag-paging-button{position:relative}.ag-disabled .ag-paging-page-summary-panel{pointer-events:none}.ag-tool-panel-wrapper{display:flex;overflow-y:auto;overflow-x:hidden;cursor:default;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-column-select-column,.ag-column-select-column-group,.ag-select-agg-func-item{position:relative;align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;height:100%}.ag-column-select-column>*,.ag-column-select-column-group>*,.ag-select-agg-func-item>*{flex:none}.ag-select-agg-func-item,.ag-column-select-column-label{flex:1 1 auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-select-checkbox{display:flex}.ag-tool-panel-horizontal-resize{cursor:ew-resize;height:100%;position:absolute;top:0;width:5px;z-index:1}.ag-ltr .ag-side-bar-left .ag-tool-panel-horizontal-resize{right:-3px}.ag-rtl .ag-side-bar-left .ag-tool-panel-horizontal-resize,.ag-ltr .ag-side-bar-right .ag-tool-panel-horizontal-resize{left:-3px}.ag-rtl .ag-side-bar-right .ag-tool-panel-horizontal-resize{right:-3px}.ag-details-row{width:100%}.ag-details-row-fixed-height{height:100%}.ag-details-grid{width:100%}.ag-details-grid-fixed-height{height:100%}.ag-header-group-cell{display:flex;align-items:center;height:100%;position:absolute}.ag-header-group-cell-no-group.ag-header-span-height .ag-header-cell-resize{display:none}.ag-cell-label-container{display:flex;justify-content:space-between;flex-direction:row-reverse;align-items:center;height:100%;width:100%;padding:5px 0}.ag-right-aligned-header .ag-cell-label-container{flex-direction:row}.ag-right-aligned-header .ag-header-cell-text{text-align:end}.ag-side-bar{display:flex;flex-direction:row-reverse}.ag-side-bar-left{order:-1;flex-direction:row}.ag-side-button-button{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;flex-wrap:nowrap;white-space:nowrap;outline:none;cursor:pointer}.ag-side-button-label{writing-mode:vertical-lr}.ag-status-bar{display:flex;justify-content:space-between;overflow:hidden}.ag-status-panel{display:inline-flex}.ag-status-name-value{white-space:nowrap}.ag-status-bar-left,.ag-status-bar-center,.ag-status-bar-right{display:inline-flex}.ag-icon{display:block;speak:none}.ag-group{position:relative;width:100%}.ag-group-title-bar{display:flex;align-items:center}.ag-group-title{display:inline;min-width:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ag-group-title-bar .ag-group-title{cursor:default}.ag-group-toolbar{display:flex;align-items:center}.ag-group-container{display:flex}.ag-disabled .ag-group-container{pointer-events:none}.ag-group-container-horizontal{flex-direction:row;flex-wrap:wrap}.ag-group-container-vertical{flex-direction:column}.ag-column-group-icons{display:block}.ag-column-group-icons>*{cursor:pointer}.ag-group-item-alignment-stretch .ag-group-item{align-items:stretch}.ag-group-item-alignment-start .ag-group-item{align-items:flex-start}.ag-group-item-alignment-end .ag-group-item{align-items:flex-end}.ag-toggle-button-icon{transition:right .3s;position:absolute;top:-1px}.ag-input-field,.ag-select{display:flex;flex-direction:row;align-items:center}.ag-input-field-input{flex:1 1 auto}.ag-floating-filter-input .ag-input-field-input[type=date]{width:1px}.ag-range-field,.ag-angle-select{display:flex;align-items:center}.ag-angle-select-wrapper{display:flex}.ag-angle-select-parent-circle{display:block;position:relative}.ag-angle-select-child-circle{position:absolute}.ag-slider-wrapper{display:flex}.ag-slider-wrapper .ag-input-field,.ag-picker-field-display{flex:1 1 auto}.ag-picker-field{display:flex;align-items:center}.ag-picker-field-icon{display:flex;border:0;padding:0;margin:0;cursor:pointer}.ag-picker-field-wrapper{overflow:hidden}.ag-label-align-right .ag-label{order:1}.ag-label-align-right>*{flex:none}.ag-label-align-top{flex-direction:column;align-items:flex-start}.ag-label-align-top>*{align-self:stretch}.ag-label-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}.ag-color-panel{width:100%;display:flex;flex-direction:column;text-align:center}.ag-spectrum-color{flex:1 1 auto;position:relative;overflow:hidden;cursor:default}.ag-spectrum-fill{position:absolute;top:0;left:0;right:0;bottom:0}.ag-spectrum-val{cursor:pointer}.ag-spectrum-dragger{position:absolute;pointer-events:none;cursor:pointer}.ag-spectrum-hue{cursor:default;background:linear-gradient(to left,red 3%,#ff0 17%,#0f0 33%,#0ff,#00f 67%,#f0f 83%,red)}.ag-spectrum-alpha{cursor:default}.ag-spectrum-hue-background{width:100%;height:100%}.ag-spectrum-alpha-background{background-image:linear-gradient(to right,#0000,#000);width:100%;height:100%}.ag-spectrum-tool{cursor:pointer}.ag-spectrum-slider{position:absolute;pointer-events:none}.ag-recent-colors{display:flex}.ag-recent-color{cursor:pointer}.ag-ltr .ag-column-select-indent-1{padding-left:20px}.ag-rtl .ag-column-select-indent-1{padding-right:20px}.ag-ltr .ag-set-filter-indent-1{padding-left:20px}.ag-rtl .ag-set-filter-indent-1{padding-right:20px}.ag-ltr .ag-row-group-indent-1{padding-left:20px}.ag-rtl .ag-row-group-indent-1{padding-right:20px}.ag-ltr .ag-column-select-indent-2{padding-left:40px}.ag-rtl .ag-column-select-indent-2{padding-right:40px}.ag-ltr .ag-set-filter-indent-2{padding-left:40px}.ag-rtl .ag-set-filter-indent-2{padding-right:40px}.ag-ltr .ag-row-group-indent-2{padding-left:40px}.ag-rtl .ag-row-group-indent-2{padding-right:40px}.ag-ltr .ag-column-select-indent-3{padding-left:60px}.ag-rtl .ag-column-select-indent-3{padding-right:60px}.ag-ltr .ag-set-filter-indent-3{padding-left:60px}.ag-rtl .ag-set-filter-indent-3{padding-right:60px}.ag-ltr .ag-row-group-indent-3{padding-left:60px}.ag-rtl .ag-row-group-indent-3{padding-right:60px}.ag-ltr .ag-column-select-indent-4{padding-left:80px}.ag-rtl .ag-column-select-indent-4{padding-right:80px}.ag-ltr .ag-set-filter-indent-4{padding-left:80px}.ag-rtl .ag-set-filter-indent-4{padding-right:80px}.ag-ltr .ag-row-group-indent-4{padding-left:80px}.ag-rtl .ag-row-group-indent-4{padding-right:80px}.ag-ltr .ag-column-select-indent-5{padding-left:100px}.ag-rtl .ag-column-select-indent-5{padding-right:100px}.ag-ltr .ag-set-filter-indent-5{padding-left:100px}.ag-rtl .ag-set-filter-indent-5{padding-right:100px}.ag-ltr .ag-row-group-indent-5{padding-left:100px}.ag-rtl .ag-row-group-indent-5{padding-right:100px}.ag-ltr .ag-column-select-indent-6{padding-left:120px}.ag-rtl .ag-column-select-indent-6{padding-right:120px}.ag-ltr .ag-set-filter-indent-6{padding-left:120px}.ag-rtl .ag-set-filter-indent-6{padding-right:120px}.ag-ltr .ag-row-group-indent-6{padding-left:120px}.ag-rtl .ag-row-group-indent-6{padding-right:120px}.ag-ltr .ag-column-select-indent-7{padding-left:140px}.ag-rtl .ag-column-select-indent-7{padding-right:140px}.ag-ltr .ag-set-filter-indent-7{padding-left:140px}.ag-rtl .ag-set-filter-indent-7{padding-right:140px}.ag-ltr .ag-row-group-indent-7{padding-left:140px}.ag-rtl .ag-row-group-indent-7{padding-right:140px}.ag-ltr .ag-column-select-indent-8{padding-left:160px}.ag-rtl .ag-column-select-indent-8{padding-right:160px}.ag-ltr .ag-set-filter-indent-8{padding-left:160px}.ag-rtl .ag-set-filter-indent-8{padding-right:160px}.ag-ltr .ag-row-group-indent-8{padding-left:160px}.ag-rtl .ag-row-group-indent-8{padding-right:160px}.ag-ltr .ag-column-select-indent-9{padding-left:180px}.ag-rtl .ag-column-select-indent-9{padding-right:180px}.ag-ltr .ag-set-filter-indent-9{padding-left:180px}.ag-rtl .ag-set-filter-indent-9{padding-right:180px}.ag-ltr .ag-row-group-indent-9{padding-left:180px}.ag-rtl .ag-row-group-indent-9{padding-right:180px}.ag-pill-select{display:flex;flex-direction:column}.ag-pill-select .ag-column-drop{flex:unset}.ag-ltr{direction:ltr}.ag-ltr .ag-body,.ag-ltr .ag-floating-top,.ag-ltr .ag-floating-bottom,.ag-ltr .ag-header,.ag-ltr .ag-sticky-top,.ag-ltr .ag-sticky-bottom,.ag-ltr .ag-body-viewport,.ag-ltr .ag-body-horizontal-scroll{flex-direction:row}.ag-rtl{direction:rtl}.ag-rtl .ag-body,.ag-rtl .ag-floating-top,.ag-rtl .ag-floating-bottom,.ag-rtl .ag-header,.ag-rtl .ag-sticky-top,.ag-rtl .ag-sticky-bottom,.ag-rtl .ag-body-viewport,.ag-rtl .ag-body-horizontal-scroll{flex-direction:row-reverse}.ag-rtl .ag-icon-contracted,.ag-rtl .ag-icon-expanded,.ag-rtl .ag-icon-tree-closed{display:block;transform:rotate(180deg)}.ag-body .ag-body-viewport{-webkit-overflow-scrolling:touch}.ag-layout-print.ag-body{display:block;height:unset}.ag-layout-print.ag-root-wrapper{display:inline-block}.ag-layout-print .ag-body-vertical-scroll,.ag-layout-print .ag-body-horizontal-scroll{display:none}.ag-layout-print.ag-force-vertical-scroll{overflow-y:visible!important}@media print{.ag-root-wrapper.ag-layout-print{display:table}.ag-root-wrapper.ag-layout-print .ag-root-wrapper-body,.ag-root-wrapper.ag-layout-print .ag-root,.ag-root-wrapper.ag-layout-print .ag-body-viewport,.ag-root-wrapper.ag-layout-print .ag-center-cols-container,.ag-root-wrapper.ag-layout-print .ag-center-cols-viewport,.ag-root-wrapper.ag-layout-print .ag-body-horizontal-scroll-viewport,.ag-root-wrapper.ag-layout-print .ag-virtual-list-viewport{height:auto!important;overflow:hidden!important;display:block!important}.ag-root-wrapper.ag-layout-print .ag-row,.ag-root-wrapper.ag-layout-print .ag-cell{break-inside:avoid}}[class^=ag-],[class^=ag-]:focus,[class^=ag-]:after,[class^=ag-]:before{box-sizing:border-box;outline:none}[class^=ag-]::-ms-clear{display:none}.ag-checkbox .ag-input-wrapper,.ag-radio-button .ag-input-wrapper{overflow:visible}.ag-range-field .ag-input-wrapper{height:100%}.ag-toggle-button{flex:none;width:unset;min-width:unset}.ag-button{border-radius:0;color:var(--ag-foreground-color)}.ag-button:hover{background-color:transparent}.ag-ltr .ag-label-align-right .ag-label{margin-left:var(--ag-grid-size)}.ag-rtl .ag-label-align-right .ag-label{margin-right:var(--ag-grid-size)}input[class^=ag-]{margin:0;background-color:var(--ag-background-color)}textarea[class^=ag-],select[class^=ag-]{background-color:var(--ag-background-color)}input[class^=ag-]:not([type]),input[class^=ag-][type=text],input[class^=ag-][type=number],input[class^=ag-][type=tel],input[class^=ag-][type=date],input[class^=ag-][type=datetime-local],textarea[class^=ag-]{font-size:inherit;line-height:inherit;color:inherit;font-family:inherit;border:var(--ag-borders-input) var(--ag-input-border-color)}input[class^=ag-]:not([type]):disabled,input[class^=ag-][type=text]:disabled,input[class^=ag-][type=number]:disabled,input[class^=ag-][type=tel]:disabled,input[class^=ag-][type=date]:disabled,input[class^=ag-][type=datetime-local]:disabled,textarea[class^=ag-]:disabled{color:var(--ag-disabled-foreground-color);background-color:var(--ag-input-disabled-background-color);border-color:var(--ag-input-disabled-border-color)}input[class^=ag-]:not([type]):focus,input[class^=ag-][type=text]:focus,input[class^=ag-][type=number]:focus,input[class^=ag-][type=tel]:focus,input[class^=ag-][type=date]:focus,input[class^=ag-][type=datetime-local]:focus,textarea[class^=ag-]:focus{outline:none;box-shadow:var(--ag-input-focus-box-shadow);border-color:var(--ag-input-focus-border-color)}input[class^=ag-]:not([type]):invalid,input[class^=ag-][type=text]:invalid,input[class^=ag-][type=number]:invalid,input[class^=ag-][type=tel]:invalid,input[class^=ag-][type=date]:invalid,input[class^=ag-][type=datetime-local]:invalid,textarea[class^=ag-]:invalid{border:var(--ag-borders-input-invalid) var(--ag-input-border-color-invalid)}input[class^=ag-][type=number]:not(.ag-number-field-input-stepper){-moz-appearance:textfield}input[class^=ag-][type=number]:not(.ag-number-field-input-stepper)::-webkit-outer-spin-button,input[class^=ag-][type=number]:not(.ag-number-field-input-stepper)::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}input[class^=ag-][type=range]{padding:0}input[class^=ag-][type=button]:focus,button[class^=ag-]:focus{box-shadow:var(--ag-input-focus-box-shadow)}.ag-drag-handle{color:var(--ag-secondary-foreground-color)}.ag-list-item,.ag-virtual-list-item{height:var(--ag-list-item-height)}.ag-virtual-list-item:focus-visible{outline:none}.ag-virtual-list-item:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-select-list{background-color:var(--ag-background-color);overflow-y:auto;overflow-x:hidden;border-radius:var(--ag-border-radius);border:var(--ag-borders) var(--ag-border-color)}.ag-list-item{display:flex;align-items:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ag-list-item.ag-active-item{background-color:var(--ag-row-hover-color)}.ag-select-list-item{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.ag-ltr .ag-select-list-item{padding-left:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-rtl .ag-select-list-item{padding-right:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-select-list-item span{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.ag-row-drag,.ag-selection-checkbox,.ag-group-expanded,.ag-group-contracted{color:var(--ag-secondary-foreground-color)}.ag-ltr .ag-row-drag,.ag-ltr .ag-selection-checkbox,.ag-ltr .ag-group-expanded,.ag-ltr .ag-group-contracted{margin-right:var(--ag-cell-widget-spacing)}.ag-rtl .ag-row-drag,.ag-rtl .ag-selection-checkbox,.ag-rtl .ag-group-expanded,.ag-rtl .ag-group-contracted{margin-left:var(--ag-cell-widget-spacing)}.ag-cell-wrapper>*:not(.ag-cell-value):not(.ag-group-value){--ag-internal-calculated-line-height: var(--ag-line-height, calc(var(--ag-row-height) - var(--ag-row-border-width)));--ag-internal-padded-row-height: calc(var(--ag-row-height) - var(--ag-row-border-width));height:min(var(--ag-internal-calculated-line-height),var(--ag-internal-padded-row-height));display:flex;align-items:center;flex:none}.ag-group-expanded,.ag-group-contracted{cursor:pointer}.ag-group-title-bar-icon{cursor:pointer;flex:none;color:var(--ag-secondary-foreground-color)}.ag-ltr .ag-group-child-count{margin-left:2px}.ag-rtl .ag-group-child-count{margin-right:2px}.ag-group-title-bar{background-color:var(--ag-subheader-background-color);padding:var(--ag-grid-size)}.ag-group-toolbar{padding:var(--ag-grid-size);background-color:var(--ag-subheader-toolbar-background-color)}.ag-disabled-group-title-bar,.ag-disabled-group-container{opacity:.5}.group-item{margin:calc(var(--ag-grid-size) * .5) 0}.ag-label{white-space:nowrap}.ag-ltr .ag-label{margin-right:var(--ag-grid-size)}.ag-rtl .ag-label{margin-left:var(--ag-grid-size)}.ag-label-align-top .ag-label{margin-bottom:calc(var(--ag-grid-size) * .5)}.ag-angle-select[disabled]{color:var(--ag-disabled-foreground-color);pointer-events:none}.ag-angle-select[disabled] .ag-angle-select-field{opacity:.4}.ag-ltr .ag-slider-field,.ag-ltr .ag-angle-select-field{margin-right:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-slider-field,.ag-rtl .ag-angle-select-field{margin-left:calc(var(--ag-grid-size) * 2)}.ag-angle-select-parent-circle{width:24px;height:24px;border-radius:12px;border:solid 1px;border-color:var(--ag-border-color);background-color:var(--ag-background-color)}.ag-angle-select-child-circle{top:4px;left:12px;width:6px;height:6px;margin-left:-3px;margin-top:-4px;border-radius:3px;background-color:var(--ag-secondary-foreground-color)}.ag-picker-field-wrapper{border:var(--ag-borders);border-color:var(--ag-border-color);border-radius:5px;background-color:var(--ag-background-color)}.ag-picker-field-wrapper:disabled{color:var(--ag-disabled-foreground-color);background-color:var(--ag-input-disabled-background-color);border-color:var(--ag-input-disabled-border-color)}.ag-picker-field-wrapper.ag-picker-has-focus,.ag-picker-field-wrapper:focus-within{outline:none;box-shadow:var(--ag-input-focus-box-shadow);border-color:var(--ag-input-focus-border-color)}.ag-picker-field-button{background-color:var(--ag-background-color);color:var(--ag-secondary-foreground-color)}.ag-dialog.ag-color-dialog{border-radius:5px}.ag-color-picker .ag-picker-field-display{height:var(--ag-icon-size)}.ag-color-picker .ag-picker-field-wrapper{max-width:45px;min-width:45px}.ag-color-panel{padding:var(--ag-grid-size)}.ag-spectrum-color{background-color:red;border-radius:2px}.ag-spectrum-tools{padding:10px}.ag-spectrum-sat{background-image:linear-gradient(to right,#fff,#cc9a8100)}.ag-spectrum-val{background-image:linear-gradient(to top,#000,#cc9a8100)}.ag-spectrum-dragger{border-radius:12px;height:12px;width:12px;border:1px solid white;background:#000;box-shadow:0 0 2px #0000003d}.ag-spectrum-hue-background,.ag-spectrum-alpha-background{border-radius:2px}.ag-spectrum-tool{margin-bottom:10px;height:11px;border-radius:2px}.ag-spectrum-slider{margin-top:-12px;width:13px;height:13px;border-radius:13px;background-color:#f8f8f8;box-shadow:0 1px 4px #0000005e}.ag-recent-color{margin:0 3px}.ag-recent-color:first-child{margin-left:0}.ag-recent-color:last-child{margin-right:0}.ag-spectrum-color:focus-visible:not(:disabled):not([readonly]),.ag-spectrum-slider:focus-visible:not(:disabled):not([readonly]),.ag-recent-color:focus-visible:not(:disabled):not([readonly]){box-shadow:var(--ag-input-focus-box-shadow)}.ag-dnd-ghost{border:var(--ag-borders) var(--ag-border-color);background:var(--ag-background-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:var(--ag-grid-size);overflow:hidden;text-overflow:ellipsis;border:var(--ag-borders-secondary) var(--ag-secondary-border-color);color:var(--ag-secondary-foreground-color);height:var(--ag-header-height)!important;line-height:var(--ag-header-height);margin:0;padding:0 calc(var(--ag-grid-size) * 2);transform:translateY(calc(var(--ag-grid-size) * 2))}.ag-dnd-ghost-icon{margin-right:var(--ag-grid-size);color:var(--ag-foreground-color)}.ag-popup-child:not(.ag-tooltip-custom){box-shadow:var(--ag-popup-shadow)}.ag-select .ag-picker-field-wrapper{min-height:var(--ag-list-item-height);cursor:default}.ag-ltr .ag-select .ag-picker-field-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-rtl .ag-select .ag-picker-field-wrapper{padding-right:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-ltr .ag-select .ag-picker-field-wrapper{padding-right:var(--ag-grid-size)}.ag-rtl .ag-select .ag-picker-field-wrapper{padding-left:var(--ag-grid-size)}.ag-select.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}.ag-select:not(.ag-cell-editor,.ag-label-align-top){min-height:var(--ag-list-item-height)}.ag-select .ag-picker-field-display{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ag-select .ag-picker-field-icon{display:flex;align-items:center}.ag-select.ag-disabled{opacity:.5}.ag-rich-select-value,.ag-rich-select-list{background-color:var(--ag-background-color)}.ag-rich-select-list{width:100%;height:auto;border-radius:var(--ag-border-radius);border:var(--ag-borders) var(--ag-border-color)}.ag-rich-select-list .ag-loading-text{padding:var(--ag-widget-vertical-spacing) var(--ag-widget-horizontal-spacing)}.ag-rich-select-value{border-bottom:var(--ag-borders-secondary) var(--ag-secondary-border-color);padding-top:0;padding-bottom:0}.ag-ltr .ag-rich-select-value{padding-left:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-rtl .ag-rich-select-value{padding-right:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-ltr .ag-rich-select-value{padding-right:var(--ag-grid-size)}.ag-rtl .ag-rich-select-value{padding-left:var(--ag-grid-size)}.ag-ltr .ag-rich-select-field-input{left:calc(var(--ag-cell-horizontal-padding))}.ag-rtl .ag-rich-select-field-input{right:calc(var(--ag-cell-horizontal-padding))}.ag-popup-editor .ag-rich-select-value{height:var(--ag-row-height);min-width:200px}.ag-rich-select-virtual-list-item{cursor:default;height:var(--ag-list-item-height)}.ag-rich-select-virtual-list-item:focus-visible:after{content:none}.ag-rich-select-virtual-list-item:hover{background-color:var(--ag-row-hover-color)}.ag-ltr .ag-rich-select-row{padding-left:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-rtl .ag-rich-select-row{padding-right:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-rich-select-row-selected{background-color:var(--ag-selected-row-background-color)}.ag-rich-select-row-text-highlight{font-weight:700}.ag-autocomplete{width:100%}.ag-autocomplete-list{width:100%;min-width:200px;height:calc(var(--ag-row-height) * 6.5)}.ag-autocomplete-virtual-list-item{cursor:default;height:var(--ag-list-item-height)}.ag-autocomplete-virtual-list-item:focus-visible:after{content:none}.ag-autocomplete-virtual-list-item:hover{background-color:var(--ag-row-hover-color)}.ag-autocomplete-row-label{margin:0px var(--ag-widget-container-horizontal-padding)}.ag-autocomplete-row-selected{background-color:var(--ag-selected-row-background-color)}.ag-dragging-range-handle .ag-dialog,.ag-dragging-fill-handle .ag-dialog{opacity:.7;pointer-events:none}.ag-dialog{border-radius:var(--ag-border-radius);border:var(--ag-borders) var(--ag-border-color);box-shadow:var(--ag-popup-shadow)}.ag-panel{background-color:var(--ag-panel-background-color);border-color:var(--ag-panel-border-color)}.ag-panel-title-bar{color:var(--ag-header-foreground-color);height:var(--ag-header-height);padding:var(--ag-grid-size) var(--ag-cell-horizontal-padding);border-bottom:var(--ag-borders) var(--ag-border-color)}.ag-ltr .ag-panel-title-bar-button{margin-left:var(--ag-grid-size)}.ag-rtl .ag-panel-title-bar-button{margin-right:var(--ag-grid-size)}.ag-tooltip{background-color:var(--ag-tooltip-background-color);color:var(--ag-foreground-color);padding:var(--ag-grid-size);border:var(--ag-borders) var(--ag-border-color);border-radius:var(--ag-card-radius);white-space:normal}.ag-tooltip.ag-tooltip-animate,.ag-tooltip-custom.ag-tooltip-animate{transition:opacity 1s}.ag-tooltip.ag-tooltip-animate.ag-tooltip-hiding,.ag-tooltip-custom.ag-tooltip-animate.ag-tooltip-hiding{opacity:0}.ag-ltr .ag-column-select-indent-1{padding-left:calc(1 * var(--ag-column-select-indent-size))}.ag-rtl .ag-column-select-indent-1{padding-right:calc(1 * var(--ag-column-select-indent-size))}.ag-ltr .ag-column-select-indent-2{padding-left:calc(2 * var(--ag-column-select-indent-size))}.ag-rtl .ag-column-select-indent-2{padding-right:calc(2 * var(--ag-column-select-indent-size))}.ag-ltr .ag-column-select-indent-3{padding-left:calc(3 * var(--ag-column-select-indent-size))}.ag-rtl .ag-column-select-indent-3{padding-right:calc(3 * var(--ag-column-select-indent-size))}.ag-ltr .ag-column-select-indent-4{padding-left:calc(4 * var(--ag-column-select-indent-size))}.ag-rtl .ag-column-select-indent-4{padding-right:calc(4 * var(--ag-column-select-indent-size))}.ag-ltr .ag-column-select-indent-5{padding-left:calc(5 * var(--ag-column-select-indent-size))}.ag-rtl .ag-column-select-indent-5{padding-right:calc(5 * var(--ag-column-select-indent-size))}.ag-ltr .ag-column-select-indent-6{padding-left:calc(6 * var(--ag-column-select-indent-size))}.ag-rtl .ag-column-select-indent-6{padding-right:calc(6 * var(--ag-column-select-indent-size))}.ag-ltr .ag-column-select-indent-7{padding-left:calc(7 * var(--ag-column-select-indent-size))}.ag-rtl .ag-column-select-indent-7{padding-right:calc(7 * var(--ag-column-select-indent-size))}.ag-ltr .ag-column-select-indent-8{padding-left:calc(8 * var(--ag-column-select-indent-size))}.ag-rtl .ag-column-select-indent-8{padding-right:calc(8 * var(--ag-column-select-indent-size))}.ag-ltr .ag-column-select-indent-9{padding-left:calc(9 * var(--ag-column-select-indent-size))}.ag-rtl .ag-column-select-indent-9{padding-right:calc(9 * var(--ag-column-select-indent-size))}.ag-column-select-header-icon{cursor:pointer}.ag-column-select-header-icon:focus-visible{outline:none}.ag-column-select-header-icon:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:0;left:0;display:block;width:calc(100% + -0px);height:calc(100% + -0px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-ltr .ag-column-group-icons:not(:last-child),.ag-ltr .ag-column-select-header-icon:not(:last-child),.ag-ltr .ag-column-select-header-checkbox:not(:last-child),.ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child),.ag-ltr .ag-column-select-checkbox:not(:last-child),.ag-ltr .ag-column-select-column-drag-handle:not(:last-child),.ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child),.ag-ltr .ag-column-select-column-label:not(:last-child){margin-right:var(--ag-widget-horizontal-spacing)}.ag-rtl .ag-column-group-icons:not(:last-child),.ag-rtl .ag-column-select-header-icon:not(:last-child),.ag-rtl .ag-column-select-header-checkbox:not(:last-child),.ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child),.ag-rtl .ag-column-select-checkbox:not(:last-child),.ag-rtl .ag-column-select-column-drag-handle:not(:last-child),.ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child),.ag-rtl .ag-column-select-column-label:not(:last-child){margin-left:var(--ag-widget-horizontal-spacing)}.ag-column-select-virtual-list-item:focus-visible{outline:none}.ag-column-select-virtual-list-item:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:1px;left:1px;display:block;width:calc(100% - 2px);height:calc(100% - 2px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-column-select-column-group:not(:last-child),.ag-column-select-column:not(:last-child){margin-bottom:var(--ag-widget-vertical-spacing)}.ag-column-select-column-readonly,.ag-column-select-column-group-readonly{color:var(--ag-disabled-foreground-color);pointer-events:none}.ag-ltr .ag-column-select-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-grid-size) * 2)}.ag-rtl .ag-column-select-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-grid-size) * 2)}.ag-column-select-virtual-list-viewport{padding:calc(var(--ag-widget-container-vertical-padding) * .5) 0px}.ag-column-select-virtual-list-item{padding:0 var(--ag-widget-container-horizontal-padding)}.ag-checkbox-edit{padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding)}.ag-pill-select .ag-column-drop{border-bottom:0;min-height:unset}.ag-pill-select .ag-column-drop-list{padding:0}.ag-pill-select .ag-select{padding-top:var(--ag-grid-size)}.ag-pill-select .ag-picker-field-wrapper{background-color:transparent;border:0}.ag-pill-select .ag-picker-field-display{cursor:pointer}.ag-rtl{text-align:right}.ag-root-wrapper{border-radius:var(--ag-wrapper-border-radius);border:var(--ag-borders) var(--ag-border-color)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-1{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 1)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-1{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 1)}.ag-ltr .ag-row-group-indent-1{padding-left:calc(1 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-1{padding-right:calc(1 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-1 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-1 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-2{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 2)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-2{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 2)}.ag-ltr .ag-row-group-indent-2{padding-left:calc(2 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-2{padding-right:calc(2 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-2 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-2 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-3{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 3)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-3{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 3)}.ag-ltr .ag-row-group-indent-3{padding-left:calc(3 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-3{padding-right:calc(3 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-3 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-3 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-4{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 4)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-4{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 4)}.ag-ltr .ag-row-group-indent-4{padding-left:calc(4 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-4{padding-right:calc(4 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-4 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-4 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-5{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 5)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-5{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 5)}.ag-ltr .ag-row-group-indent-5{padding-left:calc(5 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-5{padding-right:calc(5 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-5 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-5 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-6{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 6)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-6{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 6)}.ag-ltr .ag-row-group-indent-6{padding-left:calc(6 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-6{padding-right:calc(6 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-6 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-6 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-7{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 7)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-7{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 7)}.ag-ltr .ag-row-group-indent-7{padding-left:calc(7 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-7{padding-right:calc(7 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-7 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-7 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-8{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 8)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-8{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 8)}.ag-ltr .ag-row-group-indent-8{padding-left:calc(8 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-8{padding-right:calc(8 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-8 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-8 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-9{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 9)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-9{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 9)}.ag-ltr .ag-row-group-indent-9{padding-left:calc(9 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-9{padding-right:calc(9 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-9 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-9 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-10{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 10)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-10{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 10)}.ag-ltr .ag-row-group-indent-10{padding-left:calc(10 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-10{padding-right:calc(10 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-10 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-10 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-11{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 11)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-11{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 11)}.ag-ltr .ag-row-group-indent-11{padding-left:calc(11 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-11{padding-right:calc(11 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-11 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-11 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-12{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 12)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-12{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 12)}.ag-ltr .ag-row-group-indent-12{padding-left:calc(12 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-12{padding-right:calc(12 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-12 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-12 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-13{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 13)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-13{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 13)}.ag-ltr .ag-row-group-indent-13{padding-left:calc(13 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-13{padding-right:calc(13 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-13 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-13 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-14{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 14)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-14{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 14)}.ag-ltr .ag-row-group-indent-14{padding-left:calc(14 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-14{padding-right:calc(14 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-14 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-14 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-15{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 15)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-15{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 15)}.ag-ltr .ag-row-group-indent-15{padding-left:calc(15 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-15{padding-right:calc(15 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-15 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-15 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-16{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 16)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-16{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 16)}.ag-ltr .ag-row-group-indent-16{padding-left:calc(16 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-16{padding-right:calc(16 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-16 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-16 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-17{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 17)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-17{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 17)}.ag-ltr .ag-row-group-indent-17{padding-left:calc(17 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-17{padding-right:calc(17 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-17 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-17 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-18{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 18)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-18{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 18)}.ag-ltr .ag-row-group-indent-18{padding-left:calc(18 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-18{padding-right:calc(18 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-18 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-18 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-19{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 19)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-19{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 19)}.ag-ltr .ag-row-group-indent-19{padding-left:calc(19 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-19{padding-right:calc(19 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-19 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-19 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-20{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 20)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-20{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 20)}.ag-ltr .ag-row-group-indent-20{padding-left:calc(20 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-20{padding-right:calc(20 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-20 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-20 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-21{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 21)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-21{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 21)}.ag-ltr .ag-row-group-indent-21{padding-left:calc(21 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-21{padding-right:calc(21 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-21 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-21 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-22{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 22)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-22{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 22)}.ag-ltr .ag-row-group-indent-22{padding-left:calc(22 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-22{padding-right:calc(22 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-22 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-22 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-23{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 23)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-23{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 23)}.ag-ltr .ag-row-group-indent-23{padding-left:calc(23 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-23{padding-right:calc(23 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-23 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-23 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-24{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 24)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-24{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 24)}.ag-ltr .ag-row-group-indent-24{padding-left:calc(24 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-24{padding-right:calc(24 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-24 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-24 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-25{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 25)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-25{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 25)}.ag-ltr .ag-row-group-indent-25{padding-left:calc(25 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-25{padding-right:calc(25 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-25 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-25 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-26{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 26)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-26{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 26)}.ag-ltr .ag-row-group-indent-26{padding-left:calc(26 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-26{padding-right:calc(26 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-26 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-26 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-27{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 27)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-27{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 27)}.ag-ltr .ag-row-group-indent-27{padding-left:calc(27 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-27{padding-right:calc(27 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-27 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-27 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-28{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 28)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-28{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 28)}.ag-ltr .ag-row-group-indent-28{padding-left:calc(28 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-28{padding-right:calc(28 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-28 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-28 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-29{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 29)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-29{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 29)}.ag-ltr .ag-row-group-indent-29{padding-left:calc(29 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-29{padding-right:calc(29 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-29 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-29 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-30{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 30)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-30{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 30)}.ag-ltr .ag-row-group-indent-30{padding-left:calc(30 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-30{padding-right:calc(30 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-30 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-30 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-31{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 31)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-31{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 31)}.ag-ltr .ag-row-group-indent-31{padding-left:calc(31 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-31{padding-right:calc(31 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-31 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-31 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-32{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 32)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-32{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 32)}.ag-ltr .ag-row-group-indent-32{padding-left:calc(32 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-32{padding-right:calc(32 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-32 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-32 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-33{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 33)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-33{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 33)}.ag-ltr .ag-row-group-indent-33{padding-left:calc(33 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-33{padding-right:calc(33 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-33 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-33 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-34{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 34)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-34{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 34)}.ag-ltr .ag-row-group-indent-34{padding-left:calc(34 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-34{padding-right:calc(34 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-34 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-34 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-35{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 35)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-35{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 35)}.ag-ltr .ag-row-group-indent-35{padding-left:calc(35 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-35{padding-right:calc(35 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-35 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-35 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-36{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 36)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-36{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 36)}.ag-ltr .ag-row-group-indent-36{padding-left:calc(36 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-36{padding-right:calc(36 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-36 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-36 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-37{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 37)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-37{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 37)}.ag-ltr .ag-row-group-indent-37{padding-left:calc(37 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-37{padding-right:calc(37 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-37 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-37 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-38{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 38)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-38{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 38)}.ag-ltr .ag-row-group-indent-38{padding-left:calc(38 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-38{padding-right:calc(38 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-38 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-38 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-39{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 39)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-39{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 39)}.ag-ltr .ag-row-group-indent-39{padding-left:calc(39 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-39{padding-right:calc(39 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-39 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-39 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-40{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 40)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-40{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 40)}.ag-ltr .ag-row-group-indent-40{padding-left:calc(40 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-40{padding-right:calc(40 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-40 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-40 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-41{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 41)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-41{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 41)}.ag-ltr .ag-row-group-indent-41{padding-left:calc(41 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-41{padding-right:calc(41 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-41 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-41 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-42{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 42)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-42{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 42)}.ag-ltr .ag-row-group-indent-42{padding-left:calc(42 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-42{padding-right:calc(42 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-42 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-42 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-43{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 43)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-43{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 43)}.ag-ltr .ag-row-group-indent-43{padding-left:calc(43 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-43{padding-right:calc(43 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-43 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-43 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-44{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 44)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-44{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 44)}.ag-ltr .ag-row-group-indent-44{padding-left:calc(44 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-44{padding-right:calc(44 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-44 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-44 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-45{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 45)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-45{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 45)}.ag-ltr .ag-row-group-indent-45{padding-left:calc(45 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-45{padding-right:calc(45 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-45 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-45 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-46{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 46)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-46{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 46)}.ag-ltr .ag-row-group-indent-46{padding-left:calc(46 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-46{padding-right:calc(46 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-46 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-46 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-47{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 47)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-47{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 47)}.ag-ltr .ag-row-group-indent-47{padding-left:calc(47 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-47{padding-right:calc(47 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-47 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-47 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-48{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 48)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-48{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 48)}.ag-ltr .ag-row-group-indent-48{padding-left:calc(48 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-48{padding-right:calc(48 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-48 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-48 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-49{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 49)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-49{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 49)}.ag-ltr .ag-row-group-indent-49{padding-left:calc(49 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-49{padding-right:calc(49 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-49 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-49 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-50{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 50)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-50{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 50)}.ag-ltr .ag-row-group-indent-50{padding-left:calc(50 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-50{padding-right:calc(50 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-50 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-50 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-51{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 51)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-51{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 51)}.ag-ltr .ag-row-group-indent-51{padding-left:calc(51 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-51{padding-right:calc(51 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-51 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-51 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-52{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 52)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-52{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 52)}.ag-ltr .ag-row-group-indent-52{padding-left:calc(52 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-52{padding-right:calc(52 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-52 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-52 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-53{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 53)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-53{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 53)}.ag-ltr .ag-row-group-indent-53{padding-left:calc(53 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-53{padding-right:calc(53 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-53 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-53 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-54{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 54)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-54{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 54)}.ag-ltr .ag-row-group-indent-54{padding-left:calc(54 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-54{padding-right:calc(54 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-54 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-54 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-55{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 55)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-55{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 55)}.ag-ltr .ag-row-group-indent-55{padding-left:calc(55 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-55{padding-right:calc(55 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-55 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-55 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-56{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 56)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-56{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 56)}.ag-ltr .ag-row-group-indent-56{padding-left:calc(56 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-56{padding-right:calc(56 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-56 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-56 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-57{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 57)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-57{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 57)}.ag-ltr .ag-row-group-indent-57{padding-left:calc(57 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-57{padding-right:calc(57 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-57 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-57 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-58{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 58)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-58{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 58)}.ag-ltr .ag-row-group-indent-58{padding-left:calc(58 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-58{padding-right:calc(58 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-58 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-58 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-59{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 59)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-59{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 59)}.ag-ltr .ag-row-group-indent-59{padding-left:calc(59 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-59{padding-right:calc(59 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-59 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-59 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-60{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 60)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-60{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 60)}.ag-ltr .ag-row-group-indent-60{padding-left:calc(60 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-60{padding-right:calc(60 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-60 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-60 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-61{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 61)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-61{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 61)}.ag-ltr .ag-row-group-indent-61{padding-left:calc(61 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-61{padding-right:calc(61 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-61 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-61 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-62{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 62)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-62{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 62)}.ag-ltr .ag-row-group-indent-62{padding-left:calc(62 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-62{padding-right:calc(62 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-62 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-62 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-63{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 63)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-63{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 63)}.ag-ltr .ag-row-group-indent-63{padding-left:calc(63 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-63{padding-right:calc(63 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-63 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-63 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-64{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 64)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-64{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 64)}.ag-ltr .ag-row-group-indent-64{padding-left:calc(64 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-64{padding-right:calc(64 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-64 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-64 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-65{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 65)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-65{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 65)}.ag-ltr .ag-row-group-indent-65{padding-left:calc(65 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-65{padding-right:calc(65 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-65 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-65 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-66{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 66)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-66{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 66)}.ag-ltr .ag-row-group-indent-66{padding-left:calc(66 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-66{padding-right:calc(66 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-66 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-66 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-67{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 67)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-67{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 67)}.ag-ltr .ag-row-group-indent-67{padding-left:calc(67 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-67{padding-right:calc(67 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-67 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-67 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-68{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 68)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-68{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 68)}.ag-ltr .ag-row-group-indent-68{padding-left:calc(68 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-68{padding-right:calc(68 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-68 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-68 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-69{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 69)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-69{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 69)}.ag-ltr .ag-row-group-indent-69{padding-left:calc(69 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-69{padding-right:calc(69 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-69 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-69 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-70{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 70)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-70{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 70)}.ag-ltr .ag-row-group-indent-70{padding-left:calc(70 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-70{padding-right:calc(70 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-70 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-70 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-71{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 71)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-71{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 71)}.ag-ltr .ag-row-group-indent-71{padding-left:calc(71 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-71{padding-right:calc(71 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-71 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-71 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-72{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 72)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-72{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 72)}.ag-ltr .ag-row-group-indent-72{padding-left:calc(72 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-72{padding-right:calc(72 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-72 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-72 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-73{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 73)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-73{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 73)}.ag-ltr .ag-row-group-indent-73{padding-left:calc(73 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-73{padding-right:calc(73 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-73 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-73 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-74{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 74)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-74{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 74)}.ag-ltr .ag-row-group-indent-74{padding-left:calc(74 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-74{padding-right:calc(74 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-74 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-74 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-75{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 75)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-75{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 75)}.ag-ltr .ag-row-group-indent-75{padding-left:calc(75 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-75{padding-right:calc(75 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-75 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-75 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-76{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 76)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-76{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 76)}.ag-ltr .ag-row-group-indent-76{padding-left:calc(76 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-76{padding-right:calc(76 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-76 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-76 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-77{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 77)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-77{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 77)}.ag-ltr .ag-row-group-indent-77{padding-left:calc(77 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-77{padding-right:calc(77 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-77 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-77 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-78{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 78)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-78{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 78)}.ag-ltr .ag-row-group-indent-78{padding-left:calc(78 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-78{padding-right:calc(78 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-78 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-78 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-79{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 79)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-79{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 79)}.ag-ltr .ag-row-group-indent-79{padding-left:calc(79 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-79{padding-right:calc(79 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-79 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-79 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-80{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 80)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-80{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 80)}.ag-ltr .ag-row-group-indent-80{padding-left:calc(80 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-80{padding-right:calc(80 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-80 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-80 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-81{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 81)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-81{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 81)}.ag-ltr .ag-row-group-indent-81{padding-left:calc(81 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-81{padding-right:calc(81 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-81 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-81 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-82{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 82)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-82{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 82)}.ag-ltr .ag-row-group-indent-82{padding-left:calc(82 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-82{padding-right:calc(82 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-82 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-82 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-83{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 83)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-83{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 83)}.ag-ltr .ag-row-group-indent-83{padding-left:calc(83 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-83{padding-right:calc(83 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-83 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-83 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-84{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 84)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-84{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 84)}.ag-ltr .ag-row-group-indent-84{padding-left:calc(84 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-84{padding-right:calc(84 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-84 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-84 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-85{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 85)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-85{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 85)}.ag-ltr .ag-row-group-indent-85{padding-left:calc(85 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-85{padding-right:calc(85 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-85 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-85 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-86{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 86)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-86{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 86)}.ag-ltr .ag-row-group-indent-86{padding-left:calc(86 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-86{padding-right:calc(86 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-86 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-86 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-87{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 87)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-87{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 87)}.ag-ltr .ag-row-group-indent-87{padding-left:calc(87 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-87{padding-right:calc(87 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-87 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-87 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-88{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 88)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-88{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 88)}.ag-ltr .ag-row-group-indent-88{padding-left:calc(88 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-88{padding-right:calc(88 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-88 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-88 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-89{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 89)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-89{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 89)}.ag-ltr .ag-row-group-indent-89{padding-left:calc(89 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-89{padding-right:calc(89 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-89 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-89 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-90{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 90)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-90{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 90)}.ag-ltr .ag-row-group-indent-90{padding-left:calc(90 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-90{padding-right:calc(90 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-90 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-90 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-91{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 91)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-91{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 91)}.ag-ltr .ag-row-group-indent-91{padding-left:calc(91 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-91{padding-right:calc(91 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-91 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-91 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-92{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 92)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-92{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 92)}.ag-ltr .ag-row-group-indent-92{padding-left:calc(92 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-92{padding-right:calc(92 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-92 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-92 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-93{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 93)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-93{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 93)}.ag-ltr .ag-row-group-indent-93{padding-left:calc(93 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-93{padding-right:calc(93 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-93 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-93 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-94{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 94)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-94{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 94)}.ag-ltr .ag-row-group-indent-94{padding-left:calc(94 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-94{padding-right:calc(94 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-94 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-94 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-95{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 95)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-95{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 95)}.ag-ltr .ag-row-group-indent-95{padding-left:calc(95 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-95{padding-right:calc(95 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-95 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-95 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-96{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 96)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-96{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 96)}.ag-ltr .ag-row-group-indent-96{padding-left:calc(96 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-96{padding-right:calc(96 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-96 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-96 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-97{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 97)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-97{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 97)}.ag-ltr .ag-row-group-indent-97{padding-left:calc(97 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-97{padding-right:calc(97 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-97 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-97 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-98{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 98)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-98{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 98)}.ag-ltr .ag-row-group-indent-98{padding-left:calc(98 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-98{padding-right:calc(98 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-98 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-98 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row>.ag-cell-wrapper.ag-row-group-indent-99{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 99)}.ag-rtl .ag-row>.ag-cell-wrapper.ag-row-group-indent-99{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * 99)}.ag-ltr .ag-row-group-indent-99{padding-left:calc(99 * var(--ag-row-group-indent-size))}.ag-rtl .ag-row-group-indent-99{padding-right:calc(99 * var(--ag-row-group-indent-size))}.ag-ltr .ag-row-level-99 .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-level-99 .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}.ag-ltr .ag-row-group-leaf-indent{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-group-leaf-indent{margin-right:var(--ag-row-group-indent-size)}.ag-value-change-delta{padding-right:2px}.ag-value-change-delta-up{color:var(--ag-value-change-delta-up-color)}.ag-value-change-delta-down{color:var(--ag-value-change-delta-down-color)}.ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.ag-value-change-value-highlight{background-color:var(--ag-value-change-value-highlight-background-color);transition:background-color .1s}.ag-cell-data-changed{background-color:var(--ag-value-change-value-highlight-background-color)!important}.ag-cell-data-changed-animation{background-color:transparent}.ag-cell-highlight{background-color:var(--ag-range-selection-highlight-color)!important}.ag-row{height:var(--ag-row-height);background-color:var(--ag-background-color);color:var(--ag-data-color);border-bottom:var(--ag-row-border-style) var(--ag-row-border-color) var(--ag-row-border-width)}.ag-sticky-bottom .ag-row{border-bottom:none;border-top:var(--ag-row-border-style) var(--ag-row-border-color) var(--ag-row-border-width)}.ag-row-highlight-above:after,.ag-row-highlight-below:after{content:"";position:absolute;width:calc(100% - 1px);height:1px;background-color:var(--ag-range-selection-border-color);left:1px}.ag-row-highlight-above:after{top:-1px}.ag-row-highlight-above.ag-row-first:after{top:0}.ag-row-highlight-below:after{bottom:0}.ag-row-odd{background-color:var(--ag-odd-row-background-color)}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:var(--ag-borders-critical) var(--ag-border-color)}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:var(--ag-borders-critical) var(--ag-border-color)}.ag-row-selected:before{content:"";background-color:var(--ag-selected-row-background-color);display:block;position:absolute;top:0;left:0;right:0;bottom:0}.ag-row-hover:not(.ag-full-width-row):before,.ag-row-hover.ag-full-width-row.ag-row-group:before{content:"";background-color:var(--ag-row-hover-color);display:block;position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none}.ag-row-hover.ag-full-width-row.ag-row-group>*{position:relative}.ag-row-hover.ag-row-selected:before{background-color:var(--ag-row-hover-color);background-image:linear-gradient(var(--ag-selected-row-background-color),var(--ag-selected-row-background-color))}.ag-column-hover{background-color:var(--ag-column-hover-color)}.ag-ltr .ag-right-aligned-cell{text-align:right}.ag-rtl .ag-right-aligned-cell{text-align:left}.ag-ltr .ag-right-aligned-cell .ag-cell-value,.ag-ltr .ag-right-aligned-cell .ag-group-value{margin-left:auto}.ag-rtl .ag-right-aligned-cell .ag-cell-value,.ag-rtl .ag-right-aligned-cell .ag-group-value{margin-right:auto}.ag-cell,.ag-full-width-row .ag-cell-wrapper.ag-row-group{--ag-internal-calculated-line-height: var(--ag-line-height, calc(var(--ag-row-height) - var(--ag-row-border-width)));--ag-internal-padded-row-height: calc(var(--ag-row-height) - var(--ag-row-border-width));border:1px solid transparent;line-height:min(var(--ag-internal-calculated-line-height),var(--ag-internal-padded-row-height));padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px);-webkit-font-smoothing:subpixel-antialiased}.ag-row>.ag-cell-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}.ag-row-dragging{cursor:move;opacity:.5}.ag-cell-inline-editing{border:1px solid var(--ag-border-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:0;background-color:var(--ag-control-panel-background-color)}.ag-popup-editor .ag-large-text,.ag-autocomplete-list-popup{border:var(--ag-borders) var(--ag-border-color);background:var(--ag-background-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:var(--ag-grid-size);background-color:var(--ag-control-panel-background-color);padding:0}.ag-large-text-input{height:auto;padding:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-large-text-input textarea{resize:none}.ag-details-row{padding:calc(var(--ag-grid-size) * 5);background-color:var(--ag-background-color)}.ag-layout-auto-height .ag-center-cols-viewport,.ag-layout-auto-height .ag-center-cols-container,.ag-layout-print .ag-center-cols-viewport,.ag-layout-print .ag-center-cols-container{min-height:50px}.ag-overlay-loading-wrapper{background-color:var(--ag-modal-overlay-background-color)}.ag-overlay-loading-center{border:var(--ag-borders) var(--ag-border-color);background:var(--ag-background-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:var(--ag-grid-size)}.ag-overlay-no-rows-wrapper.ag-layout-auto-height{padding-top:30px}.ag-skeleton-container{width:100%;height:100%;align-content:center}.ag-skeleton-effect{background-color:var(--ag-row-loading-skeleton-effect-color);width:100%;height:1em;border-radius:.25rem;animation:ag-skeleton-loading 1.5s ease-in-out .5s infinite}@keyframes ag-skeleton-loading{0%{opacity:1}50%{opacity:.4}to{opacity:1}}.ag-loading{display:flex;height:100%;align-items:center}.ag-ltr .ag-loading{padding-left:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-loading{padding-right:var(--ag-cell-horizontal-padding)}.ag-ltr .ag-loading-icon{padding-right:var(--ag-cell-widget-spacing)}.ag-rtl .ag-loading-icon{padding-left:var(--ag-cell-widget-spacing)}.ag-icon-loading{animation-name:spin;animation-duration:1s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.ag-floating-top{border-bottom:var(--ag-borders-critical) var(--ag-border-color)}.ag-floating-bottom{border-top:var(--ag-borders-critical) var(--ag-border-color)}.ag-ltr .ag-cell{border-right:var(--ag-cell-horizontal-border)}.ag-rtl .ag-cell{border-left:var(--ag-cell-horizontal-border)}.ag-ltr .ag-cell{border-right-width:1px}.ag-rtl .ag-cell{border-left-width:1px}.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell){border-left:var(--ag-borders-critical) var(--ag-border-color)}.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell){border-right:var(--ag-borders-critical) var(--ag-border-color)}.ag-cell-range-selected:not(.ag-cell-focus),.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing){background-color:var(--ag-range-selection-background-color)}.ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart{background-color:var(--ag-range-selection-chart-background-color)!important}.ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category{background-color:var(--ag-range-selection-chart-category-background-color)!important}.ag-cell-range-selected-1:not(.ag-cell-focus),.ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing){background-color:var(--ag-range-selection-background-color)}.ag-cell-range-selected-2:not(.ag-cell-focus),.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2{background-color:var(--ag-range-selection-background-color-2)}.ag-cell-range-selected-3:not(.ag-cell-focus),.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3{background-color:var(--ag-range-selection-background-color-3)}.ag-cell-range-selected-4:not(.ag-cell-focus),.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4{background-color:var(--ag-range-selection-background-color-4)}.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top{border-top-color:var(--ag-range-selection-border-color);border-top-style:var(--ag-range-selection-border-style)}.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right{border-right-color:var(--ag-range-selection-border-color);border-right-style:var(--ag-range-selection-border-style)}.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom{border-bottom-color:var(--ag-range-selection-border-color);border-bottom-style:var(--ag-range-selection-border-style)}.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left{border-left-color:var(--ag-range-selection-border-color);border-left-style:var(--ag-range-selection-border-style)}.ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-ltr .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,.ag-ltr .ag-cell-range-single-cell,.ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,.ag-rtl .ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-rtl .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,.ag-rtl .ag-cell-range-single-cell,.ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle{border:1px solid;border-color:var(--ag-range-selection-border-color);border-style:var(--ag-range-selection-border-style);outline:initial}.ag-cell.ag-selection-fill-top,.ag-cell.ag-selection-fill-top.ag-cell-range-selected{border-top:1px dashed;border-top-color:var(--ag-range-selection-border-color)}.ag-ltr .ag-cell.ag-selection-fill-right,.ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-right:1px dashed var(--ag-range-selection-border-color)!important}.ag-rtl .ag-cell.ag-selection-fill-right,.ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-left:1px dashed var(--ag-range-selection-border-color)!important}.ag-cell.ag-selection-fill-bottom,.ag-cell.ag-selection-fill-bottom.ag-cell-range-selected{border-bottom:1px dashed;border-bottom-color:var(--ag-range-selection-border-color)}.ag-ltr .ag-cell.ag-selection-fill-left,.ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-left:1px dashed var(--ag-range-selection-border-color)!important}.ag-rtl .ag-cell.ag-selection-fill-left,.ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-right:1px dashed var(--ag-range-selection-border-color)!important}.ag-fill-handle,.ag-range-handle{position:absolute;width:6px;height:6px;bottom:-1px;background-color:var(--ag-range-selection-border-color)}.ag-ltr .ag-fill-handle,.ag-ltr .ag-range-handle{right:-1px}.ag-rtl .ag-fill-handle,.ag-rtl .ag-range-handle{left:-1px}.ag-fill-handle{cursor:cell}.ag-range-handle{cursor:nwse-resize}.ag-cell-inline-editing{border-color:var(--ag-input-focus-border-color)!important}.ag-menu{border:var(--ag-borders) var(--ag-border-color);background:var(--ag-background-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:var(--ag-grid-size);background-color:var(--ag-menu-background-color);border-color:var(--ag-menu-border-color);padding:0}.ag-menu-list{cursor:default;padding:var(--ag-grid-size) 0}.ag-menu-separator{height:calc(var(--ag-grid-size) * 2 + 1px)}.ag-menu-separator-part:after{content:"";display:block;border-top:var(--ag-borders-critical) var(--ag-border-color)}.ag-menu-option-active,.ag-compact-menu-option-active{background-color:var(--ag-row-hover-color)}.ag-menu-option-part,.ag-compact-menu-option-part{line-height:var(--ag-icon-size);padding:calc(var(--ag-grid-size) + 2px) 0}.ag-menu-option-disabled,.ag-compact-menu-option-disabled{opacity:.5}.ag-menu-option-icon,.ag-compact-menu-option-icon{width:var(--ag-icon-size)}.ag-ltr .ag-menu-option-icon,.ag-ltr .ag-compact-menu-option-icon{padding-left:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-menu-option-icon,.ag-rtl .ag-compact-menu-option-icon{padding-right:calc(var(--ag-grid-size) * 2)}.ag-menu-option-text,.ag-compact-menu-option-text{padding-left:calc(var(--ag-grid-size) * 2);padding-right:calc(var(--ag-grid-size) * 2)}.ag-ltr .ag-menu-option-shortcut,.ag-ltr .ag-compact-menu-option-shortcut{padding-right:var(--ag-grid-size)}.ag-rtl .ag-menu-option-shortcut,.ag-rtl .ag-compact-menu-option-shortcut{padding-left:var(--ag-grid-size)}.ag-ltr .ag-menu-option-popup-pointer,.ag-ltr .ag-compact-menu-option-popup-pointer{padding-right:var(--ag-grid-size)}.ag-rtl .ag-menu-option-popup-pointer,.ag-rtl .ag-compact-menu-option-popup-pointer{padding-left:var(--ag-grid-size)}.ag-tabs{min-width:var(--ag-tab-min-width)}.ag-tabs-header,.ag-tabs-header-wrapper{display:flex}.ag-tabs-header-wrapper .ag-tabs-header{flex:1}.ag-tabs-close-button-wrapper{border:0;border-right:var(--ag-borders) var(--ag-border-color);padding:var(--ag-grid-size)}.ag-tabs-close-button{border:0;background-color:unset;cursor:pointer;padding:0}.ag-tab{border-bottom:var(--ag-selected-tab-underline-width) solid transparent;transition:border-bottom var(--ag-selected-tab-underline-transition-speed);display:flex;flex:none;align-items:center;justify-content:center;cursor:pointer}.ag-tab:focus-visible{outline:none}.ag-tab:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-tab-selected{border-bottom-color:var(--ag-selected-tab-underline-color)}.ag-menu-header{color:var(--ag-secondary-foreground-color)}.ag-filter-separator{border-top:var(--ag-borders-critical) var(--ag-border-color)}.ag-filter-select .ag-picker-field-wrapper{width:0}.ag-filter-condition-operator{height:17px}.ag-ltr .ag-filter-condition-operator-or{margin-left:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-filter-condition-operator-or{margin-right:calc(var(--ag-grid-size) * 2)}.ag-set-filter-select-all{padding-top:var(--ag-widget-container-vertical-padding)}.ag-set-filter-list,.ag-filter-no-matches{height:calc(var(--ag-list-item-height) * 6)}.ag-set-filter-tree-list{height:calc(var(--ag-list-item-height) * 10)}.ag-set-filter-filter{margin-top:var(--ag-widget-container-vertical-padding);margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding)}.ag-filter-to{margin-top:var(--ag-widget-vertical-spacing)}.ag-mini-filter{margin:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}.ag-set-filter-item{padding:0px var(--ag-widget-container-horizontal-padding)}.ag-ltr .ag-set-filter-indent-1{padding-left:calc(var(--ag-widget-container-horizontal-padding) + 1 * var(--ag-set-filter-indent-size))}.ag-rtl .ag-set-filter-indent-1{padding-right:calc(var(--ag-widget-container-horizontal-padding) + 1 * var(--ag-set-filter-indent-size))}.ag-ltr .ag-set-filter-indent-2{padding-left:calc(var(--ag-widget-container-horizontal-padding) + 2 * var(--ag-set-filter-indent-size))}.ag-rtl .ag-set-filter-indent-2{padding-right:calc(var(--ag-widget-container-horizontal-padding) + 2 * var(--ag-set-filter-indent-size))}.ag-ltr .ag-set-filter-indent-3{padding-left:calc(var(--ag-widget-container-horizontal-padding) + 3 * var(--ag-set-filter-indent-size))}.ag-rtl .ag-set-filter-indent-3{padding-right:calc(var(--ag-widget-container-horizontal-padding) + 3 * var(--ag-set-filter-indent-size))}.ag-ltr .ag-set-filter-indent-4{padding-left:calc(var(--ag-widget-container-horizontal-padding) + 4 * var(--ag-set-filter-indent-size))}.ag-rtl .ag-set-filter-indent-4{padding-right:calc(var(--ag-widget-container-horizontal-padding) + 4 * var(--ag-set-filter-indent-size))}.ag-ltr .ag-set-filter-indent-5{padding-left:calc(var(--ag-widget-container-horizontal-padding) + 5 * var(--ag-set-filter-indent-size))}.ag-rtl .ag-set-filter-indent-5{padding-right:calc(var(--ag-widget-container-horizontal-padding) + 5 * var(--ag-set-filter-indent-size))}.ag-ltr .ag-set-filter-indent-6{padding-left:calc(var(--ag-widget-container-horizontal-padding) + 6 * var(--ag-set-filter-indent-size))}.ag-rtl .ag-set-filter-indent-6{padding-right:calc(var(--ag-widget-container-horizontal-padding) + 6 * var(--ag-set-filter-indent-size))}.ag-ltr .ag-set-filter-indent-7{padding-left:calc(var(--ag-widget-container-horizontal-padding) + 7 * var(--ag-set-filter-indent-size))}.ag-rtl .ag-set-filter-indent-7{padding-right:calc(var(--ag-widget-container-horizontal-padding) + 7 * var(--ag-set-filter-indent-size))}.ag-ltr .ag-set-filter-indent-8{padding-left:calc(var(--ag-widget-container-horizontal-padding) + 8 * var(--ag-set-filter-indent-size))}.ag-rtl .ag-set-filter-indent-8{padding-right:calc(var(--ag-widget-container-horizontal-padding) + 8 * var(--ag-set-filter-indent-size))}.ag-ltr .ag-set-filter-indent-9{padding-left:calc(var(--ag-widget-container-horizontal-padding) + 9 * var(--ag-set-filter-indent-size))}.ag-rtl .ag-set-filter-indent-9{padding-right:calc(var(--ag-widget-container-horizontal-padding) + 9 * var(--ag-set-filter-indent-size))}.ag-ltr .ag-set-filter-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}.ag-rtl .ag-set-filter-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}.ag-ltr .ag-set-filter-group-icons{margin-right:var(--ag-widget-container-horizontal-padding)}.ag-rtl .ag-set-filter-group-icons{margin-left:var(--ag-widget-container-horizontal-padding)}.ag-filter-menu .ag-set-filter-list{min-width:200px}.ag-filter-virtual-list-item:focus-visible{outline:none}.ag-filter-virtual-list-item:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:1px;left:1px;display:block;width:calc(100% - 2px);height:calc(100% - 2px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-filter-apply-panel{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-filter-apply-panel-button{line-height:1.5}.ag-ltr .ag-filter-apply-panel-button{margin-left:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-filter-apply-panel-button{margin-right:calc(var(--ag-grid-size) * 2)}.ag-simple-filter-body-wrapper{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));overflow-y:auto;min-height:calc(var(--ag-list-item-height) + var(--ag-widget-container-vertical-padding) + var(--ag-widget-vertical-spacing))}.ag-simple-filter-body-wrapper>*{margin-bottom:var(--ag-widget-vertical-spacing)}.ag-simple-filter-body-wrapper .ag-resizer-wrapper{margin:0}.ag-menu:not(.ag-tabs) .ag-filter .ag-simple-filter-body-wrapper,.ag-menu:not(.ag-tabs) .ag-filter>*:not(.ag-filter-wrapper){min-width:calc(var(--ag-menu-min-width) - 2px)}.ag-filter-no-matches{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}.ag-multi-filter-menu-item{margin:var(--ag-grid-size) 0}.ag-multi-filter-group-title-bar{padding:calc(var(--ag-grid-size) * 2) var(--ag-grid-size);background-color:transparent}.ag-group-filter-field-select-wrapper{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing))}.ag-group-filter-field-select-wrapper>*{margin-bottom:var(--ag-widget-vertical-spacing)}.ag-multi-filter-group-title-bar:focus-visible{outline:none}.ag-multi-filter-group-title-bar:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-side-bar{position:relative}.ag-tool-panel-wrapper{width:var(--ag-side-bar-panel-width);background-color:var(--ag-control-panel-background-color)}.ag-side-buttons{padding-top:calc(var(--ag-grid-size) * 4);width:calc(var(--ag-icon-size) + 4px);position:relative;overflow:hidden}button.ag-side-button-button{color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;background:transparent;padding:calc(var(--ag-grid-size) * 2) 0 calc(var(--ag-grid-size) * 2) 0;width:100%;margin:0;min-height:calc(var(--ag-grid-size) * 18);background-position-y:center;background-position-x:center;background-repeat:no-repeat;border:none;border-top:var(--ag-borders-side-button) var(--ag-border-color);border-bottom:var(--ag-borders-side-button) var(--ag-border-color)}button.ag-side-button-button:focus{box-shadow:none}.ag-side-button-button:focus-visible{outline:none}.ag-side-button-button:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-selected button.ag-side-button-button{background-color:var(--ag-side-button-selected-background-color)}.ag-side-button-icon-wrapper{margin-bottom:3px}.ag-ltr .ag-side-bar-left,.ag-rtl .ag-side-bar-right{border-right:var(--ag-borders) var(--ag-border-color)}.ag-ltr .ag-side-bar-left .ag-tool-panel-wrapper,.ag-rtl .ag-side-bar-right .ag-tool-panel-wrapper{border-left:var(--ag-borders) var(--ag-border-color)}.ag-ltr .ag-side-bar-left .ag-side-button-button,.ag-rtl .ag-side-bar-right .ag-side-button-button{border-right:var(--ag-selected-tab-underline-width) solid transparent;transition:border-right var(--ag-selected-tab-underline-transition-speed)}.ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,.ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button{border-right-color:var(--ag-selected-tab-underline-color)}.ag-rtl .ag-side-bar-left,.ag-ltr .ag-side-bar-right{border-left:var(--ag-borders) var(--ag-border-color)}.ag-rtl .ag-side-bar-left .ag-tool-panel-wrapper,.ag-ltr .ag-side-bar-right .ag-tool-panel-wrapper{border-right:var(--ag-borders) var(--ag-border-color)}.ag-rtl .ag-side-bar-left .ag-side-button-button,.ag-ltr .ag-side-bar-right .ag-side-button-button{border-left:var(--ag-selected-tab-underline-width) solid transparent;transition:border-left var(--ag-selected-tab-underline-transition-speed)}.ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,.ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button{border-left-color:var(--ag-selected-tab-underline-color)}.ag-filter-toolpanel-header{height:calc(var(--ag-grid-size) * 6)}.ag-filter-toolpanel-header,.ag-filter-toolpanel-search{padding:0 var(--ag-grid-size)}.ag-filter-toolpanel-header:focus-visible{outline:none}.ag-filter-toolpanel-header:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-filter-toolpanel-group:not(.ag-has-filter)>.ag-group-title-bar .ag-filter-toolpanel-group-instance-header-icon{display:none}.ag-filter-toolpanel-group-level-0-header{height:calc(var(--ag-grid-size) * 8)}.ag-filter-toolpanel-group-item{margin-top:calc(var(--ag-grid-size) * .5);margin-bottom:calc(var(--ag-grid-size) * .5)}.ag-filter-toolpanel-search{height:var(--ag-header-height)}.ag-filter-toolpanel-search-input{flex-grow:1;height:calc(var(--ag-grid-size) * 4)}.ag-ltr .ag-filter-toolpanel-search-input{margin-right:var(--ag-grid-size)}.ag-rtl .ag-filter-toolpanel-search-input{margin-left:var(--ag-grid-size)}.ag-filter-toolpanel-group-level-0{border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-ltr .ag-filter-toolpanel-expand,.ag-ltr .ag-filter-toolpanel-group-title-bar-icon{margin-right:var(--ag-grid-size)}.ag-rtl .ag-filter-toolpanel-expand,.ag-rtl .ag-filter-toolpanel-group-title-bar-icon{margin-left:var(--ag-grid-size)}.ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-1-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.ag-ltr .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header{padding-left:calc(var(--ag-filter-tool-panel-group-indent) * 1 + var(--ag-grid-size))}.ag-rtl .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header{padding-right:calc(var(--ag-filter-tool-panel-group-indent) * 1 + var(--ag-grid-size))}.ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-2-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.ag-ltr .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header{padding-left:calc(var(--ag-filter-tool-panel-group-indent) * 2 + var(--ag-grid-size))}.ag-rtl .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header{padding-right:calc(var(--ag-filter-tool-panel-group-indent) * 2 + var(--ag-grid-size))}.ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-3-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.ag-ltr .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header{padding-left:calc(var(--ag-filter-tool-panel-group-indent) * 3 + var(--ag-grid-size))}.ag-rtl .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header{padding-right:calc(var(--ag-filter-tool-panel-group-indent) * 3 + var(--ag-grid-size))}.ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-4-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.ag-ltr .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header{padding-left:calc(var(--ag-filter-tool-panel-group-indent) * 4 + var(--ag-grid-size))}.ag-rtl .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header{padding-right:calc(var(--ag-filter-tool-panel-group-indent) * 4 + var(--ag-grid-size))}.ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-5-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.ag-ltr .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header{padding-left:calc(var(--ag-filter-tool-panel-group-indent) * 5 + var(--ag-grid-size))}.ag-rtl .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header{padding-right:calc(var(--ag-filter-tool-panel-group-indent) * 5 + var(--ag-grid-size))}.ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-6-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.ag-ltr .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header{padding-left:calc(var(--ag-filter-tool-panel-group-indent) * 6 + var(--ag-grid-size))}.ag-rtl .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header{padding-right:calc(var(--ag-filter-tool-panel-group-indent) * 6 + var(--ag-grid-size))}.ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-7-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.ag-ltr .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header{padding-left:calc(var(--ag-filter-tool-panel-group-indent) * 7 + var(--ag-grid-size))}.ag-rtl .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header{padding-right:calc(var(--ag-filter-tool-panel-group-indent) * 7 + var(--ag-grid-size))}.ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-8-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.ag-ltr .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header{padding-left:calc(var(--ag-filter-tool-panel-group-indent) * 8 + var(--ag-grid-size))}.ag-rtl .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header{padding-right:calc(var(--ag-filter-tool-panel-group-indent) * 8 + var(--ag-grid-size))}.ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-9-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.ag-ltr .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header{padding-left:calc(var(--ag-filter-tool-panel-group-indent) * 9 + var(--ag-grid-size))}.ag-rtl .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header{padding-right:calc(var(--ag-filter-tool-panel-group-indent) * 9 + var(--ag-grid-size))}.ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-10-header.ag-filter-toolpanel-group-title-bar{background-color:transparent}.ag-ltr .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header{padding-left:calc(var(--ag-filter-tool-panel-group-indent) * 10 + var(--ag-grid-size))}.ag-rtl .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header{padding-right:calc(var(--ag-filter-tool-panel-group-indent) * 10 + var(--ag-grid-size))}.ag-filter-toolpanel-instance-header.ag-filter-toolpanel-group-level-1-header{padding-left:var(--ag-grid-size)}.ag-filter-toolpanel-instance-filter{border-bottom:var(--ag-borders) var(--ag-border-color);border-top:var(--ag-borders) var(--ag-border-color);margin-top:var(--ag-grid-size)}.ag-ltr .ag-filter-toolpanel-group-instance-header-icon,.ag-ltr .ag-filter-toolpanel-instance-header-icon{margin-left:var(--ag-grid-size)}.ag-rtl .ag-filter-toolpanel-group-instance-header-icon,.ag-rtl .ag-filter-toolpanel-instance-header-icon{margin-right:var(--ag-grid-size)}.ag-set-filter-group-icons{color:var(--ag-secondary-foreground-color)}.ag-pivot-mode-panel{min-height:var(--ag-header-height);height:var(--ag-header-height);display:flex}.ag-pivot-mode-select{display:flex;align-items:center}.ag-ltr .ag-pivot-mode-select{margin-left:var(--ag-widget-container-horizontal-padding)}.ag-rtl .ag-pivot-mode-select{margin-right:var(--ag-widget-container-horizontal-padding)}.ag-column-select-header:focus-visible{outline:none}.ag-column-select-header:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-column-select-header{height:var(--ag-header-height);align-items:center;padding:0 var(--ag-widget-container-horizontal-padding);border-bottom:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-column-panel-column-select{border-bottom:var(--ag-borders-secondary) var(--ag-secondary-border-color);border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-column-group-icons,.ag-column-select-header-icon{color:var(--ag-secondary-foreground-color)}.ag-column-select-list .ag-list-item-hovered:after{content:"";position:absolute;left:0;right:0;height:1px;background-color:var(--ag-range-selection-border-color)}.ag-column-select-list .ag-item-highlight-top:after{top:0}.ag-column-select-list .ag-item-highlight-bottom:after{bottom:0}.ag-header,.ag-advanced-filter-header{background-color:var(--ag-header-background-color);border-bottom:var(--ag-borders-critical) var(--ag-border-color)}.ag-header-row{color:var(--ag-header-foreground-color);height:var(--ag-header-height)}.ag-pinned-right-header{border-left:var(--ag-borders-critical) var(--ag-border-color)}.ag-pinned-left-header{border-right:var(--ag-borders-critical) var(--ag-border-color)}.ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon,.ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-menu-icon{margin-left:var(--ag-grid-size)}.ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon,.ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-menu-icon{margin-right:var(--ag-grid-size)}.ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon,.ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-menu-icon{margin-right:var(--ag-grid-size)}.ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon,.ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-menu-icon{margin-left:var(--ag-grid-size)}.ag-header-cell,.ag-header-group-cell{padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding)}.ag-header-cell.ag-header-cell-moving,.ag-header-group-cell.ag-header-cell-moving{background-color:var(--ag-header-cell-moving-background-color)}.ag-ltr .ag-header-group-cell-label.ag-sticky-label{left:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-header-group-cell-label.ag-sticky-label{right:var(--ag-cell-horizontal-padding)}.ag-header-cell:focus-visible{outline:none}.ag-header-cell:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-header-group-cell:focus-visible{outline:none}.ag-header-group-cell:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-advanced-filter-header-cell:focus-visible{outline:none}.ag-advanced-filter-header-cell:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-header-icon{color:var(--ag-secondary-foreground-color)}.ag-header-expand-icon{cursor:pointer}.ag-ltr .ag-header-expand-icon{margin-left:4px}.ag-rtl .ag-header-expand-icon{margin-right:4px}.ag-header-row:not(:first-child) .ag-header-cell:not(.ag-header-span-height.ag-header-span-total),.ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group{border-top:var(--ag-borders-critical) var(--ag-border-color)}.ag-header-group-cell:not(.ag-column-resizing)+.ag-header-group-cell:not(.ag-column-hover):not(.ag-header-cell-moving):hover,.ag-header-group-cell:not(.ag-column-resizing)+.ag-header-group-cell:not(.ag-column-hover).ag-column-resizing,.ag-header-cell:not(.ag-column-resizing)+.ag-header-cell:not(.ag-column-hover):not(.ag-header-cell-moving):hover,.ag-header-cell:not(.ag-column-resizing)+.ag-header-cell:not(.ag-column-hover).ag-column-resizing,.ag-header-group-cell:first-of-type:not(.ag-header-cell-moving):hover,.ag-header-group-cell:first-of-type.ag-column-resizing,.ag-header-cell:not(.ag-column-hover):first-of-type:not(.ag-header-cell-moving):hover,.ag-header-cell:not(.ag-column-hover):first-of-type.ag-column-resizing{background-color:var(--ag-header-cell-hover-background-color)}.ag-header-cell:before,.ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group):before{content:"";position:absolute;z-index:1;display:var(--ag-header-column-separator-display);width:var(--ag-header-column-separator-width);height:var(--ag-header-column-separator-height);top:calc(50% - var(--ag-header-column-separator-height) * .5);background-color:var(--ag-header-column-separator-color)}.ag-ltr .ag-header-cell:before,.ag-ltr .ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group):before{right:0}.ag-rtl .ag-header-cell:before,.ag-rtl .ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group):before{left:0}.ag-header-cell-resize{display:flex;align-items:center}.ag-header-cell-resize:after{content:"";position:absolute;z-index:1;display:var(--ag-header-column-resize-handle-display);width:var(--ag-header-column-resize-handle-width);height:var(--ag-header-column-resize-handle-height);top:calc(50% - var(--ag-header-column-resize-handle-height) * .5);background-color:var(--ag-header-column-resize-handle-color)}.ag-header-cell.ag-header-span-height .ag-header-cell-resize:after{height:calc(100% - var(--ag-grid-size) * 4);top:calc(var(--ag-grid-size) * 2)}.ag-ltr .ag-header-viewport .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-rtl .ag-header-viewport .ag-header-cell-resize:after{right:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-left-header .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-right-header .ag-header-cell-resize:after{left:50%}.ag-ltr .ag-header-select-all{margin-right:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-header-select-all{margin-left:var(--ag-cell-horizontal-padding)}.ag-ltr .ag-floating-filter-button{margin-left:var(--ag-cell-widget-spacing)}.ag-rtl .ag-floating-filter-button{margin-right:var(--ag-cell-widget-spacing)}.ag-floating-filter-button-button{color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:none;height:var(--ag-icon-size);padding:0;width:var(--ag-icon-size)}.ag-filter-loading{background-color:var(--ag-control-panel-background-color);height:100%;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;width:100%;z-index:1}.ag-paging-panel{border-top:1px solid;border-top-color:var(--ag-border-color);color:var(--ag-secondary-foreground-color);height:var(--ag-header-height)}.ag-paging-panel>*{margin:0 var(--ag-cell-horizontal-padding)}.ag-paging-panel>.ag-paging-page-size .ag-wrapper{min-width:calc(var(--ag-grid-size) * 10)}.ag-paging-button{cursor:pointer}.ag-paging-button.ag-disabled{cursor:default;color:var(--ag-disabled-foreground-color)}.ag-paging-button:focus-visible{outline:none}.ag-paging-button:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:0;left:0;display:block;width:calc(100% + -0px);height:calc(100% + -0px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-paging-button,.ag-paging-description{margin:0 var(--ag-grid-size)}.ag-status-bar{border-top:var(--ag-borders) var(--ag-border-color);color:var(--ag-disabled-foreground-color);padding-right:calc(var(--ag-grid-size) * 4);padding-left:calc(var(--ag-grid-size) * 4);line-height:1.5}.ag-status-name-value-value{color:var(--ag-foreground-color)}.ag-status-bar-center{text-align:center}.ag-status-name-value{margin-left:var(--ag-grid-size);margin-right:var(--ag-grid-size);padding-top:calc(var(--ag-grid-size) * 2);padding-bottom:calc(var(--ag-grid-size) * 2)}.ag-column-drop-cell{background:var(--ag-chip-background-color);border-radius:calc(var(--ag-grid-size) * 4);height:calc(var(--ag-grid-size) * 4);padding:0 calc(var(--ag-grid-size) * .5);border:1px solid var(--ag-chip-border-color)}.ag-column-drop-cell:focus-visible{outline:none}.ag-column-drop-cell:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:2px;left:2px;display:block;width:calc(100% - 4px);height:calc(100% - 4px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-column-drop-cell-text{margin:0 var(--ag-grid-size)}.ag-column-drop-cell-button{min-width:calc(var(--ag-grid-size) * 4);margin:0 calc(var(--ag-grid-size) * .5);color:var(--ag-secondary-foreground-color)}.ag-column-drop-cell-drag-handle{margin-left:calc(var(--ag-grid-size) * 2)}.ag-column-drop-cell-ghost{opacity:.5}.ag-column-drop-horizontal{background-color:var(--ag-header-background-color);color:var(--ag-secondary-foreground-color);height:var(--ag-header-height);border-bottom:var(--ag-borders) var(--ag-border-color)}.ag-ltr .ag-column-drop-horizontal{padding-left:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-column-drop-horizontal{padding-right:var(--ag-cell-horizontal-padding)}.ag-ltr .ag-column-drop-horizontal-half-width:not(:last-child){border-right:var(--ag-borders) var(--ag-border-color)}.ag-rtl .ag-column-drop-horizontal-half-width:not(:last-child){border-left:var(--ag-borders) var(--ag-border-color)}.ag-column-drop-horizontal-cell-separator{margin:0 var(--ag-grid-size);color:var(--ag-secondary-foreground-color)}.ag-column-drop-horizontal-empty-message{color:var(--ag-disabled-foreground-color)}.ag-ltr .ag-column-drop-horizontal-icon{margin-right:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-column-drop-horizontal-icon{margin-left:var(--ag-cell-horizontal-padding)}.ag-column-drop-vertical-list{padding-bottom:var(--ag-grid-size);padding-right:var(--ag-grid-size);padding-left:var(--ag-grid-size)}.ag-column-drop-vertical-cell{margin-top:var(--ag-grid-size)}.ag-column-drop-vertical{min-height:50px;border-bottom:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-column-drop-vertical.ag-last-column-drop{border-bottom:none}.ag-column-drop-vertical-icon{margin-left:var(--ag-grid-size);margin-right:var(--ag-grid-size)}.ag-column-drop-vertical-empty-message{position:absolute;top:0;bottom:0;left:0;right:0;overflow:hidden;color:var(--ag-disabled-foreground-color);margin-top:var(--ag-grid-size)}.ag-select-agg-func-popup{border:var(--ag-borders) var(--ag-border-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:var(--ag-grid-size);background:var(--ag-background-color);height:calc(var(--ag-grid-size) * 5 * 3.5);padding:0}.ag-select-agg-func-virtual-list-item{cursor:default}.ag-ltr .ag-select-agg-func-virtual-list-item{padding-left:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-select-agg-func-virtual-list-item{padding-right:calc(var(--ag-grid-size) * 2)}.ag-select-agg-func-virtual-list-item:hover{background-color:var(--ag-selected-row-background-color)}.ag-select-agg-func-virtual-list-item:focus-visible{outline:none}.ag-select-agg-func-virtual-list-item:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:1px;left:1px;display:block;width:calc(100% - 2px);height:calc(100% - 2px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-sort-indicator-container{display:flex}.ag-ltr .ag-sort-indicator-icon{padding-left:var(--ag-grid-size)}.ag-rtl .ag-sort-indicator-icon{padding-right:var(--ag-grid-size)}.ag-chart{position:relative;display:flex;overflow:hidden;width:100%;height:100%}.ag-chart-components-wrapper{position:relative;display:flex;flex:1 1 auto;overflow:hidden}.ag-chart-title-edit{position:absolute;display:none;top:0;left:0;text-align:center}.ag-chart-title-edit.currently-editing{display:inline-block}.ag-chart-canvas-wrapper{position:relative;flex:1 1 auto;overflow:hidden}.ag-charts-canvas{display:block}.ag-chart-menu{position:absolute;top:16px;display:flex;flex-direction:column}.ag-ltr .ag-chart-menu{right:20px}.ag-rtl .ag-chart-menu{left:20px}.ag-chart-docked-container{position:relative;width:0;min-width:0;transition:min-width .4s}.ag-chart-menu-hidden~.ag-chart-docked-container{max-width:0;overflow:hidden}.ag-chart-tabbed-menu{width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden}.ag-chart-tabbed-menu-header{flex:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.ag-chart-tabbed-menu-body{display:flex;flex:1 1 auto;align-items:stretch;overflow:hidden}.ag-chart-tab{width:100%;overflow:hidden;overflow-y:auto}.ag-chart-settings{overflow-x:hidden}.ag-chart-settings-wrapper{position:relative;flex-direction:column;width:100%;height:100%;display:flex;overflow:hidden}.ag-chart-settings-nav-bar{display:flex;align-items:center;width:100%;height:30px;padding:0 10px;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-chart-settings-card-selector{display:flex;align-items:center;justify-content:space-around;flex:1 1 auto;height:100%;padding:0 10px}.ag-chart-settings-card-item{cursor:pointer;width:10px;height:10px;background-color:#000;position:relative}.ag-chart-settings-card-item.ag-not-selected{opacity:.2}.ag-chart-settings-card-item:before{content:" ";display:block;position:absolute;background-color:transparent;left:50%;top:50%;margin-left:-10px;margin-top:-10px;width:20px;height:20px}.ag-chart-settings-prev,.ag-chart-settings-next{position:relative;flex:none}.ag-chart-settings-prev-button,.ag-chart-settings-next-button{position:absolute;top:0;left:0;width:100%;height:100%;cursor:pointer;opacity:0}.ag-chart-settings-mini-charts-container{position:relative;flex:1 1 auto;overflow-x:hidden;overflow-y:auto}.ag-chart-settings-mini-wrapper{position:absolute;top:0;left:0;display:flex;flex-direction:column;width:100%;min-height:100%;overflow:hidden}.ag-chart-settings-mini-wrapper.ag-animating{transition:left .3s;transition-timing-function:ease-in-out}.ag-chart-mini-thumbnail{cursor:pointer}.ag-chart-mini-thumbnail-canvas{display:block}.ag-chart-data-wrapper,.ag-chart-format-wrapper,.ag-chart-advanced-settings-wrapper{display:flex;flex-direction:column;position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;padding-bottom:16px}.ag-chart-data-wrapper,.ag-chart-advanced-settings-wrapper{height:100%;overflow-y:auto}.ag-chart-advanced-settings{background-color:var(--ag-control-panel-background-color)}.ag-chart-advanced-settings-wrapper,.ag-chart-advanced-settings{width:100%}.ag-chart-advanced-settings-wrapper{padding-bottom:0}.ag-chart-data-section,.ag-chart-format-section,.ag-chart-advanced-settings-section{display:flex;margin:0}.ag-chart-advanced-settings-section{border-bottom:1px solid var(--ag-secondary-border-color);padding-top:var(--ag-grid-size);padding-bottom:var(--ag-grid-size)}.ag-chart-empty-text{display:flex;top:0;width:100%;height:100%;align-items:center;justify-content:center;background-color:var(--ag-background-color)}.ag-chart .ag-chart-menu{display:none}.ag-chart-menu-hidden:hover .ag-chart-menu{display:block}.ag-chart .ag-chart-tool-panel-button-enable .ag-chart-menu,.ag-chart .ag-chart-menu-wrapper .ag-chart-menu{display:flex;flex-direction:row;top:8px;gap:20px;width:auto}.ag-ltr .ag-chart .ag-chart-tool-panel-button-enable .ag-chart-menu,.ag-ltr .ag-chart .ag-chart-menu-wrapper .ag-chart-menu{right:calc(var(--ag-cell-horizontal-padding) + var(--ag-grid-size) - 4px);justify-content:right}.ag-rtl .ag-chart .ag-chart-tool-panel-button-enable .ag-chart-menu,.ag-rtl .ag-chart .ag-chart-menu-wrapper .ag-chart-menu{left:calc(var(--ag-cell-horizontal-padding) + var(--ag-grid-size) - 4px);justify-content:left}.ag-chart-menu-close{display:none}.ag-chart-tool-panel-button-enable .ag-chart-menu-close{position:absolute;top:50%;transition:transform .33s ease-in-out;padding:0;display:block;cursor:pointer;border:none}.ag-ltr .ag-chart-tool-panel-button-enable .ag-chart-menu-close{right:0}.ag-rtl .ag-chart-tool-panel-button-enable .ag-chart-menu-close{left:0}.ag-chart-tool-panel-button-enable .ag-chart-menu-close .ag-icon{padding:14px 5px 14px 2px;width:auto;height:auto}.ag-chart-tool-panel-button-enable .ag-chart-menu-close:before{content:"";position:absolute;top:-40px;bottom:-40px}.ag-ltr .ag-chart-tool-panel-button-enable .ag-chart-menu-close:before{right:0}.ag-rtl .ag-chart-tool-panel-button-enable .ag-chart-menu-close:before{left:0}.ag-ltr .ag-chart-tool-panel-button-enable .ag-chart-menu-close:before{left:-10px}.ag-rtl .ag-chart-tool-panel-button-enable .ag-chart-menu-close:before{right:-10px}.ag-chart-tool-panel-button-enable .ag-icon-menu{display:none}.ag-ltr .ag-chart-tool-panel-button-enable .ag-chart-menu-close{transform:translate(3px,-50%)}.ag-ltr .ag-chart-tool-panel-button-enable .ag-chart-menu-close:hover{transform:translateY(-50%)}.ag-ltr .ag-chart-menu-visible .ag-chart-tool-panel-button-enable .ag-chart-menu-close:hover{transform:translate(5px,-50%)}.ag-rtl .ag-chart-tool-panel-button-enable .ag-chart-menu-close{transform:translate(-3px,-50%)}.ag-rtl .ag-chart-tool-panel-button-enable .ag-chart-menu-close:hover{transform:translateY(-50%)}.ag-rtl .ag-chart-menu-visible .ag-chart-tool-panel-button-enable .ag-chart-menu-close:hover{transform:translate(-5px,-50%)}.ag-charts-font-size-color{display:flex;align-self:stretch;justify-content:space-between}.ag-charts-data-group-item{position:relative}.ag-charts-data-group-item:not(:last-child){margin-bottom:var(--ag-grid-size)}.ag-chart-menu{border-radius:var(--ag-card-radius);background:var(--ag-background-color)}.ag-chart-menu-icon{opacity:.5;margin:2px 0;cursor:pointer;border-radius:var(--ag-card-radius);color:var(--ag-secondary-foreground-color)}.ag-chart-menu-icon:hover{opacity:1}.ag-chart-menu-toolbar-button{border:0;background-color:unset;padding:0 2px;border-radius:1px}.ag-chart-mini-thumbnail{border:1px solid var(--ag-secondary-border-color);border-radius:5px}.ag-chart-mini-thumbnail.ag-selected{border-color:var(--ag-minichart-selected-chart-color)}.ag-chart-settings-card-item{background:var(--ag-foreground-color);width:8px;height:8px;border-radius:4px}.ag-chart-settings-card-item.ag-selected{background-color:var(--ag-minichart-selected-page-color)}.ag-chart-data-column-drag-handle{margin-left:var(--ag-grid-size)}.ag-charts-settings-group-title-bar,.ag-charts-data-group-title-bar,.ag-charts-format-top-level-group-title-bar{border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color);position:relative}.ag-charts-advanced-settings-top-level-group-title-bar{position:relative;background-color:unset}.ag-charts-settings-group-title-bar:focus-visible{outline:none}.ag-charts-settings-group-title-bar:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:-4px;left:-4px;display:block;width:calc(100% + 8px);height:calc(100% + 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-charts-data-group-title-bar:focus-visible{outline:none}.ag-charts-data-group-title-bar:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:-4px;left:-4px;display:block;width:calc(100% + 8px);height:calc(100% + 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-charts-format-top-level-group-title-bar:focus-visible{outline:none}.ag-charts-format-top-level-group-title-bar:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:-4px;left:-4px;display:block;width:calc(100% + 8px);height:calc(100% + 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-charts-advanced-settings-top-level-group-title-bar:focus-visible{outline:none}.ag-charts-advanced-settings-top-level-group-title-bar:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:-4px;left:-4px;display:block;width:calc(100% + 8px);height:calc(100% + 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-charts-data-group-container{padding:calc(var(--ag-widget-container-vertical-padding) * .5) var(--ag-widget-container-horizontal-padding)}.ag-charts-data-group-container .ag-charts-data-group-item:not(.ag-charts-format-sub-level-group):not(.ag-pill-select):not(.ag-select){height:var(--ag-list-item-height)}.ag-charts-data-group-container .ag-charts-data-group-item.ag-picker-field{margin-top:var(--ag-grid-size)}.ag-charts-data-group-container .ag-list-item-hovered:after{content:"";position:absolute;left:0;right:0;height:1px;background-color:var(--ag-range-selection-border-color)}.ag-charts-data-group-container .ag-item-highlight-top:after{top:0}.ag-charts-data-group-container .ag-item-highlight-bottom:after{bottom:0}.ag-charts-format-top-level-group-container,.ag-charts-advanced-settings-top-level-group-container{margin-left:calc(var(--ag-grid-size) * 2);padding:var(--ag-grid-size)}.ag-charts-format-top-level-group-item,.ag-charts-advanced-settings-top-level-group-item{margin:var(--ag-grid-size) 0}.ag-charts-format-sub-level-group-container{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing))}.ag-charts-format-sub-level-group-container>*{margin-bottom:var(--ag-widget-vertical-spacing)}.ag-charts-settings-group-container{padding:var(--ag-grid-size);row-gap:8px;display:grid;grid-template-columns:60px 1fr 60px 1fr 60px}.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+1){grid-column:1}.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+2){grid-column:3}.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+3){grid-column:5}.ag-chart-menu-panel{background-color:var(--ag-control-panel-background-color)}.ag-ltr .ag-chart-menu-panel{border-left:solid 1px var(--ag-border-color)}.ag-rtl .ag-chart-menu-panel{border-right:solid 1px var(--ag-border-color)}.ag-date-time-list-page-title-bar{display:flex}.ag-date-time-list-page-title{flex-grow:1;text-align:center}.ag-date-time-list-page-column-labels-row,.ag-date-time-list-page-entries-row{display:flex}.ag-date-time-list-page-column-label,.ag-date-time-list-page-entry{flex-basis:0;flex-grow:1}.ag-date-time-list-page-entry{cursor:pointer;text-align:center}.ag-date-time-list-page-column-label{text-align:center}.ag-advanced-filter-header{position:relative;display:flex;align-items:center;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding)}.ag-advanced-filter{display:flex;align-items:center;width:100%}.ag-advanced-filter-apply-button,.ag-advanced-filter-builder-button{line-height:normal;white-space:nowrap}.ag-ltr .ag-advanced-filter-apply-button,.ag-ltr .ag-advanced-filter-builder-button{margin-left:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-advanced-filter-apply-button,.ag-rtl .ag-advanced-filter-builder-button{margin-right:calc(var(--ag-grid-size) * 2)}.ag-advanced-filter-builder-button{display:flex;align-items:center;border:0;background-color:unset;color:var(--ag-foreground-color);font-size:var(--ag-font-size);font-weight:600}.ag-advanced-filter-builder-button:hover:not(:disabled){background-color:var(--ag-row-hover-color)}.ag-advanced-filter-builder-button:not(:disabled){cursor:pointer}.ag-advanced-filter-builder-button-label{margin-left:var(--ag-grid-size)}.ag-advanced-filter-builder{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;width:100%;background-color:var(--ag-control-panel-background-color);display:flex;flex-direction:column}.ag-advanced-filter-builder-list{flex:1;overflow:auto}.ag-advanced-filter-builder-list .ag-list-item-hovered:after{content:"";position:absolute;left:0;right:0;height:1px;background-color:var(--ag-range-selection-border-color)}.ag-advanced-filter-builder-list .ag-item-highlight-top:after{top:0}.ag-advanced-filter-builder-list .ag-item-highlight-bottom:after{bottom:0}.ag-advanced-filter-builder-button-panel{display:flex;justify-content:flex-end;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-advanced-filter-builder .ag-advanced-filter-builder-button-panel .ag-advanced-filter-builder-apply-button,.ag-advanced-filter-builder .ag-advanced-filter-builder-button-panel .ag-advanced-filter-builder-cancel-button{margin-left:calc(var(--ag-grid-size) * 2)}.ag-advanced-filter-builder-item-wrapper{display:flex;flex:1 1 auto;align-items:center;justify-content:space-between;overflow:hidden;padding-left:calc(var(--ag-icon-size) / 2);padding-right:var(--ag-icon-size)}.ag-advanced-filter-builder-item-tree-lines>*{width:var(--ag-advanced-filter-builder-indent-size)}.ag-advanced-filter-builder-item-tree-lines .ag-advanced-filter-builder-item-tree-line-root{width:var(--ag-icon-size)}.ag-advanced-filter-builder-item-tree-lines .ag-advanced-filter-builder-item-tree-line-root:before{top:50%;height:50%}.ag-advanced-filter-builder-item-tree-line-horizontal,.ag-advanced-filter-builder-item-tree-line-vertical,.ag-advanced-filter-builder-item-tree-line-vertical-top,.ag-advanced-filter-builder-item-tree-line-vertical-bottom{position:relative;height:100%;display:flex;align-items:center}.ag-advanced-filter-builder-item-tree-line-horizontal:before,.ag-advanced-filter-builder-item-tree-line-horizontal:after,.ag-advanced-filter-builder-item-tree-line-vertical:before,.ag-advanced-filter-builder-item-tree-line-vertical:after,.ag-advanced-filter-builder-item-tree-line-vertical-top:before,.ag-advanced-filter-builder-item-tree-line-vertical-top:after,.ag-advanced-filter-builder-item-tree-line-vertical-bottom:before,.ag-advanced-filter-builder-item-tree-line-vertical-bottom:after{content:"";position:absolute;height:100%}.ag-advanced-filter-builder-item-tree-line-horizontal:after{height:50%;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size));top:0;left:calc(var(--ag-icon-size) / 2);border-bottom:1px solid;border-color:var(--ag-border-color)}.ag-advanced-filter-builder-item-tree-line-vertical:before{width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size) / 2);top:0;left:calc(var(--ag-icon-size) / 2);border-left:1px solid;border-color:var(--ag-border-color)}.ag-advanced-filter-builder-item-tree-line-vertical-top:before{height:50%;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size) / 2);top:0;left:calc(var(--ag-icon-size) / 2);border-left:1px solid;border-color:var(--ag-border-color)}.ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{height:calc((100% - 1.5 * var(--ag-icon-size)) / 2);width:calc(var(--ag-icon-size) / 2);top:calc((100% + 1.5 * var(--ag-icon-size)) / 2);left:calc(var(--ag-icon-size) / 2);border-left:1px solid;border-color:var(--ag-border-color)}.ag-advanced-filter-builder-item-condition{padding-top:var(--ag-grid-size);padding-bottom:var(--ag-grid-size)}.ag-advanced-filter-builder-item,.ag-advanced-filter-builder-item-condition,.ag-advanced-filter-builder-pill-wrapper,.ag-advanced-filter-builder-pill,.ag-advanced-filter-builder-item-buttons,.ag-advanced-filter-builder-item-tree-lines{display:flex;align-items:center;height:100%}.ag-advanced-filter-builder-pill-wrapper{margin:0px var(--ag-grid-size)}.ag-advanced-filter-builder-pill{position:relative;border-radius:var(--ag-border-radius);padding:var(--ag-grid-size) calc(var(--ag-grid-size) * 2);min-height:calc(100% - var(--ag-grid-size) * 3);min-width:calc(var(--ag-grid-size) * 2)}.ag-advanced-filter-builder-pill .ag-picker-field-display{margin-right:var(--ag-grid-size)}.ag-advanced-filter-builder-pill .ag-advanced-filter-builder-value-number{font-family:monospace;font-weight:700}.ag-advanced-filter-builder-pill .ag-advanced-filter-builder-value-empty{color:var(--ag-disabled-foreground-color)}.ag-advanced-filter-builder-pill:focus-visible{outline:none}.ag-advanced-filter-builder-pill:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:-4px;left:-4px;display:block;width:calc(100% + 8px);height:calc(100% + 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-advanced-filter-builder-item-button:focus-visible{outline:none}.ag-advanced-filter-builder-item-button:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:-4px;left:-4px;display:block;width:calc(100% + 8px);height:calc(100% + 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-advanced-filter-builder-pill-display{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:500}.ag-advanced-filter-builder-join-pill{color:var(--ag-foreground-color);background-color:var(--ag-advanced-filter-join-pill-color);cursor:pointer}.ag-advanced-filter-builder-column-pill{color:var(--ag-foreground-color);background-color:var(--ag-advanced-filter-column-pill-color);cursor:pointer}.ag-advanced-filter-builder-option-pill{color:var(--ag-foreground-color);background-color:var(--ag-advanced-filter-option-pill-color);cursor:pointer}.ag-advanced-filter-builder-value-pill{color:var(--ag-foreground-color);background-color:var(--ag-advanced-filter-value-pill-color);cursor:text;max-width:140px}.ag-advanced-filter-builder-value-pill .ag-advanced-filter-builder-pill-display{display:block}.ag-advanced-filter-builder-item-buttons>*{margin:0 calc(var(--ag-grid-size) * .5)}.ag-advanced-filter-builder-item-button{position:relative;cursor:pointer;color:var(--ag-secondary-foreground-color);opacity:50%}.ag-advanced-filter-builder-item-button-disabled{color:var(--ag-disabled-foreground-color);cursor:default}.ag-advanced-filter-builder-virtual-list-container{top:var(--ag-grid-size)}.ag-advanced-filter-builder-virtual-list-item{display:flex;cursor:default;height:var(--ag-list-item-height)}.ag-advanced-filter-builder-virtual-list-item:hover{background-color:var(--ag-row-hover-color)}.ag-advanced-filter-builder-virtual-list-item:hover .ag-advanced-filter-builder-item-button{opacity:100%}.ag-advanced-filter-builder-virtual-list-item-highlight .ag-advanced-filter-builder-item-button:focus-visible,.ag-advanced-filter-builder-validation .ag-advanced-filter-builder-invalid{opacity:100%}.ag-advanced-filter-builder-invalid{margin:0 var(--ag-grid-size);color:var(--ag-invalid-color);cursor:default}.ag-input-field-input{width:100%;min-width:0}.ag-checkbox-input-wrapper{font-family:var(--ag-icon-font-family);font-weight:var(--ag-icon-font-weight);color:var(--ag-icon-font-color);font-size:var(--ag-icon-size);line-height:var(--ag-icon-size);font-style:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:var(--ag-icon-size);height:var(--ag-icon-size);background-color:var(--ag-checkbox-background-color);border-radius:var(--ag-checkbox-border-radius);display:inline-block;vertical-align:middle;flex:none}.ag-checkbox-input-wrapper input{-webkit-appearance:none;opacity:0;width:100%;height:100%}.ag-checkbox-input-wrapper:focus-within,.ag-checkbox-input-wrapper:active{outline:none;box-shadow:var(--ag-input-focus-box-shadow)}.ag-checkbox-input-wrapper.ag-disabled{opacity:.5}.ag-checkbox-input-wrapper:after{content:var(--ag-icon-font-code-checkbox-unchecked, "");color:var(--ag-checkbox-unchecked-color);display:var(--ag-icon-font-display-checkbox-unchecked, var(--ag-icon-font-display));position:absolute;top:0;left:0;pointer-events:none}.ag-checkbox-input-wrapper.ag-checked:after{content:var(--ag-icon-font-code-checkbox-checked, "");color:var(--ag-checkbox-checked-color);display:var(--ag-icon-font-display-checkbox-checked, var(--ag-icon-font-display));position:absolute;top:0;left:0;pointer-events:none}.ag-checkbox-input-wrapper.ag-indeterminate:after{content:var(--ag-icon-font-code-checkbox-indeterminate, "");color:var(--ag-checkbox-indeterminate-color);display:var(--ag-icon-font-display-checkbox-indeterminate, var(--ag-icon-font-display));position:absolute;top:0;left:0;pointer-events:none}.ag-checkbox-input-wrapper:before{content:"";background:transparent center/contain no-repeat;position:absolute;top:0;right:0;bottom:0;left:0;background-image:var(--ag-icon-image-checkbox-unchecked, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-unchecked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-unchecked, var(--ag-icon-image-opacity, .9))}.ag-checkbox-input-wrapper.ag-checked:before{background-image:var(--ag-icon-image-checkbox-checked, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-checked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-checked, var(--ag-icon-image-opacity, .9))}.ag-checkbox-input-wrapper.ag-indeterminate:before{background-image:var(--ag-icon-image-checkbox-indeterminate, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-indeterminate, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-indeterminate, var(--ag-icon-image-opacity, .9))}.ag-toggle-button-input-wrapper{box-sizing:border-box;width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);max-width:var(--ag-toggle-button-width);height:var(--ag-toggle-button-height);background-color:var(--ag-toggle-button-off-background-color);border-radius:calc(var(--ag-toggle-button-height) * .5);position:relative;flex:none;border:var(--ag-toggle-button-border-width) solid;border-color:var(--ag-toggle-button-off-border-color)}.ag-toggle-button-input-wrapper input{opacity:0;height:100%;width:100%}.ag-toggle-button-input-wrapper:focus-within{outline:none;box-shadow:var(--ag-input-focus-box-shadow)}.ag-toggle-button-input-wrapper.ag-disabled{opacity:.5}.ag-toggle-button-input-wrapper.ag-checked{background-color:var(--ag-toggle-button-on-background-color);border-color:var(--ag-toggle-button-on-border-color)}.ag-toggle-button-input-wrapper:before{content:" ";position:absolute;top:calc(0px - var(--ag-toggle-button-border-width));left:calc(0px - var(--ag-toggle-button-border-width));display:block;box-sizing:border-box;height:var(--ag-toggle-button-height);width:var(--ag-toggle-button-height);background-color:var(--ag-toggle-button-switch-background-color);border-radius:100%;transition:left .1s;border:var(--ag-toggle-button-border-width) solid;border-color:var(--ag-toggle-button-switch-border-color)}.ag-toggle-button-input-wrapper.ag-checked:before{left:calc(100% - var(--ag-toggle-button-height) + var(--ag-toggle-button-border-width));border-color:var(--ag-toggle-button-on-border-color)}.ag-radio-button-input-wrapper{font-family:var(--ag-icon-font-family);font-weight:var(--ag-icon-font-weight);color:var(--ag-icon-font-color);font-size:var(--ag-icon-size);line-height:var(--ag-icon-size);font-style:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:var(--ag-icon-size);height:var(--ag-icon-size);background-color:var(--ag-checkbox-background-color);border-radius:var(--ag-checkbox-border-radius);display:inline-block;vertical-align:middle;flex:none;border-radius:var(--ag-icon-size)}.ag-radio-button-input-wrapper input{-webkit-appearance:none;opacity:0;width:100%;height:100%}.ag-radio-button-input-wrapper:focus-within,.ag-radio-button-input-wrapper:active{outline:none;box-shadow:var(--ag-input-focus-box-shadow)}.ag-radio-button-input-wrapper.ag-disabled{opacity:.5}.ag-radio-button-input-wrapper:after{content:var(--ag-icon-font-code-radio-button-off, "");color:var(--ag-checkbox-unchecked-color);display:var(--ag-icon-font-display-radio-button-off, var(--ag-icon-font-display));position:absolute;top:0;left:0;pointer-events:none}.ag-radio-button-input-wrapper.ag-checked:after{content:var(--ag-icon-font-code-radio-button-on, "");color:var(--ag-checkbox-checked-color);display:var(--ag-icon-font-display-radio-button-on, var(--ag-icon-font-display));position:absolute;top:0;left:0;pointer-events:none}.ag-radio-button-input-wrapper:before{content:"";background:transparent center/contain no-repeat;position:absolute;top:0;right:0;bottom:0;left:0;background-image:var(--ag-icon-image-radio-button-off, var(--ag-icon-image));display:var(--ag-icon-image-display-radio-button-off, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-radio-button-off, var(--ag-icon-image-opacity, .9))}.ag-radio-button-input-wrapper.ag-checked:before{background-image:var(--ag-icon-image-radio-button-on, var(--ag-icon-image));display:var(--ag-icon-image-display-radio-button-on, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-radio-button-on, var(--ag-icon-image-opacity, .9))}input[class^=ag-][type=range]{-webkit-appearance:none;width:100%;height:100%;background:none;overflow:visible}input[class^=ag-][type=range]::-webkit-slider-runnable-track{margin:0;padding:0;width:100%;height:3px;background-color:var(--ag-border-color);border-radius:var(--ag-border-radius);border-radius:var(--ag-checkbox-border-radius)}input[class^=ag-][type=range]::-moz-range-track{margin:0;padding:0;width:100%;height:3px;background-color:var(--ag-border-color);border-radius:var(--ag-border-radius);border-radius:var(--ag-checkbox-border-radius)}input[class^=ag-][type=range]::-ms-track{margin:0;padding:0;width:100%;height:3px;background-color:var(--ag-border-color);border-radius:var(--ag-border-radius);border-radius:var(--ag-checkbox-border-radius);color:transparent;width:calc(100% - 2px)}input[class^=ag-][type=range]::-webkit-slider-thumb{margin:0;padding:0;-webkit-appearance:none;width:var(--ag-icon-size);height:var(--ag-icon-size);background-color:var(--ag-background-color);border:1px solid;border-color:var(--ag-checkbox-unchecked-color);border-radius:var(--ag-icon-size);transform:translateY(calc(var(--ag-icon-size) * -.5 + 1.5px))}input[class^=ag-][type=range]::-ms-thumb{margin:0;padding:0;-webkit-appearance:none;width:var(--ag-icon-size);height:var(--ag-icon-size);background-color:var(--ag-background-color);border:1px solid;border-color:var(--ag-checkbox-unchecked-color);border-radius:var(--ag-icon-size)}input[class^=ag-][type=range]::-moz-ag-range-thumb{margin:0;padding:0;-webkit-appearance:none;width:var(--ag-icon-size);height:var(--ag-icon-size);background-color:var(--ag-background-color);border:1px solid;border-color:var(--ag-checkbox-unchecked-color);border-radius:var(--ag-icon-size)}input[class^=ag-][type=range]:focus{outline:none}input[class^=ag-][type=range]:focus::-webkit-slider-thumb{box-shadow:var(--ag-input-focus-box-shadow);border-color:var(--ag-checkbox-checked-color)}input[class^=ag-][type=range]:focus::-ms-thumb{box-shadow:var(--ag-input-focus-box-shadow);border-color:var(--ag-checkbox-checked-color)}input[class^=ag-][type=range]:focus::-moz-ag-range-thumb{box-shadow:var(--ag-input-focus-box-shadow);border-color:var(--ag-checkbox-checked-color)}input[class^=ag-][type=range]:active::-webkit-slider-runnable-track{background-color:var(--ag-input-focus-border-color)}input[class^=ag-][type=range]:active::-moz-ag-range-track{background-color:var(--ag-input-focus-border-color)}input[class^=ag-][type=range]:active::-ms-track{background-color:var(--ag-input-focus-border-color)}input[class^=ag-][type=range]:disabled{opacity:.5}@font-face{font-family:agGridAlpine;src:url(data:font/woff2;charset=utf-8;base64,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);font-weight:400;font-style:normal}.ag-theme-alpine,.ag-theme-alpine-dark,.ag-theme-alpine-auto-dark{--ag-alpine-active-color: #2196f3;--ag-selected-row-background-color: rgba(33, 150, 243, .3);--ag-row-hover-color: rgba(33, 150, 243, .1);--ag-column-hover-color: rgba(33, 150, 243, .1);--ag-input-focus-border-color: rgba(33, 150, 243, .4);--ag-range-selection-background-color: rgba(33, 150, 243, .2);--ag-range-selection-background-color-2: rgba(33, 150, 243, .36);--ag-range-selection-background-color-3: rgba(33, 150, 243, .49);--ag-range-selection-background-color-4: rgba(33, 150, 243, .59);--ag-background-color: #fff;--ag-foreground-color: #181d1f;--ag-border-color: #babfc7;--ag-secondary-border-color: #dde2eb;--ag-header-background-color: #f8f8f8;--ag-tooltip-background-color: #f8f8f8;--ag-odd-row-background-color: #fcfcfc;--ag-control-panel-background-color: #f8f8f8;--ag-subheader-background-color: #fff;--ag-invalid-color: #e02525;--ag-checkbox-unchecked-color: #999;--ag-advanced-filter-join-pill-color: #f08e8d;--ag-advanced-filter-column-pill-color: #a6e194;--ag-advanced-filter-option-pill-color: #f3c08b;--ag-advanced-filter-value-pill-color: #85c0e4;--ag-checkbox-background-color: var(--ag-background-color);--ag-checkbox-checked-color: var(--ag-alpine-active-color);--ag-range-selection-border-color: var(--ag-alpine-active-color);--ag-secondary-foreground-color: var(--ag-foreground-color);--ag-input-border-color: var(--ag-border-color);--ag-input-border-color-invalid: var(--ag-invalid-color);--ag-input-focus-box-shadow: 0 0 2px .1rem var(--ag-input-focus-border-color);--ag-panel-background-color: var(--ag-header-background-color);--ag-menu-background-color: var(--ag-header-background-color);--ag-disabled-foreground-color: rgba(24, 29, 31, .5);--ag-chip-background-color: rgba(24, 29, 31, .07);--ag-input-disabled-border-color: rgba(186, 191, 199, .3);--ag-input-disabled-background-color: rgba(186, 191, 199, .15);--ag-borders: solid 1px;--ag-border-radius: 3px;--ag-borders-side-button: none;--ag-side-button-selected-background-color: transparent;--ag-header-column-resize-handle-display: block;--ag-header-column-resize-handle-width: 2px;--ag-header-column-resize-handle-height: 30%;--ag-grid-size: 6px;--ag-icon-size: 16px;--ag-row-height: calc(var(--ag-grid-size) * 7);--ag-header-height: calc(var(--ag-grid-size) * 8);--ag-list-item-height: calc(var(--ag-grid-size) * 4);--ag-column-select-indent-size: var(--ag-icon-size);--ag-set-filter-indent-size: var(--ag-icon-size);--ag-advanced-filter-builder-indent-size: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);--ag-cell-horizontal-padding: calc(var(--ag-grid-size) * 3);--ag-cell-widget-spacing: calc(var(--ag-grid-size) * 2);--ag-widget-container-vertical-padding: calc(var(--ag-grid-size) * 2);--ag-widget-container-horizontal-padding: calc(var(--ag-grid-size) * 2);--ag-widget-vertical-spacing: calc(var(--ag-grid-size) * 1.5);--ag-toggle-button-height: 18px;--ag-toggle-button-width: 28px;--ag-font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;--ag-font-size: 13px;--ag-icon-font-family: agGridAlpine;--ag-selected-tab-underline-color: var(--ag-alpine-active-color);--ag-selected-tab-underline-width: 2px;--ag-selected-tab-underline-transition-speed: .3s;--ag-tab-min-width: 240px;--ag-card-shadow: 0 1px 4px 1px rgba(186, 191, 199, .4);--ag-popup-shadow: var(--ag-card-shadow);--ag-side-bar-panel-width: 250px}.ag-theme-alpine-dark{--ag-background-color: #181d1f;--ag-foreground-color: #fff;--ag-border-color: #68686e;--ag-secondary-border-color: rgba(88, 86, 82, .5);--ag-modal-overlay-background-color: rgba(24, 29, 31, .66);--ag-header-background-color: #222628;--ag-tooltip-background-color: #222628;--ag-odd-row-background-color: #222628;--ag-control-panel-background-color: #222628;--ag-subheader-background-color: #000;--ag-input-disabled-background-color: #282c2f;--ag-input-focus-box-shadow: 0 0 2px .5px rgba(255, 255, 255, .5), 0 0 4px 3px var(--ag-input-focus-border-color);--ag-card-shadow: 0 1px 20px 1px black;--ag-disabled-foreground-color: rgba(255, 255, 255, .5);--ag-chip-background-color: rgba(255, 255, 255, .07);--ag-input-disabled-border-color: rgba(104, 104, 110, .3);--ag-input-disabled-background-color: rgba(104, 104, 110, .07);--ag-advanced-filter-join-pill-color: #7a3a37;--ag-advanced-filter-column-pill-color: #355f2d;--ag-advanced-filter-option-pill-color: #5a3168;--ag-advanced-filter-value-pill-color: #374c86;--ag-row-loading-skeleton-effect-color: rgba(202, 203, 204, .4);color-scheme:dark}@media (prefers-color-scheme: dark){.ag-theme-alpine-auto-dark{--ag-background-color: #181d1f;--ag-foreground-color: #fff;--ag-border-color: #68686e;--ag-secondary-border-color: rgba(88, 86, 82, .5);--ag-modal-overlay-background-color: rgba(24, 29, 31, .66);--ag-header-background-color: #222628;--ag-tooltip-background-color: #222628;--ag-odd-row-background-color: #222628;--ag-control-panel-background-color: #222628;--ag-subheader-background-color: #000;--ag-input-disabled-background-color: #282c2f;--ag-input-focus-box-shadow: 0 0 2px .5px rgba(255, 255, 255, .5), 0 0 4px 3px var(--ag-input-focus-border-color);--ag-card-shadow: 0 1px 20px 1px black;--ag-disabled-foreground-color: rgba(255, 255, 255, .5);--ag-chip-background-color: rgba(255, 255, 255, .07);--ag-input-disabled-border-color: rgba(104, 104, 110, .3);--ag-input-disabled-background-color: rgba(104, 104, 110, .07);--ag-advanced-filter-join-pill-color: #7a3a37;--ag-advanced-filter-column-pill-color: #355f2d;--ag-advanced-filter-option-pill-color: #5a3168;--ag-advanced-filter-value-pill-color: #374c86;--ag-row-loading-skeleton-effect-color: rgba(202, 203, 204, .4);color-scheme:dark}}.ag-theme-alpine .ag-filter-toolpanel-header,.ag-theme-alpine .ag-filter-toolpanel-search,.ag-theme-alpine .ag-status-bar,.ag-theme-alpine .ag-header-row,.ag-theme-alpine .ag-panel-title-bar-title,.ag-theme-alpine .ag-multi-filter-group-title-bar,.ag-theme-alpine-dark .ag-filter-toolpanel-header,.ag-theme-alpine-dark .ag-filter-toolpanel-search,.ag-theme-alpine-dark .ag-status-bar,.ag-theme-alpine-dark .ag-header-row,.ag-theme-alpine-dark .ag-panel-title-bar-title,.ag-theme-alpine-dark .ag-multi-filter-group-title-bar,.ag-theme-alpine-auto-dark .ag-filter-toolpanel-header,.ag-theme-alpine-auto-dark .ag-filter-toolpanel-search,.ag-theme-alpine-auto-dark .ag-status-bar,.ag-theme-alpine-auto-dark .ag-header-row,.ag-theme-alpine-auto-dark .ag-panel-title-bar-title,.ag-theme-alpine-auto-dark .ag-multi-filter-group-title-bar{font-weight:700;color:var(--ag-header-foreground-color)}.ag-theme-alpine .ag-row,.ag-theme-alpine-dark .ag-row,.ag-theme-alpine-auto-dark .ag-row{font-size:calc(var(--ag-font-size) + 1px)}.ag-theme-alpine input[class^=ag-]:not([type]),.ag-theme-alpine input[class^=ag-][type=text],.ag-theme-alpine input[class^=ag-][type=number],.ag-theme-alpine input[class^=ag-][type=tel],.ag-theme-alpine input[class^=ag-][type=date],.ag-theme-alpine input[class^=ag-][type=datetime-local],.ag-theme-alpine textarea[class^=ag-],.ag-theme-alpine-dark input[class^=ag-]:not([type]),.ag-theme-alpine-dark input[class^=ag-][type=text],.ag-theme-alpine-dark input[class^=ag-][type=number],.ag-theme-alpine-dark input[class^=ag-][type=tel],.ag-theme-alpine-dark input[class^=ag-][type=date],.ag-theme-alpine-dark input[class^=ag-][type=datetime-local],.ag-theme-alpine-dark textarea[class^=ag-],.ag-theme-alpine-auto-dark input[class^=ag-]:not([type]),.ag-theme-alpine-auto-dark input[class^=ag-][type=text],.ag-theme-alpine-auto-dark input[class^=ag-][type=number],.ag-theme-alpine-auto-dark input[class^=ag-][type=tel],.ag-theme-alpine-auto-dark input[class^=ag-][type=date],.ag-theme-alpine-auto-dark input[class^=ag-][type=datetime-local],.ag-theme-alpine-auto-dark textarea[class^=ag-]{min-height:calc(var(--ag-grid-size) * 4);border-radius:var(--ag-border-radius)}.ag-theme-alpine .ag-ltr input[class^=ag-]:not([type]),.ag-theme-alpine .ag-ltr input[class^=ag-][type=text],.ag-theme-alpine .ag-ltr input[class^=ag-][type=number],.ag-theme-alpine .ag-ltr input[class^=ag-][type=tel],.ag-theme-alpine .ag-ltr input[class^=ag-][type=date],.ag-theme-alpine .ag-ltr input[class^=ag-][type=datetime-local],.ag-theme-alpine .ag-ltr textarea[class^=ag-],.ag-theme-alpine-dark .ag-ltr input[class^=ag-]:not([type]),.ag-theme-alpine-dark .ag-ltr input[class^=ag-][type=text],.ag-theme-alpine-dark .ag-ltr input[class^=ag-][type=number],.ag-theme-alpine-dark .ag-ltr input[class^=ag-][type=tel],.ag-theme-alpine-dark .ag-ltr input[class^=ag-][type=date],.ag-theme-alpine-dark .ag-ltr input[class^=ag-][type=datetime-local],.ag-theme-alpine-dark .ag-ltr textarea[class^=ag-],.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-]:not([type]),.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-][type=text],.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-][type=number],.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-][type=tel],.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-][type=date],.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-][type=datetime-local],.ag-theme-alpine-auto-dark .ag-ltr textarea[class^=ag-]{padding-left:var(--ag-grid-size)}.ag-theme-alpine .ag-rtl input[class^=ag-]:not([type]),.ag-theme-alpine .ag-rtl input[class^=ag-][type=text],.ag-theme-alpine .ag-rtl input[class^=ag-][type=number],.ag-theme-alpine .ag-rtl input[class^=ag-][type=tel],.ag-theme-alpine .ag-rtl input[class^=ag-][type=date],.ag-theme-alpine .ag-rtl input[class^=ag-][type=datetime-local],.ag-theme-alpine .ag-rtl textarea[class^=ag-],.ag-theme-alpine-dark .ag-rtl input[class^=ag-]:not([type]),.ag-theme-alpine-dark .ag-rtl input[class^=ag-][type=text],.ag-theme-alpine-dark .ag-rtl input[class^=ag-][type=number],.ag-theme-alpine-dark .ag-rtl input[class^=ag-][type=tel],.ag-theme-alpine-dark .ag-rtl input[class^=ag-][type=date],.ag-theme-alpine-dark .ag-rtl input[class^=ag-][type=datetime-local],.ag-theme-alpine-dark .ag-rtl textarea[class^=ag-],.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-]:not([type]),.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-][type=text],.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-][type=number],.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-][type=tel],.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-][type=date],.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-][type=datetime-local],.ag-theme-alpine-auto-dark .ag-rtl textarea[class^=ag-]{padding-right:var(--ag-grid-size)}.ag-theme-alpine .ag-tab,.ag-theme-alpine-dark .ag-tab,.ag-theme-alpine-auto-dark .ag-tab{padding:calc(var(--ag-grid-size) * 1.5);transition:color .4s;flex:1 1 auto}.ag-theme-alpine .ag-tab-selected,.ag-theme-alpine-dark .ag-tab-selected,.ag-theme-alpine-auto-dark .ag-tab-selected{color:var(--ag-alpine-active-color)}.ag-theme-alpine .ag-menu,.ag-theme-alpine-dark .ag-menu,.ag-theme-alpine-auto-dark .ag-menu,.ag-theme-alpine .ag-panel-content-wrapper .ag-column-select,.ag-theme-alpine-dark .ag-panel-content-wrapper .ag-column-select,.ag-theme-alpine-auto-dark .ag-panel-content-wrapper .ag-column-select{background-color:var(--ag-control-panel-background-color)}.ag-theme-alpine .ag-menu-header,.ag-theme-alpine-dark .ag-menu-header,.ag-theme-alpine-auto-dark .ag-menu-header{background-color:var(--ag-control-panel-background-color);padding-top:1px}.ag-theme-alpine .ag-tabs-header,.ag-theme-alpine-dark .ag-tabs-header,.ag-theme-alpine-auto-dark .ag-tabs-header{border-bottom:var(--ag-borders) var(--ag-border-color)}.ag-theme-alpine .ag-charts-settings-group-title-bar,.ag-theme-alpine .ag-charts-data-group-title-bar,.ag-theme-alpine .ag-charts-format-top-level-group-title-bar,.ag-theme-alpine .ag-charts-advanced-settings-top-level-group-title-bar,.ag-theme-alpine-dark .ag-charts-settings-group-title-bar,.ag-theme-alpine-dark .ag-charts-data-group-title-bar,.ag-theme-alpine-dark .ag-charts-format-top-level-group-title-bar,.ag-theme-alpine-dark .ag-charts-advanced-settings-top-level-group-title-bar,.ag-theme-alpine-auto-dark .ag-charts-settings-group-title-bar,.ag-theme-alpine-auto-dark .ag-charts-data-group-title-bar,.ag-theme-alpine-auto-dark .ag-charts-format-top-level-group-title-bar,.ag-theme-alpine-auto-dark .ag-charts-advanced-settings-top-level-group-title-bar{padding:var(--ag-grid-size) calc(var(--ag-grid-size) * 2);line-height:calc(var(--ag-icon-size) + var(--ag-grid-size) - 2px)}.ag-theme-alpine .ag-chart-mini-thumbnail,.ag-theme-alpine-dark .ag-chart-mini-thumbnail,.ag-theme-alpine-auto-dark .ag-chart-mini-thumbnail{background-color:var(--ag-background-color)}.ag-theme-alpine .ag-chart-settings-nav-bar,.ag-theme-alpine-dark .ag-chart-settings-nav-bar,.ag-theme-alpine-auto-dark .ag-chart-settings-nav-bar{border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-theme-alpine .ag-ltr .ag-group-title-bar-icon,.ag-theme-alpine-dark .ag-ltr .ag-group-title-bar-icon,.ag-theme-alpine-auto-dark .ag-ltr .ag-group-title-bar-icon{margin-right:var(--ag-grid-size)}.ag-theme-alpine .ag-rtl .ag-group-title-bar-icon,.ag-theme-alpine-dark .ag-rtl .ag-group-title-bar-icon,.ag-theme-alpine-auto-dark .ag-rtl .ag-group-title-bar-icon{margin-left:var(--ag-grid-size)}.ag-theme-alpine .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-dark .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-dark .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-charts-advanced-settings-top-level-group-toolbar{margin-top:var(--ag-grid-size)}.ag-theme-alpine .ag-ltr .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine .ag-ltr .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-dark .ag-ltr .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-dark .ag-ltr .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-ltr .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-ltr .ag-charts-advanced-settings-top-level-group-toolbar{padding-left:calc(var(--ag-icon-size) * .5 + var(--ag-grid-size) * 2)}.ag-theme-alpine .ag-rtl .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine .ag-rtl .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-dark .ag-rtl .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-dark .ag-rtl .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-rtl .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-rtl .ag-charts-advanced-settings-top-level-group-toolbar{padding-right:calc(var(--ag-icon-size) * .5 + var(--ag-grid-size) * 2)}.ag-theme-alpine .ag-charts-format-sub-level-group,.ag-theme-alpine-dark .ag-charts-format-sub-level-group,.ag-theme-alpine-auto-dark .ag-charts-format-sub-level-group{border-left:dashed 1px;border-left-color:var(--ag-border-color);padding-left:var(--ag-grid-size);margin-bottom:calc(var(--ag-grid-size) * 2)}.ag-theme-alpine .ag-charts-format-sub-level-group-title-bar,.ag-theme-alpine-dark .ag-charts-format-sub-level-group-title-bar,.ag-theme-alpine-auto-dark .ag-charts-format-sub-level-group-title-bar{padding-top:0;padding-bottom:0;background:none;font-weight:700}.ag-theme-alpine .ag-charts-format-sub-level-group-container,.ag-theme-alpine-dark .ag-charts-format-sub-level-group-container,.ag-theme-alpine-auto-dark .ag-charts-format-sub-level-group-container{padding-bottom:0}.ag-theme-alpine .ag-charts-format-sub-level-group-item:last-child,.ag-theme-alpine-dark .ag-charts-format-sub-level-group-item:last-child,.ag-theme-alpine-auto-dark .ag-charts-format-sub-level-group-item:last-child{margin-bottom:0}.ag-theme-alpine.ag-dnd-ghost,.ag-theme-alpine-dark.ag-dnd-ghost,.ag-theme-alpine-auto-dark.ag-dnd-ghost{font-size:calc(var(--ag-font-size) - 1px);font-weight:700}.ag-theme-alpine .ag-side-buttons,.ag-theme-alpine-dark .ag-side-buttons,.ag-theme-alpine-auto-dark .ag-side-buttons{width:calc(var(--ag-grid-size) * 5)}.ag-theme-alpine .ag-standard-button,.ag-theme-alpine-dark .ag-standard-button,.ag-theme-alpine-auto-dark .ag-standard-button{font-family:inherit;-moz-appearance:none;appearance:none;-webkit-appearance:none;border-radius:var(--ag-border-radius);border:1px solid;border-color:var(--ag-alpine-active-color);color:var(--ag-alpine-active-color);background-color:var(--ag-background-color);font-weight:600;padding:var(--ag-grid-size) calc(var(--ag-grid-size) * 2)}.ag-theme-alpine .ag-standard-button:hover,.ag-theme-alpine-dark .ag-standard-button:hover,.ag-theme-alpine-auto-dark .ag-standard-button:hover{border-color:var(--ag-alpine-active-color);background-color:var(--ag-row-hover-color)}.ag-theme-alpine .ag-standard-button:active,.ag-theme-alpine-dark .ag-standard-button:active,.ag-theme-alpine-auto-dark .ag-standard-button:active{border-color:var(--ag-alpine-active-color);background-color:var(--ag-alpine-active-color);color:var(--ag-background-color)}.ag-theme-alpine .ag-standard-button:disabled,.ag-theme-alpine-dark .ag-standard-button:disabled,.ag-theme-alpine-auto-dark .ag-standard-button:disabled{color:var(--ag-disabled-foreground-color);background-color:var(--ag-input-disabled-background-color);border-color:var(--ag-input-disabled-border-color)}.ag-theme-alpine .ag-column-drop-vertical,.ag-theme-alpine-dark .ag-column-drop-vertical,.ag-theme-alpine-auto-dark .ag-column-drop-vertical{min-height:75px}.ag-theme-alpine .ag-column-drop-vertical-title-bar,.ag-theme-alpine-dark .ag-column-drop-vertical-title-bar,.ag-theme-alpine-auto-dark .ag-column-drop-vertical-title-bar{padding:calc(var(--ag-grid-size) * 2);padding-bottom:0}.ag-theme-alpine .ag-column-drop-vertical-empty-message,.ag-theme-alpine-dark .ag-column-drop-vertical-empty-message,.ag-theme-alpine-auto-dark .ag-column-drop-vertical-empty-message{display:flex;align-items:center;border:dashed 1px;border-color:var(--ag-border-color);margin:calc(var(--ag-grid-size) * 2);padding:calc(var(--ag-grid-size) * 2)}.ag-theme-alpine .ag-column-drop-empty-message,.ag-theme-alpine-dark .ag-column-drop-empty-message,.ag-theme-alpine-auto-dark .ag-column-drop-empty-message{color:var(--ag-foreground-color);opacity:.75}.ag-theme-alpine .ag-pill-select .ag-column-drop,.ag-theme-alpine-dark .ag-pill-select .ag-column-drop,.ag-theme-alpine-auto-dark .ag-pill-select .ag-column-drop{min-height:unset}.ag-theme-alpine .ag-status-bar,.ag-theme-alpine-dark .ag-status-bar,.ag-theme-alpine-auto-dark .ag-status-bar{font-weight:400}.ag-theme-alpine .ag-status-name-value-value,.ag-theme-alpine-dark .ag-status-name-value-value,.ag-theme-alpine-auto-dark .ag-status-name-value-value,.ag-theme-alpine .ag-paging-number,.ag-theme-alpine .ag-paging-row-summary-panel-number,.ag-theme-alpine-dark .ag-paging-number,.ag-theme-alpine-dark .ag-paging-row-summary-panel-number,.ag-theme-alpine-auto-dark .ag-paging-number,.ag-theme-alpine-auto-dark .ag-paging-row-summary-panel-number{font-weight:700}.ag-theme-alpine .ag-column-drop-cell-button,.ag-theme-alpine-dark .ag-column-drop-cell-button,.ag-theme-alpine-auto-dark .ag-column-drop-cell-button{opacity:.5}.ag-theme-alpine .ag-column-drop-cell-button:hover,.ag-theme-alpine-dark .ag-column-drop-cell-button:hover,.ag-theme-alpine-auto-dark .ag-column-drop-cell-button:hover{opacity:.75}.ag-theme-alpine .ag-column-select-column-readonly.ag-icon-grip,.ag-theme-alpine .ag-column-select-column-readonly .ag-icon-grip,.ag-theme-alpine-dark .ag-column-select-column-readonly.ag-icon-grip,.ag-theme-alpine-dark .ag-column-select-column-readonly .ag-icon-grip,.ag-theme-alpine-auto-dark .ag-column-select-column-readonly.ag-icon-grip,.ag-theme-alpine-auto-dark .ag-column-select-column-readonly .ag-icon-grip{opacity:.35}.ag-theme-alpine .ag-header-cell-menu-button:hover,.ag-theme-alpine .ag-header-cell-filter-button:hover,.ag-theme-alpine .ag-side-button-button:hover,.ag-theme-alpine .ag-tab:hover,.ag-theme-alpine .ag-panel-title-bar-button:hover,.ag-theme-alpine .ag-header-expand-icon:hover,.ag-theme-alpine .ag-column-group-icons:hover,.ag-theme-alpine .ag-set-filter-group-icons:hover,.ag-theme-alpine .ag-group-expanded .ag-icon:hover,.ag-theme-alpine .ag-group-contracted .ag-icon:hover,.ag-theme-alpine .ag-chart-settings-prev:hover,.ag-theme-alpine .ag-chart-settings-next:hover,.ag-theme-alpine .ag-group-title-bar-icon:hover,.ag-theme-alpine .ag-column-select-header-icon:hover,.ag-theme-alpine .ag-floating-filter-button-button:hover,.ag-theme-alpine .ag-filter-toolpanel-expand:hover,.ag-theme-alpine .ag-chart-menu-icon:hover,.ag-theme-alpine .ag-chart-menu-close:hover,.ag-theme-alpine-dark .ag-header-cell-menu-button:hover,.ag-theme-alpine-dark .ag-header-cell-filter-button:hover,.ag-theme-alpine-dark .ag-side-button-button:hover,.ag-theme-alpine-dark .ag-tab:hover,.ag-theme-alpine-dark .ag-panel-title-bar-button:hover,.ag-theme-alpine-dark .ag-header-expand-icon:hover,.ag-theme-alpine-dark .ag-column-group-icons:hover,.ag-theme-alpine-dark .ag-set-filter-group-icons:hover,.ag-theme-alpine-dark .ag-group-expanded .ag-icon:hover,.ag-theme-alpine-dark .ag-group-contracted .ag-icon:hover,.ag-theme-alpine-dark .ag-chart-settings-prev:hover,.ag-theme-alpine-dark .ag-chart-settings-next:hover,.ag-theme-alpine-dark .ag-group-title-bar-icon:hover,.ag-theme-alpine-dark .ag-column-select-header-icon:hover,.ag-theme-alpine-dark .ag-floating-filter-button-button:hover,.ag-theme-alpine-dark .ag-filter-toolpanel-expand:hover,.ag-theme-alpine-dark .ag-chart-menu-icon:hover,.ag-theme-alpine-dark .ag-chart-menu-close:hover,.ag-theme-alpine-auto-dark .ag-header-cell-menu-button:hover,.ag-theme-alpine-auto-dark .ag-header-cell-filter-button:hover,.ag-theme-alpine-auto-dark .ag-side-button-button:hover,.ag-theme-alpine-auto-dark .ag-tab:hover,.ag-theme-alpine-auto-dark .ag-panel-title-bar-button:hover,.ag-theme-alpine-auto-dark .ag-header-expand-icon:hover,.ag-theme-alpine-auto-dark .ag-column-group-icons:hover,.ag-theme-alpine-auto-dark .ag-set-filter-group-icons:hover,.ag-theme-alpine-auto-dark .ag-group-expanded .ag-icon:hover,.ag-theme-alpine-auto-dark .ag-group-contracted .ag-icon:hover,.ag-theme-alpine-auto-dark .ag-chart-settings-prev:hover,.ag-theme-alpine-auto-dark .ag-chart-settings-next:hover,.ag-theme-alpine-auto-dark .ag-group-title-bar-icon:hover,.ag-theme-alpine-auto-dark .ag-column-select-header-icon:hover,.ag-theme-alpine-auto-dark .ag-floating-filter-button-button:hover,.ag-theme-alpine-auto-dark .ag-filter-toolpanel-expand:hover,.ag-theme-alpine-auto-dark .ag-chart-menu-icon:hover,.ag-theme-alpine-auto-dark .ag-chart-menu-close:hover{color:var(--ag-alpine-active-color)}.ag-theme-alpine .ag-header-cell-menu-button:hover .ag-icon,.ag-theme-alpine .ag-header-cell-filter-button:hover .ag-icon,.ag-theme-alpine .ag-side-button-button:hover .ag-icon,.ag-theme-alpine .ag-panel-title-bar-button:hover .ag-icon,.ag-theme-alpine .ag-floating-filter-button-button:hover .ag-icon,.ag-theme-alpine-dark .ag-header-cell-menu-button:hover .ag-icon,.ag-theme-alpine-dark .ag-header-cell-filter-button:hover .ag-icon,.ag-theme-alpine-dark .ag-side-button-button:hover .ag-icon,.ag-theme-alpine-dark .ag-panel-title-bar-button:hover .ag-icon,.ag-theme-alpine-dark .ag-floating-filter-button-button:hover .ag-icon,.ag-theme-alpine-auto-dark .ag-header-cell-menu-button:hover .ag-icon,.ag-theme-alpine-auto-dark .ag-header-cell-filter-button:hover .ag-icon,.ag-theme-alpine-auto-dark .ag-side-button-button:hover .ag-icon,.ag-theme-alpine-auto-dark .ag-panel-title-bar-button:hover .ag-icon,.ag-theme-alpine-auto-dark .ag-floating-filter-button-button:hover .ag-icon{color:inherit}.ag-theme-alpine .ag-filter-active .ag-icon-filter,.ag-theme-alpine-dark .ag-filter-active .ag-icon-filter,.ag-theme-alpine-auto-dark .ag-filter-active .ag-icon-filter{color:var(--ag-alpine-active-color)}.ag-theme-alpine .ag-chart-menu-close,.ag-theme-alpine-dark .ag-chart-menu-close,.ag-theme-alpine-auto-dark .ag-chart-menu-close{background:var(--ag-background-color)}.ag-theme-alpine .ag-chart-menu-close:hover .ag-icon,.ag-theme-alpine-dark .ag-chart-menu-close:hover .ag-icon,.ag-theme-alpine-auto-dark .ag-chart-menu-close:hover .ag-icon{border-color:var(--ag-alpine-active-color)}.ag-theme-alpine .ag-chart-menu-close .ag-icon,.ag-theme-alpine-dark .ag-chart-menu-close .ag-icon,.ag-theme-alpine-auto-dark .ag-chart-menu-close .ag-icon{background:var(--ag-header-background-color);border:1px solid var(--ag-border-color);border-right:none}.ag-theme-alpine .ag-chart-settings-card-item.ag-not-selected:hover,.ag-theme-alpine-dark .ag-chart-settings-card-item.ag-not-selected:hover,.ag-theme-alpine-auto-dark .ag-chart-settings-card-item.ag-not-selected:hover{opacity:.35}.ag-theme-alpine .ag-ltr .ag-panel-title-bar-button,.ag-theme-alpine-dark .ag-ltr .ag-panel-title-bar-button,.ag-theme-alpine-auto-dark .ag-ltr .ag-panel-title-bar-button{margin-left:calc(var(--ag-grid-size) * 2);margin-right:var(--ag-grid-size)}.ag-theme-alpine .ag-rtl .ag-panel-title-bar-button,.ag-theme-alpine-dark .ag-rtl .ag-panel-title-bar-button,.ag-theme-alpine-auto-dark .ag-rtl .ag-panel-title-bar-button{margin-right:calc(var(--ag-grid-size) * 2);margin-left:var(--ag-grid-size)}.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-container,.ag-theme-alpine-dark .ag-ltr .ag-filter-toolpanel-group-container,.ag-theme-alpine-auto-dark .ag-ltr .ag-filter-toolpanel-group-container{padding-left:var(--ag-grid-size)}.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-container,.ag-theme-alpine-dark .ag-rtl .ag-filter-toolpanel-group-container,.ag-theme-alpine-auto-dark .ag-rtl .ag-filter-toolpanel-group-container{padding-right:var(--ag-grid-size)}.ag-theme-alpine .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-dark .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-auto-dark .ag-filter-toolpanel-instance-filter{border:none;background-color:var(--ag-control-panel-background-color)}.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-dark .ag-ltr .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-auto-dark .ag-ltr .ag-filter-toolpanel-instance-filter{border-left:dashed 1px;border-left-color:var(--ag-border-color);margin-left:calc(var(--ag-icon-size) * .5)}.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-dark .ag-rtl .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-auto-dark .ag-rtl .ag-filter-toolpanel-instance-filter{border-right:dashed 1px;border-right-color:var(--ag-border-color);margin-right:calc(var(--ag-icon-size) * .5)}.ag-theme-alpine .ag-set-filter-list,.ag-theme-alpine-dark .ag-set-filter-list,.ag-theme-alpine-auto-dark .ag-set-filter-list{padding-top:calc(var(--ag-grid-size) * .5);padding-bottom:calc(var(--ag-grid-size) * .5)}.ag-theme-alpine .ag-layout-auto-height .ag-center-cols-viewport,.ag-theme-alpine .ag-layout-auto-height .ag-center-cols-container,.ag-theme-alpine .ag-layout-print .ag-center-cols-viewport,.ag-theme-alpine .ag-layout-print .ag-center-cols-container,.ag-theme-alpine-dark .ag-layout-auto-height .ag-center-cols-viewport,.ag-theme-alpine-dark .ag-layout-auto-height .ag-center-cols-container,.ag-theme-alpine-dark .ag-layout-print .ag-center-cols-viewport,.ag-theme-alpine-dark .ag-layout-print .ag-center-cols-container,.ag-theme-alpine-auto-dark .ag-layout-auto-height .ag-center-cols-viewport,.ag-theme-alpine-auto-dark .ag-layout-auto-height .ag-center-cols-container,.ag-theme-alpine-auto-dark .ag-layout-print .ag-center-cols-viewport,.ag-theme-alpine-auto-dark .ag-layout-print .ag-center-cols-container{min-height:150px}.ag-theme-alpine .ag-overlay-no-rows-wrapper.ag-layout-auto-height,.ag-theme-alpine-dark .ag-overlay-no-rows-wrapper.ag-layout-auto-height,.ag-theme-alpine-auto-dark .ag-overlay-no-rows-wrapper.ag-layout-auto-height{padding-top:60px}.ag-theme-alpine .ag-date-time-list-page-entry-is-current,.ag-theme-alpine-dark .ag-date-time-list-page-entry-is-current,.ag-theme-alpine-auto-dark .ag-date-time-list-page-entry-is-current{background-color:var(--ag-alpine-active-color)}.ag-theme-alpine .ag-advanced-filter-builder-button,.ag-theme-alpine-dark .ag-advanced-filter-builder-button,.ag-theme-alpine-auto-dark .ag-advanced-filter-builder-button{padding:var(--ag-grid-size);font-weight:600}')),document.head.appendChild(a)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import { o as pp, r as gp, j as Z } from "./jsx-runtime-3tyXYecC.mjs";
import P, { createContext as fp, memo as St, forwardRef as _i, useContext as Et, useRef as N, useState as G, useImperativeHandle as Es, useLayoutEffect as Fi, useCallback as de, useMemo as j, useEffect as Be, createElement as wd, Component as mp } from "react";
import yl, { createPortal as ru } from "react-dom";
import { l as Rl } from "./lodash-5ofSKtz3.mjs";
import { f as ie } from "./index-LyFokDcn.mjs";
import { m as ys } from "./tss-DN0acMKN.mjs";
import { M as Ir, d as Mr } from "./constants-CnFYFetN.mjs";
import { r as Cp, u as vp } from "./date-picker-utils-provider-CwC1AjFc.mjs";
import { g as wp } from "./focus-trap-react-CzdCUkYc.mjs";
import { S as Di } from "./standard-modal-Di6JpE2n.mjs";
import { T as Sd } from "./text-button-yPCa43NP.mjs";
import { B as Ed } from "./button-CUHBhgeQ.mjs";
import { D as Sp } from "./date-picker-FVIC1w4I.mjs";
import { _ as Ep } from "./composeRefs-YONvD-rx.mjs";
import "./useFetch-Dpmq0XZr.mjs";
import { I as Dl } from "./icon-v2-DGtVEk7e.mjs";
import { M as yp } from "./menu-63UgiRJf.mjs";
import { T as Rp } from "./tooltip-Cy1xtUCm.mjs";
import { F as Dp } from "./flex-Cc3osQLf.mjs";
import { I as Tp } from "./checkbox-DiWnVoeQ.mjs";
import { L as bp } from "./layout-box-DFBM-kSI.mjs";
import { L as yd } from "./loader-CJQkrVUR.mjs";
import { S as Rd } from "./screen-reader-only-text-B-XgpPEP.mjs";
import { I as Dd } from "./icon-button-BxDvkq_l.mjs";
import { I as Ap } from "./X10x10-Bso1Otyr.mjs";
import { i as Pp } from "./transformSpacingProps-m0OnDuSS.mjs";
const nu = (e) => P.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 14", width: "14", height: "14" }, e),
  P.createElement(
    P.Fragment,
    null,
    P.createElement(
      "g",
      { clipPath: "url(#InfoCircle14x14__a)" },
      P.createElement(
        "mask",
        { id: "InfoCircle14x14__b", style: {
          maskType: "luminance"
        }, width: 14, height: 14, x: 0, y: 0, maskUnits: "userSpaceOnUse" },
        P.createElement("path", { fill: "#fff", d: "M14 0H0V14H14V0Z" })
      ),
      P.createElement(
        "g",
        { mask: "url(#InfoCircle14x14__b)" },
        P.createElement("path", { d: "M7 0C3.13425 0 0 3.1325 0 7C0 10.8657 3.13425 14 7 14C10.8658 14 14 10.8657 14 7C14 3.1325 10.8658 0 7 0ZM8 10.5C8 10.822 7.322 11.0833 7 11.0833C6.678 11.0833 6 10.822 6 10.5V6.5C6 6.178 6.678 5.83333 7 5.83333C7.322 5.83333 8 6.178 8 6.5V10.5ZM7 5C6.517 5 6 4.483 6 4C6 3.517 6.517 3 7 3C7.483 3 8 3.517 8 4C8 4.483 7.483 5 7 5Z" })
      )
    ),
    P.createElement(
      "defs",
      null,
      P.createElement(
        "clipPath",
        { id: "InfoCircle14x14__a" },
        P.createElement("path", { fill: "#fff", d: "M0 0H14V14H0z" })
      )
    )
  )
);
nu.displayName = "InfoCircle14x14";
const lu = (e) => P.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 14", width: "14", height: "14" }, e),
  P.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    P.createElement(
      "g",
      null,
      P.createElement("path", { d: "M7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 Z M6.76755692,8.81555692 C7.06556308,8.81555692 7.41124923,8.58627077 7.41124923,8.19648615 C7.41124923,8.07038154 7.37548923,7.95573538 7.30396923,7.85256 C7.22052308,7.73792 7.18476308,7.66913231 7.18476308,7.57741538 C7.18476308,6.88956308 9.46153846,6.75198769 9.46153846,4.90624615 C9.46153846,3.62224615 8.54367385,2.9 6.97019692,2.9 C5.4444,2.9 4.53846154,3.67956923 4.53846154,4.98649231 C4.53846154,5.33042462 4.83646892,5.61702769 5.19408,5.61702769 C5.55168615,5.61702769 5.84969231,5.33042462 5.84969231,4.98649231 C5.84969231,4.34449846 6.30266462,4.02349538 6.97019692,4.02349538 C7.73309538,4.02349538 8.17414769,4.34449846 8.17414769,4.90624615 C8.17414769,6.12145846 5.86161231,6.21316923 5.86161231,7.65766769 C5.86161231,7.97866462 5.98081846,8.33405538 6.30266462,8.63212923 C6.42186462,8.74676923 6.57683077,8.81555692 6.76755692,8.81555692 Z M7.67132923,10.5065286 C7.67132923,9.98205354 7.35701538,9.72564308 6.78305846,9.72564308 C6.20909538,9.72564308 5.88112,9.98205354 5.88112,10.5065286 C5.88112,11.0193495 6.20909538,11.2641046 6.78305846,11.2641046 C7.35701538,11.2641046 7.67132923,11.0193495 7.67132923,10.5065286 Z" })
    )
  )
);
lu.displayName = "Question14x14";
const au = (e) => P.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 49 54", width: "49", height: "54" }, e),
  P.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    P.createElement(
      "g",
      { fillRule: "nonzero" },
      P.createElement("path", { d: "M656.864951,142 C660.787277,142 663.969428,145.114996 663.969428,148.954545 L663.969,151 L671.701493,151 C672.970923,151 674,152.007359 674,153.25 C674,154.492641 672.970923,155.5 671.701493,155.5 L671.489,155.5 L669.442804,189.421955 C669.233347,193.112625 666.115885,196 662.339463,196 L636.660537,196 C632.884115,196 629.766653,193.112625 629.557197,189.421978 L627.51,155.5 L627.298507,155.5 C626.029077,155.5 625,154.492641 625,153.25 C625,152.007359 626.029077,151 627.298507,151 L634.193,151 L634.193309,148.954545 C634.193309,145.114996 637.37546,142 641.297787,142 L656.864951,142 Z M666.884,155.5 L632.115,155.5 L634.147133,189.17234 C634.221265,190.478568 635.324093,191.5 636.660537,191.5 L662.339463,191.5 C663.675907,191.5 664.778735,190.478568 664.852869,189.172317 L666.884,155.5 Z M649.708588,163.375 C650.537015,163.375 651.208588,164.046573 651.208588,164.875 L651.208588,182.125 C651.208588,182.953427 650.537015,183.625 649.708588,183.625 L649.289983,183.625 C648.461556,183.625 647.789983,182.953427 647.789983,182.125 L647.789983,164.875 C647.789983,164.046573 648.461556,163.375 649.289983,163.375 L649.708588,163.375 Z M658.992195,163.379048 L659.410043,163.400667 C660.237364,163.443472 660.873339,164.148848 660.830534,164.976169 C660.830348,164.979779 660.830148,164.983389 660.829935,164.986998 L659.813836,182.211291 C659.765299,183.034055 659.062028,183.663539 658.238934,183.620952 L657.821085,183.599333 C656.993765,183.556528 656.357789,182.851152 656.400594,182.023831 C656.400781,182.020221 656.400981,182.016611 656.401194,182.013002 L657.417293,164.788709 C657.465829,163.965945 658.169101,163.336461 658.992195,163.379048 Z M641.581278,164.788709 L642.597377,182.013002 C642.646163,182.839991 642.015304,183.549948 641.188315,183.598734 C641.184706,183.598946 641.181096,183.599146 641.177485,183.599333 L640.759637,183.620952 C639.936543,183.663539 639.233271,183.034055 639.184735,182.211291 L638.168636,164.986998 C638.11985,164.160009 638.750708,163.450052 639.577698,163.401266 C639.581307,163.401054 639.584917,163.400854 639.588527,163.400667 L640.006376,163.379048 C640.829469,163.336461 641.532741,163.965945 641.581278,164.788709 Z M656.966445,146.5 L641.297787,146.5 C639.914322,146.5 638.790324,147.600277 638.790324,148.954545 L638.790324,151 L659.473908,151 L659.473908,148.954545 C659.473908,147.600277 658.34991,146.5 656.966445,146.5 Z", transform: "translate(-625 -142)" })
    )
  )
);
au.displayName = "TrashCan49x54";
var Jl = Object.defineProperty, Fp = Object.defineProperties, Lp = Object.getOwnPropertyDescriptor, Ip = Object.getOwnPropertyDescriptors, $r = Object.getOwnPropertySymbols, du = Object.prototype.hasOwnProperty, uu = Object.prototype.propertyIsEnumerable, Td = (e, t, i) => t in e ? Jl(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, _ = (e, t) => {
  for (var i in t || (t = {}))
    du.call(t, i) && Td(e, i, t[i]);
  if ($r)
    for (var i of $r(t))
      uu.call(t, i) && Td(e, i, t[i]);
  return e;
}, Re = (e, t) => Fp(e, Ip(t)), Mp = (e, t) => {
  var i = {};
  for (var s in e)
    du.call(e, s) && t.indexOf(s) < 0 && (i[s] = e[s]);
  if (e != null && $r)
    for (var s of $r(e))
      t.indexOf(s) < 0 && uu.call(e, s) && (i[s] = e[s]);
  return i;
}, qe = (e, t) => {
  for (var i in t)
    Jl(e, i, { get: t[i], enumerable: !0 });
}, u = (e, t, i, s) => {
  for (var o = s > 1 ? void 0 : s ? Lp(t, i) : t, r = e.length - 1, n; r >= 0; r--)
    (n = e[r]) && (o = (s ? n(t, i, o) : n(o)) || o);
  return s && o && Jl(t, i, o), o;
}, Kt = (e, t) => (i, s) => t(i, s, e), cu = {};
qe(cu, {
  attrToBoolean: () => jr,
  attrToNumber: () => Li,
  attrToString: () => xp,
  defaultComparator: () => Np,
  exists: () => b,
  jsonEquals: () => Tl,
  makeNull: () => si,
  missing: () => z,
  missingOrEmpty: () => It,
  toStringOrNull: () => Vo,
  values: () => ss
});
function si(e) {
  return e == null || e === "" ? null : e;
}
function b(e, t = !1) {
  return e != null && (e !== "" || t);
}
function z(e) {
  return !b(e);
}
function It(e) {
  return e == null || e.length === 0;
}
function Vo(e) {
  return e != null && typeof e.toString == "function" ? e.toString() : null;
}
function Li(e) {
  if (e === void 0)
    return;
  if (e === null || e === "")
    return null;
  if (typeof e == "number")
    return isNaN(e) ? void 0 : e;
  const t = parseInt(e, 10);
  return isNaN(t) ? void 0 : t;
}
function jr(e) {
  if (e !== void 0)
    return e === null || e === "" ? !1 : typeof e == "boolean" ? e : /true/i.test(e);
}
function xp(e) {
  if (!(e == null || e === ""))
    return e;
}
function Tl(e, t) {
  const i = e ? JSON.stringify(e) : null, s = t ? JSON.stringify(t) : null;
  return i === s;
}
function Np(e, t, i = !1) {
  const s = e == null, o = t == null;
  if (e && e.toNumber && (e = e.toNumber()), t && t.toNumber && (t = t.toNumber()), s && o)
    return 0;
  if (s)
    return -1;
  if (o)
    return 1;
  function r(n, l) {
    return n > l ? 1 : n < l ? -1 : 0;
  }
  if (typeof e != "string" || !i)
    return r(e, t);
  try {
    return e.localeCompare(t);
  } catch {
    return r(e, t);
  }
}
function ss(e) {
  if (e instanceof Set || e instanceof Map) {
    const t = [];
    return e.forEach((i) => t.push(i)), t;
  }
  return Object.values(e);
}
var Gp = class {
  constructor() {
    this.existingKeys = {};
  }
  addExistingKeys(e) {
    for (let t = 0; t < e.length; t++)
      this.existingKeys[e[t]] = !0;
  }
  getUniqueKey(e, t) {
    e = Vo(e);
    let i = 0;
    for (; ; ) {
      let s;
      if (e ? (s = e, i !== 0 && (s += "_" + i)) : t ? (s = t, i !== 0 && (s += "_" + i)) : s = i, !this.existingKeys[s])
        return this.existingKeys[s] = !0, String(s);
      i++;
    }
  }
}, hu = {};
qe(hu, {
  SKIP_JS_BUILTINS: () => vn,
  cloneObject: () => ea,
  deepCloneDefinition: () => Yr,
  getAllValuesInObject: () => Ii,
  getValueUsingField: () => Us,
  isNonNullObject: () => qr,
  iterateObject: () => tt,
  mergeDeep: () => ft,
  removeAllReferences: () => pu
});
var vn = /* @__PURE__ */ new Set(["__proto__", "constructor", "prototype"]);
function tt(e, t) {
  if (e != null) {
    if (Array.isArray(e)) {
      for (let i = 0; i < e.length; i++)
        t(i.toString(), e[i]);
      return;
    }
    for (const [i, s] of Object.entries(e))
      t(i, s);
  }
}
function ea(e) {
  const t = {}, i = Object.keys(e);
  for (let s = 0; s < i.length; s++) {
    if (vn.has(i[s]))
      continue;
    const o = i[s], r = e[o];
    t[o] = r;
  }
  return t;
}
function Yr(e, t) {
  if (!e)
    return;
  const i = e, s = {};
  return Object.keys(i).forEach((o) => {
    if (t && t.indexOf(o) >= 0 || vn.has(o))
      return;
    const r = i[o];
    qr(r) && r.constructor === Object ? s[o] = Yr(r) : s[o] = r;
  }), s;
}
function Ii(e) {
  if (!e)
    return [];
  const t = Object;
  if (typeof t.values == "function")
    return t.values(e);
  const i = [];
  for (const s in e)
    e.hasOwnProperty(s) && e.propertyIsEnumerable(s) && i.push(e[s]);
  return i;
}
function ft(e, t, i = !0, s = !1) {
  b(t) && tt(t, (o, r) => {
    if (vn.has(o))
      return;
    let n = e[o];
    n !== r && (s && n == null && r != null && typeof r == "object" && r.constructor === Object && (n = {}, e[o] = n), qr(r) && qr(n) && !Array.isArray(n) ? ft(n, r, i, s) : (i || r !== void 0) && (e[o] = r));
  });
}
function Us(e, t, i) {
  if (!t || !e)
    return;
  if (!i)
    return e[t];
  const s = t.split(".");
  let o = e;
  for (let r = 0; r < s.length; r++) {
    if (o == null)
      return;
    o = o[s[r]];
  }
  return o;
}
function pu(e, t = [], i) {
  Object.keys(e).forEach((n) => {
    typeof e[n] == "object" && !t.includes(n) && (e[n] = void 0);
  });
  const s = Object.getPrototypeOf(e), o = {}, r = (n) => `AG Grid: Grid API function ${n}() cannot be called as the grid has been destroyed.
    It is recommended to remove local references to the grid api. Alternatively, check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
    To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${i}`;
  Object.getOwnPropertyNames(s).forEach((n) => {
    if (typeof s[n] == "function" && !t.includes(n)) {
      const a = () => {
        console.warn(r(n));
      };
      o[n] = { value: a, writable: !0 };
    }
  }), Object.defineProperties(e, o);
}
function qr(e) {
  return typeof e == "object" && e !== null;
}
var gu = {};
qe(gu, {
  compose: () => Op,
  debounce: () => rt,
  doOnce: () => $s,
  errorOnce: () => es,
  executeAfter: () => mu,
  executeInAWhile: () => fu,
  executeNextVMTurn: () => bl,
  getFunctionName: () => wn,
  isFunction: () => Sn,
  noop: () => _p,
  throttle: () => Al,
  waitUntil: () => ta,
  warnOnce: () => H
});
var bd = {};
function $s(e, t) {
  bd[t] || (e(), bd[t] = !0);
}
function H(e) {
  $s(() => console.warn("AG Grid: " + e), e);
}
function es(e) {
  $s(() => console.error("AG Grid: " + e), e);
}
function wn(e) {
  if (e.name)
    return e.name;
  const t = /function\s+([^\(]+)/.exec(e.toString());
  return t && t.length === 2 ? t[1].trim() : null;
}
function Sn(e) {
  return !!(e && e.constructor && e.call && e.apply);
}
function fu(e) {
  mu(e, 400);
}
var tl = [], il = !1;
function bl(e) {
  tl.push(e), !il && (il = !0, window.setTimeout(() => {
    const t = tl.slice();
    tl.length = 0, il = !1, t.forEach((i) => i());
  }, 0));
}
function mu(e, t = 0) {
  e.length > 0 && window.setTimeout(() => e.forEach((i) => i()), t);
}
function rt(e, t) {
  let i;
  return function(...s) {
    const o = this;
    window.clearTimeout(i), i = window.setTimeout(function() {
      e.apply(o, s);
    }, t);
  };
}
function Al(e, t) {
  let i = 0;
  return function(...s) {
    const o = this, r = (/* @__PURE__ */ new Date()).getTime();
    r - i < t || (i = r, e.apply(o, s));
  };
}
function ta(e, t, i = 100, s) {
  const o = (/* @__PURE__ */ new Date()).getTime();
  let r = null, n = !1;
  const l = () => {
    const a = (/* @__PURE__ */ new Date()).getTime() - o > i;
    (e() || a) && (t(), n = !0, r != null && (window.clearInterval(r), r = null), a && s && console.warn(s));
  };
  l(), n || (r = window.setInterval(l, 10));
}
function Op(...e) {
  return (t) => e.reduce((i, s) => s(i), t);
}
var _p = () => {
}, Cu = /* @__PURE__ */ ((e) => (e.CommunityCoreModule = "@ag-grid-community/core", e.InfiniteRowModelModule = "@ag-grid-community/infinite-row-model", e.ClientSideRowModelModule = "@ag-grid-community/client-side-row-model", e.CsvExportModule = "@ag-grid-community/csv-export", e.EnterpriseCoreModule = "@ag-grid-enterprise/core", e.RowGroupingModule = "@ag-grid-enterprise/row-grouping", e.ColumnsToolPanelModule = "@ag-grid-enterprise/column-tool-panel", e.FiltersToolPanelModule = "@ag-grid-enterprise/filter-tool-panel", e.MenuModule = "@ag-grid-enterprise/menu", e.SetFilterModule = "@ag-grid-enterprise/set-filter", e.MultiFilterModule = "@ag-grid-enterprise/multi-filter", e.StatusBarModule = "@ag-grid-enterprise/status-bar", e.SideBarModule = "@ag-grid-enterprise/side-bar", e.RangeSelectionModule = "@ag-grid-enterprise/range-selection", e.MasterDetailModule = "@ag-grid-enterprise/master-detail", e.RichSelectModule = "@ag-grid-enterprise/rich-select", e.GridChartsModule = "@ag-grid-enterprise/charts", e.ViewportRowModelModule = "@ag-grid-enterprise/viewport-row-model", e.ServerSideRowModelModule = "@ag-grid-enterprise/server-side-row-model", e.ExcelExportModule = "@ag-grid-enterprise/excel-export", e.ClipboardModule = "@ag-grid-enterprise/clipboard", e.SparklinesModule = "@ag-grid-enterprise/sparklines", e.AdvancedFilterModule = "@ag-grid-enterprise/advanced-filter", e.AngularModule = "@ag-grid-community/angular", e.ReactModule = "@ag-grid-community/react", e.VueModule = "@ag-grid-community/vue", e))(Cu || {}), En = class ce {
  /**
   * Globally register the given module for all grids.
   * @param module - module to register
   */
  static register(t) {
    ce.__register(t, !0, void 0);
  }
  /**
   * Globally register the given modules for all grids.
   * @param modules - modules to register
   */
  static registerModules(t) {
    ce.__registerModules(t, !0, void 0);
  }
  /** AG GRID INTERNAL - Module registration helper. */
  static __register(t, i, s) {
    ce.runVersionChecks(t), s !== void 0 ? (ce.areGridScopedModules = !0, ce.gridModulesMap[s] === void 0 && (ce.gridModulesMap[s] = {}), ce.gridModulesMap[s][t.moduleName] = t) : ce.globalModulesMap[t.moduleName] = t, ce.setModuleBased(i);
  }
  /** AG GRID INTERNAL - Unregister grid scoped module. */
  static __unRegisterGridModules(t) {
    delete ce.gridModulesMap[t];
  }
  /** AG GRID INTERNAL - Module registration helper. */
  static __registerModules(t, i, s) {
    ce.setModuleBased(i), t && t.forEach((o) => ce.__register(o, i, s));
  }
  static isValidModuleVersion(t) {
    const [i, s] = t.version.split(".") || [], [o, r] = ce.currentModuleVersion.split(".") || [];
    return i === o && s === r;
  }
  static runVersionChecks(t) {
    if (ce.currentModuleVersion || (ce.currentModuleVersion = t.version), t.version ? ce.isValidModuleVersion(t) || console.error(`AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '${t.moduleName}' is version ${t.version} but the other modules are version ${this.currentModuleVersion}. Please update all modules to the same version.`) : console.error(`AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '${t.moduleName}' is incompatible. Please update all modules to the same version.`), t.validate) {
      const i = t.validate();
      i.isValid || console.error(`AG Grid: ${i.message}`);
    }
  }
  static setModuleBased(t) {
    ce.moduleBased === void 0 ? ce.moduleBased = t : ce.moduleBased !== t && $s(
      () => {
        console.warn("AG Grid: You are mixing modules (i.e. @ag-grid-community/core) and packages (ag-grid-community) - you can only use one or the other of these mechanisms."), console.warn("Please see https://www.ag-grid.com/javascript-grid/modules/ for more information.");
      },
      "ModulePackageCheck"
    );
  }
  /**
   * AG GRID INTERNAL - Set if files are being served from a single UMD bundle to provide accurate enterprise upgrade steps.
   */
  static __setIsBundled() {
    ce.isBundled = !0;
  }
  /** AG GRID INTERNAL - Assert a given module has been register, globally or individually with this grid. */
  static __assertRegistered(t, i, s) {
    var o;
    if (this.__isRegistered(t, s))
      return !0;
    const r = i + t;
    let n;
    if (ce.isBundled)
      n = `AG Grid: unable to use ${i} as 'ag-grid-enterprise' has not been loaded. Check you are using the Enterprise bundle:
        
        <script src="https://cdn.jsdelivr.net/npm/ag-grid-enterprise@AG_GRID_VERSION/dist/ag-grid-enterprise.min.js"><\/script>
        
For more info see: https://ag-grid.com/javascript-data-grid/getting-started/#getting-started-with-ag-grid-enterprise`;
    else if (ce.moduleBased || ce.moduleBased === void 0) {
      let l = (o = Object.entries(Cu).find(([a, d]) => d === t)) == null ? void 0 : o[0];
      n = `AG Grid: unable to use ${i} as the ${l} is not registered${ce.areGridScopedModules ? ` for gridId: ${s}` : ""}. Check if you have registered the module:
           
    import { ModuleRegistry } from '@ag-grid-community/core';
    import { ${l} } from '${t}';
    
    ModuleRegistry.registerModules([ ${l} ]);

For more info see: https://www.ag-grid.com/javascript-grid/modules/`;
    } else
      n = `AG Grid: unable to use ${i} as package 'ag-grid-enterprise' has not been imported. Check that you have imported the package:
            
    import 'ag-grid-enterprise';`;
    return $s(() => {
      console.warn(n);
    }, r), !1;
  }
  /** AG GRID INTERNAL - Is the given module registered, globally or individually with this grid. */
  static __isRegistered(t, i) {
    var s;
    return !!ce.globalModulesMap[t] || !!((s = ce.gridModulesMap[i]) != null && s[t]);
  }
  /** AG GRID INTERNAL - Get all registered modules globally / individually for this grid. */
  static __getRegisteredModules(t) {
    return [...ss(ce.globalModulesMap), ...ss(ce.gridModulesMap[t] || {})];
  }
  /** AG GRID INTERNAL - Get the list of modules registered individually for this grid. */
  static __getGridRegisteredModules(t) {
    var i;
    return ss((i = ce.gridModulesMap[t]) != null ? i : {}) || [];
  }
  /** INTERNAL */
  static __isPackageBased() {
    return !ce.moduleBased;
  }
};
En.globalModulesMap = {};
En.gridModulesMap = {};
En.areGridScopedModules = !1;
var le = En, Vp = class {
  constructor(e, t) {
    if (this.beanWrappers = {}, this.destroyed = !1, !e || !e.beanClasses)
      return;
    this.contextParams = e, this.logger = t, this.logger.log(">> creating ag-Application Context"), this.createBeans();
    const i = this.getBeanInstances();
    this.wireBeans(i), this.logger.log(">> ag-Application Context ready - component is alive");
  }
  getBeanInstances() {
    return ss(this.beanWrappers).map((e) => e.beanInstance);
  }
  createBean(e, t) {
    if (!e)
      throw Error("Can't wire to bean since it is null");
    return this.wireBeans([e], t), e;
  }
  wireBeans(e, t) {
    this.autoWireBeans(e), this.methodWireBeans(e), this.callLifeCycleMethods(e, "preConstructMethods"), b(t) && e.forEach(t), this.callLifeCycleMethods(e, "postConstructMethods");
  }
  createBeans() {
    this.contextParams.beanClasses.forEach(this.createBeanWrapper.bind(this)), tt(this.beanWrappers, (t, i) => {
      let s;
      i.bean.__agBeanMetaData && i.bean.__agBeanMetaData.autowireMethods && i.bean.__agBeanMetaData.autowireMethods.agConstructor && (s = i.bean.__agBeanMetaData.autowireMethods.agConstructor);
      const o = this.getBeansForParameters(s, i.bean.name), r = new (i.bean.bind.apply(i.bean, [null, ...o]))();
      i.beanInstance = r;
    });
    const e = Object.keys(this.beanWrappers).join(", ");
    this.logger.log(`created beans: ${e}`);
  }
  // tslint:disable-next-line
  createBeanWrapper(e) {
    const t = e.__agBeanMetaData;
    if (!t) {
      let s;
      e.prototype.constructor ? s = wn(e.prototype.constructor) : s = "" + e, console.error(`Context item ${s} is not a bean`);
      return;
    }
    const i = {
      bean: e,
      beanInstance: null,
      beanName: t.beanName
    };
    this.beanWrappers[t.beanName] = i;
  }
  autoWireBeans(e) {
    e.forEach((t) => {
      this.forEachMetaDataInHierarchy(t, (i, s) => {
        const o = i.agClassAttributes;
        o && o.forEach((r) => {
          const n = this.lookupBeanInstance(s, r.beanName, r.optional);
          t[r.attributeName] = n;
        });
      });
    });
  }
  methodWireBeans(e) {
    e.forEach((t) => {
      this.forEachMetaDataInHierarchy(t, (i, s) => {
        tt(i.autowireMethods, (o, r) => {
          if (o === "agConstructor")
            return;
          const n = this.getBeansForParameters(r, s);
          t[o].apply(t, n);
        });
      });
    });
  }
  forEachMetaDataInHierarchy(e, t) {
    let i = Object.getPrototypeOf(e);
    for (; i != null; ) {
      const s = i.constructor;
      if (s.hasOwnProperty("__agBeanMetaData")) {
        const o = s.__agBeanMetaData, r = this.getBeanName(s);
        t(o, r);
      }
      i = Object.getPrototypeOf(i);
    }
  }
  getBeanName(e) {
    if (e.__agBeanMetaData && e.__agBeanMetaData.beanName)
      return e.__agBeanMetaData.beanName;
    const t = e.toString();
    return t.substring(9, t.indexOf("("));
  }
  getBeansForParameters(e, t) {
    const i = [];
    return e && tt(e, (s, o) => {
      const r = this.lookupBeanInstance(t, o);
      i[Number(s)] = r;
    }), i;
  }
  lookupBeanInstance(e, t, i = !1) {
    if (this.destroyed)
      return this.logger.log(`AG Grid: bean reference ${t} is used after the grid is destroyed!`), null;
    if (t === "context")
      return this;
    if (this.contextParams.providedBeanInstances && this.contextParams.providedBeanInstances.hasOwnProperty(t))
      return this.contextParams.providedBeanInstances[t];
    const s = this.beanWrappers[t];
    return s ? s.beanInstance : (i || console.error(`AG Grid: unable to find bean reference ${t} while initialising ${e}`), null);
  }
  callLifeCycleMethods(e, t) {
    e.forEach((i) => this.callLifeCycleMethodsOnBean(i, t));
  }
  callLifeCycleMethodsOnBean(e, t, i) {
    const s = {};
    this.forEachMetaDataInHierarchy(e, (r) => {
      const n = r[t];
      n && n.forEach((l) => {
        l != i && (s[l] = !0);
      });
    }), Object.keys(s).forEach((r) => e[r]());
  }
  getBean(e) {
    return this.lookupBeanInstance("getBean", e, !0);
  }
  destroy() {
    if (this.destroyed)
      return;
    this.destroyed = !0, this.logger.log(">> Shutting down ag-Application Context");
    const e = this.getBeanInstances();
    this.destroyBeans(e), this.contextParams.providedBeanInstances = null, le.__unRegisterGridModules(this.contextParams.gridId), this.logger.log(">> ag-Application Context shut down - component is dead");
  }
  destroyBean(e) {
    e && this.destroyBeans([e]);
  }
  destroyBeans(e) {
    return e ? (e.forEach((t) => {
      this.callLifeCycleMethodsOnBean(t, "preDestroyMethods", "destroy");
      const i = t;
      typeof i.destroy == "function" && i.destroy();
    }), []) : [];
  }
  isDestroyed() {
    return this.destroyed;
  }
  getGridId() {
    return this.contextParams.gridId;
  }
};
function vu(e, t, i) {
  const s = us(e.constructor);
  s.preConstructMethods || (s.preConstructMethods = []), s.preConstructMethods.push(t);
}
function L(e, t, i) {
  const s = us(e.constructor);
  s.postConstructMethods || (s.postConstructMethods = []), s.postConstructMethods.push(t);
}
function dt(e, t, i) {
  const s = us(e.constructor);
  s.preDestroyMethods || (s.preDestroyMethods = []), s.preDestroyMethods.push(t);
}
function O(e) {
  return (t) => {
    const i = us(t);
    i.beanName = e;
  };
}
function f(e) {
  return (t, i, s) => {
    wu(t, e, !1, t, i);
  };
}
function ue(e) {
  return (t, i, s) => {
    wu(t, e, !0, t, i);
  };
}
function wu(e, t, i, s, o, r) {
  if (t === null) {
    console.error("AG Grid: Autowired name should not be null");
    return;
  }
  const n = us(e.constructor);
  n.agClassAttributes || (n.agClassAttributes = []), n.agClassAttributes.push({
    attributeName: o,
    beanName: t,
    optional: i
  });
}
function Mt(e) {
  return (t, i, s) => {
    const o = typeof t == "function" ? t : t.constructor;
    let r;
    if (typeof s == "number") {
      let n;
      i ? (r = us(o), n = i) : (r = us(o), n = "agConstructor"), r.autowireMethods || (r.autowireMethods = {}), r.autowireMethods[n] || (r.autowireMethods[n] = {}), r.autowireMethods[n][s] = e;
    }
  };
}
function us(e) {
  return e.hasOwnProperty("__agBeanMetaData") || (e.__agBeanMetaData = {}), e.__agBeanMetaData;
}
var qt = class {
  constructor() {
    this.allSyncListeners = /* @__PURE__ */ new Map(), this.allAsyncListeners = /* @__PURE__ */ new Map(), this.globalSyncListeners = /* @__PURE__ */ new Set(), this.globalAsyncListeners = /* @__PURE__ */ new Set(), this.asyncFunctionsQueue = [], this.scheduled = !1, this.firedEvents = {};
  }
  // because this class is used both inside the context and outside the context, we do not
  // use autowired attributes, as that would be confusing, as sometimes the attributes
  // would be wired, and sometimes not.
  //
  // the global event servers used by AG Grid is autowired by the context once, and this
  // setBeans method gets called once.
  //
  // the times when this class is used outside of the context (eg RowNode has an instance of this
  // class) then it is not a bean, and this setBeans method is not called.
  setBeans(e, t, i = null, s = null) {
    if (this.frameworkOverrides = t, this.gos = e, i) {
      const o = e.useAsyncEvents();
      this.addGlobalListener(i, o);
    }
    s && this.addGlobalListener(s, !1);
  }
  setFrameworkOverrides(e) {
    this.frameworkOverrides = e;
  }
  getListeners(e, t, i) {
    const s = t ? this.allAsyncListeners : this.allSyncListeners;
    let o = s.get(e);
    return !o && i && (o = /* @__PURE__ */ new Set(), s.set(e, o)), o;
  }
  noRegisteredListenersExist() {
    return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
  }
  addEventListener(e, t, i = !1) {
    this.getListeners(e, i, !0).add(t);
  }
  removeEventListener(e, t, i = !1) {
    const s = this.getListeners(e, i, !1);
    s && (s.delete(t), s.size === 0 && (i ? this.allAsyncListeners : this.allSyncListeners).delete(e));
  }
  addGlobalListener(e, t = !1) {
    (t ? this.globalAsyncListeners : this.globalSyncListeners).add(e);
  }
  removeGlobalListener(e, t = !1) {
    (t ? this.globalAsyncListeners : this.globalSyncListeners).delete(e);
  }
  dispatchEvent(e) {
    let t = e;
    this.gos && this.gos.addGridCommonParams(t), this.dispatchToListeners(t, !0), this.dispatchToListeners(t, !1), this.firedEvents[t.type] = !0;
  }
  dispatchEventOnce(e) {
    this.firedEvents[e.type] || this.dispatchEvent(e);
  }
  dispatchToListeners(e, t) {
    var i;
    const s = e.type;
    if (t && "event" in e) {
      const a = e.event;
      a instanceof Event && (e.eventPath = a.composedPath());
    }
    const o = (a, d) => a.forEach((c) => {
      if (!d.has(c))
        return;
      const h = this.frameworkOverrides ? () => this.frameworkOverrides.wrapIncoming(() => c(e)) : () => c(e);
      t ? this.dispatchAsync(h) : h();
    }), r = (i = this.getListeners(s, t, !1)) != null ? i : /* @__PURE__ */ new Set(), n = new Set(r);
    n.size > 0 && o(n, r), new Set(t ? this.globalAsyncListeners : this.globalSyncListeners).forEach((a) => {
      const d = this.frameworkOverrides ? () => this.frameworkOverrides.wrapIncoming(() => a(s, e)) : () => a(s, e);
      t ? this.dispatchAsync(d) : d();
    });
  }
  // this gets called inside the grid's thread, for each event that it
  // wants to set async. the grid then batches the events into one setTimeout()
  // because setTimeout() is an expensive operation. ideally we would have
  // each event in it's own setTimeout(), but we batch for performance.
  dispatchAsync(e) {
    this.asyncFunctionsQueue.push(e), this.scheduled || (this.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(this.flushAsyncQueue.bind(this), 0);
    }), this.scheduled = !0);
  }
  // this happens in the next VM turn only, and empties the queue of events
  flushAsyncQueue() {
    this.scheduled = !1;
    const e = this.asyncFunctionsQueue.slice();
    this.asyncFunctionsQueue = [], e.forEach((t) => t());
  }
};
u([
  Kt(0, Mt("gridOptionsService")),
  Kt(1, Mt("frameworkOverrides")),
  Kt(2, Mt("globalEventListener")),
  Kt(3, Mt("globalSyncEventListener"))
], qt.prototype, "setBeans", 1);
qt = u([
  O("eventService")
], qt);
var ia = class {
  constructor(e) {
    this.frameworkOverrides = e, this.wrappedListeners = /* @__PURE__ */ new Map(), this.wrappedGlobalListeners = /* @__PURE__ */ new Map();
  }
  wrap(e) {
    let t = e;
    return this.frameworkOverrides.shouldWrapOutgoing && (t = (i) => {
      this.frameworkOverrides.wrapOutgoing(() => e(i));
    }, this.wrappedListeners.set(e, t)), t;
  }
  wrapGlobal(e) {
    let t = e;
    return this.frameworkOverrides.shouldWrapOutgoing && (t = (i, s) => {
      this.frameworkOverrides.wrapOutgoing(() => e(i, s));
    }, this.wrappedGlobalListeners.set(e, t)), t;
  }
  unwrap(e) {
    var t;
    return (t = this.wrappedListeners.get(e)) != null ? t : e;
  }
  unwrapGlobal(e) {
    var t;
    return (t = this.wrappedGlobalListeners.get(e)) != null ? t : e;
  }
}, Hp = {
  resizable: !0,
  sortable: !0
}, kp = 0;
function Su() {
  return kp++;
}
var Ve = class Eu {
  constructor(t, i, s, o) {
    this.instanceId = Su(), this.autoHeaderHeight = null, this.moving = !1, this.menuVisible = !1, this.lastLeftPinned = !1, this.firstRightPinned = !1, this.filterActive = !1, this.eventService = new qt(), this.tooltipEnabled = !1, this.rowGroupActive = !1, this.pivotActive = !1, this.aggregationActive = !1, this.colDef = t, this.userProvidedColDef = i, this.colId = s, this.primary = o, this.setState(t);
  }
  getInstanceId() {
    return this.instanceId;
  }
  setState(t) {
    t.sort !== void 0 ? (t.sort === "asc" || t.sort === "desc") && (this.sort = t.sort) : (t.initialSort === "asc" || t.initialSort === "desc") && (this.sort = t.initialSort);
    const i = t.sortIndex, s = t.initialSortIndex;
    i !== void 0 ? i !== null && (this.sortIndex = i) : s !== null && (this.sortIndex = s);
    const o = t.hide, r = t.initialHide;
    o !== void 0 ? this.visible = !o : this.visible = !r, t.pinned !== void 0 ? this.setPinned(t.pinned) : this.setPinned(t.initialPinned);
    const n = t.flex, l = t.initialFlex;
    n !== void 0 ? this.flex = n : l !== void 0 && (this.flex = l);
  }
  // gets called when user provides an alternative colDef, eg
  setColDef(t, i, s) {
    this.colDef = t, this.userProvidedColDef = i, this.initMinAndMaxWidths(), this.initDotNotation(), this.initTooltip(), this.eventService.dispatchEvent(this.createColumnEvent("colDefChanged", s));
  }
  /**
   * Returns the column definition provided by the application.
   * This may not be correct, as items can be superseded by default column options.
   * However it's useful for comparison, eg to know which application column definition matches that column.
   */
  getUserProvidedColDef() {
    return this.userProvidedColDef;
  }
  setParent(t) {
    this.parent = t;
  }
  /** Returns the parent column group, if column grouping is active. */
  getParent() {
    return this.parent;
  }
  setOriginalParent(t) {
    this.originalParent = t;
  }
  /**
   * Used for marryChildren, helps with comparing when duplicate groups have been created to manage split groups.
   * 
   * Parent may contain a duplicate but not identical group when the group is split.
   */
  getOriginalParent() {
    return this.originalParent;
  }
  initialise() {
    this.initMinAndMaxWidths(), this.resetActualWidth("gridInitializing"), this.initDotNotation(), this.initTooltip();
  }
  initDotNotation() {
    const t = this.gos.get("suppressFieldDotNotation");
    this.fieldContainsDots = b(this.colDef.field) && this.colDef.field.indexOf(".") >= 0 && !t, this.tooltipFieldContainsDots = b(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf(".") >= 0 && !t;
  }
  initMinAndMaxWidths() {
    var t, i;
    const s = this.colDef;
    this.minWidth = (t = s.minWidth) != null ? t : this.environment.getMinColWidth(), this.maxWidth = (i = s.maxWidth) != null ? i : Number.MAX_SAFE_INTEGER;
  }
  initTooltip() {
    this.tooltipEnabled = b(this.colDef.tooltipField) || b(this.colDef.tooltipValueGetter) || b(this.colDef.tooltipComponent);
  }
  resetActualWidth(t) {
    const i = this.calculateColInitialWidth(this.colDef);
    this.setActualWidth(i, t, !0);
  }
  calculateColInitialWidth(t) {
    var i, s;
    const o = (i = t.minWidth) != null ? i : this.environment.getMinColWidth(), r = (s = t.maxWidth) != null ? s : Number.MAX_SAFE_INTEGER;
    let n;
    const l = Li(t.width), a = Li(t.initialWidth);
    return l != null ? n = l : a != null ? n = a : n = 200, Math.max(Math.min(n, r), o);
  }
  isEmptyGroup() {
    return !1;
  }
  isRowGroupDisplayed(t) {
    if (z(this.colDef) || z(this.colDef.showRowGroup))
      return !1;
    const i = this.colDef.showRowGroup === !0, s = this.colDef.showRowGroup === t;
    return i || s;
  }
  /** Returns `true` if column is a primary column, `false` if secondary. Secondary columns are used for pivoting. */
  isPrimary() {
    return this.primary;
  }
  /** Returns `true` if column filtering is allowed. */
  isFilterAllowed() {
    return !!this.colDef.filter;
  }
  isFieldContainsDots() {
    return this.fieldContainsDots;
  }
  isTooltipEnabled() {
    return this.tooltipEnabled;
  }
  isTooltipFieldContainsDots() {
    return this.tooltipFieldContainsDots;
  }
  /** Add an event listener to the column. */
  addEventListener(t, i) {
    var s, o;
    this.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService && (this.eventService.setFrameworkOverrides(this.frameworkOverrides), this.frameworkEventListenerService = new ia(this.frameworkOverrides));
    const r = (o = (s = this.frameworkEventListenerService) == null ? void 0 : s.wrap(i)) != null ? o : i;
    this.eventService.addEventListener(t, r);
  }
  /** Remove event listener from the column. */
  removeEventListener(t, i) {
    var s, o;
    const r = (o = (s = this.frameworkEventListenerService) == null ? void 0 : s.unwrap(i)) != null ? o : i;
    this.eventService.removeEventListener(t, r);
  }
  createColumnFunctionCallbackParams(t) {
    return this.gos.addGridCommonParams({
      node: t,
      data: t.data,
      column: this,
      colDef: this.colDef
    });
  }
  isSuppressNavigable(t) {
    if (typeof this.colDef.suppressNavigable == "boolean")
      return this.colDef.suppressNavigable;
    if (typeof this.colDef.suppressNavigable == "function") {
      const i = this.createColumnFunctionCallbackParams(t), s = this.colDef.suppressNavigable;
      return s(i);
    }
    return !1;
  }
  /**
   * Returns `true` if the cell for this column is editable for the given `rowNode`, otherwise `false`.
   */
  isCellEditable(t) {
    return t.group && !this.gos.get("enableGroupEdit") ? !1 : this.isColumnFunc(t, this.colDef.editable);
  }
  isSuppressFillHandle() {
    return !!this.colDef.suppressFillHandle;
  }
  isAutoHeight() {
    return !!this.colDef.autoHeight;
  }
  isAutoHeaderHeight() {
    return !!this.colDef.autoHeaderHeight;
  }
  isRowDrag(t) {
    return this.isColumnFunc(t, this.colDef.rowDrag);
  }
  isDndSource(t) {
    return this.isColumnFunc(t, this.colDef.dndSource);
  }
  isCellCheckboxSelection(t) {
    return this.isColumnFunc(t, this.colDef.checkboxSelection);
  }
  isSuppressPaste(t) {
    return this.isColumnFunc(t, this.colDef ? this.colDef.suppressPaste : null);
  }
  isResizable() {
    return !!this.getColDefValue("resizable");
  }
  /** Get value from ColDef or default if it exists. */
  getColDefValue(t) {
    var i;
    return (i = this.colDef[t]) != null ? i : Hp[t];
  }
  isColumnFunc(t, i) {
    if (typeof i == "boolean")
      return i;
    if (typeof i == "function") {
      const s = this.createColumnFunctionCallbackParams(t);
      return i(s);
    }
    return !1;
  }
  setMoving(t, i) {
    this.moving = t, this.eventService.dispatchEvent(this.createColumnEvent("movingChanged", i));
  }
  createColumnEvent(t, i) {
    return this.gos.addGridCommonParams({
      type: t,
      column: this,
      columns: [this],
      source: i
    });
  }
  isMoving() {
    return this.moving;
  }
  /** If sorting is active, returns the sort direction e.g. `'asc'` or `'desc'`. */
  getSort() {
    return this.sort;
  }
  setSort(t, i) {
    this.sort !== t && (this.sort = t, this.eventService.dispatchEvent(this.createColumnEvent("sortChanged", i))), this.dispatchStateUpdatedEvent("sort");
  }
  setMenuVisible(t, i) {
    this.menuVisible !== t && (this.menuVisible = t, this.eventService.dispatchEvent(this.createColumnEvent("menuVisibleChanged", i)));
  }
  isMenuVisible() {
    return this.menuVisible;
  }
  isSortable() {
    return !!this.getColDefValue("sortable");
  }
  isSortAscending() {
    return this.sort === "asc";
  }
  isSortDescending() {
    return this.sort === "desc";
  }
  isSortNone() {
    return z(this.sort);
  }
  isSorting() {
    return b(this.sort);
  }
  getSortIndex() {
    return this.sortIndex;
  }
  setSortIndex(t) {
    this.sortIndex = t, this.dispatchStateUpdatedEvent("sortIndex");
  }
  setAggFunc(t) {
    this.aggFunc = t, this.dispatchStateUpdatedEvent("aggFunc");
  }
  /** If aggregation is set for the column, returns the aggregation function. */
  getAggFunc() {
    return this.aggFunc;
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  getRight() {
    return this.left + this.actualWidth;
  }
  setLeft(t, i) {
    this.oldLeft = this.left, this.left !== t && (this.left = t, this.eventService.dispatchEvent(this.createColumnEvent("leftChanged", i)));
  }
  /** Returns `true` if filter is active on the column. */
  isFilterActive() {
    return this.filterActive;
  }
  // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
  setFilterActive(t, i, s) {
    this.filterActive !== t && (this.filterActive = t, this.eventService.dispatchEvent(this.createColumnEvent("filterActiveChanged", i)));
    const o = this.createColumnEvent("filterChanged", i);
    s && ft(o, s), this.eventService.dispatchEvent(o);
  }
  /** Returns `true` when this `Column` is hovered, otherwise `false` */
  isHovered() {
    return this.columnHoverService.isHovered(this);
  }
  setPinned(t) {
    t === !0 || t === "left" ? this.pinned = "left" : t === "right" ? this.pinned = "right" : this.pinned = null, this.dispatchStateUpdatedEvent("pinned");
  }
  setFirstRightPinned(t, i) {
    this.firstRightPinned !== t && (this.firstRightPinned = t, this.eventService.dispatchEvent(this.createColumnEvent("firstRightPinnedChanged", i)));
  }
  setLastLeftPinned(t, i) {
    this.lastLeftPinned !== t && (this.lastLeftPinned = t, this.eventService.dispatchEvent(this.createColumnEvent("lastLeftPinnedChanged", i)));
  }
  isFirstRightPinned() {
    return this.firstRightPinned;
  }
  isLastLeftPinned() {
    return this.lastLeftPinned;
  }
  isPinned() {
    return this.pinned === "left" || this.pinned === "right";
  }
  isPinnedLeft() {
    return this.pinned === "left";
  }
  isPinnedRight() {
    return this.pinned === "right";
  }
  getPinned() {
    return this.pinned;
  }
  setVisible(t, i) {
    const s = t === !0;
    this.visible !== s && (this.visible = s, this.eventService.dispatchEvent(this.createColumnEvent("visibleChanged", i))), this.dispatchStateUpdatedEvent("hide");
  }
  isVisible() {
    return this.visible;
  }
  isSpanHeaderHeight() {
    const t = this.getColDef();
    return !t.suppressSpanHeaderHeight && !t.autoHeaderHeight;
  }
  getColumnGroupPaddingInfo() {
    let t = this.getParent();
    if (!t || !t.isPadding())
      return { numberOfParents: 0, isSpanningTotal: !1 };
    const i = t.getPaddingLevel() + 1;
    let s = !0;
    for (; t; ) {
      if (!t.isPadding()) {
        s = !1;
        break;
      }
      t = t.getParent();
    }
    return { numberOfParents: i, isSpanningTotal: s };
  }
  /** Returns the column definition for this column.
   * The column definition will be the result of merging the application provided column definition with any provided defaults
   * (e.g. `defaultColDef` grid option, or column types.
   *
   * Equivalent: `getDefinition` */
  getColDef() {
    return this.colDef;
  }
  getColumnGroupShow() {
    return this.colDef.columnGroupShow;
  }
  /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getId`, `getUniqueId` */
  getColId() {
    return this.colId;
  }
  /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getColId`, `getUniqueId` */
  getId() {
    return this.colId;
  }
  /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getColId`, `getId` */
  getUniqueId() {
    return this.colId;
  }
  getDefinition() {
    return this.colDef;
  }
  /** Returns the current width of the column. If the column is resized, the actual width is the new size. */
  getActualWidth() {
    return this.actualWidth;
  }
  getAutoHeaderHeight() {
    return this.autoHeaderHeight;
  }
  /** Returns true if the header height has changed */
  setAutoHeaderHeight(t) {
    const i = t !== this.autoHeaderHeight;
    return this.autoHeaderHeight = t, i;
  }
  createBaseColDefParams(t) {
    return this.gos.addGridCommonParams({
      node: t,
      data: t.data,
      colDef: this.colDef,
      column: this
    });
  }
  getColSpan(t) {
    if (z(this.colDef.colSpan))
      return 1;
    const i = this.createBaseColDefParams(t), s = this.colDef.colSpan(i);
    return Math.max(s, 1);
  }
  getRowSpan(t) {
    if (z(this.colDef.rowSpan))
      return 1;
    const i = this.createBaseColDefParams(t), s = this.colDef.rowSpan(i);
    return Math.max(s, 1);
  }
  setActualWidth(t, i, s = !1) {
    this.minWidth != null && (t = Math.max(t, this.minWidth)), this.maxWidth != null && (t = Math.min(t, this.maxWidth)), this.actualWidth !== t && (this.actualWidth = t, this.flex && i !== "flex" && i !== "gridInitializing" && (this.flex = null), s || this.fireColumnWidthChangedEvent(i)), this.dispatchStateUpdatedEvent("width");
  }
  fireColumnWidthChangedEvent(t) {
    this.eventService.dispatchEvent(this.createColumnEvent("widthChanged", t));
  }
  isGreaterThanMax(t) {
    return this.maxWidth != null ? t > this.maxWidth : !1;
  }
  getMinWidth() {
    return this.minWidth;
  }
  getMaxWidth() {
    return this.maxWidth;
  }
  getFlex() {
    return this.flex || 0;
  }
  // this method should only be used by the columnModel to
  // change flex when required by the applyColumnState method.
  setFlex(t) {
    this.flex !== t && (this.flex = t), this.dispatchStateUpdatedEvent("flex");
  }
  setMinimum(t) {
    b(this.minWidth) && this.setActualWidth(this.minWidth, t);
  }
  setRowGroupActive(t, i) {
    this.rowGroupActive !== t && (this.rowGroupActive = t, this.eventService.dispatchEvent(this.createColumnEvent("columnRowGroupChanged", i))), this.dispatchStateUpdatedEvent("rowGroup");
  }
  /** Returns `true` if row group is currently active for this column. */
  isRowGroupActive() {
    return this.rowGroupActive;
  }
  setPivotActive(t, i) {
    this.pivotActive !== t && (this.pivotActive = t, this.eventService.dispatchEvent(this.createColumnEvent("columnPivotChanged", i))), this.dispatchStateUpdatedEvent("pivot");
  }
  /** Returns `true` if pivot is currently active for this column. */
  isPivotActive() {
    return this.pivotActive;
  }
  isAnyFunctionActive() {
    return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
  }
  isAnyFunctionAllowed() {
    return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
  }
  setValueActive(t, i) {
    this.aggregationActive !== t && (this.aggregationActive = t, this.eventService.dispatchEvent(this.createColumnEvent("columnValueChanged", i)));
  }
  /** Returns `true` if value (aggregation) is currently active for this column. */
  isValueActive() {
    return this.aggregationActive;
  }
  isAllowPivot() {
    return this.colDef.enablePivot === !0;
  }
  isAllowValue() {
    return this.colDef.enableValue === !0;
  }
  isAllowRowGroup() {
    return this.colDef.enableRowGroup === !0;
  }
  /**
   * @deprecated v31.1 Use `getColDef().menuTabs ?? defaultValues` instead.
   */
  getMenuTabs(t) {
    H("As of v31.1, 'getMenuTabs' is deprecated. Use 'getColDef().menuTabs ?? defaultValues' instead.");
    let i = this.getColDef().menuTabs;
    return i == null && (i = t), i;
  }
  dispatchStateUpdatedEvent(t) {
    this.eventService.dispatchEvent({
      type: Eu.EVENT_STATE_UPDATED,
      key: t
    });
  }
};
Ve.EVENT_MOVING_CHANGED = "movingChanged";
Ve.EVENT_LEFT_CHANGED = "leftChanged";
Ve.EVENT_WIDTH_CHANGED = "widthChanged";
Ve.EVENT_LAST_LEFT_PINNED_CHANGED = "lastLeftPinnedChanged";
Ve.EVENT_FIRST_RIGHT_PINNED_CHANGED = "firstRightPinnedChanged";
Ve.EVENT_VISIBLE_CHANGED = "visibleChanged";
Ve.EVENT_FILTER_CHANGED = "filterChanged";
Ve.EVENT_FILTER_ACTIVE_CHANGED = "filterActiveChanged";
Ve.EVENT_SORT_CHANGED = "sortChanged";
Ve.EVENT_COL_DEF_CHANGED = "colDefChanged";
Ve.EVENT_MENU_VISIBLE_CHANGED = "menuVisibleChanged";
Ve.EVENT_ROW_GROUP_CHANGED = "columnRowGroupChanged";
Ve.EVENT_PIVOT_CHANGED = "columnPivotChanged";
Ve.EVENT_VALUE_CHANGED = "columnValueChanged";
Ve.EVENT_STATE_UPDATED = "columnStateUpdated";
u([
  f("gridOptionsService")
], Ve.prototype, "gos", 2);
u([
  f("environment")
], Ve.prototype, "environment", 2);
u([
  f("columnHoverService")
], Ve.prototype, "columnHoverService", 2);
u([
  f("frameworkOverrides")
], Ve.prototype, "frameworkOverrides", 2);
u([
  L
], Ve.prototype, "initialise", 1);
var pe = Ve, yn = class Po {
  constructor(t, i, s, o) {
    this.localEventService = new qt(), this.expandable = !1, this.instanceId = Su(), this.expandableListenerRemoveCallback = null, this.colGroupDef = t, this.groupId = i, this.expanded = !!t && !!t.openByDefault, this.padding = s, this.level = o;
  }
  destroy() {
    this.expandableListenerRemoveCallback && this.reset(null, void 0);
  }
  reset(t, i) {
    this.colGroupDef = t, this.level = i, this.originalParent = null, this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback(), this.children = void 0, this.expandable = void 0;
  }
  getInstanceId() {
    return this.instanceId;
  }
  setOriginalParent(t) {
    this.originalParent = t;
  }
  getOriginalParent() {
    return this.originalParent;
  }
  getLevel() {
    return this.level;
  }
  isVisible() {
    return this.children ? this.children.some((t) => t.isVisible()) : !1;
  }
  isPadding() {
    return this.padding;
  }
  setExpanded(t) {
    this.expanded = t === void 0 ? !1 : t;
    const i = {
      type: Po.EVENT_EXPANDED_CHANGED
    };
    this.localEventService.dispatchEvent(i);
  }
  isExpandable() {
    return this.expandable;
  }
  isExpanded() {
    return this.expanded;
  }
  getGroupId() {
    return this.groupId;
  }
  getId() {
    return this.getGroupId();
  }
  setChildren(t) {
    this.children = t;
  }
  getChildren() {
    return this.children;
  }
  getColGroupDef() {
    return this.colGroupDef;
  }
  getLeafColumns() {
    const t = [];
    return this.addLeafColumns(t), t;
  }
  addLeafColumns(t) {
    this.children && this.children.forEach((i) => {
      i instanceof pe ? t.push(i) : i instanceof Po && i.addLeafColumns(t);
    });
  }
  getColumnGroupShow() {
    const t = this.colGroupDef;
    if (t)
      return t.columnGroupShow;
  }
  // need to check that this group has at least one col showing when both expanded and contracted.
  // if not, then we don't allow expanding and contracting on this group
  setupExpandable() {
    this.setExpandable(), this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback();
    const t = this.onColumnVisibilityChanged.bind(this);
    this.getLeafColumns().forEach((i) => i.addEventListener("visibleChanged", t)), this.expandableListenerRemoveCallback = () => {
      this.getLeafColumns().forEach((i) => i.removeEventListener("visibleChanged", t)), this.expandableListenerRemoveCallback = null;
    };
  }
  setExpandable() {
    if (this.isPadding())
      return;
    let t = !1, i = !1, s = !1;
    const o = this.findChildrenRemovingPadding();
    for (let n = 0, l = o.length; n < l; n++) {
      const a = o[n];
      if (!a.isVisible())
        continue;
      const d = a.getColumnGroupShow();
      d === "open" ? (t = !0, s = !0) : d === "closed" ? (i = !0, s = !0) : (t = !0, i = !0);
    }
    const r = t && i && s;
    if (this.expandable !== r) {
      this.expandable = r;
      const n = {
        type: Po.EVENT_EXPANDABLE_CHANGED
      };
      this.localEventService.dispatchEvent(n);
    }
  }
  findChildrenRemovingPadding() {
    const t = [], i = (s) => {
      s.forEach((o) => {
        o instanceof Po && o.isPadding() ? i(o.children) : t.push(o);
      });
    };
    return i(this.children), t;
  }
  onColumnVisibilityChanged() {
    this.setExpandable();
  }
  addEventListener(t, i) {
    this.localEventService.addEventListener(t, i);
  }
  removeEventListener(t, i) {
    this.localEventService.removeEventListener(t, i);
  }
};
yn.EVENT_EXPANDED_CHANGED = "expandedChanged";
yn.EVENT_EXPANDABLE_CHANGED = "expandableChanged";
u([
  dt
], yn.prototype, "destroy", 1);
var Ge = yn, Bp = {
  numericColumn: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  },
  rightAligned: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  }
}, yu = {};
qe(yu, {
  addSafePassiveEventListener: () => Mu,
  createEventPath: () => Lu,
  getCtrlForEventTarget: () => Qr,
  getEventPath: () => Iu,
  isElementInEventPath: () => Xr,
  isEventSupported: () => oa,
  isStopPropagationForAgGrid: () => Yt,
  stopPropagationForAgGrid: () => Qt
});
var Ru = {};
qe(Ru, {
  areEqual: () => ii,
  existsAndNotEmpty: () => Du,
  flatten: () => Pu,
  forEachReverse: () => Kp,
  includes: () => Tt,
  insertArrayIntoArray: () => Pl,
  insertIntoArray: () => Ho,
  last: () => se,
  moveInArray: () => Fl,
  pushAll: () => Ll,
  removeAllFromArray: () => Au,
  removeAllFromUnorderedArray: () => bu,
  removeFromArray: () => gt,
  removeFromUnorderedArray: () => sa,
  removeRepeatsFromArray: () => Up,
  shallowCompare: () => Wp,
  sortNumerically: () => Tu,
  toStrings: () => zp
});
function Du(e) {
  return e != null && e.length > 0;
}
function se(e) {
  if (!(!e || !e.length))
    return e[e.length - 1];
}
function ii(e, t, i) {
  return e == null && t == null ? !0 : e != null && t != null && e.length === t.length && e.every((s, o) => i ? i(s, t[o]) : t[o] === s);
}
function Wp(e, t) {
  return ii(e, t);
}
function Tu(e) {
  return e.sort((t, i) => t - i);
}
function Up(e, t) {
  if (e)
    for (let i = e.length - 2; i >= 0; i--) {
      const s = e[i] === t, o = e[i + 1] === t;
      s && o && e.splice(i + 1, 1);
    }
}
function sa(e, t) {
  const i = e.indexOf(t);
  i >= 0 && (e[i] = e[e.length - 1], e.pop());
}
function gt(e, t) {
  const i = e.indexOf(t);
  i >= 0 && e.splice(i, 1);
}
function bu(e, t) {
  for (let i = 0; i < t.length; i++)
    sa(e, t[i]);
}
function Au(e, t) {
  for (let i = 0; i < t.length; i++)
    gt(e, t[i]);
}
function Ho(e, t, i) {
  e.splice(i, 0, t);
}
function Pl(e, t, i) {
  if (!(e == null || t == null))
    for (let s = t.length - 1; s >= 0; s--) {
      const o = t[s];
      Ho(e, o, i);
    }
}
function Fl(e, t, i) {
  Au(e, t), t.slice().reverse().forEach((s) => Ho(e, s, i));
}
function Tt(e, t) {
  return e.indexOf(t) > -1;
}
function Pu(e) {
  return [].concat.apply([], e);
}
function Ll(e, t) {
  t == null || e == null || t.forEach((i) => e.push(i));
}
function zp(e) {
  return e.map(Vo);
}
function Kp(e, t) {
  if (e != null)
    for (let i = e.length - 1; i >= 0; i--)
      t(e[i], i);
}
var Fu = "__ag_Grid_Stop_Propagation", $p = ["touchstart", "touchend", "touchmove", "touchcancel", "scroll"], sl = {};
function Qt(e) {
  e[Fu] = !0;
}
function Yt(e) {
  return e[Fu] === !0;
}
var oa = /* @__PURE__ */ (() => {
  const e = {
    select: "input",
    change: "input",
    submit: "form",
    reset: "form",
    error: "img",
    load: "img",
    abort: "img"
  };
  return (i) => {
    if (typeof sl[i] == "boolean")
      return sl[i];
    const s = document.createElement(e[i] || "div");
    return i = "on" + i, sl[i] = i in s;
  };
})();
function Qr(e, t, i) {
  let s = t;
  for (; s; ) {
    const o = e.getDomData(s, i);
    if (o)
      return o;
    s = s.parentElement;
  }
  return null;
}
function Xr(e, t) {
  return !t || !e ? !1 : Iu(t).indexOf(e) >= 0;
}
function Lu(e) {
  const t = [];
  let i = e.target;
  for (; i; )
    t.push(i), i = i.parentElement;
  return t;
}
function Iu(e) {
  const t = e;
  return t.path ? t.path : t.composedPath ? t.composedPath() : Lu(t);
}
function Mu(e, t, i, s) {
  const r = Tt($p, i) ? { passive: !0 } : void 0;
  e && e.addEventListener && e.addEventListener(t, i, s, r);
}
var Ci = class xu {
  constructor() {
    this.destroyFunctions = [], this.destroyed = !1, this.__v_skip = !0, this.lastChangeSetIdLookup = {}, this.propertyListenerId = 0, this.isAlive = () => !this.destroyed;
  }
  // CellComp and GridComp and override this because they get the FrameworkOverrides from the Beans bean
  getFrameworkOverrides() {
    return this.frameworkOverrides;
  }
  getContext() {
    return this.context;
  }
  destroy() {
    for (let t = 0; t < this.destroyFunctions.length; t++)
      this.destroyFunctions[t]();
    this.destroyFunctions.length = 0, this.destroyed = !0, this.dispatchEvent({ type: xu.EVENT_DESTROYED });
  }
  addEventListener(t, i) {
    this.localEventService || (this.localEventService = new qt()), this.localEventService.addEventListener(t, i);
  }
  removeEventListener(t, i) {
    this.localEventService && this.localEventService.removeEventListener(t, i);
  }
  dispatchEvent(t) {
    this.localEventService && this.localEventService.dispatchEvent(t);
  }
  addManagedListener(t, i, s) {
    if (this.destroyed)
      return;
    t instanceof HTMLElement ? Mu(this.getFrameworkOverrides(), t, i, s) : t.addEventListener(i, s);
    const o = () => (t.removeEventListener(i, s), null);
    return this.destroyFunctions.push(o), () => (o(), this.destroyFunctions = this.destroyFunctions.filter((r) => r !== o), null);
  }
  setupGridOptionListener(t, i) {
    this.gos.addEventListener(t, i);
    const s = () => (this.gos.removeEventListener(t, i), null);
    return this.destroyFunctions.push(s), () => (s(), this.destroyFunctions = this.destroyFunctions.filter((o) => o !== s), null);
  }
  /**
   * Setup a managed property listener for the given GridOption property.
   * @param event GridOption property to listen to changes for.
   * @param listener Listener to run when property value changes
   */
  addManagedPropertyListener(t, i) {
    return this.destroyed ? () => null : this.setupGridOptionListener(t, i);
  }
  /**
   * Setup managed property listeners for the given set of GridOption properties.
   * The listener will be run if any of the property changes but will only run once if
   * multiple of the properties change within the same framework lifecycle event.
   * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
   * @param events Array of GridOption properties to listen for changes too.
   * @param listener Shared listener to run if any of the properties change
   */
  addManagedPropertyListeners(t, i) {
    if (this.destroyed)
      return;
    const s = t.join("-") + this.propertyListenerId++, o = (r) => {
      if (r.changeSet) {
        if (r.changeSet && r.changeSet.id === this.lastChangeSetIdLookup[s])
          return;
        this.lastChangeSetIdLookup[s] = r.changeSet.id;
      }
      const n = {
        type: "gridPropertyChanged",
        changeSet: r.changeSet,
        source: r.source
      };
      i(n);
    };
    t.forEach((r) => this.setupGridOptionListener(r, o));
  }
  addDestroyFunc(t) {
    this.isAlive() ? this.destroyFunctions.push(t) : t();
  }
  createManagedBean(t, i) {
    const s = this.createBean(t, i);
    return this.addDestroyFunc(this.destroyBean.bind(this, t, i)), s;
  }
  createBean(t, i, s) {
    return (i || this.getContext()).createBean(t, s);
  }
  destroyBean(t, i) {
    return (i || this.getContext()).destroyBean(t);
  }
  destroyBeans(t, i) {
    if (t)
      for (let s = 0; s < t.length; s++)
        this.destroyBean(t[s], i);
    return [];
  }
};
Ci.EVENT_DESTROYED = "destroyed";
u([
  f("frameworkOverrides")
], Ci.prototype, "frameworkOverrides", 2);
u([
  f("context")
], Ci.prototype, "context", 2);
u([
  f("eventService")
], Ci.prototype, "eventService", 2);
u([
  f("gridOptionsService")
], Ci.prototype, "gos", 2);
u([
  f("localeService")
], Ci.prototype, "localeService", 2);
u([
  f("environment")
], Ci.prototype, "environment", 2);
u([
  dt
], Ci.prototype, "destroy", 1);
var F = Ci, ko = class extends F {
  setBeans(e) {
    this.logger = e.create("ColumnFactory");
  }
  createColumnTree(e, t, i, s) {
    const o = new Gp(), { existingCols: r, existingGroups: n, existingColKeys: l } = this.extractExistingTreeData(i);
    o.addExistingKeys(l);
    const a = this.recursivelyCreateColumns(
      e,
      0,
      t,
      r,
      o,
      n,
      s
    ), d = this.findMaxDept(a, 0);
    this.logger.log("Number of levels for grouped columns is " + d);
    const c = this.balanceColumnTree(a, 0, d, o);
    return hi(null, c, (g, m) => {
      g instanceof Ge && g.setupExpandable(), g.setOriginalParent(m);
    }), {
      columnTree: c,
      treeDept: d
    };
  }
  extractExistingTreeData(e) {
    const t = [], i = [], s = [];
    return e && hi(null, e, (o) => {
      if (o instanceof Ge) {
        const r = o;
        i.push(r);
      } else {
        const r = o;
        s.push(r.getId()), t.push(r);
      }
    }), { existingCols: t, existingGroups: i, existingColKeys: s };
  }
  createForAutoGroups(e, t) {
    return e.map((i) => this.createAutoGroupTreeItem(t, i));
  }
  createAutoGroupTreeItem(e, t) {
    const i = this.findDepth(e);
    let s = t;
    for (let o = i - 1; o >= 0; o--) {
      const r = new Ge(
        null,
        `FAKE_PATH_${t.getId()}}_${o}`,
        !0,
        o
      );
      this.createBean(r), r.setChildren([s]), s.setOriginalParent(r), s = r;
    }
    return i === 0 && t.setOriginalParent(null), s;
  }
  findDepth(e) {
    let t = 0, i = e;
    for (; i && i[0] && i[0] instanceof Ge; )
      t++, i = i[0].getChildren();
    return t;
  }
  balanceColumnTree(e, t, i, s) {
    const o = [];
    for (let r = 0; r < e.length; r++) {
      const n = e[r];
      if (n instanceof Ge) {
        const l = n, a = this.balanceColumnTree(
          l.getChildren(),
          t + 1,
          i,
          s
        );
        l.setChildren(a), o.push(l);
      } else {
        let l, a;
        for (let d = i - 1; d >= t; d--) {
          const c = s.getUniqueKey(null, null), h = this.createMergedColGroupDef(null), g = new Ge(h, c, !0, t);
          this.createBean(g), a && a.setChildren([g]), a = g, l || (l = a);
        }
        if (l && a)
          if (o.push(l), e.some((c) => c instanceof Ge)) {
            a.setChildren([n]);
            continue;
          } else {
            a.setChildren(e);
            break;
          }
        o.push(n);
      }
    }
    return o;
  }
  findMaxDept(e, t) {
    let i = t;
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      if (o instanceof Ge) {
        const r = o, n = this.findMaxDept(r.getChildren(), t + 1);
        i < n && (i = n);
      }
    }
    return i;
  }
  recursivelyCreateColumns(e, t, i, s, o, r, n) {
    if (!e)
      return [];
    const l = new Array(e.length);
    for (let a = 0; a < l.length; a++) {
      const d = e[a];
      this.isColumnGroup(d) ? l[a] = this.createColumnGroup(
        i,
        d,
        t,
        s,
        o,
        r,
        n
      ) : l[a] = this.createColumn(i, d, s, o, n);
    }
    return l;
  }
  createColumnGroup(e, t, i, s, o, r, n) {
    const l = this.createMergedColGroupDef(t), a = o.getUniqueKey(l.groupId || null, null), d = new Ge(l, a, !1, i);
    this.createBean(d);
    const c = this.findExistingGroup(t, r);
    c && r.splice(c.idx, 1);
    let h = c == null ? void 0 : c.group;
    h && d.setExpanded(h.isExpanded());
    const g = this.recursivelyCreateColumns(
      l.children,
      i + 1,
      e,
      s,
      o,
      r,
      n
    );
    return d.setChildren(g), d;
  }
  createMergedColGroupDef(e) {
    const t = {};
    return Object.assign(t, this.gos.get("defaultColGroupDef")), Object.assign(t, e), t;
  }
  createColumn(e, t, i, s, o) {
    const r = this.findExistingColumn(t, i);
    r && (i == null || i.splice(r.idx, 1));
    let n = r == null ? void 0 : r.column;
    if (n) {
      const l = this.addColumnDefaultAndTypes(t, n.getColId());
      n.setColDef(l, t, o), this.applyColumnState(n, l, o);
    } else {
      const l = s.getUniqueKey(t.colId, t.field), a = this.addColumnDefaultAndTypes(t, l);
      n = new pe(a, t, l, e), this.context.createBean(n);
    }
    return this.dataTypeService.addColumnListeners(n), n;
  }
  applyColumnState(e, t, i) {
    const s = Li(t.flex);
    if (s !== void 0 && e.setFlex(s), e.getFlex() <= 0) {
      const l = Li(t.width);
      if (l != null)
        e.setActualWidth(l, i);
      else {
        const a = e.getActualWidth();
        e.setActualWidth(a, i);
      }
    }
    t.sort !== void 0 && (t.sort == "asc" || t.sort == "desc" ? e.setSort(t.sort, i) : e.setSort(void 0, i));
    const r = Li(t.sortIndex);
    r !== void 0 && e.setSortIndex(r);
    const n = jr(t.hide);
    n !== void 0 && e.setVisible(!n, i), t.pinned !== void 0 && e.setPinned(t.pinned);
  }
  findExistingColumn(e, t) {
    if (t)
      for (let i = 0; i < t.length; i++) {
        const s = t[i].getUserProvidedColDef();
        if (!s)
          continue;
        if (e.colId != null) {
          if (t[i].getId() === e.colId)
            return { idx: i, column: t[i] };
          continue;
        }
        if (e.field != null) {
          if (s.field === e.field)
            return { idx: i, column: t[i] };
          continue;
        }
        if (s === e)
          return { idx: i, column: t[i] };
      }
  }
  findExistingGroup(e, t) {
    if (e.groupId != null)
      for (let s = 0; s < t.length; s++) {
        const o = t[s];
        if (o.getColGroupDef() && o.getId() === e.groupId)
          return { idx: s, group: o };
      }
  }
  addColumnDefaultAndTypes(e, t) {
    const i = {}, s = this.gos.get("defaultColDef");
    ft(i, s, !1, !0);
    const o = this.dataTypeService.updateColDefAndGetColumnType(i, e, t);
    o && this.assignColumnTypes(o, i), ft(i, e, !1, !0);
    const r = this.gos.get("autoGroupColumnDef"), n = this.gos.isColumnsSortingCoupledToGroup();
    return e.rowGroup && r && n && ft(i, { sort: r.sort, initialSort: r.initialSort }, !1, !0), this.dataTypeService.validateColDef(i), i;
  }
  assignColumnTypes(e, t) {
    if (!e.length)
      return;
    const i = Object.assign({}, Bp), s = this.gos.get("columnTypes") || {};
    tt(s, (o, r) => {
      o in i ? console.warn(`AG Grid: the column type '${o}' is a default column type and cannot be overridden.`) : (r.type && H("Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type."), i[o] = r);
    }), e.forEach((o) => {
      const r = i[o.trim()];
      r ? ft(t, r, !1, !0) : console.warn("AG Grid: colDef.type '" + o + "' does not correspond to defined gridOptions.columnTypes");
    });
  }
  // if object has children, we assume it's a group
  isColumnGroup(e) {
    return e.children !== void 0;
  }
};
u([
  f("dataTypeService")
], ko.prototype, "dataTypeService", 2);
u([
  Kt(0, Mt("loggerFactory"))
], ko.prototype, "setBeans", 1);
ko = u([
  O("columnFactory")
], ko);
function hi(e, t, i) {
  if (t)
    for (let s = 0; s < t.length; s++) {
      const o = t[s];
      o instanceof Ge && hi(o, o.getChildren(), i), i(o, e);
    }
}
var Rn = class ei {
  constructor(t, i, s, o) {
    this.displayedChildren = [], this.localEventService = new qt(), this.groupId = i, this.partId = s, this.providedColumnGroup = t, this.pinned = o;
  }
  // this is static, a it is used outside of this class
  static createUniqueId(t, i) {
    return t + "_" + i;
  }
  // as the user is adding and removing columns, the groups are recalculated.
  // this reset clears out all children, ready for children to be added again
  reset() {
    this.parent = null, this.children = null, this.displayedChildren = null;
  }
  getParent() {
    return this.parent;
  }
  setParent(t) {
    this.parent = t;
  }
  getUniqueId() {
    return ei.createUniqueId(this.groupId, this.partId);
  }
  isEmptyGroup() {
    return this.displayedChildren.length === 0;
  }
  isMoving() {
    const t = this.getProvidedColumnGroup().getLeafColumns();
    return !t || t.length === 0 ? !1 : t.every((i) => i.isMoving());
  }
  checkLeft() {
    if (this.displayedChildren.forEach((t) => {
      t instanceof ei && t.checkLeft();
    }), this.displayedChildren.length > 0)
      if (this.gos.get("enableRtl")) {
        const i = se(this.displayedChildren).getLeft();
        this.setLeft(i);
      } else {
        const t = this.displayedChildren[0].getLeft();
        this.setLeft(t);
      }
    else
      this.setLeft(null);
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  setLeft(t) {
    this.oldLeft = this.left, this.left !== t && (this.left = t, this.localEventService.dispatchEvent(this.createAgEvent(ei.EVENT_LEFT_CHANGED)));
  }
  getPinned() {
    return this.pinned;
  }
  createAgEvent(t) {
    return { type: t };
  }
  addEventListener(t, i) {
    this.localEventService.addEventListener(t, i);
  }
  removeEventListener(t, i) {
    this.localEventService.removeEventListener(t, i);
  }
  getGroupId() {
    return this.groupId;
  }
  getPartId() {
    return this.partId;
  }
  isChildInThisGroupDeepSearch(t) {
    let i = !1;
    return this.children.forEach((s) => {
      t === s && (i = !0), s instanceof ei && s.isChildInThisGroupDeepSearch(t) && (i = !0);
    }), i;
  }
  getActualWidth() {
    let t = 0;
    return this.displayedChildren && this.displayedChildren.forEach((i) => {
      t += i.getActualWidth();
    }), t;
  }
  isResizable() {
    if (!this.displayedChildren)
      return !1;
    let t = !1;
    return this.displayedChildren.forEach((i) => {
      i.isResizable() && (t = !0);
    }), t;
  }
  getMinWidth() {
    let t = 0;
    return this.displayedChildren.forEach((i) => {
      t += i.getMinWidth() || 0;
    }), t;
  }
  addChild(t) {
    this.children || (this.children = []), this.children.push(t);
  }
  getDisplayedChildren() {
    return this.displayedChildren;
  }
  getLeafColumns() {
    const t = [];
    return this.addLeafColumns(t), t;
  }
  getDisplayedLeafColumns() {
    const t = [];
    return this.addDisplayedLeafColumns(t), t;
  }
  getDefinition() {
    return this.providedColumnGroup.getColGroupDef();
  }
  getColGroupDef() {
    return this.providedColumnGroup.getColGroupDef();
  }
  isPadding() {
    return this.providedColumnGroup.isPadding();
  }
  isExpandable() {
    return this.providedColumnGroup.isExpandable();
  }
  isExpanded() {
    return this.providedColumnGroup.isExpanded();
  }
  setExpanded(t) {
    this.providedColumnGroup.setExpanded(t);
  }
  addDisplayedLeafColumns(t) {
    this.displayedChildren.forEach((i) => {
      i instanceof pe ? t.push(i) : i instanceof ei && i.addDisplayedLeafColumns(t);
    });
  }
  addLeafColumns(t) {
    this.children.forEach((i) => {
      i instanceof pe ? t.push(i) : i instanceof ei && i.addLeafColumns(t);
    });
  }
  getChildren() {
    return this.children;
  }
  getColumnGroupShow() {
    return this.providedColumnGroup.getColumnGroupShow();
  }
  getProvidedColumnGroup() {
    return this.providedColumnGroup;
  }
  getPaddingLevel() {
    const t = this.getParent();
    return !this.isPadding() || !t || !t.isPadding() ? 0 : 1 + t.getPaddingLevel();
  }
  calculateDisplayedColumns() {
    this.displayedChildren = [];
    let t = this;
    for (; t != null && t.isPadding(); )
      t = t.getParent();
    if (!(t ? t.providedColumnGroup.isExpandable() : !1)) {
      this.displayedChildren = this.children, this.localEventService.dispatchEvent(this.createAgEvent(ei.EVENT_DISPLAYED_CHILDREN_CHANGED));
      return;
    }
    this.children.forEach((s) => {
      if (s instanceof ei && (!s.displayedChildren || !s.displayedChildren.length))
        return;
      switch (s.getColumnGroupShow()) {
        case "open":
          t.providedColumnGroup.isExpanded() && this.displayedChildren.push(s);
          break;
        case "closed":
          t.providedColumnGroup.isExpanded() || this.displayedChildren.push(s);
          break;
        default:
          this.displayedChildren.push(s);
          break;
      }
    }), this.localEventService.dispatchEvent(this.createAgEvent(ei.EVENT_DISPLAYED_CHILDREN_CHANGED));
  }
};
Rn.EVENT_LEFT_CHANGED = "leftChanged";
Rn.EVENT_DISPLAYED_CHILDREN_CHANGED = "displayedChildrenChanged";
u([
  f("gridOptionsService")
], Rn.prototype, "gos", 2);
var Ke = Rn, p = class {
  /*****************************  INTERNAL EVENTS: END ******************************************* */
};
p.EVENT_COLUMN_EVERYTHING_CHANGED = "columnEverythingChanged";
p.EVENT_NEW_COLUMNS_LOADED = "newColumnsLoaded";
p.EVENT_COLUMN_PIVOT_MODE_CHANGED = "columnPivotModeChanged";
p.EVENT_PIVOT_MAX_COLUMNS_EXCEEDED = "pivotMaxColumnsExceeded";
p.EVENT_COLUMN_ROW_GROUP_CHANGED = "columnRowGroupChanged";
p.EVENT_EXPAND_COLLAPSE_ALL = "expandOrCollapseAll";
p.EVENT_COLUMN_PIVOT_CHANGED = "columnPivotChanged";
p.EVENT_GRID_COLUMNS_CHANGED = "gridColumnsChanged";
p.EVENT_COLUMN_VALUE_CHANGED = "columnValueChanged";
p.EVENT_COLUMN_MOVED = "columnMoved";
p.EVENT_COLUMN_VISIBLE = "columnVisible";
p.EVENT_COLUMN_PINNED = "columnPinned";
p.EVENT_COLUMN_GROUP_OPENED = "columnGroupOpened";
p.EVENT_COLUMN_RESIZED = "columnResized";
p.EVENT_DISPLAYED_COLUMNS_CHANGED = "displayedColumnsChanged";
p.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED = "suppressMovableColumns";
p.EVENT_SUPPRESS_MENU_HIDE_CHANGED = "suppressMenuHide";
p.EVENT_SUPPRESS_FIELD_DOT_NOTATION = "suppressFieldDotNotation";
p.EVENT_VIRTUAL_COLUMNS_CHANGED = "virtualColumnsChanged";
p.EVENT_COLUMN_HEADER_MOUSE_OVER = "columnHeaderMouseOver";
p.EVENT_COLUMN_HEADER_MOUSE_LEAVE = "columnHeaderMouseLeave";
p.EVENT_COLUMN_HEADER_CLICKED = "columnHeaderClicked";
p.EVENT_COLUMN_HEADER_CONTEXT_MENU = "columnHeaderContextMenu";
p.EVENT_ASYNC_TRANSACTIONS_FLUSHED = "asyncTransactionsFlushed";
p.EVENT_ROW_GROUP_OPENED = "rowGroupOpened";
p.EVENT_ROW_DATA_UPDATED = "rowDataUpdated";
p.EVENT_PINNED_ROW_DATA_CHANGED = "pinnedRowDataChanged";
p.EVENT_RANGE_SELECTION_CHANGED = "rangeSelectionChanged";
p.EVENT_CHART_CREATED = "chartCreated";
p.EVENT_CHART_RANGE_SELECTION_CHANGED = "chartRangeSelectionChanged";
p.EVENT_CHART_OPTIONS_CHANGED = "chartOptionsChanged";
p.EVENT_CHART_DESTROYED = "chartDestroyed";
p.EVENT_TOOL_PANEL_VISIBLE_CHANGED = "toolPanelVisibleChanged";
p.EVENT_TOOL_PANEL_SIZE_CHANGED = "toolPanelSizeChanged";
p.EVENT_COLUMN_PANEL_ITEM_DRAG_START = "columnPanelItemDragStart";
p.EVENT_COLUMN_PANEL_ITEM_DRAG_END = "columnPanelItemDragEnd";
p.EVENT_MODEL_UPDATED = "modelUpdated";
p.EVENT_CUT_START = "cutStart";
p.EVENT_CUT_END = "cutEnd";
p.EVENT_PASTE_START = "pasteStart";
p.EVENT_PASTE_END = "pasteEnd";
p.EVENT_FILL_START = "fillStart";
p.EVENT_FILL_END = "fillEnd";
p.EVENT_RANGE_DELETE_START = "rangeDeleteStart";
p.EVENT_RANGE_DELETE_END = "rangeDeleteEnd";
p.EVENT_UNDO_STARTED = "undoStarted";
p.EVENT_UNDO_ENDED = "undoEnded";
p.EVENT_REDO_STARTED = "redoStarted";
p.EVENT_REDO_ENDED = "redoEnded";
p.EVENT_KEY_SHORTCUT_CHANGED_CELL_START = "keyShortcutChangedCellStart";
p.EVENT_KEY_SHORTCUT_CHANGED_CELL_END = "keyShortcutChangedCellEnd";
p.EVENT_CELL_CLICKED = "cellClicked";
p.EVENT_CELL_DOUBLE_CLICKED = "cellDoubleClicked";
p.EVENT_CELL_MOUSE_DOWN = "cellMouseDown";
p.EVENT_CELL_CONTEXT_MENU = "cellContextMenu";
p.EVENT_CELL_VALUE_CHANGED = "cellValueChanged";
p.EVENT_CELL_EDIT_REQUEST = "cellEditRequest";
p.EVENT_ROW_VALUE_CHANGED = "rowValueChanged";
p.EVENT_CELL_FOCUSED = "cellFocused";
p.EVENT_CELL_FOCUS_CLEARED = "cellFocusCleared";
p.EVENT_FULL_WIDTH_ROW_FOCUSED = "fullWidthRowFocused";
p.EVENT_ROW_SELECTED = "rowSelected";
p.EVENT_SELECTION_CHANGED = "selectionChanged";
p.EVENT_TOOLTIP_SHOW = "tooltipShow";
p.EVENT_TOOLTIP_HIDE = "tooltipHide";
p.EVENT_CELL_KEY_DOWN = "cellKeyDown";
p.EVENT_CELL_MOUSE_OVER = "cellMouseOver";
p.EVENT_CELL_MOUSE_OUT = "cellMouseOut";
p.EVENT_FILTER_CHANGED = "filterChanged";
p.EVENT_FILTER_MODIFIED = "filterModified";
p.EVENT_FILTER_OPENED = "filterOpened";
p.EVENT_ADVANCED_FILTER_BUILDER_VISIBLE_CHANGED = "advancedFilterBuilderVisibleChanged";
p.EVENT_SORT_CHANGED = "sortChanged";
p.EVENT_VIRTUAL_ROW_REMOVED = "virtualRowRemoved";
p.EVENT_ROW_CLICKED = "rowClicked";
p.EVENT_ROW_DOUBLE_CLICKED = "rowDoubleClicked";
p.EVENT_GRID_READY = "gridReady";
p.EVENT_GRID_PRE_DESTROYED = "gridPreDestroyed";
p.EVENT_GRID_SIZE_CHANGED = "gridSizeChanged";
p.EVENT_VIEWPORT_CHANGED = "viewportChanged";
p.EVENT_SCROLLBAR_WIDTH_CHANGED = "scrollbarWidthChanged";
p.EVENT_FIRST_DATA_RENDERED = "firstDataRendered";
p.EVENT_DRAG_STARTED = "dragStarted";
p.EVENT_DRAG_STOPPED = "dragStopped";
p.EVENT_CHECKBOX_CHANGED = "checkboxChanged";
p.EVENT_ROW_EDITING_STARTED = "rowEditingStarted";
p.EVENT_ROW_EDITING_STOPPED = "rowEditingStopped";
p.EVENT_CELL_EDITING_STARTED = "cellEditingStarted";
p.EVENT_CELL_EDITING_STOPPED = "cellEditingStopped";
p.EVENT_BODY_SCROLL = "bodyScroll";
p.EVENT_BODY_SCROLL_END = "bodyScrollEnd";
p.EVENT_HEIGHT_SCALE_CHANGED = "heightScaleChanged";
p.EVENT_PAGINATION_CHANGED = "paginationChanged";
p.EVENT_COMPONENT_STATE_CHANGED = "componentStateChanged";
p.EVENT_STORE_REFRESHED = "storeRefreshed";
p.EVENT_STATE_UPDATED = "stateUpdated";
p.EVENT_COLUMN_MENU_VISIBLE_CHANGED = "columnMenuVisibleChanged";
p.EVENT_CONTEXT_MENU_VISIBLE_CHANGED = "contextMenuVisibleChanged";
p.EVENT_BODY_HEIGHT_CHANGED = "bodyHeightChanged";
p.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED = "columnContainerWidthChanged";
p.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = "displayedColumnsWidthChanged";
p.EVENT_SCROLL_VISIBILITY_CHANGED = "scrollVisibilityChanged";
p.EVENT_COLUMN_HOVER_CHANGED = "columnHoverChanged";
p.EVENT_FLASH_CELLS = "flashCells";
p.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED = "paginationPixelOffsetChanged";
p.EVENT_DISPLAYED_ROWS_CHANGED = "displayedRowsChanged";
p.EVENT_LEFT_PINNED_WIDTH_CHANGED = "leftPinnedWidthChanged";
p.EVENT_RIGHT_PINNED_WIDTH_CHANGED = "rightPinnedWidthChanged";
p.EVENT_ROW_CONTAINER_HEIGHT_CHANGED = "rowContainerHeightChanged";
p.EVENT_HEADER_HEIGHT_CHANGED = "headerHeightChanged";
p.EVENT_COLUMN_HEADER_HEIGHT_CHANGED = "columnHeaderHeightChanged";
p.EVENT_ROW_DRAG_ENTER = "rowDragEnter";
p.EVENT_ROW_DRAG_MOVE = "rowDragMove";
p.EVENT_ROW_DRAG_LEAVE = "rowDragLeave";
p.EVENT_ROW_DRAG_END = "rowDragEnd";
p.EVENT_GRID_STYLES_CHANGED = "gridStylesChanged";
p.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = "columnRowGroupChangeRequest";
p.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = "columnPivotChangeRequest";
p.EVENT_COLUMN_VALUE_CHANGE_REQUEST = "columnValueChangeRequest";
p.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = "columnAggFuncChangeRequest";
p.EVENT_STORE_UPDATED = "storeUpdated";
p.EVENT_FILTER_DESTROYED = "filterDestroyed";
p.EVENT_ROW_DATA_UPDATE_STARTED = "rowDataUpdateStarted";
p.EVENT_ROW_COUNT_READY = "rowCountReady";
p.EVENT_ADVANCED_FILTER_ENABLED_CHANGED = "advancedFilterEnabledChanged";
p.EVENT_DATA_TYPES_INFERRED = "dataTypesInferred";
p.EVENT_FIELD_VALUE_CHANGED = "fieldValueChanged";
p.EVENT_FIELD_PICKER_VALUE_SELECTED = "fieldPickerValueSelected";
p.EVENT_SIDE_BAR_UPDATED = "sideBarUpdated";
var _r = /* @__PURE__ */ new Set([p.EVENT_GRID_PRE_DESTROYED, p.EVENT_FILL_START]), Nu = class {
  constructor() {
    this.existingIds = {};
  }
  getInstanceIdForKey(e) {
    const t = this.existingIds[e];
    let i;
    return typeof t != "number" ? i = 0 : i = t + 1, this.existingIds[e] = i, i;
  }
}, js = "ag-Grid-AutoColumn", Bo = class extends F {
  createAutoGroupColumns(e) {
    const t = [], i = this.gos.get("treeData");
    let s = this.gos.isGroupMultiAutoColumn();
    return i && s && (console.warn('AG Grid: you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data'), s = !1), s ? e.forEach((o, r) => {
      t.push(this.createOneAutoGroupColumn(o, r));
    }) : t.push(this.createOneAutoGroupColumn()), t;
  }
  updateAutoGroupColumns(e, t) {
    e.forEach((i, s) => this.updateOneAutoGroupColumn(i, s, t));
  }
  // rowGroupCol and index are missing if groupDisplayType != "multipleColumns"
  createOneAutoGroupColumn(e, t) {
    let i;
    e ? i = `${js}-${e.getId()}` : i = js;
    const s = this.createAutoGroupColDef(i, e, t);
    s.colId = i;
    const o = new pe(s, null, i, !0);
    return this.context.createBean(o), o;
  }
  /**
   * Refreshes an auto group col to load changes from defaultColDef or autoGroupColDef
   */
  updateOneAutoGroupColumn(e, t, i) {
    const s = e.getColDef(), o = typeof s.showRowGroup == "string" ? s.showRowGroup : void 0, r = o != null ? this.columnModel.getPrimaryColumn(o) : void 0, n = this.createAutoGroupColDef(e.getId(), r ?? void 0, t);
    e.setColDef(n, null, i), this.columnFactory.applyColumnState(e, n, i);
  }
  createAutoGroupColDef(e, t, i) {
    let s = this.createBaseColDef(t);
    const o = this.gos.get("autoGroupColumnDef");
    ft(s, o), s = this.columnFactory.addColumnDefaultAndTypes(s, e), this.gos.get("treeData") || z(s.field) && z(s.valueGetter) && z(s.filterValueGetter) && s.filter !== "agGroupColumnFilter" && (s.filter = !1), i && i > 0 && (s.headerCheckboxSelection = !1);
    const r = this.gos.isColumnsSortingCoupledToGroup(), n = s.valueGetter || s.field != null;
    return r && !n && (s.sortIndex = void 0, s.initialSort = void 0), s;
  }
  createBaseColDef(e) {
    const t = this.gos.get("autoGroupColumnDef"), s = {
      headerName: this.localeService.getLocaleTextFunc()("group", "Group")
    };
    if (t && (t.cellRenderer || t.cellRendererSelector) || (s.cellRenderer = "agGroupCellRenderer"), e) {
      const r = e.getColDef();
      Object.assign(s, {
        // cellRendererParams.groupKey: colDefToCopy.field;
        headerName: this.columnModel.getDisplayNameForColumn(e, "header"),
        headerValueGetter: r.headerValueGetter
      }), r.cellRenderer && Object.assign(s, {
        cellRendererParams: {
          innerRenderer: r.cellRenderer,
          innerRendererParams: r.cellRendererParams
        }
      }), s.showRowGroup = e.getColId();
    } else
      s.showRowGroup = !0;
    return s;
  }
};
u([
  f("columnModel")
], Bo.prototype, "columnModel", 2);
u([
  f("columnFactory")
], Bo.prototype, "columnFactory", 2);
Bo = u([
  O("autoGroupColService")
], Bo);
var Gu = {};
qe(Gu, {
  camelCaseToHumanText: () => Ou,
  camelCaseToHyphenated: () => _u,
  capitalise: () => Qp,
  escapeString: () => Oe,
  utf8_encode: () => qp
});
var jp = /[&<>"']/g, Yp = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function qp(e) {
  const t = String.fromCharCode;
  function i(h) {
    const g = [];
    if (!h)
      return [];
    const m = h.length;
    let C = 0, w, v;
    for (; C < m; )
      w = h.charCodeAt(C++), w >= 55296 && w <= 56319 && C < m ? (v = h.charCodeAt(C++), (v & 64512) == 56320 ? g.push(((w & 1023) << 10) + (v & 1023) + 65536) : (g.push(w), C--)) : g.push(w);
    return g;
  }
  function s(h) {
    if (h >= 55296 && h <= 57343)
      throw Error(
        "Lone surrogate U+" + h.toString(16).toUpperCase() + " is not a scalar value"
      );
  }
  function o(h, g) {
    return t(h >> g & 63 | 128);
  }
  function r(h) {
    if (h >= 0 && h <= 31 && h !== 10)
      return `_x${h.toString(16).toUpperCase().padStart(4, "0")}_`;
    if (!(h & 4294967168))
      return t(h);
    let g = "";
    return h & 4294965248 ? h & 4294901760 ? h & 4292870144 || (g = t(h >> 18 & 7 | 240), g += o(h, 12), g += o(h, 6)) : (s(h), g = t(h >> 12 & 15 | 224), g += o(h, 6)) : g = t(h >> 6 & 31 | 192), g += t(h & 63 | 128), g;
  }
  const n = i(e), l = n.length;
  let a = -1, d, c = "";
  for (; ++a < l; )
    d = n[a], c += r(d);
  return c;
}
function Qp(e) {
  return e[0].toUpperCase() + e.substring(1).toLowerCase();
}
function Oe(e, t) {
  if (e == null)
    return null;
  const i = e.toString().toString();
  return t ? i : i.replace(jp, (s) => Yp[s]);
}
function Ou(e) {
  if (!e || e == null)
    return null;
  const t = /([a-z])([A-Z])/g, i = /([A-Z]+)([A-Z])([a-z])/g;
  return e.replace(t, "$1 $2").replace(i, "$1 $2$3").replace(/\./g, " ").split(" ").map((o) => o.substring(0, 1).toUpperCase() + (o.length > 1 ? o.substring(1, o.length) : "")).join(" ");
}
function _u(e) {
  return e.replace(/[A-Z]/g, (t) => `-${t.toLocaleLowerCase()}`);
}
var Vu = {};
qe(Vu, {
  convertToMap: () => Ai,
  keys: () => Zp,
  mapById: () => Xp
});
function Ai(e) {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((i) => t.set(i[0], i[1])), t;
}
function Xp(e, t) {
  const i = /* @__PURE__ */ new Map();
  return e.forEach((s) => i.set(t(s), s)), i;
}
function Zp(e) {
  const t = [];
  return e.forEach((i, s) => t.push(s)), t;
}
var Ye = class extends F {
  constructor() {
    super(...arguments), this.primaryHeaderRowCount = 0, this.secondaryHeaderRowCount = 0, this.gridHeaderRowCount = 0, this.displayedColumnsLeft = [], this.displayedColumnsRight = [], this.displayedColumnsCenter = [], this.displayedColumns = [], this.displayedColumnsAndGroupsMap = {}, this.viewportColumns = [], this.viewportColumnsHash = "", this.headerViewportColumns = [], this.viewportColumnsCenter = [], this.headerViewportColumnsCenter = [], this.viewportRowLeft = {}, this.viewportRowRight = {}, this.viewportRowCenter = {}, this.autoHeightActiveAtLeastOnce = !1, this.rowGroupColumns = [], this.valueColumns = [], this.pivotColumns = [], this.ready = !1, this.changeEventsDispatching = !1, this.autoGroupsNeedBuilding = !1, this.forceRecreateAutoGroups = !1, this.pivotMode = !1, this.bodyWidth = 0, this.leftWidth = 0, this.rightWidth = 0, this.bodyWidthDirty = !0, this.shouldQueueResizeOperations = !1, this.resizeOperationQueue = [];
  }
  init() {
    this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
    const e = this.gos.get("pivotMode");
    this.isPivotSettingAllowed(e) && (this.pivotMode = e), this.addManagedPropertyListeners(["groupDisplayType", "treeData", "treeDataDisplayType", "groupHideOpenParents"], (t) => this.buildAutoGroupColumns(Bs(t.source))), this.addManagedPropertyListener("autoGroupColumnDef", (t) => this.onAutoGroupColumnDefChanged(Bs(t.source))), this.addManagedPropertyListeners(["defaultColDef", "columnTypes", "suppressFieldDotNotation"], (t) => this.onSharedColDefChanged(Bs(t.source))), this.addManagedPropertyListener("pivotMode", (t) => this.setPivotMode(this.gos.get("pivotMode"), Bs(t.source))), this.addManagedListener(this.eventService, p.EVENT_FIRST_DATA_RENDERED, () => this.onFirstDataRendered());
  }
  buildAutoGroupColumns(e) {
    this.columnDefs && (this.autoGroupsNeedBuilding = !0, this.forceRecreateAutoGroups = !0, this.updateGridColumns(), this.updateDisplayedColumns(e));
  }
  onAutoGroupColumnDefChanged(e) {
    this.groupAutoColumns && this.autoGroupColService.updateAutoGroupColumns(this.groupAutoColumns, e);
  }
  onSharedColDefChanged(e) {
    this.gridColumns && (this.groupAutoColumns && this.autoGroupColService.updateAutoGroupColumns(this.groupAutoColumns, e), this.createColumnsFromColumnDefs(!0, e));
  }
  setColumnDefs(e, t) {
    const i = !!this.columnDefs;
    this.columnDefs = e, this.createColumnsFromColumnDefs(i, t);
  }
  recreateColumnDefs(e) {
    this.onSharedColDefChanged(e);
  }
  destroyOldColumns(e, t) {
    const i = {};
    if (!e)
      return;
    hi(null, e, (o) => {
      i[o.getInstanceId()] = o;
    }), t && hi(null, t, (o) => {
      i[o.getInstanceId()] = null;
    });
    const s = Object.values(i).filter((o) => o != null);
    this.destroyBeans(s);
  }
  destroyColumns() {
    this.destroyOldColumns(this.primaryColumnTree), this.destroyOldColumns(this.secondaryBalancedTree), this.destroyOldColumns(this.groupAutoColsBalancedTree);
  }
  createColumnsFromColumnDefs(e, t) {
    const i = e ? this.compareColumnStatesAndDispatchEvents(t) : void 0;
    this.valueCache.expire(), this.autoGroupsNeedBuilding = !0;
    const s = this.primaryColumns, o = this.primaryColumnTree, r = this.columnFactory.createColumnTree(this.columnDefs, !0, o, t);
    this.destroyOldColumns(this.primaryColumnTree, r.columnTree), this.primaryColumnTree = r.columnTree, this.primaryHeaderRowCount = r.treeDept + 1, this.primaryColumns = this.getColumnsFromTree(this.primaryColumnTree), this.primaryColumnsMap = {}, this.primaryColumns.forEach((a) => this.primaryColumnsMap[a.getId()] = a), this.extractRowGroupColumns(t, s), this.extractPivotColumns(t, s), this.extractValueColumns(t, s), this.ready = !0;
    const n = this.gridColsArePrimary === void 0;
    (this.gridColsArePrimary || n || this.autoGroupsNeedBuilding) && (this.updateGridColumns(), e && this.gridColsArePrimary && !this.gos.get("maintainColumnOrder") && this.orderGridColumnsLikePrimary(), this.updateDisplayedColumns(t), this.checkViewportColumns()), this.dispatchEverythingChanged(t), this.changeEventsDispatching = !0, i && i(), this.changeEventsDispatching = !1, this.dispatchNewColumnsLoaded(t);
  }
  shouldRowModelIgnoreRefresh() {
    return this.changeEventsDispatching;
  }
  dispatchNewColumnsLoaded(e) {
    const t = {
      type: p.EVENT_NEW_COLUMNS_LOADED,
      source: e
    };
    this.eventService.dispatchEvent(t), e === "gridInitializing" && this.onColumnsReady();
  }
  // this event is legacy, no grid code listens to it. instead the grid listens to New Columns Loaded
  dispatchEverythingChanged(e) {
    const t = {
      type: p.EVENT_COLUMN_EVERYTHING_CHANGED,
      source: e
    };
    this.eventService.dispatchEvent(t);
  }
  orderGridColumnsLikePrimary() {
    const e = this.primaryColumns;
    if (!e)
      return;
    const t = e.filter((s) => this.gridColumns.indexOf(s) >= 0), i = this.gridColumns.filter((s) => t.indexOf(s) < 0);
    this.gridColumns = [...i, ...t], this.gridColumns = this.placeLockedColumns(this.gridColumns);
  }
  getAllDisplayedAutoHeightCols() {
    return this.displayedAutoHeightCols;
  }
  setViewport() {
    this.gos.get("enableRtl") ? (this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth, this.viewportRight = this.bodyWidth - this.scrollPosition) : (this.viewportLeft = this.scrollPosition, this.viewportRight = this.scrollWidth + this.scrollPosition);
  }
  // checks what columns are currently displayed due to column virtualisation. dispatches an event
  // if the list of columns has changed.
  // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
  checkViewportColumns(e = !1) {
    if (this.displayedColumnsCenter == null || !this.extractViewport())
      return;
    const i = {
      type: p.EVENT_VIRTUAL_COLUMNS_CHANGED,
      afterScroll: e
    };
    this.eventService.dispatchEvent(i);
  }
  setViewportPosition(e, t, i = !1) {
    (e !== this.scrollWidth || t !== this.scrollPosition || this.bodyWidthDirty) && (this.scrollWidth = e, this.scrollPosition = t, this.bodyWidthDirty = !0, this.setViewport(), this.ready && this.checkViewportColumns(i));
  }
  isPivotMode() {
    return this.pivotMode;
  }
  isPivotSettingAllowed(e) {
    return e && this.gos.get("treeData") ? (H("Pivot mode not available with treeData."), !1) : !0;
  }
  setPivotMode(e, t) {
    if (e === this.pivotMode || !this.isPivotSettingAllowed(this.pivotMode) || (this.pivotMode = e, !this.gridColumns))
      return;
    this.autoGroupsNeedBuilding = !0, this.updateGridColumns(), this.updateDisplayedColumns(t);
    const i = {
      type: p.EVENT_COLUMN_PIVOT_MODE_CHANGED
    };
    this.eventService.dispatchEvent(i);
  }
  getSecondaryPivotColumn(e, t) {
    if (z(this.secondaryColumns))
      return null;
    const i = this.getPrimaryColumn(t);
    let s = null;
    return this.secondaryColumns.forEach((o) => {
      const r = o.getColDef().pivotKeys, n = o.getColDef().pivotValueColumn;
      ii(r, e) && n === i && (s = o);
    }), s;
  }
  setBeans(e) {
    this.logger = e.create("columnModel");
  }
  setFirstRightAndLastLeftPinned(e) {
    let t, i;
    this.gos.get("enableRtl") ? (t = this.displayedColumnsLeft ? this.displayedColumnsLeft[0] : null, i = this.displayedColumnsRight ? se(this.displayedColumnsRight) : null) : (t = this.displayedColumnsLeft ? se(this.displayedColumnsLeft) : null, i = this.displayedColumnsRight ? this.displayedColumnsRight[0] : null), this.gridColumns.forEach((s) => {
      s.setLastLeftPinned(s === t, e), s.setFirstRightPinned(s === i, e);
    });
  }
  autoSizeColumns(e) {
    if (this.shouldQueueResizeOperations) {
      this.resizeOperationQueue.push(() => this.autoSizeColumns(e));
      return;
    }
    const { columns: t, skipHeader: i, skipHeaderGroups: s, stopAtGroup: o, source: r = "api" } = e;
    this.animationFrameService.flushAllFrames();
    const n = [];
    let l = -1;
    const a = i ?? this.gos.get("skipHeaderOnAutoSize"), d = s ?? a;
    for (; l !== 0; )
      l = 0, this.actionOnGridColumns(t, (c) => {
        if (n.indexOf(c) >= 0)
          return !1;
        const h = this.autoWidthCalculator.getPreferredWidthForColumn(c, a);
        if (h > 0) {
          const g = this.normaliseColumnWidth(c, h);
          c.setActualWidth(g, r), n.push(c), l++;
        }
        return !0;
      }, r);
    d || this.autoSizeColumnGroupsByColumns(t, r, o), this.dispatchColumnResizedEvent(n, !0, "autosizeColumns");
  }
  dispatchColumnResizedEvent(e, t, i, s = null) {
    if (e && e.length) {
      const o = {
        type: p.EVENT_COLUMN_RESIZED,
        columns: e,
        column: e.length === 1 ? e[0] : null,
        flexColumns: s,
        finished: t,
        source: i
      };
      this.eventService.dispatchEvent(o);
    }
  }
  dispatchColumnChangedEvent(e, t, i) {
    const s = {
      type: e,
      columns: t,
      column: t && t.length == 1 ? t[0] : null,
      source: i
    };
    this.eventService.dispatchEvent(s);
  }
  dispatchColumnMovedEvent(e) {
    const { movedColumns: t, source: i, toIndex: s, finished: o } = e, r = {
      type: p.EVENT_COLUMN_MOVED,
      columns: t,
      column: t && t.length === 1 ? t[0] : null,
      toIndex: s,
      finished: o,
      source: i
    };
    this.eventService.dispatchEvent(r);
  }
  dispatchColumnPinnedEvent(e, t) {
    if (!e.length)
      return;
    const i = e.length === 1 ? e[0] : null, s = this.getCommonValue(e, (r) => r.getPinned()), o = {
      type: p.EVENT_COLUMN_PINNED,
      // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
      pinned: s ?? null,
      columns: e,
      column: i,
      source: t
    };
    this.eventService.dispatchEvent(o);
  }
  dispatchColumnVisibleEvent(e, t) {
    if (!e.length)
      return;
    const i = e.length === 1 ? e[0] : null, s = this.getCommonValue(e, (r) => r.isVisible()), o = {
      type: p.EVENT_COLUMN_VISIBLE,
      visible: s,
      columns: e,
      column: i,
      source: t
    };
    this.eventService.dispatchEvent(o);
  }
  autoSizeColumn(e, t, i) {
    e && this.autoSizeColumns({ columns: [e], skipHeader: i, skipHeaderGroups: !0, source: t });
  }
  autoSizeColumnGroupsByColumns(e, t, i) {
    const s = /* @__PURE__ */ new Set();
    this.getGridColumns(e).forEach((l) => {
      let a = l.getParent();
      for (; a && a != i; )
        a.isPadding() || s.add(a), a = a.getParent();
    });
    let r;
    const n = [];
    for (const l of s) {
      for (const a of this.ctrlsService.getHeaderRowContainerCtrls())
        if (r = a.getHeaderCtrlForColumn(l), r)
          break;
      r && r.resizeLeafColumnsToFit(t);
    }
    return n;
  }
  autoSizeAllColumns(e, t) {
    if (this.shouldQueueResizeOperations) {
      this.resizeOperationQueue.push(() => this.autoSizeAllColumns(e, t));
      return;
    }
    const i = this.getAllDisplayedColumns();
    this.autoSizeColumns({ columns: i, skipHeader: t, source: e });
  }
  // Possible candidate for reuse (alot of recursive traversal duplication)
  getColumnsFromTree(e) {
    const t = [], i = (s) => {
      for (let o = 0; o < s.length; o++) {
        const r = s[o];
        r instanceof pe ? t.push(r) : r instanceof Ge && i(r.getChildren());
      }
    };
    return i(e), t;
  }
  getAllDisplayedTrees() {
    return this.displayedTreeLeft && this.displayedTreeRight && this.displayedTreeCentre ? this.displayedTreeLeft.concat(this.displayedTreeCentre).concat(this.displayedTreeRight) : null;
  }
  // + columnSelectPanel
  getPrimaryColumnTree() {
    return this.primaryColumnTree;
  }
  // + gridPanel -> for resizing the body and setting top margin
  getHeaderRowCount() {
    return this.gridHeaderRowCount;
  }
  // + headerRenderer -> setting pinned body width
  getDisplayedTreeLeft() {
    return this.displayedTreeLeft;
  }
  // + headerRenderer -> setting pinned body width
  getDisplayedTreeRight() {
    return this.displayedTreeRight;
  }
  // + headerRenderer -> setting pinned body width
  getDisplayedTreeCentre() {
    return this.displayedTreeCentre;
  }
  // gridPanel -> ensureColumnVisible
  isColumnDisplayed(e) {
    return this.getAllDisplayedColumns().indexOf(e) >= 0;
  }
  // + csvCreator
  getAllDisplayedColumns() {
    return this.displayedColumns;
  }
  getViewportColumns() {
    return this.viewportColumns;
  }
  getDisplayedLeftColumnsForRow(e) {
    return this.colSpanActive ? this.getDisplayedColumnsForRow(e, this.displayedColumnsLeft) : this.displayedColumnsLeft;
  }
  getDisplayedRightColumnsForRow(e) {
    return this.colSpanActive ? this.getDisplayedColumnsForRow(e, this.displayedColumnsRight) : this.displayedColumnsRight;
  }
  isColSpanActive() {
    return this.colSpanActive;
  }
  getDisplayedColumnsForRow(e, t, i, s) {
    const o = [];
    let r = null;
    for (let n = 0; n < t.length; n++) {
      const l = t[n], a = t.length - n, d = Math.min(l.getColSpan(e), a), c = [l];
      if (d > 1) {
        const g = d - 1;
        for (let m = 1; m <= g; m++)
          c.push(t[n + m]);
        n += g;
      }
      let h;
      i ? (h = !1, c.forEach((g) => {
        i(g) && (h = !0);
      })) : h = !0, h && (o.length === 0 && r && (s && s(l)) && o.push(r), o.push(l)), r = l;
    }
    return o;
  }
  // + rowRenderer
  // if we are not column spanning, this just returns back the virtual centre columns,
  // however if we are column spanning, then different rows can have different virtual
  // columns, so we have to work out the list for each individual row.
  getViewportCenterColumnsForRow(e) {
    if (!this.colSpanActive)
      return this.viewportColumnsCenter;
    const t = (s) => {
      const o = s.getLeft();
      return b(o) && o > this.viewportLeft;
    }, i = this.isColumnVirtualisationSuppressed() ? null : this.isColumnInRowViewport.bind(this);
    return this.getDisplayedColumnsForRow(
      e,
      this.displayedColumnsCenter,
      i,
      t
    );
  }
  isColumnAtEdge(e, t) {
    const i = this.getAllDisplayedColumns();
    if (!i.length)
      return !1;
    const s = t === "first";
    let o;
    if (e instanceof Ke) {
      const r = e.getDisplayedLeafColumns();
      if (!r.length)
        return !1;
      o = s ? r[0] : se(r);
    } else
      o = e;
    return (s ? i[0] : se(i)) === o;
  }
  getAriaColumnIndex(e) {
    let t;
    return e instanceof Ke ? t = e.getLeafColumns()[0] : t = e, this.ariaOrderColumns.indexOf(t) + 1;
  }
  isColumnInHeaderViewport(e) {
    return e.isAutoHeaderHeight() ? !0 : this.isColumnInRowViewport(e);
  }
  isColumnInRowViewport(e) {
    if (e.isAutoHeight())
      return !0;
    const t = e.getLeft() || 0, i = t + e.getActualWidth(), s = this.viewportLeft - 200, o = this.viewportRight + 200, r = t < s && i < s, n = t > o && i > o;
    return !r && !n;
  }
  // used by:
  // + angularGrid -> setting pinned body width
  // note: this should be cached
  getDisplayedColumnsLeftWidth() {
    return this.getWidthOfColsInList(this.displayedColumnsLeft);
  }
  // note: this should be cached
  getDisplayedColumnsRightWidth() {
    return this.getWidthOfColsInList(this.displayedColumnsRight);
  }
  updatePrimaryColumnList(e, t, i, s, o, r) {
    if (!e || It(e))
      return;
    let n = !1;
    if (e.forEach((a) => {
      if (!a)
        return;
      const d = this.getPrimaryColumn(a);
      if (d) {
        if (i) {
          if (t.indexOf(d) >= 0)
            return;
          t.push(d);
        } else {
          if (t.indexOf(d) < 0)
            return;
          gt(t, d);
        }
        s(d), n = !0;
      }
    }), !n)
      return;
    this.autoGroupsNeedBuilding && this.updateGridColumns(), this.updateDisplayedColumns(r);
    const l = {
      type: o,
      columns: t,
      column: t.length === 1 ? t[0] : null,
      source: r
    };
    this.eventService.dispatchEvent(l);
  }
  setRowGroupColumns(e, t) {
    this.autoGroupsNeedBuilding = !0, this.setPrimaryColumnList(
      e,
      this.rowGroupColumns,
      p.EVENT_COLUMN_ROW_GROUP_CHANGED,
      !0,
      this.setRowGroupActive.bind(this),
      t
    );
  }
  setRowGroupActive(e, t, i) {
    e !== t.isRowGroupActive() && (t.setRowGroupActive(e, i), e && !this.gos.get("suppressRowGroupHidesColumns") && this.setColumnsVisible([t], !1, i), !e && !this.gos.get("suppressMakeColumnVisibleAfterUnGroup") && this.setColumnsVisible([t], !0, i));
  }
  addRowGroupColumns(e, t) {
    this.autoGroupsNeedBuilding = !0, this.updatePrimaryColumnList(
      e,
      this.rowGroupColumns,
      !0,
      this.setRowGroupActive.bind(this, !0),
      p.EVENT_COLUMN_ROW_GROUP_CHANGED,
      t
    );
  }
  removeRowGroupColumns(e, t) {
    this.autoGroupsNeedBuilding = !0, this.updatePrimaryColumnList(
      e,
      this.rowGroupColumns,
      !1,
      this.setRowGroupActive.bind(this, !1),
      p.EVENT_COLUMN_ROW_GROUP_CHANGED,
      t
    );
  }
  addPivotColumns(e, t) {
    this.updatePrimaryColumnList(
      e,
      this.pivotColumns,
      !0,
      (i) => i.setPivotActive(!0, t),
      p.EVENT_COLUMN_PIVOT_CHANGED,
      t
    );
  }
  setPivotColumns(e, t) {
    this.setPrimaryColumnList(
      e,
      this.pivotColumns,
      p.EVENT_COLUMN_PIVOT_CHANGED,
      !0,
      (i, s) => {
        s.setPivotActive(i, t);
      },
      t
    );
  }
  removePivotColumns(e, t) {
    this.updatePrimaryColumnList(
      e,
      this.pivotColumns,
      !1,
      (i) => i.setPivotActive(!1, t),
      p.EVENT_COLUMN_PIVOT_CHANGED,
      t
    );
  }
  setPrimaryColumnList(e, t, i, s, o, r) {
    if (!this.gridColumns)
      return;
    const n = /* @__PURE__ */ new Map();
    t.forEach((l, a) => n.set(l, a)), t.length = 0, b(e) && e.forEach((l) => {
      const a = this.getPrimaryColumn(l);
      a && t.push(a);
    }), t.forEach((l, a) => {
      const d = n.get(l);
      if (d === void 0) {
        n.set(l, 0);
        return;
      }
      s && d !== a || n.delete(l);
    }), (this.primaryColumns || []).forEach((l) => {
      const a = t.indexOf(l) >= 0;
      o(a, l);
    }), this.autoGroupsNeedBuilding && this.updateGridColumns(), this.updateDisplayedColumns(r), this.dispatchColumnChangedEvent(i, [...n.keys()], r);
  }
  setValueColumns(e, t) {
    this.setPrimaryColumnList(
      e,
      this.valueColumns,
      p.EVENT_COLUMN_VALUE_CHANGED,
      !1,
      this.setValueActive.bind(this),
      t
    );
  }
  setValueActive(e, t, i) {
    if (e !== t.isValueActive() && (t.setValueActive(e, i), e && !t.getAggFunc() && this.aggFuncService)) {
      const s = this.aggFuncService.getDefaultAggFunc(t);
      t.setAggFunc(s);
    }
  }
  addValueColumns(e, t) {
    this.updatePrimaryColumnList(
      e,
      this.valueColumns,
      !0,
      this.setValueActive.bind(this, !0),
      p.EVENT_COLUMN_VALUE_CHANGED,
      t
    );
  }
  removeValueColumns(e, t) {
    this.updatePrimaryColumnList(
      e,
      this.valueColumns,
      !1,
      this.setValueActive.bind(this, !1),
      p.EVENT_COLUMN_VALUE_CHANGED,
      t
    );
  }
  // returns the width we can set to this col, taking into consideration min and max widths
  normaliseColumnWidth(e, t) {
    const i = e.getMinWidth();
    b(i) && t < i && (t = i);
    const s = e.getMaxWidth();
    return b(s) && e.isGreaterThanMax(t) && (t = s), t;
  }
  getPrimaryOrGridColumn(e) {
    return this.getPrimaryColumn(e) || this.getGridColumn(e);
  }
  setColumnWidths(e, t, i, s) {
    const o = [];
    e.forEach((r) => {
      const n = this.getPrimaryOrGridColumn(r.key);
      if (!n)
        return;
      if (o.push({
        width: r.newWidth,
        ratios: [1],
        columns: [n]
      }), this.gos.get("colResizeDefault") === "shift" && (t = !t), t) {
        const a = this.getDisplayedColAfter(n);
        if (!a)
          return;
        const d = n.getActualWidth() - r.newWidth, c = a.getActualWidth() + d;
        o.push({
          width: c,
          ratios: [1],
          columns: [a]
        });
      }
    }), o.length !== 0 && this.resizeColumnSets({
      resizeSets: o,
      finished: i,
      source: s
    });
  }
  checkMinAndMaxWidthsForSet(e) {
    const { columns: t, width: i } = e;
    let s = 0, o = 0, r = !0;
    t.forEach((a) => {
      const d = a.getMinWidth();
      s += d || 0;
      const c = a.getMaxWidth();
      b(c) && c > 0 ? o += c : r = !1;
    });
    const n = i >= s, l = !r || i <= o;
    return n && l;
  }
  // method takes sets of columns and resizes them. either all sets will be resized, or nothing
  // be resized. this is used for example when user tries to resize a group and holds shift key,
  // then both the current group (grows), and the adjacent group (shrinks), will get resized,
  // so that's two sets for this method.
  resizeColumnSets(e) {
    const { resizeSets: t, finished: i, source: s } = e;
    if (!(!t || t.every((c) => this.checkMinAndMaxWidthsForSet(c)))) {
      if (i) {
        const c = t && t.length > 0 ? t[0].columns : null;
        this.dispatchColumnResizedEvent(c, i, s);
      }
      return;
    }
    const r = [], n = [];
    t.forEach((c) => {
      const { width: h, columns: g, ratios: m } = c, C = {}, w = {};
      g.forEach((E) => n.push(E));
      let v = !0, y = 0;
      for (; v; ) {
        if (y++, y > 1e3) {
          console.error("AG Grid: infinite loop in resizeColumnSets");
          break;
        }
        v = !1;
        const E = [];
        let D = 0, R = h;
        g.forEach((I, A) => {
          if (w[I.getId()])
            R -= C[I.getId()];
          else {
            E.push(I);
            const x = m[A];
            D += x;
          }
        });
        const T = 1 / D;
        E.forEach((I, A) => {
          const V = A === E.length - 1;
          let x;
          V ? x = R : (x = Math.round(m[A] * h * T), R -= x);
          const k = I.getMinWidth(), B = I.getMaxWidth();
          b(k) && x < k ? (x = k, w[I.getId()] = !0, v = !0) : b(B) && B > 0 && x > B && (x = B, w[I.getId()] = !0, v = !0), C[I.getId()] = x;
        });
      }
      g.forEach((E) => {
        const D = C[E.getId()];
        E.getActualWidth() !== D && (E.setActualWidth(D, s), r.push(E));
      });
    });
    const l = r.length > 0;
    let a = [];
    l && (a = this.refreshFlexedColumns({ resizingCols: n, skipSetLeft: !0 }), this.setLeftValues(s), this.updateBodyWidths(), this.checkViewportColumns());
    const d = n.concat(a);
    (l || i) && this.dispatchColumnResizedEvent(d, i, s, a);
  }
  setColumnAggFunc(e, t, i) {
    if (!e)
      return;
    const s = this.getPrimaryColumn(e);
    s && (s.setAggFunc(t), this.dispatchColumnChangedEvent(p.EVENT_COLUMN_VALUE_CHANGED, [s], i));
  }
  moveRowGroupColumn(e, t, i) {
    if (this.isRowGroupEmpty())
      return;
    const s = this.rowGroupColumns[e], o = this.rowGroupColumns.slice(e, t);
    this.rowGroupColumns.splice(e, 1), this.rowGroupColumns.splice(t, 0, s);
    const r = {
      type: p.EVENT_COLUMN_ROW_GROUP_CHANGED,
      columns: o,
      column: o.length === 1 ? o[0] : null,
      source: i
    };
    this.eventService.dispatchEvent(r);
  }
  moveColumns(e, t, i, s = !0) {
    if (!this.gridColumns)
      return;
    if (this.columnAnimationService.start(), t > this.gridColumns.length - e.length) {
      console.warn("AG Grid: tried to insert columns in invalid location, toIndex = " + t), console.warn("AG Grid: remember that you should not count the moving columns when calculating the new index");
      return;
    }
    const o = this.getGridColumns(e);
    this.doesMovePassRules(o, t) && (Fl(this.gridColumns, o, t), this.updateDisplayedColumns(i), this.dispatchColumnMovedEvent({ movedColumns: o, source: i, toIndex: t, finished: s }), this.columnAnimationService.finish());
  }
  doesMovePassRules(e, t) {
    const i = this.getProposedColumnOrder(e, t);
    return this.doesOrderPassRules(i);
  }
  doesOrderPassRules(e) {
    return !(!this.doesMovePassMarryChildren(e) || !this.doesMovePassLockedPositions(e));
  }
  getProposedColumnOrder(e, t) {
    const i = this.gridColumns.slice();
    return Fl(i, e, t), i;
  }
  // returns the provided cols sorted in same order as they appear in grid columns. eg if grid columns
  // contains [a,b,c,d,e] and col passed is [e,a] then the passed cols are sorted into [a,e]
  sortColumnsLikeGridColumns(e) {
    !e || e.length <= 1 || e.filter((i) => this.gridColumns.indexOf(i) < 0).length > 0 || e.sort((i, s) => {
      const o = this.gridColumns.indexOf(i), r = this.gridColumns.indexOf(s);
      return o - r;
    });
  }
  doesMovePassLockedPositions(e) {
    let t = 0, i = !0;
    const s = (o) => o ? o === !0 || o === "left" ? 0 : 2 : 1;
    return e.forEach((o) => {
      const r = s(o.getColDef().lockPosition);
      r < t && (i = !1), t = r;
    }), i;
  }
  doesMovePassMarryChildren(e) {
    let t = !0;
    return hi(null, this.gridBalancedTree, (i) => {
      if (!(i instanceof Ge))
        return;
      const s = i, o = s.getColGroupDef();
      if (!(o && o.marryChildren))
        return;
      const n = [];
      s.getLeafColumns().forEach((h) => {
        const g = e.indexOf(h);
        n.push(g);
      });
      const l = Math.max.apply(Math, n), a = Math.min.apply(Math, n), d = l - a, c = s.getLeafColumns().length - 1;
      d > c && (t = !1);
    }), t;
  }
  moveColumnByIndex(e, t, i) {
    if (!this.gridColumns)
      return;
    const s = this.gridColumns[e];
    this.moveColumns([s], t, i);
  }
  getColumnDefs() {
    if (!this.primaryColumns)
      return;
    const e = this.primaryColumns.slice();
    return this.gridColsArePrimary ? e.sort((t, i) => this.gridColumns.indexOf(t) - this.gridColumns.indexOf(i)) : this.lastPrimaryOrder && e.sort((t, i) => this.lastPrimaryOrder.indexOf(t) - this.lastPrimaryOrder.indexOf(i)), this.columnDefFactory.buildColumnDefs(e, this.rowGroupColumns, this.pivotColumns);
  }
  // used by:
  // + angularGrid -> for setting body width
  // + rowController -> setting main row widths (when inserting and resizing)
  // need to cache this
  getBodyContainerWidth() {
    return this.bodyWidth;
  }
  getContainerWidth(e) {
    switch (e) {
      case "left":
        return this.leftWidth;
      case "right":
        return this.rightWidth;
      default:
        return this.bodyWidth;
    }
  }
  // after setColumnWidth or updateGroupsAndDisplayedColumns
  updateBodyWidths() {
    const e = this.getWidthOfColsInList(this.displayedColumnsCenter), t = this.getWidthOfColsInList(this.displayedColumnsLeft), i = this.getWidthOfColsInList(this.displayedColumnsRight);
    if (this.bodyWidthDirty = this.bodyWidth !== e, this.bodyWidth !== e || this.leftWidth !== t || this.rightWidth !== i) {
      this.bodyWidth = e, this.leftWidth = t, this.rightWidth = i;
      const o = {
        type: p.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED
      };
      this.eventService.dispatchEvent(o);
      const r = {
        type: p.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED
      };
      this.eventService.dispatchEvent(r);
    }
  }
  // + rowController
  getValueColumns() {
    return this.valueColumns ? this.valueColumns : [];
  }
  // + rowController
  getPivotColumns() {
    return this.pivotColumns ? this.pivotColumns : [];
  }
  // + clientSideRowModel
  isPivotActive() {
    return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
  }
  // + toolPanel
  getRowGroupColumns() {
    return this.rowGroupColumns ? this.rowGroupColumns : [];
  }
  // + rowController -> while inserting rows
  getDisplayedCenterColumns() {
    return this.displayedColumnsCenter;
  }
  // + rowController -> while inserting rows
  getDisplayedLeftColumns() {
    return this.displayedColumnsLeft;
  }
  getDisplayedRightColumns() {
    return this.displayedColumnsRight;
  }
  // used by:
  // + clientSideRowController -> sorting, building quick filter text
  // + headerRenderer -> sorting (clearing icon)
  getAllPrimaryColumns() {
    return this.primaryColumns ? this.primaryColumns : null;
  }
  getSecondaryColumns() {
    return this.secondaryColumns ? this.secondaryColumns : null;
  }
  getAllColumnsForQuickFilter() {
    return this.columnsForQuickFilter;
  }
  // + moveColumnController
  getAllGridColumns() {
    var e;
    return (e = this.gridColumns) != null ? e : [];
  }
  isRowGroupEmpty() {
    return It(this.rowGroupColumns);
  }
  setColumnsVisible(e, t = !1, i) {
    this.applyColumnState({
      state: e.map(
        (s) => ({
          colId: typeof s == "string" ? s : s.getColId(),
          hide: !t
        })
      )
    }, i);
  }
  setColumnsPinned(e, t, i) {
    if (!this.gridColumns)
      return;
    if (this.gos.isDomLayout("print")) {
      console.warn("AG Grid: Changing the column pinning status is not allowed with domLayout='print'");
      return;
    }
    this.columnAnimationService.start();
    let s;
    t === !0 || t === "left" ? s = "left" : t === "right" ? s = "right" : s = null, this.actionOnGridColumns(e, (o) => o.getPinned() !== s ? (o.setPinned(s), !0) : !1, i, () => ({
      type: p.EVENT_COLUMN_PINNED,
      pinned: s,
      column: null,
      columns: null,
      source: i
    })), this.columnAnimationService.finish();
  }
  // does an action on a set of columns. provides common functionality for looking up the
  // columns based on key, getting a list of effected columns, and then updated the event
  // with either one column (if it was just one col) or a list of columns
  // used by: autoResize, setVisible, setPinned
  actionOnGridColumns(e, t, i, s) {
    if (It(e))
      return;
    const o = [];
    if (e.forEach((r) => {
      if (!r)
        return;
      const n = this.getGridColumn(r);
      if (!n)
        return;
      t(n) !== !1 && o.push(n);
    }), !!o.length && (this.updateDisplayedColumns(i), b(s) && s)) {
      const r = s();
      r.columns = o, r.column = o.length === 1 ? o[0] : null, this.eventService.dispatchEvent(r);
    }
  }
  getDisplayedColBefore(e) {
    const t = this.getAllDisplayedColumns(), i = t.indexOf(e);
    return i > 0 ? t[i - 1] : null;
  }
  // used by:
  // + rowRenderer -> for navigation
  getDisplayedColAfter(e) {
    const t = this.getAllDisplayedColumns(), i = t.indexOf(e);
    return i < t.length - 1 ? t[i + 1] : null;
  }
  getDisplayedGroupAtDirection(e, t) {
    const i = e.getProvidedColumnGroup().getLevel() + e.getPaddingLevel(), s = e.getDisplayedLeafColumns(), o = t === "After" ? se(s) : s[0], r = `getDisplayedCol${t}`;
    for (; ; ) {
      const n = this[r](o);
      if (!n)
        return null;
      const l = this.getColumnGroupAtLevel(n, i);
      if (l !== e)
        return l;
    }
  }
  getColumnGroupAtLevel(e, t) {
    let i = e.getParent(), s, o;
    for (; s = i.getProvidedColumnGroup().getLevel(), o = i.getPaddingLevel(), !(s + o <= t); )
      i = i.getParent();
    return i;
  }
  isPinningLeft() {
    return this.displayedColumnsLeft.length > 0;
  }
  isPinningRight() {
    return this.displayedColumnsRight.length > 0;
  }
  getPrimaryAndSecondaryAndAutoColumns() {
    return [].concat(this.primaryColumns || [], this.groupAutoColumns || [], this.secondaryColumns || []);
  }
  createStateItemFromColumn(e) {
    const t = e.isRowGroupActive() ? this.rowGroupColumns.indexOf(e) : null, i = e.isPivotActive() ? this.pivotColumns.indexOf(e) : null, s = e.isValueActive() ? e.getAggFunc() : null, o = e.getSort() != null ? e.getSort() : null, r = e.getSortIndex() != null ? e.getSortIndex() : null, n = e.getFlex() != null && e.getFlex() > 0 ? e.getFlex() : null;
    return {
      colId: e.getColId(),
      width: e.getActualWidth(),
      hide: !e.isVisible(),
      pinned: e.getPinned(),
      sort: o,
      sortIndex: r,
      aggFunc: s,
      rowGroup: e.isRowGroupActive(),
      rowGroupIndex: t,
      pivot: e.isPivotActive(),
      pivotIndex: i,
      flex: n
    };
  }
  getColumnState() {
    if (z(this.primaryColumns) || !this.isAlive())
      return [];
    const t = this.getPrimaryAndSecondaryAndAutoColumns().map(this.createStateItemFromColumn.bind(this));
    return this.orderColumnStateList(t), t;
  }
  orderColumnStateList(e) {
    const t = Ai(this.gridColumns.map((i, s) => [i.getColId(), s]));
    e.sort((i, s) => {
      const o = t.has(i.colId) ? t.get(i.colId) : -1, r = t.has(s.colId) ? t.get(s.colId) : -1;
      return o - r;
    });
  }
  resetColumnState(e) {
    if (It(this.primaryColumns))
      return;
    const t = this.getColumnsFromTree(this.primaryColumnTree), i = [];
    let s = 1e3, o = 1e3, r = [];
    this.groupAutoColumns && (r = r.concat(this.groupAutoColumns)), t && (r = r.concat(t)), r.forEach((n) => {
      const l = this.getColumnStateFromColDef(n);
      z(l.rowGroupIndex) && l.rowGroup && (l.rowGroupIndex = s++), z(l.pivotIndex) && l.pivot && (l.pivotIndex = o++), i.push(l);
    }), this.applyColumnState({ state: i, applyOrder: !0 }, e);
  }
  getColumnStateFromColDef(e) {
    const t = (C, w) => C ?? w ?? null, i = e.getColDef(), s = t(i.sort, i.initialSort), o = t(i.sortIndex, i.initialSortIndex), r = t(i.hide, i.initialHide), n = t(i.pinned, i.initialPinned), l = t(i.width, i.initialWidth), a = t(i.flex, i.initialFlex);
    let d = t(i.rowGroupIndex, i.initialRowGroupIndex), c = t(i.rowGroup, i.initialRowGroup);
    d == null && (c == null || c == !1) && (d = null, c = null);
    let h = t(i.pivotIndex, i.initialPivotIndex), g = t(i.pivot, i.initialPivot);
    h == null && (g == null || g == !1) && (h = null, g = null);
    const m = t(i.aggFunc, i.initialAggFunc);
    return {
      colId: e.getColId(),
      sort: s,
      sortIndex: o,
      hide: r,
      pinned: n,
      width: l,
      flex: a,
      rowGroup: c,
      rowGroupIndex: d,
      pivot: g,
      pivotIndex: h,
      aggFunc: m
    };
  }
  applyColumnState(e, t) {
    if (It(this.primaryColumns))
      return !1;
    if (e && e.state && !e.state.forEach)
      return console.warn("AG Grid: applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state."), !1;
    const i = (r, n, l) => {
      const a = this.compareColumnStatesAndDispatchEvents(t);
      this.autoGroupsNeedBuilding = !0;
      const d = n.slice(), c = {}, h = {}, g = [], m = [];
      let C = 0;
      const w = this.rowGroupColumns.slice(), v = this.pivotColumns.slice();
      r.forEach((R) => {
        const T = R.colId || "";
        if (T.startsWith(js)) {
          g.push(R), m.push(R);
          return;
        }
        const A = l(T);
        A ? (this.syncColumnWithStateItem(
          A,
          R,
          e.defaultState,
          c,
          h,
          !1,
          t
        ), gt(d, A)) : (m.push(R), C += 1);
      });
      const y = (R) => this.syncColumnWithStateItem(
        R,
        null,
        e.defaultState,
        c,
        h,
        !1,
        t
      );
      d.forEach(y);
      const E = (R, T, I, A) => {
        const V = R[I.getId()], x = R[A.getId()], k = V != null, B = x != null;
        if (k && B)
          return V - x;
        if (k)
          return -1;
        if (B)
          return 1;
        const Q = T.indexOf(I), U = T.indexOf(A), me = Q >= 0, Ce = U >= 0;
        return me && Ce ? Q - U : me ? -1 : 1;
      };
      this.rowGroupColumns.sort(E.bind(this, c, w)), this.pivotColumns.sort(E.bind(this, h, v)), this.updateGridColumns();
      const D = this.groupAutoColumns ? this.groupAutoColumns.slice() : [];
      return g.forEach((R) => {
        const T = this.getAutoColumn(R.colId);
        gt(D, T), this.syncColumnWithStateItem(T, R, e.defaultState, null, null, !0, t);
      }), D.forEach(y), this.applyOrderAfterApplyState(e), this.updateDisplayedColumns(t), this.dispatchEverythingChanged(t), a(), { unmatchedAndAutoStates: m, unmatchedCount: C };
    };
    this.columnAnimationService.start();
    let {
      unmatchedAndAutoStates: s,
      unmatchedCount: o
    } = i(e.state || [], this.primaryColumns || [], (r) => this.getPrimaryColumn(r));
    return (s.length > 0 || b(e.defaultState)) && (o = i(
      s,
      this.secondaryColumns || [],
      (r) => this.getSecondaryColumn(r)
    ).unmatchedCount), this.columnAnimationService.finish(), o === 0;
  }
  applyOrderAfterApplyState(e) {
    if (!e.applyOrder || !e.state)
      return;
    let t = [];
    const i = {};
    e.state.forEach((o) => {
      if (!o.colId || i[o.colId])
        return;
      const r = this.gridColumnsMap[o.colId];
      r && (t.push(r), i[o.colId] = !0);
    });
    let s = 0;
    if (this.gridColumns.forEach((o) => {
      const r = o.getColId();
      if (i[r] != null)
        return;
      r.startsWith(js) ? Ho(t, o, s++) : t.push(o);
    }), t = this.placeLockedColumns(t), !this.doesMovePassMarryChildren(t)) {
      console.warn("AG Grid: Applying column order broke a group where columns should be married together. Applying new order has been discarded.");
      return;
    }
    this.gridColumns = t;
  }
  compareColumnStatesAndDispatchEvents(e) {
    const t = {
      rowGroupColumns: this.rowGroupColumns.slice(),
      pivotColumns: this.pivotColumns.slice(),
      valueColumns: this.valueColumns.slice()
    }, i = this.getColumnState(), s = {};
    return i.forEach((o) => {
      s[o.colId] = o;
    }), () => {
      const o = this.getPrimaryAndSecondaryAndAutoColumns(), r = (w, v, y, E) => {
        const D = v.map(E), R = y.map(E);
        if (ii(D, R))
          return;
        const I = new Set(v);
        y.forEach((x) => {
          I.delete(x) || I.add(x);
        });
        const A = [...I], V = {
          type: w,
          columns: A,
          column: A.length === 1 ? A[0] : null,
          source: e
        };
        this.eventService.dispatchEvent(V);
      }, n = (w) => {
        const v = [];
        return o.forEach((y) => {
          const E = s[y.getColId()];
          E && w(E, y) && v.push(y);
        }), v;
      }, l = (w) => w.getColId();
      r(
        p.EVENT_COLUMN_ROW_GROUP_CHANGED,
        t.rowGroupColumns,
        this.rowGroupColumns,
        l
      ), r(
        p.EVENT_COLUMN_PIVOT_CHANGED,
        t.pivotColumns,
        this.pivotColumns,
        l
      );
      const d = n((w, v) => {
        const y = w.aggFunc != null, E = y != v.isValueActive(), D = y && w.aggFunc != v.getAggFunc();
        return E || D;
      });
      d.length > 0 && this.dispatchColumnChangedEvent(p.EVENT_COLUMN_VALUE_CHANGED, d, e);
      const c = (w, v) => w.width != v.getActualWidth();
      this.dispatchColumnResizedEvent(n(c), !0, e);
      const h = (w, v) => w.pinned != v.getPinned();
      this.dispatchColumnPinnedEvent(n(h), e);
      const g = (w, v) => w.hide == v.isVisible();
      this.dispatchColumnVisibleEvent(n(g), e);
      const C = n((w, v) => w.sort != v.getSort() || w.sortIndex != v.getSortIndex());
      C.length > 0 && this.sortController.dispatchSortChangedEvents(e, C), this.normaliseColumnMovedEventForColumnState(i, e);
    };
  }
  getCommonValue(e, t) {
    if (!e || e.length == 0)
      return;
    const i = t(e[0]);
    for (let s = 1; s < e.length; s++)
      if (i !== t(e[s]))
        return;
    return i;
  }
  normaliseColumnMovedEventForColumnState(e, t) {
    const i = this.getColumnState(), s = {};
    i.forEach((a) => s[a.colId] = a);
    const o = {};
    e.forEach((a) => {
      s[a.colId] && (o[a.colId] = !0);
    });
    const r = e.filter((a) => o[a.colId]), n = i.filter((a) => o[a.colId]), l = [];
    n.forEach((a, d) => {
      const c = r && r[d];
      if (c && c.colId !== a.colId) {
        const h = this.getGridColumn(c.colId);
        h && l.push(h);
      }
    }), l.length && this.dispatchColumnMovedEvent({ movedColumns: l, source: t, finished: !0 });
  }
  syncColumnWithStateItem(e, t, i, s, o, r, n) {
    var l;
    if (!e)
      return;
    const a = (R, T) => {
      const I = { value1: void 0, value2: void 0 };
      let A = !1;
      return t && (t[R] !== void 0 && (I.value1 = t[R], A = !0), b(T) && t[T] !== void 0 && (I.value2 = t[T], A = !0)), !A && i && (i[R] !== void 0 && (I.value1 = i[R]), b(T) && i[T] !== void 0 && (I.value2 = i[T])), I;
    }, d = a("hide").value1;
    d !== void 0 && e.setVisible(!d, n);
    const c = a("pinned").value1;
    c !== void 0 && e.setPinned(c);
    const h = (l = e.getColDef().minWidth) != null ? l : this.environment.getMinColWidth(), g = a("flex").value1;
    if (g !== void 0 && e.setFlex(g), g == null) {
      const R = a("width").value1;
      R != null && h != null && R >= h && e.setActualWidth(R, n);
    }
    const m = a("sort").value1;
    m !== void 0 && (m === "desc" || m === "asc" ? e.setSort(m, n) : e.setSort(void 0, n));
    const C = a("sortIndex").value1;
    if (C !== void 0 && e.setSortIndex(C), r || !e.isPrimary())
      return;
    const w = a("aggFunc").value1;
    w !== void 0 && (typeof w == "string" ? (e.setAggFunc(w), e.isValueActive() || (e.setValueActive(!0, n), this.valueColumns.push(e))) : (b(w) && console.warn("AG Grid: stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON."), e.isValueActive() && (e.setValueActive(!1, n), gt(this.valueColumns, e))));
    const { value1: v, value2: y } = a("rowGroup", "rowGroupIndex");
    (v !== void 0 || y !== void 0) && (typeof y == "number" || v ? (e.isRowGroupActive() || (e.setRowGroupActive(!0, n), this.rowGroupColumns.push(e)), s && typeof y == "number" && (s[e.getId()] = y)) : e.isRowGroupActive() && (e.setRowGroupActive(!1, n), gt(this.rowGroupColumns, e)));
    const { value1: E, value2: D } = a("pivot", "pivotIndex");
    (E !== void 0 || D !== void 0) && (typeof D == "number" || E ? (e.isPivotActive() || (e.setPivotActive(!0, n), this.pivotColumns.push(e)), o && typeof D == "number" && (o[e.getId()] = D)) : e.isPivotActive() && (e.setPivotActive(!1, n), gt(this.pivotColumns, e)));
  }
  getGridColumns(e) {
    return this.getColumns(e, this.getGridColumn.bind(this));
  }
  getColumns(e, t) {
    const i = [];
    return e && e.forEach((s) => {
      const o = t(s);
      o && i.push(o);
    }), i;
  }
  // used by growGroupPanel
  getColumnWithValidation(e) {
    if (e == null)
      return null;
    const t = this.getGridColumn(e);
    return t || console.warn("AG Grid: could not find column " + e), t;
  }
  getPrimaryColumn(e) {
    return this.primaryColumns ? this.getColumn(e, this.primaryColumns, this.primaryColumnsMap) : null;
  }
  getGridColumn(e) {
    return this.getColumn(e, this.gridColumns, this.gridColumnsMap);
  }
  lookupGridColumn(e) {
    return this.gridColumnsMap[e];
  }
  getSecondaryColumn(e) {
    return this.secondaryColumns ? this.getColumn(e, this.secondaryColumns, this.secondaryColumnsMap) : null;
  }
  getColumn(e, t, i) {
    if (!e || !i)
      return null;
    if (typeof e == "string" && i[e])
      return i[e];
    for (let s = 0; s < t.length; s++)
      if (this.columnsMatch(t[s], e))
        return t[s];
    return this.getAutoColumn(e);
  }
  getSourceColumnsForGroupColumn(e) {
    const t = e.getColDef().showRowGroup;
    if (!t)
      return null;
    if (t === !0)
      return this.rowGroupColumns.slice(0);
    const i = this.getPrimaryColumn(t);
    return i ? [i] : null;
  }
  getAutoColumn(e) {
    return !this.groupAutoColumns || !b(this.groupAutoColumns) || z(this.groupAutoColumns) ? null : this.groupAutoColumns.find((t) => this.columnsMatch(t, e)) || null;
  }
  columnsMatch(e, t) {
    const i = e === t, s = e.getColDef() === t, o = e.getColId() == t;
    return i || s || o;
  }
  getDisplayNameForColumn(e, t, i = !1) {
    if (!e)
      return null;
    const s = this.getHeaderName(e.getColDef(), e, null, null, t);
    return i ? this.wrapHeaderNameWithAggFunc(e, s) : s;
  }
  getDisplayNameForProvidedColumnGroup(e, t, i) {
    const s = t ? t.getColGroupDef() : null;
    return s ? this.getHeaderName(s, null, e, t, i) : null;
  }
  getDisplayNameForColumnGroup(e, t) {
    return this.getDisplayNameForProvidedColumnGroup(e, e.getProvidedColumnGroup(), t);
  }
  // location is where the column is going to appear, ie who is calling us
  getHeaderName(e, t, i, s, o) {
    const r = e.headerValueGetter;
    if (r) {
      const n = this.gos.addGridCommonParams({
        colDef: e,
        column: t,
        columnGroup: i,
        providedColumnGroup: s,
        location: o
      });
      return typeof r == "function" ? r(n) : typeof r == "string" ? this.expressionService.evaluate(r, n) : (console.warn("AG Grid: headerValueGetter must be a function or a string"), "");
    } else {
      if (e.headerName != null)
        return e.headerName;
      if (e.field)
        return Ou(e.field);
    }
    return "";
  }
  wrapHeaderNameWithAggFunc(e, t) {
    if (this.gos.get("suppressAggFuncInHeader"))
      return t;
    const i = e.getColDef().pivotValueColumn, s = b(i);
    let o = null, r;
    if (s) {
      const n = this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && this.valueColumns.length === 1, l = e.getColDef().pivotTotalColumnIds !== void 0;
      if (n && !l)
        return t;
      o = i ? i.getAggFunc() : null, r = !0;
    } else {
      const n = e.isValueActive(), l = this.pivotMode || !this.isRowGroupEmpty();
      n && l ? (o = e.getAggFunc(), r = !0) : r = !1;
    }
    if (r) {
      const n = typeof o == "string" ? o : "func";
      return `${this.localeService.getLocaleTextFunc()(n, n)}(${t})`;
    }
    return t;
  }
  // returns the group with matching colId and instanceId. If instanceId is missing,
  // matches only on the colId.
  getColumnGroup(e, t) {
    if (!e)
      return null;
    if (e instanceof Ke)
      return e;
    const i = this.getAllDisplayedTrees(), s = typeof t == "number";
    let o = null;
    return Yi(i, !1, (r) => {
      if (r instanceof Ke) {
        const n = r;
        let l;
        s ? l = e === n.getGroupId() && t === n.getPartId() : l = e === n.getGroupId(), l && (o = n);
      }
    }), o;
  }
  isReady() {
    return this.ready;
  }
  extractValueColumns(e, t) {
    this.valueColumns = this.extractColumns(
      t,
      this.valueColumns,
      (i, s) => i.setValueActive(s, e),
      // aggFunc doesn't have index variant, cos order of value cols doesn't matter, so always return null
      () => {
      },
      () => {
      },
      // aggFunc is a string, so return it's existence
      (i) => {
        const s = i.aggFunc;
        if (s === null || s === "")
          return null;
        if (s !== void 0)
          return !!s;
      },
      (i) => i.initialAggFunc != null && i.initialAggFunc != ""
    ), this.valueColumns.forEach((i) => {
      const s = i.getColDef();
      s.aggFunc != null && s.aggFunc != "" ? i.setAggFunc(s.aggFunc) : i.getAggFunc() || i.setAggFunc(s.initialAggFunc);
    });
  }
  extractRowGroupColumns(e, t) {
    this.rowGroupColumns = this.extractColumns(
      t,
      this.rowGroupColumns,
      (i, s) => i.setRowGroupActive(s, e),
      (i) => i.rowGroupIndex,
      (i) => i.initialRowGroupIndex,
      (i) => i.rowGroup,
      (i) => i.initialRowGroup
    );
  }
  extractColumns(e = [], t = [], i, s, o, r, n) {
    const l = [], a = [];
    (this.primaryColumns || []).forEach((h) => {
      const g = e.indexOf(h) < 0, m = h.getColDef(), C = jr(r(m)), w = jr(n(m)), v = Li(s(m)), y = Li(o(m));
      let E;
      C !== void 0 ? E = C : v !== void 0 ? v === null ? E = !1 : E = v >= 0 : g ? w !== void 0 ? E = w : y !== void 0 ? E = y != null && y >= 0 : E = !1 : E = t.indexOf(h) >= 0, E && ((g ? v != null || y != null : v != null) ? l.push(h) : a.push(h));
    });
    const d = (h) => {
      const g = s(h.getColDef()), m = o(h.getColDef());
      return g ?? m;
    };
    l.sort((h, g) => {
      const m = d(h), C = d(g);
      return m === C ? 0 : m < C ? -1 : 1;
    });
    const c = [].concat(l);
    return t.forEach((h) => {
      a.indexOf(h) >= 0 && c.push(h);
    }), a.forEach((h) => {
      c.indexOf(h) < 0 && c.push(h);
    }), t.forEach((h) => {
      c.indexOf(h) < 0 && i(h, !1);
    }), c.forEach((h) => {
      t.indexOf(h) < 0 && i(h, !0);
    }), c;
  }
  extractPivotColumns(e, t) {
    this.pivotColumns = this.extractColumns(
      t,
      this.pivotColumns,
      (i, s) => i.setPivotActive(s, e),
      (i) => i.pivotIndex,
      (i) => i.initialPivotIndex,
      (i) => i.pivot,
      (i) => i.initialPivot
    );
  }
  resetColumnGroupState(e) {
    if (!this.primaryColumnTree)
      return;
    const t = [];
    hi(null, this.primaryColumnTree, (i) => {
      if (i instanceof Ge) {
        const s = i.getColGroupDef(), o = {
          groupId: i.getGroupId(),
          open: s ? s.openByDefault : void 0
        };
        t.push(o);
      }
    }), this.setColumnGroupState(t, e);
  }
  getColumnGroupState() {
    const e = [];
    return hi(null, this.gridBalancedTree, (t) => {
      t instanceof Ge && e.push({
        groupId: t.getGroupId(),
        open: t.isExpanded()
      });
    }), e;
  }
  setColumnGroupState(e, t) {
    if (!this.gridBalancedTree)
      return;
    this.columnAnimationService.start();
    const i = [];
    if (e.forEach((s) => {
      const o = s.groupId, r = s.open, n = this.getProvidedColumnGroup(o);
      n && n.isExpanded() !== r && (this.logger.log("columnGroupOpened(" + n.getGroupId() + "," + r + ")"), n.setExpanded(r), i.push(n));
    }), this.updateGroupsAndDisplayedColumns(t), this.setFirstRightAndLastLeftPinned(t), i.length) {
      const s = {
        type: p.EVENT_COLUMN_GROUP_OPENED,
        columnGroup: Ge.length === 1 ? i[0] : void 0,
        columnGroups: i
      };
      this.eventService.dispatchEvent(s);
    }
    this.columnAnimationService.finish();
  }
  // called by headerRenderer - when a header is opened or closed
  setColumnGroupOpened(e, t, i) {
    let s;
    e instanceof Ge ? s = e.getId() : s = e || "", this.setColumnGroupState([{ groupId: s, open: t }], i);
  }
  getProvidedColumnGroup(e) {
    typeof e != "string" && console.error("AG Grid: group key must be a string");
    let t = null;
    return hi(null, this.gridBalancedTree, (i) => {
      i instanceof Ge && i.getId() === e && (t = i);
    }), t;
  }
  calculateColumnsForDisplay() {
    let e;
    return this.pivotMode && z(this.secondaryColumns) ? e = this.gridColumns.filter((t) => {
      const i = this.groupAutoColumns && Tt(this.groupAutoColumns, t), s = this.valueColumns && Tt(this.valueColumns, t);
      return i || s;
    }) : e = this.gridColumns.filter((t) => this.groupAutoColumns && Tt(this.groupAutoColumns, t) || t.isVisible()), e;
  }
  checkColSpanActiveInCols(e) {
    let t = !1;
    return e.forEach((i) => {
      b(i.getColDef().colSpan) && (t = !0);
    }), t;
  }
  calculateColumnsForGroupDisplay() {
    this.groupDisplayColumns = [], this.groupDisplayColumnsMap = {};
    const e = (t) => {
      const i = t.getColDef(), s = i.showRowGroup;
      i && b(s) && (this.groupDisplayColumns.push(t), typeof s == "string" ? this.groupDisplayColumnsMap[s] = t : s === !0 && this.getRowGroupColumns().forEach((o) => {
        this.groupDisplayColumnsMap[o.getId()] = t;
      }));
    };
    this.gridColumns.forEach(e);
  }
  getGroupDisplayColumns() {
    return this.groupDisplayColumns;
  }
  getGroupDisplayColumnForGroup(e) {
    return this.groupDisplayColumnsMap[e];
  }
  updateDisplayedColumns(e) {
    const t = this.calculateColumnsForDisplay();
    this.buildDisplayedTrees(t), this.updateGroupsAndDisplayedColumns(e), this.setFirstRightAndLastLeftPinned(e);
  }
  isSecondaryColumnsPresent() {
    return b(this.secondaryColumns);
  }
  setSecondaryColumns(e, t) {
    if (!this.gridColumns)
      return;
    const i = e;
    if (!(!i && z(this.secondaryColumns))) {
      if (i) {
        this.processSecondaryColumnDefinitions(e);
        const s = this.columnFactory.createColumnTree(
          e,
          !1,
          this.secondaryBalancedTree || this.previousSecondaryColumns || void 0,
          t
        );
        this.destroyOldColumns(this.secondaryBalancedTree, s.columnTree), this.secondaryBalancedTree = s.columnTree, this.secondaryHeaderRowCount = s.treeDept + 1, this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree), this.secondaryColumnsMap = {}, this.secondaryColumns.forEach((o) => this.secondaryColumnsMap[o.getId()] = o), this.previousSecondaryColumns = null;
      } else
        this.previousSecondaryColumns = this.secondaryBalancedTree, this.secondaryBalancedTree = null, this.secondaryHeaderRowCount = -1, this.secondaryColumns = null, this.secondaryColumnsMap = {};
      this.updateGridColumns(), this.updateDisplayedColumns(t);
    }
  }
  processSecondaryColumnDefinitions(e) {
    const t = this.gos.get("processPivotResultColDef"), i = this.gos.get("processPivotResultColGroupDef");
    if (!t && !i)
      return;
    const s = (o) => {
      o.forEach((r) => {
        if (b(r.children)) {
          const l = r;
          i && i(l), s(l.children);
        } else
          t && t(r);
      });
    };
    e && s(e);
  }
  // called from: applyColumnState, setColumnDefs, setSecondaryColumns
  updateGridColumns() {
    const e = this.gridBalancedTree;
    if (this.gridColsArePrimary ? this.lastPrimaryOrder = this.gridColumns : this.lastSecondaryOrder = this.gridColumns, this.createGroupAutoColumnsIfNeeded()) {
      const s = Ai(this.groupAutoColumns.map((o) => [o, !0]));
      this.lastPrimaryOrder && (this.lastPrimaryOrder = this.lastPrimaryOrder.filter((o) => !s.has(o)), this.lastPrimaryOrder = [...this.groupAutoColumns, ...this.lastPrimaryOrder]), this.lastSecondaryOrder && (this.lastSecondaryOrder = this.lastSecondaryOrder.filter((o) => !s.has(o)), this.lastSecondaryOrder = [...this.groupAutoColumns, ...this.lastSecondaryOrder]);
    }
    let i;
    if (this.secondaryColumns && this.secondaryBalancedTree) {
      const s = this.secondaryColumns.some((o) => this.gridColumnsMap[o.getColId()] !== void 0);
      this.gridBalancedTree = this.secondaryBalancedTree.slice(), this.gridHeaderRowCount = this.secondaryHeaderRowCount, this.gridColumns = this.secondaryColumns.slice(), this.gridColsArePrimary = !1, s && (i = this.lastSecondaryOrder);
    } else this.primaryColumns && (this.gridBalancedTree = this.primaryColumnTree.slice(), this.gridHeaderRowCount = this.primaryHeaderRowCount, this.gridColumns = this.primaryColumns.slice(), this.gridColsArePrimary = !0, i = this.lastPrimaryOrder);
    if (this.addAutoGroupToGridColumns(), this.orderGridColsLike(i), this.gridColumns = this.placeLockedColumns(this.gridColumns), this.calculateColumnsForGroupDisplay(), this.refreshQuickFilterColumns(), this.clearDisplayedAndViewportColumns(), this.colSpanActive = this.checkColSpanActiveInCols(this.gridColumns), this.gridColumnsMap = {}, this.gridColumns.forEach((s) => this.gridColumnsMap[s.getId()] = s), this.setAutoHeightActive(), !ii(e, this.gridBalancedTree)) {
      const s = {
        type: p.EVENT_GRID_COLUMNS_CHANGED
      };
      this.eventService.dispatchEvent(s);
    }
  }
  setAutoHeightActive() {
    this.autoHeightActive = this.gridColumns.filter((e) => e.isAutoHeight()).length > 0, this.autoHeightActive && (this.autoHeightActiveAtLeastOnce = !0, this.gos.isRowModelType("clientSide") || this.gos.isRowModelType("serverSide") || H("autoHeight columns only work with Client Side Row Model and Server Side Row Model."));
  }
  orderGridColsLike(e) {
    if (z(e))
      return;
    const t = Ai(e.map((a, d) => [a, d]));
    let i = !0;
    if (this.gridColumns.forEach((a) => {
      t.has(a) && (i = !1);
    }), i)
      return;
    const s = Ai(this.gridColumns.map((a) => [a, !0])), o = e.filter((a) => s.has(a)), r = Ai(o.map((a) => [a, !0])), n = this.gridColumns.filter((a) => !r.has(a)), l = o.slice();
    n.forEach((a) => {
      let d = a.getOriginalParent();
      if (!d) {
        l.push(a);
        return;
      }
      const c = [];
      for (; !c.length && d; )
        d.getLeafColumns().forEach((C) => {
          const w = l.indexOf(C) >= 0, v = c.indexOf(C) < 0;
          w && v && c.push(C);
        }), d = d.getOriginalParent();
      if (!c.length) {
        l.push(a);
        return;
      }
      const h = c.map((m) => l.indexOf(m)), g = Math.max(...h);
      Ho(l, a, g + 1);
    }), this.gridColumns = l;
  }
  isPrimaryColumnGroupsPresent() {
    return this.primaryHeaderRowCount > 1;
  }
  // if we are using autoGroupCols, then they should be included for quick filter. this covers the
  // following scenarios:
  // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
  // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
  //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
  refreshQuickFilterColumns() {
    var e;
    let t = (e = this.isPivotMode() && !this.gos.get("applyQuickFilterBeforePivotOrAgg") ? this.secondaryColumns : this.primaryColumns) != null ? e : [];
    this.groupAutoColumns && (t = t.concat(this.groupAutoColumns)), this.columnsForQuickFilter = this.gos.get("includeHiddenColumnsInQuickFilter") ? t : t.filter((i) => i.isVisible() || i.isRowGroupActive());
  }
  placeLockedColumns(e) {
    const t = [], i = [], s = [];
    return e.forEach((o) => {
      const r = o.getColDef().lockPosition;
      r === "right" ? s.push(o) : r === "left" || r === !0 ? t.push(o) : i.push(o);
    }), [...t, ...i, ...s];
  }
  addAutoGroupToGridColumns() {
    if (z(this.groupAutoColumns)) {
      this.destroyOldColumns(this.groupAutoColsBalancedTree), this.groupAutoColsBalancedTree = null;
      return;
    }
    this.gridColumns = this.groupAutoColumns ? this.groupAutoColumns.concat(this.gridColumns) : this.gridColumns;
    const e = this.columnFactory.createForAutoGroups(this.groupAutoColumns, this.gridBalancedTree);
    this.destroyOldColumns(this.groupAutoColsBalancedTree, e), this.groupAutoColsBalancedTree = e, this.gridBalancedTree = e.concat(this.gridBalancedTree);
  }
  // gets called after we copy down grid columns, to make sure any part of the gui
  // that tries to draw, eg the header, it will get empty lists of columns rather
  // than stale columns. for example, the header will received gridColumnsChanged
  // event, so will try and draw, but it will draw successfully when it acts on the
  // virtualColumnsChanged event
  clearDisplayedAndViewportColumns() {
    this.viewportRowLeft = {}, this.viewportRowRight = {}, this.viewportRowCenter = {}, this.displayedColumnsLeft = [], this.displayedColumnsRight = [], this.displayedColumnsCenter = [], this.displayedColumns = [], this.ariaOrderColumns = [], this.viewportColumns = [], this.headerViewportColumns = [], this.viewportColumnsHash = "";
  }
  updateGroupsAndDisplayedColumns(e) {
    this.updateOpenClosedVisibilityInColumnGroups(), this.deriveDisplayedColumns(e), this.refreshFlexedColumns(), this.extractViewport(), this.updateBodyWidths();
    const t = {
      type: p.EVENT_DISPLAYED_COLUMNS_CHANGED
    };
    this.eventService.dispatchEvent(t);
  }
  deriveDisplayedColumns(e) {
    this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeLeft, this.displayedColumnsLeft), this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeCentre, this.displayedColumnsCenter), this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeRight, this.displayedColumnsRight), this.joinColumnsAriaOrder(), this.joinDisplayedColumns(), this.setLeftValues(e), this.displayedAutoHeightCols = this.displayedColumns.filter((t) => t.isAutoHeight());
  }
  isAutoRowHeightActive() {
    return this.autoHeightActive;
  }
  wasAutoRowHeightEverActive() {
    return this.autoHeightActiveAtLeastOnce;
  }
  joinColumnsAriaOrder() {
    const e = this.getAllGridColumns(), t = [], i = [], s = [];
    for (const o of e) {
      const r = o.getPinned();
      r ? r === !0 || r === "left" ? t.push(o) : s.push(o) : i.push(o);
    }
    this.ariaOrderColumns = t.concat(i).concat(s);
  }
  joinDisplayedColumns() {
    this.gos.get("enableRtl") ? this.displayedColumns = this.displayedColumnsRight.concat(this.displayedColumnsCenter).concat(this.displayedColumnsLeft) : this.displayedColumns = this.displayedColumnsLeft.concat(this.displayedColumnsCenter).concat(this.displayedColumnsRight);
  }
  // sets the left pixel position of each column
  setLeftValues(e) {
    this.setLeftValuesOfColumns(e), this.setLeftValuesOfGroups();
  }
  setLeftValuesOfColumns(e) {
    if (!this.primaryColumns)
      return;
    const t = this.getPrimaryAndSecondaryAndAutoColumns().slice(0), i = this.gos.get("enableRtl");
    [
      this.displayedColumnsLeft,
      this.displayedColumnsRight,
      this.displayedColumnsCenter
    ].forEach((s) => {
      if (i) {
        let o = this.getWidthOfColsInList(s);
        s.forEach((r) => {
          o -= r.getActualWidth(), r.setLeft(o, e);
        });
      } else {
        let o = 0;
        s.forEach((r) => {
          r.setLeft(o, e), o += r.getActualWidth();
        });
      }
      bu(t, s);
    }), t.forEach((s) => {
      s.setLeft(null, e);
    });
  }
  setLeftValuesOfGroups() {
    [
      this.displayedTreeLeft,
      this.displayedTreeRight,
      this.displayedTreeCentre
    ].forEach((e) => {
      e.forEach((t) => {
        t instanceof Ke && t.checkLeft();
      });
    });
  }
  derivedDisplayedColumnsFromDisplayedTree(e, t) {
    t.length = 0, Yi(e, !0, (i) => {
      i instanceof pe && t.push(i);
    });
  }
  isColumnVirtualisationSuppressed() {
    return this.suppressColumnVirtualisation || this.viewportRight === 0;
  }
  extractViewportColumns() {
    this.isColumnVirtualisationSuppressed() ? (this.viewportColumnsCenter = this.displayedColumnsCenter, this.headerViewportColumnsCenter = this.displayedColumnsCenter) : (this.viewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInRowViewport.bind(this)), this.headerViewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInHeaderViewport.bind(this))), this.viewportColumns = this.viewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight), this.headerViewportColumns = this.headerViewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight);
  }
  getVirtualHeaderGroupRow(e, t) {
    let i;
    switch (e) {
      case "left":
        i = this.viewportRowLeft[t];
        break;
      case "right":
        i = this.viewportRowRight[t];
        break;
      default:
        i = this.viewportRowCenter[t];
        break;
    }
    return z(i) && (i = []), i;
  }
  calculateHeaderRows() {
    this.viewportRowLeft = {}, this.viewportRowRight = {}, this.viewportRowCenter = {};
    const e = {};
    this.headerViewportColumns.forEach((i) => e[i.getId()] = !0);
    const t = (i, s, o) => {
      let r = !1;
      for (let n = 0; n < i.length; n++) {
        const l = i[n];
        let a = !1;
        if (l instanceof pe)
          a = e[l.getId()] === !0;
        else {
          const c = l.getDisplayedChildren();
          c && (a = t(c, s, o + 1));
        }
        a && (r = !0, s[o] || (s[o] = []), s[o].push(l));
      }
      return r;
    };
    t(this.displayedTreeLeft, this.viewportRowLeft, 0), t(this.displayedTreeRight, this.viewportRowRight, 0), t(this.displayedTreeCentre, this.viewportRowCenter, 0);
  }
  extractViewport() {
    const e = (s) => `${s.getId()}-${s.getPinned() || "normal"}`;
    this.extractViewportColumns();
    const t = this.viewportColumns.map(e).join("#"), i = this.viewportColumnsHash !== t;
    return i && (this.viewportColumnsHash = t, this.calculateHeaderRows()), i;
  }
  refreshFlexedColumns(e = {}) {
    var t;
    const i = e.source ? e.source : "flex";
    if (e.viewportWidth != null && (this.flexViewportWidth = e.viewportWidth), !this.flexViewportWidth)
      return [];
    let s = -1;
    if (e.resizingCols) {
      const g = new Set(e.resizingCols);
      let m = this.displayedColumnsCenter;
      for (let C = m.length - 1; C >= 0; C--)
        if (g.has(m[C])) {
          s = C;
          break;
        }
    }
    let o = 0, r = [], n = 0, l = 0;
    for (let g = 0; g < this.displayedColumnsCenter.length; g++)
      this.displayedColumnsCenter[g].getFlex() && g > s ? (r.push(this.displayedColumnsCenter[g]), l += this.displayedColumnsCenter[g].getFlex(), n += (t = this.displayedColumnsCenter[g].getMinWidth()) != null ? t : 0) : o += this.displayedColumnsCenter[g].getActualWidth();
    if (!r.length)
      return [];
    let a = [];
    o + n > this.flexViewportWidth && (r.forEach((g) => {
      var m;
      return g.setActualWidth((m = g.getMinWidth()) != null ? m : 0, i);
    }), a = r, r = []);
    const d = [];
    let c;
    e:
      for (; ; ) {
        c = this.flexViewportWidth - o;
        const g = c / l;
        for (let m = 0; m < r.length; m++) {
          const C = r[m], w = g * C.getFlex();
          let v = 0;
          const y = C.getMinWidth(), E = C.getMaxWidth();
          if (b(y) && w < y ? v = y : b(E) && w > E && (v = E), v) {
            C.setActualWidth(v, i), sa(r, C), l -= C.getFlex(), a.push(C), o += C.getActualWidth();
            continue e;
          }
          d[m] = Math.round(w);
        }
        break;
      }
    let h = c;
    return r.forEach((g, m) => {
      g.setActualWidth(Math.min(d[m], h), i), a.push(g), h -= d[m];
    }), e.skipSetLeft || this.setLeftValues(i), e.updateBodyWidths && this.updateBodyWidths(), e.fireResizedEvent && this.dispatchColumnResizedEvent(a, !0, i, r), r;
  }
  // called from api
  sizeColumnsToFit(e, t = "sizeColumnsToFit", i, s) {
    var o, r, n, l, a;
    if (this.shouldQueueResizeOperations) {
      this.resizeOperationQueue.push(() => this.sizeColumnsToFit(e, t, i, s));
      return;
    }
    const d = {};
    s && ((o = s == null ? void 0 : s.columnLimits) == null || o.forEach((y) => {
      var E = y, { key: D } = E, R = Mp(E, ["key"]);
      d[typeof D == "string" ? D : D.getColId()] = R;
    }));
    const c = this.getAllDisplayedColumns(), h = e === this.getWidthOfColsInList(c);
    if (e <= 0 || !c.length || h)
      return;
    const g = [], m = [];
    c.forEach((y) => {
      y.getColDef().suppressSizeToFit === !0 ? m.push(y) : g.push(y);
    });
    const C = g.slice(0);
    let w = !1;
    const v = (y) => {
      gt(g, y), m.push(y);
    };
    for (g.forEach((y) => {
      var E, D;
      y.resetActualWidth(t);
      const R = d == null ? void 0 : d[y.getId()], T = (E = R == null ? void 0 : R.minWidth) != null ? E : s == null ? void 0 : s.defaultMinWidth, I = (D = R == null ? void 0 : R.maxWidth) != null ? D : s == null ? void 0 : s.defaultMaxWidth, A = y.getActualWidth();
      typeof T == "number" && A < T ? y.setActualWidth(T, t, !0) : typeof I == "number" && A > I && y.setActualWidth(I, t, !0);
    }); !w; ) {
      w = !0;
      const y = e - this.getWidthOfColsInList(m);
      if (y <= 0)
        g.forEach((E) => {
          var D, R;
          const T = (R = (D = d == null ? void 0 : d[E.getId()]) == null ? void 0 : D.minWidth) != null ? R : s == null ? void 0 : s.defaultMinWidth;
          if (typeof T == "number") {
            E.setActualWidth(T, t, !0);
            return;
          }
          E.setMinimum(t);
        });
      else {
        const E = y / this.getWidthOfColsInList(g);
        let D = y;
        for (let R = g.length - 1; R >= 0; R--) {
          const T = g[R], I = d == null ? void 0 : d[T.getId()], A = (r = I == null ? void 0 : I.minWidth) != null ? r : s == null ? void 0 : s.defaultMinWidth, V = (n = I == null ? void 0 : I.maxWidth) != null ? n : s == null ? void 0 : s.defaultMaxWidth, x = (l = T.getMinWidth()) != null ? l : 0, k = (a = T.getMaxWidth()) != null ? a : Number.MAX_VALUE, B = typeof A == "number" && A > x ? A : T.getMinWidth(), Q = typeof V == "number" && V < k ? V : T.getMaxWidth();
          let U = Math.round(T.getActualWidth() * E);
          b(B) && U < B ? (U = B, v(T), w = !1) : b(Q) && U > Q ? (U = Q, v(T), w = !1) : R === 0 && (U = D), T.setActualWidth(U, t, !0), D -= U;
        }
      }
    }
    C.forEach((y) => {
      y.fireColumnWidthChangedEvent(t);
    }), this.setLeftValues(t), this.updateBodyWidths(), !i && this.dispatchColumnResizedEvent(C, !0, t);
  }
  buildDisplayedTrees(e) {
    const t = [], i = [], s = [];
    e.forEach((r) => {
      switch (r.getPinned()) {
        case "left":
          t.push(r);
          break;
        case "right":
          i.push(r);
          break;
        default:
          s.push(r);
          break;
      }
    });
    const o = new Nu();
    this.displayedTreeLeft = this.displayedGroupCreator.createDisplayedGroups(
      t,
      o,
      "left",
      this.displayedTreeLeft
    ), this.displayedTreeRight = this.displayedGroupCreator.createDisplayedGroups(
      i,
      o,
      "right",
      this.displayedTreeRight
    ), this.displayedTreeCentre = this.displayedGroupCreator.createDisplayedGroups(
      s,
      o,
      null,
      this.displayedTreeCentre
    ), this.updateDisplayedMap();
  }
  updateDisplayedMap() {
    this.displayedColumnsAndGroupsMap = {};
    const e = (t) => {
      this.displayedColumnsAndGroupsMap[t.getUniqueId()] = t;
    };
    Yi(this.displayedTreeCentre, !1, e), Yi(this.displayedTreeLeft, !1, e), Yi(this.displayedTreeRight, !1, e);
  }
  isDisplayed(e) {
    return this.displayedColumnsAndGroupsMap[e.getUniqueId()] === e;
  }
  updateOpenClosedVisibilityInColumnGroups() {
    const e = this.getAllDisplayedTrees();
    Yi(e, !1, (t) => {
      t instanceof Ke && t.calculateDisplayedColumns();
    });
  }
  getGroupAutoColumns() {
    return this.groupAutoColumns;
  }
  /**
   * Creates new auto group columns if required
   * @returns whether auto cols have changed
   */
  createGroupAutoColumnsIfNeeded() {
    const e = this.forceRecreateAutoGroups;
    if (this.forceRecreateAutoGroups = !1, !this.autoGroupsNeedBuilding)
      return !1;
    this.autoGroupsNeedBuilding = !1;
    const t = this.gos.isGroupUseEntireRow(this.pivotMode), i = this.pivotMode ? this.gos.get("pivotSuppressAutoColumn") : this.isGroupSuppressAutoColumn();
    if ((this.rowGroupColumns.length > 0 || this.gos.get("treeData")) && !i && !t) {
      const r = this.autoGroupColService.createAutoGroupColumns(this.rowGroupColumns);
      if (!this.autoColsEqual(r, this.groupAutoColumns) || e)
        return this.groupAutoColumns = r, !0;
    } else
      this.groupAutoColumns = null;
    return !1;
  }
  isGroupSuppressAutoColumn() {
    return this.gos.get("groupDisplayType") === "custom" ? !0 : this.gos.get("treeDataDisplayType") === "custom";
  }
  autoColsEqual(e, t) {
    return ii(e, t, (i, s) => i.getColId() === s.getColId());
  }
  getWidthOfColsInList(e) {
    return e.reduce((t, i) => t + i.getActualWidth(), 0);
  }
  getFirstDisplayedColumn() {
    const e = this.gos.get("enableRtl"), t = [
      "getDisplayedLeftColumns",
      "getDisplayedCenterColumns",
      "getDisplayedRightColumns"
    ];
    e && t.reverse();
    for (let i = 0; i < t.length; i++) {
      const s = this[t[i]]();
      if (s.length)
        return e ? se(s) : s[0];
    }
    return null;
  }
  setColumnHeaderHeight(e, t) {
    if (e.setAutoHeaderHeight(t)) {
      const s = {
        type: p.EVENT_COLUMN_HEADER_HEIGHT_CHANGED,
        column: e,
        columns: [e],
        source: "autosizeColumnHeaderHeight"
      };
      this.eventService.dispatchEvent(s);
    }
  }
  getColumnGroupHeaderRowHeight() {
    return this.isPivotMode() ? this.getPivotGroupHeaderHeight() : this.getGroupHeaderHeight();
  }
  getColumnHeaderRowHeight() {
    const e = this.isPivotMode() ? this.getPivotHeaderHeight() : this.getHeaderHeight(), t = this.getAllDisplayedColumns().filter((i) => i.isAutoHeaderHeight()).map((i) => i.getAutoHeaderHeight() || 0);
    return Math.max(e, ...t);
  }
  getHeaderHeight() {
    var e;
    return (e = this.gos.get("headerHeight")) != null ? e : this.environment.getFromTheme(25, "headerHeight");
  }
  getFloatingFiltersHeight() {
    var e;
    return (e = this.gos.get("floatingFiltersHeight")) != null ? e : this.getHeaderHeight();
  }
  getGroupHeaderHeight() {
    var e;
    return (e = this.gos.get("groupHeaderHeight")) != null ? e : this.getHeaderHeight();
  }
  getPivotHeaderHeight() {
    var e;
    return (e = this.gos.get("pivotHeaderHeight")) != null ? e : this.getHeaderHeight();
  }
  getPivotGroupHeaderHeight() {
    var e;
    return (e = this.gos.get("pivotGroupHeaderHeight")) != null ? e : this.getGroupHeaderHeight();
  }
  queueResizeOperations() {
    this.shouldQueueResizeOperations = !0;
  }
  processResizeOperations() {
    this.shouldQueueResizeOperations = !1, this.resizeOperationQueue.forEach((e) => e()), this.resizeOperationQueue = [];
  }
  resetColumnDefIntoColumn(e, t) {
    const i = e.getUserProvidedColDef();
    if (!i)
      return !1;
    const s = this.columnFactory.addColumnDefaultAndTypes(i, e.getColId());
    return e.setColDef(s, i, t), !0;
  }
  isColumnGroupingLocked(e) {
    const t = this.gos.get("groupLockGroupColumns");
    if (!e.isRowGroupActive() || t === 0)
      return !1;
    if (t === -1)
      return !0;
    const i = this.rowGroupColumns.findIndex((s) => s.getColId() === e.getColId());
    return t > i;
  }
  generateColumnStateForRowGroupAndPivotIndexes(e, t) {
    let i = {};
    const s = (o, r, n, l, a, d) => {
      if (!r.length || !this.primaryColumns)
        return [];
      const c = Object.keys(o), h = new Set(c), g = new Set(c), m = new Set(r.map((T) => {
        const I = T.getColId();
        return g.delete(I), I;
      }).concat(c)), C = [], w = {};
      let v = 0;
      for (let T = 0; T < this.primaryColumns.length; T++) {
        const I = this.primaryColumns[T].getColId();
        m.has(I) && (C.push(I), w[I] = v++);
      }
      let y = 1e3, E = !1, D = 0;
      const R = (T) => {
        const I = w[T];
        for (let A = D; A < I; A++) {
          const V = C[A];
          g.has(V) && (o[V][a] = y++, g.delete(V));
        }
        D = I;
      };
      r.forEach((T) => {
        const I = T.getColId();
        if (h.has(I))
          R(I), o[I][a] = y++;
        else {
          const A = T.getColDef();
          (A[a] === null || A[a] === void 0 && A[d] == null) && (E || (A[n] || A[n] === void 0 && A[l] ? R(I) : (g.forEach((k) => {
            o[k][a] = y + w[k];
          }), y += C.length, E = !0)), i[I] || (i[I] = { colId: I }), i[I][a] = y++);
        }
      });
    };
    return s(e, this.rowGroupColumns, "rowGroup", "initialRowGroup", "rowGroupIndex", "initialRowGroupIndex"), s(t, this.pivotColumns, "pivot", "initialPivot", "pivotIndex", "initialPivotIndex"), Object.values(i);
  }
  onColumnsReady() {
    const e = this.gos.get("autoSizeStrategy");
    if (!e)
      return;
    const { type: t } = e;
    setTimeout(() => {
      if (t === "fitGridWidth") {
        const { columnLimits: i, defaultMinWidth: s, defaultMaxWidth: o } = e, r = i == null ? void 0 : i.map(({ colId: n, minWidth: l, maxWidth: a }) => ({
          key: n,
          minWidth: l,
          maxWidth: a
        }));
        this.ctrlsService.getGridBodyCtrl().sizeColumnsToFit({
          defaultMinWidth: s,
          defaultMaxWidth: o,
          columnLimits: r
        });
      } else t === "fitProvidedWidth" && this.sizeColumnsToFit(e.width, "sizeColumnsToFit");
    });
  }
  onFirstDataRendered() {
    const e = this.gos.get("autoSizeStrategy");
    if ((e == null ? void 0 : e.type) !== "fitCellContents")
      return;
    const { colIds: t, skipHeader: i } = e;
    setTimeout(() => {
      t ? this.autoSizeColumns({
        columns: t,
        skipHeader: i,
        source: "autosizeColumns"
      }) : this.autoSizeAllColumns("autosizeColumns", i);
    });
  }
};
u([
  f("expressionService")
], Ye.prototype, "expressionService", 2);
u([
  f("columnFactory")
], Ye.prototype, "columnFactory", 2);
u([
  f("displayedGroupCreator")
], Ye.prototype, "displayedGroupCreator", 2);
u([
  f("ctrlsService")
], Ye.prototype, "ctrlsService", 2);
u([
  f("autoWidthCalculator")
], Ye.prototype, "autoWidthCalculator", 2);
u([
  f("columnAnimationService")
], Ye.prototype, "columnAnimationService", 2);
u([
  f("autoGroupColService")
], Ye.prototype, "autoGroupColService", 2);
u([
  f("valueCache")
], Ye.prototype, "valueCache", 2);
u([
  f("animationFrameService")
], Ye.prototype, "animationFrameService", 2);
u([
  f("sortController")
], Ye.prototype, "sortController", 2);
u([
  f("columnDefFactory")
], Ye.prototype, "columnDefFactory", 2);
u([
  ue("aggFuncService")
], Ye.prototype, "aggFuncService", 2);
u([
  L
], Ye.prototype, "init", 1);
u([
  dt
], Ye.prototype, "destroyColumns", 1);
u([
  Kt(0, Mt("loggerFactory"))
], Ye.prototype, "setBeans", 1);
Ye = u([
  O("columnModel")
], Ye);
function Bs(e) {
  return e === "gridOptionsUpdated" ? "gridOptionsChanged" : e;
}
function Yi(e, t, i) {
  if (e)
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      if (o instanceof Ke) {
        const r = t ? o.getDisplayedChildren() : o.getChildren();
        Yi(r, t, i);
      }
      i(o);
    }
}
var Il = class extends F {
  createDisplayedGroups(e, t, i, s) {
    const o = this.mapOldGroupsById(s), r = [];
    let n = e;
    for (; n.length; ) {
      const l = n;
      n = [];
      let a = 0;
      const d = (c) => {
        const h = a;
        a = c;
        const g = l[h], C = (g instanceof Ke ? g.getProvidedColumnGroup() : g).getOriginalParent();
        if (C == null) {
          for (let v = h; v < c; v++)
            r.push(l[v]);
          return;
        }
        const w = this.createColumnGroup(
          C,
          t,
          o,
          i
        );
        for (let v = h; v < c; v++)
          w.addChild(l[v]);
        n.push(w);
      };
      for (let c = 1; c < l.length; c++) {
        const h = l[c], m = (h instanceof Ke ? h.getProvidedColumnGroup() : h).getOriginalParent(), C = l[a], v = (C instanceof Ke ? C.getProvidedColumnGroup() : C).getOriginalParent();
        m !== v && d(c);
      }
      a < l.length && d(l.length);
    }
    return this.setupParentsIntoColumns(r, null), r;
  }
  createColumnGroup(e, t, i, s) {
    const o = e.getGroupId(), r = t.getInstanceIdForKey(o), n = Ke.createUniqueId(o, r);
    let l = i[n];
    return l && l.getProvidedColumnGroup() !== e && (l = null), b(l) ? l.reset() : (l = new Ke(e, o, r, s), this.context.createBean(l)), l;
  }
  // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
  mapOldGroupsById(e) {
    const t = {}, i = (s) => {
      s.forEach((o) => {
        if (o instanceof Ke) {
          const r = o;
          t[o.getUniqueId()] = r, i(r.getChildren());
        }
      });
    };
    return e && i(e), t;
  }
  setupParentsIntoColumns(e, t) {
    e.forEach((i) => {
      if (i.setParent(t), i instanceof Ke) {
        const s = i;
        this.setupParentsIntoColumns(s.getChildren(), s);
      }
    });
  }
};
Il = u([
  O("displayedGroupCreator")
], Il);
var Jp = {
  enableBrowserTooltips: !0,
  tooltipTrigger: !0,
  tooltipMouseTrack: !0,
  tooltipShowMode: !0,
  tooltipInteraction: !0,
  defaultColGroupDef: !0,
  suppressAutoSize: !0,
  skipHeaderOnAutoSize: !0,
  autoSizeStrategy: !0,
  components: !0,
  stopEditingWhenCellsLoseFocus: !0,
  undoRedoCellEditing: !0,
  undoRedoCellEditingLimit: !0,
  excelStyles: !0,
  cacheQuickFilter: !0,
  excludeHiddenColumnsFromQuickFilter: !0,
  advancedFilterModel: !0,
  customChartThemes: !0,
  chartThemeOverrides: !0,
  enableChartToolPanelsButton: !0,
  suppressChartToolPanelsButton: !0,
  chartToolPanelsDef: !0,
  loadingCellRendererSelector: !0,
  localeText: !0,
  keepDetailRows: !0,
  keepDetailRowsCount: !0,
  detailRowHeight: !0,
  detailRowAutoHeight: !0,
  tabIndex: !0,
  valueCache: !0,
  valueCacheNeverExpires: !0,
  enableCellExpressions: !0,
  suppressParentsInRowNodes: !0,
  suppressTouch: !0,
  suppressAsyncEvents: !0,
  suppressBrowserResizeObserver: !0,
  suppressPropertyNamesCheck: !0,
  debug: !0,
  loadingOverlayComponent: !0,
  suppressLoadingOverlay: !0,
  noRowsOverlayComponent: !0,
  paginationPageSizeSelector: !0,
  paginateChildRows: !0,
  pivotPanelShow: !0,
  pivotSuppressAutoColumn: !0,
  suppressExpandablePivotGroups: !0,
  aggFuncs: !0,
  suppressAggFuncInHeader: !0,
  suppressAggAtRootLevel: !0,
  removePivotHeaderRowWhenSingleValueColumn: !0,
  allowShowChangeAfterFilter: !0,
  ensureDomOrder: !0,
  enableRtl: !0,
  suppressColumnVirtualisation: !0,
  suppressMaxRenderedRowRestriction: !0,
  suppressRowVirtualisation: !0,
  rowDragText: !0,
  suppressGroupMaintainValueType: !0,
  groupLockGroupColumns: !0,
  rowGroupPanelSuppressSort: !0,
  suppressGroupRowsSticky: !0,
  rowModelType: !0,
  cacheOverflowSize: !0,
  infiniteInitialRowCount: !0,
  serverSideInitialRowCount: !0,
  suppressServerSideInfiniteScroll: !0,
  maxBlocksInCache: !0,
  maxConcurrentDatasourceRequests: !0,
  blockLoadDebounceMillis: !0,
  serverSideOnlyRefreshFilteredGroups: !0,
  serverSidePivotResultFieldSeparator: !0,
  viewportRowModelPageSize: !0,
  viewportRowModelBufferSize: !0,
  debounceVerticalScrollbar: !0,
  suppressAnimationFrame: !0,
  suppressPreventDefaultOnMouseWheel: !0,
  scrollbarWidth: !0,
  icons: !0,
  suppressRowTransform: !0,
  gridId: !0,
  functionsPassive: !0,
  enableGroupEdit: !0,
  initialState: !0,
  processUnpinnedColumns: !0,
  createChartContainer: !0,
  getLocaleText: !0,
  getRowId: !0,
  reactiveCustomComponents: !0,
  columnMenu: !0
}, ke = class {
};
ke.STRING_PROPERTIES = [
  "rowSelection",
  "overlayLoadingTemplate",
  "overlayNoRowsTemplate",
  "gridId",
  "quickFilterText",
  "rowModelType",
  "editType",
  "domLayout",
  "clipboardDelimiter",
  "rowGroupPanelShow",
  "multiSortKey",
  "pivotColumnGroupTotals",
  "pivotRowTotals",
  "pivotPanelShow",
  "fillHandleDirection",
  "groupDisplayType",
  "treeDataDisplayType",
  "colResizeDefault",
  "tooltipTrigger",
  "serverSidePivotResultFieldSeparator",
  "columnMenu",
  "tooltipShowMode",
  "grandTotalRow"
];
ke.OBJECT_PROPERTIES = [
  "components",
  "rowStyle",
  "context",
  "autoGroupColumnDef",
  "localeText",
  "icons",
  "datasource",
  "serverSideDatasource",
  "viewportDatasource",
  "groupRowRendererParams",
  "aggFuncs",
  "fullWidthCellRendererParams",
  "defaultColGroupDef",
  "defaultColDef",
  "defaultCsvExportParams",
  "defaultExcelExportParams",
  "columnTypes",
  "rowClassRules",
  "detailCellRendererParams",
  "loadingCellRendererParams",
  "loadingOverlayComponentParams",
  "noRowsOverlayComponentParams",
  "popupParent",
  "statusBar",
  "sideBar",
  "chartThemeOverrides",
  "customChartThemes",
  "chartToolPanelsDef",
  "dataTypeDefinitions",
  "advancedFilterModel",
  "advancedFilterParent",
  "advancedFilterBuilderParams",
  "initialState",
  "autoSizeStrategy"
];
ke.ARRAY_PROPERTIES = [
  "sortingOrder",
  "alignedGrids",
  "rowData",
  "columnDefs",
  "excelStyles",
  "pinnedTopRowData",
  "pinnedBottomRowData",
  "chartThemes",
  "rowClass",
  "paginationPageSizeSelector"
];
ke.NUMBER_PROPERTIES = [
  "rowHeight",
  "detailRowHeight",
  "rowBuffer",
  "headerHeight",
  "groupHeaderHeight",
  "groupLockGroupColumns",
  "floatingFiltersHeight",
  "pivotHeaderHeight",
  "pivotGroupHeaderHeight",
  "groupDefaultExpanded",
  "pivotDefaultExpanded",
  "viewportRowModelPageSize",
  "viewportRowModelBufferSize",
  "autoSizePadding",
  "maxBlocksInCache",
  "maxConcurrentDatasourceRequests",
  "tooltipShowDelay",
  "tooltipHideDelay",
  "cacheOverflowSize",
  "paginationPageSize",
  "cacheBlockSize",
  "infiniteInitialRowCount",
  "serverSideInitialRowCount",
  "scrollbarWidth",
  "asyncTransactionWaitMillis",
  "blockLoadDebounceMillis",
  "keepDetailRowsCount",
  "undoRedoCellEditingLimit",
  "cellFlashDelay",
  "cellFadeDelay",
  "cellFlashDuration",
  "cellFadeDuration",
  "tabIndex",
  "pivotMaxGeneratedColumns"
];
ke.BOOLEAN_PROPERTIES = [
  "suppressMakeColumnVisibleAfterUnGroup",
  "suppressRowClickSelection",
  "suppressCellFocus",
  "suppressHeaderFocus",
  "suppressHorizontalScroll",
  "groupSelectsChildren",
  "alwaysShowHorizontalScroll",
  "alwaysShowVerticalScroll",
  "debug",
  "enableBrowserTooltips",
  "enableCellExpressions",
  "groupIncludeTotalFooter",
  "groupSuppressBlankHeader",
  "suppressMenuHide",
  "suppressRowDeselection",
  "unSortIcon",
  "suppressMultiSort",
  "alwaysMultiSort",
  "singleClickEdit",
  "suppressLoadingOverlay",
  "suppressNoRowsOverlay",
  "suppressAutoSize",
  "skipHeaderOnAutoSize",
  "suppressParentsInRowNodes",
  "suppressColumnMoveAnimation",
  "suppressMovableColumns",
  "suppressFieldDotNotation",
  "enableRangeSelection",
  "enableRangeHandle",
  "enableFillHandle",
  "suppressClearOnFillReduction",
  "deltaSort",
  "suppressTouch",
  "suppressAsyncEvents",
  "allowContextMenuWithControlKey",
  "suppressContextMenu",
  "enableCellChangeFlash",
  "suppressDragLeaveHidesColumns",
  "suppressRowGroupHidesColumns",
  "suppressMiddleClickScrolls",
  "suppressPreventDefaultOnMouseWheel",
  "suppressCopyRowsToClipboard",
  "copyHeadersToClipboard",
  "copyGroupHeadersToClipboard",
  "pivotMode",
  "suppressAggFuncInHeader",
  "suppressColumnVirtualisation",
  "alwaysAggregateAtRootLevel",
  "suppressAggAtRootLevel",
  "suppressFocusAfterRefresh",
  "functionsPassive",
  "functionsReadOnly",
  "animateRows",
  "groupSelectsFiltered",
  "groupRemoveSingleChildren",
  "groupRemoveLowestSingleChildren",
  "enableRtl",
  "suppressClickEdit",
  "rowDragEntireRow",
  "rowDragManaged",
  "suppressRowDrag",
  "suppressMoveWhenRowDragging",
  "rowDragMultiRow",
  "enableGroupEdit",
  "embedFullWidthRows",
  "suppressPaginationPanel",
  "groupHideOpenParents",
  "groupAllowUnbalanced",
  "pagination",
  "paginationAutoPageSize",
  "suppressScrollOnNewData",
  "suppressScrollWhenPopupsAreOpen",
  "purgeClosedRowNodes",
  "cacheQuickFilter",
  "includeHiddenColumnsInQuickFilter",
  "excludeHiddenColumnsFromQuickFilter",
  "ensureDomOrder",
  "accentedSort",
  "suppressChangeDetection",
  "valueCache",
  "valueCacheNeverExpires",
  "aggregateOnlyChangedColumns",
  "suppressAnimationFrame",
  "suppressExcelExport",
  "suppressCsvExport",
  "includeHiddenColumnsInAdvancedFilter",
  "suppressMultiRangeSelection",
  "enterMovesDown",
  "enterMovesDownAfterEdit",
  "enterNavigatesVerticallyAfterEdit",
  "enterNavigatesVertically",
  "suppressPropertyNamesCheck",
  "rowMultiSelectWithClick",
  "suppressRowHoverHighlight",
  "suppressRowTransform",
  "suppressClipboardPaste",
  "suppressLastEmptyLineOnPaste",
  "enableCharts",
  "enableChartToolPanelsButton",
  "suppressChartToolPanelsButton",
  "suppressMaintainUnsortedOrder",
  "enableCellTextSelection",
  "suppressBrowserResizeObserver",
  "suppressMaxRenderedRowRestriction",
  "excludeChildrenWhenTreeDataFiltering",
  "tooltipMouseTrack",
  "tooltipInteraction",
  "keepDetailRows",
  "paginateChildRows",
  "preventDefaultOnContextMenu",
  "undoRedoCellEditing",
  "allowDragFromColumnsToolPanel",
  "pivotSuppressAutoColumn",
  "suppressExpandablePivotGroups",
  "debounceVerticalScrollbar",
  "detailRowAutoHeight",
  "serverSideFilterAllLevels",
  "serverSideSortAllLevels",
  "serverSideEnableClientSideSort",
  "serverSideOnlyRefreshFilteredGroups",
  "serverSideSortOnServer",
  "serverSideFilterOnServer",
  "suppressAggFilteredOnly",
  "showOpenedGroup",
  "suppressClipboardApi",
  "suppressModelUpdateAfterUpdateTransaction",
  "stopEditingWhenCellsLoseFocus",
  "maintainColumnOrder",
  "groupMaintainOrder",
  "columnHoverHighlight",
  "readOnlyEdit",
  "suppressRowVirtualisation",
  "enableCellEditingOnBackspace",
  "resetRowDataOnUpdate",
  "removePivotHeaderRowWhenSingleValueColumn",
  "suppressCopySingleCellRanges",
  "suppressGroupRowsSticky",
  "suppressCutToClipboard",
  "suppressServerSideInfiniteScroll",
  "rowGroupPanelSuppressSort",
  "allowShowChangeAfterFilter",
  "enableAdvancedFilter",
  "masterDetail",
  "treeData",
  "suppressGroupMaintainValueType",
  "reactiveCustomComponents",
  "applyQuickFilterBeforePivotOrAgg",
  "suppressServerSideFullWidthLoadingRow",
  "suppressAdvancedFilterEval"
];
ke.OTHER_PROPERTIES = [
  "suppressStickyTotalRow"
];
ke.FUNCTIONAL_PROPERTIES = [
  "doesExternalFilterPass",
  "processPivotResultColDef",
  "processPivotResultColGroupDef",
  "getBusinessKeyForNode",
  "isRowSelectable",
  "rowDragText",
  "groupRowRenderer",
  "fullWidthCellRenderer",
  "loadingCellRenderer",
  "loadingOverlayComponent",
  "noRowsOverlayComponent",
  "detailCellRenderer",
  "quickFilterParser",
  "quickFilterMatcher"
];
ke.CALLBACK_PROPERTIES = [
  "getLocaleText",
  "isExternalFilterPresent",
  "getRowHeight",
  "getRowClass",
  "getRowStyle",
  "getContextMenuItems",
  "getMainMenuItems",
  "processRowPostCreate",
  "processCellForClipboard",
  "getGroupRowAgg",
  "isFullWidthRow",
  "sendToClipboard",
  "navigateToNextHeader",
  "tabToNextHeader",
  "navigateToNextCell",
  "tabToNextCell",
  "processCellFromClipboard",
  "getDocument",
  "postProcessPopup",
  "getChildCount",
  "getDataPath",
  "isRowMaster",
  "postSortRows",
  "processHeaderForClipboard",
  "processUnpinnedColumns",
  "processGroupHeaderForClipboard",
  "paginationNumberFormatter",
  "processDataFromClipboard",
  "getServerSideGroupKey",
  "isServerSideGroup",
  "createChartContainer",
  "getChartToolbarItems",
  "fillOperation",
  "isApplyServerSideTransaction",
  "getServerSideGroupLevelParams",
  "isServerSideGroupOpenByDefault",
  "isGroupOpenByDefault",
  "initialGroupOrderComparator",
  "groupIncludeFooter",
  "loadingCellRendererSelector",
  "getRowId",
  "groupAggFiltering",
  "chartMenuItems",
  "groupTotalRow"
];
ke.FUNCTION_PROPERTIES = [
  ...ke.FUNCTIONAL_PROPERTIES,
  ...ke.CALLBACK_PROPERTIES
];
ke.ALL_PROPERTIES = [
  ...ke.ARRAY_PROPERTIES,
  ...ke.OBJECT_PROPERTIES,
  ...ke.STRING_PROPERTIES,
  ...ke.NUMBER_PROPERTIES,
  ...ke.FUNCTION_PROPERTIES,
  ...ke.BOOLEAN_PROPERTIES,
  ...ke.OTHER_PROPERTIES
];
var Wo = ke, Xe = class Vr {
  static getCallbackForEvent(t) {
    return !t || t.length < 2 ? t : "on" + t[0].toUpperCase() + t.substring(1);
  }
  static getGridOptionKeys() {
    return this.ALL_PROPERTIES_AND_CALLBACKS;
  }
  /** Combines component props / attributes with the provided gridOptions returning a new combined gridOptions object */
  static combineAttributesAndGridOptions(t, i) {
    typeof t != "object" && (t = {});
    const s = _({}, t);
    return Vr.getGridOptionKeys().forEach((r) => {
      const n = i[r];
      typeof n < "u" && n !== Vr.VUE_OMITTED_PROPERTY && (s[r] = n);
    }), s;
  }
  static processOnChange(t, i, s) {
    if (!t)
      return;
    const o = {};
    let r = !1;
    if (Object.keys(t).filter((l) => Vr.ALL_PROPERTIES_AND_CALLBACKS_SET.has(l)).forEach((l) => {
      o[l] = t[l], r = !0;
    }), !r)
      return;
    i.__internalUpdateGridOptions(o, !0);
    const n = {
      type: p.EVENT_COMPONENT_STATE_CHANGED
    };
    tt(o, (l, a) => {
      n[l] = a;
    }), i.dispatchEvent(n);
  }
};
Xe.EVENTS = ss(p);
Xe.VUE_OMITTED_PROPERTY = "AG-VUE-OMITTED-PROPERTY";
Xe.EXCLUDED_INTERNAL_EVENTS = [
  p.EVENT_SCROLLBAR_WIDTH_CHANGED,
  p.EVENT_CHECKBOX_CHANGED,
  p.EVENT_HEIGHT_SCALE_CHANGED,
  p.EVENT_BODY_HEIGHT_CHANGED,
  p.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED,
  p.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED,
  p.EVENT_SCROLL_VISIBILITY_CHANGED,
  p.EVENT_COLUMN_HOVER_CHANGED,
  p.EVENT_FLASH_CELLS,
  p.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED,
  p.EVENT_DISPLAYED_ROWS_CHANGED,
  p.EVENT_LEFT_PINNED_WIDTH_CHANGED,
  p.EVENT_RIGHT_PINNED_WIDTH_CHANGED,
  p.EVENT_ROW_CONTAINER_HEIGHT_CHANGED,
  p.EVENT_STORE_UPDATED,
  p.EVENT_COLUMN_PANEL_ITEM_DRAG_START,
  p.EVENT_COLUMN_PANEL_ITEM_DRAG_END,
  p.EVENT_KEY_SHORTCUT_CHANGED_CELL_START,
  p.EVENT_KEY_SHORTCUT_CHANGED_CELL_END,
  p.EVENT_FULL_WIDTH_ROW_FOCUSED,
  p.EVENT_HEADER_HEIGHT_CHANGED,
  p.EVENT_COLUMN_HEADER_HEIGHT_CHANGED,
  p.EVENT_CELL_FOCUS_CLEARED,
  p.EVENT_GRID_STYLES_CHANGED,
  p.EVENT_FILTER_DESTROYED,
  p.EVENT_ROW_DATA_UPDATE_STARTED,
  p.EVENT_ADVANCED_FILTER_ENABLED_CHANGED,
  p.EVENT_DATA_TYPES_INFERRED,
  p.EVENT_FIELD_VALUE_CHANGED,
  p.EVENT_FIELD_PICKER_VALUE_SELECTED,
  p.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED,
  p.EVENT_SUPPRESS_MENU_HIDE_CHANGED,
  p.EVENT_SUPPRESS_FIELD_DOT_NOTATION,
  p.EVENT_ROW_COUNT_READY,
  p.EVENT_SIDE_BAR_UPDATED
];
Xe.PUBLIC_EVENTS = Xe.EVENTS.filter((e) => !Tt(Xe.EXCLUDED_INTERNAL_EVENTS, e));
Xe.EVENT_CALLBACKS = Xe.EVENTS.map((e) => Xe.getCallbackForEvent(e));
Xe.BOOLEAN_PROPERTIES = Wo.BOOLEAN_PROPERTIES;
Xe.ALL_PROPERTIES = Wo.ALL_PROPERTIES;
Xe.ALL_PROPERTIES_AND_CALLBACKS = [...Xe.ALL_PROPERTIES, ...Xe.EVENT_CALLBACKS];
Xe.ALL_PROPERTIES_AND_CALLBACKS_SET = new Set(Xe.ALL_PROPERTIES_AND_CALLBACKS);
var Zr = Xe, Ml = class extends F {
  constructor() {
    super(...arguments), this.componentsMappedByName = {};
  }
  setupComponents(e) {
    e && e.forEach((t) => this.addComponent(t));
  }
  addComponent(e) {
    const i = e.componentName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase().toUpperCase();
    this.componentsMappedByName[i] = e.componentClass;
  }
  getComponentClass(e) {
    return this.componentsMappedByName[e];
  }
};
Ml = u([
  O("agStackComponentsRegistry")
], Ml);
var Hu = {};
qe(Hu, {
  getAriaCheckboxStateName: () => bn,
  getAriaLabel: () => Uu,
  getAriaLevel: () => eg,
  getAriaPosInSet: () => Wu,
  getAriaSortState: () => Bu,
  removeAriaExpanded: () => ju,
  removeAriaSort: () => Ju,
  setAriaActiveDescendant: () => aa,
  setAriaAtomic: () => zu,
  setAriaChecked: () => ig,
  setAriaColCount: () => Qu,
  setAriaColIndex: () => ua,
  setAriaColSpan: () => Xu,
  setAriaControls: () => ca,
  setAriaDescribedBy: () => tg,
  setAriaDisabled: () => la,
  setAriaExpanded: () => fi,
  setAriaHidden: () => cr,
  setAriaLabel: () => bt,
  setAriaLabelledBy: () => Ys,
  setAriaLevel: () => $u,
  setAriaLive: () => na,
  setAriaMultiSelectable: () => Yu,
  setAriaPosInSet: () => Tn,
  setAriaRelevant: () => Ku,
  setAriaRole: () => Fe,
  setAriaRowCount: () => qu,
  setAriaRowIndex: () => da,
  setAriaSelected: () => qs,
  setAriaSetSize: () => Dn,
  setAriaSort: () => Zu
});
function Vt(e, t, i) {
  i == null || typeof i == "string" && i == "" ? ra(e, t) : Ht(e, t, i);
}
function Ht(e, t, i) {
  e.setAttribute(ku(t), i.toString());
}
function ra(e, t) {
  e.removeAttribute(ku(t));
}
function ku(e) {
  return `aria-${e}`;
}
function Fe(e, t) {
  t ? e.setAttribute("role", t) : e.removeAttribute("role");
}
function Bu(e) {
  let t;
  return e === "asc" ? t = "ascending" : e === "desc" ? t = "descending" : e === "mixed" ? t = "other" : t = "none", t;
}
function eg(e) {
  return parseInt(e.getAttribute("aria-level"), 10);
}
function Wu(e) {
  return parseInt(e.getAttribute("aria-posinset"), 10);
}
function Uu(e) {
  return e.getAttribute("aria-label");
}
function bt(e, t) {
  Vt(e, "label", t);
}
function Ys(e, t) {
  Vt(e, "labelledby", t);
}
function tg(e, t) {
  Vt(e, "describedby", t);
}
function na(e, t) {
  Vt(e, "live", t);
}
function zu(e, t) {
  Vt(e, "atomic", t);
}
function Ku(e, t) {
  Vt(e, "relevant", t);
}
function $u(e, t) {
  Vt(e, "level", t);
}
function la(e, t) {
  Vt(e, "disabled", t);
}
function cr(e, t) {
  Vt(e, "hidden", t);
}
function aa(e, t) {
  Vt(e, "activedescendant", t);
}
function fi(e, t) {
  Ht(e, "expanded", t);
}
function ju(e) {
  ra(e, "expanded");
}
function Dn(e, t) {
  Ht(e, "setsize", t);
}
function Tn(e, t) {
  Ht(e, "posinset", t);
}
function Yu(e, t) {
  Ht(e, "multiselectable", t);
}
function qu(e, t) {
  Ht(e, "rowcount", t);
}
function da(e, t) {
  Ht(e, "rowindex", t);
}
function Qu(e, t) {
  Ht(e, "colcount", t);
}
function ua(e, t) {
  Ht(e, "colindex", t);
}
function Xu(e, t) {
  Ht(e, "colspan", t);
}
function Zu(e, t) {
  Ht(e, "sort", t);
}
function Ju(e) {
  ra(e, "sort");
}
function qs(e, t) {
  Vt(e, "selected", t);
}
function ig(e, t) {
  Ht(e, "checked", t === void 0 ? "mixed" : t);
}
function ca(e, t) {
  Vt(e, "controls", t.id), Ys(t, e.id);
}
function bn(e, t) {
  return t === void 0 ? e("ariaIndeterminate", "indeterminate") : t === !0 ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked");
}
var ec = {};
qe(ec, {
  browserSupportsPreventScroll: () => fa,
  getBodyHeight: () => sc,
  getBodyWidth: () => ic,
  getMaxDivHeight: () => tc,
  getSafariVersion: () => ha,
  getScrollbarWidth: () => oc,
  getTabIndex: () => Jr,
  isBrowserChrome: () => An,
  isBrowserFirefox: () => pa,
  isBrowserSafari: () => ri,
  isIOSUserAgent: () => vi,
  isInvisibleScrollbar: () => ma,
  isMacOsUserAgent: () => ga
});
var ol, xr, rl, nl, ll, al, xl, Nl;
function ri() {
  return ol === void 0 && (ol = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)), ol;
}
function ha() {
  if (xr === void 0)
    if (ri()) {
      const e = navigator.userAgent.match(/version\/(\d+)/i);
      e && (xr = e[1] != null ? parseFloat(e[1]) : 0);
    } else
      xr = 0;
  return xr;
}
function An() {
  if (rl === void 0) {
    const e = window;
    rl = !!e.chrome && (!!e.chrome.webstore || !!e.chrome.runtime) || /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }
  return rl;
}
function pa() {
  return nl === void 0 && (nl = /(firefox)/i.test(navigator.userAgent)), nl;
}
function ga() {
  return ll === void 0 && (ll = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)), ll;
}
function vi() {
  return al === void 0 && (al = /iPad|iPhone|iPod/.test(navigator.platform) || // eslint-disable-next-line
  navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1), al;
}
function fa() {
  return !ri() || ha() >= 15;
}
function Jr(e) {
  if (!e)
    return null;
  const t = e.tabIndex, i = e.getAttribute("tabIndex");
  return t === -1 && (i === null || i === "" && !pa()) ? null : t.toString();
}
function tc() {
  if (!document.body)
    return -1;
  let e = 1e6;
  const t = navigator.userAgent.toLowerCase().match(/firefox/) ? 6e6 : 1e9, i = document.createElement("div");
  for (document.body.appendChild(i); ; ) {
    const s = e * 2;
    if (i.style.height = s + "px", s > t || i.clientHeight !== s)
      break;
    e = s;
  }
  return document.body.removeChild(i), e;
}
function ic() {
  var e, t, i;
  return (i = (e = document.body) == null ? void 0 : e.clientWidth) != null ? i : window.innerHeight || ((t = document.documentElement) == null ? void 0 : t.clientWidth) || -1;
}
function sc() {
  var e, t, i;
  return (i = (e = document.body) == null ? void 0 : e.clientHeight) != null ? i : window.innerHeight || ((t = document.documentElement) == null ? void 0 : t.clientHeight) || -1;
}
function oc() {
  return Nl == null && rc(), Nl;
}
function rc() {
  const e = document.body, t = document.createElement("div");
  t.style.width = t.style.height = "100px", t.style.opacity = "0", t.style.overflow = "scroll", t.style.msOverflowStyle = "scrollbar", t.style.position = "absolute", e.appendChild(t);
  let i = t.offsetWidth - t.clientWidth;
  i === 0 && t.clientWidth === 0 && (i = null), t.parentNode && t.parentNode.removeChild(t), i != null && (Nl = i, xl = i === 0);
}
function ma() {
  return xl == null && rc(), xl;
}
var nc = {};
qe(nc, {
  dateToFormattedString: () => Ks,
  parseDateTimeFromString: () => mt,
  serialiseDate: () => Nt
});
var lc = {};
qe(lc, {
  cleanNumber: () => sg,
  createArrayOfNumbers: () => ac,
  decToHex: () => og,
  formatNumberCommas: () => Ca,
  formatNumberTwoDecimalPlacesAndCommas: () => rg,
  padStartWidthZeros: () => zs,
  sum: () => ng
});
function zs(e, t) {
  return e.toString().padStart(t, "0");
}
function ac(e, t) {
  const i = [];
  for (let s = e; s <= t; s++)
    i.push(s);
  return i;
}
function sg(e) {
  return typeof e == "string" && (e = parseInt(e, 10)), typeof e == "number" ? Math.floor(e) : null;
}
function og(e, t) {
  let i = "";
  for (let s = 0; s < t; s++)
    i += String.fromCharCode(e & 255), e >>>= 8;
  return i;
}
function rg(e, t, i) {
  return typeof e != "number" ? "" : Ca(Math.round(e * 100) / 100, t, i);
}
function Ca(e, t, i) {
  return typeof e != "number" ? "" : e.toString().replace(".", i).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${t}`);
}
function ng(e) {
  return e == null ? null : e.reduce((t, i) => t + i, 0);
}
function Nt(e, t = !0, i = "-") {
  if (!e)
    return null;
  let s = [e.getFullYear(), e.getMonth() + 1, e.getDate()].map((o) => zs(o, 2)).join(i);
  return t && (s += " " + [e.getHours(), e.getMinutes(), e.getSeconds()].map((o) => zs(o, 2)).join(":")), s;
}
var dl = (e) => {
  if (e > 3 && e < 21)
    return "th";
  switch (e % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
  }
  return "th";
};
function Ks(e, t = "YYYY-MM-DD") {
  const i = zs(e.getFullYear(), 4), s = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ], o = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ], r = {
    YYYY: () => i.slice(i.length - 4, i.length),
    YY: () => i.slice(i.length - 2, i.length),
    Y: () => `${e.getFullYear()}`,
    MMMM: () => s[e.getMonth()],
    MMM: () => s[e.getMonth()].slice(0, 3),
    MM: () => zs(e.getMonth() + 1, 2),
    Mo: () => `${e.getMonth() + 1}${dl(e.getMonth() + 1)}`,
    M: () => `${e.getMonth() + 1}`,
    Do: () => `${e.getDate()}${dl(e.getDate())}`,
    DD: () => zs(e.getDate(), 2),
    D: () => `${e.getDate()}`,
    dddd: () => o[e.getDay()],
    ddd: () => o[e.getDay()].slice(0, 3),
    dd: () => o[e.getDay()].slice(0, 2),
    do: () => `${e.getDay()}${dl(e.getDay())}`,
    d: () => `${e.getDay()}`
  }, n = new RegExp(Object.keys(r).join("|"), "g");
  return t.replace(n, (l) => l in r ? r[l]() : l);
}
function mt(e) {
  if (!e)
    return null;
  const [t, i] = e.split(" ");
  if (!t)
    return null;
  const s = t.split("-").map((h) => parseInt(h, 10));
  if (s.filter((h) => !isNaN(h)).length !== 3)
    return null;
  const [o, r, n] = s, l = new Date(o, r - 1, n);
  if (l.getFullYear() !== o || l.getMonth() !== r - 1 || l.getDate() !== n)
    return null;
  if (!i || i === "00:00:00")
    return l;
  const [a, d, c] = i.split(":").map((h) => parseInt(h, 10));
  return a >= 0 && a < 24 && l.setHours(a), d >= 0 && d < 60 && l.setMinutes(d), c >= 0 && c < 60 && l.setSeconds(c), l;
}
var dc = {};
qe(dc, {
  FOCUSABLE_EXCLUDE: () => va,
  FOCUSABLE_SELECTOR: () => uc,
  addOrRemoveAttribute: () => oi,
  addStylesToElement: () => Ta,
  bindCellRendererToHtmlElement: () => Aa,
  clearElement: () => xe,
  copyNodeList: () => fc,
  ensureDomOrder: () => Ra,
  formatSize: () => Pn,
  getAbsoluteHeight: () => Sa,
  getAbsoluteWidth: () => Uo,
  getElementRectWithOffset: () => Ea,
  getElementSize: () => Vi,
  getInnerHeight: () => hr,
  getInnerWidth: () => Rs,
  getScrollLeft: () => Ko,
  insertWithDomOrder: () => hc,
  isElementChildOfClass: () => os,
  isFocusableFormField: () => wa,
  isHorizontalScrollShowing: () => pc,
  isInDOM: () => ya,
  isNodeOrElement: () => pr,
  isRtlNegativeScroll: () => zo,
  isVerticalScrollShowing: () => gc,
  isVisible: () => wt,
  iterateNamedNodeMap: () => mc,
  loadTemplate: () => Ct,
  nodeListForEach: () => ba,
  radioCssClass: () => Gl,
  removeFromParent: () => $t,
  setDisabled: () => Qs,
  setDisplayed: () => te,
  setDomChildOrder: () => Da,
  setElementHeight: () => lg,
  setElementWidth: () => jo,
  setFixedHeight: () => rs,
  setFixedWidth: () => Gt,
  setScrollLeft: () => $o,
  setVisible: () => cc
});
var Nr;
function Gl(e, t, i) {
  const s = e.parentElement;
  let o = s && s.firstChild;
  for (; o; )
    t && o.classList.toggle(t, o === e), i && o.classList.toggle(i, o !== e), o = o.nextSibling;
}
var uc = "[tabindex], input, select, button, textarea, [href]", va = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function wa(e) {
  const t = Element.prototype.matches || Element.prototype.msMatchesSelector, s = t.call(e, "input, select, button, textarea"), o = t.call(e, va), r = wt(e);
  return s && !o && r;
}
function te(e, t, i = {}) {
  const { skipAriaHidden: s } = i;
  e.classList.toggle("ag-hidden", !t), s || cr(e, !t);
}
function cc(e, t, i = {}) {
  const { skipAriaHidden: s } = i;
  e.classList.toggle("ag-invisible", !t), s || cr(e, !t);
}
function Qs(e, t) {
  const i = "disabled", s = t ? (o) => o.setAttribute(i, "") : (o) => o.removeAttribute(i);
  s(e), ba(e.querySelectorAll("input"), (o) => s(o));
}
function os(e, t, i) {
  let s = 0;
  for (; e; ) {
    if (e.classList.contains(t))
      return !0;
    if (e = e.parentElement, typeof i == "number") {
      if (++s > i)
        break;
    } else if (e === i)
      break;
  }
  return !1;
}
function Vi(e) {
  const {
    height: t,
    width: i,
    borderTopWidth: s,
    borderRightWidth: o,
    borderBottomWidth: r,
    borderLeftWidth: n,
    paddingTop: l,
    paddingRight: a,
    paddingBottom: d,
    paddingLeft: c,
    marginTop: h,
    marginRight: g,
    marginBottom: m,
    marginLeft: C,
    boxSizing: w
  } = window.getComputedStyle(e);
  return {
    height: parseFloat(t || "0"),
    width: parseFloat(i || "0"),
    borderTopWidth: parseFloat(s || "0"),
    borderRightWidth: parseFloat(o || "0"),
    borderBottomWidth: parseFloat(r || "0"),
    borderLeftWidth: parseFloat(n || "0"),
    paddingTop: parseFloat(l || "0"),
    paddingRight: parseFloat(a || "0"),
    paddingBottom: parseFloat(d || "0"),
    paddingLeft: parseFloat(c || "0"),
    marginTop: parseFloat(h || "0"),
    marginRight: parseFloat(g || "0"),
    marginBottom: parseFloat(m || "0"),
    marginLeft: parseFloat(C || "0"),
    boxSizing: w
  };
}
function hr(e) {
  const t = Vi(e);
  return t.boxSizing === "border-box" ? t.height - t.paddingTop - t.paddingBottom : t.height;
}
function Rs(e) {
  const t = Vi(e);
  return t.boxSizing === "border-box" ? t.width - t.paddingLeft - t.paddingRight : t.width;
}
function Sa(e) {
  const t = Vi(e), i = t.marginBottom + t.marginTop;
  return Math.ceil(e.offsetHeight + i);
}
function Uo(e) {
  const t = Vi(e), i = t.marginLeft + t.marginRight;
  return Math.ceil(e.offsetWidth + i);
}
function Ea(e) {
  const t = e.getBoundingClientRect(), { borderTopWidth: i, borderLeftWidth: s, borderRightWidth: o, borderBottomWidth: r } = Vi(e);
  return {
    top: t.top + (i || 0),
    left: t.left + (s || 0),
    right: t.right + (o || 0),
    bottom: t.bottom + (r || 0)
  };
}
function zo() {
  if (typeof Nr == "boolean")
    return Nr;
  const e = document.createElement("div");
  return e.style.direction = "rtl", e.style.width = "1px", e.style.height = "1px", e.style.position = "fixed", e.style.top = "0px", e.style.overflow = "hidden", e.dir = "rtl", e.innerHTML = /* html */
  `<div style="width: 2px">
            <span style="display: inline-block; width: 1px"></span>
            <span style="display: inline-block; width: 1px"></span>
        </div>`, document.body.appendChild(e), e.scrollLeft = 1, Nr = Math.floor(e.scrollLeft) === 0, document.body.removeChild(e), Nr;
}
function Ko(e, t) {
  let i = e.scrollLeft;
  return t && (i = Math.abs(i), An() && !zo() && (i = e.scrollWidth - e.clientWidth - i)), i;
}
function $o(e, t, i) {
  i && (zo() ? t *= -1 : (ri() || An()) && (t = e.scrollWidth - e.clientWidth - t)), e.scrollLeft = t;
}
function xe(e) {
  for (; e && e.firstChild; )
    e.removeChild(e.firstChild);
}
function $t(e) {
  e && e.parentNode && e.parentNode.removeChild(e);
}
function ya(e) {
  return !!e.offsetParent;
}
function wt(e) {
  const t = e;
  return t.checkVisibility ? t.checkVisibility({ checkVisibilityCSS: !0 }) : !(!ya(e) || window.getComputedStyle(e).visibility !== "visible");
}
function Ct(e) {
  const t = document.createElement("div");
  return t.innerHTML = (e || "").trim(), t.firstChild;
}
function Ra(e, t, i) {
  i && i.nextSibling === t || (i ? i.nextSibling ? e.insertBefore(t, i.nextSibling) : e.appendChild(t) : e.firstChild && e.firstChild !== t && e.insertAdjacentElement("afterbegin", t));
}
function Da(e, t) {
  for (let i = 0; i < t.length; i++) {
    const s = t[i], o = e.children[i];
    o !== s && e.insertBefore(s, o);
  }
}
function hc(e, t, i) {
  i ? i.insertAdjacentElement("afterend", t) : e.firstChild ? e.insertAdjacentElement("afterbegin", t) : e.appendChild(t);
}
function Ta(e, t) {
  if (t)
    for (const [i, s] of Object.entries(t)) {
      if (!i || !i.length || s == null)
        continue;
      const o = _u(i), r = s.toString(), n = r.replace(/\s*!important/g, ""), l = n.length != r.length ? "important" : void 0;
      e.style.setProperty(o, n, l);
    }
}
function pc(e) {
  return e.clientWidth < e.scrollWidth;
}
function gc(e) {
  return e.clientHeight < e.scrollHeight;
}
function jo(e, t) {
  t === "flex" ? (e.style.removeProperty("width"), e.style.removeProperty("minWidth"), e.style.removeProperty("maxWidth"), e.style.flex = "1 1 auto") : Gt(e, t);
}
function Gt(e, t) {
  t = Pn(t), e.style.width = t.toString(), e.style.maxWidth = t.toString(), e.style.minWidth = t.toString();
}
function lg(e, t) {
  t === "flex" ? (e.style.removeProperty("height"), e.style.removeProperty("minHeight"), e.style.removeProperty("maxHeight"), e.style.flex = "1 1 auto") : rs(e, t);
}
function rs(e, t) {
  t = Pn(t), e.style.height = t.toString(), e.style.maxHeight = t.toString(), e.style.minHeight = t.toString();
}
function Pn(e) {
  return typeof e == "number" ? `${e}px` : e;
}
function pr(e) {
  return e instanceof Node || e instanceof HTMLElement;
}
function fc(e) {
  if (e == null)
    return [];
  const t = [];
  return ba(e, (i) => t.push(i)), t;
}
function mc(e, t) {
  if (e)
    for (let i = 0; i < e.length; i++) {
      const s = e[i];
      t(s.name, s.value);
    }
}
function oi(e, t, i) {
  i == null ? e.removeAttribute(t) : e.setAttribute(t, i.toString());
}
function ba(e, t) {
  if (e != null)
    for (let i = 0; i < e.length; i++)
      t(e[i]);
}
function Aa(e, t) {
  e.then((i) => {
    const s = i.getGui();
    s != null && (typeof s == "object" ? t.appendChild(s) : t.innerHTML = s);
  });
}
var Cc = {};
qe(Cc, {
  fuzzyCheckStrings: () => vc,
  fuzzySuggestions: () => gr
});
function vc(e, t, i) {
  const s = {}, o = e.filter(
    (r) => !t.some(
      (n) => n === r
    )
  );
  return o.length > 0 && o.forEach(
    (r) => s[r] = gr(r, i).values
  ), s;
}
function gr(e, t, i, s) {
  let o = t.map((l, a) => ({
    value: l,
    relevance: ag(e.toLowerCase(), l.toLocaleLowerCase()),
    idx: a
  }));
  if (o.sort((l, a) => a.relevance - l.relevance), i && (o = o.filter((l) => l.relevance !== 0)), o.length > 0 && s && s > 0) {
    const a = o[0].relevance * s;
    o = o.filter((d) => a - d.relevance < 0);
  }
  const r = [], n = [];
  for (const l of o)
    r.push(l.value), n.push(l.idx);
  return { values: r, indices: n };
}
function ag(e, t) {
  const i = e.replace(/\s/g, ""), s = t.replace(/\s/g, "");
  let o = 0, r = -1;
  for (let n = 0; n < i.length; n++) {
    const l = s.indexOf(i[n], r + 1);
    l !== -1 && (r = l, o += 100 - r * 100 / 1e4 * 100);
  }
  return o;
}
var wc = {};
qe(wc, {
  createIcon: () => Lt,
  createIconNoSpan: () => Te,
  iconNameClassMap: () => Sc
});
var Sc = {
  // header column group shown when expanded (click to contract)
  columnGroupOpened: "expanded",
  // header column group shown when contracted (click to expand)
  columnGroupClosed: "contracted",
  // tool panel column group contracted (click to expand)
  columnSelectClosed: "tree-closed",
  // tool panel column group expanded (click to contract)
  columnSelectOpen: "tree-open",
  // column tool panel header expand/collapse all button, shown when some children are expanded and
  //     others are collapsed
  columnSelectIndeterminate: "tree-indeterminate",
  // shown on ghost icon while dragging column to the side of the grid to pin
  columnMovePin: "pin",
  // shown on ghost icon while dragging over part of the page that is not a drop zone
  columnMoveHide: "eye-slash",
  // shown on ghost icon while dragging columns to reorder
  columnMoveMove: "arrows",
  // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
  columnMoveLeft: "left",
  // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
  columnMoveRight: "right",
  // shown on ghost icon while dragging over Row Groups drop zone
  columnMoveGroup: "group",
  // shown on ghost icon while dragging over Values drop zone
  columnMoveValue: "aggregation",
  // shown on ghost icon while dragging over pivot drop zone
  columnMovePivot: "pivot",
  // shown on ghost icon while dragging over drop zone that doesn't support it, e.g.
  //     string column over aggregation drop zone
  dropNotAllowed: "not-allowed",
  // shown on row group when contracted (click to expand)
  groupContracted: "tree-closed",
  // shown on row group when expanded (click to contract)
  groupExpanded: "tree-open",
  // set filter tree list group contracted (click to expand)
  setFilterGroupClosed: "tree-closed",
  // set filter tree list group expanded (click to contract)
  setFilterGroupOpen: "tree-open",
  // set filter tree list expand/collapse all button, shown when some children are expanded and
  //     others are collapsed
  setFilterGroupIndeterminate: "tree-indeterminate",
  // context menu chart item
  chart: "chart",
  // chart window title bar
  close: "cross",
  // X (remove) on column 'pill' after adding it to a drop zone list
  cancel: "cancel",
  // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
  check: "tick",
  // "go to first" button in pagination controls
  first: "first",
  // "go to previous" button in pagination controls
  previous: "previous",
  // "go to next" button in pagination controls
  next: "next",
  // "go to last" button in pagination controls
  last: "last",
  // shown on top right of chart when chart is linked to range data (click to unlink)
  linked: "linked",
  // shown on top right of chart when chart is not linked to range data (click to link)
  unlinked: "unlinked",
  // "Choose colour" button on chart settings tab
  colorPicker: "color-picker",
  // rotating spinner shown by the loading cell renderer
  groupLoading: "loading",
  // button to launch enterprise column menu
  menu: "menu",
  menuAlt: "menu-alt",
  // filter tool panel tab
  filter: "filter",
  // column tool panel tab
  columns: "columns",
  // button in chart regular size window title bar (click to maximise)
  maximize: "maximize",
  // button in chart maximised window title bar (click to make regular size)
  minimize: "minimize",
  // "Pin column" item in column header menu
  menuPin: "pin",
  // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
  menuValue: "aggregation",
  // "Group by {column-name}" item in column header menu
  menuAddRowGroup: "group",
  // "Un-Group by {column-name}" item in column header menu
  menuRemoveRowGroup: "group",
  // context menu copy item
  clipboardCopy: "copy",
  // context menu cut item
  clipboardCut: "cut",
  // context menu paste item
  clipboardPaste: "paste",
  // identifies the pivot drop zone
  pivotPanel: "pivot",
  // "Row groups" drop zone in column tool panel
  rowGroupPanel: "group",
  // columns tool panel Values drop zone
  valuePanel: "aggregation",
  // drag handle used to pick up draggable columns
  columnDrag: "grip",
  // drag handle used to pick up draggable rows
  rowDrag: "grip",
  // context menu export item
  save: "save",
  // csv export
  csvExport: "csv",
  // excel export,
  excelExport: "excel",
  // icon on dropdown editors
  smallDown: "small-down",
  // version of small-right used in RTL mode
  smallLeft: "small-left",
  // separater between column 'pills' when you add multiple columns to the header drop zone
  smallRight: "small-right",
  smallUp: "small-up",
  // show on column header when column is sorted ascending
  sortAscending: "asc",
  // show on column header when column is sorted descending
  sortDescending: "desc",
  // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
  sortUnSort: "none",
  // Builder button in Advanced Filter
  advancedFilterBuilder: "group",
  // drag handle used to pick up Advanced Filter Builder rows
  advancedFilterBuilderDrag: "grip",
  // Advanced Filter Builder row validation error
  advancedFilterBuilderInvalid: "not-allowed",
  // shown on Advanced Filter Builder rows to move them up
  advancedFilterBuilderMoveUp: "up",
  // shown on Advanced Filter Builder rows to move them down
  advancedFilterBuilderMoveDown: "down",
  // shown on Advanced Filter Builder rows to add new rows
  advancedFilterBuilderAdd: "plus",
  // shown on Advanced Filter Builder rows to remove row
  advancedFilterBuilderRemove: "minus",
  // Edit Chart menu item shown in Integrated Charts menu
  chartsMenuEdit: "chart",
  // Advanced Settings menu item shown in Integrated Charts menu
  chartsMenuAdvancedSettings: "settings",
  // shown in Integrated Charts menu add fields
  chartsMenuAdd: "plus"
};
function Lt(e, t, i) {
  const s = Te(e, t, i);
  if (s) {
    const { className: r } = s;
    if (typeof r == "string" && r.indexOf("ag-icon") > -1 || typeof r == "object" && r["ag-icon"])
      return s;
  }
  const o = document.createElement("span");
  return o.appendChild(s), o;
}
function Te(e, t, i, s) {
  let o = null;
  const r = i && i.getColDef().icons;
  if (r && (o = r[e]), t && !o) {
    const n = t.get("icons");
    n && (o = n[e]);
  }
  if (o) {
    let n;
    if (typeof o == "function")
      n = o();
    else if (typeof o == "string")
      n = o;
    else
      throw new Error("icon from grid options needs to be a string or a function");
    if (typeof n == "string")
      return Ct(n);
    if (pr(n))
      return n;
    console.warn("AG Grid: iconRenderer should return back a string or a dom object");
  } else {
    const n = document.createElement("span");
    let l = Sc[e];
    return l || (s ? l = e : (console.warn(`AG Grid: Did not find icon ${e}`), l = "")), n.setAttribute("class", `ag-icon ag-icon-${l}`), n.setAttribute("unselectable", "on"), Fe(n, "presentation"), n;
  }
}
var Ec = {};
qe(Ec, {
  isDeleteKey: () => Dc,
  isEventFromPrintableCharacter: () => Fn,
  isUserSuppressingHeaderKeyboardEvent: () => yc,
  isUserSuppressingKeyboardEvent: () => en,
  normaliseQwertyAzerty: () => Rc
});
var S = class {
};
S.BACKSPACE = "Backspace";
S.TAB = "Tab";
S.ENTER = "Enter";
S.ESCAPE = "Escape";
S.SPACE = " ";
S.LEFT = "ArrowLeft";
S.UP = "ArrowUp";
S.RIGHT = "ArrowRight";
S.DOWN = "ArrowDown";
S.DELETE = "Delete";
S.F2 = "F2";
S.PAGE_UP = "PageUp";
S.PAGE_DOWN = "PageDown";
S.PAGE_HOME = "Home";
S.PAGE_END = "End";
S.A = "KeyA";
S.C = "KeyC";
S.D = "KeyD";
S.V = "KeyV";
S.X = "KeyX";
S.Y = "KeyY";
S.Z = "KeyZ";
var dg = 65, ug = 67, cg = 86, hg = 68, pg = 90, gg = 89;
function Fn(e) {
  return e.altKey || e.ctrlKey || e.metaKey ? !1 : e.key.length === 1;
}
function en(e, t, i, s, o) {
  const r = s ? s.getColDef().suppressKeyboardEvent : void 0;
  if (!r)
    return !1;
  const n = e.addGridCommonParams({
    event: t,
    editing: o,
    column: s,
    node: i,
    data: i.data,
    colDef: s.getColDef()
  });
  return !!(r && r(n));
}
function yc(e, t, i, s) {
  const o = s.getDefinition(), r = o && o.suppressHeaderKeyboardEvent;
  if (!b(r))
    return !1;
  const n = e.addGridCommonParams({
    colDef: o,
    column: s,
    headerRowIndex: i,
    event: t
  });
  return !!r(n);
}
function Rc(e) {
  const { keyCode: t } = e;
  let i;
  switch (t) {
    case dg:
      i = S.A;
      break;
    case ug:
      i = S.C;
      break;
    case cg:
      i = S.V;
      break;
    case hg:
      i = S.D;
      break;
    case pg:
      i = S.Z;
      break;
    case gg:
      i = S.Y;
      break;
    default:
      i = e.code;
  }
  return i;
}
function Dc(e, t = !1) {
  return e === S.DELETE ? !0 : !t && e === S.BACKSPACE ? ga() : !1;
}
var Tc = {};
qe(Tc, {
  areEventsNear: () => Pa
});
function Pa(e, t, i) {
  if (i === 0)
    return !1;
  const s = Math.abs(e.clientX - t.clientX), o = Math.abs(e.clientY - t.clientY);
  return Math.max(s, o) <= i;
}
var bc = {};
qe(bc, {
  sortRowNodesByOrder: () => fg
});
function fg(e, t) {
  if (!e)
    return !1;
  const i = (n, l) => {
    const a = t[n.id], d = t[l.id], c = a !== void 0, h = d !== void 0, g = c && h, m = !c && !h;
    return g ? a - d : m ? n.__objectId - l.__objectId : c ? 1 : -1;
  };
  let s, o, r = !1;
  for (let n = 0; n < e.length - 1; n++)
    if (s = e[n], o = e[n + 1], i(s, o) > 0) {
      r = !0;
      break;
    }
  return r ? (e.sort(i), !0) : !1;
}
var Ac = {};
qe(Ac, {
  convertToSet: () => Fa
});
function Fa(e) {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((i) => t.add(i)), t;
}
var mg = _(_(_(_(_(_(_(_(_(_(_(_(_(_(_(_(_(_({}, Hu), Ru), ec), nc), dc), yu), gu), Cc), cu), wc), Ec), Vu), Tc), lc), hu), bc), Ac), Gu), W = mg, Xs = class {
  constructor(e = 0, t = 1) {
    this.nextValue = e, this.step = t;
  }
  next() {
    const e = this.nextValue;
    return this.nextValue += this.step, e;
  }
  peek() {
    return this.nextValue;
  }
  skip(e) {
    this.nextValue += e;
  }
}, _e = class Hr {
  constructor(t) {
    this.status = 0, this.resolution = null, this.waiters = [], t((i) => this.onDone(i), (i) => this.onReject(i));
  }
  static all(t) {
    return new Hr((i) => {
      let s = t.length;
      const o = new Array(s);
      t.forEach((r, n) => {
        r.then((l) => {
          o[n] = l, s--, s === 0 && i(o);
        });
      });
    });
  }
  static resolve(t = null) {
    return new Hr((i) => i(t));
  }
  then(t) {
    return new Hr((i) => {
      this.status === 1 ? i(t(this.resolution)) : this.waiters.push((s) => i(t(s)));
    });
  }
  resolveNow(t, i) {
    return this.status === 1 ? i(this.resolution) : t;
  }
  onDone(t) {
    this.status = 1, this.resolution = t, this.waiters.forEach((i) => i(t));
  }
  onReject(t) {
    console.warn("TBI");
  }
}, fr = class {
  constructor(e) {
    this.cssClassStates = {}, this.getGui = e;
  }
  addCssClass(e) {
    const t = (e || "").split(" ");
    if (t.length > 1) {
      t.forEach((s) => this.addCssClass(s));
      return;
    }
    if (this.cssClassStates[e] !== !0 && e.length) {
      const s = this.getGui();
      s && s.classList.add(e), this.cssClassStates[e] = !0;
    }
  }
  removeCssClass(e) {
    const t = (e || "").split(" ");
    if (t.length > 1) {
      t.forEach((s) => this.removeCssClass(s));
      return;
    }
    if (this.cssClassStates[e] !== !1 && e.length) {
      const s = this.getGui();
      s && s.classList.remove(e), this.cssClassStates[e] = !1;
    }
  }
  containsCssClass(e) {
    const t = this.getGui();
    return t ? t.classList.contains(e) : !1;
  }
  addOrRemoveCssClass(e, t) {
    if (!e)
      return;
    if (e.indexOf(" ") >= 0) {
      const s = (e || "").split(" ");
      if (s.length > 1) {
        s.forEach((o) => this.addOrRemoveCssClass(o, t));
        return;
      }
    }
    if (this.cssClassStates[e] !== t && e.length) {
      const s = this.getGui();
      s && s.classList.toggle(e, t), this.cssClassStates[e] = t;
    }
  }
}, mr = class qi extends F {
  constructor(t, i, s, o) {
    super(), this.parentComp = t, this.tooltipShowDelayOverride = i, this.tooltipHideDelayOverride = s, this.shouldDisplayTooltip = o, this.SHOW_QUICK_TOOLTIP_DIFF = 1e3, this.FADE_OUT_TOOLTIP_TIMEOUT = 1e3, this.INTERACTIVE_HIDE_DELAY = 100, this.interactionEnabled = !1, this.isInteractingWithTooltip = !1, this.state = 0, this.tooltipInstanceCount = 0, this.tooltipMouseTrack = !1;
  }
  postConstruct() {
    this.gos.get("tooltipInteraction") && (this.interactionEnabled = !0), this.tooltipTrigger = this.getTooltipTrigger(), this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
    const t = this.parentComp.getGui();
    this.tooltipTrigger === 0 && (this.addManagedListener(t, "mouseenter", this.onMouseEnter.bind(this)), this.addManagedListener(t, "mouseleave", this.onMouseLeave.bind(this))), this.tooltipTrigger === 1 && (this.addManagedListener(t, "focusin", this.onFocusIn.bind(this)), this.addManagedListener(t, "focusout", this.onFocusOut.bind(this))), this.addManagedListener(t, "mousemove", this.onMouseMove.bind(this)), this.interactionEnabled || (this.addManagedListener(t, "mousedown", this.onMouseDown.bind(this)), this.addManagedListener(t, "keydown", this.onKeyDown.bind(this)));
  }
  getGridOptionsTooltipDelay(t) {
    const i = this.gos.get(t);
    return i < 0 && H(`${t} should not be lower than 0`), Math.max(200, i);
  }
  getTooltipDelay(t) {
    var i, s;
    return t === "show" ? (i = this.tooltipShowDelayOverride) != null ? i : this.getGridOptionsTooltipDelay("tooltipShowDelay") : (s = this.tooltipHideDelayOverride) != null ? s : this.getGridOptionsTooltipDelay("tooltipHideDelay");
  }
  destroy() {
    this.setToDoNothing(), super.destroy();
  }
  getTooltipTrigger() {
    const t = this.gos.get("tooltipTrigger");
    return !t || t === "hover" ? 0 : 1;
  }
  onMouseEnter(t) {
    this.interactionEnabled && this.interactiveTooltipTimeoutId && (this.unlockService(), this.startHideTimeout()), !vi() && (qi.isLocked ? this.showTooltipTimeoutId = window.setTimeout(() => {
      this.prepareToShowTooltip(t);
    }, this.INTERACTIVE_HIDE_DELAY) : this.prepareToShowTooltip(t));
  }
  onMouseMove(t) {
    this.lastMouseEvent && (this.lastMouseEvent = t), this.tooltipMouseTrack && this.state === 2 && this.tooltipComp && this.positionTooltip();
  }
  onMouseDown() {
    this.setToDoNothing();
  }
  onMouseLeave() {
    this.interactionEnabled ? this.lockService() : this.setToDoNothing();
  }
  onFocusIn() {
    this.prepareToShowTooltip();
  }
  onFocusOut(t) {
    var i;
    const s = t.relatedTarget, o = this.parentComp.getGui(), r = (i = this.tooltipComp) == null ? void 0 : i.getGui();
    this.isInteractingWithTooltip || o.contains(s) || this.interactionEnabled && (r != null && r.contains(s)) || this.setToDoNothing();
  }
  onKeyDown() {
    this.setToDoNothing();
  }
  prepareToShowTooltip(t) {
    if (this.state != 0 || qi.isLocked)
      return;
    let i = 0;
    t && (i = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show")), this.lastMouseEvent = t || null, this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), i), this.state = 1;
  }
  isLastTooltipHiddenRecently() {
    const t = (/* @__PURE__ */ new Date()).getTime(), i = qi.lastTooltipHideTime;
    return t - i < this.SHOW_QUICK_TOOLTIP_DIFF;
  }
  setToDoNothing() {
    this.state === 2 && this.hideTooltip(), this.onBodyScrollEventCallback && (this.onBodyScrollEventCallback(), this.onBodyScrollEventCallback = void 0), this.onColumnMovedEventCallback && (this.onColumnMovedEventCallback(), this.onColumnMovedEventCallback = void 0), this.clearTimeouts(), this.state = 0, this.lastMouseEvent = null;
  }
  showTooltip() {
    const t = _({}, this.parentComp.getTooltipParams());
    if (!b(t.value) || this.shouldDisplayTooltip && !this.shouldDisplayTooltip()) {
      this.setToDoNothing();
      return;
    }
    this.state = 2, this.tooltipInstanceCount++;
    const i = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
    this.userComponentFactory.getTooltipCompDetails(t).newAgStackInstance().then(i);
  }
  hideTooltip(t) {
    if (!t && this.isInteractingWithTooltip)
      return;
    this.tooltipComp && (this.destroyTooltipComp(), qi.lastTooltipHideTime = (/* @__PURE__ */ new Date()).getTime());
    const i = {
      type: p.EVENT_TOOLTIP_HIDE,
      parentGui: this.parentComp.getGui()
    };
    this.eventService.dispatchEvent(i), this.state = 0;
  }
  newTooltipComponentCallback(t, i) {
    if (this.state !== 2 || this.tooltipInstanceCount !== t) {
      this.getContext().destroyBean(i);
      return;
    }
    const o = i.getGui();
    this.tooltipComp = i, o.classList.contains("ag-tooltip") || o.classList.add("ag-tooltip-custom"), this.tooltipTrigger === 0 && o.classList.add("ag-tooltip-animate"), this.interactionEnabled && o.classList.add("ag-tooltip-interactive");
    const r = this.localeService.getLocaleTextFunc(), n = this.popupService.addPopup({
      eChild: o,
      ariaLabel: r("ariaLabelTooltip", "Tooltip")
    });
    n && (this.tooltipPopupDestroyFunc = n.hideFunc), this.positionTooltip(), this.tooltipTrigger === 1 && (this.onBodyScrollEventCallback = this.addManagedListener(this.eventService, p.EVENT_BODY_SCROLL, this.setToDoNothing.bind(this)), this.onColumnMovedEventCallback = this.addManagedListener(this.eventService, p.EVENT_COLUMN_MOVED, this.setToDoNothing.bind(this))), this.interactionEnabled && (this.tooltipTrigger === 0 ? (this.tooltipMouseEnterListener = this.addManagedListener(o, "mouseenter", this.onTooltipMouseEnter.bind(this)) || null, this.tooltipMouseLeaveListener = this.addManagedListener(o, "mouseleave", this.onTooltipMouseLeave.bind(this)) || null) : (this.tooltipFocusInListener = this.addManagedListener(o, "focusin", this.onTooltipFocusIn.bind(this)) || null, this.tooltipFocusOutListener = this.addManagedListener(o, "focusout", this.onTooltipFocusOut.bind(this)) || null));
    const l = {
      type: p.EVENT_TOOLTIP_SHOW,
      tooltipGui: o,
      parentGui: this.parentComp.getGui()
    };
    this.eventService.dispatchEvent(l), this.startHideTimeout();
  }
  onTooltipMouseEnter() {
    this.isInteractingWithTooltip = !0, this.unlockService();
  }
  onTooltipMouseLeave() {
    this.isInteractingWithTooltip = !1, this.lockService();
  }
  onTooltipFocusIn() {
    this.isInteractingWithTooltip = !0;
  }
  onTooltipFocusOut(t) {
    var i;
    const s = this.parentComp.getGui(), o = (i = this.tooltipComp) == null ? void 0 : i.getGui(), r = t.relatedTarget;
    o != null && o.contains(r) || (this.isInteractingWithTooltip = !1, s.contains(r) ? this.startHideTimeout() : this.hideTooltip());
  }
  positionTooltip() {
    const t = {
      type: "tooltip",
      ePopup: this.tooltipComp.getGui(),
      nudgeY: 18,
      skipObserver: this.tooltipMouseTrack
    };
    this.lastMouseEvent ? this.popupService.positionPopupUnderMouseEvent(Re(_({}, t), {
      mouseEvent: this.lastMouseEvent
    })) : this.popupService.positionPopupByComponent(Re(_({}, t), {
      eventSource: this.parentComp.getGui(),
      position: "under",
      keepWithinBounds: !0,
      nudgeY: 5
    }));
  }
  destroyTooltipComp() {
    this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
    const t = this.tooltipPopupDestroyFunc, i = this.tooltipComp, s = this.tooltipTrigger === 0 ? this.FADE_OUT_TOOLTIP_TIMEOUT : 0;
    window.setTimeout(() => {
      t(), this.getContext().destroyBean(i);
    }, s), this.clearTooltipListeners(), this.tooltipPopupDestroyFunc = void 0, this.tooltipComp = void 0;
  }
  clearTooltipListeners() {
    [
      this.tooltipMouseEnterListener,
      this.tooltipMouseLeaveListener,
      this.tooltipFocusInListener,
      this.tooltipFocusOutListener
    ].forEach((t) => {
      t && t();
    }), this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
  }
  lockService() {
    qi.isLocked = !0, this.interactiveTooltipTimeoutId = window.setTimeout(() => {
      this.unlockService(), this.setToDoNothing();
    }, this.INTERACTIVE_HIDE_DELAY);
  }
  unlockService() {
    qi.isLocked = !1, this.clearInteractiveTimeout();
  }
  startHideTimeout() {
    this.clearHideTimeout(), this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
  }
  clearShowTimeout() {
    this.showTooltipTimeoutId && (window.clearTimeout(this.showTooltipTimeoutId), this.showTooltipTimeoutId = void 0);
  }
  clearHideTimeout() {
    this.hideTooltipTimeoutId && (window.clearTimeout(this.hideTooltipTimeoutId), this.hideTooltipTimeoutId = void 0);
  }
  clearInteractiveTimeout() {
    this.interactiveTooltipTimeoutId && (window.clearTimeout(this.interactiveTooltipTimeoutId), this.interactiveTooltipTimeoutId = void 0);
  }
  clearTimeouts() {
    this.clearShowTimeout(), this.clearHideTimeout(), this.clearInteractiveTimeout();
  }
};
mr.isLocked = !1;
u([
  f("popupService")
], mr.prototype, "popupService", 2);
u([
  f("userComponentFactory")
], mr.prototype, "userComponentFactory", 2);
u([
  L
], mr.prototype, "postConstruct", 1);
var Cg = mr, wi = class extends F {
  constructor(e, t) {
    super(), this.ctrl = e, t && (this.beans = t);
  }
  postConstruct() {
    this.refreshToolTip();
  }
  setBrowserTooltip(e) {
    const t = "title", i = this.ctrl.getGui();
    i && (e != null && e != "" ? i.setAttribute(t, e) : i.removeAttribute(t));
  }
  updateTooltipText() {
    this.tooltip = this.ctrl.getTooltipValue();
  }
  createTooltipFeatureIfNeeded() {
    var e, t, i, s;
    if (this.tooltipManager != null)
      return;
    const o = {
      getTooltipParams: () => this.getTooltipParams(),
      getGui: () => this.ctrl.getGui()
    };
    this.tooltipManager = this.createBean(new Cg(
      o,
      (t = (e = this.ctrl).getTooltipShowDelayOverride) == null ? void 0 : t.call(e),
      (s = (i = this.ctrl).getTooltipHideDelayOverride) == null ? void 0 : s.call(i),
      this.ctrl.shouldDisplayTooltip
    ), this.beans.context);
  }
  refreshToolTip() {
    this.browserTooltips = this.beans.gos.get("enableBrowserTooltips"), this.updateTooltipText(), this.browserTooltips ? (this.setBrowserTooltip(this.tooltip), this.tooltipManager && (this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context))) : (this.setBrowserTooltip(null), this.createTooltipFeatureIfNeeded());
  }
  getTooltipParams() {
    const e = this.ctrl, t = e.getColumn ? e.getColumn() : void 0, i = e.getColDef ? e.getColDef() : void 0, s = e.getRowNode ? e.getRowNode() : void 0;
    return {
      location: e.getLocation(),
      //'cell',
      colDef: i,
      column: t,
      rowIndex: e.getRowIndex ? e.getRowIndex() : void 0,
      node: s,
      data: s ? s.data : void 0,
      value: this.getTooltipText(),
      valueFormatted: e.getValueFormatted ? e.getValueFormatted() : void 0,
      hideTooltipCallback: () => {
        var o;
        return (o = this.tooltipManager) == null ? void 0 : o.hideTooltip(!0);
      }
    };
  }
  getTooltipText() {
    return this.tooltip;
  }
  // overriding to make public, as we don't dispose this bean via context
  destroy() {
    this.tooltipManager && (this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context)), super.destroy();
  }
};
u([
  f("beans")
], wi.prototype, "beans", 2);
u([
  L
], wi.prototype, "postConstruct", 1);
var vg = new Xs(), Cr = class Ol extends F {
  constructor(t) {
    super(), this.displayed = !0, this.visible = !0, this.compId = vg.next(), this.cssClassManager = new fr(() => this.eGui), t && this.setTemplate(t);
  }
  preConstructOnComponent() {
    this.usingBrowserTooltips = this.gos.get("enableBrowserTooltips");
  }
  getCompId() {
    return this.compId;
  }
  getTooltipParams() {
    return {
      value: this.tooltipText,
      location: "UNKNOWN"
    };
  }
  setTooltip(t) {
    const { newTooltipText: i, showDelayOverride: s, hideDelayOverride: o, location: r, shouldDisplayTooltip: n } = t || {};
    this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature)), this.tooltipText !== i && (this.tooltipText = i);
    const l = () => this.tooltipText;
    i != null && (this.tooltipFeature = this.createBean(new wi({
      getTooltipValue: l,
      getGui: () => this.getGui(),
      getLocation: () => r ?? "UNKNOWN",
      getColDef: t == null ? void 0 : t.getColDef,
      getColumn: t == null ? void 0 : t.getColumn,
      getTooltipShowDelayOverride: s != null ? () => s : void 0,
      getTooltipHideDelayOverride: o != null ? () => o : void 0,
      shouldDisplayTooltip: n
    })));
  }
  // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
  createChildComponentsFromTags(t, i) {
    fc(t.childNodes).forEach((o) => {
      if (!(o instanceof HTMLElement))
        return;
      const r = this.createComponentFromElement(o, (n) => {
        n.getGui() && this.copyAttributesFromNode(o, n.getGui());
      }, i);
      if (r) {
        if (r.addItems && o.children.length) {
          this.createChildComponentsFromTags(o, i);
          const n = Array.prototype.slice.call(o.children);
          r.addItems(n);
        }
        this.swapComponentForNode(r, t, o);
      } else o.childNodes && this.createChildComponentsFromTags(o, i);
    });
  }
  createComponentFromElement(t, i, s) {
    const o = t.nodeName, r = s ? s[t.getAttribute("ref")] : void 0, n = this.agStackComponentsRegistry.getComponentClass(o);
    if (n) {
      Ol.elementGettingCreated = t;
      const l = new n(r);
      return l.setParentComponent(this), this.createBean(l, null, i), l;
    }
    return null;
  }
  copyAttributesFromNode(t, i) {
    mc(t.attributes, (s, o) => i.setAttribute(s, o));
  }
  swapComponentForNode(t, i, s) {
    const o = t.getGui();
    i.replaceChild(o, s), i.insertBefore(document.createComment(s.nodeName), o), this.addDestroyFunc(this.destroyBean.bind(this, t)), this.swapInComponentForQuerySelectors(t, s);
  }
  swapInComponentForQuerySelectors(t, i) {
    const s = this;
    this.iterateOverQuerySelectors((o) => {
      s[o.attributeName] === i && (s[o.attributeName] = t);
    });
  }
  iterateOverQuerySelectors(t) {
    let i = Object.getPrototypeOf(this);
    for (; i != null; ) {
      const s = i.__agComponentMetaData, o = wn(i.constructor);
      s && s[o] && s[o].querySelectors && s[o].querySelectors.forEach((r) => t(r)), i = Object.getPrototypeOf(i);
    }
  }
  activateTabIndex(t) {
    const i = this.gos.get("tabIndex");
    t || (t = []), t.length || t.push(this.getGui()), t.forEach((s) => s.setAttribute("tabindex", i.toString()));
  }
  setTemplate(t, i) {
    const s = Ct(t);
    this.setTemplateFromElement(s, i);
  }
  setTemplateFromElement(t, i) {
    this.eGui = t, this.eGui.__agComponent = this, this.wireQuerySelectors(), this.getContext() && this.createChildComponentsFromTags(this.getGui(), i);
  }
  createChildComponentsPreConstruct() {
    this.getGui() && this.createChildComponentsFromTags(this.getGui());
  }
  wireQuerySelectors() {
    if (!this.eGui)
      return;
    const t = this;
    this.iterateOverQuerySelectors((i) => {
      const s = (r) => t[i.attributeName] = r;
      if (i.refSelector && this.getAttribute("ref") === i.refSelector)
        s(this.eGui);
      else {
        const r = this.eGui.querySelector(i.querySelector);
        r && s(r.__agComponent || r);
      }
    });
  }
  getGui() {
    return this.eGui;
  }
  getFocusableElement() {
    return this.eGui;
  }
  getAriaElement() {
    return this.getFocusableElement();
  }
  setParentComponent(t) {
    this.parentComponent = t;
  }
  getParentComponent() {
    return this.parentComponent;
  }
  // this method is for older code, that wants to provide the gui element,
  // it is not intended for this to be in ag-Stack
  setGui(t) {
    this.eGui = t;
  }
  queryForHtmlElement(t) {
    return this.eGui.querySelector(t);
  }
  queryForHtmlInputElement(t) {
    return this.eGui.querySelector(t);
  }
  appendChild(t, i) {
    if (t != null)
      if (i || (i = this.eGui), pr(t))
        i.appendChild(t);
      else {
        const s = t;
        i.appendChild(s.getGui());
      }
  }
  isDisplayed() {
    return this.displayed;
  }
  setVisible(t, i = {}) {
    if (t !== this.visible) {
      this.visible = t;
      const { skipAriaHidden: s } = i;
      cc(this.eGui, t, { skipAriaHidden: s });
    }
  }
  setDisplayed(t, i = {}) {
    if (t !== this.displayed) {
      this.displayed = t;
      const { skipAriaHidden: s } = i;
      te(this.eGui, t, { skipAriaHidden: s });
      const o = {
        type: Ol.EVENT_DISPLAYED_CHANGED,
        visible: this.displayed
      };
      this.dispatchEvent(o);
    }
  }
  destroy() {
    this.parentComponent && (this.parentComponent = void 0), this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature));
    const t = this.eGui;
    t && t.__agComponent && (t.__agComponent = void 0), super.destroy();
  }
  addGuiEventListener(t, i, s) {
    this.eGui.addEventListener(t, i, s), this.addDestroyFunc(() => this.eGui.removeEventListener(t, i));
  }
  addCssClass(t) {
    this.cssClassManager.addCssClass(t);
  }
  removeCssClass(t) {
    this.cssClassManager.removeCssClass(t);
  }
  containsCssClass(t) {
    return this.cssClassManager.containsCssClass(t);
  }
  addOrRemoveCssClass(t, i) {
    this.cssClassManager.addOrRemoveCssClass(t, i);
  }
  getAttribute(t) {
    const { eGui: i } = this;
    return i ? i.getAttribute(t) : null;
  }
  getRefElement(t) {
    return this.queryForHtmlElement(`[ref="${t}"]`);
  }
};
Cr.EVENT_DISPLAYED_CHANGED = "displayedChanged";
u([
  f("agStackComponentsRegistry")
], Cr.prototype, "agStackComponentsRegistry", 2);
u([
  vu
], Cr.prototype, "preConstructOnComponent", 1);
u([
  vu
], Cr.prototype, "createChildComponentsPreConstruct", 1);
var K = Cr;
function M(e) {
  return wg.bind(this, `[ref=${e}]`, e);
}
function wg(e, t, i, s, o) {
  if (e === null) {
    console.error("AG Grid: QuerySelector selector should not be null");
    return;
  }
  if (typeof o == "number") {
    console.error("AG Grid: QuerySelector should be on an attribute");
    return;
  }
  Sg(i, "querySelectors", {
    attributeName: s,
    querySelector: e,
    refSelector: t
  });
}
function Sg(e, t, i) {
  const s = Eg(e, wn(e.constructor));
  s[t] || (s[t] = []), s[t].push(i);
}
function Eg(e, t) {
  return e.__agComponentMetaData || (e.__agComponentMetaData = {}), e.__agComponentMetaData[t] || (e.__agComponentMetaData[t] = {}), e.__agComponentMetaData[t];
}
var La = class extends K {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field ref="eFloatingFilterText"></ag-input-text-field>
            </div>`
    );
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  destroy() {
    super.destroy();
  }
  init(e) {
    this.params = e;
    const t = this.columnModel.getDisplayNameForColumn(e.column, "header", !0), i = this.localeService.getLocaleTextFunc();
    this.eFloatingFilterText.setDisabled(!0).setInputAriaLabel(`${t} ${i("ariaFilterInput", "Filter Input")}`);
  }
  onParentModelChanged(e) {
    if (e == null) {
      this.eFloatingFilterText.setValue("");
      return;
    }
    this.params.parentFilterInstance((t) => {
      if (t.getModelAsString) {
        const i = t.getModelAsString(e);
        this.eFloatingFilterText.setValue(i);
      }
    });
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    this.init(e);
  }
};
u([
  M("eFloatingFilterText")
], La.prototype, "eFloatingFilterText", 2);
u([
  f("columnModel")
], La.prototype, "columnModel", 2);
var Pc = class {
  constructor(e, t, i, s, o) {
    this.alive = !0, this.context = e, this.eParent = s, t.getDateCompDetails(i).newAgStackInstance().then((l) => {
      if (!this.alive) {
        e.destroyBean(l);
        return;
      }
      this.dateComp = l, l && (s.appendChild(l.getGui()), l.afterGuiAttached && l.afterGuiAttached(), this.tempValue && l.setDate(this.tempValue), this.disabled != null && this.setDateCompDisabled(this.disabled), o == null || o(this));
    });
  }
  destroy() {
    this.alive = !1, this.dateComp = this.context.destroyBean(this.dateComp);
  }
  getDate() {
    return this.dateComp ? this.dateComp.getDate() : this.tempValue;
  }
  setDate(e) {
    this.dateComp ? this.dateComp.setDate(e) : this.tempValue = e;
  }
  setDisabled(e) {
    this.dateComp ? this.setDateCompDisabled(e) : this.disabled = e;
  }
  setDisplayed(e) {
    te(this.eParent, e);
  }
  setInputPlaceholder(e) {
    this.dateComp && this.dateComp.setInputPlaceholder && this.dateComp.setInputPlaceholder(e);
  }
  setInputAriaLabel(e) {
    this.dateComp && this.dateComp.setInputAriaLabel && this.dateComp.setInputAriaLabel(e);
  }
  afterGuiAttached(e) {
    this.dateComp && typeof this.dateComp.afterGuiAttached == "function" && this.dateComp.afterGuiAttached(e);
  }
  updateParams(e) {
    var t, i;
    let s = !1;
    (t = this.dateComp) != null && t.refresh && typeof this.dateComp.refresh == "function" && this.dateComp.refresh(e) !== null && (s = !0), !s && ((i = this.dateComp) != null && i.onParamsUpdated) && typeof this.dateComp.onParamsUpdated == "function" && this.dateComp.onParamsUpdated(e) !== null && H("Custom date component method 'onParamsUpdated' is deprecated. Use 'refresh' instead.");
  }
  setDateCompDisabled(e) {
    this.dateComp != null && this.dateComp.setDisabled != null && this.dateComp.setDisabled(e);
  }
}, Fc = class {
  constructor() {
    this.customFilterOptions = {};
  }
  init(e, t) {
    this.filterOptions = e.filterOptions || t, this.mapCustomOptions(), this.selectDefaultItem(e);
  }
  getFilterOptions() {
    return this.filterOptions;
  }
  mapCustomOptions() {
    this.filterOptions && this.filterOptions.forEach((e) => {
      if (typeof e == "string")
        return;
      const t = [["displayKey"], ["displayName"], ["predicate", "test"]], i = (s) => s.some((o) => e[o] != null) ? !0 : (console.warn(`AG Grid: ignoring FilterOptionDef as it doesn't contain one of '${s}'`), !1);
      if (!t.every(i)) {
        this.filterOptions = this.filterOptions.filter((s) => s === e) || [];
        return;
      }
      this.customFilterOptions[e.displayKey] = e;
    });
  }
  selectDefaultItem(e) {
    if (e.defaultOption)
      this.defaultOption = e.defaultOption;
    else if (this.filterOptions.length >= 1) {
      const t = this.filterOptions[0];
      typeof t == "string" ? this.defaultOption = t : t.displayKey ? this.defaultOption = t.displayKey : console.warn("AG Grid: invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'");
    } else
      console.warn("AG Grid: no filter options for filter");
  }
  getDefaultOption() {
    return this.defaultOption;
  }
  getCustomOption(e) {
    return this.customFilterOptions[e];
  }
}, Lc = {
  applyFilter: "Apply",
  clearFilter: "Clear",
  resetFilter: "Reset",
  cancelFilter: "Cancel",
  textFilter: "Text Filter",
  numberFilter: "Number Filter",
  dateFilter: "Date Filter",
  setFilter: "Set Filter",
  filterOoo: "Filter...",
  empty: "Choose one",
  equals: "Equals",
  notEqual: "Does not equal",
  lessThan: "Less than",
  greaterThan: "Greater than",
  inRange: "Between",
  inRangeStart: "From",
  inRangeEnd: "To",
  lessThanOrEqual: "Less than or equal to",
  greaterThanOrEqual: "Greater than or equal to",
  contains: "Contains",
  notContains: "Does not contain",
  startsWith: "Begins with",
  endsWith: "Ends with",
  blank: "Blank",
  notBlank: "Not blank",
  before: "Before",
  after: "After",
  andCondition: "AND",
  orCondition: "OR",
  dateFormatOoo: "yyyy-mm-dd"
}, Ln = class Ic extends F {
  constructor(t, i = {}) {
    super(), this.eFocusableElement = t, this.callbacks = i, this.callbacks = _({
      shouldStopEventPropagation: () => !1,
      onTabKeyDown: (s) => {
        if (s.defaultPrevented)
          return;
        const o = this.focusService.findNextFocusableElement(this.eFocusableElement, !1, s.shiftKey);
        o && (o.focus(), s.preventDefault());
      }
    }, i);
  }
  postConstruct() {
    this.eFocusableElement.classList.add(Ic.FOCUS_MANAGED_CLASS), this.addKeyDownListeners(this.eFocusableElement), this.callbacks.onFocusIn && this.addManagedListener(this.eFocusableElement, "focusin", this.callbacks.onFocusIn), this.callbacks.onFocusOut && this.addManagedListener(this.eFocusableElement, "focusout", this.callbacks.onFocusOut);
  }
  addKeyDownListeners(t) {
    this.addManagedListener(t, "keydown", (i) => {
      if (!(i.defaultPrevented || Yt(i))) {
        if (this.callbacks.shouldStopEventPropagation(i)) {
          Qt(i);
          return;
        }
        i.key === S.TAB ? this.callbacks.onTabKeyDown(i) : this.callbacks.handleKeyDown && this.callbacks.handleKeyDown(i);
      }
    });
  }
};
Ln.FOCUS_MANAGED_CLASS = "ag-focus-managed";
u([
  f("focusService")
], Ln.prototype, "focusService", 2);
u([
  L
], Ln.prototype, "postConstruct", 1);
var Hi = Ln, Mc = "ag-resizer-wrapper", yg = (
  /* html */
  `<div class="${Mc}">
        <div ref="eTopLeftResizer" class="ag-resizer ag-resizer-topLeft"></div>
        <div ref="eTopResizer" class="ag-resizer ag-resizer-top"></div>
        <div ref="eTopRightResizer" class="ag-resizer ag-resizer-topRight"></div>
        <div ref="eRightResizer" class="ag-resizer ag-resizer-right"></div>
        <div ref="eBottomRightResizer" class="ag-resizer ag-resizer-bottomRight"></div>
        <div ref="eBottomResizer" class="ag-resizer ag-resizer-bottom"></div>
        <div ref="eBottomLeftResizer" class="ag-resizer ag-resizer-bottomLeft"></div>
        <div ref="eLeftResizer" class="ag-resizer ag-resizer-left"></div>
    </div>`
), ao = class extends F {
  constructor(e, t) {
    super(), this.element = e, this.dragStartPosition = {
      x: 0,
      y: 0
    }, this.position = {
      x: 0,
      y: 0
    }, this.lastSize = {
      width: -1,
      height: -1
    }, this.positioned = !1, this.resizersAdded = !1, this.resizeListeners = [], this.boundaryEl = null, this.isResizing = !1, this.isMoving = !1, this.resizable = {}, this.movable = !1, this.currentResizer = null, this.config = Object.assign({}, { popup: !1 }, t);
  }
  center() {
    const { clientHeight: e, clientWidth: t } = this.offsetParent, i = t / 2 - this.getWidth() / 2, s = e / 2 - this.getHeight() / 2;
    this.offsetElement(i, s);
  }
  initialisePosition() {
    if (this.positioned)
      return;
    const { centered: e, forcePopupParentAsOffsetParent: t, minWidth: i, width: s, minHeight: o, height: r, x: n, y: l } = this.config;
    this.offsetParent || this.setOffsetParent();
    let a = 0, d = 0;
    const c = wt(this.element);
    if (c) {
      const h = this.findBoundaryElement(), g = window.getComputedStyle(h);
      if (g.minWidth != null) {
        const m = h.offsetWidth - this.element.offsetWidth;
        d = parseInt(g.minWidth, 10) - m;
      }
      if (g.minHeight != null) {
        const m = h.offsetHeight - this.element.offsetHeight;
        a = parseInt(g.minHeight, 10) - m;
      }
    }
    if (this.minHeight = o || a, this.minWidth = i || d, s && this.setWidth(s), r && this.setHeight(r), (!s || !r) && this.refreshSize(), e)
      this.center();
    else if (n || l)
      this.offsetElement(n, l);
    else if (c && t) {
      let h = this.boundaryEl, g = !0;
      if (h || (h = this.findBoundaryElement(), g = !1), h) {
        const m = parseFloat(h.style.top), C = parseFloat(h.style.left);
        g ? this.offsetElement(
          isNaN(C) ? 0 : C,
          isNaN(m) ? 0 : m
        ) : this.setPosition(C, m);
      }
    }
    this.positioned = !!this.offsetParent;
  }
  isPositioned() {
    return this.positioned;
  }
  getPosition() {
    return this.position;
  }
  setMovable(e, t) {
    if (!this.config.popup || e === this.movable)
      return;
    this.movable = e;
    const i = this.moveElementDragListener || {
      eElement: t,
      onDragStart: this.onMoveStart.bind(this),
      onDragging: this.onMove.bind(this),
      onDragStop: this.onMoveEnd.bind(this)
    };
    e ? (this.dragService.addDragSource(i), this.moveElementDragListener = i) : (this.dragService.removeDragSource(i), this.moveElementDragListener = void 0);
  }
  setResizable(e) {
    if (this.clearResizeListeners(), e ? this.addResizers() : this.removeResizers(), typeof e == "boolean") {
      if (e === !1)
        return;
      e = {
        topLeft: e,
        top: e,
        topRight: e,
        right: e,
        bottomRight: e,
        bottom: e,
        bottomLeft: e,
        left: e
      };
    }
    Object.keys(e).forEach((t) => {
      const s = !!e[t], o = this.getResizerElement(t), r = {
        dragStartPixels: 0,
        eElement: o,
        onDragStart: (n) => this.onResizeStart(n, t),
        onDragging: this.onResize.bind(this),
        onDragStop: (n) => this.onResizeEnd(n, t)
      };
      (s || !this.isAlive() && !s) && (s ? (this.dragService.addDragSource(r), this.resizeListeners.push(r), o.style.pointerEvents = "all") : o.style.pointerEvents = "none", this.resizable[t] = s);
    });
  }
  removeSizeFromEl() {
    this.element.style.removeProperty("height"), this.element.style.removeProperty("width"), this.element.style.removeProperty("flex");
  }
  restoreLastSize() {
    this.element.style.flex = "0 0 auto";
    const { height: e, width: t } = this.lastSize;
    t !== -1 && (this.element.style.width = `${t}px`), e !== -1 && (this.element.style.height = `${e}px`);
  }
  getHeight() {
    return this.element.offsetHeight;
  }
  setHeight(e) {
    const { popup: t } = this.config, i = this.element;
    let s = !1;
    if (typeof e == "string" && e.indexOf("%") !== -1)
      rs(i, e), e = Sa(i), s = !0;
    else if (e = Math.max(this.minHeight, e), this.positioned) {
      const o = this.getAvailableHeight();
      o && e > o && (e = o);
    }
    this.getHeight() !== e && (s ? (i.style.maxHeight = "unset", i.style.minHeight = "unset") : t ? rs(i, e) : (i.style.height = `${e}px`, i.style.flex = "0 0 auto", this.lastSize.height = typeof e == "number" ? e : parseFloat(e)));
  }
  getAvailableHeight() {
    const { popup: e, forcePopupParentAsOffsetParent: t } = this.config;
    this.positioned || this.initialisePosition();
    const { clientHeight: i } = this.offsetParent;
    if (!i)
      return null;
    const s = this.element.getBoundingClientRect(), o = this.offsetParent.getBoundingClientRect(), r = e ? this.position.y : s.top, n = e ? 0 : o.top;
    let l = 0;
    if (t) {
      const d = this.element.parentElement;
      if (d) {
        const { bottom: c } = d.getBoundingClientRect();
        l = c - s.bottom;
      }
    }
    return i + n - r - l;
  }
  getWidth() {
    return this.element.offsetWidth;
  }
  setWidth(e) {
    const t = this.element, { popup: i } = this.config;
    let s = !1;
    if (typeof e == "string" && e.indexOf("%") !== -1)
      Gt(t, e), e = Uo(t), s = !0;
    else if (this.positioned) {
      e = Math.max(this.minWidth, e);
      const { clientWidth: o } = this.offsetParent, r = i ? this.position.x : this.element.getBoundingClientRect().left;
      o && e + r > o && (e = o - r);
    }
    this.getWidth() !== e && (s ? (t.style.maxWidth = "unset", t.style.minWidth = "unset") : this.config.popup ? Gt(t, e) : (t.style.width = `${e}px`, t.style.flex = " unset", this.lastSize.width = typeof e == "number" ? e : parseFloat(e)));
  }
  offsetElement(e = 0, t = 0) {
    const { forcePopupParentAsOffsetParent: i } = this.config, s = i ? this.boundaryEl : this.element;
    s && (this.popupService.positionPopup({
      ePopup: s,
      keepWithinBounds: !0,
      skipObserver: this.movable || this.isResizable(),
      updatePosition: () => ({ x: e, y: t })
    }), this.setPosition(
      parseFloat(s.style.left),
      parseFloat(s.style.top)
    ));
  }
  constrainSizeToAvailableHeight(e) {
    if (!this.config.forcePopupParentAsOffsetParent)
      return;
    const t = () => {
      const i = this.getAvailableHeight();
      this.element.style.setProperty("max-height", `${i}px`);
    };
    e ? this.resizeObserverSubscriber = this.resizeObserverService.observeResize(
      this.popupService.getPopupParent(),
      t
    ) : (this.element.style.removeProperty("max-height"), this.resizeObserverSubscriber && (this.resizeObserverSubscriber(), this.resizeObserverSubscriber = void 0));
  }
  setPosition(e, t) {
    this.position.x = e, this.position.y = t;
  }
  updateDragStartPosition(e, t) {
    this.dragStartPosition = { x: e, y: t };
  }
  calculateMouseMovement(e) {
    const { e: t, isLeft: i, isTop: s, anywhereWithin: o, topBuffer: r } = e, n = t.clientX - this.dragStartPosition.x, l = t.clientY - this.dragStartPosition.y, a = this.shouldSkipX(t, !!i, !!o, n) ? 0 : n, d = this.shouldSkipY(t, !!s, r, l) ? 0 : l;
    return { movementX: a, movementY: d };
  }
  shouldSkipX(e, t, i, s) {
    const o = this.element.getBoundingClientRect(), r = this.offsetParent.getBoundingClientRect(), n = this.boundaryEl.getBoundingClientRect(), l = this.config.popup ? this.position.x : o.left;
    let a = l <= 0 && r.left >= e.clientX || r.right <= e.clientX && r.right <= n.right;
    return a ? !0 : (t ? a = // skip if we are moving to the left and the cursor
    // is positioned to the right of the left side anchor
    s < 0 && e.clientX > l + r.left || // skip if we are moving to the right and the cursor
    // is positioned to the left of the dialog
    s > 0 && e.clientX < l + r.left : i ? a = s < 0 && e.clientX > n.right || s > 0 && e.clientX < l + r.left : a = // if the movement is bound to the right side of the dialog
    // we skip if we are moving to the left and the cursor
    // is to the right of the dialog
    s < 0 && e.clientX > n.right || // or skip if we are moving to the right and the cursor
    // is to the left of the right side anchor
    s > 0 && e.clientX < n.right, a);
  }
  shouldSkipY(e, t, i = 0, s) {
    const o = this.element.getBoundingClientRect(), r = this.offsetParent.getBoundingClientRect(), n = this.boundaryEl.getBoundingClientRect(), l = this.config.popup ? this.position.y : o.top;
    let a = l <= 0 && r.top >= e.clientY || r.bottom <= e.clientY && r.bottom <= n.bottom;
    return a ? !0 : (t ? a = // skip if we are moving to towards top and the cursor is
    // below the top anchor + topBuffer
    // note: topBuffer is used when moving the dialog using the title bar
    s < 0 && e.clientY > l + r.top + i || // skip if we are moving to the bottom and the cursor is
    // above the top anchor
    s > 0 && e.clientY < l + r.top : a = // skip if we are moving towards the top and the cursor
    // is below the bottom anchor
    s < 0 && e.clientY > n.bottom || // skip if we are moving towards the bottom and the cursor
    // is above the bottom anchor
    s > 0 && e.clientY < n.bottom, a);
  }
  createResizeMap() {
    const e = this.element;
    this.resizerMap = {
      topLeft: { element: e.querySelector("[ref=eTopLeftResizer]") },
      top: { element: e.querySelector("[ref=eTopResizer]") },
      topRight: { element: e.querySelector("[ref=eTopRightResizer]") },
      right: { element: e.querySelector("[ref=eRightResizer]") },
      bottomRight: { element: e.querySelector("[ref=eBottomRightResizer]") },
      bottom: { element: e.querySelector("[ref=eBottomResizer]") },
      bottomLeft: { element: e.querySelector("[ref=eBottomLeftResizer]") },
      left: { element: e.querySelector("[ref=eLeftResizer]") }
    };
  }
  addResizers() {
    if (this.resizersAdded)
      return;
    const e = this.element;
    if (!e)
      return;
    const i = new DOMParser().parseFromString(yg, "text/html").body;
    e.appendChild(i.firstChild), this.createResizeMap(), this.resizersAdded = !0;
  }
  removeResizers() {
    this.resizerMap = void 0;
    const e = this.element.querySelector(`.${Mc}`);
    e && this.element.removeChild(e), this.resizersAdded = !1;
  }
  getResizerElement(e) {
    return this.resizerMap[e].element;
  }
  onResizeStart(e, t) {
    this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.currentResizer = {
      isTop: !!t.match(/top/i),
      isRight: !!t.match(/right/i),
      isBottom: !!t.match(/bottom/i),
      isLeft: !!t.match(/left/i)
    }, this.element.classList.add("ag-resizing"), this.resizerMap[t].element.classList.add("ag-active");
    const { popup: i, forcePopupParentAsOffsetParent: s } = this.config;
    !i && !s && this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop), this.isResizing = !0, this.updateDragStartPosition(e.clientX, e.clientY);
  }
  getSiblings() {
    const t = this.element.parentElement;
    return t ? Array.prototype.slice.call(t.children).filter((i) => !i.classList.contains("ag-hidden")) : null;
  }
  getMinSizeOfSiblings() {
    const e = this.getSiblings() || [];
    let t = 0, i = 0;
    for (let s = 0; s < e.length; s++) {
      const o = e[s], r = !!o.style.flex && o.style.flex !== "0 0 auto";
      if (o === this.element)
        continue;
      let n = this.minHeight || 0, l = this.minWidth || 0;
      if (r) {
        const a = window.getComputedStyle(o);
        a.minHeight && (n = parseInt(a.minHeight, 10)), a.minWidth && (l = parseInt(a.minWidth, 10));
      } else
        n = o.offsetHeight, l = o.offsetWidth;
      t += n, i += l;
    }
    return { height: t, width: i };
  }
  applySizeToSiblings(e) {
    let t = null;
    const i = this.getSiblings();
    if (i) {
      for (let s = 0; s < i.length; s++) {
        const o = i[s];
        o !== t && (e ? o.style.height = `${o.offsetHeight}px` : o.style.width = `${o.offsetWidth}px`, o.style.flex = "0 0 auto", o === this.element && (t = i[s + 1]));
      }
      t && (t.style.removeProperty("height"), t.style.removeProperty("min-height"), t.style.removeProperty("max-height"), t.style.flex = "1 1 auto");
    }
  }
  isResizable() {
    return Object.values(this.resizable).some((e) => e);
  }
  onResize(e) {
    if (!this.isResizing || !this.currentResizer)
      return;
    const { popup: t, forcePopupParentAsOffsetParent: i } = this.config, { isTop: s, isRight: o, isBottom: r, isLeft: n } = this.currentResizer, l = o || n, a = r || s, { movementX: d, movementY: c } = this.calculateMouseMovement({ e, isLeft: n, isTop: s }), h = this.position.x, g = this.position.y;
    let m = 0, C = 0;
    if (l && d) {
      const w = n ? -1 : 1, v = this.getWidth(), y = v + d * w;
      let E = !1;
      n && (m = v - y, (h + m <= 0 || y <= this.minWidth) && (E = !0, m = 0)), E || this.setWidth(y);
    }
    if (a && c) {
      const w = s ? -1 : 1, v = this.getHeight(), y = v + c * w;
      let E = !1;
      s ? (C = v - y, (g + C <= 0 || y <= this.minHeight) && (E = !0, C = 0)) : !this.config.popup && !this.config.forcePopupParentAsOffsetParent && v < y && this.getMinSizeOfSiblings().height + y > this.element.parentElement.offsetHeight && (E = !0), E || this.setHeight(y);
    }
    this.updateDragStartPosition(e.clientX, e.clientY), ((t || i) && m || C) && this.offsetElement(
      h + m,
      g + C
    );
  }
  onResizeEnd(e, t) {
    this.isResizing = !1, this.currentResizer = null, this.boundaryEl = null;
    const i = {
      type: "resize"
    };
    this.element.classList.remove("ag-resizing"), this.resizerMap[t].element.classList.remove("ag-active"), this.dispatchEvent(i);
  }
  refreshSize() {
    const e = this.element;
    this.config.popup && (this.config.width || this.setWidth(e.offsetWidth), this.config.height || this.setHeight(e.offsetHeight));
  }
  onMoveStart(e) {
    this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.isMoving = !0, this.element.classList.add("ag-moving"), this.updateDragStartPosition(e.clientX, e.clientY);
  }
  onMove(e) {
    if (!this.isMoving)
      return;
    const { x: t, y: i } = this.position;
    let s;
    this.config.calculateTopBuffer && (s = this.config.calculateTopBuffer());
    const { movementX: o, movementY: r } = this.calculateMouseMovement({
      e,
      isTop: !0,
      anywhereWithin: !0,
      topBuffer: s
    });
    this.offsetElement(t + o, i + r), this.updateDragStartPosition(e.clientX, e.clientY);
  }
  onMoveEnd() {
    this.isMoving = !1, this.boundaryEl = null, this.element.classList.remove("ag-moving");
  }
  setOffsetParent() {
    this.config.forcePopupParentAsOffsetParent ? this.offsetParent = this.popupService.getPopupParent() : this.offsetParent = this.element.offsetParent;
  }
  findBoundaryElement() {
    let e = this.element;
    for (; e; ) {
      if (window.getComputedStyle(e).position !== "static")
        return e;
      e = e.parentElement;
    }
    return this.element;
  }
  clearResizeListeners() {
    for (; this.resizeListeners.length; ) {
      const e = this.resizeListeners.pop();
      this.dragService.removeDragSource(e);
    }
  }
  destroy() {
    super.destroy(), this.moveElementDragListener && this.dragService.removeDragSource(this.moveElementDragListener), this.constrainSizeToAvailableHeight(!1), this.clearResizeListeners(), this.removeResizers();
  }
};
u([
  f("popupService")
], ao.prototype, "popupService", 2);
u([
  f("resizeObserverService")
], ao.prototype, "resizeObserverService", 2);
u([
  f("dragService")
], ao.prototype, "dragService", 2);
var In = class Fo extends K {
  constructor(t) {
    super(), this.filterNameKey = t, this.applyActive = !1, this.hidePopup = null, this.debouncePending = !1, this.appliedModel = null, this.buttonListeners = [];
  }
  postConstruct() {
    this.resetTemplate(), this.createManagedBean(new Hi(
      this.getFocusableElement(),
      {
        handleKeyDown: this.handleKeyDown.bind(this)
      }
    )), this.positionableFeature = new ao(
      this.getPositionableElement(),
      {
        forcePopupParentAsOffsetParent: !0
      }
    ), this.createBean(this.positionableFeature);
  }
  // override
  handleKeyDown(t) {
  }
  getFilterTitle() {
    return this.translate(this.filterNameKey);
  }
  isFilterActive() {
    return !!this.appliedModel;
  }
  resetTemplate(t) {
    let i = this.getGui();
    i && i.removeEventListener("submit", this.onFormSubmit);
    const s = (
      /* html */
      `
            <form class="ag-filter-wrapper">
                <div class="ag-filter-body-wrapper ag-${this.getCssIdentifier()}-body-wrapper" ref="eFilterBody">
                    ${this.createBodyTemplate()}
                </div>
            </form>`
    );
    this.setTemplate(s, t), i = this.getGui(), i && i.addEventListener("submit", this.onFormSubmit);
  }
  isReadOnly() {
    return !!this.providedFilterParams.readOnly;
  }
  init(t) {
    this.setParams(t), this.resetUiToDefaults(!0).then(() => {
      this.updateUiVisibility(), this.setupOnBtApplyDebounce();
    });
  }
  setParams(t) {
    this.providedFilterParams = t, this.applyActive = Fo.isUseApplyButton(t), this.resetButtonsPanel();
  }
  updateParams(t) {
    this.providedFilterParams = t, this.applyActive = Fo.isUseApplyButton(t), this.resetUiToActiveModel(this.getModel(), () => {
      this.updateUiVisibility(), this.setupOnBtApplyDebounce();
    });
  }
  resetButtonsPanel() {
    const { buttons: t } = this.providedFilterParams, i = t && t.length > 0 && !this.isReadOnly();
    if (this.eButtonsPanel ? (xe(this.eButtonsPanel), this.buttonListeners.forEach((r) => r == null ? void 0 : r()), this.buttonListeners = []) : i && (this.eButtonsPanel = document.createElement("div"), this.eButtonsPanel.classList.add("ag-filter-apply-panel")), !i) {
      this.eButtonsPanel && $t(this.eButtonsPanel);
      return;
    }
    const s = document.createDocumentFragment(), o = (r) => {
      let n, l;
      switch (r) {
        case "apply":
          n = this.translate("applyFilter"), l = (c) => this.onBtApply(!1, !1, c);
          break;
        case "clear":
          n = this.translate("clearFilter"), l = () => this.onBtClear();
          break;
        case "reset":
          n = this.translate("resetFilter"), l = () => this.onBtReset();
          break;
        case "cancel":
          n = this.translate("cancelFilter"), l = (c) => {
            this.onBtCancel(c);
          };
          break;
        default:
          console.warn("AG Grid: Unknown button type specified");
          return;
      }
      const d = Ct(
        /* html */
        `<button
                    type="${r === "apply" ? "submit" : "button"}"
                    ref="${r}FilterButton"
                    class="ag-button ag-standard-button ag-filter-apply-panel-button"
                >${n}
                </button>`
      );
      this.buttonListeners.push(this.addManagedListener(d, "click", l)), s.append(d);
    };
    Fa(t).forEach((r) => o(r)), this.eButtonsPanel.append(s), this.getGui().appendChild(this.eButtonsPanel);
  }
  // subclasses can override this to provide alternative debounce defaults
  getDefaultDebounceMs() {
    return 0;
  }
  setupOnBtApplyDebounce() {
    const t = Fo.getDebounceMs(this.providedFilterParams, this.getDefaultDebounceMs()), i = rt(this.checkApplyDebounce.bind(this), t);
    this.onBtApplyDebounce = () => {
      this.debouncePending = !0, i();
    };
  }
  checkApplyDebounce() {
    this.debouncePending && (this.debouncePending = !1, this.onBtApply());
  }
  getModel() {
    return this.appliedModel ? this.appliedModel : null;
  }
  setModel(t) {
    return (t != null ? this.setModelIntoUi(t) : this.resetUiToDefaults()).then(() => {
      this.updateUiVisibility(), this.applyModel("api");
    });
  }
  onBtCancel(t) {
    this.resetUiToActiveModel(this.getModel(), () => {
      this.handleCancelEnd(t);
    });
  }
  handleCancelEnd(t) {
    this.providedFilterParams.closeOnApply && this.close(t);
  }
  resetUiToActiveModel(t, i) {
    const s = () => {
      this.onUiChanged(!1, "prevent"), i == null || i();
    };
    t != null ? this.setModelIntoUi(t).then(s) : this.resetUiToDefaults().then(s);
  }
  onBtClear() {
    this.resetUiToDefaults().then(() => this.onUiChanged());
  }
  onBtReset() {
    this.onBtClear(), this.onBtApply();
  }
  /**
   * Applies changes made in the UI to the filter, and returns true if the model has changed.
   */
  applyModel(t = "api") {
    const i = this.getModelFromUi();
    if (!this.isModelValid(i))
      return !1;
    const s = this.appliedModel;
    return this.appliedModel = i, !this.areModelsEqual(s, i);
  }
  isModelValid(t) {
    return !0;
  }
  onFormSubmit(t) {
    t.preventDefault();
  }
  onBtApply(t = !1, i = !1, s) {
    s && s.preventDefault(), this.applyModel(i ? "rowDataUpdated" : "ui") && this.providedFilterParams.filterChangedCallback({ afterFloatingFilter: t, afterDataChange: i, source: "columnFilter" });
    const { closeOnApply: o } = this.providedFilterParams;
    o && this.applyActive && !t && !i && this.close(s);
  }
  onNewRowsLoaded() {
  }
  close(t) {
    if (!this.hidePopup)
      return;
    const i = t, s = i && i.key;
    let o;
    (s === "Enter" || s === "Space") && (o = { keyboardEvent: i }), this.hidePopup(o), this.hidePopup = null;
  }
  /**
   * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
   * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
   * be adjusted by using the apply parameter.
   */
  onUiChanged(t = !1, i) {
    if (this.updateUiVisibility(), this.providedFilterParams.filterModifiedCallback(), this.applyActive && !this.isReadOnly()) {
      const s = this.isModelValid(this.getModelFromUi()), o = this.getRefElement("applyFilterButton");
      o && Qs(o, !s);
    }
    t && !i || i === "immediately" ? this.onBtApply(t) : (!this.applyActive && !i || i === "debounce") && this.onBtApplyDebounce();
  }
  afterGuiAttached(t) {
    t && (this.hidePopup = t.hidePopup), this.refreshFilterResizer(t == null ? void 0 : t.container);
  }
  refreshFilterResizer(t) {
    if (!this.positionableFeature || t === "toolPanel")
      return;
    const i = t === "floatingFilter" || t === "columnFilter", { positionableFeature: s, gos: o } = this;
    i ? (s.restoreLastSize(), s.setResizable(
      o.get("enableRtl") ? { bottom: !0, bottomLeft: !0, left: !0 } : { bottom: !0, bottomRight: !0, right: !0 }
    )) : (this.positionableFeature.removeSizeFromEl(), this.positionableFeature.setResizable(!1)), this.positionableFeature.constrainSizeToAvailableHeight(!0);
  }
  afterGuiDetached() {
    this.checkApplyDebounce(), this.positionableFeature && this.positionableFeature.constrainSizeToAvailableHeight(!1);
  }
  // static, as used by floating filter also
  static getDebounceMs(t, i) {
    return Fo.isUseApplyButton(t) ? (t.debounceMs != null && console.warn("AG Grid: debounceMs is ignored when apply button is present"), 0) : t.debounceMs != null ? t.debounceMs : i;
  }
  // static, as used by floating filter also
  static isUseApplyButton(t) {
    return !!t.buttons && t.buttons.indexOf("apply") >= 0;
  }
  refresh(t) {
    return this.providedFilterParams = t, !0;
  }
  destroy() {
    const t = this.getGui();
    t && t.removeEventListener("submit", this.onFormSubmit), this.hidePopup = null, this.positionableFeature && (this.positionableFeature = this.destroyBean(this.positionableFeature)), this.appliedModel = null, super.destroy();
  }
  translate(t) {
    return this.localeService.getLocaleTextFunc()(t, Lc[t]);
  }
  getCellValue(t) {
    return this.providedFilterParams.getValue(t);
  }
  // override to control positionable feature
  getPositionableElement() {
    return this.eFilterBody;
  }
};
u([
  f("rowModel")
], In.prototype, "rowModel", 2);
u([
  M("eFilterBody")
], In.prototype, "eFilterBody", 2);
u([
  L
], In.prototype, "postConstruct", 1);
var tn = In, Ia = class extends K {
  constructor(e, t) {
    super(t), this.labelSeparator = "", this.labelAlignment = "left", this.disabled = !1, this.label = "", this.config = e || {};
  }
  postConstruct() {
    this.addCssClass("ag-labeled"), this.eLabel.classList.add("ag-label");
    const { labelSeparator: e, label: t, labelWidth: i, labelAlignment: s, disabled: o } = this.config;
    o != null && this.setDisabled(o), e != null && this.setLabelSeparator(e), t != null && this.setLabel(t), i != null && this.setLabelWidth(i), this.setLabelAlignment(s || this.labelAlignment), this.refreshLabel();
  }
  refreshLabel() {
    xe(this.eLabel), typeof this.label == "string" ? this.eLabel.innerText = this.label + this.labelSeparator : this.label && this.eLabel.appendChild(this.label), this.label === "" ? (te(this.eLabel, !1), Fe(this.eLabel, "presentation")) : (te(this.eLabel, !0), Fe(this.eLabel, null));
  }
  setLabelSeparator(e) {
    return this.labelSeparator === e ? this : (this.labelSeparator = e, this.label != null && this.refreshLabel(), this);
  }
  getLabelId() {
    return this.eLabel.id = this.eLabel.id || `ag-${this.getCompId()}-label`, this.eLabel.id;
  }
  getLabel() {
    return this.label;
  }
  setLabel(e) {
    return this.label === e ? this : (this.label = e, this.refreshLabel(), this);
  }
  setLabelAlignment(e) {
    const i = this.getGui().classList;
    return i.toggle("ag-label-align-left", e === "left"), i.toggle("ag-label-align-right", e === "right"), i.toggle("ag-label-align-top", e === "top"), this;
  }
  setLabelEllipsis(e) {
    return this.eLabel.classList.toggle("ag-label-ellipsis", e), this;
  }
  setLabelWidth(e) {
    return this.label == null ? this : (jo(this.eLabel, e), this);
  }
  setDisabled(e) {
    e = !!e;
    const t = this.getGui();
    return Qs(t, e), t.classList.toggle("ag-disabled", e), this.disabled = e, this;
  }
  isDisabled() {
    return !!this.disabled;
  }
};
u([
  L
], Ia.prototype, "postConstruct", 1);
var xc = class extends Ia {
  constructor(e, t, i) {
    super(e, t), this.className = i;
  }
  postConstruct() {
    super.postConstruct();
    const { width: e, value: t, onValueChange: i } = this.config;
    e != null && this.setWidth(e), t != null && this.setValue(t), i != null && this.onValueChange(i), this.className && this.addCssClass(this.className), this.refreshAriaLabelledBy();
  }
  refreshAriaLabelledBy() {
    const e = this.getAriaElement(), t = this.getLabelId();
    Uu(e) !== null ? Ys(e, "") : Ys(e, t ?? "");
  }
  setAriaLabel(e) {
    return bt(this.getAriaElement(), e), this.refreshAriaLabelledBy(), this;
  }
  onValueChange(e) {
    return this.addManagedListener(this, p.EVENT_FIELD_VALUE_CHANGED, () => e(this.getValue())), this;
  }
  getWidth() {
    return this.getGui().clientWidth;
  }
  setWidth(e) {
    return Gt(this.getGui(), e), this;
  }
  getPreviousValue() {
    return this.previousValue;
  }
  getValue() {
    return this.value;
  }
  setValue(e, t) {
    return this.value === e ? this : (this.previousValue = this.value, this.value = e, t || this.dispatchEvent({ type: p.EVENT_FIELD_VALUE_CHANGED }), this);
  }
}, Rg = (
  /* html */
  `
    <div class="ag-picker-field" role="presentation">
        <div ref="eLabel"></div>
            <div ref="eWrapper" class="ag-wrapper ag-picker-field-wrapper ag-picker-collapsed">
            <div ref="eDisplayField" class="ag-picker-field-display"></div>
            <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
        </div>
    </div>`
), Ds = class extends xc {
  constructor(e) {
    if (super(e, (e == null ? void 0 : e.template) || Rg, e == null ? void 0 : e.className), this.isPickerDisplayed = !1, this.skipClick = !1, this.pickerGap = 4, this.hideCurrentPicker = null, this.ariaRole = e == null ? void 0 : e.ariaRole, this.onPickerFocusIn = this.onPickerFocusIn.bind(this), this.onPickerFocusOut = this.onPickerFocusOut.bind(this), !e)
      return;
    const { pickerGap: t, maxPickerHeight: i, variableWidth: s, minPickerWidth: o, maxPickerWidth: r } = e;
    t != null && (this.pickerGap = t), this.variableWidth = !!s, i != null && this.setPickerMaxHeight(i), o != null && this.setPickerMinWidth(o), r != null && this.setPickerMaxWidth(r);
  }
  postConstruct() {
    super.postConstruct(), this.setupAria();
    const e = `ag-${this.getCompId()}-display`;
    this.eDisplayField.setAttribute("id", e);
    const t = this.getAriaElement();
    this.addManagedListener(t, "keydown", this.onKeyDown.bind(this)), this.addManagedListener(this.eLabel, "mousedown", this.onLabelOrWrapperMouseDown.bind(this)), this.addManagedListener(this.eWrapper, "mousedown", this.onLabelOrWrapperMouseDown.bind(this));
    const { pickerIcon: i, inputWidth: s } = this.config;
    if (i) {
      const o = Te(i, this.gos);
      o && this.eIcon.appendChild(o);
    }
    s != null && this.setInputWidth(s);
  }
  setupAria() {
    const e = this.getAriaElement();
    e.setAttribute("tabindex", this.gos.get("tabIndex").toString()), fi(e, !1), this.ariaRole && Fe(e, this.ariaRole);
  }
  onLabelOrWrapperMouseDown(e) {
    if (e) {
      const t = this.getFocusableElement();
      if (t !== this.eWrapper && (e == null ? void 0 : e.target) === t)
        return;
      e.preventDefault(), this.getFocusableElement().focus();
    }
    if (this.skipClick) {
      this.skipClick = !1;
      return;
    }
    this.isDisabled() || (this.isPickerDisplayed ? this.hidePicker() : this.showPicker());
  }
  onKeyDown(e) {
    switch (e.key) {
      case S.UP:
      case S.DOWN:
      case S.ENTER:
      case S.SPACE:
        e.preventDefault(), this.onLabelOrWrapperMouseDown();
        break;
      case S.ESCAPE:
        this.isPickerDisplayed && (e.preventDefault(), e.stopPropagation(), this.hideCurrentPicker && this.hideCurrentPicker());
        break;
    }
  }
  showPicker() {
    this.isPickerDisplayed = !0, this.pickerComponent || (this.pickerComponent = this.createPickerComponent());
    const e = this.pickerComponent.getGui();
    e.addEventListener("focusin", this.onPickerFocusIn), e.addEventListener("focusout", this.onPickerFocusOut), this.hideCurrentPicker = this.renderAndPositionPicker(), this.toggleExpandedStyles(!0);
  }
  renderAndPositionPicker() {
    const e = this.gos.getDocument(), t = this.pickerComponent.getGui();
    this.gos.get("suppressScrollWhenPopupsAreOpen") || (this.destroyMouseWheelFunc = this.addManagedListener(this.eventService, p.EVENT_BODY_SCROLL, () => {
      this.hidePicker();
    }));
    const i = this.localeService.getLocaleTextFunc(), { pickerAriaLabelKey: s, pickerAriaLabelValue: o, modalPicker: r = !0 } = this.config, n = {
      modal: r,
      eChild: t,
      closeOnEsc: !0,
      closedCallback: () => {
        const m = this.gos.getActiveDomElement(), C = !m || m === e.body;
        this.beforeHidePicker(), C && this.isAlive() && this.getFocusableElement().focus();
      },
      ariaLabel: i(s, o)
    }, l = this.popupService.addPopup(n), { maxPickerHeight: a, minPickerWidth: d, maxPickerWidth: c, variableWidth: h } = this;
    h ? (d && (t.style.minWidth = d), t.style.width = Pn(Uo(this.eWrapper)), c && (t.style.maxWidth = c)) : jo(t, c ?? Uo(this.eWrapper));
    const g = a ?? `${hr(this.popupService.getPopupParent())}px`;
    return t.style.setProperty("max-height", g), t.style.position = "absolute", this.alignPickerToComponent(), l.hideFunc;
  }
  alignPickerToComponent() {
    if (!this.pickerComponent)
      return;
    const { pickerType: e } = this.config, { pickerGap: t } = this, i = this.gos.get("enableRtl") ? "right" : "left";
    this.popupService.positionPopupByComponent({
      type: e,
      eventSource: this.eWrapper,
      ePopup: this.pickerComponent.getGui(),
      position: "under",
      alignSide: i,
      keepWithinBounds: !0,
      nudgeY: t
    });
  }
  beforeHidePicker() {
    this.destroyMouseWheelFunc && (this.destroyMouseWheelFunc(), this.destroyMouseWheelFunc = void 0), this.toggleExpandedStyles(!1);
    const e = this.pickerComponent.getGui();
    e.removeEventListener("focusin", this.onPickerFocusIn), e.removeEventListener("focusout", this.onPickerFocusOut), this.isPickerDisplayed = !1, this.pickerComponent = void 0, this.hideCurrentPicker = null;
  }
  toggleExpandedStyles(e) {
    if (!this.isAlive())
      return;
    const t = this.getAriaElement();
    fi(t, e), this.eWrapper.classList.toggle("ag-picker-expanded", e), this.eWrapper.classList.toggle("ag-picker-collapsed", !e);
  }
  onPickerFocusIn() {
    this.togglePickerHasFocus(!0);
  }
  onPickerFocusOut(e) {
    var t;
    (t = this.pickerComponent) != null && t.getGui().contains(e.relatedTarget) || this.togglePickerHasFocus(!1);
  }
  togglePickerHasFocus(e) {
    this.pickerComponent && this.eWrapper.classList.toggle("ag-picker-has-focus", e);
  }
  hidePicker() {
    this.hideCurrentPicker && this.hideCurrentPicker();
  }
  setInputWidth(e) {
    return jo(this.eWrapper, e), this;
  }
  getFocusableElement() {
    return this.eWrapper;
  }
  setPickerGap(e) {
    return this.pickerGap = e, this;
  }
  setPickerMinWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.minPickerWidth = e ?? void 0, this;
  }
  setPickerMaxWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerWidth = e ?? void 0, this;
  }
  setPickerMaxHeight(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerHeight = e ?? void 0, this;
  }
  destroy() {
    this.hidePicker(), super.destroy();
  }
};
u([
  f("popupService")
], Ds.prototype, "popupService", 2);
u([
  M("eLabel")
], Ds.prototype, "eLabel", 2);
u([
  M("eWrapper")
], Ds.prototype, "eWrapper", 2);
u([
  M("eDisplayField")
], Ds.prototype, "eDisplayField", 2);
u([
  M("eIcon")
], Ds.prototype, "eIcon", 2);
var Mn = class kr extends K {
  constructor(t = "default", i = !1) {
    super(
      /* html */
      `<div class="ag-list ag-${t}-list" role="listbox"></div>`
    ), this.cssIdentifier = t, this.unFocusable = i, this.options = [], this.itemEls = [];
  }
  init() {
    const t = this.getGui();
    this.addManagedListener(t, "mouseleave", () => this.clearHighlighted()), !this.unFocusable && this.addManagedListener(t, "keydown", this.handleKeyDown.bind(this));
  }
  handleKeyDown(t) {
    const i = t.key;
    switch (i) {
      case S.ENTER:
        if (!this.highlightedEl)
          this.setValue(this.getValue());
        else {
          const s = this.itemEls.indexOf(this.highlightedEl);
          this.setValueByIndex(s);
        }
        break;
      case S.DOWN:
      case S.UP:
        t.preventDefault(), this.navigate(i);
        break;
      case S.PAGE_DOWN:
      case S.PAGE_UP:
      case S.PAGE_HOME:
      case S.PAGE_END:
        t.preventDefault(), this.navigateToPage(i);
        break;
    }
  }
  navigate(t) {
    const i = t === S.DOWN;
    let s;
    if (!this.highlightedEl)
      s = this.itemEls[i ? 0 : this.itemEls.length - 1];
    else {
      let r = this.itemEls.indexOf(this.highlightedEl) + (i ? 1 : -1);
      r = Math.min(Math.max(r, 0), this.itemEls.length - 1), s = this.itemEls[r];
    }
    this.highlightItem(s);
  }
  navigateToPage(t) {
    if (!this.highlightedEl || this.itemEls.length === 0)
      return;
    const i = this.itemEls.indexOf(this.highlightedEl), s = this.options.length - 1, o = this.itemEls[0].clientHeight, r = Math.floor(this.getGui().clientHeight / o);
    let n = -1;
    t === S.PAGE_HOME ? n = 0 : t === S.PAGE_END ? n = s : t === S.PAGE_DOWN ? n = Math.min(i + r, s) : t === S.PAGE_UP && (n = Math.max(i - r, 0)), n !== -1 && this.highlightItem(this.itemEls[n]);
  }
  addOptions(t) {
    return t.forEach((i) => this.addOption(i)), this;
  }
  addOption(t) {
    const { value: i, text: s } = t, o = s || i;
    return this.options.push({ value: i, text: o }), this.renderOption(i, o), this.updateIndices(), this;
  }
  clearOptions() {
    this.options = [], this.reset(!0), this.itemEls.forEach((t) => {
      $t(t);
    }), this.itemEls = [];
  }
  updateIndices() {
    const t = this.getGui().querySelectorAll(".ag-list-item");
    t.forEach((i, s) => {
      Tn(i, s + 1), Dn(i, t.length);
    });
  }
  renderOption(t, i) {
    const s = this.gos.getDocument(), o = s.createElement("div");
    Fe(o, "option"), o.classList.add("ag-list-item", `ag-${this.cssIdentifier}-list-item`);
    const r = s.createElement("span");
    o.appendChild(r), r.textContent = i, this.unFocusable || (o.tabIndex = -1), this.itemEls.push(o), this.addManagedListener(o, "mousemove", () => this.highlightItem(o)), this.addManagedListener(o, "mousedown", (n) => {
      n.preventDefault(), this.setValue(t);
    }), this.createManagedBean(new wi({
      getTooltipValue: () => i,
      getGui: () => o,
      getLocation: () => "UNKNOWN",
      // only show tooltips for items where the text cannot be fully displayed
      shouldDisplayTooltip: () => r.scrollWidth > r.clientWidth
    })), this.getGui().appendChild(o);
  }
  setValue(t, i) {
    if (this.value === t)
      return this.fireItemSelected(), this;
    if (t == null)
      return this.reset(i), this;
    const s = this.options.findIndex((o) => o.value === t);
    if (s !== -1) {
      const o = this.options[s];
      this.value = o.value, this.displayValue = o.text, this.highlightItem(this.itemEls[s]), i || this.fireChangeEvent();
    }
    return this;
  }
  setValueByIndex(t) {
    return this.setValue(this.options[t].value);
  }
  getValue() {
    return this.value;
  }
  getDisplayValue() {
    return this.displayValue;
  }
  refreshHighlighted() {
    this.clearHighlighted();
    const t = this.options.findIndex((i) => i.value === this.value);
    t !== -1 && this.highlightItem(this.itemEls[t]);
  }
  reset(t) {
    this.value = null, this.displayValue = null, this.clearHighlighted(), t || this.fireChangeEvent();
  }
  highlightItem(t) {
    if (!wt(t))
      return;
    this.clearHighlighted(), this.highlightedEl = t, this.highlightedEl.classList.add(kr.ACTIVE_CLASS), qs(this.highlightedEl, !0);
    const i = this.getGui(), { scrollTop: s, clientHeight: o } = i, { offsetTop: r, offsetHeight: n } = t;
    (r + n > s + o || r < s) && this.highlightedEl.scrollIntoView({ block: "nearest" }), this.unFocusable || this.highlightedEl.focus();
  }
  clearHighlighted() {
    !this.highlightedEl || !wt(this.highlightedEl) || (this.highlightedEl.classList.remove(kr.ACTIVE_CLASS), qs(this.highlightedEl, !1), this.highlightedEl = null);
  }
  fireChangeEvent() {
    this.dispatchEvent({ type: p.EVENT_FIELD_VALUE_CHANGED }), this.fireItemSelected();
  }
  fireItemSelected() {
    this.dispatchEvent({ type: kr.EVENT_ITEM_SELECTED });
  }
};
Mn.EVENT_ITEM_SELECTED = "selectedItem";
Mn.ACTIVE_CLASS = "ag-active-item";
u([
  L
], Mn.prototype, "init", 1);
var Ad = Mn, Nc = class Gc extends Ds {
  constructor(t) {
    super(_({
      pickerAriaLabelKey: "ariaLabelSelectField",
      pickerAriaLabelValue: "Select Field",
      pickerType: "ag-list",
      className: "ag-select",
      pickerIcon: "smallDown",
      ariaRole: "combobox"
    }, t));
  }
  postConstruct() {
    super.postConstruct(), this.createListComponent(), this.eWrapper.tabIndex = this.gos.get("tabIndex");
    const { options: t, value: i, placeholder: s } = this.config;
    t != null && this.addOptions(t), i != null && this.setValue(i, !0), s && i == null && (this.eDisplayField.textContent = s), this.addManagedListener(this.eWrapper, "focusout", this.onWrapperFocusOut.bind(this));
  }
  onWrapperFocusOut(t) {
    this.eWrapper.contains(t.relatedTarget) || this.hidePicker();
  }
  createListComponent() {
    this.listComponent = this.createBean(new Ad("select", !0)), this.listComponent.setParentComponent(this);
    const t = this.listComponent.getAriaElement(), i = `ag-select-list-${this.listComponent.getCompId()}`;
    t.setAttribute("id", i), ca(this.getAriaElement(), t), this.listComponent.addManagedListener(
      this.listComponent,
      Ad.EVENT_ITEM_SELECTED,
      () => {
        this.hidePicker(), this.dispatchEvent({ type: Gc.EVENT_ITEM_SELECTED });
      }
    ), this.listComponent.addManagedListener(
      this.listComponent,
      p.EVENT_FIELD_VALUE_CHANGED,
      () => {
        this.listComponent && (this.setValue(this.listComponent.getValue(), !1, !0), this.hidePicker());
      }
    );
  }
  createPickerComponent() {
    return this.listComponent;
  }
  onKeyDown(t) {
    var i;
    const { key: s } = t;
    switch (s === S.TAB && this.hidePicker(), s) {
      case S.ENTER:
      case S.UP:
      case S.DOWN:
      case S.PAGE_UP:
      case S.PAGE_DOWN:
      case S.PAGE_HOME:
      case S.PAGE_END:
        t.preventDefault(), this.isPickerDisplayed ? (i = this.listComponent) == null || i.handleKeyDown(t) : super.onKeyDown(t);
        break;
      case S.ESCAPE:
        super.onKeyDown(t);
        break;
    }
  }
  showPicker() {
    this.listComponent && (super.showPicker(), this.listComponent.refreshHighlighted());
  }
  addOptions(t) {
    return t.forEach((i) => this.addOption(i)), this;
  }
  addOption(t) {
    return this.listComponent.addOption(t), this;
  }
  clearOptions() {
    var t;
    return (t = this.listComponent) == null || t.clearOptions(), this;
  }
  setValue(t, i, s) {
    if (this.value === t || !this.listComponent)
      return this;
    if (s || this.listComponent.setValue(t, !0), this.listComponent.getValue() === this.getValue())
      return this;
    let r = this.listComponent.getDisplayValue();
    return r == null && this.config.placeholder && (r = this.config.placeholder), this.eDisplayField.textContent = r, this.setTooltip({
      newTooltipText: r ?? null,
      shouldDisplayTooltip: () => this.eDisplayField.scrollWidth > this.eDisplayField.clientWidth
    }), super.setValue(t, i);
  }
  destroy() {
    this.listComponent && (this.destroyBean(this.listComponent), this.listComponent = void 0), super.destroy();
  }
};
Nc.EVENT_ITEM_SELECTED = "selectedItem";
var xn = Nc, jt = class extends xc {
  constructor(e, t, i = "text", s = "input") {
    super(
      e,
      /* html */
      `
            <div role="presentation">
                <div ref="eLabel" class="ag-input-field-label"></div>
                <div ref="eWrapper" class="ag-wrapper ag-input-wrapper" role="presentation">
                    <${s} ref="eInput" class="ag-input-field-input"></${s}>
                </div>
            </div>`,
      t
    ), this.inputType = i, this.displayFieldTag = s;
  }
  postConstruct() {
    super.postConstruct(), this.setInputType(), this.eLabel.classList.add(`${this.className}-label`), this.eWrapper.classList.add(`${this.className}-input-wrapper`), this.eInput.classList.add(`${this.className}-input`), this.addCssClass("ag-input-field"), this.eInput.id = this.eInput.id || `ag-${this.getCompId()}-input`;
    const { inputName: e, inputWidth: t } = this.config;
    e != null && this.setInputName(e), t != null && this.setInputWidth(t), this.addInputListeners(), this.activateTabIndex([this.eInput]);
  }
  addInputListeners() {
    this.addManagedListener(this.eInput, "input", (e) => this.setValue(e.target.value));
  }
  setInputType() {
    this.displayFieldTag === "input" && this.eInput.setAttribute("type", this.inputType);
  }
  getInputElement() {
    return this.eInput;
  }
  setInputWidth(e) {
    return jo(this.eWrapper, e), this;
  }
  setInputName(e) {
    return this.getInputElement().setAttribute("name", e), this;
  }
  getFocusableElement() {
    return this.eInput;
  }
  setMaxLength(e) {
    const t = this.eInput;
    return t.maxLength = e, this;
  }
  setInputPlaceholder(e) {
    return oi(this.eInput, "placeholder", e), this;
  }
  setInputAriaLabel(e) {
    return bt(this.eInput, e), this.refreshAriaLabelledBy(), this;
  }
  setDisabled(e) {
    return Qs(this.eInput, e), super.setDisabled(e);
  }
  setAutoComplete(e) {
    if (e === !0)
      oi(this.eInput, "autocomplete", null);
    else {
      const t = typeof e == "string" ? e : "off";
      oi(this.eInput, "autocomplete", t);
    }
    return this;
  }
};
u([
  M("eLabel")
], jt.prototype, "eLabel", 2);
u([
  M("eWrapper")
], jt.prototype, "eWrapper", 2);
u([
  M("eInput")
], jt.prototype, "eInput", 2);
var Nn = class extends jt {
  constructor(e, t = "ag-checkbox", i = "checkbox") {
    super(e, t, i), this.labelAlignment = "right", this.selected = !1, this.readOnly = !1, this.passive = !1;
  }
  postConstruct() {
    super.postConstruct();
    const { readOnly: e, passive: t } = this.config;
    typeof e == "boolean" && this.setReadOnly(e), typeof t == "boolean" && this.setPassive(t);
  }
  addInputListeners() {
    this.addManagedListener(this.eInput, "click", this.onCheckboxClick.bind(this)), this.addManagedListener(this.eLabel, "click", this.toggle.bind(this));
  }
  getNextValue() {
    return this.selected === void 0 ? !0 : !this.selected;
  }
  setPassive(e) {
    this.passive = e;
  }
  isReadOnly() {
    return this.readOnly;
  }
  setReadOnly(e) {
    this.eWrapper.classList.toggle("ag-disabled", e), this.eInput.disabled = e, this.readOnly = e;
  }
  setDisabled(e) {
    return this.eWrapper.classList.toggle("ag-disabled", e), super.setDisabled(e);
  }
  toggle() {
    if (this.eInput.disabled)
      return;
    const e = this.isSelected(), t = this.getNextValue();
    this.passive ? this.dispatchChange(t, e) : this.setValue(t);
  }
  getValue() {
    return this.isSelected();
  }
  setValue(e, t) {
    return this.refreshSelectedClass(e), this.setSelected(e, t), this;
  }
  setName(e) {
    const t = this.getInputElement();
    return t.name = e, this;
  }
  isSelected() {
    return this.selected;
  }
  setSelected(e, t) {
    this.isSelected() !== e && (this.previousValue = this.isSelected(), e = this.selected = typeof e == "boolean" ? e : void 0, this.eInput.checked = e, this.eInput.indeterminate = e === void 0, t || this.dispatchChange(this.selected, this.previousValue));
  }
  dispatchChange(e, t, i) {
    this.dispatchEvent({ type: p.EVENT_FIELD_VALUE_CHANGED, selected: e, previousValue: t, event: i });
    const s = this.getInputElement(), o = {
      type: p.EVENT_CHECKBOX_CHANGED,
      id: s.id,
      name: s.name,
      selected: e,
      previousValue: t
    };
    this.eventService.dispatchEvent(o);
  }
  onCheckboxClick(e) {
    if (this.passive || this.eInput.disabled)
      return;
    const t = this.isSelected(), i = this.selected = e.target.checked;
    this.refreshSelectedClass(i), this.dispatchChange(i, t, e);
  }
  refreshSelectedClass(e) {
    this.eWrapper.classList.toggle("ag-checked", e === !0), this.eWrapper.classList.toggle("ag-indeterminate", e == null);
  }
}, Oc = class extends Nn {
  constructor(e) {
    super(e, "ag-radio-button", "radio");
  }
  isSelected() {
    return this.eInput.checked;
  }
  toggle() {
    this.eInput.disabled || this.isSelected() || this.setValue(!0);
  }
  addInputListeners() {
    super.addInputListeners(), this.addManagedListener(this.eventService, p.EVENT_CHECKBOX_CHANGED, this.onChange.bind(this));
  }
  /**
   * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
   * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
   * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
   * not deselected, so we need to use our own event.
   */
  onChange(e) {
    e.selected && e.name && this.eInput.name && this.eInput.name === e.name && e.id && this.eInput.id !== e.id && this.setValue(!1, !0);
  }
}, Ma = class {
  constructor(e, t, i) {
    this.localeService = e, this.optionsFactory = t, this.valueFormatter = i;
  }
  // used by:
  // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
  // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
  getModelAsString(e) {
    if (!e)
      return null;
    const t = e.operator != null, i = this.localeService.getLocaleTextFunc();
    if (t) {
      const s = e;
      let { conditions: o } = s;
      if (!o) {
        const { condition1: l, condition2: a } = s;
        o = [l, a];
      }
      const r = o.map((l) => this.getModelAsString(l)), n = s.operator === "AND" ? "andCondition" : "orCondition";
      return r.join(` ${i(n, Lc[n])} `);
    } else {
      if (e.type === Pe.BLANK || e.type === Pe.NOT_BLANK)
        return i(e.type, e.type);
      {
        const s = e, o = this.optionsFactory.getCustomOption(s.type), { displayKey: r, displayName: n, numberOfInputs: l } = o || {};
        return r && n && l === 0 ? (i(r, n), n) : this.conditionToString(s, o);
      }
    }
  }
  updateParams(e) {
    this.optionsFactory = e.optionsFactory;
  }
  formatValue(e) {
    var t;
    return this.valueFormatter ? (t = this.valueFormatter(e ?? null)) != null ? t : "" : String(e);
  }
}, ut = class _s extends tn {
  constructor() {
    super(...arguments), this.eTypes = [], this.eJoinOperatorPanels = [], this.eJoinOperatorsAnd = [], this.eJoinOperatorsOr = [], this.eConditionBodies = [], this.listener = () => this.onUiChanged(), this.lastUiCompletePosition = null, this.joinOperatorId = 0;
  }
  getNumberOfInputs(t) {
    const i = this.optionsFactory.getCustomOption(t);
    if (i) {
      const { numberOfInputs: o } = i;
      return o ?? 1;
    }
    const s = [
      _s.EMPTY,
      _s.NOT_BLANK,
      _s.BLANK
    ];
    return t && s.indexOf(t) >= 0 ? 0 : t === _s.IN_RANGE ? 2 : 1;
  }
  // floating filter calls this when user applies filter from floating filter
  onFloatingFilterChanged(t, i) {
    this.setTypeFromFloatingFilter(t), this.setValueFromFloatingFilter(i), this.onUiChanged(!0);
  }
  setTypeFromFloatingFilter(t) {
    this.eTypes.forEach((i, s) => {
      s === 0 ? i.setValue(t, !0) : i.setValue(this.optionsFactory.getDefaultOption(), !0);
    });
  }
  getModelFromUi() {
    const t = this.getUiCompleteConditions();
    return t.length === 0 ? null : this.maxNumConditions > 1 && t.length > 1 ? {
      filterType: this.getFilterType(),
      operator: this.getJoinOperator(),
      condition1: t[0],
      condition2: t[1],
      conditions: t
    } : t[0];
  }
  getConditionTypes() {
    return this.eTypes.map((t) => t.getValue());
  }
  getConditionType(t) {
    return this.eTypes[t].getValue();
  }
  getJoinOperator() {
    return this.eJoinOperatorsOr.length === 0 ? this.defaultJoinOperator : this.eJoinOperatorsOr[0].getValue() === !0 ? "OR" : "AND";
  }
  areModelsEqual(t, i) {
    if (!t && !i)
      return !0;
    if (!t && i || t && !i)
      return !1;
    const s = !t.operator, o = !i.operator;
    if (!s && o || s && !o)
      return !1;
    let n;
    if (s) {
      const l = t, a = i;
      n = this.areSimpleModelsEqual(l, a);
    } else {
      const l = t, a = i;
      n = l.operator === a.operator && ii(l.conditions, a.conditions, (d, c) => this.areSimpleModelsEqual(d, c));
    }
    return n;
  }
  shouldRefresh(t) {
    var i, s, o;
    const r = this.getModel(), n = r ? (i = r.conditions) != null ? i : [r] : null, l = (o = (s = t.filterOptions) == null ? void 0 : s.map(
      (d) => typeof d == "string" ? d : d.displayKey
    )) != null ? o : this.getDefaultFilterOptions();
    return !(!(!n || n.every((d) => l.find((c) => c === d.type) !== void 0)) || typeof t.maxNumConditions == "number" && n && n.length > t.maxNumConditions);
  }
  refresh(t) {
    return !this.shouldRefresh(t) || !super.refresh(t) ? !1 : (this.setParams(t), this.removeConditionsAndOperators(0), this.createOption(), this.setModel(this.getModel()), !0);
  }
  setModelIntoUi(t) {
    if (t.operator) {
      let s = t;
      s.conditions || (s.conditions = [
        s.condition1,
        s.condition2
      ]);
      const o = this.validateAndUpdateConditions(s.conditions), r = this.getNumConditions();
      if (o < r)
        this.removeConditionsAndOperators(o);
      else if (o > r)
        for (let l = r; l < o; l++)
          this.createJoinOperatorPanel(), this.createOption();
      const n = s.operator === "OR";
      this.eJoinOperatorsAnd.forEach((l) => l.setValue(!n, !0)), this.eJoinOperatorsOr.forEach((l) => l.setValue(n, !0)), s.conditions.forEach((l, a) => {
        this.eTypes[a].setValue(l.type, !0), this.setConditionIntoUi(l, a);
      });
    } else {
      const s = t;
      this.getNumConditions() > 1 && this.removeConditionsAndOperators(1), this.eTypes[0].setValue(s.type, !0), this.setConditionIntoUi(s, 0);
    }
    return this.lastUiCompletePosition = this.getNumConditions() - 1, this.createMissingConditionsAndOperators(), this.onUiChanged(), _e.resolve();
  }
  validateAndUpdateConditions(t) {
    let i = t.length;
    return i > this.maxNumConditions && (t.splice(this.maxNumConditions), H('Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.'), i = this.maxNumConditions), i;
  }
  doesFilterPass(t) {
    var i;
    const s = this.getModel();
    if (s == null)
      return !0;
    const { operator: o } = s, r = [];
    if (o) {
      const l = s;
      r.push(...(i = l.conditions) != null ? i : []);
    } else
      r.push(s);
    return r[o && o === "OR" ? "some" : "every"]((l) => this.individualConditionPasses(t, l));
  }
  setParams(t) {
    super.setParams(t), this.setNumConditions(t), this.defaultJoinOperator = this.getDefaultJoinOperator(t.defaultJoinOperator), this.filterPlaceholder = t.filterPlaceholder, this.optionsFactory = new Fc(), this.optionsFactory.init(t, this.getDefaultFilterOptions()), this.createFilterListOptions(), this.createOption(), this.createMissingConditionsAndOperators(), this.isReadOnly() && this.eFilterBody.setAttribute("tabindex", "-1");
  }
  setNumConditions(t) {
    var i, s;
    t.suppressAndOrCondition != null && H('Since v29.2 "filterParams.suppressAndOrCondition" is deprecated. Use "filterParams.maxNumConditions = 1" instead.'), t.alwaysShowBothConditions != null && H('Since v29.2 "filterParams.alwaysShowBothConditions" is deprecated. Use "filterParams.numAlwaysVisibleConditions = 2" instead.'), this.maxNumConditions = (i = t.maxNumConditions) != null ? i : t.suppressAndOrCondition ? 1 : 2, this.maxNumConditions < 1 && (H('"filterParams.maxNumConditions" must be greater than or equal to zero.'), this.maxNumConditions = 1), this.numAlwaysVisibleConditions = (s = t.numAlwaysVisibleConditions) != null ? s : t.alwaysShowBothConditions ? 2 : 1, this.numAlwaysVisibleConditions < 1 && (H('"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.'), this.numAlwaysVisibleConditions = 1), this.numAlwaysVisibleConditions > this.maxNumConditions && (H('"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".'), this.numAlwaysVisibleConditions = this.maxNumConditions);
  }
  createOption() {
    const t = this.createManagedBean(new xn());
    this.eTypes.push(t), t.addCssClass("ag-filter-select"), this.eFilterBody.appendChild(t.getGui());
    const i = this.createValueElement();
    this.eConditionBodies.push(i), this.eFilterBody.appendChild(i), this.putOptionsIntoDropdown(t), this.resetType(t);
    const s = this.getNumConditions() - 1;
    this.forEachPositionInput(s, (o) => this.resetInput(o)), this.addChangedListeners(t, s);
  }
  createJoinOperatorPanel() {
    const t = document.createElement("div");
    this.eJoinOperatorPanels.push(t), t.classList.add("ag-filter-condition");
    const i = this.createJoinOperator(this.eJoinOperatorsAnd, t, "and"), s = this.createJoinOperator(this.eJoinOperatorsOr, t, "or");
    this.eFilterBody.appendChild(t);
    const o = this.eJoinOperatorPanels.length - 1, r = this.joinOperatorId++;
    this.resetJoinOperatorAnd(i, o, r), this.resetJoinOperatorOr(s, o, r), this.isReadOnly() || (i.onValueChange(this.listener), s.onValueChange(this.listener));
  }
  createJoinOperator(t, i, s) {
    const o = this.createManagedBean(new Oc());
    return t.push(o), o.addCssClass("ag-filter-condition-operator"), o.addCssClass(`ag-filter-condition-operator-${s}`), i.appendChild(o.getGui()), o;
  }
  getDefaultJoinOperator(t) {
    return t === "AND" || t === "OR" ? t : "AND";
  }
  createFilterListOptions() {
    const t = this.optionsFactory.getFilterOptions();
    this.filterListOptions = t.map(
      (i) => typeof i == "string" ? this.createBoilerplateListOption(i) : this.createCustomListOption(i)
    );
  }
  putOptionsIntoDropdown(t) {
    this.filterListOptions.forEach((i) => {
      t.addOption(i);
    }), t.setDisabled(this.filterListOptions.length <= 1);
  }
  createBoilerplateListOption(t) {
    return { value: t, text: this.translate(t) };
  }
  createCustomListOption(t) {
    const { displayKey: i } = t, s = this.optionsFactory.getCustomOption(t.displayKey);
    return {
      value: i,
      text: s ? this.localeService.getLocaleTextFunc()(s.displayKey, s.displayName) : this.translate(i)
    };
  }
  /**
   * @deprecated As of v29.2 filters can have more than two conditions. Check `colDef.filterParams.maxNumConditions` instead.
   */
  isAllowTwoConditions() {
    return this.maxNumConditions >= 2;
  }
  createBodyTemplate() {
    return "";
  }
  getCssIdentifier() {
    return "simple-filter";
  }
  updateUiVisibility() {
    const t = this.getJoinOperator();
    this.updateNumConditions(), this.updateConditionStatusesAndValues(this.lastUiCompletePosition, t);
  }
  updateNumConditions() {
    var t;
    let i = -1, s = !0;
    for (let o = 0; o < this.getNumConditions(); o++)
      this.isConditionUiComplete(o) ? i = o : s = !1;
    if (this.shouldAddNewConditionAtEnd(s))
      this.createJoinOperatorPanel(), this.createOption();
    else {
      const o = (t = this.lastUiCompletePosition) != null ? t : this.getNumConditions() - 2;
      if (i < o) {
        this.removeConditionsAndOperators(o + 1);
        const r = i + 1, n = o - r;
        n > 0 && this.removeConditionsAndOperators(r, n), this.createMissingConditionsAndOperators();
      }
    }
    this.lastUiCompletePosition = i;
  }
  updateConditionStatusesAndValues(t, i) {
    this.eTypes.forEach((o, r) => {
      const n = this.isConditionDisabled(r, t);
      o.setDisabled(n || this.filterListOptions.length <= 1), r === 1 && (Qs(this.eJoinOperatorPanels[0], n), this.eJoinOperatorsAnd[0].setDisabled(n), this.eJoinOperatorsOr[0].setDisabled(n));
    }), this.eConditionBodies.forEach((o, r) => {
      te(o, this.isConditionBodyVisible(r));
    });
    const s = (i ?? this.getJoinOperator()) === "OR";
    this.eJoinOperatorsAnd.forEach((o, r) => {
      o.setValue(!s, !0);
    }), this.eJoinOperatorsOr.forEach((o, r) => {
      o.setValue(s, !0);
    }), this.forEachInput((o, r, n, l) => {
      this.setElementDisplayed(o, r < l), this.setElementDisabled(o, this.isConditionDisabled(n, t));
    }), this.resetPlaceholder();
  }
  shouldAddNewConditionAtEnd(t) {
    return t && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
  }
  removeConditionsAndOperators(t, i) {
    if (t >= this.getNumConditions())
      return;
    this.removeComponents(this.eTypes, t, i), this.removeElements(this.eConditionBodies, t, i), this.removeValueElements(t, i);
    const s = Math.max(t - 1, 0);
    this.removeElements(this.eJoinOperatorPanels, s, i), this.removeComponents(this.eJoinOperatorsAnd, s, i), this.removeComponents(this.eJoinOperatorsOr, s, i);
  }
  removeElements(t, i, s) {
    this.removeItems(t, i, s).forEach((r) => $t(r));
  }
  removeComponents(t, i, s) {
    this.removeItems(t, i, s).forEach((r) => {
      $t(r.getGui()), this.destroyBean(r);
    });
  }
  removeItems(t, i, s) {
    return s == null ? t.splice(i) : t.splice(i, s);
  }
  afterGuiAttached(t) {
    if (super.afterGuiAttached(t), this.resetPlaceholder(), !(t != null && t.suppressFocus))
      if (this.isReadOnly())
        this.eFilterBody.focus();
      else {
        const i = this.getInputs(0)[0];
        if (!i)
          return;
        i instanceof jt && i.getInputElement().focus();
      }
  }
  afterGuiDetached() {
    super.afterGuiDetached();
    const t = this.getModel();
    this.resetUiToActiveModel(t);
    let i = -1, s = -1, o = !1;
    const r = this.getJoinOperator();
    for (let l = this.getNumConditions() - 1; l >= 0; l--)
      if (this.isConditionUiComplete(l))
        i === -1 && (i = l, s = l);
      else {
        const a = l >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(l - 1), d = l < i;
        (a || d) && (this.removeConditionsAndOperators(l, 1), o = !0, d && s--);
      }
    let n = !1;
    this.getNumConditions() < this.numAlwaysVisibleConditions && (this.createMissingConditionsAndOperators(), n = !0), this.shouldAddNewConditionAtEnd(s === this.getNumConditions() - 1) && (this.createJoinOperatorPanel(), this.createOption(), n = !0), n && this.updateConditionStatusesAndValues(s, r), o && this.updateJoinOperatorsDisabled(), this.lastUiCompletePosition = s;
  }
  getPlaceholderText(t, i) {
    let s = this.translate(t);
    if (Sn(this.filterPlaceholder)) {
      const o = this.filterPlaceholder, r = this.eTypes[i].getValue(), n = this.translate(r);
      s = o({
        filterOptionKey: r,
        filterOption: n,
        placeholder: s
      });
    } else typeof this.filterPlaceholder == "string" && (s = this.filterPlaceholder);
    return s;
  }
  // allow sub-classes to reset HTML placeholders after UI update.
  resetPlaceholder() {
    const t = this.localeService.getLocaleTextFunc();
    this.forEachInput((i, s, o, r) => {
      if (!(i instanceof jt))
        return;
      const n = s === 0 && r > 1 ? "inRangeStart" : s === 0 ? "filterOoo" : "inRangeEnd", l = s === 0 && r > 1 ? t("ariaFilterFromValue", "Filter from value") : s === 0 ? t("ariaFilterValue", "Filter Value") : t("ariaFilterToValue", "Filter to Value");
      i.setInputPlaceholder(this.getPlaceholderText(n, o)), i.setInputAriaLabel(l);
    });
  }
  setElementValue(t, i, s) {
    t instanceof jt && t.setValue(i != null ? String(i) : null, !0);
  }
  setElementDisplayed(t, i) {
    t instanceof K && te(t.getGui(), i);
  }
  setElementDisabled(t, i) {
    t instanceof K && Qs(t.getGui(), i);
  }
  attachElementOnChange(t, i) {
    t instanceof jt && t.onValueChange(i);
  }
  forEachInput(t) {
    this.getConditionTypes().forEach((i, s) => {
      this.forEachPositionTypeInput(s, i, t);
    });
  }
  forEachPositionInput(t, i) {
    const s = this.getConditionType(t);
    this.forEachPositionTypeInput(t, s, i);
  }
  forEachPositionTypeInput(t, i, s) {
    const o = this.getNumberOfInputs(i), r = this.getInputs(t);
    for (let n = 0; n < r.length; n++) {
      const l = r[n];
      l != null && s(l, n, t, o);
    }
  }
  isConditionDisabled(t, i) {
    return this.isReadOnly() ? !0 : t === 0 ? !1 : t > i + 1;
  }
  isConditionBodyVisible(t) {
    const i = this.getConditionType(t);
    return this.getNumberOfInputs(i) > 0;
  }
  // returns true if the UI represents a working filter, eg all parts are filled out.
  // eg if text filter and textfield blank then returns false.
  isConditionUiComplete(t) {
    return !(t >= this.getNumConditions() || this.getConditionType(t) === _s.EMPTY || this.getValues(t).some((s) => s == null));
  }
  getNumConditions() {
    return this.eTypes.length;
  }
  getUiCompleteConditions() {
    const t = [];
    for (let i = 0; i < this.getNumConditions(); i++)
      this.isConditionUiComplete(i) && t.push(this.createCondition(i));
    return t;
  }
  createMissingConditionsAndOperators() {
    if (!this.isReadOnly())
      for (let t = this.getNumConditions(); t < this.numAlwaysVisibleConditions; t++)
        this.createJoinOperatorPanel(), this.createOption();
  }
  resetUiToDefaults(t) {
    return this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions), this.eTypes.forEach((i) => this.resetType(i)), this.eJoinOperatorsAnd.forEach((i, s) => this.resetJoinOperatorAnd(i, s, this.joinOperatorId + s)), this.eJoinOperatorsOr.forEach((i, s) => this.resetJoinOperatorOr(i, s, this.joinOperatorId + s)), this.joinOperatorId++, this.forEachInput((i) => this.resetInput(i)), this.resetPlaceholder(), this.createMissingConditionsAndOperators(), this.lastUiCompletePosition = null, t || this.onUiChanged(), _e.resolve();
  }
  resetType(t) {
    const s = this.localeService.getLocaleTextFunc()("ariaFilteringOperator", "Filtering operator");
    t.setValue(this.optionsFactory.getDefaultOption(), !0).setAriaLabel(s).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
  }
  resetJoinOperatorAnd(t, i, s) {
    this.resetJoinOperator(t, i, this.isDefaultOperator("AND"), this.translate("andCondition"), s);
  }
  resetJoinOperatorOr(t, i, s) {
    this.resetJoinOperator(t, i, this.isDefaultOperator("OR"), this.translate("orCondition"), s);
  }
  resetJoinOperator(t, i, s, o, r) {
    this.updateJoinOperatorDisabled(
      t.setValue(s, !0).setName(`ag-simple-filter-and-or-${this.getCompId()}-${r}`).setLabel(o),
      i
    );
  }
  updateJoinOperatorsDisabled() {
    this.eJoinOperatorsAnd.forEach((t, i) => this.updateJoinOperatorDisabled(t, i)), this.eJoinOperatorsOr.forEach((t, i) => this.updateJoinOperatorDisabled(t, i));
  }
  updateJoinOperatorDisabled(t, i) {
    t.setDisabled(this.isReadOnly() || i > 0);
  }
  resetInput(t) {
    this.setElementValue(t, null), this.setElementDisabled(t, this.isReadOnly());
  }
  // puts model values into the UI
  setConditionIntoUi(t, i) {
    const s = this.mapValuesFromModel(t);
    this.forEachInput((o, r, n, l) => {
      n === i && this.setElementValue(o, s[r] != null ? s[r] : null);
    });
  }
  // after floating filter changes, this sets the 'value' section. this is implemented by the base class
  // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.
  setValueFromFloatingFilter(t) {
    this.forEachInput((i, s, o, r) => {
      this.setElementValue(i, s === 0 && o === 0 ? t : null, !0);
    });
  }
  isDefaultOperator(t) {
    return t === this.defaultJoinOperator;
  }
  addChangedListeners(t, i) {
    this.isReadOnly() || (t.onValueChange(this.listener), this.forEachPositionInput(i, (s) => {
      this.attachElementOnChange(s, this.listener);
    }));
  }
  /** returns true if the row passes the said condition */
  individualConditionPasses(t, i) {
    const s = this.getCellValue(t.node), o = this.mapValuesFromModel(i), r = this.optionsFactory.getCustomOption(i.type), n = this.evaluateCustomFilter(r, o, s);
    return n ?? (s == null ? this.evaluateNullValue(i.type) : this.evaluateNonNullValue(o, s, i, t));
  }
  evaluateCustomFilter(t, i, s) {
    if (t == null)
      return;
    const { predicate: o } = t;
    if (o != null && !i.some((r) => r == null))
      return o(i, s);
  }
  isBlank(t) {
    return t == null || typeof t == "string" && t.trim().length === 0;
  }
  hasInvalidInputs() {
    return !1;
  }
};
ut.EMPTY = "empty";
ut.BLANK = "blank";
ut.NOT_BLANK = "notBlank";
ut.EQUALS = "equals";
ut.NOT_EQUAL = "notEqual";
ut.LESS_THAN = "lessThan";
ut.LESS_THAN_OR_EQUAL = "lessThanOrEqual";
ut.GREATER_THAN = "greaterThan";
ut.GREATER_THAN_OR_EQUAL = "greaterThanOrEqual";
ut.IN_RANGE = "inRange";
ut.CONTAINS = "contains";
ut.NOT_CONTAINS = "notContains";
ut.STARTS_WITH = "startsWith";
ut.ENDS_WITH = "endsWith";
var Pe = ut, He = class ze extends Pe {
  setParams(t) {
    super.setParams(t), this.scalarFilterParams = t;
  }
  evaluateNullValue(t) {
    switch (t) {
      case ze.EQUALS:
      case ze.NOT_EQUAL:
        if (this.scalarFilterParams.includeBlanksInEquals)
          return !0;
        break;
      case ze.GREATER_THAN:
      case ze.GREATER_THAN_OR_EQUAL:
        if (this.scalarFilterParams.includeBlanksInGreaterThan)
          return !0;
        break;
      case ze.LESS_THAN:
      case ze.LESS_THAN_OR_EQUAL:
        if (this.scalarFilterParams.includeBlanksInLessThan)
          return !0;
        break;
      case ze.IN_RANGE:
        if (this.scalarFilterParams.includeBlanksInRange)
          return !0;
        break;
      case ze.BLANK:
        return !0;
      case ze.NOT_BLANK:
        return !1;
    }
    return !1;
  }
  evaluateNonNullValue(t, i, s) {
    const o = this.comparator(), r = t[0] != null ? o(t[0], i) : 0;
    switch (s.type) {
      case ze.EQUALS:
        return r === 0;
      case ze.NOT_EQUAL:
        return r !== 0;
      case ze.GREATER_THAN:
        return r > 0;
      case ze.GREATER_THAN_OR_EQUAL:
        return r >= 0;
      case ze.LESS_THAN:
        return r < 0;
      case ze.LESS_THAN_OR_EQUAL:
        return r <= 0;
      case ze.IN_RANGE: {
        const n = o(t[1], i);
        return this.scalarFilterParams.inRangeInclusive ? r >= 0 && n <= 0 : r > 0 && n < 0;
      }
      case ze.BLANK:
        return this.isBlank(i);
      case ze.NOT_BLANK:
        return !this.isBlank(i);
      default:
        return console.warn('AG Grid: Unexpected type of filter "' + s.type + '", it looks like the filter was configured with incorrect Filter Options'), !0;
    }
  }
}, Pd = 1e3, Fd = 1 / 0, _c = class extends Ma {
  constructor(e, t, i) {
    super(t, i), this.dateFilterParams = e;
  }
  conditionToString(e, t) {
    const { type: i } = e, { numberOfInputs: s } = t || {}, o = i == Pe.IN_RANGE || s === 2, r = mt(e.dateFrom), n = mt(e.dateTo), l = this.dateFilterParams.inRangeFloatingFilterDateFormat;
    if (o) {
      const a = r !== null ? Ks(r, l) : "null", d = n !== null ? Ks(n, l) : "null";
      return `${a}-${d}`;
    }
    return r != null ? Ks(r, l) : `${i}`;
  }
  updateParams(e) {
    super.updateParams(e), this.dateFilterParams = e.dateFilterParams;
  }
}, xa = class Vc extends He {
  constructor() {
    super("dateFilter"), this.eConditionPanelsFrom = [], this.eConditionPanelsTo = [], this.dateConditionFromComps = [], this.dateConditionToComps = [], this.minValidYear = Pd, this.maxValidYear = Fd, this.minValidDate = null, this.maxValidDate = null;
  }
  afterGuiAttached(t) {
    super.afterGuiAttached(t), this.dateConditionFromComps[0].afterGuiAttached(t);
  }
  mapValuesFromModel(t) {
    const { dateFrom: i, dateTo: s, type: o } = t || {};
    return [
      i && mt(i) || null,
      s && mt(s) || null
    ].slice(0, this.getNumberOfInputs(o));
  }
  comparator() {
    return this.dateFilterParams.comparator ? this.dateFilterParams.comparator : this.defaultComparator.bind(this);
  }
  defaultComparator(t, i) {
    const s = i;
    return i == null || s < t ? -1 : s > t ? 1 : 0;
  }
  setParams(t) {
    this.dateFilterParams = t, super.setParams(t);
    const i = (s, o) => {
      if (t[s] != null)
        if (isNaN(t[s]))
          console.warn(`AG Grid: DateFilter ${s} is not a number`);
        else
          return t[s] == null ? o : Number(t[s]);
      return o;
    };
    this.minValidYear = i("minValidYear", Pd), this.maxValidYear = i("maxValidYear", Fd), this.minValidYear > this.maxValidYear && console.warn("AG Grid: DateFilter minValidYear should be <= maxValidYear"), t.minValidDate ? this.minValidDate = t.minValidDate instanceof Date ? t.minValidDate : mt(t.minValidDate) : this.minValidDate = null, t.maxValidDate ? this.maxValidDate = t.maxValidDate instanceof Date ? t.maxValidDate : mt(t.maxValidDate) : this.maxValidDate = null, this.minValidDate && this.maxValidDate && this.minValidDate > this.maxValidDate && console.warn("AG Grid: DateFilter minValidDate should be <= maxValidDate"), this.filterModelFormatter = new _c(this.dateFilterParams, this.localeService, this.optionsFactory);
  }
  createDateCompWrapper(t) {
    const i = new Pc(
      this.getContext(),
      this.userComponentFactory,
      {
        onDateChanged: () => this.onUiChanged(),
        filterParams: this.dateFilterParams
      },
      t
    );
    return this.addDestroyFunc(() => i.destroy()), i;
  }
  setElementValue(t, i) {
    t.setDate(i);
  }
  setElementDisplayed(t, i) {
    t.setDisplayed(i);
  }
  setElementDisabled(t, i) {
    t.setDisabled(i);
  }
  getDefaultFilterOptions() {
    return Vc.DEFAULT_FILTER_OPTIONS;
  }
  createValueElement() {
    const i = this.gos.getDocument().createElement("div");
    return i.classList.add("ag-filter-body"), this.createFromToElement(i, this.eConditionPanelsFrom, this.dateConditionFromComps, "from"), this.createFromToElement(i, this.eConditionPanelsTo, this.dateConditionToComps, "to"), i;
  }
  createFromToElement(t, i, s, o) {
    const n = this.gos.getDocument().createElement("div");
    n.classList.add(`ag-filter-${o}`), n.classList.add(`ag-filter-date-${o}`), i.push(n), t.appendChild(n), s.push(this.createDateCompWrapper(n));
  }
  removeValueElements(t, i) {
    this.removeDateComps(this.dateConditionFromComps, t, i), this.removeDateComps(this.dateConditionToComps, t, i), this.removeItems(this.eConditionPanelsFrom, t, i), this.removeItems(this.eConditionPanelsTo, t, i);
  }
  removeDateComps(t, i, s) {
    this.removeItems(t, i, s).forEach((r) => r.destroy());
  }
  isValidDateValue(t) {
    if (t === null)
      return !1;
    if (this.minValidDate) {
      if (t < this.minValidDate)
        return !1;
    } else if (t.getUTCFullYear() < this.minValidYear)
      return !1;
    if (this.maxValidDate) {
      if (t > this.maxValidDate)
        return !1;
    } else if (t.getUTCFullYear() > this.maxValidYear)
      return !1;
    return !0;
  }
  isConditionUiComplete(t) {
    if (!super.isConditionUiComplete(t))
      return !1;
    let i = !0;
    return this.forEachInput((s, o, r, n) => {
      r !== t || !i || o >= n || (i = i && this.isValidDateValue(s.getDate()));
    }), i;
  }
  areSimpleModelsEqual(t, i) {
    return t.dateFrom === i.dateFrom && t.dateTo === i.dateTo && t.type === i.type;
  }
  getFilterType() {
    return "date";
  }
  createCondition(t) {
    const i = this.getConditionType(t), s = {}, o = this.getValues(t);
    return o.length > 0 && (s.dateFrom = Nt(o[0])), o.length > 1 && (s.dateTo = Nt(o[1])), _({
      dateFrom: null,
      dateTo: null,
      filterType: this.getFilterType(),
      type: i
    }, s);
  }
  resetPlaceholder() {
    const t = this.localeService.getLocaleTextFunc(), i = this.translate("dateFormatOoo"), s = t("ariaFilterValue", "Filter Value");
    this.forEachInput((o) => {
      o.setInputPlaceholder(i), o.setInputAriaLabel(s);
    });
  }
  getInputs(t) {
    return t >= this.dateConditionFromComps.length ? [null, null] : [this.dateConditionFromComps[t], this.dateConditionToComps[t]];
  }
  getValues(t) {
    const i = [];
    return this.forEachPositionInput(t, (s, o, r, n) => {
      o < n && i.push(s.getDate());
    }), i;
  }
  translate(t) {
    return t === He.LESS_THAN ? super.translate("before") : t === He.GREATER_THAN ? super.translate("after") : super.translate(t);
  }
  getModelAsString(t) {
    var i;
    return (i = this.filterModelFormatter.getModelAsString(t)) != null ? i : "";
  }
};
xa.DEFAULT_FILTER_OPTIONS = [
  He.EQUALS,
  He.NOT_EQUAL,
  He.LESS_THAN,
  He.GREATER_THAN,
  He.IN_RANGE,
  He.BLANK,
  He.NOT_BLANK
];
u([
  f("userComponentFactory")
], xa.prototype, "userComponentFactory", 2);
var Hc = xa, Na = class extends K {
  getDefaultDebounceMs() {
    return 0;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  destroy() {
    super.destroy();
  }
  isEventFromFloatingFilter(e) {
    return e && e.afterFloatingFilter;
  }
  isEventFromDataChange(e) {
    return e == null ? void 0 : e.afterDataChange;
  }
  getLastType() {
    return this.lastType;
  }
  isReadOnly() {
    return this.readOnly;
  }
  setLastTypeFromModel(e) {
    if (!e) {
      this.lastType = this.optionsFactory.getDefaultOption();
      return;
    }
    const t = e.operator;
    let i;
    t ? i = e.conditions[0] : i = e, this.lastType = i.type;
  }
  canWeEditAfterModelFromParentFilter(e) {
    if (!e)
      return this.isTypeEditable(this.lastType);
    if (e.operator)
      return !1;
    const i = e;
    return this.isTypeEditable(i.type);
  }
  init(e) {
    this.setSimpleParams(e, !1);
  }
  setSimpleParams(e, t = !0) {
    this.optionsFactory = new Fc(), this.optionsFactory.init(e.filterParams, this.getDefaultFilterOptions()), t || (this.lastType = this.optionsFactory.getDefaultOption()), this.readOnly = !!e.filterParams.readOnly;
    const i = this.isTypeEditable(this.optionsFactory.getDefaultOption());
    this.setEditable(i);
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    this.setSimpleParams(e);
  }
  doesFilterHaveSingleInput(e) {
    const t = this.optionsFactory.getCustomOption(e), { numberOfInputs: i } = t || {};
    return i == null || i == 1;
  }
  isTypeEditable(e) {
    const t = [
      Pe.IN_RANGE,
      Pe.EMPTY,
      Pe.BLANK,
      Pe.NOT_BLANK
    ];
    return !!e && !this.isReadOnly() && this.doesFilterHaveSingleInput(e) && t.indexOf(e) < 0;
  }
  getAriaLabel(e) {
    const t = this.columnModel.getDisplayNameForColumn(e.column, "header", !0), i = this.localeService.getLocaleTextFunc();
    return `${t} ${i("ariaFilterInput", "Filter Input")}`;
  }
};
u([
  f("columnModel")
], Na.prototype, "columnModel", 2);
var Gn = class extends Na {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field ref="eReadOnlyText"></ag-input-text-field>
                <div ref="eDateWrapper" style="display: flex;"></div>
            </div>`
    );
  }
  getDefaultFilterOptions() {
    return Hc.DEFAULT_FILTER_OPTIONS;
  }
  init(e) {
    super.init(e), this.params = e, this.filterParams = e.filterParams, this.createDateComponent(), this.filterModelFormatter = new _c(this.filterParams, this.localeService, this.optionsFactory);
    const t = this.localeService.getLocaleTextFunc();
    this.eReadOnlyText.setDisabled(!0).setInputAriaLabel(t("ariaDateFilterInput", "Date Filter Input"));
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    super.refresh(e), this.params = e, this.filterParams = e.filterParams, this.updateDateComponent(), this.filterModelFormatter.updateParams({ optionsFactory: this.optionsFactory, dateFilterParams: this.filterParams }), this.updateCompOnModelChange(e.currentParentModel());
  }
  updateCompOnModelChange(e) {
    const t = !this.isReadOnly() && this.canWeEditAfterModelFromParentFilter(e);
    if (this.setEditable(t), t) {
      if (e) {
        const i = e;
        this.dateComp.setDate(mt(i.dateFrom));
      } else
        this.dateComp.setDate(null);
      this.eReadOnlyText.setValue("");
    } else
      this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(e)), this.dateComp.setDate(null);
  }
  setEditable(e) {
    te(this.eDateWrapper, e), te(this.eReadOnlyText.getGui(), !e);
  }
  onParentModelChanged(e, t) {
    this.isEventFromFloatingFilter(t) || this.isEventFromDataChange(t) || (super.setLastTypeFromModel(e), this.updateCompOnModelChange(e));
  }
  onDateChanged() {
    const e = this.dateComp.getDate(), t = Nt(e);
    this.params.parentFilterInstance((i) => {
      if (i) {
        const s = mt(t);
        i.onFloatingFilterChanged(this.getLastType() || null, s);
      }
    });
  }
  getDateComponentParams() {
    const e = tn.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
    return {
      onDateChanged: rt(this.onDateChanged.bind(this), e),
      filterParams: this.params.column.getColDef().filterParams
    };
  }
  createDateComponent() {
    this.dateComp = new Pc(this.getContext(), this.userComponentFactory, this.getDateComponentParams(), this.eDateWrapper, (e) => {
      e.setInputAriaLabel(this.getAriaLabel(this.params));
    }), this.addDestroyFunc(() => this.dateComp.destroy());
  }
  updateDateComponent() {
    const e = this.gos.addGridCommonParams(this.getDateComponentParams());
    this.dateComp.updateParams(e);
  }
  getFilterModelFormatter() {
    return this.filterModelFormatter;
  }
};
u([
  f("userComponentFactory")
], Gn.prototype, "userComponentFactory", 2);
u([
  M("eReadOnlyText")
], Gn.prototype, "eReadOnlyText", 2);
u([
  M("eDateWrapper")
], Gn.prototype, "eDateWrapper", 2);
var kc = class extends K {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-filter-filter">
                <ag-input-text-field class="ag-date-filter" ref="eDateInput"></ag-input-text-field>
            </div>`
    );
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  destroy() {
    super.destroy();
  }
  init(e) {
    this.params = e, this.setParams(e);
    const t = this.eDateInput.getInputElement();
    this.addManagedListener(t, "mousedown", () => {
      this.eDateInput.isDisabled() || this.usingSafariDatePicker || t.focus();
    }), this.addManagedListener(t, "input", (i) => {
      i.target === this.gos.getActiveDomElement() && (this.eDateInput.isDisabled() || this.params.onDateChanged());
    });
  }
  setParams(e) {
    const t = this.eDateInput.getInputElement(), i = this.shouldUseBrowserDatePicker(e);
    this.usingSafariDatePicker = i && ri(), t.type = i ? "date" : "text";
    const {
      minValidYear: s,
      maxValidYear: o,
      minValidDate: r,
      maxValidDate: n
    } = e.filterParams || {};
    if (r && s && H("DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored."), n && o && H("DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored."), r && n) {
      const [l, a] = [r, n].map((d) => d instanceof Date ? d : mt(d));
      l && a && l.getTime() > a.getTime() && H("DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.");
    }
    r ? r instanceof Date ? t.min = Ks(r) : t.min = r : s && (t.min = `${s}-01-01`), n ? n instanceof Date ? t.max = Ks(n) : t.max = n : o && (t.max = `${o}-12-31`);
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    this.params = e, this.setParams(e);
  }
  getDate() {
    return mt(this.eDateInput.getValue());
  }
  setDate(e) {
    this.eDateInput.setValue(Nt(e, !1));
  }
  setInputPlaceholder(e) {
    this.eDateInput.setInputPlaceholder(e);
  }
  setInputAriaLabel(e) {
    this.eDateInput.setAriaLabel(e);
  }
  setDisabled(e) {
    this.eDateInput.setDisabled(e);
  }
  afterGuiAttached(e) {
    (!e || !e.suppressFocus) && this.eDateInput.getInputElement().focus();
  }
  shouldUseBrowserDatePicker(e) {
    return e.filterParams && e.filterParams.browserDatePicker != null ? e.filterParams.browserDatePicker : An() || pa() || ri() && ha() >= 14.1;
  }
};
u([
  M("eDateInput")
], kc.prototype, "eDateInput", 2);
var Ts = class extends jt {
  constructor(e, t = "ag-text-field", i = "text") {
    super(e, t, i);
  }
  postConstruct() {
    super.postConstruct(), this.config.allowedCharPattern && this.preventDisallowedCharacters();
  }
  setValue(e, t) {
    return this.eInput.value !== e && (this.eInput.value = b(e) ? e : ""), super.setValue(e, t);
  }
  /** Used to set an initial value into the input without necessarily setting `this.value` or triggering events (e.g. to set an invalid value) */
  setStartValue(e) {
    this.setValue(e, !0);
  }
  preventDisallowedCharacters() {
    const e = new RegExp(`[${this.config.allowedCharPattern}]`), t = (i) => {
      Fn(i) && i.key && !e.test(i.key) && i.preventDefault();
    };
    this.addManagedListener(this.eInput, "keydown", t), this.addManagedListener(this.eInput, "paste", (i) => {
      var s;
      const o = (s = i.clipboardData) == null ? void 0 : s.getData("text");
      o && o.split("").some((r) => !e.test(r)) && i.preventDefault();
    });
  }
}, Ga = class extends Ts {
  constructor(e) {
    super(e, "ag-number-field", "number");
  }
  postConstruct() {
    super.postConstruct(), this.addManagedListener(this.eInput, "blur", () => {
      const o = parseFloat(this.eInput.value), r = isNaN(o) ? "" : this.normalizeValue(o.toString());
      this.value !== r && this.setValue(r);
    }), this.addManagedListener(this.eInput, "wheel", this.onWheel.bind(this)), this.eInput.step = "any";
    const { precision: e, min: t, max: i, step: s } = this.config;
    typeof e == "number" && this.setPrecision(e), typeof t == "number" && this.setMin(t), typeof i == "number" && this.setMax(i), typeof s == "number" && this.setStep(s);
  }
  onWheel(e) {
    this.gos.getActiveDomElement() === this.eInput && e.preventDefault();
  }
  normalizeValue(e) {
    if (e === "")
      return "";
    this.precision != null && (e = this.adjustPrecision(e));
    const t = parseFloat(e);
    return this.min != null && t < this.min ? e = this.min.toString() : this.max != null && t > this.max && (e = this.max.toString()), e;
  }
  adjustPrecision(e, t) {
    if (this.precision == null)
      return e;
    if (t) {
      const s = parseFloat(e).toFixed(this.precision);
      return parseFloat(s).toString();
    }
    const i = String(e).split(".");
    if (i.length > 1) {
      if (i[1].length <= this.precision)
        return e;
      if (this.precision > 0)
        return `${i[0]}.${i[1].slice(0, this.precision)}`;
    }
    return i[0];
  }
  setMin(e) {
    return this.min === e ? this : (this.min = e, oi(this.eInput, "min", e), this);
  }
  setMax(e) {
    return this.max === e ? this : (this.max = e, oi(this.eInput, "max", e), this);
  }
  setPrecision(e) {
    return this.precision = e, this;
  }
  setStep(e) {
    return this.step === e ? this : (this.step = e, oi(this.eInput, "step", e), this);
  }
  setValue(e, t) {
    return this.setValueOrInputValue((i) => super.setValue(i, t), () => this, e);
  }
  setStartValue(e) {
    return this.setValueOrInputValue(
      (t) => super.setValue(t, !0),
      (t) => {
        this.eInput.value = t;
      },
      e
    );
  }
  setValueOrInputValue(e, t, i) {
    if (b(i)) {
      let s = this.isScientificNotation(i);
      if (s && this.eInput.validity.valid)
        return e(i);
      if (!s) {
        i = this.adjustPrecision(i);
        const o = this.normalizeValue(i);
        s = i != o;
      }
      if (s)
        return t(i);
    }
    return e(i);
  }
  getValue() {
    if (!this.eInput.validity.valid)
      return;
    const e = this.eInput.value;
    return this.isScientificNotation(e) ? this.adjustPrecision(e, !0) : super.getValue();
  }
  isScientificNotation(e) {
    return typeof e == "string" && e.includes("e");
  }
}, Bc = class extends Ma {
  conditionToString(e, t) {
    const { numberOfInputs: i } = t || {};
    return e.type == Pe.IN_RANGE || i === 2 ? `${this.formatValue(e.filter)}-${this.formatValue(e.filterTo)}` : e.filter != null ? this.formatValue(e.filter) : `${e.type}`;
  }
};
function _l(e) {
  const { allowedCharPattern: t } = e ?? {};
  return t ?? null;
}
var Wc = class Uc extends He {
  constructor() {
    super("numberFilter"), this.eValuesFrom = [], this.eValuesTo = [];
  }
  refresh(t) {
    return this.numberFilterParams.allowedCharPattern !== t.allowedCharPattern ? !1 : super.refresh(t);
  }
  mapValuesFromModel(t) {
    const { filter: i, filterTo: s, type: o } = t || {};
    return [
      this.processValue(i),
      this.processValue(s)
    ].slice(0, this.getNumberOfInputs(o));
  }
  getDefaultDebounceMs() {
    return 500;
  }
  comparator() {
    return (t, i) => t === i ? 0 : t < i ? 1 : -1;
  }
  setParams(t) {
    this.numberFilterParams = t, super.setParams(t), this.filterModelFormatter = new Bc(this.localeService, this.optionsFactory, this.numberFilterParams.numberFormatter);
  }
  getDefaultFilterOptions() {
    return Uc.DEFAULT_FILTER_OPTIONS;
  }
  setElementValue(t, i, s) {
    const o = !s && this.numberFilterParams.numberFormatter ? this.numberFilterParams.numberFormatter(i ?? null) : i;
    super.setElementValue(t, o);
  }
  createValueElement() {
    const t = _l(this.numberFilterParams), i = document.createElement("div");
    return i.classList.add("ag-filter-body"), Fe(i, "presentation"), this.createFromToElement(i, this.eValuesFrom, "from", t), this.createFromToElement(i, this.eValuesTo, "to", t), i;
  }
  createFromToElement(t, i, s, o) {
    const r = this.createManagedBean(o ? new Ts({ allowedCharPattern: o }) : new Ga());
    r.addCssClass(`ag-filter-${s}`), r.addCssClass("ag-filter-filter"), i.push(r), t.appendChild(r.getGui());
  }
  removeValueElements(t, i) {
    this.removeComponents(this.eValuesFrom, t, i), this.removeComponents(this.eValuesTo, t, i);
  }
  getValues(t) {
    const i = [];
    return this.forEachPositionInput(t, (s, o, r, n) => {
      o < n && i.push(this.processValue(this.stringToFloat(s.getValue())));
    }), i;
  }
  areSimpleModelsEqual(t, i) {
    return t.filter === i.filter && t.filterTo === i.filterTo && t.type === i.type;
  }
  getFilterType() {
    return "number";
  }
  processValue(t) {
    return t == null || isNaN(t) ? null : t;
  }
  stringToFloat(t) {
    if (typeof t == "number")
      return t;
    let i = si(t);
    return i != null && i.trim() === "" && (i = null), this.numberFilterParams.numberParser ? this.numberFilterParams.numberParser(i) : i == null || i.trim() === "-" ? null : parseFloat(i);
  }
  createCondition(t) {
    const i = this.getConditionType(t), s = {
      filterType: this.getFilterType(),
      type: i
    }, o = this.getValues(t);
    return o.length > 0 && (s.filter = o[0]), o.length > 1 && (s.filterTo = o[1]), s;
  }
  getInputs(t) {
    return t >= this.eValuesFrom.length ? [null, null] : [this.eValuesFrom[t], this.eValuesTo[t]];
  }
  getModelAsString(t) {
    var i;
    return (i = this.filterModelFormatter.getModelAsString(t)) != null ? i : "";
  }
  hasInvalidInputs() {
    let t = !1;
    return this.forEachInput((i) => {
      if (!i.getInputElement().validity.valid) {
        t = !0;
        return;
      }
    }), t;
  }
};
Wc.DEFAULT_FILTER_OPTIONS = [
  He.EQUALS,
  He.NOT_EQUAL,
  He.GREATER_THAN,
  He.GREATER_THAN_OR_EQUAL,
  He.LESS_THAN,
  He.LESS_THAN_OR_EQUAL,
  He.IN_RANGE,
  He.BLANK,
  He.NOT_BLANK
];
var zc = Wc, Kc = class extends Ma {
  conditionToString(e, t) {
    const { numberOfInputs: i } = t || {};
    return e.type == Pe.IN_RANGE || i === 2 ? `${e.filter}-${e.filterTo}` : e.filter != null ? `${e.filter}` : `${e.type}`;
  }
}, Wt = class Vs extends Pe {
  constructor() {
    super("textFilter"), this.eValuesFrom = [], this.eValuesTo = [];
  }
  static trimInput(t) {
    const i = t && t.trim();
    return i === "" ? t : i;
  }
  getDefaultDebounceMs() {
    return 500;
  }
  setParams(t) {
    this.textFilterParams = t, super.setParams(t), this.matcher = this.getTextMatcher(), this.formatter = this.textFilterParams.textFormatter || (this.textFilterParams.caseSensitive ? Vs.DEFAULT_FORMATTER : Vs.DEFAULT_LOWERCASE_FORMATTER), this.filterModelFormatter = new Kc(this.localeService, this.optionsFactory);
  }
  getTextMatcher() {
    const t = this.textFilterParams.textCustomComparator;
    return t ? (W.warnOnce("textCustomComparator is deprecated, use textMatcher instead."), ({ filterOption: i, value: s, filterText: o }) => t(i, s, o)) : this.textFilterParams.textMatcher || Vs.DEFAULT_MATCHER;
  }
  createCondition(t) {
    const i = this.getConditionType(t), s = {
      filterType: this.getFilterType(),
      type: i
    }, o = this.getValuesWithSideEffects(t, !0);
    return o.length > 0 && (s.filter = o[0]), o.length > 1 && (s.filterTo = o[1]), s;
  }
  getFilterType() {
    return "text";
  }
  areSimpleModelsEqual(t, i) {
    return t.filter === i.filter && t.filterTo === i.filterTo && t.type === i.type;
  }
  getInputs(t) {
    return t >= this.eValuesFrom.length ? [null, null] : [this.eValuesFrom[t], this.eValuesTo[t]];
  }
  getValues(t) {
    return this.getValuesWithSideEffects(t, !1);
  }
  getValuesWithSideEffects(t, i) {
    const s = [];
    return this.forEachPositionInput(t, (o, r, n, l) => {
      var a;
      if (r < l) {
        let d = si(o.getValue());
        i && this.textFilterParams.trimInput && (d = (a = Vs.trimInput(d)) != null ? a : null, o.setValue(d, !0)), s.push(d);
      }
    }), s;
  }
  getDefaultFilterOptions() {
    return Vs.DEFAULT_FILTER_OPTIONS;
  }
  createValueElement() {
    const t = document.createElement("div");
    return t.classList.add("ag-filter-body"), Fe(t, "presentation"), this.createFromToElement(t, this.eValuesFrom, "from"), this.createFromToElement(t, this.eValuesTo, "to"), t;
  }
  createFromToElement(t, i, s) {
    const o = this.createManagedBean(new Ts());
    o.addCssClass(`ag-filter-${s}`), o.addCssClass("ag-filter-filter"), i.push(o), t.appendChild(o.getGui());
  }
  removeValueElements(t, i) {
    this.removeComponents(this.eValuesFrom, t, i), this.removeComponents(this.eValuesTo, t, i);
  }
  mapValuesFromModel(t) {
    const { filter: i, filterTo: s, type: o } = t || {};
    return [
      i || null,
      s || null
    ].slice(0, this.getNumberOfInputs(o));
  }
  evaluateNullValue(t) {
    const i = [
      Pe.NOT_EQUAL,
      Pe.NOT_CONTAINS,
      Pe.BLANK
    ];
    return t ? i.indexOf(t) >= 0 : !1;
  }
  evaluateNonNullValue(t, i, s, o) {
    const r = t.map((C) => this.formatter(C)) || [], n = this.formatter(i), { api: l, colDef: a, column: d, columnApi: c, context: h, textFormatter: g } = this.textFilterParams;
    if (s.type === Pe.BLANK)
      return this.isBlank(i);
    if (s.type === Pe.NOT_BLANK)
      return !this.isBlank(i);
    const m = {
      api: l,
      colDef: a,
      column: d,
      columnApi: c,
      context: h,
      node: o.node,
      data: o.data,
      filterOption: s.type,
      value: n,
      textFormatter: g
    };
    return r.some((C) => this.matcher(Re(_({}, m), { filterText: C })));
  }
  getModelAsString(t) {
    var i;
    return (i = this.filterModelFormatter.getModelAsString(t)) != null ? i : "";
  }
};
Wt.DEFAULT_FILTER_OPTIONS = [
  Pe.CONTAINS,
  Pe.NOT_CONTAINS,
  Pe.EQUALS,
  Pe.NOT_EQUAL,
  Pe.STARTS_WITH,
  Pe.ENDS_WITH,
  Pe.BLANK,
  Pe.NOT_BLANK
];
Wt.DEFAULT_FORMATTER = (e) => e;
Wt.DEFAULT_LOWERCASE_FORMATTER = (e) => e == null ? null : e.toString().toLowerCase();
Wt.DEFAULT_MATCHER = ({ filterOption: e, value: t, filterText: i }) => {
  if (i == null)
    return !1;
  switch (e) {
    case Wt.CONTAINS:
      return t.indexOf(i) >= 0;
    case Wt.NOT_CONTAINS:
      return t.indexOf(i) < 0;
    case Wt.EQUALS:
      return t === i;
    case Wt.NOT_EQUAL:
      return t != i;
    case Wt.STARTS_WITH:
      return t.indexOf(i) === 0;
    case Wt.ENDS_WITH:
      const s = t.lastIndexOf(i);
      return s >= 0 && s === t.length - i.length;
    default:
      return !1;
  }
};
var Oa = Wt, $c = class extends F {
  constructor(e) {
    super(), this.params = e, this.valueChangedListener = () => {
    };
  }
  setupGui(e) {
    var t;
    this.eFloatingFilterTextInput = this.createManagedBean(new Ts((t = this.params) == null ? void 0 : t.config));
    const i = this.eFloatingFilterTextInput.getGui();
    e.appendChild(i), this.addManagedListener(i, "input", (s) => this.valueChangedListener(s)), this.addManagedListener(i, "keydown", (s) => this.valueChangedListener(s));
  }
  setEditable(e) {
    this.eFloatingFilterTextInput.setDisabled(!e);
  }
  setAutoComplete(e) {
    this.eFloatingFilterTextInput.setAutoComplete(e);
  }
  getValue() {
    return this.eFloatingFilterTextInput.getValue();
  }
  setValue(e, t) {
    this.eFloatingFilterTextInput.setValue(e, t);
  }
  setValueChangedListener(e) {
    this.valueChangedListener = e;
  }
  setParams(e) {
    this.setAriaLabel(e.ariaLabel), e.autoComplete !== void 0 && this.setAutoComplete(e.autoComplete);
  }
  setAriaLabel(e) {
    this.eFloatingFilterTextInput.setInputAriaLabel(e);
  }
}, On = class extends Na {
  postConstruct() {
    this.setTemplate(
      /* html */
      `
            <div class="ag-floating-filter-input" role="presentation" ref="eFloatingFilterInputContainer"></div>
        `
    );
  }
  getDefaultDebounceMs() {
    return 500;
  }
  onParentModelChanged(e, t) {
    this.isEventFromFloatingFilter(t) || this.isEventFromDataChange(t) || (this.setLastTypeFromModel(e), this.setEditable(this.canWeEditAfterModelFromParentFilter(e)), this.floatingFilterInputService.setValue(this.getFilterModelFormatter().getModelAsString(e)));
  }
  init(e) {
    this.setupFloatingFilterInputService(e), super.init(e), this.setTextInputParams(e);
  }
  setupFloatingFilterInputService(e) {
    this.floatingFilterInputService = this.createFloatingFilterInputService(e), this.floatingFilterInputService.setupGui(this.eFloatingFilterInputContainer);
  }
  setTextInputParams(e) {
    var t;
    this.params = e;
    const i = (t = e.browserAutoComplete) != null ? t : !1;
    if (this.floatingFilterInputService.setParams({
      ariaLabel: this.getAriaLabel(e),
      autoComplete: i
    }), this.applyActive = tn.isUseApplyButton(this.params.filterParams), !this.isReadOnly()) {
      const s = tn.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs()), o = rt(this.syncUpWithParentFilter.bind(this), s);
      this.floatingFilterInputService.setValueChangedListener(o);
    }
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    super.refresh(e), this.setTextInputParams(e);
  }
  recreateFloatingFilterInputService(e) {
    const t = this.floatingFilterInputService.getValue();
    xe(this.eFloatingFilterInputContainer), this.destroyBean(this.floatingFilterInputService), this.setupFloatingFilterInputService(e), this.floatingFilterInputService.setValue(t, !0);
  }
  syncUpWithParentFilter(e) {
    const t = e.key === S.ENTER;
    if (this.applyActive && !t)
      return;
    let i = this.floatingFilterInputService.getValue();
    this.params.filterParams.trimInput && (i = Oa.trimInput(i), this.floatingFilterInputService.setValue(i, !0)), this.params.parentFilterInstance((s) => {
      s && s.onFloatingFilterChanged(this.getLastType() || null, i || null);
    });
  }
  setEditable(e) {
    this.floatingFilterInputService.setEditable(e);
  }
};
u([
  M("eFloatingFilterInputContainer")
], On.prototype, "eFloatingFilterInputContainer", 2);
u([
  L
], On.prototype, "postConstruct", 1);
var Dg = class extends F {
  constructor() {
    super(...arguments), this.valueChangedListener = () => {
    }, this.numberInputActive = !0;
  }
  setupGui(e) {
    this.eFloatingFilterNumberInput = this.createManagedBean(new Ga()), this.eFloatingFilterTextInput = this.createManagedBean(new Ts()), this.eFloatingFilterTextInput.setDisabled(!0);
    const t = this.eFloatingFilterNumberInput.getGui(), i = this.eFloatingFilterTextInput.getGui();
    e.appendChild(t), e.appendChild(i), this.setupListeners(t, (s) => this.valueChangedListener(s)), this.setupListeners(i, (s) => this.valueChangedListener(s));
  }
  setEditable(e) {
    this.numberInputActive = e, this.eFloatingFilterNumberInput.setDisplayed(this.numberInputActive), this.eFloatingFilterTextInput.setDisplayed(!this.numberInputActive);
  }
  setAutoComplete(e) {
    this.eFloatingFilterNumberInput.setAutoComplete(e), this.eFloatingFilterTextInput.setAutoComplete(e);
  }
  getValue() {
    return this.getActiveInputElement().getValue();
  }
  setValue(e, t) {
    this.getActiveInputElement().setValue(e, t);
  }
  getActiveInputElement() {
    return this.numberInputActive ? this.eFloatingFilterNumberInput : this.eFloatingFilterTextInput;
  }
  setValueChangedListener(e) {
    this.valueChangedListener = e;
  }
  setupListeners(e, t) {
    this.addManagedListener(e, "input", t), this.addManagedListener(e, "keydown", t);
  }
  setParams(e) {
    this.setAriaLabel(e.ariaLabel), e.autoComplete !== void 0 && this.setAutoComplete(e.autoComplete);
  }
  setAriaLabel(e) {
    this.eFloatingFilterNumberInput.setInputAriaLabel(e), this.eFloatingFilterTextInput.setInputAriaLabel(e);
  }
}, Tg = class extends On {
  init(e) {
    var t;
    super.init(e), this.filterModelFormatter = new Bc(
      this.localeService,
      this.optionsFactory,
      (t = e.filterParams) == null ? void 0 : t.numberFormatter
    );
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    _l(e.filterParams) !== this.allowedCharPattern && this.recreateFloatingFilterInputService(e), super.refresh(e), this.filterModelFormatter.updateParams({ optionsFactory: this.optionsFactory });
  }
  getDefaultFilterOptions() {
    return zc.DEFAULT_FILTER_OPTIONS;
  }
  getFilterModelFormatter() {
    return this.filterModelFormatter;
  }
  createFloatingFilterInputService(e) {
    return this.allowedCharPattern = _l(e.filterParams), this.allowedCharPattern ? this.createManagedBean(new $c({
      config: { allowedCharPattern: this.allowedCharPattern }
    })) : this.createManagedBean(new Dg());
  }
}, bg = class extends On {
  init(e) {
    super.init(e), this.filterModelFormatter = new Kc(this.localeService, this.optionsFactory);
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    super.refresh(e), this.filterModelFormatter.updateParams({ optionsFactory: this.optionsFactory });
  }
  getDefaultFilterOptions() {
    return Oa.DEFAULT_FILTER_OPTIONS;
  }
  getFilterModelFormatter() {
    return this.filterModelFormatter;
  }
  createFloatingFilterInputService() {
    return this.createManagedBean(new $c());
  }
}, vr = class Lo {
  constructor(t, i = !1) {
    this.destroyFuncs = [], this.touching = !1, this.eventService = new qt(), this.eElement = t, this.preventMouseClick = i;
    const s = this.onTouchStart.bind(this), o = this.onTouchMove.bind(this), r = this.onTouchEnd.bind(this);
    this.eElement.addEventListener("touchstart", s, { passive: !0 }), this.eElement.addEventListener("touchmove", o, { passive: !0 }), this.eElement.addEventListener("touchend", r, { passive: !1 }), this.destroyFuncs.push(() => {
      this.eElement.removeEventListener("touchstart", s, { passive: !0 }), this.eElement.removeEventListener("touchmove", o, { passive: !0 }), this.eElement.removeEventListener("touchend", r, { passive: !1 });
    });
  }
  getActiveTouch(t) {
    for (let i = 0; i < t.length; i++)
      if (t[i].identifier === this.touchStart.identifier)
        return t[i];
    return null;
  }
  addEventListener(t, i) {
    this.eventService.addEventListener(t, i);
  }
  removeEventListener(t, i) {
    this.eventService.removeEventListener(t, i);
  }
  onTouchStart(t) {
    if (this.touching)
      return;
    this.touchStart = t.touches[0], this.touching = !0, this.moved = !1;
    const i = this.touchStart;
    window.setTimeout(() => {
      const s = this.touchStart === i;
      if (this.touching && s && !this.moved) {
        this.moved = !0;
        const o = {
          type: Lo.EVENT_LONG_TAP,
          touchStart: this.touchStart,
          touchEvent: t
        };
        this.eventService.dispatchEvent(o);
      }
    }, 500);
  }
  onTouchMove(t) {
    if (!this.touching)
      return;
    const i = this.getActiveTouch(t.touches);
    if (!i)
      return;
    !Pa(i, this.touchStart, 4) && (this.moved = !0);
  }
  onTouchEnd(t) {
    if (this.touching) {
      if (!this.moved) {
        const i = {
          type: Lo.EVENT_TAP,
          touchStart: this.touchStart
        };
        this.eventService.dispatchEvent(i), this.checkForDoubleTap();
      }
      this.preventMouseClick && t.cancelable && t.preventDefault(), this.touching = !1;
    }
  }
  checkForDoubleTap() {
    const t = (/* @__PURE__ */ new Date()).getTime();
    if (this.lastTapTime && this.lastTapTime > 0)
      if (t - this.lastTapTime > Lo.DOUBLE_TAP_MILLIS) {
        const s = {
          type: Lo.EVENT_DOUBLE_TAP,
          touchStart: this.touchStart
        };
        this.eventService.dispatchEvent(s), this.lastTapTime = null;
      } else
        this.lastTapTime = t;
    else
      this.lastTapTime = t;
  }
  destroy() {
    this.destroyFuncs.forEach((t) => t());
  }
};
vr.EVENT_TAP = "tap";
vr.EVENT_DOUBLE_TAP = "doubleTap";
vr.EVENT_LONG_TAP = "longTap";
vr.DOUBLE_TAP_MILLIS = 500;
var je = vr, Si = class jc extends K {
  constructor(t) {
    super(), t || this.setTemplate(jc.TEMPLATE);
  }
  attachCustomElements(t, i, s, o, r) {
    this.eSortOrder = t, this.eSortAsc = i, this.eSortDesc = s, this.eSortMixed = o, this.eSortNone = r;
  }
  setupSort(t, i = !1) {
    this.column = t, this.suppressOrder = i, this.setupMultiSortIndicator(), !(!this.column.isSortable() && !this.column.getColDef().showRowGroup) && (this.addInIcon("sortAscending", this.eSortAsc, t), this.addInIcon("sortDescending", this.eSortDesc, t), this.addInIcon("sortUnSort", this.eSortNone, t), this.addManagedPropertyListener("unSortIcon", () => this.updateIcons()), this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, () => this.updateIcons()), this.addManagedListener(this.eventService, p.EVENT_SORT_CHANGED, () => this.onSortChanged()), this.addManagedListener(this.eventService, p.EVENT_COLUMN_ROW_GROUP_CHANGED, () => this.onSortChanged()), this.onSortChanged());
  }
  addInIcon(t, i, s) {
    if (i == null)
      return;
    const o = Te(t, this.gos, s);
    o && i.appendChild(o);
  }
  onSortChanged() {
    this.updateIcons(), this.suppressOrder || this.updateSortOrder();
  }
  updateIcons() {
    const t = this.sortController.getDisplaySortForColumn(this.column);
    if (this.eSortAsc) {
      const i = t === "asc";
      te(this.eSortAsc, i, { skipAriaHidden: !0 });
    }
    if (this.eSortDesc) {
      const i = t === "desc";
      te(this.eSortDesc, i, { skipAriaHidden: !0 });
    }
    if (this.eSortNone) {
      const i = !this.column.getColDef().unSortIcon && !this.gos.get("unSortIcon"), s = t == null;
      te(this.eSortNone, !i && s, { skipAriaHidden: !0 });
    }
  }
  setupMultiSortIndicator() {
    this.addInIcon("sortUnSort", this.eSortMixed, this.column);
    const t = this.column.getColDef().showRowGroup;
    this.gos.isColumnsSortingCoupledToGroup() && t && (this.addManagedListener(this.eventService, p.EVENT_SORT_CHANGED, () => this.updateMultiSortIndicator()), this.addManagedListener(this.eventService, p.EVENT_COLUMN_ROW_GROUP_CHANGED, () => this.updateMultiSortIndicator()), this.updateMultiSortIndicator());
  }
  updateMultiSortIndicator() {
    if (this.eSortMixed) {
      const t = this.sortController.getDisplaySortForColumn(this.column) === "mixed";
      te(this.eSortMixed, t, { skipAriaHidden: !0 });
    }
  }
  // we listen here for global sort events, NOT column sort events, as we want to do this
  // when sorting has been set on all column (if we listened just for our col (where we
  // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
  updateSortOrder() {
    var t;
    if (!this.eSortOrder)
      return;
    const i = this.sortController.getColumnsWithSortingOrdered(), s = (t = this.sortController.getDisplaySortIndexForColumn(this.column)) != null ? t : -1, o = i.some((n) => {
      var l;
      return (l = this.sortController.getDisplaySortIndexForColumn(n)) != null ? l : !1;
    }), r = s >= 0 && o;
    te(this.eSortOrder, r, { skipAriaHidden: !0 }), s >= 0 ? this.eSortOrder.textContent = (s + 1).toString() : xe(this.eSortOrder);
  }
};
Si.TEMPLATE = /* html */
`<span class="ag-sort-indicator-container">
            <span ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
            <span ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
        </span>`;
u([
  M("eSortOrder")
], Si.prototype, "eSortOrder", 2);
u([
  M("eSortAsc")
], Si.prototype, "eSortAsc", 2);
u([
  M("eSortDesc")
], Si.prototype, "eSortDesc", 2);
u([
  M("eSortMixed")
], Si.prototype, "eSortMixed", 2);
u([
  M("eSortNone")
], Si.prototype, "eSortNone", 2);
u([
  f("columnModel")
], Si.prototype, "columnModel", 2);
u([
  f("sortController")
], Si.prototype, "sortController", 2);
var _a = Si, st = class Yc extends K {
  constructor() {
    super(...arguments), this.lastMovingChanged = 0;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  destroy() {
    super.destroy();
  }
  refresh(t) {
    const i = this.params;
    return this.params = t, this.workOutTemplate() != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || this.workOutSort() != this.currentSort || this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || i.enableFilterButton != t.enableFilterButton || i.enableFilterIcon != t.enableFilterIcon ? !1 : (this.setDisplayName(t), !0);
  }
  workOutTemplate() {
    var t;
    let i = (t = this.params.template) != null ? t : Yc.TEMPLATE;
    return i = i && i.trim ? i.trim() : i, i;
  }
  init(t) {
    this.params = t, this.currentTemplate = this.workOutTemplate(), this.setTemplate(this.currentTemplate), this.setupTap(), this.setMenu(), this.setupSort(), this.setupFilterIcon(), this.setupFilterButton(), this.setDisplayName(t);
  }
  setDisplayName(t) {
    if (this.currentDisplayName != t.displayName) {
      this.currentDisplayName = t.displayName;
      const i = Oe(this.currentDisplayName, !0);
      this.eText && (this.eText.textContent = i);
    }
  }
  addInIcon(t, i, s) {
    if (i == null)
      return;
    const o = Te(t, this.gos, s);
    o && i.appendChild(o);
  }
  setupTap() {
    const { gos: t } = this;
    if (t.get("suppressTouch"))
      return;
    const i = new je(this.getGui(), !0), s = this.shouldSuppressMenuHide(), o = s && b(this.eMenu), r = o ? new je(this.eMenu, !0) : i;
    if (this.params.enableMenu) {
      const n = o ? "EVENT_TAP" : "EVENT_LONG_TAP", l = (a) => this.params.showColumnMenuAfterMouseClick(a.touchStart);
      this.addManagedListener(r, je[n], l);
    }
    if (this.params.enableSorting) {
      const n = (l) => {
        var a, d;
        const c = l.touchStart.target;
        s && ((a = this.eMenu) != null && a.contains(c) || (d = this.eFilterButton) != null && d.contains(c)) || this.sortController.progressSort(this.params.column, !1, "uiColumnSorted");
      };
      this.addManagedListener(i, je.EVENT_TAP, n);
    }
    if (this.params.enableFilterButton) {
      const n = new je(this.eFilterButton, !0);
      this.addManagedListener(n, "tap", () => this.params.showFilter(this.eFilterButton)), this.addDestroyFunc(() => n.destroy());
    }
    this.addDestroyFunc(() => i.destroy()), o && this.addDestroyFunc(() => r.destroy());
  }
  workOutShowMenu() {
    return this.params.enableMenu && this.menuService.isHeaderMenuButtonEnabled();
  }
  shouldSuppressMenuHide() {
    return this.menuService.isHeaderMenuButtonAlwaysShowEnabled();
  }
  setMenu() {
    if (!this.eMenu)
      return;
    if (this.currentShowMenu = this.workOutShowMenu(), !this.currentShowMenu) {
      $t(this.eMenu), this.eMenu = void 0;
      return;
    }
    const t = this.menuService.isLegacyMenuEnabled();
    this.addInIcon(t ? "menu" : "menuAlt", this.eMenu, this.params.column), this.eMenu.classList.toggle("ag-header-menu-icon", !t), this.currentSuppressMenuHide = this.shouldSuppressMenuHide(), this.addManagedListener(this.eMenu, "click", () => this.params.showColumnMenu(this.eMenu)), this.eMenu.classList.toggle("ag-header-menu-always-show", this.currentSuppressMenuHide);
  }
  onMenuKeyboardShortcut(t) {
    var i, s, o, r;
    const { column: n } = this.params, l = this.menuService.isLegacyMenuEnabled();
    if (t && !l) {
      if (this.menuService.isFilterMenuInHeaderEnabled(n))
        return this.params.showFilter((s = (i = this.eFilterButton) != null ? i : this.eMenu) != null ? s : this.getGui()), !0;
    } else if (this.params.enableMenu)
      return this.params.showColumnMenu((r = (o = this.eMenu) != null ? o : this.eFilterButton) != null ? r : this.getGui()), !0;
    return !1;
  }
  workOutSort() {
    return this.params.enableSorting;
  }
  setupSort() {
    if (this.currentSort = this.params.enableSorting, this.eSortIndicator || (this.eSortIndicator = this.context.createBean(new _a(!0)), this.eSortIndicator.attachCustomElements(
      this.eSortOrder,
      this.eSortAsc,
      this.eSortDesc,
      this.eSortMixed,
      this.eSortNone
    )), this.eSortIndicator.setupSort(this.params.column), !this.currentSort)
      return;
    this.addManagedListener(this.params.column, pe.EVENT_MOVING_CHANGED, () => {
      this.lastMovingChanged = (/* @__PURE__ */ new Date()).getTime();
    }), this.eLabel && this.addManagedListener(this.eLabel, "click", (i) => {
      const s = this.params.column.isMoving(), r = (/* @__PURE__ */ new Date()).getTime() - this.lastMovingChanged < 50;
      if (!(s || r)) {
        const a = this.gos.get("multiSortKey") === "ctrl" ? i.ctrlKey || i.metaKey : i.shiftKey;
        this.params.progressSort(a);
      }
    });
    const t = () => {
      if (this.addOrRemoveCssClass("ag-header-cell-sorted-asc", this.params.column.isSortAscending()), this.addOrRemoveCssClass("ag-header-cell-sorted-desc", this.params.column.isSortDescending()), this.addOrRemoveCssClass("ag-header-cell-sorted-none", this.params.column.isSortNone()), this.params.column.getColDef().showRowGroup) {
        const i = this.columnModel.getSourceColumnsForGroupColumn(this.params.column), o = !(i == null ? void 0 : i.every((r) => this.params.column.getSort() == r.getSort()));
        this.addOrRemoveCssClass("ag-header-cell-sorted-mixed", o);
      }
    };
    this.addManagedListener(this.eventService, p.EVENT_SORT_CHANGED, t), this.addManagedListener(this.eventService, p.EVENT_COLUMN_ROW_GROUP_CHANGED, t);
  }
  setupFilterIcon() {
    this.eFilter && this.configureFilter(this.params.enableFilterIcon, this.eFilter, this.onFilterChangedIcon.bind(this));
  }
  setupFilterButton() {
    if (!this.eFilterButton)
      return;
    this.configureFilter(
      this.params.enableFilterButton,
      this.eFilterButton,
      this.onFilterChangedButton.bind(this)
    ) ? this.addManagedListener(this.eFilterButton, "click", () => this.params.showFilter(this.eFilterButton)) : this.eFilterButton = void 0;
  }
  configureFilter(t, i, s) {
    if (!t)
      return $t(i), !1;
    const { column: o } = this.params;
    return this.addInIcon("filter", i, o), this.addManagedListener(o, pe.EVENT_FILTER_CHANGED, s), s(), !0;
  }
  onFilterChangedIcon() {
    const t = this.params.column.isFilterActive();
    te(this.eFilter, t, { skipAriaHidden: !0 });
  }
  onFilterChangedButton() {
    const t = this.params.column.isFilterActive();
    this.eFilterButton.classList.toggle("ag-filter-active", t);
  }
  getAnchorElementForMenu(t) {
    var i, s, o, r;
    return t ? (s = (i = this.eFilterButton) != null ? i : this.eMenu) != null ? s : this.getGui() : (r = (o = this.eMenu) != null ? o : this.eFilterButton) != null ? r : this.getGui();
  }
};
st.TEMPLATE = /* html */
`<div class="ag-cell-label-container" role="presentation">
            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
            <span ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>
            <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                <span ref="eText" class="ag-header-cell-text"></span>
                <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
                <ag-sort-indicator ref="eSortIndicator"></ag-sort-indicator>
            </div>
        </div>`;
u([
  f("sortController")
], st.prototype, "sortController", 2);
u([
  f("menuService")
], st.prototype, "menuService", 2);
u([
  f("columnModel")
], st.prototype, "columnModel", 2);
u([
  M("eFilter")
], st.prototype, "eFilter", 2);
u([
  M("eFilterButton")
], st.prototype, "eFilterButton", 2);
u([
  M("eSortIndicator")
], st.prototype, "eSortIndicator", 2);
u([
  M("eMenu")
], st.prototype, "eMenu", 2);
u([
  M("eLabel")
], st.prototype, "eLabel", 2);
u([
  M("eText")
], st.prototype, "eText", 2);
u([
  M("eSortOrder")
], st.prototype, "eSortOrder", 2);
u([
  M("eSortAsc")
], st.prototype, "eSortAsc", 2);
u([
  M("eSortDesc")
], st.prototype, "eSortDesc", 2);
u([
  M("eSortMixed")
], st.prototype, "eSortMixed", 2);
u([
  M("eSortNone")
], st.prototype, "eSortNone", 2);
var Vl = st, wr = class qc extends K {
  constructor() {
    super(qc.TEMPLATE);
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  destroy() {
    super.destroy();
  }
  init(t) {
    this.params = t, this.checkWarnings(), this.setupLabel(), this.addGroupExpandIcon(), this.setupExpandIcons();
  }
  checkWarnings() {
    this.params.template && H("A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)");
  }
  setupExpandIcons() {
    this.addInIcon("columnGroupOpened", "agOpened"), this.addInIcon("columnGroupClosed", "agClosed");
    const t = (o) => {
      if (Yt(o))
        return;
      const r = !this.params.columnGroup.isExpanded();
      this.columnModel.setColumnGroupOpened(this.params.columnGroup.getProvidedColumnGroup(), r, "uiColumnExpanded");
    };
    this.addTouchAndClickListeners(this.eCloseIcon, t), this.addTouchAndClickListeners(this.eOpenIcon, t);
    const i = (o) => {
      Qt(o);
    };
    this.addManagedListener(this.eCloseIcon, "dblclick", i), this.addManagedListener(this.eOpenIcon, "dblclick", i), this.addManagedListener(this.getGui(), "dblclick", t), this.updateIconVisibility();
    const s = this.params.columnGroup.getProvidedColumnGroup();
    this.addManagedListener(s, Ge.EVENT_EXPANDED_CHANGED, this.updateIconVisibility.bind(this)), this.addManagedListener(s, Ge.EVENT_EXPANDABLE_CHANGED, this.updateIconVisibility.bind(this));
  }
  addTouchAndClickListeners(t, i) {
    const s = new je(t, !0);
    this.addManagedListener(s, je.EVENT_TAP, i), this.addDestroyFunc(() => s.destroy()), this.addManagedListener(t, "click", i);
  }
  updateIconVisibility() {
    if (this.params.columnGroup.isExpandable()) {
      const i = this.params.columnGroup.isExpanded();
      te(this.eOpenIcon, i), te(this.eCloseIcon, !i);
    } else
      te(this.eOpenIcon, !1), te(this.eCloseIcon, !1);
  }
  addInIcon(t, i) {
    const s = Te(t, this.gos, null);
    s && this.getRefElement(i).appendChild(s);
  }
  addGroupExpandIcon() {
    if (!this.params.columnGroup.isExpandable()) {
      te(this.eOpenIcon, !1), te(this.eCloseIcon, !1);
      return;
    }
  }
  setupLabel() {
    var t;
    const { displayName: i, columnGroup: s } = this.params;
    if (b(i)) {
      const o = Oe(i, !0);
      this.getRefElement("agLabel").textContent = o;
    }
    this.addOrRemoveCssClass("ag-sticky-label", !((t = s.getColGroupDef()) != null && t.suppressStickyLabel));
  }
};
wr.TEMPLATE = /* html */
`<div class="ag-header-group-cell-label" ref="agContainer" role="presentation">
            <span ref="agLabel" class="ag-header-group-text" role="presentation"></span>
            <span ref="agOpened" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded"></span>
            <span ref="agClosed" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed"></span>
        </div>`;
u([
  f("columnModel")
], wr.prototype, "columnModel", 2);
u([
  M("agOpened")
], wr.prototype, "eOpenIcon", 2);
u([
  M("agClosed")
], wr.prototype, "eCloseIcon", 2);
var Ag = wr, bs = class extends K {
  isPopup() {
    return !0;
  }
  setParentComponent(e) {
    e.addCssClass("ag-has-popup"), super.setParentComponent(e);
  }
  destroy() {
    const e = this.parentComponent;
    e && e.isAlive() && e.getGui().classList.remove("ag-has-popup"), super.destroy();
  }
}, Va = class Qc extends bs {
  constructor() {
    super(Qc.TEMPLATE);
  }
  init(t) {
    this.params = t, this.focusAfterAttached = t.cellStartedEdit, this.eTextArea.setMaxLength(t.maxLength || 200).setCols(t.cols || 60).setRows(t.rows || 10), b(t.value, !0) && this.eTextArea.setValue(t.value.toString(), !0), this.addGuiEventListener("keydown", this.onKeyDown.bind(this)), this.activateTabIndex();
  }
  onKeyDown(t) {
    const i = t.key;
    (i === S.LEFT || i === S.UP || i === S.RIGHT || i === S.DOWN || t.shiftKey && i === S.ENTER) && t.stopPropagation();
  }
  afterGuiAttached() {
    const t = this.localeService.getLocaleTextFunc();
    this.eTextArea.setInputAriaLabel(t("ariaInputEditor", "Input Editor")), this.focusAfterAttached && this.eTextArea.getFocusableElement().focus();
  }
  getValue() {
    const t = this.eTextArea.getValue();
    return !b(t) && !b(this.params.value) ? this.params.value : this.params.parseValue(t);
  }
};
Va.TEMPLATE = /* html */
`<div class="ag-large-text">
            <ag-input-text-area ref="eTextArea" class="ag-large-text-input"></ag-input-text-area>
        </div>`;
u([
  M("eTextArea")
], Va.prototype, "eTextArea", 2);
var Pg = Va, Ha = class extends bs {
  constructor() {
    super(
      /* html */
      `<div class="ag-cell-edit-wrapper">
                <ag-select class="ag-cell-editor" ref="eSelect"></ag-select>
            </div>`
    ), this.startedByEnter = !1;
  }
  init(e) {
    this.focusAfterAttached = e.cellStartedEdit;
    const { eSelect: t, valueService: i, gos: s } = this, { values: o, value: r, eventKey: n } = e;
    if (z(o)) {
      console.warn("AG Grid: no values found for select cellEditor");
      return;
    }
    this.startedByEnter = n != null ? n === S.ENTER : !1;
    let l = !1;
    o.forEach((h) => {
      const g = { value: h }, m = i.formatValue(e.column, null, h), C = m != null;
      g.text = C ? m : h, t.addOption(g), l = l || r === h;
    }), l ? t.setValue(e.value, !0) : e.values.length && t.setValue(e.values[0], !0);
    const { valueListGap: a, valueListMaxWidth: d, valueListMaxHeight: c } = e;
    a != null && t.setPickerGap(a), c != null && t.setPickerMaxHeight(c), d != null && t.setPickerMaxWidth(d), s.get("editType") !== "fullRow" && this.addManagedListener(this.eSelect, xn.EVENT_ITEM_SELECTED, () => e.stopEditing());
  }
  afterGuiAttached() {
    this.focusAfterAttached && this.eSelect.getFocusableElement().focus(), this.startedByEnter && setTimeout(() => {
      this.isAlive() && this.eSelect.showPicker();
    });
  }
  focusIn() {
    this.eSelect.getFocusableElement().focus();
  }
  getValue() {
    return this.eSelect.getValue();
  }
  isPopup() {
    return !1;
  }
};
u([
  f("valueService")
], Ha.prototype, "valueService", 2);
u([
  M("eSelect")
], Ha.prototype, "eSelect", 2);
var Sr = class extends bs {
  constructor(e) {
    super(
      /* html */
      `
            <div class="ag-cell-edit-wrapper">
                ${e.getTemplate()}
            </div>`
    ), this.cellEditorInput = e;
  }
  init(e) {
    this.params = e;
    const t = this.eInput;
    this.cellEditorInput.init(t, e);
    let i;
    if (e.cellStartedEdit) {
      this.focusAfterAttached = !0;
      const s = e.eventKey;
      s === S.BACKSPACE || e.eventKey === S.DELETE ? i = "" : s && s.length === 1 ? i = s : (i = this.cellEditorInput.getStartValue(), s !== S.F2 && (this.highlightAllOnFocus = !0));
    } else
      this.focusAfterAttached = !1, i = this.cellEditorInput.getStartValue();
    i != null && t.setStartValue(i), this.addManagedListener(t.getGui(), "keydown", (s) => {
      const { key: o } = s;
      (o === S.PAGE_UP || o === S.PAGE_DOWN) && s.preventDefault();
    });
  }
  afterGuiAttached() {
    var e, t;
    const i = this.localeService.getLocaleTextFunc(), s = this.eInput;
    if (s.setInputAriaLabel(i("ariaInputEditor", "Input Editor")), !this.focusAfterAttached)
      return;
    ri() || s.getFocusableElement().focus();
    const o = s.getInputElement();
    this.highlightAllOnFocus ? o.select() : (t = (e = this.cellEditorInput).setCaret) == null || t.call(e);
  }
  // gets called when tabbing through cells and in full row edit mode
  focusIn() {
    const e = this.eInput, t = e.getFocusableElement(), i = e.getInputElement();
    t.focus(), i.select();
  }
  getValue() {
    return this.cellEditorInput.getValue();
  }
  isPopup() {
    return !1;
  }
};
u([
  M("eInput")
], Sr.prototype, "eInput", 2);
var Fg = class {
  getTemplate() {
    return (
      /* html */
      '<ag-input-text-field class="ag-cell-editor" ref="eInput"></ag-input-text-field>'
    );
  }
  init(e, t) {
    this.eInput = e, this.params = t, t.maxLength != null && e.setMaxLength(t.maxLength);
  }
  getValue() {
    const e = this.eInput.getValue();
    return !b(e) && !b(this.params.value) ? this.params.value : this.params.parseValue(e);
  }
  getStartValue() {
    return this.params.useFormatter || this.params.column.getColDef().refData ? this.params.formatValue(this.params.value) : this.params.value;
  }
  setCaret() {
    const e = this.eInput.getValue(), t = b(e) && e.length || 0;
    t && this.eInput.getInputElement().setSelectionRange(t, t);
  }
}, Ld = class extends Sr {
  constructor() {
    super(new Fg());
  }
}, Lg = "↑", Ig = "↓", Xc = class extends K {
  constructor() {
    super(), this.refreshCount = 0;
    const e = document.createElement("span"), t = document.createElement("span");
    t.setAttribute("class", "ag-value-change-delta");
    const i = document.createElement("span");
    i.setAttribute("class", "ag-value-change-value"), e.appendChild(t), e.appendChild(i), this.setTemplateFromElement(e);
  }
  init(e) {
    this.eValue = this.queryForHtmlElement(".ag-value-change-value"), this.eDelta = this.queryForHtmlElement(".ag-value-change-delta"), this.refresh(e, !0);
  }
  showDelta(e, t) {
    const i = Math.abs(t), s = e.formatValue(i), o = b(s) ? s : i, r = t >= 0;
    r ? this.eDelta.textContent = Lg + o : this.eDelta.textContent = Ig + o, this.eDelta.classList.toggle("ag-value-change-delta-up", r), this.eDelta.classList.toggle("ag-value-change-delta-down", !r);
  }
  setTimerToRemoveDelta() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.getFrameworkOverrides().wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.hideDeltaValue();
      }, 2e3);
    });
  }
  hideDeltaValue() {
    this.eValue.classList.remove("ag-value-change-value-highlight"), xe(this.eDelta);
  }
  refresh(e, t = !1) {
    const i = e.value;
    if (i === this.lastValue || (b(e.valueFormatted) ? this.eValue.textContent = e.valueFormatted : b(e.value) ? this.eValue.textContent = i : xe(this.eValue), this.filterManager.isSuppressFlashingCellsBecauseFiltering()))
      return !1;
    if (typeof i == "number" && typeof this.lastValue == "number") {
      const s = i - this.lastValue;
      this.showDelta(e, s);
    }
    return this.lastValue && this.eValue.classList.add("ag-value-change-value-highlight"), t || this.setTimerToRemoveDelta(), this.lastValue = i, !0;
  }
};
u([
  f("filterManager")
], Xc.prototype, "filterManager", 2);
var Zc = class extends K {
  constructor() {
    super(), this.refreshCount = 0;
    const e = document.createElement("span"), t = document.createElement("span");
    t.setAttribute("class", "ag-value-slide-current"), e.appendChild(t), this.setTemplateFromElement(e), this.eCurrent = this.queryForHtmlElement(".ag-value-slide-current");
  }
  init(e) {
    this.refresh(e, !0);
  }
  addSlideAnimation() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.ePrevious && this.getGui().removeChild(this.ePrevious);
    const t = document.createElement("span");
    t.setAttribute("class", "ag-value-slide-previous ag-value-slide-out"), this.ePrevious = t, this.ePrevious.textContent = this.eCurrent.textContent, this.getGui().insertBefore(this.ePrevious, this.eCurrent), this.getFrameworkOverrides().wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.ePrevious.classList.add("ag-value-slide-out-end");
      }, 50), window.setTimeout(() => {
        e === this.refreshCount && (this.getGui().removeChild(this.ePrevious), this.ePrevious = null);
      }, 3e3);
    });
  }
  refresh(e, t = !1) {
    let i = e.value;
    return z(i) && (i = ""), i === this.lastValue || this.filterManager.isSuppressFlashingCellsBecauseFiltering() ? !1 : (t || this.addSlideAnimation(), this.lastValue = i, b(e.valueFormatted) ? this.eCurrent.textContent = e.valueFormatted : b(e.value) ? this.eCurrent.textContent = i : xe(this.eCurrent), !0);
  }
};
u([
  f("filterManager")
], Zc.prototype, "filterManager", 2);
var De = class fe {
  constructor(t) {
    this.rowIndex = null, this.key = null, this.childrenMapped = {}, this.displayed = !1, this.rowTop = null, this.oldRowTop = null, this.selectable = !0, this.__objectId = fe.OBJECT_ID_SEQUENCE++, this.__autoHeights = {}, this.alreadyRendered = !1, this.highlighted = null, this.hovered = !1, this.selected = !1, this.beans = t;
  }
  /**
   * Replaces the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
   */
  setData(t) {
    this.setDataCommon(t, !1);
  }
  // similar to setRowData, however it is expected that the data is the same data item. this
  // is intended to be used with Redux type stores, where the whole data can be changed. we are
  // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
  // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
  // dataChanged event, will refresh the cells rather than rip them all out (so user can show transitions).
  /**
   * Updates the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
   */
  updateData(t) {
    this.setDataCommon(t, !0);
  }
  setDataCommon(t, i) {
    const s = this.data;
    this.data = t, this.beans.valueCache.onDataChanged(), this.updateDataOnDetailNode(), this.checkRowSelectable(), this.resetQuickFilterAggregateText();
    const o = this.createDataChangedEvent(t, s, i);
    this.dispatchLocalEvent(o);
  }
  // when we are doing master / detail, the detail node is lazy created, but then kept around.
  // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
  // in sync, otherwise expand/collapse of the detail would still show the old values.
  updateDataOnDetailNode() {
    this.detailNode && (this.detailNode.data = this.data);
  }
  createDataChangedEvent(t, i, s) {
    return {
      type: fe.EVENT_DATA_CHANGED,
      node: this,
      oldData: i,
      newData: t,
      update: s
    };
  }
  createLocalRowEvent(t) {
    return {
      type: t,
      node: this
    };
  }
  getRowIndexString() {
    return this.rowPinned === "top" ? "t-" + this.rowIndex : this.rowPinned === "bottom" ? "b-" + this.rowIndex : this.rowIndex.toString();
  }
  createDaemonNode() {
    const t = new fe(this.beans);
    return t.id = this.id, t.data = this.data, t.__daemon = !0, t.selected = this.selected, t.level = this.level, t;
  }
  setDataAndId(t, i) {
    const s = b(this.id) ? this.createDaemonNode() : null, o = this.data;
    this.data = t, this.updateDataOnDetailNode(), this.setId(i), this.checkRowSelectable(), this.beans.selectionService.syncInRowNode(this, s);
    const r = this.createDataChangedEvent(t, o, !1);
    this.dispatchLocalEvent(r);
  }
  checkRowSelectable() {
    const t = this.beans.gos.get("isRowSelectable");
    this.setRowSelectable(t ? t(this) : !0);
  }
  setRowSelectable(t, i) {
    if (this.selectable !== t) {
      if (this.selectable = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_SELECTABLE_CHANGED)), i)
        return;
      if (this.beans.gos.get("groupSelectsChildren")) {
        const o = this.calculateSelectedFromChildren();
        this.setSelectedParams({
          newValue: o ?? !1,
          source: "selectableChanged"
        });
        return;
      }
      this.isSelected() && !this.selectable && this.setSelectedParams({
        newValue: !1,
        source: "selectableChanged"
      });
    }
  }
  setId(t) {
    const i = this.beans.gos.getCallback("getRowId");
    if (i)
      if (this.data) {
        const s = this.getGroupKeys(!0);
        this.id = i({
          data: this.data,
          parentKeys: s.length > 0 ? s : void 0,
          level: this.level
        }), this.id !== null && typeof this.id == "string" && this.id.startsWith(fe.ID_PREFIX_ROW_GROUP) && console.error(`AG Grid: Row IDs cannot start with ${fe.ID_PREFIX_ROW_GROUP}, this is a reserved prefix for AG Grid's row grouping feature.`), this.id !== null && typeof this.id != "string" && (this.id = "" + this.id);
      } else
        this.id = void 0;
    else
      this.id = t;
  }
  getGroupKeys(t = !1) {
    const i = [];
    let s = this;
    for (t && (s = s.parent); s && s.level >= 0; )
      i.push(s.key), s = s.parent;
    return i.reverse(), i;
  }
  isPixelInRange(t) {
    return !b(this.rowTop) || !b(this.rowHeight) ? !1 : t >= this.rowTop && t < this.rowTop + this.rowHeight;
  }
  setFirstChild(t) {
    this.firstChild !== t && (this.firstChild = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_FIRST_CHILD_CHANGED)));
  }
  setLastChild(t) {
    this.lastChild !== t && (this.lastChild = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_LAST_CHILD_CHANGED)));
  }
  setChildIndex(t) {
    this.childIndex !== t && (this.childIndex = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_CHILD_INDEX_CHANGED)));
  }
  setRowTop(t) {
    this.oldRowTop = this.rowTop, this.rowTop !== t && (this.rowTop = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_TOP_CHANGED)), this.setDisplayed(t !== null));
  }
  clearRowTopAndRowIndex() {
    this.oldRowTop = null, this.setRowTop(null), this.setRowIndex(null);
  }
  setDisplayed(t) {
    this.displayed !== t && (this.displayed = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_DISPLAYED_CHANGED)));
  }
  setDragging(t) {
    this.dragging !== t && (this.dragging = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_DRAGGING_CHANGED)));
  }
  setHighlighted(t) {
    t !== this.highlighted && (this.highlighted = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_HIGHLIGHT_CHANGED)));
  }
  setHovered(t) {
    this.hovered !== t && (this.hovered = t);
  }
  isHovered() {
    return this.hovered;
  }
  setAllChildrenCount(t) {
    this.allChildrenCount !== t && (this.allChildrenCount = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_ALL_CHILDREN_COUNT_CHANGED)));
  }
  setMaster(t) {
    this.master !== t && (this.master && !t && (this.expanded = !1), this.master = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_MASTER_CHANGED)));
  }
  setGroup(t) {
    this.group !== t && (this.group && !t && (this.expanded = !1), this.group = t, this.updateHasChildren(), this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_GROUP_CHANGED)));
  }
  /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */
  setRowHeight(t, i = !1) {
    this.rowHeight = t, this.rowHeightEstimated = i, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_HEIGHT_CHANGED));
  }
  setRowAutoHeight(t, i) {
    this.__autoHeights || (this.__autoHeights = {}), this.__autoHeights[i.getId()] = t, t != null && (this.checkAutoHeightsDebounced == null && (this.checkAutoHeightsDebounced = rt(this.checkAutoHeights.bind(this), 1)), this.checkAutoHeightsDebounced());
  }
  checkAutoHeights() {
    let t = !1, i = !0, s = 0;
    const o = this.__autoHeights;
    if (o == null || (this.beans.columnModel.getAllDisplayedAutoHeightCols().forEach((l) => {
      let a = o[l.getId()];
      if (a == null)
        if (this.beans.columnModel.isColSpanActive()) {
          let d = [];
          switch (l.getPinned()) {
            case "left":
              d = this.beans.columnModel.getDisplayedLeftColumnsForRow(this);
              break;
            case "right":
              d = this.beans.columnModel.getDisplayedRightColumnsForRow(this);
              break;
            case null:
              d = this.beans.columnModel.getViewportCenterColumnsForRow(this);
              break;
          }
          if (d.includes(l)) {
            t = !0;
            return;
          }
          a = -1;
        } else {
          t = !0;
          return;
        }
      else
        i = !1;
      a > s && (s = a);
    }), t) || ((i || s < 10) && (s = this.beans.gos.getRowHeightForNode(this).height), s == this.rowHeight))
      return;
    this.setRowHeight(s);
    const n = this.beans.rowModel;
    n.onRowHeightChangedDebounced && n.onRowHeightChangedDebounced();
  }
  setRowIndex(t) {
    this.rowIndex !== t && (this.rowIndex = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_ROW_INDEX_CHANGED)));
  }
  setUiLevel(t) {
    this.uiLevel !== t && (this.uiLevel = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_UI_LEVEL_CHANGED)));
  }
  /**
   * Set the expanded state of this rowNode. Pass `true` to expand and `false` to collapse.
   */
  setExpanded(t, i, s) {
    if (this.expanded === t)
      return;
    this.expanded = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_EXPANDED_CHANGED));
    const o = Object.assign({}, this.createGlobalRowEvent(p.EVENT_ROW_GROUP_OPENED), {
      expanded: t,
      event: i || null
    });
    this.beans.rowNodeEventThrottle.dispatchExpanded(o, s), this.beans.rowRenderer.refreshCells({ rowNodes: [this] });
  }
  createGlobalRowEvent(t) {
    return this.beans.gos.addGridCommonParams({
      type: t,
      node: this,
      data: this.data,
      rowIndex: this.rowIndex,
      rowPinned: this.rowPinned
    });
  }
  dispatchLocalEvent(t) {
    this.eventService && this.eventService.dispatchEvent(t);
  }
  /**
   * Replaces the value on the `rowNode` for the specified column. When complete,
   * the grid will refresh the rendered cell on the required row only.
   * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
   *
   * @param colKey The column where the value should be updated
   * @param newValue The new value
   * @param eventSource The source of the event
   * @returns `true` if the value was changed, otherwise `false`.
   */
  setDataValue(t, i, s) {
    const r = (() => {
      var a;
      return typeof t != "string" ? t : (a = this.beans.columnModel.getGridColumn(t)) != null ? a : this.beans.columnModel.getPrimaryColumn(t);
    })(), n = this.getValueFromValueService(r);
    if (this.beans.gos.get("readOnlyEdit"))
      return this.dispatchEventForSaveValueReadOnly(r, n, i, s), !1;
    const l = this.beans.valueService.setValue(this, r, i, s);
    return this.dispatchCellChangedEvent(r, i, n), this.checkRowSelectable(), l;
  }
  getValueFromValueService(t) {
    var i, s;
    const o = this.leafGroup && this.beans.columnModel.isPivotMode(), r = this.group && this.expanded && !this.footer && !o;
    let n = !1;
    const l = (i = this.beans.gos.get("groupTotalRow")) != null ? i : this.beans.gos.get("groupIncludeFooter");
    typeof l != "function" ? n = !!l : n = !!((s = this.beans.gos.getCallback("groupTotalRow")) != null ? s : this.beans.gos.getCallback("groupIncludeFooter"))({ node: this });
    const a = this.beans.gos.get("groupSuppressBlankHeader"), d = r && n && !a;
    return this.beans.valueService.getValue(t, this, !1, d);
  }
  dispatchEventForSaveValueReadOnly(t, i, s, o) {
    const r = this.beans.gos.addGridCommonParams({
      type: p.EVENT_CELL_EDIT_REQUEST,
      event: null,
      rowIndex: this.rowIndex,
      rowPinned: this.rowPinned,
      column: t,
      colDef: t.getColDef(),
      data: this.data,
      node: this,
      oldValue: i,
      newValue: s,
      value: s,
      source: o
    });
    this.beans.eventService.dispatchEvent(r);
  }
  setGroupValue(t, i) {
    const s = this.beans.columnModel.getGridColumn(t);
    z(this.groupData) && (this.groupData = {});
    const o = s.getColId(), r = this.groupData[o];
    r !== i && (this.groupData[o] = i, this.dispatchCellChangedEvent(s, i, r));
  }
  // sets the data for an aggregation
  setAggData(t) {
    const i = this.aggData;
    if (this.aggData = t, this.eventService) {
      const s = (o) => {
        const r = this.aggData ? this.aggData[o] : void 0, n = i ? i[o] : void 0;
        if (r === n)
          return;
        const l = this.beans.columnModel.lookupGridColumn(o);
        l && this.dispatchCellChangedEvent(l, r, n);
      };
      for (const o in this.aggData)
        s(o);
      for (const o in t)
        o in this.aggData || s(o);
    }
  }
  updateHasChildren() {
    let t = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0;
    if (this.beans.gos.isRowModelType("serverSide")) {
      const s = this.beans.gos.get("treeData"), o = this.beans.gos.get("isServerSideGroup");
      t = !this.stub && !this.footer && (s ? !!o && o(this.data) : !!this.group);
    }
    t !== this.__hasChildren && (this.__hasChildren = !!t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(fe.EVENT_HAS_CHILDREN_CHANGED)));
  }
  hasChildren() {
    return this.__hasChildren == null && this.updateHasChildren(), this.__hasChildren;
  }
  isEmptyRowGroupNode() {
    return this.group && It(this.childrenAfterGroup);
  }
  dispatchCellChangedEvent(t, i, s) {
    const o = {
      type: fe.EVENT_CELL_CHANGED,
      node: this,
      column: t,
      newValue: i,
      oldValue: s
    };
    this.dispatchLocalEvent(o);
  }
  /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However if you edit without using grid editing, you will need to clear this string down for the row to be updated with the new values.
   * Otherwise new values will not work with the `quickFilter`. */
  resetQuickFilterAggregateText() {
    this.quickFilterAggregateText = null;
  }
  /** Returns:
  * - `true` if the node can be expanded, i.e it is a group or master row.
  * - `false` if the node cannot be expanded
  */
  isExpandable() {
    return this.footer ? !1 : this.beans.columnModel.isPivotMode() ? this.hasChildren() && !this.leafGroup : this.hasChildren() || !!this.master;
  }
  /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */
  isSelected() {
    return this.footer ? this.sibling.isSelected() : this.selected;
  }
  /** Perform a depth-first search of this node and its children. */
  depthFirstSearch(t) {
    this.childrenAfterGroup && this.childrenAfterGroup.forEach((i) => i.depthFirstSearch(t)), t(this);
  }
  // + selectionController.calculatedSelectedForAllGroupNodes()
  calculateSelectedFromChildren() {
    var t;
    let i = !1, s = !1, o = !1;
    if (!((t = this.childrenAfterGroup) != null && t.length))
      return this.selectable ? this.selected : null;
    for (let r = 0; r < this.childrenAfterGroup.length; r++) {
      const n = this.childrenAfterGroup[r];
      let l = n.isSelected();
      if (!n.selectable) {
        const a = n.calculateSelectedFromChildren();
        if (a === null)
          continue;
        l = a;
      }
      switch (l) {
        case !0:
          i = !0;
          break;
        case !1:
          s = !0;
          break;
        default:
          o = !0;
          break;
      }
    }
    if (!(o || i && s))
      return i ? !0 : s ? !1 : this.selectable ? this.selected : null;
  }
  setSelectedInitialValue(t) {
    this.selected = t;
  }
  selectThisNode(t, i, s = "api") {
    const o = !this.selectable && t, r = this.selected === t;
    if (o || r)
      return !1;
    this.selected = t, this.eventService && this.dispatchLocalEvent(this.createLocalRowEvent(fe.EVENT_ROW_SELECTED));
    const n = this.sibling;
    n && n.footer && n.eventService && n.dispatchLocalEvent(n.createLocalRowEvent(fe.EVENT_ROW_SELECTED));
    const l = Re(_({}, this.createGlobalRowEvent(p.EVENT_ROW_SELECTED)), {
      event: i || null,
      source: s
    });
    return this.beans.eventService.dispatchEvent(l), !0;
  }
  /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` will select the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param source - Source property that will appear in the `selectionChanged` event.
   */
  setSelected(t, i = !1, s = "api") {
    if (typeof s == "boolean") {
      console.warn("AG Grid: since version v30, rowNode.setSelected() property `suppressFinishActions` has been removed, please use `gridApi.setNodesSelected()` for bulk actions, and the event `source` property for ignoring events instead.");
      return;
    }
    this.setSelectedParams({
      newValue: t,
      clearSelection: i,
      rangeSelect: !1,
      source: s
    });
  }
  // this is for internal use only. To make calling code more readable, this is the same method as setSelected except it takes names parameters
  setSelectedParams(t) {
    return this.rowPinned ? (console.warn("AG Grid: cannot select pinned rows"), 0) : this.id === void 0 ? (console.warn("AG Grid: cannot select node until id for node is known"), 0) : this.beans.selectionService.setNodesSelected(Re(_({}, t), { nodes: [this.footer ? this.sibling : this] }));
  }
  /**
   * Returns:
   * - `true` if node is either pinned to the `top` or `bottom`
   * - `false` if the node isn't pinned
   */
  isRowPinned() {
    return this.rowPinned === "top" || this.rowPinned === "bottom";
  }
  isParentOfNode(t) {
    let i = this.parent;
    for (; i; ) {
      if (i === t)
        return !0;
      i = i.parent;
    }
    return !1;
  }
  /** Add an event listener. */
  addEventListener(t, i) {
    var s, o;
    this.eventService || (this.eventService = new qt()), this.beans.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService && (this.eventService.setFrameworkOverrides(this.beans.frameworkOverrides), this.frameworkEventListenerService = new ia(this.beans.frameworkOverrides));
    const r = (o = (s = this.frameworkEventListenerService) == null ? void 0 : s.wrap(i)) != null ? o : i;
    this.eventService.addEventListener(t, r);
  }
  /** Remove event listener. */
  removeEventListener(t, i) {
    var s, o;
    if (!this.eventService)
      return;
    const r = (o = (s = this.frameworkEventListenerService) == null ? void 0 : s.unwrap(i)) != null ? o : i;
    this.eventService.removeEventListener(t, r), this.eventService.noRegisteredListenersExist() && (this.eventService = null);
  }
  onMouseEnter() {
    this.dispatchLocalEvent(this.createLocalRowEvent(fe.EVENT_MOUSE_ENTER));
  }
  onMouseLeave() {
    this.dispatchLocalEvent(this.createLocalRowEvent(fe.EVENT_MOUSE_LEAVE));
  }
  getFirstChildOfFirstChild(t) {
    let i = this, s = !0, o = !1, r = null;
    for (; s && !o; ) {
      const n = i.parent;
      b(n) && i.firstChild ? n.rowGroupColumn === t && (o = !0, r = n) : s = !1, i = n;
    }
    return o ? r : null;
  }
  /**
   * Returns:
   * - `true` if the node is a full width cell
   * - `false` if the node is not a full width cell
   */
  isFullWidthCell() {
    if (this.detail)
      return !0;
    const t = this.beans.gos.getCallback("isFullWidthRow");
    return t ? t({ rowNode: this }) : !1;
  }
  /**
   * Returns the route of the row node. If the Row Node is a group, it returns the route to that Row Node.
   * If the Row Node is not a group, it returns `undefined`.
   */
  getRoute() {
    if (this.key == null)
      return;
    const t = [];
    let i = this;
    for (; i.key != null; )
      t.push(i.key), i = i.parent;
    return t.reverse();
  }
  createFooter() {
    if (this.sibling)
      return;
    const t = /* @__PURE__ */ new Set([
      "eventService",
      "__objectId",
      "sticky"
    ]), i = new fe(this.beans);
    Object.keys(this).forEach((s) => {
      t.has(s) || (i[s] = this[s]);
    }), i.footer = !0, i.setRowTop(null), i.setRowIndex(null), i.oldRowTop = null, i.id = "rowGroupFooter_" + this.id, i.sibling = this, this.sibling = i;
  }
  // Only used by SSRM. In CSRM this is never used as footers should always be present for
  // the purpose of exporting collapsed groups. In SSRM it is not possible to export collapsed
  // groups anyway, so can destroy footers.
  destroyFooter() {
    this.sibling && (this.sibling.setRowTop(null), this.sibling.setRowIndex(null), this.sibling = void 0);
  }
};
De.ID_PREFIX_ROW_GROUP = "row-group-";
De.ID_PREFIX_TOP_PINNED = "t-";
De.ID_PREFIX_BOTTOM_PINNED = "b-";
De.OBJECT_ID_SEQUENCE = 0;
De.EVENT_ROW_SELECTED = "rowSelected";
De.EVENT_DATA_CHANGED = "dataChanged";
De.EVENT_CELL_CHANGED = "cellChanged";
De.EVENT_ALL_CHILDREN_COUNT_CHANGED = "allChildrenCountChanged";
De.EVENT_MASTER_CHANGED = "masterChanged";
De.EVENT_GROUP_CHANGED = "groupChanged";
De.EVENT_MOUSE_ENTER = "mouseEnter";
De.EVENT_MOUSE_LEAVE = "mouseLeave";
De.EVENT_HEIGHT_CHANGED = "heightChanged";
De.EVENT_TOP_CHANGED = "topChanged";
De.EVENT_DISPLAYED_CHANGED = "displayedChanged";
De.EVENT_FIRST_CHILD_CHANGED = "firstChildChanged";
De.EVENT_LAST_CHILD_CHANGED = "lastChildChanged";
De.EVENT_CHILD_INDEX_CHANGED = "childIndexChanged";
De.EVENT_ROW_INDEX_CHANGED = "rowIndexChanged";
De.EVENT_EXPANDED_CHANGED = "expandedChanged";
De.EVENT_HAS_CHILDREN_CHANGED = "hasChildrenChanged";
De.EVENT_SELECTABLE_CHANGED = "selectableChanged";
De.EVENT_UI_LEVEL_CHANGED = "uiLevelChanged";
De.EVENT_HIGHLIGHT_CHANGED = "rowHighlightChanged";
De.EVENT_DRAGGING_CHANGED = "draggingChanged";
var X = De, _n = class extends K {
  constructor() {
    super(
      /* html*/
      `
            <div class="ag-selection-checkbox" role="presentation">
                <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
            </div>`
    );
  }
  postConstruct() {
    this.eCheckbox.setPassive(!0);
  }
  getCheckboxId() {
    return this.eCheckbox.getInputElement().id;
  }
  onDataChanged() {
    this.onSelectionChanged();
  }
  onSelectableChanged() {
    this.showOrHideSelect();
  }
  onSelectionChanged() {
    const e = this.localeService.getLocaleTextFunc(), t = this.rowNode.isSelected(), i = bn(e, t), [s, o] = this.rowNode.selectable ? ["ariaRowToggleSelection", "Press Space to toggle row selection"] : ["ariaRowSelectionDisabled", "Row Selection is disabled for this row"], r = e(s, o);
    this.eCheckbox.setValue(t, !0), this.eCheckbox.setInputAriaLabel(`${r} (${i})`);
  }
  onClicked(e, t, i) {
    return this.rowNode.setSelectedParams({ newValue: e, rangeSelect: i.shiftKey, groupSelectsFiltered: t, event: i, source: "checkboxSelected" });
  }
  init(e) {
    if (this.rowNode = e.rowNode, this.column = e.column, this.overrides = e.overrides, this.onSelectionChanged(), this.addManagedListener(this.eCheckbox.getInputElement(), "dblclick", (s) => {
      Qt(s);
    }), this.addManagedListener(this.eCheckbox.getInputElement(), "click", (s) => {
      Qt(s);
      const o = this.gos.get("groupSelectsFiltered"), r = this.eCheckbox.getValue();
      this.shouldHandleIndeterminateState(r, o) ? this.onClicked(!0, o, s || {}) === 0 && this.onClicked(!1, o, s) : r ? this.onClicked(!1, o, s) : this.onClicked(!0, o, s || {});
    }), this.addManagedListener(this.rowNode, X.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_DATA_CHANGED, this.onDataChanged.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_SELECTABLE_CHANGED, this.onSelectableChanged.bind(this)), this.gos.get("isRowSelectable") || typeof this.getIsVisible() == "function") {
      const s = this.showOrHideSelect.bind(this);
      this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, s), this.addManagedListener(this.rowNode, X.EVENT_DATA_CHANGED, s), this.addManagedListener(this.rowNode, X.EVENT_CELL_CHANGED, s), this.showOrHideSelect();
    }
    this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
  }
  shouldHandleIndeterminateState(e, t) {
    return t && (this.eCheckbox.getPreviousValue() === void 0 || e === void 0) && this.gos.isRowModelType("clientSide");
  }
  showOrHideSelect() {
    var e, t, i;
    let s = this.rowNode.selectable;
    const o = this.getIsVisible();
    if (s)
      if (typeof o == "function") {
        const n = (e = this.overrides) == null ? void 0 : e.callbackParams;
        if (!this.column)
          s = o(Re(_({}, n), { node: this.rowNode, data: this.rowNode.data }));
        else {
          const l = this.column.createColumnFunctionCallbackParams(this.rowNode);
          s = o(_(_({}, n), l));
        }
      } else
        s = o ?? !1;
    if ((t = this.column) == null ? void 0 : t.getColDef().showDisabledCheckboxes) {
      this.eCheckbox.setDisabled(!s), this.setVisible(!0), this.setDisplayed(!0);
      return;
    }
    if ((i = this.overrides) != null && i.removeHidden) {
      this.setDisplayed(s);
      return;
    }
    this.setVisible(s);
  }
  getIsVisible() {
    var e, t;
    return this.overrides ? this.overrides.isVisible : (t = (e = this.column) == null ? void 0 : e.getColDef()) == null ? void 0 : t.checkboxSelection;
  }
};
u([
  M("eCheckbox")
], _n.prototype, "eCheckbox", 2);
u([
  L
], _n.prototype, "postConstruct", 1);
var Jc = /* @__PURE__ */ ((e) => (e[e.Left = 0] = "Left", e[e.Right = 1] = "Right", e))(Jc || {}), Y = class extends F {
  constructor() {
    super(...arguments), this.dragSourceAndParamsList = [], this.dropTargets = [];
  }
  init() {
    this.ePinnedIcon = Lt("columnMovePin", this.gos, null), this.eHideIcon = Lt("columnMoveHide", this.gos, null), this.eMoveIcon = Lt("columnMoveMove", this.gos, null), this.eLeftIcon = Lt("columnMoveLeft", this.gos, null), this.eRightIcon = Lt("columnMoveRight", this.gos, null), this.eGroupIcon = Lt("columnMoveGroup", this.gos, null), this.eAggregateIcon = Lt("columnMoveValue", this.gos, null), this.ePivotIcon = Lt("columnMovePivot", this.gos, null), this.eDropNotAllowedIcon = Lt("dropNotAllowed", this.gos, null);
  }
  addDragSource(e, t = !1) {
    const i = {
      eElement: e.eElement,
      dragStartPixels: e.dragStartPixels,
      onDragStart: this.onDragStart.bind(this, e),
      onDragStop: this.onDragStop.bind(this),
      onDragging: this.onDragging.bind(this),
      includeTouch: t
    };
    this.dragSourceAndParamsList.push({ params: i, dragSource: e }), this.dragService.addDragSource(i);
  }
  removeDragSource(e) {
    const t = this.dragSourceAndParamsList.find((i) => i.dragSource === e);
    t && (this.dragService.removeDragSource(t.params), gt(this.dragSourceAndParamsList, t));
  }
  clearDragSourceParamsList() {
    this.dragSourceAndParamsList.forEach((e) => this.dragService.removeDragSource(e.params)), this.dragSourceAndParamsList.length = 0, this.dropTargets.length = 0;
  }
  nudge() {
    this.dragging && this.onDragging(this.eventLastTime, !0);
  }
  onDragStart(e, t) {
    this.dragging = !0, this.dragSource = e, this.eventLastTime = t, this.dragItem = this.dragSource.getDragItem(), this.lastDropTarget = void 0, this.dragSource.onDragStarted && this.dragSource.onDragStarted(), this.createGhost();
  }
  onDragStop(e) {
    if (this.eventLastTime = null, this.dragging = !1, this.dragSource.onDragStopped && this.dragSource.onDragStopped(), this.lastDropTarget && this.lastDropTarget.onDragStop) {
      const t = this.createDropTargetEvent(this.lastDropTarget, e, null, null, !1);
      this.lastDropTarget.onDragStop(t);
    }
    this.lastDropTarget = null, this.dragItem = null, this.removeGhost();
  }
  onDragging(e, t) {
    var i, s, o, r;
    const n = this.getHorizontalDirection(e), l = this.getVerticalDirection(e);
    this.eventLastTime = e, this.positionGhost(e);
    const a = this.dropTargets.filter((c) => this.isMouseOnDropTarget(e, c)), d = this.findCurrentDropTarget(e, a);
    if (d !== this.lastDropTarget)
      this.leaveLastTargetIfExists(e, n, l, t), this.lastDropTarget !== null && d === null && ((s = (i = this.dragSource).onGridExit) == null || s.call(i, this.dragItem)), this.lastDropTarget === null && d !== null && ((r = (o = this.dragSource).onGridEnter) == null || r.call(o, this.dragItem)), this.enterDragTargetIfExists(d, e, n, l, t), this.lastDropTarget = d;
    else if (d && d.onDragging) {
      const c = this.createDropTargetEvent(d, e, n, l, t);
      d.onDragging(c);
    }
  }
  getAllContainersFromDropTarget(e) {
    const t = e.getSecondaryContainers ? e.getSecondaryContainers() : null, i = [[e.getContainer()]];
    return t ? i.concat(t) : i;
  }
  allContainersIntersect(e, t) {
    for (const i of t) {
      const s = i.getBoundingClientRect();
      if (s.width === 0 || s.height === 0)
        return !1;
      const o = e.clientX >= s.left && e.clientX < s.right, r = e.clientY >= s.top && e.clientY < s.bottom;
      if (!o || !r)
        return !1;
    }
    return !0;
  }
  // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
  isMouseOnDropTarget(e, t) {
    const i = this.getAllContainersFromDropTarget(t);
    let s = !1;
    for (const o of i)
      if (this.allContainersIntersect(e, o)) {
        s = !0;
        break;
      }
    return t.targetContainsSource && !t.getContainer().contains(this.dragSource.eElement) ? !1 : s && t.isInterestedIn(this.dragSource.type, this.dragSource.eElement);
  }
  findCurrentDropTarget(e, t) {
    const i = t.length;
    if (i === 0)
      return null;
    if (i === 1)
      return t[0];
    const o = this.gos.getRootNode().elementsFromPoint(e.clientX, e.clientY);
    for (const r of o)
      for (const n of t)
        if (Pu(this.getAllContainersFromDropTarget(n)).indexOf(r) !== -1)
          return n;
    return null;
  }
  enterDragTargetIfExists(e, t, i, s, o) {
    if (e) {
      if (e.onDragEnter) {
        const r = this.createDropTargetEvent(e, t, i, s, o);
        e.onDragEnter(r);
      }
      this.setGhostIcon(e.getIconName ? e.getIconName() : null);
    }
  }
  leaveLastTargetIfExists(e, t, i, s) {
    if (this.lastDropTarget) {
      if (this.lastDropTarget.onDragLeave) {
        const o = this.createDropTargetEvent(this.lastDropTarget, e, t, i, s);
        this.lastDropTarget.onDragLeave(o);
      }
      this.setGhostIcon(null);
    }
  }
  addDropTarget(e) {
    this.dropTargets.push(e);
  }
  removeDropTarget(e) {
    this.dropTargets = this.dropTargets.filter((t) => t.getContainer() !== e.getContainer());
  }
  hasExternalDropZones() {
    return this.dropTargets.some((e) => e.external);
  }
  findExternalZone(e) {
    return this.dropTargets.filter((i) => i.external).find((i) => i.getContainer() === e.getContainer()) || null;
  }
  getHorizontalDirection(e) {
    const t = this.eventLastTime && this.eventLastTime.clientX, i = e.clientX;
    return t === i ? null : t > i ? 0 : 1;
  }
  getVerticalDirection(e) {
    const t = this.eventLastTime && this.eventLastTime.clientY, i = e.clientY;
    return t === i ? null : t > i ? 0 : 1;
  }
  createDropTargetEvent(e, t, i, s, o) {
    const r = e.getContainer(), n = r.getBoundingClientRect(), { gridApi: l, columnApi: a, dragItem: d, dragSource: c } = this, h = t.clientX - n.left, g = t.clientY - n.top;
    return { event: t, x: h, y: g, vDirection: s, hDirection: i, dragSource: c, fromNudge: o, dragItem: d, api: l, columnApi: a, dropZoneTarget: r };
  }
  positionGhost(e) {
    const t = this.eGhost;
    if (!t)
      return;
    const s = t.getBoundingClientRect().height, o = ic() - 2, r = sc() - 2, n = Ea(t.offsetParent), { clientY: l, clientX: a } = e;
    let d = l - n.top - s / 2, c = a - n.left - 10;
    const h = this.gos.getDocument(), g = h.defaultView || window, m = g.pageYOffset || h.documentElement.scrollTop, C = g.pageXOffset || h.documentElement.scrollLeft;
    o > 0 && c + t.clientWidth > o + C && (c = o + C - t.clientWidth), c < 0 && (c = 0), r > 0 && d + t.clientHeight > r + m && (d = r + m - t.clientHeight), d < 0 && (d = 0), t.style.left = `${c}px`, t.style.top = `${d}px`;
  }
  removeGhost() {
    this.eGhost && this.eGhostParent && this.eGhostParent.removeChild(this.eGhost), this.eGhost = null;
  }
  createGhost() {
    this.eGhost = Ct(Y.GHOST_TEMPLATE), this.mouseEventService.stampTopLevelGridCompWithGridInstance(this.eGhost);
    const { theme: e } = this.environment.getTheme();
    e && this.eGhost.classList.add(e), this.eGhostIcon = this.eGhost.querySelector(".ag-dnd-ghost-icon"), this.setGhostIcon(null);
    const t = this.eGhost.querySelector(".ag-dnd-ghost-label");
    let i = this.dragSource.dragItemName;
    Sn(i) && (i = i()), t.innerHTML = Oe(i) || "", this.eGhost.style.height = "25px", this.eGhost.style.top = "20px", this.eGhost.style.left = "20px";
    const s = this.gos.getDocument();
    let o = null, r = null;
    try {
      o = s.fullscreenElement;
    } catch {
    } finally {
      o || (o = this.gos.getRootNode());
      const n = o.querySelector("body");
      n ? r = n : o instanceof ShadowRoot ? r = o : o instanceof Document ? r = o == null ? void 0 : o.documentElement : r = o;
    }
    this.eGhostParent = r, this.eGhostParent ? this.eGhostParent.appendChild(this.eGhost) : console.warn("AG Grid: could not find document body, it is needed for dragging columns");
  }
  setGhostIcon(e, t = !1) {
    xe(this.eGhostIcon);
    let i = null;
    switch (e || (e = this.dragSource.getDefaultIconName ? this.dragSource.getDefaultIconName() : Y.ICON_NOT_ALLOWED), e) {
      case Y.ICON_PINNED:
        i = this.ePinnedIcon;
        break;
      case Y.ICON_MOVE:
        i = this.eMoveIcon;
        break;
      case Y.ICON_LEFT:
        i = this.eLeftIcon;
        break;
      case Y.ICON_RIGHT:
        i = this.eRightIcon;
        break;
      case Y.ICON_GROUP:
        i = this.eGroupIcon;
        break;
      case Y.ICON_AGGREGATE:
        i = this.eAggregateIcon;
        break;
      case Y.ICON_PIVOT:
        i = this.ePivotIcon;
        break;
      case Y.ICON_NOT_ALLOWED:
        i = this.eDropNotAllowedIcon;
        break;
      case Y.ICON_HIDE:
        i = this.eHideIcon;
        break;
    }
    this.eGhostIcon.classList.toggle("ag-shake-left-to-right", t), !(i === this.eHideIcon && this.gos.get("suppressDragLeaveHidesColumns")) && i && this.eGhostIcon.appendChild(i);
  }
};
Y.ICON_PINNED = "pinned";
Y.ICON_MOVE = "move";
Y.ICON_LEFT = "left";
Y.ICON_RIGHT = "right";
Y.ICON_GROUP = "group";
Y.ICON_AGGREGATE = "aggregate";
Y.ICON_PIVOT = "pivot";
Y.ICON_NOT_ALLOWED = "notAllowed";
Y.ICON_HIDE = "hide";
Y.GHOST_TEMPLATE = /* html */
`<div class="ag-dnd-ghost ag-unselectable">
            <span class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>
            <div class="ag-dnd-ghost-label"></div>
        </div>`;
u([
  f("dragService")
], Y.prototype, "dragService", 2);
u([
  f("mouseEventService")
], Y.prototype, "mouseEventService", 2);
u([
  f("columnApi")
], Y.prototype, "columnApi", 2);
u([
  f("gridApi")
], Y.prototype, "gridApi", 2);
u([
  L
], Y.prototype, "init", 1);
u([
  dt
], Y.prototype, "clearDragSourceParamsList", 1);
Y = u([
  O("dragAndDropService")
], Y);
var cs = class extends K {
  constructor(e, t, i, s, o, r) {
    super(), this.cellValueFn = e, this.rowNode = t, this.column = i, this.customGui = s, this.dragStartPixels = o, this.suppressVisibilityChange = r, this.dragSource = null;
  }
  isCustomGui() {
    return this.customGui != null;
  }
  postConstruct() {
    if (this.customGui ? this.setDragElement(this.customGui, this.dragStartPixels) : (this.setTemplate(
      /* html */
      '<div class="ag-drag-handle ag-row-drag" aria-hidden="true"></div>'
    ), this.getGui().appendChild(Te("rowDrag", this.gos, null)), this.addDragSource()), this.checkCompatibility(), !this.suppressVisibilityChange) {
      const e = this.gos.get("rowDragManaged") ? new ih(this, this.beans, this.rowNode, this.column) : new th(this, this.beans, this.rowNode, this.column);
      this.createManagedBean(e, this.beans.context);
    }
  }
  setDragElement(e, t) {
    this.setTemplateFromElement(e), this.addDragSource(t);
  }
  getSelectedNodes() {
    if (!this.gos.get("rowDragMultiRow"))
      return [this.rowNode];
    const t = this.beans.selectionService.getSelectedNodes();
    return t.indexOf(this.rowNode) !== -1 ? t : [this.rowNode];
  }
  // returns true if all compatibility items work out
  checkCompatibility() {
    const e = this.gos.get("rowDragManaged");
    this.gos.get("treeData") && e && H("If using row drag with tree data, you cannot have rowDragManaged=true");
  }
  getDragItem() {
    return {
      rowNode: this.rowNode,
      rowNodes: this.getSelectedNodes(),
      columns: this.column ? [this.column] : void 0,
      defaultTextValue: this.cellValueFn()
    };
  }
  getRowDragText(e) {
    if (e) {
      const t = e.getColDef();
      if (t.rowDragText)
        return t.rowDragText;
    }
    return this.gos.get("rowDragText");
  }
  addDragSource(e = 4) {
    this.dragSource && this.removeDragSource();
    const t = this.localeService.getLocaleTextFunc();
    this.dragSource = {
      type: 2,
      eElement: this.getGui(),
      dragItemName: () => {
        var i;
        const s = this.getDragItem(), o = ((i = s.rowNodes) == null ? void 0 : i.length) || 1, r = this.getRowDragText(this.column);
        return r ? r(s, o) : o === 1 ? this.cellValueFn() : `${o} ${t("rowDragRows", "rows")}`;
      },
      getDragItem: () => this.getDragItem(),
      dragStartPixels: e,
      dragSourceDomDataKey: this.gos.getDomDataKey()
    }, this.beans.dragAndDropService.addDragSource(this.dragSource, !0);
  }
  removeDragSource() {
    this.dragSource && this.beans.dragAndDropService.removeDragSource(this.dragSource), this.dragSource = null;
  }
};
u([
  f("beans")
], cs.prototype, "beans", 2);
u([
  L
], cs.prototype, "postConstruct", 1);
u([
  dt
], cs.prototype, "removeDragSource", 1);
var eh = class extends F {
  constructor(e, t, i) {
    super(), this.parent = e, this.rowNode = t, this.column = i;
  }
  setDisplayedOrVisible(e) {
    const t = { skipAriaHidden: !0 };
    if (e)
      this.parent.setDisplayed(!1, t);
    else {
      let i = !0, s = !1;
      this.column && (i = this.column.isRowDrag(this.rowNode) || this.parent.isCustomGui(), s = Sn(this.column.getColDef().rowDrag)), s ? (this.parent.setDisplayed(!0, t), this.parent.setVisible(i, t)) : (this.parent.setDisplayed(i, t), this.parent.setVisible(!0, t));
    }
  }
}, th = class extends eh {
  constructor(e, t, i, s) {
    super(e, i, s), this.beans = t;
  }
  postConstruct() {
    this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, p.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this)), this.workOutVisibility();
  }
  onSuppressRowDrag() {
    this.workOutVisibility();
  }
  workOutVisibility() {
    const e = this.gos.get("suppressRowDrag");
    this.setDisplayedOrVisible(e);
  }
};
u([
  L
], th.prototype, "postConstruct", 1);
var ih = class extends eh {
  constructor(e, t, i, s) {
    super(e, i, s), this.beans = t;
  }
  postConstruct() {
    this.addManagedListener(this.beans.eventService, p.EVENT_SORT_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, p.EVENT_FILTER_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, p.EVENT_COLUMN_ROW_GROUP_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, p.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this)), this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this)), this.workOutVisibility();
  }
  onSuppressRowDrag() {
    this.workOutVisibility();
  }
  workOutVisibility() {
    const t = this.beans.ctrlsService.getGridBodyCtrl().getRowDragFeature(), i = t && t.shouldPreventRowMove(), s = this.gos.get("suppressRowDrag"), o = this.beans.dragAndDropService.hasExternalDropZones(), r = i && !o || s;
    this.setDisplayedOrVisible(r);
  }
};
u([
  L
], ih.prototype, "postConstruct", 1);
var As = class extends F {
  init(e, t, i, s, o, r, n) {
    var l, a, d, c;
    this.params = n, this.eGui = t, this.eCheckbox = i, this.eExpanded = s, this.eContracted = o, this.comp = e, this.compClass = r;
    const { node: h, value: g, colDef: m } = n, C = this.isTopLevelFooter();
    if (!C) {
      if (this.isEmbeddedRowMismatch())
        return;
      if (h.footer && this.gos.get("groupHideOpenParents")) {
        const v = m && m.showRowGroup, y = h.rowGroupColumn && h.rowGroupColumn.getColId();
        if (v !== y)
          return;
      }
    }
    if (this.setupShowingValueForOpenedParent(), this.findDisplayedGroupNode(), !C) {
      const w = n.node.footer && n.node.rowGroupIndex === this.columnModel.getRowGroupColumns().findIndex((I) => {
        var A;
        return I.getColId() === ((A = n.colDef) == null ? void 0 : A.showRowGroup);
      }), y = this.gos.get("groupDisplayType") != "multipleColumns" || this.gos.get("treeData") || this.gos.get("showOpenedGroup") && !n.node.footer && (!n.node.group || n.node.rowGroupIndex != null && n.node.rowGroupIndex > this.columnModel.getRowGroupColumns().findIndex((I) => {
        var A;
        return I.getColId() === ((A = n.colDef) == null ? void 0 : A.showRowGroup);
      })), E = !h.group && (((l = this.params.colDef) == null ? void 0 : l.field) || ((a = this.params.colDef) == null ? void 0 : a.valueGetter)), D = this.isExpandable(), R = this.columnModel.isPivotMode() && h.leafGroup && ((d = h.rowGroupColumn) == null ? void 0 : d.getColId()) === ((c = n.column) == null ? void 0 : c.getColDef().showRowGroup);
      if (!this.showingValueForOpenedParent && !D && !E && !y && !w && !R)
        return;
    }
    this.addExpandAndContract(), this.addFullWidthRowDraggerIfNeeded(), this.addCheckboxIfNeeded(), this.addValueElement(), this.setupIndent(), this.refreshAriaExpanded();
  }
  getCellAriaRole() {
    var e, t;
    const i = (e = this.params.colDef) == null ? void 0 : e.cellAriaRole, s = (t = this.params.column) == null ? void 0 : t.getColDef().cellAriaRole;
    return i || s || "gridcell";
  }
  destroy() {
    super.destroy(), this.expandListener = null;
  }
  refreshAriaExpanded() {
    const { node: e, eGridCell: t } = this.params;
    if (this.expandListener && (this.expandListener = this.expandListener()), !this.isExpandable()) {
      ju(t);
      return;
    }
    const i = () => {
      fi(t, !!e.expanded);
    };
    this.expandListener = this.addManagedListener(e, X.EVENT_EXPANDED_CHANGED, i) || null, i();
  }
  isTopLevelFooter() {
    if (!this.gos.getGrandTotalRow() || this.params.value != null || this.params.node.level != -1)
      return !1;
    const t = this.params.colDef;
    if (t == null || t.showRowGroup === !0)
      return !0;
    const s = this.columnModel.getRowGroupColumns();
    return !s || s.length === 0 ? !0 : s[0].getId() === t.showRowGroup;
  }
  // if we are doing embedded full width rows, we only show the renderer when
  // in the body, or if pinning in the pinned section, or if pinning and RTL,
  // in the right section. otherwise we would have the cell repeated in each section.
  isEmbeddedRowMismatch() {
    if (!this.params.fullWidth || !this.gos.get("embedFullWidthRows"))
      return !1;
    const e = this.params.pinned === "left", t = this.params.pinned === "right", i = !e && !t;
    return this.gos.get("enableRtl") ? this.columnModel.isPinningLeft() ? !t : !i : this.columnModel.isPinningLeft() ? !e : !i;
  }
  findDisplayedGroupNode() {
    const e = this.params.column, t = this.params.node;
    if (this.showingValueForOpenedParent) {
      let i = t.parent;
      for (; i != null; ) {
        if (i.rowGroupColumn && e.isRowGroupDisplayed(i.rowGroupColumn.getId())) {
          this.displayedGroupNode = i;
          break;
        }
        i = i.parent;
      }
    }
    z(this.displayedGroupNode) && (this.displayedGroupNode = t);
  }
  setupShowingValueForOpenedParent() {
    const e = this.params.node, t = this.params.column;
    if (!this.gos.get("groupHideOpenParents")) {
      this.showingValueForOpenedParent = !1;
      return;
    }
    if (!e.groupData) {
      this.showingValueForOpenedParent = !1;
      return;
    }
    if (e.rowGroupColumn != null) {
      const o = e.rowGroupColumn.getId();
      if (t.isRowGroupDisplayed(o)) {
        this.showingValueForOpenedParent = !1;
        return;
      }
    }
    const s = e.groupData[t.getId()] != null;
    this.showingValueForOpenedParent = s;
  }
  addValueElement() {
    this.displayedGroupNode.footer ? this.addFooterValue() : (this.addGroupValue(), this.addChildCount());
  }
  addGroupValue() {
    var e;
    const t = this.adjustParamsWithDetailsFromRelatedColumn(), i = this.getInnerCompDetails(t), { valueFormatted: s, value: o } = t;
    let r = s;
    if (r == null) {
      const n = this.displayedGroupNode.rowGroupColumn && ((e = this.params.column) == null ? void 0 : e.isRowGroupDisplayed(this.displayedGroupNode.rowGroupColumn.getId()));
      this.displayedGroupNode.key === "" && this.displayedGroupNode.group && n ? r = this.localeService.getLocaleTextFunc()("blanks", "(Blanks)") : r = o ?? null;
    }
    this.comp.setInnerRenderer(i, r);
  }
  adjustParamsWithDetailsFromRelatedColumn() {
    const e = this.displayedGroupNode.rowGroupColumn, t = this.params.column;
    if (!e)
      return this.params;
    if (t != null && !t.isRowGroupDisplayed(e.getId()))
      return this.params;
    const s = this.params, { value: o, node: r } = this.params, n = this.valueService.formatValue(e, r, o);
    return Re(_({}, s), {
      valueFormatted: n
    });
  }
  addFooterValue() {
    let e = this.params.totalValueGetter;
    if (!e) {
      const s = this.params.footerValueGetter;
      s && (e = s, H("As of v31.3, footerValueGetter is deprecated. Use `totalValueGetter` instead."));
    }
    let t = "";
    if (e) {
      const s = ea(this.params);
      s.value = this.params.value, typeof e == "function" ? t = e(s) : typeof e == "string" ? t = this.expressionService.evaluate(e, s) : console.warn("AG Grid: footerValueGetter should be either a function or a string (expression)");
    } else
      t = this.localeService.getLocaleTextFunc()("footerTotal", "Total") + " " + (this.params.value != null ? this.params.value : "");
    const i = this.getInnerCompDetails(this.params);
    this.comp.setInnerRenderer(i, t);
  }
  getInnerCompDetails(e) {
    if (e.fullWidth)
      return this.userComponentFactory.getFullWidthGroupRowInnerCellRenderer(
        this.gos.get("groupRowRendererParams"),
        e
      );
    const t = this.userComponentFactory.getInnerRendererDetails(e, e), i = (n) => n && n.componentClass == this.compClass;
    if (t && !i(t))
      return t;
    const s = this.displayedGroupNode.rowGroupColumn, o = s ? s.getColDef() : void 0;
    if (!o)
      return;
    const r = this.userComponentFactory.getCellRendererDetails(o, e);
    if (r && !i(r))
      return r;
    if (i(r) && o.cellRendererParams && o.cellRendererParams.innerRenderer)
      return this.userComponentFactory.getInnerRendererDetails(o.cellRendererParams, e);
  }
  addChildCount() {
    this.params.suppressCount || (this.addManagedListener(this.displayedGroupNode, X.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.updateChildCount.bind(this)), this.updateChildCount());
  }
  updateChildCount() {
    const e = this.displayedGroupNode.allChildrenCount, s = this.isShowRowGroupForThisRow() && e != null && e >= 0 ? `(${e})` : "";
    this.comp.setChildCount(s);
  }
  isShowRowGroupForThisRow() {
    if (this.gos.get("treeData"))
      return !0;
    const e = this.displayedGroupNode.rowGroupColumn;
    if (!e)
      return !1;
    const t = this.params.column;
    return t == null || t.isRowGroupDisplayed(e.getId());
  }
  addExpandAndContract() {
    var e;
    const t = this.params, i = Te("groupExpanded", this.gos, null), s = Te("groupContracted", this.gos, null);
    i && this.eExpanded.appendChild(i), s && this.eContracted.appendChild(s);
    const o = t.eGridCell;
    !(((e = this.params.column) == null ? void 0 : e.isCellEditable(t.node)) && this.gos.get("enableGroupEdit")) && this.isExpandable() && !t.suppressDoubleClickExpand && this.addManagedListener(o, "dblclick", this.onCellDblClicked.bind(this)), this.addManagedListener(this.eExpanded, "click", this.onExpandClicked.bind(this)), this.addManagedListener(this.eContracted, "click", this.onExpandClicked.bind(this)), this.addManagedListener(o, "keydown", this.onKeyDown.bind(this)), this.addManagedListener(t.node, X.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this)), this.showExpandAndContractIcons();
    const n = this.onRowNodeIsExpandableChanged.bind(this);
    this.addManagedListener(this.displayedGroupNode, X.EVENT_ALL_CHILDREN_COUNT_CHANGED, n), this.addManagedListener(this.displayedGroupNode, X.EVENT_MASTER_CHANGED, n), this.addManagedListener(this.displayedGroupNode, X.EVENT_GROUP_CHANGED, n), this.addManagedListener(this.displayedGroupNode, X.EVENT_HAS_CHILDREN_CHANGED, n);
  }
  onExpandClicked(e) {
    Yt(e) || (Qt(e), this.onExpandOrContract(e));
  }
  onExpandOrContract(e) {
    const t = this.displayedGroupNode, i = !t.expanded;
    !i && t.sticky && this.scrollToStickyNode(t), t.setExpanded(i, e);
  }
  scrollToStickyNode(e) {
    this.ctrlsService.getGridBodyCtrl().getScrollFeature().setVerticalScrollPosition(e.rowTop - e.stickyRowTop);
  }
  isExpandable() {
    if (this.showingValueForOpenedParent)
      return !0;
    const e = this.displayedGroupNode, t = this.columnModel.isPivotMode() && e.leafGroup;
    if (!(e.isExpandable() && !e.footer && !t))
      return !1;
    const s = this.params.column;
    return s != null && typeof s.getColDef().showRowGroup == "string" ? this.isShowRowGroupForThisRow() : !0;
  }
  showExpandAndContractIcons() {
    const { params: e, displayedGroupNode: t, columnModel: i } = this, { node: s } = e, o = this.isExpandable();
    if (o) {
      const d = this.showingValueForOpenedParent ? !0 : s.expanded;
      this.comp.setExpandedDisplayed(d), this.comp.setContractedDisplayed(!d);
    } else
      this.comp.setExpandedDisplayed(!1), this.comp.setContractedDisplayed(!1);
    const r = i.isPivotMode(), n = r && t.leafGroup, l = o && !n, a = s.footer && s.level === -1;
    this.comp.addOrRemoveCssClass("ag-cell-expandable", l), this.comp.addOrRemoveCssClass("ag-row-group", l), r ? this.comp.addOrRemoveCssClass("ag-pivot-leaf-group", n) : a || this.comp.addOrRemoveCssClass("ag-row-group-leaf-indent", !l);
  }
  onRowNodeIsExpandableChanged() {
    this.showExpandAndContractIcons(), this.setIndent(), this.refreshAriaExpanded();
  }
  setupIndent() {
    const e = this.params.node;
    this.params.suppressPadding || (this.addManagedListener(e, X.EVENT_UI_LEVEL_CHANGED, this.setIndent.bind(this)), this.setIndent());
  }
  setIndent() {
    if (this.gos.get("groupHideOpenParents"))
      return;
    const e = this.params, t = e.node, i = !!e.colDef, s = this.gos.get("treeData"), r = !i || s || e.colDef.showRowGroup === !0 ? t.uiLevel : 0;
    this.indentClass && this.comp.addOrRemoveCssClass(this.indentClass, !1), this.indentClass = "ag-row-group-indent-" + r, this.comp.addOrRemoveCssClass(this.indentClass, !0);
  }
  addFullWidthRowDraggerIfNeeded() {
    if (!this.params.fullWidth || !this.params.rowDrag)
      return;
    const e = new cs(() => this.params.value, this.params.node);
    this.createManagedBean(e, this.context), this.eGui.insertAdjacentElement("afterbegin", e.getGui());
  }
  isUserWantsSelected() {
    const e = this.params.checkbox;
    return typeof e == "function" || e === !0;
  }
  addCheckboxIfNeeded() {
    const e = this.displayedGroupNode, t = this.isUserWantsSelected() && // footers cannot be selected
    !e.footer && // pinned rows cannot be selected
    !e.rowPinned && // details cannot be selected
    !e.detail;
    if (t) {
      const i = new _n();
      this.getContext().createBean(i), i.init({
        rowNode: this.params.node,
        // when groupHideOpenParents = true and group expanded, we want the checkbox to refer to leaf node state (not group node state)
        column: this.params.column,
        overrides: {
          isVisible: this.params.checkbox,
          callbackParams: this.params,
          removeHidden: !0
        }
      }), this.eCheckbox.appendChild(i.getGui()), this.addDestroyFunc(() => this.getContext().destroyBean(i));
    }
    this.comp.setCheckboxVisible(t);
  }
  onKeyDown(e) {
    !(e.key === S.ENTER) || this.params.suppressEnterExpand || this.params.column && this.params.column.isCellEditable(this.params.node) || this.onExpandOrContract(e);
  }
  onCellDblClicked(e) {
    if (Yt(e))
      return;
    Xr(this.eExpanded, e) || Xr(this.eContracted, e) || this.onExpandOrContract(e);
  }
};
u([
  f("expressionService")
], As.prototype, "expressionService", 2);
u([
  f("valueService")
], As.prototype, "valueService", 2);
u([
  f("columnModel")
], As.prototype, "columnModel", 2);
u([
  f("userComponentFactory")
], As.prototype, "userComponentFactory", 2);
u([
  f("ctrlsService")
], As.prototype, "ctrlsService", 2);
var Ps = class sh extends K {
  constructor() {
    super(sh.TEMPLATE);
  }
  init(t) {
    const i = {
      setInnerRenderer: (n, l) => this.setRenderDetails(n, l),
      setChildCount: (n) => this.eChildCount.textContent = n,
      addOrRemoveCssClass: (n, l) => this.addOrRemoveCssClass(n, l),
      setContractedDisplayed: (n) => te(this.eContracted, n),
      setExpandedDisplayed: (n) => te(this.eExpanded, n),
      setCheckboxVisible: (n) => this.eCheckbox.classList.toggle("ag-invisible", !n)
    }, s = this.createManagedBean(new As()), o = !t.colDef, r = this.getGui();
    s.init(i, r, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, t), o && Fe(r, s.getCellAriaRole());
  }
  setRenderDetails(t, i) {
    if (t) {
      const s = t.newAgStackInstance();
      if (!s)
        return;
      s.then((o) => {
        if (!o)
          return;
        const r = () => this.context.destroyBean(o);
        this.isAlive() ? (this.eValue.appendChild(o.getGui()), this.addDestroyFunc(r)) : r();
      });
    } else
      this.eValue.innerText = i;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to have public here instead of private or protected
  destroy() {
    this.getContext().destroyBean(this.innerCellRenderer), super.destroy();
  }
  refresh() {
    return !1;
  }
};
Ps.TEMPLATE = /* html */
`<span class="ag-cell-wrapper">
            <span class="ag-group-expanded" ref="eExpanded"></span>
            <span class="ag-group-contracted" ref="eContracted"></span>
            <span class="ag-group-checkbox ag-invisible" ref="eCheckbox"></span>
            <span class="ag-group-value" ref="eValue"></span>
            <span class="ag-group-child-count" ref="eChildCount"></span>
        </span>`;
u([
  M("eExpanded")
], Ps.prototype, "eExpanded", 2);
u([
  M("eContracted")
], Ps.prototype, "eContracted", 2);
u([
  M("eCheckbox")
], Ps.prototype, "eCheckbox", 2);
u([
  M("eValue")
], Ps.prototype, "eValue", 2);
u([
  M("eChildCount")
], Ps.prototype, "eChildCount", 2);
var Id = Ps, Vn = class oh extends K {
  constructor() {
    super(oh.TEMPLATE);
  }
  init(t) {
    t.node.failedLoad ? this.setupFailed() : this.setupLoading();
  }
  setupFailed() {
    const t = this.localeService.getLocaleTextFunc();
    this.eLoadingText.innerText = t("loadingError", "ERR");
  }
  setupLoading() {
    const t = Te("groupLoading", this.gos, null);
    t && this.eLoadingIcon.appendChild(t);
    const i = this.localeService.getLocaleTextFunc();
    this.eLoadingText.innerText = i("loadingOoo", "Loading");
  }
  refresh(t) {
    return !1;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  destroy() {
    super.destroy();
  }
};
Vn.TEMPLATE = `<div class="ag-loading">
            <span class="ag-loading-icon" ref="eLoadingIcon"></span>
            <span class="ag-loading-text" ref="eLoadingText"></span>
        </div>`;
u([
  M("eLoadingIcon")
], Vn.prototype, "eLoadingIcon", 2);
u([
  M("eLoadingText")
], Vn.prototype, "eLoadingText", 2);
var Mg = Vn, rh = class nh extends K {
  constructor() {
    super(nh.TEMPLATE);
  }
  init(t) {
    const i = `ag-cell-skeleton-renderer-${this.getCompId()}`;
    this.getGui().setAttribute("id", i), this.addDestroyFunc(() => Ys(t.eParentOfValue)), Ys(t.eParentOfValue, i), t.node.failedLoad ? this.setupFailed() : this.setupLoading();
  }
  setupFailed() {
    const t = this.localeService.getLocaleTextFunc();
    this.getGui().innerText = t("loadingError", "ERR");
    const i = t("ariaSkeletonCellLoadingFailed", "Row failed to load");
    bt(this.getGui(), i);
  }
  setupLoading() {
    const i = this.gos.getDocument().createElement("div");
    i.classList.add("ag-skeleton-effect"), this.getGui().appendChild(i);
    const o = this.localeService.getLocaleTextFunc()("ariaSkeletonCellLoading", "Row data is loading");
    bt(this.getGui(), o);
  }
  refresh(t) {
    return !1;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  destroy() {
    super.destroy();
  }
};
rh.TEMPLATE = '<div class="ag-skeleton-container"></div>';
var xg = rh, lh = class ah extends K {
  constructor() {
    super();
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  destroy() {
    super.destroy();
  }
  init(t) {
    const i = this.gos.get("overlayLoadingTemplate");
    if (this.setTemplate(i ?? ah.DEFAULT_LOADING_OVERLAY_TEMPLATE), !i) {
      const s = this.localeService.getLocaleTextFunc();
      setTimeout(() => {
        this.getGui().textContent = s("loadingOoo", "Loading...");
      });
    }
  }
};
lh.DEFAULT_LOADING_OVERLAY_TEMPLATE = /* html */
'<span aria-live="polite" aria-atomic="true" class="ag-overlay-loading-center"></span>';
var Ng = lh, dh = class uh extends K {
  constructor() {
    super();
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  destroy() {
    super.destroy();
  }
  init(t) {
    const i = this.gos.get("overlayNoRowsTemplate");
    if (this.setTemplate(i ?? uh.DEFAULT_NO_ROWS_TEMPLATE), !i) {
      const s = this.localeService.getLocaleTextFunc();
      setTimeout(() => {
        this.getGui().textContent = s("noRowsToShow", "No Rows To Show");
      });
    }
  }
};
dh.DEFAULT_NO_ROWS_TEMPLATE = /* html */
'<span class="ag-overlay-no-rows-center"></span>';
var Gg = dh, Og = class extends bs {
  constructor() {
    super(
      /* html */
      '<div class="ag-tooltip"></div>'
    );
  }
  // will need to type params
  init(e) {
    const { value: t } = e;
    this.getGui().textContent = Oe(t, !0);
  }
}, _g = class {
  getTemplate() {
    return (
      /* html */
      '<ag-input-number-field class="ag-cell-editor" ref="eInput"></ag-input-number-field>'
    );
  }
  init(e, t) {
    this.eInput = e, this.params = t, t.max != null && e.setMax(t.max), t.min != null && e.setMin(t.min), t.precision != null && e.setPrecision(t.precision), t.step != null && e.setStep(t.step);
    const i = e.getInputElement();
    t.preventStepping ? e.addManagedListener(i, "keydown", this.preventStepping) : t.showStepperButtons && i.classList.add("ag-number-field-input-stepper");
  }
  preventStepping(e) {
    (e.key === S.UP || e.key === S.DOWN) && e.preventDefault();
  }
  getValue() {
    const e = this.eInput.getValue();
    if (!b(e) && !b(this.params.value))
      return this.params.value;
    let t = this.params.parseValue(e);
    if (t == null)
      return t;
    if (typeof t == "string") {
      if (t === "")
        return null;
      t = Number(t);
    }
    return isNaN(t) ? null : t;
  }
  getStartValue() {
    return this.params.value;
  }
}, Vg = class extends Sr {
  constructor() {
    super(new _g());
  }
}, Hg = class {
  getTemplate() {
    return (
      /* html */
      '<ag-input-date-field class="ag-cell-editor" ref="eInput"></ag-input-date-field>'
    );
  }
  init(e, t) {
    this.eInput = e, this.params = t, t.min != null && e.setMin(t.min), t.max != null && e.setMax(t.max), t.step != null && e.setStep(t.step);
  }
  getValue() {
    const e = this.eInput.getDate();
    return !b(e) && !b(this.params.value) ? this.params.value : e ?? null;
  }
  getStartValue() {
    const { value: e } = this.params;
    if (e instanceof Date)
      return Nt(e, !1);
  }
}, kg = class extends Sr {
  constructor() {
    super(new Hg());
  }
}, Bg = class {
  constructor(e) {
    this.getDataTypeService = e;
  }
  getTemplate() {
    return (
      /* html */
      '<ag-input-date-field class="ag-cell-editor" ref="eInput"></ag-input-date-field>'
    );
  }
  init(e, t) {
    this.eInput = e, this.params = t, t.min != null && e.setMin(t.min), t.max != null && e.setMax(t.max), t.step != null && e.setStep(t.step);
  }
  getValue() {
    const e = this.formatDate(this.eInput.getDate());
    return !b(e) && !b(this.params.value) ? this.params.value : this.params.parseValue(e ?? "");
  }
  getStartValue() {
    var e, t;
    return Nt((t = this.parseDate((e = this.params.value) != null ? e : void 0)) != null ? t : null, !1);
  }
  parseDate(e) {
    return this.getDataTypeService().getDateParserFunction(this.params.column)(e);
  }
  formatDate(e) {
    return this.getDataTypeService().getDateFormatterFunction(this.params.column)(e);
  }
}, ch = class extends Sr {
  constructor() {
    super(new Bg(() => this.dataTypeService));
  }
};
u([
  f("dataTypeService")
], ch.prototype, "dataTypeService", 2);
var ka = class hh extends K {
  constructor() {
    super(hh.TEMPLATE);
  }
  init(t) {
    this.params = t, this.updateCheckbox(t);
    const i = this.eCheckbox.getInputElement();
    i.setAttribute("tabindex", "-1"), na(i, "polite"), this.addManagedListener(i, "click", (s) => {
      if (Qt(s), this.eCheckbox.isDisabled())
        return;
      const o = this.eCheckbox.getValue();
      this.onCheckboxChanged(o);
    }), this.addManagedListener(i, "dblclick", (s) => {
      Qt(s);
    }), this.addManagedListener(this.params.eGridCell, "keydown", (s) => {
      if (s.key === S.SPACE && !this.eCheckbox.isDisabled()) {
        this.params.eGridCell === this.gos.getActiveDomElement() && this.eCheckbox.toggle();
        const o = this.eCheckbox.getValue();
        this.onCheckboxChanged(o), s.preventDefault();
      }
    });
  }
  refresh(t) {
    return this.params = t, this.updateCheckbox(t), !0;
  }
  updateCheckbox(t) {
    var i, s, o;
    let r, n = !0;
    if (t.node.group && t.column) {
      const h = t.column.getColId();
      h.startsWith(js) ? r = t.value == null || t.value === "" ? void 0 : t.value === "true" : t.node.aggData && t.node.aggData[h] !== void 0 ? r = (i = t.value) != null ? i : void 0 : n = !1;
    } else
      r = (s = t.value) != null ? s : void 0;
    if (!n) {
      this.eCheckbox.setDisplayed(!1);
      return;
    }
    this.eCheckbox.setValue(r);
    const l = t.disabled != null ? t.disabled : !((o = t.column) != null && o.isCellEditable(t.node));
    this.eCheckbox.setDisabled(l);
    const a = this.localeService.getLocaleTextFunc(), d = bn(a, r), c = l ? d : `${a("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${d})`;
    this.eCheckbox.setInputAriaLabel(c);
  }
  onCheckboxChanged(t) {
    const { column: i, node: s, rowIndex: o, value: r } = this.params, n = {
      type: p.EVENT_CELL_EDITING_STARTED,
      column: i,
      colDef: i == null ? void 0 : i.getColDef(),
      data: s.data,
      node: s,
      rowIndex: o,
      rowPinned: s.rowPinned,
      value: r
    };
    this.eventService.dispatchEvent(n);
    const l = this.params.node.setDataValue(this.params.column, t, "edit"), a = {
      type: p.EVENT_CELL_EDITING_STOPPED,
      column: i,
      colDef: i == null ? void 0 : i.getColDef(),
      data: s.data,
      node: s,
      rowIndex: o,
      rowPinned: s.rowPinned,
      value: r,
      oldValue: r,
      newValue: t,
      valueChanged: l
    };
    this.eventService.dispatchEvent(a);
  }
};
ka.TEMPLATE = /* html*/
`
        <div class="ag-cell-wrapper ag-checkbox-cell" role="presentation">
            <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
        </div>`;
u([
  M("eCheckbox")
], ka.prototype, "eCheckbox", 2);
var Wg = ka, ph = class extends bs {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit">
                <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
            </div>`
    );
  }
  init(e) {
    var t;
    this.params = e;
    const i = (t = e.value) != null ? t : void 0;
    this.eCheckbox.setValue(i), this.eCheckbox.getInputElement().setAttribute("tabindex", "-1"), this.setAriaLabel(i), this.addManagedListener(
      this.eCheckbox,
      p.EVENT_FIELD_VALUE_CHANGED,
      (o) => this.setAriaLabel(o.selected)
    );
  }
  getValue() {
    return this.eCheckbox.getValue();
  }
  focusIn() {
    this.eCheckbox.getFocusableElement().focus();
  }
  afterGuiAttached() {
    this.params.cellStartedEdit && this.focusIn();
  }
  isPopup() {
    return !1;
  }
  setAriaLabel(e) {
    const t = this.localeService.getLocaleTextFunc(), i = bn(t, e), s = t("ariaToggleCellValue", "Press SPACE to toggle cell value");
    this.eCheckbox.setInputAriaLabel(`${s} (${i})`);
  }
};
u([
  M("eCheckbox")
], ph.prototype, "eCheckbox", 2);
var Ug = class extends K {
  constructor() {
    super(), this.setTemplate(
      /* html */
      "<div></div>"
    );
  }
  init(e) {
    var t;
    this.params = e, this.cssClassPrefix = (t = this.params.cssClassPrefix) != null ? t : "ag-menu-option", this.addIcon(), this.addName(), this.addShortcut(), this.addSubMenu();
  }
  configureDefaults() {
    return !0;
  }
  addIcon() {
    if (this.params.isCompact)
      return;
    const e = Ct(
      /* html */
      `<span ref="eIcon" class="${this.getClassName("part")} ${this.getClassName("icon")}" role="presentation"></span>`
    );
    this.params.checked ? e.appendChild(Te("check", this.gos)) : this.params.icon && (pr(this.params.icon) ? e.appendChild(this.params.icon) : typeof this.params.icon == "string" ? e.innerHTML = this.params.icon : console.warn("AG Grid: menu item icon must be DOM node or string")), this.getGui().appendChild(e);
  }
  addName() {
    const e = Ct(
      /* html */
      `<span ref="eName" class="${this.getClassName("part")} ${this.getClassName("text")}">${this.params.name || ""}</span>`
    );
    this.getGui().appendChild(e);
  }
  addShortcut() {
    if (this.params.isCompact)
      return;
    const e = Ct(
      /* html */
      `<span ref="eShortcut" class="${this.getClassName("part")} ${this.getClassName("shortcut")}">${this.params.shortcut || ""}</span>`
    );
    this.getGui().appendChild(e);
  }
  addSubMenu() {
    const e = Ct(
      /* html */
      `<span ref="ePopupPointer" class="${this.getClassName("part")} ${this.getClassName("popup-pointer")}"></span>`
    ), t = this.getGui();
    if (this.params.subMenu) {
      const i = this.gos.get("enableRtl") ? "smallLeft" : "smallRight";
      fi(t, !1), e.appendChild(Te(i, this.gos));
    }
    t.appendChild(e);
  }
  getClassName(e) {
    return `${this.cssClassPrefix}-${e}`;
  }
  destroy() {
    super.destroy();
  }
}, sn = class extends F {
  constructor() {
    super(...arguments), this.agGridDefaults = {
      //date
      agDateInput: kc,
      //header
      agColumnHeader: Vl,
      agColumnGroupHeader: Ag,
      agSortIndicator: _a,
      //floating filters
      agTextColumnFloatingFilter: bg,
      agNumberColumnFloatingFilter: Tg,
      agDateColumnFloatingFilter: Gn,
      agReadOnlyFloatingFilter: La,
      // renderers
      agAnimateShowChangeCellRenderer: Xc,
      agAnimateSlideCellRenderer: Zc,
      agGroupCellRenderer: Id,
      agGroupRowRenderer: Id,
      agLoadingCellRenderer: Mg,
      agSkeletonCellRenderer: xg,
      agCheckboxCellRenderer: Wg,
      //editors
      agCellEditor: Ld,
      agTextCellEditor: Ld,
      agNumberCellEditor: Vg,
      agDateCellEditor: kg,
      agDateStringCellEditor: ch,
      agSelectCellEditor: Ha,
      agLargeTextCellEditor: Pg,
      agCheckboxCellEditor: ph,
      //filter
      agTextColumnFilter: Oa,
      agNumberColumnFilter: zc,
      agDateColumnFilter: Hc,
      //overlays
      agLoadingOverlay: Ng,
      agNoRowsOverlay: Gg,
      // tooltips
      agTooltipComponent: Og,
      // menu item
      agMenuItem: Ug
    }, this.enterpriseAgDefaultCompsModule = {
      agSetColumnFilter: "@ag-grid-enterprise/set-filter",
      agSetColumnFloatingFilter: "@ag-grid-enterprise/set-filter",
      agMultiColumnFilter: "@ag-grid-enterprise/multi-filter",
      agMultiColumnFloatingFilter: "@ag-grid-enterprise/multi-filter",
      agGroupColumnFilter: "@ag-grid-enterprise/row-grouping",
      agGroupColumnFloatingFilter: "@ag-grid-enterprise/row-grouping",
      agRichSelect: "@ag-grid-enterprise/rich-select",
      agRichSelectCellEditor: "@ag-grid-enterprise/rich-select",
      agDetailCellRenderer: "@ag-grid-enterprise/master-detail",
      agSparklineCellRenderer: "@ag-grid-enterprise/sparklines"
      /* SparklinesModule */
    }, this.jsComps = {};
  }
  init() {
    const e = this.gos.get("components");
    e != null && tt(e, (t, i) => this.registerJsComponent(t, i));
  }
  registerDefaultComponent(e, t) {
    if (this.agGridDefaults[e]) {
      console.error("Trying to overwrite a default component. You should call registerComponent");
      return;
    }
    this.agGridDefaults[e] = t;
  }
  registerJsComponent(e, t) {
    this.jsComps[e] = t;
  }
  retrieve(e, t) {
    const i = (l, a) => ({ componentFromFramework: a, component: l }), s = this.getFrameworkOverrides().frameworkComponent(t, this.gos.get("components"));
    if (s != null)
      return i(s, !0);
    const o = this.jsComps[t];
    if (o) {
      const l = this.getFrameworkOverrides().isFrameworkComponent(o);
      return i(o, l);
    }
    const r = this.agGridDefaults[t];
    if (r)
      return i(r, !1);
    const n = this.enterpriseAgDefaultCompsModule[t];
    return n ? le.__assertRegistered(n, `AG Grid '${e}' component: ${t}`, this.context.getGridId()) : $s(() => {
      this.warnAboutMissingComponent(e, t);
    }, "MissingComp" + t), null;
  }
  warnAboutMissingComponent(e, t) {
    const i = [
      // Don't include the old names / internals in potential suggestions
      ...Object.keys(this.agGridDefaults).filter((o) => !["agCellEditor", "agGroupRowRenderer", "agSortIndicator"].includes(o)),
      ...Object.keys(this.jsComps)
    ], s = gr(t, i, !0, 0.8).values;
    console.warn(`AG Grid: Could not find '${t}' component. It was configured as "${e}: '${t}'" but it wasn't found in the list of registered components.`), s.length > 0 && console.warn(`         Did you mean: [${s.slice(0, 3)}]?`), console.warn(`If using a custom component check it has been registered as described in: ${this.getFrameworkOverrides().getDocLink("components/")}`);
  }
};
u([
  L
], sn.prototype, "init", 1);
sn = u([
  O("userComponentRegistry")
], sn);
var zg = {
  propertyName: "dateComponent",
  cellRenderer: !1
}, Kg = {
  propertyName: "headerComponent",
  cellRenderer: !1
}, $g = {
  propertyName: "headerGroupComponent",
  cellRenderer: !1
}, Md = {
  propertyName: "cellRenderer",
  cellRenderer: !0
}, jg = {
  propertyName: "loadingCellRenderer",
  cellRenderer: !0
}, Yg = {
  propertyName: "cellEditor",
  cellRenderer: !1
}, xd = {
  propertyName: "innerRenderer",
  cellRenderer: !0
}, qg = {
  propertyName: "loadingOverlayComponent",
  cellRenderer: !1
}, Qg = {
  propertyName: "noRowsOverlayComponent",
  cellRenderer: !1
}, Xg = {
  propertyName: "tooltipComponent",
  cellRenderer: !1
}, Hl = {
  propertyName: "filter",
  cellRenderer: !1
}, Zg = {
  propertyName: "floatingFilterComponent",
  cellRenderer: !1
}, Jg = {
  propertyName: "toolPanel",
  cellRenderer: !1
}, ef = {
  propertyName: "statusPanel",
  cellRenderer: !1
}, tf = {
  propertyName: "fullWidthCellRenderer",
  cellRenderer: !0
}, sf = {
  propertyName: "loadingCellRenderer",
  cellRenderer: !0
}, of = {
  propertyName: "groupRowRenderer",
  cellRenderer: !0
}, rf = {
  propertyName: "detailCellRenderer",
  cellRenderer: !0
}, nf = {
  propertyName: "menuItem",
  cellRenderer: !1
}, gh = class {
  static getFloatingFilterType(e) {
    return this.filterToFloatingFilterMapping[e];
  }
};
gh.filterToFloatingFilterMapping = {
  set: "agSetColumnFloatingFilter",
  agSetColumnFilter: "agSetColumnFloatingFilter",
  multi: "agMultiColumnFloatingFilter",
  agMultiColumnFilter: "agMultiColumnFloatingFilter",
  group: "agGroupColumnFloatingFilter",
  agGroupColumnFilter: "agGroupColumnFloatingFilter",
  number: "agNumberColumnFloatingFilter",
  agNumberColumnFilter: "agNumberColumnFloatingFilter",
  date: "agDateColumnFloatingFilter",
  agDateColumnFilter: "agDateColumnFloatingFilter",
  text: "agTextColumnFloatingFilter",
  agTextColumnFilter: "agTextColumnFloatingFilter"
};
var Mi = class extends F {
  getHeaderCompDetails(e, t) {
    return this.getCompDetails(e, Kg, "agColumnHeader", t);
  }
  getHeaderGroupCompDetails(e) {
    const t = e.columnGroup.getColGroupDef();
    return this.getCompDetails(t, $g, "agColumnGroupHeader", e);
  }
  // this one is unusual, as it can be LoadingCellRenderer, DetailCellRenderer, FullWidthCellRenderer or GroupRowRenderer.
  // so we have to pass the type in.
  getFullWidthCellRendererDetails(e) {
    return this.getCompDetails(this.gridOptions, tf, null, e, !0);
  }
  getFullWidthLoadingCellRendererDetails(e) {
    return this.getCompDetails(this.gridOptions, sf, "agLoadingCellRenderer", e, !0);
  }
  getFullWidthGroupCellRendererDetails(e) {
    return this.getCompDetails(this.gridOptions, of, "agGroupRowRenderer", e, !0);
  }
  getFullWidthDetailCellRendererDetails(e) {
    return this.getCompDetails(this.gridOptions, rf, "agDetailCellRenderer", e, !0);
  }
  // CELL RENDERER
  getInnerRendererDetails(e, t) {
    return this.getCompDetails(e, xd, null, t);
  }
  getFullWidthGroupRowInnerCellRenderer(e, t) {
    return this.getCompDetails(e, xd, null, t);
  }
  getCellRendererDetails(e, t) {
    return this.getCompDetails(e, Md, null, t);
  }
  getLoadingCellRendererDetails(e, t) {
    return this.getCompDetails(e, jg, "agSkeletonCellRenderer", t, !0);
  }
  // CELL EDITOR
  getCellEditorDetails(e, t) {
    return this.getCompDetails(e, Yg, "agCellEditor", t, !0);
  }
  // FILTER
  getFilterDetails(e, t, i) {
    return this.getCompDetails(e, Hl, i, t, !0);
  }
  getDateCompDetails(e) {
    return this.getCompDetails(this.gridOptions, zg, "agDateInput", e, !0);
  }
  getLoadingOverlayCompDetails(e) {
    return this.getCompDetails(this.gridOptions, qg, "agLoadingOverlay", e, !0);
  }
  getNoRowsOverlayCompDetails(e) {
    return this.getCompDetails(this.gridOptions, Qg, "agNoRowsOverlay", e, !0);
  }
  getTooltipCompDetails(e) {
    return this.getCompDetails(e.colDef, Xg, "agTooltipComponent", e, !0);
  }
  getSetFilterCellRendererDetails(e, t) {
    return this.getCompDetails(e, Md, null, t);
  }
  getFloatingFilterCompDetails(e, t, i) {
    return this.getCompDetails(e, Zg, i, t);
  }
  getToolPanelCompDetails(e, t) {
    return this.getCompDetails(e, Jg, null, t, !0);
  }
  getStatusPanelCompDetails(e, t) {
    return this.getCompDetails(e, ef, null, t, !0);
  }
  getMenuItemCompDetails(e, t) {
    return this.getCompDetails(e, nf, "agMenuItem", t, !0);
  }
  getCompDetails(e, t, i, s, o = !1) {
    const { propertyName: r, cellRenderer: n } = t;
    let { compName: l, jsComp: a, fwComp: d, paramsFromSelector: c, popupFromSelector: h, popupPositionFromSelector: g } = this.getCompKeys(e, t, s);
    const m = (y) => {
      const E = this.userComponentRegistry.retrieve(r, y);
      E && (a = E.componentFromFramework ? void 0 : E.component, d = E.componentFromFramework ? E.component : void 0);
    };
    if (l != null && m(l), a == null && d == null && i != null && m(i), a && n && !this.agComponentUtils.doesImplementIComponent(a) && (a = this.agComponentUtils.adaptFunction(r, a)), !a && !d) {
      o && console.error(`AG Grid: Could not find component ${l}, did you forget to configure this component?`);
      return;
    }
    const C = this.mergeParamsWithApplicationProvidedParams(e, t, s, c), w = a == null, v = a || d;
    return {
      componentFromFramework: w,
      componentClass: v,
      params: C,
      type: t,
      popupFromSelector: h,
      popupPositionFromSelector: g,
      newAgStackInstance: () => this.newAgStackInstance(v, w, C, t)
    };
  }
  getCompKeys(e, t, i) {
    const { propertyName: s } = t;
    let o, r, n, l, a, d;
    if (e) {
      const c = e, h = c[s + "Selector"], g = h ? h(i) : null, m = (C) => {
        typeof C == "string" ? o = C : C != null && C !== !0 && (this.getFrameworkOverrides().isFrameworkComponent(C) ? n = C : r = C);
      };
      g ? (m(g.component), l = g.params, a = g.popup, d = g.popupPosition) : m(c[s]);
    }
    return { compName: o, jsComp: r, fwComp: n, paramsFromSelector: l, popupFromSelector: a, popupPositionFromSelector: d };
  }
  newAgStackInstance(e, t, i, s) {
    const o = s.propertyName, r = !t;
    let n;
    if (r)
      n = new e();
    else {
      const a = this.componentMetadataProvider.retrieve(o);
      n = this.frameworkComponentWrapper.wrap(
        e,
        a.mandatoryMethodList,
        a.optionalMethodList,
        s
      );
    }
    const l = this.initComponent(n, i);
    return l == null ? _e.resolve(n) : l.then(() => n);
  }
  // used by Floating Filter
  mergeParamsWithApplicationProvidedParams(e, t, i, s = null) {
    const o = this.gos.getGridCommonParams();
    ft(o, i);
    const r = e, n = r && r[t.propertyName + "Params"];
    if (typeof n == "function") {
      const l = n(i);
      ft(o, l);
    } else typeof n == "object" && ft(o, n);
    return ft(o, s), o;
  }
  initComponent(e, t) {
    if (this.context.createBean(e), e.init != null)
      return e.init(t);
  }
  getDefaultFloatingFilterType(e, t) {
    if (e == null)
      return null;
    let i = null, { compName: s, jsComp: o, fwComp: r } = this.getCompKeys(e, Hl);
    return s ? i = gh.getFloatingFilterType(s) : o == null && r == null && e.filter === !0 && (i = t()), i;
  }
};
u([
  f("gridOptions")
], Mi.prototype, "gridOptions", 2);
u([
  f("agComponentUtils")
], Mi.prototype, "agComponentUtils", 2);
u([
  f("componentMetadataProvider")
], Mi.prototype, "componentMetadataProvider", 2);
u([
  f("userComponentRegistry")
], Mi.prototype, "userComponentRegistry", 2);
u([
  ue("frameworkComponentWrapper")
], Mi.prototype, "frameworkComponentWrapper", 2);
Mi = u([
  O("userComponentFactory")
], Mi);
var fh = class {
  constructor(e) {
    this.tickingInterval = null, this.onScrollCallback = null, this.scrollContainer = e.scrollContainer, this.scrollHorizontally = e.scrollAxis.indexOf("x") !== -1, this.scrollVertically = e.scrollAxis.indexOf("y") !== -1, this.scrollByTick = e.scrollByTick != null ? e.scrollByTick : 20, e.onScrollCallback && (this.onScrollCallback = e.onScrollCallback), this.scrollVertically && (this.getVerticalPosition = e.getVerticalPosition, this.setVerticalPosition = e.setVerticalPosition), this.scrollHorizontally && (this.getHorizontalPosition = e.getHorizontalPosition, this.setHorizontalPosition = e.setHorizontalPosition), this.shouldSkipVerticalScroll = e.shouldSkipVerticalScroll || (() => !1), this.shouldSkipHorizontalScroll = e.shouldSkipHorizontalScroll || (() => !1);
  }
  check(e, t = !1) {
    const i = t || this.shouldSkipVerticalScroll();
    if (i && this.shouldSkipHorizontalScroll())
      return;
    const s = this.scrollContainer.getBoundingClientRect(), o = this.scrollByTick;
    this.tickLeft = e.clientX < s.left + o, this.tickRight = e.clientX > s.right - o, this.tickUp = e.clientY < s.top + o && !i, this.tickDown = e.clientY > s.bottom - o && !i, this.tickLeft || this.tickRight || this.tickUp || this.tickDown ? this.ensureTickingStarted() : this.ensureCleared();
  }
  ensureTickingStarted() {
    this.tickingInterval === null && (this.tickingInterval = window.setInterval(this.doTick.bind(this), 100), this.tickCount = 0);
  }
  doTick() {
    this.tickCount++;
    let e;
    if (e = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40, this.scrollVertically) {
      const t = this.getVerticalPosition();
      this.tickUp && this.setVerticalPosition(t - e), this.tickDown && this.setVerticalPosition(t + e);
    }
    if (this.scrollHorizontally) {
      const t = this.getHorizontalPosition();
      this.tickLeft && this.setHorizontalPosition(t - e), this.tickRight && this.setHorizontalPosition(t + e);
    }
    this.onScrollCallback && this.onScrollCallback();
  }
  ensureCleared() {
    this.tickingInterval && (window.clearInterval(this.tickingInterval), this.tickingInterval = null);
  }
}, Pt = class extends F {
  constructor(e) {
    super(), this.eContainer = e;
  }
  postConstruct() {
    this.gos.isRowModelType("clientSide") && (this.clientSideRowModel = this.rowModel), this.ctrlsService.whenReady((e) => {
      const t = e.gridBodyCtrl;
      this.autoScrollService = new fh({
        scrollContainer: t.getBodyViewportElement(),
        scrollAxis: "y",
        getVerticalPosition: () => t.getScrollFeature().getVScrollPosition().top,
        setVerticalPosition: (i) => t.getScrollFeature().setVerticalScrollPosition(i),
        onScrollCallback: () => {
          this.onDragging(this.lastDraggingEvent);
        }
      });
    });
  }
  getContainer() {
    return this.eContainer;
  }
  isInterestedIn(e) {
    return e === 2;
  }
  getIconName() {
    return this.gos.get("rowDragManaged") && this.shouldPreventRowMove() ? Y.ICON_NOT_ALLOWED : Y.ICON_MOVE;
  }
  shouldPreventRowMove() {
    return !!(this.columnModel.getRowGroupColumns().length || this.filterManager.isAnyFilterPresent() || this.sortController.isSortActive());
  }
  getRowNodes(e) {
    if (!this.isFromThisGrid(e))
      return e.dragItem.rowNodes || [];
    const t = e.dragItem.rowNode;
    if (this.gos.get("rowDragMultiRow")) {
      const s = [...this.selectionService.getSelectedNodes()].sort(
        (o, r) => o.rowIndex == null || r.rowIndex == null ? 0 : this.getRowIndexNumber(o) - this.getRowIndexNumber(r)
      );
      if (s.indexOf(t) !== -1)
        return s;
    }
    return [t];
  }
  onDragEnter(e) {
    e.dragItem.rowNodes = this.getRowNodes(e), this.dispatchGridEvent(p.EVENT_ROW_DRAG_ENTER, e), this.getRowNodes(e).forEach((t) => {
      t.setDragging(!0);
    }), this.onEnterOrDragging(e);
  }
  onDragging(e) {
    this.onEnterOrDragging(e);
  }
  isFromThisGrid(e) {
    const { dragSourceDomDataKey: t } = e.dragSource;
    return t === this.gos.getDomDataKey();
  }
  isDropZoneWithinThisGrid(e) {
    const i = this.ctrlsService.getGridBodyCtrl().getGui(), { dropZoneTarget: s } = e;
    return !i.contains(s);
  }
  onEnterOrDragging(e) {
    this.dispatchGridEvent(p.EVENT_ROW_DRAG_MOVE, e), this.lastDraggingEvent = e;
    const t = this.mouseEventService.getNormalisedPosition(e).y;
    this.gos.get("rowDragManaged") && this.doManagedDrag(e, t), this.autoScrollService.check(e.event);
  }
  doManagedDrag(e, t) {
    const i = this.isFromThisGrid(e), s = this.gos.get("rowDragManaged"), o = e.dragItem.rowNodes;
    s && this.shouldPreventRowMove() || (this.gos.get("suppressMoveWhenRowDragging") || !i ? this.isDropZoneWithinThisGrid(e) || this.clientSideRowModel.highlightRowAtPixel(o[0], t) : this.moveRows(o, t));
  }
  getRowIndexNumber(e) {
    return parseInt(se(e.getRowIndexString().split("-")), 10);
  }
  moveRowAndClearHighlight(e) {
    const t = this.clientSideRowModel.getLastHighlightedRowNode(), i = t && t.highlighted === 1, s = this.mouseEventService.getNormalisedPosition(e).y, o = e.dragItem.rowNodes;
    let r = i ? 1 : 0;
    if (this.isFromThisGrid(e))
      o.forEach((n) => {
        n.rowTop < s && (r -= 1);
      }), this.moveRows(o, s, r);
    else {
      const n = this.gos.getCallback("getRowId");
      let l = this.clientSideRowModel.getRowIndexAtPixel(s) + 1;
      this.clientSideRowModel.getHighlightPosition(s) === 0 && l--, this.clientSideRowModel.updateRowData({
        add: o.map((a) => a.data).filter(
          (a) => !this.clientSideRowModel.getRowNode(
            n ? n({ data: a, level: 0 }) : a.id
          )
        ),
        addIndex: l
      });
    }
    this.clearRowHighlight();
  }
  clearRowHighlight() {
    this.clientSideRowModel.highlightRowAtPixel(null);
  }
  moveRows(e, t, i = 0) {
    var s;
    this.clientSideRowModel.ensureRowsAtPixel(e, t, i) && (this.focusService.clearFocusedCell(), (s = this.rangeService) == null || s.removeAllCellRanges());
  }
  addRowDropZone(e) {
    if (!e.getContainer()) {
      H("addRowDropZone - A container target needs to be provided");
      return;
    }
    if (this.dragAndDropService.findExternalZone(e)) {
      console.warn("AG Grid: addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.");
      return;
    }
    let t = {
      getContainer: e.getContainer
    };
    e.fromGrid ? t = e : (e.onDragEnter && (t.onDragEnter = (i) => {
      e.onDragEnter(this.draggingToRowDragEvent(p.EVENT_ROW_DRAG_ENTER, i));
    }), e.onDragLeave && (t.onDragLeave = (i) => {
      e.onDragLeave(this.draggingToRowDragEvent(p.EVENT_ROW_DRAG_LEAVE, i));
    }), e.onDragging && (t.onDragging = (i) => {
      e.onDragging(this.draggingToRowDragEvent(p.EVENT_ROW_DRAG_MOVE, i));
    }), e.onDragStop && (t.onDragStop = (i) => {
      e.onDragStop(this.draggingToRowDragEvent(p.EVENT_ROW_DRAG_END, i));
    })), this.dragAndDropService.addDropTarget(_({
      isInterestedIn: (i) => i === 2,
      getIconName: () => Y.ICON_MOVE,
      external: !0
    }, t));
  }
  getRowDropZone(e) {
    const t = this.getContainer.bind(this), i = this.onDragEnter.bind(this), s = this.onDragLeave.bind(this), o = this.onDragging.bind(this), r = this.onDragStop.bind(this);
    return e ? {
      getContainer: t,
      onDragEnter: e.onDragEnter ? (n) => {
        i(n), e.onDragEnter(this.draggingToRowDragEvent(p.EVENT_ROW_DRAG_ENTER, n));
      } : i,
      onDragLeave: e.onDragLeave ? (n) => {
        s(n), e.onDragLeave(this.draggingToRowDragEvent(p.EVENT_ROW_DRAG_LEAVE, n));
      } : s,
      onDragging: e.onDragging ? (n) => {
        o(n), e.onDragging(this.draggingToRowDragEvent(p.EVENT_ROW_DRAG_MOVE, n));
      } : o,
      onDragStop: e.onDragStop ? (n) => {
        r(n), e.onDragStop(this.draggingToRowDragEvent(p.EVENT_ROW_DRAG_END, n));
      } : r,
      fromGrid: !0
      /* @private */
    } : {
      getContainer: t,
      onDragEnter: i,
      onDragLeave: s,
      onDragging: o,
      onDragStop: r,
      /* @private */
      fromGrid: !0
    };
  }
  draggingToRowDragEvent(e, t) {
    const i = this.mouseEventService.getNormalisedPosition(t).y, s = i > this.paginationProxy.getCurrentPageHeight();
    let o = -1, r;
    s || (o = this.rowModel.getRowIndexAtPixel(i), r = this.rowModel.getRow(o));
    let n;
    switch (t.vDirection) {
      case 1:
        n = "down";
        break;
      case 0:
        n = "up";
        break;
      default:
        n = null;
        break;
    }
    return this.gos.addGridCommonParams({
      type: e,
      event: t.event,
      node: t.dragItem.rowNode,
      nodes: t.dragItem.rowNodes,
      overIndex: o,
      overNode: r,
      y: i,
      vDirection: n
    });
  }
  dispatchGridEvent(e, t) {
    const i = this.draggingToRowDragEvent(e, t);
    this.eventService.dispatchEvent(i);
  }
  onDragLeave(e) {
    this.dispatchGridEvent(p.EVENT_ROW_DRAG_LEAVE, e), this.stopDragging(e), this.gos.get("rowDragManaged") && this.clearRowHighlight();
  }
  onDragStop(e) {
    this.dispatchGridEvent(p.EVENT_ROW_DRAG_END, e), this.stopDragging(e), this.gos.get("rowDragManaged") && (this.gos.get("suppressMoveWhenRowDragging") || !this.isFromThisGrid(e)) && !this.isDropZoneWithinThisGrid(e) && this.moveRowAndClearHighlight(e);
  }
  stopDragging(e) {
    this.autoScrollService.ensureCleared(), this.getRowNodes(e).forEach((t) => {
      t.setDragging(!1);
    });
  }
};
u([
  f("dragAndDropService")
], Pt.prototype, "dragAndDropService", 2);
u([
  f("rowModel")
], Pt.prototype, "rowModel", 2);
u([
  f("paginationProxy")
], Pt.prototype, "paginationProxy", 2);
u([
  f("columnModel")
], Pt.prototype, "columnModel", 2);
u([
  f("focusService")
], Pt.prototype, "focusService", 2);
u([
  f("sortController")
], Pt.prototype, "sortController", 2);
u([
  f("filterManager")
], Pt.prototype, "filterManager", 2);
u([
  f("selectionService")
], Pt.prototype, "selectionService", 2);
u([
  f("mouseEventService")
], Pt.prototype, "mouseEventService", 2);
u([
  f("ctrlsService")
], Pt.prototype, "ctrlsService", 2);
u([
  ue("rangeService")
], Pt.prototype, "rangeService", 2);
u([
  L
], Pt.prototype, "postConstruct", 1);
var Yo = class extends F {
  constructor() {
    super(...arguments), this.dragEndFunctions = [], this.dragSources = [];
  }
  removeAllListeners() {
    this.dragSources.forEach(this.removeListener.bind(this)), this.dragSources.length = 0;
  }
  removeListener(e) {
    const t = e.dragSource.eElement, i = e.mouseDownListener;
    if (t.removeEventListener("mousedown", i), e.touchEnabled) {
      const s = e.touchStartListener;
      t.removeEventListener("touchstart", s, { passive: !0 });
    }
  }
  removeDragSource(e) {
    const t = this.dragSources.find((i) => i.dragSource === e);
    t && (this.removeListener(t), gt(this.dragSources, t));
  }
  isDragging() {
    return this.dragging;
  }
  addDragSource(e) {
    const t = this.onMouseDown.bind(this, e), { eElement: i, includeTouch: s, stopPropagationForTouch: o } = e;
    i.addEventListener("mousedown", t);
    let r = null;
    const n = this.gos.get("suppressTouch");
    s && !n && (r = (l) => {
      wa(l.target) || (l.cancelable && (l.preventDefault(), o && l.stopPropagation()), this.onTouchStart(e, l));
    }, i.addEventListener("touchstart", r, { passive: !1 })), this.dragSources.push({
      dragSource: e,
      mouseDownListener: t,
      touchStartListener: r,
      touchEnabled: !!s
    });
  }
  getStartTarget() {
    return this.startTarget;
  }
  // gets called whenever mouse down on any drag source
  onTouchStart(e, t) {
    this.currentDragParams = e, this.dragging = !1;
    const i = t.touches[0];
    this.touchLastTime = i, this.touchStart = i;
    const s = (a) => this.onTouchMove(a, e.eElement), o = (a) => this.onTouchUp(a, e.eElement), r = (a) => {
      a.cancelable && a.preventDefault();
    }, n = t.target, l = [
      // Prevents the page document from moving while we are dragging items around.
      // preventDefault needs to be called in the touchmove listener and never inside the
      // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
      { target: this.gos.getRootNode(), type: "touchmove", listener: r, options: { passive: !1 } },
      { target: n, type: "touchmove", listener: s, options: { passive: !0 } },
      { target: n, type: "touchend", listener: o, options: { passive: !0 } },
      { target: n, type: "touchcancel", listener: o, options: { passive: !0 } }
    ];
    this.addTemporaryEvents(l), e.dragStartPixels === 0 && this.onCommonMove(i, this.touchStart, e.eElement);
  }
  // gets called whenever mouse down on any drag source
  onMouseDown(e, t) {
    const i = t;
    if (e.skipMouseEvent && e.skipMouseEvent(t) || i._alreadyProcessedByDragService || (i._alreadyProcessedByDragService = !0, t.button !== 0))
      return;
    this.shouldPreventMouseEvent(t) && t.preventDefault(), this.currentDragParams = e, this.dragging = !1, this.mouseStartEvent = t, this.startTarget = t.target;
    const s = (a) => this.onMouseMove(a, e.eElement), o = (a) => this.onMouseUp(a, e.eElement), r = (a) => a.preventDefault(), n = this.gos.getRootNode(), l = [
      { target: n, type: "mousemove", listener: s },
      { target: n, type: "mouseup", listener: o },
      { target: n, type: "contextmenu", listener: r }
    ];
    this.addTemporaryEvents(l), e.dragStartPixels === 0 && this.onMouseMove(t, e.eElement);
  }
  addTemporaryEvents(e) {
    e.forEach((t) => {
      const { target: i, type: s, listener: o, options: r } = t;
      i.addEventListener(s, o, r);
    }), this.dragEndFunctions.push(() => {
      e.forEach((t) => {
        const { target: i, type: s, listener: o, options: r } = t;
        i.removeEventListener(s, o, r);
      });
    });
  }
  // returns true if the event is close to the original event by X pixels either vertically or horizontally.
  // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
  isEventNearStartEvent(e, t) {
    const { dragStartPixels: i } = this.currentDragParams, s = b(i) ? i : 4;
    return Pa(e, t, s);
  }
  getFirstActiveTouch(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].identifier === this.touchStart.identifier)
        return e[t];
    return null;
  }
  onCommonMove(e, t, i) {
    if (!this.dragging) {
      if (!this.dragging && this.isEventNearStartEvent(e, t))
        return;
      this.dragging = !0;
      const s = {
        type: p.EVENT_DRAG_STARTED,
        target: i
      };
      this.eventService.dispatchEvent(s), this.currentDragParams.onDragStart(t), this.currentDragParams.onDragging(t);
    }
    this.currentDragParams.onDragging(e);
  }
  onTouchMove(e, t) {
    const i = this.getFirstActiveTouch(e.touches);
    i && this.onCommonMove(i, this.touchStart, t);
  }
  // only gets called after a mouse down - as this is only added after mouseDown
  // and is removed when mouseUp happens
  onMouseMove(e, t) {
    var i;
    ri() && ((i = this.gos.getDocument().getSelection()) == null || i.removeAllRanges()), this.shouldPreventMouseEvent(e) && e.preventDefault(), this.onCommonMove(e, this.mouseStartEvent, t);
  }
  shouldPreventMouseEvent(e) {
    const t = this.gos.get("enableCellTextSelection"), i = e.type === "mousemove";
    return (
      // when `isEnableCellTextSelect` is `true`, we need to preventDefault on mouseMove
      // to avoid the grid text being selected while dragging components.
      t && i && e.cancelable && this.mouseEventService.isEventFromThisGrid(e) && !this.isOverFormFieldElement(e)
    );
  }
  isOverFormFieldElement(e) {
    const t = e.target, i = t == null ? void 0 : t.tagName.toLocaleLowerCase();
    return !!(i != null && i.match("^a$|textarea|input|select|button"));
  }
  onTouchUp(e, t) {
    let i = this.getFirstActiveTouch(e.changedTouches);
    i || (i = this.touchLastTime), this.onUpCommon(i, t);
  }
  onMouseUp(e, t) {
    this.onUpCommon(e, t);
  }
  onUpCommon(e, t) {
    if (this.dragging) {
      this.dragging = !1, this.currentDragParams.onDragStop(e);
      const i = {
        type: p.EVENT_DRAG_STOPPED,
        target: t
      };
      this.eventService.dispatchEvent(i);
    }
    this.mouseStartEvent = null, this.startTarget = null, this.touchStart = null, this.touchLastTime = null, this.currentDragParams = null, this.dragEndFunctions.forEach((i) => i()), this.dragEndFunctions.length = 0;
  }
};
u([
  f("mouseEventService")
], Yo.prototype, "mouseEventService", 2);
u([
  dt
], Yo.prototype, "removeAllListeners", 1);
Yo = u([
  O("dragService")
], Yo);
var ul = "ag-list-item-hovered", mh = class extends F {
  constructor(e, t, i) {
    super(), this.comp = e, this.virtualList = t, this.params = i, this.currentDragValue = null, this.lastHoveredListItem = null;
  }
  postConstruct() {
    this.addManagedListener(this.params.eventSource, this.params.listItemDragStartEvent, this.listItemDragStart.bind(this)), this.addManagedListener(this.params.eventSource, this.params.listItemDragEndEvent, this.listItemDragEnd.bind(this)), this.createDropTarget(), this.createAutoScrollService();
  }
  listItemDragStart(e) {
    this.currentDragValue = this.params.getCurrentDragValue(e), this.moveBlocked = this.params.isMoveBlocked(this.currentDragValue);
  }
  listItemDragEnd() {
    window.setTimeout(() => {
      this.currentDragValue = null, this.moveBlocked = !1;
    }, 10);
  }
  createDropTarget() {
    const e = {
      isInterestedIn: (t) => t === this.params.dragSourceType,
      getIconName: () => this.moveBlocked ? Y.ICON_PINNED : Y.ICON_MOVE,
      getContainer: () => this.comp.getGui(),
      onDragging: (t) => this.onDragging(t),
      onDragStop: () => this.onDragStop(),
      onDragLeave: () => this.onDragLeave()
    };
    this.dragAndDropService.addDropTarget(e);
  }
  createAutoScrollService() {
    const e = this.virtualList.getGui();
    this.autoScrollService = new fh({
      scrollContainer: e,
      scrollAxis: "y",
      getVerticalPosition: () => e.scrollTop,
      setVerticalPosition: (t) => e.scrollTop = t
    });
  }
  onDragging(e) {
    if (!this.currentDragValue || this.moveBlocked)
      return;
    const t = this.getListDragItem(e), i = this.virtualList.getComponentAt(t.rowIndex);
    if (!i)
      return;
    const s = i.getGui().parentElement;
    this.lastHoveredListItem && this.lastHoveredListItem.rowIndex === t.rowIndex && this.lastHoveredListItem.position === t.position || (this.autoScrollService.check(e.event), this.clearHoveredItems(), this.lastHoveredListItem = t, Gl(s, ul), Gl(s, `ag-item-highlight-${t.position}`));
  }
  getListDragItem(e) {
    const t = this.virtualList.getGui(), i = parseFloat(window.getComputedStyle(t).paddingTop), s = this.virtualList.getRowHeight(), o = this.virtualList.getScrollTop(), r = Math.max(0, (e.y - i + o) / s), n = this.params.getNumRows(this.comp) - 1, l = Math.min(n, r) | 0;
    return {
      rowIndex: l,
      position: Math.round(r) > r || r > n ? "bottom" : "top",
      component: this.virtualList.getComponentAt(l)
    };
  }
  onDragStop() {
    this.moveBlocked || (this.params.moveItem(this.currentDragValue, this.lastHoveredListItem), this.clearHoveredItems(), this.autoScrollService.ensureCleared());
  }
  onDragLeave() {
    this.clearHoveredItems(), this.autoScrollService.ensureCleared();
  }
  clearHoveredItems() {
    this.virtualList.getGui().querySelectorAll(`.${ul}`).forEach((t) => {
      [
        ul,
        "ag-item-highlight-top",
        "ag-item-highlight-bottom"
      ].forEach((i) => {
        t.classList.remove(i);
      });
    }), this.lastHoveredListItem = null;
  }
};
u([
  f("dragAndDropService")
], mh.prototype, "dragAndDropService", 2);
u([
  L
], mh.prototype, "postConstruct", 1);
function ts(e) {
  const t = e;
  return t != null && t.getFrameworkComponentInstance != null ? t.getFrameworkComponentInstance() : e;
}
var J = class {
  constructor() {
    this.detailGridInfoMap = {}, this.destroyCalled = !1;
  }
  init() {
    switch (this.rowModel.getType()) {
      case "clientSide":
        this.clientSideRowModel = this.rowModel;
        break;
      case "infinite":
        this.infiniteRowModel = this.rowModel;
        break;
      case "serverSide":
        this.serverSideRowModel = this.rowModel;
        break;
    }
    this.ctrlsService.whenReady((e) => {
      this.gridBodyCtrl = e.gridBodyCtrl;
    });
  }
  /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */
  __getAlignedGridService() {
    return this.alignedGridsService;
  }
  /** Returns the `gridId` for the current grid as specified via the gridOptions property `gridId` or the auto assigned grid id if none was provided. */
  getGridId() {
    return this.context.getGridId();
  }
  /** Register a detail grid with the master grid when it is created. */
  addDetailGridInfo(e, t) {
    this.detailGridInfoMap[e] = t;
  }
  /** Unregister a detail grid from the master grid when it is destroyed. */
  removeDetailGridInfo(e) {
    delete this.detailGridInfoMap[e];
  }
  /** Returns the `DetailGridInfo` corresponding to the supplied `detailGridId`. */
  getDetailGridInfo(e) {
    return this.detailGridInfoMap[e];
  }
  /** Iterates through each `DetailGridInfo` in the grid and calls the supplied callback on each. */
  forEachDetailGridInfo(e) {
    let t = 0;
    tt(this.detailGridInfoMap, (i, s) => {
      b(s) && (e(s, t), t++);
    });
  }
  /** Similar to `exportDataAsCsv`, except returns the result as a string rather than download it. */
  getDataAsCsv(e) {
    if (le.__assertRegistered("@ag-grid-community/csv-export", "api.getDataAsCsv", this.context.getGridId()))
      return this.csvCreator.getDataAsCsv(e);
  }
  /** Downloads a CSV export of the grid's data. */
  exportDataAsCsv(e) {
    le.__assertRegistered("@ag-grid-community/csv-export", "api.exportDataAsCsv", this.context.getGridId()) && this.csvCreator.exportDataAsCsv(e);
  }
  assertNotExcelMultiSheet(e, t) {
    return le.__assertRegistered("@ag-grid-enterprise/excel-export", "api." + e, this.context.getGridId()) ? this.excelCreator.getFactoryMode() === 1 ? (console.warn("AG Grid: The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'"), !1) : !0 : !1;
  }
  /** Similar to `exportDataAsExcel`, except instead of downloading a file, it will return a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) to be processed by the user. */
  getDataAsExcel(e) {
    if (this.assertNotExcelMultiSheet("getDataAsExcel", e))
      return this.excelCreator.getDataAsExcel(e);
  }
  /** Downloads an Excel export of the grid's data. */
  exportDataAsExcel(e) {
    this.assertNotExcelMultiSheet("exportDataAsExcel", e) && this.excelCreator.exportDataAsExcel(e);
  }
  /** This is method to be used to get the grid's data as a sheet, that will later be exported either by `getMultipleSheetsAsExcel()` or `exportMultipleSheetsAsExcel()`. */
  getSheetDataForExcel(e) {
    if (le.__assertRegistered("@ag-grid-enterprise/excel-export", "api.getSheetDataForExcel", this.context.getGridId()))
      return this.excelCreator.setFactoryMode(
        1
        /* MULTI_SHEET */
      ), this.excelCreator.getSheetDataForExcel(e);
  }
  /** Similar to `exportMultipleSheetsAsExcel`, except instead of downloading a file, it will return a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) to be processed by the user. */
  getMultipleSheetsAsExcel(e) {
    if (le.__assertRegistered("@ag-grid-enterprise/excel-export", "api.getMultipleSheetsAsExcel", this.context.getGridId()))
      return this.excelCreator.getMultipleSheetsAsExcel(e);
  }
  /** Downloads an Excel export of multiple sheets in one file. */
  exportMultipleSheetsAsExcel(e) {
    le.__assertRegistered("@ag-grid-enterprise/excel-export", "api.exportMultipleSheetsAsExcel", this.context.getGridId()) && this.excelCreator.exportMultipleSheetsAsExcel(e);
  }
  /**
   * Sets an ARIA property in the grid panel (element with `role=\"grid\"`), and removes an ARIA property when the value is null.
   *
   * Example: `api.setGridAriaProperty('label', 'my grid')` will set `aria-label=\"my grid\"`.
   *
   * `api.setGridAriaProperty('label', null)` will remove the `aria-label` attribute from the grid element.
   */
  setGridAriaProperty(e, t) {
    if (!e)
      return;
    const i = this.ctrlsService.getGridBodyCtrl().getGui(), s = `aria-${e}`;
    t === null ? i.removeAttribute(s) : i.setAttribute(s, t);
  }
  logMissingRowModel(e, ...t) {
    console.error(`AG Grid: api.${e} can only be called when gridOptions.rowModelType is ${t.join(" or ")}`);
  }
  logDeprecation(e, t, i, s) {
    H(`Since ${e} api.${t} is deprecated. Please use ${i} instead. ${s ?? ""}`);
  }
  /** Gets the number of top pinned rows. */
  getPinnedTopRowCount() {
    return this.pinnedRowModel.getPinnedTopRowCount();
  }
  /** Gets the number of bottom pinned rows. */
  getPinnedBottomRowCount() {
    return this.pinnedRowModel.getPinnedBottomRowCount();
  }
  /** Gets the top pinned row with the specified index. */
  getPinnedTopRow(e) {
    return this.pinnedRowModel.getPinnedTopRow(e);
  }
  /** Gets the bottom pinned row with the specified index. */
  getPinnedBottomRow(e) {
    return this.pinnedRowModel.getPinnedBottomRow(e);
  }
  expireValueCache() {
    this.valueCache.expire();
  }
  /**
   * Returns an object with two properties:
   *  - `top`: The top pixel position of the current scroll in the grid
   *  - `bottom`: The bottom pixel position of the current scroll in the grid
   */
  getVerticalPixelRange() {
    return this.gridBodyCtrl.getScrollFeature().getVScrollPosition();
  }
  /**
   * Returns an object with two properties:
   * - `left`: The left pixel position of the current scroll in the grid
   * - `right`: The right pixel position of the current scroll in the grid
   */
  getHorizontalPixelRange() {
    return this.gridBodyCtrl.getScrollFeature().getHScrollPosition();
  }
  /** Performs change detection on all cells, refreshing cells where required. */
  refreshCells(e = {}) {
    this.frameworkOverrides.wrapIncoming(() => this.rowRenderer.refreshCells(e));
  }
  /** Flash rows, columns or individual cells. */
  flashCells(e = {}) {
    const t = (i) => H(`Since v31.1 api.flashCells parameter '${i}Delay' is deprecated. Please use '${i}Duration' instead.`);
    b(e.fadeDelay) && t("fade"), b(e.flashDelay) && t("flash"), this.frameworkOverrides.wrapIncoming(() => this.rowRenderer.flashCells(e));
  }
  /** Remove row(s) from the DOM and recreate them again from scratch. */
  redrawRows(e = {}) {
    const t = e ? e.rowNodes : void 0;
    this.frameworkOverrides.wrapIncoming(() => this.rowRenderer.redrawRows(t));
  }
  /** Redraws the header. Useful if a column name changes, or something else that changes how the column header is displayed. */
  refreshHeader() {
    this.frameworkOverrides.wrapIncoming(() => this.ctrlsService.getHeaderRowContainerCtrls().forEach((e) => e.refresh()));
  }
  /** Returns `true` if any filter is set. This includes quick filter, column filter, external filter or advanced filter. */
  isAnyFilterPresent() {
    return this.filterManager.isAnyFilterPresent();
  }
  /** Returns `true` if any column filter is set, otherwise `false`. */
  isColumnFilterPresent() {
    return this.filterManager.isColumnFilterPresent() || this.filterManager.isAggregateFilterPresent();
  }
  /** Returns `true` if the Quick Filter is set, otherwise `false`. */
  isQuickFilterPresent() {
    return this.filterManager.isQuickFilterPresent();
  }
  /**
   * Returns the row model inside the table.
   * From here you can see the original rows, rows after filter has been applied,
   * rows after aggregation has been applied, and the final set of 'to be displayed' rows.
   *
   * @deprecated As of v31.1, getModel() is deprecated and will not be available in future versions.
   * Please use the appropriate grid API methods instead
   */
  getModel() {
    return H("Since v31.1 getModel() is deprecated. Please use the appropriate grid API methods instead."), this.rowModel;
  }
  /** 
   * Expand or collapse a specific row node, optionally expanding/collapsing all of its parent nodes.
   * By default rows are expanded asynchronously for best performance. Set forceSync: `true` if you need to interact with the expanded row immediately after this function.
   */
  setRowNodeExpanded(e, t, i, s) {
    this.expansionService.setRowNodeExpanded(e, t, i, s);
  }
  /**
   * Informs the grid that row group expanded state has changed and it needs to rerender the group nodes.
   * Typically called after updating the row node expanded state explicitly, i.e `rowNode.expanded = false`,
   * across multiple groups and you want to update the grid view in a single rerender instead of on every group change.
   */
  onGroupExpandedOrCollapsed() {
    if (z(this.clientSideRowModel)) {
      this.logMissingRowModel("onGroupExpandedOrCollapsed", "clientSide");
      return;
    }
    this.expansionService.onGroupExpandedOrCollapsed();
  }
  /**
   * Refresh the Client-Side Row Model, executing the grouping, filtering and sorting again.
   * Optionally provide the step you wish the refresh to apply from. Defaults to `everything`.
   */
  refreshClientSideRowModel(e) {
    if (z(this.clientSideRowModel)) {
      this.logMissingRowModel("refreshClientSideRowModel", "clientSide");
      return;
    }
    this.clientSideRowModel.refreshModel(e);
  }
  /** Returns `true` when there are no more animation frames left to process. */
  isAnimationFrameQueueEmpty() {
    return this.animationFrameService.isQueueEmpty();
  }
  flushAllAnimationFrames() {
    this.animationFrameService.flushAllFrames();
  }
  /**
   * Returns the row node with the given ID.
   * The row node ID is the one you provide from the callback `getRowId(params)`,
   * otherwise the ID is a number (cast as string) auto-generated by the grid when
   * the row data is set.
   */
  getRowNode(e) {
    return this.rowModel.getRowNode(e);
  }
  /**
   * Gets the sizes that various UI elements will be rendered at with the current theme.
   * If you override the row or header height using `gridOptions`, the override value you provided will be returned.
   */
  getSizesForCurrentTheme() {
    return {
      rowHeight: this.gos.getRowHeightAsNumber(),
      headerHeight: this.columnModel.getHeaderHeight()
    };
  }
  /** Expand all groups. */
  expandAll() {
    this.clientSideRowModel || this.serverSideRowModel ? this.expansionService.expandAll(!0) : this.logMissingRowModel("expandAll", "clientSide", "serverSide");
  }
  /** Collapse all groups. */
  collapseAll() {
    this.clientSideRowModel || this.serverSideRowModel ? this.expansionService.expandAll(!1) : this.logMissingRowModel("collapseAll", "clientSide", "serverSide");
  }
  /**
   * Registers a callback to a virtual row.
   * A virtual row is a row that is visually rendered on the screen (rows that are not visible because of the scroll position are not rendered).
   * Unlike normal events, you do not need to unregister rendered row listeners.
   * When the rendered row is removed from the grid, all associated rendered row listeners will also be removed.
   * listen for this event if your `cellRenderer` needs to do cleanup when the row no longer exists.
   */
  addRenderedRowListener(e, t, i) {
    this.rowRenderer.addRenderedRowListener(e, t, i);
  }
  /** Get the current Quick Filter text from the grid, or `undefined` if none is set. */
  getQuickFilter() {
    return this.gos.get("quickFilterText");
  }
  /** Get the state of the Advanced Filter. Used for saving Advanced Filter state */
  getAdvancedFilterModel() {
    return le.__assertRegistered("@ag-grid-enterprise/advanced-filter", "api.getAdvancedFilterModel", this.context.getGridId()) ? this.filterManager.getAdvancedFilterModel() : null;
  }
  /** Set the state of the Advanced Filter. Used for restoring Advanced Filter state */
  setAdvancedFilterModel(e) {
    this.filterManager.setAdvancedFilterModel(e);
  }
  /** Open the Advanced Filter Builder dialog (if enabled). */
  showAdvancedFilterBuilder() {
    le.__assertRegistered("@ag-grid-enterprise/advanced-filter", "api.setAdvancedFilterModel", this.context.getGridId()) && this.filterManager.showAdvancedFilterBuilder("api");
  }
  /**
   * Set all of the provided nodes selection state to the provided value.
   */
  setNodesSelected(e) {
    if (!e.nodes.every((n) => n.rowPinned ? (console.warn("AG Grid: cannot select pinned rows"), !1) : n.id === void 0 ? (console.warn("AG Grid: cannot select node until id for node is known"), !1) : !0))
      return;
    const { nodes: i, source: s, newValue: o } = e, r = i;
    this.selectionService.setNodesSelected({ nodes: r, source: s ?? "api", newValue: o });
  }
  /**
   * Select all rows, regardless of filtering and rows that are not visible due to grouping being enabled and their groups not expanded.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAll'`
   */
  selectAll(e = "apiSelectAll") {
    this.selectionService.selectAllRowNodes({ source: e });
  }
  /**
   * Clear all row selections, regardless of filtering.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAll'`
   */
  deselectAll(e = "apiSelectAll") {
    this.selectionService.deselectAllRowNodes({ source: e });
  }
  /**
   * Select all filtered rows.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllFiltered'`
   */
  selectAllFiltered(e = "apiSelectAllFiltered") {
    this.selectionService.selectAllRowNodes({ source: e, justFiltered: !0 });
  }
  /**
   * Clear all filtered selections.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllFiltered'`
   */
  deselectAllFiltered(e = "apiSelectAllFiltered") {
    this.selectionService.deselectAllRowNodes({ source: e, justFiltered: !0 });
  }
  /**
   * Returns an object containing rules matching the selected rows in the SSRM.
   * 
   * If `groupSelectsChildren=false` the returned object will be flat, and will conform to IServerSideSelectionState.
   * If `groupSelectsChildren=true` the returned object will be hierarchical, and will conform to IServerSideGroupSelectionState.
   */
  getServerSideSelectionState() {
    return z(this.serverSideRowModel) ? (this.logMissingRowModel("getServerSideSelectionState", "serverSide"), null) : this.selectionService.getSelectionState();
  }
  /**
   * Set the rules matching the selected rows in the SSRM.
   * 
   * If `groupSelectsChildren=false` the param will be flat, and should conform to IServerSideSelectionState.
   * If `groupSelectsChildren=true` the param will be hierarchical, and should conform to IServerSideGroupSelectionState.
   */
  setServerSideSelectionState(e) {
    if (z(this.serverSideRowModel)) {
      this.logMissingRowModel("setServerSideSelectionState", "serverSide");
      return;
    }
    this.selectionService.setSelectionState(e, "api");
  }
  /**
   * Select all rows on the current page.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllCurrentPage'`
   */
  selectAllOnCurrentPage(e = "apiSelectAllCurrentPage") {
    this.selectionService.selectAllRowNodes({ source: e, justCurrentPage: !0 });
  }
  /**
   * Clear all filtered on the current page.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllCurrentPage'`
   */
  deselectAllOnCurrentPage(e = "apiSelectAllCurrentPage") {
    this.selectionService.deselectAllRowNodes({ source: e, justCurrentPage: !0 });
  }
  /** Show the 'loading' overlay. */
  showLoadingOverlay() {
    this.overlayService.showLoadingOverlay();
  }
  /** Show the 'no rows' overlay. */
  showNoRowsOverlay() {
    this.overlayService.showNoRowsOverlay();
  }
  /** Hides the overlay if showing. */
  hideOverlay() {
    this.overlayService.hideOverlay();
  }
  /**
   * Returns an unsorted list of selected nodes.
   * Getting the underlying node (rather than the data) is useful when working with tree / aggregated data,
   * as the node can be traversed.
   */
  getSelectedNodes() {
    return this.selectionService.getSelectedNodes();
  }
  /** Returns an unsorted list of selected rows (i.e. row data that you provided). */
  getSelectedRows() {
    return this.selectionService.getSelectedRows();
  }
  /**
   * Returns a list of all selected nodes at 'best cost', a feature to be used with groups / trees.
   * If a group has all its children selected, then the group appears in the result, but not the children.
   * Designed for use with `'children'` as the group selection type, where groups don't actually appear in the selection normally.
   */
  getBestCostNodeSelection() {
    if (z(this.clientSideRowModel)) {
      this.logMissingRowModel("getBestCostNodeSelection", "clientSide");
      return;
    }
    return this.selectionService.getBestCostNodeSelection();
  }
  /** Retrieve rendered nodes. Due to virtualisation this will contain only the current visible rows and those in the buffer. */
  getRenderedNodes() {
    return this.rowRenderer.getRenderedNodes();
  }
  /**
   *  Ensures the column is visible by scrolling the table if needed.
   *
   * This will have no effect before the firstDataRendered event has fired.
   *
   * @param key - The column to ensure visible
   * @param position - Where the column will be positioned.
   * - `auto` - Scrolls the minimum amount to make sure the column is visible.
   * - `start` - Scrolls the column to the start of the viewport.
   * - `middle` - Scrolls the column to the middle of the viewport.
   * - `end` - Scrolls the column to the end of the viewport.
  */
  ensureColumnVisible(e, t = "auto") {
    this.frameworkOverrides.wrapIncoming(() => this.gridBodyCtrl.getScrollFeature().ensureColumnVisible(e, t), "ensureVisible");
  }
  /**
   * Vertically scrolls the grid until the provided row index is inside the visible viewport.
   * If a position is provided, the grid will attempt to scroll until the row is at the given position within the viewport.
   * This will have no effect before the firstDataRendered event has fired.
   */
  ensureIndexVisible(e, t) {
    this.frameworkOverrides.wrapIncoming(() => this.gridBodyCtrl.getScrollFeature().ensureIndexVisible(e, t), "ensureVisible");
  }
  /**
   * Vertically scrolls the grid until the provided row (or a row matching the provided comparator) is inside the visible viewport.
   * If a position is provided, the grid will attempt to scroll until the row is at the given position within the viewport.
   * This will have no effect before the firstDataRendered event has fired.
   */
  ensureNodeVisible(e, t = null) {
    this.frameworkOverrides.wrapIncoming(() => this.gridBodyCtrl.getScrollFeature().ensureNodeVisible(e, t), "ensureVisible");
  }
  /**
   * Similar to `forEachNode`, except lists all the leaf nodes.
   * This effectively goes through all the data that you provided to the grid before the grid performed any grouping.
   * If using tree data, goes through all the nodes for the data you provided, including nodes that have children,
   * but excluding groups the grid created where gaps were missing in the hierarchy.
   */
  forEachLeafNode(e) {
    if (z(this.clientSideRowModel)) {
      this.logMissingRowModel("forEachLeafNode", "clientSide");
      return;
    }
    this.clientSideRowModel.forEachLeafNode(e);
  }
  /**
   * Iterates through each node (row) in the grid and calls the callback for each node.
   * This works similar to the `forEach` method on a JavaScript array.
   * This is called for every node, ignoring any filtering or sorting applied within the grid.
   * If using the Infinite Row Model, then this gets called for each page loaded in the page cache.
   */
  forEachNode(e, t) {
    this.rowModel.forEachNode(e, t);
  }
  /** Similar to `forEachNode`, except skips any filtered out data. */
  forEachNodeAfterFilter(e) {
    if (z(this.clientSideRowModel)) {
      this.logMissingRowModel("forEachNodeAfterFilter", "clientSide");
      return;
    }
    this.clientSideRowModel.forEachNodeAfterFilter(e);
  }
  /** Similar to `forEachNodeAfterFilter`, except the callbacks are called in the order the rows are displayed in the grid. */
  forEachNodeAfterFilterAndSort(e) {
    if (z(this.clientSideRowModel)) {
      this.logMissingRowModel("forEachNodeAfterFilterAndSort", "clientSide");
      return;
    }
    this.clientSideRowModel.forEachNodeAfterFilterAndSort(e);
  }
  /**
   * @deprecated v31.1 To get/set individual filter models, use `getColumnFilterModel` or `setColumnFilterModel` instead.
   * To get hold of the filter instance, use `getColumnFilterInstance` which returns the instance asynchronously.
   */
  getFilterInstance(e, t) {
    return H("'getFilterInstance' is deprecated. To get/set individual filter models, use 'getColumnFilterModel' or 'setColumnFilterModel' instead. To get hold of the filter instance, use 'getColumnFilterInstance' which returns the instance asynchronously."), this.filterManager.getFilterInstance(e, t);
  }
  /**
   * Returns the filter component instance for a column.
   * For getting/setting models for individual column filters, use `getColumnFilterModel` and `setColumnFilterModel` instead of this.
   * `key` can be a column ID or a `Column` object.
   */
  getColumnFilterInstance(e) {
    return this.filterManager.getColumnFilterInstance(e);
  }
  /** Destroys a filter. Useful to force a particular filter to be created from scratch again. */
  destroyFilter(e) {
    const t = this.columnModel.getPrimaryColumn(e);
    if (t)
      return this.filterManager.destroyFilter(t, "api");
  }
  /** Gets the status panel instance corresponding to the supplied `id`. */
  getStatusPanel(e) {
    if (!le.__assertRegistered("@ag-grid-enterprise/status-bar", "api.getStatusPanel", this.context.getGridId()))
      return;
    const t = this.statusBarService.getStatusPanel(e);
    return ts(t);
  }
  getColumnDef(e) {
    const t = this.columnModel.getPrimaryColumn(e);
    return t ? t.getColDef() : null;
  }
  /**
   * Returns the current column definitions.
  */
  getColumnDefs() {
    return this.columnModel.getColumnDefs();
  }
  /**
   * Informs the grid that a filter has changed. This is typically called after a filter change through one of the filter APIs.
   * @param source The source of the filter change event. If not specified defaults to `'api'`.
   */
  onFilterChanged(e = "api") {
    this.filterManager.onFilterChanged({ source: e });
  }
  /**
   * Gets the grid to act as if the sort was changed.
   * Useful if you update some values and want to get the grid to reorder them according to the new values.
   */
  onSortChanged() {
    this.sortController.onSortChanged("api");
  }
  /**
   * Sets the state of all the column filters. Provide it with what you get from `getFilterModel()` to restore filter state.
   * If inferring cell data types, and row data is provided asynchronously and is yet to be set,
   * the filter model will be applied asynchronously after row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition,
   * or provide cell data types for every column.
   */
  setFilterModel(e) {
    this.frameworkOverrides.wrapIncoming(() => this.filterManager.setFilterModel(e));
  }
  /** Gets the current state of all the column filters. Used for saving filter state. */
  getFilterModel() {
    return this.filterManager.getFilterModel();
  }
  /**
   * Gets the current filter model for the specified column.
   * Will return `null` if no active filter.
   */
  getColumnFilterModel(e) {
    return this.filterManager.getColumnFilterModel(e);
  }
  /**
   * Sets the filter model for the specified column.
   * Setting a `model` of `null` will reset the filter (make inactive).
   * Must wait on the response before calling `api.onFilterChanged()`.
   */
  setColumnFilterModel(e, t) {
    return this.filterManager.setColumnFilterModel(e, t);
  }
  /** Returns the focused cell (or the last focused cell if the grid lost focus). */
  getFocusedCell() {
    return this.focusService.getFocusedCell();
  }
  /** Clears the focused cell. */
  clearFocusedCell() {
    return this.focusService.clearFocusedCell();
  }
  /** Sets the focus to the specified cell. `rowPinned` can be either 'top', 'bottom' or null (for not pinned). */
  setFocusedCell(e, t, i) {
    this.focusService.setFocusedCell({ rowIndex: e, column: t, rowPinned: i, forceBrowserFocus: !0 });
  }
  /** Adds a drop zone outside of the grid where rows can be dropped. */
  addRowDropZone(e) {
    this.gridBodyCtrl.getRowDragFeature().addRowDropZone(e);
  }
  /** Removes an external drop zone added by `addRowDropZone`. */
  removeRowDropZone(e) {
    const t = this.dragAndDropService.findExternalZone(e);
    t && this.dragAndDropService.removeDropTarget(t);
  }
  /** Returns the `RowDropZoneParams` to be used by another grid's `addRowDropZone` method. */
  getRowDropZoneParams(e) {
    return this.gridBodyCtrl.getRowDragFeature().getRowDropZone(e);
  }
  assertSideBarLoaded(e) {
    return le.__assertRegistered("@ag-grid-enterprise/side-bar", "api." + e, this.context.getGridId());
  }
  /** Returns `true` if the side bar is visible. */
  isSideBarVisible() {
    return this.assertSideBarLoaded("isSideBarVisible") && this.sideBarService.getSideBarComp().isDisplayed();
  }
  /** Show/hide the entire side bar, including any visible panel and the tab buttons. */
  setSideBarVisible(e) {
    this.assertSideBarLoaded("setSideBarVisible") && this.sideBarService.getSideBarComp().setDisplayed(e);
  }
  /** Sets the side bar position relative to the grid. Possible values are `'left'` or `'right'`. */
  setSideBarPosition(e) {
    this.assertSideBarLoaded("setSideBarPosition") && this.sideBarService.getSideBarComp().setSideBarPosition(e);
  }
  /** Opens a particular tool panel. Provide the ID of the tool panel to open. */
  openToolPanel(e) {
    this.assertSideBarLoaded("openToolPanel") && this.sideBarService.getSideBarComp().openToolPanel(e, "api");
  }
  /** Closes the currently open tool panel (if any). */
  closeToolPanel() {
    this.assertSideBarLoaded("closeToolPanel") && this.sideBarService.getSideBarComp().close("api");
  }
  /** Returns the ID of the currently shown tool panel if any, otherwise `null`. */
  getOpenedToolPanel() {
    return this.assertSideBarLoaded("getOpenedToolPanel") ? this.sideBarService.getSideBarComp().openedItem() : null;
  }
  /** Force refresh all tool panels by calling their `refresh` method. */
  refreshToolPanel() {
    this.assertSideBarLoaded("refreshToolPanel") && this.sideBarService.getSideBarComp().refresh();
  }
  /** Returns `true` if the tool panel is showing, otherwise `false`. */
  isToolPanelShowing() {
    return this.assertSideBarLoaded("isToolPanelShowing") && this.sideBarService.getSideBarComp().isToolPanelShowing();
  }
  /** Gets the tool panel instance corresponding to the supplied `id`. */
  getToolPanelInstance(e) {
    if (this.assertSideBarLoaded("getToolPanelInstance")) {
      const t = this.sideBarService.getSideBarComp().getToolPanelInstance(e);
      return ts(t);
    }
  }
  /** Returns the current side bar configuration. If a shortcut was used, returns the detailed long form. */
  getSideBar() {
    if (this.assertSideBarLoaded("getSideBar"))
      return this.sideBarService.getSideBarComp().getDef();
  }
  /** Tells the grid to recalculate the row heights. */
  resetRowHeights() {
    if (b(this.clientSideRowModel)) {
      if (this.columnModel.isAutoRowHeightActive()) {
        console.warn("AG Grid: calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.");
        return;
      }
      this.clientSideRowModel.resetRowHeights();
    }
  }
  /**
   * Sets the `rowCount` and `maxRowFound` properties.
   * The second parameter, `maxRowFound`, is optional and if left out, only `rowCount` is set.
   * Set `rowCount` to adjust the height of the vertical scroll.
   * Set `maxRowFound` to enable / disable searching for more rows.
   * Use this method if you add or remove rows into the dataset and need to reset the number of rows or instruct the grid that the entire row count is no longer known.
   */
  setRowCount(e, t) {
    if (this.serverSideRowModel) {
      if (this.columnModel.isRowGroupEmpty()) {
        this.serverSideRowModel.setRowCount(e, t);
        return;
      }
      console.error("AG Grid: setRowCount cannot be used while using row grouping.");
      return;
    }
    if (this.infiniteRowModel) {
      this.infiniteRowModel.setRowCount(e, t);
      return;
    }
    this.logMissingRowModel("setRowCount", "infinite", "serverSide");
  }
  /** Tells the grid a row height has changed. To be used after calling `rowNode.setRowHeight(newHeight)`. */
  onRowHeightChanged() {
    this.clientSideRowModel ? this.clientSideRowModel.onRowHeightChanged() : this.serverSideRowModel && this.serverSideRowModel.onRowHeightChanged();
  }
  /**
   * @deprecated v31.3 Use `getCellValue` instead.
   */
  getValue(e, t) {
    return this.logDeprecation("31.3", "getValue", "getCellValue"), this.getCellValue({ colKey: e, rowNode: t });
  }
  getCellValue(e) {
    var t;
    const { colKey: i, rowNode: s, useFormatter: o } = e;
    let r = (t = this.columnModel.getPrimaryColumn(i)) != null ? t : this.columnModel.getGridColumn(i);
    if (z(r))
      return null;
    const n = this.valueService.getValue(r, s);
    if (o) {
      const l = this.valueService.formatValue(r, s, n);
      return l ?? Oe(n, !0);
    }
    return n;
  }
  /**
   * Add an event listener for the specified `eventType`.
   * Works similar to `addEventListener` for a browser DOM element.
   * Listeners will be automatically removed when the grid is destroyed.
   */
  addEventListener(e, t) {
    this.apiEventService.addEventListener(e, t);
  }
  /**
   * Add an event listener for all event types coming from the grid.
   * Listeners will be automatically removed when the grid is destroyed.
   */
  addGlobalListener(e) {
    this.apiEventService.addGlobalListener(e);
  }
  /** Remove an event listener. */
  removeEventListener(e, t) {
    this.apiEventService.removeEventListener(e, t);
  }
  /** Remove a global event listener. */
  removeGlobalListener(e) {
    this.apiEventService.removeGlobalListener(e);
  }
  dispatchEvent(e) {
    this.eventService.dispatchEvent(e);
  }
  /** Will destroy the grid and release resources. If you are using a framework you do not need to call this, as the grid links in with the framework lifecycle. However if you are using Web Components or native JavaScript, you do need to call this, to avoid a memory leak in your application. */
  destroy() {
    var e;
    const t = `See ${this.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed")}`;
    if (this.destroyCalled)
      return;
    const i = {
      type: p.EVENT_GRID_PRE_DESTROYED,
      state: this.getState()
    };
    this.dispatchEvent(i), this.destroyCalled = !0, (e = this.ctrlsService.get("gridCtrl")) == null || e.destroyGridUi(), this.context.destroy(), this.detailGridInfoMap = {}, pu(this, ["isDestroyed"], t);
  }
  /** Returns `true` if the grid has been destroyed. */
  isDestroyed() {
    return this.destroyCalled;
  }
  /** Reset the Quick Filter cache text on every rowNode. */
  resetQuickFilter() {
    this.filterManager.resetQuickFilterCache();
  }
  /** Returns the list of selected cell ranges. */
  getCellRanges() {
    return this.rangeService ? this.rangeService.getCellRanges() : (le.__assertRegistered("@ag-grid-enterprise/range-selection", "api.getCellRanges", this.context.getGridId()), null);
  }
  /** Adds the provided cell range to the selected ranges. */
  addCellRange(e) {
    if (this.rangeService) {
      this.rangeService.addCellRange(e);
      return;
    }
    le.__assertRegistered("@ag-grid-enterprise/range-selection", "api.addCellRange", this.context.getGridId());
  }
  /** Clears the selected ranges. */
  clearRangeSelection() {
    this.rangeService && this.rangeService.removeAllCellRanges(), le.__assertRegistered("@ag-grid-enterprise/range-selection", "gridApi.clearRangeSelection", this.context.getGridId());
  }
  /** Reverts the last cell edit. */
  undoCellEditing() {
    this.undoRedoService.undo("api");
  }
  /** Re-applies the most recently undone cell edit. */
  redoCellEditing() {
    this.undoRedoService.redo("api");
  }
  /** Returns current number of available cell edit undo operations. */
  getCurrentUndoSize() {
    return this.undoRedoService.getCurrentUndoStackSize();
  }
  /** Returns current number of available cell edit redo operations. */
  getCurrentRedoSize() {
    return this.undoRedoService.getCurrentRedoStackSize();
  }
  assertChart(e, t) {
    if (le.__assertRegistered("@ag-grid-enterprise/charts", "api." + e, this.context.getGridId()))
      return this.frameworkOverrides.wrapIncoming(() => t());
  }
  /** Returns a list of models with information about the charts that are currently rendered from the grid. */
  getChartModels() {
    return this.assertChart("getChartModels", () => this.chartService.getChartModels());
  }
  /** Returns the `ChartRef` using the supplied `chartId`. */
  getChartRef(e) {
    return this.assertChart("getChartRef", () => this.chartService.getChartRef(e));
  }
  /** Returns a base64-encoded image data URL for the referenced chartId. */
  getChartImageDataURL(e) {
    return this.assertChart("getChartImageDataURL", () => this.chartService.getChartImageDataURL(e));
  }
  /** Starts a browser-based image download for the referenced chartId. */
  downloadChart(e) {
    return this.assertChart("downloadChart", () => this.chartService.downloadChart(e));
  }
  /** Open the Chart Tool Panel. */
  openChartToolPanel(e) {
    return this.assertChart("openChartToolPanel", () => this.chartService.openChartToolPanel(e));
  }
  /** Close the Chart Tool Panel. */
  closeChartToolPanel(e) {
    return this.assertChart("closeChartToolPanel", () => this.chartService.closeChartToolPanel(e.chartId));
  }
  /** Used to programmatically create charts from a range. */
  createRangeChart(e) {
    return this.assertChart("createRangeChart", () => this.chartService.createRangeChart(e));
  }
  /** Used to programmatically create pivot charts from a grid. */
  createPivotChart(e) {
    return this.assertChart("createPivotChart", () => this.chartService.createPivotChart(e));
  }
  /** Used to programmatically create cross filter charts from a range. */
  createCrossFilterChart(e) {
    return this.assertChart("createCrossFilterChart", () => this.chartService.createCrossFilterChart(e));
  }
  /** Used to programmatically update a chart. */
  updateChart(e) {
    return this.assertChart("updateChart", () => this.chartService.updateChart(e));
  }
  /** Restores a chart using the `ChartModel` that was previously obtained from `getChartModels()`. */
  restoreChart(e, t) {
    return this.assertChart("restoreChart", () => this.chartService.restoreChart(e, t));
  }
  assertClipboard(e, t) {
    le.__assertRegistered("@ag-grid-enterprise/clipboard", "api" + e, this.context.getGridId()) && t();
  }
  /** Copies data to clipboard by following the same rules as pressing Ctrl+C. */
  copyToClipboard(e) {
    this.assertClipboard("copyToClipboard", () => this.clipboardService.copyToClipboard(e));
  }
  /** Cuts data to clipboard by following the same rules as pressing Ctrl+X. */
  cutToClipboard(e) {
    this.assertClipboard("cutToClipboard", () => this.clipboardService.cutToClipboard(e));
  }
  /** Copies the selected rows to the clipboard. */
  copySelectedRowsToClipboard(e) {
    this.assertClipboard("copySelectedRowsToClipboard", () => this.clipboardService.copySelectedRowsToClipboard(e));
  }
  /** Copies the selected ranges to the clipboard. */
  copySelectedRangeToClipboard(e) {
    this.assertClipboard("copySelectedRangeToClipboard", () => this.clipboardService.copySelectedRangeToClipboard(e));
  }
  /** Copies the selected range down, similar to `Ctrl + D` in Excel. */
  copySelectedRangeDown() {
    this.assertClipboard("copySelectedRangeDown", () => this.clipboardService.copyRangeDown());
  }
  /** Pastes the data from the Clipboard into the focused cell of the grid. If no grid cell is focused, calling this method has no effect. */
  pasteFromClipboard() {
    this.assertClipboard("pasteFromClipboard", () => this.clipboardService.pasteFromClipboard());
  }
  /** @deprecated v31.1 Use `IHeaderParams.showColumnMenu` within a header component, or `api.showColumnMenu` elsewhere. */
  showColumnMenuAfterButtonClick(e, t) {
    H("'showColumnMenuAfterButtonClick' is deprecated. Use 'IHeaderParams.showColumnMenu' within a header component, or 'api.showColumnMenu' elsewhere.");
    const i = this.columnModel.getGridColumn(e);
    this.menuService.showColumnMenu({
      column: i,
      buttonElement: t,
      positionBy: "button"
    });
  }
  /** @deprecated v31.1 Use `IHeaderParams.showColumnMenuAfterMouseClick` within a header component, or `api.showColumnMenu` elsewhere. */
  showColumnMenuAfterMouseClick(e, t) {
    H("'showColumnMenuAfterMouseClick' is deprecated. Use 'IHeaderParams.showColumnMenuAfterMouseClick' within a header component, or 'api.showColumnMenu' elsewhere.");
    let i = this.columnModel.getGridColumn(e);
    if (i || (i = this.columnModel.getPrimaryColumn(e)), !i) {
      console.error(`AG Grid: column '${e}' not found`);
      return;
    }
    this.menuService.showColumnMenu({
      column: i,
      mouseEvent: t,
      positionBy: "mouse"
    });
  }
  /**
   * Displays the AG Grid context menu
   */
  showContextMenu(e) {
    const { rowNode: t, column: i, value: s, x: o, y: r } = e || {};
    let { x: n, y: l } = this.menuService.getContextMenuPosition(t, i);
    o != null && (n = o), r != null && (l = r), this.menuService.showContextMenu({
      mouseEvent: new MouseEvent("mousedown", { clientX: n, clientY: l }),
      rowNode: t,
      column: i,
      value: s
    });
  }
  /** Show the column chooser. */
  showColumnChooser(e) {
    this.menuService.showColumnChooser({ chooserParams: e });
  }
  /** Show the filter for the provided column. */
  showColumnFilter(e) {
    const t = this.columnModel.getGridColumn(e);
    if (!t) {
      console.error(`AG Grid: column '${e}' not found`);
      return;
    }
    this.menuService.showFilterMenu({
      column: t,
      containerType: "columnFilter",
      positionBy: "auto"
    });
  }
  /** Show the column menu for the provided column. */
  showColumnMenu(e) {
    const t = this.columnModel.getGridColumn(e);
    if (!t) {
      console.error(`AG Grid: column '${e}' not found`);
      return;
    }
    this.menuService.showColumnMenu({
      column: t,
      positionBy: "auto"
    });
  }
  /** Hides any visible context menu or column menu. */
  hidePopupMenu() {
    this.menuService.hidePopupMenu();
  }
  /** Hide the column chooser if visible. */
  hideColumnChooser() {
    this.menuService.hideColumnChooser();
  }
  /** Navigates the grid focus to the next cell, as if tabbing. */
  tabToNextCell(e) {
    return this.navigationService.tabToNextCell(!1, e);
  }
  /** Navigates the grid focus to the previous cell, as if shift-tabbing. */
  tabToPreviousCell(e) {
    return this.navigationService.tabToNextCell(!0, e);
  }
  /** Returns the list of active cell renderer instances. */
  getCellRendererInstances(e = {}) {
    return this.rowRenderer.getCellRendererInstances(e).map(ts);
  }
  /** Returns the list of active cell editor instances. Optionally provide parameters to restrict to certain columns / row nodes. */
  getCellEditorInstances(e = {}) {
    return this.rowRenderer.getCellEditorInstances(e).map(ts);
  }
  /** If the grid is editing, returns back details of the editing cell(s). */
  getEditingCells() {
    return this.rowRenderer.getEditingCells();
  }
  /** If a cell is editing, it stops the editing. Pass `true` if you want to cancel the editing (i.e. don't accept changes). */
  stopEditing(e = !1) {
    this.rowRenderer.stopEditing(e);
  }
  /** Start editing the provided cell. If another cell is editing, the editing will be stopped in that other cell. */
  startEditingCell(e) {
    const t = this.columnModel.getGridColumn(e.colKey);
    if (!t) {
      console.warn(`AG Grid: no column found for ${e.colKey}`);
      return;
    }
    const i = {
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned || null,
      column: t
    };
    e.rowPinned == null && this.ensureIndexVisible(e.rowIndex), this.ensureColumnVisible(e.colKey);
    const o = this.navigationService.getCellByPosition(i);
    o && (this.focusService.isCellFocused(i) || this.focusService.setFocusedCell(i), o.startRowOrCellEdit(e.key));
  }
  /** @deprecated v31.1 addAggFunc(key, func) is  deprecated, please use addAggFuncs({ key: func }) instead. */
  addAggFunc(e, t) {
    this.logDeprecation("v31.1", "addAggFunc(key, func)", "addAggFuncs({ key: func })"), this.aggFuncService && this.aggFuncService.addAggFuncs({ key: t });
  }
  /** Add aggregations function with the specified keys. */
  addAggFuncs(e) {
    this.aggFuncService && this.aggFuncService.addAggFuncs(e);
  }
  /** Clears all aggregation functions (including those provided by the grid). */
  clearAggFuncs() {
    this.aggFuncService && this.aggFuncService.clear();
  }
  /** Apply transactions to the server side row model. */
  applyServerSideTransaction(e) {
    if (!this.serverSideTransactionManager) {
      this.logMissingRowModel("applyServerSideTransaction", "serverSide");
      return;
    }
    return this.serverSideTransactionManager.applyTransaction(e);
  }
  /** Batch apply transactions to the server side row model. */
  applyServerSideTransactionAsync(e, t) {
    if (!this.serverSideTransactionManager) {
      this.logMissingRowModel("applyServerSideTransactionAsync", "serverSide");
      return;
    }
    return this.serverSideTransactionManager.applyTransactionAsync(e, t);
  }
  /**
   * Applies row data to a server side store.
   * New rows will overwrite rows at the same index in the same way as if provided by a datasource success callback.
  */
  applyServerSideRowData(e) {
    var t, i;
    const s = (t = e.startRow) != null ? t : 0, o = (i = e.route) != null ? i : [];
    if (s < 0) {
      console.warn(`AG Grid: invalid value ${e.startRow} for startRow, the value should be >= 0`);
      return;
    }
    this.serverSideRowModel ? this.serverSideRowModel.applyRowData(e.successParams, s, o) : this.logMissingRowModel("setServerSideDatasource", "serverSide");
  }
  /** Gets all failed server side loads to retry. */
  retryServerSideLoads() {
    if (!this.serverSideRowModel) {
      this.logMissingRowModel("retryServerSideLoads", "serverSide");
      return;
    }
    this.serverSideRowModel.retryLoads();
  }
  flushServerSideAsyncTransactions() {
    if (!this.serverSideTransactionManager) {
      this.logMissingRowModel("flushServerSideAsyncTransactions", "serverSide");
      return;
    }
    return this.serverSideTransactionManager.flushAsyncTransactions();
  }
  /** Update row data. Pass a transaction object with lists for `add`, `remove` and `update`. */
  applyTransaction(e) {
    if (!this.clientSideRowModel) {
      this.logMissingRowModel("applyTransaction", "clientSide");
      return;
    }
    return this.frameworkOverrides.wrapIncoming(() => this.clientSideRowModel.updateRowData(e));
  }
  /** Same as `applyTransaction` except executes asynchronously for efficiency. */
  applyTransactionAsync(e, t) {
    if (!this.clientSideRowModel) {
      this.logMissingRowModel("applyTransactionAsync", "clientSide");
      return;
    }
    this.frameworkOverrides.wrapIncoming(() => this.clientSideRowModel.batchUpdateRowData(e, t));
  }
  /** Executes any remaining asynchronous grid transactions, if any are waiting to be executed. */
  flushAsyncTransactions() {
    if (!this.clientSideRowModel) {
      this.logMissingRowModel("flushAsyncTransactions", "clientSide");
      return;
    }
    this.frameworkOverrides.wrapIncoming(() => this.clientSideRowModel.flushAsyncTransactions());
  }
  /**
   * Marks all the currently loaded blocks in the cache for reload.
   * If you have 10 blocks in the cache, all 10 will be marked for reload.
   * The old data will continue to be displayed until the new data is loaded.
   */
  refreshInfiniteCache() {
    this.infiniteRowModel ? this.infiniteRowModel.refreshCache() : this.logMissingRowModel("refreshInfiniteCache", "infinite");
  }
  /**
   * Purges the cache.
   * The grid is then told to refresh. Only the blocks required to display the current data on screen are fetched (typically no more than 2).
   * The grid will display nothing while the new blocks are loaded.
   * Use this to immediately remove the old data from the user.
   */
  purgeInfiniteCache() {
    this.infiniteRowModel ? this.infiniteRowModel.purgeCache() : this.logMissingRowModel("purgeInfiniteCache", "infinite");
  }
  /**
   * Refresh a server-side store level.
   * If you pass no parameters, then the top level store is refreshed.
   * To refresh a child level, pass in the string of keys to get to the desired level.
   * Once the store refresh is complete, the storeRefreshed event is fired.
   */
  refreshServerSide(e) {
    if (!this.serverSideRowModel) {
      this.logMissingRowModel("refreshServerSide", "serverSide");
      return;
    }
    this.serverSideRowModel.refreshStore(e);
  }
  /** Returns info on all server side group levels. */
  getServerSideGroupLevelState() {
    return this.serverSideRowModel ? this.serverSideRowModel.getStoreState() : (this.logMissingRowModel("getServerSideGroupLevelState", "serverSide"), []);
  }
  /** The row count defines how many rows the grid allows scrolling to. */
  getInfiniteRowCount() {
    if (this.infiniteRowModel)
      return this.infiniteRowModel.getRowCount();
    this.logMissingRowModel("getInfiniteRowCount", "infinite");
  }
  /** Returns `true` if grid allows for scrolling past the last row to load more rows, thus providing infinite scroll. */
  isLastRowIndexKnown() {
    if (this.infiniteRowModel)
      return this.infiniteRowModel.isLastRowIndexKnown();
    this.logMissingRowModel("isLastRowIndexKnown", "infinite");
  }
  /**
   * Returns an object representing the state of the cache. This is useful for debugging and understanding how the cache is working.
   */
  getCacheBlockState() {
    return this.rowNodeBlockLoader.getBlockState();
  }
  /** @deprecated v31.1 `getFirstDisplayedRow` is deprecated. Please use `getFirstDisplayedRowIndex` instead. */
  getFirstDisplayedRow() {
    return this.logDeprecation("v31.1", "getFirstDisplayedRow", "getFirstDisplayedRowIndex"), this.getFirstDisplayedRowIndex();
  }
  /** Get the index of the first displayed row due to scrolling (includes invisible rendered rows in the buffer). */
  getFirstDisplayedRowIndex() {
    return this.rowRenderer.getFirstVirtualRenderedRow();
  }
  /** @deprecated v31.1 `getLastDisplayedRow` is deprecated. Please use `getLastDisplayedRowIndex` instead. */
  getLastDisplayedRow() {
    return this.logDeprecation("v31.1", "getLastDisplayedRow", "getLastDisplayedRowIndex"), this.getLastDisplayedRowIndex();
  }
  /** Get the index of the last displayed row due to scrolling (includes invisible rendered rows in the buffer). */
  getLastDisplayedRowIndex() {
    return this.rowRenderer.getLastVirtualRenderedRow();
  }
  /** Returns the displayed `RowNode` at the given `index`. */
  getDisplayedRowAtIndex(e) {
    return this.rowModel.getRow(e);
  }
  /** Returns the total number of displayed rows. */
  getDisplayedRowCount() {
    return this.rowModel.getRowCount();
  }
  /**
   * Returns `true` when the last page is known.
   * This will always be `true` if you are using the Client-Side Row Model for pagination.
   * Returns `false` when the last page is not known; this only happens when using Infinite Row Model.
   */
  paginationIsLastPageFound() {
    return this.paginationProxy.isLastPageFound();
  }
  /** Returns how many rows are being shown per page. */
  paginationGetPageSize() {
    return this.paginationProxy.getPageSize();
  }
  /** Returns the 0-based index of the page which is showing. */
  paginationGetCurrentPage() {
    return this.paginationProxy.getCurrentPage();
  }
  /** Returns the total number of pages. Returns `null` if `paginationIsLastPageFound() === false`. */
  paginationGetTotalPages() {
    return this.paginationProxy.getTotalPages();
  }
  /** The total number of rows. Returns `null` if `paginationIsLastPageFound() === false`. */
  paginationGetRowCount() {
    return this.paginationProxy.getMasterRowCount();
  }
  /** Navigates to the next page. */
  paginationGoToNextPage() {
    this.paginationProxy.goToNextPage();
  }
  /** Navigates to the previous page. */
  paginationGoToPreviousPage() {
    this.paginationProxy.goToPreviousPage();
  }
  /** Navigates to the first page. */
  paginationGoToFirstPage() {
    this.paginationProxy.goToFirstPage();
  }
  /** Navigates to the last page. */
  paginationGoToLastPage() {
    this.paginationProxy.goToLastPage();
  }
  /** Goes to the specified page. If the page requested doesn't exist, it will go to the last page. */
  paginationGoToPage(e) {
    this.paginationProxy.goToPage(e);
  }
  // Methods migrated from old ColumnApi
  /**
   * Adjusts the size of columns to fit the available horizontal space.
   *
   * Note: it is not recommended to call this method rapidly e.g. in response
   * to window resize events or as the container size is animated. This can
   * cause the scrollbar to flicker. Use column flex for smoother results.
   * 
   * If inferring cell data types with custom column types
   * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition.
   **/
  sizeColumnsToFit(e) {
    typeof e == "number" ? this.columnModel.sizeColumnsToFit(e, "api") : this.gridBodyCtrl.sizeColumnsToFit(e);
  }
  /** Call this if you want to open or close a column group. */
  setColumnGroupOpened(e, t) {
    this.columnModel.setColumnGroupOpened(e, t, "api");
  }
  /** Returns the column group with the given name. */
  getColumnGroup(e, t) {
    return this.columnModel.getColumnGroup(e, t);
  }
  /** Returns the provided column group with the given name. */
  getProvidedColumnGroup(e) {
    return this.columnModel.getProvidedColumnGroup(e);
  }
  /** Returns the display name for a column. Useful if you are doing your own header rendering and want the grid to work out if `headerValueGetter` is used, or if you are doing your own column management GUI, to know what to show as the column name. */
  getDisplayNameForColumn(e, t) {
    return this.columnModel.getDisplayNameForColumn(e, t) || "";
  }
  /** Returns the display name for a column group (when grouping columns). */
  getDisplayNameForColumnGroup(e, t) {
    return this.columnModel.getDisplayNameForColumnGroup(e, t) || "";
  }
  /** Returns the column with the given `colKey`, which can either be the `colId` (a string) or the `colDef` (an object). */
  getColumn(e) {
    return this.columnModel.getPrimaryColumn(e);
  }
  /** Returns all the columns, regardless of visible or not. */
  getColumns() {
    return this.columnModel.getAllPrimaryColumns();
  }
  /** Applies the state of the columns from a previous state. Returns `false` if one or more columns could not be found. */
  applyColumnState(e) {
    return this.columnModel.applyColumnState(e, "api");
  }
  /** Gets the state of the columns. Typically used when saving column state. */
  getColumnState() {
    return this.columnModel.getColumnState();
  }
  /** Sets the state back to match the originally provided column definitions. */
  resetColumnState() {
    this.columnModel.resetColumnState("api");
  }
  /** Gets the state of the column groups. Typically used when saving column group state. */
  getColumnGroupState() {
    return this.columnModel.getColumnGroupState();
  }
  /** Sets the state of the column group state from a previous state. */
  setColumnGroupState(e) {
    this.columnModel.setColumnGroupState(e, "api");
  }
  /** Sets the state back to match the originally provided column definitions. */
  resetColumnGroupState() {
    this.columnModel.resetColumnGroupState("api");
  }
  /** Returns `true` if pinning left or right, otherwise `false`. */
  isPinning() {
    return this.columnModel.isPinningLeft() || this.columnModel.isPinningRight();
  }
  /** Returns `true` if pinning left, otherwise `false`. */
  isPinningLeft() {
    return this.columnModel.isPinningLeft();
  }
  /** Returns `true` if pinning right, otherwise `false`. */
  isPinningRight() {
    return this.columnModel.isPinningRight();
  }
  /** Returns the column to the right of the provided column, taking into consideration open / closed column groups and visible columns. This is useful if you need to know what column is beside yours e.g. if implementing your own cell navigation. */
  getDisplayedColAfter(e) {
    return this.columnModel.getDisplayedColAfter(e);
  }
  /** Same as `getVisibleColAfter` except gives column to the left. */
  getDisplayedColBefore(e) {
    return this.columnModel.getDisplayedColBefore(e);
  }
  /** @deprecated v31.1 setColumnVisible(key, visible) deprecated, please use setColumnsVisible([key], visible) instead. */
  setColumnVisible(e, t) {
    this.logDeprecation("v31.1", "setColumnVisible(key,visible)", "setColumnsVisible([key],visible)"), this.columnModel.setColumnsVisible([e], t, "api");
  }
  /** Sets the visibility of columns. Key can be the column ID or `Column` object. */
  setColumnsVisible(e, t) {
    this.columnModel.setColumnsVisible(e, t, "api");
  }
  /** @deprecated v31.1 setColumnPinned(key, pinned) deprecated, please use setColumnsPinned([key], pinned) instead. */
  setColumnPinned(e, t) {
    this.logDeprecation("v31.1", "setColumnPinned(key,pinned)", "setColumnsPinned([key],pinned)"), this.columnModel.setColumnsPinned([e], t, "api");
  }
  /** Set a column's pinned / unpinned state. Key can be the column ID, field, `ColDef` object or `Column` object. */
  setColumnsPinned(e, t) {
    this.columnModel.setColumnsPinned(e, t, "api");
  }
  /**
   * Returns all the grid columns, same as `getColumns()`, except
   *
   *  a) it has the order of the columns that are presented in the grid
   *
   *  b) it's after the 'pivot' step, so if pivoting, has the value columns for the pivot.
   */
  getAllGridColumns() {
    return this.columnModel.getAllGridColumns();
  }
  /** Same as `getAllDisplayedColumns` but just for the pinned left portion of the grid. */
  getDisplayedLeftColumns() {
    return this.columnModel.getDisplayedLeftColumns();
  }
  /** Same as `getAllDisplayedColumns` but just for the center portion of the grid. */
  getDisplayedCenterColumns() {
    return this.columnModel.getDisplayedCenterColumns();
  }
  /** Same as `getAllDisplayedColumns` but just for the pinned right portion of the grid. */
  getDisplayedRightColumns() {
    return this.columnModel.getDisplayedRightColumns();
  }
  /** Returns all columns currently displayed (e.g. are visible and if in a group, the group is showing the columns) for the pinned left, centre and pinned right portions of the grid. */
  getAllDisplayedColumns() {
    return this.columnModel.getAllDisplayedColumns();
  }
  /** Same as `getAllGridColumns()`, except only returns rendered columns, i.e. columns that are not within the viewport and therefore not rendered, due to column virtualisation, are not displayed. */
  getAllDisplayedVirtualColumns() {
    return this.columnModel.getViewportColumns();
  }
  /** @deprecated v31.1 moveColumn(key, toIndex) deprecated, please use moveColumns([key], toIndex) instead. */
  moveColumn(e, t) {
    this.logDeprecation("v31.1", "moveColumn(key, toIndex)", "moveColumns([key], toIndex)"), this.columnModel.moveColumns([e], t, "api");
  }
  /** Moves the column at `fromIdex` to `toIndex`. The column is first removed, then added at the `toIndex` location, thus index locations will change to the right of the column after the removal. */
  moveColumnByIndex(e, t) {
    this.columnModel.moveColumnByIndex(e, t, "api");
  }
  /** Moves columns to `toIndex`. The columns are first removed, then added at the `toIndex` location, thus index locations will change to the right of the column after the removal. */
  moveColumns(e, t) {
    this.columnModel.moveColumns(e, t, "api");
  }
  /** Move the column to a new position in the row grouping order. */
  moveRowGroupColumn(e, t) {
    this.columnModel.moveRowGroupColumn(e, t, "api");
  }
  /** Sets the agg function for a column. `aggFunc` can be one of the built-in aggregations or a custom aggregation by name or direct function. */
  setColumnAggFunc(e, t) {
    this.columnModel.setColumnAggFunc(e, t, "api");
  }
  /** @deprecated v31.1 setColumnWidths(key, newWidth) deprecated, please use setColumnWidths( [{key: newWidth}] ) instead. */
  setColumnWidth(e, t, i = !0, s = "api") {
    this.logDeprecation("v31.1", "setColumnWidth(col, width)", "setColumnWidths([{key: col, newWidth: width}])"), this.columnModel.setColumnWidths([{ key: e, newWidth: t }], !1, i, s);
  }
  /** Sets the column widths of the columns provided. The finished flag gets included in the resulting event and not used internally by the grid. The finished flag is intended for dragging, where a dragging action will produce many `columnWidth` events, so the consumer of events knows when it receives the last event in a stream. The finished parameter is optional, and defaults to `true`. */
  setColumnWidths(e, t = !0, i = "api") {
    this.columnModel.setColumnWidths(e, !1, t, i);
  }
  /** Get the pivot mode. */
  isPivotMode() {
    return this.columnModel.isPivotMode();
  }
  /** Returns the pivot result column for the given `pivotKeys` and `valueColId`. Useful to then call operations on the pivot column. */
  getPivotResultColumn(e, t) {
    return this.columnModel.getSecondaryPivotColumn(e, t);
  }
  /** Set the value columns to the provided list of columns. */
  setValueColumns(e) {
    this.columnModel.setValueColumns(e, "api");
  }
  /** Get a list of the existing value columns. */
  getValueColumns() {
    return this.columnModel.getValueColumns();
  }
  /** @deprecated v31.1 removeValueColumn(colKey) deprecated, please use removeValueColumns([colKey]) instead. */
  removeValueColumn(e) {
    this.logDeprecation("v31.1", "removeValueColumn(colKey)", "removeValueColumns([colKey])"), this.columnModel.removeValueColumns([e], "api");
  }
  /** Remove the given list of columns from the existing set of value columns. */
  removeValueColumns(e) {
    this.columnModel.removeValueColumns(e, "api");
  }
  /** @deprecated v31.1 addValueColumn(colKey) deprecated, please use addValueColumns([colKey]) instead. */
  addValueColumn(e) {
    this.logDeprecation("v31.1", "addValueColumn(colKey)", "addValueColumns([colKey])"), this.columnModel.addValueColumns([e], "api");
  }
  /** Add the given list of columns to the existing set of value columns. */
  addValueColumns(e) {
    this.columnModel.addValueColumns(e, "api");
  }
  /** Set the row group columns. */
  setRowGroupColumns(e) {
    this.columnModel.setRowGroupColumns(e, "api");
  }
  /** @deprecated v31.1 removeRowGroupColumn(colKey) deprecated, please use removeRowGroupColumns([colKey]) instead. */
  removeRowGroupColumn(e) {
    this.logDeprecation("v31.1", "removeRowGroupColumn(colKey)", "removeRowGroupColumns([colKey])"), this.columnModel.removeRowGroupColumns([e], "api");
  }
  /** Remove columns from the row groups. */
  removeRowGroupColumns(e) {
    this.columnModel.removeRowGroupColumns(e, "api");
  }
  /** @deprecated v31.1 addRowGroupColumn(colKey) deprecated, please use addRowGroupColumns([colKey]) instead. */
  addRowGroupColumn(e) {
    this.logDeprecation("v31.1", "addRowGroupColumn(colKey)", "addRowGroupColumns([colKey])"), this.columnModel.addRowGroupColumns([e], "api");
  }
  /** Add columns to the row groups. */
  addRowGroupColumns(e) {
    this.columnModel.addRowGroupColumns(e, "api");
  }
  /** Get row group columns. */
  getRowGroupColumns() {
    return this.columnModel.getRowGroupColumns();
  }
  /** Set the pivot columns. */
  setPivotColumns(e) {
    this.columnModel.setPivotColumns(e, "api");
  }
  /** @deprecated v31.1 removePivotColumn(colKey) deprecated, please use removePivotColumns([colKey]) instead. */
  removePivotColumn(e) {
    this.logDeprecation("v31.1", "removePivotColumn(colKey)", "removePivotColumns([colKey])"), this.columnModel.removePivotColumns([e], "api");
  }
  /** Remove pivot columns. */
  removePivotColumns(e) {
    this.columnModel.removePivotColumns(e, "api");
  }
  /** @deprecated v31.1 addPivotColumn(colKey) deprecated, please use addPivotColumns([colKey]) instead. */
  addPivotColumn(e) {
    this.logDeprecation("v31.1", "addPivotColumn(colKey)", "addPivotColumns([colKey])"), this.columnModel.addPivotColumns([e], "api");
  }
  /** Add pivot columns. */
  addPivotColumns(e) {
    this.columnModel.addPivotColumns(e, "api");
  }
  /** Get the pivot columns. */
  getPivotColumns() {
    return this.columnModel.getPivotColumns();
  }
  /** Same as `getAllDisplayedColumnGroups` but just for the pinned left portion of the grid. */
  getLeftDisplayedColumnGroups() {
    return this.columnModel.getDisplayedTreeLeft();
  }
  /** Same as `getAllDisplayedColumnGroups` but just for the center portion of the grid. */
  getCenterDisplayedColumnGroups() {
    return this.columnModel.getDisplayedTreeCentre();
  }
  /** Same as `getAllDisplayedColumnGroups` but just for the pinned right portion of the grid. */
  getRightDisplayedColumnGroups() {
    return this.columnModel.getDisplayedTreeRight();
  }
  /** Returns all 'root' column headers. If you are not grouping columns, these return the columns. If you are grouping, these return the top level groups - you can navigate down through each one to get the other lower level headers and finally the columns at the bottom. */
  getAllDisplayedColumnGroups() {
    return this.columnModel.getAllDisplayedTrees();
  }
  /** @deprecated v31.1 autoSizeColumn(key) deprecated, please use autoSizeColumns([colKey]) instead. */
  autoSizeColumn(e, t) {
    return this.logDeprecation("v31.1", "autoSizeColumn(key, skipHeader)", "autoSizeColumns([key], skipHeader)"), this.columnModel.autoSizeColumns({ columns: [e], skipHeader: t, source: "api" });
  }
  /**
   * Auto-sizes columns based on their contents. If inferring cell data types with custom column types
   * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition.
   */
  autoSizeColumns(e, t) {
    this.columnModel.autoSizeColumns({ columns: e, skipHeader: t, source: "api" });
  }
  /**
   * Calls `autoSizeColumns` on all displayed columns. If inferring cell data types with custom column types
   * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition.
   */
  autoSizeAllColumns(e) {
    this.columnModel.autoSizeAllColumns("api", e);
  }
  /** Set the pivot result columns. */
  setPivotResultColumns(e) {
    this.columnModel.setSecondaryColumns(e, "api");
  }
  /** Returns the grid's pivot result columns. */
  getPivotResultColumns() {
    return this.columnModel.getSecondaryColumns();
  }
  /** Get the current state of the grid. Can be used in conjunction with the `initialState` grid option to save and restore grid state. */
  getState() {
    return this.stateService.getState();
  }
  /**
   * Returns the grid option value for a provided key.
   */
  getGridOption(e) {
    return this.gos.get(e);
  }
  /**
   * Updates a single gridOption to the new value provided. (Cannot be used on `Initial` properties.)
   * If updating multiple options, it is recommended to instead use `api.updateGridOptions()` which batches update logic.
   */
  setGridOption(e, t) {
    this.updateGridOptions({ [e]: t });
  }
  /**
   * Updates the provided subset of gridOptions with the provided values. (Cannot be used on `Initial` properties.)
   */
  updateGridOptions(e) {
    this.gos.updateGridOptions({ options: e });
  }
  /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */
  __internalUpdateGridOptions(e, t) {
    this.gos.updateGridOptions({ options: e, force: t, source: "gridOptionsUpdated" });
  }
  deprecatedUpdateGridOption(e, t) {
    H(`set${e.charAt(0).toUpperCase()}${e.slice(1, e.length)} is deprecated. Please use 'api.setGridOption('${e}', newValue)' or 'api.updateGridOptions({ ${e}: newValue })' instead.`), this.setGridOption(e, t);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the top pinned rows. Call with no rows / undefined to clear top pinned rows. 
   **/
  setPivotMode(e) {
    this.deprecatedUpdateGridOption("pivotMode", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the top pinned rows. Call with no rows / undefined to clear top pinned rows. 
   **/
  setPinnedTopRowData(e) {
    this.deprecatedUpdateGridOption("pinnedTopRowData", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the bottom pinned rows. Call with no rows / undefined to clear bottom pinned rows.
   * */
  setPinnedBottomRowData(e) {
    this.deprecatedUpdateGridOption("pinnedBottomRowData", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * DOM element to use as the popup parent for grid popups (context menu, column menu etc).
   * */
  setPopupParent(e) {
    this.deprecatedUpdateGridOption("popupParent", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */
  setSuppressModelUpdateAfterUpdateTransaction(e) {
    this.deprecatedUpdateGridOption("suppressModelUpdateAfterUpdateTransaction", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Resets the data type definitions. This will update the columns in the grid.
   * */
  setDataTypeDefinitions(e) {
    this.deprecatedUpdateGridOption("dataTypeDefinitions", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set whether the grid paginates the data or not.
   *  - `true` to enable pagination
   *  - `false` to disable pagination
   */
  setPagination(e) {
    this.deprecatedUpdateGridOption("pagination", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `paginationPageSize`, then re-paginates the grid so the changes are applied immediately.
   * */
  paginationSetPageSize(e) {
    this.deprecatedUpdateGridOption("paginationPageSize", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Resets the side bar to the provided configuration. The parameter is the same as the sideBar grid property. The side bar is re-created from scratch with the new config.
   * */
  setSideBar(e) {
    this.deprecatedUpdateGridOption("sideBar", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */
  setSuppressClipboardPaste(e) {
    this.deprecatedUpdateGridOption("suppressClipboardPaste", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */
  setGroupRemoveSingleChildren(e) {
    this.deprecatedUpdateGridOption("groupRemoveSingleChildren", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */
  setGroupRemoveLowestSingleChildren(e) {
    this.deprecatedUpdateGridOption("groupRemoveLowestSingleChildren", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */
  setGroupDisplayType(e) {
    this.deprecatedUpdateGridOption("groupDisplayType", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `groupIncludeFooter` property
   */
  setGroupIncludeFooter(e) {
    this.deprecatedUpdateGridOption("groupIncludeFooter", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `groupIncludeTotalFooter` property
   */
  setGroupIncludeTotalFooter(e) {
    this.deprecatedUpdateGridOption("groupIncludeTotalFooter", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */
  setRowClass(e) {
    this.deprecatedUpdateGridOption("rowClass", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `deltaSort` property
   * */
  setDeltaSort(e) {
    this.deprecatedUpdateGridOption("deltaSort", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `suppressRowDrag` property.
   * */
  setSuppressRowDrag(e) {
    this.deprecatedUpdateGridOption("suppressRowDrag", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `suppressMoveWhenRowDragging` property.
   * */
  setSuppressMoveWhenRowDragging(e) {
    this.deprecatedUpdateGridOption("suppressMoveWhenRowDragging", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `suppressRowClickSelection` property.
   * */
  setSuppressRowClickSelection(e) {
    this.deprecatedUpdateGridOption("suppressRowClickSelection", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Enable/disable the Advanced Filter
   * */
  setEnableAdvancedFilter(e) {
    this.deprecatedUpdateGridOption("enableAdvancedFilter", e);
  }
  /** 
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `includeHiddenColumnsInAdvancedFilter` grid option.
   * By default hidden columns are excluded from the Advanced Filter.
   * Set to `true` to include them.
   */
  setIncludeHiddenColumnsInAdvancedFilter(e) {
    this.deprecatedUpdateGridOption("includeHiddenColumnsInAdvancedFilter", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * DOM element to use as the parent for the Advanced Filter, to allow it to appear outside of the grid.
   * Set to `null` to appear inside the grid.
   */
  setAdvancedFilterParent(e) {
    this.deprecatedUpdateGridOption("advancedFilterParent", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the Advanced Filter Builder parameters.
   * */
  setAdvancedFilterBuilderParams(e) {
    this.deprecatedUpdateGridOption("advancedFilterBuilderParams", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Pass a Quick Filter text into the grid for filtering.
   * */
  setQuickFilter(e) {
    H("setQuickFilter is deprecated. Please use 'api.setGridOption('quickFilterText', newValue)' or 'api.updateGridOptions({ quickFilterText: newValue })' instead."), this.gos.updateGridOptions({ options: { quickFilterText: e } });
  }
  /** 
   * @deprecated As of v30, hidden columns are excluded from the Quick Filter by default. To include hidden columns, use `setIncludeHiddenColumnsInQuickFilter` instead.
   */
  setExcludeHiddenColumnsFromQuickFilter(e) {
    this.deprecatedUpdateGridOption("includeHiddenColumnsInQuickFilter", !e);
  }
  /** 
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `includeHiddenColumnsInQuickFilter` grid option.
   * By default hidden columns are excluded from the Quick Filter.
   * Set to `true` to include them.
   */
  setIncludeHiddenColumnsInQuickFilter(e) {
    this.deprecatedUpdateGridOption("includeHiddenColumnsInQuickFilter", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `quickFilterParser` grid option,
   * which changes how the Quick Filter splits the Quick Filter text into search terms.
   */
  setQuickFilterParser(e) {
    this.deprecatedUpdateGridOption("quickFilterParser", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `quickFilterMatcher` grid option,
   * which changes the matching logic for whether a row passes the Quick Filter.
   */
  setQuickFilterMatcher(e) {
    this.deprecatedUpdateGridOption("quickFilterMatcher", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * If `true`, the horizontal scrollbar will always be present, even if not required. Otherwise, it will only be displayed when necessary.
   * */
  setAlwaysShowHorizontalScroll(e) {
    this.deprecatedUpdateGridOption("alwaysShowHorizontalScroll", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * If `true`, the vertical scrollbar will always be present, even if not required. Otherwise it will only be displayed when necessary.
   * */
  setAlwaysShowVerticalScroll(e) {
    this.deprecatedUpdateGridOption("alwaysShowVerticalScroll", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */
  setFunctionsReadOnly(e) {
    this.deprecatedUpdateGridOption("functionsReadOnly", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new column definitions. The grid will redraw all the column headers, and then redraw all of the rows.
   */
  setColumnDefs(e, t = "api") {
    H("setColumnDefs is deprecated. Please use 'api.setGridOption('columnDefs', newValue)' or 'api.updateGridOptions({ columnDefs: newValue })' instead."), this.gos.updateGridOptions({
      options: { columnDefs: e },
      source: t
    });
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new auto group column definition. The grid will recreate any auto-group columns if present.
   * */
  setAutoGroupColumnDef(e, t = "api") {
    H("setAutoGroupColumnDef is deprecated. Please use 'api.setGridOption('autoGroupColumnDef', newValue)' or 'api.updateGridOptions({ autoGroupColumnDef: newValue })' instead."), this.gos.updateGridOptions({
      options: { autoGroupColumnDef: e },
      source: t
    });
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new Default Column Definition.
   * */
  setDefaultColDef(e, t = "api") {
    H("setDefaultColDef is deprecated. Please use 'api.setGridOption('defaultColDef', newValue)' or 'api.updateGridOptions({ defaultColDef: newValue })' instead."), this.gos.updateGridOptions({
      options: { defaultColDef: e },
      source: t
    });
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new Column Types.
   * */
  setColumnTypes(e, t = "api") {
    H("setColumnTypes is deprecated. Please use 'api.setGridOption('columnTypes', newValue)' or 'api.updateGridOptions({ columnTypes: newValue })' instead."), this.gos.updateGridOptions({
      options: { columnTypes: e },
      source: t
    });
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `treeData` property.
   * */
  setTreeData(e) {
    this.deprecatedUpdateGridOption("treeData", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set new datasource for Server-Side Row Model.
   * */
  setServerSideDatasource(e) {
    this.deprecatedUpdateGridOption("serverSideDatasource", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * 
   * Note this purges all the cached data and reloads all the rows of the grid.
   * */
  setCacheBlockSize(e) {
    this.deprecatedUpdateGridOption("cacheBlockSize", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set new datasource for Infinite Row Model.
   * */
  setDatasource(e) {
    this.deprecatedUpdateGridOption("datasource", e);
  }
  /** 
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set new datasource for Viewport Row Model.
   * */
  setViewportDatasource(e) {
    this.deprecatedUpdateGridOption("viewportDatasource", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the row data.
   * */
  setRowData(e) {
    this.deprecatedUpdateGridOption("rowData", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `enableCellTextSelection` property.
   * */
  setEnableCellTextSelection(e) {
    this.deprecatedUpdateGridOption("enableCellTextSelection", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing the column label header.
   * */
  setHeaderHeight(e) {
    this.deprecatedUpdateGridOption("headerHeight", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Switch between layout options: `normal`, `autoHeight`, `print`.
   * Defaults to `normal` if no domLayout provided.
   */
  setDomLayout(e) {
    this.deprecatedUpdateGridOption("domLayout", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the preferred direction for the selection fill handle.
   * */
  setFillHandleDirection(e) {
    this.deprecatedUpdateGridOption("fillHandleDirection", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the rows containing header column groups.
   * */
  setGroupHeaderHeight(e) {
    this.deprecatedUpdateGridOption("groupHeaderHeight", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing the floating filters.
   * */
  setFloatingFiltersHeight(e) {
    this.deprecatedUpdateGridOption("floatingFiltersHeight", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing the columns when in pivot mode.
   * */
  setPivotHeaderHeight(e) {
    this.deprecatedUpdateGridOption("pivotHeaderHeight", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing header column groups when in pivot mode.
   * */
  setPivotGroupHeaderHeight(e) {
    this.deprecatedUpdateGridOption("pivotGroupHeaderHeight", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setAnimateRows(e) {
    this.deprecatedUpdateGridOption("animateRows", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setIsExternalFilterPresent(e) {
    this.deprecatedUpdateGridOption("isExternalFilterPresent", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setDoesExternalFilterPass(e) {
    this.deprecatedUpdateGridOption("doesExternalFilterPass", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setNavigateToNextCell(e) {
    this.deprecatedUpdateGridOption("navigateToNextCell", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setTabToNextCell(e) {
    this.deprecatedUpdateGridOption("tabToNextCell", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setTabToNextHeader(e) {
    this.deprecatedUpdateGridOption("tabToNextHeader", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setNavigateToNextHeader(e) {
    this.deprecatedUpdateGridOption("navigateToNextHeader", e);
  }
  setRowGroupPanelShow(e) {
    this.deprecatedUpdateGridOption("rowGroupPanelShow", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetGroupRowAgg(e) {
    this.deprecatedUpdateGridOption("getGroupRowAgg", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetBusinessKeyForNode(e) {
    this.deprecatedUpdateGridOption("getBusinessKeyForNode", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetChildCount(e) {
    this.deprecatedUpdateGridOption("getChildCount", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setProcessRowPostCreate(e) {
    this.deprecatedUpdateGridOption("processRowPostCreate", e);
  }
  /**
   * @deprecated v31 `getRowId` is a static property and cannot be updated.
   *  */
  setGetRowId(e) {
    H("getRowId is a static property and can no longer be updated.");
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetRowClass(e) {
    this.deprecatedUpdateGridOption("getRowClass", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setIsFullWidthRow(e) {
    this.deprecatedUpdateGridOption("isFullWidthRow", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setIsRowSelectable(e) {
    this.deprecatedUpdateGridOption("isRowSelectable", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setIsRowMaster(e) {
    this.deprecatedUpdateGridOption("isRowMaster", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setPostSortRows(e) {
    this.deprecatedUpdateGridOption("postSortRows", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetDocument(e) {
    this.deprecatedUpdateGridOption("getDocument", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetContextMenuItems(e) {
    this.deprecatedUpdateGridOption("getContextMenuItems", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetMainMenuItems(e) {
    this.deprecatedUpdateGridOption("getMainMenuItems", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setProcessCellForClipboard(e) {
    this.deprecatedUpdateGridOption("processCellForClipboard", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setSendToClipboard(e) {
    this.deprecatedUpdateGridOption("sendToClipboard", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setProcessCellFromClipboard(e) {
    this.deprecatedUpdateGridOption("processCellFromClipboard", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setProcessPivotResultColDef(e) {
    this.deprecatedUpdateGridOption("processPivotResultColDef", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setProcessPivotResultColGroupDef(e) {
    this.deprecatedUpdateGridOption("processPivotResultColGroupDef", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setPostProcessPopup(e) {
    this.deprecatedUpdateGridOption("postProcessPopup", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setInitialGroupOrderComparator(e) {
    this.deprecatedUpdateGridOption("initialGroupOrderComparator", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetChartToolbarItems(e) {
    this.deprecatedUpdateGridOption("getChartToolbarItems", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setPaginationNumberFormatter(e) {
    this.deprecatedUpdateGridOption("paginationNumberFormatter", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetServerSideGroupLevelParams(e) {
    this.deprecatedUpdateGridOption("getServerSideGroupLevelParams", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setIsServerSideGroupOpenByDefault(e) {
    this.deprecatedUpdateGridOption("isServerSideGroupOpenByDefault", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setIsApplyServerSideTransaction(e) {
    this.deprecatedUpdateGridOption("isApplyServerSideTransaction", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setIsServerSideGroup(e) {
    this.deprecatedUpdateGridOption("isServerSideGroup", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetServerSideGroupKey(e) {
    this.deprecatedUpdateGridOption("getServerSideGroupKey", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetRowStyle(e) {
    this.deprecatedUpdateGridOption("getRowStyle", e);
  }
  /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */
  setGetRowHeight(e) {
    this.deprecatedUpdateGridOption("getRowHeight", e);
  }
};
u([
  f("rowRenderer")
], J.prototype, "rowRenderer", 2);
u([
  f("navigationService")
], J.prototype, "navigationService", 2);
u([
  f("filterManager")
], J.prototype, "filterManager", 2);
u([
  f("columnModel")
], J.prototype, "columnModel", 2);
u([
  f("selectionService")
], J.prototype, "selectionService", 2);
u([
  f("gridOptionsService")
], J.prototype, "gos", 2);
u([
  f("valueService")
], J.prototype, "valueService", 2);
u([
  f("alignedGridsService")
], J.prototype, "alignedGridsService", 2);
u([
  f("eventService")
], J.prototype, "eventService", 2);
u([
  f("pinnedRowModel")
], J.prototype, "pinnedRowModel", 2);
u([
  f("context")
], J.prototype, "context", 2);
u([
  f("rowModel")
], J.prototype, "rowModel", 2);
u([
  f("sortController")
], J.prototype, "sortController", 2);
u([
  f("paginationProxy")
], J.prototype, "paginationProxy", 2);
u([
  f("focusService")
], J.prototype, "focusService", 2);
u([
  f("dragAndDropService")
], J.prototype, "dragAndDropService", 2);
u([
  f("menuService")
], J.prototype, "menuService", 2);
u([
  f("valueCache")
], J.prototype, "valueCache", 2);
u([
  f("animationFrameService")
], J.prototype, "animationFrameService", 2);
u([
  f("ctrlsService")
], J.prototype, "ctrlsService", 2);
u([
  f("overlayService")
], J.prototype, "overlayService", 2);
u([
  f("stateService")
], J.prototype, "stateService", 2);
u([
  f("expansionService")
], J.prototype, "expansionService", 2);
u([
  f("apiEventService")
], J.prototype, "apiEventService", 2);
u([
  f("frameworkOverrides")
], J.prototype, "frameworkOverrides", 2);
u([
  f("undoRedoService")
], J.prototype, "undoRedoService", 2);
u([
  f("rowNodeBlockLoader")
], J.prototype, "rowNodeBlockLoader", 2);
u([
  ue("csvCreator")
], J.prototype, "csvCreator", 2);
u([
  ue("excelCreator")
], J.prototype, "excelCreator", 2);
u([
  ue("rangeService")
], J.prototype, "rangeService", 2);
u([
  ue("clipboardService")
], J.prototype, "clipboardService", 2);
u([
  ue("aggFuncService")
], J.prototype, "aggFuncService", 2);
u([
  ue("statusBarService")
], J.prototype, "statusBarService", 2);
u([
  ue("chartService")
], J.prototype, "chartService", 2);
u([
  ue("ssrmTransactionManager")
], J.prototype, "serverSideTransactionManager", 2);
u([
  ue("sideBarService")
], J.prototype, "sideBarService", 2);
u([
  L
], J.prototype, "init", 1);
J = u([
  O("gridApi")
], J);
var vt = class extends F {
  constructor() {
    super(...arguments), this.quickFilter = null, this.quickFilterParts = null;
  }
  postConstruct() {
    this.addManagedListener(this.eventService, p.EVENT_COLUMN_PIVOT_MODE_CHANGED, () => this.resetQuickFilterCache()), this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, () => this.resetQuickFilterCache()), this.addManagedListener(this.eventService, p.EVENT_COLUMN_ROW_GROUP_CHANGED, () => this.resetQuickFilterCache()), this.addManagedListener(this.eventService, p.EVENT_COLUMN_VISIBLE, () => {
      this.gos.get("includeHiddenColumnsInQuickFilter") || this.resetQuickFilterCache();
    }), this.addManagedPropertyListener("quickFilterText", (e) => this.setQuickFilter(e.currentValue)), this.addManagedPropertyListeners([
      "includeHiddenColumnsInQuickFilter",
      "applyQuickFilterBeforePivotOrAgg"
    ], () => this.onQuickFilterColumnConfigChanged()), this.quickFilter = this.parseQuickFilter(this.gos.get("quickFilterText")), this.parser = this.gos.get("quickFilterParser"), this.matcher = this.gos.get("quickFilterMatcher"), this.setQuickFilterParts(), this.addManagedPropertyListeners(["quickFilterMatcher", "quickFilterParser"], () => this.setQuickFilterParserAndMatcher());
  }
  isQuickFilterPresent() {
    return this.quickFilter !== null;
  }
  doesRowPassQuickFilter(e) {
    const t = this.gos.get("cacheQuickFilter");
    return this.matcher ? this.doesRowPassQuickFilterMatcher(t, e) : this.quickFilterParts.every(
      (i) => t ? this.doesRowPassQuickFilterCache(e, i) : this.doesRowPassQuickFilterNoCache(e, i)
    );
  }
  resetQuickFilterCache() {
    this.rowModel.forEachNode((e) => e.quickFilterAggregateText = null);
  }
  setQuickFilterParts() {
    const { quickFilter: e, parser: t } = this;
    e ? this.quickFilterParts = t ? t(e) : e.split(" ") : this.quickFilterParts = null;
  }
  parseQuickFilter(e) {
    return b(e) ? this.gos.isRowModelType("clientSide") ? e.toUpperCase() : (console.warn("AG Grid - Quick filtering only works with the Client-Side Row Model"), null) : null;
  }
  setQuickFilter(e) {
    if (e != null && typeof e != "string") {
      console.warn(`AG Grid - Grid option quickFilterText only supports string inputs, received: ${typeof e}`);
      return;
    }
    const t = this.parseQuickFilter(e);
    this.quickFilter !== t && (this.quickFilter = t, this.setQuickFilterParts(), this.dispatchEvent({ type: vt.EVENT_QUICK_FILTER_CHANGED }));
  }
  setQuickFilterParserAndMatcher() {
    const e = this.gos.get("quickFilterParser"), t = this.gos.get("quickFilterMatcher"), i = e !== this.parser || t !== this.matcher;
    this.parser = e, this.matcher = t, i && (this.setQuickFilterParts(), this.dispatchEvent({ type: vt.EVENT_QUICK_FILTER_CHANGED }));
  }
  onQuickFilterColumnConfigChanged() {
    this.columnModel.refreshQuickFilterColumns(), this.resetQuickFilterCache(), this.isQuickFilterPresent() && this.dispatchEvent({ type: vt.EVENT_QUICK_FILTER_CHANGED });
  }
  doesRowPassQuickFilterNoCache(e, t) {
    return this.columnModel.getAllColumnsForQuickFilter().some((s) => {
      const o = this.getQuickFilterTextForColumn(s, e);
      return b(o) && o.indexOf(t) >= 0;
    });
  }
  doesRowPassQuickFilterCache(e, t) {
    return this.checkGenerateQuickFilterAggregateText(e), e.quickFilterAggregateText.indexOf(t) >= 0;
  }
  doesRowPassQuickFilterMatcher(e, t) {
    let i;
    e ? (this.checkGenerateQuickFilterAggregateText(t), i = t.quickFilterAggregateText) : i = this.getQuickFilterAggregateText(t);
    const { quickFilterParts: s, matcher: o } = this;
    return o(s, i);
  }
  checkGenerateQuickFilterAggregateText(e) {
    e.quickFilterAggregateText || (e.quickFilterAggregateText = this.getQuickFilterAggregateText(e));
  }
  getQuickFilterTextForColumn(e, t) {
    let i = this.valueService.getValue(e, t, !0);
    const s = e.getColDef();
    if (s.getQuickFilterText) {
      const o = this.gos.addGridCommonParams({
        value: i,
        node: t,
        data: t.data,
        column: e,
        colDef: s
      });
      i = s.getQuickFilterText(o);
    }
    return b(i) ? i.toString().toUpperCase() : null;
  }
  getQuickFilterAggregateText(e) {
    const t = [];
    return this.columnModel.getAllColumnsForQuickFilter().forEach((s) => {
      const o = this.getQuickFilterTextForColumn(s, e);
      b(o) && t.push(o);
    }), t.join(vt.QUICK_FILTER_SEPARATOR);
  }
};
vt.EVENT_QUICK_FILTER_CHANGED = "quickFilterChanged";
vt.QUICK_FILTER_SEPARATOR = `
`;
u([
  f("valueService")
], vt.prototype, "valueService", 2);
u([
  f("columnModel")
], vt.prototype, "columnModel", 2);
u([
  f("rowModel")
], vt.prototype, "rowModel", 2);
u([
  L
], vt.prototype, "postConstruct", 1);
vt = u([
  O("quickFilterService")
], vt);
var Ot = class extends F {
  constructor() {
    super(...arguments), this.allColumnFilters = /* @__PURE__ */ new Map(), this.allColumnListeners = /* @__PURE__ */ new Map(), this.activeAggregateFilters = [], this.activeColumnFilters = [], this.processingFilterChange = !1, this.filterModelUpdateQueue = [], this.columnFilterModelUpdateQueue = [], this.advancedFilterModelUpdateQueue = [];
  }
  init() {
    var e, t, i;
    this.addManagedListener(this.eventService, p.EVENT_GRID_COLUMNS_CHANGED, () => this.onColumnsChanged()), this.addManagedListener(this.eventService, p.EVENT_COLUMN_VALUE_CHANGED, () => this.refreshFiltersForAggregations()), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PIVOT_CHANGED, () => this.refreshFiltersForAggregations()), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PIVOT_MODE_CHANGED, () => this.refreshFiltersForAggregations()), this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, () => this.updateAdvancedFilterColumns()), this.addManagedListener(this.eventService, p.EVENT_COLUMN_VISIBLE, () => this.updateAdvancedFilterColumns()), this.addManagedListener(this.eventService, p.EVENT_ROW_DATA_UPDATED, () => this.onNewRowsLoaded("rowDataUpdated")), this.externalFilterPresent = this.isExternalFilterPresentCallback(), this.addManagedPropertyListeners(["isExternalFilterPresent", "doesExternalFilterPass"], () => {
      this.onFilterChanged({ source: "api" });
    }), this.updateAggFiltering(), this.addManagedPropertyListener("groupAggFiltering", () => {
      this.updateAggFiltering(), this.onFilterChanged();
    }), this.addManagedPropertyListener("advancedFilterModel", (s) => this.setAdvancedFilterModel(s.currentValue)), this.addManagedListener(
      this.eventService,
      p.EVENT_ADVANCED_FILTER_ENABLED_CHANGED,
      ({ enabled: s }) => this.onAdvancedFilterEnabledChanged(s)
    ), this.addManagedListener(this.eventService, p.EVENT_DATA_TYPES_INFERRED, () => this.processFilterModelUpdateQueue()), this.addManagedListener(this.quickFilterService, vt.EVENT_QUICK_FILTER_CHANGED, () => this.onFilterChanged({ source: "quickFilter" })), this.initialFilterModel = _({}, (i = (t = (e = this.gos.get("initialState")) == null ? void 0 : e.filter) == null ? void 0 : t.filterModel) != null ? i : {});
  }
  isExternalFilterPresentCallback() {
    const e = this.gos.getCallback("isExternalFilterPresent");
    return typeof e == "function" ? e({}) : !1;
  }
  doesExternalFilterPass(e) {
    const t = this.gos.get("doesExternalFilterPass");
    return typeof t == "function" ? t(e) : !1;
  }
  setFilterModel(e, t = "api") {
    if (this.isAdvancedFilterEnabled()) {
      this.warnAdvancedFilters();
      return;
    }
    if (this.dataTypeService.isPendingInference()) {
      this.filterModelUpdateQueue.push({ model: e, source: t });
      return;
    }
    const i = [], s = this.getFilterModel();
    if (e) {
      const o = Fa(Object.keys(e));
      this.allColumnFilters.forEach((r, n) => {
        const l = e[n];
        i.push(this.setModelOnFilterWrapper(r.filterPromise, l)), o.delete(n);
      }), o.forEach((r) => {
        const n = this.columnModel.getPrimaryColumn(r) || this.columnModel.getGridColumn(r);
        if (!n) {
          console.warn("AG Grid: setFilterModel() - no column found for colId: " + r);
          return;
        }
        if (!n.isFilterAllowed()) {
          console.warn("AG Grid: setFilterModel() - unable to fully apply model, filtering disabled for colId: " + r);
          return;
        }
        const l = this.getOrCreateFilterWrapper(n, "NO_UI");
        if (!l) {
          console.warn("AG-Grid: setFilterModel() - unable to fully apply model, unable to create filter for colId: " + r);
          return;
        }
        i.push(this.setModelOnFilterWrapper(l.filterPromise, e[r]));
      });
    } else
      this.allColumnFilters.forEach((o) => {
        i.push(this.setModelOnFilterWrapper(o.filterPromise, null));
      });
    _e.all(i).then(() => {
      const o = this.getFilterModel(), r = [];
      this.allColumnFilters.forEach((n, l) => {
        const a = s ? s[l] : null, d = o ? o[l] : null;
        W.jsonEquals(a, d) || r.push(n.column);
      }), r.length > 0 && this.onFilterChanged({ columns: r, source: t });
    });
  }
  setModelOnFilterWrapper(e, t) {
    return new _e((i) => {
      e.then((s) => {
        typeof s.setModel != "function" && (console.warn("AG Grid: filter missing setModel method, which is needed for setFilterModel"), i()), (s.setModel(t) || _e.resolve()).then(() => i());
      });
    });
  }
  getFilterModel() {
    const e = {};
    return this.allColumnFilters.forEach((t, i) => {
      const s = this.getModelFromFilterWrapper(t);
      b(s) && (e[i] = s);
    }), e;
  }
  getModelFromFilterWrapper(e) {
    var t;
    const s = e.filterPromise.resolveNow(null, (o) => o);
    return s == null ? (t = this.initialFilterModel[e.column.getColId()]) != null ? t : null : typeof s.getModel != "function" ? (console.warn("AG Grid: filter API missing getModel method, which is needed for getFilterModel"), null) : s.getModel();
  }
  isColumnFilterPresent() {
    return this.activeColumnFilters.length > 0;
  }
  isAggregateFilterPresent() {
    return !!this.activeAggregateFilters.length;
  }
  isExternalFilterPresent() {
    return this.externalFilterPresent;
  }
  isChildFilterPresent() {
    return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.isExternalFilterPresent() || this.isAdvancedFilterPresent();
  }
  isAdvancedFilterPresent() {
    return this.isAdvancedFilterEnabled() && this.advancedFilterService.isFilterPresent();
  }
  onAdvancedFilterEnabledChanged(e) {
    var t;
    e ? this.allColumnFilters.size && (this.allColumnFilters.forEach((i) => this.disposeFilterWrapper(i, "advancedFilterEnabled")), this.onFilterChanged({ source: "advancedFilter" })) : (t = this.advancedFilterService) != null && t.isFilterPresent() && (this.advancedFilterService.setModel(null), this.onFilterChanged({ source: "advancedFilter" }));
  }
  isAdvancedFilterEnabled() {
    var e;
    return !!((e = this.advancedFilterService) != null && e.isEnabled());
  }
  isAdvancedFilterHeaderActive() {
    return this.isAdvancedFilterEnabled() && this.advancedFilterService.isHeaderActive();
  }
  doAggregateFiltersPass(e, t) {
    return this.doColumnFiltersPass(e, t, !0);
  }
  // called by:
  // 1) onFilterChanged()
  // 2) onNewRowsLoaded()
  updateActiveFilters() {
    this.activeColumnFilters.length = 0, this.activeAggregateFilters.length = 0;
    const e = (s) => s ? s.isFilterActive ? s.isFilterActive() : (console.warn("AG Grid: Filter is missing isFilterActive() method"), !1) : !1, t = !!this.gos.getGroupAggFiltering(), i = (s) => {
      if (!s.isPrimary())
        return !0;
      const r = !this.columnModel.isPivotActive();
      return !s.isValueActive() || !r ? !1 : this.columnModel.isPivotMode() ? !0 : t;
    };
    this.allColumnFilters.forEach((s) => {
      if (s.filterPromise.resolveNow(!1, e)) {
        const o = s.filterPromise.resolveNow(null, (r) => r);
        i(s.column) ? this.activeAggregateFilters.push(o) : this.activeColumnFilters.push(o);
      }
    });
  }
  updateFilterFlagInColumns(e, t) {
    this.allColumnFilters.forEach((i) => {
      const s = i.filterPromise.resolveNow(!1, (o) => o.isFilterActive());
      i.column.setFilterActive(s, e, t);
    });
  }
  isAnyFilterPresent() {
    return this.isQuickFilterPresent() || this.isColumnFilterPresent() || this.isAggregateFilterPresent() || this.isExternalFilterPresent() || this.isAdvancedFilterPresent();
  }
  doColumnFiltersPass(e, t, i) {
    const { data: s, aggData: o } = e, r = i ? this.activeAggregateFilters : this.activeColumnFilters, n = i ? o : s;
    for (let l = 0; l < r.length; l++) {
      const a = r[l];
      if (!(a == null || a === t)) {
        if (typeof a.doesFilterPass != "function")
          throw new Error("Filter is missing method doesFilterPass");
        if (!a.doesFilterPass({ node: e, data: n }))
          return !1;
      }
    }
    return !0;
  }
  resetQuickFilterCache() {
    this.quickFilterService.resetQuickFilterCache();
  }
  refreshFiltersForAggregations() {
    this.gos.getGroupAggFiltering() && this.onFilterChanged();
  }
  // sometimes (especially in React) the filter can call onFilterChanged when we are in the middle
  // of a render cycle. this would be bad, so we wait for render cycle to complete when this happens.
  // this happens in react when we change React State in the grid (eg setting RowCtrl's in RowContainer)
  // which results in React State getting applied in the main application, triggering a useEffect() to
  // be kicked off adn then the application calling the grid's API. in AG-6554, the custom filter was
  // getting it's useEffect() triggered in this way.
  callOnFilterChangedOutsideRenderCycle(e) {
    const t = () => this.onFilterChanged(e);
    this.rowRenderer.isRefreshInProgress() ? setTimeout(t, 0) : t();
  }
  onFilterChanged(e = {}) {
    const { source: t, filterInstance: i, additionalEventAttributes: s, columns: o } = e;
    this.updateDependantFilters(), this.updateActiveFilters(), this.updateFilterFlagInColumns("filterChanged", s), this.externalFilterPresent = this.isExternalFilterPresentCallback(), this.allColumnFilters.forEach((n) => {
      n.filterPromise && n.filterPromise.then((l) => {
        l && l !== i && l.onAnyFilterChanged && l.onAnyFilterChanged();
      });
    });
    const r = {
      source: t,
      type: p.EVENT_FILTER_CHANGED,
      columns: o || []
    };
    s && ft(r, s), this.processingFilterChange = !0, this.eventService.dispatchEvent(r), this.processingFilterChange = !1;
  }
  isSuppressFlashingCellsBecauseFiltering() {
    var e;
    return !((e = this.gos.get("allowShowChangeAfterFilter")) != null ? e : !1) && this.processingFilterChange;
  }
  isQuickFilterPresent() {
    return this.quickFilterService.isQuickFilterPresent();
  }
  updateAggFiltering() {
    this.aggFiltering = !!this.gos.getGroupAggFiltering();
  }
  isAggregateQuickFilterPresent() {
    return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
  }
  isNonAggregateQuickFilterPresent() {
    return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
  }
  shouldApplyQuickFilterAfterAgg() {
    return (this.aggFiltering || this.columnModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
  }
  doesRowPassOtherFilters(e, t) {
    return this.doesRowPassFilter({ rowNode: t, filterInstanceToSkip: e });
  }
  doesRowPassAggregateFilters(e) {
    return !(this.isAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(e.rowNode) || this.isAggregateFilterPresent() && !this.doAggregateFiltersPass(e.rowNode, e.filterInstanceToSkip));
  }
  doesRowPassFilter(e) {
    return !(this.isNonAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(e.rowNode) || this.isExternalFilterPresent() && !this.doesExternalFilterPass(e.rowNode) || this.isColumnFilterPresent() && !this.doColumnFiltersPass(e.rowNode, e.filterInstanceToSkip) || this.isAdvancedFilterPresent() && !this.advancedFilterService.doesFilterPass(e.rowNode));
  }
  onNewRowsLoaded(e) {
    this.allColumnFilters.forEach((t) => {
      t.filterPromise.then((i) => {
        i.onNewRowsLoaded && i.onNewRowsLoaded();
      });
    }), this.updateFilterFlagInColumns(e, { afterDataChange: !0 }), this.updateActiveFilters();
  }
  createValueGetter(e) {
    return ({ node: t }) => this.valueService.getValue(e, t, !0);
  }
  createGetValue(e) {
    return (t, i) => {
      const s = i ? this.columnModel.getGridColumn(i) : e;
      return s ? this.valueService.getValue(s, t, !0) : void 0;
    };
  }
  getFilterComponent(e, t, i = !0) {
    var s;
    if (i)
      return ((s = this.getOrCreateFilterWrapper(e, t)) == null ? void 0 : s.filterPromise) || null;
    const o = this.cachedFilter(e);
    return o ? o.filterPromise : null;
  }
  isFilterActive(e) {
    const t = this.cachedFilter(e);
    return !!t && t.filterPromise.resolveNow(!1, (i) => i.isFilterActive());
  }
  getOrCreateFilterWrapper(e, t) {
    if (!e.isFilterAllowed())
      return null;
    let i = this.cachedFilter(e);
    return i || (i = this.createFilterWrapper(e, t), this.setColumnFilterWrapper(e, i)), i;
  }
  cachedFilter(e) {
    return this.allColumnFilters.get(e.getColId());
  }
  getDefaultFilter(e) {
    let t;
    if (le.__isRegistered("@ag-grid-enterprise/set-filter", this.context.getGridId()))
      t = "agSetColumnFilter";
    else {
      const i = this.dataTypeService.getBaseDataType(e);
      i === "number" ? t = "agNumberColumnFilter" : i === "date" || i === "dateString" ? t = "agDateColumnFilter" : t = "agTextColumnFilter";
    }
    return t;
  }
  getDefaultFloatingFilter(e) {
    let t;
    if (le.__isRegistered("@ag-grid-enterprise/set-filter", this.context.getGridId()))
      t = "agSetColumnFloatingFilter";
    else {
      const i = this.dataTypeService.getBaseDataType(e);
      i === "number" ? t = "agNumberColumnFloatingFilter" : i === "date" || i === "dateString" ? t = "agDateColumnFloatingFilter" : t = "agTextColumnFloatingFilter";
    }
    return t;
  }
  createFilterInstance(e) {
    const t = this.getDefaultFilter(e), i = e.getColDef();
    let s;
    const o = Re(_({}, this.createFilterParams(e, i)), {
      filterModifiedCallback: () => this.filterModifiedCallbackFactory(s, e)(),
      filterChangedCallback: (n) => this.filterChangedCallbackFactory(s, e)(n),
      doesRowPassOtherFilter: (n) => this.doesRowPassOtherFilters(s, n)
    }), r = this.userComponentFactory.getFilterDetails(i, o, t);
    return r ? {
      filterPromise: () => {
        const n = r.newAgStackInstance();
        return n && n.then((l) => s = l), n;
      },
      compDetails: r
    } : { filterPromise: null, compDetails: null };
  }
  createFilterParams(e, t) {
    return this.gos.addGridCommonParams({
      column: e,
      colDef: ea(t),
      rowModel: this.rowModel,
      filterChangedCallback: () => {
      },
      filterModifiedCallback: () => {
      },
      valueGetter: this.createValueGetter(e),
      getValue: this.createGetValue(e),
      doesRowPassOtherFilter: () => !0
    });
  }
  createFilterWrapper(e, t) {
    var i;
    const s = {
      column: e,
      filterPromise: null,
      compiledElement: null,
      compDetails: null
    }, { filterPromise: o, compDetails: r } = this.createFilterInstance(e);
    return s.filterPromise = (i = o == null ? void 0 : o()) != null ? i : null, s.compDetails = r, s;
  }
  onColumnsChanged() {
    const e = [];
    this.allColumnFilters.forEach((t, i) => {
      let s;
      t.column.isPrimary() ? s = this.columnModel.getPrimaryColumn(i) : s = this.columnModel.getGridColumn(i), !(s && s === t.column) && (e.push(t.column), this.disposeFilterWrapper(t, "columnChanged"), this.disposeColumnListener(i));
    }), e.length > 0 ? this.onFilterChanged({ columns: e, source: "api" }) : this.updateDependantFilters();
  }
  updateDependantFilters() {
    const e = this.columnModel.getGroupAutoColumns();
    e == null || e.forEach((t) => {
      t.getColDef().filter === "agGroupColumnFilter" && this.getOrCreateFilterWrapper(t, "NO_UI");
    });
  }
  // for group filters, can change dynamically whether they are allowed or not
  isFilterAllowed(e) {
    var t, i;
    if (this.isAdvancedFilterEnabled() || !e.isFilterAllowed())
      return !1;
    const o = this.allColumnFilters.get(e.getColId());
    return (i = (t = o == null ? void 0 : o.filterPromise) == null ? void 0 : t.resolveNow(
      !0,
      // defer to filter component isFilterAllowed if it exists
      (r) => typeof (r == null ? void 0 : r.isFilterAllowed) == "function" ? r == null ? void 0 : r.isFilterAllowed() : !0
    )) != null ? i : !0;
  }
  getFloatingFilterCompDetails(e, t) {
    const i = (a) => {
      const d = this.getFilterComponent(e, "NO_UI");
      d != null && d.then((c) => {
        a(ts(c));
      });
    }, s = e.getColDef(), o = Re(_({}, this.createFilterParams(e, s)), {
      filterChangedCallback: () => i((a) => this.filterChangedCallbackFactory(a, e)())
    }), r = this.userComponentFactory.mergeParamsWithApplicationProvidedParams(s, Hl, o);
    let n = this.userComponentFactory.getDefaultFloatingFilterType(s, () => this.getDefaultFloatingFilter(e));
    n == null && (n = "agReadOnlyFloatingFilter");
    const l = {
      column: e,
      filterParams: r,
      currentParentModel: () => this.getCurrentFloatingFilterParentModel(e),
      parentFilterInstance: i,
      showParentFilter: t,
      suppressFilterButton: !1
      // This one might be overridden from the colDef
    };
    return this.userComponentFactory.getFloatingFilterCompDetails(s, l, n);
  }
  getCurrentFloatingFilterParentModel(e) {
    const t = this.getFilterComponent(e, "NO_UI", !1);
    return t ? t.resolveNow(null, (i) => i && i.getModel()) : null;
  }
  // destroys the filter, so it no longer takes part
  destroyFilter(e, t = "api") {
    const i = e.getColId(), s = this.allColumnFilters.get(i);
    this.disposeColumnListener(i), delete this.initialFilterModel[i], s && (this.disposeFilterWrapper(s, t), this.onFilterChanged({
      columns: [e],
      source: "api"
    }));
  }
  disposeColumnListener(e) {
    const t = this.allColumnListeners.get(e);
    t && (this.allColumnListeners.delete(e), t());
  }
  disposeFilterWrapper(e, t) {
    e.filterPromise.then((i) => {
      this.getContext().destroyBean(i), e.column.setFilterActive(!1, "filterDestroyed"), this.allColumnFilters.delete(e.column.getColId());
      const s = {
        type: p.EVENT_FILTER_DESTROYED,
        source: t,
        column: e.column
      };
      this.eventService.dispatchEvent(s);
    });
  }
  filterModifiedCallbackFactory(e, t) {
    return () => {
      const i = {
        type: p.EVENT_FILTER_MODIFIED,
        column: t,
        filterInstance: e
      };
      this.eventService.dispatchEvent(i);
    };
  }
  filterChangedCallbackFactory(e, t) {
    return (i) => {
      var s;
      const o = (s = i == null ? void 0 : i.source) != null ? s : "api", r = {
        filter: e,
        additionalEventAttributes: i,
        columns: [t],
        source: o
      };
      this.callOnFilterChangedOutsideRenderCycle(r);
    };
  }
  checkDestroyFilter(e) {
    const t = this.allColumnFilters.get(e);
    if (!t)
      return;
    const i = t.column, { compDetails: s } = i.isFilterAllowed() ? this.createFilterInstance(i) : { compDetails: null };
    if (this.areFilterCompsDifferent(t.compDetails, s)) {
      this.destroyFilter(i, "paramsUpdated");
      return;
    }
    const o = i.getColDef().filterParams;
    if (!t.filterPromise) {
      this.destroyFilter(i, "paramsUpdated");
      return;
    }
    t.filterPromise.then((r) => {
      (r != null && r.refresh ? r.refresh(_(Re(_({}, this.createFilterParams(i, i.getColDef())), {
        filterModifiedCallback: this.filterModifiedCallbackFactory(r, i),
        filterChangedCallback: this.filterChangedCallbackFactory(r, i),
        doesRowPassOtherFilter: (l) => this.doesRowPassOtherFilters(r, l)
      }), o)) : !0) === !1 && this.destroyFilter(i, "paramsUpdated");
    });
  }
  setColumnFilterWrapper(e, t) {
    const i = e.getColId();
    this.allColumnFilters.set(i, t), this.allColumnListeners.set(
      i,
      this.addManagedListener(
        e,
        pe.EVENT_COL_DEF_CHANGED,
        () => this.checkDestroyFilter(i)
      )
    );
  }
  areFilterCompsDifferent(e, t) {
    if (!t || !e)
      return !0;
    const { componentClass: i } = e, { componentClass: s } = t;
    return !(i === s || // react hooks returns new wrappers, so check nested render method
    (i == null ? void 0 : i.render) && (s == null ? void 0 : s.render) && i.render === s.render);
  }
  getAdvancedFilterModel() {
    return this.isAdvancedFilterEnabled() ? this.advancedFilterService.getModel() : null;
  }
  setAdvancedFilterModel(e) {
    if (this.isAdvancedFilterEnabled()) {
      if (this.dataTypeService.isPendingInference()) {
        this.advancedFilterModelUpdateQueue.push(e);
        return;
      }
      this.advancedFilterService.setModel(e ?? null), this.onFilterChanged({ source: "advancedFilter" });
    }
  }
  showAdvancedFilterBuilder(e) {
    this.isAdvancedFilterEnabled() && this.advancedFilterService.getCtrl().toggleFilterBuilder(e, !0);
  }
  updateAdvancedFilterColumns() {
    this.isAdvancedFilterEnabled() && this.advancedFilterService.updateValidity() && this.onFilterChanged({ source: "advancedFilter" });
  }
  hasFloatingFilters() {
    return this.isAdvancedFilterEnabled() ? !1 : this.columnModel.getAllGridColumns().some((t) => t.getColDef().floatingFilter);
  }
  getFilterInstance(e, t) {
    if (this.isAdvancedFilterEnabled()) {
      this.warnAdvancedFilters();
      return;
    }
    const i = this.getFilterInstanceImpl(e, (o) => {
      if (!t)
        return;
      const r = ts(o);
      t(r);
    });
    return ts(i);
  }
  getColumnFilterInstance(e) {
    return new Promise((t) => {
      this.getFilterInstance(e, (i) => {
        t(i);
      });
    });
  }
  getFilterInstanceImpl(e, t) {
    const i = this.columnModel.getPrimaryColumn(e);
    if (!i)
      return;
    const s = this.getFilterComponent(i, "NO_UI"), o = s && s.resolveNow(null, (r) => r);
    return o ? setTimeout(t, 0, o) : s && s.then((r) => {
      t(r);
    }), o;
  }
  warnAdvancedFilters() {
    H("Column Filter API methods have been disabled as Advanced Filters are enabled.");
  }
  setupAdvancedFilterHeaderComp(e) {
    var t;
    (t = this.advancedFilterService) == null || t.getCtrl().setupHeaderComp(e);
  }
  getHeaderRowCount() {
    return this.isAdvancedFilterHeaderActive() ? 1 : 0;
  }
  getHeaderHeight() {
    return this.isAdvancedFilterHeaderActive() ? this.advancedFilterService.getCtrl().getHeaderHeight() : 0;
  }
  processFilterModelUpdateQueue() {
    this.filterModelUpdateQueue.forEach(({ model: e, source: t }) => this.setFilterModel(e, t)), this.filterModelUpdateQueue = [], this.columnFilterModelUpdateQueue.forEach(({ key: e, model: t, resolve: i }) => {
      this.setColumnFilterModel(e, t).then(() => i());
    }), this.columnFilterModelUpdateQueue = [], this.advancedFilterModelUpdateQueue.forEach((e) => this.setAdvancedFilterModel(e)), this.advancedFilterModelUpdateQueue = [];
  }
  getColumnFilterModel(e) {
    const t = this.getFilterWrapper(e);
    return t ? this.getModelFromFilterWrapper(t) : null;
  }
  setColumnFilterModel(e, t) {
    if (this.isAdvancedFilterEnabled())
      return this.warnAdvancedFilters(), Promise.resolve();
    if (this.dataTypeService.isPendingInference()) {
      let r = () => {
      };
      const n = new Promise((l) => {
        r = l;
      });
      return this.columnFilterModelUpdateQueue.push({ key: e, model: t, resolve: r }), n;
    }
    const i = this.columnModel.getPrimaryColumn(e), s = i ? this.getOrCreateFilterWrapper(i, "NO_UI") : null;
    return s ? ((r) => new Promise((n) => {
      r.then((l) => n(l));
    }))(this.setModelOnFilterWrapper(s.filterPromise, t)) : Promise.resolve();
  }
  getFilterWrapper(e) {
    var t;
    const i = this.columnModel.getPrimaryColumn(e);
    return i && (t = this.cachedFilter(i)) != null ? t : null;
  }
  destroy() {
    super.destroy(), this.allColumnFilters.forEach((e) => this.disposeFilterWrapper(e, "gridDestroyed")), this.allColumnListeners.clear();
  }
};
u([
  f("valueService")
], Ot.prototype, "valueService", 2);
u([
  f("columnModel")
], Ot.prototype, "columnModel", 2);
u([
  f("rowModel")
], Ot.prototype, "rowModel", 2);
u([
  f("userComponentFactory")
], Ot.prototype, "userComponentFactory", 2);
u([
  f("rowRenderer")
], Ot.prototype, "rowRenderer", 2);
u([
  f("dataTypeService")
], Ot.prototype, "dataTypeService", 2);
u([
  f("quickFilterService")
], Ot.prototype, "quickFilterService", 2);
u([
  ue("advancedFilterService")
], Ot.prototype, "advancedFilterService", 2);
u([
  L
], Ot.prototype, "init", 1);
Ot = u([
  O("filterManager")
], Ot);
var Hn = class extends K {
  constructor(e, t) {
    super(
      /* html */
      '<div class="ag-filter"></div>'
    ), this.column = e, this.source = t, this.filterWrapper = null;
  }
  postConstruct() {
    this.createFilter(!0), this.addManagedListener(this.eventService, p.EVENT_FILTER_DESTROYED, this.onFilterDestroyed.bind(this));
  }
  hasFilter() {
    return !!this.filterWrapper;
  }
  getFilter() {
    var e, t;
    return (t = (e = this.filterWrapper) == null ? void 0 : e.filterPromise) != null ? t : null;
  }
  afterInit() {
    var e, t, i;
    return (i = (t = (e = this.filterWrapper) == null ? void 0 : e.filterPromise) == null ? void 0 : t.then(() => {
    })) != null ? i : _e.resolve();
  }
  afterGuiAttached(e) {
    var t, i;
    (i = (t = this.filterWrapper) == null ? void 0 : t.filterPromise) == null || i.then((s) => {
      var o;
      (o = s == null ? void 0 : s.afterGuiAttached) == null || o.call(s, e);
    });
  }
  afterGuiDetached() {
    var e, t;
    (t = (e = this.filterWrapper) == null ? void 0 : e.filterPromise) == null || t.then((i) => {
      var s;
      (s = i == null ? void 0 : i.afterGuiDetached) == null || s.call(i);
    });
  }
  createFilter(e) {
    var t;
    const { column: i, source: s } = this;
    this.filterWrapper = this.filterManager.getOrCreateFilterWrapper(i, s), (t = this.filterWrapper) != null && t.filterPromise && this.filterWrapper.filterPromise.then((o) => {
      let r = o.getGui();
      if (b(r) || console.warn(`AG Grid: getGui method from filter returned ${r}, it should be a DOM element or an HTML template string.`), typeof r == "string" && (r = Ct(r)), this.appendChild(r), e) {
        const n = {
          type: p.EVENT_FILTER_OPENED,
          column: i,
          source: s,
          eGui: this.getGui()
        };
        this.eventService.dispatchEvent(n);
      }
    });
  }
  onFilterDestroyed(e) {
    (e.source === "api" || e.source === "paramsUpdated") && e.column.getId() === this.column.getId() && this.columnModel.getPrimaryColumn(this.column) && (xe(this.getGui()), this.createFilter());
  }
  destroy() {
    this.filterWrapper = null, super.destroy();
  }
};
u([
  f("filterManager")
], Hn.prototype, "filterManager", 2);
u([
  f("columnModel")
], Hn.prototype, "columnModel", 2);
u([
  L
], Hn.prototype, "postConstruct", 1);
var Ba = class extends K {
  constructor(e, t) {
    super(e), this.ctrl = t;
  }
  getCtrl() {
    return this.ctrl;
  }
}, Fs = class Ch extends Ba {
  constructor(t) {
    super(Ch.TEMPLATE, t);
  }
  postConstruct() {
    const t = this.getGui(), i = {
      addOrRemoveCssClass: (s, o) => this.addOrRemoveCssClass(s, o),
      addOrRemoveBodyCssClass: (s, o) => this.eFloatingFilterBody.classList.toggle(s, o),
      setButtonWrapperDisplayed: (s) => te(this.eButtonWrapper, s),
      setCompDetails: (s) => this.setCompDetails(s),
      getFloatingFilterComp: () => this.compPromise,
      setWidth: (s) => t.style.width = s,
      setMenuIcon: (s) => this.eButtonShowMainFilter.appendChild(s)
    };
    this.ctrl.setComp(i, t, this.eButtonShowMainFilter, this.eFloatingFilterBody);
  }
  setCompDetails(t) {
    if (!t) {
      this.destroyFloatingFilterComp(), this.compPromise = null;
      return;
    }
    this.compPromise = t.newAgStackInstance(), this.compPromise.then((i) => this.afterCompCreated(i));
  }
  destroyFloatingFilterComp() {
    this.floatingFilterComp && (this.eFloatingFilterBody.removeChild(this.floatingFilterComp.getGui()), this.floatingFilterComp = this.destroyBean(this.floatingFilterComp));
  }
  afterCompCreated(t) {
    if (t) {
      if (!this.isAlive()) {
        this.destroyBean(t);
        return;
      }
      this.destroyFloatingFilterComp(), this.floatingFilterComp = t, this.eFloatingFilterBody.appendChild(t.getGui()), t.afterGuiAttached && t.afterGuiAttached();
    }
  }
};
Fs.TEMPLATE = /* html */
`<div class="ag-header-cell ag-floating-filter" role="gridcell">
            <div ref="eFloatingFilterBody" role="presentation"></div>
            <div class="ag-floating-filter-button ag-hidden" ref="eButtonWrapper" role="presentation">
                <button type="button" class="ag-button ag-floating-filter-button-button" ref="eButtonShowMainFilter" tabindex="-1"></button>
            </div>
        </div>`;
u([
  M("eFloatingFilterBody")
], Fs.prototype, "eFloatingFilterBody", 2);
u([
  M("eButtonWrapper")
], Fs.prototype, "eButtonWrapper", 2);
u([
  M("eButtonShowMainFilter")
], Fs.prototype, "eButtonShowMainFilter", 2);
u([
  L
], Fs.prototype, "postConstruct", 1);
u([
  dt
], Fs.prototype, "destroyFloatingFilterComp", 1);
var lf = Fs, kn = class extends F {
  constructor(e) {
    super(), this.view = e;
  }
  postConstruct() {
    this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this)), this.updateLayoutClasses();
  }
  updateLayoutClasses() {
    const e = this.getDomLayout(), t = {
      autoHeight: e === "autoHeight",
      normal: e === "normal",
      print: e === "print"
    }, i = t.autoHeight ? "ag-layout-auto-height" : t.print ? "ag-layout-print" : "ag-layout-normal";
    this.view.updateLayoutClasses(i, t);
  }
  // returns either 'print', 'autoHeight' or 'normal' (normal is the default)
  getDomLayout() {
    var e;
    const t = (e = this.gos.get("domLayout")) != null ? e : "normal";
    return ["normal", "print", "autoHeight"].indexOf(t) === -1 ? (H(`${t} is not valid for DOM Layout, valid values are 'normal', 'autoHeight', 'print'.`), "normal") : t;
  }
};
u([
  L
], kn.prototype, "postConstruct", 1);
var Ei = class extends F {
  constructor(e) {
    super(), this.lastScrollSource = [null, null], this.scrollLeft = -1, this.nextScrollTop = -1, this.scrollTop = -1, this.lastOffsetHeight = -1, this.lastScrollTop = -1, this.eBodyViewport = e, this.resetLastHScrollDebounced = rt(() => this.lastScrollSource[
      1
      /* Horizontal */
    ] = null, 500), this.resetLastVScrollDebounced = rt(() => this.lastScrollSource[
      0
      /* Vertical */
    ] = null, 500);
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl"), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this)), this.ctrlsService.whenReady((e) => {
      this.centerRowsCtrl = e.center, this.onDisplayedColumnsWidthChanged(), this.addScrollListener();
    });
  }
  addScrollListener() {
    const { fakeHScrollComp: e, fakeVScrollComp: t } = this.ctrlsService.getParams();
    this.addManagedListener(this.centerRowsCtrl.getViewportElement(), "scroll", this.onHScroll.bind(this)), e.onScrollCallback(this.onFakeHScroll.bind(this));
    const i = this.gos.get("debounceVerticalScrollbar"), s = i ? rt(this.onVScroll.bind(this), 100) : this.onVScroll.bind(this), o = i ? rt(this.onFakeVScroll.bind(this), 100) : this.onFakeVScroll.bind(this);
    this.addManagedListener(this.eBodyViewport, "scroll", s), t.onScrollCallback(o);
  }
  onDisplayedColumnsWidthChanged() {
    this.enableRtl && this.horizontallyScrollHeaderCenterAndFloatingCenter();
  }
  horizontallyScrollHeaderCenterAndFloatingCenter(e) {
    if (this.centerRowsCtrl == null)
      return;
    e === void 0 && (e = this.centerRowsCtrl.getCenterViewportScrollLeft());
    const i = this.enableRtl ? e : -e, {
      topCenter: s,
      stickyTopCenter: o,
      stickyBottomCenter: r,
      centerHeader: n,
      bottomCenter: l,
      fakeHScrollComp: a
    } = this.ctrlsService.getParams();
    n.setHorizontalScroll(-i), l.setContainerTranslateX(i), s.setContainerTranslateX(i), o.setContainerTranslateX(i), r.setContainerTranslateX(i);
    const d = this.centerRowsCtrl.getViewportElement(), c = this.lastScrollSource[
      1
      /* Horizontal */
    ] === 0;
    e = Math.abs(e), c ? a.setScrollPosition(e) : $o(d, e, this.enableRtl);
  }
  isControllingScroll(e, t) {
    return this.lastScrollSource[t] == null ? (this.lastScrollSource[t] = e, !0) : this.lastScrollSource[t] === e;
  }
  onFakeHScroll() {
    this.isControllingScroll(
      1,
      1
      /* Horizontal */
    ) && this.onHScrollCommon(
      1
      /* FakeContainer */
    );
  }
  onHScroll() {
    this.isControllingScroll(
      0,
      1
      /* Horizontal */
    ) && this.onHScrollCommon(
      0
      /* Container */
    );
  }
  onHScrollCommon(e) {
    const t = this.centerRowsCtrl.getViewportElement(), { scrollLeft: i } = t;
    if (this.shouldBlockScrollUpdate(1, i, !0))
      return;
    let s;
    e === 0 ? s = Ko(t, this.enableRtl) : s = this.ctrlsService.get("fakeHScrollComp").getScrollPosition(), this.doHorizontalScroll(Math.round(s)), this.resetLastHScrollDebounced();
  }
  onFakeVScroll() {
    this.isControllingScroll(
      1,
      0
      /* Vertical */
    ) && this.onVScrollCommon(
      1
      /* FakeContainer */
    );
  }
  onVScroll() {
    this.isControllingScroll(
      0,
      0
      /* Vertical */
    ) && this.onVScrollCommon(
      0
      /* Container */
    );
  }
  onVScrollCommon(e) {
    let t;
    e === 0 ? t = this.eBodyViewport.scrollTop : t = this.ctrlsService.get("fakeVScrollComp").getScrollPosition(), !this.shouldBlockScrollUpdate(0, t, !0) && (this.animationFrameService.setScrollTop(t), this.nextScrollTop = t, e === 0 ? this.ctrlsService.get("fakeVScrollComp").setScrollPosition(t) : this.eBodyViewport.scrollTop = t, this.gos.get("suppressAnimationFrame") ? this.scrollGridIfNeeded() : this.animationFrameService.schedule(), this.resetLastVScrollDebounced());
  }
  doHorizontalScroll(e) {
    const t = this.ctrlsService.get("fakeHScrollComp").getScrollPosition();
    this.scrollLeft === e && e === t || (this.scrollLeft = e, this.fireScrollEvent(
      1
      /* Horizontal */
    ), this.horizontallyScrollHeaderCenterAndFloatingCenter(e), this.centerRowsCtrl.onHorizontalViewportChanged(!0));
  }
  fireScrollEvent(e) {
    const t = {
      type: p.EVENT_BODY_SCROLL,
      direction: e === 1 ? "horizontal" : "vertical",
      left: this.scrollLeft,
      top: this.scrollTop
    };
    this.eventService.dispatchEvent(t), window.clearTimeout(this.scrollTimer), this.scrollTimer = void 0, this.scrollTimer = window.setTimeout(() => {
      const i = Re(_({}, t), {
        type: p.EVENT_BODY_SCROLL_END
      });
      this.eventService.dispatchEvent(i);
    }, 100);
  }
  shouldBlockScrollUpdate(e, t, i = !1) {
    return i && !vi() ? !1 : e === 0 ? this.shouldBlockVerticalScroll(t) : this.shouldBlockHorizontalScroll(t);
  }
  shouldBlockVerticalScroll(e) {
    const t = hr(this.eBodyViewport), { scrollHeight: i } = this.eBodyViewport;
    return e < 0 || e + t > i;
  }
  shouldBlockHorizontalScroll(e) {
    const t = this.centerRowsCtrl.getCenterWidth(), { scrollWidth: i } = this.centerRowsCtrl.getViewportElement();
    if (this.enableRtl && zo()) {
      if (e > 0)
        return !0;
    } else if (e < 0)
      return !0;
    return Math.abs(e) + t > i;
  }
  redrawRowsAfterScroll() {
    this.fireScrollEvent(
      0
      /* Vertical */
    );
  }
  // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
  // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
  // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
  // back to the left to be kept in sync.
  // adding and removing the grid from the DOM both resets the scroll position and
  // triggers a resize event, so notify listeners if the scroll position has changed
  checkScrollLeft() {
    this.scrollLeft !== this.centerRowsCtrl.getCenterViewportScrollLeft() && this.onHScrollCommon(
      0
      /* Container */
    );
  }
  scrollGridIfNeeded() {
    const e = this.scrollTop != this.nextScrollTop;
    return e && (this.scrollTop = this.nextScrollTop, this.redrawRowsAfterScroll()), e;
  }
  // called by scrollHorizontally method and alignedGridsService
  setHorizontalScrollPosition(e, t = !1) {
    const s = this.centerRowsCtrl.getViewportElement().scrollWidth - this.centerRowsCtrl.getCenterWidth();
    !t && this.shouldBlockScrollUpdate(1, e) && (this.enableRtl && zo() ? e = e > 0 ? 0 : s : e = Math.min(Math.max(e, 0), s)), $o(this.centerRowsCtrl.getViewportElement(), Math.abs(e), this.enableRtl), this.doHorizontalScroll(e);
  }
  setVerticalScrollPosition(e) {
    this.eBodyViewport.scrollTop = e;
  }
  getVScrollPosition() {
    return this.lastScrollTop = this.eBodyViewport.scrollTop, this.lastOffsetHeight = this.eBodyViewport.offsetHeight, {
      top: this.lastScrollTop,
      bottom: this.lastScrollTop + this.lastOffsetHeight
    };
  }
  /** Get an approximate scroll position that returns the last real value read.
   * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
   * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
   */
  getApproximateVScollPosition() {
    return this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0 ? {
      top: this.scrollTop,
      bottom: this.scrollTop + this.lastOffsetHeight
    } : this.getVScrollPosition();
  }
  getHScrollPosition() {
    return this.centerRowsCtrl.getHScrollPosition();
  }
  isHorizontalScrollShowing() {
    return this.centerRowsCtrl.isHorizontalScrollShowing();
  }
  // called by the headerRootComp and moveColumnController
  scrollHorizontally(e) {
    const t = this.centerRowsCtrl.getViewportElement().scrollLeft;
    return this.setHorizontalScrollPosition(t + e), this.centerRowsCtrl.getViewportElement().scrollLeft - t;
  }
  // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
  scrollToTop() {
    this.eBodyViewport.scrollTop = 0;
  }
  // Valid values for position are bottom, middle and top
  ensureNodeVisible(e, t = null) {
    const i = this.rowModel.getRowCount();
    let s = -1;
    for (let o = 0; o < i; o++) {
      const r = this.rowModel.getRow(o);
      if (typeof e == "function") {
        if (r && e(r)) {
          s = o;
          break;
        }
      } else if (e === r || e === r.data) {
        s = o;
        break;
      }
    }
    s >= 0 && this.ensureIndexVisible(s, t);
  }
  // Valid values for position are bottom, middle and top
  // position should be {'top','middle','bottom', or undefined/null}.
  // if undefined/null, then the grid will to the minimal amount of scrolling,
  // eg if grid needs to scroll up, it scrolls until row is on top,
  //    if grid needs to scroll down, it scrolls until row is on bottom,
  //    if row is already in view, grid does not scroll
  ensureIndexVisible(e, t) {
    if (this.gos.isDomLayout("print"))
      return;
    const i = this.paginationProxy.getRowCount();
    if (typeof e != "number" || e < 0 || e >= i) {
      console.warn("AG Grid: Invalid row index for ensureIndexVisible: " + e);
      return;
    }
    const o = this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel");
    this.getFrameworkOverrides().wrapIncoming(() => {
      o || this.paginationProxy.goToPageWithIndex(e);
      const r = this.ctrlsService.getGridBodyCtrl(), n = r.getStickyTopHeight(), l = r.getStickyBottomHeight(), a = this.paginationProxy.getRow(e);
      let d;
      do {
        const c = a.rowTop, h = a.rowHeight, g = this.paginationProxy.getPixelOffset(), m = a.rowTop - g, C = m + a.rowHeight, w = this.getVScrollPosition(), v = this.heightScaler.getDivStretchOffset(), y = w.top + v, E = w.bottom + v, D = E - y, R = this.heightScaler.getScrollPositionForPixel(m), T = this.heightScaler.getScrollPositionForPixel(C - D), I = Math.min((R + T) / 2, m), A = y + n > m, V = E - l < C;
        let x = null;
        t === "top" ? x = R : t === "bottom" ? x = T : t === "middle" ? x = I : A ? x = R - n : V && (x = T + l), x !== null && (this.setVerticalScrollPosition(x), this.rowRenderer.redraw({ afterScroll: !0 })), d = c !== a.rowTop || h !== a.rowHeight;
      } while (d);
      this.animationFrameService.flushAllFrames();
    });
  }
  ensureColumnVisible(e, t = "auto") {
    const i = this.columnModel.getGridColumn(e);
    if (!i || i.isPinned() || !this.columnModel.isColumnDisplayed(i))
      return;
    const s = this.getPositionedHorizontalScroll(i, t);
    this.getFrameworkOverrides().wrapIncoming(() => {
      s !== null && this.centerRowsCtrl.setCenterViewportScrollLeft(s), this.centerRowsCtrl.onHorizontalViewportChanged(), this.animationFrameService.flushAllFrames();
    });
  }
  setScrollPosition(e, t) {
    this.getFrameworkOverrides().wrapIncoming(() => {
      this.centerRowsCtrl.setCenterViewportScrollLeft(t), this.setVerticalScrollPosition(e), this.rowRenderer.redraw({ afterScroll: !0 }), this.animationFrameService.flushAllFrames();
    });
  }
  getPositionedHorizontalScroll(e, t) {
    const { columnBeforeStart: i, columnAfterEnd: s } = this.isColumnOutsideViewport(e), o = this.centerRowsCtrl.getCenterWidth() < e.getActualWidth(), r = this.centerRowsCtrl.getCenterWidth(), n = this.enableRtl;
    let l = (n ? i : s) || o, a = n ? s : i;
    t !== "auto" && (l = t === "start", a = t === "end");
    const d = t === "middle";
    if (l || a || d) {
      const { colLeft: c, colMiddle: h, colRight: g } = this.getColumnBounds(e);
      return d ? h - r / 2 : l ? n ? g : c : n ? c - r : g - r;
    }
    return null;
  }
  isColumnOutsideViewport(e) {
    const { start: t, end: i } = this.getViewportBounds(), { colLeft: s, colRight: o } = this.getColumnBounds(e), r = this.enableRtl, n = r ? t > o : i < o, l = r ? i < s : t > s;
    return { columnBeforeStart: n, columnAfterEnd: l };
  }
  getColumnBounds(e) {
    const t = this.enableRtl, i = this.columnModel.getBodyContainerWidth(), s = e.getActualWidth(), o = e.getLeft(), r = t ? -1 : 1, n = t ? i - o : o, l = n + s * r, a = n + s / 2 * r;
    return { colLeft: n, colMiddle: a, colRight: l };
  }
  getViewportBounds() {
    const e = this.centerRowsCtrl.getCenterWidth(), t = this.centerRowsCtrl.getCenterViewportScrollLeft(), i = t, s = e + t;
    return { start: i, end: s, width: e };
  }
};
u([
  f("ctrlsService")
], Ei.prototype, "ctrlsService", 2);
u([
  f("animationFrameService")
], Ei.prototype, "animationFrameService", 2);
u([
  f("paginationProxy")
], Ei.prototype, "paginationProxy", 2);
u([
  f("rowModel")
], Ei.prototype, "rowModel", 2);
u([
  f("rowContainerHeightService")
], Ei.prototype, "heightScaler", 2);
u([
  f("rowRenderer")
], Ei.prototype, "rowRenderer", 2);
u([
  f("columnModel")
], Ei.prototype, "columnModel", 2);
u([
  L
], Ei.prototype, "postConstruct", 1);
var vh = "ag-force-vertical-scroll", af = "ag-selectable", df = "ag-column-moving", ot = class extends F {
  constructor() {
    super(...arguments), this.stickyTopHeight = 0, this.stickyBottomHeight = 0;
  }
  getScrollFeature() {
    return this.bodyScrollFeature;
  }
  getBodyViewportElement() {
    return this.eBodyViewport;
  }
  setComp(e, t, i, s, o, r, n) {
    this.comp = e, this.eGridBody = t, this.eBodyViewport = i, this.eTop = s, this.eBottom = o, this.eStickyTop = r, this.eStickyBottom = n, this.setCellTextSelection(this.gos.get("enableCellTextSelection")), this.addManagedPropertyListener("enableCellTextSelection", (l) => this.setCellTextSelection(l.currentValue)), this.createManagedBean(new kn(this.comp)), this.bodyScrollFeature = this.createManagedBean(new Ei(this.eBodyViewport)), this.addRowDragListener(), this.setupRowAnimationCssClass(), this.addEventListeners(), this.addFocusListeners([s, i, o, r, n]), this.onGridColumnsChanged(), this.addBodyViewportListener(), this.setFloatingHeights(), this.disableBrowserDragging(), this.addStopEditingWhenGridLosesFocus(), this.filterManager.setupAdvancedFilterHeaderComp(s), this.ctrlsService.register("gridBodyCtrl", this);
  }
  getComp() {
    return this.comp;
  }
  addEventListeners() {
    this.addManagedListener(this.eventService, p.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
  }
  addFocusListeners(e) {
    e.forEach((t) => {
      this.addManagedListener(t, "focusin", (i) => {
        const { target: s } = i, o = os(s, "ag-root", t);
        t.classList.toggle("ag-has-focus", !o);
      }), this.addManagedListener(t, "focusout", (i) => {
        const { target: s, relatedTarget: o } = i, r = t.contains(o), n = os(o, "ag-root", t);
        os(s, "ag-root", t) || (!r || n) && t.classList.remove("ag-has-focus");
      });
    });
  }
  // used by ColumnAnimationService
  setColumnMovingCss(e) {
    this.comp.setColumnMovingCss(df, e);
  }
  setCellTextSelection(e = !1) {
    this.comp.setCellSelectableCss(af, e);
  }
  onScrollVisibilityChanged() {
    const e = this.scrollVisibleService.isVerticalScrollShowing();
    this.setVerticalScrollPaddingVisible(e), this.setStickyWidth(e), this.setStickyBottomOffsetBottom();
    const t = e && this.gos.getScrollbarWidth() || 0, i = ma() ? 16 : 0, s = `calc(100% + ${t + i}px)`;
    this.animationFrameService.requestAnimationFrame(() => this.comp.setBodyViewportWidth(s));
  }
  onGridColumnsChanged() {
    const e = this.columnModel.getAllGridColumns();
    this.comp.setColumnCount(e.length);
  }
  // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
  // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
  disableBrowserDragging() {
    this.addManagedListener(this.eGridBody, "dragstart", (e) => {
      if (e.target instanceof HTMLImageElement)
        return e.preventDefault(), !1;
    });
  }
  addStopEditingWhenGridLosesFocus() {
    if (!this.gos.get("stopEditingWhenCellsLoseFocus"))
      return;
    const e = (i) => {
      const s = i.relatedTarget;
      if (Jr(s) === null) {
        this.rowRenderer.stopEditing();
        return;
      }
      let o = (
        // see if click came from inside the viewports
        t.some((r) => r.contains(s)) && this.mouseEventService.isElementInThisGrid(s)
      );
      if (!o) {
        const r = this.popupService;
        o = r.getActivePopups().some((n) => n.contains(s)) || r.isElementWithinCustomPopup(s);
      }
      o || this.rowRenderer.stopEditing();
    }, t = [this.eBodyViewport, this.eBottom, this.eTop, this.eStickyTop, this.eStickyBottom];
    t.forEach((i) => this.addManagedListener(i, "focusout", e));
  }
  updateRowCount() {
    const e = this.headerNavigationService.getHeaderRowCount() + this.filterManager.getHeaderRowCount(), t = this.rowModel.isLastRowIndexKnown() ? this.rowModel.getRowCount() : -1, i = t === -1 ? -1 : e + t;
    this.comp.setRowCount(i);
  }
  registerBodyViewportResizeListener(e) {
    this.comp.registerBodyViewportResizeListener(e);
  }
  setVerticalScrollPaddingVisible(e) {
    const t = e ? "scroll" : "hidden";
    this.comp.setPinnedTopBottomOverflowY(t);
  }
  isVerticalScrollShowing() {
    const e = this.gos.get("alwaysShowVerticalScroll"), t = e ? vh : null, i = this.gos.isDomLayout("normal");
    return this.comp.setAlwaysVerticalScrollClass(t, e), e || i && gc(this.eBodyViewport);
  }
  setupRowAnimationCssClass() {
    const e = () => {
      const t = this.gos.isAnimateRows() && !this.rowContainerHeightService.isStretching(), i = t ? "ag-row-animation" : "ag-row-no-animation";
      this.comp.setRowAnimationCssOnBodyViewport(i, t);
    };
    e(), this.addManagedListener(this.eventService, p.EVENT_HEIGHT_SCALE_CHANGED, e), this.addManagedPropertyListener("animateRows", e);
  }
  getGridBodyElement() {
    return this.eGridBody;
  }
  addBodyViewportListener() {
    const e = this.onBodyViewportContextMenu.bind(this);
    this.addManagedListener(this.eBodyViewport, "contextmenu", e), this.mockContextMenuForIPad(e), this.addManagedListener(this.eBodyViewport, "wheel", this.onBodyViewportWheel.bind(this)), this.addManagedListener(this.eStickyTop, "wheel", this.onStickyWheel.bind(this)), this.addManagedListener(this.eStickyBottom, "wheel", this.onStickyWheel.bind(this)), this.addFullWidthContainerWheelListener();
  }
  addFullWidthContainerWheelListener() {
    const e = this.eBodyViewport.querySelector(".ag-full-width-container"), t = this.eBodyViewport.querySelector(".ag-center-cols-viewport");
    e && t && this.addManagedListener(e, "wheel", (i) => this.onFullWidthContainerWheel(i, t));
  }
  onFullWidthContainerWheel(e, t) {
    !e.deltaX || Math.abs(e.deltaY) > Math.abs(e.deltaX) || !this.mouseEventService.isEventFromThisGrid(e) || (e.preventDefault(), t.scrollBy({ left: e.deltaX }));
  }
  onBodyViewportContextMenu(e, t, i) {
    if (!e && !i)
      return;
    this.gos.get("preventDefaultOnContextMenu") && (e || i).preventDefault();
    const { target: s } = e || t;
    (s === this.eBodyViewport || s === this.ctrlsService.get("center").getViewportElement()) && this.menuService.showContextMenu({ mouseEvent: e, touchEvent: i, value: null, anchorToElement: this.eGridBody });
  }
  mockContextMenuForIPad(e) {
    if (!vi())
      return;
    const t = new je(this.eBodyViewport), i = (s) => {
      e(void 0, s.touchStart, s.touchEvent);
    };
    this.addManagedListener(t, je.EVENT_LONG_TAP, i), this.addDestroyFunc(() => t.destroy());
  }
  onBodyViewportWheel(e) {
    this.gos.get("suppressScrollWhenPopupsAreOpen") && this.popupService.hasAnchoredPopup() && e.preventDefault();
  }
  onStickyWheel(e) {
    e.preventDefault(), e.offsetY && this.scrollVertically(e.deltaY);
  }
  getGui() {
    return this.eGridBody;
  }
  // called by rowDragFeature
  scrollVertically(e) {
    const t = this.eBodyViewport.scrollTop;
    return this.bodyScrollFeature.setVerticalScrollPosition(t + e), this.eBodyViewport.scrollTop - t;
  }
  addRowDragListener() {
    this.rowDragFeature = this.createManagedBean(new Pt(this.eBodyViewport)), this.dragAndDropService.addDropTarget(this.rowDragFeature);
  }
  getRowDragFeature() {
    return this.rowDragFeature;
  }
  onPinnedRowDataChanged() {
    this.setFloatingHeights();
  }
  setFloatingHeights() {
    const { pinnedRowModel: e } = this;
    let t = e.getPinnedTopTotalHeight(), i = e.getPinnedBottomTotalHeight();
    this.comp.setTopHeight(t), this.comp.setBottomHeight(i), this.comp.setTopDisplay(t ? "inherit" : "none"), this.comp.setBottomDisplay(i ? "inherit" : "none"), this.setStickyTopOffsetTop(), this.setStickyBottomOffsetBottom();
  }
  setStickyTopHeight(e = 0) {
    this.comp.setStickyTopHeight(`${e}px`), this.stickyTopHeight = e;
  }
  getStickyTopHeight() {
    return this.stickyTopHeight;
  }
  setStickyBottomHeight(e = 0) {
    this.comp.setStickyBottomHeight(`${e}px`), this.stickyBottomHeight = e;
  }
  getStickyBottomHeight() {
    return this.stickyBottomHeight;
  }
  setStickyWidth(e) {
    if (!e)
      this.comp.setStickyTopWidth("100%"), this.comp.setStickyBottomWidth("100%");
    else {
      const t = this.gos.getScrollbarWidth();
      this.comp.setStickyTopWidth(`calc(100% - ${t}px)`), this.comp.setStickyBottomWidth(`calc(100% - ${t}px)`);
    }
  }
  onHeaderHeightChanged() {
    this.setStickyTopOffsetTop();
  }
  setStickyTopOffsetTop() {
    const t = this.ctrlsService.get("gridHeaderCtrl").getHeaderHeight() + this.filterManager.getHeaderHeight(), i = this.pinnedRowModel.getPinnedTopTotalHeight();
    let s = 0;
    t > 0 && (s += t), i > 0 && (s += i), s > 0 && (s += 1), this.comp.setStickyTopTop(`${s}px`);
  }
  setStickyBottomOffsetBottom() {
    const e = this.pinnedRowModel.getPinnedBottomTotalHeight(), i = this.scrollVisibleService.isHorizontalScrollShowing() && this.gos.getScrollbarWidth() || 0, s = e + i;
    this.comp.setStickyBottomBottom(`${s}px`);
  }
  // method will call itself if no available width. this covers if the grid
  // isn't visible, but is just about to be visible.
  sizeColumnsToFit(e, t) {
    const s = this.isVerticalScrollShowing() ? this.gos.getScrollbarWidth() : 0, r = Rs(this.eGridBody) - s;
    if (r > 0) {
      this.columnModel.sizeColumnsToFit(r, "sizeColumnsToFit", !1, e);
      return;
    }
    t === void 0 ? window.setTimeout(() => {
      this.sizeColumnsToFit(e, 100);
    }, 0) : t === 100 ? window.setTimeout(() => {
      this.sizeColumnsToFit(e, 500);
    }, 100) : t === 500 ? window.setTimeout(() => {
      this.sizeColumnsToFit(e, -1);
    }, 500) : console.warn("AG Grid: tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?");
  }
  // + rangeService
  addScrollEventListener(e) {
    this.eBodyViewport.addEventListener("scroll", e, { passive: !0 });
  }
  // + focusService
  removeScrollEventListener(e) {
    this.eBodyViewport.removeEventListener("scroll", e);
  }
};
u([
  f("animationFrameService")
], ot.prototype, "animationFrameService", 2);
u([
  f("rowContainerHeightService")
], ot.prototype, "rowContainerHeightService", 2);
u([
  f("ctrlsService")
], ot.prototype, "ctrlsService", 2);
u([
  f("columnModel")
], ot.prototype, "columnModel", 2);
u([
  f("scrollVisibleService")
], ot.prototype, "scrollVisibleService", 2);
u([
  f("menuService")
], ot.prototype, "menuService", 2);
u([
  f("headerNavigationService")
], ot.prototype, "headerNavigationService", 2);
u([
  f("dragAndDropService")
], ot.prototype, "dragAndDropService", 2);
u([
  f("pinnedRowModel")
], ot.prototype, "pinnedRowModel", 2);
u([
  f("rowRenderer")
], ot.prototype, "rowRenderer", 2);
u([
  f("popupService")
], ot.prototype, "popupService", 2);
u([
  f("mouseEventService")
], ot.prototype, "mouseEventService", 2);
u([
  f("rowModel")
], ot.prototype, "rowModel", 2);
u([
  f("filterManager")
], ot.prototype, "filterManager", 2);
var Ao = "ag-cell-range-selected", uf = "ag-cell-range-chart", cf = "ag-cell-range-single-cell", hf = "ag-cell-range-chart-category", pf = "ag-cell-range-handle", gf = "ag-cell-range-top", ff = "ag-cell-range-right", mf = "ag-cell-range-bottom", Cf = "ag-cell-range-left", vf = class {
  constructor(e, t) {
    this.beans = e, this.rangeService = e.rangeService, this.selectionHandleFactory = e.selectionHandleFactory, this.cellCtrl = t;
  }
  setComp(e, t) {
    this.cellComp = e, this.eGui = t, this.onRangeSelectionChanged();
  }
  onRangeSelectionChanged() {
    this.cellComp && (this.rangeCount = this.rangeService.getCellRangeCount(this.cellCtrl.getCellPosition()), this.hasChartRange = this.getHasChartRange(), this.cellComp.addOrRemoveCssClass(Ao, this.rangeCount !== 0), this.cellComp.addOrRemoveCssClass(`${Ao}-1`, this.rangeCount === 1), this.cellComp.addOrRemoveCssClass(`${Ao}-2`, this.rangeCount === 2), this.cellComp.addOrRemoveCssClass(`${Ao}-3`, this.rangeCount === 3), this.cellComp.addOrRemoveCssClass(`${Ao}-4`, this.rangeCount >= 4), this.cellComp.addOrRemoveCssClass(uf, this.hasChartRange), qs(this.eGui, this.rangeCount > 0 ? !0 : void 0), this.cellComp.addOrRemoveCssClass(cf, this.isSingleCell()), this.updateRangeBorders(), this.refreshHandle());
  }
  updateRangeBorders() {
    const e = this.getRangeBorders(), t = this.isSingleCell(), i = !t && e.top, s = !t && e.right, o = !t && e.bottom, r = !t && e.left;
    this.cellComp.addOrRemoveCssClass(gf, i), this.cellComp.addOrRemoveCssClass(ff, s), this.cellComp.addOrRemoveCssClass(mf, o), this.cellComp.addOrRemoveCssClass(Cf, r);
  }
  isSingleCell() {
    const { rangeService: e } = this.beans;
    return this.rangeCount === 1 && !!e && !e.isMoreThanOneCell();
  }
  getHasChartRange() {
    const { rangeService: e } = this.beans;
    if (!this.rangeCount || !e)
      return !1;
    const t = e.getCellRanges();
    return t.length > 0 && t.every((i) => Tt([
      1,
      0
      /* VALUE */
    ], i.type));
  }
  updateRangeBordersIfRangeCount() {
    this.rangeCount > 0 && (this.updateRangeBorders(), this.refreshHandle());
  }
  getRangeBorders() {
    const e = this.beans.gos.get("enableRtl");
    let t = !1, i = !1, s = !1, o = !1;
    const r = this.cellCtrl.getCellPosition().column, n = this.beans.columnModel;
    let l, a;
    e ? (l = n.getDisplayedColAfter(r), a = n.getDisplayedColBefore(r)) : (l = n.getDisplayedColBefore(r), a = n.getDisplayedColAfter(r));
    const d = this.rangeService.getCellRanges().filter(
      (c) => this.rangeService.isCellInSpecificRange(this.cellCtrl.getCellPosition(), c)
    );
    l || (o = !0), a || (i = !0);
    for (let c = 0; c < d.length && !(t && i && s && o); c++) {
      const h = d[c], g = this.rangeService.getRangeStartRow(h), m = this.rangeService.getRangeEndRow(h);
      !t && this.beans.rowPositionUtils.sameRow(g, this.cellCtrl.getCellPosition()) && (t = !0), !s && this.beans.rowPositionUtils.sameRow(m, this.cellCtrl.getCellPosition()) && (s = !0), !o && l && h.columns.indexOf(l) < 0 && (o = !0), !i && a && h.columns.indexOf(a) < 0 && (i = !0);
    }
    return { top: t, right: i, bottom: s, left: o };
  }
  refreshHandle() {
    if (this.beans.context.isDestroyed())
      return;
    const e = this.shouldHaveSelectionHandle();
    this.selectionHandle && !e && (this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle)), e && this.addSelectionHandle(), this.cellComp.addOrRemoveCssClass(pf, !!this.selectionHandle);
  }
  shouldHaveSelectionHandle() {
    const e = this.beans.gos, t = this.rangeService.getCellRanges(), i = t.length;
    if (this.rangeCount < 1 || i < 1)
      return !1;
    const s = se(t), o = this.cellCtrl.getCellPosition(), r = e.get("enableFillHandle") && !this.cellCtrl.isSuppressFillHandle(), n = e.get("enableRangeHandle");
    let l = i === 1 && !this.cellCtrl.isEditing() && (r || n);
    if (this.hasChartRange) {
      const d = t[0].type === 1 && this.rangeService.isCellInSpecificRange(o, t[0]);
      this.cellComp.addOrRemoveCssClass(hf, d), l = s.type === 0;
    }
    return l && s.endRow != null && this.rangeService.isContiguousRange(s) && this.rangeService.isBottomRightCell(s, o);
  }
  addSelectionHandle() {
    const e = this.beans.gos, t = se(this.rangeService.getCellRanges()).type, s = e.get("enableFillHandle") && z(t) ? 0 : 1;
    this.selectionHandle && this.selectionHandle.getType() !== s && (this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle)), this.selectionHandle || (this.selectionHandle = this.selectionHandleFactory.createSelectionHandle(s)), this.selectionHandle.refresh(this.cellCtrl);
  }
  destroy() {
    this.beans.context.destroyBean(this.selectionHandle);
  }
}, wf = class extends F {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.beans = t, this.column = e.getColumn(), this.rowNode = e.getRowNode();
  }
  setupRowSpan() {
    this.rowSpan = this.column.getRowSpan(this.rowNode), this.addManagedListener(this.beans.eventService, p.EVENT_NEW_COLUMNS_LOADED, () => this.onNewColumnsLoaded());
  }
  setComp(e) {
    this.eGui = e, this.setupColSpan(), this.setupRowSpan(), this.onLeftChanged(), this.onWidthChanged(), this.applyRowSpan();
  }
  onNewColumnsLoaded() {
    const e = this.column.getRowSpan(this.rowNode);
    this.rowSpan !== e && (this.rowSpan = e, this.applyRowSpan(!0));
  }
  onDisplayColumnsChanged() {
    const e = this.getColSpanningList();
    ii(this.colsSpanning, e) || (this.colsSpanning = e, this.onWidthChanged(), this.onLeftChanged());
  }
  setupColSpan() {
    this.column.getColDef().colSpan != null && (this.colsSpanning = this.getColSpanningList(), this.addManagedListener(this.beans.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayColumnsChanged.bind(this)), this.addManagedListener(this.beans.eventService, p.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onWidthChanged.bind(this)));
  }
  onWidthChanged() {
    if (!this.eGui)
      return;
    const e = this.getCellWidth();
    this.eGui.style.width = `${e}px`;
  }
  getCellWidth() {
    return this.colsSpanning ? this.colsSpanning.reduce((e, t) => e + t.getActualWidth(), 0) : this.column.getActualWidth();
  }
  getColSpanningList() {
    const e = this.column.getColSpan(this.rowNode), t = [];
    if (e === 1)
      t.push(this.column);
    else {
      let i = this.column;
      const s = this.column.getPinned();
      for (let o = 0; i && o < e && (t.push(i), i = this.beans.columnModel.getDisplayedColAfter(i), !(!i || z(i) || s !== i.getPinned())); o++)
        ;
    }
    return t;
  }
  onLeftChanged() {
    if (!this.eGui)
      return;
    const e = this.modifyLeftForPrintLayout(this.getCellLeft());
    this.eGui.style.left = e + "px";
  }
  getCellLeft() {
    let e;
    return this.beans.gos.get("enableRtl") && this.colsSpanning ? e = se(this.colsSpanning) : e = this.column, e.getLeft();
  }
  modifyLeftForPrintLayout(e) {
    if (!this.cellCtrl.isPrintLayout() || this.column.getPinned() === "left")
      return e;
    const t = this.beans.columnModel.getDisplayedColumnsLeftWidth();
    if (this.column.getPinned() === "right") {
      const i = this.beans.columnModel.getBodyContainerWidth();
      return t + i + (e || 0);
    }
    return t + (e || 0);
  }
  applyRowSpan(e) {
    if (this.rowSpan === 1 && !e)
      return;
    const i = this.beans.gos.getRowHeightAsNumber() * this.rowSpan;
    this.eGui.style.height = `${i}px`, this.eGui.style.zIndex = "1";
  }
  // overriding to make public, as we don't dispose this bean via context
  destroy() {
    super.destroy();
  }
}, Sf = class extends F {
  constructor(e, t) {
    super(), this.staticClasses = [], this.cellCtrl = e, this.beans = t, this.column = e.getColumn(), this.rowNode = e.getRowNode();
  }
  setComp(e) {
    this.cellComp = e, this.applyUserStyles(), this.applyCellClassRules(), this.applyClassesFromColDef();
  }
  applyCellClassRules() {
    const e = this.column.getColDef(), { cellClassRules: t } = e, i = this.beans.gos.addGridCommonParams({
      value: this.cellCtrl.getValue(),
      data: this.rowNode.data,
      node: this.rowNode,
      colDef: e,
      column: this.column,
      rowIndex: this.rowNode.rowIndex
    });
    this.beans.stylingService.processClassRules(
      // if current was previous, skip
      t === this.cellClassRules ? void 0 : this.cellClassRules,
      t,
      i,
      (s) => this.cellComp.addOrRemoveCssClass(s, !0),
      (s) => this.cellComp.addOrRemoveCssClass(s, !1)
    ), this.cellClassRules = t;
  }
  applyUserStyles() {
    const e = this.column.getColDef();
    if (!e.cellStyle)
      return;
    let t;
    if (typeof e.cellStyle == "function") {
      const i = this.beans.gos.addGridCommonParams({
        column: this.column,
        value: this.cellCtrl.getValue(),
        colDef: e,
        data: this.rowNode.data,
        node: this.rowNode,
        rowIndex: this.rowNode.rowIndex
      }), s = e.cellStyle;
      t = s(i);
    } else
      t = e.cellStyle;
    t && this.cellComp.setUserStyles(t);
  }
  applyClassesFromColDef() {
    const e = this.column.getColDef(), t = this.beans.gos.addGridCommonParams({
      value: this.cellCtrl.getValue(),
      data: this.rowNode.data,
      node: this.rowNode,
      column: this.column,
      colDef: e,
      rowIndex: this.rowNode.rowIndex
    });
    this.staticClasses.length && this.staticClasses.forEach((i) => this.cellComp.addOrRemoveCssClass(i, !1)), this.staticClasses = this.beans.stylingService.getStaticCellClasses(e, t), this.staticClasses.length && this.staticClasses.forEach((i) => this.cellComp.addOrRemoveCssClass(i, !0));
  }
  // overriding to make public, as we don't dispose this bean via context
  destroy() {
    super.destroy();
  }
}, q = class {
  postConstruct() {
    this.gos.isRowModelType("clientSide") && (this.clientSideRowModel = this.rowModel), this.gos.isRowModelType("serverSide") && (this.serverSideRowModel = this.rowModel);
  }
};
u([
  f("resizeObserverService")
], q.prototype, "resizeObserverService", 2);
u([
  f("paginationProxy")
], q.prototype, "paginationProxy", 2);
u([
  f("context")
], q.prototype, "context", 2);
u([
  f("gridOptionsService")
], q.prototype, "gos", 2);
u([
  f("environment")
], q.prototype, "environment", 2);
u([
  f("rowRenderer")
], q.prototype, "rowRenderer", 2);
u([
  f("valueService")
], q.prototype, "valueService", 2);
u([
  f("eventService")
], q.prototype, "eventService", 2);
u([
  f("columnModel")
], q.prototype, "columnModel", 2);
u([
  f("headerNavigationService")
], q.prototype, "headerNavigationService", 2);
u([
  f("navigationService")
], q.prototype, "navigationService", 2);
u([
  f("columnAnimationService")
], q.prototype, "columnAnimationService", 2);
u([
  f("focusService")
], q.prototype, "focusService", 2);
u([
  f("popupService")
], q.prototype, "popupService", 2);
u([
  f("stylingService")
], q.prototype, "stylingService", 2);
u([
  f("columnHoverService")
], q.prototype, "columnHoverService", 2);
u([
  f("userComponentFactory")
], q.prototype, "userComponentFactory", 2);
u([
  f("userComponentRegistry")
], q.prototype, "userComponentRegistry", 2);
u([
  f("animationFrameService")
], q.prototype, "animationFrameService", 2);
u([
  f("dragService")
], q.prototype, "dragService", 2);
u([
  f("dragAndDropService")
], q.prototype, "dragAndDropService", 2);
u([
  f("sortController")
], q.prototype, "sortController", 2);
u([
  f("filterManager")
], q.prototype, "filterManager", 2);
u([
  f("rowContainerHeightService")
], q.prototype, "rowContainerHeightService", 2);
u([
  f("frameworkOverrides")
], q.prototype, "frameworkOverrides", 2);
u([
  f("cellPositionUtils")
], q.prototype, "cellPositionUtils", 2);
u([
  f("rowPositionUtils")
], q.prototype, "rowPositionUtils", 2);
u([
  f("selectionService")
], q.prototype, "selectionService", 2);
u([
  f("rowCssClassCalculator")
], q.prototype, "rowCssClassCalculator", 2);
u([
  f("rowModel")
], q.prototype, "rowModel", 2);
u([
  f("ctrlsService")
], q.prototype, "ctrlsService", 2);
u([
  f("ctrlsFactory")
], q.prototype, "ctrlsFactory", 2);
u([
  f("agStackComponentsRegistry")
], q.prototype, "agStackComponentsRegistry", 2);
u([
  f("valueCache")
], q.prototype, "valueCache", 2);
u([
  f("rowNodeEventThrottle")
], q.prototype, "rowNodeEventThrottle", 2);
u([
  f("localeService")
], q.prototype, "localeService", 2);
u([
  f("syncService")
], q.prototype, "syncService", 2);
u([
  f("ariaAnnouncementService")
], q.prototype, "ariaAnnouncementService", 2);
u([
  ue("rangeService")
], q.prototype, "rangeService", 2);
u([
  ue("selectionHandleFactory")
], q.prototype, "selectionHandleFactory", 2);
u([
  L
], q.prototype, "postConstruct", 1);
q = u([
  O("beans")
], q);
var Ef = class extends q {
  constructor(e, t, i) {
    super(), this.cellCtrl = e, this.beans = t, this.column = i;
  }
  onMouseEvent(e, t) {
    if (!Yt(t))
      switch (e) {
        case "click":
          this.onCellClicked(t);
          break;
        case "mousedown":
        case "touchstart":
          this.onMouseDown(t);
          break;
        case "dblclick":
          this.onCellDoubleClicked(t);
          break;
        case "mouseout":
          this.onMouseOut(t);
          break;
        case "mouseover":
          this.onMouseOver(t);
          break;
      }
  }
  onCellClicked(e) {
    if (this.isDoubleClickOnIPad()) {
      this.onCellDoubleClicked(e), e.preventDefault();
      return;
    }
    const { eventService: t, rangeService: i, gos: s } = this.beans, o = e.ctrlKey || e.metaKey;
    i && o && i.getCellRangeCount(this.cellCtrl.getCellPosition()) > 1 && i.intersectLastRange(!0);
    const r = this.cellCtrl.createEvent(e, p.EVENT_CELL_CLICKED);
    t.dispatchEvent(r);
    const n = this.column.getColDef();
    n.onCellClicked && window.setTimeout(() => {
      this.beans.frameworkOverrides.wrapOutgoing(() => {
        n.onCellClicked(r);
      });
    }, 0), (s.get("singleClickEdit") || n.singleClickEdit) && !s.get("suppressClickEdit") && !(e.shiftKey && (i == null ? void 0 : i.getCellRanges().length) != 0) && this.cellCtrl.startRowOrCellEdit();
  }
  // returns true if on iPad and this is second 'click' event in 200ms
  isDoubleClickOnIPad() {
    if (!vi() || oa("dblclick"))
      return !1;
    const e = (/* @__PURE__ */ new Date()).getTime(), t = e - this.lastIPadMouseClickEvent < 200;
    return this.lastIPadMouseClickEvent = e, t;
  }
  onCellDoubleClicked(e) {
    const t = this.column.getColDef(), i = this.cellCtrl.createEvent(e, p.EVENT_CELL_DOUBLE_CLICKED);
    this.beans.eventService.dispatchEvent(i), typeof t.onCellDoubleClicked == "function" && window.setTimeout(() => {
      this.beans.frameworkOverrides.wrapOutgoing(() => {
        t.onCellDoubleClicked(i);
      });
    }, 0), !this.beans.gos.get("singleClickEdit") && !this.beans.gos.get("suppressClickEdit") && this.cellCtrl.startRowOrCellEdit(null, e);
  }
  onMouseDown(e) {
    const { ctrlKey: t, metaKey: i, shiftKey: s } = e, o = e.target, { cellCtrl: r, beans: n } = this, { eventService: l, rangeService: a, focusService: d } = n;
    if (this.isRightClickInExistingRange(e))
      return;
    const c = a && a.getCellRanges().length != 0;
    if (!s || !c) {
      const h = ri() && !r.isEditing() && !wa(o);
      r.focusCell(h);
    }
    if (s && c && !d.isCellFocused(r.getCellPosition())) {
      e.preventDefault();
      const h = d.getFocusedCell();
      if (h) {
        const { column: g, rowIndex: m, rowPinned: C } = h, w = n.rowRenderer.getRowByPosition({ rowIndex: m, rowPinned: C }), v = w == null ? void 0 : w.getCellCtrl(g);
        v != null && v.isEditing() && v.stopEditing(), d.setFocusedCell({
          column: g,
          rowIndex: m,
          rowPinned: C,
          forceBrowserFocus: !0,
          preventScrollOnBrowserFocus: !0
        });
      }
    }
    if (!this.containsWidget(o)) {
      if (a) {
        const h = this.cellCtrl.getCellPosition();
        if (s)
          a.extendLatestRangeToCell(h);
        else {
          const g = t || i;
          a.setRangeToCell(h, g);
        }
      }
      l.dispatchEvent(this.cellCtrl.createEvent(e, p.EVENT_CELL_MOUSE_DOWN));
    }
  }
  isRightClickInExistingRange(e) {
    const { rangeService: t } = this.beans;
    if (t) {
      const i = t.isCellInAnyRange(this.cellCtrl.getCellPosition()), s = e.button === 2 || e.ctrlKey && this.beans.gos.get("allowContextMenuWithControlKey");
      if (i && s)
        return !0;
    }
    return !1;
  }
  containsWidget(e) {
    return os(e, "ag-selection-checkbox", 3);
  }
  onMouseOut(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const t = this.cellCtrl.createEvent(e, p.EVENT_CELL_MOUSE_OUT);
    this.beans.eventService.dispatchEvent(t), this.beans.columnHoverService.clearMouseOver();
  }
  onMouseOver(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const t = this.cellCtrl.createEvent(e, p.EVENT_CELL_MOUSE_OVER);
    this.beans.eventService.dispatchEvent(t), this.beans.columnHoverService.setMouseOver([this.column]);
  }
  mouseStayingInsideCell(e) {
    if (!e.target || !e.relatedTarget)
      return !1;
    const t = this.cellCtrl.getGui(), i = t.contains(e.target), s = t.contains(e.relatedTarget);
    return i && s;
  }
  destroy() {
  }
}, yf = class extends F {
  constructor(e, t, i, s, o) {
    super(), this.cellCtrl = e, this.beans = t, this.rowNode = s, this.rowCtrl = o;
  }
  setComp(e) {
    this.eGui = e;
  }
  onKeyDown(e) {
    const t = e.key;
    switch (t) {
      case S.ENTER:
        this.onEnterKeyDown(e);
        break;
      case S.F2:
        this.onF2KeyDown(e);
        break;
      case S.ESCAPE:
        this.onEscapeKeyDown(e);
        break;
      case S.TAB:
        this.onTabKeyDown(e);
        break;
      case S.BACKSPACE:
      case S.DELETE:
        this.onBackspaceOrDeleteKeyDown(t, e);
        break;
      case S.DOWN:
      case S.UP:
      case S.RIGHT:
      case S.LEFT:
        this.onNavigationKeyDown(e, t);
        break;
    }
  }
  onNavigationKeyDown(e, t) {
    this.cellCtrl.isEditing() || (e.shiftKey && this.cellCtrl.isRangeSelectionEnabled() ? this.onShiftRangeSelect(e) : this.beans.navigationService.navigateToNextCell(e, t, this.cellCtrl.getCellPosition(), !0), e.preventDefault());
  }
  onShiftRangeSelect(e) {
    if (!this.beans.rangeService)
      return;
    const t = this.beans.rangeService.extendLatestRangeInDirection(e);
    t && this.beans.navigationService.ensureCellVisible(t);
  }
  onTabKeyDown(e) {
    this.beans.navigationService.onTabKeyDown(this.cellCtrl, e);
  }
  onBackspaceOrDeleteKeyDown(e, t) {
    var i;
    const { cellCtrl: s, beans: o, rowNode: r } = this, { gos: n, rangeService: l, eventService: a } = o;
    if (!s.isEditing()) {
      if (a.dispatchEvent({ type: p.EVENT_KEY_SHORTCUT_CHANGED_CELL_START }), Dc(e, n.get("enableCellEditingOnBackspace"))) {
        if (l && n.get("enableRangeSelection"))
          l.clearCellRangeCellValues({ dispatchWrapperEvents: !0, wrapperEventSource: "deleteKey" });
        else if (s.isCellEditable()) {
          const d = s.getColumn(), c = (i = this.beans.valueService.parseValue(d, r, "", r.getValueFromValueService(d))) != null ? i : null;
          r.setDataValue(d, c, "cellClear");
        }
      } else
        s.startRowOrCellEdit(e, t);
      a.dispatchEvent({ type: p.EVENT_KEY_SHORTCUT_CHANGED_CELL_END });
    }
  }
  onEnterKeyDown(e) {
    if (this.cellCtrl.isEditing() || this.rowCtrl.isEditing())
      this.cellCtrl.stopEditingAndFocus(!1, e.shiftKey);
    else if (this.beans.gos.get("enterNavigatesVertically")) {
      const t = e.shiftKey ? S.UP : S.DOWN;
      this.beans.navigationService.navigateToNextCell(null, t, this.cellCtrl.getCellPosition(), !1);
    } else
      this.cellCtrl.startRowOrCellEdit(S.ENTER, e), this.cellCtrl.isEditing() && e.preventDefault();
  }
  onF2KeyDown(e) {
    this.cellCtrl.isEditing() || this.cellCtrl.startRowOrCellEdit(S.F2, e);
  }
  onEscapeKeyDown(e) {
    this.cellCtrl.isEditing() && (this.cellCtrl.stopRowOrCellEdit(!0), this.cellCtrl.focusCell(!0));
  }
  processCharacter(e) {
    if (e.target !== this.eGui || this.cellCtrl.isEditing())
      return;
    const s = e.key;
    s === " " ? this.onSpaceKeyDown(e) : (this.cellCtrl.startRowOrCellEdit(s, e), e.preventDefault());
  }
  onSpaceKeyDown(e) {
    const { gos: t } = this.beans;
    if (!this.cellCtrl.isEditing() && t.isRowSelection()) {
      const i = this.rowNode.isSelected(), s = !i;
      if (s || !t.get("suppressRowDeselection")) {
        const o = this.beans.gos.get("groupSelectsFiltered"), r = this.rowNode.setSelectedParams({
          newValue: s,
          rangeSelect: e.shiftKey,
          groupSelectsFiltered: o,
          event: e,
          source: "spaceKey"
        });
        i === void 0 && r === 0 && this.rowNode.setSelectedParams({
          newValue: !1,
          rangeSelect: e.shiftKey,
          groupSelectsFiltered: o,
          event: e,
          source: "spaceKey"
        });
      }
    }
    e.preventDefault();
  }
  destroy() {
    super.destroy();
  }
}, wh = class extends K {
  constructor(e, t, i) {
    super(
      /* html */
      '<div class="ag-drag-handle ag-row-drag" draggable="true"></div>'
    ), this.rowNode = e, this.column = t, this.eCell = i;
  }
  postConstruct() {
    this.getGui().appendChild(Te("rowDrag", this.gos, null)), this.addGuiEventListener("mousedown", (t) => {
      t.stopPropagation();
    }), this.addDragSource(), this.checkVisibility();
  }
  addDragSource() {
    this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
  }
  onDragStart(e) {
    const t = this.column.getColDef().dndSourceOnRowDrag;
    e.dataTransfer.setDragImage(this.eCell, 0, 0);
    const i = () => {
      try {
        const s = JSON.stringify(this.rowNode.data);
        e.dataTransfer.setData("application/json", s), e.dataTransfer.setData("text/plain", s);
      } catch {
      }
    };
    if (t) {
      const s = this.gos.addGridCommonParams({
        rowNode: this.rowNode,
        dragEvent: e
      });
      t(s);
    } else
      i();
  }
  checkVisibility() {
    const e = this.column.isDndSource(this.rowNode);
    this.setDisplayed(e);
  }
};
u([
  L
], wh.prototype, "postConstruct", 1);
var Rf = "ag-column-first", Df = "ag-column-last", Bn = class {
  static getHeaderClassesFromColDef(e, t, i, s) {
    return z(e) ? [] : this.getColumnClassesFromCollDef(
      e.headerClass,
      e,
      t,
      i,
      s
    );
  }
  static getToolPanelClassesFromColDef(e, t, i, s) {
    return z(e) ? [] : this.getColumnClassesFromCollDef(
      e.toolPanelClass,
      e,
      t,
      i,
      s
    );
  }
  static refreshFirstAndLastStyles(e, t, i) {
    e.addOrRemoveCssClass(Rf, i.isColumnAtEdge(t, "first")), e.addOrRemoveCssClass(Df, i.isColumnAtEdge(t, "last"));
  }
  static getClassParams(e, t, i, s) {
    return t.addGridCommonParams({
      // bad naming, as colDef here can be a group or a column,
      // however most people won't appreciate the difference,
      // so keeping it as colDef to avoid confusion.
      colDef: e,
      column: i,
      columnGroup: s
    });
  }
  static getColumnClassesFromCollDef(e, t, i, s, o) {
    if (z(e))
      return [];
    let r;
    if (typeof e == "function") {
      const n = this.getClassParams(t, i, s, o);
      r = e(n);
    } else
      r = e;
    return typeof r == "string" ? [r] : Array.isArray(r) ? [...r] : [];
  }
}, Tf = "ag-cell", bf = "ag-cell-auto-height", Af = "ag-cell-normal-height", Pf = "ag-cell-focus", Ff = "ag-cell-first-right-pinned", Lf = "ag-cell-last-left-pinned", If = "ag-cell-not-inline-editing", Mf = "ag-column-hover", xf = "ag-cell-wrap-text", Nf = 0, Sh = class kl extends F {
  constructor(t, i, s, o) {
    super(), this.cellRangeFeature = null, this.cellPositionFeature = null, this.cellCustomStyleFeature = null, this.tooltipFeature = null, this.cellMouseListenerFeature = null, this.cellKeyboardListenerFeature = null, this.suppressRefreshCell = !1, this.onCellCompAttachedFuncs = [], this.column = t, this.rowNode = i, this.beans = s, this.rowCtrl = o, this.instanceId = t.getId() + "-" + Nf++, this.colIdSanitised = Oe(this.column.getId()), s.gos.get("suppressCellFocus") || (this.tabIndex = -1), this.createCellPosition(), this.addFeatures(), this.updateAndFormatValue(!1);
  }
  shouldRestoreFocus() {
    return this.beans.focusService.shouldRestoreFocus(this.cellPosition);
  }
  addFeatures() {
    this.cellPositionFeature = new wf(this, this.beans), this.addDestroyFunc(() => {
      var i;
      (i = this.cellPositionFeature) == null || i.destroy(), this.cellPositionFeature = null;
    }), this.cellCustomStyleFeature = new Sf(this, this.beans), this.addDestroyFunc(() => {
      var i;
      (i = this.cellCustomStyleFeature) == null || i.destroy(), this.cellCustomStyleFeature = null;
    }), this.cellMouseListenerFeature = new Ef(this, this.beans, this.column), this.addDestroyFunc(() => {
      var i;
      (i = this.cellMouseListenerFeature) == null || i.destroy(), this.cellMouseListenerFeature = null;
    }), this.cellKeyboardListenerFeature = new yf(this, this.beans, this.column, this.rowNode, this.rowCtrl), this.addDestroyFunc(() => {
      var i;
      (i = this.cellKeyboardListenerFeature) == null || i.destroy(), this.cellKeyboardListenerFeature = null;
    }), this.column.isTooltipEnabled() && (this.enableTooltipFeature(), this.addDestroyFunc(() => {
      this.disableTooltipFeature();
    })), this.beans.rangeService && this.beans.gos.get("enableRangeSelection") && (this.cellRangeFeature = new vf(this.beans, this), this.addDestroyFunc(() => {
      var i;
      (i = this.cellRangeFeature) == null || i.destroy(), this.cellRangeFeature = null;
    }));
  }
  enableTooltipFeature(t, i) {
    const s = () => {
      const n = this.column.getColDef(), l = this.rowNode.data;
      if (n.tooltipField && b(l))
        return Us(l, n.tooltipField, this.column.isTooltipFieldContainsDots());
      const a = n.tooltipValueGetter;
      return a ? a(this.beans.gos.addGridCommonParams({
        location: "cell",
        colDef: this.column.getColDef(),
        column: this.column,
        rowIndex: this.cellPosition.rowIndex,
        node: this.rowNode,
        data: this.rowNode.data,
        value: this.value,
        valueFormatted: this.valueFormatted
      })) : null;
    }, o = this.beans.gos.get("tooltipShowMode") === "whenTruncated";
    !i && o && !this.isCellRenderer() && (i = () => {
      const n = this.getGui(), l = n.children.length === 0 ? n : n.querySelector(".ag-cell-value");
      return l ? l.scrollWidth > l.clientWidth : !0;
    });
    const r = {
      getColumn: () => this.column,
      getColDef: () => this.column.getColDef(),
      getRowIndex: () => this.cellPosition.rowIndex,
      getRowNode: () => this.rowNode,
      getGui: () => this.getGui(),
      getLocation: () => "cell",
      getTooltipValue: t != null ? () => t : s,
      // this makes no sense, why is the cell formatted value passed to the tooltip???
      getValueFormatted: () => this.valueFormatted,
      shouldDisplayTooltip: i
    };
    this.tooltipFeature = new wi(r, this.beans);
  }
  disableTooltipFeature() {
    this.tooltipFeature && (this.tooltipFeature.destroy(), this.tooltipFeature = null);
  }
  setComp(t, i, s, o, r) {
    var n, l, a, d;
    this.cellComp = t, this.eGui = i, this.printLayout = o, this.addDomData(), this.onCellFocused(this.focusEventToRestore), this.applyStaticCssClasses(), this.setWrapText(), this.onFirstRightPinnedChanged(), this.onLastLeftPinnedChanged(), this.onColumnHover(), this.setupControlComps(), this.setupAutoHeight(s), this.refreshFirstAndLastStyles(), this.refreshAriaColIndex(), (n = this.cellPositionFeature) == null || n.setComp(i), (l = this.cellCustomStyleFeature) == null || l.setComp(t), (a = this.tooltipFeature) == null || a.refreshToolTip(), (d = this.cellKeyboardListenerFeature) == null || d.setComp(this.eGui), this.cellRangeFeature && this.cellRangeFeature.setComp(t, i), r && this.isCellEditable() ? this.startEditing() : this.showValue(), this.onCellCompAttachedFuncs.length && (this.onCellCompAttachedFuncs.forEach((c) => c()), this.onCellCompAttachedFuncs = []);
  }
  setupAutoHeight(t) {
    if (this.isAutoHeight = this.column.isAutoHeight(), !this.isAutoHeight || !t)
      return;
    const i = t.parentElement, s = this.beans.gos.getRowHeightForNode(this.rowNode).height, o = (l) => {
      if (this.editing || !this.isAlive())
        return;
      const { paddingTop: a, paddingBottom: d, borderBottomWidth: c, borderTopWidth: h } = Vi(i), g = a + d + c + h, C = t.offsetHeight + g;
      if (l < 5) {
        const v = this.beans.gos.getDocument(), y = !v || !v.contains(t), E = C == 0;
        if (y || E) {
          window.setTimeout(() => o(l + 1), 0);
          return;
        }
      }
      const w = Math.max(C, s);
      this.rowNode.setRowAutoHeight(w, this.column);
    }, r = () => o(0);
    r();
    const n = this.beans.resizeObserverService.observeResize(t, r);
    this.addDestroyFunc(() => {
      n(), this.rowNode.setRowAutoHeight(void 0, this.column);
    });
  }
  getCellAriaRole() {
    var t;
    return (t = this.column.getColDef().cellAriaRole) != null ? t : "gridcell";
  }
  getInstanceId() {
    return this.instanceId;
  }
  getColumnIdSanitised() {
    return this.colIdSanitised;
  }
  getTabIndex() {
    return this.tabIndex;
  }
  isCellRenderer() {
    const t = this.column.getColDef();
    return t.cellRenderer != null || t.cellRendererSelector != null;
  }
  getValueToDisplay() {
    var t;
    return (t = this.valueFormatted) != null ? t : this.value;
  }
  showValue(t = !1) {
    var i;
    const s = this.getValueToDisplay();
    let o;
    if (this.rowNode.stub) {
      const r = this.createCellRendererParams();
      o = this.beans.userComponentFactory.getLoadingCellRendererDetails(this.column.getColDef(), r);
    } else if (this.isCellRenderer()) {
      const r = this.createCellRendererParams();
      o = this.beans.userComponentFactory.getCellRendererDetails(this.column.getColDef(), r);
    }
    this.cellComp.setRenderDetails(o, s, t), (i = this.cellRangeFeature) == null || i.refreshHandle();
  }
  setupControlComps() {
    const t = this.column.getColDef();
    this.includeSelection = this.isIncludeControl(t.checkboxSelection), this.includeRowDrag = this.isIncludeControl(t.rowDrag), this.includeDndSource = this.isIncludeControl(t.dndSource), this.cellComp.setIncludeSelection(this.includeSelection), this.cellComp.setIncludeDndSource(this.includeDndSource), this.cellComp.setIncludeRowDrag(this.includeRowDrag);
  }
  isForceWrapper() {
    return this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
  }
  isIncludeControl(t) {
    return this.rowNode.rowPinned != null ? !1 : typeof t == "function" || t === !0;
  }
  refreshShouldDestroy() {
    const t = this.column.getColDef(), i = this.includeSelection != this.isIncludeControl(t.checkboxSelection), s = this.includeRowDrag != this.isIncludeControl(t.rowDrag), o = this.includeDndSource != this.isIncludeControl(t.dndSource), r = this.isAutoHeight != this.column.isAutoHeight();
    return i || s || o || r;
  }
  // either called internally if single cell editing, or called by rowRenderer if row editing
  startEditing(t = null, i = !1, s = null) {
    if (!this.isCellEditable() || this.editing)
      return;
    if (!this.cellComp) {
      this.onCellCompAttachedFuncs.push(() => {
        this.startEditing(t, i, s);
      });
      return;
    }
    const o = this.createCellEditorParams(t, i), r = this.column.getColDef(), n = this.beans.userComponentFactory.getCellEditorDetails(r, o);
    this.editCompDetails = n;
    const l = (n == null ? void 0 : n.popupFromSelector) != null ? n.popupFromSelector : !!r.cellEditorPopup, a = (n == null ? void 0 : n.popupPositionFromSelector) != null ? n.popupPositionFromSelector : r.cellEditorPopupPosition;
    this.setEditing(!0), this.cellComp.setEditDetails(n, l, a, this.beans.gos.get("reactiveCustomComponents"));
    const d = this.createEvent(s, p.EVENT_CELL_EDITING_STARTED);
    this.beans.eventService.dispatchEvent(d);
  }
  setEditing(t) {
    var i;
    this.editing !== t && (this.editing = t, (i = this.cellRangeFeature) == null || i.refreshHandle());
  }
  // pass in 'true' to cancel the editing.
  stopRowOrCellEdit(t = !1) {
    this.beans.gos.get("editType") === "fullRow" ? this.rowCtrl.stopEditing(t) : this.stopEditing(t);
  }
  onPopupEditorClosed() {
    this.isEditing() && this.stopEditingAndFocus();
  }
  takeValueFromCellEditor(t) {
    const i = { newValueExists: !1 };
    if (t)
      return i;
    const s = this.cellComp.getCellEditor();
    return !s || s.isCancelAfterEnd && s.isCancelAfterEnd() ? i : {
      newValue: s.getValue(),
      newValueExists: !0
    };
  }
  /**
   * @returns `True` if the value changes, otherwise `False`.
   */
  saveNewValue(t, i) {
    if (i === t)
      return !1;
    this.suppressRefreshCell = !0;
    const s = this.rowNode.setDataValue(this.column, i, "edit");
    return this.suppressRefreshCell = !1, s;
  }
  /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */
  stopEditing(t = !1) {
    if (!this.editing)
      return !1;
    const { newValue: i, newValueExists: s } = this.takeValueFromCellEditor(t), o = this.rowNode.getValueFromValueService(this.column);
    let r = !1;
    return s && (r = this.saveNewValue(o, i)), this.setEditing(!1), this.cellComp.setEditDetails(), this.editCompDetails = void 0, this.updateAndFormatValue(!1), this.refreshCell({ forceRefresh: !0, suppressFlash: !0 }), this.dispatchEditingStoppedEvent(o, i, !t && !!r), r;
  }
  dispatchEditingStoppedEvent(t, i, s) {
    const o = Re(_({}, this.createEvent(null, p.EVENT_CELL_EDITING_STOPPED)), {
      oldValue: t,
      newValue: i,
      valueChanged: s
    });
    this.beans.eventService.dispatchEvent(o);
  }
  createCellEditorParams(t, i) {
    return this.beans.gos.addGridCommonParams({
      value: this.rowNode.getValueFromValueService(this.column),
      eventKey: t,
      column: this.column,
      colDef: this.column.getColDef(),
      rowIndex: this.getCellPosition().rowIndex,
      node: this.rowNode,
      data: this.rowNode.data,
      cellStartedEdit: i,
      onKeyDown: this.onKeyDown.bind(this),
      stopEditing: this.stopEditingAndFocus.bind(this),
      eGridCell: this.getGui(),
      parseValue: this.parseValue.bind(this),
      formatValue: this.formatValue.bind(this)
    });
  }
  createCellRendererParams() {
    return this.beans.gos.addGridCommonParams({
      value: this.value,
      valueFormatted: this.valueFormatted,
      getValue: () => this.rowNode.getValueFromValueService(this.column),
      setValue: (i) => this.beans.valueService.setValue(this.rowNode, this.column, i),
      formatValue: this.formatValue.bind(this),
      data: this.rowNode.data,
      node: this.rowNode,
      pinned: this.column.getPinned(),
      colDef: this.column.getColDef(),
      column: this.column,
      rowIndex: this.getCellPosition().rowIndex,
      refreshCell: this.refreshCell.bind(this),
      eGridCell: this.getGui(),
      eParentOfValue: this.cellComp.getParentOfValue(),
      registerRowDragger: (i, s, o, r) => this.registerRowDragger(i, s, r),
      setTooltip: (i, s) => {
        var o;
        this.tooltipFeature && this.disableTooltipFeature(), this.enableTooltipFeature(i, s), (o = this.tooltipFeature) == null || o.refreshToolTip();
      }
    });
  }
  parseValue(t) {
    return this.beans.valueService.parseValue(this.column, this.rowNode, t, this.getValue());
  }
  setFocusOutOnEditor() {
    if (!this.editing)
      return;
    const t = this.cellComp.getCellEditor();
    t && t.focusOut && t.focusOut();
  }
  setFocusInOnEditor() {
    if (!this.editing)
      return;
    const t = this.cellComp.getCellEditor();
    t && t.focusIn ? t.focusIn() : this.focusCell(!0);
  }
  onCellChanged(t) {
    t.column === this.column && this.refreshCell({});
  }
  refreshOrDestroyCell(t) {
    var i;
    this.refreshShouldDestroy() ? (i = this.rowCtrl) == null || i.recreateCell(this) : this.refreshCell(t);
  }
  // + stop editing {forceRefresh: true, suppressFlash: true}
  // + event cellChanged {}
  // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
  // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
  // + rowCtrl: api refreshCells() {animate: true/false}
  // + rowRenderer: api softRefreshView() {}
  refreshCell(t) {
    var i, s, o, r;
    if (this.suppressRefreshCell || this.editing)
      return;
    const n = this.column.getColDef(), l = t != null && !!t.newData, a = t != null && !!t.suppressFlash || !!n.suppressCellFlash, d = n.field == null && n.valueGetter == null && n.showRowGroup == null, c = t && t.forceRefresh || d || l, h = !!this.cellComp, g = this.updateAndFormatValue(h), m = c || g;
    if (h) {
      if (m) {
        this.showValue(l);
        const C = this.beans.filterManager.isSuppressFlashingCellsBecauseFiltering();
        !a && !C && (this.beans.gos.get("enableCellChangeFlash") || n.enableCellChangeFlash) && this.flashCell(), (i = this.cellCustomStyleFeature) == null || i.applyUserStyles(), (s = this.cellCustomStyleFeature) == null || s.applyClassesFromColDef();
      }
      (o = this.tooltipFeature) == null || o.refreshToolTip(), (r = this.cellCustomStyleFeature) == null || r.applyCellClassRules();
    }
  }
  // cell editors call this, when they want to stop for reasons other
  // than what we pick up on. eg selecting from a dropdown ends editing.
  stopEditingAndFocus(t = !1, i = !1) {
    this.stopRowOrCellEdit(), this.focusCell(!0), t || this.navigateAfterEdit(i);
  }
  navigateAfterEdit(t) {
    if (this.beans.gos.get("enterNavigatesVerticallyAfterEdit")) {
      const s = t ? S.UP : S.DOWN;
      this.beans.navigationService.navigateToNextCell(null, s, this.getCellPosition(), !1);
    }
  }
  // user can also call this via API
  flashCell(t) {
    var i, s;
    const o = (i = t == null ? void 0 : t.flashDuration) != null ? i : t == null ? void 0 : t.flashDelay, r = (s = t == null ? void 0 : t.fadeDuration) != null ? s : t == null ? void 0 : t.fadeDelay;
    this.animateCell("data-changed", o, r);
  }
  animateCell(t, i, s) {
    if (!this.cellComp)
      return;
    const o = `ag-cell-${t}`, r = `ag-cell-${t}-animation`, { gos: n } = this.beans;
    i || (i = n.get("cellFlashDuration")), b(s) || (s = n.get("cellFadeDuration")), this.cellComp.addOrRemoveCssClass(o, !0), this.cellComp.addOrRemoveCssClass(r, !1), this.beans.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        this.isAlive() && (this.cellComp.addOrRemoveCssClass(o, !1), this.cellComp.addOrRemoveCssClass(r, !0), this.eGui.style.transition = `background-color ${s}ms`, window.setTimeout(() => {
          this.isAlive() && (this.cellComp.addOrRemoveCssClass(r, !1), this.eGui.style.transition = "");
        }, s));
      }, i);
    });
  }
  onFlashCells(t) {
    if (!this.cellComp)
      return;
    const i = this.beans.cellPositionUtils.createId(this.getCellPosition());
    t.cells[i] && this.animateCell("highlight");
  }
  isCellEditable() {
    return this.column.isCellEditable(this.rowNode);
  }
  isSuppressFillHandle() {
    return this.column.isSuppressFillHandle();
  }
  formatValue(t) {
    var i;
    return (i = this.callValueFormatter(t)) != null ? i : t;
  }
  callValueFormatter(t) {
    return this.beans.valueService.formatValue(this.column, this.rowNode, t);
  }
  updateAndFormatValue(t) {
    const i = this.value, s = this.valueFormatted;
    return this.value = this.rowNode.getValueFromValueService(this.column), this.valueFormatted = this.callValueFormatter(this.value), t ? !this.valuesAreEqual(i, this.value) || this.valueFormatted != s : !0;
  }
  valuesAreEqual(t, i) {
    const s = this.column.getColDef();
    return s.equals ? s.equals(t, i) : t === i;
  }
  getComp() {
    return this.cellComp;
  }
  getValue() {
    return this.value;
  }
  addDomData() {
    const t = this.getGui();
    this.beans.gos.setDomData(t, kl.DOM_DATA_KEY_CELL_CTRL, this), this.addDestroyFunc(() => this.beans.gos.setDomData(t, kl.DOM_DATA_KEY_CELL_CTRL, null));
  }
  createEvent(t, i) {
    return this.beans.gos.addGridCommonParams({
      type: i,
      node: this.rowNode,
      data: this.rowNode.data,
      value: this.value,
      column: this.column,
      colDef: this.column.getColDef(),
      rowPinned: this.rowNode.rowPinned,
      event: t,
      rowIndex: this.rowNode.rowIndex
    });
  }
  processCharacter(t) {
    var i;
    (i = this.cellKeyboardListenerFeature) == null || i.processCharacter(t);
  }
  onKeyDown(t) {
    var i;
    (i = this.cellKeyboardListenerFeature) == null || i.onKeyDown(t);
  }
  onMouseEvent(t, i) {
    var s;
    (s = this.cellMouseListenerFeature) == null || s.onMouseEvent(t, i);
  }
  getGui() {
    return this.eGui;
  }
  getColSpanningList() {
    return this.cellPositionFeature.getColSpanningList();
  }
  onLeftChanged() {
    var t;
    this.cellComp && ((t = this.cellPositionFeature) == null || t.onLeftChanged());
  }
  onDisplayedColumnsChanged() {
    this.eGui && (this.refreshAriaColIndex(), this.refreshFirstAndLastStyles());
  }
  refreshFirstAndLastStyles() {
    const { cellComp: t, column: i, beans: s } = this;
    Bn.refreshFirstAndLastStyles(t, i, s.columnModel);
  }
  refreshAriaColIndex() {
    const t = this.beans.columnModel.getAriaColumnIndex(this.column);
    ua(this.getGui(), t);
  }
  isSuppressNavigable() {
    return this.column.isSuppressNavigable(this.rowNode);
  }
  onWidthChanged() {
    var t;
    return (t = this.cellPositionFeature) == null ? void 0 : t.onWidthChanged();
  }
  getColumn() {
    return this.column;
  }
  getRowNode() {
    return this.rowNode;
  }
  isPrintLayout() {
    return this.printLayout;
  }
  getCellPosition() {
    return this.cellPosition;
  }
  isEditing() {
    return this.editing;
  }
  // called by rowRenderer when user navigates via tab key
  startRowOrCellEdit(t, i = null) {
    if (!this.cellComp) {
      this.onCellCompAttachedFuncs.push(() => {
        this.startRowOrCellEdit(t, i);
      });
      return;
    }
    this.beans.gos.get("editType") === "fullRow" ? this.rowCtrl.startRowEditing(t, this) : this.startEditing(t, !0, i);
  }
  getRowCtrl() {
    return this.rowCtrl;
  }
  getRowPosition() {
    return {
      rowIndex: this.cellPosition.rowIndex,
      rowPinned: this.cellPosition.rowPinned
    };
  }
  updateRangeBordersIfRangeCount() {
    this.cellComp && this.cellRangeFeature && this.cellRangeFeature.updateRangeBordersIfRangeCount();
  }
  onRangeSelectionChanged() {
    this.cellComp && this.cellRangeFeature && this.cellRangeFeature.onRangeSelectionChanged();
  }
  isRangeSelectionEnabled() {
    return this.cellRangeFeature != null;
  }
  focusCell(t = !1) {
    this.beans.focusService.setFocusedCell({
      rowIndex: this.getCellPosition().rowIndex,
      column: this.column,
      rowPinned: this.rowNode.rowPinned,
      forceBrowserFocus: t
    });
  }
  onRowIndexChanged() {
    this.createCellPosition(), this.onCellFocused(), this.cellRangeFeature && this.cellRangeFeature.onRangeSelectionChanged();
  }
  onFirstRightPinnedChanged() {
    if (!this.cellComp)
      return;
    const t = this.column.isFirstRightPinned();
    this.cellComp.addOrRemoveCssClass(Ff, t);
  }
  onLastLeftPinnedChanged() {
    if (!this.cellComp)
      return;
    const t = this.column.isLastLeftPinned();
    this.cellComp.addOrRemoveCssClass(Lf, t);
  }
  onCellFocused(t) {
    if (this.beans.gos.get("suppressCellFocus"))
      return;
    const i = this.beans.focusService.isCellFocused(this.cellPosition);
    if (!this.cellComp) {
      i && (t != null && t.forceBrowserFocus) && (this.focusEventToRestore = t);
      return;
    }
    this.focusEventToRestore = void 0, this.cellComp.addOrRemoveCssClass(Pf, i), i && t && t.forceBrowserFocus && this.cellComp.getFocusableElement().focus({ preventScroll: !!t.preventScrollOnBrowserFocus });
    const s = this.beans.gos.get("editType") === "fullRow";
    !i && !s && this.editing && this.stopRowOrCellEdit(), i && this.rowCtrl.announceDescription();
  }
  createCellPosition() {
    this.cellPosition = {
      rowIndex: this.rowNode.rowIndex,
      rowPinned: si(this.rowNode.rowPinned),
      column: this.column
    };
  }
  // CSS Classes that only get applied once, they never change
  applyStaticCssClasses() {
    this.cellComp.addOrRemoveCssClass(Tf, !0), this.cellComp.addOrRemoveCssClass(If, !0);
    const t = this.column.isAutoHeight() == !0;
    this.cellComp.addOrRemoveCssClass(bf, t), this.cellComp.addOrRemoveCssClass(Af, !t);
  }
  onColumnHover() {
    if (!this.cellComp || !this.beans.gos.get("columnHoverHighlight"))
      return;
    const t = this.beans.columnHoverService.isHovered(this.column);
    this.cellComp.addOrRemoveCssClass(Mf, t);
  }
  onColDefChanged() {
    if (!this.cellComp)
      return;
    if (this.column.isTooltipEnabled() ? (this.disableTooltipFeature(), this.enableTooltipFeature()) : this.disableTooltipFeature(), this.setWrapText(), !this.editing)
      this.refreshOrDestroyCell({ forceRefresh: !0, suppressFlash: !0 });
    else {
      const i = this.getCellEditor();
      if (i != null && i.refresh) {
        const { eventKey: s, cellStartedEdit: o } = this.editCompDetails.params, r = this.createCellEditorParams(s, o), n = this.column.getColDef(), l = this.beans.userComponentFactory.getCellEditorDetails(n, r);
        i.refresh(l.params);
      }
    }
  }
  setWrapText() {
    const t = this.column.getColDef().wrapText == !0;
    this.cellComp.addOrRemoveCssClass(xf, t);
  }
  dispatchCellContextMenuEvent(t) {
    const i = this.column.getColDef(), s = this.createEvent(t, p.EVENT_CELL_CONTEXT_MENU);
    this.beans.eventService.dispatchEvent(s), i.onCellContextMenu && window.setTimeout(() => {
      this.beans.frameworkOverrides.wrapOutgoing(() => {
        i.onCellContextMenu(s);
      });
    }, 0);
  }
  getCellRenderer() {
    return this.cellComp ? this.cellComp.getCellRenderer() : null;
  }
  getCellEditor() {
    return this.cellComp ? this.cellComp.getCellEditor() : null;
  }
  destroy() {
    this.onCellCompAttachedFuncs = [], super.destroy();
  }
  createSelectionCheckbox() {
    const t = new _n();
    return this.beans.context.createBean(t), t.init({ rowNode: this.rowNode, column: this.column }), t;
  }
  createDndSource() {
    const t = new wh(this.rowNode, this.column, this.eGui);
    return this.beans.context.createBean(t), t;
  }
  registerRowDragger(t, i, s) {
    if (this.customRowDragComp) {
      this.customRowDragComp.setDragElement(t, i);
      return;
    }
    const o = this.createRowDragComp(t, i, s);
    o && (this.customRowDragComp = o, this.addDestroyFunc(() => {
      this.beans.context.destroyBean(o), this.customRowDragComp = null;
    }));
  }
  createRowDragComp(t, i, s) {
    const o = this.beans.gos.get("pagination"), r = this.beans.gos.get("rowDragManaged"), n = this.beans.gos.isRowModelType("clientSide");
    if (r) {
      if (!n) {
        H("managed row dragging is only allowed in the Client Side Row Model");
        return;
      }
      if (o) {
        H("managed row dragging is not possible when doing pagination");
        return;
      }
    }
    const l = new cs(() => this.value, this.rowNode, this.column, t, i, s);
    return this.beans.context.createBean(l), l;
  }
};
Sh.DOM_DATA_KEY_CELL_CTRL = "cellCtrl";
var ns = Sh, Gf = 0, Eh = class Bl extends F {
  constructor(t, i, s, o, r) {
    super(), this.allRowGuis = [], this.active = !0, this.centerCellCtrls = { list: [], map: {} }, this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} }, this.slideInAnimation = {
      left: !1,
      center: !1,
      right: !1,
      fullWidth: !1
    }, this.fadeInAnimation = {
      left: !1,
      center: !1,
      right: !1,
      fullWidth: !1
    }, this.rowDragComps = [], this.lastMouseDownOnDragger = !1, this.emptyStyle = {}, this.updateColumnListsPending = !1, this.rowId = null, this.businessKeySanitised = null, this.beans = i, this.gos = i.gos, this.rowNode = t, this.paginationPage = i.paginationProxy.getCurrentPage(), this.useAnimationFrameForCreate = o, this.printLayout = r, this.suppressRowTransform = this.gos.get("suppressRowTransform"), this.instanceId = t.id + "-" + Gf++, this.rowId = Oe(t.id), this.initRowBusinessKey(), this.rowFocused = i.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned), this.rowLevel = i.rowCssClassCalculator.calculateRowLevel(this.rowNode), this.setRowType(), this.setAnimateFlags(s), this.rowStyles = this.processStylesFromGridOptions(), this.isFullWidth() && !this.gos.get("suppressCellFocus") && (this.tabIndex = -1), this.addListeners();
  }
  initRowBusinessKey() {
    this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode"), this.updateRowBusinessKey();
  }
  updateRowBusinessKey() {
    if (typeof this.businessKeyForNodeFunc != "function")
      return;
    const t = this.businessKeyForNodeFunc(this.rowNode);
    this.businessKeySanitised = Oe(t);
  }
  getRowId() {
    return this.rowId;
  }
  getRowStyles() {
    return this.rowStyles;
  }
  getTabIndex() {
    return this.tabIndex;
  }
  isSticky() {
    return this.rowNode.sticky;
  }
  getInstanceId() {
    return this.instanceId;
  }
  setComp(t, i, s) {
    const o = { rowComp: t, element: i, containerType: s };
    this.allRowGuis.push(o), s === "left" ? this.leftGui = o : s === "right" ? this.rightGui = o : s === "fullWidth" ? this.fullWidthGui = o : this.centerGui = o, this.initialiseRowComp(o), this.rowType !== "FullWidthLoading" && !this.rowNode.rowPinned && this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
  }
  unsetComp(t) {
    switch (this.allRowGuis = this.allRowGuis.filter((i) => i.containerType !== t), t) {
      case "left":
        this.leftGui = void 0;
        break;
      case "right":
        this.rightGui = void 0;
        break;
      case "fullWidth":
        this.fullWidthGui = void 0;
        break;
      case "center":
        this.centerGui = void 0;
        break;
    }
  }
  isCacheable() {
    return this.rowType === "FullWidthDetail" && this.gos.get("keepDetailRows");
  }
  setCached(t) {
    const i = t ? "none" : "";
    this.allRowGuis.forEach((s) => s.element.style.display = i);
  }
  initialiseRowComp(t) {
    const i = this.gos;
    this.listenOnDomOrder(t), this.beans.columnModel.wasAutoRowHeightEverActive() && this.rowNode.checkAutoHeights(), this.onRowHeightChanged(t), this.updateRowIndexes(t), this.setFocusedClasses(t), this.setStylesFromGridOptions(!1, t), i.isRowSelection() && this.rowNode.selectable && this.onRowSelected(t), this.updateColumnLists(!this.useAnimationFrameForCreate);
    const s = t.rowComp;
    this.getInitialRowClasses(t.containerType).forEach((r) => s.addOrRemoveCssClass(r, !0)), this.executeSlideAndFadeAnimations(t), this.rowNode.group && fi(t.element, this.rowNode.expanded == !0), this.setRowCompRowId(s), this.setRowCompRowBusinessKey(s), i.setDomData(t.element, Bl.DOM_DATA_KEY_ROW_CTRL, this), this.addDestroyFunc(
      () => i.setDomData(t.element, Bl.DOM_DATA_KEY_ROW_CTRL, null)
    ), this.useAnimationFrameForCreate ? this.beans.animationFrameService.createTask(
      this.addHoverFunctionality.bind(this, t.element),
      this.rowNode.rowIndex,
      "createTasksP2"
    ) : this.addHoverFunctionality(t.element), this.isFullWidth() && this.setupFullWidth(t), i.get("rowDragEntireRow") && this.addRowDraggerToRow(t), this.useAnimationFrameForCreate && this.beans.animationFrameService.addDestroyTask(() => {
      this.isAlive() && t.rowComp.addOrRemoveCssClass("ag-after-created", !0);
    }), this.executeProcessRowPostCreateFunc();
  }
  setRowCompRowBusinessKey(t) {
    this.businessKeySanitised != null && t.setRowBusinessKey(this.businessKeySanitised);
  }
  getBusinessKey() {
    return this.businessKeySanitised;
  }
  setRowCompRowId(t) {
    this.rowId = Oe(this.rowNode.id), this.rowId != null && t.setRowId(this.rowId);
  }
  executeSlideAndFadeAnimations(t) {
    const { containerType: i } = t;
    this.slideInAnimation[i] && (bl(() => {
      this.onTopChanged();
    }), this.slideInAnimation[i] = !1), this.fadeInAnimation[i] && (bl(() => {
      t.rowComp.addOrRemoveCssClass("ag-opacity-zero", !1);
    }), this.fadeInAnimation[i] = !1);
  }
  addRowDraggerToRow(t) {
    if (this.gos.get("enableRangeSelection")) {
      H("Setting `rowDragEntireRow: true` in the gridOptions doesn't work with `enableRangeSelection: true`");
      return;
    }
    const i = this.beans.localeService.getLocaleTextFunc(), s = new cs(
      () => `1 ${i("rowDragRow", "row")}`,
      this.rowNode,
      void 0,
      t.element,
      void 0,
      !0
    ), o = this.createBean(s, this.beans.context);
    this.rowDragComps.push(o);
  }
  setupFullWidth(t) {
    const i = this.getPinnedForContainer(t.containerType);
    if (this.rowType == "FullWidthDetail" && !le.__assertRegistered("@ag-grid-enterprise/master-detail", "cell renderer 'agDetailCellRenderer' (for master detail)", this.beans.context.getGridId()))
      return;
    const s = this.createFullWidthCompDetails(t.element, i);
    t.rowComp.showFullWidth(s);
  }
  isPrintLayout() {
    return this.printLayout;
  }
  getFullWidthCellRenderers() {
    var t, i;
    return this.gos.get("embedFullWidthRows") ? this.allRowGuis.map((s) => {
      var o;
      return (o = s == null ? void 0 : s.rowComp) == null ? void 0 : o.getFullWidthCellRenderer();
    }) : [(i = (t = this.fullWidthGui) == null ? void 0 : t.rowComp) == null ? void 0 : i.getFullWidthCellRenderer()];
  }
  // use by autoWidthCalculator, as it clones the elements
  getCellElement(t) {
    const i = this.getCellCtrl(t);
    return i ? i.getGui() : null;
  }
  executeProcessRowPostCreateFunc() {
    const t = this.gos.getCallback("processRowPostCreate");
    if (!t || !this.areAllContainersReady())
      return;
    const i = {
      // areAllContainersReady asserts that centerGui is not null
      eRow: this.centerGui.element,
      ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
      ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
      node: this.rowNode,
      rowIndex: this.rowNode.rowIndex,
      addRenderedRowListener: this.addEventListener.bind(this)
    };
    t(i);
  }
  areAllContainersReady() {
    const t = !!this.leftGui || !this.beans.columnModel.isPinningLeft(), i = !!this.centerGui, s = !!this.rightGui || !this.beans.columnModel.isPinningRight();
    return t && i && s;
  }
  setRowType() {
    const t = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow"), i = this.rowNode.isFullWidthCell(), s = this.gos.get("masterDetail") && this.rowNode.detail, o = this.beans.columnModel.isPivotMode(), n = !!this.rowNode.group && !this.rowNode.footer && this.gos.isGroupUseEntireRow(o);
    t ? this.rowType = "FullWidthLoading" : s ? this.rowType = "FullWidthDetail" : i ? this.rowType = "FullWidth" : n ? this.rowType = "FullWidthGroup" : this.rowType = "Normal";
  }
  updateColumnLists(t = !1, i = !1) {
    if (this.isFullWidth())
      return;
    if (t || this.gos.get("suppressAnimationFrame") || this.printLayout) {
      this.updateColumnListsImpl(i);
      return;
    }
    this.updateColumnListsPending || (this.beans.animationFrameService.createTask(
      () => {
        this.active && this.updateColumnListsImpl(!0);
      },
      this.rowNode.rowIndex,
      "createTasksP1"
    ), this.updateColumnListsPending = !0);
  }
  createCellCtrls(t, i, s = null) {
    const o = {
      list: [],
      map: {}
    }, r = (n, l) => {
      o.list.push(l), o.map[n] = l;
    };
    return i.forEach((n) => {
      const l = n.getInstanceId();
      let a = t.map[l];
      a || (a = new ns(n, this.rowNode, this.beans, this)), r(l, a);
    }), t.list.forEach((n) => {
      if (o.map[n.getColumn().getInstanceId()] != null)
        return;
      if (!this.isCellEligibleToBeRemoved(n, s)) {
        r(n.getColumn().getInstanceId(), n);
        return;
      }
      n.destroy();
    }), o;
  }
  updateColumnListsImpl(t) {
    this.updateColumnListsPending = !1, this.createAllCellCtrls(), this.setCellCtrls(t);
  }
  setCellCtrls(t) {
    this.allRowGuis.forEach((i) => {
      const s = this.getCellCtrlsForContainer(i.containerType);
      i.rowComp.setCellCtrls(s, t);
    });
  }
  getCellCtrlsForContainer(t) {
    switch (t) {
      case "left":
        return this.leftCellCtrls.list;
      case "right":
        return this.rightCellCtrls.list;
      case "fullWidth":
        return [];
      case "center":
        return this.centerCellCtrls.list;
      default:
        const i = t;
        throw new Error(`Unhandled case: ${i}`);
    }
  }
  createAllCellCtrls() {
    const t = this.beans.columnModel;
    if (this.printLayout)
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, t.getAllDisplayedColumns()), this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} };
    else {
      const i = t.getViewportCenterColumnsForRow(this.rowNode);
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, i);
      const s = t.getDisplayedLeftColumnsForRow(this.rowNode);
      this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, s, "left");
      const o = t.getDisplayedRightColumnsForRow(this.rowNode);
      this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, o, "right");
    }
  }
  isCellEligibleToBeRemoved(t, i) {
    if (t.getColumn().getPinned() != i)
      return !0;
    const n = t.isEditing(), l = this.beans.focusService.isCellFocused(t.getCellPosition());
    if (n || l) {
      const d = t.getColumn();
      return !(this.beans.columnModel.getAllDisplayedColumns().indexOf(d) >= 0);
    }
    return !0;
  }
  getDomOrder() {
    return this.gos.get("ensureDomOrder") || this.gos.isDomLayout("print");
  }
  listenOnDomOrder(t) {
    const i = () => {
      t.rowComp.setDomOrder(this.getDomOrder());
    };
    this.addManagedPropertyListener("domLayout", i), this.addManagedPropertyListener("ensureDomOrder", i);
  }
  setAnimateFlags(t) {
    if (this.isSticky() || !t)
      return;
    const i = b(this.rowNode.oldRowTop), s = this.beans.columnModel.isPinningLeft(), o = this.beans.columnModel.isPinningRight();
    if (i) {
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
        this.slideInAnimation.fullWidth = !0;
        return;
      }
      this.slideInAnimation.center = !0, this.slideInAnimation.left = s, this.slideInAnimation.right = o;
    } else {
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
        this.fadeInAnimation.fullWidth = !0;
        return;
      }
      this.fadeInAnimation.center = !0, this.fadeInAnimation.left = s, this.fadeInAnimation.right = o;
    }
  }
  isEditing() {
    return this.editingRow;
  }
  isFullWidth() {
    return this.rowType !== "Normal";
  }
  refreshFullWidth() {
    const t = (l, a) => l ? l.rowComp.refreshFullWidth(() => this.createFullWidthCompDetails(l.element, a).params) : !0, i = t(this.fullWidthGui, null), s = t(this.centerGui, null), o = t(this.leftGui, "left"), r = t(this.rightGui, "right");
    return i && s && o && r;
  }
  addListeners() {
    this.addManagedListener(this.rowNode, X.EVENT_HEIGHT_CHANGED, () => this.onRowHeightChanged()), this.addManagedListener(this.rowNode, X.EVENT_ROW_SELECTED, () => this.onRowSelected()), this.addManagedListener(this.rowNode, X.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_TOP_CHANGED, this.onTopChanged.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_EXPANDED_CHANGED, this.updateExpandedCss.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_HAS_CHILDREN_CHANGED, this.updateExpandedCss.bind(this)), this.rowNode.detail && this.addManagedListener(this.rowNode.parent, X.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_CELL_CHANGED, this.postProcessCss.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_HIGHLIGHT_CHANGED, this.onRowNodeHighlightChanged.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_DRAGGING_CHANGED, this.postProcessRowDragging.bind(this)), this.addManagedListener(this.rowNode, X.EVENT_UI_LEVEL_CHANGED, this.onUiLevelChanged.bind(this));
    const t = this.beans.eventService;
    this.addManagedListener(t, p.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED, this.onPaginationPixelOffsetChanged.bind(this)), this.addManagedListener(t, p.EVENT_HEIGHT_SCALE_CHANGED, this.onTopChanged.bind(this)), this.addManagedListener(t, p.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(t, p.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this)), this.addManagedListener(t, p.EVENT_CELL_FOCUSED, this.onCellFocusChanged.bind(this)), this.addManagedListener(t, p.EVENT_CELL_FOCUS_CLEARED, this.onCellFocusChanged.bind(this)), this.addManagedListener(t, p.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this)), this.addManagedListener(t, p.EVENT_MODEL_UPDATED, this.refreshFirstAndLastRowStyles.bind(this)), this.addManagedListener(t, p.EVENT_COLUMN_MOVED, this.updateColumnLists.bind(this)), this.addDestroyFunc(() => {
      this.destroyBeans(this.rowDragComps, this.beans.context), this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature, this.beans.context));
    }), this.addManagedPropertyListeners(["rowDragEntireRow"], () => {
      if (this.gos.get("rowDragEntireRow")) {
        this.allRowGuis.forEach((s) => {
          this.addRowDraggerToRow(s);
        });
        return;
      }
      this.destroyBeans(this.rowDragComps, this.beans.context), this.rowDragComps = [];
    }), this.addListenersForCellComps();
  }
  addListenersForCellComps() {
    this.addManagedListener(this.rowNode, X.EVENT_ROW_INDEX_CHANGED, () => {
      this.getAllCellCtrls().forEach((t) => t.onRowIndexChanged());
    }), this.addManagedListener(this.rowNode, X.EVENT_CELL_CHANGED, (t) => {
      this.getAllCellCtrls().forEach((i) => i.onCellChanged(t));
    });
  }
  onRowNodeDataChanged(t) {
    if (this.isFullWidth() !== !!this.rowNode.isFullWidthCell()) {
      this.beans.rowRenderer.redrawRow(this.rowNode);
      return;
    }
    if (this.isFullWidth()) {
      this.refreshFullWidth() || this.beans.rowRenderer.redrawRow(this.rowNode);
      return;
    }
    this.getAllCellCtrls().forEach(
      (s) => s.refreshCell({
        suppressFlash: !t.update,
        newData: !t.update
      })
    ), this.allRowGuis.forEach((s) => {
      this.setRowCompRowId(s.rowComp), this.updateRowBusinessKey(), this.setRowCompRowBusinessKey(s.rowComp);
    }), this.onRowSelected(), this.postProcessCss();
  }
  postProcessCss() {
    this.setStylesFromGridOptions(!0), this.postProcessClassesFromGridOptions(), this.postProcessRowClassRules(), this.postProcessRowDragging();
  }
  onRowNodeHighlightChanged() {
    const t = this.rowNode.highlighted;
    this.allRowGuis.forEach((i) => {
      const s = t === 0, o = t === 1;
      i.rowComp.addOrRemoveCssClass("ag-row-highlight-above", s), i.rowComp.addOrRemoveCssClass("ag-row-highlight-below", o);
    });
  }
  postProcessRowDragging() {
    const t = this.rowNode.dragging;
    this.allRowGuis.forEach((i) => i.rowComp.addOrRemoveCssClass("ag-row-dragging", t));
  }
  updateExpandedCss() {
    const t = this.rowNode.isExpandable(), i = this.rowNode.expanded == !0;
    this.allRowGuis.forEach((s) => {
      s.rowComp.addOrRemoveCssClass("ag-row-group", t), s.rowComp.addOrRemoveCssClass("ag-row-group-expanded", t && i), s.rowComp.addOrRemoveCssClass("ag-row-group-contracted", t && !i), fi(s.element, t && i);
    });
  }
  onDisplayedColumnsChanged() {
    this.updateColumnLists(!0), this.beans.columnModel.wasAutoRowHeightEverActive() && this.rowNode.checkAutoHeights();
  }
  onVirtualColumnsChanged() {
    this.updateColumnLists(!1, !0);
  }
  getRowPosition() {
    return {
      rowPinned: si(this.rowNode.rowPinned),
      rowIndex: this.rowNode.rowIndex
    };
  }
  onKeyboardNavigate(t) {
    const i = this.allRowGuis.find((a) => a.element.contains(t.target));
    if (!((i ? i.element : null) === t.target))
      return;
    const r = this.rowNode, n = this.beans.focusService.getFocusedCell(), l = {
      rowIndex: r.rowIndex,
      rowPinned: r.rowPinned,
      column: n && n.column
    };
    this.beans.navigationService.navigateToNextCell(t, t.key, l, !0), t.preventDefault();
  }
  onTabKeyDown(t) {
    if (t.defaultPrevented || Yt(t))
      return;
    const i = this.allRowGuis.find((n) => n.element.contains(t.target)), s = i ? i.element : null, o = s === t.target;
    let r = null;
    o || (r = this.beans.focusService.findNextFocusableElement(s, !1, t.shiftKey)), (this.isFullWidth() && o || !r) && this.beans.navigationService.onTabKeyDown(this, t);
  }
  getFullWidthElement() {
    return this.fullWidthGui ? this.fullWidthGui.element : null;
  }
  getRowYPosition() {
    var t;
    const i = (t = this.allRowGuis.find((s) => wt(s.element))) == null ? void 0 : t.element;
    return i ? i.getBoundingClientRect().top : 0;
  }
  onFullWidthRowFocused(t) {
    var i;
    const s = this.rowNode, o = t ? this.isFullWidth() && t.rowIndex === s.rowIndex && t.rowPinned == s.rowPinned : !1, r = this.fullWidthGui ? this.fullWidthGui.element : (i = this.centerGui) == null ? void 0 : i.element;
    r && (r.classList.toggle("ag-full-width-focus", o), o && r.focus({ preventScroll: !0 }));
  }
  recreateCell(t) {
    this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, t), this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, t), this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, t), t.destroy(), this.updateColumnLists();
  }
  removeCellCtrl(t, i) {
    const s = {
      list: [],
      map: {}
    };
    return t.list.forEach((o) => {
      o !== i && (s.list.push(o), s.map[o.getColumn().getInstanceId()] = o);
    }), s;
  }
  onMouseEvent(t, i) {
    switch (t) {
      case "dblclick":
        this.onRowDblClick(i);
        break;
      case "click":
        this.onRowClick(i);
        break;
      case "touchstart":
      case "mousedown":
        this.onRowMouseDown(i);
        break;
    }
  }
  createRowEvent(t, i) {
    return this.gos.addGridCommonParams({
      type: t,
      node: this.rowNode,
      data: this.rowNode.data,
      rowIndex: this.rowNode.rowIndex,
      rowPinned: this.rowNode.rowPinned,
      event: i
    });
  }
  createRowEventWithSource(t, i) {
    const s = this.createRowEvent(t, i);
    return s.source = this, s;
  }
  onRowDblClick(t) {
    if (Yt(t))
      return;
    const i = this.createRowEventWithSource(p.EVENT_ROW_DOUBLE_CLICKED, t);
    this.beans.eventService.dispatchEvent(i);
  }
  onRowMouseDown(t) {
    if (this.lastMouseDownOnDragger = os(t.target, "ag-row-drag", 3), !this.isFullWidth())
      return;
    const i = this.rowNode, s = this.beans.columnModel;
    this.beans.rangeService && this.beans.rangeService.removeAllCellRanges(), this.beans.focusService.setFocusedCell({
      rowIndex: i.rowIndex,
      column: s.getAllDisplayedColumns()[0],
      rowPinned: i.rowPinned,
      forceBrowserFocus: !0
    });
  }
  onRowClick(t) {
    if (Yt(t) || this.lastMouseDownOnDragger)
      return;
    const s = this.createRowEventWithSource(p.EVENT_ROW_CLICKED, t);
    this.beans.eventService.dispatchEvent(s);
    const o = t.ctrlKey || t.metaKey, r = t.shiftKey;
    if (
      // we do not allow selecting groups by clicking (as the click here expands the group), or if it's a detail row,
      // so return if it's a group row
      this.gos.get("groupSelectsChildren") && this.rowNode.group || this.isRowSelectionBlocked() || // if click selection suppressed, do nothing
      this.gos.get("suppressRowClickSelection")
    )
      return;
    const l = this.gos.get("rowMultiSelectWithClick"), a = !this.gos.get("suppressRowDeselection"), d = "rowClicked";
    if (this.rowNode.isSelected())
      l ? this.rowNode.setSelectedParams({ newValue: !1, event: t, source: d }) : o ? a && this.rowNode.setSelectedParams({ newValue: !1, event: t, source: d }) : this.rowNode.setSelectedParams({ newValue: !0, clearSelection: !r, rangeSelect: r, event: t, source: d });
    else {
      const c = l ? !1 : !o;
      this.rowNode.setSelectedParams({ newValue: !0, clearSelection: c, rangeSelect: r, event: t, source: d });
    }
  }
  isRowSelectionBlocked() {
    return !this.rowNode.selectable || !!this.rowNode.rowPinned || !this.gos.isRowSelection();
  }
  setupDetailRowAutoHeight(t) {
    if (this.rowType !== "FullWidthDetail" || !this.gos.get("detailRowAutoHeight"))
      return;
    const i = () => {
      const o = t.clientHeight;
      if (o != null && o > 0) {
        const r = () => {
          this.rowNode.setRowHeight(o), this.beans.clientSideRowModel ? this.beans.clientSideRowModel.onRowHeightChanged() : this.beans.serverSideRowModel && this.beans.serverSideRowModel.onRowHeightChanged();
        };
        window.setTimeout(r, 0);
      }
    }, s = this.beans.resizeObserverService.observeResize(t, i);
    this.addDestroyFunc(s), i();
  }
  createFullWidthCompDetails(t, i) {
    const s = this.gos.addGridCommonParams({
      fullWidth: !0,
      data: this.rowNode.data,
      node: this.rowNode,
      value: this.rowNode.key,
      valueFormatted: this.rowNode.key,
      rowIndex: this.rowNode.rowIndex,
      // these need to be taken out, as part of 'afterAttached' now
      eGridCell: t,
      eParentOfValue: t,
      pinned: i,
      addRenderedRowListener: this.addEventListener.bind(this),
      registerRowDragger: (o, r, n, l) => this.addFullWidthRowDragging(o, r, n, l),
      setTooltip: (o, r) => this.refreshRowTooltip(o, r)
    });
    switch (this.rowType) {
      case "FullWidthDetail":
        return this.beans.userComponentFactory.getFullWidthDetailCellRendererDetails(s);
      case "FullWidthGroup":
        return this.beans.userComponentFactory.getFullWidthGroupCellRendererDetails(s);
      case "FullWidthLoading":
        return this.beans.userComponentFactory.getFullWidthLoadingCellRendererDetails(s);
      default:
        return this.beans.userComponentFactory.getFullWidthCellRendererDetails(s);
    }
  }
  refreshRowTooltip(t, i) {
    if (!this.fullWidthGui)
      return;
    const s = {
      getGui: () => this.fullWidthGui.element,
      getTooltipValue: () => t,
      getLocation: () => "fullWidthRow",
      shouldDisplayTooltip: i
    };
    this.tooltipFeature && this.destroyBean(this.tooltipFeature, this.beans.context), this.tooltipFeature = this.createBean(new wi(s, this.beans));
  }
  addFullWidthRowDragging(t, i, s = "", o) {
    if (!this.isFullWidth())
      return;
    const r = new cs(() => s, this.rowNode, void 0, t, i, o);
    this.createBean(r, this.beans.context), this.addDestroyFunc(() => {
      this.destroyBean(r, this.beans.context);
    });
  }
  onUiLevelChanged() {
    const t = this.beans.rowCssClassCalculator.calculateRowLevel(this.rowNode);
    if (this.rowLevel != t) {
      const i = "ag-row-level-" + t, s = "ag-row-level-" + this.rowLevel;
      this.allRowGuis.forEach((o) => {
        o.rowComp.addOrRemoveCssClass(i, !0), o.rowComp.addOrRemoveCssClass(s, !1);
      });
    }
    this.rowLevel = t;
  }
  isFirstRowOnPage() {
    return this.rowNode.rowIndex === this.beans.paginationProxy.getPageFirstRow();
  }
  isLastRowOnPage() {
    return this.rowNode.rowIndex === this.beans.paginationProxy.getPageLastRow();
  }
  refreshFirstAndLastRowStyles() {
    const t = this.isFirstRowOnPage(), i = this.isLastRowOnPage();
    this.firstRowOnPage !== t && (this.firstRowOnPage = t, this.allRowGuis.forEach((s) => s.rowComp.addOrRemoveCssClass("ag-row-first", t))), this.lastRowOnPage !== i && (this.lastRowOnPage = i, this.allRowGuis.forEach((s) => s.rowComp.addOrRemoveCssClass("ag-row-last", i)));
  }
  stopEditing(t = !1) {
    if (this.stoppingRowEdit)
      return;
    const i = this.getAllCellCtrls(), s = this.editingRow;
    this.stoppingRowEdit = !0;
    let o = !1;
    for (const r of i) {
      const n = r.stopEditing(t);
      s && !t && !o && n && (o = !0);
    }
    if (o) {
      const r = this.createRowEvent(p.EVENT_ROW_VALUE_CHANGED);
      this.beans.eventService.dispatchEvent(r);
    }
    s && this.setEditingRow(!1), this.stoppingRowEdit = !1;
  }
  setInlineEditingCss(t) {
    this.allRowGuis.forEach((i) => {
      i.rowComp.addOrRemoveCssClass("ag-row-inline-editing", t), i.rowComp.addOrRemoveCssClass("ag-row-not-inline-editing", !t);
    });
  }
  setEditingRow(t) {
    this.editingRow = t, this.allRowGuis.forEach((s) => s.rowComp.addOrRemoveCssClass("ag-row-editing", t));
    const i = t ? this.createRowEvent(p.EVENT_ROW_EDITING_STARTED) : this.createRowEvent(p.EVENT_ROW_EDITING_STOPPED);
    this.beans.eventService.dispatchEvent(i);
  }
  startRowEditing(t = null, i = null, s = null) {
    if (this.editingRow)
      return;
    this.getAllCellCtrls().reduce((r, n) => {
      const l = n === i;
      return l ? n.startEditing(t, l, s) : n.startEditing(null, l, s), r ? !0 : n.isEditing();
    }, !1) && this.setEditingRow(!0);
  }
  getAllCellCtrls() {
    return this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0 ? this.centerCellCtrls.list : [...this.centerCellCtrls.list, ...this.leftCellCtrls.list, ...this.rightCellCtrls.list];
  }
  postProcessClassesFromGridOptions() {
    const t = this.beans.rowCssClassCalculator.processClassesFromGridOptions(this.rowNode);
    !t || !t.length || t.forEach((i) => {
      this.allRowGuis.forEach((s) => s.rowComp.addOrRemoveCssClass(i, !0));
    });
  }
  postProcessRowClassRules() {
    this.beans.rowCssClassCalculator.processRowClassRules(
      this.rowNode,
      (t) => {
        this.allRowGuis.forEach((i) => i.rowComp.addOrRemoveCssClass(t, !0));
      },
      (t) => {
        this.allRowGuis.forEach((i) => i.rowComp.addOrRemoveCssClass(t, !1));
      }
    );
  }
  setStylesFromGridOptions(t, i) {
    t && (this.rowStyles = this.processStylesFromGridOptions()), this.forEachGui(i, (s) => s.rowComp.setUserStyles(this.rowStyles));
  }
  getPinnedForContainer(t) {
    return t === "left" ? "left" : t === "right" ? "right" : null;
  }
  getInitialRowClasses(t) {
    const i = this.getPinnedForContainer(t), s = {
      rowNode: this.rowNode,
      rowFocused: this.rowFocused,
      fadeRowIn: this.fadeInAnimation[t],
      rowIsEven: this.rowNode.rowIndex % 2 === 0,
      rowLevel: this.rowLevel,
      fullWidthRow: this.isFullWidth(),
      firstRowOnPage: this.isFirstRowOnPage(),
      lastRowOnPage: this.isLastRowOnPage(),
      printLayout: this.printLayout,
      expandable: this.rowNode.isExpandable(),
      pinned: i
    };
    return this.beans.rowCssClassCalculator.getInitialRowClasses(s);
  }
  processStylesFromGridOptions() {
    const t = this.gos.get("rowStyle");
    if (t && typeof t == "function") {
      console.warn("AG Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead");
      return;
    }
    const i = this.gos.getCallback("getRowStyle");
    let s;
    if (i) {
      const o = {
        data: this.rowNode.data,
        node: this.rowNode,
        rowIndex: this.rowNode.rowIndex
      };
      s = i(o);
    }
    return s || t ? Object.assign({}, t, s) : this.emptyStyle;
  }
  onRowSelected(t) {
    const i = !!this.rowNode.isSelected();
    this.forEachGui(t, (s) => {
      s.rowComp.addOrRemoveCssClass("ag-row-selected", i), qs(s.element, i), s.element.contains(this.beans.gos.getActiveDomElement()) && (s === this.centerGui || s === this.fullWidthGui) && this.announceDescription();
    });
  }
  announceDescription() {
    if (this.isRowSelectionBlocked())
      return;
    const t = this.rowNode.isSelected();
    if (t && this.beans.gos.get("suppressRowDeselection"))
      return;
    const s = this.beans.localeService.getLocaleTextFunc()(
      t ? "ariaRowDeselect" : "ariaRowSelect",
      `Press SPACE to ${t ? "deselect" : "select"} this row.`
    );
    this.beans.ariaAnnouncementService.announceValue(s);
  }
  addHoverFunctionality(t) {
    this.active && (this.addManagedListener(t, "mouseenter", () => this.rowNode.onMouseEnter()), this.addManagedListener(t, "mouseleave", () => this.rowNode.onMouseLeave()), this.addManagedListener(this.rowNode, X.EVENT_MOUSE_ENTER, () => {
      !this.beans.dragService.isDragging() && !this.gos.get("suppressRowHoverHighlight") && (t.classList.add("ag-row-hover"), this.rowNode.setHovered(!0));
    }), this.addManagedListener(this.rowNode, X.EVENT_MOUSE_LEAVE, () => {
      t.classList.remove("ag-row-hover"), this.rowNode.setHovered(!1);
    }));
  }
  // for animation, we don't want to animate entry or exit to a very far away pixel,
  // otherwise the row would move so fast, it would appear to disappear. so this method
  // moves the row closer to the viewport if it is far away, so the row slide in / out
  // at a speed the user can see.
  roundRowTopToBounds(t) {
    const i = this.beans.ctrlsService.getGridBodyCtrl().getScrollFeature().getApproximateVScollPosition(), s = this.applyPaginationOffset(i.top, !0) - 100, o = this.applyPaginationOffset(i.bottom, !0) + 100;
    return Math.min(Math.max(s, t), o);
  }
  getFrameworkOverrides() {
    return this.beans.frameworkOverrides;
  }
  forEachGui(t, i) {
    t ? i(t) : this.allRowGuis.forEach(i);
  }
  onRowHeightChanged(t) {
    if (this.rowNode.rowHeight == null)
      return;
    const i = this.rowNode.rowHeight, s = this.beans.environment.getDefaultRowHeight(), r = this.gos.isGetRowHeightFunction() ? this.gos.getRowHeightForNode(this.rowNode).height : void 0, n = r ? `${Math.min(s, r) - 2}px` : void 0;
    this.forEachGui(t, (l) => {
      l.element.style.height = `${i}px`, n && l.element.style.setProperty("--ag-line-height", n);
    });
  }
  addEventListener(t, i) {
    super.addEventListener(t, i);
  }
  removeEventListener(t, i) {
    super.removeEventListener(t, i);
  }
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  destroyFirstPass(t = !1) {
    if (this.active = !1, !t && this.gos.isAnimateRows() && !this.isSticky())
      if (this.rowNode.rowTop != null) {
        const o = this.roundRowTopToBounds(this.rowNode.rowTop);
        this.setRowTop(o);
      } else
        this.allRowGuis.forEach((o) => o.rowComp.addOrRemoveCssClass("ag-opacity-zero", !0));
    this.rowNode.setHovered(!1);
    const i = this.createRowEvent(p.EVENT_VIRTUAL_ROW_REMOVED);
    this.dispatchEvent(i), this.beans.eventService.dispatchEvent(i), super.destroy();
  }
  destroySecondPass() {
    this.allRowGuis.length = 0, this.stopEditing();
    const t = (i) => (i.list.forEach((s) => s.destroy()), { list: [], map: {} });
    this.centerCellCtrls = t(this.centerCellCtrls), this.leftCellCtrls = t(this.leftCellCtrls), this.rightCellCtrls = t(this.rightCellCtrls);
  }
  setFocusedClasses(t) {
    this.forEachGui(t, (i) => {
      i.rowComp.addOrRemoveCssClass("ag-row-focus", this.rowFocused), i.rowComp.addOrRemoveCssClass("ag-row-no-focus", !this.rowFocused);
    });
  }
  onCellFocusChanged() {
    const t = this.beans.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
    t !== this.rowFocused && (this.rowFocused = t, this.setFocusedClasses()), !t && this.editingRow && this.stopEditing(!1);
  }
  onPaginationChanged() {
    const t = this.beans.paginationProxy.getCurrentPage();
    this.paginationPage !== t && (this.paginationPage = t, this.onTopChanged()), this.refreshFirstAndLastRowStyles();
  }
  onTopChanged() {
    this.setRowTop(this.rowNode.rowTop);
  }
  onPaginationPixelOffsetChanged() {
    this.onTopChanged();
  }
  // applies pagination offset, eg if on second page, and page height is 500px, then removes
  // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
  // reverse will take the offset away rather than add.
  applyPaginationOffset(t, i = !1) {
    if (this.rowNode.isRowPinned() || this.rowNode.sticky)
      return t;
    const s = this.beans.paginationProxy.getPixelOffset();
    return t + s * (i ? 1 : -1);
  }
  setRowTop(t) {
    if (!this.printLayout && b(t)) {
      const i = this.applyPaginationOffset(t), r = `${this.rowNode.isRowPinned() || this.rowNode.sticky ? i : this.beans.rowContainerHeightService.getRealPixelPosition(i)}px`;
      this.setRowTopStyle(r);
    }
  }
  // the top needs to be set into the DOM element when the element is created, not updated afterwards.
  // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
  // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
  // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
  // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
  // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
  // time, the row would animate down (ie from position zero).
  getInitialRowTop(t) {
    return this.suppressRowTransform ? this.getInitialRowTopShared(t) : void 0;
  }
  getInitialTransform(t) {
    return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(t)})`;
  }
  getInitialRowTopShared(t) {
    if (this.printLayout)
      return "";
    let i;
    if (this.isSticky())
      i = this.rowNode.stickyRowTop;
    else {
      const s = this.slideInAnimation[t] ? this.roundRowTopToBounds(this.rowNode.oldRowTop) : this.rowNode.rowTop, o = this.applyPaginationOffset(s);
      i = this.rowNode.isRowPinned() ? o : this.beans.rowContainerHeightService.getRealPixelPosition(o);
    }
    return i + "px";
  }
  setRowTopStyle(t) {
    this.allRowGuis.forEach(
      (i) => this.suppressRowTransform ? i.rowComp.setTop(t) : i.rowComp.setTransform(`translateY(${t})`)
    );
  }
  getRowNode() {
    return this.rowNode;
  }
  getCellCtrl(t) {
    let i = null;
    return this.getAllCellCtrls().forEach((s) => {
      s.getColumn() == t && (i = s);
    }), i != null || this.getAllCellCtrls().forEach((s) => {
      s.getColSpanningList().indexOf(t) >= 0 && (i = s);
    }), i;
  }
  onRowIndexChanged() {
    this.rowNode.rowIndex != null && (this.onCellFocusChanged(), this.updateRowIndexes(), this.postProcessCss());
  }
  getRowIndex() {
    return this.rowNode.getRowIndexString();
  }
  updateRowIndexes(t) {
    const i = this.rowNode.getRowIndexString(), s = this.beans.headerNavigationService.getHeaderRowCount() + this.beans.filterManager.getHeaderRowCount(), o = this.rowNode.rowIndex % 2 === 0, r = s + this.rowNode.rowIndex + 1;
    this.forEachGui(t, (n) => {
      n.rowComp.setRowIndex(i), n.rowComp.addOrRemoveCssClass("ag-row-even", o), n.rowComp.addOrRemoveCssClass("ag-row-odd", !o), da(n.element, r);
    });
  }
};
Eh.DOM_DATA_KEY_ROW_CTRL = "renderedRow";
var ls = Eh, yt = class extends F {
  constructor(e) {
    super(), this.element = e;
  }
  postConstruct() {
    this.addKeyboardListeners(), this.addMouseListeners(), this.mockContextMenuForIPad();
  }
  addKeyboardListeners() {
    const e = "keydown", t = this.processKeyboardEvent.bind(this, e);
    this.addManagedListener(this.element, e, t);
  }
  addMouseListeners() {
    ["dblclick", "contextmenu", "mouseover", "mouseout", "click", oa("touchstart") ? "touchstart" : "mousedown"].forEach((i) => {
      const s = this.processMouseEvent.bind(this, i);
      this.addManagedListener(this.element, i, s);
    });
  }
  processMouseEvent(e, t) {
    if (!this.mouseEventService.isEventFromThisGrid(t) || Yt(t))
      return;
    const i = this.getRowForEvent(t), s = this.mouseEventService.getRenderedCellForEvent(t);
    e === "contextmenu" ? this.handleContextMenuMouseEvent(t, void 0, i, s) : (s && s.onMouseEvent(e, t), i && i.onMouseEvent(e, t));
  }
  mockContextMenuForIPad() {
    if (!vi())
      return;
    const e = new je(this.element), t = (i) => {
      const s = this.getRowForEvent(i.touchEvent), o = this.mouseEventService.getRenderedCellForEvent(i.touchEvent);
      this.handleContextMenuMouseEvent(void 0, i.touchEvent, s, o);
    };
    this.addManagedListener(e, je.EVENT_LONG_TAP, t), this.addDestroyFunc(() => e.destroy());
  }
  getRowForEvent(e) {
    let t = e.target;
    for (; t; ) {
      const i = this.gos.getDomData(t, ls.DOM_DATA_KEY_ROW_CTRL);
      if (i)
        return i;
      t = t.parentElement;
    }
    return null;
  }
  handleContextMenuMouseEvent(e, t, i, s) {
    const o = i ? i.getRowNode() : null, r = s ? s.getColumn() : null;
    let n = null;
    if (r) {
      const d = e || t;
      s.dispatchCellContextMenuEvent(d ?? null), n = this.valueService.getValue(r, o);
    }
    const l = this.ctrlsService.getGridBodyCtrl(), a = s ? s.getGui() : l.getGridBodyElement();
    this.menuService.showContextMenu({ mouseEvent: e, touchEvent: t, rowNode: o, column: r, value: n, anchorToElement: a });
  }
  getControlsForEventTarget(e) {
    return {
      cellCtrl: Qr(this.gos, e, ns.DOM_DATA_KEY_CELL_CTRL),
      rowCtrl: Qr(this.gos, e, ls.DOM_DATA_KEY_ROW_CTRL)
    };
  }
  processKeyboardEvent(e, t) {
    const { cellCtrl: i, rowCtrl: s } = this.getControlsForEventTarget(t.target);
    t.defaultPrevented || (i ? this.processCellKeyboardEvent(i, e, t) : s && s.isFullWidth() && this.processFullWidthRowKeyboardEvent(s, e, t));
  }
  processCellKeyboardEvent(e, t, i) {
    const s = e.getRowNode(), o = e.getColumn(), r = e.isEditing();
    if (!en(this.gos, i, s, o, r) && t === "keydown" && (!r && this.navigationService.handlePageScrollingKey(i) || e.onKeyDown(i), this.doGridOperations(i, e.isEditing()), Fn(i) && e.processCharacter(i)), t === "keydown") {
      const l = e.createEvent(i, p.EVENT_CELL_KEY_DOWN);
      this.eventService.dispatchEvent(l);
    }
  }
  processFullWidthRowKeyboardEvent(e, t, i) {
    const s = e.getRowNode(), o = this.focusService.getFocusedCell(), r = o && o.column;
    if (!en(this.gos, i, s, r, !1)) {
      const l = i.key;
      if (t === "keydown")
        switch (l) {
          case S.PAGE_HOME:
          case S.PAGE_END:
          case S.PAGE_UP:
          case S.PAGE_DOWN:
            this.navigationService.handlePageScrollingKey(i, !0);
            break;
          case S.UP:
          case S.DOWN:
            e.onKeyboardNavigate(i);
            break;
          case S.TAB:
            e.onTabKeyDown(i);
            break;
        }
    }
    if (t === "keydown") {
      const l = e.createRowEvent(p.EVENT_CELL_KEY_DOWN, i);
      this.eventService.dispatchEvent(l);
    }
  }
  doGridOperations(e, t) {
    if (!e.ctrlKey && !e.metaKey || t || !this.mouseEventService.isEventFromThisGrid(e))
      return;
    const i = Rc(e);
    if (i === S.A)
      return this.onCtrlAndA(e);
    if (i === S.C)
      return this.onCtrlAndC(e);
    if (i === S.D)
      return this.onCtrlAndD(e);
    if (i === S.V)
      return this.onCtrlAndV(e);
    if (i === S.X)
      return this.onCtrlAndX(e);
    if (i === S.Y)
      return this.onCtrlAndY();
    if (i === S.Z)
      return this.onCtrlAndZ(e);
  }
  onCtrlAndA(e) {
    const { pinnedRowModel: t, paginationProxy: i, rangeService: s } = this;
    if (s && i.isRowsToRender()) {
      const [o, r] = [
        t.isEmpty("top"),
        t.isEmpty("bottom")
      ], n = o ? null : "top";
      let l, a;
      r ? (l = null, a = this.paginationProxy.getRowCount() - 1) : (l = "bottom", a = t.getPinnedBottomRowData().length - 1);
      const d = this.columnModel.getAllDisplayedColumns();
      if (It(d))
        return;
      s.setCellRange({
        rowStartIndex: 0,
        rowStartPinned: n,
        rowEndIndex: a,
        rowEndPinned: l,
        columnStart: d[0],
        columnEnd: se(d)
      });
    }
    e.preventDefault();
  }
  onCtrlAndC(e) {
    if (!this.clipboardService || this.gos.get("enableCellTextSelection"))
      return;
    const { cellCtrl: t, rowCtrl: i } = this.getControlsForEventTarget(e.target);
    t != null && t.isEditing() || i != null && i.isEditing() || (e.preventDefault(), this.clipboardService.copyToClipboard());
  }
  onCtrlAndX(e) {
    if (!this.clipboardService || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard"))
      return;
    const { cellCtrl: t, rowCtrl: i } = this.getControlsForEventTarget(e.target);
    t != null && t.isEditing() || i != null && i.isEditing() || (e.preventDefault(), this.clipboardService.cutToClipboard(void 0, "ui"));
  }
  onCtrlAndV(e) {
    const { cellCtrl: t, rowCtrl: i } = this.getControlsForEventTarget(e.target);
    t != null && t.isEditing() || i != null && i.isEditing() || this.clipboardService && !this.gos.get("suppressClipboardPaste") && this.clipboardService.pasteFromClipboard();
  }
  onCtrlAndD(e) {
    this.clipboardService && !this.gos.get("suppressClipboardPaste") && this.clipboardService.copyRangeDown(), e.preventDefault();
  }
  onCtrlAndZ(e) {
    this.gos.get("undoRedoCellEditing") && (e.preventDefault(), e.shiftKey ? this.undoRedoService.redo("ui") : this.undoRedoService.undo("ui"));
  }
  onCtrlAndY() {
    this.undoRedoService.redo("ui");
  }
};
u([
  f("mouseEventService")
], yt.prototype, "mouseEventService", 2);
u([
  f("valueService")
], yt.prototype, "valueService", 2);
u([
  f("menuService")
], yt.prototype, "menuService", 2);
u([
  f("ctrlsService")
], yt.prototype, "ctrlsService", 2);
u([
  f("navigationService")
], yt.prototype, "navigationService", 2);
u([
  f("focusService")
], yt.prototype, "focusService", 2);
u([
  f("undoRedoService")
], yt.prototype, "undoRedoService", 2);
u([
  f("columnModel")
], yt.prototype, "columnModel", 2);
u([
  f("paginationProxy")
], yt.prototype, "paginationProxy", 2);
u([
  f("pinnedRowModel")
], yt.prototype, "pinnedRowModel", 2);
u([
  ue("rangeService")
], yt.prototype, "rangeService", 2);
u([
  ue("clipboardService")
], yt.prototype, "clipboardService", 2);
u([
  L
], yt.prototype, "postConstruct", 1);
var uo = class extends F {
  constructor(e) {
    super(), this.centerContainerCtrl = e;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.listenForResize();
    }), this.addManagedListener(this.eventService, p.EVENT_SCROLLBAR_WIDTH_CHANGED, this.onScrollbarWidthChanged.bind(this)), this.addManagedPropertyListeners(["alwaysShowHorizontalScroll", "alwaysShowVerticalScroll"], () => {
      this.checkViewportAndScrolls();
    });
  }
  listenForResize() {
    const e = () => this.onCenterViewportResized();
    this.centerContainerCtrl.registerViewportResizeListener(e), this.gridBodyCtrl.registerBodyViewportResizeListener(e);
  }
  onScrollbarWidthChanged() {
    this.checkViewportAndScrolls();
  }
  onCenterViewportResized() {
    if (this.centerContainerCtrl.isViewportInTheDOMTree()) {
      this.keepPinnedColumnsNarrowerThanViewport(), this.checkViewportAndScrolls();
      const e = this.centerContainerCtrl.getCenterWidth();
      e !== this.centerWidth && (this.centerWidth = e, this.columnModel.refreshFlexedColumns(
        { viewportWidth: this.centerWidth, updateBodyWidths: !0, fireResizedEvent: !0 }
      ));
    } else
      this.bodyHeight = 0;
  }
  keepPinnedColumnsNarrowerThanViewport() {
    const e = this.gridBodyCtrl.getBodyViewportElement(), t = Rs(e);
    if (t <= 50)
      return;
    let i = this.getPinnedColumnsOverflowingViewport(t - 50);
    const s = this.gos.getCallback("processUnpinnedColumns");
    i.length && (s && (i = s({
      columns: i,
      viewportWidth: t
    })), this.columnModel.setColumnsPinned(i, null, "viewportSizeFeature"));
  }
  getPinnedColumnsOverflowingViewport(e) {
    const t = this.pinnedWidthService.getPinnedRightWidth(), i = this.pinnedWidthService.getPinnedLeftWidth(), s = t + i;
    if (s < e)
      return [];
    const o = [...this.columnModel.getDisplayedLeftColumns()], r = [...this.columnModel.getDisplayedRightColumns()];
    let n = 0, l = 0, a = 0;
    const d = [];
    let c = s - a - e;
    for (; (l < o.length || n < r.length) && c > 0; ) {
      if (n < r.length) {
        const h = r[n++];
        c -= h.getActualWidth(), d.push(h);
      }
      if (l < o.length && c > 0) {
        const h = o[l++];
        c -= h.getActualWidth(), d.push(h);
      }
    }
    return d;
  }
  // gets called every time the viewport size changes. we use this to check visibility of scrollbars
  // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
  checkViewportAndScrolls() {
    this.updateScrollVisibleService(), this.checkBodyHeight(), this.onHorizontalViewportChanged(), this.gridBodyCtrl.getScrollFeature().checkScrollLeft();
  }
  getBodyHeight() {
    return this.bodyHeight;
  }
  checkBodyHeight() {
    const e = this.gridBodyCtrl.getBodyViewportElement(), t = hr(e);
    if (this.bodyHeight !== t) {
      this.bodyHeight = t;
      const i = {
        type: p.EVENT_BODY_HEIGHT_CHANGED
      };
      this.eventService.dispatchEvent(i);
    }
  }
  updateScrollVisibleService() {
    this.updateScrollVisibleServiceImpl(), setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
  }
  updateScrollVisibleServiceImpl() {
    const e = {
      horizontalScrollShowing: this.isHorizontalScrollShowing(),
      verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
    };
    this.scrollVisibleService.setScrollsVisible(e);
  }
  isHorizontalScrollShowing() {
    return this.centerContainerCtrl.isHorizontalScrollShowing();
  }
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
  onHorizontalViewportChanged() {
    const e = this.centerContainerCtrl.getCenterWidth(), t = this.centerContainerCtrl.getViewportScrollLeft();
    this.columnModel.setViewportPosition(e, t);
  }
};
u([
  f("ctrlsService")
], uo.prototype, "ctrlsService", 2);
u([
  f("pinnedWidthService")
], uo.prototype, "pinnedWidthService", 2);
u([
  f("columnModel")
], uo.prototype, "columnModel", 2);
u([
  f("scrollVisibleService")
], uo.prototype, "scrollVisibleService", 2);
u([
  L
], uo.prototype, "postConstruct", 1);
var Wa = class extends F {
  constructor(e) {
    super(), this.element = e;
  }
  postConstruct() {
    this.addManagedListener(this.eventService, p.EVENT_LEFT_PINNED_WIDTH_CHANGED, this.onPinnedLeftWidthChanged.bind(this));
  }
  onPinnedLeftWidthChanged() {
    const e = this.pinnedWidthService.getPinnedLeftWidth(), t = e > 0;
    te(this.element, t), Gt(this.element, e);
  }
  getWidth() {
    return this.pinnedWidthService.getPinnedLeftWidth();
  }
};
u([
  f("pinnedWidthService")
], Wa.prototype, "pinnedWidthService", 2);
u([
  L
], Wa.prototype, "postConstruct", 1);
var Ua = class extends F {
  constructor(e) {
    super(), this.element = e;
  }
  postConstruct() {
    this.addManagedListener(this.eventService, p.EVENT_RIGHT_PINNED_WIDTH_CHANGED, this.onPinnedRightWidthChanged.bind(this));
  }
  onPinnedRightWidthChanged() {
    const e = this.pinnedWidthService.getPinnedRightWidth(), t = e > 0;
    te(this.element, t), Gt(this.element, e);
  }
  getWidth() {
    return this.pinnedWidthService.getPinnedRightWidth();
  }
};
u([
  f("pinnedWidthService")
], Ua.prototype, "pinnedWidthService", 2);
u([
  L
], Ua.prototype, "postConstruct", 1);
var Wn = class extends F {
  constructor(e, t) {
    super(), this.eContainer = e, this.eViewport = t;
  }
  postConstruct() {
    this.addManagedListener(this.eventService, p.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onHeightChanged.bind(this));
  }
  onHeightChanged() {
    const e = this.maxDivHeightScaler.getUiContainerHeight(), t = e != null ? `${e}px` : "";
    this.eContainer.style.height = t, this.eViewport && (this.eViewport.style.height = t);
  }
};
u([
  f("rowContainerHeightService")
], Wn.prototype, "maxDivHeightScaler", 2);
u([
  L
], Wn.prototype, "postConstruct", 1);
var Un = class extends F {
  constructor(e) {
    super(), this.eContainer = e;
  }
  postConstruct() {
    if (!this.rangeService)
      return;
    this.params = {
      eElement: this.eContainer,
      onDragStart: this.rangeService.onDragStart.bind(this.rangeService),
      onDragStop: this.rangeService.onDragStop.bind(this.rangeService),
      onDragging: this.rangeService.onDragging.bind(this.rangeService)
    }, this.addManagedPropertyListener("enableRangeSelection", (t) => {
      if (t.currentValue) {
        this.enableFeature();
        return;
      }
      this.disableFeature();
    }), this.addDestroyFunc(() => this.disableFeature()), this.gos.get("enableRangeSelection") && this.enableFeature();
  }
  enableFeature() {
    this.dragService.addDragSource(this.params);
  }
  disableFeature() {
    this.dragService.removeDragSource(this.params);
  }
};
u([
  f("dragService")
], Un.prototype, "dragService", 2);
u([
  ue("rangeService")
], Un.prototype, "rangeService", 2);
u([
  L
], Un.prototype, "postConstruct", 1);
var co = class extends F {
  constructor(e, t = !1) {
    super(), this.callback = e, this.addSpacer = t;
  }
  postConstruct() {
    const e = this.setWidth.bind(this);
    this.addManagedPropertyListener("domLayout", e), this.addManagedListener(this.eventService, p.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED, e), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, e), this.addManagedListener(this.eventService, p.EVENT_LEFT_PINNED_WIDTH_CHANGED, e), this.addSpacer && (this.addManagedListener(this.eventService, p.EVENT_RIGHT_PINNED_WIDTH_CHANGED, e), this.addManagedListener(this.eventService, p.EVENT_SCROLL_VISIBILITY_CHANGED, e), this.addManagedListener(this.eventService, p.EVENT_SCROLLBAR_WIDTH_CHANGED, e)), this.setWidth();
  }
  setWidth() {
    const { columnModel: e } = this, t = this.gos.isDomLayout("print"), i = e.getBodyContainerWidth(), s = e.getDisplayedColumnsLeftWidth(), o = e.getDisplayedColumnsRightWidth();
    let r;
    t ? r = i + s + o : (r = i, this.addSpacer && (this.gos.get("enableRtl") ? s : o) === 0 && this.scrollVisibleService.isVerticalScrollShowing() && (r += this.gos.getScrollbarWidth())), this.callback(r);
  }
};
u([
  f("columnModel")
], co.prototype, "columnModel", 2);
u([
  f("scrollVisibleService")
], co.prototype, "scrollVisibleService", 2);
u([
  L
], co.prototype, "postConstruct", 1);
var Ee = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e.CENTER = "center", e.FULL_WIDTH = "fullWidth", e.TOP_LEFT = "topLeft", e.TOP_RIGHT = "topRight", e.TOP_CENTER = "topCenter", e.TOP_FULL_WIDTH = "topFullWidth", e.STICKY_TOP_LEFT = "stickyTopLeft", e.STICKY_TOP_RIGHT = "stickyTopRight", e.STICKY_TOP_CENTER = "stickyTopCenter", e.STICKY_TOP_FULL_WIDTH = "stickyTopFullWidth", e.STICKY_BOTTOM_LEFT = "stickyBottomLeft", e.STICKY_BOTTOM_RIGHT = "stickyBottomRight", e.STICKY_BOTTOM_CENTER = "stickyBottomCenter", e.STICKY_BOTTOM_FULL_WIDTH = "stickyBottomFullWidth", e.BOTTOM_LEFT = "bottomLeft", e.BOTTOM_RIGHT = "bottomRight", e.BOTTOM_CENTER = "bottomCenter", e.BOTTOM_FULL_WIDTH = "bottomFullWidth", e))(Ee || {});
function yh(e) {
  switch (e) {
    case "center":
    case "topCenter":
    case "stickyTopCenter":
    case "bottomCenter":
    case "stickyBottomCenter":
      return "center";
    case "left":
    case "topLeft":
    case "stickyTopLeft":
    case "bottomLeft":
    case "stickyBottomLeft":
      return "left";
    case "right":
    case "topRight":
    case "stickyTopRight":
    case "bottomRight":
    case "stickyBottomRight":
      return "right";
    case "fullWidth":
    case "topFullWidth":
    case "stickyTopFullWidth":
    case "bottomFullWidth":
    case "stickyBottomFullWidth":
      return "fullWidth";
    default:
      throw Error("Invalid Row Container Type");
  }
}
var Of = Ai([
  ["center", "ag-center-cols-container"],
  ["left", "ag-pinned-left-cols-container"],
  ["right", "ag-pinned-right-cols-container"],
  ["fullWidth", "ag-full-width-container"],
  ["topCenter", "ag-floating-top-container"],
  ["topLeft", "ag-pinned-left-floating-top"],
  ["topRight", "ag-pinned-right-floating-top"],
  ["topFullWidth", "ag-floating-top-full-width-container"],
  ["stickyTopCenter", "ag-sticky-top-container"],
  ["stickyTopLeft", "ag-pinned-left-sticky-top"],
  ["stickyTopRight", "ag-pinned-right-sticky-top"],
  ["stickyTopFullWidth", "ag-sticky-top-full-width-container"],
  ["stickyBottomCenter", "ag-sticky-bottom-container"],
  ["stickyBottomLeft", "ag-pinned-left-sticky-bottom"],
  ["stickyBottomRight", "ag-pinned-right-sticky-bottom"],
  ["stickyBottomFullWidth", "ag-sticky-bottom-full-width-container"],
  ["bottomCenter", "ag-floating-bottom-container"],
  ["bottomLeft", "ag-pinned-left-floating-bottom"],
  ["bottomRight", "ag-pinned-right-floating-bottom"],
  ["bottomFullWidth", "ag-floating-bottom-full-width-container"]
]), _f = Ai([
  ["center", "ag-center-cols-viewport"],
  ["topCenter", "ag-floating-top-viewport"],
  ["stickyTopCenter", "ag-sticky-top-viewport"],
  ["bottomCenter", "ag-floating-bottom-viewport"],
  ["stickyBottomCenter", "ag-sticky-bottom-viewport"]
]), Ls = class Rh extends F {
  constructor(t) {
    super(), this.visible = !0, this.EMPTY_CTRLS = [], this.name = t, this.isFullWithContainer = this.name === "topFullWidth" || this.name === "stickyTopFullWidth" || this.name === "stickyBottomFullWidth" || this.name === "bottomFullWidth" || this.name === "fullWidth";
  }
  static getRowContainerCssClasses(t) {
    const i = Of.get(t), s = _f.get(t);
    return { container: i, viewport: s };
  }
  static getPinned(t) {
    switch (t) {
      case "bottomLeft":
      case "topLeft":
      case "stickyTopLeft":
      case "stickyBottomLeft":
      case "left":
        return "left";
      case "bottomRight":
      case "topRight":
      case "stickyTopRight":
      case "stickyBottomRight":
      case "right":
        return "right";
      default:
        return null;
    }
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl"), this.forContainers(
      [
        "center"
        /* CENTER */
      ],
      () => this.viewportSizeFeature = this.createManagedBean(new uo(this))
    );
  }
  registerWithCtrlsService() {
    switch (this.name) {
      case "fullWidth":
      case "topFullWidth":
      case "stickyTopFullWidth":
      case "bottomFullWidth":
      case "stickyBottomFullWidth":
        return;
      default:
        this.ctrlsService.register(this.name, this);
    }
  }
  forContainers(t, i) {
    t.indexOf(this.name) >= 0 && i();
  }
  getContainerElement() {
    return this.eContainer;
  }
  getViewportSizeFeature() {
    return this.viewportSizeFeature;
  }
  setComp(t, i, s) {
    this.comp = t, this.eContainer = i, this.eViewport = s, this.createManagedBean(new yt(this.eContainer)), this.addPreventScrollWhileDragging(), this.listenOnDomOrder(), this.stopHScrollOnPinnedRows();
    const o = [
      "topCenter",
      "topLeft",
      "topRight"
      /* TOP_RIGHT */
    ], r = [
      "stickyTopCenter",
      "stickyTopLeft",
      "stickyTopRight"
      /* STICKY_TOP_RIGHT */
    ], n = [
      "stickyBottomCenter",
      "stickyBottomLeft",
      "stickyBottomRight"
      /* STICKY_BOTTOM_RIGHT */
    ], l = [
      "bottomCenter",
      "bottomLeft",
      "bottomRight"
      /* BOTTOM_RIGHT */
    ], a = [
      "center",
      "left",
      "right"
      /* RIGHT */
    ], d = [...o, ...l, ...a, ...r, ...n], c = [
      "center",
      "left",
      "right",
      "fullWidth"
      /* FULL_WIDTH */
    ], h = [
      "center",
      "topCenter",
      "stickyTopCenter",
      "bottomCenter",
      "stickyBottomCenter"
      /* STICKY_BOTTOM_CENTER */
    ], g = [
      "left",
      "bottomLeft",
      "topLeft",
      "stickyTopLeft",
      "stickyBottomLeft"
      /* STICKY_BOTTOM_LEFT */
    ], m = [
      "right",
      "bottomRight",
      "topRight",
      "stickyTopRight",
      "stickyBottomRight"
      /* STICKY_BOTTOM_RIGHT */
    ];
    this.forContainers(g, () => {
      this.pinnedWidthFeature = this.createManagedBean(new Wa(this.eContainer)), this.addManagedListener(this.eventService, p.EVENT_LEFT_PINNED_WIDTH_CHANGED, () => this.onPinnedWidthChanged());
    }), this.forContainers(m, () => {
      this.pinnedWidthFeature = this.createManagedBean(new Ua(this.eContainer)), this.addManagedListener(this.eventService, p.EVENT_RIGHT_PINNED_WIDTH_CHANGED, () => this.onPinnedWidthChanged());
    }), this.forContainers(c, () => this.createManagedBean(new Wn(this.eContainer, this.name === "center" ? s : void 0))), this.forContainers(d, () => this.createManagedBean(new Un(this.eContainer))), this.forContainers(h, () => this.createManagedBean(
      new co((C) => this.comp.setContainerWidth(`${C}px`))
    )), this.addListeners(), this.registerWithCtrlsService();
  }
  addListeners() {
    this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, () => this.onDisplayedColumnsChanged()), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, () => this.onDisplayedColumnsWidthChanged()), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_ROWS_CHANGED, (t) => this.onDisplayedRowsChanged(t.afterScroll)), this.onDisplayedColumnsChanged(), this.onDisplayedColumnsWidthChanged(), this.onDisplayedRowsChanged();
  }
  listenOnDomOrder() {
    if ([
      "stickyTopCenter",
      "stickyTopLeft",
      "stickyTopRight",
      "stickyTopFullWidth",
      "stickyBottomCenter",
      "stickyBottomLeft",
      "stickyBottomRight",
      "stickyBottomFullWidth"
      /* STICKY_BOTTOM_FULL_WIDTH */
    ].indexOf(this.name) >= 0) {
      this.comp.setDomOrder(!0);
      return;
    }
    const s = () => {
      const o = this.gos.get("ensureDomOrder"), r = this.gos.isDomLayout("print");
      this.comp.setDomOrder(o || r);
    };
    this.addManagedPropertyListener("domLayout", s), s();
  }
  // when editing a pinned row, if the cell is half outside the scrollable area, the browser can
  // scroll the column into view. we do not want this, the pinned sections should never scroll.
  // so we listen to scrolls on these containers and reset the scroll if we find one.
  stopHScrollOnPinnedRows() {
    this.forContainers([
      "topCenter",
      "stickyTopCenter",
      "bottomCenter",
      "stickyBottomCenter"
      /* STICKY_BOTTOM_CENTER */
    ], () => {
      const t = () => this.eViewport.scrollLeft = 0;
      this.addManagedListener(this.eViewport, "scroll", t);
    });
  }
  onDisplayedColumnsChanged() {
    this.forContainers([
      "center"
      /* CENTER */
    ], () => this.onHorizontalViewportChanged());
  }
  onDisplayedColumnsWidthChanged() {
    this.forContainers([
      "center"
      /* CENTER */
    ], () => this.onHorizontalViewportChanged());
  }
  // this methods prevents the grid views from being scrolled while the dragService is being used
  // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
  addPreventScrollWhileDragging() {
    const t = (i) => {
      this.dragService.isDragging() && i.cancelable && i.preventDefault();
    };
    this.eContainer.addEventListener("touchmove", t, { passive: !1 }), this.addDestroyFunc(() => this.eContainer.removeEventListener("touchmove", t));
  }
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
  onHorizontalViewportChanged(t = !1) {
    const i = this.getCenterWidth(), s = this.getCenterViewportScrollLeft();
    this.columnModel.setViewportPosition(i, s, t);
  }
  getCenterWidth() {
    return Rs(this.eViewport);
  }
  getCenterViewportScrollLeft() {
    return Ko(this.eViewport, this.enableRtl);
  }
  registerViewportResizeListener(t) {
    const i = this.resizeObserverService.observeResize(this.eViewport, t);
    this.addDestroyFunc(() => i());
  }
  isViewportInTheDOMTree() {
    return ya(this.eViewport);
  }
  getViewportScrollLeft() {
    return Ko(this.eViewport, this.enableRtl);
  }
  isHorizontalScrollShowing() {
    return this.gos.get("alwaysShowHorizontalScroll") || pc(this.eViewport);
  }
  getViewportElement() {
    return this.eViewport;
  }
  setContainerTranslateX(t) {
    this.eContainer.style.transform = `translateX(${t}px)`;
  }
  getHScrollPosition() {
    return {
      left: this.eViewport.scrollLeft,
      right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
    };
  }
  setCenterViewportScrollLeft(t) {
    $o(this.eViewport, t, this.enableRtl);
  }
  isContainerVisible() {
    return !Rh.getPinned(this.name) || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
  }
  onPinnedWidthChanged() {
    const t = this.isContainerVisible();
    this.visible != t && (this.visible = t, this.onDisplayedRowsChanged());
  }
  onDisplayedRowsChanged(t = !1) {
    const i = this.getRowCtrls();
    if (!this.visible || i.length === 0) {
      this.comp.setRowCtrls({ rowCtrls: this.EMPTY_CTRLS });
      return;
    }
    const s = this.gos.isDomLayout("print"), r = this.gos.get("embedFullWidthRows") || s, n = i.filter((l) => {
      const a = l.isFullWidth();
      return this.isFullWithContainer ? !r && a : r || !a;
    });
    this.comp.setRowCtrls({ rowCtrls: n, useFlushSync: t });
  }
  getRowCtrls() {
    switch (this.name) {
      case "topCenter":
      case "topLeft":
      case "topRight":
      case "topFullWidth":
        return this.rowRenderer.getTopRowCtrls();
      case "stickyTopCenter":
      case "stickyTopLeft":
      case "stickyTopRight":
      case "stickyTopFullWidth":
        return this.rowRenderer.getStickyTopRowCtrls();
      case "stickyBottomCenter":
      case "stickyBottomLeft":
      case "stickyBottomRight":
      case "stickyBottomFullWidth":
        return this.rowRenderer.getStickyBottomRowCtrls();
      case "bottomCenter":
      case "bottomLeft":
      case "bottomRight":
      case "bottomFullWidth":
        return this.rowRenderer.getBottomRowCtrls();
      default:
        return this.rowRenderer.getCentreRowCtrls();
    }
  }
};
u([
  f("dragService")
], Ls.prototype, "dragService", 2);
u([
  f("ctrlsService")
], Ls.prototype, "ctrlsService", 2);
u([
  f("columnModel")
], Ls.prototype, "columnModel", 2);
u([
  f("resizeObserverService")
], Ls.prototype, "resizeObserverService", 2);
u([
  f("rowRenderer")
], Ls.prototype, "rowRenderer", 2);
u([
  L
], Ls.prototype, "postConstruct", 1);
var on = Ls, Vf = (
  /* html */
  `<div class="ag-root ag-unselectable" role="treegrid">
        <ag-header-root ref="gridHeader"></ag-header-root>
        <div class="ag-floating-top" ref="eTop" role="presentation">
            <ag-row-container ref="topLeftContainer" name="topLeft"></ag-row-container>
            <ag-row-container ref="topCenterContainer" name="topCenter"></ag-row-container>
            <ag-row-container ref="topRightContainer" name="topRight"></ag-row-container>
            <ag-row-container ref="topFullWidthContainer" name="topFullWidth"></ag-row-container>
        </div>
        <div class="ag-body" ref="eBody" role="presentation">
            <div class="ag-body-viewport" ref="eBodyViewport" role="presentation">
                <ag-row-container ref="leftContainer" name="left"></ag-row-container>
                <ag-row-container ref="centerContainer" name="center"></ag-row-container>
                <ag-row-container ref="rightContainer" name="right"></ag-row-container>
                <ag-row-container ref="fullWidthContainer" name="fullWidth"></ag-row-container>
            </div>
            <ag-fake-vertical-scroll></ag-fake-vertical-scroll>
        </div>
        <div class="ag-sticky-top" ref="eStickyTop" role="presentation">
            <ag-row-container ref="stickyTopLeftContainer" name="stickyTopLeft"></ag-row-container>
            <ag-row-container ref="stickyTopCenterContainer" name="stickyTopCenter"></ag-row-container>
            <ag-row-container ref="stickyTopRightContainer" name="stickyTopRight"></ag-row-container>
            <ag-row-container ref="stickyTopFullWidthContainer" name="stickyTopFullWidth"></ag-row-container>
        </div>
        <div class="ag-sticky-bottom" ref="eStickyBottom" role="presentation">
            <ag-row-container ref="stickyBottomLeftContainer" name="stickyBottomLeft"></ag-row-container>
            <ag-row-container ref="stickyBottomCenterContainer" name="stickyBottomCenter"></ag-row-container>
            <ag-row-container ref="stickyBottomRightContainer" name="stickyBottomRight"></ag-row-container>
            <ag-row-container ref="stickyBottomFullWidthContainer" name="stickyBottomFullWidth"></ag-row-container>
        </div>
        <div class="ag-floating-bottom" ref="eBottom" role="presentation">
            <ag-row-container ref="bottomLeftContainer" name="bottomLeft"></ag-row-container>
            <ag-row-container ref="bottomCenterContainer" name="bottomCenter"></ag-row-container>
            <ag-row-container ref="bottomRightContainer" name="bottomRight"></ag-row-container>
            <ag-row-container ref="bottomFullWidthContainer" name="bottomFullWidth"></ag-row-container>
        </div>
        <ag-fake-horizontal-scroll></ag-fake-horizontal-scroll>
        <ag-overlay-wrapper></ag-overlay-wrapper>
    </div>`
), Xt = class extends K {
  constructor() {
    super(Vf);
  }
  init() {
    const t = (s, o) => {
      const r = `${s}px`;
      o.style.minHeight = r, o.style.height = r;
    }, i = {
      setRowAnimationCssOnBodyViewport: (s, o) => this.setRowAnimationCssOnBodyViewport(s, o),
      setColumnCount: (s) => Qu(this.getGui(), s),
      setRowCount: (s) => qu(this.getGui(), s),
      setTopHeight: (s) => t(s, this.eTop),
      setBottomHeight: (s) => t(s, this.eBottom),
      setTopDisplay: (s) => this.eTop.style.display = s,
      setBottomDisplay: (s) => this.eBottom.style.display = s,
      setStickyTopHeight: (s) => this.eStickyTop.style.height = s,
      setStickyTopTop: (s) => this.eStickyTop.style.top = s,
      setStickyTopWidth: (s) => this.eStickyTop.style.width = s,
      setStickyBottomHeight: (s) => this.eStickyBottom.style.height = s,
      setStickyBottomBottom: (s) => this.eStickyBottom.style.bottom = s,
      setStickyBottomWidth: (s) => this.eStickyBottom.style.width = s,
      setColumnMovingCss: (s, o) => this.addOrRemoveCssClass(s, o),
      updateLayoutClasses: (s, o) => {
        [
          this.eBodyViewport.classList,
          this.eBody.classList
        ].forEach((n) => {
          n.toggle("ag-layout-auto-height", o.autoHeight), n.toggle("ag-layout-normal", o.normal), n.toggle("ag-layout-print", o.print);
        }), this.addOrRemoveCssClass("ag-layout-auto-height", o.autoHeight), this.addOrRemoveCssClass("ag-layout-normal", o.normal), this.addOrRemoveCssClass("ag-layout-print", o.print);
      },
      setAlwaysVerticalScrollClass: (s, o) => this.eBodyViewport.classList.toggle(vh, o),
      registerBodyViewportResizeListener: (s) => {
        const o = this.resizeObserverService.observeResize(this.eBodyViewport, s);
        this.addDestroyFunc(() => o());
      },
      setPinnedTopBottomOverflowY: (s) => this.eTop.style.overflowY = this.eBottom.style.overflowY = s,
      setCellSelectableCss: (s, o) => {
        [this.eTop, this.eBodyViewport, this.eBottom].forEach((r) => r.classList.toggle(s, o));
      },
      setBodyViewportWidth: (s) => this.eBodyViewport.style.width = s
    };
    this.ctrl = this.createManagedBean(new ot()), this.ctrl.setComp(
      i,
      this.getGui(),
      this.eBodyViewport,
      this.eTop,
      this.eBottom,
      this.eStickyTop,
      this.eStickyBottom
    ), (this.rangeService && this.gos.get("enableRangeSelection") || this.gos.get("rowSelection") === "multiple") && Yu(this.getGui(), !0);
  }
  setRowAnimationCssOnBodyViewport(t, i) {
    const s = this.eBodyViewport.classList;
    s.toggle("ag-row-animation", i), s.toggle("ag-row-no-animation", !i);
  }
  getFloatingTopBottom() {
    return [this.eTop, this.eBottom];
  }
};
u([
  f("resizeObserverService")
], Xt.prototype, "resizeObserverService", 2);
u([
  ue("rangeService")
], Xt.prototype, "rangeService", 2);
u([
  M("eBodyViewport")
], Xt.prototype, "eBodyViewport", 2);
u([
  M("eStickyTop")
], Xt.prototype, "eStickyTop", 2);
u([
  M("eStickyBottom")
], Xt.prototype, "eStickyBottom", 2);
u([
  M("eTop")
], Xt.prototype, "eTop", 2);
u([
  M("eBottom")
], Xt.prototype, "eBottom", 2);
u([
  M("gridHeader")
], Xt.prototype, "headerRootComp", 2);
u([
  M("eBody")
], Xt.prototype, "eBody", 2);
u([
  L
], Xt.prototype, "init", 1);
var Zs = class extends F {
  postConstruct() {
    this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
  }
  onDisplayedColumnsChanged() {
    this.update();
  }
  onDisplayedColumnsWidthChanged() {
    this.update();
  }
  update() {
    this.columnAnimationService.isActive() ? this.columnAnimationService.executeLaterVMTurn(() => {
      this.columnAnimationService.executeLaterVMTurn(() => this.updateImpl());
    }) : this.updateImpl();
  }
  updateImpl() {
    const e = this.ctrlsService.get("center");
    if (!e || this.columnAnimationService.isActive())
      return;
    const t = {
      horizontalScrollShowing: e.isHorizontalScrollShowing(),
      verticalScrollShowing: this.isVerticalScrollShowing()
    };
    this.setScrollsVisible(t);
  }
  setScrollsVisible(e) {
    if (this.horizontalScrollShowing !== e.horizontalScrollShowing || this.verticalScrollShowing !== e.verticalScrollShowing) {
      this.horizontalScrollShowing = e.horizontalScrollShowing, this.verticalScrollShowing = e.verticalScrollShowing;
      const i = {
        type: p.EVENT_SCROLL_VISIBILITY_CHANGED
      };
      this.eventService.dispatchEvent(i);
    }
  }
  // used by pagination service - to know page height
  isHorizontalScrollShowing() {
    return this.horizontalScrollShowing;
  }
  // used by header container
  isVerticalScrollShowing() {
    return this.verticalScrollShowing;
  }
};
u([
  f("ctrlsService")
], Zs.prototype, "ctrlsService", 2);
u([
  f("columnAnimationService")
], Zs.prototype, "columnAnimationService", 2);
u([
  L
], Zs.prototype, "postConstruct", 1);
Zs = u([
  O("scrollVisibleService")
], Zs);
var gi = class extends F {
  constructor() {
    super(...arguments), this.gridInstanceId = gi.gridInstanceSequence.next();
  }
  // we put the instance id onto the main DOM element. this is used for events, when grids are inside grids,
  // so the grid can work out if the even came from this grid or a grid inside this one. see the ctrl+v logic
  // for where this is used.
  stampTopLevelGridCompWithGridInstance(e) {
    e[gi.GRID_DOM_KEY] = this.gridInstanceId;
  }
  getRenderedCellForEvent(e) {
    return Qr(this.gos, e.target, ns.DOM_DATA_KEY_CELL_CTRL);
  }
  // walks the path of the event, and returns true if this grid is the first one that it finds. if doing
  // master / detail grids, and a child grid is found, then it returns false. this stops things like copy/paste
  // getting executed on many grids at the same time.
  isEventFromThisGrid(e) {
    return this.isElementInThisGrid(e.target);
  }
  isElementInThisGrid(e) {
    let t = e;
    for (; t; ) {
      const i = t[gi.GRID_DOM_KEY];
      if (b(i))
        return i === this.gridInstanceId;
      t = t.parentElement;
    }
    return !1;
  }
  getCellPositionForEvent(e) {
    const t = this.getRenderedCellForEvent(e);
    return t ? t.getCellPosition() : null;
  }
  getNormalisedPosition(e) {
    const t = this.gos.isDomLayout("normal"), i = e;
    let s, o;
    if (i.clientX != null || i.clientY != null ? (s = i.clientX, o = i.clientY) : (s = i.x, o = i.y), t) {
      const r = this.ctrlsService.getGridBodyCtrl(), n = r.getScrollFeature().getVScrollPosition(), l = r.getScrollFeature().getHScrollPosition();
      s += l.left, o += n.top;
    }
    return { x: s, y: o };
  }
};
gi.gridInstanceSequence = new Xs();
gi.GRID_DOM_KEY = "__ag_grid_instance";
u([
  f("ctrlsService")
], gi.prototype, "ctrlsService", 2);
gi = u([
  O("mouseEventService")
], gi);
var it = class extends F {
  constructor() {
    super(), this.onPageDown = Al(this.onPageDown, 100), this.onPageUp = Al(this.onPageUp, 100);
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  handlePageScrollingKey(e, t = !1) {
    const i = e.key, s = e.altKey, o = e.ctrlKey || e.metaKey, r = !!this.rangeService && e.shiftKey, n = this.mouseEventService.getCellPositionForEvent(e);
    let l = !1;
    switch (i) {
      case S.PAGE_HOME:
      case S.PAGE_END:
        !o && !s && (this.onHomeOrEndKey(i), l = !0);
        break;
      case S.LEFT:
      case S.RIGHT:
      case S.UP:
      case S.DOWN:
        if (!n)
          return !1;
        o && !s && !r && (this.onCtrlUpDownLeftRight(i, n), l = !0);
        break;
      case S.PAGE_DOWN:
      case S.PAGE_UP:
        !o && !s && (l = this.handlePageUpDown(i, n, t));
        break;
    }
    return l && e.preventDefault(), l;
  }
  handlePageUpDown(e, t, i) {
    return i && (t = this.focusService.getFocusedCell()), t ? (e === S.PAGE_UP ? this.onPageUp(t) : this.onPageDown(t), !0) : !1;
  }
  navigateTo(e) {
    var t;
    const { scrollIndex: i, scrollType: s, scrollColumn: o, focusIndex: r, focusColumn: n } = e;
    b(o) && !o.isPinned() && this.gridBodyCon.getScrollFeature().ensureColumnVisible(o), b(i) && this.gridBodyCon.getScrollFeature().ensureIndexVisible(i, s), e.isAsync || this.gridBodyCon.getScrollFeature().ensureIndexVisible(r), this.focusService.setFocusedCell({ rowIndex: r, column: n, rowPinned: null, forceBrowserFocus: !0 }), (t = this.rangeService) == null || t.setRangeToCell({ rowIndex: r, rowPinned: null, column: n });
  }
  // this method is throttled, see the `constructor`
  onPageDown(e) {
    const i = this.ctrlsService.getGridBodyCtrl().getScrollFeature().getVScrollPosition(), s = this.getViewportHeight(), o = this.paginationProxy.getPixelOffset(), r = i.top + s, n = this.paginationProxy.getRowIndexAtPixel(r + o);
    this.columnModel.isAutoRowHeightActive() ? this.navigateToNextPageWithAutoHeight(e, n) : this.navigateToNextPage(e, n);
  }
  // this method is throttled, see the `constructor`
  onPageUp(e) {
    const i = this.ctrlsService.getGridBodyCtrl().getScrollFeature().getVScrollPosition(), s = this.paginationProxy.getPixelOffset(), o = i.top, r = this.paginationProxy.getRowIndexAtPixel(o + s);
    this.columnModel.isAutoRowHeightActive() ? this.navigateToNextPageWithAutoHeight(e, r, !0) : this.navigateToNextPage(e, r, !0);
  }
  navigateToNextPage(e, t, i = !1) {
    const s = this.getViewportHeight(), o = this.paginationProxy.getPageFirstRow(), r = this.paginationProxy.getPageLastRow(), n = this.paginationProxy.getPixelOffset(), l = this.paginationProxy.getRow(e.rowIndex), a = i ? (l == null ? void 0 : l.rowHeight) - s - n : s - n, d = (l == null ? void 0 : l.rowTop) + a;
    let c = this.paginationProxy.getRowIndexAtPixel(d + n);
    if (c === e.rowIndex) {
      const g = i ? -1 : 1;
      t = c = e.rowIndex + g;
    }
    let h;
    i ? (h = "bottom", c < o && (c = o), t < o && (t = o)) : (h = "top", c > r && (c = r), t > r && (t = r)), this.isRowTallerThanView(c) && (t = c, h = "top"), this.navigateTo({
      scrollIndex: t,
      scrollType: h,
      scrollColumn: null,
      focusIndex: c,
      focusColumn: e.column
    });
  }
  navigateToNextPageWithAutoHeight(e, t, i = !1) {
    this.navigateTo({
      scrollIndex: t,
      scrollType: i ? "bottom" : "top",
      scrollColumn: null,
      focusIndex: t,
      focusColumn: e.column
    }), setTimeout(() => {
      const s = this.getNextFocusIndexForAutoHeight(e, i);
      this.navigateTo({
        scrollIndex: t,
        scrollType: i ? "bottom" : "top",
        scrollColumn: null,
        focusIndex: s,
        focusColumn: e.column,
        isAsync: !0
      });
    }, 50);
  }
  getNextFocusIndexForAutoHeight(e, t = !1) {
    var i;
    const s = t ? -1 : 1, o = this.getViewportHeight(), r = this.paginationProxy.getPageLastRow();
    let n = 0, l = e.rowIndex;
    for (; l >= 0 && l <= r; ) {
      const a = this.paginationProxy.getRow(l);
      if (a) {
        const d = (i = a.rowHeight) != null ? i : 0;
        if (n + d > o)
          break;
        n += d;
      }
      l += s;
    }
    return Math.max(0, Math.min(l, r));
  }
  getViewportHeight() {
    const { gridBodyCtrl: e, center: t } = this.ctrlsService.getParams(), i = e.getScrollFeature().getVScrollPosition(), s = this.gos.getScrollbarWidth();
    let o = i.bottom - i.top;
    return t.isHorizontalScrollShowing() && (o -= s), o;
  }
  isRowTallerThanView(e) {
    const t = this.paginationProxy.getRow(e);
    if (!t)
      return !1;
    const i = t.rowHeight;
    return typeof i != "number" ? !1 : i > this.getViewportHeight();
  }
  onCtrlUpDownLeftRight(e, t) {
    const i = this.cellNavigationService.getNextCellToFocus(e, t, !0), { rowIndex: s, column: o } = i;
    this.navigateTo({
      scrollIndex: s,
      scrollType: null,
      scrollColumn: o,
      focusIndex: s,
      focusColumn: o
    });
  }
  // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
  // same cell into view (which means either scroll all the way up, or all the way down).
  onHomeOrEndKey(e) {
    const t = e === S.PAGE_HOME, i = this.columnModel.getAllDisplayedColumns(), s = t ? i[0] : se(i), o = t ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
    this.navigateTo({
      scrollIndex: o,
      scrollType: null,
      scrollColumn: s,
      focusIndex: o,
      focusColumn: s
    });
  }
  // result of keyboard event
  onTabKeyDown(e, t) {
    const i = t.shiftKey, s = this.tabToNextCellCommon(e, i, t);
    if (s !== !1) {
      s && t.preventDefault();
      return;
    }
    if (i) {
      const { rowIndex: o, rowPinned: r } = e.getRowPosition();
      (r ? o === 0 : o === this.paginationProxy.getPageFirstRow()) && (this.gos.get("headerHeight") === 0 || this.gos.get("suppressHeaderFocus") ? this.focusService.focusNextGridCoreContainer(!0, !0) : (t.preventDefault(), this.focusService.focusPreviousFromFirstCell(t)));
    } else
      e instanceof ns && e.focusCell(!0), this.focusService.focusNextGridCoreContainer(i) && t.preventDefault();
  }
  // comes from API
  tabToNextCell(e, t) {
    const i = this.focusService.getFocusedCell();
    if (!i)
      return !1;
    let s = this.getCellByPosition(i);
    return !s && (s = this.rowRenderer.getRowByPosition(i), !s || !s.isFullWidth()) ? !1 : !!this.tabToNextCellCommon(s, e, t);
  }
  tabToNextCellCommon(e, t, i) {
    let s = e.isEditing();
    if (!s && e instanceof ns) {
      const n = e.getRowCtrl();
      n && (s = n.isEditing());
    }
    let o;
    return s ? this.gos.get("editType") === "fullRow" ? o = this.moveToNextEditingRow(e, t, i) : o = this.moveToNextEditingCell(e, t, i) : o = this.moveToNextCellNotEditing(e, t), o === null ? o : o || !!this.focusService.getFocusedHeader();
  }
  // returns null if no navigation should be performed
  moveToNextEditingCell(e, t, i = null) {
    const s = e.getCellPosition();
    e.getGui().focus(), e.stopEditing();
    const o = this.findNextCellToFocusOn(s, t, !0);
    return o === !1 ? null : o == null ? !1 : (o.startEditing(null, !0, i), o.focusCell(!1), !0);
  }
  // returns null if no navigation should be performed
  moveToNextEditingRow(e, t, i = null) {
    const s = e.getCellPosition(), o = this.findNextCellToFocusOn(s, t, !0);
    if (o === !1)
      return null;
    if (o == null)
      return !1;
    const r = o.getCellPosition(), n = this.isCellEditable(s), l = this.isCellEditable(r), a = r && s.rowIndex === r.rowIndex && s.rowPinned === r.rowPinned;
    return n && e.setFocusOutOnEditor(), a || (e.getRowCtrl().stopEditing(), o.getRowCtrl().startRowEditing(void 0, void 0, i)), l ? (o.setFocusInOnEditor(), o.focusCell()) : o.focusCell(!0), !0;
  }
  // returns null if no navigation should be performed
  moveToNextCellNotEditing(e, t) {
    const i = this.columnModel.getAllDisplayedColumns();
    let s;
    e instanceof ls ? s = Re(_({}, e.getRowPosition()), {
      column: t ? i[0] : se(i)
    }) : s = e.getCellPosition();
    const o = this.findNextCellToFocusOn(s, t, !1);
    if (o === !1)
      return null;
    if (o instanceof ns)
      o.focusCell(!0);
    else if (o)
      return this.tryToFocusFullWidthRow(o.getRowPosition(), t);
    return b(o);
  }
  /**
   * called by the cell, when tab is pressed while editing.
   * @return: RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
   */
  findNextCellToFocusOn(e, t, i) {
    var s;
    let o = e;
    for (; ; ) {
      e !== o && (e = o), t || (o = this.getLastCellOfColSpan(o)), o = this.cellNavigationService.getNextTabbedCell(o, t);
      const r = this.gos.getCallback("tabToNextCell");
      if (b(r)) {
        const d = r({
          backwards: t,
          editing: i,
          previousCellPosition: e,
          nextCellPosition: o || null
        });
        if (d === !0 || d === null)
          d === null && H("Returning `null` from tabToNextCell is deprecated. Return `true` to stay on the current cell, or `false` to let the browser handle the tab behaviour."), o = e;
        else {
          if (d === !1)
            return !1;
          d.floating && (H("tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?"), d.rowPinned = d.floating), o = {
            rowIndex: d.rowIndex,
            column: d.column,
            rowPinned: d.rowPinned
          };
        }
      }
      if (!o)
        return null;
      if (o.rowIndex < 0) {
        const a = this.headerNavigationService.getHeaderRowCount();
        return this.focusService.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: a + o.rowIndex,
            column: o.column
          },
          fromCell: !0
        }), null;
      }
      const n = this.gos.get("editType") === "fullRow";
      if (i && !n && !this.isCellEditable(o))
        continue;
      this.ensureCellVisible(o);
      const l = this.getCellByPosition(o);
      if (!l) {
        const a = this.rowRenderer.getRowByPosition(o);
        if (!a || !a.isFullWidth() || i)
          continue;
        return a;
      }
      if (!l.isSuppressNavigable())
        return (s = this.rangeService) == null || s.setRangeToCell(o), l;
    }
  }
  isCellEditable(e) {
    const t = this.lookupRowNodeForCell(e);
    return t ? e.column.isCellEditable(t) : !1;
  }
  getCellByPosition(e) {
    const t = this.rowRenderer.getRowByPosition(e);
    return t ? t.getCellCtrl(e.column) : null;
  }
  lookupRowNodeForCell(e) {
    return e.rowPinned === "top" ? this.pinnedRowModel.getPinnedTopRow(e.rowIndex) : e.rowPinned === "bottom" ? this.pinnedRowModel.getPinnedBottomRow(e.rowIndex) : this.paginationProxy.getRow(e.rowIndex);
  }
  // we use index for rows, but column object for columns, as the next column (by index) might not
  // be visible (header grouping) so it's not reliable, so using the column object instead.
  navigateToNextCell(e, t, i, s) {
    let o = i, r = !1;
    for (; o && (o === i || !this.isValidNavigateCell(o)); )
      this.gos.get("enableRtl") ? t === S.LEFT && (o = this.getLastCellOfColSpan(o)) : t === S.RIGHT && (o = this.getLastCellOfColSpan(o)), o = this.cellNavigationService.getNextCellToFocus(t, o), r = z(o);
    if (r && e && e.key === S.UP && (o = {
      rowIndex: -1,
      rowPinned: null,
      column: i.column
    }), s) {
      const l = this.gos.getCallback("navigateToNextCell");
      if (b(l)) {
        const d = l({
          key: t,
          previousCellPosition: i,
          nextCellPosition: o || null,
          event: e
        });
        b(d) ? (d.floating && (H("tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?"), d.rowPinned = d.floating), o = {
          rowPinned: d.rowPinned,
          rowIndex: d.rowIndex,
          column: d.column
        }) : o = null;
      }
    }
    if (!o)
      return;
    if (o.rowIndex < 0) {
      const l = this.headerNavigationService.getHeaderRowCount();
      this.focusService.focusHeaderPosition({
        headerPosition: { headerRowIndex: l + o.rowIndex, column: i.column },
        event: e || void 0,
        fromCell: !0
      });
      return;
    }
    const n = this.getNormalisedPosition(o);
    n ? this.focusPosition(n) : this.tryToFocusFullWidthRow(o);
  }
  getNormalisedPosition(e) {
    this.ensureCellVisible(e);
    const t = this.getCellByPosition(e);
    return t ? (e = t.getCellPosition(), this.ensureCellVisible(e), e) : null;
  }
  tryToFocusFullWidthRow(e, t = !1) {
    const i = this.columnModel.getAllDisplayedColumns(), s = this.rowRenderer.getRowByPosition(e);
    if (!s || !s.isFullWidth())
      return !1;
    const o = this.focusService.getFocusedCell(), r = {
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: e.column || (t ? se(i) : i[0])
    };
    this.focusPosition(r);
    const n = o != null ? this.rowPositionUtils.before(r, o) : !1, l = {
      type: p.EVENT_FULL_WIDTH_ROW_FOCUSED,
      rowIndex: r.rowIndex,
      rowPinned: r.rowPinned,
      column: r.column,
      isFullWidthCell: !0,
      floating: r.rowPinned,
      fromBelow: n
    };
    return this.eventService.dispatchEvent(l), !0;
  }
  focusPosition(e) {
    var t;
    this.focusService.setFocusedCell({
      rowIndex: e.rowIndex,
      column: e.column,
      rowPinned: e.rowPinned,
      forceBrowserFocus: !0
    }), (t = this.rangeService) == null || t.setRangeToCell(e);
  }
  isValidNavigateCell(e) {
    return !!this.rowPositionUtils.getRowNode(e);
  }
  getLastCellOfColSpan(e) {
    const t = this.getCellByPosition(e);
    if (!t)
      return e;
    const i = t.getColSpanningList();
    return i.length === 1 ? e : {
      rowIndex: e.rowIndex,
      column: se(i),
      rowPinned: e.rowPinned
    };
  }
  ensureCellVisible(e) {
    const t = this.gos.isGroupRowsSticky(), i = this.rowModel.getRow(e.rowIndex);
    !(t && (i == null ? void 0 : i.sticky)) && z(e.rowPinned) && this.gridBodyCon.getScrollFeature().ensureIndexVisible(e.rowIndex), e.column.isPinned() || this.gridBodyCon.getScrollFeature().ensureColumnVisible(e.column);
  }
};
u([
  f("mouseEventService")
], it.prototype, "mouseEventService", 2);
u([
  f("paginationProxy")
], it.prototype, "paginationProxy", 2);
u([
  f("focusService")
], it.prototype, "focusService", 2);
u([
  f("columnModel")
], it.prototype, "columnModel", 2);
u([
  f("rowModel")
], it.prototype, "rowModel", 2);
u([
  f("ctrlsService")
], it.prototype, "ctrlsService", 2);
u([
  f("rowRenderer")
], it.prototype, "rowRenderer", 2);
u([
  f("headerNavigationService")
], it.prototype, "headerNavigationService", 2);
u([
  f("rowPositionUtils")
], it.prototype, "rowPositionUtils", 2);
u([
  f("cellNavigationService")
], it.prototype, "cellNavigationService", 2);
u([
  f("pinnedRowModel")
], it.prototype, "pinnedRowModel", 2);
u([
  ue("rangeService")
], it.prototype, "rangeService", 2);
u([
  L
], it.prototype, "postConstruct", 1);
it = u([
  O("navigationService")
], it);
var za = class Dh extends bs {
  constructor(t) {
    super(
      /* html */
      '<div class="ag-popup-editor" tabindex="-1"/>'
    ), this.params = t;
  }
  postConstruct() {
    this.gos.setDomData(this.getGui(), Dh.DOM_KEY_POPUP_EDITOR_WRAPPER, !0), this.addKeyDownListener();
  }
  addKeyDownListener() {
    const t = this.getGui(), i = this.params, s = (o) => {
      en(this.gos, o, i.node, i.column, !0) || i.onKeyDown(o);
    };
    this.addManagedListener(t, "keydown", s);
  }
};
za.DOM_KEY_POPUP_EDITOR_WRAPPER = "popupEditorWrapper";
u([
  L
], za.prototype, "postConstruct", 1);
var Th = za, Hf = class extends K {
  constructor(t, i, s, o, r) {
    super(), this.rendererVersion = 0, this.editorVersion = 0, this.beans = t, this.column = i.getColumn(), this.rowNode = i.getRowNode(), this.rowCtrl = i.getRowCtrl(), this.eRow = o, this.cellCtrl = i;
    const n = document.createElement("div");
    n.setAttribute("comp-id", `${this.getCompId()}`), this.setTemplateFromElement(n);
    const l = this.getGui();
    this.forceWrapper = i.isForceWrapper(), this.refreshWrapper(!1);
    const a = (h, g) => {
      g != null && g != "" ? l.setAttribute(h, g) : l.removeAttribute(h);
    };
    Fe(l, i.getCellAriaRole()), a("col-id", i.getColumnIdSanitised());
    const d = i.getTabIndex();
    d !== void 0 && a("tabindex", d.toString());
    const c = {
      addOrRemoveCssClass: (h, g) => this.addOrRemoveCssClass(h, g),
      setUserStyles: (h) => Ta(l, h),
      getFocusableElement: () => this.getFocusableElement(),
      setIncludeSelection: (h) => this.includeSelection = h,
      setIncludeRowDrag: (h) => this.includeRowDrag = h,
      setIncludeDndSource: (h) => this.includeDndSource = h,
      setRenderDetails: (h, g, m) => this.setRenderDetails(h, g, m),
      setEditDetails: (h, g, m) => this.setEditDetails(h, g, m),
      getCellEditor: () => this.cellEditor || null,
      getCellRenderer: () => this.cellRenderer || null,
      getParentOfValue: () => this.getParentOfValue()
    };
    i.setComp(c, this.getGui(), this.eCellWrapper, s, r);
  }
  getParentOfValue() {
    return this.eCellValue ? this.eCellValue : this.eCellWrapper ? this.eCellWrapper : this.getGui();
  }
  setRenderDetails(t, i, s) {
    if (this.cellEditor && !this.cellEditorPopupWrapper)
      return;
    this.firstRender = this.firstRender == null;
    const r = this.refreshWrapper(!1);
    this.refreshEditStyles(!1), t ? !(s || r) && this.refreshCellRenderer(t) || (this.destroyRenderer(), this.createCellRendererInstance(t)) : (this.destroyRenderer(), this.insertValueWithoutCellRenderer(i));
  }
  setEditDetails(t, i, s) {
    t ? this.createCellEditorInstance(t, i, s) : this.destroyEditor();
  }
  removeControls() {
    this.checkboxSelectionComp = this.beans.context.destroyBean(this.checkboxSelectionComp), this.dndSourceComp = this.beans.context.destroyBean(this.dndSourceComp), this.rowDraggingComp = this.beans.context.destroyBean(this.rowDraggingComp);
  }
  // returns true if wrapper was changed
  refreshWrapper(t) {
    const i = this.includeRowDrag || this.includeDndSource || this.includeSelection, s = i || this.forceWrapper, o = s && this.eCellWrapper == null;
    if (o) {
      const c = document.createElement("div");
      c.setAttribute("role", "presentation"), c.setAttribute("class", "ag-cell-wrapper"), this.eCellWrapper = c, this.getGui().appendChild(this.eCellWrapper);
    }
    const r = !s && this.eCellWrapper != null;
    r && ($t(this.eCellWrapper), this.eCellWrapper = void 0), this.addOrRemoveCssClass("ag-cell-value", !s);
    const n = !t && s, l = n && this.eCellValue == null;
    if (l) {
      const c = document.createElement("span");
      c.setAttribute("role", "presentation"), c.setAttribute("class", "ag-cell-value"), this.eCellValue = c, this.eCellWrapper.appendChild(this.eCellValue);
    }
    const a = !n && this.eCellValue != null;
    a && ($t(this.eCellValue), this.eCellValue = void 0);
    const d = o || r || l || a;
    return d && this.removeControls(), t || i && this.addControls(), d;
  }
  addControls() {
    this.includeRowDrag && this.rowDraggingComp == null && (this.rowDraggingComp = this.cellCtrl.createRowDragComp(), this.rowDraggingComp && this.eCellWrapper.insertBefore(this.rowDraggingComp.getGui(), this.eCellValue)), this.includeDndSource && this.dndSourceComp == null && (this.dndSourceComp = this.cellCtrl.createDndSource(), this.eCellWrapper.insertBefore(this.dndSourceComp.getGui(), this.eCellValue)), this.includeSelection && this.checkboxSelectionComp == null && (this.checkboxSelectionComp = this.cellCtrl.createSelectionCheckbox(), this.eCellWrapper.insertBefore(this.checkboxSelectionComp.getGui(), this.eCellValue));
  }
  createCellEditorInstance(t, i, s) {
    const o = this.editorVersion, r = t.newAgStackInstance();
    if (!r)
      return;
    const { params: n } = t;
    r.then((a) => this.afterCellEditorCreated(o, a, n, i, s)), z(this.cellEditor) && n.cellStartedEdit && this.cellCtrl.focusCell(!0);
  }
  insertValueWithoutCellRenderer(t) {
    const i = this.getParentOfValue();
    xe(i);
    const s = t != null ? Oe(t, !0) : null;
    s != null && (i.textContent = s);
  }
  destroyEditorAndRenderer() {
    this.destroyRenderer(), this.destroyEditor();
  }
  destroyRenderer() {
    const { context: t } = this.beans;
    this.cellRenderer = t.destroyBean(this.cellRenderer), $t(this.cellRendererGui), this.cellRendererGui = null, this.rendererVersion++;
  }
  destroyEditor() {
    const { context: t } = this.beans;
    this.hideEditorPopup && this.hideEditorPopup(), this.hideEditorPopup = void 0, this.cellEditor = t.destroyBean(this.cellEditor), this.cellEditorPopupWrapper = t.destroyBean(this.cellEditorPopupWrapper), $t(this.cellEditorGui), this.cellEditorGui = null, this.editorVersion++;
  }
  refreshCellRenderer(t) {
    if (this.cellRenderer == null || this.cellRenderer.refresh == null || this.cellRendererClass !== t.componentClass)
      return !1;
    const i = this.cellRenderer.refresh(t.params);
    return i === !0 || i === void 0;
  }
  createCellRendererInstance(t) {
    const s = !this.beans.gos.get("suppressAnimationFrame"), o = this.rendererVersion, { componentClass: r } = t, n = () => {
      if (this.rendererVersion !== o || !this.isAlive())
        return;
      const a = t.newAgStackInstance(), d = this.afterCellRendererCreated.bind(this, o, r);
      a && a.then(d);
    };
    s && this.firstRender ? this.beans.animationFrameService.createTask(n, this.rowNode.rowIndex, "createTasksP2") : n();
  }
  getCtrl() {
    return this.cellCtrl;
  }
  getRowCtrl() {
    return this.rowCtrl;
  }
  getCellRenderer() {
    return this.cellRenderer;
  }
  getCellEditor() {
    return this.cellEditor;
  }
  afterCellRendererCreated(t, i, s) {
    if (!this.isAlive() || t !== this.rendererVersion) {
      this.beans.context.destroyBean(s);
      return;
    }
    if (this.cellRenderer = s, this.cellRendererClass = i, this.cellRendererGui = this.cellRenderer.getGui(), this.cellRendererGui != null) {
      const r = this.getParentOfValue();
      xe(r), r.appendChild(this.cellRendererGui);
    }
  }
  afterCellEditorCreated(t, i, s, o, r) {
    if (t !== this.editorVersion) {
      this.beans.context.destroyBean(i);
      return;
    }
    if (i.isCancelBeforeStart && i.isCancelBeforeStart()) {
      this.beans.context.destroyBean(i), this.cellCtrl.stopEditing(!0);
      return;
    }
    if (!i.getGui) {
      console.warn(`AG Grid: cellEditor for column ${this.column.getId()} is missing getGui() method`), this.beans.context.destroyBean(i);
      return;
    }
    this.cellEditor = i, this.cellEditorGui = i.getGui();
    const a = o || i.isPopup !== void 0 && i.isPopup();
    a ? this.addPopupCellEditor(s, r) : this.addInCellEditor(), this.refreshEditStyles(!0, a), i.afterGuiAttached && i.afterGuiAttached();
  }
  refreshEditStyles(t, i) {
    var s;
    this.addOrRemoveCssClass("ag-cell-inline-editing", t && !i), this.addOrRemoveCssClass("ag-cell-popup-editing", t && !!i), this.addOrRemoveCssClass("ag-cell-not-inline-editing", !t || !!i), (s = this.rowCtrl) == null || s.setInlineEditingCss(t);
  }
  addInCellEditor() {
    const t = this.getGui();
    t.contains(this.beans.gos.getActiveDomElement()) && t.focus(), this.destroyRenderer(), this.refreshWrapper(!0), this.clearParentOfValue(), this.cellEditorGui && this.getParentOfValue().appendChild(this.cellEditorGui);
  }
  addPopupCellEditor(t, i) {
    this.beans.gos.get("editType") === "fullRow" && console.warn("AG Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.");
    const s = this.cellEditor;
    this.cellEditorPopupWrapper = this.beans.context.createBean(new Th(t));
    const o = this.cellEditorPopupWrapper.getGui();
    this.cellEditorGui && o.appendChild(this.cellEditorGui);
    const r = this.beans.popupService, n = this.beans.gos.get("stopEditingWhenCellsLoseFocus"), l = i ?? (s.getPopupPosition ? s.getPopupPosition() : "over"), a = this.beans.gos.get("enableRtl"), d = {
      ePopup: o,
      column: this.column,
      rowNode: this.rowNode,
      type: "popupCellEditor",
      eventSource: this.getGui(),
      position: l,
      alignSide: a ? "right" : "left",
      keepWithinBounds: !0
    }, c = r.positionPopupByComponent.bind(r, d), h = this.beans.localeService.getLocaleTextFunc(), g = r.addPopup({
      modal: n,
      eChild: o,
      closeOnEsc: !0,
      closedCallback: () => {
        this.cellCtrl.onPopupEditorClosed();
      },
      anchorToElement: this.getGui(),
      positionCallback: c,
      ariaLabel: h("ariaLabelCellEditor", "Cell Editor")
    });
    g && (this.hideEditorPopup = g.hideFunc);
  }
  detach() {
    this.eRow.removeChild(this.getGui());
  }
  // if the row is also getting destroyed, then we don't need to remove from dom,
  // as the row will also get removed, so no need to take out the cells from the row
  // if the row is going (removing is an expensive operation, so only need to remove
  // the top part)
  //
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  destroy() {
    this.cellCtrl.stopEditing(), this.destroyEditorAndRenderer(), this.removeControls(), super.destroy();
  }
  clearParentOfValue() {
    const t = this.getGui();
    t.contains(this.beans.gos.getActiveDomElement()) && fa() && t.focus({ preventScroll: !0 }), xe(this.getParentOfValue());
  }
}, kf = class extends K {
  constructor(t, i, s) {
    super(), this.cellComps = {}, this.beans = i, this.rowCtrl = t;
    const o = document.createElement("div");
    o.setAttribute("comp-id", `${this.getCompId()}`), o.setAttribute("style", this.getInitialStyle(s)), this.setTemplateFromElement(o);
    const r = this.getGui(), n = r.style;
    this.domOrder = this.rowCtrl.getDomOrder(), Fe(r, "row");
    const l = this.rowCtrl.getTabIndex();
    l != null && r.setAttribute("tabindex", l.toString());
    const a = {
      setDomOrder: (d) => this.domOrder = d,
      setCellCtrls: (d) => this.setCellCtrls(d),
      showFullWidth: (d) => this.showFullWidth(d),
      getFullWidthCellRenderer: () => this.getFullWidthCellRenderer(),
      addOrRemoveCssClass: (d, c) => this.addOrRemoveCssClass(d, c),
      setUserStyles: (d) => Ta(r, d),
      setTop: (d) => n.top = d,
      setTransform: (d) => n.transform = d,
      setRowIndex: (d) => r.setAttribute("row-index", d),
      setRowId: (d) => r.setAttribute("row-id", d),
      setRowBusinessKey: (d) => r.setAttribute("row-business-key", d),
      refreshFullWidth: (d) => this.refreshFullWidth(d)
    };
    t.setComp(a, this.getGui(), s), this.addDestroyFunc(() => {
      t.unsetComp(s);
    });
  }
  getInitialStyle(t) {
    const i = this.rowCtrl.getInitialTransform(t);
    return i ? `transform: ${i}` : `top: ${this.rowCtrl.getInitialRowTop(t)}`;
  }
  showFullWidth(t) {
    const i = (o) => {
      if (this.isAlive()) {
        const r = o.getGui();
        this.getGui().appendChild(r), this.rowCtrl.setupDetailRowAutoHeight(r), this.setFullWidthRowComp(o);
      } else
        this.beans.context.destroyBean(o);
    }, s = t.newAgStackInstance();
    s && s.then(i);
  }
  setCellCtrls(t) {
    const i = Object.assign({}, this.cellComps);
    t.forEach((o) => {
      const r = o.getInstanceId();
      this.cellComps[r] == null ? this.newCellComp(o) : i[r] = null;
    });
    const s = Ii(i).filter((o) => o != null);
    this.destroyCells(s), this.ensureDomOrder(t);
  }
  ensureDomOrder(t) {
    if (!this.domOrder)
      return;
    const i = [];
    t.forEach((s) => {
      const o = this.cellComps[s.getInstanceId()];
      o && i.push(o.getGui());
    }), Da(this.getGui(), i);
  }
  newCellComp(t) {
    const i = new Hf(
      this.beans,
      t,
      this.rowCtrl.isPrintLayout(),
      this.getGui(),
      this.rowCtrl.isEditing()
    );
    this.cellComps[t.getInstanceId()] = i, this.getGui().appendChild(i.getGui());
  }
  destroy() {
    super.destroy(), this.destroyAllCells();
  }
  destroyAllCells() {
    const t = Ii(this.cellComps).filter((i) => i != null);
    this.destroyCells(t);
  }
  setFullWidthRowComp(t) {
    this.fullWidthCellRenderer && console.error("AG Grid - should not be setting fullWidthRowComponent twice"), this.fullWidthCellRenderer = t, this.addDestroyFunc(() => {
      this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer);
    });
  }
  getFullWidthCellRenderer() {
    return this.fullWidthCellRenderer;
  }
  destroyCells(t) {
    t.forEach((i) => {
      if (!i)
        return;
      const s = i.getCtrl().getInstanceId();
      this.cellComps[s] === i && (i.detach(), i.destroy(), this.cellComps[s] = null);
    });
  }
  refreshFullWidth(t) {
    const { fullWidthCellRenderer: i } = this;
    if (!i || !i.refresh)
      return !1;
    const s = t();
    return i.refresh(s);
  }
};
function Bf() {
  const e = K.elementGettingCreated.getAttribute("name"), t = on.getRowContainerCssClasses(e);
  let i;
  return e === "center" || e === "topCenter" || e === "stickyTopCenter" || e === "bottomCenter" || e === "stickyBottomCenter" ? i = /* html */
  `<div class="${t.viewport}" ref="eViewport" role="presentation">
                <div class="${t.container}" ref="eContainer"></div>
            </div>` : i = /* html */
  `<div class="${t.container}" ref="eContainer"></div>`, i;
}
var ho = class extends K {
  constructor() {
    super(Bf()), this.rowComps = {}, this.name = K.elementGettingCreated.getAttribute("name"), this.type = yh(this.name);
  }
  postConstruct() {
    const t = {
      setViewportHeight: (s) => this.eViewport.style.height = s,
      setRowCtrls: ({ rowCtrls: s }) => this.setRowCtrls(s),
      setDomOrder: (s) => {
        this.domOrder = s;
      },
      setContainerWidth: (s) => this.eContainer.style.width = s
    };
    this.createManagedBean(new on(this.name)).setComp(t, this.eContainer, this.eViewport);
  }
  preDestroy() {
    this.setRowCtrls([]);
  }
  setRowCtrls(t) {
    const i = _({}, this.rowComps);
    this.rowComps = {}, this.lastPlacedElement = null;
    const s = (o) => {
      const r = o.getInstanceId(), n = i[r];
      if (n)
        this.rowComps[r] = n, delete i[r], this.ensureDomOrder(n.getGui());
      else {
        if (!o.getRowNode().displayed)
          return;
        const l = new kf(o, this.beans, this.type);
        this.rowComps[r] = l, this.appendRow(l.getGui());
      }
    };
    t.forEach(s), Ii(i).forEach((o) => {
      this.eContainer.removeChild(o.getGui()), o.destroy();
    }), Fe(this.eContainer, "rowgroup");
  }
  appendRow(t) {
    this.domOrder ? hc(this.eContainer, t, this.lastPlacedElement) : this.eContainer.appendChild(t), this.lastPlacedElement = t;
  }
  ensureDomOrder(t) {
    this.domOrder && (Ra(this.eContainer, t, this.lastPlacedElement), this.lastPlacedElement = t);
  }
};
u([
  f("beans")
], ho.prototype, "beans", 2);
u([
  M("eViewport")
], ho.prototype, "eViewport", 2);
u([
  M("eContainer")
], ho.prototype, "eContainer", 2);
u([
  L
], ho.prototype, "postConstruct", 1);
u([
  dt
], ho.prototype, "preDestroy", 1);
var Ka = class {
  constructor(e) {
    this.columnsToAggregate = [], this.columnsToGroup = [], this.columnsToPivot = [], this.pinned = e;
  }
  /** Callback for when drag enters */
  onDragEnter(e) {
    if (this.clearColumnsList(), this.gos.get("functionsReadOnly"))
      return;
    const t = e.dragItem.columns;
    t && t.forEach((i) => {
      i.isPrimary() && (i.isAnyFunctionActive() || (i.isAllowValue() ? this.columnsToAggregate.push(i) : i.isAllowRowGroup() ? this.columnsToGroup.push(i) : i.isAllowPivot() && this.columnsToPivot.push(i)));
    });
  }
  getIconName() {
    return this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length > 0 ? this.pinned ? Y.ICON_PINNED : Y.ICON_MOVE : null;
  }
  /** Callback for when drag leaves */
  onDragLeave(e) {
    this.clearColumnsList();
  }
  clearColumnsList() {
    this.columnsToAggregate.length = 0, this.columnsToGroup.length = 0, this.columnsToPivot.length = 0;
  }
  /** Callback for when dragging */
  onDragging(e) {
  }
  /** Callback for when drag stops */
  onDragStop(e) {
    this.columnsToAggregate.length > 0 && this.columnModel.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop"), this.columnsToGroup.length > 0 && this.columnModel.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop"), this.columnsToPivot.length > 0 && this.columnModel.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
  }
};
u([
  f("columnModel")
], Ka.prototype, "columnModel", 2);
u([
  f("gridOptionsService")
], Ka.prototype, "gos", 2);
var as = class {
  static attemptMoveColumns(e) {
    const { isFromHeader: t, hDirection: i, xPosition: s, fromEnter: o, fakeEvent: r, pinned: n, gos: l, columnModel: a } = e, d = i === 0, c = i === 1;
    let { allMovingColumns: h } = e;
    if (t) {
      let R = [];
      h.forEach((T) => {
        var I;
        let A = null, V = T.getParent();
        for (; V != null && V.getDisplayedLeafColumns().length === 1; )
          A = V, V = V.getParent();
        A != null ? (!!((I = A.getColGroupDef()) != null && I.marryChildren) ? A.getProvidedColumnGroup().getLeafColumns() : A.getLeafColumns()).forEach((B) => {
          R.includes(B) || R.push(B);
        }) : R.includes(T) || R.push(T);
      }), h = R;
    }
    const g = h.slice();
    a.sortColumnsLikeGridColumns(g);
    const m = this.calculateValidMoves({
      movingCols: g,
      draggingRight: c,
      xPosition: s,
      pinned: n,
      gos: l,
      columnModel: a
    }), C = this.calculateOldIndex(g, a);
    if (m.length === 0)
      return;
    const w = m[0];
    let v = C !== null && !o;
    if (t && (v = C !== null), v && !r && (d && w >= C || c && w <= C))
      return;
    const y = a.getAllDisplayedColumns();
    let E = [], D = null;
    for (let R = 0; R < m.length; R++) {
      const T = m[R], I = a.getProposedColumnOrder(g, T);
      if (!a.doesOrderPassRules(I))
        continue;
      const A = I.filter((x) => y.includes(x));
      if (D === null)
        D = A;
      else if (!ii(A, D))
        break;
      const V = this.groupFragCount(I);
      E.push({ move: T, fragCount: V });
    }
    if (E.length !== 0)
      return E.sort((R, T) => R.fragCount - T.fragCount), this.moveColumns(h, E[0].move, "uiColumnMoved", !1, a);
  }
  static moveColumns(e, t, i, s, o) {
    return o.moveColumns(e, t, i, s), s ? null : { columns: e, toIndex: t };
  }
  // returns the index of the first column in the list ONLY if the cols are all beside
  // each other. if the cols are not beside each other, then returns null
  static calculateOldIndex(e, t) {
    const i = t.getAllGridColumns(), s = Tu(e.map((a) => i.indexOf(a))), o = s[0];
    return se(s) - o !== s.length - 1 ? null : o;
  }
  // A measure of how fragmented in terms of groups an order of columns is
  static groupFragCount(e) {
    function t(s) {
      let o = [], r = s.getOriginalParent();
      for (; r != null; )
        o.push(r), r = r.getOriginalParent();
      return o;
    }
    let i = 0;
    for (let s = 0; s < e.length - 1; s++) {
      let o = t(e[s]), r = t(e[s + 1]);
      [o, r] = o.length > r.length ? [o, r] : [r, o], o.forEach((n) => {
        r.indexOf(n) === -1 && i++;
      });
    }
    return i;
  }
  static getDisplayedColumns(e, t) {
    switch (t) {
      case "left":
        return e.getDisplayedLeftColumns();
      case "right":
        return e.getDisplayedRightColumns();
      default:
        return e.getDisplayedCenterColumns();
    }
  }
  static calculateValidMoves(e) {
    const { movingCols: t, draggingRight: i, xPosition: s, pinned: o, gos: r, columnModel: n } = e;
    if (r.get("suppressMovableColumns") || t.some((E) => E.getColDef().suppressMovable))
      return [];
    const a = this.getDisplayedColumns(n, o), d = n.getAllGridColumns(), c = a.filter((E) => Tt(t, E)), h = a.filter((E) => !Tt(t, E)), g = d.filter((E) => !Tt(t, E));
    let m = 0, C = s;
    if (i) {
      let E = 0;
      c.forEach((D) => E += D.getActualWidth()), C -= E;
    }
    if (C > 0) {
      for (let E = 0; E < h.length; E++) {
        const D = h[E];
        if (C -= D.getActualWidth(), C < 0)
          break;
        m++;
      }
      i && m++;
    }
    let w;
    if (m > 0) {
      const E = h[m - 1];
      w = g.indexOf(E) + 1;
    } else
      w = g.indexOf(h[0]), w === -1 && (w = 0);
    const v = [w], y = (E, D) => E - D;
    if (i) {
      let E = w + 1;
      const D = d.length - 1;
      for (; E <= D; )
        v.push(E), E++;
      v.sort(y);
    } else {
      let E = w;
      const D = d.length - 1;
      let R = d[E];
      for (; E <= D && a.indexOf(R) < 0; )
        E++, v.push(E), R = d[E];
      E = w - 1;
      const T = 0;
      for (; E >= T; )
        v.push(E), E--;
      v.sort(y).reverse();
    }
    return v;
  }
  static normaliseX(e, t, i, s, o) {
    const r = o.getHeaderRowContainerCtrl(t).getViewport();
    return i && (e -= r.getBoundingClientRect().left), s.get("enableRtl") && (e = r.clientWidth - e), t == null && (e += o.get("center").getCenterViewportScrollLeft()), e;
  }
}, po = class {
  constructor(e) {
    this.needToMoveLeft = !1, this.needToMoveRight = !1, this.lastMovedInfo = null, this.pinned = e, this.isCenterContainer = !b(e);
  }
  init() {
    this.ctrlsService.whenReady((e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  getIconName() {
    return this.pinned ? Y.ICON_PINNED : Y.ICON_MOVE;
  }
  onDragEnter(e) {
    const t = e.dragItem.columns;
    if (e.dragSource.type === 0)
      this.setColumnsVisible(t, !0, "uiColumnDragged");
    else {
      const s = e.dragItem.visibleState, o = (t || []).filter((r) => s[r.getId()]);
      this.setColumnsVisible(o, !0, "uiColumnDragged");
    }
    this.setColumnsPinned(t, this.pinned, "uiColumnDragged"), this.onDragging(e, !0, !0);
  }
  onDragLeave() {
    this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  setColumnsVisible(e, t, i) {
    if (e) {
      const s = e.filter((o) => !o.getColDef().lockVisible);
      this.columnModel.setColumnsVisible(s, t, i);
    }
  }
  setColumnsPinned(e, t, i) {
    if (e) {
      const s = e.filter((o) => !o.getColDef().lockPinned);
      this.columnModel.setColumnsPinned(s, t, i);
    }
  }
  onDragStop() {
    this.onDragging(this.lastDraggingEvent, !1, !0, !0), this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  checkCenterForScrolling(e) {
    if (this.isCenterContainer) {
      const t = this.ctrlsService.get("center"), i = t.getCenterViewportScrollLeft(), s = i + t.getCenterWidth();
      this.gos.get("enableRtl") ? (this.needToMoveRight = e < i + 50, this.needToMoveLeft = e > s - 50) : (this.needToMoveLeft = e < i + 50, this.needToMoveRight = e > s - 50), this.needToMoveLeft || this.needToMoveRight ? this.ensureIntervalStarted() : this.ensureIntervalCleared();
    }
  }
  onDragging(e = this.lastDraggingEvent, t = !1, i = !1, s = !1) {
    var o;
    if (s) {
      if (this.lastMovedInfo) {
        const { columns: c, toIndex: h } = this.lastMovedInfo;
        as.moveColumns(c, h, "uiColumnMoved", !0, this.columnModel);
      }
      return;
    }
    if (this.lastDraggingEvent = e, z(e.hDirection))
      return;
    const r = as.normaliseX(
      e.x,
      this.pinned,
      !1,
      this.gos,
      this.ctrlsService
    );
    t || this.checkCenterForScrolling(r);
    const n = this.normaliseDirection(e.hDirection), l = e.dragSource.type, a = ((o = e.dragSource.getDragItem().columns) == null ? void 0 : o.filter((c) => c.getColDef().lockPinned ? c.getPinned() == this.pinned : !0)) || [], d = as.attemptMoveColumns({
      allMovingColumns: a,
      isFromHeader: l === 1,
      hDirection: n,
      xPosition: r,
      pinned: this.pinned,
      fromEnter: t,
      fakeEvent: i,
      gos: this.gos,
      columnModel: this.columnModel
    });
    d && (this.lastMovedInfo = d);
  }
  normaliseDirection(e) {
    if (this.gos.get("enableRtl"))
      switch (e) {
        case 0:
          return 1;
        case 1:
          return 0;
        default:
          console.error(`AG Grid: Unknown direction ${e}`);
      }
    else
      return e;
  }
  ensureIntervalStarted() {
    this.movingIntervalId || (this.intervalCount = 0, this.failedMoveAttempts = 0, this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100), this.needToMoveLeft ? this.dragAndDropService.setGhostIcon(Y.ICON_LEFT, !0) : this.dragAndDropService.setGhostIcon(Y.ICON_RIGHT, !0));
  }
  ensureIntervalCleared() {
    this.movingIntervalId && (window.clearInterval(this.movingIntervalId), this.movingIntervalId = null, this.dragAndDropService.setGhostIcon(Y.ICON_MOVE));
  }
  moveInterval() {
    let e;
    this.intervalCount++, e = 10 + this.intervalCount * 5, e > 100 && (e = 100);
    let t = null;
    const i = this.gridBodyCon.getScrollFeature();
    if (this.needToMoveLeft ? t = i.scrollHorizontally(-e) : this.needToMoveRight && (t = i.scrollHorizontally(e)), t !== 0)
      this.onDragging(this.lastDraggingEvent), this.failedMoveAttempts = 0;
    else {
      this.failedMoveAttempts++;
      const o = this.lastDraggingEvent.dragItem.columns.filter((r) => !r.getColDef().lockPinned);
      if (o.length > 0 && (this.dragAndDropService.setGhostIcon(Y.ICON_PINNED), this.failedMoveAttempts > 7)) {
        const r = this.needToMoveLeft ? "left" : "right";
        this.setColumnsPinned(o, r, "uiColumnDragged"), this.dragAndDropService.nudge();
      }
    }
  }
};
u([
  f("columnModel")
], po.prototype, "columnModel", 2);
u([
  f("dragAndDropService")
], po.prototype, "dragAndDropService", 2);
u([
  f("gridOptionsService")
], po.prototype, "gos", 2);
u([
  f("ctrlsService")
], po.prototype, "ctrlsService", 2);
u([
  L
], po.prototype, "init", 1);
var go = class extends F {
  constructor(e, t) {
    super(), this.pinned = e, this.eContainer = t;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      switch (this.pinned) {
        case "left":
          this.eSecondaryContainers = [
            [e.gridBodyCtrl.getBodyViewportElement(), e.left.getContainerElement()],
            [e.bottomLeft.getContainerElement()],
            [e.topLeft.getContainerElement()]
          ];
          break;
        case "right":
          this.eSecondaryContainers = [
            [e.gridBodyCtrl.getBodyViewportElement(), e.right.getContainerElement()],
            [e.bottomRight.getContainerElement()],
            [e.topRight.getContainerElement()]
          ];
          break;
        default:
          this.eSecondaryContainers = [
            [e.gridBodyCtrl.getBodyViewportElement(), e.center.getViewportElement()],
            [e.bottomCenter.getViewportElement()],
            [e.topCenter.getViewportElement()]
          ];
          break;
      }
    });
  }
  isInterestedIn(e) {
    return e === 1 || e === 0 && this.gos.get("allowDragFromColumnsToolPanel");
  }
  getSecondaryContainers() {
    return this.eSecondaryContainers;
  }
  getContainer() {
    return this.eContainer;
  }
  init() {
    this.moveColumnFeature = this.createManagedBean(new po(this.pinned)), this.bodyDropPivotTarget = this.createManagedBean(new Ka(this.pinned)), this.dragAndDropService.addDropTarget(this);
  }
  getIconName() {
    return this.currentDropListener.getIconName();
  }
  // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
  // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
  // dropped into the grid's body.
  isDropColumnInPivotMode(e) {
    return this.columnModel.isPivotMode() && e.dragSource.type === 0;
  }
  onDragEnter(e) {
    this.currentDropListener = this.isDropColumnInPivotMode(e) ? this.bodyDropPivotTarget : this.moveColumnFeature, this.currentDropListener.onDragEnter(e);
  }
  onDragLeave(e) {
    this.currentDropListener.onDragLeave(e);
  }
  onDragging(e) {
    this.currentDropListener.onDragging(e);
  }
  onDragStop(e) {
    this.currentDropListener.onDragStop(e);
  }
};
u([
  f("dragAndDropService")
], go.prototype, "dragAndDropService", 2);
u([
  f("columnModel")
], go.prototype, "columnModel", 2);
u([
  f("ctrlsService")
], go.prototype, "ctrlsService", 2);
u([
  L
], go.prototype, "postConstruct", 1);
u([
  L
], go.prototype, "init", 1);
var fo = class bh extends Ba {
  constructor(t) {
    super(bh.TEMPLATE, t), this.headerCompVersion = 0, this.column = t.getColumnGroupChild(), this.pinned = t.getPinned();
  }
  postConstruct() {
    const t = this.getGui();
    ((r, n) => {
      n != null && n != "" ? t.setAttribute(r, n) : t.removeAttribute(r);
    })("col-id", this.column.getColId());
    const s = {
      setWidth: (r) => t.style.width = r,
      addOrRemoveCssClass: (r, n) => this.addOrRemoveCssClass(r, n),
      setAriaSort: (r) => r ? Zu(t, r) : Ju(t),
      setUserCompDetails: (r) => this.setUserCompDetails(r),
      getUserCompInstance: () => this.headerComp
    };
    this.ctrl.setComp(s, this.getGui(), this.eResize, this.eHeaderCompWrapper);
    const o = this.ctrl.getSelectAllGui();
    this.eResize.insertAdjacentElement("afterend", o);
  }
  destroyHeaderComp() {
    this.headerComp && (this.eHeaderCompWrapper.removeChild(this.headerCompGui), this.headerComp = this.destroyBean(this.headerComp), this.headerCompGui = void 0);
  }
  setUserCompDetails(t) {
    this.headerCompVersion++;
    const i = this.headerCompVersion;
    t.newAgStackInstance().then((s) => this.afterCompCreated(i, s));
  }
  afterCompCreated(t, i) {
    if (t != this.headerCompVersion || !this.isAlive()) {
      this.destroyBean(i);
      return;
    }
    this.destroyHeaderComp(), this.headerComp = i, this.headerCompGui = i.getGui(), this.eHeaderCompWrapper.appendChild(this.headerCompGui), this.ctrl.setDragSource(this.getGui());
  }
};
fo.TEMPLATE = /* html */
`<div class="ag-header-cell" role="columnheader">
            <div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
            <div ref="eHeaderCompWrapper" class="ag-header-cell-comp-wrapper" role="presentation"></div>
        </div>`;
u([
  M("eResize")
], fo.prototype, "eResize", 2);
u([
  M("eHeaderCompWrapper")
], fo.prototype, "eHeaderCompWrapper", 2);
u([
  L
], fo.prototype, "postConstruct", 1);
u([
  dt
], fo.prototype, "destroyHeaderComp", 1);
var Wf = fo, zn = class Ah extends Ba {
  constructor(t) {
    super(Ah.TEMPLATE, t);
  }
  postConstruct() {
    const t = this.getGui(), i = (o, r) => r != null ? t.setAttribute(o, r) : t.removeAttribute(o);
    t.setAttribute("col-id", this.ctrl.getColId());
    const s = {
      addOrRemoveCssClass: (o, r) => this.addOrRemoveCssClass(o, r),
      setResizableDisplayed: (o) => te(this.eResize, o),
      setWidth: (o) => t.style.width = o,
      setAriaExpanded: (o) => i("aria-expanded", o),
      setUserCompDetails: (o) => this.setUserCompDetails(o),
      getUserCompInstance: () => this.headerGroupComp
    };
    this.ctrl.setComp(s, t, this.eResize);
  }
  setUserCompDetails(t) {
    t.newAgStackInstance().then((i) => this.afterHeaderCompCreated(i));
  }
  afterHeaderCompCreated(t) {
    const i = () => this.destroyBean(t);
    if (!this.isAlive()) {
      i();
      return;
    }
    const s = this.getGui(), o = t.getGui();
    s.appendChild(o), this.addDestroyFunc(i), this.headerGroupComp = t, this.ctrl.setDragSource(s);
  }
};
zn.TEMPLATE = /* html */
`<div class="ag-header-group-cell" role="columnheader">
            <div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
        </div>`;
u([
  M("eResize")
], zn.prototype, "eResize", 2);
u([
  L
], zn.prototype, "postConstruct", 1);
var Uf = zn, Wl = /* @__PURE__ */ ((e) => (e.COLUMN_GROUP = "group", e.COLUMN = "column", e.FLOATING_FILTER = "filter", e))(Wl || {}), $a = class extends K {
  constructor(t) {
    super(), this.headerComps = {}, this.ctrl = t, this.setTemplate(
      /* html */
      `<div class="${this.ctrl.getHeaderRowClass()}" role="row"></div>`
    );
  }
  init() {
    da(this.getGui(), this.ctrl.getAriaRowIndex());
    const t = {
      setHeight: (i) => this.getGui().style.height = i,
      setTop: (i) => this.getGui().style.top = i,
      setHeaderCtrls: (i, s) => this.setHeaderCtrls(i, s),
      setWidth: (i) => this.getGui().style.width = i
    };
    this.ctrl.setComp(t);
  }
  destroyHeaderCtrls() {
    this.setHeaderCtrls([], !1);
  }
  setHeaderCtrls(t, i) {
    if (!this.isAlive())
      return;
    const s = this.headerComps;
    if (this.headerComps = {}, t.forEach((o) => {
      const r = o.getInstanceId();
      let n = s[r];
      delete s[r], n == null && (n = this.createHeaderComp(o), this.getGui().appendChild(n.getGui())), this.headerComps[r] = n;
    }), tt(s, (o, r) => {
      this.getGui().removeChild(r.getGui()), this.destroyBean(r);
    }), i) {
      const o = Ii(this.headerComps);
      o.sort((n, l) => {
        const a = n.getCtrl().getColumnGroupChild().getLeft(), d = l.getCtrl().getColumnGroupChild().getLeft();
        return a - d;
      });
      const r = o.map((n) => n.getGui());
      Da(this.getGui(), r);
    }
  }
  createHeaderComp(t) {
    let i;
    switch (this.ctrl.getType()) {
      case "group":
        i = new Uf(t);
        break;
      case "filter":
        i = new lf(t);
        break;
      default:
        i = new Wf(t);
        break;
    }
    return this.createBean(i), i.setParentComponent(this), i;
  }
};
u([
  L
], $a.prototype, "init", 1);
u([
  dt
], $a.prototype, "destroyHeaderCtrls", 1);
var zf = 0, yi = class Ph extends F {
  constructor(t, i, s) {
    super(), this.resizeToggleTimeout = 0, this.resizeMultiplier = 1, this.resizeFeature = null, this.lastFocusEvent = null, this.dragSource = null, this.columnGroupChild = t, this.parentRowCtrl = s, this.beans = i, this.instanceId = t.getUniqueId() + "-" + zf++;
  }
  postConstruct() {
    this.addManagedPropertyListeners(["suppressHeaderFocus"], () => this.refreshTabIndex());
  }
  shouldStopEventPropagation(t) {
    const { headerRowIndex: i, column: s } = this.focusService.getFocusedHeader();
    return yc(
      this.gos,
      t,
      i,
      s
    );
  }
  getWrapperHasFocus() {
    return this.gos.getActiveDomElement() === this.eGui;
  }
  setGui(t) {
    this.eGui = t, this.addDomData(), this.addManagedListener(this.beans.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.onDisplayedColumnsChanged(), this.refreshTabIndex();
  }
  onDisplayedColumnsChanged() {
    !this.comp || !this.column || (this.refreshFirstAndLastStyles(), this.refreshAriaColIndex());
  }
  refreshFirstAndLastStyles() {
    const { comp: t, column: i, beans: s } = this;
    Bn.refreshFirstAndLastStyles(t, i, s.columnModel);
  }
  refreshAriaColIndex() {
    const { beans: t, column: i } = this, s = t.columnModel.getAriaColumnIndex(i);
    ua(this.eGui, s);
  }
  addResizeAndMoveKeyboardListeners() {
    this.resizeFeature && (this.addManagedListener(this.eGui, "keydown", this.onGuiKeyDown.bind(this)), this.addManagedListener(this.eGui, "keyup", this.onGuiKeyUp.bind(this)));
  }
  refreshTabIndex() {
    this.gos.get("suppressHeaderFocus") ? this.eGui.removeAttribute("tabindex") : this.eGui.setAttribute("tabindex", "-1");
  }
  onGuiKeyDown(t) {
    var i;
    const s = this.gos.getActiveDomElement(), o = t.key === S.LEFT || t.key === S.RIGHT;
    if (this.isResizing && (t.preventDefault(), t.stopImmediatePropagation()), // if elements within the header are focused, we don't process the event
    s !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
    !t.shiftKey && !t.altKey || ((this.isResizing || o) && (t.preventDefault(), t.stopImmediatePropagation()), !o))
      return;
    const r = t.key === S.LEFT !== this.gos.get("enableRtl"), n = Jc[r ? "Left" : "Right"];
    if (t.altKey) {
      this.isResizing = !0, this.resizeMultiplier += 1;
      const l = this.getViewportAdjustedResizeDiff(t);
      this.resizeHeader(l, t.shiftKey), (i = this.resizeFeature) == null || i.toggleColumnResizing(!0);
    } else
      this.moveHeader(n);
  }
  getViewportAdjustedResizeDiff(t) {
    let i = this.getResizeDiff(t);
    if (this.column.getPinned()) {
      const o = this.pinnedWidthService.getPinnedLeftWidth(), r = this.pinnedWidthService.getPinnedRightWidth(), n = Rs(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50;
      if (o + r + i > n)
        if (n > o + r)
          i = n - o - r;
        else
          return 0;
    }
    return i;
  }
  getResizeDiff(t) {
    let i = t.key === S.LEFT !== this.gos.get("enableRtl");
    const s = this.column.getPinned(), o = this.gos.get("enableRtl");
    return s && o !== (s === "right") && (i = !i), (i ? -1 : 1) * this.resizeMultiplier;
  }
  onGuiKeyUp() {
    this.isResizing && (this.resizeToggleTimeout && (window.clearTimeout(this.resizeToggleTimeout), this.resizeToggleTimeout = 0), this.isResizing = !1, this.resizeMultiplier = 1, this.resizeToggleTimeout = setTimeout(() => {
      var t;
      (t = this.resizeFeature) == null || t.toggleColumnResizing(!1);
    }, 150));
  }
  handleKeyDown(t) {
    const i = this.getWrapperHasFocus();
    switch (t.key) {
      case S.PAGE_DOWN:
      case S.PAGE_UP:
      case S.PAGE_HOME:
      case S.PAGE_END:
        i && t.preventDefault();
    }
  }
  addDomData() {
    const t = Ph.DOM_DATA_KEY_HEADER_CTRL;
    this.gos.setDomData(this.eGui, t, this), this.addDestroyFunc(() => this.gos.setDomData(this.eGui, t, null));
  }
  getGui() {
    return this.eGui;
  }
  focus(t) {
    return this.eGui ? (this.lastFocusEvent = t || null, this.eGui.focus(), !0) : !1;
  }
  getRowIndex() {
    return this.parentRowCtrl.getRowIndex();
  }
  getParentRowCtrl() {
    return this.parentRowCtrl;
  }
  getPinned() {
    return this.parentRowCtrl.getPinned();
  }
  getInstanceId() {
    return this.instanceId;
  }
  getColumnGroupChild() {
    return this.columnGroupChild;
  }
  removeDragSource() {
    this.dragSource && (this.dragAndDropService.removeDragSource(this.dragSource), this.dragSource = null);
  }
  handleContextMenuMouseEvent(t, i, s) {
    const o = t ?? i;
    this.gos.get("preventDefaultOnContextMenu") && o.preventDefault();
    const r = s instanceof pe ? s : void 0;
    this.menuService.isHeaderContextMenuEnabled(r) && this.menuService.showHeaderContextMenu(r, t, i), this.dispatchColumnMouseEvent(p.EVENT_COLUMN_HEADER_CONTEXT_MENU, s);
  }
  dispatchColumnMouseEvent(t, i) {
    const s = {
      type: t,
      column: i
    };
    this.eventService.dispatchEvent(s);
  }
  destroy() {
    super.destroy(), this.removeDragSource(), this.comp = null, this.column = null, this.resizeFeature = null, this.lastFocusEvent = null, this.columnGroupChild = null, this.parentRowCtrl = null, this.eGui = null;
  }
};
yi.DOM_DATA_KEY_HEADER_CTRL = "headerCtrl";
u([
  f("pinnedWidthService")
], yi.prototype, "pinnedWidthService", 2);
u([
  f("focusService")
], yi.prototype, "focusService", 2);
u([
  f("userComponentFactory")
], yi.prototype, "userComponentFactory", 2);
u([
  f("ctrlsService")
], yi.prototype, "ctrlsService", 2);
u([
  f("dragAndDropService")
], yi.prototype, "dragAndDropService", 2);
u([
  f("menuService")
], yi.prototype, "menuService", 2);
u([
  L
], yi.prototype, "postConstruct", 1);
var Kn = yi, $n = class extends F {
  constructor(e, t, i, s) {
    super(), this.columnOrGroup = e, this.eCell = t, this.ariaEl = this.eCell.querySelector("[role=columnheader]") || this.eCell, this.colsSpanning = s, this.beans = i;
  }
  setColsSpanning(e) {
    this.colsSpanning = e, this.onLeftChanged();
  }
  getColumnOrGroup() {
    return this.beans.gos.get("enableRtl") && this.colsSpanning ? se(this.colsSpanning) : this.columnOrGroup;
  }
  postConstruct() {
    this.addManagedListener(this.columnOrGroup, pe.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this)), this.setLeftFirstTime(), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onLeftChanged.bind(this)), this.addManagedPropertyListener("domLayout", this.onLeftChanged.bind(this));
  }
  setLeftFirstTime() {
    const e = this.beans.gos.get("suppressColumnMoveAnimation"), t = b(this.columnOrGroup.getOldLeft());
    this.beans.columnAnimationService.isActive() && t && !e ? this.animateInLeft() : this.onLeftChanged();
  }
  animateInLeft() {
    const e = this.getColumnOrGroup(), t = e.getLeft(), i = e.getOldLeft(), s = this.modifyLeftForPrintLayout(e, i), o = this.modifyLeftForPrintLayout(e, t);
    this.setLeft(s), this.actualLeft = o, this.beans.columnAnimationService.executeNextVMTurn(() => {
      this.actualLeft === o && this.setLeft(o);
    });
  }
  onLeftChanged() {
    const e = this.getColumnOrGroup(), t = e.getLeft();
    this.actualLeft = this.modifyLeftForPrintLayout(e, t), this.setLeft(this.actualLeft);
  }
  modifyLeftForPrintLayout(e, t) {
    if (!this.beans.gos.isDomLayout("print") || e.getPinned() === "left")
      return t;
    const s = this.beans.columnModel.getDisplayedColumnsLeftWidth();
    if (e.getPinned() === "right") {
      const o = this.beans.columnModel.getBodyContainerWidth();
      return s + o + t;
    }
    return s + t;
  }
  setLeft(e) {
    if (b(e) && (this.eCell.style.left = `${e}px`), this.columnOrGroup instanceof pe)
      this.columnOrGroup;
    else {
      const i = this.columnOrGroup.getLeafColumns();
      if (!i.length)
        return;
      i.length > 1 && Xu(this.ariaEl, i.length), i[0];
    }
  }
};
u([
  L
], $n.prototype, "postConstruct", 1);
var Er = class extends F {
  constructor(e, t) {
    super(), this.columns = e, this.element = t;
  }
  postConstruct() {
    this.gos.get("columnHoverHighlight") && this.addMouseHoverListeners();
  }
  addMouseHoverListeners() {
    this.addManagedListener(this.element, "mouseout", this.onMouseOut.bind(this)), this.addManagedListener(this.element, "mouseover", this.onMouseOver.bind(this));
  }
  onMouseOut() {
    this.columnHoverService.clearMouseOver();
  }
  onMouseOver() {
    this.columnHoverService.setMouseOver(this.columns);
  }
};
u([
  f("columnHoverService")
], Er.prototype, "columnHoverService", 2);
u([
  L
], Er.prototype, "postConstruct", 1);
var Kf = class extends Kn {
  constructor(e, t, i) {
    super(e, t, i), this.iconCreated = !1, this.column = e;
  }
  setComp(e, t, i, s) {
    this.comp = e, this.eButtonShowMainFilter = i, this.eFloatingFilterBody = s, this.setGui(t), this.setupActive(), this.setupWidth(), this.setupLeft(), this.setupHover(), this.setupFocus(), this.setupAria(), this.setupFilterButton(), this.setupUserComp(), this.setupSyncWithFilter(), this.setupUi(), this.addManagedListener(this.eButtonShowMainFilter, "click", this.showParentFilter.bind(this)), this.setupFilterChangedListener(), this.addManagedListener(this.column, pe.EVENT_COL_DEF_CHANGED, this.onColDefChanged.bind(this));
  }
  // empty abstract method
  resizeHeader() {
  }
  // empty abstract method
  moveHeader() {
  }
  setupActive() {
    const e = this.column.getColDef(), t = !!e.filter, i = !!e.floatingFilter;
    this.active = t && i;
  }
  setupUi() {
    if (this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton), !this.active || this.iconCreated)
      return;
    const e = Te("filter", this.gos, this.column);
    e && (this.iconCreated = !0, this.eButtonShowMainFilter.appendChild(e));
  }
  setupFocus() {
    this.createManagedBean(new Hi(
      this.eGui,
      {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      }
    ));
  }
  setupAria() {
    const e = this.localeService.getLocaleTextFunc();
    bt(this.eButtonShowMainFilter, e("ariaFilterMenuOpen", "Open Filter Menu"));
  }
  onTabKeyDown(e) {
    if (this.gos.getActiveDomElement() === this.eGui)
      return;
    const s = this.focusService.findNextFocusableElement(this.eGui, null, e.shiftKey);
    if (s) {
      this.beans.headerNavigationService.scrollToColumn(this.column), e.preventDefault(), s.focus();
      return;
    }
    const o = this.findNextColumnWithFloatingFilter(e.shiftKey);
    o && this.focusService.focusHeaderPosition({
      headerPosition: {
        headerRowIndex: this.getParentRowCtrl().getRowIndex(),
        column: o
      },
      event: e
    }) && e.preventDefault();
  }
  findNextColumnWithFloatingFilter(e) {
    const t = this.beans.columnModel;
    let i = this.column;
    do
      if (i = e ? t.getDisplayedColBefore(i) : t.getDisplayedColAfter(i), !i)
        break;
    while (!i.getColDef().filter || !i.getColDef().floatingFilter);
    return i;
  }
  handleKeyDown(e) {
    super.handleKeyDown(e);
    const t = this.getWrapperHasFocus();
    switch (e.key) {
      case S.UP:
      case S.DOWN:
        t || e.preventDefault();
      case S.LEFT:
      case S.RIGHT:
        if (t)
          return;
        e.stopPropagation();
      case S.ENTER:
        t && this.focusService.focusInto(this.eGui) && e.preventDefault();
        break;
      case S.ESCAPE:
        t || this.eGui.focus();
    }
  }
  onFocusIn(e) {
    if (this.eGui.contains(e.relatedTarget))
      return;
    const i = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter"), s = !!e.relatedTarget && os(e.relatedTarget, "ag-floating-filter");
    if (i && s && e.target === this.eGui) {
      const r = this.lastFocusEvent, n = !!(r && r.key === S.TAB);
      if (r && n) {
        const l = r.shiftKey;
        this.focusService.focusInto(this.eGui, l);
      }
    }
    const o = this.getRowIndex();
    this.beans.focusService.setFocusedHeader(o, this.column);
  }
  setupHover() {
    this.createManagedBean(new Er([this.column], this.eGui));
    const e = () => {
      if (!this.gos.get("columnHoverHighlight"))
        return;
      const t = this.beans.columnHoverService.isHovered(this.column);
      this.comp.addOrRemoveCssClass("ag-column-hover", t);
    };
    this.addManagedListener(this.eventService, p.EVENT_COLUMN_HOVER_CHANGED, e), e();
  }
  setupLeft() {
    const e = new $n(this.column, this.eGui, this.beans);
    this.createManagedBean(e);
  }
  setupFilterButton() {
    this.suppressFilterButton = !this.menuService.isFloatingFilterButtonEnabled(this.column), this.highlightFilterButtonWhenActive = !this.menuService.isLegacyMenuEnabled();
  }
  setupUserComp() {
    if (!this.active)
      return;
    const e = this.beans.filterManager.getFloatingFilterCompDetails(
      this.column,
      () => this.showParentFilter()
    );
    e && this.setCompDetails(e);
  }
  setCompDetails(e) {
    this.userCompDetails = e, this.comp.setCompDetails(e);
  }
  showParentFilter() {
    const e = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
    this.menuService.showFilterMenu({
      column: this.column,
      buttonElement: e,
      containerType: "floatingFilter",
      positionBy: "button"
    });
  }
  setupSyncWithFilter() {
    if (!this.active)
      return;
    const { filterManager: e } = this.beans, t = (i) => {
      if ((i == null ? void 0 : i.source) === "filterDestroyed" && this.context.isDestroyed())
        return;
      const s = this.comp.getFloatingFilterComp();
      s && s.then((o) => {
        var r;
        if (o) {
          const n = e.getCurrentFloatingFilterParentModel(this.column);
          o.onParentModelChanged(n, i ? this.gos.addGridCommonParams({
            columns: (r = i.columns) != null ? r : [],
            type: p.EVENT_FILTER_CHANGED,
            source: i.source === "api" ? "api" : "columnFilter"
          }) : null);
        }
      });
    };
    this.destroySyncListener = this.addManagedListener(this.column, pe.EVENT_FILTER_CHANGED, t), e.isFilterActive(this.column) && t(null);
  }
  setupWidth() {
    const e = () => {
      const t = `${this.column.getActualWidth()}px`;
      this.comp.setWidth(t);
    };
    this.addManagedListener(this.column, pe.EVENT_WIDTH_CHANGED, e), e();
  }
  setupFilterChangedListener() {
    this.active && (this.destroyFilterChangedListener = this.addManagedListener(this.column, pe.EVENT_FILTER_CHANGED, this.updateFilterButton.bind(this)), this.updateFilterButton());
  }
  updateFilterButton() {
    if (!this.suppressFilterButton && this.comp) {
      const e = this.beans.filterManager.isFilterAllowed(this.column);
      this.comp.setButtonWrapperDisplayed(e), this.highlightFilterButtonWhenActive && e && this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
    }
  }
  onColDefChanged() {
    var e, t;
    const i = this.active;
    this.setupActive();
    const s = !i && this.active;
    i && !this.active && ((e = this.destroySyncListener) == null || e.call(this), (t = this.destroyFilterChangedListener) == null || t.call(this));
    const o = this.active ? this.beans.filterManager.getFloatingFilterCompDetails(
      this.column,
      () => this.showParentFilter()
    ) : null, r = this.comp.getFloatingFilterComp();
    !r || !o ? this.updateCompDetails(o, s) : r.then((n) => {
      var l;
      !n || this.beans.filterManager.areFilterCompsDifferent((l = this.userCompDetails) != null ? l : null, o) ? this.updateCompDetails(o, s) : this.updateFloatingFilterParams(o);
    });
  }
  updateCompDetails(e, t) {
    this.isAlive() && (this.setCompDetails(e), this.setupFilterButton(), this.setupUi(), t && (this.setupSyncWithFilter(), this.setupFilterChangedListener()));
  }
  updateFloatingFilterParams(e) {
    var t;
    if (!e)
      return;
    const i = e.params;
    (t = this.comp.getFloatingFilterComp()) == null || t.then((s) => {
      let o = !1;
      s != null && s.refresh && typeof s.refresh == "function" && s.refresh(i) !== null && (o = !0), !o && (s != null && s.onParamsUpdated) && typeof s.onParamsUpdated == "function" && s.onParamsUpdated(i) !== null && H("Custom floating filter method 'onParamsUpdated' is deprecated. Use 'refresh' instead.");
    });
  }
  destroy() {
    super.destroy(), this.eButtonShowMainFilter = null, this.eFloatingFilterBody = null, this.userCompDetails = null, this.destroySyncListener = null, this.destroyFilterChangedListener = null;
  }
}, mo = class extends F {
  constructor(e, t, i, s, o) {
    super(), this.pinned = e, this.column = t, this.eResize = i, this.comp = s, this.ctrl = o;
  }
  postConstruct() {
    const e = [];
    let t, i;
    const s = () => {
      if (te(this.eResize, t), !t)
        return;
      const n = this.horizontalResizeService.addResizeBar({
        eResizeBar: this.eResize,
        onResizeStart: this.onResizeStart.bind(this),
        onResizing: this.onResizing.bind(this, !1),
        onResizeEnd: this.onResizing.bind(this, !0)
      });
      if (e.push(n), i) {
        const l = this.gos.get("skipHeaderOnAutoSize"), a = () => {
          this.columnModel.autoSizeColumn(this.column, "uiColumnResized", l);
        };
        this.eResize.addEventListener("dblclick", a);
        const d = new je(this.eResize);
        d.addEventListener(je.EVENT_DOUBLE_TAP, a), e.push(() => {
          this.eResize.removeEventListener("dblclick", a), d.removeEventListener(je.EVENT_DOUBLE_TAP, a), d.destroy();
        });
      }
    }, o = () => {
      e.forEach((n) => n()), e.length = 0;
    }, r = () => {
      const n = this.column.isResizable(), l = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
      (n !== t || l !== i) && (t = n, i = l, o(), s());
    };
    r(), this.addDestroyFunc(o), this.ctrl.addRefreshFunction(r);
  }
  onResizing(e, t) {
    const { column: i, lastResizeAmount: s, resizeStartWidth: o } = this, r = this.normaliseResizeAmount(t), n = o + r, l = [{ key: i, newWidth: n }];
    if (this.column.getPinned()) {
      const a = this.pinnedWidthService.getPinnedLeftWidth(), d = this.pinnedWidthService.getPinnedRightWidth(), c = Rs(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50;
      if (a + d + (r - s) > c)
        return;
    }
    this.lastResizeAmount = r, this.columnModel.setColumnWidths(l, this.resizeWithShiftKey, e, "uiColumnResized"), e && this.toggleColumnResizing(!1);
  }
  onResizeStart(e) {
    this.resizeStartWidth = this.column.getActualWidth(), this.lastResizeAmount = 0, this.resizeWithShiftKey = e, this.toggleColumnResizing(!0);
  }
  toggleColumnResizing(e) {
    this.comp.addOrRemoveCssClass("ag-column-resizing", e);
  }
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
  normaliseResizeAmount(e) {
    let t = e;
    const i = this.pinned !== "left", s = this.pinned === "right";
    return this.gos.get("enableRtl") ? i && (t *= -1) : s && (t *= -1), t;
  }
};
u([
  f("horizontalResizeService")
], mo.prototype, "horizontalResizeService", 2);
u([
  f("pinnedWidthService")
], mo.prototype, "pinnedWidthService", 2);
u([
  f("ctrlsService")
], mo.prototype, "ctrlsService", 2);
u([
  f("columnModel")
], mo.prototype, "columnModel", 2);
u([
  L
], mo.prototype, "postConstruct", 1);
var ja = class extends F {
  constructor(e) {
    super(), this.cbSelectAllVisible = !1, this.processingEventFromCheckbox = !1, this.column = e;
  }
  onSpaceKeyDown(e) {
    const t = this.cbSelectAll;
    t.isDisplayed() && !t.getGui().contains(this.gos.getActiveDomElement()) && (e.preventDefault(), t.setValue(!t.getValue()));
  }
  getCheckboxGui() {
    return this.cbSelectAll.getGui();
  }
  setComp(e) {
    this.headerCellCtrl = e, this.cbSelectAll = this.createManagedBean(new Nn()), this.cbSelectAll.addCssClass("ag-header-select-all"), Fe(this.cbSelectAll.getGui(), "presentation"), this.showOrHideSelectAll(), this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this)), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_SELECTION_CHANGED, this.onSelectionChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_PAGINATION_CHANGED, this.onSelectionChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_MODEL_UPDATED, this.onModelChanged.bind(this)), this.addManagedListener(this.cbSelectAll, p.EVENT_FIELD_VALUE_CHANGED, this.onCbSelectAll.bind(this)), cr(this.cbSelectAll.getGui(), !0), this.cbSelectAll.getInputElement().setAttribute("tabindex", "-1"), this.refreshSelectAllLabel();
  }
  onNewColumnsLoaded() {
    this.showOrHideSelectAll();
  }
  onDisplayedColumnsChanged() {
    this.isAlive() && this.showOrHideSelectAll();
  }
  showOrHideSelectAll() {
    this.cbSelectAllVisible = this.isCheckboxSelection(), this.cbSelectAll.setDisplayed(this.cbSelectAllVisible, { skipAriaHidden: !0 }), this.cbSelectAllVisible && (this.checkRightRowModelType("selectAllCheckbox"), this.checkSelectionType("selectAllCheckbox"), this.updateStateOfCheckbox()), this.refreshSelectAllLabel();
  }
  onModelChanged() {
    this.cbSelectAllVisible && this.updateStateOfCheckbox();
  }
  onSelectionChanged() {
    this.cbSelectAllVisible && this.updateStateOfCheckbox();
  }
  updateStateOfCheckbox() {
    if (this.processingEventFromCheckbox)
      return;
    this.processingEventFromCheckbox = !0;
    const e = this.selectionService.getSelectAllState(
      this.isFilteredOnly(),
      this.isCurrentPageOnly()
    );
    this.cbSelectAll.setValue(e);
    const t = this.selectionService.hasNodesToSelect(this.isFilteredOnly(), this.isCurrentPageOnly());
    this.cbSelectAll.setDisabled(!t), this.refreshSelectAllLabel(), this.processingEventFromCheckbox = !1;
  }
  refreshSelectAllLabel() {
    const e = this.localeService.getLocaleTextFunc(), i = this.cbSelectAll.getValue() ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked"), s = e("ariaRowSelectAll", "Press Space to toggle all rows selection");
    this.cbSelectAllVisible ? this.headerCellCtrl.setAriaDescriptionProperty("selectAll", `${s} (${i})`) : this.headerCellCtrl.setAriaDescriptionProperty("selectAll", null), this.cbSelectAll.setInputAriaLabel(`${s} (${i})`), this.headerCellCtrl.announceAriaDescription();
  }
  checkSelectionType(e) {
    return this.gos.get("rowSelection") === "multiple" ? !0 : (console.warn(`AG Grid: ${e} is only available if using 'multiple' rowSelection.`), !1);
  }
  checkRightRowModelType(e) {
    const t = this.rowModel.getType();
    return t === "clientSide" || t === "serverSide" ? !0 : (console.warn(`AG Grid: ${e} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${t}.`), !1);
  }
  onCbSelectAll() {
    if (this.processingEventFromCheckbox || !this.cbSelectAllVisible)
      return;
    const e = this.cbSelectAll.getValue(), t = this.isFilteredOnly(), i = this.isCurrentPageOnly();
    let s = "uiSelectAll";
    i ? s = "uiSelectAllCurrentPage" : t && (s = "uiSelectAllFiltered");
    const o = {
      source: s,
      justFiltered: t,
      justCurrentPage: i
    };
    e ? this.selectionService.selectAllRowNodes(o) : this.selectionService.deselectAllRowNodes(o);
  }
  isCheckboxSelection() {
    let e = this.column.getColDef().headerCheckboxSelection;
    if (typeof e == "function") {
      const t = e, i = this.gos.addGridCommonParams({
        column: this.column,
        colDef: this.column.getColDef()
      });
      e = t(i);
    }
    return e ? this.checkRightRowModelType("headerCheckboxSelection") && this.checkSelectionType("headerCheckboxSelection") : !1;
  }
  isFilteredOnly() {
    return !!this.column.getColDef().headerCheckboxSelectionFilteredOnly;
  }
  isCurrentPageOnly() {
    return !!this.column.getColDef().headerCheckboxSelectionCurrentPageOnly;
  }
};
u([
  f("rowModel")
], ja.prototype, "rowModel", 2);
u([
  f("selectionService")
], ja.prototype, "selectionService", 2);
var $f = class extends Kn {
  constructor(e, t, i) {
    super(e, t, i), this.refreshFunctions = [], this.userHeaderClasses = /* @__PURE__ */ new Set(), this.ariaDescriptionProperties = /* @__PURE__ */ new Map(), this.column = e;
  }
  setComp(e, t, i, s) {
    this.comp = e, this.setGui(t), this.updateState(), this.setupWidth(), this.setupMovingCss(), this.setupMenuClass(), this.setupSortableClass(), this.setupWrapTextClass(), this.refreshSpanHeaderHeight(), this.setupAutoHeight(s), this.addColumnHoverListener(), this.setupFilterClass(), this.setupClassesFromColDef(), this.setupTooltip(), this.addActiveHeaderMouseListeners(), this.setupSelectAll(), this.setupUserComp(), this.refreshAria(), this.resizeFeature = this.createManagedBean(new mo(this.getPinned(), this.column, i, e, this)), this.createManagedBean(new Er([this.column], t)), this.createManagedBean(new $n(this.column, t, this.beans)), this.createManagedBean(new Hi(
      t,
      {
        shouldStopEventPropagation: (o) => this.shouldStopEventPropagation(o),
        onTabKeyDown: () => null,
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      }
    )), this.addResizeAndMoveKeyboardListeners(), this.addManagedPropertyListeners(["suppressMovableColumns", "suppressMenuHide", "suppressAggFuncInHeader"], this.refresh.bind(this)), this.addManagedListener(this.column, pe.EVENT_COL_DEF_CHANGED, this.refresh.bind(this)), this.addManagedListener(this.eventService, p.EVENT_COLUMN_VALUE_CHANGED, this.onColumnValueChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PIVOT_CHANGED, this.onColumnPivotChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
  }
  resizeHeader(e, t) {
    var i, s;
    if (!this.column.isResizable())
      return;
    const o = this.column.getActualWidth(), r = (i = this.column.getMinWidth()) != null ? i : 0, n = (s = this.column.getMaxWidth()) != null ? s : Number.MAX_SAFE_INTEGER, l = Math.min(Math.max(o + e, r), n);
    this.beans.columnModel.setColumnWidths([{ key: this.column, newWidth: l }], t, !0, "uiColumnResized");
  }
  moveHeader(e) {
    const { eGui: t, column: i, gos: s, ctrlsService: o } = this, r = this.getPinned(), n = t.getBoundingClientRect().left, l = i.getActualWidth(), a = s.get("enableRtl"), d = e === 0 !== a, c = as.normaliseX(
      d ? n - 20 : n + l + 20,
      r,
      !0,
      s,
      o
    );
    as.attemptMoveColumns({
      allMovingColumns: [i],
      isFromHeader: !0,
      hDirection: e,
      xPosition: c,
      pinned: r,
      fromEnter: !1,
      fakeEvent: !1,
      gos: s,
      columnModel: this.beans.columnModel
    }), o.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(i, "auto");
  }
  setupUserComp() {
    const e = this.lookupUserCompDetails();
    this.setCompDetails(e);
  }
  setCompDetails(e) {
    this.userCompDetails = e, this.comp.setUserCompDetails(e);
  }
  lookupUserCompDetails() {
    const e = this.createParams(), t = this.column.getColDef();
    return this.userComponentFactory.getHeaderCompDetails(t, e);
  }
  createParams() {
    return this.gos.addGridCommonParams({
      column: this.column,
      displayName: this.displayName,
      enableSorting: this.column.isSortable(),
      enableMenu: this.menuEnabled,
      enableFilterButton: this.openFilterEnabled && this.menuService.isHeaderFilterButtonEnabled(this.column),
      enableFilterIcon: !this.openFilterEnabled || this.menuService.isLegacyMenuEnabled(),
      showColumnMenu: (t) => {
        this.menuService.showColumnMenu({
          column: this.column,
          buttonElement: t,
          positionBy: "button"
        });
      },
      showColumnMenuAfterMouseClick: (t) => {
        this.menuService.showColumnMenu({
          column: this.column,
          mouseEvent: t,
          positionBy: "mouse"
        });
      },
      showFilter: (t) => {
        this.menuService.showFilterMenu({
          column: this.column,
          buttonElement: t,
          containerType: "columnFilter",
          positionBy: "button"
        });
      },
      progressSort: (t) => {
        this.beans.sortController.progressSort(this.column, !!t, "uiColumnSorted");
      },
      setSort: (t, i) => {
        this.beans.sortController.setSortForColumn(this.column, t, !!i, "uiColumnSorted");
      },
      eGridHeader: this.getGui(),
      setTooltip: (t, i) => {
        this.setupTooltip(t, i);
      }
    });
  }
  setupSelectAll() {
    this.selectAllFeature = this.createManagedBean(new ja(this.column)), this.selectAllFeature.setComp(this);
  }
  getSelectAllGui() {
    return this.selectAllFeature.getCheckboxGui();
  }
  handleKeyDown(e) {
    super.handleKeyDown(e), e.key === S.SPACE && this.selectAllFeature.onSpaceKeyDown(e), e.key === S.ENTER && this.onEnterKeyDown(e), e.key === S.DOWN && e.altKey && this.showMenuOnKeyPress(e, !1);
  }
  onEnterKeyDown(e) {
    if (e.ctrlKey || e.metaKey)
      this.showMenuOnKeyPress(e, !0);
    else if (this.sortable) {
      const t = e.shiftKey;
      this.beans.sortController.progressSort(this.column, t, "uiColumnSorted");
    }
  }
  showMenuOnKeyPress(e, t) {
    const i = this.comp.getUserCompInstance();
    !i || !(i instanceof Vl) || i.onMenuKeyboardShortcut(t) && e.preventDefault();
  }
  onFocusIn(e) {
    if (!this.getGui().contains(e.relatedTarget)) {
      const t = this.getRowIndex();
      this.focusService.setFocusedHeader(t, this.column), this.announceAriaDescription();
    }
    this.focusService.isKeyboardMode() && this.setActiveHeader(!0);
  }
  onFocusOut(e) {
    this.getGui().contains(e.relatedTarget) || this.setActiveHeader(!1);
  }
  setupTooltip(e, t) {
    this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature));
    const i = this.gos.get("tooltipShowMode") === "whenTruncated", s = this.eGui, o = this.column.getColDef();
    !t && i && !o.headerComponent && (t = () => {
      const l = s.querySelector(".ag-header-cell-text");
      return l ? l.scrollWidth > l.clientWidth : !0;
    });
    const r = {
      getColumn: () => this.column,
      getColDef: () => this.column.getColDef(),
      getGui: () => s,
      getLocation: () => "header",
      getTooltipValue: () => e ?? this.column.getColDef().headerTooltip,
      shouldDisplayTooltip: t
    }, n = this.createManagedBean(new wi(r));
    this.refreshFunctions.push(() => n.refreshToolTip());
  }
  setupClassesFromColDef() {
    const e = () => {
      const t = this.column.getColDef(), i = Bn.getHeaderClassesFromColDef(t, this.gos, this.column, null), s = this.userHeaderClasses;
      this.userHeaderClasses = new Set(i), i.forEach((o) => {
        s.has(o) ? s.delete(o) : this.comp.addOrRemoveCssClass(o, !0);
      }), s.forEach((o) => this.comp.addOrRemoveCssClass(o, !1));
    };
    this.refreshFunctions.push(e), e();
  }
  setDragSource(e) {
    if (this.dragSourceElement = e, this.removeDragSource(), !e || !this.draggable)
      return;
    const { column: t, beans: i, displayName: s, dragAndDropService: o, gos: r } = this, { columnModel: n } = i;
    let l = !this.gos.get("suppressDragLeaveHidesColumns");
    const a = this.dragSource = {
      type: 1,
      eElement: e,
      getDefaultIconName: () => l ? Y.ICON_HIDE : Y.ICON_NOT_ALLOWED,
      getDragItem: () => this.createDragItem(t),
      dragItemName: s,
      onDragStarted: () => {
        l = !r.get("suppressDragLeaveHidesColumns"), t.setMoving(!0, "uiColumnMoved");
      },
      onDragStopped: () => t.setMoving(!1, "uiColumnMoved"),
      onGridEnter: (d) => {
        var c;
        if (l) {
          const h = ((c = d == null ? void 0 : d.columns) == null ? void 0 : c.filter((g) => !g.getColDef().lockVisible)) || [];
          n.setColumnsVisible(h, !0, "uiColumnMoved");
        }
      },
      onGridExit: (d) => {
        var c;
        if (l) {
          const h = ((c = d == null ? void 0 : d.columns) == null ? void 0 : c.filter((g) => !g.getColDef().lockVisible)) || [];
          n.setColumnsVisible(h, !1, "uiColumnMoved");
        }
      }
    };
    o.addDragSource(a, !0);
  }
  createDragItem(e) {
    const t = {};
    return t[e.getId()] = e.isVisible(), {
      columns: [e],
      visibleState: t
    };
  }
  updateState() {
    this.menuEnabled = this.menuService.isColumnMenuInHeaderEnabled(this.column), this.openFilterEnabled = this.menuService.isFilterMenuInHeaderEnabled(this.column), this.sortable = this.column.isSortable(), this.displayName = this.calculateDisplayName(), this.draggable = this.workOutDraggable();
  }
  addRefreshFunction(e) {
    this.refreshFunctions.push(e);
  }
  refresh() {
    this.updateState(), this.refreshHeaderComp(), this.refreshAria(), this.refreshFunctions.forEach((e) => e());
  }
  refreshHeaderComp() {
    const e = this.lookupUserCompDetails();
    (this.comp.getUserCompInstance() != null && this.userCompDetails.componentClass == e.componentClass ? this.attemptHeaderCompRefresh(e.params) : !1) ? this.setDragSource(this.dragSourceElement) : this.setCompDetails(e);
  }
  attemptHeaderCompRefresh(e) {
    const t = this.comp.getUserCompInstance();
    return !t || !t.refresh ? !1 : t.refresh(e);
  }
  calculateDisplayName() {
    return this.beans.columnModel.getDisplayNameForColumn(this.column, "header", !0);
  }
  checkDisplayName() {
    this.displayName !== this.calculateDisplayName() && this.refresh();
  }
  workOutDraggable() {
    const e = this.column.getColDef();
    return !!(!this.gos.get("suppressMovableColumns") && !e.suppressMovable && !e.lockPosition) || !!e.enableRowGroup || !!e.enablePivot;
  }
  onColumnRowGroupChanged() {
    this.checkDisplayName();
  }
  onColumnPivotChanged() {
    this.checkDisplayName();
  }
  onColumnValueChanged() {
    this.checkDisplayName();
  }
  setupWidth() {
    const e = () => {
      const t = this.column.getActualWidth();
      this.comp.setWidth(`${t}px`);
    };
    this.addManagedListener(this.column, pe.EVENT_WIDTH_CHANGED, e), e();
  }
  setupMovingCss() {
    const e = () => {
      this.comp.addOrRemoveCssClass("ag-header-cell-moving", this.column.isMoving());
    };
    this.addManagedListener(this.column, pe.EVENT_MOVING_CHANGED, e), e();
  }
  setupMenuClass() {
    const e = () => {
      this.comp.addOrRemoveCssClass("ag-column-menu-visible", this.column.isMenuVisible());
    };
    this.addManagedListener(this.column, pe.EVENT_MENU_VISIBLE_CHANGED, e), e();
  }
  setupSortableClass() {
    const e = () => {
      this.comp.addOrRemoveCssClass("ag-header-cell-sortable", !!this.sortable);
    };
    e(), this.addRefreshFunction(e), this.addManagedListener(this.eventService, pe.EVENT_SORT_CHANGED, this.refreshAriaSort.bind(this));
  }
  setupFilterClass() {
    const e = () => {
      const t = this.column.isFilterActive();
      this.comp.addOrRemoveCssClass("ag-header-cell-filtered", t), this.refreshAria();
    };
    this.addManagedListener(this.column, pe.EVENT_FILTER_ACTIVE_CHANGED, e), e();
  }
  setupWrapTextClass() {
    const e = () => {
      const t = !!this.column.getColDef().wrapHeaderText;
      this.comp.addOrRemoveCssClass("ag-header-cell-wrap-text", t);
    };
    e(), this.addRefreshFunction(e);
  }
  onDisplayedColumnsChanged() {
    super.onDisplayedColumnsChanged(), this.isAlive() && this.onHeaderHeightChanged();
  }
  onHeaderHeightChanged() {
    this.refreshSpanHeaderHeight();
  }
  refreshSpanHeaderHeight() {
    const { eGui: e, column: t, comp: i, beans: s } = this;
    if (!t.isSpanHeaderHeight()) {
      e.style.removeProperty("top"), e.style.removeProperty("height"), i.addOrRemoveCssClass("ag-header-span-height", !1), i.addOrRemoveCssClass("ag-header-span-total", !1);
      return;
    }
    const { numberOfParents: o, isSpanningTotal: r } = this.column.getColumnGroupPaddingInfo();
    i.addOrRemoveCssClass("ag-header-span-height", o > 0);
    const { columnModel: n } = s, l = n.getColumnHeaderRowHeight();
    if (o === 0) {
      i.addOrRemoveCssClass("ag-header-span-total", !1), e.style.setProperty("top", "0px"), e.style.setProperty("height", `${l}px`);
      return;
    }
    i.addOrRemoveCssClass("ag-header-span-total", r);
    const d = n.isPivotMode() ? n.getPivotGroupHeaderHeight() : n.getGroupHeaderHeight(), c = o * d;
    e.style.setProperty("top", `${-c}px`), e.style.setProperty("height", `${l + c}px`);
  }
  setupAutoHeight(e) {
    const { columnModel: t, resizeObserverService: i } = this.beans, s = (d) => {
      if (!this.isAlive())
        return;
      const { paddingTop: c, paddingBottom: h, borderBottomWidth: g, borderTopWidth: m } = Vi(this.getGui()), C = c + h + g + m, v = e.offsetHeight + C;
      if (d < 5) {
        const y = this.beans.gos.getDocument(), E = !y || !y.contains(e), D = v == 0;
        if (E || D) {
          window.setTimeout(() => s(d + 1), 0);
          return;
        }
      }
      t.setColumnHeaderHeight(this.column, v);
    };
    let o = !1, r;
    const n = () => {
      const d = this.column.isAutoHeaderHeight();
      d && !o && l(), !d && o && a();
    }, l = () => {
      o = !0, s(0), this.comp.addOrRemoveCssClass("ag-header-cell-auto-height", !0), r = i.observeResize(e, () => s(0));
    }, a = () => {
      o = !1, r && r(), this.comp.addOrRemoveCssClass("ag-header-cell-auto-height", !1), r = void 0;
    };
    n(), this.addDestroyFunc(() => a()), this.addManagedListener(this.column, pe.EVENT_WIDTH_CHANGED, () => o && s(0)), this.addManagedListener(this.eventService, pe.EVENT_SORT_CHANGED, () => {
      o && window.setTimeout(() => s(0));
    }), this.addRefreshFunction(n);
  }
  refreshAriaSort() {
    if (this.sortable) {
      const e = this.localeService.getLocaleTextFunc(), t = this.beans.sortController.getDisplaySortForColumn(this.column) || null;
      this.comp.setAriaSort(Bu(t)), this.setAriaDescriptionProperty("sort", e("ariaSortableColumn", "Press ENTER to sort"));
    } else
      this.comp.setAriaSort(), this.setAriaDescriptionProperty("sort", null);
  }
  refreshAriaMenu() {
    if (this.menuEnabled) {
      const e = this.localeService.getLocaleTextFunc();
      this.setAriaDescriptionProperty("menu", e("ariaMenuColumn", "Press ALT DOWN to open column menu"));
    } else
      this.setAriaDescriptionProperty("menu", null);
  }
  refreshAriaFilterButton() {
    if (this.openFilterEnabled && !this.menuService.isLegacyMenuEnabled()) {
      const e = this.localeService.getLocaleTextFunc();
      this.setAriaDescriptionProperty("filterButton", e("ariaFilterColumn", "Press CTRL ENTER to open filter"));
    } else
      this.setAriaDescriptionProperty("filterButton", null);
  }
  refreshAriaFiltered() {
    const e = this.localeService.getLocaleTextFunc();
    this.column.isFilterActive() ? this.setAriaDescriptionProperty("filter", e("ariaColumnFiltered", "Column Filtered")) : this.setAriaDescriptionProperty("filter", null);
  }
  setAriaDescriptionProperty(e, t) {
    t != null ? this.ariaDescriptionProperties.set(e, t) : this.ariaDescriptionProperties.delete(e);
  }
  announceAriaDescription() {
    if (!this.eGui.contains(this.beans.gos.getActiveDomElement()))
      return;
    const e = Array.from(this.ariaDescriptionProperties.keys()).sort((t, i) => t === "filter" ? -1 : i.charCodeAt(0) - t.charCodeAt(0)).map((t) => this.ariaDescriptionProperties.get(t)).join(". ");
    this.beans.ariaAnnouncementService.announceValue(e);
  }
  refreshAria() {
    this.refreshAriaSort(), this.refreshAriaMenu(), this.refreshAriaFilterButton(), this.refreshAriaFiltered();
  }
  addColumnHoverListener() {
    const e = () => {
      if (!this.gos.get("columnHoverHighlight"))
        return;
      const t = this.beans.columnHoverService.isHovered(this.column);
      this.comp.addOrRemoveCssClass("ag-column-hover", t);
    };
    this.addManagedListener(this.eventService, p.EVENT_COLUMN_HOVER_CHANGED, e), e();
  }
  getColId() {
    return this.column.getColId();
  }
  addActiveHeaderMouseListeners() {
    const e = (s) => this.handleMouseOverChange(s.type === "mouseenter"), t = () => this.dispatchColumnMouseEvent(p.EVENT_COLUMN_HEADER_CLICKED, this.column), i = (s) => this.handleContextMenuMouseEvent(s, void 0, this.column);
    this.addManagedListener(this.getGui(), "mouseenter", e), this.addManagedListener(this.getGui(), "mouseleave", e), this.addManagedListener(this.getGui(), "click", t), this.addManagedListener(this.getGui(), "contextmenu", i);
  }
  handleMouseOverChange(e) {
    this.setActiveHeader(e);
    const i = {
      type: e ? p.EVENT_COLUMN_HEADER_MOUSE_OVER : p.EVENT_COLUMN_HEADER_MOUSE_LEAVE,
      column: this.column
    };
    this.eventService.dispatchEvent(i);
  }
  setActiveHeader(e) {
    this.comp.addOrRemoveCssClass("ag-header-active", e);
  }
  getAnchorElementForMenu(e) {
    const t = this.comp.getUserCompInstance();
    return t instanceof Vl ? t.getAnchorElementForMenu(e) : this.getGui();
  }
  destroy() {
    super.destroy(), this.refreshFunctions = null, this.selectAllFeature = null, this.dragSourceElement = null, this.userCompDetails = null, this.userHeaderClasses = null, this.ariaDescriptionProperties = null;
  }
}, yr = class extends F {
  constructor(e, t, i, s) {
    super(), this.eResize = t, this.comp = e, this.pinned = i, this.columnGroup = s;
  }
  postConstruct() {
    if (!this.columnGroup.isResizable()) {
      this.comp.setResizableDisplayed(!1);
      return;
    }
    const e = this.horizontalResizeService.addResizeBar({
      eResizeBar: this.eResize,
      onResizeStart: this.onResizeStart.bind(this),
      onResizing: this.onResizing.bind(this, !1),
      onResizeEnd: this.onResizing.bind(this, !0)
    });
    if (this.addDestroyFunc(e), !this.gos.get("suppressAutoSize")) {
      const t = this.gos.get("skipHeaderOnAutoSize");
      this.eResize.addEventListener("dblclick", () => {
        const i = [];
        this.columnGroup.getDisplayedLeafColumns().forEach((o) => {
          o.getColDef().suppressAutoSize || i.push(o.getColId());
        }), i.length > 0 && this.columnModel.autoSizeColumns({
          columns: i,
          skipHeader: t,
          stopAtGroup: this.columnGroup,
          source: "uiColumnResized"
        }), this.resizeLeafColumnsToFit("uiColumnResized");
      });
    }
  }
  onResizeStart(e) {
    const t = this.getInitialValues(e);
    this.storeLocalValues(t), this.toggleColumnResizing(!0);
  }
  onResizing(e, t, i = "uiColumnResized") {
    const s = this.normaliseDragChange(t), o = this.resizeStartWidth + s;
    this.resizeColumnsFromLocalValues(o, i, e);
  }
  getInitialValues(e) {
    const t = this.getColumnsToResize(), i = this.getInitialSizeOfColumns(t), s = this.getSizeRatiosOfColumns(t, i), o = {
      columnsToResize: t,
      resizeStartWidth: i,
      resizeRatios: s
    };
    let r = null;
    if (e && (r = this.columnModel.getDisplayedGroupAtDirection(this.columnGroup, "After")), r) {
      const n = r.getDisplayedLeafColumns(), l = o.groupAfterColumns = n.filter((d) => d.isResizable()), a = o.groupAfterStartWidth = this.getInitialSizeOfColumns(l);
      o.groupAfterRatios = this.getSizeRatiosOfColumns(l, a);
    } else
      o.groupAfterColumns = void 0, o.groupAfterStartWidth = void 0, o.groupAfterRatios = void 0;
    return o;
  }
  storeLocalValues(e) {
    const {
      columnsToResize: t,
      resizeStartWidth: i,
      resizeRatios: s,
      groupAfterColumns: o,
      groupAfterStartWidth: r,
      groupAfterRatios: n
    } = e;
    this.resizeCols = t, this.resizeStartWidth = i, this.resizeRatios = s, this.resizeTakeFromCols = o, this.resizeTakeFromStartWidth = r, this.resizeTakeFromRatios = n;
  }
  clearLocalValues() {
    this.resizeCols = void 0, this.resizeRatios = void 0, this.resizeTakeFromCols = void 0, this.resizeTakeFromRatios = void 0;
  }
  resizeLeafColumnsToFit(e) {
    const t = this.autoWidthCalculator.getPreferredWidthForColumnGroup(this.columnGroup), i = this.getInitialValues();
    t > i.resizeStartWidth && this.resizeColumns(i, t, e, !0);
  }
  resizeColumnsFromLocalValues(e, t, i = !0) {
    var s, o, r;
    if (!this.resizeCols || !this.resizeRatios)
      return;
    const n = {
      columnsToResize: this.resizeCols,
      resizeStartWidth: this.resizeStartWidth,
      resizeRatios: this.resizeRatios,
      groupAfterColumns: (s = this.resizeTakeFromCols) != null ? s : void 0,
      groupAfterStartWidth: (o = this.resizeTakeFromStartWidth) != null ? o : void 0,
      groupAfterRatios: (r = this.resizeTakeFromRatios) != null ? r : void 0
    };
    this.resizeColumns(n, e, t, i);
  }
  resizeColumns(e, t, i, s = !0) {
    const {
      columnsToResize: o,
      resizeStartWidth: r,
      resizeRatios: n,
      groupAfterColumns: l,
      groupAfterStartWidth: a,
      groupAfterRatios: d
    } = e, c = [];
    if (c.push({
      columns: o,
      ratios: n,
      width: t
    }), l) {
      const h = t - r;
      c.push({
        columns: l,
        ratios: d,
        width: a - h
      });
    }
    this.columnModel.resizeColumnSets({
      resizeSets: c,
      finished: s,
      source: i
    }), s && this.toggleColumnResizing(!1);
  }
  toggleColumnResizing(e) {
    this.comp.addOrRemoveCssClass("ag-column-resizing", e);
  }
  getColumnsToResize() {
    return this.columnGroup.getDisplayedLeafColumns().filter((t) => t.isResizable());
  }
  getInitialSizeOfColumns(e) {
    return e.reduce(
      (t, i) => t + i.getActualWidth(),
      0
    );
  }
  getSizeRatiosOfColumns(e, t) {
    return e.map((i) => i.getActualWidth() / t);
  }
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderCell - should refactor out?
  normaliseDragChange(e) {
    let t = e;
    return this.gos.get("enableRtl") ? this.pinned !== "left" && (t *= -1) : this.pinned === "right" && (t *= -1), t;
  }
  destroy() {
    super.destroy(), this.clearLocalValues();
  }
};
u([
  f("horizontalResizeService")
], yr.prototype, "horizontalResizeService", 2);
u([
  f("autoWidthCalculator")
], yr.prototype, "autoWidthCalculator", 2);
u([
  f("columnModel")
], yr.prototype, "columnModel", 2);
u([
  L
], yr.prototype, "postConstruct", 1);
var Fh = class extends F {
  constructor(e, t) {
    super(), this.removeChildListenersFuncs = [], this.columnGroup = t, this.comp = e;
  }
  postConstruct() {
    this.addListenersToChildrenColumns(), this.addManagedListener(this.columnGroup, Ke.EVENT_DISPLAYED_CHILDREN_CHANGED, this.onDisplayedChildrenChanged.bind(this)), this.onWidthChanged(), this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
  }
  addListenersToChildrenColumns() {
    this.removeListenersOnChildrenColumns();
    const e = this.onWidthChanged.bind(this);
    this.columnGroup.getLeafColumns().forEach((t) => {
      t.addEventListener("widthChanged", e), t.addEventListener("visibleChanged", e), this.removeChildListenersFuncs.push(() => {
        t.removeEventListener("widthChanged", e), t.removeEventListener("visibleChanged", e);
      });
    });
  }
  removeListenersOnChildrenColumns() {
    this.removeChildListenersFuncs.forEach((e) => e()), this.removeChildListenersFuncs = [];
  }
  onDisplayedChildrenChanged() {
    this.addListenersToChildrenColumns(), this.onWidthChanged();
  }
  onWidthChanged() {
    const e = this.columnGroup.getActualWidth();
    this.comp.setWidth(`${e}px`), this.comp.addOrRemoveCssClass("ag-hidden", e === 0);
  }
};
u([
  L
], Fh.prototype, "postConstruct", 1);
var jf = class extends Kn {
  constructor(e, t, i) {
    super(e, t, i), this.onSuppressColMoveChange = () => {
      if (!this.isAlive() || this.isSuppressMoving())
        this.removeDragSource();
      else if (!this.dragSource) {
        const s = this.getGui();
        this.setDragSource(s);
      }
    }, this.column = e;
  }
  setComp(e, t, i) {
    this.comp = e, this.setGui(t), this.displayName = this.beans.columnModel.getDisplayNameForColumnGroup(this.column, "header"), this.addClasses(), this.setupMovingCss(), this.setupExpandable(), this.setupTooltip(), this.addDestroyFunc(() => {
      this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature));
    }), this.setupUserComp(), this.addHeaderMouseListeners();
    const s = this.getParentRowCtrl().getPinned(), o = this.column.getProvidedColumnGroup().getLeafColumns();
    this.createManagedBean(new Er(o, t)), this.createManagedBean(new $n(this.column, t, this.beans)), this.createManagedBean(new Fh(e, this.column)), this.resizeFeature = this.createManagedBean(new yr(e, i, s, this.column)), this.createManagedBean(new Hi(
      t,
      {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: () => {
        },
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      }
    )), this.addManagedPropertyListener(p.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED, this.onSuppressColMoveChange), this.addResizeAndMoveKeyboardListeners();
  }
  resizeHeader(e, t) {
    if (!this.resizeFeature)
      return;
    const i = this.resizeFeature.getInitialValues(t);
    this.resizeFeature.resizeColumns(i, i.resizeStartWidth + e, "uiColumnResized", !0);
  }
  moveHeader(e) {
    const { beans: t, eGui: i, column: s, gos: o, ctrlsService: r } = this, n = o.get("enableRtl"), l = e === 0, a = this.getPinned(), d = i.getBoundingClientRect(), c = d.left, h = d.width, g = as.normaliseX(
      l !== n ? c - 20 : c + h + 20,
      a,
      !0,
      o,
      r
    ), m = s.getGroupId(), C = this.focusService.getFocusedHeader();
    as.attemptMoveColumns({
      allMovingColumns: this.column.getLeafColumns(),
      isFromHeader: !0,
      hDirection: e,
      xPosition: g,
      pinned: a,
      fromEnter: !1,
      fakeEvent: !1,
      gos: o,
      columnModel: t.columnModel
    });
    const w = s.getDisplayedLeafColumns(), v = l ? w[0] : se(w);
    this.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(v, "auto"), !this.isAlive() && C && this.restoreFocus(m, s, C);
  }
  restoreFocus(e, t, i) {
    const s = t.getLeafColumns();
    if (!s.length)
      return;
    const o = s[0].getParent();
    if (!o)
      return;
    const r = this.findGroupWidthId(o, e);
    r && this.focusService.focusHeaderPosition({
      headerPosition: Re(_({}, i), {
        column: r
      })
    });
  }
  findGroupWidthId(e, t) {
    for (; e; ) {
      if (e.getGroupId() === t)
        return e;
      e = e.getParent();
    }
    return null;
  }
  resizeLeafColumnsToFit(e) {
    this.resizeFeature && this.resizeFeature.resizeLeafColumnsToFit(e);
  }
  setupUserComp() {
    const e = this.gos.addGridCommonParams({
      displayName: this.displayName,
      columnGroup: this.column,
      setExpanded: (i) => {
        this.beans.columnModel.setColumnGroupOpened(this.column.getProvidedColumnGroup(), i, "gridInitializing");
      },
      setTooltip: (i, s) => {
        this.setupTooltip(i, s);
      }
    }), t = this.userComponentFactory.getHeaderGroupCompDetails(e);
    this.comp.setUserCompDetails(t);
  }
  addHeaderMouseListeners() {
    const e = (s) => this.handleMouseOverChange(s.type === "mouseenter"), t = () => this.dispatchColumnMouseEvent(p.EVENT_COLUMN_HEADER_CLICKED, this.column.getProvidedColumnGroup()), i = (s) => this.handleContextMenuMouseEvent(s, void 0, this.column.getProvidedColumnGroup());
    this.addManagedListener(this.getGui(), "mouseenter", e), this.addManagedListener(this.getGui(), "mouseleave", e), this.addManagedListener(this.getGui(), "click", t), this.addManagedListener(this.getGui(), "contextmenu", i);
  }
  handleMouseOverChange(e) {
    const i = {
      type: e ? p.EVENT_COLUMN_HEADER_MOUSE_OVER : p.EVENT_COLUMN_HEADER_MOUSE_LEAVE,
      column: this.column.getProvidedColumnGroup()
    };
    this.eventService.dispatchEvent(i);
  }
  setupTooltip(e, t) {
    this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature));
    const i = this.column.getColGroupDef(), s = this.gos.get("tooltipShowMode") === "whenTruncated", o = this.eGui;
    !t && s && !(i != null && i.headerGroupComponent) && (t = () => {
      const n = o.querySelector(".ag-header-group-text");
      return n ? n.scrollWidth > n.clientWidth : !0;
    });
    const r = {
      getColumn: () => this.column,
      getGui: () => o,
      getLocation: () => "headerGroup",
      getTooltipValue: () => e ?? (i && i.headerTooltip),
      shouldDisplayTooltip: t
    };
    i && (r.getColDef = () => i), this.createBean(new wi(r));
  }
  setupExpandable() {
    const e = this.column.getProvidedColumnGroup();
    this.refreshExpanded(), this.addManagedListener(e, Ge.EVENT_EXPANDABLE_CHANGED, this.refreshExpanded.bind(this)), this.addManagedListener(e, Ge.EVENT_EXPANDED_CHANGED, this.refreshExpanded.bind(this));
  }
  refreshExpanded() {
    const e = this.column;
    this.expandable = e.isExpandable();
    const t = e.isExpanded();
    this.expandable ? this.comp.setAriaExpanded(t ? "true" : "false") : this.comp.setAriaExpanded(void 0);
  }
  getColId() {
    return this.column.getUniqueId();
  }
  addClasses() {
    const e = this.column.getColGroupDef(), t = Bn.getHeaderClassesFromColDef(e, this.gos, null, this.column);
    this.column.isPadding() ? (t.push("ag-header-group-cell-no-group"), this.column.getLeafColumns().every((s) => s.isSpanHeaderHeight()) && t.push("ag-header-span-height")) : t.push("ag-header-group-cell-with-group"), t.forEach((i) => this.comp.addOrRemoveCssClass(i, !0));
  }
  setupMovingCss() {
    const t = this.column.getProvidedColumnGroup().getLeafColumns(), i = () => this.comp.addOrRemoveCssClass("ag-header-cell-moving", this.column.isMoving());
    t.forEach((s) => {
      this.addManagedListener(s, pe.EVENT_MOVING_CHANGED, i);
    }), i();
  }
  onFocusIn(e) {
    if (!this.eGui.contains(e.relatedTarget)) {
      const t = this.getRowIndex();
      this.beans.focusService.setFocusedHeader(t, this.column);
    }
  }
  handleKeyDown(e) {
    super.handleKeyDown(e);
    const t = this.getWrapperHasFocus();
    if (!(!this.expandable || !t) && e.key === S.ENTER) {
      const i = this.column, s = !i.isExpanded();
      this.beans.columnModel.setColumnGroupOpened(i.getProvidedColumnGroup(), s, "uiColumnExpanded");
    }
  }
  // unlike columns, this will only get called once, as we don't react on props on column groups
  // (we will always destroy and recreate this comp if something changes)
  setDragSource(e) {
    if (!this.isAlive() || this.isSuppressMoving() || (this.removeDragSource(), !e))
      return;
    const { beans: t, column: i, displayName: s, gos: o, dragAndDropService: r } = this, { columnModel: n } = t, l = i.getProvidedColumnGroup().getLeafColumns();
    let a = !o.get("suppressDragLeaveHidesColumns");
    const d = this.dragSource = {
      type: 1,
      eElement: e,
      getDefaultIconName: () => a ? Y.ICON_HIDE : Y.ICON_NOT_ALLOWED,
      dragItemName: s,
      // we add in the original group leaf columns, so we move both visible and non-visible items
      getDragItem: () => this.getDragItemForGroup(i),
      onDragStarted: () => {
        a = !o.get("suppressDragLeaveHidesColumns"), l.forEach((c) => c.setMoving(!0, "uiColumnDragged"));
      },
      onDragStopped: () => l.forEach((c) => c.setMoving(!1, "uiColumnDragged")),
      onGridEnter: (c) => {
        var h;
        if (a) {
          const g = ((h = c == null ? void 0 : c.columns) == null ? void 0 : h.filter((m) => !m.getColDef().lockVisible)) || [];
          n.setColumnsVisible(g, !0, "uiColumnMoved");
        }
      },
      onGridExit: (c) => {
        var h;
        if (a) {
          const g = ((h = c == null ? void 0 : c.columns) == null ? void 0 : h.filter((m) => !m.getColDef().lockVisible)) || [];
          n.setColumnsVisible(g, !1, "uiColumnMoved");
        }
      }
    };
    r.addDragSource(d, !0);
  }
  // when moving the columns, we want to move all the columns (contained within the DragItem) in this group in one go,
  // and in the order they are currently in the screen.
  getDragItemForGroup(e) {
    const t = e.getProvidedColumnGroup().getLeafColumns(), i = {};
    t.forEach((o) => i[o.getId()] = o.isVisible());
    const s = [];
    return this.beans.columnModel.getAllDisplayedColumns().forEach((o) => {
      t.indexOf(o) >= 0 && (s.push(o), gt(t, o));
    }), t.forEach((o) => s.push(o)), {
      columns: s,
      visibleState: i
    };
  }
  isSuppressMoving() {
    let e = !1;
    return this.column.getLeafColumns().forEach((i) => {
      (i.getColDef().suppressMovable || i.getColDef().lockPosition) && (e = !0);
    }), e || this.gos.get("suppressMovableColumns");
  }
}, Yf = 0, Go = class extends F {
  constructor(e, t, i) {
    super(), this.instanceId = Yf++, this.rowIndex = e, this.pinned = t, this.type = i;
    const s = i == "group" ? "ag-header-row-column-group" : i == "filter" ? "ag-header-row-column-filter" : "ag-header-row-column";
    this.headerRowClass = `ag-header-row ${s}`;
  }
  postConstruct() {
    this.isPrintLayout = this.gos.isDomLayout("print"), this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
  }
  getInstanceId() {
    return this.instanceId;
  }
  /**
   * 
   * @param comp Proxy to the actual component
   * @param initCompState Should the component be initialised with the current state of the controller. Default: true
   */
  setComp(e, t = !0) {
    this.comp = e, t && (this.onRowHeightChanged(), this.onVirtualColumnsChanged()), this.setWidth(), this.addEventListeners();
  }
  getHeaderRowClass() {
    return this.headerRowClass;
  }
  getAriaRowIndex() {
    return this.rowIndex + 1;
  }
  addEventListeners() {
    this.addManagedListener(this.eventService, p.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this)), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_VIRTUAL_COLUMNS_CHANGED, (e) => this.onVirtualColumnsChanged(e.afterScroll)), this.addManagedListener(this.eventService, p.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, this.onRowHeightChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_GRID_STYLES_CHANGED, this.onRowHeightChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("domLayout", this.onDisplayedColumnsChanged.bind(this)), this.addManagedPropertyListener("ensureDomOrder", (e) => this.isEnsureDomOrder = e.currentValue), this.addManagedPropertyListener("headerHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("pivotHeaderHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("groupHeaderHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("pivotGroupHeaderHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("floatingFiltersHeight", this.onRowHeightChanged.bind(this));
  }
  getHeaderCellCtrl(e) {
    if (this.headerCellCtrls)
      return ss(this.headerCellCtrls).find((t) => t.getColumnGroupChild() === e);
  }
  onDisplayedColumnsChanged() {
    this.isPrintLayout = this.gos.isDomLayout("print"), this.onVirtualColumnsChanged(), this.setWidth(), this.onRowHeightChanged();
  }
  getType() {
    return this.type;
  }
  onColumnResized() {
    this.setWidth();
  }
  setWidth() {
    const e = this.getWidthForRow();
    this.comp.setWidth(`${e}px`);
  }
  getWidthForRow() {
    const { columnModel: e } = this.beans;
    return this.isPrintLayout ? this.pinned != null ? 0 : e.getContainerWidth("right") + e.getContainerWidth("left") + e.getContainerWidth(null) : e.getContainerWidth(this.pinned);
  }
  onRowHeightChanged() {
    var { topOffset: e, rowHeight: t } = this.getTopAndHeight();
    this.comp.setTop(e + "px"), this.comp.setHeight(t + "px");
  }
  getTopAndHeight() {
    const { columnModel: e, filterManager: t } = this.beans;
    let i = e.getHeaderRowCount();
    const s = [];
    let o = 0;
    t.hasFloatingFilters() && (i++, o = 1);
    const r = e.getColumnGroupHeaderRowHeight(), n = e.getColumnHeaderRowHeight(), l = 1 + o, a = i - l;
    for (let h = 0; h < a; h++)
      s.push(r);
    s.push(n);
    for (let h = 0; h < o; h++)
      s.push(e.getFloatingFiltersHeight());
    let d = 0;
    for (let h = 0; h < this.rowIndex; h++)
      d += s[h];
    const c = s[this.rowIndex];
    return { topOffset: d, rowHeight: c };
  }
  getPinned() {
    return this.pinned;
  }
  getRowIndex() {
    return this.rowIndex;
  }
  onVirtualColumnsChanged(e = !1) {
    const t = this.getHeaderCtrls(), i = this.isEnsureDomOrder || this.isPrintLayout;
    this.comp.setHeaderCtrls(t, i, e);
  }
  getHeaderCtrls() {
    const e = this.headerCellCtrls;
    this.headerCellCtrls = /* @__PURE__ */ new Map();
    const t = this.getColumnsInViewport();
    for (const o of t)
      this.recycleAndCreateHeaderCtrls(o, e);
    const i = (o) => {
      const { focusService: r, columnModel: n } = this.beans;
      return r.isHeaderWrapperFocused(o) ? n.isDisplayed(o.getColumnGroupChild()) : !1;
    };
    if (e)
      for (const [o, r] of e)
        i(r) ? this.headerCellCtrls.set(o, r) : this.destroyBean(r);
    return Array.from(this.headerCellCtrls.values());
  }
  recycleAndCreateHeaderCtrls(e, t) {
    if (!this.headerCellCtrls || e.isEmptyGroup())
      return;
    const i = e.getUniqueId();
    let s;
    if (t && (s = t.get(i), t.delete(i)), s && s.getColumnGroupChild() != e && (this.destroyBean(s), s = void 0), s == null)
      switch (this.type) {
        case "filter":
          s = this.createBean(new Kf(e, this.beans, this));
          break;
        case "group":
          s = this.createBean(new jf(e, this.beans, this));
          break;
        default:
          s = this.createBean(new $f(e, this.beans, this));
          break;
      }
    this.headerCellCtrls.set(i, s);
  }
  getColumnsInViewport() {
    return this.isPrintLayout ? this.getColumnsInViewportPrintLayout() : this.getColumnsInViewportNormalLayout();
  }
  getColumnsInViewportPrintLayout() {
    if (this.pinned != null)
      return [];
    let e = [];
    const t = this.getActualDepth(), { columnModel: i } = this.beans;
    return ["left", null, "right"].forEach((s) => {
      const o = i.getVirtualHeaderGroupRow(s, t);
      e = e.concat(o);
    }), e;
  }
  getActualDepth() {
    return this.type == "filter" ? this.rowIndex - 1 : this.rowIndex;
  }
  getColumnsInViewportNormalLayout() {
    return this.beans.columnModel.getVirtualHeaderGroupRow(this.pinned, this.getActualDepth());
  }
  focusHeader(e, t) {
    if (!this.headerCellCtrls)
      return !1;
    const s = Array.from(this.headerCellCtrls.values()).find((o) => o.getColumnGroupChild() == e);
    return s ? s.focus(t) : !1;
  }
  destroy() {
    this.headerCellCtrls && this.headerCellCtrls.forEach((e) => {
      this.destroyBean(e);
    }), this.headerCellCtrls = void 0, super.destroy();
  }
};
u([
  f("beans")
], Go.prototype, "beans", 2);
u([
  L
], Go.prototype, "postConstruct", 1);
var ki = class extends F {
  constructor(e) {
    super(), this.hidden = !1, this.includeFloatingFilter = !1, this.groupsRowCtrls = [], this.pinned = e;
  }
  setComp(e, t) {
    this.comp = e, this.eViewport = t, this.setupCenterWidth(), this.setupPinnedWidth(), this.setupDragAndDrop(this.eViewport), this.addManagedListener(this.eventService, p.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.ctrlsService.registerHeaderContainer(this, this.pinned), this.columnModel.isReady() && this.refresh();
  }
  setupDragAndDrop(e) {
    const t = new go(this.pinned, e);
    this.createManagedBean(t);
  }
  refresh(e = !1) {
    const t = new Xs(), i = this.focusService.getFocusHeaderToUseAfterRefresh(), s = () => {
      const l = this.columnModel.getHeaderRowCount() - 1;
      this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
      for (let a = 0; a < l; a++) {
        const d = this.createBean(new Go(
          t.next(),
          this.pinned,
          "group"
          /* COLUMN_GROUP */
        ));
        this.groupsRowCtrls.push(d);
      }
    }, o = () => {
      const l = t.next(), a = !this.hidden && (this.columnsRowCtrl == null || !e || this.columnsRowCtrl.getRowIndex() !== l);
      (a || this.hidden) && (this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl)), a && (this.columnsRowCtrl = this.createBean(new Go(
        l,
        this.pinned,
        "column"
        /* COLUMN */
      )));
    }, r = () => {
      this.includeFloatingFilter = this.filterManager.hasFloatingFilters() && !this.hidden;
      const l = () => {
        this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
      };
      if (!this.includeFloatingFilter) {
        l();
        return;
      }
      const a = t.next();
      if (this.filtersRowCtrl) {
        const d = this.filtersRowCtrl.getRowIndex() !== a;
        (!e || d) && l();
      }
      this.filtersRowCtrl || (this.filtersRowCtrl = this.createBean(new Go(
        a,
        this.pinned,
        "filter"
        /* FLOATING_FILTER */
      )));
    };
    s(), o(), r();
    const n = this.getAllCtrls();
    this.comp.setCtrls(n), this.restoreFocusOnHeader(i);
  }
  restoreFocusOnHeader(e) {
    e == null || e.column.getPinned() != this.pinned || this.focusService.focusHeaderPosition({ headerPosition: e });
  }
  getAllCtrls() {
    const e = [...this.groupsRowCtrls];
    return this.columnsRowCtrl && e.push(this.columnsRowCtrl), this.filtersRowCtrl && e.push(this.filtersRowCtrl), e;
  }
  // grid cols have changed - this also means the number of rows in the header can have
  // changed. so we remove all the old rows and insert new ones for a complete refresh
  onGridColumnsChanged() {
    this.refresh(!0);
  }
  onDisplayedColumnsChanged() {
    const e = this.filterManager.hasFloatingFilters() && !this.hidden;
    this.includeFloatingFilter !== e && this.refresh(!0);
  }
  setupCenterWidth() {
    this.pinned == null && this.createManagedBean(new co((e) => this.comp.setCenterWidth(`${e}px`), !0));
  }
  setHorizontalScroll(e) {
    this.comp.setViewportScrollLeft(e);
  }
  setupPinnedWidth() {
    if (this.pinned == null)
      return;
    const e = this.pinned === "left", t = this.pinned === "right";
    this.hidden = !0;
    const i = () => {
      const s = e ? this.pinnedWidthService.getPinnedLeftWidth() : this.pinnedWidthService.getPinnedRightWidth();
      if (s == null)
        return;
      const o = s == 0, r = this.hidden !== o, n = this.gos.get("enableRtl"), l = this.gos.getScrollbarWidth(), d = this.scrollVisibleService.isVerticalScrollShowing() && (n && e || !n && t) ? s + l : s;
      this.comp.setPinnedContainerWidth(`${d}px`), this.comp.setDisplayed(!o), r && (this.hidden = o, this.refresh());
    };
    this.addManagedListener(this.eventService, p.EVENT_LEFT_PINNED_WIDTH_CHANGED, i), this.addManagedListener(this.eventService, p.EVENT_RIGHT_PINNED_WIDTH_CHANGED, i), this.addManagedListener(this.eventService, p.EVENT_SCROLL_VISIBILITY_CHANGED, i), this.addManagedListener(this.eventService, p.EVENT_SCROLLBAR_WIDTH_CHANGED, i);
  }
  getHeaderCtrlForColumn(e) {
    if (e instanceof pe)
      return this.columnsRowCtrl ? this.columnsRowCtrl.getHeaderCellCtrl(e) : void 0;
    if (this.groupsRowCtrls.length !== 0)
      for (let t = 0; t < this.groupsRowCtrls.length; t++) {
        const i = this.groupsRowCtrls[t].getHeaderCellCtrl(e);
        if (i)
          return i;
      }
  }
  getHtmlElementForColumnHeader(e) {
    const t = this.getHeaderCtrlForColumn(e);
    return t ? t.getGui() : null;
  }
  getRowType(e) {
    const i = this.getAllCtrls()[e];
    return i ? i.getType() : void 0;
  }
  focusHeader(e, t, i) {
    const o = this.getAllCtrls()[e];
    return o ? o.focusHeader(t, i) : !1;
  }
  getViewport() {
    return this.eViewport;
  }
  getRowCount() {
    return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
  }
  destroy() {
    this.filtersRowCtrl && (this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl)), this.columnsRowCtrl && (this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl)), this.groupsRowCtrls && this.groupsRowCtrls.length && (this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls)), super.destroy();
  }
};
u([
  f("ctrlsService")
], ki.prototype, "ctrlsService", 2);
u([
  f("scrollVisibleService")
], ki.prototype, "scrollVisibleService", 2);
u([
  f("pinnedWidthService")
], ki.prototype, "pinnedWidthService", 2);
u([
  f("columnModel")
], ki.prototype, "columnModel", 2);
u([
  f("focusService")
], ki.prototype, "focusService", 2);
u([
  f("filterManager")
], ki.prototype, "filterManager", 2);
var Is = class Br extends K {
  constructor(t) {
    super(), this.headerRowComps = {}, this.rowCompsList = [], this.pinned = t;
  }
  init() {
    this.selectAndSetTemplate();
    const t = {
      setDisplayed: (s) => this.setDisplayed(s),
      setCtrls: (s) => this.setCtrls(s),
      // only gets called for center section
      setCenterWidth: (s) => this.eCenterContainer.style.width = s,
      setViewportScrollLeft: (s) => this.getGui().scrollLeft = s,
      // only gets called for pinned sections
      setPinnedContainerWidth: (s) => {
        const o = this.getGui();
        o.style.width = s, o.style.maxWidth = s, o.style.minWidth = s;
      }
    };
    this.createManagedBean(new ki(this.pinned)).setComp(t, this.getGui());
  }
  selectAndSetTemplate() {
    const t = this.pinned == "left", i = this.pinned == "right", s = t ? Br.PINNED_LEFT_TEMPLATE : i ? Br.PINNED_RIGHT_TEMPLATE : Br.CENTER_TEMPLATE;
    this.setTemplate(s), this.eRowContainer = this.eCenterContainer ? this.eCenterContainer : this.getGui();
  }
  destroyRowComps() {
    this.setCtrls([]);
  }
  destroyRowComp(t) {
    this.destroyBean(t), this.eRowContainer.removeChild(t.getGui());
  }
  setCtrls(t) {
    const i = this.headerRowComps;
    this.headerRowComps = {}, this.rowCompsList = [];
    let s;
    const o = (r) => {
      const n = r.getGui();
      n.parentElement != this.eRowContainer && this.eRowContainer.appendChild(n), s && Ra(this.eRowContainer, n, s), s = n;
    };
    t.forEach((r) => {
      const n = r.getInstanceId(), l = i[n];
      delete i[n];
      const a = l || this.createBean(new $a(r));
      this.headerRowComps[n] = a, this.rowCompsList.push(a), o(a);
    }), Ii(i).forEach((r) => this.destroyRowComp(r));
  }
};
Is.PINNED_LEFT_TEMPLATE = /* html */
'<div class="ag-pinned-left-header" role="rowgroup"></div>';
Is.PINNED_RIGHT_TEMPLATE = /* html */
'<div class="ag-pinned-right-header" role="rowgroup"></div>';
Is.CENTER_TEMPLATE = /* html */
`<div class="ag-header-viewport" role="presentation">
            <div class="ag-header-container" ref="eCenterContainer" role="rowgroup"></div>
        </div>`;
u([
  M("eCenterContainer")
], Is.prototype, "eCenterContainer", 2);
u([
  L
], Is.prototype, "init", 1);
u([
  dt
], Is.prototype, "destroyRowComps", 1);
var cl = Is, hs = class extends F {
  constructor() {
    super(...arguments), this.currentHeaderRowWithoutSpan = -1;
  }
  postConstruct() {
    this.ctrlsService.whenReady((t) => {
      this.gridBodyCon = t.gridBodyCtrl;
    });
    const e = this.gos.getDocument();
    this.addManagedListener(e, "mousedown", () => this.setCurrentHeaderRowWithoutSpan(-1));
  }
  getHeaderRowCount() {
    const e = this.ctrlsService.getHeaderRowContainerCtrl();
    return e ? e.getRowCount() : 0;
  }
  /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */
  navigateVertically(e, t, i) {
    if (t || (t = this.focusService.getFocusedHeader()), !t)
      return !1;
    const { headerRowIndex: s, column: o } = t, r = this.getHeaderRowCount(), n = e === 0;
    let { headerRowIndex: l, column: a, headerRowIndexWithoutSpan: d } = n ? this.headerPositionUtils.getColumnVisibleParent(o, s) : this.headerPositionUtils.getColumnVisibleChild(o, s), c = !1;
    return l < 0 && (l = 0, a = o, c = !0), l >= r ? (l = -1, this.setCurrentHeaderRowWithoutSpan(-1)) : d !== void 0 && (this.currentHeaderRowWithoutSpan = d), !c && !a ? !1 : this.focusService.focusHeaderPosition({
      headerPosition: { headerRowIndex: l, column: a },
      allowUserOverride: !0,
      event: i
    });
  }
  setCurrentHeaderRowWithoutSpan(e) {
    this.currentHeaderRowWithoutSpan = e;
  }
  /*
   * This method navigates grid header horizontally
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */
  navigateHorizontally(e, t = !1, i) {
    const s = this.focusService.getFocusedHeader(), o = e === 2, r = this.gos.get("enableRtl");
    let n, l;
    if (this.currentHeaderRowWithoutSpan !== -1 ? s.headerRowIndex = this.currentHeaderRowWithoutSpan : this.currentHeaderRowWithoutSpan = s.headerRowIndex, o !== r ? (l = "Before", n = this.headerPositionUtils.findHeader(s, l)) : (l = "After", n = this.headerPositionUtils.findHeader(s, l)), n || !t)
      return this.focusService.focusHeaderPosition({
        headerPosition: n,
        direction: l,
        fromTab: t,
        allowUserOverride: !0,
        event: i
      });
    if (t) {
      const a = this.gos.getCallback("tabToNextHeader");
      if (a)
        return this.focusService.focusHeaderPositionFromUserFunc({
          userFunc: a,
          headerPosition: n,
          direction: l
        });
    }
    return this.focusNextHeaderRow(s, l, i);
  }
  focusNextHeaderRow(e, t, i) {
    const s = e.headerRowIndex;
    let o = null, r;
    if (t === "Before" ? s > 0 && (r = s - 1, this.currentHeaderRowWithoutSpan -= 1, o = this.headerPositionUtils.findColAtEdgeForHeaderRow(r, "end")) : (r = s + 1, this.currentHeaderRowWithoutSpan < this.getHeaderRowCount() ? this.currentHeaderRowWithoutSpan += 1 : this.setCurrentHeaderRowWithoutSpan(-1), o = this.headerPositionUtils.findColAtEdgeForHeaderRow(r, "start")), !o)
      return !1;
    const { column: n, headerRowIndex: l } = this.headerPositionUtils.getHeaderIndexToFocus(o.column, o == null ? void 0 : o.headerRowIndex);
    return this.focusService.focusHeaderPosition({
      headerPosition: { column: n, headerRowIndex: l },
      direction: t,
      fromTab: !0,
      allowUserOverride: !0,
      event: i
    });
  }
  scrollToColumn(e, t = "After") {
    if (e.getPinned())
      return;
    let i;
    if (e instanceof Ke) {
      const s = e.getDisplayedLeafColumns();
      i = t === "Before" ? se(s) : s[0];
    } else
      i = e;
    this.gridBodyCon.getScrollFeature().ensureColumnVisible(i);
  }
};
u([
  f("focusService")
], hs.prototype, "focusService", 2);
u([
  f("headerPositionUtils")
], hs.prototype, "headerPositionUtils", 2);
u([
  f("ctrlsService")
], hs.prototype, "ctrlsService", 2);
u([
  L
], hs.prototype, "postConstruct", 1);
hs = u([
  O("headerNavigationService")
], hs);
var Bi = class extends F {
  setComp(e, t, i) {
    this.comp = e, this.eGui = t, this.createManagedBean(new Hi(
      i,
      {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      }
    )), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.onPivotModeChanged(), this.setupHeaderHeight();
    const s = this.onHeaderContextMenu.bind(this);
    this.addManagedListener(this.eGui, "contextmenu", s), this.mockContextMenuForIPad(s), this.ctrlsService.register("gridHeaderCtrl", this);
  }
  setupHeaderHeight() {
    const e = this.setHeaderHeight.bind(this);
    e(), this.addManagedPropertyListener("headerHeight", e), this.addManagedPropertyListener("pivotHeaderHeight", e), this.addManagedPropertyListener("groupHeaderHeight", e), this.addManagedPropertyListener("pivotGroupHeaderHeight", e), this.addManagedPropertyListener("floatingFiltersHeight", e), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, e), this.addManagedListener(this.eventService, p.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, e), this.addManagedListener(this.eventService, p.EVENT_GRID_STYLES_CHANGED, e), this.addManagedListener(this.eventService, p.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, e);
  }
  getHeaderHeight() {
    return this.headerHeight;
  }
  setHeaderHeight() {
    const { columnModel: e } = this;
    let t = 0, i = e.getHeaderRowCount(), s;
    this.filterManager.hasFloatingFilters() && (i++, t = 1);
    const r = this.columnModel.getColumnGroupHeaderRowHeight(), n = this.columnModel.getColumnHeaderRowHeight(), l = 1 + t, a = i - l;
    if (s = t * e.getFloatingFiltersHeight(), s += a * r, s += n, this.headerHeight === s)
      return;
    this.headerHeight = s;
    const d = `${s + 1}px`;
    this.comp.setHeightAndMinHeight(d), this.eventService.dispatchEvent({
      type: p.EVENT_HEADER_HEIGHT_CHANGED
    });
  }
  onPivotModeChanged() {
    const e = this.columnModel.isPivotMode();
    this.comp.addOrRemoveCssClass("ag-pivot-on", e), this.comp.addOrRemoveCssClass("ag-pivot-off", !e);
  }
  onDisplayedColumnsChanged() {
    const t = this.columnModel.getAllDisplayedColumns().some((i) => i.isSpanHeaderHeight());
    this.comp.addOrRemoveCssClass("ag-header-allow-overflow", t);
  }
  onTabKeyDown(e) {
    const t = this.gos.get("enableRtl"), i = e.shiftKey !== t ? 2 : 3;
    (this.headerNavigationService.navigateHorizontally(i, !0, e) || this.focusService.focusNextGridCoreContainer(e.shiftKey)) && e.preventDefault();
  }
  handleKeyDown(e) {
    let t = null;
    switch (e.key) {
      case S.LEFT:
        t = 2;
      case S.RIGHT:
        b(t) || (t = 3), this.headerNavigationService.navigateHorizontally(t, !1, e);
        break;
      case S.UP:
        t = 0;
      case S.DOWN:
        b(t) || (t = 1), this.headerNavigationService.navigateVertically(t, null, e) && e.preventDefault();
        break;
      default:
        return;
    }
  }
  onFocusOut(e) {
    const { relatedTarget: t } = e;
    !t && this.eGui.contains(this.gos.getActiveDomElement()) || this.eGui.contains(t) || this.focusService.clearFocusedHeader();
  }
  onHeaderContextMenu(e, t, i) {
    if (!e && !i || !this.menuService.isHeaderContextMenuEnabled())
      return;
    const { target: s } = e ?? t;
    (s === this.eGui || s === this.ctrlsService.getHeaderRowContainerCtrl().getViewport()) && this.menuService.showHeaderContextMenu(void 0, e, i);
  }
  mockContextMenuForIPad(e) {
    if (!vi())
      return;
    const t = new je(this.eGui), i = (s) => {
      e(void 0, s.touchStart, s.touchEvent);
    };
    this.addManagedListener(t, je.EVENT_LONG_TAP, i), this.addDestroyFunc(() => t.destroy());
  }
};
u([
  f("headerNavigationService")
], Bi.prototype, "headerNavigationService", 2);
u([
  f("focusService")
], Bi.prototype, "focusService", 2);
u([
  f("columnModel")
], Bi.prototype, "columnModel", 2);
u([
  f("ctrlsService")
], Bi.prototype, "ctrlsService", 2);
u([
  f("filterManager")
], Bi.prototype, "filterManager", 2);
u([
  f("menuService")
], Bi.prototype, "menuService", 2);
var Ya = class Lh extends K {
  constructor() {
    super(Lh.TEMPLATE);
  }
  postConstruct() {
    const t = {
      addOrRemoveCssClass: (o, r) => this.addOrRemoveCssClass(o, r),
      setHeightAndMinHeight: (o) => {
        this.getGui().style.height = o, this.getGui().style.minHeight = o;
      }
    };
    this.createManagedBean(new Bi()).setComp(t, this.getGui(), this.getFocusableElement());
    const s = (o) => {
      this.createManagedBean(o), this.appendChild(o);
    };
    s(new cl("left")), s(new cl(null)), s(new cl("right"));
  }
};
Ya.TEMPLATE = /* html */
'<div class="ag-header" role="presentation"/>';
u([
  L
], Ya.prototype, "postConstruct", 1);
var qf = Ya, qo = class extends F {
  addResizeBar(e) {
    const t = {
      dragStartPixels: e.dragStartPixels || 0,
      eElement: e.eResizeBar,
      onDragStart: this.onDragStart.bind(this, e),
      onDragStop: this.onDragStop.bind(this, e),
      onDragging: this.onDragging.bind(this, e),
      includeTouch: !0,
      stopPropagationForTouch: !0
    };
    return this.dragService.addDragSource(t), () => this.dragService.removeDragSource(t);
  }
  onDragStart(e, t) {
    this.dragStartX = t.clientX, this.setResizeIcons();
    const i = t instanceof MouseEvent && t.shiftKey === !0;
    e.onResizeStart(i);
  }
  setResizeIcons() {
    const e = this.ctrlsService.get("gridCtrl");
    e.setResizeCursor(!0), e.disableUserSelect(!0);
  }
  onDragStop(e, t) {
    e.onResizeEnd(this.resizeAmount), this.resetIcons();
  }
  resetIcons() {
    const e = this.ctrlsService.get("gridCtrl");
    e.setResizeCursor(!1), e.disableUserSelect(!1);
  }
  onDragging(e, t) {
    this.resizeAmount = t.clientX - this.dragStartX, e.onResizing(this.resizeAmount);
  }
};
u([
  f("dragService")
], qo.prototype, "dragService", 2);
u([
  f("ctrlsService")
], qo.prototype, "ctrlsService", 2);
qo = u([
  O("horizontalResizeService")
], qo);
var xi = class extends F {
  hideActiveMenu() {
    this.hidePopup && this.hidePopup();
  }
  showMenuAfterMouseEvent(e, t, i) {
    this.showPopup(e, (s) => {
      this.popupService.positionPopupUnderMouseEvent({
        column: e,
        type: i,
        mouseEvent: t,
        ePopup: s
      });
    }, i, t.target, this.menuService.isLegacyMenuEnabled());
  }
  showMenuAfterButtonClick(e, t, i) {
    let s = -1, o = "left";
    const r = this.menuService.isLegacyMenuEnabled();
    !r && this.gos.get("enableRtl") && (s = 1, o = "right");
    let n = r ? void 0 : 4 * s, l = r ? void 0 : 4;
    this.showPopup(e, (a) => {
      this.popupService.positionPopupByComponent({
        type: i,
        eventSource: t,
        ePopup: a,
        nudgeX: n,
        nudgeY: l,
        alignSide: o,
        keepWithinBounds: !0,
        position: "under",
        column: e
      });
    }, i, t, r);
  }
  showPopup(e, t, i, s, o) {
    const r = e ? this.createBean(new Hn(e, "COLUMN_MENU")) : void 0;
    if (this.activeMenu = r, !(r != null && r.hasFilter()) || !e)
      throw new Error("AG Grid - unable to show popup filter, filter instantiation failed");
    const n = document.createElement("div");
    Fe(n, "presentation"), n.classList.add("ag-menu"), o || n.classList.add("ag-filter-menu"), this.tabListener = this.addManagedListener(n, "keydown", (C) => this.trapFocusWithin(C, n)), n.appendChild(r == null ? void 0 : r.getGui());
    let l;
    const a = () => r == null ? void 0 : r.afterGuiDetached(), d = this.menuService.isColumnMenuAnchoringEnabled() ? s ?? this.ctrlsService.getGridBodyCtrl().getGui() : void 0, c = (C) => {
      e.setMenuVisible(!1, "contextMenu");
      const w = C instanceof KeyboardEvent;
      if (this.tabListener && (this.tabListener = this.tabListener()), w && s && wt(s)) {
        const v = this.focusService.findTabbableParent(s);
        v && v.focus();
      }
      a(), this.destroyBean(this.activeMenu), this.dispatchVisibleChangedEvent(!1, i, e);
    }, h = this.localeService.getLocaleTextFunc(), g = o && i !== "columnFilter" ? h("ariaLabelColumnMenu", "Column Menu") : h("ariaLabelColumnFilter", "Column Filter"), m = this.popupService.addPopup({
      modal: !0,
      eChild: n,
      closeOnEsc: !0,
      closedCallback: c,
      positionCallback: () => t(n),
      anchorToElement: d,
      ariaLabel: g
    });
    m && (this.hidePopup = l = m.hideFunc), r.afterInit().then(() => {
      t(n), r.afterGuiAttached({ container: i, hidePopup: l });
    }), e.setMenuVisible(!0, "contextMenu"), this.dispatchVisibleChangedEvent(!0, i, e);
  }
  trapFocusWithin(e, t) {
    e.key !== S.TAB || e.defaultPrevented || this.focusService.findNextFocusableElement(t, !1, e.shiftKey) || (e.preventDefault(), this.focusService.focusInto(t, e.shiftKey));
  }
  dispatchVisibleChangedEvent(e, t, i) {
    const s = {
      type: p.EVENT_COLUMN_MENU_VISIBLE_CHANGED,
      visible: e,
      switchingTab: !1,
      key: t,
      column: i ?? null
    };
    this.eventService.dispatchEvent(s);
  }
  isMenuEnabled(e) {
    var t;
    return e.isFilterAllowed() && ((t = e.getColDef().menuTabs) != null ? t : ["filterMenuTab"]).includes("filterMenuTab");
  }
  showMenuAfterContextMenuEvent() {
  }
  destroy() {
    this.destroyBean(this.activeMenu), super.destroy();
  }
};
u([
  f("filterManager")
], xi.prototype, "filterManager", 2);
u([
  f("popupService")
], xi.prototype, "popupService", 2);
u([
  f("focusService")
], xi.prototype, "focusService", 2);
u([
  f("ctrlsService")
], xi.prototype, "ctrlsService", 2);
u([
  f("menuService")
], xi.prototype, "menuService", 2);
xi = u([
  O("filterMenuFactory")
], xi);
var Wr = /* @__PURE__ */ ((e) => (e.TAB_GUARD = "ag-tab-guard", e.TAB_GUARD_TOP = "ag-tab-guard-top", e.TAB_GUARD_BOTTOM = "ag-tab-guard-bottom", e))(Wr || {}), jn = class extends F {
  constructor(e) {
    super(), this.skipTabGuardFocus = !1, this.forcingFocusOut = !1;
    const {
      comp: t,
      eTopGuard: i,
      eBottomGuard: s,
      focusTrapActive: o,
      forceFocusOutWhenTabGuardsAreEmpty: r,
      focusInnerElement: n,
      onFocusIn: l,
      onFocusOut: a,
      shouldStopEventPropagation: d,
      onTabKeyDown: c,
      handleKeyDown: h,
      eFocusableElement: g
    } = e;
    this.comp = t, this.eTopGuard = i, this.eBottomGuard = s, this.providedFocusInnerElement = n, this.eFocusableElement = g, this.focusTrapActive = !!o, this.forceFocusOutWhenTabGuardsAreEmpty = !!r, this.providedFocusIn = l, this.providedFocusOut = a, this.providedShouldStopEventPropagation = d, this.providedOnTabKeyDown = c, this.providedHandleKeyDown = h;
  }
  postConstruct() {
    this.createManagedBean(new Hi(
      this.eFocusableElement,
      {
        shouldStopEventPropagation: () => this.shouldStopEventPropagation(),
        onTabKeyDown: (e) => this.onTabKeyDown(e),
        handleKeyDown: (e) => this.handleKeyDown(e),
        onFocusIn: (e) => this.onFocusIn(e),
        onFocusOut: (e) => this.onFocusOut(e)
      }
    )), this.activateTabGuards(), [this.eTopGuard, this.eBottomGuard].forEach(
      (e) => this.addManagedListener(e, "focus", this.onFocus.bind(this))
    );
  }
  handleKeyDown(e) {
    this.providedHandleKeyDown && this.providedHandleKeyDown(e);
  }
  tabGuardsAreActive() {
    return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
  }
  shouldStopEventPropagation() {
    return this.providedShouldStopEventPropagation ? this.providedShouldStopEventPropagation() : !1;
  }
  activateTabGuards() {
    if (this.forcingFocusOut)
      return;
    const e = this.gos.get("tabIndex");
    this.comp.setTabIndex(e.toString());
  }
  deactivateTabGuards() {
    this.comp.setTabIndex();
  }
  onFocus(e) {
    if (this.skipTabGuardFocus) {
      this.skipTabGuardFocus = !1;
      return;
    }
    if (this.forceFocusOutWhenTabGuardsAreEmpty && this.focusService.findFocusableElements(this.eFocusableElement, ".ag-tab-guard").length === 0) {
      this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
      return;
    }
    const t = e.target === this.eBottomGuard;
    this.providedFocusInnerElement ? this.providedFocusInnerElement(t) : this.focusInnerElement(t);
  }
  findNextElementOutsideAndFocus(e) {
    const t = this.gos.getDocument(), i = this.focusService.findFocusableElements(t.body, null, !0), s = i.indexOf(e ? this.eTopGuard : this.eBottomGuard);
    if (s === -1)
      return;
    let o, r;
    e ? (o = 0, r = s) : (o = s + 1, r = i.length);
    const n = i.slice(o, r), l = this.gos.get("tabIndex");
    n.sort((a, d) => {
      const c = parseInt(a.getAttribute("tabindex") || "0"), h = parseInt(d.getAttribute("tabindex") || "0");
      return h === l ? 1 : c === l ? -1 : c === 0 ? 1 : h === 0 ? -1 : c - h;
    }), n[e ? n.length - 1 : 0].focus();
  }
  onFocusIn(e) {
    this.focusTrapActive || (this.providedFocusIn && this.providedFocusIn(e), this.deactivateTabGuards());
  }
  onFocusOut(e) {
    this.focusTrapActive || (this.providedFocusOut && this.providedFocusOut(e), this.eFocusableElement.contains(e.relatedTarget) || this.activateTabGuards());
  }
  onTabKeyDown(e) {
    if (this.providedOnTabKeyDown) {
      this.providedOnTabKeyDown(e);
      return;
    }
    if (this.focusTrapActive || e.defaultPrevented)
      return;
    const t = this.tabGuardsAreActive();
    t && this.deactivateTabGuards();
    const i = this.getNextFocusableElement(e.shiftKey);
    t && setTimeout(() => this.activateTabGuards(), 0), i && (i.focus(), e.preventDefault());
  }
  focusInnerElement(e = !1) {
    const t = this.focusService.findFocusableElements(this.eFocusableElement);
    this.tabGuardsAreActive() && (t.splice(0, 1), t.splice(t.length - 1, 1)), t.length && t[e ? t.length - 1 : 0].focus({ preventScroll: !0 });
  }
  getNextFocusableElement(e) {
    return this.focusService.findNextFocusableElement(this.eFocusableElement, !1, e);
  }
  forceFocusOutOfContainer(e = !1) {
    if (this.forcingFocusOut)
      return;
    const t = e ? this.eTopGuard : this.eBottomGuard;
    this.activateTabGuards(), this.skipTabGuardFocus = !0, this.forcingFocusOut = !0, t.focus(), window.setTimeout(() => {
      this.forcingFocusOut = !1, this.activateTabGuards();
    });
  }
  isTabGuard(e) {
    return e === this.eTopGuard || e === this.eBottomGuard;
  }
};
u([
  f("focusService")
], jn.prototype, "focusService", 2);
u([
  L
], jn.prototype, "postConstruct", 1);
var Rr = class extends K {
  initialiseTabGuard(t) {
    this.eTopGuard = this.createTabGuard("top"), this.eBottomGuard = this.createTabGuard("bottom"), this.eFocusableElement = this.getFocusableElement();
    const i = [this.eTopGuard, this.eBottomGuard], s = {
      setTabIndex: (o) => {
        i.forEach((r) => o != null ? r.setAttribute("tabindex", o) : r.removeAttribute("tabindex"));
      }
    };
    this.addTabGuards(this.eTopGuard, this.eBottomGuard), this.tabGuardCtrl = this.createManagedBean(new jn({
      comp: s,
      focusTrapActive: !!t.focusTrapActive,
      eTopGuard: this.eTopGuard,
      eBottomGuard: this.eBottomGuard,
      eFocusableElement: this.eFocusableElement,
      onFocusIn: t.onFocusIn,
      onFocusOut: t.onFocusOut,
      focusInnerElement: t.focusInnerElement,
      handleKeyDown: t.handleKeyDown,
      onTabKeyDown: t.onTabKeyDown,
      shouldStopEventPropagation: t.shouldStopEventPropagation,
      forceFocusOutWhenTabGuardsAreEmpty: t.forceFocusOutWhenTabGuardsAreEmpty
    }));
  }
  createTabGuard(t) {
    const i = document.createElement("div"), s = t === "top" ? "ag-tab-guard-top" : "ag-tab-guard-bottom";
    return i.classList.add("ag-tab-guard", s), Fe(i, "presentation"), i;
  }
  addTabGuards(t, i) {
    this.eFocusableElement.insertAdjacentElement("afterbegin", t), this.eFocusableElement.insertAdjacentElement("beforeend", i);
  }
  removeAllChildrenExceptTabGuards() {
    const t = [this.eTopGuard, this.eBottomGuard];
    xe(this.getFocusableElement()), this.addTabGuards(...t);
  }
  forceFocusOutOfContainer(t = !1) {
    this.tabGuardCtrl.forceFocusOutOfContainer(t);
  }
  appendChild(t, i) {
    pr(t) || (t = t.getGui());
    const { eBottomGuard: s } = this;
    s ? s.insertAdjacentElement("beforebegin", t) : super.appendChild(t, i);
  }
}, Yn = class Ih extends Rr {
  constructor(t) {
    super(Ih.getTemplate(t.cssClass)), this.items = [], this.tabbedItemScrollMap = /* @__PURE__ */ new Map(), this.params = t;
  }
  postConstruct() {
    this.setupHeader(), this.params.items && this.params.items.forEach((t) => this.addItem(t)), this.initialiseTabGuard({
      onTabKeyDown: this.onTabKeyDown.bind(this),
      handleKeyDown: this.handleKeyDown.bind(this),
      focusInnerElement: this.focusInnerElement.bind(this),
      focusTrapActive: !0
    }), this.addDestroyFunc(() => {
      var t, i, s;
      return (s = (i = (t = this.activeItem) == null ? void 0 : t.tabbedItem) == null ? void 0 : i.afterDetachedCallback) == null ? void 0 : s.call(i);
    });
  }
  static getTemplate(t) {
    return (
      /* html */
      `<div class="ag-tabs ${t}">
            <div ref="eHeader"></div>
            <div ref="eBody" role="presentation" class="ag-tabs-body ${t ? `${t}-body` : ""}"></div>
        </div>`
    );
  }
  setupHeader() {
    const { enableCloseButton: t, cssClass: i } = this.params, s = (o, r) => {
      o.classList.add(`ag-tabs-${r}`), i && o.classList.add(`${i}-${r}`);
    };
    t ? (this.setupCloseButton(s), this.eTabHeader = this.gos.getDocument().createElement("div"), s(this.eHeader, "header-wrapper"), Fe(this.eHeader, "presentation"), this.eHeader.appendChild(this.eTabHeader)) : this.eTabHeader = this.eHeader, Fe(this.eTabHeader, "tablist"), s(this.eTabHeader, "header");
  }
  setupCloseButton(t) {
    const i = this.gos.getDocument(), s = i.createElement("button");
    t(s, "close-button");
    const o = Te(
      "close",
      this.gos,
      void 0,
      !0
    );
    bt(s, this.params.closeButtonAriaLabel), s.appendChild(o), this.addManagedListener(s, "click", () => {
      var n, l;
      return (l = (n = this.params).onCloseClicked) == null ? void 0 : l.call(n);
    });
    const r = i.createElement("div");
    t(r, "close-button-wrapper"), Fe(r, "presentation"), r.appendChild(s), this.eHeader.appendChild(r), this.eCloseButton = s;
  }
  handleKeyDown(t) {
    switch (t.key) {
      case S.RIGHT:
      case S.LEFT:
        if (!this.eTabHeader.contains(this.gos.getActiveDomElement()))
          return;
        const i = t.key === S.RIGHT, s = this.gos.get("enableRtl"), o = this.items.indexOf(this.activeItem), r = i !== s ? Math.min(o + 1, this.items.length - 1) : Math.max(o - 1, 0);
        if (o === r)
          return;
        t.preventDefault();
        const n = this.items[r];
        this.showItemWrapper(n), n.eHeaderButton.focus();
        break;
      case S.UP:
      case S.DOWN:
        t.stopPropagation();
        break;
    }
  }
  onTabKeyDown(t) {
    var i, s, o, r;
    if (t.defaultPrevented)
      return;
    const { focusService: n, eHeader: l, eBody: a, activeItem: d, params: c } = this, { suppressTrapFocus: h, enableCloseButton: g } = c, m = this.gos.getActiveDomElement(), C = t.target, w = t.shiftKey;
    if (l.contains(m)) {
      t.preventDefault(), g && w && !((i = this.eCloseButton) != null && i.contains(m)) ? (s = this.eCloseButton) == null || s.focus() : h && w ? (o = this.focusService.findFocusableElementBeforeTabGuard(this.gos.getDocument().body, C)) == null || o.focus() : this.focusBody(t.shiftKey);
      return;
    }
    let v = null;
    if (n.isTargetUnderManagedComponent(a, C) && (w && (v = this.focusService.findFocusableElementBeforeTabGuard(a, C)), !v && !h && (v = d.eHeaderButton)), !v && a.contains(m) && (v = n.findNextFocusableElement(a, !1, w), !v)) {
      t.preventDefault(), h && !w ? this.forceFocusOutOfContainer(w) : g && !w ? (r = this.eCloseButton) == null || r.focus() : this.focusHeader();
      return;
    }
    v && (t.preventDefault(), v.focus());
  }
  focusInnerElement(t) {
    t ? this.focusHeader() : this.focusBody(!0);
  }
  focusHeader(t) {
    this.activeItem.eHeaderButton.focus({ preventScroll: t });
  }
  focusBody(t) {
    this.focusService.focusInto(this.eBody, t);
  }
  setAfterAttachedParams(t) {
    this.afterAttachedParams = t;
  }
  showFirstItem() {
    this.items.length > 0 && this.showItemWrapper(this.items[0]);
  }
  addItem(t) {
    const i = document.createElement("span");
    Fe(i, "tab"), i.setAttribute("tabindex", "-1"), i.appendChild(t.title), i.classList.add("ag-tab"), this.eTabHeader.appendChild(i), bt(i, t.titleLabel);
    const s = {
      tabbedItem: t,
      eHeaderButton: i
    };
    this.items.push(s), i.addEventListener("click", this.showItemWrapper.bind(this, s));
  }
  showItem(t) {
    const i = this.items.find((s) => s.tabbedItem === t);
    i && this.showItemWrapper(i);
  }
  showItemWrapper(t) {
    var i, s, o, r, n, l;
    const { tabbedItem: a, eHeaderButton: d } = t;
    if ((s = (i = this.params).onItemClicked) == null || s.call(i, { item: a }), this.activeItem === t) {
      (r = (o = this.params).onActiveItemClicked) == null || r.call(o);
      return;
    }
    this.lastScrollListener && (this.lastScrollListener = this.lastScrollListener()), xe(this.eBody), a.bodyPromise.then((c) => {
      this.eBody.appendChild(c);
      const h = !this.focusService.isKeyboardMode();
      if (this.params.suppressFocusBodyOnOpen || this.focusService.focusInto(this.eBody, !1, h), a.afterAttachedCallback && a.afterAttachedCallback(this.afterAttachedParams), this.params.keepScrollPosition) {
        const g = a.getScrollableContainer && a.getScrollableContainer() || c;
        this.lastScrollListener = this.addManagedListener(g, "scroll", () => {
          this.tabbedItemScrollMap.set(a.name, g.scrollTop);
        });
        const m = this.tabbedItemScrollMap.get(a.name);
        m !== void 0 && setTimeout(() => {
          g.scrollTop = m;
        }, 0);
      }
    }), this.activeItem && (this.activeItem.eHeaderButton.classList.remove("ag-tab-selected"), (l = (n = this.activeItem.tabbedItem).afterDetachedCallback) == null || l.call(n)), d.classList.add("ag-tab-selected"), this.activeItem = t;
  }
};
u([
  f("focusService")
], Yn.prototype, "focusService", 2);
u([
  M("eHeader")
], Yn.prototype, "eHeader", 2);
u([
  M("eBody")
], Yn.prototype, "eBody", 2);
u([
  L
], Yn.prototype, "postConstruct", 1);
var Qf = 50, Ul = class extends F {
  constructor() {
    super(...arguments), this.polyfillFunctions = [];
  }
  observeResize(e, t) {
    const i = this.gos.getWindow(), s = () => {
      const l = new i.ResizeObserver(t);
      return l.observe(e), () => l.disconnect();
    }, o = () => {
      var l, a;
      let d = (l = e == null ? void 0 : e.clientWidth) != null ? l : 0, c = (a = e == null ? void 0 : e.clientHeight) != null ? a : 0, h = !0;
      const g = () => {
        var m, C;
        if (h) {
          const w = (m = e == null ? void 0 : e.clientWidth) != null ? m : 0, v = (C = e == null ? void 0 : e.clientHeight) != null ? C : 0;
          (w !== d || v !== c) && (d = w, c = v, t()), this.doNextPolyfillTurn(g);
        }
      };
      return g(), () => h = !1;
    }, r = this.gos.get("suppressBrowserResizeObserver");
    return !!i.ResizeObserver && !r ? s() : this.getFrameworkOverrides().wrapIncoming(() => o(), "resize-observer");
  }
  doNextPolyfillTurn(e) {
    this.polyfillFunctions.push(e), this.schedulePolyfill();
  }
  schedulePolyfill() {
    if (this.polyfillScheduled)
      return;
    const e = () => {
      const t = this.polyfillFunctions;
      this.polyfillScheduled = !1, this.polyfillFunctions = [], t.forEach((i) => i());
    };
    this.polyfillScheduled = !0, window.setTimeout(e, Qf);
  }
};
Ul = u([
  O("resizeObserverService")
], Ul);
var Js = class extends F {
  constructor() {
    super(...arguments), this.createTasksP1 = { list: [], sorted: !1 }, this.createTasksP2 = { list: [], sorted: !1 }, this.destroyTasks = [], this.ticking = !1, this.scrollGoingDown = !0, this.lastPage = 0, this.lastScrollTop = 0, this.taskCount = 0, this.cancelledTasks = /* @__PURE__ */ new Set();
  }
  setScrollTop(e) {
    const t = this.gos.get("pagination");
    if (this.scrollGoingDown = e >= this.lastScrollTop, t && e === 0) {
      const i = this.paginationProxy.getCurrentPage();
      i !== this.lastPage && (this.lastPage = i, this.scrollGoingDown = !0);
    }
    this.lastScrollTop = e;
  }
  init() {
    this.useAnimationFrame = !this.gos.get("suppressAnimationFrame");
  }
  isOn() {
    return this.useAnimationFrame;
  }
  // this method is for our AG Grid sanity only - if animation frames are turned off,
  // then no place in the code should be looking to add any work to be done in animation
  // frames. this stops bugs - where some code is asking for a frame to be executed
  // when it should not.
  verifyAnimationFrameOn(e) {
    this.useAnimationFrame === !1 && console.warn(`AG Grid: AnimationFrameService.${e} called but animation frames are off`);
  }
  createTask(e, t, i) {
    this.verifyAnimationFrameOn(i);
    const s = { task: e, index: t, createOrder: ++this.taskCount };
    this.addTaskToList(this[i], s), this.schedule();
  }
  cancelTask(e) {
    this.cancelledTasks.add(e);
  }
  addTaskToList(e, t) {
    e.list.push(t), e.sorted = !1;
  }
  sortTaskList(e) {
    if (e.sorted)
      return;
    const t = this.scrollGoingDown ? 1 : -1;
    e.list.sort((i, s) => i.index !== s.index ? t * (s.index - i.index) : s.createOrder - i.createOrder), e.sorted = !0;
  }
  addDestroyTask(e) {
    this.verifyAnimationFrameOn("createTasksP3"), this.destroyTasks.push(e), this.schedule();
  }
  executeFrame(e) {
    this.verifyAnimationFrameOn("executeFrame");
    const t = this.createTasksP1, i = t.list, s = this.createTasksP2, o = s.list, r = this.destroyTasks, n = (/* @__PURE__ */ new Date()).getTime();
    let l = (/* @__PURE__ */ new Date()).getTime() - n;
    const a = e <= 0, d = this.ctrlsService.getGridBodyCtrl();
    for (; a || l < e; ) {
      if (!d.getScrollFeature().scrollGridIfNeeded()) {
        let h;
        if (i.length)
          this.sortTaskList(t), h = i.pop().task;
        else if (o.length)
          this.sortTaskList(s), h = o.pop().task;
        else if (r.length)
          h = r.pop();
        else {
          this.cancelledTasks.clear();
          break;
        }
        this.cancelledTasks.has(h) || h();
      }
      l = (/* @__PURE__ */ new Date()).getTime() - n;
    }
    i.length || o.length || r.length ? this.requestFrame() : this.stopTicking();
  }
  stopTicking() {
    this.ticking = !1;
  }
  flushAllFrames() {
    this.useAnimationFrame && this.executeFrame(-1);
  }
  schedule() {
    this.useAnimationFrame && (this.ticking || (this.ticking = !0, this.requestFrame()));
  }
  requestFrame() {
    const e = this.executeFrame.bind(this, 60);
    this.requestAnimationFrame(e);
  }
  requestAnimationFrame(e) {
    const t = this.gos.getWindow();
    t.requestAnimationFrame ? t.requestAnimationFrame(e) : t.webkitRequestAnimationFrame ? t.webkitRequestAnimationFrame(e) : t.setTimeout(e, 0);
  }
  isQueueEmpty() {
    return !this.ticking;
  }
  // a debounce utility used for parts of the app involved with rendering.
  // the advantage over normal debounce is the client can call flushAllFrames()
  // to make sure all rendering is complete. we don't wait any milliseconds,
  // as this is intended to batch calls in one VM turn.
  debounce(e) {
    let t = !1;
    return () => {
      if (!this.isOn()) {
        window.setTimeout(e, 0);
        return;
      }
      t || (t = !0, this.addDestroyTask(() => {
        t = !1, e();
      }));
    };
  }
};
u([
  f("ctrlsService")
], Js.prototype, "ctrlsService", 2);
u([
  f("paginationProxy")
], Js.prototype, "paginationProxy", 2);
u([
  L
], Js.prototype, "init", 1);
Js = u([
  O("animationFrameService")
], Js);
var Qo = class extends F {
  postConstruct() {
    this.isClientSideRowModel = this.rowModel.getType() === "clientSide";
  }
  expandRows(e) {
    if (!this.isClientSideRowModel)
      return;
    const t = new Set(e);
    this.rowModel.forEachNode((i) => {
      i.id && t.has(i.id) && (i.expanded = !0);
    }), this.onGroupExpandedOrCollapsed();
  }
  getExpandedRows() {
    const e = [];
    return this.rowModel.forEachNode(({ expanded: t, id: i }) => {
      t && i && e.push(i);
    }), e;
  }
  expandAll(e) {
    this.isClientSideRowModel && this.rowModel.expandOrCollapseAll(e);
  }
  setRowNodeExpanded(e, t, i, s) {
    e && (i && e.parent && e.parent.level !== -1 && this.setRowNodeExpanded(e.parent, t, i, s), e.setExpanded(t, void 0, s));
  }
  onGroupExpandedOrCollapsed() {
    this.isClientSideRowModel && this.rowModel.refreshModel({
      step: "map"
      /* MAP */
    });
  }
};
u([
  f("rowModel")
], Qo.prototype, "rowModel", 2);
u([
  L
], Qo.prototype, "postConstruct", 1);
Qo = u([
  O("expansionService")
], Qo);
var _t = class extends F {
  postConstruct() {
    var e;
    this.activeMenuFactory = (e = this.enterpriseMenuFactory) != null ? e : this.filterMenuFactory;
  }
  showColumnMenu(e) {
    this.showColumnMenuCommon(this.activeMenuFactory, e, "columnMenu");
  }
  showFilterMenu(e) {
    const t = this.enterpriseMenuFactory && this.isLegacyMenuEnabled() ? this.enterpriseMenuFactory : this.filterMenuFactory;
    this.showColumnMenuCommon(t, e, e.containerType, !0);
  }
  showHeaderContextMenu(e, t, i) {
    this.activeMenuFactory.showMenuAfterContextMenuEvent(e, t, i);
  }
  getContextMenuPosition(e, t) {
    const i = this.getRowCtrl(e), s = this.getCellGui(i, t);
    if (!s)
      return i ? { x: 0, y: i.getRowYPosition() } : { x: 0, y: 0 };
    const o = s.getBoundingClientRect();
    return {
      x: o.x + o.width / 2,
      y: o.y + o.height / 2
    };
  }
  showContextMenu(e) {
    var t, i, s;
    const { column: o, rowNode: r } = e;
    let { anchorToElement: n, value: l } = e;
    r && o && l == null && (l = r.getValueFromValueService(o)), n == null && (n = this.getContextMenuAnchorElement(r, o)), (s = this.contextMenuFactory) == null || s.onContextMenu(
      (t = e.mouseEvent) != null ? t : null,
      (i = e.touchEvent) != null ? i : null,
      r ?? null,
      o ?? null,
      l,
      n
    );
  }
  showColumnChooser(e) {
    var t;
    (t = this.columnChooserFactory) == null || t.showColumnChooser(e);
  }
  hidePopupMenu() {
    var e;
    (e = this.contextMenuFactory) == null || e.hideActiveMenu(), this.activeMenuFactory.hideActiveMenu();
  }
  hideColumnChooser() {
    var e;
    (e = this.columnChooserFactory) == null || e.hideActiveColumnChooser();
  }
  isColumnMenuInHeaderEnabled(e) {
    const { suppressMenu: t, suppressHeaderMenuButton: i } = e.getColDef();
    return !(i ?? t) && this.activeMenuFactory.isMenuEnabled(e) && (this.isLegacyMenuEnabled() || !!this.enterpriseMenuFactory);
  }
  isFilterMenuInHeaderEnabled(e) {
    return !e.getColDef().suppressHeaderFilterButton && this.filterManager.isFilterAllowed(e);
  }
  isHeaderContextMenuEnabled(e) {
    return !(e != null && e.getColDef().suppressHeaderContextMenu) && this.getColumnMenuType() === "new";
  }
  isHeaderMenuButtonAlwaysShowEnabled() {
    return this.isSuppressMenuHide();
  }
  isHeaderMenuButtonEnabled() {
    const e = !this.isSuppressMenuHide();
    return !(vi() && e);
  }
  isHeaderFilterButtonEnabled(e) {
    return this.isFilterMenuInHeaderEnabled(e) && !this.isLegacyMenuEnabled() && !this.isFloatingFilterButtonDisplayed(e);
  }
  isFilterMenuItemEnabled(e) {
    return this.filterManager.isFilterAllowed(e) && !this.isLegacyMenuEnabled() && !this.isFilterMenuInHeaderEnabled(e) && !this.isFloatingFilterButtonDisplayed(e);
  }
  isColumnMenuAnchoringEnabled() {
    return !this.isLegacyMenuEnabled();
  }
  areAdditionalColumnMenuItemsEnabled() {
    return this.getColumnMenuType() === "new";
  }
  isLegacyMenuEnabled() {
    return this.getColumnMenuType() === "legacy";
  }
  isFloatingFilterButtonEnabled(e) {
    var t;
    const i = e.getColDef(), s = (t = i.floatingFilterComponentParams) == null ? void 0 : t.suppressFilterButton;
    return s != null && H("As of v31.1, 'colDef.floatingFilterComponentParams.suppressFilterButton' is deprecated. Use 'colDef.suppressFloatingFilterButton' instead."), i.suppressFloatingFilterButton == null ? !s : !i.suppressFloatingFilterButton;
  }
  getColumnMenuType() {
    var e;
    return (e = this.gos.get("columnMenu")) != null ? e : "legacy";
  }
  isFloatingFilterButtonDisplayed(e) {
    return !!e.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(e);
  }
  isSuppressMenuHide() {
    const e = this.gos.get("suppressMenuHide");
    return this.isLegacyMenuEnabled() || this.gos.exists("suppressMenuHide") ? e : !0;
  }
  showColumnMenuCommon(e, t, i, s) {
    const { column: o, positionBy: r } = t;
    if (r === "button") {
      const { buttonElement: n } = t;
      e.showMenuAfterButtonClick(o, n, i, s);
    } else if (r === "mouse") {
      const { mouseEvent: n } = t;
      e.showMenuAfterMouseEvent(o, n, i, s);
    } else o && (this.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(o, "auto"), this.animationFrameService.requestAnimationFrame(() => {
      const n = this.ctrlsService.getHeaderRowContainerCtrl(o.getPinned()).getHeaderCtrlForColumn(o);
      e.showMenuAfterButtonClick(o, n.getAnchorElementForMenu(s), i, !0);
    }));
  }
  getRowCtrl(e) {
    const { rowIndex: t, rowPinned: i } = e || {};
    if (t != null)
      return this.rowRenderer.getRowByPosition({ rowIndex: t, rowPinned: i }) || void 0;
  }
  getCellGui(e, t) {
    if (!e || !t)
      return;
    const i = e.getCellCtrl(t);
    return (i == null ? void 0 : i.getGui()) || void 0;
  }
  getContextMenuAnchorElement(e, t) {
    const i = this.ctrlsService.getGridBodyCtrl().getGridBodyElement(), s = this.getRowCtrl(e);
    if (!s)
      return i;
    const o = this.getCellGui(s, t);
    return o || (s.isFullWidth() ? s.getFullWidthElement() : i);
  }
};
u([
  f("filterMenuFactory")
], _t.prototype, "filterMenuFactory", 2);
u([
  f("ctrlsService")
], _t.prototype, "ctrlsService", 2);
u([
  f("animationFrameService")
], _t.prototype, "animationFrameService", 2);
u([
  f("filterManager")
], _t.prototype, "filterManager", 2);
u([
  f("rowRenderer")
], _t.prototype, "rowRenderer", 2);
u([
  ue("columnChooserFactory")
], _t.prototype, "columnChooserFactory", 2);
u([
  ue("contextMenuFactory")
], _t.prototype, "contextMenuFactory", 2);
u([
  ue("enterpriseMenuFactory")
], _t.prototype, "enterpriseMenuFactory", 2);
u([
  L
], _t.prototype, "postConstruct", 1);
_t = u([
  O("menuService")
], _t);
var ps = class extends F {
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.centerRowContainerCtrl = e.center;
    });
  }
  // this is the trick: we create a dummy container and clone all the cells
  // into the dummy, then check the dummy's width. then destroy the dummy
  // as we don't need it any more.
  // drawback: only the cells visible on the screen are considered
  getPreferredWidthForColumn(e, t) {
    const i = this.getHeaderCellForColumn(e);
    if (!i)
      return -1;
    const s = this.rowRenderer.getAllCellsForColumn(e);
    return t || s.push(i), this.addElementsToContainerAndGetWidth(s);
  }
  getPreferredWidthForColumnGroup(e) {
    const t = this.getHeaderCellForColumn(e);
    return t ? this.addElementsToContainerAndGetWidth([t]) : -1;
  }
  addElementsToContainerAndGetWidth(e) {
    const t = document.createElement("form");
    t.style.position = "fixed";
    const i = this.centerRowContainerCtrl.getContainerElement();
    e.forEach((r) => this.cloneItemIntoDummy(r, t)), i.appendChild(t);
    const s = t.offsetWidth;
    i.removeChild(t);
    const o = this.getAutoSizePadding();
    return s + o;
  }
  getAutoSizePadding() {
    return this.gos.get("autoSizePadding");
  }
  getHeaderCellForColumn(e) {
    let t = null;
    return this.ctrlsService.getHeaderRowContainerCtrls().forEach(
      (i) => {
        const s = i.getHtmlElementForColumnHeader(e);
        s != null && (t = s);
      }
    ), t;
  }
  cloneItemIntoDummy(e, t) {
    const i = e.cloneNode(!0);
    i.style.width = "", i.style.position = "static", i.style.left = "";
    const s = document.createElement("div"), o = s.classList;
    ["ag-header-cell", "ag-header-group-cell"].some(
      (l) => i.classList.contains(l)
    ) ? (o.add("ag-header", "ag-header-row"), s.style.position = "static") : o.add("ag-row");
    let n = e.parentElement;
    for (; n; ) {
      if (["ag-header-row", "ag-row"].some(
        (a) => n.classList.contains(a)
      )) {
        for (let a = 0; a < n.classList.length; a++) {
          const d = n.classList[a];
          d != "ag-row-position-absolute" && o.add(d);
        }
        break;
      }
      n = n.parentElement;
    }
    s.appendChild(i), t.appendChild(s);
  }
};
u([
  f("rowRenderer")
], ps.prototype, "rowRenderer", 2);
u([
  f("ctrlsService")
], ps.prototype, "ctrlsService", 2);
u([
  f("rowCssClassCalculator")
], ps.prototype, "rowCssClassCalculator", 2);
u([
  L
], ps.prototype, "postConstruct", 1);
ps = u([
  O("autoWidthCalculator")
], ps);
var Dr = class extends F {
  constructor(e, t) {
    super(), this.createRowCon = e, this.destroyRowCtrls = t, this.stickyTopRowCtrls = [], this.stickyBottomRowCtrls = [], this.topContainerHeight = 0, this.bottomContainerHeight = 0;
  }
  postConstruct() {
    this.isClientSide = this.rowModel.getType() === "clientSide", this.ctrlsService.whenReady((e) => {
      this.gridBodyCtrl = e.gridBodyCtrl;
    });
  }
  getStickyTopRowCtrls() {
    return this.stickyTopRowCtrls;
  }
  getStickyBottomRowCtrls() {
    return this.stickyBottomRowCtrls;
  }
  /**
   * Get the last pixel of the group, this pixel is used to push the sticky node up out of the viewport.
   */
  getLastPixelOfGroup(e) {
    return this.isClientSide ? this.getClientSideLastPixelOfGroup(e) : this.getServerSideLastPixelOfGroup(e);
  }
  /**
   * Get the first pixel of the group, this pixel is used to push the sticky node down out of the viewport
   */
  getFirstPixelOfGroup(e) {
    return e.footer ? e.sibling.rowTop + e.sibling.rowHeight - 1 : e.hasChildren() ? e.rowTop - 1 : 0;
  }
  getServerSideLastPixelOfGroup(e) {
    var t, i, s, o;
    if (this.isClientSide)
      throw new Error("This func should only be called in server side row model.");
    if (e.isExpandable() || e.footer) {
      if (e.master)
        return e.detailNode.rowTop + e.detailNode.rowHeight;
      if (!e.sibling || Math.abs(e.sibling.rowIndex - e.rowIndex) === 1) {
        let n = (t = e.childStore) == null ? void 0 : t.getStoreBounds();
        return e.footer && (n = (i = e.sibling.childStore) == null ? void 0 : i.getStoreBounds()), ((s = n == null ? void 0 : n.heightPx) != null ? s : 0) + ((o = n == null ? void 0 : n.topPx) != null ? o : 0);
      }
      return e.footer ? e.rowTop + e.rowHeight : e.sibling.rowTop + e.sibling.rowHeight;
    }
    return Number.MAX_SAFE_INTEGER;
  }
  getClientSideLastPixelOfGroup(e) {
    if (!this.isClientSide)
      throw new Error("This func should only be called in client side row model.");
    if (e.isExpandable() || e.footer) {
      const t = e.footer && e.rowIndex === 0, i = !e.sibling || Math.abs(e.sibling.rowIndex - e.rowIndex) === 1;
      if (t || i) {
        let s = e.footer ? e.sibling : e;
        for (; s.isExpandable() && s.expanded; )
          if (s.master)
            s = s.detailNode;
          else if (s.childrenAfterSort) {
            if (s.childrenAfterSort.length === 0)
              break;
            s = se(s.childrenAfterSort);
          }
        return s.rowTop + s.rowHeight;
      }
      return e.footer ? e.rowTop + e.rowHeight : e.sibling.rowTop + e.sibling.rowHeight;
    }
    return Number.MAX_SAFE_INTEGER;
  }
  updateStickyRows(e) {
    const t = e === "top";
    let i = 0;
    if (!this.canRowsBeSticky())
      return this.refreshNodesAndContainerHeight(e, /* @__PURE__ */ new Set(), i);
    const s = t ? this.rowRenderer.getFirstVisibleVerticalPixel() : this.rowRenderer.getLastVisibleVerticalPixel(), o = /* @__PURE__ */ new Set(), r = (d) => {
      if (o.add(d), t) {
        const c = this.getLastPixelOfGroup(d), h = s + i + d.rowHeight;
        c < h ? d.stickyRowTop = i + (c - h) : d.stickyRowTop = i;
      } else {
        const c = this.getFirstPixelOfGroup(d), h = s - (i + d.rowHeight);
        c > h ? d.stickyRowTop = i - (c - h) : d.stickyRowTop = i;
      }
      i = 0, o.forEach((c) => {
        const h = c.stickyRowTop + c.rowHeight;
        i < h && (i = h);
      });
    }, n = this.areFooterRowsStickySuppressed(), l = this.gos.get("suppressGroupRowsSticky"), a = (d) => d.displayed ? d.footer ? n === !0 || n === "grand" && d.level === -1 || n === "group" && d.level > -1 ? !1 : !o.has(d) : d.isExpandable() ? l === !0 ? !1 : !o.has(d) && d.expanded : !1 : !1;
    for (let d = 0; d < 100; d++) {
      let c = s + i;
      t || (c = s - i);
      const h = this.rowModel.getRowIndexAtPixel(c), g = this.rowModel.getRow(h);
      if (g == null)
        break;
      const C = this.getStickyAncestors(g).find(
        (v) => (t ? v.rowIndex < h : v.rowIndex > h) && a(v)
      );
      if (C) {
        r(C);
        continue;
      }
      if ((t ? g.rowTop < c : g.rowTop + g.rowHeight > c) && a(g)) {
        r(g);
        continue;
      }
      break;
    }
    return t || o.forEach((d) => {
      d.stickyRowTop = i - (d.stickyRowTop + d.rowHeight);
    }), this.refreshNodesAndContainerHeight(e, o, i);
  }
  areFooterRowsStickySuppressed() {
    const e = this.gos.get("suppressStickyTotalRow");
    if (e === !0)
      return !0;
    const t = !!this.gos.get("groupIncludeFooter") || e === "group", i = !!this.gos.get("groupIncludeTotalFooter") || e === "grand";
    return t && i ? !0 : i ? "grand" : t ? "group" : !1;
  }
  canRowsBeSticky() {
    const e = this.gos.isGroupRowsSticky(), t = this.areFooterRowsStickySuppressed(), i = this.gos.get("suppressGroupRowsSticky");
    return e && (!t || !i);
  }
  getStickyAncestors(e) {
    const t = [];
    let i = e.footer ? e.sibling : e.parent;
    for (; i; )
      i.sibling && t.push(i.sibling), t.push(i), i = i.parent;
    return t.reverse();
  }
  checkStickyRows() {
    const e = this.updateStickyRows("top"), t = this.updateStickyRows("bottom");
    return e || t;
  }
  destroyStickyCtrls() {
    this.refreshNodesAndContainerHeight("top", /* @__PURE__ */ new Set(), 0), this.refreshNodesAndContainerHeight("bottom", /* @__PURE__ */ new Set(), 0);
  }
  refreshStickyNode(e) {
    const t = /* @__PURE__ */ new Set();
    if (this.stickyTopRowCtrls.some((i) => i.getRowNode() === e)) {
      for (let i = 0; i < this.stickyTopRowCtrls.length; i++) {
        const s = this.stickyTopRowCtrls[i].getRowNode();
        s !== e && t.add(s);
      }
      this.refreshNodesAndContainerHeight("top", t, this.topContainerHeight) && this.checkStickyRows();
      return;
    }
    for (let i = 0; i < this.stickyBottomRowCtrls.length; i++) {
      const s = this.stickyBottomRowCtrls[i].getRowNode();
      s !== e && t.add(s);
    }
    this.refreshNodesAndContainerHeight("bottom", t, this.bottomContainerHeight) && this.checkStickyRows();
  }
  /**
   * Destroy old ctrls and create new ctrls where necessary.
   */
  refreshNodesAndContainerHeight(e, t, i) {
    const s = e === "top", o = s ? this.stickyTopRowCtrls : this.stickyBottomRowCtrls, r = {}, n = [];
    for (let h = 0; h < o.length; h++) {
      const g = o[h].getRowNode();
      if (!t.has(g)) {
        r[g.id] = o[h], g.sticky = !1;
        continue;
      }
      n.push(o[h]);
    }
    const l = /* @__PURE__ */ new Set();
    for (let h = 0; h < n.length; h++)
      l.add(n[h].getRowNode());
    const a = [];
    t.forEach((h) => {
      l.has(h) || (h.sticky = !0, a.push(this.createRowCon(h, !1, !1)));
    });
    let d = !!a.length || n.length !== o.length;
    s ? this.topContainerHeight !== i && (this.topContainerHeight = i, this.gridBodyCtrl.setStickyTopHeight(i), d = !0) : this.bottomContainerHeight !== i && (this.bottomContainerHeight = i, this.gridBodyCtrl.setStickyBottomHeight(i), d = !0), this.destroyRowCtrls(r, !1);
    const c = [...n, ...a];
    return c.sort((h, g) => g.getRowNode().rowIndex - h.getRowNode().rowIndex), s || c.reverse(), c.forEach((h) => h.setRowTop(h.getRowNode().stickyRowTop)), d ? (s ? this.stickyTopRowCtrls = c : this.stickyBottomRowCtrls = c, !0) : !1;
  }
};
u([
  f("rowModel")
], Dr.prototype, "rowModel", 2);
u([
  f("rowRenderer")
], Dr.prototype, "rowRenderer", 2);
u([
  f("ctrlsService")
], Dr.prototype, "ctrlsService", 2);
u([
  L
], Dr.prototype, "postConstruct", 1);
var At = class extends F {
  constructor() {
    super(...arguments), this.destroyFuncsForColumnListeners = [], this.rowCtrlsByRowIndex = {}, this.zombieRowCtrls = {}, this.allRowCtrls = [], this.topRowCtrls = [], this.bottomRowCtrls = [], this.refreshInProgress = !1, this.dataFirstRenderedFired = !1, this.setupRangeSelectionListeners = () => {
      const e = () => {
        this.getAllCellCtrls().forEach((r) => r.onRangeSelectionChanged());
      }, t = () => {
        this.getAllCellCtrls().forEach((r) => r.updateRangeBordersIfRangeCount());
      }, i = () => {
        this.eventService.addEventListener(p.EVENT_RANGE_SELECTION_CHANGED, e), this.eventService.addEventListener(p.EVENT_COLUMN_MOVED, t), this.eventService.addEventListener(p.EVENT_COLUMN_PINNED, t), this.eventService.addEventListener(p.EVENT_COLUMN_VISIBLE, t);
      }, s = () => {
        this.eventService.removeEventListener(p.EVENT_RANGE_SELECTION_CHANGED, e), this.eventService.removeEventListener(p.EVENT_COLUMN_MOVED, t), this.eventService.removeEventListener(p.EVENT_COLUMN_PINNED, t), this.eventService.removeEventListener(p.EVENT_COLUMN_VISIBLE, t);
      };
      this.addDestroyFunc(() => s()), this.addManagedPropertyListener("enableRangeSelection", (r) => {
        r.currentValue ? i() : s();
      }), this.gos.get("enableRangeSelection") && i();
    };
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.initialise();
    });
  }
  initialise() {
    if (this.addManagedListener(this.eventService, p.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this)), this.addManagedListener(this.eventService, p.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_BODY_SCROLL, this.onBodyScroll.bind(this)), this.addManagedListener(this.eventService, p.EVENT_BODY_HEIGHT_CHANGED, this.redraw.bind(this)), this.addManagedPropertyListeners(["domLayout", "embedFullWidthRows"], () => this.onDomLayoutChanged()), this.addManagedPropertyListeners(["suppressMaxRenderedRowRestriction", "rowBuffer"], () => this.redraw()), this.addManagedPropertyListeners([
      "suppressCellFocus",
      "getBusinessKeyForNode",
      "fullWidthCellRenderer",
      "fullWidthCellRendererParams",
      "rowStyle",
      "getRowStyle",
      "rowClass",
      "getRowClass",
      "rowClassRules",
      "suppressStickyTotalRow",
      "groupRowRenderer",
      "groupRowRendererParams",
      // maybe only needs to refresh FW rows...
      "loadingCellRenderer",
      "loadingCellRendererParams",
      "detailCellRenderer",
      "detailCellRendererParams",
      "enableRangeSelection",
      "enableCellTextSelection"
    ], () => this.redrawRows()), this.gos.isGroupRowsSticky()) {
      const e = this.rowModel.getType();
      (e === "clientSide" || e === "serverSide") && (this.stickyRowFeature = this.createManagedBean(new Dr(
        this.createRowCon.bind(this),
        this.destroyRowCtrls.bind(this)
      )));
    }
    this.registerCellEventListeners(), this.initialiseCache(), this.printLayout = this.gos.isDomLayout("print"), this.embedFullWidthRows = this.printLayout || this.gos.get("embedFullWidthRows"), this.redrawAfterModelUpdate();
  }
  initialiseCache() {
    if (this.gos.get("keepDetailRows")) {
      const e = this.getKeepDetailRowsCount(), t = e ?? 3;
      this.cachedRowCtrls = new Xf(t);
    }
  }
  getKeepDetailRowsCount() {
    return this.gos.get("keepDetailRowsCount");
  }
  getStickyTopRowCtrls() {
    return this.stickyRowFeature ? this.stickyRowFeature.getStickyTopRowCtrls() : [];
  }
  getStickyBottomRowCtrls() {
    return this.stickyRowFeature ? this.stickyRowFeature.getStickyBottomRowCtrls() : [];
  }
  updateAllRowCtrls() {
    const e = Ii(this.rowCtrlsByRowIndex), t = Ii(this.zombieRowCtrls), i = this.cachedRowCtrls ? this.cachedRowCtrls.getEntries() : [];
    t.length > 0 || i.length > 0 ? this.allRowCtrls = [...e, ...t, ...i] : this.allRowCtrls = e;
  }
  onCellFocusChanged(e) {
    this.getAllCellCtrls().forEach((t) => t.onCellFocused(e)), this.getFullWidthRowCtrls().forEach((t) => t.onFullWidthRowFocused(e));
  }
  // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
  // registering and de-registering for events is a performance bottleneck. so we register here once and inform
  // all active cells.
  registerCellEventListeners() {
    this.addManagedListener(this.eventService, p.EVENT_CELL_FOCUSED, (e) => {
      this.onCellFocusChanged(e);
    }), this.addManagedListener(this.eventService, p.EVENT_CELL_FOCUS_CLEARED, () => {
      this.onCellFocusChanged();
    }), this.addManagedListener(this.eventService, p.EVENT_FLASH_CELLS, (e) => {
      this.getAllCellCtrls().forEach((t) => t.onFlashCells(e));
    }), this.addManagedListener(this.eventService, p.EVENT_COLUMN_HOVER_CHANGED, () => {
      this.getAllCellCtrls().forEach((e) => e.onColumnHover());
    }), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, () => {
      this.getAllCellCtrls().forEach((e) => e.onDisplayedColumnsChanged());
    }), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, () => {
      this.printLayout && this.getAllCellCtrls().forEach((e) => e.onLeftChanged());
    }), this.setupRangeSelectionListeners(), this.refreshListenersToColumnsForCellComps(), this.addManagedListener(this.eventService, p.EVENT_GRID_COLUMNS_CHANGED, this.refreshListenersToColumnsForCellComps.bind(this)), this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
  }
  // executes all functions in destroyFuncsForColumnListeners and then clears the list
  removeGridColumnListeners() {
    this.destroyFuncsForColumnListeners.forEach((e) => e()), this.destroyFuncsForColumnListeners.length = 0;
  }
  // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
  // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
  // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
  // once instead.
  refreshListenersToColumnsForCellComps() {
    this.removeGridColumnListeners(), this.columnModel.getAllGridColumns().forEach((t) => {
      const i = (a) => {
        this.getAllCellCtrls().forEach((d) => {
          d.getColumn() === t && a(d);
        });
      }, s = () => {
        i((a) => a.onLeftChanged());
      }, o = () => {
        i((a) => a.onWidthChanged());
      }, r = () => {
        i((a) => a.onFirstRightPinnedChanged());
      }, n = () => {
        i((a) => a.onLastLeftPinnedChanged());
      }, l = () => {
        i((a) => a.onColDefChanged());
      };
      t.addEventListener("leftChanged", s), t.addEventListener("widthChanged", o), t.addEventListener("firstRightPinnedChanged", r), t.addEventListener("lastLeftPinnedChanged", n), t.addEventListener("colDefChanged", l), this.destroyFuncsForColumnListeners.push(() => {
        t.removeEventListener("leftChanged", s), t.removeEventListener("widthChanged", o), t.removeEventListener("firstRightPinnedChanged", r), t.removeEventListener("lastLeftPinnedChanged", n), t.removeEventListener("colDefChanged", l);
      });
    });
  }
  onDomLayoutChanged() {
    const e = this.gos.isDomLayout("print"), t = e || this.gos.get("embedFullWidthRows"), i = t !== this.embedFullWidthRows || this.printLayout !== e;
    this.printLayout = e, this.embedFullWidthRows = t, i && this.redrawAfterModelUpdate({ domLayoutChanged: !0 });
  }
  // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
  // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
  datasourceChanged() {
    this.firstRenderedRow = 0, this.lastRenderedRow = -1;
    const e = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(e);
  }
  onPageLoaded(e) {
    const t = {
      recycleRows: e.keepRenderedRows,
      animate: e.animate,
      newData: e.newData,
      newPage: e.newPage,
      // because this is a model updated event (not pinned rows), we
      // can skip updating the pinned rows. this is needed so that if user
      // is doing transaction updates, the pinned rows are not getting constantly
      // trashed - or editing cells in pinned rows are not refreshed and put into read mode
      onlyBody: !0
    };
    this.redrawAfterModelUpdate(t);
  }
  getAllCellsForColumn(e) {
    const t = [];
    return this.getAllRowCtrls().forEach((i) => {
      const s = i.getCellElement(e);
      s && t.push(s);
    }), t;
  }
  refreshFloatingRowComps() {
    this.refreshFloatingRows(
      this.topRowCtrls,
      this.pinnedRowModel.getPinnedTopRowData()
    ), this.refreshFloatingRows(
      this.bottomRowCtrls,
      this.pinnedRowModel.getPinnedBottomRowData()
    );
  }
  getTopRowCtrls() {
    return this.topRowCtrls;
  }
  getCentreRowCtrls() {
    return this.allRowCtrls;
  }
  getBottomRowCtrls() {
    return this.bottomRowCtrls;
  }
  refreshFloatingRows(e, t) {
    e.forEach((i) => {
      i.destroyFirstPass(), i.destroySecondPass();
    }), e.length = 0, t && t.forEach((i) => {
      const s = new ls(
        i,
        this.beans,
        !1,
        !1,
        this.printLayout
      );
      e.push(s);
    });
  }
  onPinnedRowDataChanged() {
    const e = {
      recycleRows: !0
    };
    this.redrawAfterModelUpdate(e);
  }
  redrawRow(e, t = !1) {
    var i;
    if (e.sticky)
      this.stickyRowFeature.refreshStickyNode(e);
    else if ((i = this.cachedRowCtrls) != null && i.has(e)) {
      this.cachedRowCtrls.removeRow(e);
      return;
    } else {
      const s = (o) => {
        const r = o[e.rowIndex];
        r && r.getRowNode() === e && (r.destroyFirstPass(), r.destroySecondPass(), o[e.rowIndex] = this.createRowCon(e, !1, !1));
      };
      switch (e.rowPinned) {
        case "top":
          s(this.topRowCtrls);
          break;
        case "bottom":
          s(this.bottomRowCtrls);
          break;
        default:
          s(this.rowCtrlsByRowIndex), this.updateAllRowCtrls();
      }
    }
    t || this.dispatchDisplayedRowsChanged(!1);
  }
  redrawRows(e) {
    if (e != null) {
      e == null || e.forEach((i) => this.redrawRow(i, !0)), this.dispatchDisplayedRowsChanged(!1);
      return;
    }
    this.redrawAfterModelUpdate();
  }
  getCellToRestoreFocusToAfterRefresh(e) {
    const t = e != null && e.suppressKeepFocus ? null : this.focusService.getFocusCellToUseAfterRefresh();
    if (t == null)
      return null;
    const i = this.gos.getActiveDomElement(), s = this.gos.getDomData(i, ns.DOM_DATA_KEY_CELL_CTRL), o = this.gos.getDomData(i, ls.DOM_DATA_KEY_ROW_CTRL);
    return s || o ? t : null;
  }
  // gets called from:
  // +) initialisation (in registerGridComp) params = null
  // +) onDomLayoutChanged, params = null
  // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
  // +) onPinnedRowDataChanged, recycleRows = true
  // +) redrawRows (from Grid API), recycleRows = true/false
  redrawAfterModelUpdate(e = {}) {
    this.getLockOnRefresh();
    const t = this.getCellToRestoreFocusToAfterRefresh(e);
    this.updateContainerHeights(), this.scrollToTopIfNewData(e);
    const i = !e.domLayoutChanged && !!e.recycleRows, s = e.animate && this.gos.isAnimateRows(), o = i ? this.getRowsToRecycle() : null;
    i || this.removeAllRowComps(), this.workOutFirstAndLastRowsToRender(), this.stickyRowFeature && this.stickyRowFeature.checkStickyRows(), this.recycleRows(o, s), this.gridBodyCtrl.updateRowCount(), e.onlyBody || this.refreshFloatingRowComps(), this.dispatchDisplayedRowsChanged(), t != null && this.restoreFocusedCell(t), this.releaseLockOnRefresh();
  }
  scrollToTopIfNewData(e) {
    const t = e.newData || e.newPage, i = this.gos.get("suppressScrollOnNewData");
    t && !i && this.gridBodyCtrl.getScrollFeature().scrollToTop();
  }
  updateContainerHeights() {
    if (this.printLayout) {
      this.rowContainerHeightService.setModelHeight(null);
      return;
    }
    let e = this.paginationProxy.getCurrentPageHeight();
    e === 0 && (e = 1), this.rowContainerHeightService.setModelHeight(e);
  }
  getLockOnRefresh() {
    if (this.refreshInProgress)
      throw new Error(
        "AG Grid: cannot get grid to draw rows when it is in the middle of drawing rows. Your code probably called a grid API method while the grid was in the render stage. To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). To see what part of your code that caused the refresh check this stacktrace."
      );
    this.refreshInProgress = !0;
  }
  releaseLockOnRefresh() {
    this.refreshInProgress = !1;
  }
  isRefreshInProgress() {
    return this.refreshInProgress;
  }
  // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
  // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
  // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
  // edited cell).
  restoreFocusedCell(e) {
    e && (this.focusService.setRestoreFocusedCell(e), this.onCellFocusChanged(this.beans.gos.addGridCommonParams({
      rowIndex: e.rowIndex,
      column: e.column,
      rowPinned: e.rowPinned,
      forceBrowserFocus: !0,
      preventScrollOnBrowserFocus: !0,
      type: "mock"
    })));
  }
  stopEditing(e = !1) {
    this.getAllRowCtrls().forEach((t) => {
      t.stopEditing(e);
    });
  }
  getAllCellCtrls() {
    const e = [], t = this.getAllRowCtrls(), i = t.length;
    for (let s = 0; s < i; s++) {
      const o = t[s].getAllCellCtrls(), r = o.length;
      for (let n = 0; n < r; n++)
        e.push(o[n]);
    }
    return e;
  }
  getAllRowCtrls() {
    const e = this.stickyRowFeature && this.stickyRowFeature.getStickyTopRowCtrls() || [], t = this.stickyRowFeature && this.stickyRowFeature.getStickyBottomRowCtrls() || [], i = [...this.topRowCtrls, ...this.bottomRowCtrls, ...e, ...t];
    for (const s in this.rowCtrlsByRowIndex)
      i.push(this.rowCtrlsByRowIndex[s]);
    return i;
  }
  addRenderedRowListener(e, t, i) {
    const s = this.rowCtrlsByRowIndex[t];
    s && s.addEventListener(e, i);
  }
  flashCells(e = {}) {
    this.getCellCtrls(e.rowNodes, e.columns).forEach((t) => t.flashCell(e));
  }
  refreshCells(e = {}) {
    const t = {
      forceRefresh: e.force,
      newData: !1,
      suppressFlash: e.suppressFlash
    };
    this.getCellCtrls(e.rowNodes, e.columns).forEach((i) => i.refreshOrDestroyCell(t)), e.rowNodes && (this.getRowCtrls(e.rowNodes).forEach((i) => {
      if (!i.isFullWidth())
        return;
      i.refreshFullWidth() || this.redrawRow(i.getRowNode(), !0);
    }), this.dispatchDisplayedRowsChanged(!1));
  }
  getCellRendererInstances(e) {
    var t;
    const i = this.getCellCtrls(e.rowNodes, e.columns).map((r) => r.getCellRenderer()).filter((r) => r != null);
    if ((t = e.columns) != null && t.length)
      return i;
    const s = [], o = this.mapRowNodes(e.rowNodes);
    return this.getAllRowCtrls().forEach((r) => {
      if (o && !this.isRowInMap(r.getRowNode(), o) || !r.isFullWidth())
        return;
      const n = r.getFullWidthCellRenderers();
      for (let l = 0; l < n.length; l++) {
        const a = n[l];
        a != null && s.push(a);
      }
    }), [...s, ...i];
  }
  getCellEditorInstances(e) {
    const t = [];
    return this.getCellCtrls(e.rowNodes, e.columns).forEach((i) => {
      const s = i.getCellEditor();
      s && t.push(s);
    }), t;
  }
  getEditingCells() {
    const e = [];
    return this.getAllCellCtrls().forEach((t) => {
      if (t.isEditing()) {
        const i = t.getCellPosition();
        e.push(i);
      }
    }), e;
  }
  mapRowNodes(e) {
    if (!e)
      return;
    const t = {
      top: {},
      bottom: {},
      normal: {}
    };
    return e.forEach((i) => {
      const s = i.id;
      switch (i.rowPinned) {
        case "top":
          t.top[s] = i;
          break;
        case "bottom":
          t.bottom[s] = i;
          break;
        default:
          t.normal[s] = i;
          break;
      }
    }), t;
  }
  isRowInMap(e, t) {
    const i = e.id;
    switch (e.rowPinned) {
      case "top":
        return t.top[i] != null;
      case "bottom":
        return t.bottom[i] != null;
      default:
        return t.normal[i] != null;
    }
  }
  /**
   * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
   */
  getRowCtrls(e) {
    const t = this.mapRowNodes(e), i = this.getAllRowCtrls();
    return !e || !t ? i : i.filter((s) => {
      const o = s.getRowNode();
      return this.isRowInMap(o, t);
    });
  }
  // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
  // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
  getCellCtrls(e, t) {
    let i;
    b(t) && (i = {}, t.forEach((o) => {
      const r = this.columnModel.getGridColumn(o);
      b(r) && (i[r.getId()] = !0);
    }));
    const s = [];
    return this.getRowCtrls(e).forEach((o) => {
      o.getAllCellCtrls().forEach((r) => {
        const n = r.getColumn().getId();
        i && !i[n] || s.push(r);
      });
    }), s;
  }
  destroy() {
    this.removeAllRowComps(), super.destroy();
  }
  removeAllRowComps() {
    const e = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(e), this.stickyRowFeature && this.stickyRowFeature.destroyStickyCtrls();
  }
  getRowsToRecycle() {
    const e = [];
    tt(this.rowCtrlsByRowIndex, (i, s) => {
      s.getRowNode().id == null && e.push(i);
    }), this.removeRowCtrls(e);
    const t = {};
    return tt(this.rowCtrlsByRowIndex, (i, s) => {
      const o = s.getRowNode();
      t[o.id] = s;
    }), this.rowCtrlsByRowIndex = {}, t;
  }
  // takes array of row indexes
  removeRowCtrls(e, t = !1) {
    e.forEach((i) => {
      const s = this.rowCtrlsByRowIndex[i];
      s && (s.destroyFirstPass(t), s.destroySecondPass()), delete this.rowCtrlsByRowIndex[i];
    });
  }
  onBodyScroll(e) {
    e.direction === "vertical" && this.redraw({ afterScroll: !0 });
  }
  // gets called when rows don't change, but viewport does, so after:
  // 1) height of grid body changes, ie number of displayed rows has changed
  // 2) grid scrolled to new position
  // 3) ensure index visible (which is a scroll)
  redraw(e = {}) {
    const { afterScroll: t } = e;
    let i;
    this.stickyRowFeature && fa() && (i = this.getCellToRestoreFocusToAfterRefresh() || void 0);
    const s = this.firstRenderedRow, o = this.lastRenderedRow;
    this.workOutFirstAndLastRowsToRender();
    let r = !1;
    this.stickyRowFeature && (r = this.stickyRowFeature.checkStickyRows());
    const n = this.firstRenderedRow !== s || this.lastRenderedRow !== o;
    if (!(t && !r && !n) && (this.getLockOnRefresh(), this.recycleRows(null, !1, t), this.releaseLockOnRefresh(), this.dispatchDisplayedRowsChanged(t && !r), i != null)) {
      const l = this.getCellToRestoreFocusToAfterRefresh();
      i != null && l == null && (this.animationFrameService.flushAllFrames(), this.restoreFocusedCell(i));
    }
  }
  removeRowCompsNotToDraw(e, t) {
    const i = {};
    e.forEach((r) => i[r] = !0);
    const o = Object.keys(this.rowCtrlsByRowIndex).filter((r) => !i[r]);
    this.removeRowCtrls(o, t);
  }
  calculateIndexesToDraw(e) {
    let t = ac(this.firstRenderedRow, this.lastRenderedRow);
    const i = (o, r) => {
      const n = r.getRowNode().rowIndex;
      n != null && (n < this.firstRenderedRow || n > this.lastRenderedRow) && this.doNotUnVirtualiseRow(r) && t.push(n);
    };
    tt(this.rowCtrlsByRowIndex, i), tt(e, i), t.sort((o, r) => o - r);
    const s = [];
    for (let o = 0; o < t.length; o++) {
      const r = t[o], n = this.paginationProxy.getRow(r);
      n && !n.sticky && s.push(r);
    }
    return s;
  }
  recycleRows(e, t = !1, i = !1) {
    const s = this.calculateIndexesToDraw(e);
    (this.printLayout || i) && (t = !1), this.removeRowCompsNotToDraw(s, !t), s.forEach((o) => {
      this.createOrUpdateRowCtrl(o, e, t, i);
    }), e && (i && !this.gos.get("suppressAnimationFrame") && !this.printLayout ? this.beans.animationFrameService.addDestroyTask(() => {
      this.destroyRowCtrls(e, t), this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged();
    }) : this.destroyRowCtrls(e, t)), this.updateAllRowCtrls();
  }
  dispatchDisplayedRowsChanged(e = !1) {
    const t = { type: p.EVENT_DISPLAYED_ROWS_CHANGED, afterScroll: e };
    this.eventService.dispatchEvent(t);
  }
  onDisplayedColumnsChanged() {
    const e = this.columnModel.isPinningLeft(), t = this.columnModel.isPinningRight();
    (this.pinningLeft !== e || t !== this.pinningRight) && (this.pinningLeft = e, this.pinningRight = t, this.embedFullWidthRows && this.redrawFullWidthEmbeddedRows());
  }
  // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
  // then it should go into the pinned left area if pinning left, or the center area if not pinning.
  redrawFullWidthEmbeddedRows() {
    const e = [];
    this.getFullWidthRowCtrls().forEach((t) => {
      const i = t.getRowNode().rowIndex;
      e.push(i.toString());
    }), this.refreshFloatingRowComps(), this.removeRowCtrls(e), this.redraw({ afterScroll: !0 });
  }
  getFullWidthRowCtrls(e) {
    const t = this.mapRowNodes(e);
    return this.getAllRowCtrls().filter((i) => {
      if (!i.isFullWidth())
        return !1;
      const s = i.getRowNode();
      return !(t != null && !this.isRowInMap(s, t));
    });
  }
  createOrUpdateRowCtrl(e, t, i, s) {
    let o, r = this.rowCtrlsByRowIndex[e];
    if (r || (o = this.paginationProxy.getRow(e), b(o) && b(t) && t[o.id] && o.alreadyRendered && (r = t[o.id], t[o.id] = null)), !r)
      if (o || (o = this.paginationProxy.getRow(e)), b(o))
        r = this.createRowCon(o, i, s);
      else
        return;
    return o && (o.alreadyRendered = !0), this.rowCtrlsByRowIndex[e] = r, r;
  }
  destroyRowCtrls(e, t) {
    const i = [];
    tt(e, (s, o) => {
      if (o) {
        if (this.cachedRowCtrls && o.isCacheable()) {
          this.cachedRowCtrls.addRow(o);
          return;
        }
        o.destroyFirstPass(!t), t ? (this.zombieRowCtrls[o.getInstanceId()] = o, i.push(() => {
          o.destroySecondPass(), delete this.zombieRowCtrls[o.getInstanceId()];
        })) : o.destroySecondPass();
      }
    }), t && (i.push(() => {
      this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged();
    }), fu(i));
  }
  getRowBuffer() {
    return this.gos.get("rowBuffer");
  }
  getRowBufferInPixels() {
    const e = this.getRowBuffer(), t = this.gos.getRowHeightAsNumber();
    return e * t;
  }
  workOutFirstAndLastRowsToRender() {
    this.rowContainerHeightService.updateOffset();
    let e, t;
    if (!this.paginationProxy.isRowsToRender())
      e = 0, t = -1;
    else if (this.printLayout)
      this.environment.refreshRowHeightVariable(), e = this.paginationProxy.getPageFirstRow(), t = this.paginationProxy.getPageLastRow();
    else {
      const l = this.getRowBufferInPixels(), a = this.ctrlsService.getGridBodyCtrl(), d = this.gos.get("suppressRowVirtualisation");
      let c = !1, h, g;
      do {
        const y = this.paginationProxy.getPixelOffset(), { pageFirstPixel: E, pageLastPixel: D } = this.paginationProxy.getCurrentPagePixelRange(), R = this.rowContainerHeightService.getDivStretchOffset(), T = a.getScrollFeature().getVScrollPosition(), I = T.top, A = T.bottom;
        d ? (h = E + R, g = D + R) : (h = Math.max(I + y - l, E) + R, g = Math.min(A + y + l, D) + R), this.firstVisibleVPixel = Math.max(I + y, E) + R, this.lastVisibleVPixel = Math.min(A + y, D) + R, c = this.ensureAllRowsInRangeHaveHeightsCalculated(h, g);
      } while (c);
      let m = this.paginationProxy.getRowIndexAtPixel(h), C = this.paginationProxy.getRowIndexAtPixel(g);
      const w = this.paginationProxy.getPageFirstRow(), v = this.paginationProxy.getPageLastRow();
      m < w && (m = w), C > v && (C = v), e = m, t = C;
    }
    const i = this.gos.isDomLayout("normal"), s = this.gos.get("suppressMaxRenderedRowRestriction"), o = Math.max(this.getRowBuffer(), 500);
    i && !s && t - e > o && (t = e + o);
    const r = e !== this.firstRenderedRow, n = t !== this.lastRenderedRow;
    if (r || n) {
      this.firstRenderedRow = e, this.lastRenderedRow = t;
      const l = {
        type: p.EVENT_VIEWPORT_CHANGED,
        firstRow: e,
        lastRow: t
      };
      this.eventService.dispatchEvent(l);
    }
  }
  /**
   * This event will only be fired once, and is queued until after the browser next renders.
   * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
   * but not execute the event until all of the data has finished being rendered to the dom.
   */
  dispatchFirstDataRenderedEvent() {
    if (this.dataFirstRenderedFired)
      return;
    this.dataFirstRenderedFired = !0;
    const e = {
      type: p.EVENT_FIRST_DATA_RENDERED,
      firstRow: this.firstRenderedRow,
      lastRow: this.lastRenderedRow
    };
    window.requestAnimationFrame(() => {
      this.beans.eventService.dispatchEvent(e);
    });
  }
  ensureAllRowsInRangeHaveHeightsCalculated(e, t) {
    const i = this.paginationProxy.ensureRowHeightsValid(e, t, -1, -1);
    return i && this.updateContainerHeights(), i;
  }
  getFirstVisibleVerticalPixel() {
    return this.firstVisibleVPixel;
  }
  getLastVisibleVerticalPixel() {
    return this.lastVisibleVPixel;
  }
  getFirstVirtualRenderedRow() {
    return this.firstRenderedRow;
  }
  getLastVirtualRenderedRow() {
    return this.lastRenderedRow;
  }
  // check that none of the rows to remove are editing or focused as:
  // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
  //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
  //    the edit is reset - so we want to keep it rendered.
  // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
  //    otherwise the user can range select and drag (with focus cell going out of the viewport)
  //    and then ctrl+c, nothing will happen if cell is removed from dom.
  // c) if detail record of master detail, as users complained that the context of detail rows
  //    was getting lost when detail row out of view. eg user expands to show detail row,
  //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
  //    after detail panel is scrolled out of / into view.
  doNotUnVirtualiseRow(e) {
    const s = e.getRowNode(), o = this.focusService.isRowNodeFocused(s), r = e.isEditing(), n = s.detail;
    return o || r || n ? !!this.paginationProxy.isRowPresent(s) : !1;
  }
  createRowCon(e, t, i) {
    const s = this.cachedRowCtrls ? this.cachedRowCtrls.getRow(e) : null;
    if (s)
      return s;
    const o = this.gos.get("suppressAnimationFrame"), r = i && !o && !this.printLayout;
    return new ls(
      e,
      this.beans,
      t,
      r,
      this.printLayout
    );
  }
  getRenderedNodes() {
    const e = this.rowCtrlsByRowIndex;
    return Object.values(e).map((t) => t.getRowNode());
  }
  getRowByPosition(e) {
    let t;
    const { rowIndex: i } = e;
    switch (e.rowPinned) {
      case "top":
        t = this.topRowCtrls[i];
        break;
      case "bottom":
        t = this.bottomRowCtrls[i];
        break;
      default:
        t = this.rowCtrlsByRowIndex[i], t || (t = this.getStickyTopRowCtrls().find((s) => s.getRowNode().rowIndex === i) || null, t || (t = this.getStickyBottomRowCtrls().find((s) => s.getRowNode().rowIndex === i) || null));
        break;
    }
    return t;
  }
  // returns true if any row between startIndex and endIndex is rendered. used by
  // SSRM or IRM, as they don't want to purge visible blocks from cache.
  isRangeInRenderedViewport(e, t) {
    if (e == null || t == null)
      return !1;
    const s = e > this.lastRenderedRow;
    return !(t < this.firstRenderedRow) && !s;
  }
};
u([
  f("animationFrameService")
], At.prototype, "animationFrameService", 2);
u([
  f("paginationProxy")
], At.prototype, "paginationProxy", 2);
u([
  f("columnModel")
], At.prototype, "columnModel", 2);
u([
  f("pinnedRowModel")
], At.prototype, "pinnedRowModel", 2);
u([
  f("rowModel")
], At.prototype, "rowModel", 2);
u([
  f("focusService")
], At.prototype, "focusService", 2);
u([
  f("beans")
], At.prototype, "beans", 2);
u([
  f("rowContainerHeightService")
], At.prototype, "rowContainerHeightService", 2);
u([
  f("ctrlsService")
], At.prototype, "ctrlsService", 2);
u([
  L
], At.prototype, "postConstruct", 1);
At = u([
  O("rowRenderer")
], At);
var Xf = class {
  constructor(e) {
    this.entriesMap = {}, this.entriesList = [], this.maxCount = e;
  }
  addRow(e) {
    if (this.entriesMap[e.getRowNode().id] = e, this.entriesList.push(e), e.setCached(!0), this.entriesList.length > this.maxCount) {
      const t = this.entriesList[0];
      t.destroyFirstPass(), t.destroySecondPass(), this.removeFromCache(t);
    }
  }
  getRow(e) {
    if (e == null || e.id == null)
      return null;
    const t = this.entriesMap[e.id];
    return t ? (this.removeFromCache(t), t.setCached(!1), t.getRowNode() != e ? null : t) : null;
  }
  has(e) {
    return this.entriesMap[e.id] != null;
  }
  removeRow(e) {
    const t = e.id, i = this.entriesMap[t];
    delete this.entriesMap[t], gt(this.entriesList, i);
  }
  removeFromCache(e) {
    const t = e.getRowNode().id;
    delete this.entriesMap[t], gt(this.entriesList, e);
  }
  getEntries() {
    return this.entriesList;
  }
}, Xo = class extends F {
  init() {
    this.setPinnedTopRowData(), this.setPinnedBottomRowData(), this.addManagedPropertyListener("pinnedTopRowData", () => this.setPinnedTopRowData()), this.addManagedPropertyListener("pinnedBottomRowData", () => this.setPinnedBottomRowData());
  }
  isEmpty(e) {
    const t = e === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
    return It(t);
  }
  isRowsToRender(e) {
    return !this.isEmpty(e);
  }
  getRowAtPixel(e, t) {
    const i = t === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
    if (It(i))
      return 0;
    for (let s = 0; s < i.length; s++) {
      const o = i[s];
      if (o.rowTop + o.rowHeight - 1 >= e)
        return s;
    }
    return i.length - 1;
  }
  setPinnedTopRowData() {
    const e = this.gos.get("pinnedTopRowData");
    this.pinnedTopRows = this.createNodesFromData(e, !0);
    const t = {
      type: p.EVENT_PINNED_ROW_DATA_CHANGED
    };
    this.eventService.dispatchEvent(t);
  }
  setPinnedBottomRowData() {
    const e = this.gos.get("pinnedBottomRowData");
    this.pinnedBottomRows = this.createNodesFromData(e, !1);
    const t = {
      type: p.EVENT_PINNED_ROW_DATA_CHANGED
    };
    this.eventService.dispatchEvent(t);
  }
  createNodesFromData(e, t) {
    const i = [];
    if (e) {
      let s = 0;
      e.forEach((o, r) => {
        const n = new X(this.beans);
        n.data = o;
        const l = t ? X.ID_PREFIX_TOP_PINNED : X.ID_PREFIX_BOTTOM_PINNED;
        n.id = l + r, n.rowPinned = t ? "top" : "bottom", n.setRowTop(s), n.setRowHeight(this.gos.getRowHeightForNode(n).height), n.setRowIndex(r), s += n.rowHeight, i.push(n);
      });
    }
    return i;
  }
  getPinnedTopRowData() {
    return this.pinnedTopRows;
  }
  getPinnedBottomRowData() {
    return this.pinnedBottomRows;
  }
  getPinnedTopTotalHeight() {
    return this.getTotalHeight(this.pinnedTopRows);
  }
  getPinnedTopRowCount() {
    return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
  }
  getPinnedBottomRowCount() {
    return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
  }
  getPinnedTopRow(e) {
    return this.pinnedTopRows[e];
  }
  getPinnedBottomRow(e) {
    return this.pinnedBottomRows[e];
  }
  forEachPinnedTopRow(e) {
    It(this.pinnedTopRows) || this.pinnedTopRows.forEach(e);
  }
  forEachPinnedBottomRow(e) {
    It(this.pinnedBottomRows) || this.pinnedBottomRows.forEach(e);
  }
  getPinnedBottomTotalHeight() {
    return this.getTotalHeight(this.pinnedBottomRows);
  }
  getTotalHeight(e) {
    if (!e || e.length === 0)
      return 0;
    const t = se(e);
    return t.rowTop + t.rowHeight;
  }
};
u([
  f("beans")
], Xo.prototype, "beans", 2);
u([
  L
], Xo.prototype, "init", 1);
Xo = u([
  O("pinnedRowModel")
], Xo);
var qn = class {
  constructor(e, t) {
    this.active = !0, this.nodeIdsToColumns = {}, this.mapToItems = {}, this.keepingColumns = e, this.pathRoot = {
      rowNode: t,
      children: null
    }, this.mapToItems[t.id] = this.pathRoot;
  }
  // can be set inactive by:
  // a) ClientSideRowModel, if no transactions or
  // b) PivotService, if secondary columns changed
  setInactive() {
    this.active = !1;
  }
  isActive() {
    return this.active;
  }
  depthFirstSearchChangedPath(e, t) {
    if (e.children)
      for (let i = 0; i < e.children.length; i++)
        this.depthFirstSearchChangedPath(e.children[i], t);
    t(e.rowNode);
  }
  depthFirstSearchEverything(e, t, i) {
    if (e.childrenAfterGroup)
      for (let s = 0; s < e.childrenAfterGroup.length; s++) {
        const o = e.childrenAfterGroup[s];
        o.childrenAfterGroup ? this.depthFirstSearchEverything(e.childrenAfterGroup[s], t, i) : i && t(o);
      }
    t(e);
  }
  // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
  // will be called for child nodes in addition to parent nodes.
  forEachChangedNodeDepthFirst(e, t = !1, i = !1) {
    this.active && !i ? this.depthFirstSearchChangedPath(this.pathRoot, e) : this.depthFirstSearchEverything(this.pathRoot.rowNode, e, t);
  }
  executeFromRootNode(e) {
    e(this.pathRoot.rowNode);
  }
  createPathItems(e) {
    let t = e, i = 0;
    for (; !this.mapToItems[t.id]; ) {
      const s = {
        rowNode: t,
        children: null
      };
      this.mapToItems[t.id] = s, i++, t = t.parent;
    }
    return i;
  }
  populateColumnsMap(e, t) {
    if (!this.keepingColumns || !t)
      return;
    let i = e;
    for (; i; )
      this.nodeIdsToColumns[i.id] || (this.nodeIdsToColumns[i.id] = {}), t.forEach((s) => this.nodeIdsToColumns[i.id][s.getId()] = !0), i = i.parent;
  }
  linkPathItems(e, t) {
    let i = e;
    for (let s = 0; s < t; s++) {
      const o = this.mapToItems[i.id], r = this.mapToItems[i.parent.id];
      r.children || (r.children = []), r.children.push(o), i = i.parent;
    }
  }
  // called by
  // 1) change detection (provides cols) and
  // 2) groupStage if doing transaction update (doesn't provide cols)
  addParentNode(e, t) {
    if (!e || e.isRowPinned())
      return;
    const i = this.createPathItems(e);
    this.linkPathItems(e, i), this.populateColumnsMap(e, t);
  }
  canSkip(e) {
    return this.active && !this.mapToItems[e.id];
  }
  getValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return t;
    const i = this.nodeIdsToColumns[e.id];
    return t.filter((o) => i[o.getId()]);
  }
  getNotValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return null;
    const i = this.nodeIdsToColumns[e.id];
    return t.filter((o) => !i[o.getId()]);
  }
}, Co = class Qi extends F {
  constructor(t) {
    super(), this.state = Qi.STATE_WAITING_TO_LOAD, this.version = 0, this.id = t;
  }
  getId() {
    return this.id;
  }
  load() {
    this.state = Qi.STATE_LOADING, this.loadFromDatasource();
  }
  getVersion() {
    return this.version;
  }
  setStateWaitingToLoad() {
    this.version++, this.state = Qi.STATE_WAITING_TO_LOAD;
  }
  getState() {
    return this.state;
  }
  pageLoadFailed(t) {
    this.isRequestMostRecentAndLive(t) && (this.state = Qi.STATE_FAILED, this.processServerFail()), this.dispatchLoadCompleted(!1);
  }
  success(t, i) {
    this.successCommon(t, i);
  }
  pageLoaded(t, i, s) {
    this.successCommon(t, { rowData: i, rowCount: s });
  }
  isRequestMostRecentAndLive(t) {
    const i = t === this.version, s = this.isAlive();
    return i && s;
  }
  successCommon(t, i) {
    this.dispatchLoadCompleted(), this.isRequestMostRecentAndLive(t) && (this.state = Qi.STATE_LOADED, this.processServerResult(i));
  }
  dispatchLoadCompleted(t = !0) {
    const i = {
      type: Qi.EVENT_LOAD_COMPLETE,
      success: t,
      block: this
    };
    this.dispatchEvent(i);
  }
};
Co.EVENT_LOAD_COMPLETE = "loadComplete";
Co.STATE_WAITING_TO_LOAD = "needsLoading";
Co.STATE_LOADING = "loading";
Co.STATE_LOADED = "loaded";
Co.STATE_FAILED = "failed";
var zl = Co, ni = class extends F {
  constructor() {
    super(...arguments), this.activeBlockLoadsCount = 0, this.blocks = [], this.active = !0;
  }
  postConstruct() {
    this.maxConcurrentRequests = this.getMaxConcurrentDatasourceRequests();
    const e = this.gos.get("blockLoadDebounceMillis");
    e && e > 0 && (this.checkBlockToLoadDebounce = W.debounce(this.performCheckBlocksToLoad.bind(this), e));
  }
  setBeans(e) {
    this.logger = e.create("RowNodeBlockLoader");
  }
  getMaxConcurrentDatasourceRequests() {
    const e = this.gos.get("maxConcurrentDatasourceRequests");
    if (e == null)
      return 2;
    if (!(e <= 0))
      return e;
  }
  addBlock(e) {
    this.blocks.push(e), e.addEventListener(zl.EVENT_LOAD_COMPLETE, this.loadComplete.bind(this)), this.checkBlockToLoad();
  }
  removeBlock(e) {
    W.removeFromArray(this.blocks, e);
  }
  destroy() {
    super.destroy(), this.active = !1;
  }
  loadComplete() {
    this.activeBlockLoadsCount--, this.checkBlockToLoad(), this.dispatchEvent({ type: ni.BLOCK_LOADED_EVENT }), this.activeBlockLoadsCount == 0 && this.dispatchEvent({ type: ni.BLOCK_LOADER_FINISHED_EVENT });
  }
  checkBlockToLoad() {
    this.checkBlockToLoadDebounce ? this.checkBlockToLoadDebounce() : this.performCheckBlocksToLoad();
  }
  performCheckBlocksToLoad() {
    if (!this.active)
      return;
    if (this.printCacheStatus(), this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
      this.logger.log("checkBlockToLoad: max loads exceeded");
      return;
    }
    const e = this.getAvailableLoadingCount(), t = this.blocks.filter((i) => i.getState() === zl.STATE_WAITING_TO_LOAD).slice(0, e);
    this.registerLoads(t.length), t.forEach((i) => i.load()), this.printCacheStatus();
  }
  getBlockState() {
    if (this.gos.isRowModelType("serverSide"))
      return this.rowModel.getBlockStates();
    const e = {};
    return this.blocks.forEach((t) => {
      const { id: i, state: s } = t.getBlockStateJson();
      e[i] = s;
    }), e;
  }
  printCacheStatus() {
    this.logger.isLogging() && this.logger.log(`printCacheStatus: activePageLoadsCount = ${this.activeBlockLoadsCount}, blocks = ${JSON.stringify(this.getBlockState())}`);
  }
  isLoading() {
    return this.activeBlockLoadsCount > 0;
  }
  registerLoads(e) {
    this.activeBlockLoadsCount += e;
  }
  getAvailableLoadingCount() {
    return this.maxConcurrentRequests !== void 0 ? this.maxConcurrentRequests - this.activeBlockLoadsCount : void 0;
  }
};
ni.BLOCK_LOADED_EVENT = "blockLoaded";
ni.BLOCK_LOADER_FINISHED_EVENT = "blockLoaderFinished";
u([
  f("rowModel")
], ni.prototype, "rowModel", 2);
u([
  L
], ni.prototype, "postConstruct", 1);
u([
  Kt(0, Mt("loggerFactory"))
], ni.prototype, "setBeans", 1);
ni = u([
  O("rowNodeBlockLoader")
], ni);
var Zo = class extends F {
  constructor() {
    super(...arguments), this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = 0, this.pixelOffset = 0, this.masterRowCount = 0;
  }
  postConstruct() {
    this.active = this.gos.get("pagination"), this.pageSizeFromGridOptions = this.gos.get("paginationPageSize"), this.paginateChildRows = this.isPaginateChildRows(), this.addManagedListener(this.eventService, p.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this)), this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this)), this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this)), this.onModelUpdated();
  }
  ensureRowHeightsValid(e, t, i, s) {
    const o = this.rowModel.ensureRowHeightsValid(e, t, this.getPageFirstRow(), this.getPageLastRow());
    return o && this.calculatePages(), o;
  }
  isPaginateChildRows() {
    return this.gos.get("groupRemoveSingleChildren") || this.gos.get("groupRemoveLowestSingleChildren") ? !0 : this.gos.get("paginateChildRows");
  }
  onModelUpdated(e) {
    this.calculatePages();
    const t = {
      type: p.EVENT_PAGINATION_CHANGED,
      animate: e ? e.animate : !1,
      newData: e ? e.newData : !1,
      newPage: e ? e.newPage : !1,
      newPageSize: e ? e.newPageSize : !1,
      keepRenderedRows: e ? e.keepRenderedRows : !1
    };
    this.eventService.dispatchEvent(t);
  }
  onPaginationGridOptionChanged() {
    this.active = this.gos.get("pagination"), this.calculatePages();
    const e = {
      type: p.EVENT_PAGINATION_CHANGED,
      animate: !1,
      newData: !1,
      newPage: !1,
      newPageSize: !1,
      // important to keep rendered rows, otherwise every time grid is resized,
      // we would destroy all the rows.
      keepRenderedRows: !0
    };
    this.eventService.dispatchEvent(e);
  }
  onPageSizeGridOptionChanged() {
    this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
  }
  goToPage(e) {
    if (!this.active || this.currentPage === e || typeof this.currentPage != "number")
      return;
    this.currentPage = e, this.calculatePages();
    const t = {
      type: p.EVENT_PAGINATION_CHANGED,
      animate: !1,
      newData: !1,
      newPage: !0,
      newPageSize: !1,
      keepRenderedRows: !1
    };
    this.eventService.dispatchEvent(t);
  }
  getPixelOffset() {
    return this.pixelOffset;
  }
  getRow(e) {
    return this.rowModel.getRow(e);
  }
  getRowNode(e) {
    return this.rowModel.getRowNode(e);
  }
  getRowIndexAtPixel(e) {
    return this.rowModel.getRowIndexAtPixel(e);
  }
  getCurrentPageHeight() {
    return z(this.topRowBounds) || z(this.bottomRowBounds) ? 0 : Math.max(this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop, 0);
  }
  getCurrentPagePixelRange() {
    const e = this.topRowBounds ? this.topRowBounds.rowTop : 0, t = this.bottomRowBounds ? this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight : 0;
    return { pageFirstPixel: e, pageLastPixel: t };
  }
  isRowPresent(e) {
    return this.rowModel.isRowPresent(e) ? e.rowIndex >= this.topDisplayedRowIndex && e.rowIndex <= this.bottomDisplayedRowIndex : !1;
  }
  isEmpty() {
    return this.rowModel.isEmpty();
  }
  isRowsToRender() {
    return this.rowModel.isRowsToRender();
  }
  forEachNode(e) {
    return this.rowModel.forEachNode(e);
  }
  forEachNodeOnPage(e) {
    const t = this.getPageFirstRow(), i = this.getPageLastRow();
    for (let s = t; s <= i; s++) {
      const o = this.getRow(s);
      o && e(o);
    }
  }
  getType() {
    return this.rowModel.getType();
  }
  getRowBounds(e) {
    const t = this.rowModel.getRowBounds(e);
    return t.rowIndex = e, t;
  }
  getPageFirstRow() {
    return this.topRowBounds ? this.topRowBounds.rowIndex : -1;
  }
  getPageLastRow() {
    return this.bottomRowBounds ? this.bottomRowBounds.rowIndex : -1;
  }
  getRowCount() {
    return this.rowModel.getRowCount();
  }
  getPageForIndex(e) {
    return Math.floor(e / this.pageSize);
  }
  goToPageWithIndex(e) {
    if (!this.active)
      return;
    const t = this.getPageForIndex(e);
    this.goToPage(t);
  }
  isRowInPage(e) {
    return this.active ? this.getPageForIndex(e.rowIndex) === this.currentPage : !0;
  }
  isLastPageFound() {
    return this.rowModel.isLastRowIndexKnown();
  }
  getCurrentPage() {
    return this.currentPage;
  }
  goToNextPage() {
    this.goToPage(this.currentPage + 1);
  }
  goToPreviousPage() {
    this.goToPage(this.currentPage - 1);
  }
  goToFirstPage() {
    this.goToPage(0);
  }
  goToLastPage() {
    const e = this.rowModel.getRowCount(), t = Math.floor(e / this.pageSize);
    this.goToPage(t);
  }
  getPageSize() {
    return this.pageSize;
  }
  getTotalPages() {
    return this.totalPages;
  }
  /** This is only for state setting before data has been loaded */
  setPage(e) {
    this.currentPage = e;
  }
  get pageSize() {
    return b(this.pageSizeAutoCalculated) ? this.pageSizeAutoCalculated : b(this.pageSizeFromPageSizeSelector) ? this.pageSizeFromPageSizeSelector : b(this.pageSizeFromInitialState) ? this.pageSizeFromInitialState : b(this.pageSizeFromGridOptions) ? this.pageSizeFromGridOptions : this.defaultPageSize;
  }
  unsetAutoCalculatedPageSize() {
    if (this.pageSizeAutoCalculated === void 0)
      return;
    const e = this.pageSizeAutoCalculated;
    if (this.pageSizeAutoCalculated = void 0, this.pageSize === e)
      return;
    this.calculatePages();
    const t = {
      type: p.EVENT_PAGINATION_CHANGED,
      animate: !1,
      newData: !1,
      newPage: !1,
      newPageSize: !0,
      keepRenderedRows: !1
    };
    this.eventService.dispatchEvent(t);
  }
  setPageSize(e, t) {
    const i = this.pageSize;
    switch (t) {
      case "autoCalculated":
        this.pageSizeAutoCalculated = e;
        break;
      case "pageSizeSelector":
        this.pageSizeFromPageSizeSelector = e, this.currentPage !== 0 && this.goToFirstPage();
        break;
      case "initialState":
        this.pageSizeFromInitialState = e;
        break;
      case "gridOptions":
        this.pageSizeFromGridOptions = e, this.pageSizeFromInitialState = void 0, this.pageSizeFromPageSizeSelector = void 0, this.currentPage !== 0 && this.goToFirstPage();
        break;
    }
    if (i !== this.pageSize) {
      this.calculatePages();
      const s = {
        type: p.EVENT_PAGINATION_CHANGED,
        animate: !1,
        newData: !1,
        newPage: !1,
        newPageSize: !0,
        keepRenderedRows: !0
      };
      this.eventService.dispatchEvent(s);
    }
  }
  calculatePages() {
    this.active ? this.paginateChildRows ? this.calculatePagesAllRows() : this.calculatePagesMasterRowsOnly() : this.calculatedPagesNotActive(), this.topRowBounds = this.rowModel.getRowBounds(this.topDisplayedRowIndex), this.topRowBounds && (this.topRowBounds.rowIndex = this.topDisplayedRowIndex), this.bottomRowBounds = this.rowModel.getRowBounds(this.bottomDisplayedRowIndex), this.bottomRowBounds && (this.bottomRowBounds.rowIndex = this.bottomDisplayedRowIndex), this.setPixelOffset(b(this.topRowBounds) ? this.topRowBounds.rowTop : 0);
  }
  setPixelOffset(e) {
    this.pixelOffset !== e && (this.pixelOffset = e, this.eventService.dispatchEvent({ type: p.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED }));
  }
  setZeroRows() {
    this.masterRowCount = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = -1, this.currentPage = 0, this.totalPages = 0;
  }
  adjustCurrentPageIfInvalid() {
    this.currentPage >= this.totalPages && (this.currentPage = this.totalPages - 1), (!isFinite(this.currentPage) || isNaN(this.currentPage) || this.currentPage < 0) && (this.currentPage = 0);
  }
  calculatePagesMasterRowsOnly() {
    if (this.masterRowCount = this.rowModel.getTopLevelRowCount(), this.masterRowCount <= 0) {
      this.setZeroRows();
      return;
    }
    const e = this.masterRowCount - 1;
    this.totalPages = Math.floor(e / this.pageSize) + 1, this.adjustCurrentPageIfInvalid();
    const t = this.pageSize * this.currentPage;
    let i = this.pageSize * (this.currentPage + 1) - 1;
    if (i > e && (i = e), this.topDisplayedRowIndex = this.rowModel.getTopLevelRowDisplayedIndex(t), i === e)
      this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
    else {
      const s = this.rowModel.getTopLevelRowDisplayedIndex(i + 1);
      this.bottomDisplayedRowIndex = s - 1;
    }
  }
  getMasterRowCount() {
    return this.masterRowCount;
  }
  calculatePagesAllRows() {
    if (this.masterRowCount = this.rowModel.getRowCount(), this.masterRowCount === 0) {
      this.setZeroRows();
      return;
    }
    const e = this.masterRowCount - 1;
    this.totalPages = Math.floor(e / this.pageSize) + 1, this.adjustCurrentPageIfInvalid(), this.topDisplayedRowIndex = this.pageSize * this.currentPage, this.bottomDisplayedRowIndex = this.pageSize * (this.currentPage + 1) - 1, this.bottomDisplayedRowIndex > e && (this.bottomDisplayedRowIndex = e);
  }
  calculatedPagesNotActive() {
    this.setPageSize(void 0, "autoCalculated"), this.totalPages = 1, this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
  }
};
u([
  f("rowModel")
], Zo.prototype, "rowModel", 2);
u([
  L
], Zo.prototype, "postConstruct", 1);
Zo = u([
  O("paginationProxy")
], Zo);
var rn = class extends F {
  processAllCellClasses(e, t, i, s) {
    this.processClassRules(void 0, e.cellClassRules, t, i, s), this.processStaticCellClasses(e, t, i);
  }
  processClassRules(e, t, i, s, o) {
    if (t == null && e == null)
      return;
    const r = {}, n = {}, l = (a, d) => {
      a.split(" ").forEach((c) => {
        c.trim() != "" && d(c);
      });
    };
    if (t) {
      const a = Object.keys(t);
      for (let d = 0; d < a.length; d++) {
        const c = a[d], h = t[c];
        let g;
        typeof h == "string" ? g = this.expressionService.evaluate(h, i) : typeof h == "function" && (g = h(i)), l(c, (m) => {
          g ? r[m] = !0 : n[m] = !0;
        });
      }
    }
    e && o && Object.keys(e).forEach((a) => l(a, (d) => {
      r[d] || (n[d] = !0);
    })), o && Object.keys(n).forEach(o), Object.keys(r).forEach(s);
  }
  getStaticCellClasses(e, t) {
    const { cellClass: i } = e;
    if (!i)
      return [];
    let s;
    return typeof i == "function" ? s = i(t) : s = i, typeof s == "string" && (s = [s]), s || [];
  }
  processStaticCellClasses(e, t, i) {
    this.getStaticCellClasses(e, t).forEach((o) => {
      i(o);
    });
  }
};
u([
  f("expressionService")
], rn.prototype, "expressionService", 2);
rn = u([
  O("stylingService")
], rn);
var Mh = class extends Nn {
  constructor(e) {
    super(e, "ag-toggle-button");
  }
  setValue(e, t) {
    return super.setValue(e, t), this.addOrRemoveCssClass("ag-selected", this.getValue()), this;
  }
}, Zf = class extends jt {
  constructor(e) {
    super(e, "ag-text-area", null, "textarea");
  }
  setValue(e, t) {
    const i = super.setValue(e, t);
    return this.eInput.value = e, i;
  }
  setCols(e) {
    return this.eInput.cols = e, this;
  }
  setRows(e) {
    return this.eInput.rows = e, this;
  }
}, Jf = class extends Ts {
  constructor(e) {
    super(e, "ag-date-field", "date");
  }
  postConstruct() {
    super.postConstruct(), this.addManagedListener(this.eInput, "wheel", this.onWheel.bind(this));
    const e = ri();
    this.addManagedListener(this.eInput, "mousedown", () => {
      this.isDisabled() || e || this.eInput.focus();
    }), this.eInput.step = "any";
  }
  onWheel(e) {
    this.gos.getActiveDomElement() === this.eInput && e.preventDefault();
  }
  setMin(e) {
    var t;
    const i = e instanceof Date ? (t = Nt(e ?? null, !1)) != null ? t : void 0 : e;
    return this.min === i ? this : (this.min = i, oi(this.eInput, "min", i), this);
  }
  setMax(e) {
    var t;
    const i = e instanceof Date ? (t = Nt(e ?? null, !1)) != null ? t : void 0 : e;
    return this.max === i ? this : (this.max = i, oi(this.eInput, "max", i), this);
  }
  setStep(e) {
    return this.step === e ? this : (this.step = e, oi(this.eInput, "step", e), this);
  }
  getDate() {
    var e;
    if (this.eInput.validity.valid)
      return (e = mt(this.getValue())) != null ? e : void 0;
  }
  setDate(e, t) {
    this.setValue(Nt(e ?? null, !1), t);
  }
}, em = class extends jt {
  constructor(e) {
    super(e, "ag-range-field", "range");
  }
  postConstruct() {
    super.postConstruct();
    const { min: e, max: t, step: i } = this.config;
    e != null && this.setMinValue(e), t != null && this.setMaxValue(t), this.setStep(i || 1);
  }
  addInputListeners() {
    this.addManagedListener(this.eInput, "input", (e) => {
      const t = e.target.value;
      this.setValue(t);
    });
  }
  setMinValue(e) {
    return this.min = e, this.eInput.setAttribute("min", e.toString()), this;
  }
  setMaxValue(e) {
    return this.max = e, this.eInput.setAttribute("max", e.toString()), this;
  }
  setStep(e) {
    return this.eInput.setAttribute("step", e.toString()), this;
  }
  setValue(e, t) {
    this.min != null && (e = Math.max(parseFloat(e), this.min).toString()), this.max != null && (e = Math.min(parseFloat(e), this.max).toString());
    const i = super.setValue(e, t);
    return this.eInput.value = e, i;
  }
}, qa = class extends K {
  constructor(e, t) {
    super(
      /* html */
      '<div class="ag-rich-select-row" role="presentation"></div>'
    ), this.params = e, this.wrapperEl = t;
  }
  postConstruct() {
    this.addManagedListener(this.getGui(), "click", this.onClick.bind(this));
  }
  setState(e) {
    let t = "";
    this.params.valueFormatter && (t = this.params.valueFormatter(e)), this.populateWithRenderer(e, t) || this.populateWithoutRenderer(e, t), this.value = e;
  }
  highlightString(e) {
    const { parsedValue: t } = this;
    if (this.params.cellRenderer || !b(t))
      return;
    let i = b(e);
    if (i) {
      const s = t == null ? void 0 : t.toLocaleLowerCase().indexOf(e.toLocaleLowerCase());
      if (s >= 0) {
        const o = s + e.length, r = Oe(t.slice(0, s), !0), n = Oe(t.slice(s, o), !0), l = Oe(t.slice(o));
        this.renderValueWithoutRenderer(`${r}<span class="ag-rich-select-row-text-highlight">${n}</span>${l}`);
      } else
        i = !1;
    }
    i || this.renderValueWithoutRenderer(t);
  }
  updateHighlighted(e) {
    var t;
    const i = this.getGui(), s = `ag-rich-select-row-${this.getCompId()}`;
    if ((t = i.parentElement) == null || t.setAttribute("id", s), e) {
      const o = this.getParentComponent().getAriaElement();
      aa(o, s), this.wrapperEl.setAttribute("data-active-option", s);
    }
    qs(i.parentElement, e), this.addOrRemoveCssClass("ag-rich-select-row-selected", e);
  }
  populateWithoutRenderer(e, t) {
    const i = this.gos.getDocument(), s = this.getGui(), o = i.createElement("span");
    o.style.overflow = "hidden", o.style.textOverflow = "ellipsis";
    const r = Oe(b(t) ? t : e, !0);
    this.parsedValue = b(r) ? r : null, s.appendChild(o), this.renderValueWithoutRenderer(r), this.setTooltip({
      newTooltipText: this.parsedValue,
      shouldDisplayTooltip: () => o.scrollWidth > o.clientWidth
    });
  }
  renderValueWithoutRenderer(e) {
    const t = this.getGui().querySelector("span");
    t && (t.innerHTML = b(e) ? e : "&nbsp;");
  }
  populateWithRenderer(e, t) {
    let i, s;
    return this.params.cellRenderer && (s = this.userComponentFactory.getCellRendererDetails(this.params, {
      value: e,
      valueFormatted: t,
      setTooltip: (o, r) => {
        this.setTooltip({ newTooltipText: o, shouldDisplayTooltip: r });
      }
    })), s && (i = s.newAgStackInstance()), i && Aa(i, this.getGui()), i ? (i.then((o) => {
      this.addDestroyFunc(() => {
        this.getContext().destroyBean(o);
      });
    }), !0) : !1;
  }
  onClick() {
    const e = this.getParentComponent(), t = {
      type: p.EVENT_FIELD_PICKER_VALUE_SELECTED,
      fromEnterKey: !1,
      value: this.value
    };
    e == null || e.dispatchEvent(t);
  }
};
u([
  f("userComponentFactory")
], qa.prototype, "userComponentFactory", 2);
u([
  L
], qa.prototype, "postConstruct", 1);
var Tr = class xh extends Rr {
  constructor(t) {
    super(xh.getTemplate((t == null ? void 0 : t.cssIdentifier) || "default")), this.renderedRows = /* @__PURE__ */ new Map(), this.rowHeight = 20, this.pageSize = -1, this.isScrolling = !1, this.isHeightFromTheme = !0;
    const { cssIdentifier: i = "default", ariaRole: s = "listbox", listName: o } = t || {};
    this.cssIdentifier = i, this.ariaRole = s, this.listName = o;
  }
  postConstruct() {
    this.addScrollListener(), this.rowHeight = this.getItemHeight(), this.addResizeObserver(), this.initialiseTabGuard({
      onFocusIn: (t) => this.onFocusIn(t),
      onFocusOut: (t) => this.onFocusOut(t),
      focusInnerElement: (t) => this.focusInnerElement(t),
      onTabKeyDown: (t) => this.onTabKeyDown(t),
      handleKeyDown: (t) => this.handleKeyDown(t)
    }), this.setAriaProperties(), this.addManagedListener(this.eventService, p.EVENT_GRID_STYLES_CHANGED, this.onGridStylesChanged.bind(this));
  }
  onGridStylesChanged() {
    this.rowHeight = this.getItemHeight(), this.refresh();
  }
  setAriaProperties() {
    const i = this.localeService.getLocaleTextFunc()("ariaDefaultListName", this.listName || "List"), s = this.eContainer;
    Fe(s, this.ariaRole), bt(s, i);
  }
  addResizeObserver() {
    const t = () => this.animationFrameService.requestAnimationFrame(() => this.drawVirtualRows()), i = this.resizeObserverService.observeResize(this.getGui(), t);
    this.addDestroyFunc(i);
  }
  focusInnerElement(t) {
    this.focusRow(t ? this.model.getRowCount() - 1 : 0);
  }
  onFocusIn(t) {
    const i = t.target;
    i.classList.contains("ag-virtual-list-item") && (this.lastFocusedRowIndex = Wu(i) - 1);
  }
  onFocusOut(t) {
    this.getFocusableElement().contains(t.relatedTarget) || (this.lastFocusedRowIndex = null);
  }
  handleKeyDown(t) {
    switch (t.key) {
      case S.UP:
      case S.DOWN:
        this.navigate(t.key === S.UP) && t.preventDefault();
        break;
      case S.PAGE_HOME:
      case S.PAGE_END:
      case S.PAGE_UP:
      case S.PAGE_DOWN:
        this.navigateToPage(t.key) !== null && t.preventDefault();
        break;
    }
  }
  onTabKeyDown(t) {
    this.navigate(t.shiftKey) ? t.preventDefault() : (Qt(t), this.forceFocusOutOfContainer(t.shiftKey));
  }
  navigate(t) {
    if (this.lastFocusedRowIndex == null)
      return !1;
    const i = this.lastFocusedRowIndex + (t ? -1 : 1);
    return i < 0 || i >= this.model.getRowCount() ? !1 : (this.focusRow(i), !0);
  }
  navigateToPage(t, i = "focused") {
    let s = !1;
    i === "focused" && (i = this.getLastFocusedRow(), s = !0);
    const o = this.model.getRowCount() - 1;
    let r = -1;
    return t === S.PAGE_HOME ? r = 0 : t === S.PAGE_END ? r = o : t === S.PAGE_DOWN ? r = Math.min(i + this.pageSize, o) : t === S.PAGE_UP && (r = Math.max(i - this.pageSize, 0)), r === -1 ? null : (s ? this.focusRow(r) : this.ensureIndexVisible(r), r);
  }
  getLastFocusedRow() {
    return this.lastFocusedRowIndex;
  }
  focusRow(t) {
    this.isScrolling || (this.isScrolling = !0, this.ensureIndexVisible(t), this.animationFrameService.requestAnimationFrame(() => {
      if (this.isScrolling = !1, !this.isAlive())
        return;
      const i = this.renderedRows.get(t);
      i && i.eDiv.focus();
    }));
  }
  getComponentAt(t) {
    const i = this.renderedRows.get(t);
    return i && i.rowComponent;
  }
  forEachRenderedRow(t) {
    this.renderedRows.forEach((i, s) => t(i.rowComponent, s));
  }
  static getTemplate(t) {
    return (
      /* html */
      `<div class="ag-virtual-list-viewport ag-${t}-virtual-list-viewport" role="presentation">
                <div class="ag-virtual-list-container ag-${t}-virtual-list-container" ref="eContainer"></div>
            </div>`
    );
  }
  getItemHeight() {
    return this.isHeightFromTheme ? this.environment.getListItemHeight() : this.rowHeight;
  }
  /**
   * Returns true if the view had to be scrolled, otherwise, false.
   */
  ensureIndexVisible(t, i = !0) {
    const s = this.model.getRowCount();
    if (typeof t != "number" || t < 0 || t >= s)
      return console.warn("AG Grid: invalid row index for ensureIndexVisible: " + t), !1;
    const o = t * this.rowHeight, r = o + this.rowHeight, n = this.getGui(), l = n.scrollTop, a = n.offsetHeight, d = l + a, c = i ? 0 : this.rowHeight, h = l > o + c, g = d < r - c;
    if (h)
      return n.scrollTop = o, !0;
    if (g) {
      const m = r - a;
      return n.scrollTop = m, !0;
    }
    return !1;
  }
  setComponentCreator(t) {
    this.componentCreator = t;
  }
  setComponentUpdater(t) {
    this.componentUpdater = t;
  }
  getRowHeight() {
    return this.rowHeight;
  }
  getScrollTop() {
    return this.getGui().scrollTop;
  }
  setRowHeight(t) {
    this.isHeightFromTheme = !1, this.rowHeight = t, this.refresh();
  }
  refresh(t) {
    if (this.model == null || !this.isAlive())
      return;
    const i = this.model.getRowCount();
    this.eContainer.style.height = `${i * this.rowHeight}px`, ta(
      () => this.eContainer.clientHeight >= i * this.rowHeight,
      () => {
        this.isAlive() && (this.canSoftRefresh(t) ? this.drawVirtualRows(!0) : (this.clearVirtualRows(), this.drawVirtualRows()));
      }
    );
  }
  canSoftRefresh(t) {
    return !!(t && this.renderedRows.size && typeof this.model.areRowsEqual == "function" && this.componentUpdater);
  }
  clearVirtualRows() {
    this.renderedRows.forEach((t, i) => this.removeRow(i));
  }
  drawVirtualRows(t) {
    if (!this.isAlive() || !this.model)
      return;
    const i = this.getGui(), s = i.scrollTop, o = s + i.offsetHeight, r = Math.floor(s / this.rowHeight), n = Math.floor(o / this.rowHeight);
    this.pageSize = Math.floor((o - s) / this.rowHeight), this.ensureRowsRendered(r, n, t);
  }
  ensureRowsRendered(t, i, s) {
    this.renderedRows.forEach((o, r) => {
      (r < t || r > i) && r !== this.lastFocusedRowIndex && this.removeRow(r);
    }), s && this.refreshRows();
    for (let o = t; o <= i; o++)
      this.renderedRows.has(o) || o < this.model.getRowCount() && this.insertRow(o);
  }
  insertRow(t) {
    const i = this.model.getRow(t), s = document.createElement("div");
    s.classList.add("ag-virtual-list-item", `ag-${this.cssIdentifier}-virtual-list-item`), Fe(s, this.ariaRole === "tree" ? "treeitem" : "option"), Dn(s, this.model.getRowCount()), Tn(s, t + 1), s.setAttribute("tabindex", "-1"), s.style.height = `${this.rowHeight}px`, s.style.top = `${this.rowHeight * t}px`;
    const o = this.componentCreator(i, s);
    o.addGuiEventListener("focusin", () => this.lastFocusedRowIndex = t), s.appendChild(o.getGui()), this.renderedRows.has(t - 1) ? this.renderedRows.get(t - 1).eDiv.insertAdjacentElement("afterend", s) : this.renderedRows.has(t + 1) ? this.renderedRows.get(t + 1).eDiv.insertAdjacentElement("beforebegin", s) : this.eContainer.appendChild(s), this.renderedRows.set(t, { rowComponent: o, eDiv: s, value: i });
  }
  removeRow(t) {
    const i = this.renderedRows.get(t);
    this.eContainer.removeChild(i.eDiv), this.destroyBean(i.rowComponent), this.renderedRows.delete(t);
  }
  refreshRows() {
    const t = this.model.getRowCount();
    this.renderedRows.forEach((i, s) => {
      var o, r;
      if (s >= t)
        this.removeRow(s);
      else {
        const n = this.model.getRow(s);
        (r = (o = this.model).areRowsEqual) != null && r.call(o, i.value, n) ? this.componentUpdater(n, i.rowComponent) : this.removeRow(s);
      }
    });
  }
  addScrollListener() {
    this.addGuiEventListener("scroll", () => this.drawVirtualRows(), { passive: !0 });
  }
  setModel(t) {
    this.model = t;
  }
  getAriaElement() {
    return this.eContainer;
  }
  destroy() {
    this.isAlive() && (this.clearVirtualRows(), super.destroy());
  }
};
u([
  f("resizeObserverService")
], Tr.prototype, "resizeObserverService", 2);
u([
  f("animationFrameService")
], Tr.prototype, "animationFrameService", 2);
u([
  M("eContainer")
], Tr.prototype, "eContainer", 2);
u([
  L
], Tr.prototype, "postConstruct", 1);
var Nh = Tr, tm = (
  /* html */
  `
    <div class="ag-picker-field" role="presentation">
        <div ref="eLabel"></div>
            <div ref="eWrapper" class="ag-wrapper ag-picker-field-wrapper ag-rich-select-value ag-picker-collapsed">
            <div ref="eDisplayField" class="ag-picker-field-display"></div>
            <ag-input-text-field ref="eInput" class="ag-rich-select-field-input"></ag-input-text-field>
            <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
        </div>
    </div>`
), Qn = class extends Ds {
  constructor(e) {
    var t, i;
    super(Re(_({
      pickerAriaLabelKey: "ariaLabelRichSelectField",
      pickerAriaLabelValue: "Rich Select Field",
      pickerType: "ag-list",
      className: "ag-rich-select",
      pickerIcon: "smallDown",
      ariaRole: "combobox",
      template: (t = e == null ? void 0 : e.template) != null ? t : tm,
      modalPicker: !1
    }, e), {
      // maxPickerHeight needs to be set after expanding `config`
      maxPickerHeight: (i = e == null ? void 0 : e.maxPickerHeight) != null ? i : "calc(var(--ag-row-height) * 6.5)"
    })), this.searchString = "", this.highlightedItem = -1, this.lastRowHovered = -1, this.searchStringCreator = null;
    const { cellRowHeight: s, value: o, valueList: r, searchStringCreator: n } = e || {};
    s != null && (this.cellRowHeight = s), o !== void 0 && (this.value = o), r != null && (this.values = r), n && (this.searchStringCreator = n);
  }
  postConstruct() {
    super.postConstruct(), this.createLoadingElement(), this.createListComponent();
    const { allowTyping: e, placeholder: t } = this.config;
    e ? (this.eInput.setAutoComplete(!1).setInputPlaceholder(t), this.eDisplayField.classList.add("ag-hidden")) : this.eInput.setDisplayed(!1), this.eWrapper.tabIndex = this.gos.get("tabIndex");
    const { searchDebounceDelay: i = 300 } = this.config;
    this.clearSearchString = rt(this.clearSearchString, i), this.renderSelectedValue(), e && (this.eInput.onValueChange((s) => this.searchTextFromString(s)), this.addManagedListener(this.eWrapper, "focus", this.onWrapperFocus.bind(this))), this.addManagedListener(this.eWrapper, "focusout", this.onWrapperFocusOut.bind(this));
  }
  createLoadingElement() {
    const e = this.gos.getDocument(), t = this.localeService.getLocaleTextFunc(), i = e.createElement("div");
    i.classList.add("ag-loading-text"), i.innerText = t("loadingOoo", "Loading..."), this.eLoading = i;
  }
  createListComponent() {
    this.listComponent = this.createBean(new Nh({ cssIdentifier: "rich-select" })), this.listComponent.setComponentCreator(this.createRowComponent.bind(this));
    const e = (l, a) => {
    };
    this.listComponent.setComponentUpdater(e), this.listComponent.setParentComponent(this), this.addManagedListener(this.listComponent, p.EVENT_FIELD_PICKER_VALUE_SELECTED, (l) => {
      this.onListValueSelected(l.value, l.fromEnterKey);
    });
    const { cellRowHeight: t } = this;
    t && this.listComponent.setRowHeight(t);
    const i = this.listComponent.getGui(), s = this.listComponent.getAriaElement();
    this.addManagedListener(i, "mousemove", this.onPickerMouseMove.bind(this)), this.addManagedListener(i, "mousedown", (l) => l.preventDefault()), i.classList.add("ag-rich-select-list");
    const o = `ag-rich-select-list-${this.listComponent.getCompId()}`;
    s.setAttribute("id", o);
    const n = this.localeService.getLocaleTextFunc()(this.config.pickerAriaLabelKey, this.config.pickerAriaLabelValue);
    bt(s, n), ca(this.eWrapper, s);
  }
  renderSelectedValue() {
    const { value: e, eDisplayField: t, config: i } = this, { allowTyping: s, initialInputValue: o } = this.config, r = this.config.valueFormatter ? this.config.valueFormatter(e) : e;
    if (s) {
      this.eInput.setValue(o ?? r);
      return;
    }
    let n;
    i.cellRenderer && (n = this.userComponentFactory.getCellRendererDetails(this.config, {
      value: e,
      valueFormatted: r
    }));
    let l;
    if (n && (l = n.newAgStackInstance()), l)
      xe(t), Aa(l, t), l.then((a) => {
        this.addDestroyFunc(() => this.getContext().destroyBean(a));
      });
    else {
      if (b(this.value))
        t.innerText = r, t.classList.remove("ag-display-as-placeholder");
      else {
        const { placeholder: a } = i;
        b(a) ? (t.innerHTML = `${Oe(a)}`, t.classList.add("ag-display-as-placeholder")) : xe(t);
      }
      this.setTooltip({
        newTooltipText: r ?? null,
        shouldDisplayTooltip: () => this.eDisplayField.scrollWidth > this.eDisplayField.clientWidth
      });
    }
  }
  getCurrentValueIndex() {
    const { currentList: e, value: t } = this;
    if (t == null || !e)
      return -1;
    for (let i = 0; i < e.length; i++)
      if (e[i] === t)
        return i;
    return -1;
  }
  highlightFilterMatch() {
    var e;
    (e = this.listComponent) == null || e.forEachRenderedRow((t, i) => {
      t.highlightString(this.searchString);
    });
  }
  highlightSelectedValue(e) {
    var t;
    e == null && (e = this.getCurrentValueIndex()), this.highlightedItem = e, (t = this.listComponent) == null || t.forEachRenderedRow((i, s) => {
      const o = e === -1 ? !1 : this.highlightedItem === s;
      i.updateHighlighted(o);
    });
  }
  setRowHeight(e) {
    e !== this.cellRowHeight && (this.cellRowHeight = e), this.listComponent && this.listComponent.setRowHeight(e);
  }
  createPickerComponent() {
    const { values: e } = this;
    return e && this.setValueList({ valueList: e }), this.listComponent;
  }
  setSearchStringCreator(e) {
    this.searchStringCreator = e;
  }
  setValueList(e) {
    const { valueList: t, refresh: i } = e;
    this.listComponent && this.currentList !== t && (this.currentList = t, this.listComponent.setModel({
      getRowCount: () => t.length,
      getRow: (s) => t[s],
      areRowsEqual: (s, o) => s === o
    }), i && (this.values ? this.listComponent.refresh(!0) : (this.values = t, this.isPickerDisplayed && this.showCurrentValueInPicker())));
  }
  showPicker() {
    super.showPicker(), this.showCurrentValueInPicker(), this.displayOrHidePicker();
  }
  showCurrentValueInPicker() {
    var e, t;
    if (!this.listComponent)
      return;
    if (!this.currentList) {
      this.isPickerDisplayed && this.eLoading && this.listComponent.appendChild(this.eLoading);
      return;
    }
    (e = this.eLoading) != null && e.offsetParent && ((t = this.eLoading.parentElement) == null || t.removeChild(this.eLoading));
    const i = this.getCurrentValueIndex();
    i !== -1 ? (this.listComponent.refresh(), this.listComponent.ensureIndexVisible(i), this.listComponent.refresh(!0), this.highlightSelectedValue(i)) : this.listComponent.refresh();
  }
  beforeHidePicker() {
    this.highlightedItem = -1, super.beforeHidePicker();
  }
  onWrapperFocus() {
    if (!this.eInput)
      return;
    const e = this.eInput.getFocusableElement();
    e.focus(), e.select();
  }
  onWrapperFocusOut(e) {
    this.eWrapper.contains(e.relatedTarget) || this.hidePicker();
  }
  buildSearchStringFromKeyboardEvent(e) {
    let { key: t } = e;
    if (t === S.BACKSPACE)
      this.searchString = this.searchString.slice(0, -1), t = "";
    else if (!Fn(e))
      return;
    e.preventDefault(), this.searchTextFromCharacter(t);
  }
  searchTextFromCharacter(e) {
    this.searchString += e, this.runSearch(), this.clearSearchString();
  }
  searchTextFromString(e) {
    e == null && (e = ""), this.searchString = e, this.runSearch();
  }
  buildSearchStrings(e) {
    const { valueFormatter: t = (s) => s } = this.config;
    let i;
    return typeof e[0] == "number" || typeof e[0] == "string" ? i = e.map((s) => t(s)) : typeof e[0] == "object" && this.searchStringCreator && (i = this.searchStringCreator(e)), i;
  }
  getSuggestionsAndFilteredValues(e, t) {
    let i = [], s = [];
    if (!e.length)
      return { suggestions: i, filteredValues: s };
    const { searchType: o = "fuzzy", filterList: r } = this.config;
    if (o === "fuzzy") {
      const n = gr(this.searchString, t, !0);
      i = n.values;
      const l = n.indices;
      if (r && l.length)
        for (let a = 0; a < l.length; a++)
          s.push(this.values[l[a]]);
    } else
      i = t.filter((n, l) => {
        const a = n.toLocaleLowerCase(), d = this.searchString.toLocaleLowerCase(), c = o === "match" ? a.startsWith(d) : a.indexOf(d) !== -1;
        return r && c && s.push(this.values[l]), c;
      });
    return { suggestions: i, filteredValues: s };
  }
  filterListModel(e) {
    const { filterList: t } = this.config;
    t && (this.setValueList({ valueList: e, refresh: !0 }), this.alignPickerToComponent());
  }
  runSearch() {
    var e, t;
    const { values: i } = this, s = this.buildSearchStrings(i);
    if (!s) {
      this.highlightSelectedValue(-1);
      return;
    }
    const { suggestions: o, filteredValues: r } = this.getSuggestionsAndFilteredValues(this.searchString, s), { filterList: n, highlightMatch: l, searchType: a = "fuzzy" } = this.config, d = r.length, c = !!(n && this.searchString !== "");
    if (this.filterListModel(c ? r : i), o.length) {
      const h = c ? 0 : s.indexOf(o[0]);
      this.selectListItem(h);
    } else if (this.highlightSelectedValue(-1), !c || d)
      (e = this.listComponent) == null || e.ensureIndexVisible(0);
    else if (c) {
      this.getAriaElement().removeAttribute("data-active-option");
      const h = (t = this.listComponent) == null ? void 0 : t.getAriaElement();
      h && aa(h, null);
    }
    l && a !== "fuzzy" && this.highlightFilterMatch(), this.displayOrHidePicker();
  }
  displayOrHidePicker() {
    var e;
    const t = (e = this.listComponent) == null ? void 0 : e.getGui(), i = this.currentList ? this.currentList.length === 0 : !1;
    t == null || t.classList.toggle("ag-hidden", i);
  }
  clearSearchString() {
    this.searchString = "";
  }
  selectListItem(e, t) {
    if (!this.isPickerDisplayed || !this.currentList || !this.listComponent || e < 0 || e >= this.currentList.length)
      return;
    this.listComponent.ensureIndexVisible(e, !t) && !t && this.listComponent.refresh(!0), this.highlightSelectedValue(e);
  }
  setValue(e, t, i) {
    const s = this.currentList ? this.currentList.indexOf(e) : -1;
    return s === -1 ? this : (this.value = e, i || this.selectListItem(s), this.renderSelectedValue(), super.setValue(e, t));
  }
  createRowComponent(e) {
    const t = new qa(this.config, this.eWrapper);
    t.setParentComponent(this.listComponent), this.getContext().createBean(t), t.setState(e);
    const { highlightMatch: i, searchType: s = "fuzzy" } = this.config;
    return i && s !== "fuzzy" && t.highlightString(this.searchString), t;
  }
  getRowForMouseEvent(e) {
    const { listComponent: t } = this;
    if (!t)
      return -1;
    const s = (t == null ? void 0 : t.getGui()).getBoundingClientRect(), o = t.getScrollTop(), r = e.clientY - s.top + o;
    return Math.floor(r / t.getRowHeight());
  }
  onPickerMouseMove(e) {
    if (!this.listComponent)
      return;
    const t = this.getRowForMouseEvent(e);
    t !== -1 && t != this.lastRowHovered && (this.lastRowHovered = t, this.selectListItem(t, !0));
  }
  onNavigationKeyDown(e, t) {
    e.preventDefault();
    const i = t === S.DOWN;
    if (!this.isPickerDisplayed && i) {
      this.showPicker();
      return;
    }
    const s = this.highlightedItem, r = s === -1 ? 0 : s + (i ? 1 : -1);
    this.selectListItem(r);
  }
  onPageNavigation(e) {
    var t;
    if (!this.isPickerDisplayed)
      return;
    const i = (t = this.listComponent) == null ? void 0 : t.navigateToPage(e, this.highlightedItem);
    i != null && this.animationFrameService.requestAnimationFrame(() => {
      if (!this.isAlive())
        return null;
      this.highlightSelectedValue(i);
    });
  }
  onEnterKeyDown(e) {
    this.isPickerDisplayed && (e.preventDefault(), this.currentList && this.onListValueSelected(this.currentList[this.highlightedItem], !0));
  }
  onTabKeyDown() {
    !this.isPickerDisplayed || !this.currentList || this.setValue(this.currentList[this.highlightedItem], !1, !0);
  }
  onListValueSelected(e, t) {
    this.setValue(e, !1, !0), this.dispatchPickerEvent(e, t), this.hidePicker();
  }
  dispatchPickerEvent(e, t) {
    const i = {
      type: p.EVENT_FIELD_PICKER_VALUE_SELECTED,
      fromEnterKey: t,
      value: e
    };
    this.dispatchEvent(i);
  }
  getFocusableElement() {
    const { allowTyping: e } = this.config;
    return e ? this.eInput.getFocusableElement() : super.getFocusableElement();
  }
  onKeyDown(e) {
    const t = e.key, { allowTyping: i } = this.config;
    switch (t) {
      case S.LEFT:
      case S.RIGHT:
        i || e.preventDefault();
        break;
      case S.PAGE_HOME:
      case S.PAGE_END:
        if (i) {
          e.preventDefault();
          const s = this.eInput.getInputElement(), o = t === S.PAGE_HOME ? 0 : s.value.length;
          s.setSelectionRange(o, o);
          break;
        }
      case S.PAGE_UP:
      case S.PAGE_DOWN:
        e.preventDefault(), this.onPageNavigation(t);
        break;
      case S.DOWN:
      case S.UP:
        this.onNavigationKeyDown(e, t);
        break;
      case S.ESCAPE:
        this.isPickerDisplayed && (wt(this.listComponent.getGui()) && (e.preventDefault(), Qt(e)), this.hidePicker());
        break;
      case S.ENTER:
        this.onEnterKeyDown(e);
        break;
      case S.TAB:
        this.onTabKeyDown();
        break;
      default:
        i || this.buildSearchStringFromKeyboardEvent(e);
    }
  }
  destroy() {
    this.listComponent && (this.destroyBean(this.listComponent), this.listComponent = void 0), this.eLoading = void 0, super.destroy();
  }
};
u([
  f("userComponentFactory")
], Qn.prototype, "userComponentFactory", 2);
u([
  f("animationFrameService")
], Qn.prototype, "animationFrameService", 2);
u([
  M("eInput")
], Qn.prototype, "eInput", 2);
var vo = class Gh extends Ia {
  constructor(t) {
    super(t, Gh.TEMPLATE), this.labelAlignment = "top";
  }
  init() {
    this.eSlider.addCssClass("ag-slider-field");
    const { minValue: t, maxValue: i, textFieldWidth: s, step: o, value: r, onValueChange: n } = this.config;
    t != null && this.setMinValue(t), i != null && this.setMaxValue(i), s != null && this.setTextFieldWidth(s), o != null && this.setStep(o), r != null && this.setValue(r), n != null && this.onValueChange(n);
  }
  onValueChange(t) {
    const i = p.EVENT_FIELD_VALUE_CHANGED;
    return this.addManagedListener(this.eText, i, () => {
      const s = parseFloat(this.eText.getValue());
      this.eSlider.setValue(s.toString(), !0), t(s || 0);
    }), this.addManagedListener(this.eSlider, i, () => {
      const s = this.eSlider.getValue();
      this.eText.setValue(s, !0), t(parseFloat(s));
    }), this;
  }
  setSliderWidth(t) {
    return this.eSlider.setWidth(t), this;
  }
  setTextFieldWidth(t) {
    return this.eText.setWidth(t), this;
  }
  setMinValue(t) {
    return this.eSlider.setMinValue(t), this.eText.setMin(t), this;
  }
  setMaxValue(t) {
    return this.eSlider.setMaxValue(t), this.eText.setMax(t), this;
  }
  getValue() {
    return this.eText.getValue();
  }
  setValue(t, i) {
    return this.getValue() === t ? this : (this.eText.setValue(t, !0), this.eSlider.setValue(t, !0), i || this.dispatchEvent({ type: p.EVENT_FIELD_VALUE_CHANGED }), this);
  }
  setStep(t) {
    return this.eSlider.setStep(t), this.eText.setStep(t), this;
  }
};
vo.TEMPLATE = /* html */
`<div class="ag-slider">
            <label ref="eLabel"></label>
            <div class="ag-wrapper ag-slider-wrapper">
                <ag-input-range ref="eSlider"></ag-input-range>
                <ag-input-number-field ref="eText"></ag-input-number-field>
            </div>
        </div>`;
u([
  M("eLabel")
], vo.prototype, "eLabel", 2);
u([
  M("eSlider")
], vo.prototype, "eSlider", 2);
u([
  M("eText")
], vo.prototype, "eText", 2);
u([
  L
], vo.prototype, "init", 1);
var im = vo, Wi = class Hs extends K {
  constructor(t = {}) {
    super(Hs.getTemplate(t)), this.params = t, this.suppressEnabledCheckbox = !0, this.suppressToggleExpandOnEnableChange = !1;
    const {
      enabled: i,
      items: s,
      suppressEnabledCheckbox: o,
      expanded: r,
      suppressToggleExpandOnEnableChange: n,
      useToggle: l
    } = t;
    this.cssIdentifier = t.cssIdentifier || "default", this.enabled = i ?? !0, this.items = s || [], this.useToggle = l ?? !1, this.alignItems = t.alignItems || "center", this.expanded = r ?? !0, o != null && (this.suppressEnabledCheckbox = o), n != null && (this.suppressToggleExpandOnEnableChange = n);
  }
  static getTemplate(t) {
    const i = t.cssIdentifier || "default", s = t.direction || "vertical";
    return (
      /* html */
      `
            <div class="ag-group ag-${i}-group" role="presentation">
                <div ref="eToolbar" class="ag-group-toolbar ag-${i}-group-toolbar">
                    <ag-checkbox ref="cbGroupEnabled"></ag-checkbox>
                </div>
                <div ref="eContainer" class="ag-group-container ag-group-container-${s} ag-${i}-group-container"></div>
            </div>
        `
    );
  }
  postConstruct() {
    if (this.setupTitleBar(), this.items.length) {
      const o = this.items;
      this.items = [], this.addItems(o);
    }
    const t = this.localeService.getLocaleTextFunc();
    this.cbGroupEnabled.setLabel(t("enabled", "Enabled")), this.enabled && this.setEnabled(this.enabled, void 0, !0), this.setAlignItems(this.alignItems);
    const { onEnableChange: i, suppressOpenCloseIcons: s } = this.params;
    this.hideEnabledCheckbox(this.suppressEnabledCheckbox), this.hideOpenCloseIcons(s ?? !1), this.refreshChildDisplay(), te(this.eContainer, this.expanded), this.cbGroupEnabled.onValueChange((o) => {
      this.setEnabled(o, !0, this.suppressToggleExpandOnEnableChange), this.dispatchEnableChangeEvent(o);
    }), i != null && this.onEnableChange(i);
  }
  refreshChildDisplay() {
    var t;
    te(this.eToolbar, this.expanded && !this.suppressEnabledCheckbox), (t = this.eTitleBar) == null || t.refreshOnExpand(this.expanded);
  }
  isExpanded() {
    return this.expanded;
  }
  setAlignItems(t) {
    this.alignItems !== t && this.removeCssClass(`ag-group-item-alignment-${this.alignItems}`), this.alignItems = t;
    const i = `ag-group-item-alignment-${this.alignItems}`;
    return this.addCssClass(i), this;
  }
  toggleGroupExpand(t) {
    var i;
    let s = !1;
    if ((i = this.eTitleBar) != null && i.isSuppressCollapse() && !this.useToggle)
      t = !0, s = !0;
    else if (t = t ?? !this.expanded, this.expanded === t)
      return this;
    return this.expanded = t, this.refreshChildDisplay(), te(this.eContainer, t), s || this.dispatchEvent({ type: t ? Hs.EVENT_EXPANDED : Hs.EVENT_COLLAPSED }), this;
  }
  addItems(t) {
    t.forEach((i) => this.addItem(i));
  }
  prependItem(t) {
    this.insertItem(t, !0);
  }
  addItem(t) {
    this.insertItem(t, !1);
  }
  insertItem(t, i) {
    const s = this.eContainer, o = t instanceof K ? t.getGui() : t;
    o.classList.add("ag-group-item", `ag-${this.cssIdentifier}-group-item`), i ? (s.insertAdjacentElement("afterbegin", o), this.items.unshift(o)) : (s.appendChild(o), this.items.push(o));
  }
  hideItem(t, i) {
    const s = this.items[i];
    te(s, !t);
  }
  getItemIndex(t) {
    const i = t instanceof K ? t.getGui() : t;
    return this.items.indexOf(i);
  }
  setTitle(t) {
    var i;
    return (i = this.eTitleBar) == null || i.setTitle(t), this;
  }
  addTitleBarWidget(t) {
    var i;
    return (i = this.eTitleBar) == null || i.addWidget(t), this;
  }
  addCssClassToTitleBar(t) {
    var i;
    (i = this.eTitleBar) == null || i.addCssClass(t);
  }
  dispatchEnableChangeEvent(t) {
    const i = {
      type: Hs.EVENT_ENABLE_CHANGE,
      enabled: t
    };
    this.dispatchEvent(i);
  }
  setEnabled(t, i, s) {
    var o;
    return this.enabled = t, this.refreshDisabledStyles(), s || this.toggleGroupExpand(t), i || (this.cbGroupEnabled.setValue(t), (o = this.eToggle) == null || o.setValue(t)), this;
  }
  isEnabled() {
    return this.enabled;
  }
  onEnableChange(t) {
    return this.addManagedListener(this, Hs.EVENT_ENABLE_CHANGE, (i) => t(i.enabled)), this;
  }
  hideEnabledCheckbox(t) {
    return this.suppressEnabledCheckbox = t, this.refreshChildDisplay(), this.refreshDisabledStyles(), this;
  }
  hideOpenCloseIcons(t) {
    var i;
    return (i = this.eTitleBar) == null || i.hideOpenCloseIcons(t), this;
  }
  refreshDisabledStyles() {
    var t;
    const i = !this.enabled;
    this.eContainer.classList.toggle("ag-disabled", i), (t = this.eTitleBar) == null || t.refreshDisabledStyles(this.suppressEnabledCheckbox && i), this.eContainer.classList.toggle("ag-disabled-group-container", i);
  }
  setupTitleBar() {
    const t = this.useToggle ? this.createToggleTitleBar() : this.createDefaultTitleBar();
    this.eToolbar.insertAdjacentElement("beforebegin", t.getGui());
  }
  createDefaultTitleBar() {
    const t = this.createManagedBean(new Nd(this.params));
    return this.eTitleBar = t, t.refreshOnExpand(this.expanded), this.addManagedListener(t, Nd.EVENT_EXPAND_CHANGED, (i) => this.toggleGroupExpand(i.expanded)), t;
  }
  createToggleTitleBar() {
    var t;
    const i = this.createManagedBean(new Mh({
      value: this.enabled,
      label: this.params.title,
      labelAlignment: "left",
      labelWidth: "flex",
      onValueChange: (s) => {
        this.setEnabled(s, !0), this.dispatchEnableChangeEvent(s);
      }
    }));
    return i.addCssClass("ag-group-title-bar"), i.addCssClass(`ag-${(t = this.params.cssIdentifier) != null ? t : "default"}-group-title-bar ag-unselectable`), this.eToggle = i, this.toggleGroupExpand(this.enabled), i;
  }
};
Wi.EVENT_EXPANDED = "expanded";
Wi.EVENT_COLLAPSED = "collapsed";
Wi.EVENT_ENABLE_CHANGE = "enableChange";
u([
  M("eToolbar")
], Wi.prototype, "eToolbar", 2);
u([
  M("cbGroupEnabled")
], Wi.prototype, "cbGroupEnabled", 2);
u([
  M("eContainer")
], Wi.prototype, "eContainer", 2);
u([
  L
], Wi.prototype, "postConstruct", 1);
var sm = Wi, hl = "ag-disabled-group-title-bar", wo = class Kl extends K {
  constructor(t = {}) {
    super(Kl.getTemplate(t)), this.suppressOpenCloseIcons = !1;
    const { title: i, suppressOpenCloseIcons: s } = t;
    i && i.length > 0 && (this.title = i), s != null && (this.suppressOpenCloseIcons = s);
  }
  static getTemplate(t) {
    var i;
    const s = (i = t.cssIdentifier) != null ? i : "default";
    return (
      /* html */
      `
            <div class="ag-group-title-bar ag-${s}-group-title-bar ag-unselectable" role="button">
                <span class="ag-group-title-bar-icon ag-${s}-group-title-bar-icon" ref="eGroupOpenedIcon" role="presentation"></span>
                <span class="ag-group-title-bar-icon ag-${s}-group-title-bar-icon" ref="eGroupClosedIcon" role="presentation"></span>
                <span ref="eTitle" class="ag-group-title ag-${s}-group-title"></span>
            </div>
        `
    );
  }
  postConstruct() {
    this.setTitle(this.title), this.hideOpenCloseIcons(this.suppressOpenCloseIcons), this.setupExpandContract();
  }
  setupExpandContract() {
    this.eGroupClosedIcon.appendChild(Lt("columnSelectClosed", this.gos, null)), this.eGroupOpenedIcon.appendChild(Lt("columnSelectOpen", this.gos, null)), this.addManagedListener(this.getGui(), "click", () => this.dispatchExpandChanged()), this.addManagedListener(this.getGui(), "keydown", (t) => {
      switch (t.key) {
        case S.ENTER:
        case S.SPACE:
          t.preventDefault(), this.dispatchExpandChanged();
          break;
        case S.RIGHT:
        case S.LEFT:
          t.preventDefault(), this.dispatchExpandChanged(t.key === S.RIGHT);
          break;
      }
    });
  }
  refreshOnExpand(t) {
    this.refreshAriaStatus(t), this.refreshOpenCloseIcons(t);
  }
  refreshAriaStatus(t) {
    this.suppressOpenCloseIcons || fi(this.getGui(), t);
  }
  refreshOpenCloseIcons(t) {
    const i = !this.suppressOpenCloseIcons;
    te(this.eGroupOpenedIcon, i && t), te(this.eGroupClosedIcon, i && !t);
  }
  isSuppressCollapse() {
    return this.suppressOpenCloseIcons;
  }
  dispatchExpandChanged(t) {
    const i = {
      type: Kl.EVENT_EXPAND_CHANGED,
      expanded: t
    };
    this.dispatchEvent(i);
  }
  setTitle(t) {
    const i = this.getGui(), s = !!t && t.length > 0;
    t = s ? t : void 0, this.eTitle.textContent = t ?? "", te(i, s), t !== this.title && (this.title = t);
    const o = i.classList.contains(hl);
    return this.refreshDisabledStyles(o), this;
  }
  addWidget(t) {
    return this.getGui().appendChild(t), this;
  }
  hideOpenCloseIcons(t) {
    return this.suppressOpenCloseIcons = t, t && this.dispatchExpandChanged(!0), this;
  }
  refreshDisabledStyles(t) {
    const i = this.getGui();
    t ? (i.classList.add(hl), i.removeAttribute("tabindex")) : (i.classList.remove(hl), typeof this.title == "string" ? i.setAttribute("tabindex", "0") : i.removeAttribute("tabindex"));
  }
};
wo.EVENT_EXPAND_CHANGED = "expandedChanged";
u([
  M("eGroupOpenedIcon")
], wo.prototype, "eGroupOpenedIcon", 2);
u([
  M("eGroupClosedIcon")
], wo.prototype, "eGroupClosedIcon", 2);
u([
  M("eTitle")
], wo.prototype, "eTitle", 2);
u([
  L
], wo.prototype, "postConstruct", 1);
var Nd = wo, Qa = class extends Rr {
  constructor(e = 0, t) {
    super(
      /* html */
      '<div class="ag-menu-list" role="tree"></div>'
    ), this.level = e, this.menuItems = [], this.params = t ?? {
      column: null,
      node: null,
      value: null
    };
  }
  postConstruct() {
    this.initialiseTabGuard({
      onTabKeyDown: (e) => this.onTabKeyDown(e),
      handleKeyDown: (e) => this.handleKeyDown(e),
      onFocusIn: (e) => this.handleFocusIn(e),
      onFocusOut: (e) => this.handleFocusOut(e)
    });
  }
  onTabKeyDown(e) {
    const t = this.getParentComponent(), i = t && t.getGui();
    i && i.classList.contains("ag-focus-managed") || e.preventDefault(), e.shiftKey && this.closeIfIsChild(e);
  }
  handleKeyDown(e) {
    switch (e.key) {
      case S.UP:
      case S.RIGHT:
      case S.DOWN:
      case S.LEFT:
        e.preventDefault(), this.handleNavKey(e.key);
        break;
      case S.ESCAPE:
        this.closeIfIsChild() && Qt(e);
        break;
    }
  }
  handleFocusIn(e) {
    var t, i;
    const s = e.relatedTarget;
    !this.tabGuardCtrl.isTabGuard(s) && (this.getGui().contains(s) || (i = (t = this.activeMenuItem) == null ? void 0 : t.getSubMenuGui()) != null && i.contains(s)) || (this.activeMenuItem ? this.activeMenuItem.activate() : this.activateFirstItem());
  }
  handleFocusOut(e) {
    var t;
    const i = e.relatedTarget;
    !this.activeMenuItem || this.getGui().contains(i) || (t = this.activeMenuItem.getSubMenuGui()) != null && t.contains(i) || this.activeMenuItem.isSubMenuOpening() || this.activeMenuItem.deactivate();
  }
  clearActiveItem() {
    this.activeMenuItem && (this.activeMenuItem.deactivate(), this.activeMenuItem = null);
  }
  addMenuItems(e) {
    e != null && _e.all(e.map((t) => t === "separator" ? _e.resolve({ eGui: this.createSeparator() }) : typeof t == "string" ? (console.warn(`AG Grid: unrecognised menu item ${t}`), _e.resolve({ eGui: null })) : this.addItem(t))).then((t) => {
      t.forEach((i) => {
        i != null && i.eGui && (this.appendChild(i.eGui), i.comp && this.menuItems.push(i.comp));
      });
    });
  }
  addItem(e) {
    const t = this.createManagedBean(new Gr());
    return t.init({
      menuItemDef: e,
      isAnotherSubMenuOpen: () => this.menuItems.some((i) => i.isSubMenuOpen()),
      level: this.level,
      contextParams: this.params
    }).then(() => (t.setParentComponent(this), this.addManagedListener(t, Gr.EVENT_CLOSE_MENU, (i) => {
      this.dispatchEvent(i);
    }), this.addManagedListener(t, Gr.EVENT_MENU_ITEM_ACTIVATED, (i) => {
      this.activeMenuItem && this.activeMenuItem !== i.menuItem && this.activeMenuItem.deactivate(), this.activeMenuItem = i.menuItem;
    }), {
      comp: t,
      eGui: t.getGui()
    }));
  }
  activateFirstItem() {
    const e = this.menuItems.filter((t) => !t.isDisabled())[0];
    e && e.activate();
  }
  createSeparator() {
    return Ct(
      /* html */
      `
            <div class="ag-menu-separator" aria-hidden="true">
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
            </div>`
    );
  }
  handleNavKey(e) {
    switch (e) {
      case S.UP:
      case S.DOWN:
        const i = this.findNextItem(e === S.UP);
        i && i !== this.activeMenuItem && i.activate();
        return;
    }
    const t = this.gos.get("enableRtl") ? S.RIGHT : S.LEFT;
    e === t ? this.closeIfIsChild() : this.openChild();
  }
  closeIfIsChild(e) {
    const t = this.getParentComponent();
    return t && t instanceof Gr ? (e && e.preventDefault(), t.closeSubMenu(), t.getGui().focus(), !0) : !1;
  }
  openChild() {
    this.activeMenuItem && this.activeMenuItem.openSubMenu(!0);
  }
  findNextItem(e) {
    const t = this.menuItems.filter((o) => !o.isDisabled());
    if (!t.length)
      return;
    if (!this.activeMenuItem)
      return e ? se(t) : t[0];
    e && t.reverse();
    let i, s = !1;
    for (let o = 0; o < t.length; o++) {
      const r = t[o];
      if (!s) {
        r === this.activeMenuItem && (s = !0);
        continue;
      }
      i = r;
      break;
    }
    return s && !i ? t[0] : i || this.activeMenuItem;
  }
  destroy() {
    this.clearActiveItem(), super.destroy();
  }
};
u([
  f("focusService")
], Qa.prototype, "focusService", 2);
u([
  L
], Qa.prototype, "postConstruct", 1);
var Oh = class extends Rr {
  constructor(e) {
    super(), this.wrappedComponent = e, this.setTemplateFromElement(e.getGui());
  }
  postConstruct() {
    this.initialiseTabGuard({
      onTabKeyDown: (e) => this.onTabKeyDown(e),
      handleKeyDown: (e) => this.handleKeyDown(e)
    });
  }
  handleKeyDown(e) {
    e.key === S.ESCAPE && this.closePanel();
  }
  onTabKeyDown(e) {
    e.defaultPrevented || (this.closePanel(), e.preventDefault());
  }
  closePanel() {
    const e = this.parentComponent;
    e.closeSubMenu(), setTimeout(() => e.getGui().focus(), 0);
  }
};
u([
  L
], Oh.prototype, "postConstruct", 1);
var So = class ks extends F {
  constructor() {
    super(...arguments), this.isActive = !1, this.subMenuIsOpen = !1, this.subMenuIsOpening = !1, this.suppressRootStyles = !0, this.suppressAria = !0, this.suppressFocus = !0;
  }
  init(t) {
    var i, s;
    const { menuItemDef: o, isAnotherSubMenuOpen: r, level: n, childComponent: l, contextParams: a } = t;
    return this.params = t.menuItemDef, this.level = n, this.isAnotherSubMenuOpen = r, this.childComponent = l, this.contextParams = a, this.cssClassPrefix = (s = (i = this.params.menuItemParams) == null ? void 0 : i.cssClassPrefix) != null ? s : "ag-menu-option", this.userComponentFactory.getMenuItemCompDetails(this.params, Re(_({}, o), {
      level: n,
      isAnotherSubMenuOpen: r,
      openSubMenu: (c) => this.openSubMenu(c),
      closeSubMenu: () => this.closeSubMenu(),
      closeMenu: (c) => this.closeMenu(c),
      updateTooltip: (c, h) => this.refreshTooltip(c, h),
      onItemActivated: () => this.onItemActivated()
    })).newAgStackInstance().then((c) => {
      var h;
      this.menuItemComp = c;
      const g = (h = c.configureDefaults) == null ? void 0 : h.call(c);
      g && this.configureDefaults(g === !0 ? void 0 : g);
    });
  }
  addListeners(t, i) {
    i != null && i.suppressClick || this.addManagedListener(t, "click", (s) => this.onItemSelected(s)), i != null && i.suppressKeyboardSelect || this.addManagedListener(t, "keydown", (s) => {
      (s.key === S.ENTER || s.key === S.SPACE) && (s.preventDefault(), this.onItemSelected(s));
    }), i != null && i.suppressMouseDown || this.addManagedListener(t, "mousedown", (s) => {
      s.stopPropagation(), s.preventDefault();
    }), i != null && i.suppressMouseOver || (this.addManagedListener(t, "mouseenter", () => this.onMouseEnter()), this.addManagedListener(t, "mouseleave", () => this.onMouseLeave()));
  }
  isDisabled() {
    return !!this.params.disabled;
  }
  openSubMenu(t = !1) {
    var i, s;
    if (this.closeSubMenu(), !this.params.subMenu)
      return;
    this.subMenuIsOpening = !0;
    const o = Ct(
      /* html */
      '<div class="ag-menu" role="presentation"></div>'
    );
    this.eSubMenuGui = o;
    let r, n = () => {
      this.subMenuIsOpening = !1;
    };
    if (this.childComponent) {
      const c = this.createBean(new Oh(this.childComponent));
      c.setParentComponent(this);
      const h = c.getGui(), g = "mouseenter", m = () => this.cancelDeactivate();
      h.addEventListener(g, m), r = () => h.removeEventListener(g, m), o.appendChild(h), this.childComponent.afterGuiAttached && (n = () => {
        this.childComponent.afterGuiAttached(), this.subMenuIsOpening = !1;
      });
    } else if (this.params.subMenu) {
      const c = this.createBean(new Qa(this.level + 1, this.contextParams));
      c.setParentComponent(this), c.addMenuItems(this.params.subMenu), o.appendChild(c.getGui()), this.addManagedListener(c, ks.EVENT_CLOSE_MENU, (h) => this.dispatchEvent(h)), c.addGuiEventListener("mouseenter", () => this.cancelDeactivate()), r = () => this.destroyBean(c), t && (n = () => {
        c.activateFirstItem(), this.subMenuIsOpening = !1;
      });
    }
    const l = this.popupService.positionPopupForMenu.bind(
      this.popupService,
      { eventSource: this.eGui, ePopup: o }
    ), a = this.localeService.getLocaleTextFunc(), d = this.popupService.addPopup({
      modal: !0,
      eChild: o,
      positionCallback: l,
      anchorToElement: this.eGui,
      ariaLabel: a("ariaLabelSubMenu", "SubMenu"),
      afterGuiAttached: n
    });
    this.subMenuIsOpen = !0, this.setAriaExpanded(!0), this.hideSubMenu = () => {
      var c, h;
      d && d.hideFunc(), this.subMenuIsOpen = !1, this.setAriaExpanded(!1), r(), (h = (c = this.menuItemComp).setExpanded) == null || h.call(c, !1), this.eSubMenuGui = void 0;
    }, (s = (i = this.menuItemComp).setExpanded) == null || s.call(i, !0);
  }
  setAriaExpanded(t) {
    this.suppressAria || fi(this.eGui, t);
  }
  closeSubMenu() {
    this.hideSubMenu && (this.hideSubMenu(), this.hideSubMenu = null, this.setAriaExpanded(!1));
  }
  isSubMenuOpen() {
    return this.subMenuIsOpen;
  }
  isSubMenuOpening() {
    return this.subMenuIsOpening;
  }
  activate(t) {
    var i, s;
    this.cancelActivate(), !this.params.disabled && (this.isActive = !0, this.suppressRootStyles || this.eGui.classList.add(`${this.cssClassPrefix}-active`), (s = (i = this.menuItemComp).setActive) == null || s.call(i, !0), this.suppressFocus || this.eGui.focus({ preventScroll: !0 }), t && this.params.subMenu && window.setTimeout(() => {
      this.isAlive() && this.isActive && this.openSubMenu();
    }, 300), this.onItemActivated());
  }
  deactivate() {
    var t, i;
    this.cancelDeactivate(), this.suppressRootStyles || this.eGui.classList.remove(`${this.cssClassPrefix}-active`), (i = (t = this.menuItemComp).setActive) == null || i.call(t, !1), this.isActive = !1, this.subMenuIsOpen && this.hideSubMenu();
  }
  getGui() {
    return this.menuItemComp.getGui();
  }
  getParentComponent() {
    return this.parentComponent;
  }
  setParentComponent(t) {
    this.parentComponent = t;
  }
  getSubMenuGui() {
    return this.eSubMenuGui;
  }
  onItemSelected(t) {
    var i, s;
    (s = (i = this.menuItemComp).select) == null || s.call(i), this.params.action ? this.getFrameworkOverrides().wrapOutgoing(() => this.params.action(this.gos.addGridCommonParams(_({}, this.contextParams)))) : this.openSubMenu(t && t.type === "keydown"), !(this.params.subMenu && !this.params.action || this.params.suppressCloseOnSelect) && this.closeMenu(t);
  }
  closeMenu(t) {
    const i = {
      type: ks.EVENT_CLOSE_MENU
    };
    t && (t instanceof MouseEvent ? i.mouseEvent = t : i.keyboardEvent = t), this.dispatchEvent(i);
  }
  onItemActivated() {
    const t = {
      type: ks.EVENT_MENU_ITEM_ACTIVATED,
      menuItem: this
    };
    this.dispatchEvent(t);
  }
  cancelActivate() {
    this.activateTimeoutId && (window.clearTimeout(this.activateTimeoutId), this.activateTimeoutId = 0);
  }
  cancelDeactivate() {
    this.deactivateTimeoutId && (window.clearTimeout(this.deactivateTimeoutId), this.deactivateTimeoutId = 0);
  }
  onMouseEnter() {
    this.cancelDeactivate(), this.isAnotherSubMenuOpen() ? this.activateTimeoutId = window.setTimeout(() => this.activate(!0), ks.ACTIVATION_DELAY) : this.activate(!0);
  }
  onMouseLeave() {
    this.cancelActivate(), this.isSubMenuOpen() ? this.deactivateTimeoutId = window.setTimeout(() => this.deactivate(), ks.ACTIVATION_DELAY) : this.deactivate();
  }
  configureDefaults(t) {
    var i, s, o;
    if (!this.menuItemComp) {
      setTimeout(() => this.configureDefaults(t));
      return;
    }
    let r = this.menuItemComp.getGui();
    const n = (s = (i = this.menuItemComp).getRootElement) == null ? void 0 : s.call(i);
    n && (t != null && t.suppressRootStyles || r.classList.add("ag-menu-option-custom"), r = n), this.eGui = r, this.suppressRootStyles = !!(t != null && t.suppressRootStyles), this.suppressRootStyles || (r.classList.add(this.cssClassPrefix), (o = this.params.cssClasses) == null || o.forEach((l) => r.classList.add(l)), this.params.disabled && r.classList.add(`${this.cssClassPrefix}-disabled`)), t != null && t.suppressTooltip || this.refreshTooltip(this.params.tooltip), this.suppressAria = !!(t != null && t.suppressAria), this.suppressAria || (Fe(r, "treeitem"), $u(r, this.level + 1), this.params.disabled && la(r, !0)), t != null && t.suppressTabIndex || r.setAttribute("tabindex", "-1"), this.params.disabled || this.addListeners(r, t), this.suppressFocus = !!(t != null && t.suppressFocus);
  }
  refreshTooltip(t, i) {
    this.tooltip = t, this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature)), !(!t || !this.menuItemComp) && (this.tooltipFeature = this.createBean(new wi({
      getGui: () => this.getGui(),
      getTooltipValue: () => this.tooltip,
      getLocation: () => "menu",
      shouldDisplayTooltip: i
    })));
  }
  destroy() {
    this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature)), super.destroy();
  }
};
So.EVENT_CLOSE_MENU = "closeMenu";
So.EVENT_MENU_ITEM_ACTIVATED = "menuItemActivated";
So.ACTIVATION_DELAY = 80;
u([
  f("popupService")
], So.prototype, "popupService", 2);
u([
  f("userComponentFactory")
], So.prototype, "userComponentFactory", 2);
var Gr = So, Ms = class $l extends K {
  constructor(t) {
    super($l.getTemplate(t)), this.config = t, this.closable = !0;
  }
  static getTemplate(t) {
    const i = t.cssIdentifier || "default";
    return (
      /* html */
      `<div class="ag-panel ag-${i}-panel" tabindex="-1">
            <div ref="eTitleBar" class="ag-panel-title-bar ag-${i}-panel-title-bar ag-unselectable">
                <span ref="eTitle" class="ag-panel-title-bar-title ag-${i}-panel-title-bar-title"></span>
                <div ref="eTitleBarButtons" class="ag-panel-title-bar-buttons ag-${i}-panel-title-bar-buttons"></div>
            </div>
            <div ref="eContentWrapper" class="ag-panel-content-wrapper ag-${i}-panel-content-wrapper"></div>
        </div>`
    );
  }
  postConstruct() {
    const {
      component: t,
      closable: i,
      hideTitleBar: s,
      title: o,
      minWidth: r = 250,
      width: n,
      minHeight: l = 250,
      height: a,
      centered: d,
      popup: c,
      x: h,
      y: g
    } = this.config;
    this.positionableFeature = new ao(this.getGui(), {
      minWidth: r,
      width: n,
      minHeight: l,
      height: a,
      centered: d,
      x: h,
      y: g,
      popup: c,
      calculateTopBuffer: () => this.positionableFeature.getHeight() - this.getBodyHeight()
    }), this.createManagedBean(this.positionableFeature);
    const m = this.getGui();
    t && this.setBodyComponent(t), s ? te(this.eTitleBar, !1) : (o && this.setTitle(o), this.setClosable(i ?? this.closable)), this.addManagedListener(this.eTitleBar, "mousedown", (C) => {
      if (m.contains(C.relatedTarget) || m.contains(this.gos.getActiveDomElement()) || this.eTitleBarButtons.contains(C.target)) {
        C.preventDefault();
        return;
      }
      const w = this.eContentWrapper.querySelector("button, [href], input, select, textarea, [tabindex]");
      w && w.focus();
    }), !(c && this.positionableFeature.isPositioned()) && (this.renderComponent && this.renderComponent(), this.positionableFeature.initialisePosition(), this.eContentWrapper.style.height = "0");
  }
  renderComponent() {
    const t = this.getGui();
    t.focus(), this.close = () => {
      t.parentElement.removeChild(t), this.destroy();
    };
  }
  getHeight() {
    return this.positionableFeature.getHeight();
  }
  setHeight(t) {
    this.positionableFeature.setHeight(t);
  }
  getWidth() {
    return this.positionableFeature.getWidth();
  }
  setWidth(t) {
    this.positionableFeature.setWidth(t);
  }
  setClosable(t) {
    if (t !== this.closable && (this.closable = t), t) {
      const i = this.closeButtonComp = new K($l.CLOSE_BTN_TEMPLATE);
      this.getContext().createBean(i);
      const s = i.getGui(), o = Te("close", this.gos);
      o.classList.add("ag-panel-title-bar-button-icon"), s.appendChild(o), this.addTitleBarButton(i), i.addManagedListener(s, "click", this.onBtClose.bind(this));
    } else if (this.closeButtonComp) {
      const i = this.closeButtonComp.getGui();
      i.parentElement.removeChild(i), this.closeButtonComp = this.destroyBean(this.closeButtonComp);
    }
  }
  setBodyComponent(t) {
    t.setParentComponent(this), this.eContentWrapper.appendChild(t.getGui());
  }
  addTitleBarButton(t, i) {
    const s = this.eTitleBarButtons, o = s.children, r = o.length;
    i == null && (i = r), i = Math.max(0, Math.min(i, r)), t.addCssClass("ag-panel-title-bar-button");
    const n = t.getGui();
    i === 0 ? s.insertAdjacentElement("afterbegin", n) : i === r ? s.insertAdjacentElement("beforeend", n) : o[i - 1].insertAdjacentElement("afterend", n), t.setParentComponent(this);
  }
  getBodyHeight() {
    return hr(this.eContentWrapper);
  }
  getBodyWidth() {
    return Rs(this.eContentWrapper);
  }
  setTitle(t) {
    this.eTitle.innerText = t;
  }
  // called when user hits the 'x' in the top right
  onBtClose() {
    this.close();
  }
  destroy() {
    this.closeButtonComp && (this.closeButtonComp = this.destroyBean(this.closeButtonComp));
    const t = this.getGui();
    t && wt(t) && this.close(), super.destroy();
  }
};
Ms.CLOSE_BTN_TEMPLATE = /* html */
'<div class="ag-button"></div>';
u([
  M("eContentWrapper")
], Ms.prototype, "eContentWrapper", 2);
u([
  M("eTitleBar")
], Ms.prototype, "eTitleBar", 2);
u([
  M("eTitleBarButtons")
], Ms.prototype, "eTitleBarButtons", 2);
u([
  M("eTitle")
], Ms.prototype, "eTitle", 2);
u([
  L
], Ms.prototype, "postConstruct", 1);
var om = Ms, rm = class extends om {
  constructor(e) {
    super(Re(_({}, e), { popup: !0 })), this.isMaximizable = !1, this.isMaximized = !1, this.maximizeListeners = [], this.resizeListenerDestroy = null, this.lastPosition = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
  postConstruct() {
    const e = this.getGui(), { movable: t, resizable: i, maximizable: s } = this.config;
    this.addCssClass("ag-dialog"), super.postConstruct(), this.addManagedListener(e, "focusin", (o) => {
      this.popupService.bringPopupToFront(e);
    }), t && this.setMovable(t), s && this.setMaximizable(s), i && this.setResizable(i);
  }
  renderComponent() {
    const e = this.getGui(), { alwaysOnTop: t, modal: i, title: s, afterGuiAttached: o } = this.config, r = this.localeService.getLocaleTextFunc(), n = this.popupService.addPopup({
      modal: i,
      eChild: e,
      closeOnEsc: !0,
      closedCallback: this.onClosed.bind(this),
      alwaysOnTop: t,
      ariaLabel: s || r("ariaLabelDialog", "Dialog"),
      afterGuiAttached: o
    });
    n && (this.close = n.hideFunc);
  }
  onClosed(e) {
    var t, i;
    this.destroy(), (i = (t = this.config).closedCallback) == null || i.call(t, e);
  }
  toggleMaximize() {
    const e = this.positionableFeature.getPosition();
    if (this.isMaximized) {
      const { x: t, y: i, width: s, height: o } = this.lastPosition;
      this.setWidth(s), this.setHeight(o), this.positionableFeature.offsetElement(t, i);
    } else
      this.lastPosition.width = this.getWidth(), this.lastPosition.height = this.getHeight(), this.lastPosition.x = e.x, this.lastPosition.y = e.y, this.positionableFeature.offsetElement(0, 0), this.setHeight("100%"), this.setWidth("100%");
    this.isMaximized = !this.isMaximized, this.refreshMaximizeIcon();
  }
  refreshMaximizeIcon() {
    te(this.maximizeIcon, !this.isMaximized), te(this.minimizeIcon, this.isMaximized);
  }
  clearMaximizebleListeners() {
    this.maximizeListeners.length && (this.maximizeListeners.forEach((e) => e()), this.maximizeListeners.length = 0), this.resizeListenerDestroy && (this.resizeListenerDestroy(), this.resizeListenerDestroy = null);
  }
  destroy() {
    this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp), this.clearMaximizebleListeners(), super.destroy();
  }
  setResizable(e) {
    this.positionableFeature.setResizable(e);
  }
  setMovable(e) {
    this.positionableFeature.setMovable(e, this.eTitleBar);
  }
  setMaximizable(e) {
    if (!e) {
      this.clearMaximizebleListeners(), this.maximizeButtonComp && (this.destroyBean(this.maximizeButtonComp), this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = void 0);
      return;
    }
    const t = this.eTitleBar;
    if (!t || e === this.isMaximizable)
      return;
    const i = this.buildMaximizeAndMinimizeElements();
    this.refreshMaximizeIcon(), i.addManagedListener(i.getGui(), "click", this.toggleMaximize.bind(this)), this.addTitleBarButton(i, 0), this.maximizeListeners.push(
      this.addManagedListener(t, "dblclick", this.toggleMaximize.bind(this))
    ), this.resizeListenerDestroy = this.addManagedListener(this, "resize", () => {
      this.isMaximized = !1, this.refreshMaximizeIcon();
    });
  }
  buildMaximizeAndMinimizeElements() {
    const e = this.maximizeButtonComp = this.createBean(new K(
      /* html */
      '<div class="ag-dialog-button"></span>'
    )), t = e.getGui();
    return this.maximizeIcon = Te("maximize", this.gos), t.appendChild(this.maximizeIcon), this.maximizeIcon.classList.add("ag-panel-title-bar-button-icon"), this.minimizeIcon = Te("minimize", this.gos), t.appendChild(this.minimizeIcon), this.minimizeIcon.classList.add("ag-panel-title-bar-button-icon"), e;
  }
};
u([
  f("popupService")
], rm.prototype, "popupService", 2);
var nm = 0, mi = class extends F {
  constructor() {
    super(...arguments), this.popupList = [];
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.gridCtrl = e.gridCtrl;
    }), this.addManagedListener(this.eventService, p.EVENT_GRID_STYLES_CHANGED, this.handleThemeChange.bind(this));
  }
  getPopupParent() {
    const e = this.gos.get("popupParent");
    return e || this.gridCtrl.getGui();
  }
  positionPopupForMenu(e) {
    const { eventSource: t, ePopup: i } = e, s = this.getPopupIndex(i);
    if (s !== -1) {
      const m = this.popupList[s];
      m.alignedToElement = t;
    }
    const o = t.getBoundingClientRect(), r = this.getParentRect(), n = this.keepXYWithinBounds(
      i,
      o.top - r.top,
      0
      /* vertical */
    ), l = i.clientWidth > 0 ? i.clientWidth : 200;
    i.style.minWidth = `${l}px`;
    const d = r.right - r.left - l;
    let c;
    this.gos.get("enableRtl") ? (c = g(), c < 0 && (c = h(), this.setAlignedStyles(i, "left")), c > d && (c = 0, this.setAlignedStyles(i, "right"))) : (c = h(), c > d && (c = g(), this.setAlignedStyles(i, "right")), c < 0 && (c = 0, this.setAlignedStyles(i, "left"))), i.style.left = `${c}px`, i.style.top = `${n}px`;
    function h() {
      return o.right - r.left - 2;
    }
    function g() {
      return o.left - r.left - l;
    }
  }
  positionPopupUnderMouseEvent(e) {
    const { ePopup: t, nudgeX: i, nudgeY: s, skipObserver: o } = e;
    this.positionPopup({
      ePopup: t,
      nudgeX: i,
      nudgeY: s,
      keepWithinBounds: !0,
      skipObserver: o,
      updatePosition: () => this.calculatePointerAlign(e.mouseEvent),
      postProcessCallback: () => this.callPostProcessPopup(e.type, e.ePopup, null, e.mouseEvent, e.column, e.rowNode)
    });
  }
  calculatePointerAlign(e) {
    const t = this.getParentRect();
    return {
      x: e.clientX - t.left,
      y: e.clientY - t.top
    };
  }
  positionPopupByComponent(e) {
    const { ePopup: t, nudgeX: i, nudgeY: s, keepWithinBounds: o, eventSource: r, alignSide: n = "left", position: l = "over", column: a, rowNode: d, type: c } = e, h = r.getBoundingClientRect(), g = this.getParentRect(), m = this.getPopupIndex(t);
    if (m !== -1) {
      const w = this.popupList[m];
      w.alignedToElement = r;
    }
    const C = () => {
      let w = h.left - g.left;
      n === "right" && (w -= t.offsetWidth - h.width);
      let v;
      return l === "over" ? (v = h.top - g.top, this.setAlignedStyles(t, "over")) : (this.setAlignedStyles(t, "under"), this.shouldRenderUnderOrAbove(t, h, g, e.nudgeY || 0) === "under" ? v = h.top - g.top + h.height : v = h.top - t.offsetHeight - (s || 0) * 2 - g.top), { x: w, y: v };
    };
    this.positionPopup({
      ePopup: t,
      nudgeX: i,
      nudgeY: s,
      keepWithinBounds: o,
      updatePosition: C,
      postProcessCallback: () => this.callPostProcessPopup(c, t, r, null, a, d)
    });
  }
  shouldRenderUnderOrAbove(e, t, i, s) {
    const o = i.bottom - t.bottom, r = t.top - i.top, n = e.offsetHeight + s;
    return o > n ? "under" : r > n || r > o ? "above" : "under";
  }
  setAlignedStyles(e, t) {
    const i = this.getPopupIndex(e);
    if (i === -1)
      return;
    const s = this.popupList[i], { alignedToElement: o } = s;
    !o || (["right", "left", "over", "above", "under"].forEach((n) => {
      o.classList.remove(`ag-has-popup-positioned-${n}`), e.classList.remove(`ag-popup-positioned-${n}`);
    }), !t) || (o.classList.add(`ag-has-popup-positioned-${t}`), e.classList.add(`ag-popup-positioned-${t}`));
  }
  callPostProcessPopup(e, t, i, s, o, r) {
    const n = this.gos.getCallback("postProcessPopup");
    n && n({
      column: o,
      rowNode: r,
      ePopup: t,
      type: e,
      eventSource: i,
      mouseEvent: s
    });
  }
  positionPopup(e) {
    const { ePopup: t, keepWithinBounds: i, nudgeX: s, nudgeY: o, skipObserver: r, updatePosition: n } = e, l = { width: 0, height: 0 }, a = (d = !1) => {
      let { x: c, y: h } = n();
      d && t.clientWidth === l.width && t.clientHeight === l.height || (l.width = t.clientWidth, l.height = t.clientHeight, s && (c += s), o && (h += o), i && (c = this.keepXYWithinBounds(
        t,
        c,
        1
        /* horizontal */
      ), h = this.keepXYWithinBounds(
        t,
        h,
        0
        /* vertical */
      )), t.style.left = `${c}px`, t.style.top = `${h}px`, e.postProcessCallback && e.postProcessCallback());
    };
    if (a(), !r) {
      const d = this.resizeObserverService.observeResize(t, () => a(!0));
      setTimeout(() => d(), mi.WAIT_FOR_POPUP_CONTENT_RESIZE);
    }
  }
  getActivePopups() {
    return this.popupList.map((e) => e.element);
  }
  getPopupList() {
    return this.popupList;
  }
  getParentRect() {
    const e = this.gos.getDocument();
    let t = this.getPopupParent();
    return t === e.body ? t = e.documentElement : getComputedStyle(t).position === "static" && (t = t.offsetParent), Ea(t);
  }
  keepXYWithinBounds(e, t, i) {
    const s = i === 0, o = s ? "clientHeight" : "clientWidth", r = s ? "top" : "left", n = s ? "offsetHeight" : "offsetWidth", l = s ? "scrollTop" : "scrollLeft", a = this.gos.getDocument(), d = a.documentElement, c = this.getPopupParent(), h = c.getBoundingClientRect(), g = a.documentElement.getBoundingClientRect(), m = c === a.body, C = e[n];
    let v = m ? (s ? Sa : Uo)(d) + d[l] : c[o];
    m && (v -= Math.abs(g[r] - h[r]));
    const y = v - C;
    return Math.min(Math.max(t, 0), Math.abs(y));
  }
  addPopup(e) {
    const t = this.gos.getDocument(), { eChild: i, ariaLabel: s, alwaysOnTop: o, positionCallback: r, anchorToElement: n } = e;
    if (!t)
      return console.warn("AG Grid: could not find the document, document is empty"), { hideFunc: () => {
      } };
    const l = this.getPopupIndex(i);
    if (l !== -1)
      return { hideFunc: this.popupList[l].hideFunc };
    this.initialisePopupPosition(i);
    const a = this.createPopupWrapper(i, s, !!o), d = this.addEventListenersToPopup(Re(_({}, e), { wrapperEl: a }));
    return r && r(), this.addPopupToPopupList(i, a, d, n), {
      hideFunc: d
    };
  }
  initialisePopupPosition(e) {
    const i = this.getPopupParent().getBoundingClientRect();
    b(e.style.top) || (e.style.top = `${i.top * -1}px`), b(e.style.left) || (e.style.left = `${i.left * -1}px`);
  }
  createPopupWrapper(e, t, i) {
    const s = this.getPopupParent(), o = document.createElement("div"), { allThemes: r } = this.environment.getTheme();
    return r.length && o.classList.add(...r), o.classList.add("ag-popup"), e.classList.add(
      this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr",
      "ag-popup-child"
    ), e.hasAttribute("role") || Fe(e, "dialog"), bt(e, t), o.appendChild(e), s.appendChild(o), i ? this.setAlwaysOnTop(e, !0) : this.bringPopupToFront(e), o;
  }
  handleThemeChange() {
    const { allThemes: e } = this.environment.getTheme();
    for (const t of this.popupList) {
      for (const i of Array.from(t.wrapper.classList))
        i.startsWith("ag-theme-") && t.wrapper.classList.remove(i);
      e.length && t.wrapper.classList.add(...e);
    }
  }
  addEventListenersToPopup(e) {
    const t = this.gos.getDocument(), i = this.getPopupParent(), { wrapperEl: s, eChild: o, closedCallback: r, afterGuiAttached: n, closeOnEsc: l, modal: a } = e;
    let d = !1;
    const c = (C) => {
      if (!s.contains(this.gos.getActiveDomElement()))
        return;
      C.key === S.ESCAPE && !Yt(C) && m({ keyboardEvent: C });
    }, h = (C) => m({ mouseEvent: C }), g = (C) => m({ touchEvent: C }), m = (C = {}) => {
      const { mouseEvent: w, touchEvent: v, keyboardEvent: y, forceHide: E } = C;
      !E && // we don't hide popup if the event was on the child, or any
      // children of this child
      (this.isEventFromCurrentPopup({ mouseEvent: w, touchEvent: v }, o) || // this method should only be called once. the client can have different
      // paths, each one wanting to close, so this method may be called multiple times.
      d) || (d = !0, i.removeChild(s), t.removeEventListener("keydown", c), t.removeEventListener("mousedown", h), t.removeEventListener("touchstart", g), t.removeEventListener("contextmenu", h), this.eventService.removeEventListener(p.EVENT_DRAG_STARTED, h), r && r(w || v || y), this.removePopupFromPopupList(o));
    };
    return n && n({ hidePopup: m }), window.setTimeout(() => {
      l && t.addEventListener("keydown", c), a && (t.addEventListener("mousedown", h), this.eventService.addEventListener(p.EVENT_DRAG_STARTED, h), t.addEventListener("touchstart", g), t.addEventListener("contextmenu", h));
    }, 0), m;
  }
  addPopupToPopupList(e, t, i, s) {
    this.popupList.push({
      element: e,
      wrapper: t,
      hideFunc: i,
      instanceId: nm++,
      isAnchored: !!s
    }), s && this.setPopupPositionRelatedToElement(e, s);
  }
  getPopupIndex(e) {
    return this.popupList.findIndex((t) => t.element === e);
  }
  setPopupPositionRelatedToElement(e, t) {
    const i = this.getPopupIndex(e);
    if (i === -1)
      return;
    const s = this.popupList[i];
    if (s.stopAnchoringPromise && s.stopAnchoringPromise.then((r) => r && r()), s.stopAnchoringPromise = void 0, s.isAnchored = !1, !t)
      return;
    const o = this.keepPopupPositionedRelativeTo({
      element: t,
      ePopup: e,
      hidePopup: s.hideFunc
    });
    return s.stopAnchoringPromise = o, s.isAnchored = !0, o;
  }
  removePopupFromPopupList(e) {
    this.setAlignedStyles(e, null), this.setPopupPositionRelatedToElement(e, null), this.popupList = this.popupList.filter((t) => t.element !== e);
  }
  keepPopupPositionedRelativeTo(e) {
    const t = this.getPopupParent(), i = t.getBoundingClientRect(), { element: s, ePopup: o } = e, r = s.getBoundingClientRect(), n = i.top - r.top, l = i.left - r.left;
    let a = n, d = l;
    const c = o.style.top, h = parseInt(c.substring(0, c.length - 1), 10), g = o.style.left, m = parseInt(g.substring(0, g.length - 1), 10);
    return new _e((C) => {
      this.getFrameworkOverrides().setInterval(() => {
        const w = t.getBoundingClientRect(), v = s.getBoundingClientRect();
        if (v.top == 0 && v.left == 0 && v.height == 0 && v.width == 0) {
          e.hidePopup();
          return;
        }
        const E = w.top - v.top;
        if (E != a) {
          const R = this.keepXYWithinBounds(
            o,
            h + n - E,
            0
            /* vertical */
          );
          o.style.top = `${R}px`;
        }
        a = E;
        const D = w.left - v.left;
        if (D != d) {
          const R = this.keepXYWithinBounds(
            o,
            m + l - D,
            1
            /* horizontal */
          );
          o.style.left = `${R}px`;
        }
        d = D;
      }, 200).then((w) => {
        C(() => {
          w != null && window.clearInterval(w);
        });
      });
    });
  }
  hasAnchoredPopup() {
    return this.popupList.some((e) => e.isAnchored);
  }
  isEventFromCurrentPopup(e, t) {
    const { mouseEvent: i, touchEvent: s } = e, o = i || s;
    if (!o)
      return !1;
    const r = this.getPopupIndex(t);
    if (r === -1)
      return !1;
    for (let n = r; n < this.popupList.length; n++) {
      const l = this.popupList[n];
      if (Xr(l.element, o))
        return !0;
    }
    return this.isElementWithinCustomPopup(o.target);
  }
  isElementWithinCustomPopup(e) {
    const t = this.gos.getDocument();
    for (; e && e !== t.body; ) {
      if (e.classList.contains("ag-custom-component-popup") || e.parentElement === null)
        return !0;
      e = e.parentElement;
    }
    return !1;
  }
  getWrapper(e) {
    for (; !e.classList.contains("ag-popup") && e.parentElement; )
      e = e.parentElement;
    return e.classList.contains("ag-popup") ? e : null;
  }
  setAlwaysOnTop(e, t) {
    const i = this.getWrapper(e);
    i && (i.classList.toggle("ag-always-on-top", !!t), t && this.bringPopupToFront(i));
  }
  bringPopupToFront(e) {
    const t = this.getPopupParent(), i = Array.prototype.slice.call(t.querySelectorAll(".ag-popup")), s = i.length, o = Array.prototype.slice.call(t.querySelectorAll(".ag-popup.ag-always-on-top")), r = o.length, n = this.getWrapper(e);
    if (!n || s <= 1 || !t.contains(e))
      return;
    const l = i.indexOf(n), a = n.querySelectorAll("div"), d = [];
    for (a.forEach((c) => {
      c.scrollTop !== 0 && d.push([c, c.scrollTop]);
    }), r ? n.classList.contains("ag-always-on-top") ? l !== s - 1 && se(o).insertAdjacentElement("afterend", n) : l !== s - r - 1 && o[0].insertAdjacentElement("beforebegin", n) : l !== s - 1 && se(i).insertAdjacentElement("afterend", n); d.length; ) {
      const c = d.pop();
      c[0].scrollTop = c[1];
    }
  }
};
mi.WAIT_FOR_POPUP_CONTENT_RESIZE = 200;
u([
  f("focusService")
], mi.prototype, "focusService", 2);
u([
  f("ctrlsService")
], mi.prototype, "ctrlsService", 2);
u([
  f("resizeObserverService")
], mi.prototype, "resizeObserverService", 2);
u([
  L
], mi.prototype, "postConstruct", 1);
mi = u([
  O("popupService")
], mi);
var lm = class extends K {
  constructor() {
    super(
      /* html */
      `
        <div class="ag-autocomplete-row" role="presentation">
            <div class="ag-autocomplete-row-label"></div>
        </div>`
    ), this.hasHighlighting = !1;
  }
  setState(e, t) {
    this.value = e, this.render(), this.updateSelected(t);
  }
  updateSelected(e) {
    this.addOrRemoveCssClass("ag-autocomplete-row-selected", e);
  }
  setSearchString(e) {
    var t;
    let i = !1;
    if (b(e)) {
      const s = (t = this.value) == null ? void 0 : t.toLocaleLowerCase().indexOf(e.toLocaleLowerCase());
      if (s >= 0) {
        i = !0, this.hasHighlighting = !0;
        const o = s + e.length, r = Oe(this.value.slice(0, s)), n = Oe(this.value.slice(s, o)), l = Oe(this.value.slice(o));
        this.getGui().lastElementChild.innerHTML = `${r}<b>${n}</b>${l}`;
      }
    }
    !i && this.hasHighlighting && (this.hasHighlighting = !1, this.render());
  }
  render() {
    var e;
    this.getGui().lastElementChild.innerHTML = (e = Oe(this.value)) != null ? e : "&nbsp;";
  }
}, Xn = class _h extends bs {
  constructor(t) {
    super(_h.TEMPLATE), this.params = t, this.searchString = "";
  }
  destroy() {
    super.destroy();
  }
  init() {
    this.autocompleteEntries = this.params.autocompleteEntries, this.virtualList = this.createManagedBean(new Nh({ cssIdentifier: "autocomplete" })), this.virtualList.setComponentCreator(this.createRowComponent.bind(this)), this.eList.appendChild(this.virtualList.getGui()), this.virtualList.setModel({
      getRowCount: () => this.autocompleteEntries.length,
      getRow: (i) => this.autocompleteEntries[i]
    });
    const t = this.virtualList.getGui();
    this.addManagedListener(t, "click", () => this.params.onConfirmed()), this.addManagedListener(t, "mousemove", this.onMouseMove.bind(this)), this.addManagedListener(t, "mousedown", (i) => i.preventDefault()), this.setSelectedValue(0);
  }
  onNavigationKeyDown(t, i) {
    t.preventDefault();
    const s = this.autocompleteEntries.indexOf(this.selectedValue), o = i === S.UP ? s - 1 : s + 1;
    this.checkSetSelectedValue(o);
  }
  setSearch(t) {
    this.searchString = t, b(t) ? this.runSearch() : (this.autocompleteEntries = this.params.autocompleteEntries, this.virtualList.refresh(), this.checkSetSelectedValue(0)), this.updateSearchInList();
  }
  runContainsSearch(t, i) {
    let s, o = !1;
    const r = t.toLocaleLowerCase(), n = i.filter((l) => {
      const d = l.toLocaleLowerCase().indexOf(r), c = d === 0, h = d >= 0;
      return h && (!s || !o && c || o === c && l.length < s.length) && (s = l, o = c), h;
    });
    return !s && n.length && (s = n[0]), { topMatch: s, allMatches: n };
  }
  runSearch() {
    var t, i;
    const { autocompleteEntries: s } = this.params, o = s.map((d) => {
      var c;
      return (c = d.displayValue) != null ? c : d.key;
    });
    let r, n;
    if (this.params.useFuzzySearch)
      r = gr(this.searchString, o, !0).values, n = r.length ? r[0] : void 0;
    else {
      const d = this.runContainsSearch(this.searchString, o);
      r = d.allMatches, n = d.topMatch;
    }
    let l = s.filter(({ key: d, displayValue: c }) => r.includes(c ?? d));
    if (!l.length && this.selectedValue && ((i = (t = this.params) == null ? void 0 : t.forceLastSelection) != null && i.call(t, this.selectedValue, this.searchString)) && (l = [this.selectedValue]), this.autocompleteEntries = l, this.virtualList.refresh(), !n)
      return;
    const a = r.indexOf(n);
    this.checkSetSelectedValue(a);
  }
  updateSearchInList() {
    this.virtualList.forEachRenderedRow((t) => t.setSearchString(this.searchString));
  }
  checkSetSelectedValue(t) {
    t >= 0 && t < this.autocompleteEntries.length && this.setSelectedValue(t);
  }
  setSelectedValue(t) {
    const i = this.autocompleteEntries[t];
    this.selectedValue !== i && (this.selectedValue = i, this.virtualList.ensureIndexVisible(t), this.virtualList.forEachRenderedRow((s, o) => {
      s.updateSelected(t === o);
    }));
  }
  createRowComponent(t) {
    var i;
    const s = new lm();
    return this.getContext().createBean(s), s.setState((i = t.displayValue) != null ? i : t.key, t === this.selectedValue), s;
  }
  onMouseMove(t) {
    const i = this.virtualList.getGui().getBoundingClientRect(), s = this.virtualList.getScrollTop(), o = t.clientY - i.top + s, r = Math.floor(o / this.virtualList.getRowHeight());
    this.checkSetSelectedValue(r);
  }
  afterGuiAttached() {
    this.virtualList.refresh();
  }
  getSelectedValue() {
    var t;
    return this.autocompleteEntries.length && (t = this.selectedValue) != null ? t : null;
  }
};
Xn.TEMPLATE = /* html */
`<div class="ag-autocomplete-list-popup">
            <div ref="eList" class="ag-autocomplete-list"></div>
        <div>`;
u([
  M("eList")
], Xn.prototype, "eList", 2);
u([
  L
], Xn.prototype, "init", 1);
var am = Xn, Ui = class Io extends K {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-autocomplete" role="presentation">
                <ag-input-text-field ref="eAutocompleteInput"></ag-input-text-field>
            </div>`
    ), this.isListOpen = !1, this.lastPosition = 0, this.valid = !0;
  }
  postConstruct() {
    this.eAutocompleteInput.onValueChange((t) => this.onValueChanged(t)), this.eAutocompleteInput.getInputElement().setAttribute("autocomplete", "off"), this.addGuiEventListener("keydown", this.onKeyDown.bind(this)), this.addGuiEventListener("click", this.updatePositionAndList.bind(this)), this.addDestroyFunc(() => {
      this.destroyBean(this.autocompleteList);
    }), this.addGuiEventListener("focusout", () => this.onFocusOut());
  }
  onValueChanged(t) {
    const i = si(t);
    this.updateValue(i), this.updateAutocompleteList(i);
  }
  updateValue(t) {
    this.updateLastPosition(), this.dispatchEvent({
      type: Io.EVENT_VALUE_CHANGED,
      value: t
    }), this.validate(t);
  }
  updateAutocompleteList(t) {
    var i, s, o, r;
    const n = (s = (i = this.listGenerator) == null ? void 0 : i.call(this, t, this.lastPosition)) != null ? s : { enabled: !1 };
    if ((!n.type || n.type !== ((o = this.autocompleteListParams) == null ? void 0 : o.type)) && this.isListOpen && this.closeList(), this.autocompleteListParams = n, (r = this.autocompleteListParams) != null && r.enabled) {
      this.isListOpen || this.openList();
      const { searchString: l } = this.autocompleteListParams;
      this.autocompleteList.setSearch(l ?? "");
    } else
      this.isListOpen && this.closeList();
  }
  onKeyDown(t) {
    const i = t.key;
    switch (this.updateLastPosition(), i) {
      case S.ENTER:
        this.onEnterKeyDown(t);
        break;
      case S.TAB:
        this.onTabKeyDown(t);
        break;
      case S.DOWN:
      case S.UP:
        this.onUpDownKeyDown(t, i);
        break;
      case S.LEFT:
      case S.RIGHT:
      case S.PAGE_HOME:
      case S.PAGE_END:
        setTimeout(() => {
          this.updatePositionAndList();
        });
        break;
      case S.ESCAPE:
        this.onEscapeKeyDown(t);
        break;
      case S.SPACE:
        t.ctrlKey && !this.isListOpen && (t.preventDefault(), this.forceOpenList());
        break;
    }
  }
  confirmSelection() {
    var t;
    const i = (t = this.autocompleteList) == null ? void 0 : t.getSelectedValue();
    i && (this.closeList(), this.dispatchEvent({
      type: Io.EVENT_OPTION_SELECTED,
      value: this.getValue(),
      position: this.lastPosition,
      updateEntry: i,
      autocompleteType: this.autocompleteListParams.type
    }));
  }
  onTabKeyDown(t) {
    this.isListOpen && (t.preventDefault(), t.stopPropagation(), this.confirmSelection());
  }
  onEnterKeyDown(t) {
    t.preventDefault(), this.isListOpen ? this.confirmSelection() : this.onCompleted();
  }
  onUpDownKeyDown(t, i) {
    var s;
    t.preventDefault(), this.isListOpen ? (s = this.autocompleteList) == null || s.onNavigationKeyDown(t, i) : this.forceOpenList();
  }
  onEscapeKeyDown(t) {
    this.isListOpen && (t.preventDefault(), t.stopPropagation(), this.closeList(), this.setCaret(this.lastPosition, !0));
  }
  onFocusOut() {
    this.isListOpen && this.closeList();
  }
  updatePositionAndList() {
    var t;
    this.updateLastPosition(), this.updateAutocompleteList((t = this.eAutocompleteInput.getValue()) != null ? t : null);
  }
  setCaret(t, i) {
    const s = this.gos.getDocument(), o = this.gos.getActiveDomElement();
    i && (!o || o === s.body) && this.eAutocompleteInput.getFocusableElement().focus();
    const r = this.eAutocompleteInput.getInputElement();
    r.setSelectionRange(t, t), t === r.value.length && (r.scrollLeft = r.scrollWidth);
  }
  forceOpenList() {
    this.onValueChanged(this.eAutocompleteInput.getValue());
  }
  updateLastPosition() {
    var t;
    this.lastPosition = (t = this.eAutocompleteInput.getInputElement().selectionStart) != null ? t : 0;
  }
  validate(t) {
    var i;
    this.validator && (this.validationMessage = this.validator(t), this.eAutocompleteInput.getInputElement().setCustomValidity((i = this.validationMessage) != null ? i : ""), this.valid = !this.validationMessage, this.dispatchEvent({
      type: Io.EVENT_VALID_CHANGED,
      isValid: this.valid,
      validationMessage: this.validationMessage
    }));
  }
  openList() {
    this.isListOpen = !0, this.autocompleteList = this.createBean(new am({
      autocompleteEntries: this.autocompleteListParams.entries,
      onConfirmed: () => this.confirmSelection(),
      forceLastSelection: this.forceLastSelection
    }));
    const t = this.autocompleteList.getGui(), i = {
      ePopup: t,
      type: "autocomplete",
      eventSource: this.getGui(),
      position: "under",
      alignSide: this.gos.get("enableRtl") ? "right" : "left",
      keepWithinBounds: !0
    }, s = this.popupService.addPopup({
      eChild: t,
      anchorToElement: this.getGui(),
      positionCallback: () => this.popupService.positionPopupByComponent(i),
      ariaLabel: this.listAriaLabel
    });
    this.hidePopup = s.hideFunc, this.autocompleteList.afterGuiAttached();
  }
  closeList() {
    this.isListOpen = !1, this.hidePopup(), this.destroyBean(this.autocompleteList), this.autocompleteList = null;
  }
  onCompleted() {
    this.isListOpen && this.closeList(), this.dispatchEvent({
      type: Io.EVENT_VALUE_CONFIRMED,
      value: this.getValue(),
      isValid: this.isValid()
    });
  }
  getValue() {
    return si(this.eAutocompleteInput.getValue());
  }
  setInputPlaceholder(t) {
    return this.eAutocompleteInput.setInputPlaceholder(t), this;
  }
  setInputAriaLabel(t) {
    return this.eAutocompleteInput.setInputAriaLabel(t), this;
  }
  setListAriaLabel(t) {
    return this.listAriaLabel = t, this;
  }
  setListGenerator(t) {
    return this.listGenerator = t, this;
  }
  setValidator(t) {
    return this.validator = t, this;
  }
  isValid() {
    return this.valid;
  }
  setValue(t) {
    const { value: i, position: s, silent: o, updateListOnlyIfOpen: r, restoreFocus: n } = t;
    this.eAutocompleteInput.setValue(i, !0), this.setCaret(s ?? this.lastPosition, n), o || this.updateValue(i), (!r || this.isListOpen) && this.updateAutocompleteList(i);
  }
  setForceLastSelection(t) {
    return this.forceLastSelection = t, this;
  }
  setInputDisabled(t) {
    return this.eAutocompleteInput.setDisabled(t), this;
  }
};
Ui.EVENT_VALUE_CHANGED = "eventValueChanged";
Ui.EVENT_VALUE_CONFIRMED = "eventValueConfirmed";
Ui.EVENT_OPTION_SELECTED = "eventOptionSelected";
Ui.EVENT_VALID_CHANGED = "eventValidChanged";
u([
  f("popupService")
], Ui.prototype, "popupService", 2);
u([
  M("eAutocompleteInput")
], Ui.prototype, "eAutocompleteInput", 2);
u([
  L
], Ui.prototype, "postConstruct", 1);
var dm = Ui, zi = class Ur extends K {
  constructor(t, i, s, o) {
    super(), this.dragSourceDropTarget = t, this.ghost = i, this.horizontal = s, this.template = o;
  }
  init() {
    var t;
    this.setTemplate((t = this.template) != null ? t : Ur.TEMPLATE);
    const i = this.getGui();
    this.addElementClasses(i), this.addElementClasses(this.eDragHandle, "drag-handle"), this.addElementClasses(this.eText, "text"), this.addElementClasses(this.eButton, "button"), this.eDragHandle.appendChild(Te("columnDrag", this.gos)), this.eButton.appendChild(Te("cancel", this.gos)), this.setupComponents(), !this.ghost && this.isDraggable() && this.addDragSource(), this.setupAria(), this.setupTooltip(), this.activateTabIndex(), this.refreshDraggable();
  }
  isDraggable() {
    return !0;
  }
  refreshDraggable() {
    this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !this.isDraggable());
  }
  setupAria() {
    const t = this.localeService.getLocaleTextFunc(), i = [this.getAriaDisplayName()];
    this.addAdditionalAriaInstructions(i, t), bt(this.getGui(), i.join(". "));
  }
  addAdditionalAriaInstructions(t, i) {
    if (this.isRemovable()) {
      const s = i("ariaDropZoneColumnComponentDescription", "Press DELETE to remove");
      t.push(s);
    }
  }
  setupTooltip() {
    const t = () => {
      const i = this.getTooltip();
      this.setTooltip({ newTooltipText: i });
    };
    t(), this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, t);
  }
  getDragSourceId() {
  }
  getDefaultIconName() {
    return Y.ICON_NOT_ALLOWED;
  }
  addDragSource() {
    const { dragAndDropService: t, eDragHandle: i } = this, s = this.createGetDragItem(), o = this.getDefaultIconName(), r = {
      type: this.getDragSourceType(),
      sourceId: this.getDragSourceId(),
      eElement: i,
      getDefaultIconName: () => o,
      getDragItem: s,
      dragItemName: this.getDisplayName()
    };
    t.addDragSource(r, !0), this.addDestroyFunc(() => t.removeDragSource(r));
  }
  setupComponents() {
    this.setTextValue(), this.setupRemove(), this.ghost && this.addCssClass("ag-column-drop-cell-ghost");
  }
  isRemovable() {
    return !0;
  }
  refreshRemove() {
    te(this.eButton, this.isRemovable());
  }
  setupRemove() {
    this.refreshRemove();
    const t = { type: Ur.EVENT_COLUMN_REMOVE };
    this.addGuiEventListener("keydown", (s) => this.onKeyDown(s)), this.addManagedListener(this.eButton, "click", (s) => {
      this.dispatchEvent(t), s.stopPropagation();
    });
    const i = new je(this.eButton);
    this.addManagedListener(i, je.EVENT_TAP, () => {
      this.dispatchEvent(t);
    }), this.addDestroyFunc(i.destroy.bind(i));
  }
  onKeyDown(t) {
    t.key === S.DELETE && this.isRemovable() && (t.preventDefault(), this.dispatchEvent({ type: Ur.EVENT_COLUMN_REMOVE }));
  }
  getDisplayValue() {
    return this.getDisplayName();
  }
  setTextValue() {
    const t = this.getDisplayValue(), i = Oe(t);
    this.eText.innerHTML = i;
  }
  addElementClasses(t, i) {
    i = i ? `-${i}` : "";
    const s = this.horizontal ? "horizontal" : "vertical";
    t.classList.add(`ag-column-drop-cell${i}`, `ag-column-drop-${s}-cell${i}`);
  }
  destroy() {
    super.destroy(), this.dragSourceDropTarget = null;
  }
};
zi.EVENT_COLUMN_REMOVE = "columnRemove";
zi.TEMPLATE = /* html */
`<span role="option">
          <span ref="eDragHandle" class="ag-drag-handle ag-column-drop-cell-drag-handle" role="presentation"></span>
          <span ref="eText" class="ag-column-drop-cell-text" aria-hidden="true"></span>
          <span ref="eButton" class="ag-column-drop-cell-button" role="presentation"></span>
        </span>`;
u([
  f("dragAndDropService")
], zi.prototype, "dragAndDropService", 2);
u([
  M("eText")
], zi.prototype, "eText", 2);
u([
  M("eDragHandle")
], zi.prototype, "eDragHandle", 2);
u([
  M("eButton")
], zi.prototype, "eButton", 2);
u([
  L
], zi.prototype, "init", 1);
var um = zi, br = class ti extends K {
  constructor(t) {
    super(
      /* html */
      '<div class="ag-unselectable" role="presentation"></div>'
    ), this.horizontal = t, this.state = ti.STATE_NOT_DRAGGING, this.guiDestroyFunctions = [], this.childPillComponents = [], this.resizeEnabled = !1, this.addElementClasses(this.getGui()), this.ePillDropList = document.createElement("div"), this.addElementClasses(this.ePillDropList, "list"), Fe(this.ePillDropList, "listbox");
  }
  isHorizontal() {
    return this.horizontal;
  }
  toggleResizable(t) {
    this.positionableFeature.setResizable(t ? { bottom: !0 } : !1), this.resizeEnabled = t;
  }
  isSourceEventFromTarget(t) {
    const { dropZoneTarget: i, dragSource: s } = t;
    return i.contains(s.eElement);
  }
  destroy() {
    this.destroyGui(), super.destroy();
  }
  destroyGui() {
    this.guiDestroyFunctions.forEach((t) => t()), this.guiDestroyFunctions.length = 0, this.childPillComponents.length = 0, xe(this.getGui()), xe(this.ePillDropList);
  }
  init(t) {
    this.params = t ?? {}, this.createManagedBean(new Hi(
      this.getFocusableElement(),
      {
        handleKeyDown: this.handleKeyDown.bind(this)
      }
    )), this.setupDropTarget(), this.positionableFeature = new ao(this.getGui(), { minHeight: 100 }), this.createManagedBean(this.positionableFeature), this.refreshGui(), bt(this.ePillDropList, this.getAriaLabel());
  }
  handleKeyDown(t) {
    const i = !this.horizontal;
    let s = t.key === S.DOWN, o = t.key === S.UP;
    if (!i) {
      const n = this.gos.get("enableRtl");
      s = !n && t.key === S.RIGHT || n && t.key === S.LEFT, o = !n && t.key === S.LEFT || n && t.key === S.RIGHT;
    }
    if (!s && !o)
      return;
    const r = this.focusService.findNextFocusableElement(
      this.getFocusableElement(),
      !1,
      o
    );
    r && (t.preventDefault(), r.focus());
  }
  addElementClasses(t, i) {
    i = i ? `-${i}` : "";
    const s = this.horizontal ? "horizontal" : "vertical";
    t.classList.add(`ag-column-drop${i}`, `ag-column-drop-${s}${i}`);
  }
  setupDropTarget() {
    this.dropTarget = {
      getContainer: this.getGui.bind(this),
      getIconName: this.getIconName.bind(this),
      onDragging: this.onDragging.bind(this),
      onDragEnter: this.onDragEnter.bind(this),
      onDragLeave: this.onDragLeave.bind(this),
      onDragStop: this.onDragStop.bind(this),
      isInterestedIn: this.isInterestedIn.bind(this)
    }, this.dragAndDropService.addDropTarget(this.dropTarget);
  }
  minimumAllowedNewInsertIndex() {
    return 0;
  }
  checkInsertIndex(t) {
    const i = this.getNewInsertIndex(t);
    if (i < 0)
      return !1;
    const s = this.minimumAllowedNewInsertIndex(), o = Math.max(s, i), r = o !== this.insertIndex;
    return r && (this.insertIndex = o), r;
  }
  getNewInsertIndex(t) {
    const i = t.event, s = this.horizontal ? i.clientX : i.clientY, o = this.childPillComponents.map((n) => n.getGui().getBoundingClientRect()), r = o.findIndex((n) => this.horizontal ? n.right > s && n.left < s : n.top < s && n.bottom > s);
    if (r === -1) {
      const n = this.gos.get("enableRtl");
      return o.every((d) => s > (this.horizontal ? d.right : d.bottom)) ? n && this.horizontal ? 0 : this.childPillComponents.length : o.every((d) => s < (this.horizontal ? d.left : d.top)) ? n && this.horizontal ? this.childPillComponents.length : 0 : this.insertIndex;
    }
    return this.insertIndex <= r ? r + 1 : r;
  }
  checkDragStartedBySelf(t) {
    this.state === ti.STATE_NOT_DRAGGING && (this.state = ti.STATE_REARRANGE_ITEMS, this.potentialDndItems = this.getItems(t.dragSource.getDragItem()), this.refreshGui(), this.checkInsertIndex(t), this.refreshGui());
  }
  onDragging(t) {
    this.checkDragStartedBySelf(t), this.checkInsertIndex(t) && this.refreshGui();
  }
  handleDragEnterEnd(t) {
  }
  onDragEnter(t) {
    const i = this.getItems(t.dragSource.getDragItem());
    this.state = ti.STATE_NEW_ITEMS_IN;
    const s = i.filter((r) => this.isItemDroppable(r, t)), o = s.every((r) => this.childPillComponents.map((n) => n.getItem()).indexOf(r) !== -1);
    if (s.length !== 0) {
      if (this.potentialDndItems = s, o) {
        this.state = ti.STATE_NOT_DRAGGING;
        return;
      }
      this.handleDragEnterEnd(t), this.checkInsertIndex(t), this.refreshGui();
    }
  }
  isPotentialDndItems() {
    return Du(this.potentialDndItems);
  }
  handleDragLeaveEnd(t) {
  }
  onDragLeave(t) {
    if (this.state === ti.STATE_REARRANGE_ITEMS) {
      const i = this.getItems(t.dragSource.getDragItem());
      this.removeItems(i);
    }
    this.isPotentialDndItems() && (this.handleDragLeaveEnd(t), this.potentialDndItems = [], this.refreshGui()), this.state = ti.STATE_NOT_DRAGGING;
  }
  refreshOnDragStop() {
    return !0;
  }
  onDragStop() {
    if (this.isPotentialDndItems()) {
      let t = !1;
      this.state === ti.STATE_NEW_ITEMS_IN ? (this.addItems(this.potentialDndItems), t = !0) : t = this.rearrangeItems(this.potentialDndItems), this.potentialDndItems = [], (this.refreshOnDragStop() || !t) && this.refreshGui();
    }
    this.state = ti.STATE_NOT_DRAGGING;
  }
  removeItems(t) {
    const i = this.getExistingItems().filter((s) => !Tt(t, s));
    this.updateItems(i);
  }
  addItems(t) {
    if (!t)
      return;
    const i = this.getExistingItems().slice(), s = t.filter((o) => i.indexOf(o) < 0);
    Pl(i, s, this.insertIndex), this.updateItems(i);
  }
  addItem(t) {
    this.insertIndex = this.getExistingItems().length, this.addItems([t]), this.refreshGui();
  }
  rearrangeItems(t) {
    const i = this.getNonGhostItems().slice();
    return Pl(i, t, this.insertIndex), ii(i, this.getExistingItems()) ? !1 : (this.updateItems(i), !0);
  }
  refreshGui() {
    const t = this.ePillDropList.scrollTop, i = this.resizeEnabled, s = this.getFocusedItem();
    let o = this.focusService.findNextFocusableElement();
    o || (o = this.focusService.findNextFocusableElement(void 0, !1, !0)), this.toggleResizable(!1), this.destroyGui(), this.addIconAndTitleToGui(), this.addEmptyMessageToGui(), this.addItemsToGui(), this.isHorizontal() || (this.ePillDropList.scrollTop = t), i && this.toggleResizable(i), this.focusService.isKeyboardMode() && this.restoreFocus(s, o);
  }
  getFocusedItem() {
    const t = this.getGui(), i = this.gos.getActiveDomElement();
    return t.contains(i) ? Array.from(t.querySelectorAll(".ag-column-drop-cell")).indexOf(i) : -1;
  }
  restoreFocus(t, i) {
    const s = this.getGui(), o = Array.from(s.querySelectorAll(".ag-column-drop-cell"));
    if (t === -1)
      return;
    o.length === 0 && i.focus();
    const r = Math.min(o.length - 1, t), n = o[r];
    n && n.focus();
  }
  focusList(t) {
    const i = t ? this.childPillComponents.length - 1 : 0;
    this.restoreFocus(i, this.getFocusableElement());
  }
  getNonGhostItems() {
    const t = this.getExistingItems();
    return this.isPotentialDndItems() ? t.filter((i) => !Tt(this.potentialDndItems, i)) : t;
  }
  addItemsToGui() {
    const i = this.getNonGhostItems().map((s) => this.createItemComponent(s, !1));
    if (this.isPotentialDndItems()) {
      const s = this.potentialDndItems.map((o) => this.createItemComponent(o, !0));
      this.insertIndex >= i.length ? i.push(...s) : i.splice(this.insertIndex, 0, ...s);
    }
    this.appendChild(this.ePillDropList), i.forEach((s, o) => {
      o > 0 && this.addArrow(this.ePillDropList), this.ePillDropList.appendChild(s.getGui());
    }), this.addAriaLabelsToComponents();
  }
  addAriaLabelsToComponents() {
    this.childPillComponents.forEach((t, i) => {
      const s = t.getGui();
      Tn(s, i + 1), Dn(s, this.childPillComponents.length);
    });
  }
  createItemComponent(t, i) {
    const s = this.createPillComponent(t, this.dropTarget, i, this.horizontal);
    return s.addEventListener(um.EVENT_COLUMN_REMOVE, this.removeItems.bind(this, [t])), this.context.createBean(s), this.guiDestroyFunctions.push(() => this.destroyBean(s)), i || this.childPillComponents.push(s), s;
  }
  addIconAndTitleToGui() {
    const { title: t, icon: i } = this.params;
    if (!t || !i)
      return;
    const s = document.createElement("div");
    if (cr(s, !0), this.addElementClasses(s, "title-bar"), this.addElementClasses(i, "icon"), this.addOrRemoveCssClass("ag-column-drop-empty", this.isExistingItemsEmpty()), s.appendChild(i), !this.horizontal) {
      const o = document.createElement("span");
      this.addElementClasses(o, "title"), o.innerHTML = t, s.appendChild(o);
    }
    this.appendChild(s);
  }
  isExistingItemsEmpty() {
    return this.getExistingItems().length === 0;
  }
  addEmptyMessageToGui() {
    const { emptyMessage: t } = this.params;
    if (!t || !this.isExistingItemsEmpty() || this.isPotentialDndItems())
      return;
    const i = document.createElement("span");
    i.innerHTML = t, this.addElementClasses(i, "empty-message"), this.ePillDropList.appendChild(i);
  }
  addArrow(t) {
    if (this.horizontal) {
      const i = this.gos.get("enableRtl"), s = Te(i ? "smallLeft" : "smallRight", this.gos);
      this.addElementClasses(s, "cell-separator"), t.appendChild(s);
    }
  }
};
br.STATE_NOT_DRAGGING = "notDragging";
br.STATE_NEW_ITEMS_IN = "newItemsIn";
br.STATE_REARRANGE_ITEMS = "rearrangeItems";
u([
  f("focusService")
], br.prototype, "focusService", 2);
u([
  f("dragAndDropService")
], br.prototype, "dragAndDropService", 2);
var cm = ["touchstart", "touchend", "touchmove", "touchcancel"], Vh = class {
  constructor(e = "javascript") {
    this.frameworkName = e, this.renderingEngine = "vanilla", this.wrapIncoming = (t) => t(), this.wrapOutgoing = (t) => t();
  }
  setInterval(e, t) {
    return new _e((i) => {
      i(window.setInterval(e, t));
    });
  }
  // for Vanilla JS, we just add the event to the element
  addEventListener(e, t, i, s) {
    const o = Tt(cm, t);
    e.addEventListener(t, i, { capture: !!s, passive: o });
  }
  get shouldWrapOutgoing() {
    return !1;
  }
  frameworkComponent(e) {
    return null;
  }
  isFrameworkComponent(e) {
    return !1;
  }
  getDocLink(e) {
    return `https://www.ag-grid.com/${this.frameworkName === "solid" ? "react" : this.frameworkName}-data-grid${e ? `/${e}` : ""}`;
  }
}, Ni = class extends F {
  // returns null if no cell to focus on, ie at the end of the grid
  getNextCellToFocus(e, t, i = !1) {
    return i ? this.getNextCellToFocusWithCtrlPressed(e, t) : this.getNextCellToFocusWithoutCtrlPressed(e, t);
  }
  getNextCellToFocusWithCtrlPressed(e, t) {
    const i = e === S.UP, s = e === S.DOWN, o = e === S.LEFT;
    let r, n;
    if (i || s)
      n = i ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow(), r = t.column;
    else {
      const l = this.columnModel.getAllDisplayedColumns(), a = this.gos.get("enableRtl");
      n = t.rowIndex, r = o !== a ? l[0] : se(l);
    }
    return {
      rowIndex: n,
      rowPinned: null,
      column: r
    };
  }
  getNextCellToFocusWithoutCtrlPressed(e, t) {
    let i = t, s = !1;
    for (; !s; ) {
      switch (e) {
        case S.UP:
          i = this.getCellAbove(i);
          break;
        case S.DOWN:
          i = this.getCellBelow(i);
          break;
        case S.RIGHT:
          this.gos.get("enableRtl") ? i = this.getCellToLeft(i) : i = this.getCellToRight(i);
          break;
        case S.LEFT:
          this.gos.get("enableRtl") ? i = this.getCellToRight(i) : i = this.getCellToLeft(i);
          break;
        default:
          i = null, console.warn("AG Grid: unknown key for navigation " + e);
          break;
      }
      i ? s = this.isCellGoodToFocusOn(i) : s = !0;
    }
    return i;
  }
  isCellGoodToFocusOn(e) {
    const t = e.column;
    let i;
    switch (e.rowPinned) {
      case "top":
        i = this.pinnedRowModel.getPinnedTopRow(e.rowIndex);
        break;
      case "bottom":
        i = this.pinnedRowModel.getPinnedBottomRow(e.rowIndex);
        break;
      default:
        i = this.rowModel.getRow(e.rowIndex);
        break;
    }
    return i ? !t.isSuppressNavigable(i) : !1;
  }
  getCellToLeft(e) {
    if (!e)
      return null;
    const t = this.columnModel.getDisplayedColBefore(e.column);
    return t ? {
      rowIndex: e.rowIndex,
      column: t,
      rowPinned: e.rowPinned
    } : null;
  }
  getCellToRight(e) {
    if (!e)
      return null;
    const t = this.columnModel.getDisplayedColAfter(e.column);
    return t ? {
      rowIndex: e.rowIndex,
      column: t,
      rowPinned: e.rowPinned
    } : null;
  }
  getRowBelow(e) {
    const t = e.rowIndex, i = e.rowPinned;
    if (this.isLastRowInContainer(e))
      switch (i) {
        case "bottom":
          return null;
        case "top":
          return this.rowModel.isRowsToRender() ? { rowIndex: this.paginationProxy.getPageFirstRow(), rowPinned: null } : this.pinnedRowModel.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
        default:
          return this.pinnedRowModel.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
      }
    const s = this.rowModel.getRow(e.rowIndex), o = this.getNextStickyPosition(s);
    return o || { rowIndex: t + 1, rowPinned: i };
  }
  getNextStickyPosition(e, t) {
    if (!this.gos.isGroupRowsSticky() || !e || !e.sticky)
      return;
    const i = this.rowRenderer.getStickyTopRowCtrls().some((l) => l.getRowNode().rowIndex === e.rowIndex);
    let s = [];
    i ? s = [...this.rowRenderer.getStickyTopRowCtrls()].sort(
      (l, a) => l.getRowNode().rowIndex - a.getRowNode().rowIndex
    ) : s = [...this.rowRenderer.getStickyBottomRowCtrls()].sort(
      (l, a) => a.getRowNode().rowIndex - l.getRowNode().rowIndex
    );
    const o = t ? -1 : 1, r = s.findIndex((l) => l.getRowNode().rowIndex === e.rowIndex), n = s[r + o];
    if (n)
      return { rowIndex: n.getRowNode().rowIndex, rowPinned: null };
  }
  getCellBelow(e) {
    if (!e)
      return null;
    const t = this.getRowBelow(e);
    return t ? {
      rowIndex: t.rowIndex,
      column: e.column,
      rowPinned: t.rowPinned
    } : null;
  }
  isLastRowInContainer(e) {
    const t = e.rowPinned, i = e.rowIndex;
    return t === "top" ? this.pinnedRowModel.getPinnedTopRowData().length - 1 <= i : t === "bottom" ? this.pinnedRowModel.getPinnedBottomRowData().length - 1 <= i : this.paginationProxy.getPageLastRow() <= i;
  }
  getRowAbove(e) {
    const t = e.rowIndex, i = e.rowPinned;
    if (i ? t === 0 : t === this.paginationProxy.getPageFirstRow())
      return i === "top" ? null : i ? this.rowModel.isRowsToRender() ? this.getLastBodyCell() : this.pinnedRowModel.isRowsToRender("top") ? this.getLastFloatingTopRow() : null : this.pinnedRowModel.isRowsToRender("top") ? this.getLastFloatingTopRow() : null;
    const o = this.rowModel.getRow(e.rowIndex), r = this.getNextStickyPosition(o, !0);
    return r || { rowIndex: t - 1, rowPinned: i };
  }
  getCellAbove(e) {
    if (!e)
      return null;
    const t = this.getRowAbove({ rowIndex: e.rowIndex, rowPinned: e.rowPinned });
    return t ? {
      rowIndex: t.rowIndex,
      column: e.column,
      rowPinned: t.rowPinned
    } : null;
  }
  getLastBodyCell() {
    return { rowIndex: this.paginationProxy.getPageLastRow(), rowPinned: null };
  }
  getLastFloatingTopRow() {
    return { rowIndex: this.pinnedRowModel.getPinnedTopRowData().length - 1, rowPinned: "top" };
  }
  getNextTabbedCell(e, t) {
    return t ? this.getNextTabbedCellBackwards(e) : this.getNextTabbedCellForwards(e);
  }
  getNextTabbedCellForwards(e) {
    const t = this.columnModel.getAllDisplayedColumns();
    let i = e.rowIndex, s = e.rowPinned, o = this.columnModel.getDisplayedColAfter(e.column);
    if (!o) {
      o = t[0];
      const r = this.getRowBelow(e);
      if (z(r) || !r.rowPinned && !this.paginationProxy.isRowInPage(r))
        return null;
      i = r ? r.rowIndex : null, s = r ? r.rowPinned : null;
    }
    return { rowIndex: i, column: o, rowPinned: s };
  }
  getNextTabbedCellBackwards(e) {
    const t = this.columnModel.getAllDisplayedColumns();
    let i = e.rowIndex, s = e.rowPinned, o = this.columnModel.getDisplayedColBefore(e.column);
    if (!o) {
      o = se(t);
      const r = this.getRowAbove({ rowIndex: e.rowIndex, rowPinned: e.rowPinned });
      if (z(r) || !r.rowPinned && !this.paginationProxy.isRowInPage(r))
        return null;
      i = r ? r.rowIndex : null, s = r ? r.rowPinned : null;
    }
    return { rowIndex: i, column: o, rowPinned: s };
  }
};
u([
  f("columnModel")
], Ni.prototype, "columnModel", 2);
u([
  f("rowModel")
], Ni.prototype, "rowModel", 2);
u([
  f("rowRenderer")
], Ni.prototype, "rowRenderer", 2);
u([
  f("pinnedRowModel")
], Ni.prototype, "pinnedRowModel", 2);
u([
  f("paginationProxy")
], Ni.prototype, "paginationProxy", 2);
Ni = u([
  O("cellNavigationService")
], Ni);
var gs = class extends F {
  constructor() {
    super(...arguments), this.consuming = !1;
  }
  setBeans(e) {
    this.logger = e.create("AlignedGridsService");
  }
  getAlignedGridApis() {
    var e;
    let t = (e = this.gos.get("alignedGrids")) != null ? e : [];
    const i = typeof t == "function";
    typeof t == "function" && (t = t());
    const s = () => `See ${this.getFrameworkOverrides().getDocLink("aligned-grids")}`;
    return t.map((r) => {
      var n;
      if (!r) {
        es("alignedGrids contains an undefined option."), i || es(`You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`), es(s());
        return;
      }
      if (r instanceof J)
        return r;
      const l = r;
      return "current" in l ? (n = l.current) == null ? void 0 : n.api : (l.api || es(`alignedGrids - No api found on the linked grid. If you are passing gridOptions to alignedGrids since v31 this is no longer valid. ${s()}`), l.api);
    }).filter((r) => !!r && !r.isDestroyed());
  }
  init() {
    this.addManagedListener(this.eventService, p.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, p.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, p.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, p.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, p.EVENT_BODY_SCROLL, this.fireScrollEvent.bind(this));
  }
  // common logic across all the fire methods
  fireEvent(e) {
    this.consuming || this.getAlignedGridApis().forEach((t) => {
      if (t.isDestroyed())
        return;
      const i = t.__getAlignedGridService();
      e(i);
    });
  }
  // common logic across all consume methods. very little common logic, however extracting
  // guarantees consistency across the methods.
  onEvent(e) {
    this.consuming = !0, e(), this.consuming = !1;
  }
  fireColumnEvent(e) {
    this.fireEvent((t) => {
      t.onColumnEvent(e);
    });
  }
  fireScrollEvent(e) {
    e.direction === "horizontal" && this.fireEvent((t) => {
      t.onScrollEvent(e);
    });
  }
  onScrollEvent(e) {
    this.onEvent(() => {
      this.ctrlsService.getGridBodyCtrl().getScrollFeature().setHorizontalScrollPosition(e.left, !0);
    });
  }
  getMasterColumns(e) {
    const t = [];
    return e.columns ? e.columns.forEach((i) => {
      t.push(i);
    }) : e.column && t.push(e.column), t;
  }
  getColumnIds(e) {
    const t = [];
    return e.columns ? e.columns.forEach((i) => {
      t.push(i.getColId());
    }) : e.column && t.push(e.column.getColId()), t;
  }
  onColumnEvent(e) {
    this.onEvent(() => {
      switch (e.type) {
        case p.EVENT_COLUMN_MOVED:
        case p.EVENT_COLUMN_VISIBLE:
        case p.EVENT_COLUMN_PINNED:
        case p.EVENT_COLUMN_RESIZED:
          const t = e;
          this.processColumnEvent(t);
          break;
        case p.EVENT_COLUMN_GROUP_OPENED:
          const i = e;
          this.processGroupOpenedEvent(i);
          break;
        case p.EVENT_COLUMN_PIVOT_CHANGED:
          console.warn("AG Grid: pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.");
          break;
      }
    });
  }
  processGroupOpenedEvent(e) {
    e.columnGroups.forEach((t) => {
      let i = null;
      if (t) {
        const s = t.getGroupId();
        i = this.columnModel.getProvidedColumnGroup(s);
      }
      t && !i || (this.logger.log("onColumnEvent-> processing " + e + " expanded = " + t.isExpanded()), this.columnModel.setColumnGroupOpened(i, t.isExpanded(), "alignedGridChanged"));
    });
  }
  processColumnEvent(e) {
    var t;
    const i = e.column;
    let s = null;
    if (i && (s = this.columnModel.getPrimaryColumn(i.getColId())), i && !s)
      return;
    const o = this.getMasterColumns(e);
    switch (e.type) {
      case p.EVENT_COLUMN_MOVED:
        {
          const d = e, h = e.api.getColumnState().map((g) => ({ colId: g.colId }));
          this.columnModel.applyColumnState(
            { state: h, applyOrder: !0 },
            "alignedGridChanged"
          ), this.logger.log(`onColumnEvent-> processing ${e.type} toIndex = ${d.toIndex}`);
        }
        break;
      case p.EVENT_COLUMN_VISIBLE:
        {
          const d = e, h = e.api.getColumnState().map((g) => ({ colId: g.colId, hide: g.hide }));
          this.columnModel.applyColumnState({ state: h }, "alignedGridChanged"), this.logger.log(`onColumnEvent-> processing ${e.type} visible = ${d.visible}`);
        }
        break;
      case p.EVENT_COLUMN_PINNED:
        {
          const d = e, h = e.api.getColumnState().map((g) => ({ colId: g.colId, pinned: g.pinned }));
          this.columnModel.applyColumnState({ state: h }, "alignedGridChanged"), this.logger.log(`onColumnEvent-> processing ${e.type} pinned = ${d.pinned}`);
        }
        break;
      case p.EVENT_COLUMN_RESIZED:
        const l = e, a = {};
        o.forEach((d) => {
          this.logger.log(`onColumnEvent-> processing ${e.type} actualWidth = ${d.getActualWidth()}`), a[d.getId()] = { key: d.getColId(), newWidth: d.getActualWidth() };
        }), (t = l.flexColumns) == null || t.forEach((d) => {
          a[d.getId()] && delete a[d.getId()];
        }), this.columnModel.setColumnWidths(Object.values(a), !1, l.finished, "alignedGridChanged");
        break;
    }
    const n = this.ctrlsService.getGridBodyCtrl().isVerticalScrollShowing();
    this.getAlignedGridApis().forEach((l) => {
      l.setGridOption("alwaysShowVerticalScroll", n);
    });
  }
};
u([
  f("columnModel")
], gs.prototype, "columnModel", 2);
u([
  f("ctrlsService")
], gs.prototype, "ctrlsService", 2);
u([
  Kt(0, Mt("loggerFactory"))
], gs.prototype, "setBeans", 1);
u([
  L
], gs.prototype, "init", 1);
gs = u([
  O("alignedGridsService")
], gs);
var fs = class extends F {
  constructor() {
    super(...arguments), this.selectedNodes = /* @__PURE__ */ new Map(), this.lastRowNode = null;
  }
  init() {
    this.rowSelection = this.gos.get("rowSelection"), this.groupSelectsChildren = this.gos.get("groupSelectsChildren"), this.addManagedPropertyListeners(["groupSelectsChildren", "rowSelection"], () => {
      this.groupSelectsChildren = this.gos.get("groupSelectsChildren"), this.rowSelection = this.gos.get("rowSelection"), this.deselectAllRowNodes({ source: "api" });
    }), this.addManagedListener(this.eventService, p.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
  }
  destroy() {
    super.destroy(), this.resetNodes(), this.lastRowNode = null;
  }
  isMultiselect() {
    return this.rowSelection === "multiple";
  }
  setNodesSelected(e) {
    var t;
    const {
      newValue: i,
      clearSelection: s,
      suppressFinishActions: o,
      rangeSelect: r,
      nodes: n,
      event: l,
      source: a = "api"
    } = e;
    if (n.length === 0)
      return 0;
    if (n.length > 1 && !this.isMultiselect())
      return console.warn("AG Grid: cannot multi select while rowSelection='single'"), 0;
    const d = this.groupSelectsChildren && e.groupSelectsFiltered === !0, c = n.map((g) => g.footer ? g.sibling : g);
    if (r) {
      if (n.length > 1)
        return console.warn("AG Grid: cannot range select while selecting multiple rows"), 0;
      let g = null;
      if (a === "checkboxSelected" && i === !1 && this.lastRowNode && (this.lastRowNode.id ? g = this.lastRowNode : this.lastRowNode = null), g == null && (g = this.getLastSelectedNode()), g) {
        const m = c[0];
        if (m !== g && this.isMultiselect())
          return this.selectRange(m, g, i, a);
      }
    }
    this.lastRowNode = i ? null : c[0];
    let h = 0;
    for (let g = 0; g < c.length; g++) {
      const m = c[g];
      d && m.group || m.selectThisNode(i, l, a) && h++, this.groupSelectsChildren && ((t = m.childrenAfterGroup) != null && t.length) && (h += this.selectChildren(m, i, d, a));
    }
    if (!o && (i && (s || !this.isMultiselect()) && (h += this.clearOtherNodes(c[0], a)), h > 0)) {
      this.updateGroupsFromChildrenSelections(a);
      const m = {
        type: p.EVENT_SELECTION_CHANGED,
        source: a
      };
      this.eventService.dispatchEvent(m);
    }
    return h;
  }
  // selects all rows between this node and the last selected node (or the top if this is the first selection).
  // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
  // holding down 'shift'.
  selectRange(e, t, i = !0, s) {
    const o = this.rowModel.getNodesInRangeForSelection(e, t);
    let r = 0;
    o.forEach((l) => {
      if (l.group && this.groupSelectsChildren)
        return;
      l.selectThisNode(i, void 0, s) && r++;
    }), this.updateGroupsFromChildrenSelections(s);
    const n = {
      type: p.EVENT_SELECTION_CHANGED,
      source: s
    };
    return this.eventService.dispatchEvent(n), r;
  }
  selectChildren(e, t, i, s) {
    const o = i ? e.childrenAfterAggFilter : e.childrenAfterGroup;
    return z(o) ? 0 : this.setNodesSelected({
      newValue: t,
      clearSelection: !1,
      suppressFinishActions: !0,
      groupSelectsFiltered: i,
      source: s,
      nodes: o
    });
  }
  getLastSelectedNode() {
    const e = Array.from(this.selectedNodes.keys());
    if (e.length == 0)
      return null;
    const t = this.selectedNodes.get(se(e));
    return t || null;
  }
  getSelectedNodes() {
    const e = [];
    return this.selectedNodes.forEach((t) => {
      t && e.push(t);
    }), e;
  }
  getSelectedRows() {
    const e = [];
    return this.selectedNodes.forEach((t) => {
      t && t.data && e.push(t.data);
    }), e;
  }
  getSelectionCount() {
    return this.selectedNodes.size;
  }
  /**
   * This method is used by the CSRM to remove groups which are being disposed of,
   * events do not need fired in this case
   */
  filterFromSelection(e) {
    const t = /* @__PURE__ */ new Map();
    this.selectedNodes.forEach((i, s) => {
      i && e(i) && t.set(s, i);
    }), this.selectedNodes = t;
  }
  // should only be called if groupSelectsChildren=true
  updateGroupsFromChildrenSelections(e, t) {
    if (!this.groupSelectsChildren || this.rowModel.getType() !== "clientSide")
      return !1;
    const s = this.rowModel.getRootNode();
    t || (t = new qn(!0, s), t.setInactive());
    let o = !1;
    return t.forEachChangedNodeDepthFirst((r) => {
      if (r !== s) {
        const n = r.calculateSelectedFromChildren();
        o = r.selectThisNode(n === null ? !1 : n, void 0, e) || o;
      }
    }), o;
  }
  clearOtherNodes(e, t) {
    const i = /* @__PURE__ */ new Map();
    let s = 0;
    return this.selectedNodes.forEach((o) => {
      if (o && o.id !== e.id) {
        const r = this.selectedNodes.get(o.id);
        s += r.setSelectedParams({
          newValue: !1,
          clearSelection: !1,
          suppressFinishActions: !0,
          source: t
        }), this.groupSelectsChildren && o.parent && i.set(o.parent.id, o.parent);
      }
    }), i.forEach((o) => {
      const r = o.calculateSelectedFromChildren();
      o.selectThisNode(r === null ? !1 : r, void 0, t);
    }), s;
  }
  onRowSelected(e) {
    const t = e.node;
    this.groupSelectsChildren && t.group || (t.isSelected() ? this.selectedNodes.set(t.id, t) : this.selectedNodes.delete(t.id));
  }
  syncInRowNode(e, t) {
    this.syncInOldRowNode(e, t), this.syncInNewRowNode(e);
  }
  // if the id has changed for the node, then this means the rowNode
  // is getting used for a different data item, which breaks
  // our selectedNodes, as the node now is mapped by the old id
  // which is inconsistent. so to keep the old node as selected,
  // we swap in the clone (with the old id and old data). this means
  // the oldNode is effectively a daemon we keep a reference to,
  // so if client calls api.getSelectedNodes(), it gets the daemon
  // in the result. when the client un-selects, the reference to the
  // daemon is removed. the daemon, because it's an oldNode, is not
  // used by the grid for rendering, it's a copy of what the node used
  // to be like before the id was changed.
  syncInOldRowNode(e, t) {
    if (b(t) && e.id !== t.id && t) {
      const s = t.id;
      this.selectedNodes.get(s) == e && this.selectedNodes.set(t.id, t);
    }
  }
  syncInNewRowNode(e) {
    this.selectedNodes.has(e.id) ? (e.setSelectedInitialValue(!0), this.selectedNodes.set(e.id, e)) : e.setSelectedInitialValue(!1);
  }
  reset(e) {
    const t = this.getSelectionCount();
    if (this.resetNodes(), t) {
      const i = {
        type: p.EVENT_SELECTION_CHANGED,
        source: e
      };
      this.eventService.dispatchEvent(i);
    }
  }
  resetNodes() {
    var e;
    (e = this.selectedNodes) == null || e.clear();
  }
  // returns a list of all nodes at 'best cost' - a feature to be used
  // with groups / trees. if a group has all it's children selected,
  // then the group appears in the result, but not the children.
  // Designed for use with 'children' as the group selection type,
  // where groups don't actually appear in the selection normally.
  getBestCostNodeSelection() {
    if (this.rowModel.getType() !== "clientSide")
      return;
    const t = this.rowModel.getTopLevelNodes();
    if (t === null)
      return;
    const i = [];
    function s(o) {
      for (let r = 0, n = o.length; r < n; r++) {
        const l = o[r];
        if (l.isSelected())
          i.push(l);
        else {
          const a = l;
          a.group && a.children && s(a.children);
        }
      }
    }
    return s(t), i;
  }
  isEmpty() {
    let e = 0;
    return this.selectedNodes.forEach((t) => {
      t && e++;
    }), e === 0;
  }
  deselectAllRowNodes(e) {
    const t = (l) => l.selectThisNode(!1, void 0, s), i = this.rowModel.getType() === "clientSide", { source: s, justFiltered: o, justCurrentPage: r } = e;
    if (r || o) {
      if (!i) {
        console.error("AG Grid: selecting just filtered only works when gridOptions.rowModelType='clientSide'");
        return;
      }
      this.getNodesToSelect(o, r).forEach(t);
    } else
      this.selectedNodes.forEach((l) => {
        l && t(l);
      }), this.reset(s);
    i && this.groupSelectsChildren && this.updateGroupsFromChildrenSelections(s);
    const n = {
      type: p.EVENT_SELECTION_CHANGED,
      source: s
    };
    this.eventService.dispatchEvent(n);
  }
  getSelectedCounts(e, t) {
    let i = 0, s = 0;
    const o = (r) => {
      this.groupSelectsChildren && r.group || (r.isSelected() ? i++ : r.selectable && s++);
    };
    return this.getNodesToSelect(e, t).forEach(o), { selectedCount: i, notSelectedCount: s };
  }
  getSelectAllState(e, t) {
    const { selectedCount: i, notSelectedCount: s } = this.getSelectedCounts(e, t);
    return i === 0 && s === 0 ? !1 : i > 0 && s > 0 ? null : i > 0;
  }
  hasNodesToSelect(e = !1, t = !1) {
    return this.getNodesToSelect(e, t).filter((i) => i.selectable).length > 0;
  }
  /**
   * @param justFiltered whether to just include nodes which have passed the filter
   * @param justCurrentPage whether to just include nodes on the current page
   * @returns all nodes including unselectable nodes which are the target of this selection attempt
   */
  getNodesToSelect(e = !1, t = !1) {
    if (this.rowModel.getType() !== "clientSide")
      throw new Error(`selectAll only available when rowModelType='clientSide', ie not ${this.rowModel.getType()}`);
    const i = [];
    if (t)
      return this.paginationProxy.forEachNodeOnPage((o) => {
        if (!o.group) {
          i.push(o);
          return;
        }
        if (!o.expanded) {
          const r = (n) => {
            var l;
            i.push(n), (l = n.childrenAfterFilter) != null && l.length && n.childrenAfterFilter.forEach(r);
          };
          r(o);
          return;
        }
        this.groupSelectsChildren || i.push(o);
      }), i;
    const s = this.rowModel;
    return e ? (s.forEachNodeAfterFilter((o) => {
      i.push(o);
    }), i) : (s.forEachNode((o) => {
      i.push(o);
    }), i);
  }
  selectAllRowNodes(e) {
    if (this.rowModel.getType() !== "clientSide")
      throw new Error(`selectAll only available when rowModelType='clientSide', ie not ${this.rowModel.getType()}`);
    const { source: t, justFiltered: i, justCurrentPage: s } = e, o = (n) => n.selectThisNode(!0, void 0, t);
    this.getNodesToSelect(i, s).forEach(o), this.rowModel.getType() === "clientSide" && this.groupSelectsChildren && this.updateGroupsFromChildrenSelections(t);
    const r = {
      type: p.EVENT_SELECTION_CHANGED,
      source: t
    };
    this.eventService.dispatchEvent(r);
  }
  getSelectionState() {
    const e = [];
    return this.selectedNodes.forEach((t) => {
      t != null && t.id && e.push(t.id);
    }), e.length ? e : null;
  }
  setSelectionState(e, t) {
    if (!Array.isArray(e))
      return;
    const i = new Set(e), s = [];
    this.rowModel.forEachNode((o) => {
      i.has(o.id) && s.push(o);
    }), this.setNodesSelected({
      newValue: !0,
      nodes: s,
      source: t
    });
  }
};
u([
  f("rowModel")
], fs.prototype, "rowModel", 2);
u([
  f("paginationProxy")
], fs.prototype, "paginationProxy", 2);
u([
  L
], fs.prototype, "init", 1);
fs = u([
  O("selectionService")
], fs);
var eo = class {
  constructor(e) {
    this.viaApi = (t, ...i) => (H(`Since v31, 'columnApi.${t}' is deprecated and moved to 'api.${t}'.`), this.api[t](...i)), this.api = e;
  }
  /** @deprecated v31 use `api.sizeColumnsToFit()` instead.   */
  sizeColumnsToFit(e) {
    this.viaApi("sizeColumnsToFit", e);
  }
  /** @deprecated v31 use `api.setColumnGroupOpened() instead. */
  setColumnGroupOpened(e, t) {
    this.viaApi("setColumnGroupOpened", e, t);
  }
  /** @deprecated v31 use `api.getColumnGroup() instead. */
  getColumnGroup(e, t) {
    return this.viaApi("getColumnGroup", e, t);
  }
  /** @deprecated v31 use `api.getProvidedColumnGroup() instead. */
  getProvidedColumnGroup(e) {
    return this.viaApi("getProvidedColumnGroup", e);
  }
  /** @deprecated v31 use `api.getDisplayNameForColumn() instead. */
  getDisplayNameForColumn(e, t) {
    return this.viaApi("getDisplayNameForColumn", e, t);
  }
  /** @deprecated v31 use `api.getDisplayNameForColumnGroup() instead. */
  getDisplayNameForColumnGroup(e, t) {
    return this.viaApi("getDisplayNameForColumnGroup", e, t);
  }
  /** @deprecated v31 use `api.getColumn() instead. */
  getColumn(e) {
    return this.viaApi("getColumn", e);
  }
  /** @deprecated v31 use `api.getColumns() instead. */
  getColumns() {
    return this.viaApi("getColumns");
  }
  /** @deprecated v31 use `api.applyColumnState() instead. */
  applyColumnState(e) {
    return this.viaApi("applyColumnState", e);
  }
  /** @deprecated v31 use `api.getColumnState() instead. */
  getColumnState() {
    return this.viaApi("getColumnState");
  }
  /** @deprecated v31 use `api.resetColumnState() instead. */
  resetColumnState() {
    this.viaApi("resetColumnState");
  }
  /** @deprecated v31 use `api.getColumnGroupState() instead. */
  getColumnGroupState() {
    return this.viaApi("getColumnGroupState");
  }
  /** @deprecated v31 use `api.setColumnGroupState() instead. */
  setColumnGroupState(e) {
    this.viaApi("setColumnGroupState", e);
  }
  /** @deprecated v31 use `api.resetColumnGroupState() instead. */
  resetColumnGroupState() {
    this.viaApi("resetColumnGroupState");
  }
  /** @deprecated v31 use `api.isPinning() instead. */
  isPinning() {
    return this.viaApi("isPinning");
  }
  /** @deprecated v31 use `api.isPinningLeft() instead. */
  isPinningLeft() {
    return this.viaApi("isPinningLeft");
  }
  /** @deprecated v31 use `api.isPinningRight() instead. */
  isPinningRight() {
    return this.viaApi("isPinningRight");
  }
  /** @deprecated v31 use `api.getDisplayedColAfter() instead. */
  getDisplayedColAfter(e) {
    return this.viaApi("getDisplayedColAfter", e);
  }
  /** @deprecated v31 use `api.getDisplayedColBefore() instead. */
  getDisplayedColBefore(e) {
    return this.viaApi("getDisplayedColBefore", e);
  }
  /** @deprecated v31 use `api.setColumnVisible() instead. */
  setColumnVisible(e, t) {
    this.viaApi("setColumnVisible", e, t);
  }
  /** @deprecated v31 use `api.setColumnsVisible() instead. */
  setColumnsVisible(e, t) {
    this.viaApi("setColumnsVisible", e, t);
  }
  /** @deprecated v31 use `api.setColumnPinned() instead. */
  setColumnPinned(e, t) {
    this.viaApi("setColumnPinned", e, t);
  }
  /** @deprecated v31 use `api.setColumnsPinned() instead. */
  setColumnsPinned(e, t) {
    this.viaApi("setColumnsPinned", e, t);
  }
  /** @deprecated v31 use `api.getAllGridColumns() instead. */
  getAllGridColumns() {
    return this.viaApi("getAllGridColumns");
  }
  /** @deprecated v31 use `api.getDisplayedLeftColumns() instead. */
  getDisplayedLeftColumns() {
    return this.viaApi("getDisplayedLeftColumns");
  }
  /** @deprecated v31 use `api.getDisplayedCenterColumns() instead. */
  getDisplayedCenterColumns() {
    return this.viaApi("getDisplayedCenterColumns");
  }
  /** @deprecated v31 use `api.getDisplayedRightColumns() instead. */
  getDisplayedRightColumns() {
    return this.viaApi("getDisplayedRightColumns");
  }
  /** @deprecated v31 use `api.getAllDisplayedColumns() instead. */
  getAllDisplayedColumns() {
    return this.viaApi("getAllDisplayedColumns");
  }
  /** @deprecated v31 use `api.getAllDisplayedVirtualColumns() instead. */
  getAllDisplayedVirtualColumns() {
    return this.viaApi("getAllDisplayedVirtualColumns");
  }
  /** @deprecated v31 use `api.moveColumn() instead. */
  moveColumn(e, t) {
    this.viaApi("moveColumn", e, t);
  }
  /** @deprecated v31 use `api.moveColumnByIndex() instead. */
  moveColumnByIndex(e, t) {
    this.viaApi("moveColumnByIndex", e, t);
  }
  /** @deprecated v31 use `api.moveColumns() instead. */
  moveColumns(e, t) {
    this.viaApi("moveColumns", e, t);
  }
  /** @deprecated v31 use `api.moveRowGroupColumn() instead. */
  moveRowGroupColumn(e, t) {
    this.viaApi("moveRowGroupColumn", e, t);
  }
  /** @deprecated v31 use `api.setColumnAggFunc() instead. */
  setColumnAggFunc(e, t) {
    this.viaApi("setColumnAggFunc", e, t);
  }
  /** @deprecated v31 use `api.setColumnWidth() instead. */
  setColumnWidth(e, t, i = !0, s) {
    this.viaApi("setColumnWidth", e, t, i, s);
  }
  /** @deprecated v31 use `api.setColumnWidths() instead. */
  setColumnWidths(e, t = !0, i) {
    this.viaApi("setColumnWidths", e, t, i);
  }
  /** @deprecated v31 use `api.setPivotMode() instead. */
  setPivotMode(e) {
    this.viaApi("setPivotMode", e);
  }
  /** @deprecated v31 use `api.isPivotMode() instead. */
  isPivotMode() {
    return this.viaApi("isPivotMode");
  }
  /** @deprecated v31 use `api.getPivotResultColumn() instead. */
  getPivotResultColumn(e, t) {
    return this.viaApi("getPivotResultColumn", e, t);
  }
  /** @deprecated v31 use `api.setValueColumns() instead. */
  setValueColumns(e) {
    this.viaApi("setValueColumns", e);
  }
  /** @deprecated v31 use `api.getValueColumns() instead. */
  getValueColumns() {
    return this.viaApi("getValueColumns");
  }
  /** @deprecated v31 use `api.removeValueColumn() instead. */
  removeValueColumn(e) {
    this.viaApi("removeValueColumn", e);
  }
  /** @deprecated v31 use `api.removeValueColumns() instead. */
  removeValueColumns(e) {
    this.viaApi("removeValueColumns", e);
  }
  /** @deprecated v31 use `api.addValueColumn() instead. */
  addValueColumn(e) {
    this.viaApi("addValueColumn", e);
  }
  /** @deprecated v31 use `api.addValueColumns() instead. */
  addValueColumns(e) {
    this.viaApi("addValueColumns", e);
  }
  /** @deprecated v31 use `api.setRowGroupColumns() instead. */
  setRowGroupColumns(e) {
    this.viaApi("setRowGroupColumns", e);
  }
  /** @deprecated v31 use `api.removeRowGroupColumn() instead. */
  removeRowGroupColumn(e) {
    this.viaApi("removeRowGroupColumn", e);
  }
  /** @deprecated v31 use `api.removeRowGroupColumns() instead. */
  removeRowGroupColumns(e) {
    this.viaApi("removeRowGroupColumns", e);
  }
  /** @deprecated v31 use `api.addRowGroupColumn() instead. */
  addRowGroupColumn(e) {
    this.viaApi("addRowGroupColumn", e);
  }
  /** @deprecated v31 use `api.addRowGroupColumns() instead. */
  addRowGroupColumns(e) {
    this.viaApi("addRowGroupColumns", e);
  }
  /** @deprecated v31 use `api.getRowGroupColumns() instead. */
  getRowGroupColumns() {
    return this.viaApi("getRowGroupColumns");
  }
  /** @deprecated v31 use `api.setPivotColumns() instead. */
  setPivotColumns(e) {
    this.viaApi("setPivotColumns", e);
  }
  /** @deprecated v31 use `api.removePivotColumn() instead. */
  removePivotColumn(e) {
    this.viaApi("removePivotColumn", e);
  }
  /** @deprecated v31 use `api.removePivotColumns() instead. */
  removePivotColumns(e) {
    this.viaApi("removePivotColumns", e);
  }
  /** @deprecated v31 use `api.addPivotColumn() instead. */
  addPivotColumn(e) {
    this.viaApi("addPivotColumn", e);
  }
  /** @deprecated v31 use `api.addPivotColumns() instead. */
  addPivotColumns(e) {
    this.viaApi("addPivotColumns", e);
  }
  /** @deprecated v31 use `api.getPivotColumns() instead. */
  getPivotColumns() {
    return this.viaApi("getPivotColumns");
  }
  /** @deprecated v31 use `api.getLeftDisplayedColumnGroups() instead. */
  getLeftDisplayedColumnGroups() {
    return this.viaApi("getLeftDisplayedColumnGroups");
  }
  /** @deprecated v31 use `api.getCenterDisplayedColumnGroups() instead. */
  getCenterDisplayedColumnGroups() {
    return this.viaApi("getCenterDisplayedColumnGroups");
  }
  /** @deprecated v31 use `api.getRightDisplayedColumnGroups() instead. */
  getRightDisplayedColumnGroups() {
    return this.viaApi("getRightDisplayedColumnGroups");
  }
  /** @deprecated v31 use `api.getAllDisplayedColumnGroups() instead. */
  getAllDisplayedColumnGroups() {
    return this.viaApi("getAllDisplayedColumnGroups");
  }
  /** @deprecated v31 use `api.autoSizeColumn() instead. */
  autoSizeColumn(e, t) {
    return this.viaApi("autoSizeColumn", e, t);
  }
  /** @deprecated v31 use `api.autoSizeColumns() instead. */
  autoSizeColumns(e, t) {
    this.viaApi("autoSizeColumns", e, t);
  }
  /** @deprecated v31 use `api.autoSizeAllColumns() instead. */
  autoSizeAllColumns(e) {
    this.viaApi("autoSizeAllColumns", e);
  }
  /** @deprecated v31 use `api.setPivotResultColumns() instead. */
  setPivotResultColumns(e) {
    this.viaApi("setPivotResultColumns", e);
  }
  /** @deprecated v31 use `api.getPivotResultColumns() instead. */
  getPivotResultColumns() {
    return this.viaApi("getPivotResultColumns");
  }
};
u([
  f("gridApi")
], eo.prototype, "api", 2);
eo = u([
  O("columnApi")
], eo);
var Gi = class extends F {
  constructor() {
    super(...arguments), this.initialised = !1, this.isSsrm = !1;
  }
  init() {
    this.isSsrm = this.gos.isRowModelType("serverSide"), this.cellExpressions = this.gos.get("enableCellExpressions"), this.isTreeData = this.gos.get("treeData"), this.initialised = !0;
    const e = (i) => this.callColumnCellValueChangedHandler(i), t = this.gos.useAsyncEvents();
    this.eventService.addEventListener(p.EVENT_CELL_VALUE_CHANGED, e, t), this.addDestroyFunc(() => this.eventService.removeEventListener(p.EVENT_CELL_VALUE_CHANGED, e, t)), this.addManagedPropertyListener("treeData", (i) => this.isTreeData = i.currentValue);
  }
  getValue(e, t, i = !1, s = !1) {
    if (this.initialised || this.init(), !t)
      return;
    const o = e.getColDef(), r = o.field, n = e.getColId(), l = t.data;
    let a;
    const d = t.groupData && t.groupData[n] !== void 0, c = !s && t.aggData && t.aggData[n] !== void 0, h = this.isSsrm && s && !!e.getColDef().aggFunc, g = this.isSsrm && t.footer && t.field && (e.getColDef().showRowGroup === !0 || e.getColDef().showRowGroup === t.field);
    if (i && o.filterValueGetter ? a = this.executeFilterValueGetter(o.filterValueGetter, l, e, t) : this.isTreeData && c ? a = t.aggData[n] : this.isTreeData && o.valueGetter ? a = this.executeValueGetter(o.valueGetter, l, e, t) : this.isTreeData && r && l ? a = Us(l, r, e.isFieldContainsDots()) : d ? a = t.groupData[n] : c ? a = t.aggData[n] : o.valueGetter ? a = this.executeValueGetter(o.valueGetter, l, e, t) : g ? a = Us(l, t.field, e.isFieldContainsDots()) : r && l && !h && (a = Us(l, r, e.isFieldContainsDots())), this.cellExpressions && typeof a == "string" && a.indexOf("=") === 0) {
      const m = a.substring(1);
      a = this.executeValueGetter(m, l, e, t);
    }
    if (a == null) {
      const m = this.getOpenedGroup(t, e);
      if (m != null)
        return m;
    }
    return a;
  }
  parseValue(e, t, i, s) {
    const o = e.getColDef(), r = this.gos.addGridCommonParams({
      node: t,
      data: t == null ? void 0 : t.data,
      oldValue: s,
      newValue: i,
      colDef: o,
      column: e
    }), n = o.valueParser;
    return b(n) ? typeof n == "function" ? n(r) : this.expressionService.evaluate(n, r) : i;
  }
  formatValue(e, t, i, s, o = !0) {
    let r = null, n;
    const l = e.getColDef();
    if (s ? n = s : o && (n = l.valueFormatter), n) {
      const a = this.gos.addGridCommonParams({
        value: i,
        node: t,
        data: t ? t.data : null,
        colDef: l,
        column: e
      });
      typeof n == "function" ? r = n(a) : r = this.expressionService.evaluate(n, a);
    } else if (l.refData)
      return l.refData[i] || "";
    return r == null && Array.isArray(i) && (r = i.join(", ")), r;
  }
  getOpenedGroup(e, t) {
    if (!this.gos.get("showOpenedGroup") || !t.getColDef().showRowGroup)
      return;
    const s = t.getColDef().showRowGroup;
    let o = e.parent;
    for (; o != null; ) {
      if (o.rowGroupColumn && (s === !0 || s === o.rowGroupColumn.getColId()))
        return o.key;
      o = o.parent;
    }
  }
  /**
   * Sets the value of a GridCell
   * @param rowNode The `RowNode` to be updated
   * @param colKey The `Column` to be updated
   * @param newValue The new value to be set
   * @param eventSource The event source
   * @returns `True` if the value has been updated, otherwise`False`.
   */
  setValue(e, t, i, s) {
    const o = this.columnModel.getPrimaryColumn(t);
    if (!e || !o)
      return !1;
    z(e.data) && (e.data = {});
    const { field: r, valueSetter: n } = o.getColDef();
    if (z(r) && z(n))
      return console.warn("AG Grid: you need either field or valueSetter set on colDef for editing to work"), !1;
    if (!this.dataTypeService.checkType(o, i))
      return console.warn("AG Grid: Data type of the new value does not match the cell data type of the column"), !1;
    const l = this.gos.addGridCommonParams({
      node: e,
      data: e.data,
      oldValue: this.getValue(o, e),
      newValue: i,
      colDef: o.getColDef(),
      column: o
    });
    l.newValue = i;
    let a;
    if (b(n) ? typeof n == "function" ? a = n(l) : a = this.expressionService.evaluate(n, l) : a = this.setValueUsingField(e.data, r, i, o.isFieldContainsDots()), a === void 0 && (a = !0), !a)
      return !1;
    e.resetQuickFilterAggregateText(), this.valueCache.onDataChanged(), l.newValue = this.getValue(o, e);
    const d = {
      type: p.EVENT_CELL_VALUE_CHANGED,
      event: null,
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: l.column,
      api: l.api,
      columnApi: l.columnApi,
      colDef: l.colDef,
      context: l.context,
      data: e.data,
      node: e,
      oldValue: l.oldValue,
      newValue: l.newValue,
      value: l.newValue,
      source: s
    };
    return this.eventService.dispatchEvent(d), !0;
  }
  callColumnCellValueChangedHandler(e) {
    const t = e.colDef.onCellValueChanged;
    typeof t == "function" && this.getFrameworkOverrides().wrapOutgoing(() => {
      t({
        node: e.node,
        data: e.data,
        oldValue: e.oldValue,
        newValue: e.newValue,
        colDef: e.colDef,
        column: e.column,
        api: e.api,
        columnApi: e.columnApi,
        context: e.context
      });
    });
  }
  setValueUsingField(e, t, i, s) {
    if (!t)
      return !1;
    let o = !1;
    if (!s)
      o = e[t] === i, o || (e[t] = i);
    else {
      const r = t.split(".");
      let n = e;
      for (; r.length > 0 && n; ) {
        const l = r.shift();
        r.length === 0 ? (o = n[l] === i, o || (n[l] = i)) : n = n[l];
      }
    }
    return !o;
  }
  executeFilterValueGetter(e, t, i, s) {
    const o = this.gos.addGridCommonParams({
      data: t,
      node: s,
      column: i,
      colDef: i.getColDef(),
      getValue: this.getValueCallback.bind(this, s)
    });
    return typeof e == "function" ? e(o) : this.expressionService.evaluate(e, o);
  }
  executeValueGetter(e, t, i, s) {
    const o = i.getColId(), r = this.valueCache.getValue(s, o);
    if (r !== void 0)
      return r;
    const n = this.gos.addGridCommonParams({
      data: t,
      node: s,
      column: i,
      colDef: i.getColDef(),
      getValue: this.getValueCallback.bind(this, s)
    });
    let l;
    return typeof e == "function" ? l = e(n) : l = this.expressionService.evaluate(e, n), this.valueCache.setValue(s, o, l), l;
  }
  getValueCallback(e, t) {
    const i = this.columnModel.getPrimaryColumn(t);
    return i ? this.getValue(i, e) : null;
  }
  // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
  getKeyForNode(e, t) {
    const i = this.getValue(e, t), s = e.getColDef().keyCreator;
    let o = i;
    if (s) {
      const r = this.gos.addGridCommonParams({
        value: i,
        colDef: e.getColDef(),
        column: e,
        node: t,
        data: t.data
      });
      o = s(r);
    }
    return typeof o == "string" || o == null || (o = String(o), o === "[object Object]" && H("a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se AG Grid docs) or b) to toString() on the object to return a key")), o;
  }
};
u([
  f("expressionService")
], Gi.prototype, "expressionService", 2);
u([
  f("columnModel")
], Gi.prototype, "columnModel", 2);
u([
  f("valueCache")
], Gi.prototype, "valueCache", 2);
u([
  f("dataTypeService")
], Gi.prototype, "dataTypeService", 2);
u([
  L
], Gi.prototype, "init", 1);
Gi = u([
  O("valueService")
], Gi);
var nn = class extends F {
  constructor() {
    super(...arguments), this.expressionToFunctionCache = {};
  }
  setBeans(e) {
    this.logger = e.create("ExpressionService");
  }
  evaluate(e, t) {
    if (typeof e == "string")
      return this.evaluateExpression(e, t);
    console.error("AG Grid: value should be either a string or a function", e);
  }
  evaluateExpression(e, t) {
    try {
      return this.createExpressionFunction(e)(
        t.value,
        t.context,
        t.oldValue,
        t.newValue,
        t.value,
        t.node,
        t.data,
        t.colDef,
        t.rowIndex,
        t.api,
        t.columnApi,
        t.getValue,
        t.column,
        t.columnGroup
      );
    } catch (i) {
      return console.log("Processing of the expression failed"), console.log("Expression = " + e), console.log("Params =", t), console.log("Exception = " + i), null;
    }
  }
  createExpressionFunction(e) {
    if (this.expressionToFunctionCache[e])
      return this.expressionToFunctionCache[e];
    const t = this.createFunctionBody(e), i = new Function("x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, columnApi, getValue, column, columnGroup", t);
    return this.expressionToFunctionCache[e] = i, i;
  }
  createFunctionBody(e) {
    return e.indexOf("return") >= 0 ? e : "return " + e + ";";
  }
};
u([
  Kt(0, Mt("loggerFactory"))
], nn.prototype, "setBeans", 1);
nn = u([
  O("expressionService")
], nn);
var ln = class extends F {
  setBeans(e) {
    this.logging = e.get("debug");
  }
  create(e) {
    return new Xa(e, this.isLogging.bind(this));
  }
  isLogging() {
    return this.logging;
  }
};
u([
  Kt(0, Mt("gridOptionsService"))
], ln.prototype, "setBeans", 1);
ln = u([
  O("loggerFactory")
], ln);
var Xa = class {
  constructor(e, t) {
    this.name = e, this.isLoggingFunc = t;
  }
  isLogging() {
    return this.isLoggingFunc();
  }
  log(e) {
    this.isLoggingFunc() && console.log("AG Grid." + this.name + ": " + e);
  }
}, Ki = class extends F {
  setComp(e, t, i) {
    this.view = e, this.eGridHostDiv = t, this.eGui = i, this.eGui.setAttribute("grid-id", this.context.getGridId()), this.dragAndDropService.addDropTarget({
      getContainer: () => this.eGui,
      isInterestedIn: (o) => o === 1 || o === 0,
      getIconName: () => Y.ICON_NOT_ALLOWED
    }), this.mouseEventService.stampTopLevelGridCompWithGridInstance(t), this.createManagedBean(new kn(this.view)), this.addRtlSupport();
    const s = this.resizeObserverService.observeResize(
      this.eGridHostDiv,
      this.onGridSizeChanged.bind(this)
    );
    this.addDestroyFunc(() => s()), this.ctrlsService.register("gridCtrl", this);
  }
  isDetailGrid() {
    var e;
    const t = this.focusService.findTabbableParent(this.getGui());
    return ((e = t == null ? void 0 : t.getAttribute("row-id")) == null ? void 0 : e.startsWith("detail")) || !1;
  }
  showDropZones() {
    return le.__isRegistered("@ag-grid-enterprise/row-grouping", this.context.getGridId());
  }
  showSideBar() {
    return le.__isRegistered("@ag-grid-enterprise/side-bar", this.context.getGridId());
  }
  showStatusBar() {
    return le.__isRegistered("@ag-grid-enterprise/status-bar", this.context.getGridId());
  }
  showWatermark() {
    return le.__isRegistered("@ag-grid-enterprise/core", this.context.getGridId());
  }
  onGridSizeChanged() {
    const e = {
      type: p.EVENT_GRID_SIZE_CHANGED,
      clientWidth: this.eGridHostDiv.clientWidth,
      clientHeight: this.eGridHostDiv.clientHeight
    };
    this.eventService.dispatchEvent(e);
  }
  addRtlSupport() {
    const e = this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr";
    this.view.setRtlClass(e);
  }
  destroyGridUi() {
    this.view.destroyGridUi();
  }
  getGui() {
    return this.eGui;
  }
  setResizeCursor(e) {
    this.view.setCursor(e ? "ew-resize" : null);
  }
  disableUserSelect(e) {
    this.view.setUserSelect(e ? "none" : null);
  }
  focusNextInnerContainer(e) {
    const t = this.view.getFocusableContainers(), i = this.gos.getActiveDomElement(), o = t.findIndex((r) => r.contains(i)) + (e ? -1 : 1);
    return o <= 0 || o >= t.length ? !1 : this.focusService.focusInto(t[o]);
  }
  focusInnerElement(e) {
    const t = this.view.getFocusableContainers(), i = this.columnModel.getAllDisplayedColumns();
    if (e) {
      if (t.length > 1)
        return this.focusService.focusInto(se(t), !0);
      const s = se(i);
      if (this.focusService.focusGridView(s, !0))
        return !0;
    }
    if (this.gos.get("headerHeight") === 0 || this.gos.get("suppressHeaderFocus")) {
      if (this.focusService.focusGridView(i[0]))
        return !0;
      for (let s = 1; s < t.length; s++)
        if (this.focusService.focusInto(t[s]))
          return !0;
      return !1;
    }
    return this.focusService.focusFirstHeader();
  }
  forceFocusOutOfContainer(e = !1) {
    this.view.forceFocusOutOfContainer(e);
  }
};
u([
  f("focusService")
], Ki.prototype, "focusService", 2);
u([
  f("resizeObserverService")
], Ki.prototype, "resizeObserverService", 2);
u([
  f("columnModel")
], Ki.prototype, "columnModel", 2);
u([
  f("ctrlsService")
], Ki.prototype, "ctrlsService", 2);
u([
  f("mouseEventService")
], Ki.prototype, "mouseEventService", 2);
u([
  f("dragAndDropService")
], Ki.prototype, "dragAndDropService", 2);
var Ar = class extends Rr {
  constructor(t) {
    super(), this.eGridDiv = t;
  }
  postConstruct() {
    this.logger = this.loggerFactory.create("GridComp");
    const t = {
      destroyGridUi: () => this.destroyBean(this),
      setRtlClass: (s) => this.addCssClass(s),
      forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
      updateLayoutClasses: this.updateLayoutClasses.bind(this),
      getFocusableContainers: this.getFocusableContainers.bind(this),
      setUserSelect: (s) => {
        this.getGui().style.userSelect = s ?? "", this.getGui().style.webkitUserSelect = s ?? "";
      },
      setCursor: (s) => {
        this.getGui().style.cursor = s ?? "";
      }
    };
    this.ctrl = this.createManagedBean(new Ki());
    const i = this.createTemplate();
    this.setTemplate(i), this.ctrl.setComp(t, this.eGridDiv, this.getGui()), this.insertGridIntoDom(), this.initialiseTabGuard({
      // we want to override the default behaviour to do nothing for onTabKeyDown
      onTabKeyDown: () => {
      },
      focusInnerElement: (s) => this.ctrl.focusInnerElement(s),
      forceFocusOutWhenTabGuardsAreEmpty: !0
    });
  }
  insertGridIntoDom() {
    const t = this.getGui();
    this.eGridDiv.appendChild(t), this.addDestroyFunc(() => {
      this.eGridDiv.removeChild(t), this.logger.log("Grid removed from DOM");
    });
  }
  updateLayoutClasses(t, i) {
    const s = this.eRootWrapperBody.classList;
    s.toggle("ag-layout-auto-height", i.autoHeight), s.toggle("ag-layout-normal", i.normal), s.toggle("ag-layout-print", i.print), this.addOrRemoveCssClass("ag-layout-auto-height", i.autoHeight), this.addOrRemoveCssClass("ag-layout-normal", i.normal), this.addOrRemoveCssClass("ag-layout-print", i.print);
  }
  createTemplate() {
    const t = this.ctrl.showDropZones() ? "<ag-grid-header-drop-zones></ag-grid-header-drop-zones>" : "", i = this.ctrl.showSideBar() ? '<ag-side-bar ref="sideBar"></ag-side-bar>' : "", s = this.ctrl.showStatusBar() ? '<ag-status-bar ref="statusBar"></ag-status-bar>' : "", o = this.ctrl.showWatermark() ? "<ag-watermark></ag-watermark>" : "";
    return (
      /* html */
      `<div class="ag-root-wrapper" role="presentation">
                ${t}
                <div class="ag-root-wrapper-body" ref="rootWrapperBody" role="presentation">
                    <ag-grid-body ref="gridBody"></ag-grid-body>
                    ${i}
                </div>
                ${s}
                <ag-pagination></ag-pagination>
                ${o}
            </div>`
    );
  }
  getFocusableElement() {
    return this.eRootWrapperBody;
  }
  getFocusableContainers() {
    const t = [
      this.gridBodyComp.getGui()
    ];
    return this.sideBarComp && t.push(
      this.sideBarComp.getGui()
    ), t.filter((i) => wt(i));
  }
};
u([
  f("loggerFactory")
], Ar.prototype, "loggerFactory", 2);
u([
  M("gridBody")
], Ar.prototype, "gridBodyComp", 2);
u([
  M("sideBar")
], Ar.prototype, "sideBarComp", 2);
u([
  M("rootWrapperBody")
], Ar.prototype, "eRootWrapperBody", 2);
u([
  L
], Ar.prototype, "postConstruct", 1);
var ms = class extends F {
  progressSort(e, t, i) {
    const s = this.getNextSortDirection(e);
    this.setSortForColumn(e, s, t, i);
  }
  setSortForColumn(e, t, i, s) {
    t !== "asc" && t !== "desc" && (t = null);
    const o = this.gos.isColumnsSortingCoupledToGroup();
    let r = [e];
    if (o && e.getColDef().showRowGroup) {
      const a = this.columnModel.getSourceColumnsForGroupColumn(e), d = a == null ? void 0 : a.filter((c) => c.isSortable());
      d && (r = [e, ...d]);
    }
    r.forEach((a) => a.setSort(t, s));
    const n = (i || this.gos.get("alwaysMultiSort")) && !this.gos.get("suppressMultiSort"), l = [];
    if (!n) {
      const a = this.clearSortBarTheseColumns(r, s);
      l.push(...a);
    }
    this.updateSortIndex(e), l.push(...r), this.dispatchSortChangedEvents(s, l);
  }
  updateSortIndex(e) {
    const t = this.gos.isColumnsSortingCoupledToGroup(), i = this.columnModel.getGroupDisplayColumnForGroup(e.getId()), s = t && i || e, o = this.getColumnsWithSortingOrdered();
    this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach((l) => l.setSortIndex(null));
    const r = o.filter((l) => t && l.getColDef().showRowGroup ? !1 : l !== s);
    (s.getSort() ? [...r, s] : r).forEach((l, a) => {
      l.setSortIndex(a);
    });
  }
  // gets called by API, so if data changes, use can call this, which will end up
  // working out the sort order again of the rows.
  onSortChanged(e, t) {
    this.dispatchSortChangedEvents(e, t);
  }
  isSortActive() {
    const t = this.columnModel.getPrimaryAndSecondaryAndAutoColumns().filter((i) => !!i.getSort());
    return t && t.length > 0;
  }
  dispatchSortChangedEvents(e, t) {
    const i = {
      type: p.EVENT_SORT_CHANGED,
      source: e
    };
    t && (i.columns = t), this.eventService.dispatchEvent(i);
  }
  clearSortBarTheseColumns(e, t) {
    const i = [];
    return this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach((s) => {
      e.includes(s) || (s.getSort() && i.push(s), s.setSort(void 0, t));
    }), i;
  }
  getNextSortDirection(e) {
    let t;
    if (e.getColDef().sortingOrder ? t = e.getColDef().sortingOrder : this.gos.get("sortingOrder") ? t = this.gos.get("sortingOrder") : t = ms.DEFAULT_SORTING_ORDER, !Array.isArray(t) || t.length <= 0)
      return console.warn(`AG Grid: sortingOrder must be an array with at least one element, currently it's ${t}`), null;
    const i = t.indexOf(e.getSort()), s = i < 0, o = i == t.length - 1;
    let r;
    return s || o ? r = t[0] : r = t[i + 1], ms.DEFAULT_SORTING_ORDER.indexOf(r) < 0 ? (console.warn("AG Grid: invalid sort type " + r), null) : r;
  }
  /**
   * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
   */
  getIndexedSortMap() {
    let e = this.columnModel.getPrimaryAndSecondaryAndAutoColumns().filter((r) => !!r.getSort());
    if (this.columnModel.isPivotMode()) {
      const r = this.gos.isColumnsSortingCoupledToGroup();
      e = e.filter((n) => {
        const l = !!n.getAggFunc(), a = !n.isPrimary(), d = r ? this.columnModel.getGroupDisplayColumnForGroup(n.getId()) : n.getColDef().showRowGroup;
        return l || a || d;
      });
    }
    const t = this.columnModel.getRowGroupColumns().filter((r) => !!r.getSort()), i = {};
    e.forEach((r, n) => i[r.getId()] = n), e.sort((r, n) => {
      const l = r.getSortIndex(), a = n.getSortIndex();
      if (l != null && a != null)
        return l - a;
      if (l == null && a == null) {
        const d = i[r.getId()], c = i[n.getId()];
        return d > c ? 1 : -1;
      } else return a == null ? -1 : 1;
    });
    const s = this.gos.isColumnsSortingCoupledToGroup() && !!t.length;
    s && (e = [
      ...new Set(
        // if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
        e.map((r) => {
          var n;
          return (n = this.columnModel.getGroupDisplayColumnForGroup(r.getId())) != null ? n : r;
        })
      )
    ]);
    const o = /* @__PURE__ */ new Map();
    return e.forEach((r, n) => o.set(r, n)), s && t.forEach((r) => {
      const n = this.columnModel.getGroupDisplayColumnForGroup(r.getId());
      o.set(r, o.get(n));
    }), o;
  }
  getColumnsWithSortingOrdered() {
    return [...this.getIndexedSortMap().entries()].sort(([e, t], [i, s]) => t - s).map(([e]) => e);
  }
  // used by server side row models, to sent sort to server
  getSortModel() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({
      sort: e.getSort(),
      colId: e.getId()
    }));
  }
  getSortOptions() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({
      sort: e.getSort(),
      column: e
    }));
  }
  canColumnDisplayMixedSort(e) {
    const t = this.gos.isColumnsSortingCoupledToGroup(), i = !!e.getColDef().showRowGroup;
    return t && i;
  }
  getDisplaySortForColumn(e) {
    const t = this.columnModel.getSourceColumnsForGroupColumn(e);
    if (!this.canColumnDisplayMixedSort(e) || !(t != null && t.length))
      return e.getSort();
    const s = e.getColDef().field != null || !!e.getColDef().valueGetter ? [e, ...t] : t, o = s[0].getSort();
    return s.every((n) => n.getSort() == o) ? o : "mixed";
  }
  getDisplaySortIndexForColumn(e) {
    return this.getIndexedSortMap().get(e);
  }
};
ms.DEFAULT_SORTING_ORDER = ["asc", "desc", null];
u([
  f("columnModel")
], ms.prototype, "columnModel", 2);
ms = u([
  O("sortController")
], ms);
var he = class extends F {
  static addKeyboardModeEvents(e) {
    this.instanceCount > 0 || (e.addEventListener("keydown", he.toggleKeyboardMode), e.addEventListener("mousedown", he.toggleKeyboardMode));
  }
  static removeKeyboardModeEvents(e) {
    this.instanceCount > 0 || (e.addEventListener("keydown", he.toggleKeyboardMode), e.addEventListener("mousedown", he.toggleKeyboardMode));
  }
  static toggleKeyboardMode(e) {
    const t = he.keyboardModeActive, i = e.type === "keydown";
    i && (e.ctrlKey || e.metaKey || e.altKey) || t !== i && (he.keyboardModeActive = i);
  }
  static unregisterGridCompController(e) {
    he.removeKeyboardModeEvents(e);
  }
  init() {
    const e = this.clearFocusedCell.bind(this);
    this.addManagedListener(this.eventService, p.EVENT_COLUMN_PIVOT_MODE_CHANGED, e), this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverythingChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_COLUMN_GROUP_OPENED, e), this.addManagedListener(this.eventService, p.EVENT_COLUMN_ROW_GROUP_CHANGED, e), this.registerKeyboardFocusEvents(), this.ctrlsService.whenReady((t) => {
      this.gridCtrl = t.gridCtrl;
    });
  }
  registerKeyboardFocusEvents() {
    const e = this.gos.getDocument();
    he.addKeyboardModeEvents(e), he.instanceCount++, this.addDestroyFunc(() => {
      he.instanceCount--, he.unregisterGridCompController(e);
    });
  }
  onColumnEverythingChanged() {
    if (!this.focusedCellPosition)
      return;
    const e = this.focusedCellPosition.column, t = this.columnModel.getGridColumn(e.getId());
    e !== t && this.clearFocusedCell();
  }
  isKeyboardMode() {
    return he.keyboardModeActive;
  }
  // we check if the browser is focusing something, and if it is, and
  // it's the cell we think is focused, then return the cell. so this
  // methods returns the cell if a) we think it has focus and b) the
  // browser thinks it has focus. this then returns nothing if we
  // first focus a cell, then second click outside the grid, as then the
  // grid cell will still be focused as far as the grid is concerned,
  // however the browser focus will have moved somewhere else.
  getFocusCellToUseAfterRefresh() {
    return this.gos.get("suppressFocusAfterRefresh") || !this.focusedCellPosition || this.isDomDataMissingInHierarchy(this.gos.getActiveDomElement(), ls.DOM_DATA_KEY_ROW_CTRL) ? null : this.focusedCellPosition;
  }
  getFocusHeaderToUseAfterRefresh() {
    return this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeaderPosition || this.isDomDataMissingInHierarchy(this.gos.getActiveDomElement(), Kn.DOM_DATA_KEY_HEADER_CTRL) ? null : this.focusedHeaderPosition;
  }
  isDomDataMissingInHierarchy(e, t) {
    let i = e;
    for (; i; ) {
      if (this.gos.getDomData(i, t))
        return !1;
      i = i.parentNode;
    }
    return !0;
  }
  getFocusedCell() {
    return this.focusedCellPosition;
  }
  shouldRestoreFocus(e) {
    return this.isCellRestoreFocused(e) ? (setTimeout(() => {
      this.restoredFocusedCellPosition = null;
    }, 0), !0) : !1;
  }
  isCellRestoreFocused(e) {
    return this.restoredFocusedCellPosition == null ? !1 : this.cellPositionUtils.equals(e, this.restoredFocusedCellPosition);
  }
  setRestoreFocusedCell(e) {
    this.getFrameworkOverrides().renderingEngine === "react" && (this.restoredFocusedCellPosition = e);
  }
  getFocusEventParams() {
    const { rowIndex: e, rowPinned: t, column: i } = this.focusedCellPosition, s = {
      rowIndex: e,
      rowPinned: t,
      column: i,
      isFullWidthCell: !1
    }, o = this.rowRenderer.getRowByPosition({ rowIndex: e, rowPinned: t });
    return o && (s.isFullWidthCell = o.isFullWidth()), s;
  }
  clearFocusedCell() {
    if (this.restoredFocusedCellPosition = null, this.focusedCellPosition == null)
      return;
    const e = _({
      type: p.EVENT_CELL_FOCUS_CLEARED
    }, this.getFocusEventParams());
    this.focusedCellPosition = null, this.eventService.dispatchEvent(e);
  }
  setFocusedCell(e) {
    const {
      column: t,
      rowIndex: i,
      rowPinned: s,
      forceBrowserFocus: o = !1,
      preventScrollOnBrowserFocus: r = !1
    } = e, n = this.columnModel.getGridColumn(t);
    if (!n) {
      this.focusedCellPosition = null;
      return;
    }
    this.focusedCellPosition = n ? {
      rowIndex: i,
      rowPinned: si(s),
      column: n
    } : null;
    const l = Re(_({
      type: p.EVENT_CELL_FOCUSED
    }, this.getFocusEventParams()), {
      forceBrowserFocus: o,
      preventScrollOnBrowserFocus: r,
      floating: null
    });
    this.eventService.dispatchEvent(l);
  }
  isCellFocused(e) {
    return this.focusedCellPosition == null ? !1 : this.cellPositionUtils.equals(e, this.focusedCellPosition);
  }
  isRowNodeFocused(e) {
    return this.isRowFocused(e.rowIndex, e.rowPinned);
  }
  isHeaderWrapperFocused(e) {
    if (this.focusedHeaderPosition == null)
      return !1;
    const t = e.getColumnGroupChild(), i = e.getRowIndex(), s = e.getPinned(), { column: o, headerRowIndex: r } = this.focusedHeaderPosition;
    return t === o && i === r && s == o.getPinned();
  }
  clearFocusedHeader() {
    this.focusedHeaderPosition = null;
  }
  getFocusedHeader() {
    return this.focusedHeaderPosition;
  }
  setFocusedHeader(e, t) {
    this.focusedHeaderPosition = { headerRowIndex: e, column: t };
  }
  focusHeaderPosition(e) {
    if (this.gos.get("suppressHeaderFocus"))
      return !1;
    const { direction: t, fromTab: i, allowUserOverride: s, event: o, fromCell: r, rowWithoutSpanValue: n } = e;
    let { headerPosition: l } = e;
    if (r && this.filterManager.isAdvancedFilterHeaderActive())
      return this.focusAdvancedFilter(l);
    if (s) {
      const a = this.getFocusedHeader(), d = this.headerNavigationService.getHeaderRowCount();
      if (i) {
        const c = this.gos.getCallback("tabToNextHeader");
        c && (l = this.getHeaderPositionFromUserFunc({
          userFunc: c,
          direction: t,
          currentPosition: a,
          headerPosition: l,
          headerRowCount: d
        }));
      } else {
        const c = this.gos.getCallback("navigateToNextHeader");
        if (c && o) {
          const h = {
            key: o.key,
            previousHeaderPosition: a,
            nextHeaderPosition: l,
            headerRowCount: d,
            event: o
          };
          l = c(h);
        }
      }
    }
    return l ? this.focusProvidedHeaderPosition({
      headerPosition: l,
      direction: t,
      event: o,
      fromCell: r,
      rowWithoutSpanValue: n
    }) : !1;
  }
  focusHeaderPositionFromUserFunc(e) {
    if (this.gos.get("suppressHeaderFocus"))
      return !1;
    const { userFunc: t, headerPosition: i, direction: s, event: o } = e, r = this.getFocusedHeader(), n = this.headerNavigationService.getHeaderRowCount(), l = this.getHeaderPositionFromUserFunc({
      userFunc: t,
      direction: s,
      currentPosition: r,
      headerPosition: i,
      headerRowCount: n
    });
    return !!l && this.focusProvidedHeaderPosition({
      headerPosition: l,
      direction: s,
      event: o
    });
  }
  getHeaderPositionFromUserFunc(e) {
    const { userFunc: t, direction: i, currentPosition: s, headerPosition: o, headerRowCount: r } = e, l = t({
      backwards: i === "Before",
      previousHeaderPosition: s,
      nextHeaderPosition: o,
      headerRowCount: r
    });
    return l === !0 || l === null ? (l === null && H("Returning `null` from tabToNextHeader is deprecated. Return `true` to stay on the current header, or `false` to let the browser handle the tab behaviour."), s) : l === !1 ? null : l;
  }
  focusProvidedHeaderPosition(e) {
    const { headerPosition: t, direction: i, fromCell: s, rowWithoutSpanValue: o, event: r } = e;
    if (t.headerRowIndex === -1)
      return this.filterManager.isAdvancedFilterHeaderActive() ? this.focusAdvancedFilter(t) : this.focusGridView(t.column);
    this.headerNavigationService.scrollToColumn(t.column, i);
    const l = this.ctrlsService.getHeaderRowContainerCtrl(t.column.getPinned()).focusHeader(t.headerRowIndex, t.column, r);
    return l && (o != null || s) && this.headerNavigationService.setCurrentHeaderRowWithoutSpan(o ?? -1), l;
  }
  focusFirstHeader() {
    let e = this.columnModel.getAllDisplayedColumns()[0];
    if (!e)
      return !1;
    e.getParent() && (e = this.columnModel.getColumnGroupAtLevel(e, 0));
    const t = this.headerPositionUtils.getHeaderIndexToFocus(e, 0);
    return this.focusHeaderPosition({
      headerPosition: t,
      rowWithoutSpanValue: 0
    });
  }
  focusLastHeader(e) {
    const t = this.headerNavigationService.getHeaderRowCount() - 1, i = se(this.columnModel.getAllDisplayedColumns());
    return this.focusHeaderPosition({
      headerPosition: { headerRowIndex: t, column: i },
      rowWithoutSpanValue: -1,
      event: e
    });
  }
  focusPreviousFromFirstCell(e) {
    return this.filterManager.isAdvancedFilterHeaderActive() ? this.focusAdvancedFilter(null) : this.focusLastHeader(e);
  }
  isAnyCellFocused() {
    return !!this.focusedCellPosition;
  }
  isRowFocused(e, t) {
    return this.focusedCellPosition == null ? !1 : this.focusedCellPosition.rowIndex === e && this.focusedCellPosition.rowPinned === si(t);
  }
  findFocusableElements(e, t, i = !1) {
    const s = uc;
    let o = va;
    t && (o += ", " + t), i && (o += ', [tabindex="-1"]');
    const r = Array.prototype.slice.apply(e.querySelectorAll(s)).filter((a) => wt(a)), n = Array.prototype.slice.apply(e.querySelectorAll(o));
    return n.length ? ((a, d) => a.filter((c) => d.indexOf(c) === -1))(r, n) : r;
  }
  focusInto(e, t = !1, i = !1) {
    const s = this.findFocusableElements(e, null, i), o = t ? se(s) : s[0];
    return o ? (o.focus({ preventScroll: !0 }), !0) : !1;
  }
  findFocusableElementBeforeTabGuard(e, t) {
    if (!t)
      return null;
    const i = this.findFocusableElements(e), s = i.indexOf(t);
    if (s === -1)
      return null;
    let o = -1;
    for (let r = s - 1; r >= 0; r--)
      if (i[r].classList.contains(
        "ag-tab-guard-top"
        /* TAB_GUARD_TOP */
      )) {
        o = r;
        break;
      }
    return o <= 0 ? null : i[o - 1];
  }
  findNextFocusableElement(e = this.eGridDiv, t, i) {
    const s = this.findFocusableElements(e, t ? ':not([tabindex="-1"])' : null), o = this.gos.getActiveDomElement();
    let r;
    t ? r = s.findIndex((l) => l.contains(o)) : r = s.indexOf(o);
    const n = r + (i ? -1 : 1);
    return n < 0 || n >= s.length ? null : s[n];
  }
  isTargetUnderManagedComponent(e, t) {
    if (!t)
      return !1;
    const i = e.querySelectorAll(`.${Hi.FOCUS_MANAGED_CLASS}`);
    if (!i.length)
      return !1;
    for (let s = 0; s < i.length; s++)
      if (i[s].contains(t))
        return !0;
    return !1;
  }
  findTabbableParent(e, t = 5) {
    let i = 0;
    for (; e && Jr(e) === null && ++i <= t; )
      e = e.parentElement;
    return Jr(e) === null ? null : e;
  }
  focusGridView(e, t) {
    var i;
    if (this.gos.get("suppressCellFocus"))
      return t ? this.gos.get("suppressHeaderFocus") ? this.focusNextGridCoreContainer(!0, !0) : this.focusLastHeader() : this.focusNextGridCoreContainer(!1);
    const s = t ? this.rowPositionUtils.getLastRow() : this.rowPositionUtils.getFirstRow();
    if (!s)
      return !1;
    const { rowIndex: o, rowPinned: r } = s, n = this.getFocusedHeader();
    return !e && n && (e = n.column), o == null || !e ? !1 : (this.navigationService.ensureCellVisible({ rowIndex: o, column: e, rowPinned: r }), this.setFocusedCell({
      rowIndex: o,
      column: e,
      rowPinned: si(r),
      forceBrowserFocus: !0
    }), (i = this.rangeService) == null || i.setRangeToCell({ rowIndex: o, rowPinned: r, column: e }), !0);
  }
  focusNextGridCoreContainer(e, t = !1) {
    return !t && this.gridCtrl.focusNextInnerContainer(e) ? !0 : ((t || !e && !this.gridCtrl.isDetailGrid()) && this.gridCtrl.forceFocusOutOfContainer(e), !1);
  }
  focusAdvancedFilter(e) {
    var t, i;
    return this.advancedFilterFocusColumn = e == null ? void 0 : e.column, (i = (t = this.advancedFilterService) == null ? void 0 : t.getCtrl().focusHeaderComp()) != null ? i : !1;
  }
  focusNextFromAdvancedFilter(e, t) {
    var i, s;
    const o = (s = t ? void 0 : this.advancedFilterFocusColumn) != null ? s : (i = this.columnModel.getAllDisplayedColumns()) == null ? void 0 : i[0];
    return e ? this.focusHeaderPosition({
      headerPosition: {
        column: o,
        headerRowIndex: this.headerNavigationService.getHeaderRowCount() - 1
      }
    }) : this.focusGridView(o);
  }
  clearAdvancedFilterColumn() {
    this.advancedFilterFocusColumn = void 0;
  }
};
he.keyboardModeActive = !1;
he.instanceCount = 0;
u([
  f("eGridDiv")
], he.prototype, "eGridDiv", 2);
u([
  f("columnModel")
], he.prototype, "columnModel", 2);
u([
  f("headerNavigationService")
], he.prototype, "headerNavigationService", 2);
u([
  f("headerPositionUtils")
], he.prototype, "headerPositionUtils", 2);
u([
  f("rowRenderer")
], he.prototype, "rowRenderer", 2);
u([
  f("rowPositionUtils")
], he.prototype, "rowPositionUtils", 2);
u([
  f("cellPositionUtils")
], he.prototype, "cellPositionUtils", 2);
u([
  f("navigationService")
], he.prototype, "navigationService", 2);
u([
  f("ctrlsService")
], he.prototype, "ctrlsService", 2);
u([
  f("filterManager")
], he.prototype, "filterManager", 2);
u([
  ue("rangeService")
], he.prototype, "rangeService", 2);
u([
  ue("advancedFilterService")
], he.prototype, "advancedFilterService", 2);
u([
  L
], he.prototype, "init", 1);
he = u([
  O("focusService")
], he);
var jl = class extends F {
  setMouseOver(e) {
    this.selectedColumns = e;
    const t = {
      type: p.EVENT_COLUMN_HOVER_CHANGED
    };
    this.eventService.dispatchEvent(t);
  }
  clearMouseOver() {
    this.selectedColumns = null;
    const e = {
      type: p.EVENT_COLUMN_HOVER_CHANGED
    };
    this.eventService.dispatchEvent(e);
  }
  isHovered(e) {
    return !!this.selectedColumns && this.selectedColumns.indexOf(e) >= 0;
  }
};
jl = u([
  O("columnHoverService")
], jl);
var Jo = class extends F {
  constructor() {
    super(...arguments), this.executeNextFuncs = [], this.executeLaterFuncs = [], this.active = !1, this.suppressAnimation = !1, this.animationThreadCount = 0;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => this.gridBodyCtrl = e.gridBodyCtrl);
  }
  isActive() {
    return this.active && !this.suppressAnimation;
  }
  setSuppressAnimation(e) {
    this.suppressAnimation = e;
  }
  start() {
    this.active || this.gos.get("suppressColumnMoveAnimation") || this.gos.get("enableRtl") || (this.ensureAnimationCssClassPresent(), this.active = !0);
  }
  finish() {
    this.active && this.flush(() => {
      this.active = !1;
    });
  }
  executeNextVMTurn(e) {
    this.active ? this.executeNextFuncs.push(e) : e();
  }
  executeLaterVMTurn(e) {
    this.active ? this.executeLaterFuncs.push(e) : e();
  }
  ensureAnimationCssClassPresent() {
    this.animationThreadCount++;
    const e = this.animationThreadCount;
    this.gridBodyCtrl.setColumnMovingCss(!0), this.executeLaterFuncs.push(() => {
      this.animationThreadCount === e && this.gridBodyCtrl.setColumnMovingCss(!1);
    });
  }
  flush(e) {
    if (this.executeNextFuncs.length === 0 && this.executeLaterFuncs.length === 0) {
      e();
      return;
    }
    const t = (i) => {
      for (; i.length; ) {
        const s = i.pop();
        s && s();
      }
    };
    this.getFrameworkOverrides().wrapIncoming(() => {
      window.setTimeout(() => t(this.executeNextFuncs), 0), window.setTimeout(() => {
        e(), t(this.executeLaterFuncs);
      }, 200);
    });
  }
};
u([
  f("ctrlsService")
], Jo.prototype, "ctrlsService", 2);
u([
  L
], Jo.prototype, "postConstruct", 1);
Jo = u([
  O("columnAnimationService")
], Jo);
var to = class extends F {
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.centerRowsCtrl = e.center, this.addManagedListener(this.eventService, p.EVENT_BODY_HEIGHT_CHANGED, this.checkPageSize.bind(this)), this.addManagedListener(this.eventService, p.EVENT_SCROLL_VISIBILITY_CHANGED, this.checkPageSize.bind(this)), this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this)), this.checkPageSize();
    });
  }
  notActive() {
    return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
  }
  onPaginationAutoSizeChanged() {
    this.notActive() ? this.paginationProxy.unsetAutoCalculatedPageSize() : this.checkPageSize();
  }
  checkPageSize() {
    if (this.notActive())
      return;
    const e = this.centerRowsCtrl.getViewportSizeFeature().getBodyHeight();
    if (e > 0) {
      const t = () => {
        const i = this.gos.getRowHeightAsNumber(), s = Math.floor(e / i);
        this.paginationProxy.setPageSize(s, "autoCalculated");
      };
      this.isBodyRendered ? rt(() => t(), 50)() : (t(), this.isBodyRendered = !0);
    } else
      this.isBodyRendered = !1;
  }
};
u([
  f("ctrlsService")
], to.prototype, "ctrlsService", 2);
u([
  f("paginationProxy")
], to.prototype, "paginationProxy", 2);
u([
  L
], to.prototype, "postConstruct", 1);
to = u([
  O("paginationAutoPageSizeService")
], to);
var an = class extends F {
  constructor() {
    super(...arguments), this.cacheVersion = 0;
  }
  init() {
    this.active = this.gos.get("valueCache"), this.neverExpires = this.gos.get("valueCacheNeverExpires");
  }
  onDataChanged() {
    this.neverExpires || this.expire();
  }
  expire() {
    this.cacheVersion++;
  }
  setValue(e, t, i) {
    this.active && (e.__cacheVersion !== this.cacheVersion && (e.__cacheVersion = this.cacheVersion, e.__cacheData = {}), e.__cacheData[t] = i);
  }
  getValue(e, t) {
    if (!(!this.active || e.__cacheVersion !== this.cacheVersion))
      return e.__cacheData[t];
  }
};
u([
  L
], an.prototype, "init", 1);
an = u([
  O("valueCache")
], an);
var hm = "paste", io = class extends F {
  init() {
    this.rowModel.getType() === "clientSide" && (this.clientSideRowModel = this.rowModel), this.addManagedListener(this.eventService, p.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged.bind(this));
  }
  onCellValueChanged(e) {
    e.source !== hm && this.doChangeDetection(e.node, e.column);
  }
  doChangeDetection(e, t) {
    if (this.gos.get("suppressChangeDetection"))
      return;
    const i = [e];
    if (this.clientSideRowModel && !e.isRowPinned()) {
      const s = this.gos.get("aggregateOnlyChangedColumns"), o = new qn(s, this.clientSideRowModel.getRootNode());
      o.addParentNode(e.parent, [t]), this.clientSideRowModel.doAggregate(o), o.forEachChangedNodeDepthFirst((r) => {
        i.push(r);
      });
    }
    this.rowRenderer.refreshCells({ rowNodes: i });
  }
};
u([
  f("rowModel")
], io.prototype, "rowModel", 2);
u([
  f("rowRenderer")
], io.prototype, "rowRenderer", 2);
u([
  L
], io.prototype, "init", 1);
io = u([
  O("changeDetectionService")
], io);
var dn = class extends F {
  adaptFunction(e, t) {
    const i = this.componentMetadataProvider.retrieve(e);
    return i && i.functionAdapter ? i.functionAdapter(t) : null;
  }
  adaptCellRendererFunction(e) {
    class t {
      refresh(s) {
        return !1;
      }
      getGui() {
        return this.eGui;
      }
      init(s) {
        const o = e(s), r = typeof o;
        if (r === "string" || r === "number" || r === "boolean") {
          this.eGui = Ct("<span>" + o + "</span>");
          return;
        }
        if (o == null) {
          this.eGui = Ct("<span></span>");
          return;
        }
        this.eGui = o;
      }
    }
    return t;
  }
  doesImplementIComponent(e) {
    return e ? e.prototype && "getGui" in e.prototype : !1;
  }
};
u([
  f("componentMetadataProvider")
], dn.prototype, "componentMetadataProvider", 2);
dn = u([
  O("agComponentUtils")
], dn);
var er = class extends F {
  postConstruct() {
    this.componentMetaData = {
      dateComponent: {
        mandatoryMethodList: ["getDate", "setDate"],
        optionalMethodList: ["afterGuiAttached", "setInputPlaceholder", "setInputAriaLabel", "setDisabled", "onParamsUpdated", "refresh"]
      },
      detailCellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ["refresh"],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      headerComponent: {
        mandatoryMethodList: [],
        optionalMethodList: ["refresh"]
      },
      headerGroupComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      loadingCellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: [],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      loadingOverlayComponent: {
        mandatoryMethodList: [],
        optionalMethodList: ["refresh"]
      },
      noRowsOverlayComponent: {
        mandatoryMethodList: [],
        optionalMethodList: ["refresh"]
      },
      floatingFilterComponent: {
        mandatoryMethodList: ["onParentModelChanged"],
        optionalMethodList: ["afterGuiAttached", "onParamsUpdated", "refresh"]
      },
      cellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ["refresh", "afterGuiAttached"],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      cellEditor: {
        mandatoryMethodList: ["getValue"],
        optionalMethodList: ["isPopup", "isCancelBeforeStart", "isCancelAfterEnd", "getPopupPosition", "focusIn", "focusOut", "afterGuiAttached", "refresh"]
      },
      innerRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ["afterGuiAttached"],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      fullWidthCellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ["refresh", "afterGuiAttached"],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      groupRowRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ["afterGuiAttached"],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      filter: {
        mandatoryMethodList: ["isFilterActive", "doesFilterPass", "getModel", "setModel"],
        optionalMethodList: ["afterGuiAttached", "afterGuiDetached", "onNewRowsLoaded", "getModelAsString", "onFloatingFilterChanged", "onAnyFilterChanged", "refresh"]
      },
      statusPanel: {
        mandatoryMethodList: [],
        optionalMethodList: ["refresh"]
      },
      toolPanel: {
        mandatoryMethodList: [],
        optionalMethodList: ["refresh", "getState"]
      },
      tooltipComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      menuItem: {
        mandatoryMethodList: [],
        optionalMethodList: ["setActive", "select", "setExpanded", "configureDefaults"]
      }
    };
  }
  retrieve(e) {
    return this.componentMetaData[e];
  }
};
u([
  f("agComponentUtils")
], er.prototype, "agComponentUtils", 2);
u([
  L
], er.prototype, "postConstruct", 1);
er = u([
  O("componentMetadataProvider")
], er);
var pm = 25, Gd = 10, pl = 8, gm = 4, gl = 4, fl = 6, fm = 16, Od = 14, ml = 8, mm = {
  // this item is required for custom themes
  "ag-theme-custom": {
    headerHeight: 25,
    headerCellMinWidth: 24,
    listItemHeight: gm * 5,
    rowHeight: 25,
    chartMenuPanelWidth: 220
  },
  "ag-theme-material": {
    headerHeight: pl * 7,
    headerCellMinWidth: 48,
    listItemHeight: pl * 4,
    rowHeight: pl * 6,
    chartMenuPanelWidth: 240
  },
  "ag-theme-balham": {
    headerHeight: gl * 8,
    headerCellMinWidth: 24,
    listItemHeight: gl * 6,
    rowHeight: gl * 7,
    chartMenuPanelWidth: 220
  },
  "ag-theme-alpine": {
    headerHeight: fl * 8,
    headerCellMinWidth: 36,
    listItemHeight: fl * 4,
    rowHeight: fl * 7,
    chartMenuPanelWidth: 240
  },
  "ag-theme-quartz": {
    headerHeight: Od + ml * 4.25,
    headerCellMinWidth: 36,
    listItemHeight: fm + ml,
    rowHeight: Od + ml * 3.5,
    chartMenuPanelWidth: 260
  }
}, _d = {
  headerHeight: ["ag-header-row"],
  headerCellMinWidth: ["ag-header-cell"],
  listItemHeight: ["ag-virtual-list-item"],
  rowHeight: ["ag-row"],
  chartMenuPanelWidth: ["ag-chart-docked-container"]
}, tr = class extends F {
  constructor() {
    super(...arguments), this.calculatedSizes = {}, this.calculatedTheme = null;
  }
  postConstruct() {
    var e;
    const t = (e = this.getTheme().el) != null ? e : this.eGridDiv;
    this.addManagedPropertyListener("rowHeight", () => this.refreshRowHeightVariable()), this.mutationObserver = new MutationObserver(() => {
      this.calculatedSizes = {}, this.calculatedTheme = null, this.calculatedTheme = this.getTheme(), this.fireGridStylesChangedEvent();
    }), this.mutationObserver.observe(t || this.eGridDiv, {
      attributes: !0,
      attributeFilter: ["class"]
    });
  }
  fireGridStylesChangedEvent() {
    const e = {
      type: p.EVENT_GRID_STYLES_CHANGED
    };
    this.eventService.dispatchEvent(e);
  }
  getSassVariable(e) {
    const { themeFamily: t, el: i } = this.getTheme();
    if (!t || t.indexOf("ag-theme") !== 0)
      return;
    this.calculatedSizes || (this.calculatedSizes = {}), this.calculatedSizes[t] || (this.calculatedSizes[t] = {});
    const s = this.calculatedSizes[t][e];
    return s ?? (this.calculatedSizes[t][e] = this.calculateValueForSassProperty(e, t, i), this.calculatedSizes[t][e]);
  }
  calculateValueForSassProperty(e, t, i) {
    const s = "ag-theme-" + (t.match("material") ? "material" : t.match("balham") ? "balham" : t.match("alpine") ? "alpine" : "custom"), o = mm[s][e], r = this.gos.getDocument();
    if (i || (i = this.eGridDiv), !_d[e])
      return o;
    const n = _d[e], l = r.createElement("div"), a = Array.from(i.classList);
    l.classList.add(t, ...a), l.style.position = "absolute";
    const d = n.reduce((h, g) => {
      const m = r.createElement("div");
      return m.style.position = "static", m.classList.add(g), h.appendChild(m), m;
    }, l);
    let c = 0;
    if (r.body) {
      r.body.appendChild(l);
      const h = e.toLowerCase().indexOf("height") !== -1 ? "height" : "width";
      c = parseInt(window.getComputedStyle(d)[h], 10), r.body.removeChild(l);
    }
    return c || o;
  }
  isThemeDark() {
    const { theme: e } = this.getTheme();
    return !!e && e.indexOf("dark") >= 0;
  }
  chartMenuPanelWidth() {
    return this.getSassVariable("chartMenuPanelWidth");
  }
  getTheme() {
    if (this.calculatedTheme)
      return this.calculatedTheme;
    const e = /\bag-(material|(?:theme-([\w\-]*)))\b/g;
    let t = this.eGridDiv, i = null, s = [];
    for (; t; )
      if (i = e.exec(t.className), !i)
        t = t.parentElement || void 0;
      else {
        const r = t.className.match(e);
        r && (s = r);
        break;
      }
    if (!i)
      return { allThemes: s };
    const o = i[0];
    return this.calculatedTheme = { theme: o, el: t, themeFamily: o.replace(/-dark$/, ""), allThemes: s }, this.calculatedTheme;
  }
  getFromTheme(e, t) {
    var i;
    return (i = this.getSassVariable(t)) != null ? i : e;
  }
  getDefaultRowHeight() {
    return this.getFromTheme(pm, "rowHeight");
  }
  getListItemHeight() {
    return this.getFromTheme(20, "listItemHeight");
  }
  refreshRowHeightVariable() {
    const e = this.eGridDiv.style.getPropertyValue("--ag-line-height").trim(), t = this.gos.get("rowHeight");
    if (t == null || isNaN(t) || !isFinite(t))
      return e !== null && this.eGridDiv.style.setProperty("--ag-line-height", null), -1;
    const i = `${t}px`;
    return e != i ? (this.eGridDiv.style.setProperty("--ag-line-height", i), t) : e != "" ? parseFloat(e) : -1;
  }
  getMinColWidth() {
    const e = this.getFromTheme(null, "headerCellMinWidth");
    return b(e) ? Math.max(e, Gd) : Gd;
  }
  destroy() {
    this.calculatedSizes = null, this.mutationObserver && this.mutationObserver.disconnect(), super.destroy();
  }
};
u([
  f("eGridDiv")
], tr.prototype, "eGridDiv", 2);
u([
  L
], tr.prototype, "postConstruct", 1);
tr = u([
  O("environment")
], tr);
var so = class extends F {
  constructor() {
    super(...arguments), this.scrollY = 0, this.uiBodyHeight = 0;
  }
  agWire(e) {
    this.logger = e.create("RowContainerHeightService");
  }
  postConstruct() {
    this.addManagedListener(this.eventService, p.EVENT_BODY_HEIGHT_CHANGED, this.updateOffset.bind(this)), this.maxDivHeight = tc(), this.logger.log("maxDivHeight = " + this.maxDivHeight);
  }
  isStretching() {
    return this.stretching;
  }
  getDivStretchOffset() {
    return this.divStretchOffset;
  }
  updateOffset() {
    if (!this.stretching)
      return;
    const t = this.ctrlsService.getGridBodyCtrl().getScrollFeature().getVScrollPosition().top, i = this.getUiBodyHeight();
    (t !== this.scrollY || i !== this.uiBodyHeight) && (this.scrollY = t, this.uiBodyHeight = i, this.calculateOffset());
  }
  calculateOffset() {
    this.setUiContainerHeight(this.maxDivHeight), this.pixelsToShave = this.modelHeight - this.uiContainerHeight, this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
    const e = this.scrollY / this.maxScrollY, t = e * this.pixelsToShave;
    this.logger.log(`Div Stretch Offset = ${t} (${this.pixelsToShave} * ${e})`), this.setDivStretchOffset(t);
  }
  setUiContainerHeight(e) {
    e !== this.uiContainerHeight && (this.uiContainerHeight = e, this.eventService.dispatchEvent({ type: p.EVENT_ROW_CONTAINER_HEIGHT_CHANGED }));
  }
  clearOffset() {
    this.setUiContainerHeight(this.modelHeight), this.pixelsToShave = 0, this.setDivStretchOffset(0);
  }
  setDivStretchOffset(e) {
    const t = typeof e == "number" ? Math.floor(e) : null;
    this.divStretchOffset !== t && (this.divStretchOffset = t, this.eventService.dispatchEvent({ type: p.EVENT_HEIGHT_SCALE_CHANGED }));
  }
  setModelHeight(e) {
    this.modelHeight = e, this.stretching = e != null && this.maxDivHeight > 0 && e > this.maxDivHeight, this.stretching ? this.calculateOffset() : this.clearOffset();
  }
  getUiContainerHeight() {
    return this.uiContainerHeight;
  }
  getRealPixelPosition(e) {
    return e - this.divStretchOffset;
  }
  getUiBodyHeight() {
    const t = this.ctrlsService.getGridBodyCtrl().getScrollFeature().getVScrollPosition();
    return t.bottom - t.top;
  }
  getScrollPositionForPixel(e) {
    if (this.pixelsToShave <= 0)
      return e;
    const t = this.modelHeight - this.getUiBodyHeight(), i = e / t;
    return this.maxScrollY * i;
  }
};
u([
  f("ctrlsService")
], so.prototype, "ctrlsService", 2);
u([
  Kt(0, Mt("loggerFactory"))
], so.prototype, "agWire", 1);
u([
  L
], so.prototype, "postConstruct", 1);
so = u([
  O("rowContainerHeightService")
], so);
var oo = class extends F {
  init() {
    this.addManagedPropertyListener("isRowSelectable", () => this.updateSelectable());
  }
  /**
   * Used by CSRM only, to update selectable state after group state changes.
   */
  updateSelectableAfterGrouping() {
    this.updateSelectable(!0);
  }
  updateSelectable(e = !1) {
    const t = !!this.gos.get("rowSelection"), i = this.gos.get("isRowSelectable");
    if (!t || !i)
      return;
    const s = this.gos.get("groupSelectsChildren"), o = this.rowModel.getType() === "clientSide" && s, r = [], n = (l) => {
      if (e && !l.group)
        return;
      if (o && l.group) {
        const d = l.childrenAfterGroup.some((c) => c.selectable === !0);
        l.setRowSelectable(d, !0);
        return;
      }
      const a = i ? i(l) : !0;
      l.setRowSelectable(a, !0), !a && l.isSelected() && r.push(l);
    };
    if (o) {
      const l = this.rowModel;
      new qn(!1, l.getRootNode()).forEachChangedNodeDepthFirst(n, !0, !0);
    } else
      this.rowModel.forEachNode(n);
    r.length && this.selectionService.setNodesSelected({ nodes: r, newValue: !1, source: "selectableChanged" }), o && this.selectionService instanceof fs && this.selectionService.updateGroupsFromChildrenSelections("selectableChanged");
  }
};
u([
  f("rowModel")
], oo.prototype, "rowModel", 2);
u([
  f("selectionService")
], oo.prototype, "selectionService", 2);
u([
  L
], oo.prototype, "init", 1);
oo = u([
  O("selectableService")
], oo);
var Rt = class extends K {
  constructor() {
    super(), this.previousAndFirstButtonsDisabled = !1, this.nextButtonDisabled = !1, this.lastButtonDisabled = !1, this.areListenersSetup = !1;
  }
  postConstruct() {
    const e = this.gos.get("enableRtl");
    this.setTemplate(this.getTemplate());
    const { btFirst: t, btPrevious: i, btNext: s, btLast: o, pageSizeComp: r } = this;
    this.activateTabIndex([t, i, s, o]), t.insertAdjacentElement("afterbegin", Te(e ? "last" : "first", this.gos)), i.insertAdjacentElement("afterbegin", Te(e ? "next" : "previous", this.gos)), s.insertAdjacentElement("afterbegin", Te(e ? "previous" : "next", this.gos)), o.insertAdjacentElement("afterbegin", Te(e ? "first" : "last", this.gos)), this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this)), this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this)), this.addManagedPropertyListeners(
      ["paginationPageSizeSelector", "paginationAutoPageSize", "suppressPaginationPanel"],
      () => this.onPageSizeRelatedOptionsChange()
    ), this.pageSizeComp.toggleSelectDisplay(
      this.pageSizeComp.shouldShowPageSizeSelector()
    ), this.onPaginationChanged();
  }
  onPaginationChanged() {
    const t = this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel");
    this.setDisplayed(t), t && (this.setupListeners(), this.enableOrDisableButtons(), this.updateRowLabels(), this.setCurrentPageLabel(), this.setTotalLabels(), this.onPageSizeRelatedOptionsChange());
  }
  onPageSizeRelatedOptionsChange() {
    this.pageSizeComp.toggleSelectDisplay(
      this.pageSizeComp.shouldShowPageSizeSelector()
    );
  }
  setupListeners() {
    this.areListenersSetup || (this.addManagedListener(this.eventService, p.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this)), [
      { el: this.btFirst, fn: this.onBtFirst.bind(this) },
      { el: this.btPrevious, fn: this.onBtPrevious.bind(this) },
      { el: this.btNext, fn: this.onBtNext.bind(this) },
      { el: this.btLast, fn: this.onBtLast.bind(this) }
    ].forEach((e) => {
      const { el: t, fn: i } = e;
      this.addManagedListener(t, "click", i), this.addManagedListener(t, "keydown", (s) => {
        (s.key === S.ENTER || s.key === S.SPACE) && (s.preventDefault(), i());
      });
    }), this.areListenersSetup = !0);
  }
  onBtFirst() {
    this.previousAndFirstButtonsDisabled || this.paginationProxy.goToFirstPage();
  }
  setCurrentPageLabel() {
    const e = this.paginationProxy.getTotalPages() > 0, t = this.paginationProxy.getCurrentPage(), i = e ? t + 1 : 0;
    this.lbCurrent.textContent = this.formatNumber(i);
  }
  formatNumber(e) {
    const t = this.gos.getCallback("paginationNumberFormatter");
    if (t)
      return t({ value: e });
    const i = this.localeService.getLocaleTextFunc(), s = i("thousandSeparator", ","), o = i("decimalSeparator", ".");
    return Ca(e, s, o);
  }
  getTemplate() {
    const e = this.localeService.getLocaleTextFunc(), t = e("page", "Page"), i = e("to", "to"), s = e("of", "of"), o = e("firstPage", "First Page"), r = e("previousPage", "Previous Page"), n = e("nextPage", "Next Page"), l = e("lastPage", "Last Page"), a = this.getCompId();
    return (
      /* html */
      `<div class="ag-paging-panel ag-unselectable" id="ag-${a}">
                <ag-page-size-selector ref="pageSizeComp"></ag-page-size-selector>
                <span class="ag-paging-row-summary-panel" role="status">
                    <span id="ag-${a}-first-row" ref="lbFirstRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-${a}-to">${i}</span>
                    <span id="ag-${a}-last-row" ref="lbLastRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-${a}-of">${s}</span>
                    <span id="ag-${a}-row-count" ref="lbRecordCount" class="ag-paging-row-summary-panel-number"></span>
                </span>
                <span class="ag-paging-page-summary-panel" role="presentation">
                    <div ref="btFirst" class="ag-button ag-paging-button" role="button" aria-label="${o}"></div>
                    <div ref="btPrevious" class="ag-button ag-paging-button" role="button" aria-label="${r}"></div>
                    <span class="ag-paging-description" role="status">
                        <span id="ag-${a}-start-page">${t}</span>
                        <span id="ag-${a}-start-page-number" ref="lbCurrent" class="ag-paging-number"></span>
                        <span id="ag-${a}-of-page">${s}</span>
                        <span id="ag-${a}-of-page-number" ref="lbTotal" class="ag-paging-number"></span>
                    </span>
                    <div ref="btNext" class="ag-button ag-paging-button" role="button" aria-label="${n}"></div>
                    <div ref="btLast" class="ag-button ag-paging-button" role="button" aria-label="${l}"></div>
                </span>
            </div>`
    );
  }
  onBtNext() {
    this.nextButtonDisabled || this.paginationProxy.goToNextPage();
  }
  onBtPrevious() {
    this.previousAndFirstButtonsDisabled || this.paginationProxy.goToPreviousPage();
  }
  onBtLast() {
    this.lastButtonDisabled || this.paginationProxy.goToLastPage();
  }
  enableOrDisableButtons() {
    const e = this.paginationProxy.getCurrentPage(), t = this.paginationProxy.isLastPageFound(), i = this.paginationProxy.getTotalPages();
    this.previousAndFirstButtonsDisabled = e === 0, this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled), this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
    const s = this.isZeroPagesToDisplay(), o = e === i - 1;
    this.nextButtonDisabled = o || s, this.lastButtonDisabled = !t || s || e === i - 1, this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled), this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
  }
  toggleButtonDisabled(e, t) {
    la(e, t), e.classList.toggle("ag-disabled", t);
  }
  updateRowLabels() {
    const e = this.paginationProxy.getCurrentPage(), t = this.paginationProxy.getPageSize(), i = this.paginationProxy.isLastPageFound(), s = this.paginationProxy.isLastPageFound() ? this.paginationProxy.getMasterRowCount() : null;
    let o, r;
    if (this.isZeroPagesToDisplay() ? o = r = 0 : (o = t * e + 1, r = o + t - 1, i && r > s && (r = s)), this.lbFirstRowOnPage.textContent = this.formatNumber(o), this.rowNodeBlockLoader.isLoading()) {
      const n = this.localeService.getLocaleTextFunc();
      this.lbLastRowOnPage.innerHTML = n("pageLastRowUnknown", "?");
    } else
      this.lbLastRowOnPage.textContent = this.formatNumber(r);
  }
  isZeroPagesToDisplay() {
    const e = this.paginationProxy.isLastPageFound(), t = this.paginationProxy.getTotalPages();
    return e && t === 0;
  }
  setTotalLabels() {
    const e = this.paginationProxy.isLastPageFound(), t = this.paginationProxy.getTotalPages(), i = e ? this.paginationProxy.getMasterRowCount() : null;
    if (i === 1) {
      const s = this.paginationProxy.getRow(0);
      if (s && s.group && !(s.groupData || s.aggData)) {
        this.setTotalLabelsToZero();
        return;
      }
    }
    if (e)
      this.lbTotal.textContent = this.formatNumber(t), this.lbRecordCount.textContent = this.formatNumber(i);
    else {
      const s = this.localeService.getLocaleTextFunc()("more", "more");
      this.lbTotal.innerHTML = s, this.lbRecordCount.innerHTML = s;
    }
  }
  setTotalLabelsToZero() {
    this.lbFirstRowOnPage.textContent = this.formatNumber(0), this.lbCurrent.textContent = this.formatNumber(0), this.lbLastRowOnPage.textContent = this.formatNumber(0), this.lbTotal.textContent = this.formatNumber(0), this.lbRecordCount.textContent = this.formatNumber(0);
  }
};
u([
  f("paginationProxy")
], Rt.prototype, "paginationProxy", 2);
u([
  f("rowNodeBlockLoader")
], Rt.prototype, "rowNodeBlockLoader", 2);
u([
  M("btFirst")
], Rt.prototype, "btFirst", 2);
u([
  M("btPrevious")
], Rt.prototype, "btPrevious", 2);
u([
  M("btNext")
], Rt.prototype, "btNext", 2);
u([
  M("btLast")
], Rt.prototype, "btLast", 2);
u([
  M("lbRecordCount")
], Rt.prototype, "lbRecordCount", 2);
u([
  M("lbFirstRowOnPage")
], Rt.prototype, "lbFirstRowOnPage", 2);
u([
  M("lbLastRowOnPage")
], Rt.prototype, "lbLastRowOnPage", 2);
u([
  M("lbCurrent")
], Rt.prototype, "lbCurrent", 2);
u([
  M("lbTotal")
], Rt.prototype, "lbTotal", 2);
u([
  M("pageSizeComp")
], Rt.prototype, "pageSizeComp", 2);
u([
  L
], Rt.prototype, "postConstruct", 1);
var Pr = class Hh extends K {
  constructor() {
    super(Hh.TEMPLATE), this.inProgress = !1, this.destroyRequested = !1;
  }
  updateLayoutClasses(t, i) {
    const s = this.eOverlayWrapper.classList;
    s.toggle("ag-layout-auto-height", i.autoHeight), s.toggle("ag-layout-normal", i.normal), s.toggle("ag-layout-print", i.print);
  }
  postConstruct() {
    this.createManagedBean(new kn(this)), this.setDisplayed(!1, { skipAriaHidden: !0 }), this.overlayService.registerOverlayWrapperComp(this);
  }
  setWrapperTypeClass(t) {
    const i = this.eOverlayWrapper.classList;
    this.activeOverlayWrapperCssClass && i.toggle(this.activeOverlayWrapperCssClass, !1), this.activeOverlayWrapperCssClass = t, i.toggle(t, !0);
  }
  showOverlay(t, i, s) {
    this.inProgress || (this.setWrapperTypeClass(i), this.destroyActiveOverlay(), this.inProgress = !0, t && t.then((o) => {
      this.inProgress = !1, this.eOverlayWrapper.appendChild(o.getGui()), this.activeOverlay = o, this.updateListenerDestroyFunc = s, this.destroyRequested && (this.destroyRequested = !1, this.destroyActiveOverlay());
    }), this.setDisplayed(!0, { skipAriaHidden: !0 }));
  }
  destroyActiveOverlay() {
    var t;
    if (this.inProgress) {
      this.destroyRequested = !0;
      return;
    }
    this.activeOverlay && (this.activeOverlay = this.getContext().destroyBean(this.activeOverlay), (t = this.updateListenerDestroyFunc) == null || t.call(this), xe(this.eOverlayWrapper));
  }
  hideOverlay() {
    this.destroyActiveOverlay(), this.setDisplayed(!1, { skipAriaHidden: !0 });
  }
  destroy() {
    this.destroyActiveOverlay(), super.destroy();
  }
};
Pr.TEMPLATE = /* html */
`
        <div class="ag-overlay" role="presentation">
            <div class="ag-overlay-panel" role="presentation">
                <div class="ag-overlay-wrapper" ref="eOverlayWrapper" role="presentation"></div>
            </div>
        </div>`;
u([
  f("overlayService")
], Pr.prototype, "overlayService", 2);
u([
  M("eOverlayWrapper")
], Pr.prototype, "eOverlayWrapper", 2);
u([
  L
], Pr.prototype, "postConstruct", 1);
var Cm = Pr, ro = class extends F {
  getFirstRow() {
    let e = 0, t;
    return this.pinnedRowModel.getPinnedTopRowCount() ? t = "top" : this.rowModel.getRowCount() ? (t = null, e = this.paginationProxy.getPageFirstRow()) : this.pinnedRowModel.getPinnedBottomRowCount() && (t = "bottom"), t === void 0 ? null : { rowIndex: e, rowPinned: t };
  }
  getLastRow() {
    let e, t = null;
    const i = this.pinnedRowModel.getPinnedBottomRowCount(), s = this.pinnedRowModel.getPinnedTopRowCount();
    return i ? (t = "bottom", e = i - 1) : this.rowModel.getRowCount() ? (t = null, e = this.paginationProxy.getPageLastRow()) : s && (t = "top", e = s - 1), e === void 0 ? null : { rowIndex: e, rowPinned: t };
  }
  getRowNode(e) {
    switch (e.rowPinned) {
      case "top":
        return this.pinnedRowModel.getPinnedTopRowData()[e.rowIndex];
      case "bottom":
        return this.pinnedRowModel.getPinnedBottomRowData()[e.rowIndex];
      default:
        return this.rowModel.getRow(e.rowIndex);
    }
  }
  sameRow(e, t) {
    return !e && !t ? !0 : e && !t || !e && t ? !1 : e.rowIndex === t.rowIndex && e.rowPinned == t.rowPinned;
  }
  // tests if this row selection is before the other row selection
  before(e, t) {
    switch (e.rowPinned) {
      case "top":
        if (t.rowPinned !== "top")
          return !0;
        break;
      case "bottom":
        if (t.rowPinned !== "bottom")
          return !1;
        break;
      default:
        if (b(t.rowPinned))
          return t.rowPinned !== "top";
        break;
    }
    return e.rowIndex < t.rowIndex;
  }
};
u([
  f("rowModel")
], ro.prototype, "rowModel", 2);
u([
  f("pinnedRowModel")
], ro.prototype, "pinnedRowModel", 2);
u([
  f("paginationProxy")
], ro.prototype, "paginationProxy", 2);
ro = u([
  O("rowPositionUtils")
], ro);
var Yl = class extends F {
  createId(e) {
    const { rowIndex: t, rowPinned: i, column: s } = e;
    return this.createIdFromValues({ rowIndex: t, column: s, rowPinned: i });
  }
  createIdFromValues(e) {
    const { rowIndex: t, rowPinned: i, column: s } = e;
    return `${t}.${i ?? "null"}.${s.getId()}`;
  }
  equals(e, t) {
    const i = e.column === t.column, s = e.rowPinned === t.rowPinned, o = e.rowIndex === t.rowIndex;
    return i && s && o;
  }
};
Yl = u([
  O("cellPositionUtils")
], Yl);
var Mo = class {
  constructor(e) {
    this.cellValueChanges = e;
  }
}, Cl = class extends Mo {
  constructor(e, t, i, s) {
    super(e), this.initialRange = t, this.finalRange = i, this.ranges = s;
  }
}, kh = class Bh {
  constructor(t) {
    this.actionStack = [], this.maxStackSize = t || Bh.DEFAULT_STACK_SIZE, this.actionStack = new Array(this.maxStackSize);
  }
  pop() {
    return this.actionStack.pop();
  }
  push(t) {
    t.cellValueChanges && t.cellValueChanges.length > 0 && (this.actionStack.length === this.maxStackSize && this.actionStack.shift(), this.actionStack.push(t));
  }
  clear() {
    this.actionStack = [];
  }
  getCurrentStackSize() {
    return this.actionStack.length;
  }
};
kh.DEFAULT_STACK_SIZE = 10;
var Vd = kh, li = class extends F {
  constructor() {
    super(...arguments), this.cellValueChanges = [], this.activeCellEdit = null, this.activeRowEdit = null, this.isPasting = !1, this.isRangeInAction = !1, this.onCellValueChanged = (e) => {
      const t = { column: e.column, rowIndex: e.rowIndex, rowPinned: e.rowPinned }, i = this.activeCellEdit !== null && this.cellPositionUtils.equals(this.activeCellEdit, t), s = this.activeRowEdit !== null && this.rowPositionUtils.sameRow(this.activeRowEdit, t);
      if (!(i || s || this.isPasting || this.isRangeInAction))
        return;
      const { rowPinned: r, rowIndex: n, column: l, oldValue: a, value: d } = e, c = {
        rowPinned: r,
        rowIndex: n,
        columnId: l.getColId(),
        newValue: d,
        oldValue: a
      };
      this.cellValueChanges.push(c);
    }, this.clearStacks = () => {
      this.undoStack.clear(), this.redoStack.clear();
    };
  }
  init() {
    if (!this.gos.get("undoRedoCellEditing"))
      return;
    const e = this.gos.get("undoRedoCellEditingLimit");
    e <= 0 || (this.undoStack = new Vd(e), this.redoStack = new Vd(e), this.addRowEditingListeners(), this.addCellEditingListeners(), this.addPasteListeners(), this.addFillListeners(), this.addCellKeyListeners(), this.addManagedListener(this.eventService, p.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged), this.addManagedListener(this.eventService, p.EVENT_MODEL_UPDATED, (t) => {
      t.keepUndoRedoStack || this.clearStacks();
    }), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearStacks), this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, this.clearStacks), this.addManagedListener(this.eventService, p.EVENT_COLUMN_GROUP_OPENED, this.clearStacks), this.addManagedListener(this.eventService, p.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearStacks), this.addManagedListener(this.eventService, p.EVENT_COLUMN_MOVED, this.clearStacks), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PINNED, this.clearStacks), this.addManagedListener(this.eventService, p.EVENT_COLUMN_VISIBLE, this.clearStacks), this.addManagedListener(this.eventService, p.EVENT_ROW_DRAG_END, this.clearStacks), this.ctrlsService.whenReady((t) => {
      this.gridBodyCtrl = t.gridBodyCtrl;
    }));
  }
  getCurrentUndoStackSize() {
    return this.undoStack ? this.undoStack.getCurrentStackSize() : 0;
  }
  getCurrentRedoStackSize() {
    return this.redoStack ? this.redoStack.getCurrentStackSize() : 0;
  }
  undo(e) {
    const t = {
      type: p.EVENT_UNDO_STARTED,
      source: e
    };
    this.eventService.dispatchEvent(t);
    const i = this.undoRedo(this.undoStack, this.redoStack, "initialRange", "oldValue", "undo"), s = {
      type: p.EVENT_UNDO_ENDED,
      source: e,
      operationPerformed: i
    };
    this.eventService.dispatchEvent(s);
  }
  redo(e) {
    const t = {
      type: p.EVENT_REDO_STARTED,
      source: e
    };
    this.eventService.dispatchEvent(t);
    const i = this.undoRedo(this.redoStack, this.undoStack, "finalRange", "newValue", "redo"), s = {
      type: p.EVENT_REDO_ENDED,
      source: e,
      operationPerformed: i
    };
    this.eventService.dispatchEvent(s);
  }
  undoRedo(e, t, i, s, o) {
    if (!e)
      return !1;
    const r = e.pop();
    return !r || !r.cellValueChanges ? !1 : (this.processAction(r, (n) => n[s], o), r instanceof Cl ? this.processRange(this.rangeService, r.ranges || [r[i]]) : this.processCell(r.cellValueChanges), t.push(r), !0);
  }
  processAction(e, t, i) {
    e.cellValueChanges.forEach((s) => {
      const { rowIndex: o, rowPinned: r, columnId: n } = s, l = { rowIndex: o, rowPinned: r }, a = this.rowPositionUtils.getRowNode(l);
      a.displayed && a.setDataValue(n, t(s), i);
    });
  }
  processRange(e, t) {
    let i;
    e.removeAllCellRanges(!0), t.forEach((s, o) => {
      if (!s)
        return;
      const r = s.startRow, n = s.endRow;
      o === t.length - 1 && (i = {
        rowPinned: r.rowPinned,
        rowIndex: r.rowIndex,
        columnId: s.startColumn.getColId()
      }, this.setLastFocusedCell(i));
      const l = {
        rowStartIndex: r.rowIndex,
        rowStartPinned: r.rowPinned,
        rowEndIndex: n.rowIndex,
        rowEndPinned: n.rowPinned,
        columnStart: s.startColumn,
        columns: s.columns
      };
      e.addCellRange(l);
    });
  }
  processCell(e) {
    const t = e[0], { rowIndex: i, rowPinned: s } = t, o = { rowIndex: i, rowPinned: s }, r = this.rowPositionUtils.getRowNode(o), n = {
      rowPinned: t.rowPinned,
      rowIndex: r.rowIndex,
      columnId: t.columnId
    };
    this.setLastFocusedCell(n, this.rangeService);
  }
  setLastFocusedCell(e, t) {
    const { rowIndex: i, columnId: s, rowPinned: o } = e, r = this.gridBodyCtrl.getScrollFeature(), n = this.columnModel.getGridColumn(s);
    if (!n)
      return;
    r.ensureIndexVisible(i), r.ensureColumnVisible(n);
    const l = { rowIndex: i, column: n, rowPinned: o };
    this.focusService.setFocusedCell(Re(_({}, l), { forceBrowserFocus: !0 })), t == null || t.setRangeToCell(l);
  }
  addRowEditingListeners() {
    this.addManagedListener(this.eventService, p.EVENT_ROW_EDITING_STARTED, (e) => {
      this.activeRowEdit = { rowIndex: e.rowIndex, rowPinned: e.rowPinned };
    }), this.addManagedListener(this.eventService, p.EVENT_ROW_EDITING_STOPPED, () => {
      const e = new Mo(this.cellValueChanges);
      this.pushActionsToUndoStack(e), this.activeRowEdit = null;
    });
  }
  addCellEditingListeners() {
    this.addManagedListener(this.eventService, p.EVENT_CELL_EDITING_STARTED, (e) => {
      this.activeCellEdit = { column: e.column, rowIndex: e.rowIndex, rowPinned: e.rowPinned };
    }), this.addManagedListener(this.eventService, p.EVENT_CELL_EDITING_STOPPED, (e) => {
      if (this.activeCellEdit = null, e.valueChanged && !this.activeRowEdit && !this.isPasting && !this.isRangeInAction) {
        const i = new Mo(this.cellValueChanges);
        this.pushActionsToUndoStack(i);
      }
    });
  }
  addPasteListeners() {
    this.addManagedListener(this.eventService, p.EVENT_PASTE_START, () => {
      this.isPasting = !0;
    }), this.addManagedListener(this.eventService, p.EVENT_PASTE_END, () => {
      const e = new Mo(this.cellValueChanges);
      this.pushActionsToUndoStack(e), this.isPasting = !1;
    });
  }
  addFillListeners() {
    this.addManagedListener(this.eventService, p.EVENT_FILL_START, () => {
      this.isRangeInAction = !0;
    }), this.addManagedListener(this.eventService, p.EVENT_FILL_END, (e) => {
      const t = new Cl(this.cellValueChanges, e.initialRange, e.finalRange);
      this.pushActionsToUndoStack(t), this.isRangeInAction = !1;
    });
  }
  addCellKeyListeners() {
    this.addManagedListener(this.eventService, p.EVENT_KEY_SHORTCUT_CHANGED_CELL_START, () => {
      this.isRangeInAction = !0;
    }), this.addManagedListener(this.eventService, p.EVENT_KEY_SHORTCUT_CHANGED_CELL_END, () => {
      let e;
      this.rangeService && this.gos.get("enableRangeSelection") ? e = new Cl(this.cellValueChanges, void 0, void 0, [...this.rangeService.getCellRanges()]) : e = new Mo(this.cellValueChanges), this.pushActionsToUndoStack(e), this.isRangeInAction = !1;
    });
  }
  pushActionsToUndoStack(e) {
    this.undoStack.push(e), this.cellValueChanges = [], this.redoStack.clear();
  }
};
u([
  f("focusService")
], li.prototype, "focusService", 2);
u([
  f("ctrlsService")
], li.prototype, "ctrlsService", 2);
u([
  f("cellPositionUtils")
], li.prototype, "cellPositionUtils", 2);
u([
  f("rowPositionUtils")
], li.prototype, "rowPositionUtils", 2);
u([
  f("columnModel")
], li.prototype, "columnModel", 2);
u([
  ue("rangeService")
], li.prototype, "rangeService", 2);
u([
  L
], li.prototype, "init", 1);
li = u([
  O("undoRedoService")
], li);
var ir = class extends F {
  findHeader(e, t) {
    let i, s;
    if (e.column instanceof Ke ? i = this.columnModel.getDisplayedGroupAtDirection(e.column, t) : (s = `getDisplayedCol${t}`, i = this.columnModel[s](e.column)), !i)
      return;
    let { headerRowIndex: o } = e;
    if (this.getHeaderRowType(o) !== "filter") {
      const l = [i];
      for (; i.getParent(); )
        i = i.getParent(), l.push(i);
      i = l[l.length - 1 - o];
    }
    const { column: r, headerRowIndex: n } = this.getHeaderIndexToFocus(i, o);
    return {
      column: r,
      headerRowIndex: n
    };
  }
  getHeaderIndexToFocus(e, t) {
    let i;
    if (e instanceof Ke && this.isAnyChildSpanningHeaderHeight(e) && e.isPadding()) {
      const s = e;
      i = s.getLeafColumns()[0];
      let o = i;
      for (; o !== s; )
        t++, o = o.getParent();
    }
    return {
      column: i || e,
      headerRowIndex: t
    };
  }
  isAnyChildSpanningHeaderHeight(e) {
    return e ? e.getLeafColumns().some((t) => t.isSpanHeaderHeight()) : !1;
  }
  getColumnVisibleParent(e, t) {
    const i = this.getHeaderRowType(t), s = i === "filter", o = i === "column";
    let r = s ? e : e.getParent(), n = t - 1, l = n;
    if (o && this.isAnyChildSpanningHeaderHeight(e.getParent())) {
      for (; r && r.isPadding(); )
        r = r.getParent(), n--;
      l = n, n < 0 && (r = e, n = t, l = void 0);
    }
    return { column: r, headerRowIndex: n, headerRowIndexWithoutSpan: l };
  }
  getColumnVisibleChild(e, t, i = "After") {
    const s = this.getHeaderRowType(t);
    let o = e, r = t + 1, n = r;
    if (s === "group") {
      const l = e.getDisplayedLeafColumns(), a = i === "After" ? l[0] : se(l), d = [];
      let c = a;
      for (; c.getParent() !== e; )
        c = c.getParent(), d.push(c);
      if (o = a, a.isSpanHeaderHeight())
        for (let h = d.length - 1; h >= 0; h--) {
          const g = d[h];
          if (!g.isPadding()) {
            o = g;
            break;
          }
          r++;
        }
      else
        o = se(d), o || (o = a);
    }
    return { column: o, headerRowIndex: r, headerRowIndexWithoutSpan: n };
  }
  getHeaderRowType(e) {
    const t = this.ctrlsService.getHeaderRowContainerCtrl();
    if (t)
      return t.getRowType(e);
  }
  findColAtEdgeForHeaderRow(e, t) {
    const i = this.columnModel.getAllDisplayedColumns(), s = i[t === "start" ? 0 : i.length - 1];
    if (!s)
      return;
    const r = this.ctrlsService.getHeaderRowContainerCtrl(s.getPinned()).getRowType(e);
    if (r == "group") {
      const n = this.columnModel.getColumnGroupAtLevel(s, e);
      return {
        headerRowIndex: e,
        column: n
      };
    }
    return {
      // if type==null, means the header level didn't exist
      headerRowIndex: r == null ? -1 : e,
      column: s
    };
  }
};
u([
  f("columnModel")
], ir.prototype, "columnModel", 2);
u([
  f("ctrlsService")
], ir.prototype, "ctrlsService", 2);
ir = u([
  O("headerPositionUtils")
], ir);
var ql = class {
  buildColumnDefs(e, t, i) {
    const s = [], o = {};
    return e.forEach((r) => {
      const n = this.createDefFromColumn(r, t, i);
      let l = !0, a = n, d = r.getOriginalParent(), c = null;
      for (; d; ) {
        let h = null;
        if (d.isPadding()) {
          d = d.getOriginalParent();
          continue;
        }
        const g = o[d.getGroupId()];
        if (g) {
          g.children.push(a), l = !1;
          break;
        }
        if (h = this.createDefFromGroup(d), h && (h.children = [a], o[h.groupId] = h, a = h, d = d.getOriginalParent()), d != null && c === d) {
          l = !1;
          break;
        }
        c = d;
      }
      l && s.push(a);
    }), s;
  }
  createDefFromGroup(e) {
    const t = Yr(e.getColGroupDef(), ["children"]);
    return t && (t.groupId = e.getGroupId()), t;
  }
  createDefFromColumn(e, t, i) {
    const s = Yr(e.getColDef());
    return s.colId = e.getColId(), s.width = e.getActualWidth(), s.rowGroup = e.isRowGroupActive(), s.rowGroupIndex = e.isRowGroupActive() ? t.indexOf(e) : null, s.pivot = e.isPivotActive(), s.pivotIndex = e.isPivotActive() ? i.indexOf(e) : null, s.aggFunc = e.isValueActive() ? e.getAggFunc() : null, s.hide = e.isVisible() ? void 0 : !0, s.pinned = e.isPinned() ? e.getPinned() : null, s.sort = e.getSort() ? e.getSort() : null, s.sortIndex = e.getSortIndex() != null ? e.getSortIndex() : null, s;
  }
};
ql = u([
  O("columnDefFactory")
], ql);
var sr = class {
  getInitialRowClasses(e) {
    const t = [];
    return b(e.extraCssClass) && t.push(e.extraCssClass), t.push("ag-row"), t.push(e.rowFocused ? "ag-row-focus" : "ag-row-no-focus"), e.fadeRowIn && t.push("ag-opacity-zero"), t.push(e.rowIsEven ? "ag-row-even" : "ag-row-odd"), e.rowNode.isRowPinned() && t.push("ag-row-pinned"), e.rowNode.isSelected() && t.push("ag-row-selected"), e.rowNode.footer && t.push("ag-row-footer"), t.push("ag-row-level-" + e.rowLevel), e.rowNode.stub && t.push("ag-row-loading"), e.fullWidthRow && t.push("ag-full-width-row"), e.expandable && (t.push("ag-row-group"), t.push(e.rowNode.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted")), e.rowNode.dragging && t.push("ag-row-dragging"), Ll(t, this.processClassesFromGridOptions(e.rowNode)), Ll(t, this.preProcessRowClassRules(e.rowNode)), t.push(e.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute"), e.firstRowOnPage && t.push("ag-row-first"), e.lastRowOnPage && t.push("ag-row-last"), e.fullWidthRow && (e.pinned === "left" && t.push("ag-cell-last-left-pinned"), e.pinned === "right" && t.push("ag-cell-first-right-pinned")), t;
  }
  processClassesFromGridOptions(e) {
    const t = [], i = (r) => {
      typeof r == "string" ? t.push(r) : Array.isArray(r) && r.forEach((n) => t.push(n));
    }, s = this.gos.get("rowClass");
    if (s) {
      if (typeof s == "function")
        return console.warn("AG Grid: rowClass should not be a function, please use getRowClass instead"), [];
      i(s);
    }
    const o = this.gos.getCallback("getRowClass");
    if (o) {
      const r = {
        data: e.data,
        node: e,
        rowIndex: e.rowIndex
      }, n = o(r);
      i(n);
    }
    return t;
  }
  preProcessRowClassRules(e) {
    const t = [];
    return this.processRowClassRules(
      e,
      (i) => {
        t.push(i);
      },
      (i) => {
      }
    ), t;
  }
  processRowClassRules(e, t, i) {
    const s = this.gos.addGridCommonParams({
      data: e.data,
      node: e,
      rowIndex: e.rowIndex
    });
    this.stylingService.processClassRules(
      void 0,
      this.gos.get("rowClassRules"),
      s,
      t,
      i
    );
  }
  calculateRowLevel(e) {
    return e.group ? e.level : e.parent ? e.parent.level + 1 : 0;
  }
};
u([
  f("stylingService")
], sr.prototype, "stylingService", 2);
u([
  f("gridOptionsService")
], sr.prototype, "gos", 2);
sr = u([
  O("rowCssClassCalculator")
], sr);
var no = class extends F {
  init() {
    this.isAccentedSort = this.gos.get("accentedSort"), this.primaryColumnsSortGroups = this.gos.isColumnsSortingCoupledToGroup(), this.addManagedPropertyListener("accentedSort", (e) => this.isAccentedSort = e.currentValue), this.addManagedPropertyListener("autoGroupColumnDef", () => this.primaryColumnsSortGroups = this.gos.isColumnsSortingCoupledToGroup());
  }
  doFullSort(e, t) {
    const i = (o, r) => ({ currentPos: r, rowNode: o }), s = e.map(i);
    return s.sort(this.compareRowNodes.bind(this, t)), s.map((o) => o.rowNode);
  }
  compareRowNodes(e, t, i) {
    const s = t.rowNode, o = i.rowNode;
    for (let r = 0, n = e.length; r < n; r++) {
      const l = e[r], a = l.sort === "desc", d = this.getValue(s, l.column), c = this.getValue(o, l.column);
      let h;
      const g = this.getComparator(l, s);
      if (g ? h = g(d, c, s, o, a) : h = W.defaultComparator(d, c, this.isAccentedSort), !isNaN(h) && h !== 0)
        return l.sort === "asc" ? h : h * -1;
    }
    return t.currentPos - i.currentPos;
  }
  getComparator(e, t) {
    const i = e.column, s = i.getColDef().comparator;
    if (s != null)
      return s;
    if (!i.getColDef().showRowGroup)
      return;
    const o = !t.group && i.getColDef().field;
    if (!o)
      return;
    const r = this.columnModel.getPrimaryColumn(o);
    if (r)
      return r.getColDef().comparator;
  }
  getValue(e, t) {
    var i, s;
    if (!this.primaryColumnsSortGroups)
      return this.valueService.getValue(t, e, !1, !1);
    if (e.rowGroupColumn === t) {
      if (this.gos.isGroupUseEntireRow(this.columnModel.isPivotActive())) {
        const l = (i = e.allLeafChildren) == null ? void 0 : i[0];
        return l ? this.valueService.getValue(t, l, !1, !1) : void 0;
      }
      const n = this.columnModel.getGroupDisplayColumnForGroup(t.getId());
      return n ? (s = e.groupData) == null ? void 0 : s[n.getId()] : void 0;
    }
    if (!(e.group && t.getColDef().showRowGroup))
      return this.valueService.getValue(t, e, !1, !1);
  }
};
u([
  f("valueService")
], no.prototype, "valueService", 2);
u([
  f("columnModel")
], no.prototype, "columnModel", 2);
u([
  L
], no.prototype, "init", 1);
no = u([
  O("rowNodeSorter")
], no);
var ds = class extends F {
  constructor() {
    super(...arguments), this.params = {}, this.ready = !1, this.readyCallbacks = [];
  }
  checkReady() {
    const e = this.params;
    this.ready = e.gridCtrl != null && e.gridBodyCtrl != null && e.center != null && e.left != null && e.right != null && e.bottomCenter != null && e.bottomLeft != null && e.bottomRight != null && e.topCenter != null && e.topLeft != null && e.topRight != null && e.stickyTopCenter != null && e.stickyTopLeft != null && e.stickyTopRight != null && e.stickyBottomCenter != null && e.stickyBottomLeft != null && e.stickyBottomRight != null && e.centerHeader != null && e.leftHeader != null && e.rightHeader != null && e.fakeHScrollComp != null && e.fakeVScrollComp != null && e.gridHeaderCtrl != null, this.ready && (this.readyCallbacks.forEach((t) => t(e)), this.readyCallbacks.length = 0);
  }
  whenReady(e) {
    this.ready ? e(this.params) : this.readyCallbacks.push(e);
  }
  register(e, t) {
    this.params[e] = t, this.checkReady();
  }
  registerHeaderContainer(e, t) {
    switch (t) {
      case "left":
        this.params.leftHeader = e;
        break;
      case "right":
        this.params.rightHeader = e;
        break;
      default:
        this.params.centerHeader = e;
        break;
    }
    this.checkReady();
  }
  get(e) {
    return this.params[e];
  }
  getParams() {
    return this.params;
  }
  getGridBodyCtrl() {
    return this.params.gridBodyCtrl;
  }
  getHeaderRowContainerCtrls() {
    return [this.params.leftHeader, this.params.rightHeader, this.params.centerHeader];
  }
  getHeaderRowContainerCtrl(e) {
    switch (e) {
      case "left":
        return this.params.leftHeader;
      case "right":
        return this.params.rightHeader;
      default:
        return this.params.centerHeader;
    }
  }
};
ds.NAME = "ctrlsService";
ds = u([
  O(ds.NAME)
], ds);
var Ql = class extends F {
  constructor() {
    super(...arguments), this.registry = {};
  }
  register(e) {
    this.registry[e.controllerName] = e.controllerClass;
  }
  getInstance(e) {
    const t = this.registry[e];
    if (t != null)
      return new t();
  }
};
Ql = u([
  O("ctrlsFactory")
], Ql);
var xs = class extends K {
  constructor(e, t) {
    super(e), this.direction = t, this.hideTimeout = null;
  }
  postConstruct() {
    this.addManagedListener(this.eventService, p.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this)), this.onScrollVisibilityChanged(), this.addOrRemoveCssClass("ag-apple-scrollbar", ga() || vi());
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.invisibleScrollbar = ma(), this.invisibleScrollbar && (this.hideAndShowInvisibleScrollAsNeeded(), this.addActiveListenerToggles()));
  }
  addActiveListenerToggles() {
    const e = ["mouseenter", "mousedown", "touchstart"], t = ["mouseleave", "touchend"], i = this.getGui();
    e.forEach(
      (s) => this.addManagedListener(
        i,
        s,
        () => this.addOrRemoveCssClass("ag-scrollbar-active", !0)
      )
    ), t.forEach(
      (s) => this.addManagedListener(
        i,
        s,
        () => this.addOrRemoveCssClass("ag-scrollbar-active", !1)
      )
    );
  }
  onScrollVisibilityChanged() {
    this.invisibleScrollbar === void 0 && this.initialiseInvisibleScrollbar(), this.animationFrameService.requestAnimationFrame(() => this.setScrollVisible());
  }
  hideAndShowInvisibleScrollAsNeeded() {
    this.addManagedListener(this.eventService, p.EVENT_BODY_SCROLL, (e) => {
      e.direction === this.direction && (this.hideTimeout !== null && (window.clearTimeout(this.hideTimeout), this.hideTimeout = null), this.addOrRemoveCssClass("ag-scrollbar-scrolling", !0));
    }), this.addManagedListener(this.eventService, p.EVENT_BODY_SCROLL_END, () => {
      this.hideTimeout = window.setTimeout(() => {
        this.addOrRemoveCssClass("ag-scrollbar-scrolling", !1), this.hideTimeout = null;
      }, 400);
    });
  }
  attemptSettingScrollPosition(e) {
    const t = this.getViewport();
    ta(() => wt(t), () => this.setScrollPosition(e), 100);
  }
  getViewport() {
    return this.eViewport;
  }
  getContainer() {
    return this.eContainer;
  }
  onScrollCallback(e) {
    this.addManagedListener(this.getViewport(), "scroll", e);
  }
};
u([
  M("eViewport")
], xs.prototype, "eViewport", 2);
u([
  M("eContainer")
], xs.prototype, "eContainer", 2);
u([
  f("scrollVisibleService")
], xs.prototype, "scrollVisibleService", 2);
u([
  f("ctrlsService")
], xs.prototype, "ctrlsService", 2);
u([
  f("animationFrameService")
], xs.prototype, "animationFrameService", 2);
var Ns = class Wh extends xs {
  constructor() {
    super(Wh.TEMPLATE, "horizontal");
  }
  postConstruct() {
    super.postConstruct();
    const t = this.setFakeHScrollSpacerWidths.bind(this);
    this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, t), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, t), this.addManagedListener(this.eventService, p.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this)), this.addManagedPropertyListener("domLayout", t), this.ctrlsService.register("fakeHScrollComp", this), this.createManagedBean(new co((i) => this.eContainer.style.width = `${i}px`)), this.addManagedPropertyListeners(["suppressHorizontalScroll"], this.onScrollVisibilityChanged.bind(this));
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.enableRtl = this.gos.get("enableRtl"), super.initialiseInvisibleScrollbar(), this.invisibleScrollbar && this.refreshCompBottom());
  }
  onPinnedRowDataChanged() {
    this.refreshCompBottom();
  }
  refreshCompBottom() {
    if (!this.invisibleScrollbar)
      return;
    const t = this.pinnedRowModel.getPinnedBottomTotalHeight();
    this.getGui().style.bottom = `${t}px`;
  }
  onScrollVisibilityChanged() {
    super.onScrollVisibilityChanged(), this.setFakeHScrollSpacerWidths();
  }
  setFakeHScrollSpacerWidths() {
    const t = this.scrollVisibleService.isVerticalScrollShowing();
    let i = this.columnModel.getDisplayedColumnsRightWidth();
    const s = !this.enableRtl && t, o = this.gos.getScrollbarWidth();
    s && (i += o), Gt(this.eRightSpacer, i), this.eRightSpacer.classList.toggle("ag-scroller-corner", i <= o);
    let r = this.columnModel.getDisplayedColumnsLeftWidth();
    this.enableRtl && t && (r += o), Gt(this.eLeftSpacer, r), this.eLeftSpacer.classList.toggle("ag-scroller-corner", r <= o);
  }
  setScrollVisible() {
    const t = this.scrollVisibleService.isHorizontalScrollShowing(), i = this.invisibleScrollbar, s = this.gos.get("suppressHorizontalScroll"), o = t && this.gos.getScrollbarWidth() || 0, n = s ? 0 : o === 0 && i ? 16 : o;
    this.addOrRemoveCssClass("ag-scrollbar-invisible", i), rs(this.getGui(), n), rs(this.eViewport, n), rs(this.eContainer, n), this.setDisplayed(t, { skipAriaHidden: !0 });
  }
  getScrollPosition() {
    return Ko(this.getViewport(), this.enableRtl);
  }
  setScrollPosition(t) {
    wt(this.getViewport()) || this.attemptSettingScrollPosition(t), $o(this.getViewport(), t, this.enableRtl);
  }
};
Ns.TEMPLATE = /* html */
`<div class="ag-body-horizontal-scroll" aria-hidden="true">
            <div class="ag-horizontal-left-spacer" ref="eLeftSpacer"></div>
            <div class="ag-body-horizontal-scroll-viewport" ref="eViewport">
                <div class="ag-body-horizontal-scroll-container" ref="eContainer"></div>
            </div>
            <div class="ag-horizontal-right-spacer" ref="eRightSpacer"></div>
        </div>`;
u([
  M("eLeftSpacer")
], Ns.prototype, "eLeftSpacer", 2);
u([
  M("eRightSpacer")
], Ns.prototype, "eRightSpacer", 2);
u([
  f("columnModel")
], Ns.prototype, "columnModel", 2);
u([
  f("pinnedRowModel")
], Ns.prototype, "pinnedRowModel", 2);
u([
  L
], Ns.prototype, "postConstruct", 1);
var vm = Ns, or = class extends F {
  postConstruct() {
    const e = this.checkContainerWidths.bind(this);
    this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_CHANGED, e), this.addManagedListener(this.eventService, p.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, e), this.addManagedPropertyListener("domLayout", e);
  }
  checkContainerWidths() {
    const e = this.gos.isDomLayout("print"), t = e ? 0 : this.columnModel.getDisplayedColumnsLeftWidth(), i = e ? 0 : this.columnModel.getDisplayedColumnsRightWidth();
    t != this.leftWidth && (this.leftWidth = t, this.eventService.dispatchEvent({ type: p.EVENT_LEFT_PINNED_WIDTH_CHANGED })), i != this.rightWidth && (this.rightWidth = i, this.eventService.dispatchEvent({ type: p.EVENT_RIGHT_PINNED_WIDTH_CHANGED }));
  }
  getPinnedRightWidth() {
    return this.rightWidth;
  }
  getPinnedLeftWidth() {
    return this.leftWidth;
  }
};
u([
  f("columnModel")
], or.prototype, "columnModel", 2);
u([
  L
], or.prototype, "postConstruct", 1);
or = u([
  O("pinnedWidthService")
], or);
var lo = class extends F {
  constructor() {
    super(...arguments), this.events = [];
  }
  postConstruct() {
    this.rowModel.getType() == "clientSide" && (this.clientSideRowModel = this.rowModel);
  }
  // because the user can call rowNode.setExpanded() many times in one VM turn,
  // we throttle the calls to ClientSideRowModel using animationFrameService. this means for 100
  // row nodes getting expanded, we only update the CSRM once, and then we fire all events after
  // CSRM has updated.
  //
  // if we did not do this, then the user could call setExpanded on 100+ rows, causing the grid
  // to re-render 100+ times, which would be a performance lag.
  //
  // we use animationFrameService
  // rather than _.debounce() so this will get done if anyone flushes the animationFrameService
  // (eg user calls api.ensureRowVisible(), which in turn flushes ).
  dispatchExpanded(e, t) {
    if (this.clientSideRowModel == null) {
      this.eventService.dispatchEvent(e);
      return;
    }
    this.events.push(e);
    const i = () => {
      this.clientSideRowModel && this.clientSideRowModel.onRowGroupOpened(), this.events.forEach((s) => this.eventService.dispatchEvent(s)), this.events = [];
    };
    t ? i() : (this.dispatchExpandedDebounced == null && (this.dispatchExpandedDebounced = this.animationFrameService.debounce(i)), this.dispatchExpandedDebounced());
  }
};
u([
  f("animationFrameService")
], lo.prototype, "animationFrameService", 2);
u([
  f("rowModel")
], lo.prototype, "rowModel", 2);
u([
  L
], lo.prototype, "postConstruct", 1);
lo = u([
  O("rowNodeEventThrottle")
], lo);
var wm = {
  columnsMenuParams: { version: "31.1", message: "Use `columnChooserParams` instead." },
  suppressMenu: { version: "31.1", message: "Use `suppressHeaderMenuButton` instead." },
  suppressCellFlash: { version: "31.2", message: "Use `enableCellChangeFlash={false}` in the ColDef" },
  dndSource: { version: "31.2", message: "This feature has been replaced by `Row Dragging to an External DropZone`." },
  dndSourceOnRowDrag: { version: "31.2", message: "This feature has been replaced by `Row Dragging to an External DropZone`." }
}, Ti = (e, t) => {
  var i;
  return ((i = t.rowModelType) != null ? i : "clientSide") === "clientSide" ? {
    module: "@ag-grid-enterprise/row-grouping"
    /* RowGroupingModule */
  } : null;
}, Sm = {
  // supported on all row models, but need module for client side.
  enableRowGroup: Ti,
  rowGroup: Ti,
  rowGroupIndex: Ti,
  enablePivot: Ti,
  enableValue: Ti,
  pivot: Ti,
  pivotIndex: Ti,
  aggFunc: Ti,
  cellEditor: (e) => e.cellEditor === "agRichSelect" || e.cellEditor === "agRichSelectCellEditor" ? {
    module: "@ag-grid-enterprise/rich-select"
    /* RichSelectModule */
  } : null,
  menuTabs: (e) => {
    var t;
    const i = ["columnsMenuTab", "generalMenuTab"];
    return (t = e.menuTabs) != null && t.some((s) => i.includes(s)) ? {
      module: "@ag-grid-enterprise/menu"
      /* MenuModule */
    } : null;
  },
  columnsMenuParams: {
    module: [
      "@ag-grid-enterprise/menu",
      "@ag-grid-enterprise/column-tool-panel"
      /* ColumnsToolPanelModule */
    ]
  },
  columnChooserParams: {
    module: [
      "@ag-grid-enterprise/menu",
      "@ag-grid-enterprise/column-tool-panel"
      /* ColumnsToolPanelModule */
    ]
  },
  headerCheckboxSelection: {
    supportedRowModels: ["clientSide", "serverSide"],
    dependencies: (e, { rowSelection: t }) => t === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple"
  },
  headerCheckboxSelectionFilteredOnly: {
    supportedRowModels: ["clientSide"],
    dependencies: (e, { rowSelection: t }) => t === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple"
  },
  headerCheckboxSelectionCurrentPageOnly: {
    supportedRowModels: ["clientSide"],
    dependencies: (e, { rowSelection: t }) => t === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple"
  },
  children: () => Ws
}, Em = {
  headerName: void 0,
  columnGroupShow: void 0,
  headerClass: void 0,
  toolPanelClass: void 0,
  headerValueGetter: void 0,
  pivotKeys: void 0,
  groupId: void 0,
  colId: void 0,
  sort: void 0,
  initialSort: void 0,
  field: void 0,
  type: void 0,
  cellDataType: void 0,
  tooltipComponent: void 0,
  tooltipField: void 0,
  headerTooltip: void 0,
  cellClass: void 0,
  showRowGroup: void 0,
  filter: void 0,
  initialAggFunc: void 0,
  defaultAggFunc: void 0,
  aggFunc: void 0,
  pinned: void 0,
  initialPinned: void 0,
  chartDataType: void 0,
  cellAriaRole: void 0,
  cellEditorPopupPosition: void 0,
  headerGroupComponent: void 0,
  headerGroupComponentParams: void 0,
  cellStyle: void 0,
  cellRenderer: void 0,
  cellRendererParams: void 0,
  cellEditor: void 0,
  cellEditorParams: void 0,
  filterParams: void 0,
  pivotValueColumn: void 0,
  headerComponent: void 0,
  headerComponentParams: void 0,
  floatingFilterComponent: void 0,
  floatingFilterComponentParams: void 0,
  tooltipComponentParams: void 0,
  refData: void 0,
  columnsMenuParams: void 0,
  columnChooserParams: void 0,
  children: void 0,
  sortingOrder: void 0,
  allowedAggFuncs: void 0,
  menuTabs: void 0,
  pivotTotalColumnIds: void 0,
  cellClassRules: void 0,
  icons: void 0,
  sortIndex: void 0,
  initialSortIndex: void 0,
  flex: void 0,
  initialFlex: void 0,
  width: void 0,
  initialWidth: void 0,
  minWidth: void 0,
  maxWidth: void 0,
  rowGroupIndex: void 0,
  initialRowGroupIndex: void 0,
  pivotIndex: void 0,
  initialPivotIndex: void 0,
  suppressCellFlash: void 0,
  suppressColumnsToolPanel: void 0,
  suppressFiltersToolPanel: void 0,
  openByDefault: void 0,
  marryChildren: void 0,
  suppressStickyLabel: void 0,
  hide: void 0,
  initialHide: void 0,
  rowGroup: void 0,
  initialRowGroup: void 0,
  pivot: void 0,
  initialPivot: void 0,
  checkboxSelection: void 0,
  showDisabledCheckboxes: void 0,
  headerCheckboxSelection: void 0,
  headerCheckboxSelectionFilteredOnly: void 0,
  headerCheckboxSelectionCurrentPageOnly: void 0,
  suppressMenu: void 0,
  suppressHeaderMenuButton: void 0,
  suppressMovable: void 0,
  lockPosition: void 0,
  lockVisible: void 0,
  lockPinned: void 0,
  unSortIcon: void 0,
  suppressSizeToFit: void 0,
  suppressAutoSize: void 0,
  enableRowGroup: void 0,
  enablePivot: void 0,
  enableValue: void 0,
  editable: void 0,
  suppressPaste: void 0,
  suppressNavigable: void 0,
  enableCellChangeFlash: void 0,
  rowDrag: void 0,
  dndSource: void 0,
  autoHeight: void 0,
  wrapText: void 0,
  sortable: void 0,
  resizable: void 0,
  singleClickEdit: void 0,
  floatingFilter: void 0,
  cellEditorPopup: void 0,
  suppressFillHandle: void 0,
  wrapHeaderText: void 0,
  autoHeaderHeight: void 0,
  dndSourceOnRowDrag: void 0,
  valueGetter: void 0,
  valueSetter: void 0,
  filterValueGetter: void 0,
  keyCreator: void 0,
  valueFormatter: void 0,
  valueParser: void 0,
  comparator: void 0,
  equals: void 0,
  pivotComparator: void 0,
  suppressKeyboardEvent: void 0,
  suppressHeaderKeyboardEvent: void 0,
  colSpan: void 0,
  rowSpan: void 0,
  getQuickFilterText: void 0,
  onCellValueChanged: void 0,
  onCellClicked: void 0,
  onCellDoubleClicked: void 0,
  onCellContextMenu: void 0,
  rowDragText: void 0,
  tooltipValueGetter: void 0,
  cellRendererSelector: void 0,
  cellEditorSelector: void 0,
  suppressSpanHeaderHeight: void 0,
  useValueFormatterForExport: void 0,
  useValueParserForImport: void 0,
  mainMenuItems: void 0,
  contextMenuItems: void 0,
  suppressFloatingFilterButton: void 0,
  suppressHeaderFilterButton: void 0,
  suppressHeaderContextMenu: void 0,
  loadingCellRenderer: void 0,
  loadingCellRendererParams: void 0,
  loadingCellRendererSelector: void 0
}, ym = Object.keys(Em), Ws = {
  objectName: "colDef",
  allProperties: ym,
  docsUrl: "column-properties/",
  deprecations: wm,
  validations: Sm
}, Rm = {
  enableChartToolPanelsButton: { version: "29" },
  functionsPassive: { version: "29.2" },
  onColumnRowGroupChangeRequest: { version: "29.2" },
  onColumnPivotChangeRequest: { version: "29.2" },
  onColumnValueChangeRequest: { version: "29.2" },
  onColumnAggFuncChangeRequest: { version: "29.2" },
  serverSideFilterAllLevels: { version: "30", message: "All server-side group levels are now filtered by default. This can be toggled using `serverSideOnlyRefreshFilteredGroups`." },
  suppressAggAtRootLevel: { version: "30", message: "The root level aggregation is now suppressed by default. This can be toggled using  `alwaysAggregateAtRootLevel`." },
  excludeHiddenColumnsFromQuickFilter: { version: "30", message: "Hidden columns are now excluded from the Quick Filter by default. This can be toggled using `includeHiddenColumnsInQuickFilter`." },
  enterMovesDown: { version: "30", renamed: "enterNavigatesVertically" },
  enterMovesDownAfterEdit: { version: "30", renamed: "enterNavigatesVerticallyAfterEdit" },
  suppressParentsInRowNodes: { version: "30.2", message: "Using suppressParentsInRowNodes is no longer recommended. To serialize nodes it is now recommended to instead remove the parent node reference before serialization." },
  advancedFilterModel: { version: "31", message: "Use `initialState.filter.advancedFilterModel` instead." },
  suppressAsyncEvents: { version: "31", message: "Events should be handled asynchronously." },
  cellFadeDelay: { version: "31.1", renamed: "cellFadeDuration" },
  cellFlashDelay: { version: "31.1", renamed: "cellFlashDuration" },
  suppressServerSideInfiniteScroll: { version: "31.1" },
  serverSideSortOnServer: { version: "31.1" },
  serverSideFilterOnServer: { version: "31.1" },
  enableCellChangeFlash: { version: "31.2", message: "Use `enableCellChangeFlash` in the `ColDef` or `defaultColDef` for all columns." },
  groupIncludeFooter: { version: "31.3", message: "Use `groupTotalRow` instead." },
  groupIncludeTotalFooter: { version: "31.3", message: "Use `grandTotalRow` instead." }
}, Dm = {
  suppressContextMenu: !1,
  preventDefaultOnContextMenu: !1,
  allowContextMenuWithControlKey: !1,
  suppressMenuHide: !1,
  enableBrowserTooltips: !1,
  tooltipTrigger: "hover",
  tooltipShowDelay: 2e3,
  tooltipHideDelay: 1e4,
  tooltipMouseTrack: !1,
  tooltipShowMode: "standard",
  tooltipInteraction: !1,
  copyHeadersToClipboard: !1,
  copyGroupHeadersToClipboard: !1,
  clipboardDelimiter: "	",
  suppressCopyRowsToClipboard: !1,
  suppressCopySingleCellRanges: !1,
  suppressLastEmptyLineOnPaste: !1,
  suppressClipboardPaste: !1,
  suppressClipboardApi: !1,
  suppressCutToClipboard: !1,
  maintainColumnOrder: !1,
  suppressFieldDotNotation: !1,
  allowDragFromColumnsToolPanel: !1,
  suppressMovableColumns: !1,
  suppressColumnMoveAnimation: !1,
  suppressDragLeaveHidesColumns: !1,
  suppressRowGroupHidesColumns: !1,
  suppressAutoSize: !1,
  autoSizePadding: 20,
  skipHeaderOnAutoSize: !1,
  singleClickEdit: !1,
  suppressClickEdit: !1,
  readOnlyEdit: !1,
  stopEditingWhenCellsLoseFocus: !1,
  enterNavigatesVertically: !1,
  enterNavigatesVerticallyAfterEdit: !1,
  enableCellEditingOnBackspace: !1,
  undoRedoCellEditing: !1,
  undoRedoCellEditingLimit: 10,
  suppressCsvExport: !1,
  suppressExcelExport: !1,
  cacheQuickFilter: !1,
  includeHiddenColumnsInQuickFilter: !1,
  excludeChildrenWhenTreeDataFiltering: !1,
  enableAdvancedFilter: !1,
  includeHiddenColumnsInAdvancedFilter: !1,
  enableCharts: !1,
  suppressChartToolPanelsButton: !1,
  masterDetail: !1,
  keepDetailRows: !1,
  keepDetailRowsCount: 10,
  detailRowAutoHeight: !1,
  tabIndex: 0,
  rowBuffer: 10,
  valueCache: !1,
  valueCacheNeverExpires: !1,
  enableCellExpressions: !1,
  suppressTouch: !1,
  suppressFocusAfterRefresh: !1,
  suppressAsyncEvents: !1,
  suppressBrowserResizeObserver: !1,
  suppressPropertyNamesCheck: !1,
  suppressChangeDetection: !1,
  debug: !1,
  suppressLoadingOverlay: !1,
  suppressNoRowsOverlay: !1,
  pagination: !1,
  paginationPageSize: 100,
  paginationPageSizeSelector: !0,
  paginationAutoPageSize: !1,
  paginateChildRows: !1,
  suppressPaginationPanel: !1,
  pivotMode: !1,
  pivotPanelShow: "never",
  pivotDefaultExpanded: 0,
  pivotSuppressAutoColumn: !1,
  suppressExpandablePivotGroups: !1,
  functionsReadOnly: !1,
  suppressAggFuncInHeader: !1,
  alwaysAggregateAtRootLevel: !1,
  aggregateOnlyChangedColumns: !1,
  suppressAggFilteredOnly: !1,
  removePivotHeaderRowWhenSingleValueColumn: !1,
  animateRows: !0,
  enableCellChangeFlash: !1,
  cellFlashDelay: 500,
  cellFlashDuration: 500,
  cellFadeDelay: 1e3,
  cellFadeDuration: 1e3,
  allowShowChangeAfterFilter: !1,
  domLayout: "normal",
  ensureDomOrder: !1,
  enableRtl: !1,
  suppressColumnVirtualisation: !1,
  suppressMaxRenderedRowRestriction: !1,
  suppressRowVirtualisation: !1,
  rowDragManaged: !1,
  suppressRowDrag: !1,
  suppressMoveWhenRowDragging: !1,
  rowDragEntireRow: !1,
  rowDragMultiRow: !1,
  embedFullWidthRows: !1,
  groupDisplayType: "singleColumn",
  groupDefaultExpanded: 0,
  groupMaintainOrder: !1,
  groupSelectsChildren: !1,
  groupIncludeTotalFooter: !1,
  groupSuppressBlankHeader: !1,
  groupSelectsFiltered: !1,
  showOpenedGroup: !1,
  groupRemoveSingleChildren: !1,
  groupRemoveLowestSingleChildren: !1,
  groupHideOpenParents: !1,
  groupAllowUnbalanced: !1,
  rowGroupPanelShow: "never",
  suppressMakeColumnVisibleAfterUnGroup: !1,
  treeData: !1,
  rowGroupPanelSuppressSort: !1,
  suppressGroupRowsSticky: !1,
  rowModelType: "clientSide",
  asyncTransactionWaitMillis: 50,
  suppressModelUpdateAfterUpdateTransaction: !1,
  cacheOverflowSize: 1,
  infiniteInitialRowCount: 1,
  serverSideInitialRowCount: 1,
  suppressServerSideInfiniteScroll: !1,
  cacheBlockSize: 100,
  maxBlocksInCache: -1,
  maxConcurrentDatasourceRequests: 2,
  blockLoadDebounceMillis: 0,
  purgeClosedRowNodes: !1,
  serverSideSortAllLevels: !1,
  serverSideOnlyRefreshFilteredGroups: !1,
  serverSideSortOnServer: !1,
  serverSideFilterOnServer: !1,
  serverSidePivotResultFieldSeparator: "_",
  viewportRowModelPageSize: 5,
  viewportRowModelBufferSize: 5,
  alwaysShowHorizontalScroll: !1,
  alwaysShowVerticalScroll: !1,
  debounceVerticalScrollbar: !1,
  suppressHorizontalScroll: !1,
  suppressScrollOnNewData: !1,
  suppressScrollWhenPopupsAreOpen: !1,
  suppressAnimationFrame: !1,
  suppressMiddleClickScrolls: !1,
  suppressPreventDefaultOnMouseWheel: !1,
  rowMultiSelectWithClick: !1,
  suppressRowDeselection: !1,
  suppressRowClickSelection: !1,
  suppressCellFocus: !1,
  suppressHeaderFocus: !1,
  suppressMultiRangeSelection: !1,
  enableCellTextSelection: !1,
  enableRangeSelection: !1,
  enableRangeHandle: !1,
  enableFillHandle: !1,
  fillHandleDirection: "xy",
  suppressClearOnFillReduction: !1,
  accentedSort: !1,
  unSortIcon: !1,
  suppressMultiSort: !1,
  alwaysMultiSort: !1,
  suppressMaintainUnsortedOrder: !1,
  suppressRowHoverHighlight: !1,
  suppressRowTransform: !1,
  columnHoverHighlight: !1,
  deltaSort: !1,
  enableGroupEdit: !1,
  suppressGroupMaintainValueType: !1,
  functionsPassive: !1,
  groupLockGroupColumns: 0,
  serverSideEnableClientSideSort: !1,
  suppressServerSideFullWidthLoadingRow: !1,
  pivotMaxGeneratedColumns: -1
}, Tm = {
  sideBar: {
    module: "@ag-grid-enterprise/side-bar"
    /* SideBarModule */
  },
  statusBar: {
    module: "@ag-grid-enterprise/status-bar"
    /* StatusBarModule */
  },
  enableCharts: {
    module: "@ag-grid-enterprise/charts"
    /* GridChartsModule */
  },
  getMainMenuItems: {
    module: "@ag-grid-enterprise/menu"
    /* MenuModule */
  },
  getContextMenuItems: {
    module: "@ag-grid-enterprise/menu"
    /* MenuModule */
  },
  allowContextMenuWithControlKey: {
    module: "@ag-grid-enterprise/menu"
    /* MenuModule */
  },
  enableAdvancedFilter: {
    module: "@ag-grid-enterprise/advanced-filter"
    /* AdvancedFilterModule */
  },
  treeData: {
    supportedRowModels: ["clientSide", "serverSide"],
    module: "@ag-grid-enterprise/row-grouping",
    dependencies: (e) => {
      var t;
      const i = (t = e.rowModelType) != null ? t : "clientSide";
      switch (i) {
        case "clientSide":
          const s = `treeData requires 'getDataPath' in the ${i} row model.`;
          return e.getDataPath ? null : s;
        case "serverSide":
          const o = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${i} row model.`;
          return e.isServerSideGroup && e.getServerSideGroupKey ? null : o;
      }
      return null;
    }
  },
  masterDetail: {
    module: "@ag-grid-enterprise/master-detail"
    /* MasterDetailModule */
  },
  enableRangeSelection: {
    module: "@ag-grid-enterprise/range-selection"
    /* RangeSelectionModule */
  },
  enableRangeHandle: {
    dependencies: {
      enableRangeSelection: [!0]
    }
  },
  enableFillHandle: {
    dependencies: {
      enableRangeSelection: [!0]
    }
  },
  groupDefaultExpanded: {
    supportedRowModels: ["clientSide"]
  },
  groupIncludeFooter: {
    supportedRowModels: ["clientSide", "serverSide"],
    dependencies: (e) => {
      var t;
      switch ((t = e.rowModelType) != null ? t : "clientSide") {
        case "clientSide":
          return null;
        case "serverSide":
          return e.suppressServerSideInfiniteScroll ? "groupIncludeFooter is not supported alongside suppressServerSideInfiniteScroll" : null;
      }
      return null;
    }
  },
  groupIncludeTotalFooter: {
    supportedRowModels: ["clientSide"]
  },
  groupRemoveSingleChildren: {
    dependencies: {
      groupHideOpenParents: [void 0, !1],
      groupRemoveLowestSingleChildren: [void 0, !1]
    }
  },
  groupRemoveLowestSingleChildren: {
    dependencies: {
      groupHideOpenParents: [void 0, !1],
      groupRemoveSingleChildren: [void 0, !1]
    }
  },
  groupSelectsChildren: {
    dependencies: {
      rowSelection: ["multiple"]
    }
  },
  suppressParentsInRowNodes: {
    dependencies: {
      groupSelectsChildren: [void 0, !1]
    }
  },
  viewportDatasource: {
    supportedRowModels: ["viewport"],
    module: "@ag-grid-enterprise/viewport-row-model"
    /* ViewportRowModelModule */
  },
  serverSideDatasource: {
    supportedRowModels: ["serverSide"],
    module: "@ag-grid-enterprise/server-side-row-model"
    /* ServerSideRowModelModule */
  },
  cacheBlockSize: {
    supportedRowModels: ["serverSide", "infinite"]
  },
  datasource: {
    supportedRowModels: ["infinite"],
    module: "@ag-grid-community/infinite-row-model"
    /* InfiniteRowModelModule */
  },
  rowData: {
    supportedRowModels: ["clientSide"],
    module: "@ag-grid-community/client-side-row-model"
    /* ClientSideRowModelModule */
  },
  columnDefs: () => Ws,
  defaultColDef: () => Ws,
  defaultColGroupDef: () => Ws,
  autoGroupColumnDef: () => Ws
}, bm = {
  objectName: "gridOptions",
  allProperties: [
    ...Wo.ALL_PROPERTIES,
    ...Zr.EVENT_CALLBACKS
  ],
  propertyExceptions: ["api", "columnApi"],
  docsUrl: "grid-options/",
  deprecations: Rm,
  validations: Tm
}, ae = class {
  constructor() {
    this.destroyed = !1, this.domDataKey = "__AG_" + Math.random().toString(), this.propertyEventService = new qt(), this.globalEventHandlerFactory = (e) => (t, i) => {
      if (this.destroyed)
        return;
      const s = _r.has(t);
      if (s && !e || !s && e)
        return;
      const o = Zr.getCallbackForEvent(t), r = this.gridOptions[o];
      typeof r == "function" && this.frameworkOverrides.wrapOutgoing(() => {
        r(i);
      });
    };
  }
  // This is quicker then having code call gridOptionsService.get('context')
  get context() {
    return this.gridOptions.context;
  }
  init() {
    this.columnApi = new eo(this.api);
    const e = !this.get("suppressAsyncEvents");
    this.eventService.addGlobalListener(this.globalEventHandlerFactory().bind(this), e), this.eventService.addGlobalListener(this.globalEventHandlerFactory(!0).bind(this), !1), this.propertyEventService.setFrameworkOverrides(this.frameworkOverrides), this.getScrollbarWidth();
  }
  destroy() {
    this.destroyed = !0, this.columnApi = void 0;
  }
  /**
   * Get the raw value of the GridOptions property provided.
   * @param property
   */
  get(e) {
    var t;
    return (t = this.gridOptions[e]) != null ? t : Dm[e];
  }
  /**
   * Get the GridOption callback but wrapped so that the common params of api,columnApi and context are automatically applied to the params.
   * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
   */
  getCallback(e) {
    return this.mergeGridCommonParams(this.gridOptions[e]);
  }
  /**
   * Returns `true` if a value has been specified for this GridOption.
   * @param property GridOption property
   */
  exists(e) {
    return b(this.gridOptions[e]);
  }
  /**
  * Wrap the user callback and attach the api, columnApi and context to the params object on the way through.
  * @param callback User provided callback
  * @returns Wrapped callback where the params object not require api, columnApi and context
  */
  mergeGridCommonParams(e) {
    return e && ((i) => {
      const s = i;
      return s.api = this.api, s.columnApi = this.columnApi, s.context = this.context, e(s);
    });
  }
  static toBoolean(e) {
    return typeof e == "boolean" ? e : typeof e == "string" ? e.toUpperCase() === "TRUE" || e == "" : !1;
  }
  static toNumber(e) {
    if (typeof e == "number")
      return e;
    if (typeof e == "string") {
      const t = parseInt(e);
      return isNaN(t) ? void 0 : t;
    }
  }
  static toConstrainedNum(e, t) {
    return (i) => {
      const s = ae.toNumber(i);
      if (!(s == null || s < e || s > t))
        return s;
    };
  }
  static getCoercedValue(e, t) {
    const i = ae.PROPERTY_COERCIONS.get(e);
    return i ? i(t) : t;
  }
  static getCoercedGridOptions(e) {
    const t = {};
    return Object.entries(e).forEach(([i, s]) => {
      const o = ae.getCoercedValue(i, s);
      t[i] = o;
    }), t;
  }
  updateGridOptions({ options: e, force: t, source: i = "api" }) {
    const s = { id: ae.changeSetId++, properties: [] }, o = [];
    Object.entries(e).forEach(([r, n]) => {
      i === "api" && Jp[r] && H(`${r} is an initial property and cannot be updated.`);
      const l = ae.getCoercedValue(r, n), a = t || typeof l == "object" && i === "api", d = this.gridOptions[r];
      if (a || d !== l) {
        this.gridOptions[r] = l;
        const c = {
          type: r,
          currentValue: l,
          previousValue: d,
          changeSet: s,
          source: i
        };
        o.push(c);
      }
    }), this.validationService.processGridOptions(this.gridOptions), s.properties = o.map((r) => r.type), o.forEach((r) => {
      this.gridOptions.debug && console.log(`AG Grid: Updated property ${r.type} from `, r.previousValue, " to  ", r.currentValue), this.propertyEventService.dispatchEvent(r);
    });
  }
  addEventListener(e, t) {
    this.propertyEventService.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    this.propertyEventService.removeEventListener(e, t);
  }
  // *************** Helper methods ************************** //
  // Methods to share common GridOptions related logic that goes above accessing a single property
  // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
  // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
  // allow the user to provide the scroll width before we work it out.
  getScrollbarWidth() {
    if (this.scrollbarWidth == null) {
      const t = typeof this.gridOptions.scrollbarWidth == "number" && this.gridOptions.scrollbarWidth >= 0 ? this.gridOptions.scrollbarWidth : oc();
      t != null && (this.scrollbarWidth = t, this.eventService.dispatchEvent({
        type: p.EVENT_SCROLLBAR_WIDTH_CHANGED
      }));
    }
    return this.scrollbarWidth;
  }
  isRowModelType(e) {
    return this.gridOptions.rowModelType === e || e === "clientSide" && z(this.gridOptions.rowModelType);
  }
  isDomLayout(e) {
    var t;
    return ((t = this.gridOptions.domLayout) != null ? t : "normal") === e;
  }
  isRowSelection() {
    return this.gridOptions.rowSelection === "single" || this.gridOptions.rowSelection === "multiple";
  }
  useAsyncEvents() {
    return !this.get("suppressAsyncEvents");
  }
  isGetRowHeightFunction() {
    return typeof this.gridOptions.getRowHeight == "function";
  }
  getRowHeightForNode(e, t = !1, i) {
    if (i == null && (i = this.environment.getDefaultRowHeight()), this.isGetRowHeightFunction()) {
      if (t)
        return { height: i, estimated: !0 };
      const o = {
        node: e,
        data: e.data
      }, r = this.getCallback("getRowHeight")(o);
      if (this.isNumeric(r))
        return r === 0 && H("The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead."), { height: Math.max(1, r), estimated: !1 };
    }
    return e.detail && this.get("masterDetail") ? this.getMasterDetailRowHeight() : { height: this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight) ? this.gridOptions.rowHeight : i, estimated: !1 };
  }
  getMasterDetailRowHeight() {
    return this.get("detailRowAutoHeight") ? { height: 1, estimated: !1 } : this.isNumeric(this.gridOptions.detailRowHeight) ? { height: this.gridOptions.detailRowHeight, estimated: !1 } : { height: 300, estimated: !1 };
  }
  // we don't allow dynamic row height for virtual paging
  getRowHeightAsNumber() {
    if (!this.gridOptions.rowHeight || z(this.gridOptions.rowHeight))
      return this.environment.getDefaultRowHeight();
    const e = this.environment.refreshRowHeightVariable();
    return e !== -1 ? e : (console.warn("AG Grid row height must be a number if not using standard row model"), this.environment.getDefaultRowHeight());
  }
  isNumeric(e) {
    return !isNaN(e) && typeof e == "number" && isFinite(e);
  }
  getDomDataKey() {
    return this.domDataKey;
  }
  // returns the dom data, or undefined if not found
  getDomData(e, t) {
    const i = e[this.getDomDataKey()];
    return i ? i[t] : void 0;
  }
  setDomData(e, t, i) {
    const s = this.getDomDataKey();
    let o = e[s];
    z(o) && (o = {}, e[s] = o), o[t] = i;
  }
  getDocument() {
    let e = null;
    return this.gridOptions.getDocument && b(this.gridOptions.getDocument) ? e = this.gridOptions.getDocument() : this.eGridDiv && (e = this.eGridDiv.ownerDocument), e && b(e) ? e : document;
  }
  getWindow() {
    return this.getDocument().defaultView || window;
  }
  getRootNode() {
    return this.eGridDiv.getRootNode();
  }
  getActiveDomElement() {
    return this.getRootNode().activeElement;
  }
  getAsyncTransactionWaitMillis() {
    return b(this.gridOptions.asyncTransactionWaitMillis) ? this.gridOptions.asyncTransactionWaitMillis : 50;
  }
  isAnimateRows() {
    return this.get("ensureDomOrder") ? !1 : this.get("animateRows");
  }
  isGroupRowsSticky() {
    return !(this.get("paginateChildRows") || this.get("groupHideOpenParents") || this.isDomLayout("print"));
  }
  isColumnsSortingCoupledToGroup() {
    const e = this.gridOptions.autoGroupColumnDef;
    return !(e != null && e.comparator) && !this.get("treeData");
  }
  getGroupAggFiltering() {
    const e = this.gridOptions.groupAggFiltering;
    if (typeof e == "function")
      return this.getCallback("groupAggFiltering");
    if (e === !0)
      return () => !0;
  }
  getGrandTotalRow() {
    const e = this.gridOptions.grandTotalRow;
    if (e)
      return e;
    if (this.gridOptions.groupIncludeTotalFooter)
      return "bottom";
  }
  getGroupTotalRowCallback() {
    const e = this.get("groupTotalRow");
    if (typeof e == "function")
      return this.getCallback("groupTotalRow");
    if (e)
      return () => e;
    const t = this.get("groupIncludeFooter");
    if (typeof t == "function") {
      const i = this.getCallback("groupIncludeFooter");
      return (s) => i(s) ? "bottom" : void 0;
    }
    return () => t ? "bottom" : void 0;
  }
  isGroupMultiAutoColumn() {
    return this.gridOptions.groupDisplayType ? this.gridOptions.groupDisplayType === "multipleColumns" : this.get("groupHideOpenParents");
  }
  isGroupUseEntireRow(e) {
    return e ? !1 : this.gridOptions.groupDisplayType === "groupRows";
  }
  getGridCommonParams() {
    return {
      api: this.api,
      columnApi: this.columnApi,
      context: this.context
    };
  }
  addGridCommonParams(e) {
    const t = e;
    return t.api = this.api, t.columnApi = this.columnApi, t.context = this.context, t;
  }
};
ae.PROPERTY_COERCIONS = new Map([
  ...Wo.BOOLEAN_PROPERTIES.map((e) => [e, ae.toBoolean]),
  ...Wo.NUMBER_PROPERTIES.map((e) => [e, ae.toNumber]),
  ["groupAggFiltering", (e) => typeof e == "function" ? e : ae.toBoolean(e)],
  ["pageSize", ae.toConstrainedNum(1, Number.MAX_VALUE)],
  ["autoSizePadding", ae.toConstrainedNum(0, Number.MAX_VALUE)],
  ["keepDetailRowsCount", ae.toConstrainedNum(1, Number.MAX_VALUE)],
  ["rowBuffer", ae.toConstrainedNum(0, Number.MAX_VALUE)],
  ["infiniteInitialRowCount", ae.toConstrainedNum(1, Number.MAX_VALUE)],
  ["cacheOverflowSize", ae.toConstrainedNum(1, Number.MAX_VALUE)],
  ["cacheBlockSize", ae.toConstrainedNum(1, Number.MAX_VALUE)],
  ["serverSideInitialRowCount", ae.toConstrainedNum(1, Number.MAX_VALUE)],
  ["viewportRowModelPageSize", ae.toConstrainedNum(1, Number.MAX_VALUE)],
  ["viewportRowModelBufferSize", ae.toConstrainedNum(0, Number.MAX_VALUE)]
]);
ae.changeSetId = 0;
u([
  f("gridOptions")
], ae.prototype, "gridOptions", 2);
u([
  f("eventService")
], ae.prototype, "eventService", 2);
u([
  f("environment")
], ae.prototype, "environment", 2);
u([
  f("frameworkOverrides")
], ae.prototype, "frameworkOverrides", 2);
u([
  f("eGridDiv")
], ae.prototype, "eGridDiv", 2);
u([
  f("validationService")
], ae.prototype, "validationService", 2);
u([
  f("gridApi")
], ae.prototype, "api", 2);
u([
  L
], ae.prototype, "init", 1);
u([
  dt
], ae.prototype, "destroy", 1);
ae = u([
  O("gridOptionsService")
], ae);
var Xl = class extends F {
  getLocaleTextFunc() {
    const e = this.gos.getCallback("getLocaleText");
    if (e)
      return (i, s, o) => e({
        key: i,
        defaultValue: s,
        variableValues: o
      });
    const t = this.gos.get("localeText");
    return (i, s, o) => {
      let r = t && t[i];
      if (r && o && o.length) {
        let n = 0;
        for (; !(n >= o.length || r.indexOf("${variable}") === -1); )
          r = r.replace("${variable}", o[n++]);
      }
      return r ?? s;
    };
  }
};
Xl = u([
  O("localeService")
], Xl);
var Za = class Uh extends xs {
  constructor() {
    super(Uh.TEMPLATE, "vertical");
  }
  postConstruct() {
    super.postConstruct(), this.createManagedBean(new Wn(this.eContainer)), this.ctrlsService.register("fakeVScrollComp", this), this.addManagedListener(this.eventService, p.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onRowContainerHeightChanged.bind(this));
  }
  setScrollVisible() {
    const t = this.scrollVisibleService.isVerticalScrollShowing(), i = this.invisibleScrollbar, s = t && this.gos.getScrollbarWidth() || 0, o = s === 0 && i ? 16 : s;
    this.addOrRemoveCssClass("ag-scrollbar-invisible", i), Gt(this.getGui(), o), Gt(this.eViewport, o), Gt(this.eContainer, o), this.setDisplayed(t, { skipAriaHidden: !0 });
  }
  onRowContainerHeightChanged() {
    const { ctrlsService: t } = this, s = t.getGridBodyCtrl().getBodyViewportElement(), o = this.getScrollPosition(), r = s.scrollTop;
    o != r && this.setScrollPosition(r, !0);
  }
  getScrollPosition() {
    return this.getViewport().scrollTop;
  }
  setScrollPosition(t, i) {
    !i && !wt(this.getViewport()) && this.attemptSettingScrollPosition(t), this.getViewport().scrollTop = t;
  }
};
Za.TEMPLATE = /* html */
`<div class="ag-body-vertical-scroll" aria-hidden="true">
            <div class="ag-body-vertical-scroll-viewport" ref="eViewport">
                <div class="ag-body-vertical-scroll-container" ref="eContainer"></div>
            </div>
        </div>`;
u([
  L
], Za.prototype, "postConstruct", 1);
var Am = Za, Hd = {
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December"
}, kd = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"], Cs = class extends F {
  constructor() {
    super(...arguments), this.dataTypeDefinitions = {}, this.isWaitingForRowData = !1, this.isColumnTypeOverrideInDataTypeDefinitions = !1, this.columnStateUpdatesPendingInference = {}, this.columnStateUpdateListenerDestroyFuncs = [];
  }
  init() {
    this.groupHideOpenParents = this.gos.get("groupHideOpenParents"), this.addManagedPropertyListener("groupHideOpenParents", () => {
      this.groupHideOpenParents = this.gos.get("groupHideOpenParents");
    }), this.processDataTypeDefinitions(), this.addManagedPropertyListener("dataTypeDefinitions", (e) => {
      this.processDataTypeDefinitions(), this.columnModel.recreateColumnDefs(Bs(e.source));
    });
  }
  processDataTypeDefinitions() {
    var e;
    const t = this.getDefaultDataTypes();
    this.dataTypeDefinitions = {}, Object.entries(t).forEach(([s, o]) => {
      this.dataTypeDefinitions[s] = Re(_({}, o), {
        groupSafeValueFormatter: this.createGroupSafeValueFormatter(o)
      });
    });
    const i = (e = this.gos.get("dataTypeDefinitions")) != null ? e : {};
    this.dataTypeMatchers = {}, Object.entries(i).forEach(([s, o]) => {
      const r = this.processDataTypeDefinition(o, i, [s], t);
      r && (this.dataTypeDefinitions[s] = r, o.dataTypeMatcher && (this.dataTypeMatchers[s] = o.dataTypeMatcher));
    }), this.checkObjectValueHandlers(t), ["dateString", "text", "number", "boolean", "date"].forEach((s) => {
      const o = this.dataTypeMatchers[s];
      o && delete this.dataTypeMatchers[s], this.dataTypeMatchers[s] = o ?? t[s].dataTypeMatcher;
    });
  }
  mergeDataTypeDefinitions(e, t) {
    const i = _(_({}, e), t);
    return e.columnTypes && t.columnTypes && t.appendColumnTypes && (i.columnTypes = [
      ...this.convertColumnTypes(e.columnTypes),
      ...this.convertColumnTypes(t.columnTypes)
    ]), i;
  }
  processDataTypeDefinition(e, t, i, s) {
    let o;
    const r = e.extendsDataType;
    if (e.columnTypes && (this.isColumnTypeOverrideInDataTypeDefinitions = !0), e.extendsDataType === e.baseDataType) {
      let n = s[r];
      const l = t[r];
      if (n && l && (n = l), !this.validateDataTypeDefinition(e, n, r))
        return;
      o = this.mergeDataTypeDefinitions(
        n,
        e
      );
    } else {
      if (i.includes(r)) {
        H('Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.');
        return;
      }
      const n = t[r];
      if (!this.validateDataTypeDefinition(e, n, r))
        return;
      const l = this.processDataTypeDefinition(
        n,
        t,
        [...i, r],
        s
      );
      if (!l)
        return;
      o = this.mergeDataTypeDefinitions(
        l,
        e
      );
    }
    return Re(_({}, o), {
      groupSafeValueFormatter: this.createGroupSafeValueFormatter(o)
    });
  }
  validateDataTypeDefinition(e, t, i) {
    return t ? t.baseDataType !== e.baseDataType ? (H('The "baseDataType" property of a data type definition must match that of its parent.'), !1) : !0 : (H(`The data type definition ${i} does not exist.`), !1);
  }
  createGroupSafeValueFormatter(e) {
    if (e.valueFormatter)
      return (t) => {
        var i, s;
        if ((i = t.node) != null && i.group) {
          const o = t.column.getAggFunc();
          if (o) {
            if (o === "first" || o === "last")
              return e.valueFormatter(t);
            if (e.baseDataType === "number" && o !== "count") {
              if (typeof t.value == "number")
                return e.valueFormatter(t);
              if (typeof t.value == "object") {
                if (!t.value)
                  return;
                if ("toNumber" in t.value)
                  return e.valueFormatter(Re(_({}, t), {
                    value: t.value.toNumber()
                  }));
                if ("value" in t.value)
                  return e.valueFormatter(Re(_({}, t), {
                    value: t.value.value
                  }));
              }
            }
          }
          if (!this.gos.get("suppressGroupMaintainValueType"))
            return;
        } else if (this.groupHideOpenParents && t.column.isRowGroupActive()) {
          if (typeof t.value != "string" || (s = e.dataTypeMatcher) != null && s.call(e, t.value))
            return e.valueFormatter(t);
          if (!this.gos.get("suppressGroupMaintainValueType"))
            return;
        }
        return e.valueFormatter(t);
      };
  }
  updateColDefAndGetDataTypeDefinitionColumnType(e, t, i) {
    let { cellDataType: s } = t;
    const { field: o } = t;
    if (s === void 0 && (s = e.cellDataType), (s == null || s === !0) && (s = this.canInferCellDataType(e, t) ? this.inferCellDataType(o, i) : !1), !s) {
      e.cellDataType = !1;
      return;
    }
    const r = this.dataTypeDefinitions[s];
    if (!r) {
      H(`Missing data type definition - "${s}"`);
      return;
    }
    return e.cellDataType = s, r.groupSafeValueFormatter && (e.valueFormatter = r.groupSafeValueFormatter), r.valueParser && (e.valueParser = r.valueParser), r.suppressDefaultProperties || this.setColDefPropertiesForBaseDataType(e, r, i), r.columnTypes;
  }
  updateColDefAndGetColumnType(e, t, i) {
    var s, o;
    const r = this.updateColDefAndGetDataTypeDefinitionColumnType(e, t, i), n = (o = (s = t.type) != null ? s : r) != null ? o : e.type;
    return e.type = n, n ? this.convertColumnTypes(n) : void 0;
  }
  addColumnListeners(e) {
    if (!this.isWaitingForRowData)
      return;
    const t = this.columnStateUpdatesPendingInference[e.getColId()];
    if (!t)
      return;
    const i = (s) => {
      t.add(s.key);
    };
    e.addEventListener(pe.EVENT_STATE_UPDATED, i), this.columnStateUpdateListenerDestroyFuncs.push(() => e.removeEventListener(pe.EVENT_STATE_UPDATED, i));
  }
  canInferCellDataType(e, t) {
    var i;
    if (this.rowModel.getType() !== "clientSide")
      return !1;
    const s = { cellRenderer: !0, valueGetter: !0, valueParser: !0, refData: !0 };
    if (this.doColDefPropsPreventInference(t, s))
      return !1;
    const o = t.type === null ? e.type : t.type;
    if (o) {
      const r = (i = this.gos.get("columnTypes")) != null ? i : {};
      if (this.convertColumnTypes(o).some((l) => {
        const a = r[l.trim()];
        return a && this.doColDefPropsPreventInference(a, s);
      }))
        return !1;
    }
    return !this.doColDefPropsPreventInference(e, s);
  }
  doColDefPropsPreventInference(e, t) {
    return [
      ["cellRenderer", "agSparklineCellRenderer"],
      ["valueGetter", void 0],
      ["valueParser", void 0],
      ["refData", void 0]
    ].some(([i, s]) => this.doesColDefPropPreventInference(e, t, i, s));
  }
  doesColDefPropPreventInference(e, t, i, s) {
    if (!t[i])
      return !1;
    const o = e[i];
    return o === null ? (t[i] = !1, !1) : s === void 0 ? !!o : o === s;
  }
  inferCellDataType(e, t) {
    var i;
    if (!e)
      return;
    let s;
    const o = this.getInitialData();
    if (o) {
      const n = e.indexOf(".") >= 0 && !this.gos.get("suppressFieldDotNotation");
      s = Us(o, e, n);
    } else
      this.initWaitForRowData(t);
    if (s == null)
      return;
    const [r] = (i = Object.entries(this.dataTypeMatchers).find(([n, l]) => l(s))) != null ? i : ["object"];
    return r;
  }
  getInitialData() {
    const e = this.gos.get("rowData");
    if (e != null && e.length)
      return e[0];
    if (this.initialData)
      return this.initialData;
    {
      const t = this.rowModel.getRootNode().allLeafChildren;
      if (t != null && t.length)
        return t[0].data;
    }
    return null;
  }
  initWaitForRowData(e) {
    if (this.columnStateUpdatesPendingInference[e] = /* @__PURE__ */ new Set(), this.isWaitingForRowData)
      return;
    this.isWaitingForRowData = !0;
    const t = this.isColumnTypeOverrideInDataTypeDefinitions;
    t && this.columnModel.queueResizeOperations();
    const i = this.addManagedListener(this.eventService, p.EVENT_ROW_DATA_UPDATE_STARTED, (s) => {
      const { firstRowData: o } = s;
      if (!o)
        return;
      i == null || i(), this.isWaitingForRowData = !1, this.processColumnsPendingInference(o, t), this.columnStateUpdatesPendingInference = {}, t && this.columnModel.processResizeOperations();
      const r = {
        type: p.EVENT_DATA_TYPES_INFERRED
      };
      this.eventService.dispatchEvent(r);
    });
  }
  isPendingInference() {
    return this.isWaitingForRowData;
  }
  processColumnsPendingInference(e, t) {
    this.initialData = e;
    const i = [];
    this.columnStateUpdateListenerDestroyFuncs.forEach((r) => r()), this.columnStateUpdateListenerDestroyFuncs = [];
    const s = {}, o = {};
    Object.entries(this.columnStateUpdatesPendingInference).forEach(([r, n]) => {
      const l = this.columnModel.getGridColumn(r);
      if (!l)
        return;
      const a = l.getColDef();
      if (!this.columnModel.resetColumnDefIntoColumn(l, "cellDataTypeInferred"))
        return;
      const d = l.getColDef();
      if (t && d.type && d.type !== a.type) {
        const c = this.getUpdatedColumnState(l, n);
        c.rowGroup && c.rowGroupIndex == null && (s[r] = c), c.pivot && c.pivotIndex == null && (o[r] = c), i.push(c);
      }
    }), t && i.push(...this.columnModel.generateColumnStateForRowGroupAndPivotIndexes(s, o)), i.length && this.columnModel.applyColumnState({ state: i }, "cellDataTypeInferred"), this.initialData = null;
  }
  getUpdatedColumnState(e, t) {
    const i = this.columnModel.getColumnStateFromColDef(e);
    return t.forEach((s) => {
      delete i[s], s === "rowGroup" ? delete i.rowGroupIndex : s === "pivot" && delete i.pivotIndex;
    }), i;
  }
  checkObjectValueHandlers(e) {
    const t = this.dataTypeDefinitions.object, i = e.object;
    this.hasObjectValueParser = t.valueParser !== i.valueParser, this.hasObjectValueFormatter = t.valueFormatter !== i.valueFormatter;
  }
  convertColumnTypes(e) {
    let t = [];
    return e instanceof Array ? e.some((s) => typeof s != "string") ? console.warn("if colDef.type is supplied an array it should be of type 'string[]'") : t = e : typeof e == "string" ? t = e.split(",") : console.warn("colDef.type should be of type 'string' | 'string[]'"), t;
  }
  getDateStringTypeDefinition(e) {
    var t;
    return e ? (t = this.getDataTypeDefinition(e)) != null ? t : this.dataTypeDefinitions.dateString : this.dataTypeDefinitions.dateString;
  }
  getDateParserFunction(e) {
    return this.getDateStringTypeDefinition(e).dateParser;
  }
  getDateFormatterFunction(e) {
    return this.getDateStringTypeDefinition(e).dateFormatter;
  }
  getDataTypeDefinition(e) {
    const t = e.getColDef();
    if (t.cellDataType)
      return this.dataTypeDefinitions[t.cellDataType];
  }
  getBaseDataType(e) {
    var t;
    return (t = this.getDataTypeDefinition(e)) == null ? void 0 : t.baseDataType;
  }
  checkType(e, t) {
    var i;
    if (t == null)
      return !0;
    const s = (i = this.getDataTypeDefinition(e)) == null ? void 0 : i.dataTypeMatcher;
    return s ? s(t) : !0;
  }
  validateColDef(e) {
    e.cellDataType === "object" && (e.valueFormatter === this.dataTypeDefinitions.object.groupSafeValueFormatter && !this.hasObjectValueFormatter && H('Cell data type is "object" but no value formatter has been provided. Please either provide an object data type definition with a value formatter, or set "colDef.valueFormatter"'), e.editable && e.valueParser === this.dataTypeDefinitions.object.valueParser && !this.hasObjectValueParser && H('Cell data type is "object" but no value parser has been provided. Please either provide an object data type definition with a value parser, or set "colDef.valueParser"'));
  }
  setColDefPropertiesForBaseDataType(e, t, i) {
    const s = (l, a, d) => {
      let c = l.getColDef().valueFormatter;
      return c === t.groupSafeValueFormatter && (c = t.valueFormatter), this.valueService.formatValue(l, a, d, c);
    }, o = le.__isRegistered("@ag-grid-enterprise/set-filter", this.context.getGridId()), r = this.localeService.getLocaleTextFunc(), n = (l) => {
      const { filterParams: a } = e;
      e.filterParams = typeof a == "object" ? _(_({}, a), l) : l;
    };
    switch (t.baseDataType) {
      case "number": {
        e.cellEditor = "agNumberCellEditor", o && n({
          comparator: (l, a) => {
            const d = l == null ? 0 : parseInt(l), c = a == null ? 0 : parseInt(a);
            return d === c ? 0 : d > c ? 1 : -1;
          }
        });
        break;
      }
      case "boolean": {
        e.cellEditor = "agCheckboxCellEditor", e.cellRenderer = "agCheckboxCellRenderer", e.suppressKeyboardEvent = (l) => !!l.colDef.editable && l.event.key === S.SPACE, n(o ? {
          valueFormatter: (l) => b(l.value) ? r(String(l.value), l.value ? "True" : "False") : r("blanks", "(Blanks)")
        } : {
          maxNumConditions: 1,
          debounceMs: 0,
          filterOptions: [
            "empty",
            {
              displayKey: "true",
              displayName: "True",
              predicate: (l, a) => a,
              numberOfInputs: 0
            },
            {
              displayKey: "false",
              displayName: "False",
              predicate: (l, a) => a === !1,
              numberOfInputs: 0
            }
          ]
        });
        break;
      }
      case "date": {
        e.cellEditor = "agDateCellEditor", e.keyCreator = (l) => s(l.column, l.node, l.value), o && n({
          valueFormatter: (l) => {
            const a = s(l.column, l.node, l.value);
            return b(a) ? a : r("blanks", "(Blanks)");
          },
          treeList: !0,
          treeListFormatter: (l, a) => {
            if (a === 1 && l != null) {
              const d = kd[Number(l) - 1];
              return r(d, Hd[d]);
            }
            return l ?? r("blanks", "(Blanks)");
          }
        });
        break;
      }
      case "dateString": {
        e.cellEditor = "agDateStringCellEditor", e.keyCreator = (a) => s(a.column, a.node, a.value);
        const l = t.dateParser;
        n(o ? {
          valueFormatter: (a) => {
            const d = s(a.column, a.node, a.value);
            return b(d) ? d : r("blanks", "(Blanks)");
          },
          treeList: !0,
          treeListPathGetter: (a) => {
            const d = l(a ?? void 0);
            return d ? [String(d.getFullYear()), String(d.getMonth() + 1), String(d.getDate())] : null;
          },
          treeListFormatter: (a, d) => {
            if (d === 1 && a != null) {
              const c = kd[Number(a) - 1];
              return r(c, Hd[c]);
            }
            return a ?? r("blanks", "(Blanks)");
          }
        } : {
          comparator: (a, d) => {
            const c = l(d);
            return d == null || c < a ? -1 : c > a ? 1 : 0;
          }
        });
        break;
      }
      case "object": {
        e.cellEditorParams = {
          useFormatter: !0
        }, e.comparator = (l, a) => {
          const d = this.columnModel.getPrimaryColumn(i), c = d == null ? void 0 : d.getColDef();
          if (!d || !c)
            return 0;
          const h = l == null ? "" : s(d, null, l), g = a == null ? "" : s(d, null, a);
          return h === g ? 0 : h > g ? 1 : -1;
        }, e.keyCreator = (l) => s(l.column, l.node, l.value), o ? n({
          valueFormatter: (l) => {
            const a = s(l.column, l.node, l.value);
            return b(a) ? a : r("blanks", "(Blanks)");
          }
        }) : e.filterValueGetter = (l) => s(
          l.column,
          l.node,
          this.valueService.getValue(l.column, l.node)
        );
        break;
      }
    }
  }
  getDefaultDataTypes() {
    const e = (i) => !!i.match("^\\d{4}-\\d{2}-\\d{2}$"), t = this.localeService.getLocaleTextFunc();
    return {
      number: {
        baseDataType: "number",
        // can be empty space with legacy copy
        valueParser: (i) => {
          var s, o;
          return ((o = (s = i.newValue) == null ? void 0 : s.trim) == null ? void 0 : o.call(s)) === "" ? null : Number(i.newValue);
        },
        valueFormatter: (i) => i.value == null ? "" : typeof i.value != "number" || isNaN(i.value) ? t("invalidNumber", "Invalid Number") : String(i.value),
        dataTypeMatcher: (i) => typeof i == "number"
      },
      text: {
        baseDataType: "text",
        valueParser: (i) => i.newValue === "" ? null : Vo(i.newValue),
        dataTypeMatcher: (i) => typeof i == "string"
      },
      boolean: {
        baseDataType: "boolean",
        valueParser: (i) => {
          var s, o;
          return i.newValue == null ? i.newValue : ((o = (s = i.newValue) == null ? void 0 : s.trim) == null ? void 0 : o.call(s)) === "" ? null : String(i.newValue).toLowerCase() === "true";
        },
        valueFormatter: (i) => i.value == null ? "" : String(i.value),
        dataTypeMatcher: (i) => typeof i == "boolean"
      },
      date: {
        baseDataType: "date",
        valueParser: (i) => mt(i.newValue == null ? null : String(i.newValue)),
        valueFormatter: (i) => {
          var s;
          return i.value == null ? "" : !(i.value instanceof Date) || isNaN(i.value.getTime()) ? t("invalidDate", "Invalid Date") : (s = Nt(i.value, !1)) != null ? s : "";
        },
        dataTypeMatcher: (i) => i instanceof Date
      },
      dateString: {
        baseDataType: "dateString",
        dateParser: (i) => {
          var s;
          return (s = mt(i)) != null ? s : void 0;
        },
        dateFormatter: (i) => {
          var s;
          return (s = Nt(i ?? null, !1)) != null ? s : void 0;
        },
        valueParser: (i) => e(String(i.newValue)) ? i.newValue : null,
        valueFormatter: (i) => e(String(i.value)) ? i.value : "",
        dataTypeMatcher: (i) => typeof i == "string" && e(i)
      },
      object: {
        baseDataType: "object",
        valueParser: () => null,
        valueFormatter: (i) => {
          var s;
          return (s = Vo(i.value)) != null ? s : "";
        }
      }
    };
  }
};
u([
  f("rowModel")
], Cs.prototype, "rowModel", 2);
u([
  f("columnModel")
], Cs.prototype, "columnModel", 2);
u([
  f("valueService")
], Cs.prototype, "valueService", 2);
u([
  L
], Cs.prototype, "init", 1);
Cs = u([
  O("dataTypeService")
], Cs);
var vs = class extends F {
  constructor() {
    super(...arguments), this.waitingForColumns = !1;
  }
  postConstruct() {
    this.addManagedPropertyListener("columnDefs", (e) => this.setColumnDefs(e));
  }
  start() {
    this.ctrlsService.whenReady(() => {
      const e = this.gos.get("columnDefs");
      e ? this.setColumnsAndData(e) : this.waitingForColumns = !0, this.gridReady();
    });
  }
  setColumnsAndData(e) {
    this.columnModel.setColumnDefs(e ?? [], "gridInitializing"), this.rowModel.start();
  }
  gridReady() {
    this.dispatchGridReadyEvent();
    const e = le.__isRegistered("@ag-grid-enterprise/core", this.context.getGridId());
    new Xa("AG Grid", () => this.gos.get("debug")).log(`initialised successfully, enterprise = ${e}`);
  }
  dispatchGridReadyEvent() {
    const e = {
      type: p.EVENT_GRID_READY
    };
    this.eventService.dispatchEvent(e);
  }
  setColumnDefs(e) {
    const t = this.gos.get("columnDefs");
    if (t) {
      if (this.waitingForColumns) {
        this.waitingForColumns = !1, this.setColumnsAndData(t);
        return;
      }
      this.columnModel.setColumnDefs(t, Bs(e.source));
    }
  }
};
u([
  f("ctrlsService")
], vs.prototype, "ctrlsService", 2);
u([
  f("columnModel")
], vs.prototype, "columnModel", 2);
u([
  f("rowModel")
], vs.prototype, "rowModel", 2);
u([
  L
], vs.prototype, "postConstruct", 1);
vs = u([
  O("syncService")
], vs);
var ws = class extends F {
  constructor() {
    super(...arguments), this.manuallyDisplayed = !1;
  }
  postConstruct() {
    this.addManagedListener(this.eventService, p.EVENT_ROW_DATA_UPDATED, () => this.onRowDataUpdated()), this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, () => this.onNewColumnsLoaded());
  }
  registerOverlayWrapperComp(e) {
    this.overlayWrapperComp = e, (!this.gos.get("columnDefs") || this.gos.isRowModelType("clientSide") && !this.gos.get("rowData")) && this.showLoadingOverlay();
  }
  showLoadingOverlay() {
    if (this.gos.get("suppressLoadingOverlay"))
      return;
    const e = {}, t = this.userComponentFactory.getLoadingOverlayCompDetails(e);
    this.showOverlay(t, "ag-overlay-loading-wrapper", "loadingOverlayComponentParams");
  }
  showNoRowsOverlay() {
    if (this.gos.get("suppressNoRowsOverlay"))
      return;
    const e = {}, t = this.userComponentFactory.getNoRowsOverlayCompDetails(e);
    this.showOverlay(t, "ag-overlay-no-rows-wrapper", "noRowsOverlayComponentParams");
  }
  showOverlay(e, t, i) {
    const s = e.newAgStackInstance(), o = this.addManagedPropertyListener(i, ({ currentValue: r }) => {
      s.then((n) => {
        n.refresh && n.refresh(this.gos.addGridCommonParams(_({}, r ?? {})));
      });
    });
    this.manuallyDisplayed = this.columnModel.isReady() && !this.paginationProxy.isEmpty(), this.overlayWrapperComp.showOverlay(s, t, o);
  }
  hideOverlay() {
    this.manuallyDisplayed = !1, this.overlayWrapperComp.hideOverlay();
  }
  showOrHideOverlay() {
    const e = this.paginationProxy.isEmpty(), t = this.gos.get("suppressNoRowsOverlay");
    e && !t ? this.showNoRowsOverlay() : this.hideOverlay();
  }
  onRowDataUpdated() {
    this.showOrHideOverlay();
  }
  onNewColumnsLoaded() {
    this.columnModel.isReady() && !this.paginationProxy.isEmpty() && !this.manuallyDisplayed && this.hideOverlay();
  }
};
u([
  f("userComponentFactory")
], ws.prototype, "userComponentFactory", 2);
u([
  f("paginationProxy")
], ws.prototype, "paginationProxy", 2);
u([
  f("columnModel")
], ws.prototype, "columnModel", 2);
u([
  L
], ws.prototype, "postConstruct", 1);
ws = u([
  O("overlayService")
], ws);
var nt = class extends F {
  constructor() {
    super(...arguments), this.suppressEvents = !0, this.queuedUpdateSources = /* @__PURE__ */ new Set(), this.dispatchStateUpdateEventDebounced = rt(() => this.dispatchQueuedStateUpdateEvents(), 0), this.onRowGroupOpenedDebounced = rt(() => this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()), 0), this.onRowSelectedDebounced = rt(() => {
      this.staleStateKeys.delete("rowSelection"), this.updateCachedState("rowSelection", this.getRowSelectionState());
    }, 0), this.staleStateKeys = /* @__PURE__ */ new Set();
  }
  postConstruct() {
    var e;
    this.isClientSideRowModel = this.rowModel.getType() === "clientSide", this.cachedState = (e = this.gos.get("initialState")) != null ? e : {}, this.ctrlsService.whenReady(() => this.suppressEventsAndDispatchInitEvent(() => this.setupStateOnGridReady()));
    const t = this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, ({ source: o }) => {
      o === "gridInitializing" && (t == null || t(), this.suppressEventsAndDispatchInitEvent(() => this.setupStateOnColumnsInitialised()));
    }), i = this.addManagedListener(this.eventService, p.EVENT_ROW_COUNT_READY, () => {
      i == null || i(), this.suppressEventsAndDispatchInitEvent(() => this.setupStateOnRowCountReady());
    }), s = this.addManagedListener(this.eventService, p.EVENT_FIRST_DATA_RENDERED, () => {
      s == null || s(), this.suppressEventsAndDispatchInitEvent(() => this.setupStateOnFirstDataRendered());
    });
  }
  getState() {
    return this.staleStateKeys.size && this.refreshStaleState(), this.cachedState;
  }
  setupStateOnGridReady() {
    this.updateCachedState("sideBar", this.getSideBarState()), this.addManagedListener(this.eventService, p.EVENT_TOOL_PANEL_VISIBLE_CHANGED, () => this.updateCachedState("sideBar", this.getSideBarState())), this.addManagedListener(this.eventService, p.EVENT_SIDE_BAR_UPDATED, () => this.updateCachedState("sideBar", this.getSideBarState()));
  }
  setupStateOnColumnsInitialised() {
    var e;
    const t = (e = this.gos.get("initialState")) != null ? e : {};
    this.setColumnState(t), this.setColumnGroupState(t), this.updateColumnState([
      "aggregation",
      "columnOrder",
      "columnPinning",
      "columnSizing",
      "columnVisibility",
      "pivot",
      "pivot",
      "rowGroup",
      "sort"
    ]), this.updateCachedState("columnGroup", this.getColumnGroupState()), this.addManagedListener(this.eventService, p.EVENT_COLUMN_VALUE_CHANGED, () => this.updateColumnState(["aggregation"])), this.addManagedListener(this.eventService, p.EVENT_COLUMN_MOVED, () => this.updateColumnState(["columnOrder"])), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PINNED, () => this.updateColumnState(["columnPinning"])), this.addManagedListener(this.eventService, p.EVENT_COLUMN_RESIZED, () => this.updateColumnState(["columnSizing"])), this.addManagedListener(this.eventService, p.EVENT_COLUMN_VISIBLE, () => this.updateColumnState(["columnVisibility"])), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PIVOT_CHANGED, () => this.updateColumnState(["pivot"])), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PIVOT_MODE_CHANGED, () => this.updateColumnState(["pivot"])), this.addManagedListener(this.eventService, p.EVENT_COLUMN_ROW_GROUP_CHANGED, () => this.updateColumnState(["rowGroup"])), this.addManagedListener(this.eventService, p.EVENT_SORT_CHANGED, () => this.updateColumnState(["sort"])), this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, () => this.updateColumnState([
      "aggregation",
      "columnOrder",
      "columnPinning",
      "columnSizing",
      "columnVisibility",
      "pivot",
      "pivot",
      "rowGroup",
      "sort"
    ])), this.addManagedListener(this.eventService, p.EVENT_COLUMN_GROUP_OPENED, () => this.updateCachedState("columnGroup", this.getColumnGroupState()));
  }
  setupStateOnRowCountReady() {
    var e;
    const {
      filter: t,
      rowGroupExpansion: i,
      rowSelection: s,
      pagination: o
    } = (e = this.gos.get("initialState")) != null ? e : {}, r = this.gos.get("advancedFilterModel");
    (t || r) && this.setFilterState(t, r), i && this.setRowGroupExpansionState(i), s && this.setRowSelectionState(s), o && this.setPaginationState(o), this.updateCachedState("filter", this.getFilterState()), this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()), this.updateCachedState("rowSelection", this.getRowSelectionState()), this.updateCachedState("pagination", this.getPaginationState()), this.addManagedListener(this.eventService, p.EVENT_FILTER_CHANGED, () => this.updateCachedState("filter", this.getFilterState())), this.addManagedListener(this.eventService, p.EVENT_ROW_GROUP_OPENED, () => this.onRowGroupOpenedDebounced()), this.addManagedListener(this.eventService, p.EVENT_EXPAND_COLLAPSE_ALL, () => this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState())), this.addManagedListener(this.eventService, p.EVENT_SELECTION_CHANGED, () => {
      this.staleStateKeys.add("rowSelection"), this.onRowSelectedDebounced();
    }), this.addManagedListener(this.eventService, p.EVENT_PAGINATION_CHANGED, (n) => {
      (n.newPage || n.newPageSize) && this.updateCachedState("pagination", this.getPaginationState());
    });
  }
  setupStateOnFirstDataRendered() {
    var e;
    const {
      scroll: t,
      rangeSelection: i,
      focusedCell: s,
      columnOrder: o
    } = (e = this.gos.get("initialState")) != null ? e : {};
    s && this.setFocusedCellState(s), i && this.setRangeSelectionState(i), t && this.setScrollState(t), this.setColumnPivotState(!!(o != null && o.orderedColIds)), this.updateCachedState("sideBar", this.getSideBarState()), this.updateCachedState("focusedCell", this.getFocusedCellState()), this.updateCachedState("rangeSelection", this.getRangeSelectionState()), this.updateCachedState("scroll", this.getScrollState()), this.addManagedListener(this.eventService, p.EVENT_CELL_FOCUSED, () => this.updateCachedState("focusedCell", this.getFocusedCellState())), this.addManagedListener(this.eventService, p.EVENT_RANGE_SELECTION_CHANGED, (r) => {
      r.finished && this.updateCachedState("rangeSelection", this.getRangeSelectionState());
    }), this.addManagedListener(this.eventService, p.EVENT_BODY_SCROLL_END, () => this.updateCachedState("scroll", this.getScrollState()));
  }
  getColumnState() {
    const e = this.columnModel.isPivotMode(), t = [], i = [], s = [], o = [], r = [], n = [], l = [], a = [], d = [], c = this.columnModel.getColumnState();
    for (let h = 0; h < c.length; h++) {
      const {
        colId: g,
        sort: m,
        sortIndex: C,
        rowGroup: w,
        rowGroupIndex: v,
        aggFunc: y,
        pivot: E,
        pivotIndex: D,
        pinned: R,
        hide: T,
        width: I,
        flex: A
      } = c[h];
      d.push(g), m && (t[C ?? 0] = { colId: g, sort: m }), w && (i[v ?? 0] = g), typeof y == "string" && s.push({ colId: g, aggFunc: y }), E && (o[D ?? 0] = g), R && (R === "right" ? n : r).push(g), T && l.push(g), (A || I) && a.push({ colId: g, flex: A ?? void 0, width: I });
    }
    return {
      sort: t.length ? { sortModel: t } : void 0,
      rowGroup: i.length ? { groupColIds: i } : void 0,
      aggregation: s.length ? { aggregationModel: s } : void 0,
      pivot: o.length || e ? { pivotMode: e, pivotColIds: o } : void 0,
      columnPinning: r.length || n.length ? { leftColIds: r, rightColIds: n } : void 0,
      columnVisibility: l.length ? { hiddenColIds: l } : void 0,
      columnSizing: a.length ? { columnSizingModel: a } : void 0,
      columnOrder: d.length ? { orderedColIds: d } : void 0
    };
  }
  setColumnState(e) {
    const {
      sort: t,
      rowGroup: i,
      aggregation: s,
      pivot: o,
      columnPinning: r,
      columnVisibility: n,
      columnSizing: l,
      columnOrder: a
    } = e, d = {}, c = (C) => {
      let w = d[C];
      return w || (w = { colId: C }, d[C] = w, w);
    };
    t && t.sortModel.forEach(({ colId: C, sort: w }, v) => {
      const y = c(C);
      y.sort = w, y.sortIndex = v;
    }), i && i.groupColIds.forEach((C, w) => {
      const v = c(C);
      v.rowGroup = !0, v.rowGroupIndex = w;
    }), s && s.aggregationModel.forEach(({ colId: C, aggFunc: w }) => {
      c(C).aggFunc = w;
    }), o && (o.pivotColIds.forEach((C, w) => {
      const v = c(C);
      v.pivot = !0, v.pivotIndex = w;
    }), this.gos.updateGridOptions({ options: { pivotMode: o.pivotMode }, source: "gridInitializing" })), r && (r.leftColIds.forEach((C) => {
      c(C).pinned = "left";
    }), r.rightColIds.forEach((C) => {
      c(C).pinned = "right";
    })), n && n.hiddenColIds.forEach((C) => {
      c(C).hide = !0;
    }), l && l.columnSizingModel.forEach(({ colId: C, flex: w, width: v }) => {
      const y = c(C);
      y.flex = w ?? null, y.width = v;
    });
    const h = a == null ? void 0 : a.orderedColIds, g = !!(h != null && h.length), m = g ? h.map((C) => c(C)) : Object.values(d);
    if (m.length) {
      this.columnStates = m;
      const C = {
        sort: null,
        sortIndex: null,
        rowGroup: null,
        rowGroupIndex: null,
        aggFunc: null,
        pivot: null,
        pivotIndex: null,
        pinned: null,
        hide: null,
        flex: null
      };
      this.columnModel.applyColumnState({
        state: m,
        applyOrder: g,
        defaultState: C
      }, "gridInitializing");
    }
  }
  setColumnPivotState(e) {
    const t = this.columnStates;
    this.columnStates = void 0;
    const i = this.columnGroupStates;
    if (this.columnGroupStates = void 0, !!this.columnModel.isSecondaryColumnsPresent()) {
      if (t) {
        let s = [];
        for (const o of t)
          this.columnModel.getSecondaryColumn(o.colId) && s.push(o);
        this.columnModel.applyColumnState({
          state: s,
          applyOrder: e
        }, "gridInitializing");
      }
      i && this.columnModel.setColumnGroupState(i, "gridInitializing");
    }
  }
  getColumnGroupState() {
    const e = this.columnModel.getColumnGroupState(), t = [];
    return e.forEach(({ groupId: i, open: s }) => {
      s && t.push(i);
    }), t.length ? { openColumnGroupIds: t } : void 0;
  }
  setColumnGroupState(e) {
    var t;
    if (!e.hasOwnProperty("columnGroup"))
      return;
    const i = new Set((t = e.columnGroup) == null ? void 0 : t.openColumnGroupIds), o = this.columnModel.getColumnGroupState().map(({ groupId: r }) => {
      const n = i.has(r);
      return n && i.delete(r), {
        groupId: r,
        open: n
      };
    });
    i.forEach((r) => {
      o.push({
        groupId: r,
        open: !0
      });
    }), o.length && (this.columnGroupStates = o), this.columnModel.setColumnGroupState(o, "gridInitializing");
  }
  getFilterState() {
    var e;
    let t = this.filterManager.getFilterModel();
    t && Object.keys(t).length === 0 && (t = void 0);
    const i = (e = this.filterManager.getAdvancedFilterModel()) != null ? e : void 0;
    return t || i ? { filterModel: t, advancedFilterModel: i } : void 0;
  }
  setFilterState(e, t) {
    const { filterModel: i, advancedFilterModel: s } = e ?? { advancedFilterModel: t };
    i && this.filterManager.setFilterModel(i, "columnFilter"), s && this.filterManager.setAdvancedFilterModel(s);
  }
  getRangeSelectionState() {
    var e;
    const t = (e = this.rangeService) == null ? void 0 : e.getCellRanges().map((i) => {
      const { id: s, type: o, startRow: r, endRow: n, columns: l, startColumn: a } = i;
      return {
        id: s,
        type: o,
        startRow: r,
        endRow: n,
        colIds: l.map((d) => d.getColId()),
        startColId: a.getColId()
      };
    });
    return t != null && t.length ? { cellRanges: t } : void 0;
  }
  setRangeSelectionState(e) {
    if (!this.gos.get("enableRangeSelection") || !this.rangeService)
      return;
    const t = [];
    e.cellRanges.forEach((i) => {
      const s = [];
      if (i.colIds.forEach((r) => {
        const n = this.columnModel.getGridColumn(r);
        n && s.push(n);
      }), !s.length)
        return;
      let o = this.columnModel.getGridColumn(i.startColId);
      if (!o) {
        const r = this.columnModel.getAllDisplayedColumns(), n = new Set(s);
        o = r.find((l) => n.has(l));
      }
      t.push(Re(_({}, i), {
        columns: s,
        startColumn: o
      }));
    }), this.rangeService.setCellRanges(t);
  }
  getScrollState() {
    var e, t, i;
    if (!this.isClientSideRowModel)
      return;
    const s = (e = this.ctrlsService.getGridBodyCtrl()) == null ? void 0 : e.getScrollFeature(), { left: o } = (t = s == null ? void 0 : s.getHScrollPosition()) != null ? t : { left: 0 }, { top: r } = (i = s == null ? void 0 : s.getVScrollPosition()) != null ? i : { top: 0 };
    return r || o ? {
      top: r,
      left: o
    } : void 0;
  }
  setScrollState(e) {
    var t;
    if (!this.isClientSideRowModel)
      return;
    const { top: i, left: s } = e;
    (t = this.ctrlsService.getGridBodyCtrl()) == null || t.getScrollFeature().setScrollPosition(i, s);
  }
  getSideBarState() {
    var e, t;
    return (t = (e = this.sideBarService) == null ? void 0 : e.getSideBarComp()) == null ? void 0 : t.getState();
  }
  getFocusedCellState() {
    if (!this.isClientSideRowModel)
      return;
    const e = this.focusService.getFocusedCell();
    if (e) {
      const { column: t, rowIndex: i, rowPinned: s } = e;
      return {
        colId: t.getColId(),
        rowIndex: i,
        rowPinned: s
      };
    }
  }
  setFocusedCellState(e) {
    if (!this.isClientSideRowModel)
      return;
    const { colId: t, rowIndex: i, rowPinned: s } = e;
    this.focusService.setFocusedCell({
      column: this.columnModel.getGridColumn(t),
      rowIndex: i,
      rowPinned: s,
      forceBrowserFocus: !0,
      preventScrollOnBrowserFocus: !0
    });
  }
  getPaginationState() {
    const e = this.paginationProxy.getCurrentPage(), t = this.gos.get("paginationAutoPageSize") ? void 0 : this.paginationProxy.getPageSize();
    if (!(!e && !t))
      return { page: e, pageSize: t };
  }
  setPaginationState(e) {
    e.pageSize && !this.gos.get("paginationAutoPageSize") && this.paginationProxy.setPageSize(e.pageSize, "initialState"), typeof e.page == "number" && this.paginationProxy.setPage(e.page);
  }
  getRowSelectionState() {
    var e;
    const t = this.selectionService.getSelectionState();
    return !t || !Array.isArray(t) && (t.selectAll === !1 || t.selectAllChildren === !1) && !((e = t == null ? void 0 : t.toggledNodes) != null && e.length) ? void 0 : t;
  }
  setRowSelectionState(e) {
    this.selectionService.setSelectionState(e, "gridInitializing");
  }
  getRowGroupExpansionState() {
    const e = this.expansionService.getExpandedRows();
    return e.length ? {
      expandedRowGroupIds: e
    } : void 0;
  }
  setRowGroupExpansionState(e) {
    this.expansionService.expandRows(e.expandedRowGroupIds);
  }
  updateColumnState(e) {
    const t = this.getColumnState();
    let i = !1;
    Object.entries(t).forEach(([s, o]) => {
      Tl(o, this.cachedState[s]) || (i = !0);
    }), this.cachedState = _(_({}, this.cachedState), t), i && this.dispatchStateUpdateEvent(e);
  }
  updateCachedState(e, t) {
    const i = this.cachedState[e];
    this.setCachedStateValue(e, t), Tl(t, i) || this.dispatchStateUpdateEvent([e]);
  }
  setCachedStateValue(e, t) {
    this.cachedState = Re(_({}, this.cachedState), {
      [e]: t
    });
  }
  refreshStaleState() {
    this.staleStateKeys.forEach((e) => {
      switch (e) {
        case "rowSelection":
          this.setCachedStateValue(e, this.getRowSelectionState());
          break;
      }
    }), this.staleStateKeys.clear();
  }
  dispatchStateUpdateEvent(e) {
    this.suppressEvents || (e.forEach((t) => this.queuedUpdateSources.add(t)), this.dispatchStateUpdateEventDebounced());
  }
  dispatchQueuedStateUpdateEvents() {
    const e = Array.from(this.queuedUpdateSources);
    this.queuedUpdateSources.clear();
    const t = {
      type: p.EVENT_STATE_UPDATED,
      sources: e,
      state: this.cachedState
    };
    this.eventService.dispatchEvent(t);
  }
  suppressEventsAndDispatchInitEvent(e) {
    this.suppressEvents = !0, this.columnAnimationService.setSuppressAnimation(!0), e(), setTimeout(() => {
      this.suppressEvents = !1, this.queuedUpdateSources.clear(), this.isAlive() && (this.columnAnimationService.setSuppressAnimation(!1), this.dispatchStateUpdateEvent(["gridInitializing"]));
    });
  }
};
u([
  f("filterManager")
], nt.prototype, "filterManager", 2);
u([
  f("ctrlsService")
], nt.prototype, "ctrlsService", 2);
u([
  f("focusService")
], nt.prototype, "focusService", 2);
u([
  f("columnModel")
], nt.prototype, "columnModel", 2);
u([
  f("paginationProxy")
], nt.prototype, "paginationProxy", 2);
u([
  f("rowModel")
], nt.prototype, "rowModel", 2);
u([
  f("selectionService")
], nt.prototype, "selectionService", 2);
u([
  f("expansionService")
], nt.prototype, "expansionService", 2);
u([
  f("columnAnimationService")
], nt.prototype, "columnAnimationService", 2);
u([
  ue("sideBarService")
], nt.prototype, "sideBarService", 2);
u([
  ue("rangeService")
], nt.prototype, "rangeService", 2);
u([
  L
], nt.prototype, "postConstruct", 1);
nt = u([
  O("stateService")
], nt);
var rr = class extends F {
  init() {
    this.processGridOptions(this.gridOptions);
  }
  processGridOptions(e) {
    this.processOptions(e, bm);
  }
  processColumnDefs(e) {
    this.processOptions(e, Ws);
  }
  processOptions(e, t) {
    const { validations: i, deprecations: s, allProperties: o, propertyExceptions: r, objectName: n, docsUrl: l } = t;
    o && this.gridOptions.suppressPropertyNamesCheck !== !0 && this.checkProperties(
      e,
      [...r ?? [], ...Object.keys(s)],
      o,
      n,
      l
    );
    const a = /* @__PURE__ */ new Set();
    Object.keys(e).forEach((c) => {
      var h;
      const g = s[c];
      if (g)
        if ("renamed" in g) {
          const { renamed: D, version: R } = g;
          a.add(`As of v${R}, ${String(c)} is deprecated. Please use ${String(D)} instead.`), e[D] = e[c];
        } else {
          const { message: D, version: R } = g;
          a.add(`As of v${R}, ${String(c)} is deprecated. ${D ?? ""}`);
        }
      const m = e[c];
      if (m == null || m === !1)
        return;
      const C = i[c];
      let w;
      if (C)
        if (typeof C == "function") {
          const D = C(e, this.gridOptions);
          if (!D)
            return;
          if ("objectName" in D) {
            const R = e[c];
            if (Array.isArray(R)) {
              R.forEach((T) => {
                this.processOptions(T, D);
              });
              return;
            }
            this.processOptions(e[c], D);
            return;
          }
          w = D;
        } else
          w = C;
      else return;
      const { module: v, dependencies: y, supportedRowModels: E } = w;
      if (E) {
        const D = (h = this.gridOptions.rowModelType) != null ? h : "clientSide";
        if (!E.includes(D)) {
          a.add(`${String(c)} is not supported with the '${D}' row model.`);
          return;
        }
      }
      if (v) {
        const D = Array.isArray(v) ? v : [v];
        let R = !0;
        if (D.forEach((T) => {
          le.__assertRegistered(T, String(c), this.context.getGridId()) || (R = !1, a.add(`${String(c)} is only available when ${T} is loaded.`));
        }), !R)
          return;
      }
      if (y) {
        const D = this.checkForWarning(c, y, e);
        if (D) {
          a.add(D);
          return;
        }
      }
    }), a.size > 0 && a.forEach((c) => {
      H(c);
    });
  }
  checkForWarning(e, t, i) {
    if (typeof t == "function")
      return t(i, this.gridOptions);
    const o = Object.entries(t).find(([l, a]) => {
      const d = i[l];
      return !a.includes(d);
    });
    if (!o)
      return null;
    const [r, n] = o;
    return n.length > 1 ? `'${String(e)}' requires '${r}' to be one of [${n.join(", ")}].` : `'${String(e)}' requires '${r}' to be ${n[0]}.`;
  }
  checkProperties(e, t, i, s, o) {
    const r = ["__ob__", "__v_skip", "__metadata__"], n = vc(
      Object.getOwnPropertyNames(e),
      [...r, ...t, ...i],
      i
    );
    if (tt(n, (l, a) => {
      H(`invalid ${s} property '${l}' did you mean any of these: ${a.slice(0, 8).join(", ")}`);
    }), Object.keys(n).length > 0 && o) {
      const l = this.getFrameworkOverrides().getDocLink(o);
      H(`to see all the valid ${s} properties please check: ${l}`);
    }
  }
};
u([
  f("gridOptions")
], rr.prototype, "gridOptions", 2);
u([
  L
], rr.prototype, "init", 1);
rr = u([
  O("validationService")
], rr);
var un = class extends F {
  constructor() {
    super(...arguments), this.syncEventListeners = /* @__PURE__ */ new Map(), this.asyncEventListeners = /* @__PURE__ */ new Map(), this.syncGlobalEventListeners = /* @__PURE__ */ new Set(), this.globalEventListenerPairs = /* @__PURE__ */ new Map();
  }
  postConstruct() {
    this.frameworkEventWrappingService = new ia(this.getFrameworkOverrides());
  }
  addEventListener(e, t) {
    const i = this.frameworkEventWrappingService.wrap(t), s = this.gos.useAsyncEvents() && !_r.has(e), o = s ? this.asyncEventListeners : this.syncEventListeners;
    o.has(e) || o.set(e, /* @__PURE__ */ new Set()), o.get(e).add(i), this.eventService.addEventListener(e, i, s);
  }
  removeEventListener(e, t) {
    var i;
    const s = this.frameworkEventWrappingService.unwrap(t), o = this.asyncEventListeners.get(e), r = !!(o != null && o.delete(s));
    r || (i = this.syncEventListeners.get(e)) == null || i.delete(s), this.eventService.removeEventListener(e, s, r);
  }
  addGlobalListener(e) {
    const t = this.frameworkEventWrappingService.wrapGlobal(e);
    if (this.gos.useAsyncEvents()) {
      const s = (r, n) => {
        _r.has(r) && t(r, n);
      }, o = (r, n) => {
        _r.has(r) || t(r, n);
      };
      this.globalEventListenerPairs.set(e, { syncListener: s, asyncListener: o }), this.eventService.addGlobalListener(s, !1), this.eventService.addGlobalListener(o, !0);
    } else
      this.syncGlobalEventListeners.add(t), this.eventService.addGlobalListener(t, !1);
  }
  removeGlobalListener(e) {
    const t = this.frameworkEventWrappingService.unwrapGlobal(e);
    if (this.globalEventListenerPairs.has(t)) {
      const { syncListener: s, asyncListener: o } = this.globalEventListenerPairs.get(t);
      this.eventService.removeGlobalListener(s, !1), this.eventService.removeGlobalListener(o, !0), this.globalEventListenerPairs.delete(e);
    } else
      this.syncGlobalEventListeners.delete(t), this.eventService.removeGlobalListener(t, !1);
  }
  destroyEventListeners(e, t) {
    e.forEach((i, s) => {
      i.forEach((o) => this.eventService.removeEventListener(s, o, t)), i.clear();
    }), e.clear();
  }
  destroyGlobalListeners(e, t) {
    e.forEach((i) => this.eventService.removeGlobalListener(i, t)), e.clear();
  }
  destroy() {
    super.destroy(), this.destroyEventListeners(this.syncEventListeners, !1), this.destroyEventListeners(this.asyncEventListeners, !0), this.destroyGlobalListeners(this.syncGlobalEventListeners, !1), this.globalEventListenerPairs.forEach(({ syncListener: e, asyncListener: t }) => {
      this.eventService.removeGlobalListener(e, !1), this.eventService.removeGlobalListener(t, !0);
    }), this.globalEventListenerPairs.clear();
  }
};
u([
  L
], un.prototype, "postConstruct", 1);
un = u([
  O("apiEventService")
], un);
var Ja = class extends K {
  constructor() {
    super(
      /* html */
      '<span class="ag-paging-page-size"></span>'
    ), this.hasEmptyOption = !1, this.handlePageSizeItemSelected = () => {
      if (!this.selectPageSizeComp)
        return;
      const e = this.selectPageSizeComp.getValue();
      if (!e)
        return;
      const t = Number(e);
      isNaN(t) || t < 1 || t === this.paginationProxy.getPageSize() || (this.paginationProxy.setPageSize(t, "pageSizeSelector"), this.hasEmptyOption && this.toggleSelectDisplay(!0), this.selectPageSizeComp.getFocusableElement().focus());
    };
  }
  init() {
    this.addManagedPropertyListener("paginationPageSizeSelector", () => {
      this.onPageSizeSelectorValuesChange();
    }), this.addManagedListener(
      this.eventService,
      p.EVENT_PAGINATION_CHANGED,
      (e) => this.handlePaginationChanged(e)
    );
  }
  handlePaginationChanged(e) {
    if (!this.selectPageSizeComp || !(e != null && e.newPageSize))
      return;
    const t = this.paginationProxy.getPageSize();
    this.getPageSizeSelectorValues().includes(t) ? this.selectPageSizeComp.setValue(t.toString()) : this.hasEmptyOption ? this.selectPageSizeComp.setValue("") : this.toggleSelectDisplay(!0);
  }
  toggleSelectDisplay(e) {
    this.selectPageSizeComp && this.reset(), e && (this.reloadPageSizesSelector(), this.selectPageSizeComp && this.appendChild(this.selectPageSizeComp));
  }
  reset() {
    xe(this.getGui()), this.selectPageSizeComp && (this.destroyBean(this.selectPageSizeComp), this.selectPageSizeComp = void 0);
  }
  onPageSizeSelectorValuesChange() {
    this.selectPageSizeComp && this.shouldShowPageSizeSelector() && this.reloadPageSizesSelector();
  }
  shouldShowPageSizeSelector() {
    return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get("paginationPageSizeSelector") !== !1;
  }
  reloadPageSizesSelector() {
    const e = this.getPageSizeSelectorValues(), t = this.paginationProxy.getPageSize(), i = !t || !e.includes(t);
    i && (e.unshift(""), H(
      `The paginationPageSize grid option is set to a value that is not in the list of page size options.
                Please make sure that the paginationPageSize grid option is set to one of the values in the 
                paginationPageSizeSelector array, or set the paginationPageSizeSelector to false to hide the page size selector.`
    )), this.selectPageSizeComp && (this.destroyBean(this.selectPageSizeComp), this.selectPageSizeComp = void 0);
    const s = this.localeService.getLocaleTextFunc(), o = s("pageSizeSelectorLabel", "Page Size:"), r = e.map((l) => ({
      value: String(l),
      text: String(l)
    })), n = s("ariaPageSizeSelectorLabel", "Page Size");
    this.selectPageSizeComp = this.createManagedBean(new xn()).addOptions(r).setValue(String(i ? "" : t)).setAriaLabel(n).setLabel(o).onValueChange(() => this.handlePageSizeItemSelected()), this.hasEmptyOption = i;
  }
  getPageSizeSelectorValues() {
    const e = [20, 50, 100], t = this.gos.get("paginationPageSizeSelector");
    return !Array.isArray(t) || !this.validateValues(t) ? e : [...t].sort((i, s) => i - s);
  }
  validateValues(e) {
    if (!e.length)
      return H(
        `The paginationPageSizeSelector grid option is an empty array. This is most likely a mistake.
                If you want to hide the page size selector, please set the paginationPageSizeSelector to false.`
      ), !1;
    for (let t = 0; t < e.length; t++) {
      const i = e[t], s = typeof i == "number", o = i > 0;
      if (!s)
        return H(
          `The paginationPageSizeSelector grid option contains a non-numeric value.
                    Please make sure that all values in the paginationPageSizeSelector array are numbers.`
        ), !1;
      if (!o)
        return H(
          `The paginationPageSizeSelector grid option contains a negative number or zero.
                    Please make sure that all values in the paginationPageSizeSelector array are positive.`
        ), !1;
    }
    return !0;
  }
  destroy() {
    this.toggleSelectDisplay(!1), super.destroy();
  }
};
u([
  f("paginationProxy")
], Ja.prototype, "paginationProxy", 2);
u([
  L
], Ja.prototype, "init", 1);
var nr = class extends F {
  constructor() {
    super(), this.descriptionContainer = null, this.announceValue = rt(this.announceValue.bind(this), 200);
  }
  postConstruct() {
    const e = this.gos.getDocument(), t = this.descriptionContainer = e.createElement("div");
    t.classList.add("ag-aria-description-container"), na(t, "polite"), Ku(t, "additions text"), zu(t, !0), this.eGridDiv.appendChild(t);
  }
  announceValue(e) {
    this.descriptionContainer && (this.descriptionContainer.textContent = "", setTimeout(() => {
      this.isAlive() && this.descriptionContainer && (this.descriptionContainer.textContent = e);
    }, 50));
  }
  destroy() {
    super.destroy();
    const { descriptionContainer: e } = this;
    e && (xe(e), e.parentElement && e.parentElement.removeChild(e)), this.descriptionContainer = null, this.eGridDiv = null;
  }
};
u([
  f("eGridDiv")
], nr.prototype, "eGridDiv", 2);
u([
  L
], nr.prototype, "postConstruct", 1);
nr = u([
  O("ariaAnnouncementService")
], nr);
var Zl = class {
};
Zl.gridOptions = void 0;
var Pm = 1, Fm = class {
  create(e, t, i, s, o) {
    var r;
    let n = {};
    Zl.gridOptions ? (ft(n, Zl.gridOptions, !0, !0), n = _(_({}, n), t)) : n = t;
    const l = ae.getCoercedGridOptions(n), a = !!l.debug, d = (r = l.gridId) != null ? r : String(Pm++), c = this.getRegisteredModules(o, d), h = this.createBeansList(l.rowModelType, c, d), g = this.createProvidedBeans(e, l, o);
    if (!h) {
      es("Failed to create grid.");
      return;
    }
    const m = {
      providedBeanInstances: g,
      beanClasses: h,
      debug: a,
      gridId: d
    }, C = new Xa("Context", () => m.debug), w = new Vp(m, C), v = w.getBean("beans");
    return this.registerModuleUserComponents(v, c), this.registerStackComponents(v, c), this.registerControllers(v, c), i(w), v.syncService.start(), s && s(w), w.getBean("gridApi");
  }
  registerControllers(e, t) {
    t.forEach((i) => {
      i.controllers && i.controllers.forEach((s) => e.ctrlsFactory.register(s));
    });
  }
  registerStackComponents(e, t) {
    const i = this.createAgStackComponentsList(t);
    e.agStackComponentsRegistry.setupComponents(i);
  }
  getRegisteredModules(e, t) {
    const i = e ? e.modules : null, s = le.__getRegisteredModules(t), o = [], r = {}, n = (l, a, d) => {
      ((h) => {
        r[h.moduleName] || (r[h.moduleName] = !0, o.push(h), le.__register(h, l, d));
      })(a), a.dependantModules && a.dependantModules.forEach((h) => n(l, h, d));
    };
    return i && i.forEach((l) => n(!0, l, t)), s && s.forEach((l) => n(!le.__isPackageBased(), l, void 0)), o;
  }
  registerModuleUserComponents(e, t) {
    this.extractModuleEntity(
      t,
      (s) => s.userComponents ? s.userComponents : []
    ).forEach((s) => {
      e.userComponentRegistry.registerDefaultComponent(s.componentName, s.componentClass);
    });
  }
  createProvidedBeans(e, t, i) {
    let s = i ? i.frameworkOverrides : null;
    z(s) && (s = new Vh());
    const o = {
      gridOptions: t,
      eGridDiv: e,
      globalEventListener: i ? i.globalEventListener : null,
      globalSyncEventListener: i ? i.globalSyncEventListener : null,
      frameworkOverrides: s
    };
    return i && i.providedBeanInstances && Object.assign(o, i.providedBeanInstances), o;
  }
  createAgStackComponentsList(e) {
    let t = [
      { componentName: "AgCheckbox", componentClass: Nn },
      { componentName: "AgRadioButton", componentClass: Oc },
      { componentName: "AgToggleButton", componentClass: Mh },
      { componentName: "AgInputTextField", componentClass: Ts },
      { componentName: "AgInputTextArea", componentClass: Zf },
      { componentName: "AgInputNumberField", componentClass: Ga },
      { componentName: "AgInputDateField", componentClass: Jf },
      { componentName: "AgInputRange", componentClass: em },
      { componentName: "AgRichSelect", componentClass: Qn },
      { componentName: "AgSelect", componentClass: xn },
      { componentName: "AgSlider", componentClass: im },
      { componentName: "AgGridBody", componentClass: Xt },
      { componentName: "AgHeaderRoot", componentClass: qf },
      { componentName: "AgSortIndicator", componentClass: _a },
      { componentName: "AgPagination", componentClass: Rt },
      { componentName: "AgPageSizeSelector", componentClass: Ja },
      { componentName: "AgOverlayWrapper", componentClass: Cm },
      { componentName: "AgGroupComponent", componentClass: sm },
      { componentName: "AgRowContainer", componentClass: ho },
      { componentName: "AgFakeHorizontalScroll", componentClass: vm },
      { componentName: "AgFakeVerticalScroll", componentClass: Am },
      { componentName: "AgAutocomplete", componentClass: dm }
    ];
    const i = this.extractModuleEntity(
      e,
      (s) => s.agStackComponents ? s.agStackComponents : []
    );
    return t = t.concat(i), t;
  }
  createBeansList(e = "clientSide", t, i) {
    const s = t.filter((a) => !a.rowModel || a.rowModel === e), o = {
      clientSide: "@ag-grid-community/client-side-row-model",
      infinite: "@ag-grid-community/infinite-row-model",
      serverSide: "@ag-grid-enterprise/server-side-row-model",
      viewport: "@ag-grid-enterprise/viewport-row-model"
      /* ViewportRowModelModule */
    };
    if (!o[e]) {
      es("Could not find row model for rowModelType = " + e);
      return;
    }
    if (!le.__assertRegistered(o[e], `rowModelType = '${e}'`, i))
      return;
    const r = [
      q,
      ro,
      Yl,
      ir,
      to,
      J,
      sn,
      dn,
      er,
      Ul,
      Mi,
      so,
      qo,
      Xl,
      rr,
      Xo,
      Yo,
      Il,
      qt,
      ae,
      mi,
      fs,
      Ot,
      Ye,
      hs,
      Zo,
      At,
      nn,
      ko,
      gs,
      it,
      an,
      Gi,
      ln,
      ps,
      xi,
      Y,
      eo,
      he,
      gi,
      tr,
      Ni,
      rn,
      Zs,
      ms,
      jl,
      Jo,
      oo,
      Bo,
      io,
      Js,
      li,
      Ml,
      ql,
      sr,
      ni,
      no,
      ds,
      or,
      lo,
      Ql,
      Cs,
      vt,
      vs,
      ws,
      nt,
      Qo,
      un,
      nr,
      _t
    ], n = this.extractModuleEntity(s, (a) => a.beans ? a.beans : []);
    r.push(...n);
    const l = [];
    return r.forEach((a) => {
      l.indexOf(a) < 0 && l.push(a);
    }), l;
  }
  extractModuleEntity(e, t) {
    return [].concat(...e.map(t));
  }
}, Lm = class {
  wrap(e, t, i = [], s) {
    const o = this.createWrapper(e, s);
    return t.forEach((r) => {
      this.createMethod(o, r, !0);
    }), i.forEach((r) => {
      this.createMethod(o, r, !1);
    }), o;
  }
  unwrap(e) {
    return e;
  }
  createMethod(e, t, i) {
    e.addMethod(t, this.createMethodProxy(e, t, i));
  }
  createMethodProxy(e, t, i) {
    return function() {
      return e.hasMethod(t) ? e.callMethod(t, arguments) : (i && console.warn("AG Grid: Framework component is missing the method " + t + "()"), null);
    };
  }
}, Eo = typeof global > "u" ? {} : global;
Eo.HTMLElement = typeof HTMLElement > "u" ? {} : HTMLElement;
Eo.HTMLButtonElement = typeof HTMLButtonElement > "u" ? {} : HTMLButtonElement;
Eo.HTMLSelectElement = typeof HTMLSelectElement > "u" ? {} : HTMLSelectElement;
Eo.HTMLInputElement = typeof HTMLInputElement > "u" ? {} : HTMLInputElement;
Eo.Node = typeof Node > "u" ? {} : Node;
Eo.MouseEvent = typeof MouseEvent > "u" ? {} : MouseEvent;
var ed = class xo {
  constructor(t, i, s, o, r, n) {
    this.nextId = 0, this.rowCountReady = !1, this.allNodesMap = {}, this.rootNode = t, this.gos = i, this.eventService = s, this.columnModel = o, this.beans = n, this.selectionService = r, this.rootNode.group = !0, this.rootNode.level = -1, this.rootNode.id = xo.ROOT_NODE_ID, this.rootNode.allLeafChildren = [], this.rootNode.childrenAfterGroup = [], this.rootNode.childrenAfterSort = [], this.rootNode.childrenAfterAggFilter = [], this.rootNode.childrenAfterFilter = [];
  }
  getCopyOfNodesMap() {
    return W.cloneObject(this.allNodesMap);
  }
  getRowNode(t) {
    return this.allNodesMap[t];
  }
  setRowData(t) {
    if (typeof t == "string") {
      console.warn("AG Grid: rowData must be an array.");
      return;
    }
    this.rowCountReady = !0, this.dispatchRowDataUpdateStartedEvent(t);
    const i = this.rootNode, s = this.rootNode.sibling;
    i.childrenAfterFilter = null, i.childrenAfterGroup = null, i.childrenAfterAggFilter = null, i.childrenAfterSort = null, i.childrenMapped = null, i.updateHasChildren(), this.nextId = 0, this.allNodesMap = {}, t ? i.allLeafChildren = t.map((o) => this.createNode(o, this.rootNode, xo.TOP_LEVEL)) : (i.allLeafChildren = [], i.childrenAfterGroup = []), s && (s.childrenAfterFilter = i.childrenAfterFilter, s.childrenAfterGroup = i.childrenAfterGroup, s.childrenAfterAggFilter = i.childrenAfterAggFilter, s.childrenAfterSort = i.childrenAfterSort, s.childrenMapped = i.childrenMapped, s.allLeafChildren = i.allLeafChildren);
  }
  updateRowData(t, i) {
    this.rowCountReady = !0, this.dispatchRowDataUpdateStartedEvent(t.add);
    const s = {
      remove: [],
      update: [],
      add: []
    }, o = [];
    return this.executeRemove(t, s, o), this.executeUpdate(t, s, o), this.executeAdd(t, s), this.updateSelection(o, "rowDataChanged"), i && W.sortRowNodesByOrder(this.rootNode.allLeafChildren, i), s;
  }
  isRowCountReady() {
    return this.rowCountReady;
  }
  dispatchRowDataUpdateStartedEvent(t) {
    const i = {
      type: p.EVENT_ROW_DATA_UPDATE_STARTED,
      firstRowData: t != null && t.length ? t[0] : null
    };
    this.eventService.dispatchEvent(i);
  }
  updateSelection(t, i) {
    const s = t.length > 0;
    if (s && this.selectionService.setNodesSelected({
      newValue: !1,
      nodes: t,
      suppressFinishActions: !0,
      source: i
    }), this.selectionService.updateGroupsFromChildrenSelections(i), s) {
      const o = {
        type: p.EVENT_SELECTION_CHANGED,
        source: i
      };
      this.eventService.dispatchEvent(o);
    }
  }
  executeAdd(t, i) {
    var s;
    const { add: o, addIndex: r } = t;
    if (W.missingOrEmpty(o))
      return;
    const n = o.map((l) => this.createNode(l, this.rootNode, xo.TOP_LEVEL));
    if (typeof r == "number" && r >= 0) {
      const { allLeafChildren: l } = this.rootNode, a = l.length;
      let d = r;
      if (this.gos.get("treeData") && r > 0 && a > 0) {
        for (let m = 0; m < a; m++)
          if (((s = l[m]) == null ? void 0 : s.rowIndex) == r - 1) {
            d = m + 1;
            break;
          }
      }
      const h = l.slice(0, d), g = l.slice(d, l.length);
      this.rootNode.allLeafChildren = [...h, ...n, ...g];
    } else
      this.rootNode.allLeafChildren = [...this.rootNode.allLeafChildren, ...n];
    this.rootNode.sibling && (this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren), i.add = n;
  }
  executeRemove(t, i, s) {
    const { remove: o } = t;
    if (W.missingOrEmpty(o))
      return;
    const r = {};
    o.forEach((n) => {
      const l = this.lookupRowNode(n);
      l && (l.isSelected() && s.push(l), l.clearRowTopAndRowIndex(), r[l.id] = !0, delete this.allNodesMap[l.id], i.remove.push(l));
    }), this.rootNode.allLeafChildren = this.rootNode.allLeafChildren.filter((n) => !r[n.id]), this.rootNode.sibling && (this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren);
  }
  executeUpdate(t, i, s) {
    const { update: o } = t;
    W.missingOrEmpty(o) || o.forEach((r) => {
      const n = this.lookupRowNode(r);
      n && (n.updateData(r), !n.selectable && n.isSelected() && s.push(n), this.setMasterForRow(n, r, xo.TOP_LEVEL, !1), i.update.push(n));
    });
  }
  lookupRowNode(t) {
    const i = this.gos.getCallback("getRowId");
    let s;
    if (i) {
      const o = i({ data: t, level: 0 });
      if (s = this.allNodesMap[o], !s)
        return console.error(`AG Grid: could not find row id=${o}, data item was not found for this id`), null;
    } else if (s = this.rootNode.allLeafChildren.find((o) => o.data === t), !s)
      return console.error("AG Grid: could not find data item as object was not found", t), console.error("Consider using getRowId to help the Grid find matching row data"), null;
    return s || null;
  }
  createNode(t, i, s) {
    const o = new X(this.beans);
    o.group = !1, this.setMasterForRow(o, t, s, !0);
    const r = this.gos.get("suppressParentsInRowNodes");
    return i && !r && (o.parent = i), o.level = s, o.setDataAndId(t, this.nextId.toString()), this.allNodesMap[o.id] && console.warn(`AG Grid: duplicate node id '${o.id}' detected from getRowId callback, this could cause issues in your grid.`), this.allNodesMap[o.id] = o, this.nextId++, o;
  }
  setMasterForRow(t, i, s, o) {
    if (this.gos.get("treeData"))
      t.setMaster(!1), o && (t.expanded = !1);
    else {
      if (this.gos.get("masterDetail")) {
        const l = this.gos.get("isRowMaster");
        l ? t.setMaster(l(i)) : t.setMaster(!0);
      } else
        t.setMaster(!1);
      if (o) {
        const l = this.columnModel.getRowGroupColumns(), a = l ? l.length : 0, d = s + a;
        t.expanded = t.master ? this.isExpanded(d) : !1;
      }
    }
  }
  isExpanded(t) {
    const i = this.gos.get("groupDefaultExpanded");
    return i === -1 ? !0 : t < i;
  }
};
ed.TOP_LEVEL = 0;
ed.ROOT_NODE_ID = "ROOT_NODE_ID";
var Im = ed, lt = class extends F {
  constructor() {
    super(...arguments), this.onRowHeightChanged_debounced = W.debounce(this.onRowHeightChanged.bind(this), 100), this.rowsToDisplay = [], this.hasStarted = !1, this.shouldSkipSettingDataOnStart = !1, this.isRefreshingModel = !1, this.rowCountReady = !1;
  }
  init() {
    const e = this.refreshModel.bind(this, {
      step: "group"
      /* EVERYTHING */
    }), t = !this.gos.get("suppressAnimationFrame"), i = this.refreshModel.bind(this, {
      step: "group",
      // after cols change, row grouping (the first stage) could of changed
      afterColumnsChanged: !0,
      keepRenderedRows: !0,
      // we want animations cos sorting or filtering could be applied
      animate: t
    });
    this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, i), this.addManagedListener(this.eventService, p.EVENT_COLUMN_ROW_GROUP_CHANGED, e), this.addManagedListener(this.eventService, p.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PIVOT_CHANGED, this.refreshModel.bind(this, {
      step: "pivot"
      /* PIVOT */
    })), this.addManagedListener(this.eventService, p.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_SORT_CHANGED, this.onSortChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_COLUMN_PIVOT_MODE_CHANGED, e), this.addManagedListener(this.eventService, p.EVENT_GRID_STYLES_CHANGED, this.onGridStylesChanges.bind(this)), this.addManagedListener(this.eventService, p.EVENT_GRID_READY, () => this.onGridReady()), this.addPropertyListeners(), this.rootNode = new X(this.beans), this.nodeManager = new Im(
      this.rootNode,
      this.gos,
      this.eventService,
      this.columnModel,
      this.selectionService,
      this.beans
    );
  }
  addPropertyListeners() {
    const e = /* @__PURE__ */ new Set([
      "treeData",
      "masterDetail"
    ]), t = /* @__PURE__ */ new Set([
      "suppressParentsInRowNodes",
      "groupDefaultExpanded",
      "groupAllowUnbalanced",
      "initialGroupOrderComparator",
      "groupHideOpenParents",
      "groupDisplayType"
    ]), i = /* @__PURE__ */ new Set([
      "excludeChildrenWhenTreeDataFiltering"
    ]), s = /* @__PURE__ */ new Set([
      "removePivotHeaderRowWhenSingleValueColumn",
      "pivotRowTotals",
      "pivotColumnGroupTotals",
      "suppressExpandablePivotGroups"
    ]), o = /* @__PURE__ */ new Set([
      "getGroupRowAgg",
      "alwaysAggregateAtRootLevel",
      "groupIncludeTotalFooter",
      "suppressAggFilteredOnly",
      "grandTotalRow"
    ]), r = /* @__PURE__ */ new Set([
      "postSortRows",
      "groupDisplayType",
      "accentedSort"
    ]), n = /* @__PURE__ */ new Set([]), l = /* @__PURE__ */ new Set([
      "groupRemoveSingleChildren",
      "groupRemoveLowestSingleChildren",
      "groupIncludeFooter",
      "groupTotalRow"
    ]), a = [
      ...e,
      ...t,
      ...i,
      ...s,
      ...s,
      ...o,
      ...r,
      ...n,
      ...l
    ];
    this.addManagedPropertyListeners(a, (d) => {
      var c;
      const h = (c = d.changeSet) == null ? void 0 : c.properties;
      if (!h)
        return;
      const g = (m) => h.some((C) => m.has(C));
      if (g(e)) {
        this.setRowData(this.rootNode.allLeafChildren.map((m) => m.data));
        return;
      }
      if (g(t)) {
        this.refreshModel({
          step: "group"
          /* EVERYTHING */
        });
        return;
      }
      if (g(i)) {
        this.refreshModel({
          step: "filter"
          /* FILTER */
        });
        return;
      }
      if (g(s)) {
        this.refreshModel({
          step: "pivot"
          /* PIVOT */
        });
        return;
      }
      if (g(o)) {
        this.refreshModel({
          step: "aggregate"
          /* AGGREGATE */
        });
        return;
      }
      if (g(r)) {
        this.refreshModel({
          step: "sort"
          /* SORT */
        });
        return;
      }
      if (g(n)) {
        this.refreshModel({
          step: "filter_aggregates"
          /* FILTER_AGGREGATES */
        });
        return;
      }
      g(l) && this.refreshModel({
        step: "map"
        /* MAP */
      });
    }), this.addManagedPropertyListener("rowHeight", () => this.resetRowHeights());
  }
  start() {
    this.hasStarted = !0, this.shouldSkipSettingDataOnStart ? this.dispatchUpdateEventsAndRefresh() : this.setInitialData();
  }
  setInitialData() {
    const e = this.gos.get("rowData");
    e && (this.shouldSkipSettingDataOnStart = !0, this.setRowData(e));
  }
  ensureRowHeightsValid(e, t, i, s) {
    let o, r = !1;
    do {
      o = !1;
      const n = this.getRowIndexAtPixel(e), l = this.getRowIndexAtPixel(t), a = Math.max(n, i), d = Math.min(l, s);
      for (let c = a; c <= d; c++) {
        const h = this.getRow(c);
        if (h.rowHeightEstimated) {
          const g = this.gos.getRowHeightForNode(h);
          h.setRowHeight(g.height), o = !0, r = !0;
        }
      }
      o && this.setRowTopAndRowIndex();
    } while (o);
    return r;
  }
  setRowTopAndRowIndex() {
    const e = this.environment.getDefaultRowHeight();
    let t = 0;
    const i = /* @__PURE__ */ new Set(), s = this.gos.isDomLayout("normal");
    for (let o = 0; o < this.rowsToDisplay.length; o++) {
      const r = this.rowsToDisplay[o];
      if (r.id != null && i.add(r.id), r.rowHeight == null) {
        const n = this.gos.getRowHeightForNode(r, s, e);
        r.setRowHeight(n.height, n.estimated);
      }
      r.setRowTop(t), r.setRowIndex(o), t += r.rowHeight;
    }
    return i;
  }
  clearRowTopAndRowIndex(e, t) {
    const i = e.isActive(), s = (r) => {
      r && r.id != null && !t.has(r.id) && r.clearRowTopAndRowIndex();
    }, o = (r) => {
      if (s(r), s(r.detailNode), s(r.sibling), r.hasChildren() && r.childrenAfterGroup) {
        const n = r.level == -1;
        i && !n && !r.expanded || r.childrenAfterGroup.forEach(o);
      }
    };
    o(this.rootNode);
  }
  // returns false if row was moved, otherwise true
  ensureRowsAtPixel(e, t, i = 0) {
    const s = this.getRowIndexAtPixel(t), o = this.getRow(s), r = !this.gos.get("suppressAnimationFrame");
    return o === e[0] ? !1 : (e.forEach((n) => {
      W.removeFromArray(this.rootNode.allLeafChildren, n);
    }), e.forEach((n, l) => {
      W.insertIntoArray(this.rootNode.allLeafChildren, n, Math.max(s + i, 0) + l);
    }), this.refreshModel({
      step: "group",
      keepRenderedRows: !0,
      keepEditingRows: !0,
      animate: r
    }), !0);
  }
  highlightRowAtPixel(e, t) {
    const i = t != null ? this.getRowIndexAtPixel(t) : null, s = i != null ? this.getRow(i) : null;
    if (!s || !e || s === e || t == null) {
      this.lastHighlightedRow && (this.lastHighlightedRow.setHighlighted(null), this.lastHighlightedRow = null);
      return;
    }
    const o = this.getHighlightPosition(t, s);
    this.lastHighlightedRow && this.lastHighlightedRow !== s && (this.lastHighlightedRow.setHighlighted(null), this.lastHighlightedRow = null), s.setHighlighted(o), this.lastHighlightedRow = s;
  }
  getHighlightPosition(e, t) {
    if (!t) {
      const o = this.getRowIndexAtPixel(e);
      if (t = this.getRow(o || 0), !t)
        return 1;
    }
    const { rowTop: i, rowHeight: s } = t;
    return e - i < s / 2 ? 0 : 1;
  }
  getLastHighlightedRowNode() {
    return this.lastHighlightedRow;
  }
  isLastRowIndexKnown() {
    return !0;
  }
  getRowCount() {
    return this.rowsToDisplay ? this.rowsToDisplay.length : 0;
  }
  getTopLevelRowCount() {
    if (this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode)
      return 1;
    const t = this.rootNode.childrenAfterAggFilter;
    return t ? t.length : 0;
  }
  getTopLevelRowDisplayedIndex(e) {
    if (this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode)
      return e;
    let i = this.rootNode.childrenAfterSort[e];
    if (this.gos.get("groupHideOpenParents"))
      for (; i.expanded && i.childrenAfterSort && i.childrenAfterSort.length > 0; )
        i = i.childrenAfterSort[0];
    return i.rowIndex;
  }
  getRowBounds(e) {
    if (W.missing(this.rowsToDisplay))
      return null;
    const t = this.rowsToDisplay[e];
    return t ? {
      rowTop: t.rowTop,
      rowHeight: t.rowHeight
    } : null;
  }
  onRowGroupOpened() {
    const e = this.gos.isAnimateRows();
    this.refreshModel({ step: "map", keepRenderedRows: !0, animate: e });
  }
  onFilterChanged(e) {
    if (e.afterDataChange)
      return;
    const t = this.gos.isAnimateRows(), s = e.columns.length === 0 || e.columns.some((o) => o.isPrimary()) ? "filter" : "filter_aggregates";
    this.refreshModel({ step: s, keepRenderedRows: !0, animate: t });
  }
  onSortChanged() {
    const e = this.gos.isAnimateRows();
    this.refreshModel({ step: "sort", keepRenderedRows: !0, animate: e, keepEditingRows: !0 });
  }
  getType() {
    return "clientSide";
  }
  onValueChanged() {
    this.columnModel.isPivotActive() ? this.refreshModel({
      step: "pivot"
      /* PIVOT */
    }) : this.refreshModel({
      step: "aggregate"
      /* AGGREGATE */
    });
  }
  createChangePath(e) {
    const t = W.missingOrEmpty(e), i = new qn(!1, this.rootNode);
    return (t || this.gos.get("treeData")) && i.setInactive(), i;
  }
  isSuppressModelUpdateAfterUpdateTransaction(e) {
    if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction") || e.rowNodeTransactions == null)
      return !1;
    const t = e.rowNodeTransactions.filter(
      (s) => s.add != null && s.add.length > 0 || s.remove != null && s.remove.length > 0
    );
    return t == null || t.length == 0;
  }
  buildRefreshModelParams(e) {
    let t = "group";
    const i = {
      everything: "group",
      group: "group",
      filter: "filter",
      map: "map",
      aggregate: "aggregate",
      sort: "sort",
      pivot: "pivot"
      /* PIVOT */
    };
    if (W.exists(e) && (t = i[e]), W.missing(t)) {
      console.error(`AG Grid: invalid step ${e}, available steps are ${Object.keys(i).join(", ")}`);
      return;
    }
    const s = !this.gos.get("suppressAnimationFrame");
    return {
      step: t,
      keepRenderedRows: !0,
      keepEditingRows: !0,
      animate: s
    };
  }
  refreshModel(e) {
    if (!this.hasStarted || this.isRefreshingModel || this.columnModel.shouldRowModelIgnoreRefresh())
      return;
    let t = typeof e == "object" && "step" in e ? e : this.buildRefreshModelParams(e);
    if (!t || this.isSuppressModelUpdateAfterUpdateTransaction(t))
      return;
    const i = this.createChangePath(t.rowNodeTransactions);
    switch (this.isRefreshingModel = !0, t.step) {
      case "group":
        this.doRowGrouping(
          t.rowNodeTransactions,
          t.rowNodeOrder,
          i,
          !!t.afterColumnsChanged
        );
      case "filter":
        this.doFilter(i);
      case "pivot":
        this.doPivot(i);
      case "aggregate":
        this.doAggregate(i);
      case "filter_aggregates":
        this.doFilterAggregates(i);
      case "sort":
        this.doSort(t.rowNodeTransactions, i);
      case "map":
        this.doRowsToDisplay();
    }
    const s = this.setRowTopAndRowIndex();
    this.clearRowTopAndRowIndex(i, s), this.isRefreshingModel = !1;
    const o = {
      type: p.EVENT_MODEL_UPDATED,
      animate: t.animate,
      keepRenderedRows: t.keepRenderedRows,
      newData: t.newData,
      newPage: !1,
      keepUndoRedoStack: t.keepUndoRedoStack
    };
    this.eventService.dispatchEvent(o);
  }
  isEmpty() {
    const e = W.missing(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
    return W.missing(this.rootNode) || e || !this.columnModel.isReady();
  }
  isRowsToRender() {
    return W.exists(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
  }
  getNodesInRangeForSelection(e, t) {
    let i = !t, s = !1;
    const o = [], r = this.gos.get("groupSelectsChildren");
    return this.forEachNodeAfterFilterAndSort((n) => {
      if (s)
        return;
      if (i && (n === t || n === e) && (s = !0, n.group && r)) {
        o.push(...n.allLeafChildren);
        return;
      }
      if (!i) {
        if (n !== t && n !== e)
          return;
        i = !0;
      }
      if (!n.group || !r) {
        o.push(n);
        return;
      }
    }), o;
  }
  setDatasource(e) {
    console.error("AG Grid: should never call setDatasource on clientSideRowController");
  }
  getTopLevelNodes() {
    return this.rootNode ? this.rootNode.childrenAfterGroup : null;
  }
  getRootNode() {
    return this.rootNode;
  }
  getRow(e) {
    return this.rowsToDisplay[e];
  }
  isRowPresent(e) {
    return this.rowsToDisplay.indexOf(e) >= 0;
  }
  getRowIndexAtPixel(e) {
    if (this.isEmpty() || this.rowsToDisplay.length === 0)
      return -1;
    let t = 0, i = this.rowsToDisplay.length - 1;
    if (e <= 0)
      return 0;
    if (W.last(this.rowsToDisplay).rowTop <= e)
      return this.rowsToDisplay.length - 1;
    let o = -1, r = -1;
    for (; ; ) {
      const n = Math.floor((t + i) / 2), l = this.rowsToDisplay[n];
      if (this.isRowInPixel(l, e) || (l.rowTop < e ? t = n + 1 : l.rowTop > e && (i = n - 1), o === t && r === i))
        return n;
      o = t, r = i;
    }
  }
  isRowInPixel(e, t) {
    const i = e.rowTop, s = e.rowTop + e.rowHeight;
    return i <= t && s > t;
  }
  forEachLeafNode(e) {
    this.rootNode.allLeafChildren && this.rootNode.allLeafChildren.forEach((t, i) => e(t, i));
  }
  forEachNode(e, t = !1) {
    this.recursivelyWalkNodesAndCallback({
      nodes: [...this.rootNode.childrenAfterGroup || []],
      callback: e,
      recursionType: 0,
      index: 0,
      includeFooterNodes: t
    });
  }
  forEachNodeAfterFilter(e, t = !1) {
    this.recursivelyWalkNodesAndCallback({
      nodes: [...this.rootNode.childrenAfterAggFilter || []],
      callback: e,
      recursionType: 1,
      index: 0,
      includeFooterNodes: t
    });
  }
  forEachNodeAfterFilterAndSort(e, t = !1) {
    this.recursivelyWalkNodesAndCallback({
      nodes: [...this.rootNode.childrenAfterSort || []],
      callback: e,
      recursionType: 2,
      index: 0,
      includeFooterNodes: t
    });
  }
  forEachPivotNode(e, t = !1) {
    this.recursivelyWalkNodesAndCallback({
      nodes: [this.rootNode],
      callback: e,
      recursionType: 3,
      index: 0,
      includeFooterNodes: t
    });
  }
  // iterates through each item in memory, and calls the callback function
  // nodes - the rowNodes to traverse
  // callback - the user provided callback
  // recursion type - need this to know what child nodes to recurse, eg if looking at all nodes, or filtered notes etc
  // index - works similar to the index in forEach in javascript's array function
  recursivelyWalkNodesAndCallback(e) {
    const { nodes: t, callback: i, recursionType: s, includeFooterNodes: o } = e;
    let { index: r } = e;
    const n = (l) => {
      var a;
      const d = (a = t[0]) == null ? void 0 : a.parent;
      if (!d)
        return;
      const c = o && this.gos.getGrandTotalRow(), h = this.gos.getGroupTotalRowCallback(), g = o && h({ node: d });
      if (d === this.rootNode) {
        c === l && (d.createFooter(), i(d.sibling, r++));
        return;
      }
      g === l && (d.createFooter(), i(d.sibling, r++));
    };
    n("top");
    for (let l = 0; l < t.length; l++) {
      const a = t[l];
      if (i(a, r++), a.hasChildren() && !a.footer) {
        let d = null;
        switch (s) {
          case 0:
            d = a.childrenAfterGroup;
            break;
          case 1:
            d = a.childrenAfterAggFilter;
            break;
          case 2:
            d = a.childrenAfterSort;
            break;
          case 3:
            d = a.leafGroup ? null : a.childrenAfterSort;
            break;
        }
        d && (r = this.recursivelyWalkNodesAndCallback({
          nodes: [...d],
          callback: i,
          recursionType: s,
          index: r,
          includeFooterNodes: o
        }));
      }
    }
    return n("bottom"), r;
  }
  // it's possible to recompute the aggregate without doing the other parts
  // + api.refreshClientSideRowModel('aggregate')
  doAggregate(e) {
    var t;
    (t = this.aggregationStage) == null || t.execute({ rowNode: this.rootNode, changedPath: e });
  }
  doFilterAggregates(e) {
    this.filterAggregatesStage ? this.filterAggregatesStage.execute({ rowNode: this.rootNode, changedPath: e }) : this.rootNode.childrenAfterAggFilter = this.rootNode.childrenAfterFilter;
  }
  // + gridApi.expandAll()
  // + gridApi.collapseAll()
  expandOrCollapseAll(e) {
    const t = this.gos.get("treeData"), i = this.columnModel.isPivotActive(), s = (n) => {
      n && n.forEach((l) => {
        const a = () => {
          l.expanded = e, s(l.childrenAfterGroup);
        };
        if (t) {
          W.exists(l.childrenAfterGroup) && a();
          return;
        }
        if (i) {
          !l.leafGroup && a();
          return;
        }
        l.group && a();
      });
    };
    this.rootNode && s(this.rootNode.childrenAfterGroup), this.refreshModel({
      step: "map"
      /* MAP */
    });
    const o = e ? "expandAll" : "collapseAll", r = {
      type: p.EVENT_EXPAND_COLLAPSE_ALL,
      source: o
    };
    this.eventService.dispatchEvent(r);
  }
  doSort(e, t) {
    this.sortStage.execute({
      rowNode: this.rootNode,
      rowNodeTransactions: e,
      changedPath: t
    });
  }
  doRowGrouping(e, t, i, s) {
    if (this.groupStage) {
      if (e ? this.groupStage.execute({
        rowNode: this.rootNode,
        rowNodeTransactions: e,
        rowNodeOrder: t,
        changedPath: i
      }) : this.groupStage.execute({
        rowNode: this.rootNode,
        changedPath: i,
        afterColumnsChanged: s
      }), this.gos.get("groupSelectsChildren") && this.selectionService.updateGroupsFromChildrenSelections("rowGroupChanged", i)) {
        const r = {
          type: p.EVENT_SELECTION_CHANGED,
          source: "rowGroupChanged"
        };
        this.eventService.dispatchEvent(r);
      }
    } else
      this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren, this.rootNode.sibling && (this.rootNode.sibling.childrenAfterGroup = this.rootNode.childrenAfterGroup), this.rootNode.updateHasChildren();
    this.nodeManager.isRowCountReady() && (this.rowCountReady = !0, this.eventService.dispatchEventOnce({
      type: p.EVENT_ROW_COUNT_READY
    }));
  }
  doFilter(e) {
    this.filterStage.execute({ rowNode: this.rootNode, changedPath: e });
  }
  doPivot(e) {
    var t;
    (t = this.pivotStage) == null || t.execute({ rowNode: this.rootNode, changedPath: e });
  }
  getCopyOfNodesMap() {
    return this.nodeManager.getCopyOfNodesMap();
  }
  getRowNode(e) {
    if (typeof e == "string" && e.indexOf(X.ID_PREFIX_ROW_GROUP) == 0) {
      let i;
      return this.forEachNode((s) => {
        s.id === e && (i = s);
      }), i;
    }
    return this.nodeManager.getRowNode(e);
  }
  // rows: the rows to put into the model
  setRowData(e) {
    this.selectionService.reset("rowDataChanged"), this.nodeManager.setRowData(e), this.hasStarted && this.dispatchUpdateEventsAndRefresh();
  }
  dispatchUpdateEventsAndRefresh() {
    const e = {
      type: p.EVENT_ROW_DATA_UPDATED
    };
    this.eventService.dispatchEvent(e), this.refreshModel({
      step: "group",
      newData: !0
    });
  }
  batchUpdateRowData(e, t) {
    if (this.applyAsyncTransactionsTimeout == null) {
      this.rowDataTransactionBatch = [];
      const i = this.gos.getAsyncTransactionWaitMillis();
      this.applyAsyncTransactionsTimeout = window.setTimeout(() => {
        this.executeBatchUpdateRowData();
      }, i);
    }
    this.rowDataTransactionBatch.push({ rowDataTransaction: e, callback: t });
  }
  flushAsyncTransactions() {
    this.applyAsyncTransactionsTimeout != null && (clearTimeout(this.applyAsyncTransactionsTimeout), this.executeBatchUpdateRowData());
  }
  executeBatchUpdateRowData() {
    this.valueCache.onDataChanged();
    const e = [], t = [];
    let i = !1;
    if (this.rowDataTransactionBatch && this.rowDataTransactionBatch.forEach((s) => {
      const o = this.nodeManager.updateRowData(s.rowDataTransaction, void 0);
      t.push(o), s.callback && e.push(s.callback.bind(null, o)), typeof s.rowDataTransaction.addIndex == "number" && (i = !0);
    }), this.commonUpdateRowData(t, void 0, i), e.length > 0 && window.setTimeout(() => {
      e.forEach((s) => s());
    }, 0), t.length > 0) {
      const s = {
        type: p.EVENT_ASYNC_TRANSACTIONS_FLUSHED,
        results: t
      };
      this.eventService.dispatchEvent(s);
    }
    this.rowDataTransactionBatch = null, this.applyAsyncTransactionsTimeout = void 0;
  }
  updateRowData(e, t) {
    this.valueCache.onDataChanged();
    const i = this.nodeManager.updateRowData(e, t), s = typeof e.addIndex == "number";
    return this.commonUpdateRowData([i], t, s), i;
  }
  createRowNodeOrder() {
    if (this.gos.get("suppressMaintainUnsortedOrder"))
      return;
    const t = {};
    if (this.rootNode && this.rootNode.allLeafChildren)
      for (let i = 0; i < this.rootNode.allLeafChildren.length; i++) {
        const s = this.rootNode.allLeafChildren[i];
        t[s.id] = i;
      }
    return t;
  }
  // common to updateRowData and batchUpdateRowData
  commonUpdateRowData(e, t, i) {
    if (!this.hasStarted)
      return;
    const s = !this.gos.get("suppressAnimationFrame");
    i && (t = this.createRowNodeOrder());
    const o = {
      type: p.EVENT_ROW_DATA_UPDATED
    };
    this.eventService.dispatchEvent(o), this.refreshModel({
      step: "group",
      rowNodeTransactions: e,
      rowNodeOrder: t,
      keepRenderedRows: !0,
      keepEditingRows: !0,
      animate: s
    });
  }
  doRowsToDisplay() {
    this.rowsToDisplay = this.flattenStage.execute({ rowNode: this.rootNode });
  }
  onRowHeightChanged() {
    this.refreshModel({ step: "map", keepRenderedRows: !0, keepEditingRows: !0, keepUndoRedoStack: !0 });
  }
  /** This method is debounced. It is used for row auto-height. If we don't debounce,
   * then the Row Models will end up recalculating each row position
   * for each row height change and result in the Row Renderer laying out rows.
   * This is particularly bad if using print layout, and showing eg 1,000 rows,
   * each row will change it's height, causing Row Model to update 1,000 times.
   */
  onRowHeightChangedDebounced() {
    this.onRowHeightChanged_debounced();
  }
  resetRowHeights() {
    const e = this.resetRowHeightsForAllRowNodes();
    this.rootNode.setRowHeight(this.rootNode.rowHeight, !0), this.rootNode.sibling && this.rootNode.sibling.setRowHeight(this.rootNode.sibling.rowHeight, !0), e && this.onRowHeightChanged();
  }
  resetRowHeightsForAllRowNodes() {
    let e = !1;
    return this.forEachNode((t) => {
      t.setRowHeight(t.rowHeight, !0);
      const i = t.detailNode;
      i && i.setRowHeight(i.rowHeight, !0), t.sibling && t.sibling.setRowHeight(t.sibling.rowHeight, !0), e = !0;
    }), e;
  }
  onGridStylesChanges() {
    this.columnModel.isAutoRowHeightActive() || this.resetRowHeights();
  }
  onGridReady() {
    this.hasStarted || this.setInitialData();
  }
  isRowDataLoaded() {
    return this.rowCountReady;
  }
};
u([
  f("columnModel")
], lt.prototype, "columnModel", 2);
u([
  f("selectionService")
], lt.prototype, "selectionService", 2);
u([
  f("valueCache")
], lt.prototype, "valueCache", 2);
u([
  f("beans")
], lt.prototype, "beans", 2);
u([
  f("filterStage")
], lt.prototype, "filterStage", 2);
u([
  f("sortStage")
], lt.prototype, "sortStage", 2);
u([
  f("flattenStage")
], lt.prototype, "flattenStage", 2);
u([
  ue("groupStage")
], lt.prototype, "groupStage", 2);
u([
  ue("aggregationStage")
], lt.prototype, "aggregationStage", 2);
u([
  ue("pivotStage")
], lt.prototype, "pivotStage", 2);
u([
  ue("filterAggregatesStage")
], lt.prototype, "filterAggregatesStage", 2);
u([
  L
], lt.prototype, "init", 1);
lt = u([
  O("rowModel")
], lt);
var cn = class extends F {
  execute(e) {
    const { changedPath: t } = e;
    this.filterService.filter(t);
  }
};
u([
  f("filterService")
], cn.prototype, "filterService", 2);
cn = u([
  O("filterStage")
], cn);
var lr = class extends F {
  execute(e) {
    const t = this.sortController.getSortOptions(), i = W.exists(t) && t.length > 0, s = i && W.exists(e.rowNodeTransactions) && this.gos.get("deltaSort"), o = t.some((r) => this.gos.isColumnsSortingCoupledToGroup() ? r.column.isPrimary() && r.column.isRowGroupActive() : !!r.column.getColDef().showRowGroup);
    this.sortService.sort(t, i, s, e.rowNodeTransactions, e.changedPath, o);
  }
};
u([
  f("sortService")
], lr.prototype, "sortService", 2);
u([
  f("sortController")
], lr.prototype, "sortController", 2);
lr = u([
  O("sortStage")
], lr);
var hn = class extends F {
  execute(e) {
    const t = e.rowNode, i = [], s = this.beans.columnModel.isPivotMode(), o = s && t.leafGroup, r = o ? [t] : t.childrenAfterSort, n = this.getFlattenDetails();
    this.recursivelyAddToRowsToDisplay(n, r, i, s, 0);
    const l = i.length > 0;
    if (!o && l && n.grandTotalRow) {
      t.createFooter();
      const d = n.grandTotalRow === "top";
      this.addRowNodeToRowsToDisplay(n, t.sibling, i, 0, d);
    }
    return i;
  }
  getFlattenDetails() {
    const e = this.gos.get("groupRemoveSingleChildren");
    return {
      groupRemoveLowestSingleChildren: !e && this.gos.get("groupRemoveLowestSingleChildren"),
      groupRemoveSingleChildren: e,
      isGroupMultiAutoColumn: this.gos.isGroupMultiAutoColumn(),
      hideOpenParents: this.gos.get("groupHideOpenParents"),
      grandTotalRow: this.gos.getGrandTotalRow(),
      groupTotalRow: this.gos.getGroupTotalRowCallback()
    };
  }
  recursivelyAddToRowsToDisplay(e, t, i, s, o) {
    if (!W.missingOrEmpty(t))
      for (let r = 0; r < t.length; r++) {
        const n = t[r], l = n.hasChildren(), a = s && !l, d = e.groupRemoveSingleChildren && l && n.childrenAfterGroup.length === 1, c = e.groupRemoveLowestSingleChildren && l && n.leafGroup && n.childrenAfterGroup.length === 1, h = s && n.leafGroup, g = e.hideOpenParents && n.expanded && !n.master && !h;
        if (!a && !g && !d && !c && this.addRowNodeToRowsToDisplay(e, n, i, o), !(s && n.leafGroup)) {
          if (l) {
            const C = d || c;
            if (n.expanded || C) {
              const w = e.groupTotalRow({ node: n });
              w || n.destroyFooter();
              const v = C ? o : o + 1;
              w === "top" && (n.createFooter(), this.addRowNodeToRowsToDisplay(e, n.sibling, i, v)), this.recursivelyAddToRowsToDisplay(
                e,
                n.childrenAfterSort,
                i,
                s,
                v
              ), w === "bottom" && (n.createFooter(), this.addRowNodeToRowsToDisplay(e, n.sibling, i, v));
            }
          } else if (n.master && n.expanded) {
            const C = this.createDetailNode(n);
            this.addRowNodeToRowsToDisplay(e, C, i, o);
          }
        }
      }
  }
  // duplicated method, it's also in floatingRowModel
  addRowNodeToRowsToDisplay(e, t, i, s, o) {
    o ? i.unshift(t) : i.push(t), t.setUiLevel(e.isGroupMultiAutoColumn ? 0 : s);
  }
  createDetailNode(e) {
    if (W.exists(e.detailNode))
      return e.detailNode;
    const t = new X(this.beans);
    return t.detail = !0, t.selectable = !1, t.parent = e, W.exists(e.id) && (t.id = "detail_" + e.id), t.data = e.data, t.level = e.level + 1, e.detailNode = t, t;
  }
};
u([
  f("beans")
], hn.prototype, "beans", 2);
hn = u([
  O("flattenStage")
], hn);
var ar = class extends F {
  sort(e, t, i, s, o, r) {
    const n = this.gos.get("groupMaintainOrder"), l = this.columnModel.getAllGridColumns().some((g) => g.isRowGroupActive());
    let a = {};
    i && s && (a = this.calculateDirtyNodes(s));
    const d = this.columnModel.isPivotMode(), c = this.gos.getCallback("postSortRows"), h = (g) => {
      var m;
      this.pullDownGroupDataForHideOpenParents(g.childrenAfterAggFilter, !0);
      const C = d && g.leafGroup;
      if (n && l && !g.leafGroup && !r) {
        const v = (m = this.columnModel.getRowGroupColumns()) == null ? void 0 : m[g.level + 1], y = (v == null ? void 0 : v.getSort()) === null, E = g.childrenAfterAggFilter.slice(0);
        if (g.childrenAfterSort && !y) {
          const D = {};
          g.childrenAfterSort.forEach((R, T) => {
            D[R.id] = T;
          }), E.sort((R, T) => {
            var I, A;
            return ((I = D[R.id]) != null ? I : 0) - ((A = D[T.id]) != null ? A : 0);
          });
        }
        g.childrenAfterSort = E;
      } else !t || C ? g.childrenAfterSort = g.childrenAfterAggFilter.slice(0) : i ? g.childrenAfterSort = this.doDeltaSort(g, a, o, e) : g.childrenAfterSort = this.rowNodeSorter.doFullSort(g.childrenAfterAggFilter, e);
      if (g.sibling && (g.sibling.childrenAfterSort = g.childrenAfterSort), this.updateChildIndexes(g), c) {
        const v = { nodes: g.childrenAfterSort };
        c(v);
      }
    };
    o && o.forEachChangedNodeDepthFirst(h), this.updateGroupDataForHideOpenParents(o);
  }
  calculateDirtyNodes(e) {
    const t = {}, i = (s) => {
      s && s.forEach((o) => t[o.id] = !0);
    };
    return e && e.forEach((s) => {
      i(s.add), i(s.update), i(s.remove);
    }), t;
  }
  doDeltaSort(e, t, i, s) {
    const o = e.childrenAfterAggFilter, r = e.childrenAfterSort;
    if (!r)
      return this.rowNodeSorter.doFullSort(o, s);
    const n = {}, l = [];
    o.forEach((h) => {
      t[h.id] || !i.canSkip(h) ? l.push(h) : n[h.id] = !0;
    });
    const a = r.filter((h) => n[h.id]), d = (h, g) => ({ currentPos: g, rowNode: h }), c = l.map(d).sort((h, g) => this.rowNodeSorter.compareRowNodes(s, h, g));
    return this.mergeSortedArrays(
      s,
      c,
      a.map(d)
    ).map(({ rowNode: h }) => h);
  }
  // Merge two sorted arrays into each other
  mergeSortedArrays(e, t, i) {
    const s = [];
    let o = 0, r = 0;
    for (; o < t.length && r < i.length; )
      this.rowNodeSorter.compareRowNodes(e, t[o], i[r]) < 0 ? s.push(t[o++]) : s.push(i[r++]);
    for (; o < t.length; )
      s.push(t[o++]);
    for (; r < i.length; )
      s.push(i[r++]);
    return s;
  }
  updateChildIndexes(e) {
    if (W.missing(e.childrenAfterSort))
      return;
    const t = e.childrenAfterSort;
    for (let i = 0; i < t.length; i++) {
      const s = t[i], o = i === 0, r = i === e.childrenAfterSort.length - 1;
      s.setFirstChild(o), s.setLastChild(r), s.setChildIndex(i);
    }
  }
  updateGroupDataForHideOpenParents(e) {
    if (!this.gos.get("groupHideOpenParents"))
      return;
    if (this.gos.get("treeData"))
      return W.warnOnce("The property hideOpenParents dose not work with Tree Data. This is because Tree Data has values at the group level, it doesn't make sense to hide them."), !1;
    const t = (i) => {
      this.pullDownGroupDataForHideOpenParents(i.childrenAfterSort, !1), i.childrenAfterSort.forEach((s) => {
        s.hasChildren() && t(s);
      });
    };
    e && e.executeFromRootNode((i) => t(i));
  }
  pullDownGroupDataForHideOpenParents(e, t) {
    !this.gos.get("groupHideOpenParents") || W.missing(e) || e.forEach((i) => {
      this.columnModel.getGroupDisplayColumns().forEach((o) => {
        const r = o.getColDef().showRowGroup;
        if (typeof r != "string") {
          console.error("AG Grid: groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup");
          return;
        }
        const n = r, l = this.columnModel.getPrimaryColumn(n);
        if (l !== i.rowGroupColumn)
          if (t)
            i.setGroupValue(o.getId(), void 0);
          else {
            const d = i.getFirstChildOfFirstChild(l);
            d && i.setGroupValue(o.getId(), d.key);
          }
      });
    });
  }
};
u([
  f("columnModel")
], ar.prototype, "columnModel", 2);
u([
  f("rowNodeSorter")
], ar.prototype, "rowNodeSorter", 2);
ar = u([
  O("sortService")
], ar);
var pn = class extends F {
  filter(e) {
    const t = this.filterManager.isChildFilterPresent();
    this.filterNodes(t, e);
  }
  filterNodes(e, t) {
    const i = (s, o) => {
      s.hasChildren() && e && !o ? s.childrenAfterFilter = s.childrenAfterGroup.filter((r) => {
        const n = r.childrenAfterFilter && r.childrenAfterFilter.length > 0, l = r.data && this.filterManager.doesRowPassFilter({ rowNode: r });
        return n || l;
      }) : s.childrenAfterFilter = s.childrenAfterGroup, s.sibling && (s.sibling.childrenAfterFilter = s.childrenAfterFilter);
    };
    if (this.doingTreeDataFiltering()) {
      const s = (r, n) => {
        if (r.childrenAfterGroup)
          for (let l = 0; l < r.childrenAfterGroup.length; l++) {
            const a = r.childrenAfterGroup[l], d = n || this.filterManager.doesRowPassFilter({ rowNode: a });
            a.childrenAfterGroup ? s(r.childrenAfterGroup[l], d) : i(a, d);
          }
        i(r, n);
      }, o = (r) => s(r, !1);
      t.executeFromRootNode(o);
    } else {
      const s = (o) => i(o, !1);
      t.forEachChangedNodeDepthFirst(s, !0);
    }
  }
  doingTreeDataFiltering() {
    return this.gos.get("treeData") && !this.gos.get("excludeChildrenWhenTreeDataFiltering");
  }
};
u([
  f("filterManager")
], pn.prototype, "filterManager", 2);
pn = u([
  O("filterService")
], pn);
var Ss = class extends F {
  postConstruct() {
    this.rowModel.getType() === "clientSide" && (this.clientSideRowModel = this.rowModel, this.addManagedPropertyListener("rowData", () => this.onRowDataUpdated()));
  }
  isActive() {
    const e = this.gos.exists("getRowId");
    return this.gos.get("resetRowDataOnUpdate") ? !1 : e;
  }
  setRowData(e) {
    const t = this.createTransactionForRowData(e);
    if (!t)
      return;
    const [i, s] = t;
    this.clientSideRowModel.updateRowData(i, s);
  }
  // converts the setRowData() command to a transaction
  createTransactionForRowData(e) {
    if (W.missing(this.clientSideRowModel)) {
      console.error("AG Grid: ImmutableService only works with ClientSideRowModel");
      return;
    }
    const t = this.gos.getCallback("getRowId");
    if (t == null) {
      console.error("AG Grid: ImmutableService requires getRowId() callback to be implemented, your row data needs IDs!");
      return;
    }
    const i = {
      remove: [],
      update: [],
      add: []
    }, s = this.clientSideRowModel.getCopyOfNodesMap(), r = this.gos.get("suppressMaintainUnsortedOrder") ? void 0 : {};
    return W.exists(e) && e.forEach((n, l) => {
      const a = t({ data: n, level: 0 }), d = s[a];
      r && (r[a] = l), d ? (d.data !== n && i.update.push(n), s[a] = void 0) : i.add.push(n);
    }), W.iterateObject(s, (n, l) => {
      l && i.remove.push(l.data);
    }), [i, r];
  }
  onRowDataUpdated() {
    const e = this.gos.get("rowData");
    e && (this.isActive() ? this.setRowData(e) : (this.selectionService.reset("rowDataChanged"), this.clientSideRowModel.setRowData(e)));
  }
};
u([
  f("rowModel")
], Ss.prototype, "rowModel", 2);
u([
  f("rowRenderer")
], Ss.prototype, "rowRenderer", 2);
u([
  f("selectionService")
], Ss.prototype, "selectionService", 2);
u([
  L
], Ss.prototype, "postConstruct", 1);
Ss = u([
  O("immutableService")
], Ss);
var Mm = "31.3.4", xm = {
  version: Mm,
  moduleName: "@ag-grid-community/client-side-row-model",
  rowModel: "clientSide",
  beans: [lt, cn, lr, hn, ar, pn, Ss]
}, Nm = Object.defineProperty, Gm = Object.getOwnPropertyDescriptor, ct = (e, t, i, s) => {
  for (var o = s > 1 ? void 0 : s ? Gm(t, i) : t, r = e.length - 1, n; r >= 0; r--)
    (n = e[r]) && (o = (s ? n(t, i, o) : n(o)) || o);
  return s && o && Nm(t, i, o), o;
}, Om = (e, t) => (i, s) => t(i, s, e), dr = class extends zl {
  constructor(e, t, i) {
    super(e), this.parentCache = t, this.params = i, this.startRow = e * i.blockSize, this.endRow = this.startRow + i.blockSize;
  }
  postConstruct() {
    this.createRowNodes();
  }
  getBlockStateJson() {
    return {
      id: "" + this.getId(),
      state: {
        blockNumber: this.getId(),
        startRow: this.getStartRow(),
        endRow: this.getEndRow(),
        pageStatus: this.getState()
      }
    };
  }
  setDataAndId(e, t, i) {
    W.exists(t) ? e.setDataAndId(t, i.toString()) : e.setDataAndId(void 0, void 0);
  }
  loadFromDatasource() {
    const e = this.createLoadParams();
    if (W.missing(this.params.datasource.getRows)) {
      console.warn("AG Grid: datasource is missing getRows method");
      return;
    }
    window.setTimeout(() => {
      this.params.datasource.getRows(e);
    }, 0);
  }
  processServerFail() {
  }
  createLoadParams() {
    return {
      startRow: this.getStartRow(),
      endRow: this.getEndRow(),
      successCallback: this.pageLoaded.bind(this, this.getVersion()),
      failCallback: this.pageLoadFailed.bind(this, this.getVersion()),
      sortModel: this.params.sortModel,
      filterModel: this.params.filterModel,
      context: this.gos.getGridCommonParams().context
    };
  }
  forEachNode(e, t, i) {
    this.rowNodes.forEach((s, o) => {
      this.startRow + o < i && e(s, t.next());
    });
  }
  getLastAccessed() {
    return this.lastAccessed;
  }
  getRow(e, t = !1) {
    t || (this.lastAccessed = this.params.lastAccessedSequence.next());
    const i = e - this.startRow;
    return this.rowNodes[i];
  }
  getStartRow() {
    return this.startRow;
  }
  getEndRow() {
    return this.endRow;
  }
  // creates empty row nodes, data is missing as not loaded yet
  createRowNodes() {
    this.rowNodes = [];
    for (let e = 0; e < this.params.blockSize; e++) {
      const t = this.startRow + e, i = new X(this.beans);
      i.setRowHeight(this.params.rowHeight), i.uiLevel = 0, i.setRowIndex(t), i.setRowTop(this.params.rowHeight * t), this.rowNodes.push(i);
    }
  }
  processServerResult(e) {
    this.rowNodes.forEach((i, s) => {
      const o = e.rowData ? e.rowData[s] : void 0;
      !i.id && i.alreadyRendered && o && (this.rowNodes[s] = new X(this.beans), this.rowNodes[s].setRowIndex(i.rowIndex), this.rowNodes[s].setRowTop(i.rowTop), this.rowNodes[s].setRowHeight(i.rowHeight), i.clearRowTopAndRowIndex()), this.setDataAndId(this.rowNodes[s], o, this.startRow + s);
    });
    const t = e.rowCount != null && e.rowCount >= 0 ? e.rowCount : void 0;
    this.parentCache.pageLoaded(this, t);
  }
  destroyRowNodes() {
    this.rowNodes.forEach((e) => {
      e.clearRowTopAndRowIndex();
    });
  }
};
ct([
  f("beans")
], dr.prototype, "beans", 2);
ct([
  L
], dr.prototype, "postConstruct", 1);
ct([
  dt
], dr.prototype, "destroyRowNodes", 1);
var yo = class zh extends F {
  constructor(t) {
    super(), this.lastRowIndexKnown = !1, this.blocks = {}, this.blockCount = 0, this.rowCount = t.initialRowCount, this.params = t;
  }
  setBeans(t) {
    this.logger = t.create("InfiniteCache");
  }
  // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
  // it will want new pages in the cache as it asks for rows. only when we are inserting /
  // removing rows via the api is dontCreatePage set, where we move rows between the pages.
  getRow(t, i = !1) {
    const s = Math.floor(t / this.params.blockSize);
    let o = this.blocks[s];
    if (!o) {
      if (i)
        return;
      o = this.createBlock(s);
    }
    return o.getRow(t);
  }
  createBlock(t) {
    const i = this.createBean(new dr(t, this, this.params));
    return this.blocks[i.getId()] = i, this.blockCount++, this.purgeBlocksIfNeeded(i), this.params.rowNodeBlockLoader.addBlock(i), i;
  }
  // we have this on infinite row model only, not server side row model,
  // because for server side, it would leave the children in inconsistent
  // state - eg if a node had children, but after the refresh it had data
  // for a different row, then the children would be with the wrong row node.
  refreshCache() {
    if (this.blockCount == 0) {
      this.purgeCache();
      return;
    }
    this.getBlocksInOrder().forEach((i) => i.setStateWaitingToLoad()), this.params.rowNodeBlockLoader.checkBlockToLoad();
  }
  destroyAllBlocks() {
    this.getBlocksInOrder().forEach((t) => this.destroyBlock(t));
  }
  getRowCount() {
    return this.rowCount;
  }
  isLastRowIndexKnown() {
    return this.lastRowIndexKnown;
  }
  // block calls this, when page loaded
  pageLoaded(t, i) {
    this.isAlive() && (this.logger.log(`onPageLoaded: page = ${t.getId()}, lastRow = ${i}`), this.checkRowCount(t, i), this.onCacheUpdated());
  }
  purgeBlocksIfNeeded(t) {
    const i = this.getBlocksInOrder().filter((l) => l != t), s = (l, a) => a.getLastAccessed() - l.getLastAccessed();
    i.sort(s);
    const o = this.params.maxBlocksInCache > 0, r = o ? this.params.maxBlocksInCache - 1 : null, n = zh.MAX_EMPTY_BLOCKS_TO_KEEP - 1;
    i.forEach((l, a) => {
      const d = l.getState() === dr.STATE_WAITING_TO_LOAD && a >= n, c = o ? a >= r : !1;
      if (d || c) {
        if (this.isBlockCurrentlyDisplayed(l) || this.isBlockFocused(l))
          return;
        this.removeBlockFromCache(l);
      }
    });
  }
  isBlockFocused(t) {
    const i = this.focusService.getFocusCellToUseAfterRefresh();
    if (!i || i.rowPinned != null)
      return !1;
    const s = t.getStartRow(), o = t.getEndRow();
    return i.rowIndex >= s && i.rowIndex < o;
  }
  isBlockCurrentlyDisplayed(t) {
    const i = t.getStartRow(), s = t.getEndRow() - 1;
    return this.rowRenderer.isRangeInRenderedViewport(i, s);
  }
  removeBlockFromCache(t) {
    t && this.destroyBlock(t);
  }
  checkRowCount(t, i) {
    if (typeof i == "number" && i >= 0)
      this.rowCount = i, this.lastRowIndexKnown = !0;
    else if (!this.lastRowIndexKnown) {
      const o = (t.getId() + 1) * this.params.blockSize + this.params.overflowSize;
      this.rowCount < o && (this.rowCount = o);
    }
  }
  setRowCount(t, i) {
    this.rowCount = t, W.exists(i) && (this.lastRowIndexKnown = i), this.lastRowIndexKnown || this.rowCount % this.params.blockSize === 0 && this.rowCount++, this.onCacheUpdated();
  }
  forEachNodeDeep(t) {
    const i = new Xs();
    this.getBlocksInOrder().forEach((s) => s.forEachNode(t, i, this.rowCount));
  }
  getBlocksInOrder() {
    const t = (s, o) => s.getId() - o.getId();
    return W.getAllValuesInObject(this.blocks).sort(t);
  }
  destroyBlock(t) {
    delete this.blocks[t.getId()], this.destroyBean(t), this.blockCount--, this.params.rowNodeBlockLoader.removeBlock(t);
  }
  // gets called 1) row count changed 2) cache purged 3) items inserted
  onCacheUpdated() {
    if (this.isAlive()) {
      this.destroyAllBlocksPastVirtualRowCount();
      const t = {
        type: p.EVENT_STORE_UPDATED
      };
      this.eventService.dispatchEvent(t);
    }
  }
  destroyAllBlocksPastVirtualRowCount() {
    const t = [];
    this.getBlocksInOrder().forEach((i) => {
      i.getId() * this.params.blockSize >= this.rowCount && t.push(i);
    }), t.length > 0 && t.forEach((i) => this.destroyBlock(i));
  }
  purgeCache() {
    this.getBlocksInOrder().forEach((t) => this.removeBlockFromCache(t)), this.lastRowIndexKnown = !1, this.rowCount === 0 && (this.rowCount = this.params.initialRowCount), this.onCacheUpdated();
  }
  getRowNodesInRange(t, i) {
    const s = [];
    let o = -1, r = !1;
    const n = new Xs();
    W.missing(t) && (r = !0);
    let l = !1;
    return this.getBlocksInOrder().forEach((d) => {
      if (!l) {
        if (r && o + 1 !== d.getId()) {
          l = !0;
          return;
        }
        o = d.getId(), d.forEachNode((c) => {
          const h = c === t || c === i;
          (r || h) && s.push(c), h && (r = !r);
        }, n, this.rowCount);
      }
    }), l || r ? [] : s;
  }
};
yo.MAX_EMPTY_BLOCKS_TO_KEEP = 2;
ct([
  f("rowRenderer")
], yo.prototype, "rowRenderer", 2);
ct([
  f("focusService")
], yo.prototype, "focusService", 2);
ct([
  Om(0, Mt("loggerFactory"))
], yo.prototype, "setBeans", 1);
ct([
  dt
], yo.prototype, "destroyAllBlocks", 1);
var _m = yo, ai = class extends F {
  getRowBounds(e) {
    return {
      rowHeight: this.rowHeight,
      rowTop: this.rowHeight * e
    };
  }
  // we don't implement as lazy row heights is not supported in this row model
  ensureRowHeightsValid(e, t, i, s) {
    return !1;
  }
  init() {
    this.gos.isRowModelType("infinite") && (this.rowHeight = this.gos.getRowHeightAsNumber(), this.addEventListeners(), this.addDestroyFunc(() => this.destroyCache()), this.verifyProps());
  }
  verifyProps() {
    this.gos.exists("initialGroupOrderComparator") && W.warnOnce("initialGroupOrderComparator cannot be used with Infinite Row Model as sorting is done on the server side");
  }
  start() {
    this.setDatasource(this.gos.get("datasource"));
  }
  destroyDatasource() {
    this.datasource && (this.getContext().destroyBean(this.datasource), this.rowRenderer.datasourceChanged(), this.datasource = null);
  }
  addEventListeners() {
    this.addManagedListener(this.eventService, p.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_SORT_CHANGED, this.onSortChanged.bind(this)), this.addManagedListener(this.eventService, p.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverything.bind(this)), this.addManagedListener(this.eventService, p.EVENT_STORE_UPDATED, this.onCacheUpdated.bind(this)), this.addManagedPropertyListener("datasource", () => this.setDatasource(this.gos.get("datasource"))), this.addManagedPropertyListener("cacheBlockSize", () => this.resetCache()), this.addManagedPropertyListener("rowHeight", () => {
      this.rowHeight = this.gos.getRowHeightAsNumber(), this.cacheParams.rowHeight = this.rowHeight, this.updateRowHeights();
    });
  }
  onFilterChanged() {
    this.reset();
  }
  onSortChanged() {
    this.reset();
  }
  onColumnEverything() {
    let e;
    this.cacheParams ? e = this.isSortModelDifferent() : e = !0, e && this.reset();
  }
  isSortModelDifferent() {
    return !W.jsonEquals(this.cacheParams.sortModel, this.sortController.getSortModel());
  }
  getType() {
    return "infinite";
  }
  setDatasource(e) {
    this.destroyDatasource(), this.datasource = e, e && this.reset();
  }
  isEmpty() {
    return !this.infiniteCache;
  }
  isRowsToRender() {
    return !!this.infiniteCache;
  }
  getNodesInRangeForSelection(e, t) {
    return this.infiniteCache ? this.infiniteCache.getRowNodesInRange(e, t) : [];
  }
  reset() {
    if (!this.datasource)
      return;
    this.gos.getCallback("getRowId") != null || this.selectionService.reset("rowDataChanged"), this.resetCache();
  }
  createModelUpdatedEvent() {
    return {
      type: p.EVENT_MODEL_UPDATED,
      // not sure if these should all be false - noticed if after implementing,
      // maybe they should be true?
      newPage: !1,
      newPageSize: !1,
      newData: !1,
      keepRenderedRows: !0,
      animate: !1
    };
  }
  resetCache() {
    this.destroyCache(), this.cacheParams = {
      // the user provided datasource
      datasource: this.datasource,
      // sort and filter model
      filterModel: this.filterManager.getFilterModel(),
      sortModel: this.sortController.getSortModel(),
      rowNodeBlockLoader: this.rowNodeBlockLoader,
      // properties - this way we take a snapshot of them, so if user changes any, they will be
      // used next time we create a new cache, which is generally after a filter or sort change,
      // or a new datasource is set
      initialRowCount: this.gos.get("infiniteInitialRowCount"),
      maxBlocksInCache: this.gos.get("maxBlocksInCache"),
      rowHeight: this.gos.getRowHeightAsNumber(),
      // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
      // the current page and request first row of next page
      overflowSize: this.gos.get("cacheOverflowSize"),
      // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
      // server for one page at a time. so the default if not specified is 100.
      blockSize: this.gos.get("cacheBlockSize"),
      // the cache could create this, however it is also used by the pages, so handy to create it
      // here as the settings are also passed to the pages
      lastAccessedSequence: new Xs()
    }, this.infiniteCache = this.createBean(new _m(this.cacheParams)), this.eventService.dispatchEventOnce({
      type: p.EVENT_ROW_COUNT_READY
    });
    const e = this.createModelUpdatedEvent();
    this.eventService.dispatchEvent(e);
  }
  updateRowHeights() {
    this.forEachNode((t) => {
      t.setRowHeight(this.rowHeight), t.setRowTop(this.rowHeight * t.rowIndex);
    });
    const e = this.createModelUpdatedEvent();
    this.eventService.dispatchEvent(e);
  }
  destroyCache() {
    this.infiniteCache && (this.infiniteCache = this.destroyBean(this.infiniteCache));
  }
  onCacheUpdated() {
    const e = this.createModelUpdatedEvent();
    this.eventService.dispatchEvent(e);
  }
  getRow(e) {
    if (this.infiniteCache && !(e >= this.infiniteCache.getRowCount()))
      return this.infiniteCache.getRow(e);
  }
  getRowNode(e) {
    let t;
    return this.forEachNode((i) => {
      i.id === e && (t = i);
    }), t;
  }
  forEachNode(e) {
    this.infiniteCache && this.infiniteCache.forEachNodeDeep(e);
  }
  getTopLevelRowCount() {
    return this.getRowCount();
  }
  getTopLevelRowDisplayedIndex(e) {
    return e;
  }
  getRowIndexAtPixel(e) {
    if (this.rowHeight !== 0) {
      const t = Math.floor(e / this.rowHeight), i = this.getRowCount() - 1;
      return t > i ? i : t;
    }
    return 0;
  }
  getRowCount() {
    return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
  }
  isRowPresent(e) {
    return !!this.getRowNode(e.id);
  }
  refreshCache() {
    this.infiniteCache && this.infiniteCache.refreshCache();
  }
  purgeCache() {
    this.infiniteCache && this.infiniteCache.purgeCache();
  }
  // for iRowModel
  isLastRowIndexKnown() {
    return this.infiniteCache ? this.infiniteCache.isLastRowIndexKnown() : !1;
  }
  setRowCount(e, t) {
    this.infiniteCache && this.infiniteCache.setRowCount(e, t);
  }
};
ct([
  f("filterManager")
], ai.prototype, "filterManager", 2);
ct([
  f("sortController")
], ai.prototype, "sortController", 2);
ct([
  f("selectionService")
], ai.prototype, "selectionService", 2);
ct([
  f("rowRenderer")
], ai.prototype, "rowRenderer", 2);
ct([
  f("rowNodeBlockLoader")
], ai.prototype, "rowNodeBlockLoader", 2);
ct([
  L
], ai.prototype, "init", 1);
ct([
  dt
], ai.prototype, "destroyDatasource", 1);
ai = ct([
  O("rowModel")
], ai);
var Vm = "31.3.4", Hm = {
  version: Vm,
  moduleName: "@ag-grid-community/infinite-row-model",
  rowModel: "infinite",
  beans: [ai]
}, km = Object.defineProperty, Bm = Object.getOwnPropertyDescriptor, Dt = (e, t, i, s) => {
  for (var o = s > 1 ? void 0 : s ? Bm(t, i) : t, r = e.length - 1, n; r >= 0; r--)
    (n = e[r]) && (o = (s ? n(t, i, o) : n(o)) || o);
  return s && o && km(t, i, o), o;
}, Wm = class {
  setBeans(e) {
    this.beans = e;
  }
  getFileName(e) {
    const t = this.getDefaultFileExtension();
    return (e == null || !e.length) && (e = this.getDefaultFileName()), e.indexOf(".") === -1 ? `${e}.${t}` : e;
  }
  getData(e) {
    const t = this.createSerializingSession(e);
    return this.beans.gridSerializer.serialize(t, e);
  }
  getDefaultFileName() {
    return `export.${this.getDefaultFileExtension()}`;
  }
}, Um = class {
  constructor(e) {
    this.groupColumns = [];
    const {
      columnModel: t,
      valueService: i,
      gos: s,
      processCellCallback: o,
      processHeaderCallback: r,
      processGroupHeaderCallback: n,
      processRowGroupCallback: l
    } = e;
    this.columnModel = t, this.valueService = i, this.gos = s, this.processCellCallback = o, this.processHeaderCallback = r, this.processGroupHeaderCallback = n, this.processRowGroupCallback = l;
  }
  prepare(e) {
    this.groupColumns = e.filter((t) => !!t.getColDef().showRowGroup);
  }
  extractHeaderValue(e) {
    const t = this.getHeaderName(this.processHeaderCallback, e);
    return t ?? "";
  }
  extractRowCellValue(e, t, i, s, o) {
    const n = (!this.gos.get("groupHideOpenParents") || o.footer) && this.shouldRenderGroupSummaryCell(o, e, t) ? this.createValueForGroupNode(e, o) : this.valueService.getValue(e, o);
    return this.processCell({
      accumulatedRowIndex: i,
      rowNode: o,
      column: e,
      value: n,
      processCellCallback: this.processCellCallback,
      type: s
    });
  }
  shouldRenderGroupSummaryCell(e, t, i) {
    var s;
    if (!(e && e.group))
      return !1;
    if (this.groupColumns.indexOf(t) !== -1) {
      if (((s = e.groupData) == null ? void 0 : s[t.getId()]) != null || this.gos.isRowModelType("serverSide") && e.group)
        return !0;
      if (e.footer && e.level === -1) {
        const l = t.getColDef();
        return l == null || l.showRowGroup === !0 || l.showRowGroup === this.columnModel.getRowGroupColumns()[0].getId();
      }
    }
    const n = this.gos.isGroupUseEntireRow(this.columnModel.isPivotMode());
    return i === 0 && n;
  }
  getHeaderName(e, t) {
    return e ? e(this.gos.addGridCommonParams({ column: t })) : this.columnModel.getDisplayNameForColumn(t, "csv", !0);
  }
  createValueForGroupNode(e, t) {
    if (this.processRowGroupCallback)
      return this.processRowGroupCallback(this.gos.addGridCommonParams({ column: e, node: t }));
    const i = this.gos.get("treeData"), s = this.gos.get("suppressGroupMaintainValueType"), o = (a) => {
      var d, c;
      if (i || s)
        return a.key;
      const h = (d = a.groupData) == null ? void 0 : d[e.getId()];
      return !h || !a.rowGroupColumn || a.rowGroupColumn.getColDef().useValueFormatterForExport === !1 ? h : (c = this.valueService.formatValue(a.rowGroupColumn, a, h)) != null ? c : h;
    }, r = t.footer, n = [o(t)];
    if (!this.gos.isGroupMultiAutoColumn())
      for (; t.parent; )
        t = t.parent, n.push(o(t));
    const l = n.reverse().join(" -> ");
    return r ? `Total ${l}` : l;
  }
  processCell(e) {
    var t;
    const { accumulatedRowIndex: i, rowNode: s, column: o, value: r, processCellCallback: n, type: l } = e;
    return n ? {
      value: (t = n(this.gos.addGridCommonParams({
        accumulatedRowIndex: i,
        column: o,
        node: s,
        value: r,
        type: l,
        parseValue: (a) => this.valueService.parseValue(o, s, a, this.valueService.getValue(o, s)),
        formatValue: (a) => {
          var d;
          return (d = this.valueService.formatValue(o, s, a)) != null ? d : a;
        }
      }))) != null ? t : ""
    } : o.getColDef().useValueFormatterForExport !== !1 ? {
      value: r ?? "",
      valueFormatted: this.valueService.formatValue(o, s, r)
    } : { value: r ?? "" };
  }
}, zm = class {
  static download(e, t) {
    const i = document.defaultView || window;
    if (!i) {
      console.warn("AG Grid: There is no `window` associated with the current `document`");
      return;
    }
    const s = document.createElement("a"), o = i.URL.createObjectURL(t);
    s.setAttribute("href", o), s.setAttribute("download", e), s.style.display = "none", document.body.appendChild(s), s.dispatchEvent(new MouseEvent("click", {
      bubbles: !1,
      cancelable: !0,
      view: i
    })), document.body.removeChild(s), i.setTimeout(() => {
      i.URL.revokeObjectURL(o);
    }, 0);
  }
}, Bd = `\r
`, Km = class extends Um {
  constructor(e) {
    super(e), this.isFirstLine = !0, this.result = "";
    const { suppressQuotes: t, columnSeparator: i } = e;
    this.suppressQuotes = t, this.columnSeparator = i;
  }
  addCustomContent(e) {
    e && (typeof e == "string" ? (/^\s*\n/.test(e) || this.beginNewLine(), e = e.replace(/\r?\n/g, Bd), this.result += e) : e.forEach((t) => {
      this.beginNewLine(), t.forEach((i, s) => {
        s !== 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(i.data.value || ""), i.mergeAcross && this.appendEmptyCells(i.mergeAcross);
      });
    }));
  }
  onNewHeaderGroupingRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
    };
  }
  onNewHeaderGroupingRowColumn(e, t, i, s) {
    i != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(t), this.appendEmptyCells(s);
  }
  appendEmptyCells(e) {
    for (let t = 1; t <= e; t++)
      this.result += this.columnSeparator + this.putInQuotes("");
  }
  onNewHeaderRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewHeaderRowColumn.bind(this)
    };
  }
  onNewHeaderRowColumn(e, t) {
    t != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(this.extractHeaderValue(e));
  }
  onNewBodyRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewBodyRowColumn.bind(this)
    };
  }
  onNewBodyRowColumn(e, t, i) {
    var s;
    t != 0 && (this.result += this.columnSeparator);
    const o = this.extractRowCellValue(e, t, t, "csv", i);
    this.result += this.putInQuotes((s = o.valueFormatted) != null ? s : o.value);
  }
  putInQuotes(e) {
    if (this.suppressQuotes)
      return e;
    if (e == null)
      return '""';
    let t;
    return typeof e == "string" ? t = e : typeof e.toString == "function" ? t = e.toString() : (console.warn("AG Grid: unknown value type during csv conversion"), t = ""), '"' + t.replace(/"/g, '""') + '"';
  }
  parse() {
    return this.result;
  }
  beginNewLine() {
    this.isFirstLine || (this.result += Bd), this.isFirstLine = !1;
  }
}, Oi = class extends Wm {
  postConstruct() {
    this.setBeans({
      gridSerializer: this.gridSerializer,
      gos: this.gos
    });
  }
  getMergedParams(e) {
    const t = this.gos.get("defaultCsvExportParams");
    return Object.assign({}, t, e);
  }
  export(e) {
    if (this.isExportSuppressed()) {
      console.warn("AG Grid: Export cancelled. Export is not allowed as per your configuration.");
      return;
    }
    const t = this.getMergedParams(e), i = this.getData(t), s = new Blob(["\uFEFF", i], { type: "text/plain" }), o = typeof t.fileName == "function" ? t.fileName(this.gos.getGridCommonParams()) : t.fileName;
    zm.download(this.getFileName(o), s);
  }
  exportDataAsCsv(e) {
    this.export(e);
  }
  getDataAsCsv(e, t = !1) {
    const i = t ? Object.assign({}, e) : this.getMergedParams(e);
    return this.getData(i);
  }
  getDefaultFileExtension() {
    return "csv";
  }
  createSerializingSession(e) {
    const { columnModel: t, valueService: i, gos: s } = this, {
      processCellCallback: o,
      processHeaderCallback: r,
      processGroupHeaderCallback: n,
      processRowGroupCallback: l,
      suppressQuotes: a,
      columnSeparator: d
    } = e;
    return new Km({
      columnModel: t,
      valueService: i,
      gos: s,
      processCellCallback: o || void 0,
      processHeaderCallback: r || void 0,
      processGroupHeaderCallback: n || void 0,
      processRowGroupCallback: l || void 0,
      suppressQuotes: a || !1,
      columnSeparator: d || ","
    });
  }
  isExportSuppressed() {
    return this.gos.get("suppressCsvExport");
  }
};
Dt([
  f("columnModel")
], Oi.prototype, "columnModel", 2);
Dt([
  f("valueService")
], Oi.prototype, "valueService", 2);
Dt([
  f("gridSerializer")
], Oi.prototype, "gridSerializer", 2);
Dt([
  f("gridOptionsService")
], Oi.prototype, "gos", 2);
Dt([
  L
], Oi.prototype, "postConstruct", 1);
Oi = Dt([
  O("csvCreator")
], Oi);
var di = class extends F {
  serialize(e, t = {}) {
    const { allColumns: i, columnKeys: s, skipRowGroups: o } = t, r = this.getColumnsToExport(i, o, s);
    return W.compose(
      // first pass, put in the header names of the cols
      this.prepareSession(r),
      this.prependContent(t),
      this.exportColumnGroups(t, r),
      this.exportHeaders(t, r),
      this.processPinnedTopRows(t, r),
      this.processRows(t, r),
      this.processPinnedBottomRows(t, r),
      this.appendContent(t)
    )(e).parse();
  }
  processRow(e, t, i, s) {
    const o = t.shouldRowBeSkipped || (() => !1), r = this.gos.get("groupRemoveSingleChildren"), n = this.gos.get("groupRemoveLowestSingleChildren"), a = t.rowPositions != null || !!t.onlySelected, d = this.gos.get("groupHideOpenParents") && !a, c = this.columnModel.isPivotMode() ? s.leafGroup : !s.group, h = !!s.footer;
    t.skipRowGroups;
    const g = n && s.leafGroup, m = s.allChildrenCount === 1 && (r || g);
    if (!c && !h && (t.skipRowGroups || m || d) || t.onlySelected && !s.isSelected() || t.skipPinnedTop && s.rowPinned === "top" || t.skipPinnedBottom && s.rowPinned === "bottom" || s.level === -1 && !c && !h || o(this.gos.addGridCommonParams({ node: s })))
      return;
    const v = e.onNewBodyRow(s);
    if (i.forEach((y, E) => {
      v.onColumn(y, E, s);
    }), t.getCustomContentBelowRow) {
      const y = t.getCustomContentBelowRow(this.gos.addGridCommonParams({ node: s }));
      y && e.addCustomContent(y);
    }
  }
  appendContent(e) {
    return (t) => {
      const i = e.appendContent;
      return i && t.addCustomContent(i), t;
    };
  }
  prependContent(e) {
    return (t) => {
      const i = e.prependContent;
      return i && t.addCustomContent(i), t;
    };
  }
  prepareSession(e) {
    return (t) => (t.prepare(e), t);
  }
  exportColumnGroups(e, t) {
    return (i) => {
      if (!e.skipColumnGroupHeaders) {
        const s = new Nu(), o = this.displayedGroupCreator.createDisplayedGroups(
          t,
          s,
          null
        );
        this.recursivelyAddHeaderGroups(o, i, e.processGroupHeaderCallback);
      }
      return i;
    };
  }
  exportHeaders(e, t) {
    return (i) => {
      if (!e.skipColumnHeaders) {
        const s = i.onNewHeaderRow();
        t.forEach((o, r) => {
          s.onColumn(o, r, void 0);
        });
      }
      return i;
    };
  }
  processPinnedTopRows(e, t) {
    return (i) => {
      const s = this.processRow.bind(this, i, e, t);
      return e.rowPositions ? e.rowPositions.filter((o) => o.rowPinned === "top").sort((o, r) => o.rowIndex - r.rowIndex).map((o) => this.pinnedRowModel.getPinnedTopRow(o.rowIndex)).forEach(s) : this.pinnedRowModel.forEachPinnedTopRow(s), i;
    };
  }
  processRows(e, t) {
    return (i) => {
      const s = this.rowModel, o = s.getType(), r = o === "clientSide", n = o === "serverSide", l = !r && e.onlySelected, a = this.processRow.bind(this, i, e, t), {
        exportedRows: d = "filteredAndSorted"
      } = e;
      if (e.rowPositions)
        e.rowPositions.filter((c) => c.rowPinned == null).sort((c, h) => c.rowIndex - h.rowIndex).map((c) => s.getRow(c.rowIndex)).forEach(a);
      else if (this.columnModel.isPivotMode())
        r ? s.forEachPivotNode(a, !0) : n ? s.forEachNodeAfterFilterAndSort(a, !0) : s.forEachNode(a);
      else if (e.onlySelectedAllPages || l) {
        const c = this.selectionService.getSelectedNodes();
        this.replicateSortedOrder(c), c.forEach(a);
      } else
        d === "all" ? s.forEachNode(a) : r || n ? s.forEachNodeAfterFilterAndSort(a, !0) : s.forEachNode(a);
      return i;
    };
  }
  replicateSortedOrder(e) {
    const t = this.sortController.getSortOptions(), i = (s, o) => {
      var r, n, l, a;
      return s.rowIndex != null && o.rowIndex != null ? s.rowIndex - o.rowIndex : s.level === o.level ? ((r = s.parent) == null ? void 0 : r.id) === ((n = o.parent) == null ? void 0 : n.id) ? this.rowNodeSorter.compareRowNodes(t, {
        rowNode: s,
        currentPos: (l = s.rowIndex) != null ? l : -1
      }, {
        rowNode: o,
        currentPos: (a = o.rowIndex) != null ? a : -1
      }) : i(s.parent, o.parent) : s.level > o.level ? i(s.parent, o) : i(s, o.parent);
    };
    e.sort(i);
  }
  processPinnedBottomRows(e, t) {
    return (i) => {
      const s = this.processRow.bind(this, i, e, t);
      return e.rowPositions ? e.rowPositions.filter((o) => o.rowPinned === "bottom").sort((o, r) => o.rowIndex - r.rowIndex).map((o) => this.pinnedRowModel.getPinnedBottomRow(o.rowIndex)).forEach(s) : this.pinnedRowModel.forEachPinnedBottomRow(s), i;
    };
  }
  getColumnsToExport(e = !1, t = !1, i) {
    const s = this.columnModel.isPivotMode();
    if (i && i.length)
      return this.columnModel.getGridColumns(i);
    const o = this.gos.get("treeData");
    let r = [];
    return e && !s ? r = this.columnModel.getAllGridColumns() : r = this.columnModel.getAllDisplayedColumns(), t && !o && (r = r.filter((n) => n.getColId() !== js)), r;
  }
  recursivelyAddHeaderGroups(e, t, i) {
    const s = [];
    e.forEach((o) => {
      const r = o;
      r.getChildren && r.getChildren().forEach((n) => s.push(n));
    }), e.length > 0 && e[0] instanceof Ke && this.doAddHeaderHeader(t, e, i), s && s.length > 0 && this.recursivelyAddHeaderGroups(s, t, i);
  }
  doAddHeaderHeader(e, t, i) {
    const s = e.onNewHeaderGroupingRow();
    let o = 0;
    t.forEach((r) => {
      const n = r;
      let l;
      i ? l = i(this.gos.addGridCommonParams({
        columnGroup: n
      })) : l = this.columnModel.getDisplayNameForColumnGroup(n, "header");
      const a = n.getLeafColumns().reduce((d, c, h, g) => {
        let m = W.last(d);
        return c.getColumnGroupShow() === "open" ? (!m || m[1] != null) && (m = [h], d.push(m)) : m && m[1] == null && (m[1] = h - 1), h === g.length - 1 && m && m[1] == null && (m[1] = h), d;
      }, []);
      s.onColumn(n, l || "", o++, n.getLeafColumns().length - 1, a);
    });
  }
};
Dt([
  f("displayedGroupCreator")
], di.prototype, "displayedGroupCreator", 2);
Dt([
  f("columnModel")
], di.prototype, "columnModel", 2);
Dt([
  f("rowModel")
], di.prototype, "rowModel", 2);
Dt([
  f("pinnedRowModel")
], di.prototype, "pinnedRowModel", 2);
Dt([
  f("selectionService")
], di.prototype, "selectionService", 2);
Dt([
  f("rowNodeSorter")
], di.prototype, "rowNodeSorter", 2);
Dt([
  f("sortController")
], di.prototype, "sortController", 2);
di = Dt([
  O("gridSerializer")
], di);
var $m = "31.3.4", jm = {
  version: $m,
  moduleName: "@ag-grid-community/csv-export",
  beans: [Oi, di]
};
le.__registerModules([xm, Hm, jm], !1, void 0);
var Kh = { exports: {} }, Ro = {};
/** @license React v17.0.2
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zt = pp, pi = gp;
function Ie(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, i = 1; i < arguments.length; i++) t += "&args[]=" + encodeURIComponent(arguments[i]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var td = 60106, gn = 60107, id = 60108, sd = 60114, fn = 60109, od = 60110, rd = 60112, mn = 60113, nd = 60120, ld = 60115, ad = 60116, $h = 60121, jh = 60117, Yh = 60119, qh = 60129, Qh = 60131;
if (typeof Symbol == "function" && Symbol.for) {
  var Je = Symbol.for;
  td = Je("react.portal"), gn = Je("react.fragment"), id = Je("react.strict_mode"), sd = Je("react.profiler"), fn = Je("react.provider"), od = Je("react.context"), rd = Je("react.forward_ref"), mn = Je("react.suspense"), nd = Je("react.suspense_list"), ld = Je("react.memo"), ad = Je("react.lazy"), $h = Je("react.block"), jh = Je("react.fundamental"), Yh = Je("react.scope"), qh = Je("react.debug_trace_mode"), Qh = Je("react.legacy_hidden");
}
function Oo(e) {
  if (e == null) return null;
  if (typeof e == "function") return e.displayName || e.name || null;
  if (typeof e == "string") return e;
  switch (e) {
    case gn:
      return "Fragment";
    case td:
      return "Portal";
    case sd:
      return "Profiler";
    case id:
      return "StrictMode";
    case mn:
      return "Suspense";
    case nd:
      return "SuspenseList";
  }
  if (typeof e == "object") switch (e.$$typeof) {
    case od:
      return (e.displayName || "Context") + ".Consumer";
    case fn:
      return (e._context.displayName || "Context") + ".Provider";
    case rd:
      var t = e.render;
      return t = t.displayName || t.name || "", e.displayName || (t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef");
    case ld:
      return Oo(e.type);
    case $h:
      return Oo(e._render);
    case ad:
      t = e._payload, e = e._init;
      try {
        return Oo(e(t));
      } catch {
      }
  }
  return null;
}
var Ym = pi.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Xh = {};
function ur(e, t) {
  for (var i = e._threadCount | 0; i <= t; i++) e[i] = e._currentValue2, e._threadCount = i + 1;
}
function qm(e, t, i, s) {
  if (s && (s = e.contextType, typeof s == "object" && s !== null)) return ur(s, i), s[i];
  if (e = e.contextTypes) {
    i = {};
    for (var o in e) i[o] = t[o];
    t = i;
  } else t = Xh;
  return t;
}
for (var et = new Uint16Array(16), Or = 0; 15 > Or; Or++) et[Or] = Or + 1;
et[15] = 0;
var Qm = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Wd = Object.prototype.hasOwnProperty, Ud = {}, zd = {};
function Zh(e) {
  return Wd.call(zd, e) ? !0 : Wd.call(Ud, e) ? !1 : Qm.test(e) ? zd[e] = !0 : (Ud[e] = !0, !1);
}
function Xm(e, t, i, s) {
  if (i !== null && i.type === 0) return !1;
  switch (typeof t) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return i !== null ? !i.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
    default:
      return !1;
  }
}
function Zm(e, t, i, s) {
  if (t === null || typeof t > "u" || Xm(e, t, i)) return !0;
  if (i !== null) switch (i.type) {
    case 3:
      return !t;
    case 4:
      return t === !1;
    case 5:
      return isNaN(t);
    case 6:
      return isNaN(t) || 1 > t;
  }
  return !1;
}
function ht(e, t, i, s, o, r, n) {
  this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = s, this.attributeNamespace = o, this.mustUseProperty = i, this.propertyName = e, this.type = t, this.sanitizeURL = r, this.removeEmptyString = n;
}
var Ze = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
  Ze[e] = new ht(e, 0, !1, e, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var t = e[0];
  Ze[t] = new ht(t, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  Ze[e] = new ht(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
  Ze[e] = new ht(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
  Ze[e] = new ht(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function(e) {
  Ze[e] = new ht(e, 3, !0, e, null, !1, !1);
});
["capture", "download"].forEach(function(e) {
  Ze[e] = new ht(e, 4, !1, e, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function(e) {
  Ze[e] = new ht(e, 6, !1, e, null, !1, !1);
});
["rowSpan", "start"].forEach(function(e) {
  Ze[e] = new ht(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var dd = /[\-:]([a-z])/g;
function ud(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
  var t = e.replace(
    dd,
    ud
  );
  Ze[t] = new ht(t, 1, !1, e, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
  var t = e.replace(dd, ud);
  Ze[t] = new ht(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
  var t = e.replace(dd, ud);
  Ze[t] = new ht(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  Ze[e] = new ht(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
Ze.xlinkHref = new ht("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function(e) {
  Ze[e] = new ht(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
var Jm = /["'&<>]/;
function Xi(e) {
  if (typeof e == "boolean" || typeof e == "number") return "" + e;
  e = "" + e;
  var t = Jm.exec(e);
  if (t) {
    var i = "", s, o = 0;
    for (s = t.index; s < e.length; s++) {
      switch (e.charCodeAt(s)) {
        case 34:
          t = "&quot;";
          break;
        case 38:
          t = "&amp;";
          break;
        case 39:
          t = "&#x27;";
          break;
        case 60:
          t = "&lt;";
          break;
        case 62:
          t = "&gt;";
          break;
        default:
          continue;
      }
      o !== s && (i += e.substring(o, s)), o = s + 1, i += t;
    }
    e = o !== s ? i + e.substring(o, s) : i;
  }
  return e;
}
function eC(e, t) {
  var i = Ze.hasOwnProperty(e) ? Ze[e] : null, s;
  return (s = e !== "style") && (s = i !== null ? i.type === 0 : !(!(2 < e.length) || e[0] !== "o" && e[0] !== "O" || e[1] !== "n" && e[1] !== "N")), s || Zm(e, t, i) ? "" : i !== null ? (e = i.attributeName, s = i.type, s === 3 || s === 4 && t === !0 ? e + '=""' : (i.sanitizeURL && (t = "" + t), e + '="' + (Xi(t) + '"'))) : Zh(e) ? e + '="' + (Xi(t) + '"') : "";
}
function tC(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var iC = typeof Object.is == "function" ? Object.is : tC, ui = null, zr = null, ye = null, No = !1, Cn = !1, Pi = null, Zn = 0;
function Zi() {
  if (ui === null) throw Error(Ie(321));
  return ui;
}
function Kd() {
  if (0 < Zn) throw Error(Ie(312));
  return { memoizedState: null, queue: null, next: null };
}
function cd() {
  return ye === null ? zr === null ? (No = !1, zr = ye = Kd()) : (No = !0, ye = zr) : ye.next === null ? (No = !1, ye = ye.next = Kd()) : (No = !0, ye = ye.next), ye;
}
function Jh(e, t, i, s) {
  for (; Cn; ) Cn = !1, Zn += 1, ye = null, i = e(t, s);
  return ep(), i;
}
function ep() {
  ui = null, Cn = !1, zr = null, Zn = 0, ye = Pi = null;
}
function tp(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function $d(e, t, i) {
  if (ui = Zi(), ye = cd(), No) {
    var s = ye.queue;
    if (t = s.dispatch, Pi !== null && (i = Pi.get(s), i !== void 0)) {
      Pi.delete(s), s = ye.memoizedState;
      do
        s = e(s, i.action), i = i.next;
      while (i !== null);
      return ye.memoizedState = s, [s, t];
    }
    return [ye.memoizedState, t];
  }
  return e = e === tp ? typeof t == "function" ? t() : t : i !== void 0 ? i(t) : t, ye.memoizedState = e, e = ye.queue = { last: null, dispatch: null }, e = e.dispatch = sC.bind(null, ui, e), [ye.memoizedState, e];
}
function jd(e, t) {
  if (ui = Zi(), ye = cd(), t = t === void 0 ? null : t, ye !== null) {
    var i = ye.memoizedState;
    if (i !== null && t !== null) {
      var s = i[1];
      e: if (s === null) s = !1;
      else {
        for (var o = 0; o < s.length && o < t.length; o++) if (!iC(t[o], s[o])) {
          s = !1;
          break e;
        }
        s = !0;
      }
      if (s) return i[0];
    }
  }
  return e = e(), ye.memoizedState = [e, t], e;
}
function sC(e, t, i) {
  if (!(25 > Zn)) throw Error(Ie(301));
  if (e === ui) if (Cn = !0, e = { action: i, next: null }, Pi === null && (Pi = /* @__PURE__ */ new Map()), i = Pi.get(t), i === void 0) Pi.set(t, e);
  else {
    for (t = i; t.next !== null; ) t = t.next;
    t.next = e;
  }
}
function vl() {
}
var is = null, oC = { readContext: function(e) {
  var t = is.threadID;
  return ur(e, t), e[t];
}, useContext: function(e) {
  Zi();
  var t = is.threadID;
  return ur(e, t), e[t];
}, useMemo: jd, useReducer: $d, useRef: function(e) {
  ui = Zi(), ye = cd();
  var t = ye.memoizedState;
  return t === null ? (e = { current: e }, ye.memoizedState = e) : t;
}, useState: function(e) {
  return $d(tp, e);
}, useLayoutEffect: function() {
}, useCallback: function(e, t) {
  return jd(function() {
    return e;
  }, t);
}, useImperativeHandle: vl, useEffect: vl, useDebugValue: vl, useDeferredValue: function(e) {
  return Zi(), e;
}, useTransition: function() {
  return Zi(), [function(e) {
    e();
  }, !1];
}, useOpaqueIdentifier: function() {
  return (is.identifierPrefix || "") + "R:" + (is.uniqueID++).toString(36);
}, useMutableSource: function(e, t) {
  return Zi(), t(e._source);
} }, rC = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function nC(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
var ip = { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 }, lC = zt({ menuitem: !0 }, ip), _o = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, aC = ["Webkit", "ms", "Moz", "O"];
Object.keys(_o).forEach(function(e) {
  aC.forEach(function(t) {
    t = t + e.charAt(0).toUpperCase() + e.substring(1), _o[t] = _o[e];
  });
});
var dC = /([A-Z])/g, uC = /^ms-/, bi = pi.Children.toArray, wl = Ym.ReactCurrentDispatcher, cC = { listing: !0, pre: !0, textarea: !0 }, hC = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Yd = {}, Sl = {};
function pC(e) {
  if (e == null) return e;
  var t = "";
  return pi.Children.forEach(e, function(i) {
    i != null && (t += i);
  }), t;
}
var gC = Object.prototype.hasOwnProperty, fC = { children: null, dangerouslySetInnerHTML: null, suppressContentEditableWarning: null, suppressHydrationWarning: null };
function qd(e, t) {
  if (e === void 0) throw Error(Ie(152, Oo(t) || "Component"));
}
function mC(e, t, i) {
  function s(n, l) {
    var a = l.prototype && l.prototype.isReactComponent, d = qm(l, t, i, a), c = [], h = !1, g = { isMounted: function() {
      return !1;
    }, enqueueForceUpdate: function() {
      if (c === null) return null;
    }, enqueueReplaceState: function(D, R) {
      h = !0, c = [R];
    }, enqueueSetState: function(D, R) {
      if (c === null) return null;
      c.push(R);
    } };
    if (a) {
      if (a = new l(n.props, d, g), typeof l.getDerivedStateFromProps == "function") {
        var m = l.getDerivedStateFromProps.call(null, n.props, a.state);
        m != null && (a.state = zt({}, a.state, m));
      }
    } else if (ui = {}, a = l(
      n.props,
      d,
      g
    ), a = Jh(l, n.props, a, d), a == null || a.render == null) {
      e = a, qd(e, l);
      return;
    }
    if (a.props = n.props, a.context = d, a.updater = g, g = a.state, g === void 0 && (a.state = g = null), typeof a.UNSAFE_componentWillMount == "function" || typeof a.componentWillMount == "function") if (typeof a.componentWillMount == "function" && typeof l.getDerivedStateFromProps != "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && typeof l.getDerivedStateFromProps != "function" && a.UNSAFE_componentWillMount(), c.length) {
      g = c;
      var C = h;
      if (c = null, h = !1, C && g.length === 1) a.state = g[0];
      else {
        m = C ? g[0] : a.state;
        var w = !0;
        for (C = C ? 1 : 0; C < g.length; C++) {
          var v = g[C];
          v = typeof v == "function" ? v.call(a, m, n.props, d) : v, v != null && (w ? (w = !1, m = zt({}, m, v)) : zt(m, v));
        }
        a.state = m;
      }
    } else c = null;
    if (e = a.render(), qd(e, l), typeof a.getChildContext == "function" && (n = l.childContextTypes, typeof n == "object")) {
      var y = a.getChildContext();
      for (var E in y) if (!(E in n)) throw Error(Ie(108, Oo(l) || "Unknown", E));
    }
    y && (t = zt({}, t, y));
  }
  for (; pi.isValidElement(e); ) {
    var o = e, r = o.type;
    if (typeof r != "function") break;
    s(o, r);
  }
  return { child: e, context: t };
}
var sp = function() {
  function e(i, s, o) {
    pi.isValidElement(i) ? i.type !== gn ? i = [i] : (i = i.props.children, i = pi.isValidElement(i) ? [i] : bi(i)) : i = bi(i), i = { type: null, domNamespace: rC.html, children: i, childIndex: 0, context: Xh, footer: "" };
    var r = et[0];
    if (r === 0) {
      var n = et;
      r = n.length;
      var l = 2 * r;
      if (!(65536 >= l)) throw Error(Ie(304));
      var a = new Uint16Array(l);
      for (a.set(n), et = a, et[0] = r + 1, n = r; n < l - 1; n++) et[n] = n + 1;
      et[l - 1] = 0;
    } else et[0] = et[r];
    this.threadID = r, this.stack = [i], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = s, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [], this.uniqueID = 0, this.identifierPrefix = o && o.identifierPrefix || "";
  }
  var t = e.prototype;
  return t.destroy = function() {
    if (!this.exhausted) {
      this.exhausted = !0, this.clearProviders();
      var i = this.threadID;
      et[i] = et[0], et[0] = i;
    }
  }, t.pushProvider = function(i) {
    var s = ++this.contextIndex, o = i.type._context, r = this.threadID;
    ur(o, r);
    var n = o[r];
    this.contextStack[s] = o, this.contextValueStack[s] = n, o[r] = i.props.value;
  }, t.popProvider = function() {
    var i = this.contextIndex, s = this.contextStack[i], o = this.contextValueStack[i];
    this.contextStack[i] = null, this.contextValueStack[i] = null, this.contextIndex--, s[this.threadID] = o;
  }, t.clearProviders = function() {
    for (var i = this.contextIndex; 0 <= i; i--) this.contextStack[i][this.threadID] = this.contextValueStack[i];
  }, t.read = function(i) {
    if (this.exhausted) return null;
    var s = is;
    is = this;
    var o = wl.current;
    wl.current = oC;
    try {
      for (var r = [""], n = !1; r[0].length < i; ) {
        if (this.stack.length === 0) {
          this.exhausted = !0;
          var l = this.threadID;
          et[l] = et[0], et[0] = l;
          break;
        }
        var a = this.stack[this.stack.length - 1];
        if (n || a.childIndex >= a.children.length) {
          var d = a.footer;
          if (d !== "" && (this.previousWasTextNode = !1), this.stack.pop(), a.type === "select") this.currentSelectValue = null;
          else if (a.type != null && a.type.type != null && a.type.type.$$typeof === fn) this.popProvider(a.type);
          else if (a.type === mn) {
            this.suspenseDepth--;
            var c = r.pop();
            if (n) {
              n = !1;
              var h = a.fallbackFrame;
              if (!h) throw Error(Ie(303));
              this.stack.push(h), r[this.suspenseDepth] += "<!--$!-->";
              continue;
            } else r[this.suspenseDepth] += c;
          }
          r[this.suspenseDepth] += d;
        } else {
          var g = a.children[a.childIndex++], m = "";
          try {
            m += this.render(g, a.context, a.domNamespace);
          } catch (C) {
            throw C != null && typeof C.then == "function" ? Error(Ie(294)) : C;
          } finally {
          }
          r.length <= this.suspenseDepth && r.push(""), r[this.suspenseDepth] += m;
        }
      }
      return r[0];
    } finally {
      wl.current = o, is = s, ep();
    }
  }, t.render = function(i, s, o) {
    if (typeof i == "string" || typeof i == "number")
      return o = "" + i, o === "" ? "" : this.makeStaticMarkup ? Xi(o) : this.previousWasTextNode ? "<!-- -->" + Xi(o) : (this.previousWasTextNode = !0, Xi(o));
    if (s = mC(i, s, this.threadID), i = s.child, s = s.context, i === null || i === !1) return "";
    if (!pi.isValidElement(i)) {
      if (i != null && i.$$typeof != null)
        throw o = i.$$typeof, Error(o === td ? Ie(257) : Ie(258, o.toString()));
      return i = bi(i), this.stack.push({ type: null, domNamespace: o, children: i, childIndex: 0, context: s, footer: "" }), "";
    }
    var r = i.type;
    if (typeof r == "string") return this.renderDOM(i, s, o);
    switch (r) {
      case Qh:
      case qh:
      case id:
      case sd:
      case nd:
      case gn:
        return i = bi(i.props.children), this.stack.push({
          type: null,
          domNamespace: o,
          children: i,
          childIndex: 0,
          context: s,
          footer: ""
        }), "";
      case mn:
        throw Error(Ie(294));
      case Yh:
        throw Error(Ie(343));
    }
    if (typeof r == "object" && r !== null) switch (r.$$typeof) {
      case rd:
        ui = {};
        var n = r.render(i.props, i.ref);
        return n = Jh(r.render, i.props, n, i.ref), n = bi(n), this.stack.push({ type: null, domNamespace: o, children: n, childIndex: 0, context: s, footer: "" }), "";
      case ld:
        return i = [pi.createElement(r.type, zt({ ref: i.ref }, i.props))], this.stack.push({ type: null, domNamespace: o, children: i, childIndex: 0, context: s, footer: "" }), "";
      case fn:
        return r = bi(i.props.children), o = { type: i, domNamespace: o, children: r, childIndex: 0, context: s, footer: "" }, this.pushProvider(i), this.stack.push(o), "";
      case od:
        r = i.type, n = i.props;
        var l = this.threadID;
        return ur(r, l), r = bi(n.children(r[l])), this.stack.push({ type: i, domNamespace: o, children: r, childIndex: 0, context: s, footer: "" }), "";
      case jh:
        throw Error(Ie(338));
      case ad:
        return r = i.type, n = r._init, r = n(r._payload), i = [pi.createElement(r, zt({ ref: i.ref }, i.props))], this.stack.push({
          type: null,
          domNamespace: o,
          children: i,
          childIndex: 0,
          context: s,
          footer: ""
        }), "";
    }
    throw Error(Ie(130, r == null ? r : typeof r, ""));
  }, t.renderDOM = function(i, s, o) {
    var r = i.type.toLowerCase();
    if (!Yd.hasOwnProperty(r)) {
      if (!hC.test(r)) throw Error(Ie(65, r));
      Yd[r] = !0;
    }
    var n = i.props;
    if (r === "input") n = zt({ type: void 0 }, n, { defaultChecked: void 0, defaultValue: void 0, value: n.value != null ? n.value : n.defaultValue, checked: n.checked != null ? n.checked : n.defaultChecked });
    else if (r === "textarea") {
      var l = n.value;
      if (l == null) {
        l = n.defaultValue;
        var a = n.children;
        if (a != null) {
          if (l != null) throw Error(Ie(92));
          if (Array.isArray(a)) {
            if (!(1 >= a.length)) throw Error(Ie(93));
            a = a[0];
          }
          l = "" + a;
        }
        l == null && (l = "");
      }
      n = zt({}, n, { value: void 0, children: "" + l });
    } else if (r === "select") this.currentSelectValue = n.value != null ? n.value : n.defaultValue, n = zt({}, n, { value: void 0 });
    else if (r === "option") {
      a = this.currentSelectValue;
      var d = pC(n.children);
      if (a != null) {
        var c = n.value != null ? n.value + "" : d;
        if (l = !1, Array.isArray(a)) {
          for (var h = 0; h < a.length; h++)
            if ("" + a[h] === c) {
              l = !0;
              break;
            }
        } else l = "" + a === c;
        n = zt(
          { selected: void 0, children: void 0 },
          n,
          { selected: l, children: d }
        );
      }
    }
    if (l = n) {
      if (lC[r] && (l.children != null || l.dangerouslySetInnerHTML != null)) throw Error(Ie(137, r));
      if (l.dangerouslySetInnerHTML != null) {
        if (l.children != null) throw Error(Ie(60));
        if (!(typeof l.dangerouslySetInnerHTML == "object" && "__html" in l.dangerouslySetInnerHTML)) throw Error(Ie(61));
      }
      if (l.style != null && typeof l.style != "object") throw Error(Ie(62));
    }
    l = n, a = this.makeStaticMarkup, d = this.stack.length === 1, c = "<" + i.type;
    e: if (r.indexOf("-") === -1) h = typeof l.is == "string";
    else switch (r) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        h = !1;
        break e;
      default:
        h = !0;
    }
    for (R in l) if (gC.call(l, R)) {
      var g = l[R];
      if (g != null) {
        if (R === "style") {
          var m = void 0, C = "", w = "";
          for (m in g) if (g.hasOwnProperty(m)) {
            var v = m.indexOf("--") === 0, y = g[m];
            if (y != null) {
              if (v) var E = m;
              else if (E = m, Sl.hasOwnProperty(E)) E = Sl[E];
              else {
                var D = E.replace(dC, "-$1").toLowerCase().replace(uC, "-ms-");
                E = Sl[E] = D;
              }
              C += w + E + ":", w = m, v = y == null || typeof y == "boolean" || y === "" ? "" : v || typeof y != "number" || y === 0 || _o.hasOwnProperty(w) && _o[w] ? ("" + y).trim() : y + "px", C += v, w = ";";
            }
          }
          g = C || null;
        }
        m = null, h ? fC.hasOwnProperty(R) || (m = R, m = Zh(m) && g != null ? m + '="' + (Xi(g) + '"') : "") : m = eC(R, g), m && (c += " " + m);
      }
    }
    a || d && (c += ' data-reactroot=""');
    var R = c;
    l = "", ip.hasOwnProperty(r) ? R += "/>" : (R += ">", l = "</" + i.type + ">");
    e: {
      if (a = n.dangerouslySetInnerHTML, a != null) {
        if (a.__html != null) {
          a = a.__html;
          break e;
        }
      } else if (a = n.children, typeof a == "string" || typeof a == "number") {
        a = Xi(a);
        break e;
      }
      a = null;
    }
    return a != null ? (n = [], cC.hasOwnProperty(r) && a.charAt(0) === `
` && (R += `
`), R += a) : n = bi(n.children), i = i.type, o = o == null || o === "http://www.w3.org/1999/xhtml" ? nC(i) : o === "http://www.w3.org/2000/svg" && i === "foreignObject" ? "http://www.w3.org/1999/xhtml" : o, this.stack.push({ domNamespace: o, type: r, children: n, childIndex: 0, context: s, footer: l }), this.previousWasTextNode = !1, R;
  }, e;
}();
Ro.renderToNodeStream = function() {
  throw Error(Ie(207));
};
Ro.renderToStaticMarkup = function(e, t) {
  e = new sp(e, !0, t);
  try {
    return e.read(1 / 0);
  } finally {
    e.destroy();
  }
};
Ro.renderToStaticNodeStream = function() {
  throw Error(Ie(208));
};
Ro.renderToString = function(e, t) {
  e = new sp(e, !1, t);
  try {
    return e.read(1 / 0);
  } finally {
    e.destroy();
  }
};
Ro.version = "17.0.2";
Kh.exports = Ro;
var CC = Kh.exports, vC = Object.defineProperty, wC = Object.defineProperties, SC = Object.getOwnPropertyDescriptors, Qd = Object.getOwnPropertySymbols, EC = Object.prototype.hasOwnProperty, yC = Object.prototype.propertyIsEnumerable, Xd = (e, t, i) => t in e ? vC(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, be = (e, t) => {
  for (var i in t || (t = {}))
    EC.call(t, i) && Xd(e, i, t[i]);
  if (Qd)
    for (var i of Qd(t))
      yC.call(t, i) && Xd(e, i, t[i]);
  return e;
}, at = (e, t) => wC(e, SC(t)), hd = fp({
  setMethods: () => {
  }
}), RC = (e) => {
  const { initialProps: t, addUpdateCallback: i, CustomComponentClass: s, setMethods: o } = e, [r, n] = G(t);
  return Be(() => {
    i((l) => n(l));
  }, []), /* @__PURE__ */ P.createElement(hd.Provider, { value: { setMethods: o } }, /* @__PURE__ */ P.createElement(s, be({}, r)));
}, DC = St(RC), TC = 0;
function Zd() {
  return `agPortalKey_${++TC}`;
}
var op = class {
  constructor(e, t, i, s) {
    this.portal = null, this.oldPortal = null, this.reactComponent = e, this.portalManager = t, this.componentType = i, this.suppressFallbackMethods = !!s, this.statelessComponent = this.isStateless(this.reactComponent), this.key = Zd(), this.portalKey = Zd(), this.instanceCreated = this.isStatelessComponent() ? _e.resolve(!1) : new _e((o) => {
      this.resolveInstanceCreated = o;
    });
  }
  getGui() {
    return this.eParentElement;
  }
  /** `getGui()` returns the parent element. This returns the actual root element. */
  getRootElement() {
    return this.eParentElement.firstChild;
  }
  destroy() {
    return this.componentInstance && typeof this.componentInstance.destroy == "function" && this.componentInstance.destroy(), this.portalManager.destroyPortal(this.portal);
  }
  createParentElement(e) {
    const t = this.portalManager.getComponentWrappingElement(), i = document.createElement(t || "div");
    return i.classList.add("ag-react-container"), e.reactContainer = i, i;
  }
  addParentContainerStyleAndClasses() {
    this.componentInstance && (this.componentInstance.getReactContainerStyle && this.componentInstance.getReactContainerStyle() && (W.warnOnce('Since v31.1 "getReactContainerStyle" is deprecated. Apply styling directly to ".ag-react-container" if needed.'), Object.assign(this.eParentElement.style, this.componentInstance.getReactContainerStyle())), this.componentInstance.getReactContainerClasses && this.componentInstance.getReactContainerClasses() && (W.warnOnce('Since v31.1 "getReactContainerClasses" is deprecated. Apply styling directly to ".ag-react-container" if needed.'), this.componentInstance.getReactContainerClasses().forEach((t) => this.eParentElement.classList.add(t))));
  }
  statelessComponentRendered() {
    return this.eParentElement.childElementCount > 0 || this.eParentElement.childNodes.length > 0;
  }
  getFrameworkComponentInstance() {
    return this.componentInstance;
  }
  isStatelessComponent() {
    return this.statelessComponent;
  }
  getReactComponentName() {
    return this.reactComponent.name;
  }
  getMemoType() {
    return this.hasSymbol() ? Symbol.for("react.memo") : 60115;
  }
  hasSymbol() {
    return typeof Symbol == "function" && Symbol.for;
  }
  isStateless(e) {
    return typeof e == "function" && !(e.prototype && e.prototype.isReactComponent) || typeof e == "object" && e.$$typeof === this.getMemoType();
  }
  hasMethod(e) {
    const t = this.getFrameworkComponentInstance();
    return !!t && t[e] != null || this.fallbackMethodAvailable(e);
  }
  callMethod(e, t) {
    const i = this.getFrameworkComponentInstance();
    if (this.isStatelessComponent())
      return this.fallbackMethod(e, t && t[0] ? t[0] : {});
    if (!i) {
      setTimeout(() => this.callMethod(e, t));
      return;
    }
    const s = i[e];
    if (s)
      return s.apply(i, t);
    if (this.fallbackMethodAvailable(e))
      return this.fallbackMethod(e, t && t[0] ? t[0] : {});
  }
  addMethod(e, t) {
    this[e] = t;
  }
  init(e) {
    return this.eParentElement = this.createParentElement(e), this.params = e, this.createOrUpdatePortal(e), new _e((t) => this.createReactComponent(t));
  }
  createOrUpdatePortal(e) {
    this.isStatelessComponent() || (this.ref = (t) => {
      var i;
      this.componentInstance = t, this.addParentContainerStyleAndClasses(), (i = this.resolveInstanceCreated) == null || i.call(this, !0), this.resolveInstanceCreated = void 0;
    }, e.ref = this.ref), this.reactElement = this.createElement(this.reactComponent, at(be({}, e), { key: this.key })), this.portal = ru(
      this.reactElement,
      this.eParentElement,
      this.portalKey
      // fixed deltaRowModeRefreshCompRenderer
    );
  }
  createElement(e, t) {
    return wd(e, t);
  }
  createReactComponent(e) {
    this.portalManager.mountReactPortal(this.portal, this, (t) => {
      e(t);
    });
  }
  isNullValue() {
    return this.valueRenderedIsNull(this.params);
  }
  rendered() {
    return this.isStatelessComponent() && this.statelessComponentRendered() || !!(!this.isStatelessComponent() && this.getFrameworkComponentInstance());
  }
  valueRenderedIsNull(e) {
    if (!this.componentType.cellRenderer)
      return !1;
    const t = console.error;
    try {
      return console.error = () => {
      }, CC.renderToStaticMarkup(wd(this.reactComponent, e)) === "";
    } catch {
    } finally {
      console.error = t;
    }
    return !1;
  }
  /*
  * fallback methods - these will be invoked if a corresponding instance method is not present
  * for example if refresh is called and is not available on the component instance, then refreshComponent on this
  * class will be invoked instead
  *
  * Currently only refresh is supported
  */
  refreshComponent(e) {
    this.oldPortal = this.portal, this.createOrUpdatePortal(e), this.portalManager.updateReactPortal(this.oldPortal, this.portal);
  }
  fallbackMethod(e, t) {
    const i = this[`${e}Component`];
    if (!this.suppressFallbackMethods && i)
      return i.bind(this)(t);
  }
  fallbackMethodAvailable(e) {
    return this.suppressFallbackMethods ? !1 : !!this[`${e}Component`];
  }
};
function pd(e, t, i) {
  e.forEach((s) => {
    const o = t[s];
    o && (i[s] = o);
  });
}
var $i = class extends op {
  constructor() {
    super(...arguments), this.awaitUpdateCallback = new _e((e) => {
      this.resolveUpdateCallback = e;
    }), this.wrapperComponent = DC;
  }
  init(e) {
    return this.sourceParams = e, super.init(this.getProps());
  }
  addMethod() {
  }
  getInstance() {
    return this.instanceCreated.then(() => this.componentInstance);
  }
  getFrameworkComponentInstance() {
    return this;
  }
  createElement(e, t) {
    return super.createElement(this.wrapperComponent, {
      initialProps: t,
      CustomComponentClass: e,
      setMethods: (i) => this.setMethods(i),
      addUpdateCallback: (i) => {
        this.updateCallback = () => (i(this.getProps()), new _e((s) => {
          setTimeout(() => {
            s();
          });
        })), this.resolveUpdateCallback();
      }
    });
  }
  setMethods(e) {
    this.providedMethods = e, pd(this.getOptionalMethods(), this.providedMethods, this);
  }
  getOptionalMethods() {
    return [];
  }
  getProps() {
    return at(be({}, this.sourceParams), {
      key: this.key,
      ref: this.ref
    });
  }
  refreshProps() {
    return this.updateCallback ? this.updateCallback() : new _e((e) => this.awaitUpdateCallback.then(() => {
      this.updateCallback().then(() => e());
    }));
  }
}, bC = class extends $i {
  constructor() {
    super(...arguments), this.date = null, this.onDateChange = (e) => this.updateDate(e);
  }
  getDate() {
    return this.date;
  }
  setDate(e) {
    this.date = e, this.refreshProps();
  }
  refresh(e) {
    this.sourceParams = e, this.refreshProps();
  }
  getOptionalMethods() {
    return ["afterGuiAttached", "setInputPlaceholder", "setInputAriaLabel", "setDisabled"];
  }
  updateDate(e) {
    this.setDate(e), this.sourceParams.onDateChanged();
  }
  getProps() {
    const e = super.getProps();
    return e.date = this.date, e.onDateChange = this.onDateChange, delete e.onDateChanged, e;
  }
}, AC = class extends $i {
  constructor() {
    super(...arguments), this.model = null, this.onModelChange = (e) => this.updateModel(e), this.onUiChange = () => this.sourceParams.filterChangedCallback();
  }
  isFilterActive() {
    return this.model != null;
  }
  doesFilterPass(e) {
    return this.providedMethods.doesFilterPass(e);
  }
  getModel() {
    return this.model;
  }
  setModel(e) {
    return this.model = e, this.refreshProps();
  }
  refresh(e) {
    return this.sourceParams = e, this.refreshProps(), !0;
  }
  getOptionalMethods() {
    return ["afterGuiAttached", "afterGuiDetached", "onNewRowsLoaded", "getModelAsString", "onAnyFilterChanged"];
  }
  updateModel(e) {
    this.setModel(e).then(() => this.sourceParams.filterChangedCallback());
  }
  getProps() {
    const e = super.getProps();
    return e.model = this.model, e.onModelChange = this.onModelChange, e.onUiChange = this.onUiChange, delete e.filterChangedCallback, delete e.filterModifiedCallback, delete e.valueGetter, e;
  }
};
function rp(e, t) {
  e.parentFilterInstance((i) => {
    (i.setModel(t) || _e.resolve()).then(() => {
      e.filterParams.filterChangedCallback();
    });
  });
}
var PC = class {
  constructor(e, t) {
    this.floatingFilterParams = e, this.refreshProps = t, this.model = null, this.onModelChange = (i) => this.updateModel(i);
  }
  getProps() {
    return at(be({}, this.floatingFilterParams), {
      model: this.model,
      onModelChange: this.onModelChange
    });
  }
  onParentModelChanged(e) {
    this.model = e, this.refreshProps();
  }
  refresh(e) {
    this.floatingFilterParams = e, this.refreshProps();
  }
  setMethods(e) {
    pd(this.getOptionalMethods(), e, this);
  }
  getOptionalMethods() {
    return ["afterGuiAttached"];
  }
  updateModel(e) {
    this.model = e, this.refreshProps(), rp(this.floatingFilterParams, e);
  }
}, FC = class extends $i {
  constructor() {
    super(...arguments), this.model = null, this.onModelChange = (e) => this.updateModel(e);
  }
  onParentModelChanged(e) {
    this.model = e, this.refreshProps();
  }
  refresh(e) {
    this.sourceParams = e, this.refreshProps();
  }
  getOptionalMethods() {
    return ["afterGuiAttached"];
  }
  updateModel(e) {
    this.model = e, this.refreshProps(), rp(this.sourceParams, e);
  }
  getProps() {
    const e = super.getProps();
    return e.model = this.model, e.onModelChange = this.onModelChange, e;
  }
}, LC = class extends $i {
  refresh(e) {
    this.sourceParams = e, this.refreshProps();
  }
}, IC = class extends $i {
  constructor() {
    super(...arguments), this.active = !1, this.expanded = !1, this.onActiveChange = (e) => this.updateActive(e);
  }
  setActive(e) {
    this.awaitSetActive(e);
  }
  setExpanded(e) {
    this.expanded = e, this.refreshProps();
  }
  getOptionalMethods() {
    return ["select", "configureDefaults"];
  }
  awaitSetActive(e) {
    return this.active = e, this.refreshProps();
  }
  updateActive(e) {
    const t = this.awaitSetActive(e);
    e && t.then(() => this.sourceParams.onItemActivated());
  }
  getProps() {
    const e = super.getProps();
    return e.active = this.active, e.expanded = this.expanded, e.onActiveChange = this.onActiveChange, delete e.onItemActivated, e;
  }
}, MC = class extends $i {
  refresh(e) {
    this.sourceParams = e, this.refreshProps();
  }
}, xC = class extends $i {
  refresh(e) {
    return this.sourceParams = e, this.refreshProps(), !0;
  }
}, NC = class extends $i {
  constructor() {
    super(...arguments), this.onStateChange = (e) => this.updateState(e);
  }
  refresh(e) {
    return this.sourceParams = e, this.refreshProps(), !0;
  }
  getState() {
    return this.state;
  }
  updateState(e) {
    this.state = e, this.refreshProps(), this.sourceParams.onStateUpdated();
  }
  getProps() {
    const e = super.getProps();
    return e.state = this.state, e.onStateChange = this.onStateChange, e;
  }
}, np = class lp {
  constructor(t, i, s) {
    this.destroyed = !1, this.portals = [], this.hasPendingPortalUpdate = !1, this.wrappingElement = i || "div", this.refresher = t, this.maxComponentCreationTimeMs = s || lp.MAX_COMPONENT_CREATION_TIME_IN_MS;
  }
  getPortals() {
    return this.portals;
  }
  destroy() {
    this.destroyed = !0;
  }
  destroyPortal(t) {
    this.portals = this.portals.filter((i) => i !== t), this.batchUpdate();
  }
  getComponentWrappingElement() {
    return this.wrappingElement;
  }
  mountReactPortal(t, i, s) {
    this.portals = [...this.portals, t], this.waitForInstance(i, s), this.batchUpdate();
  }
  updateReactPortal(t, i) {
    this.portals[this.portals.indexOf(t)] = i, this.batchUpdate();
  }
  batchUpdate() {
    this.hasPendingPortalUpdate || (setTimeout(() => {
      this.destroyed || (this.refresher(), this.hasPendingPortalUpdate = !1);
    }), this.hasPendingPortalUpdate = !0);
  }
  waitForInstance(t, i, s = Date.now()) {
    if (this.destroyed) {
      i(null);
      return;
    }
    if (t.rendered())
      i(t);
    else {
      if (Date.now() - s >= this.maxComponentCreationTimeMs && !this.hasPendingPortalUpdate) {
        if (t.isNullValue()) {
          i(t);
          return;
        }
        console.error(`AG Grid: React Component '${t.getReactComponentName()}' not created within ${this.maxComponentCreationTimeMs}ms.`), console.error("    If the component is using `forwardRef` but not `useImperativeHandle`, add the following: `useImperativeHandle(ref, () => ({}));`");
        return;
      }
      window.setTimeout(() => {
        this.waitForInstance(t, i, s);
      });
    }
  }
};
np.MAX_COMPONENT_CREATION_TIME_IN_MS = 1e3;
var GC = np, pt = P.createContext({}), Ut = (...e) => e.filter((i) => i != null && i !== "").join(" "), xt = class ap {
  constructor(...t) {
    this.classesMap = {}, t.forEach((i) => {
      this.classesMap[i] = !0;
    });
  }
  setClass(t, i) {
    if (!!this.classesMap[t] == i)
      return this;
    const o = new ap();
    return o.classesMap = be({}, this.classesMap), o.classesMap[t] = i, o;
  }
  toString() {
    return Object.keys(this.classesMap).filter((i) => this.classesMap[i]).join(" ");
  }
}, Do = (e) => {
  const t = () => typeof Symbol == "function" && Symbol.for, i = () => t() ? Symbol.for("react.memo") : 60115;
  return typeof e == "function" && !(e.prototype && e.prototype.isReactComponent) || typeof e == "object" && e.$$typeof === i();
}, OC = yl.createRoot != null && yl.flushSync != null, Kr = !1;
function _C(e) {
  return Kr || setTimeout(() => Kr = !1, 0), Kr = !0, e();
}
var gd = (e, t) => {
  OC && e && !Kr ? yl.flushSync(t) : t();
};
function fd(e, t, i) {
  if (t == null || e == null)
    return t;
  if (e === t || t.length === 0 && e.length === 0)
    return e;
  if (i || e.length === 0 && t.length > 0 || e.length > 0 && t.length === 0)
    return t;
  const s = [], o = [], r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  for (let l = 0; l < t.length; l++) {
    const a = t[l];
    n.set(a.getInstanceId(), a);
  }
  for (let l = 0; l < e.length; l++) {
    const a = e[l];
    r.set(a.getInstanceId(), a), n.has(a.getInstanceId()) && s.push(a);
  }
  for (let l = 0; l < t.length; l++) {
    const a = t[l], d = a.getInstanceId();
    r.has(d) || o.push(a);
  }
  return s.length === e.length && o.length === 0 ? e : s.length === 0 && o.length === t.length ? t : s.length === 0 ? o : o.length === 0 ? s : [...s, ...o];
}
var Fr = (e, t, i, s) => {
  if (!e || e.componentFromFramework || t.isDestroyed())
    return;
  const r = e.newAgStackInstance();
  if (!r)
    return;
  let n, l, a = !1;
  return r.then((d) => {
    if (a) {
      t.destroyBean(d);
      return;
    }
    n = d, l = n.getGui(), i.appendChild(l), Jd(s, n);
  }), () => {
    a = !0, n && (l && l.parentElement && l.parentElement.removeChild(l), t.destroyBean(n), s && Jd(s, void 0));
  };
}, Jd = (e, t) => {
  if (e)
    if (e instanceof Function)
      e(t);
    else {
      const i = e;
      i.current = t;
    }
}, VC = (e) => {
  const t = e.newAgStackInstance();
  if (t)
    return t.resolveNow(null, (i) => i);
}, dp = _i((e, t) => {
  var i;
  const s = Et(pt).context, o = N(null), r = N(null), n = N(null), l = N(null), a = N(null), d = N(), [c, h] = G(), [g, m] = G(), [C, w] = G(), [v, y] = G(() => new xt()), [E, D] = G(() => new xt("ag-hidden")), [R, T] = G(() => new xt("ag-hidden")), [I, A] = G(() => new xt("ag-invisible"));
  Es(t, () => ({
    // force new instance when grid tries to refresh
    refresh() {
      return !1;
    }
  })), Fi(() => Fr(c, s, r.current), [c]);
  const V = de((ve) => {
    if (o.current = ve, !o.current) {
      s.destroyBean(d.current), d.current = null;
      return;
    }
    const ge = {
      setInnerRenderer: (ee, oe) => {
        h(ee), w(oe);
      },
      setChildCount: (ee) => m(ee),
      addOrRemoveCssClass: (ee, oe) => y((Le) => Le.setClass(ee, oe)),
      setContractedDisplayed: (ee) => T((oe) => oe.setClass("ag-hidden", !ee)),
      setExpandedDisplayed: (ee) => D((oe) => oe.setClass("ag-hidden", !ee)),
      setCheckboxVisible: (ee) => A((oe) => oe.setClass("ag-invisible", !ee))
    };
    d.current = s.createBean(new As()), d.current.init(ge, o.current, n.current, l.current, a.current, dp, e);
  }, []), x = j(() => `ag-cell-wrapper ${v.toString()}`, [v]), k = j(() => `ag-group-expanded ${E.toString()}`, [E]), B = j(() => `ag-group-contracted ${R.toString()}`, [R]), Q = j(() => `ag-group-checkbox ${I.toString()}`, [I]), U = c && c.componentFromFramework, me = U ? c.componentClass : void 0, Ce = c == null && C != null, Ae = W.escapeString(C, !0);
  return /* @__PURE__ */ P.createElement("span", be({ className: x, ref: V }, e.colDef ? {} : { role: (i = d.current) == null ? void 0 : i.getCellAriaRole() }), /* @__PURE__ */ P.createElement("span", { className: k, ref: l }), /* @__PURE__ */ P.createElement("span", { className: B, ref: a }), /* @__PURE__ */ P.createElement("span", { className: Q, ref: n }), /* @__PURE__ */ P.createElement("span", { className: "ag-group-value", ref: r }, Ce && /* @__PURE__ */ P.createElement(P.Fragment, null, Ae), U && /* @__PURE__ */ P.createElement(me, be({}, c.params))), /* @__PURE__ */ P.createElement("span", { className: "ag-group-child-count" }, g));
}), eu = dp, HC = (e) => {
  const { ctrl: t } = e, i = t.isAlive(), { context: s } = Et(pt), o = i ? t.getColId() : void 0, [r, n] = G(), l = N(null), a = N(null), d = N(null), c = N();
  let h = N();
  i && !h.current && (h.current = new fr(() => l.current));
  const g = de((v) => {
    var y;
    if (l.current = v, !l.current || !i)
      return;
    const E = {
      setWidth: (R) => {
        l.current && (l.current.style.width = R);
      },
      addOrRemoveCssClass: (R, T) => h.current.addOrRemoveCssClass(R, T),
      setAriaSort: (R) => {
        l.current && (R ? W.setAriaSort(l.current, R) : W.removeAriaSort(l.current));
      },
      setUserCompDetails: (R) => n(R),
      getUserCompInstance: () => c.current || void 0
    };
    t.setComp(E, l.current, a.current, d.current);
    const D = t.getSelectAllGui();
    (y = a.current) == null || y.insertAdjacentElement("afterend", D);
  }, []);
  Fi(() => Fr(r, s, d.current, c), [r]), Be(() => {
    t.setDragSource(l.current);
  }, [r]);
  const m = j(() => !!((r == null ? void 0 : r.componentFromFramework) && Do(r.componentClass)), [r]), C = r && r.componentFromFramework, w = r && r.componentClass;
  return /* @__PURE__ */ P.createElement(
    "div",
    {
      ref: g,
      className: "ag-header-cell",
      "col-id": o,
      role: "columnheader"
    },
    /* @__PURE__ */ P.createElement("div", { ref: a, className: "ag-header-cell-resize", role: "presentation" }),
    /* @__PURE__ */ P.createElement("div", { ref: d, className: "ag-header-cell-comp-wrapper", role: "presentation" }, C && m && /* @__PURE__ */ P.createElement(w, be({}, r.params)), C && !m && /* @__PURE__ */ P.createElement(w, at(be({}, r.params), { ref: c })))
  );
}, kC = St(HC), BC = (e) => {
  const { context: t } = Et(pt), { ctrl: i } = e, [s, o] = G(() => new xt()), [r, n] = G(() => new xt()), [l, a] = G("false"), [d, c] = G(), [h, g] = G(), m = j(() => i.getColId(), []), C = N(null), w = N(null), v = N(), y = de((A) => {
    if (C.current = A, !C.current)
      return;
    const V = {
      setWidth: (x) => {
        C.current && (C.current.style.width = x);
      },
      addOrRemoveCssClass: (x, k) => o((B) => B.setClass(x, k)),
      setUserCompDetails: (x) => g(x),
      setResizableDisplayed: (x) => {
        n((k) => k.setClass("ag-hidden", !x)), a(x ? "false" : "true");
      },
      setAriaExpanded: (x) => c(x),
      getUserCompInstance: () => v.current || void 0
    };
    i.setComp(V, C.current, w.current);
  }, []);
  Fi(() => Fr(h, t, C.current), [h]), Be(() => {
    C.current && i.setDragSource(C.current);
  }, [h]);
  const E = j(() => !!((h == null ? void 0 : h.componentFromFramework) && Do(h.componentClass)), [h]), D = j(() => "ag-header-group-cell " + s.toString(), [s]), R = j(() => "ag-header-cell-resize " + r.toString(), [r]), T = h && h.componentFromFramework, I = h && h.componentClass;
  return /* @__PURE__ */ P.createElement(
    "div",
    {
      ref: y,
      className: D,
      "col-id": m,
      role: "columnheader",
      "aria-expanded": d
    },
    T && E && /* @__PURE__ */ P.createElement(I, be({}, h.params)),
    T && !E && /* @__PURE__ */ P.createElement(I, at(be({}, h.params), { ref: v })),
    /* @__PURE__ */ P.createElement("div", { ref: w, "aria-hidden": l, className: R })
  );
}, WC = St(BC);
function md() {
  W.warnOnce("Using custom components without `reactiveCustomComponents = true` is deprecated.");
}
var UC = (e) => {
  const { context: t, gos: i } = Et(pt), [s, o] = G(() => new xt("ag-header-cell", "ag-floating-filter")), [r, n] = G(() => new xt()), [l, a] = G(() => new xt("ag-floating-filter-button", "ag-hidden")), [d, c] = G("false"), [h, g] = G(), [m, C] = G(1), w = N(null), v = N(null), y = N(null), E = N(null), D = N(), R = N(), T = (ve) => {
    ve != null && D.current && D.current(ve);
  }, { ctrl: I } = e, A = de((ve) => {
    if (w.current = ve, !w.current)
      return;
    R.current = new _e((ee) => {
      D.current = ee;
    });
    const ge = {
      addOrRemoveCssClass: (ee, oe) => o((Le) => Le.setClass(ee, oe)),
      addOrRemoveBodyCssClass: (ee, oe) => n((Le) => Le.setClass(ee, oe)),
      setButtonWrapperDisplayed: (ee) => {
        a((oe) => oe.setClass("ag-hidden", !ee)), c(ee ? "false" : "true");
      },
      setWidth: (ee) => {
        w.current && (w.current.style.width = ee);
      },
      setCompDetails: (ee) => g(ee),
      getFloatingFilterComp: () => R.current ? R.current : null,
      setMenuIcon: (ee) => {
        var oe;
        return (oe = E.current) == null ? void 0 : oe.appendChild(ee);
      }
    };
    I.setComp(ge, w.current, E.current, v.current);
  }, []);
  Fi(() => Fr(h, t, v.current, T), [h]);
  const V = j(() => s.toString(), [s]), x = j(() => r.toString(), [r]), k = j(() => l.toString(), [l]), B = j(() => !!(h && h.componentFromFramework && Do(h.componentClass)), [h]), Q = j(() => i.get("reactiveCustomComponents"), []), U = j(() => {
    if (h)
      if (Q) {
        const ve = new PC(h.params, () => C((ge) => ge + 1));
        return T(ve), ve;
      } else h.componentFromFramework && md();
  }, [h]), me = U == null ? void 0 : U.getProps(), Ce = h && h.componentFromFramework, Ae = h && h.componentClass;
  return /* @__PURE__ */ P.createElement("div", { ref: A, className: V, role: "gridcell" }, /* @__PURE__ */ P.createElement("div", { ref: v, className: x, role: "presentation" }, Ce && !Q && /* @__PURE__ */ P.createElement(Ae, at(be({}, h.params), { ref: B ? () => {
  } : T })), Ce && Q && /* @__PURE__ */ P.createElement(hd.Provider, { value: {
    setMethods: (ve) => U.setMethods(ve)
  } }, /* @__PURE__ */ P.createElement(Ae, be({}, me)))), /* @__PURE__ */ P.createElement("div", { ref: y, "aria-hidden": d, className: k, role: "presentation" }, /* @__PURE__ */ P.createElement("button", { ref: E, type: "button", className: "ag-button ag-floating-filter-button-button", tabIndex: -1 })));
}, zC = St(UC), KC = (e) => {
  const { ctrl: t } = e, { topOffset: i, rowHeight: s } = j(() => t.getTopAndHeight(), []), o = t.getAriaRowIndex(), r = t.getHeaderRowClass(), [n, l] = G(() => s + "px"), [a, d] = G(() => i + "px"), c = N(null), h = N(null), [g, m] = G(() => t.getHeaderCtrls()), C = N(null), w = de((E) => {
    if (C.current = E, !E)
      return;
    const D = {
      setHeight: (R) => l(R),
      setTop: (R) => d(R),
      setHeaderCtrls: (R, T, I) => {
        h.current = c.current, c.current = R;
        const A = fd(h.current, R, T);
        A !== h.current && gd(I, () => m(A));
      },
      setWidth: (R) => {
        C.current && (C.current.style.width = R);
      }
    };
    t.setComp(D, !1);
  }, []), v = j(() => ({
    height: n,
    top: a
  }), [n, a]), y = de((E) => {
    switch (t.getType()) {
      case Wl.COLUMN_GROUP:
        return /* @__PURE__ */ P.createElement(WC, { ctrl: E, key: E.getInstanceId() });
      case Wl.FLOATING_FILTER:
        return /* @__PURE__ */ P.createElement(zC, { ctrl: E, key: E.getInstanceId() });
      default:
        return /* @__PURE__ */ P.createElement(kC, { ctrl: E, key: E.getInstanceId() });
    }
  }, []);
  return /* @__PURE__ */ P.createElement("div", { ref: w, className: r, role: "row", style: v, "aria-rowindex": o }, g.map(y));
}, $C = St(KC), jC = (e) => {
  const [t, i] = G(!0), [s, o] = G([]), { context: r } = Et(pt), n = N(null), l = N(null), a = N(null), d = e.pinned === "left", c = e.pinned === "right", h = !d && !c, g = de((w) => {
    if (n.current = w, !n.current) {
      r.destroyBean(a.current), a.current = null;
      return;
    }
    const v = {
      setDisplayed: i,
      setCtrls: (y) => o(y),
      // centre only
      setCenterWidth: (y) => {
        l.current && (l.current.style.width = y);
      },
      setViewportScrollLeft: (y) => {
        n.current && (n.current.scrollLeft = y);
      },
      // pinned only
      setPinnedContainerWidth: (y) => {
        n.current && (n.current.style.width = y, n.current.style.minWidth = y, n.current.style.maxWidth = y);
      }
    };
    a.current = r.createBean(new ki(e.pinned)), a.current.setComp(v, n.current);
  }, []), m = t ? "" : "ag-hidden", C = () => s.map((w) => /* @__PURE__ */ P.createElement($C, { ctrl: w, key: w.getInstanceId() }));
  return /* @__PURE__ */ P.createElement(P.Fragment, null, d && /* @__PURE__ */ P.createElement("div", { ref: g, className: "ag-pinned-left-header " + m, "aria-hidden": !t, role: "rowgroup" }, C()), c && /* @__PURE__ */ P.createElement("div", { ref: g, className: "ag-pinned-right-header " + m, "aria-hidden": !t, role: "rowgroup" }, C()), h && /* @__PURE__ */ P.createElement("div", { ref: g, className: "ag-header-viewport " + m, role: "presentation" }, /* @__PURE__ */ P.createElement("div", { ref: l, className: "ag-header-container", role: "rowgroup" }, C())));
}, El = St(jC), YC = () => {
  const [e, t] = G(() => new xt()), [i, s] = G(), { context: o } = Et(pt), r = N(null), n = N(null), l = de((c) => {
    if (r.current = c, !c) {
      o.destroyBean(n.current), n.current = null;
      return;
    }
    const h = {
      addOrRemoveCssClass: (g, m) => t((C) => C.setClass(g, m)),
      setHeightAndMinHeight: (g) => s(g)
    };
    n.current = o.createBean(new Bi()), n.current.setComp(h, r.current, r.current);
  }, []), a = j(() => "ag-header " + e.toString(), [e]), d = j(() => ({
    height: i,
    minHeight: i
  }), [i]);
  return /* @__PURE__ */ P.createElement("div", { ref: l, className: a, style: d, role: "presentation" }, /* @__PURE__ */ P.createElement(El, { pinned: "left" }), /* @__PURE__ */ P.createElement(El, { pinned: null }), /* @__PURE__ */ P.createElement(El, { pinned: "right" }));
}, qC = St(YC), QC = (e, t) => {
  Be(() => {
    const i = t.current;
    if (i) {
      const s = i.parentElement;
      if (s) {
        const o = document.createComment(e);
        return s.insertBefore(o, i), () => {
          s.removeChild(o);
        };
      }
    }
  }, [e]);
}, Ji = QC, XC = (e) => {
  const t = N(e), i = N(), s = N(!1), o = N(!1), [, r] = G(0);
  s.current && (o.current = !0), Be(() => (s.current || (i.current = t.current(), s.current = !0), r((n) => n + 1), () => {
    o.current && i.current && i.current();
  }), []);
}, ZC = (e) => {
  const [t, i] = G(), { context: s, popupService: o, localeService: r, gos: n } = Et(pt);
  return XC(() => {
    const { editDetails: l, cellCtrl: a, eParentCell: d } = e, { compDetails: c } = l, h = n.get("stopEditingWhenCellsLoseFocus"), g = s.createBean(new Th(c.params)), m = g.getGui();
    if (e.jsChildComp) {
      const D = e.jsChildComp.getGui();
      D && m.appendChild(D);
    }
    const C = {
      column: a.getColumn(),
      rowNode: a.getRowNode(),
      type: "popupCellEditor",
      eventSource: d,
      ePopup: m,
      position: l.popupPosition,
      keepWithinBounds: !0
    }, w = o.positionPopupByComponent.bind(o, C), v = r.getLocaleTextFunc(), y = o.addPopup({
      modal: h,
      eChild: m,
      closeOnEsc: !0,
      closedCallback: () => {
        a.onPopupEditorClosed();
      },
      anchorToElement: d,
      positionCallback: w,
      ariaLabel: v("ariaLabelCellEditor", "Cell Editor")
    }), E = y ? y.hideFunc : void 0;
    return i(g), e.jsChildComp && e.jsChildComp.afterGuiAttached && e.jsChildComp.afterGuiAttached(), () => {
      E != null && E(), s.destroyBean(g);
    };
  }), /* @__PURE__ */ P.createElement(P.Fragment, null, t && e.wrappedContent && ru(e.wrappedContent, t.getGui()));
}, tu = St(ZC), JC = (e, t, i, s, o, r) => {
  const { context: n } = Et(pt), l = de(() => {
    const a = o.current;
    if (!a)
      return;
    const d = a.getGui();
    d && d.parentElement && d.parentElement.removeChild(d), n.destroyBean(a), o.current = void 0;
  }, []);
  Be(() => {
    const a = e != null, d = e && e.compDetails && !e.compDetails.componentFromFramework, c = t && i == null;
    if (!(a && d && !c)) {
      l();
      return;
    }
    const g = e.compDetails;
    if (o.current) {
      const y = o.current, D = y.refresh != null && e.force == !1 ? y.refresh(g.params) : !1;
      if (D === !0 || D === void 0)
        return;
      l();
    }
    const m = g.newAgStackInstance();
    if (!m)
      return;
    const C = m.resolveNow(null, (y) => y);
    if (!C)
      return;
    const w = C.getGui();
    if (!w)
      return;
    (t ? i : r.current).appendChild(w), o.current = C;
  }, [e, t, s]), Be(() => l, []);
}, ev = JC, tv = class {
  constructor(e, t) {
    this.cellEditorParams = e, this.refreshProps = t, this.instanceCreated = new _e((i) => {
      this.resolveInstanceCreated = i;
    }), this.onValueChange = (i) => this.updateValue(i), this.value = e.value;
  }
  getProps() {
    return at(be({}, this.cellEditorParams), {
      initialValue: this.cellEditorParams.value,
      value: this.value,
      onValueChange: this.onValueChange
    });
  }
  getValue() {
    return this.value;
  }
  refresh(e) {
    this.cellEditorParams = e, this.refreshProps();
  }
  setMethods(e) {
    pd(this.getOptionalMethods(), e, this);
  }
  getInstance() {
    return this.instanceCreated.then(() => this.componentInstance);
  }
  setRef(e) {
    var t;
    this.componentInstance = e, (t = this.resolveInstanceCreated) == null || t.call(this), this.resolveInstanceCreated = void 0;
  }
  getOptionalMethods() {
    return ["isPopup", "isCancelBeforeStart", "isCancelAfterEnd", "getPopupPosition", "focusIn", "focusOut", "afterGuiAttached"];
  }
  updateValue(e) {
    this.value = e, this.refreshProps();
  }
}, iv = (e, t, i) => {
  const s = i.getColumn();
  if (!e && t.isPopup && t.isPopup()) {
    const o = `AG Grid: Found an issue in column ${s.getColId()}. If using React, specify an editor is a popup using colDef.cellEditorPopup=true. AG Grid React cannot depend on the editor component specifying if it's in a popup (via the isPopup() method on the editor), as React needs to know this information BEFORE the component is created.`;
    W.doOnce(() => console.warn(o), "jsEditorComp-isPopup-" + i.getColumn().getColId());
  }
  if (e && t.getPopupPosition && t.getPopupPosition() != null) {
    const o = `AG Grid: Found an issue in column ${s.getColId()}. If using React, specify an editor popup position using colDef.cellEditorPopupPosition=true. AG Grid React cannot depend on the editor component specifying it's position (via the getPopupPosition() method on the editor), as React needs to know this information BEFORE the component is created.`;
    W.doOnce(() => console.warn(o), "jsEditorComp-getPopupPosition-" + i.getColumn().getColId());
  }
}, sv = (e, t, i) => {
  const { compProxy: s } = e;
  i(s);
  const o = s.getProps(), r = Do(t);
  return /* @__PURE__ */ P.createElement(hd.Provider, { value: {
    setMethods: (n) => s.setMethods(n)
  } }, r && /* @__PURE__ */ P.createElement(t, be({}, o)), !r && /* @__PURE__ */ P.createElement(t, at(be({}, o), { ref: (n) => s.setRef(n) })));
}, iu = (e, t, i) => {
  const s = e.compProxy;
  return /* @__PURE__ */ P.createElement(P.Fragment, null, !s && /* @__PURE__ */ P.createElement(t, at(be({}, e.compDetails.params), { ref: i })), s && sv(e, t, i));
}, ov = (e, t, i, s, o, r) => {
  const n = e.compDetails, l = n.componentClass, a = n.componentFromFramework && !e.popup, d = n.componentFromFramework && e.popup, c = !n.componentFromFramework && e.popup;
  return /* @__PURE__ */ P.createElement(P.Fragment, null, a && iu(e, l, t), d && /* @__PURE__ */ P.createElement(
    tu,
    {
      editDetails: e,
      cellCtrl: o,
      eParentCell: s,
      wrappedContent: iu(e, l, i)
    }
  ), c && r && /* @__PURE__ */ P.createElement(
    tu,
    {
      editDetails: e,
      cellCtrl: o,
      eParentCell: s,
      jsChildComp: r
    }
  ));
}, rv = (e, t, i, s, o, r, n) => {
  const { compDetails: l, value: a } = e, d = !l, c = l && l.componentFromFramework, h = l && l.componentClass, g = a != null && a.toString ? a.toString() : a, m = () => /* @__PURE__ */ P.createElement(P.Fragment, null, d && /* @__PURE__ */ P.createElement(P.Fragment, null, g), c && !r && /* @__PURE__ */ P.createElement(h, at(be({}, l.params), { key: t, ref: s })), c && r && /* @__PURE__ */ P.createElement(h, at(be({}, l.params), { key: t })));
  return /* @__PURE__ */ P.createElement(P.Fragment, null, o ? /* @__PURE__ */ P.createElement("span", { role: "presentation", id: `cell-${i}`, className: "ag-cell-value", ref: n }, m()) : m());
}, nv = (e) => {
  const { context: t } = Et(pt), { cellCtrl: i, printLayout: s, editingRow: o } = e, r = i.getTabIndex(), n = i.getColumnIdSanitised(), l = i.getInstanceId(), [a, d] = G(() => i.isCellRenderer() ? void 0 : { compDetails: void 0, value: i.getValueToDisplay(), force: !1 }), [c, h] = G(), [g, m] = G(1), [C, w] = G(), [v, y] = G(!1), [E, D] = G(!1), [R, T] = G(!1), [I, A] = G(), V = j(() => i.isForceWrapper(), [i]), x = j(() => i.getCellAriaRole(), [i]), k = N(null), B = N(null), Q = N(), U = N(), me = N(), Ce = N([]), Ae = N(), [ve, ge] = G(0), ee = de((Me) => {
    Ae.current = Me, ge((Ne) => Ne + 1);
  }, []), oe = a != null && (v || R || E), Le = V || oe, re = de((Me, Ne) => {
    U.current = Ne, Ne && (iv(Me, Ne, i), Ne.isCancelBeforeStart && Ne.isCancelBeforeStart() && setTimeout(() => {
      i.stopEditing(!0), i.focusCell(!0);
    }));
  }, [i]), Se = de(
    (Me) => re(!0, Me),
    [re]
  ), Zt = de(
    (Me) => re(!1, Me),
    [re]
  );
  let we = N();
  we.current || (we.current = new fr(() => k.current)), ev(a, Le, Ae.current, ve, Q, k);
  const Ft = N();
  Fi(() => {
    const Me = Ft.current, Ne = a;
    if (Ft.current = a, Me == null || Me.compDetails == null || Ne == null || Ne.compDetails == null)
      return;
    const We = Me.compDetails, ne = Ne.compDetails;
    if (We.componentClass != ne.componentClass || B.current == null || B.current.refresh == null)
      return;
    B.current.refresh(ne.params) != !0 && m((kt) => kt + 1);
  }, [a]), Fi(() => {
    if (!(c && !c.compDetails.componentFromFramework))
      return;
    const Ne = c.compDetails, We = c.popup === !0, ne = VC(Ne);
    if (!ne)
      return;
    const Ue = ne.getGui();
    if (re(We, ne), !We) {
      const kt = (V ? me : k).current;
      kt == null || kt.appendChild(Ue), ne.afterGuiAttached && ne.afterGuiAttached();
    }
    return A(ne), () => {
      t.destroyBean(ne), re(We, void 0), A(void 0), Ue && Ue.parentElement && Ue.parentElement.removeChild(Ue);
    };
  }, [c]);
  const Qe = de((Me) => {
    if (me.current = Me, !me.current) {
      Ce.current.forEach((We) => We()), Ce.current = [];
      return;
    }
    const Ne = (We) => {
      var ne;
      if (We) {
        const Ue = We.getGui();
        (ne = me.current) == null || ne.insertAdjacentElement("afterbegin", Ue), Ce.current.push(() => {
          t.destroyBean(We), W.removeFromParent(Ue);
        });
      }
      return We;
    };
    if (v) {
      const We = i.createSelectionCheckbox();
      Ne(We);
    }
    R && Ne(i.createDndSource()), E && Ne(i.createRowDragComp());
  }, [i, t, R, E, v]), ci = de((Me) => {
    if (k.current = Me, !k.current || !i)
      return;
    const Ne = {
      addOrRemoveCssClass: (ne, Ue) => we.current.addOrRemoveCssClass(ne, Ue),
      setUserStyles: (ne) => w(ne),
      getFocusableElement: () => k.current,
      setIncludeSelection: (ne) => y(ne),
      setIncludeRowDrag: (ne) => D(ne),
      setIncludeDndSource: (ne) => T(ne),
      getCellEditor: () => U.current || null,
      getCellRenderer: () => B.current ? B.current : Q.current,
      getParentOfValue: () => Ae.current ? Ae.current : me.current ? me.current : k.current,
      setRenderDetails: (ne, Ue, kt) => {
        d((Bt) => (Bt == null ? void 0 : Bt.compDetails) !== ne || (Bt == null ? void 0 : Bt.value) !== Ue || (Bt == null ? void 0 : Bt.force) !== kt ? {
          value: Ue,
          compDetails: ne,
          force: kt
        } : Bt);
      },
      setEditDetails: (ne, Ue, kt, Bt) => {
        if (ne) {
          let ji;
          Bt ? ji = new tv(ne.params, () => m((Jn) => Jn + 1)) : ne.componentFromFramework && md(), h({
            compDetails: ne,
            popup: Ue,
            popupPosition: kt,
            compProxy: ji
          }), Ue || d(void 0);
        } else
          h((ji) => {
            ji != null && ji.compProxy && (U.current = void 0);
          });
      }
    }, We = me.current || void 0;
    i.setComp(Ne, k.current, We, s, o);
  }, []), Gs = j(() => !!(a && a.compDetails && a.compDetails.componentFromFramework && Do(a.compDetails.componentClass)), [a]);
  Fi(() => {
    var Me;
    k.current && (we.current.addOrRemoveCssClass("ag-cell-value", !Le), we.current.addOrRemoveCssClass("ag-cell-inline-editing", !!c && !c.popup), we.current.addOrRemoveCssClass("ag-cell-popup-editing", !!c && !!c.popup), we.current.addOrRemoveCssClass("ag-cell-not-inline-editing", !c || !!c.popup), (Me = i.getRowCtrl()) == null || Me.setInlineEditingCss(!!c), i.shouldRestoreFocus() && !i.isEditing() && k.current.focus({ preventScroll: !0 }));
  });
  const Lr = () => /* @__PURE__ */ P.createElement(P.Fragment, null, a != null && rv(
    a,
    g,
    l,
    B,
    Le,
    Gs,
    ee
  ), c != null && ov(
    c,
    Zt,
    Se,
    k.current,
    i,
    I
  ));
  return /* @__PURE__ */ P.createElement(
    "div",
    {
      ref: ci,
      style: C,
      tabIndex: r,
      role: x,
      "col-id": n
    },
    Le ? /* @__PURE__ */ P.createElement("div", { className: "ag-cell-wrapper", role: "presentation", ref: Qe }, Lr()) : Lr()
  );
}, lv = St(nv), av = (e) => {
  const { context: t, gos: i } = Et(pt), { rowCtrl: s, containerType: o } = e, r = s.getTabIndex(), n = N(s.getDomOrder()), l = s.isFullWidth(), a = s.getRowNode().displayed, [d, c] = G(() => a ? s.getRowIndex() : null), [h, g] = G(() => s.getRowId()), [m, C] = G(() => s.getBusinessKey()), [w, v] = G(() => s.getRowStyles()), y = N(null), E = N(null), [D, R] = G(() => null), [T, I] = G(), [A, V] = G(() => a ? s.getInitialRowTop(o) : void 0), [x, k] = G(() => a ? s.getInitialTransform(o) : void 0), B = N(null), Q = N(), U = N(!1), [me, Ce] = G(0);
  Be(() => {
    var we;
    if (U.current || !T || me > 10)
      return;
    const Ft = (we = B.current) == null ? void 0 : we.firstChild;
    Ft ? (s.setupDetailRowAutoHeight(Ft), U.current = !0) : Ce((Qe) => Qe + 1);
  }, [T, me]);
  let Ae = N();
  Ae.current || (Ae.current = new fr(() => B.current));
  const ve = de((we) => {
    if (B.current = we, !B.current) {
      s.unsetComp(o);
      return;
    }
    if (!s.isAlive())
      return;
    const Ft = {
      // the rowTop is managed by state, instead of direct style manipulation by rowCtrl (like all the other styles)
      // as we need to have an initial value when it's placed into he DOM for the first time, for animation to work.
      setTop: V,
      setTransform: k,
      // i found using React for managing classes at the row level was to slow, as modifying classes caused a lot of
      // React code to execute, so avoiding React for managing CSS Classes made the grid go much faster.
      addOrRemoveCssClass: (Qe, ci) => Ae.current.addOrRemoveCssClass(Qe, ci),
      setDomOrder: (Qe) => n.current = Qe,
      setRowIndex: c,
      setRowId: g,
      setRowBusinessKey: C,
      setUserStyles: v,
      // if we don't maintain the order, then cols will be ripped out and into the dom
      // when cols reordered, which would stop the CSS transitions from working
      setCellCtrls: (Qe, ci) => {
        E.current = y.current, y.current = Qe;
        const Gs = fd(E.current, Qe, n.current);
        Gs !== E.current && gd(ci, () => R(Gs));
      },
      showFullWidth: (Qe) => I(Qe),
      getFullWidthCellRenderer: () => Q.current,
      refreshFullWidth: (Qe) => re.current ? (I((ci) => at(be({}, ci), {
        params: Qe()
      })), !0) : !Q.current || !Q.current.refresh ? !1 : Q.current.refresh(Qe())
    };
    s.setComp(Ft, B.current, o);
  }, []);
  Fi(() => Fr(T, t, B.current, Q), [T]);
  const ge = j(() => {
    const we = { top: A, transform: x };
    return Object.assign(we, w), we;
  }, [A, x, w]), ee = l && T && T.componentFromFramework, oe = !l && D != null, Le = j(() => !!((T == null ? void 0 : T.componentFromFramework) && Do(T.componentClass)), [T]), re = N(!1);
  Be(() => {
    re.current = Le && !!T && !!i.get("reactiveCustomComponents");
  }, [Le, T]);
  const Se = () => D == null ? void 0 : D.map((we) => /* @__PURE__ */ P.createElement(
    lv,
    {
      cellCtrl: we,
      editingRow: s.isEditing(),
      printLayout: s.isPrintLayout(),
      key: we.getInstanceId()
    }
  )), Zt = () => {
    const we = T.componentClass;
    return /* @__PURE__ */ P.createElement(P.Fragment, null, Le && /* @__PURE__ */ P.createElement(we, be({}, T.params)), !Le && /* @__PURE__ */ P.createElement(we, at(be({}, T.params), { ref: Q })));
  };
  return /* @__PURE__ */ P.createElement(
    "div",
    {
      ref: ve,
      role: "row",
      style: ge,
      "row-index": d,
      "row-id": h,
      "row-business-key": m,
      tabIndex: r
    },
    oe && Se(),
    ee && Zt()
  );
}, dv = St(av), uv = (e) => {
  const { context: t } = Et(pt), { name: i } = e, s = j(() => yh(i), [i]), o = N(null), r = N(null), n = N([]), l = N([]), [a, d] = G(() => []), c = N(!1), h = N(), g = j(() => on.getRowContainerCssClasses(i), [i]), m = j(() => Ut(g.viewport), [g]), C = j(() => Ut(g.container), [g]), w = i === Ee.CENTER || i === Ee.TOP_CENTER || i === Ee.BOTTOM_CENTER || i === Ee.STICKY_TOP_CENTER || i === Ee.STICKY_BOTTOM_CENTER, v = w ? o : r;
  Ji(" AG Row Container " + i + " ", v);
  const y = de(() => w ? o.current != null && r.current != null : r.current != null, []), E = de(() => w ? o.current == null && r.current == null : r.current == null, []), D = de(() => {
    if (E() && (t.destroyBean(h.current), h.current = null), y()) {
      const A = (x) => {
        const k = fd(l.current, n.current, c.current);
        k !== l.current && (l.current = k, gd(x, () => d(k)));
      }, V = {
        setViewportHeight: (x) => {
          o.current && (o.current.style.height = x);
        },
        setRowCtrls: ({ rowCtrls: x, useFlushSync: k }) => {
          const B = !!k && n.current.length > 0 && x.length > 0;
          n.current = x, A(B);
        },
        setDomOrder: (x) => {
          c.current != x && (c.current = x, A(!1));
        },
        setContainerWidth: (x) => {
          r.current && (r.current.style.width = x);
        }
      };
      h.current = t.createBean(new on(i)), h.current.setComp(V, r.current, o.current);
    }
  }, [y, E]), R = de((A) => {
    r.current = A, D();
  }, [D]), T = de((A) => {
    o.current = A, D();
  }, [D]), I = () => /* @__PURE__ */ P.createElement(
    "div",
    {
      className: C,
      ref: R,
      role: "rowgroup"
    },
    a.map(
      (A) => /* @__PURE__ */ P.createElement(dv, { rowCtrl: A, containerType: s, key: A.getInstanceId() })
    )
  );
  return /* @__PURE__ */ P.createElement(P.Fragment, null, w ? /* @__PURE__ */ P.createElement("div", { className: m, ref: T, role: "presentation" }, I()) : I());
}, cv = St(uv), hv = () => {
  const { context: e, agStackComponentsRegistry: t, resizeObserverService: i } = Et(pt), [s, o] = G(""), [r, n] = G(0), [l, a] = G(0), [d, c] = G("0px"), [h, g] = G("0px"), [m, C] = G("100%"), [w, v] = G("0px"), [y, E] = G("0px"), [D, R] = G("100%"), [T, I] = G(""), [A, V] = G(""), [x, k] = G(null), [B, Q] = G(""), [U, me] = G(null), [Ce, Ae] = G("ag-layout-normal");
  let ve = N();
  ve.current || (ve.current = new fr(() => ge.current));
  const ge = N(null), ee = N(null), oe = N(null), Le = N(null), re = N(null), Se = N(null), Zt = N(null), we = N([]), Ft = N([]);
  Ji(" AG Grid Body ", ge), Ji(" AG Pinned Top ", ee), Ji(" AG Sticky Top ", oe), Ji(" AG Middle ", Se), Ji(" AG Pinned Bottom ", Zt);
  const Qe = de((Os) => {
    if (ge.current = Os, !ge.current) {
      e.destroyBeans(we.current), Ft.current.forEach(($e) => $e()), we.current = [], Ft.current = [];
      return;
    }
    if (!e)
      return;
    const bo = ($e) => {
      const Jt = t.getComponentClass($e), vd = e.createBean(new Jt());
      return we.current.push(vd), vd;
    }, Ri = ($e, Jt) => {
      $e.appendChild(Jt), Ft.current.push(() => $e.removeChild(Jt));
    };
    Ri(ge.current, document.createComment(" AG Fake Horizontal Scroll ")), Ri(ge.current, bo("AG-FAKE-HORIZONTAL-SCROLL").getGui()), Ri(ge.current, document.createComment(" AG Overlay Wrapper ")), Ri(ge.current, bo("AG-OVERLAY-WRAPPER").getGui()), re.current && (Ri(re.current, document.createComment(" AG Fake Vertical Scroll ")), Ri(re.current, bo("AG-FAKE-VERTICAL-SCROLL").getGui()));
    const el = {
      setRowAnimationCssOnBodyViewport: o,
      setColumnCount: ($e) => {
        ge.current && W.setAriaColCount(ge.current, $e);
      },
      setRowCount: ($e) => {
        ge.current && W.setAriaRowCount(ge.current, $e);
      },
      setTopHeight: n,
      setBottomHeight: a,
      setStickyTopHeight: c,
      setStickyTopTop: g,
      setStickyTopWidth: C,
      setTopDisplay: I,
      setBottomDisplay: V,
      setColumnMovingCss: ($e, Jt) => ve.current.addOrRemoveCssClass($e, Jt),
      updateLayoutClasses: Ae,
      setAlwaysVerticalScrollClass: k,
      setPinnedTopBottomOverflowY: Q,
      setCellSelectableCss: ($e, Jt) => me(Jt ? $e : null),
      setBodyViewportWidth: ($e) => {
        Se.current && (Se.current.style.width = $e);
      },
      registerBodyViewportResizeListener: ($e) => {
        if (Se.current) {
          const Jt = i.observeResize(Se.current, $e);
          Ft.current.push(() => Jt());
        }
      },
      setStickyBottomHeight: v,
      setStickyBottomBottom: E,
      setStickyBottomWidth: R
    }, Cd = e.createBean(new ot());
    we.current.push(Cd), Cd.setComp(
      el,
      ge.current,
      Se.current,
      ee.current,
      Zt.current,
      oe.current,
      Le.current
    );
  }, []), ci = j(
    () => Ut("ag-root", "ag-unselectable", Ce),
    [Ce]
  ), Gs = j(
    () => Ut("ag-body-viewport", s, Ce, x, U),
    [s, Ce, x, U]
  ), Lr = j(
    () => Ut("ag-body", Ce),
    [Ce]
  ), Me = j(
    () => Ut("ag-floating-top", U),
    [U]
  ), Ne = j(
    () => Ut("ag-sticky-top", U),
    [U]
  ), We = j(
    () => Ut("ag-sticky-bottom", U),
    [U]
  ), ne = j(
    () => Ut("ag-floating-bottom", U),
    [U]
  ), Ue = j(() => ({
    height: r,
    minHeight: r,
    display: T,
    overflowY: B
  }), [r, T, B]), kt = j(() => ({
    height: d,
    top: h,
    width: m
  }), [d, h, m]), Bt = j(() => ({
    height: w,
    bottom: y,
    width: D
  }), [w, y, D]), ji = j(() => ({
    height: l,
    minHeight: l,
    display: A,
    overflowY: B
  }), [l, A, B]), Jn = (Os) => /* @__PURE__ */ P.createElement(cv, { name: Os, key: `${Os}-container` }), To = ({
    section: Os,
    children: bo,
    className: Ri,
    style: el
  }) => /* @__PURE__ */ P.createElement("div", { ref: Os, className: Ri, role: "presentation", style: el }, bo.map(Jn));
  return /* @__PURE__ */ P.createElement("div", { ref: Qe, className: ci, role: "treegrid" }, /* @__PURE__ */ P.createElement(qC, null), To({ section: ee, className: Me, style: Ue, children: [
    Ee.TOP_LEFT,
    Ee.TOP_CENTER,
    Ee.TOP_RIGHT,
    Ee.TOP_FULL_WIDTH
  ] }), /* @__PURE__ */ P.createElement("div", { className: Lr, ref: re, role: "presentation" }, To({
    section: Se,
    className: Gs,
    children: [
      Ee.LEFT,
      Ee.CENTER,
      Ee.RIGHT,
      Ee.FULL_WIDTH
    ]
  })), To({ section: oe, className: Ne, style: kt, children: [
    Ee.STICKY_TOP_LEFT,
    Ee.STICKY_TOP_CENTER,
    Ee.STICKY_TOP_RIGHT,
    Ee.STICKY_TOP_FULL_WIDTH
  ] }), To({ section: Le, className: We, style: Bt, children: [
    Ee.STICKY_BOTTOM_LEFT,
    Ee.STICKY_BOTTOM_CENTER,
    Ee.STICKY_BOTTOM_RIGHT,
    Ee.STICKY_BOTTOM_FULL_WIDTH
  ] }), To({ section: Zt, className: ne, style: ji, children: [
    Ee.BOTTOM_LEFT,
    Ee.BOTTOM_CENTER,
    Ee.BOTTOM_RIGHT,
    Ee.BOTTOM_FULL_WIDTH
  ] }));
}, pv = St(hv), gv = (e, t) => {
  const { children: i, eFocusableElement: s, onTabKeyDown: o, gridCtrl: r, forceFocusOutWhenTabGuardsAreEmpty: n } = e, { context: l } = Et(pt), a = N(null), d = N(null), c = N(), h = (v) => {
    const y = v == null ? void 0 : parseInt(v, 10).toString();
    [a, d].forEach((E) => {
      var D, R;
      y === void 0 ? (D = E.current) == null || D.removeAttribute("tabindex") : (R = E.current) == null || R.setAttribute("tabindex", y);
    });
  };
  Es(t, () => ({
    forceFocusOutOfContainer(v) {
      var y;
      (y = c.current) == null || y.forceFocusOutOfContainer(v);
    }
  }));
  const g = de(() => {
    if (!a.current && !d.current) {
      l.destroyBean(c.current), c.current = null;
      return;
    }
    if (a.current && d.current) {
      const v = {
        setTabIndex: h
      };
      c.current = l.createBean(new jn({
        comp: v,
        eTopGuard: a.current,
        eBottomGuard: d.current,
        eFocusableElement: s,
        onTabKeyDown: o,
        forceFocusOutWhenTabGuardsAreEmpty: n,
        focusInnerElement: (y) => r.focusInnerElement(y)
      }));
    }
  }, []), m = de((v) => {
    a.current = v, g();
  }, [g]), C = de((v) => {
    d.current = v, g();
  }, [g]), w = (v) => {
    const y = v === "top" ? Wr.TAB_GUARD_TOP : Wr.TAB_GUARD_BOTTOM;
    return /* @__PURE__ */ P.createElement(
      "div",
      {
        className: `${Wr.TAB_GUARD} ${y}`,
        role: "presentation",
        ref: v === "top" ? m : C
      }
    );
  };
  return /* @__PURE__ */ P.createElement(P.Fragment, null, w("top"), i, w("bottom"));
}, fv = _i(gv), mv = St(fv), Cv = ({ context: e }) => {
  const [t, i] = G(""), [s, o] = G(""), [r, n] = G(""), [l, a] = G(null), [d, c] = G(null), [h, g] = G(!1), [m, C] = G(), w = N(null), v = N(null), y = N(), [E, D] = G(null), R = N(() => {
  }), T = de(() => {
  }, []), I = j(() => e.isDestroyed() ? null : e.getBean("beans"), [e]);
  Ji(" AG Grid ", v);
  const A = de((Q) => {
    if (v.current = Q, !v.current) {
      e.destroyBean(w.current), w.current = null;
      return;
    }
    if (e.isDestroyed())
      return;
    w.current = e.createBean(new Ki());
    const U = w.current;
    R.current = U.focusInnerElement.bind(U);
    const me = {
      destroyGridUi: () => {
      },
      // do nothing, as framework users destroy grid by removing the comp
      setRtlClass: i,
      forceFocusOutOfContainer: (Ce) => {
        var Ae;
        (Ae = y.current) == null || Ae.forceFocusOutOfContainer(Ce);
      },
      updateLayoutClasses: n,
      getFocusableContainers: () => {
        var Ce, Ae;
        const ve = [], ge = (Ce = v.current) == null ? void 0 : Ce.querySelector(".ag-root"), ee = (Ae = v.current) == null ? void 0 : Ae.querySelector(".ag-side-bar:not(.ag-hidden)");
        return ge && ve.push(ge), ee && ve.push(ee), ve;
      },
      setCursor: a,
      setUserSelect: c
    };
    U.setComp(me, v.current, v.current), g(!0);
  }, []);
  Be(() => {
    if (!m || !I || !w.current || !E || !v.current)
      return;
    const Q = w.current, U = [], { agStackComponentsRegistry: me } = I, Ce = me.getComponentClass("AG-GRID-HEADER-DROP-ZONES"), Ae = me.getComponentClass("AG-SIDE-BAR"), ve = me.getComponentClass("AG-STATUS-BAR"), ge = me.getComponentClass("AG-WATERMARK"), ee = me.getComponentClass("AG-PAGINATION"), oe = [], Le = v.current;
    if (Q.showDropZones() && Ce) {
      const re = e.createBean(new Ce()), Se = re.getGui();
      Le.insertAdjacentElement("afterbegin", Se), oe.push(Se), U.push(re);
    }
    if (Q.showSideBar() && Ae) {
      const re = e.createBean(new Ae()), Se = re.getGui(), Zt = E.querySelector(".ag-tab-guard-bottom");
      Zt && (Zt.insertAdjacentElement("beforebegin", Se), oe.push(Se)), U.push(re);
    }
    if (Q.showStatusBar() && ve) {
      const re = e.createBean(new ve()), Se = re.getGui();
      Le.insertAdjacentElement("beforeend", Se), oe.push(Se), U.push(re);
    }
    if (ee) {
      const re = e.createBean(new ee()), Se = re.getGui();
      Le.insertAdjacentElement("beforeend", Se), oe.push(Se), U.push(re);
    }
    if (Q.showWatermark() && ge) {
      const re = e.createBean(new ge()), Se = re.getGui();
      Le.insertAdjacentElement("beforeend", Se), oe.push(Se), U.push(re);
    }
    return () => {
      e.destroyBeans(U), oe.forEach((re) => {
        re.parentElement && re.parentElement.removeChild(re);
      });
    };
  }, [m, E, I]);
  const V = j(() => Ut("ag-root-wrapper", t, s, r), [t, s, r]), x = j(() => Ut("ag-root-wrapper-body", "ag-focus-managed", r), [r]), k = j(() => ({
    userSelect: d ?? "",
    WebkitUserSelect: d ?? "",
    cursor: l ?? ""
  }), [d, l]), B = de((Q) => {
    y.current = Q, C(Q !== null);
  }, []);
  return /* @__PURE__ */ P.createElement("div", { ref: A, className: V, style: k, role: "presentation" }, /* @__PURE__ */ P.createElement("div", { className: x, ref: D, role: "presentation" }, h && E && I && /* @__PURE__ */ P.createElement(pt.Provider, { value: I }, /* @__PURE__ */ P.createElement(
    mv,
    {
      ref: B,
      eFocusableElement: E,
      onTabKeyDown: T,
      gridCtrl: w.current,
      forceFocusOutWhenTabGuardsAreEmpty: !0
    },
    // we wait for initialised before rending the children, so GridComp has created and registered with it's
    // GridCtrl before we create the child GridBodyComp. Otherwise the GridBodyComp would initialise first,
    // before we have set the the Layout CSS classes, causing the GridBodyComp to render rows to a grid that
    // doesn't have it's height specified, which would result if all the rows getting rendered (and if many rows,
    // hangs the UI)
    /* @__PURE__ */ P.createElement(pv, null)
  ))));
}, vv = St(Cv), up = (e) => {
  var t, i;
  const s = N(), o = N(null), r = N(null), n = N([]), l = N([]), a = N(e), d = N(!1), [c, h] = G(void 0), [, g] = G(0), m = de((v) => {
    if (o.current = v, !o.current) {
      n.current.forEach((A) => A()), n.current.length = 0;
      return;
    }
    const y = e.modules || [];
    r.current || (r.current = new GC(
      () => g((A) => A + 1),
      e.componentWrappingElement,
      e.maxComponentCreationTimeMs
    ), n.current.push(() => {
      var A;
      (A = r.current) == null || A.destroy(), r.current = null;
    }));
    const E = Zr.combineAttributesAndGridOptions(e.gridOptions, e), D = {
      providedBeanInstances: {
        frameworkComponentWrapper: new Sv(r.current, !!E.reactiveCustomComponents)
      },
      modules: y,
      frameworkOverrides: new yv()
    }, R = (A) => {
      h(A), n.current.push(() => {
        A.destroy();
      }), A.getBean(ds.NAME).whenReady(() => {
        if (A.isDestroyed())
          return;
        const x = s.current;
        x && e.setGridApi && e.setGridApi(x, new eo(x));
      });
    }, T = (A) => {
      A.getBean(ds.NAME).whenReady(() => {
        l.current.forEach((x) => x()), l.current.length = 0, d.current = !0;
      });
    }, I = new Fm();
    s.current = I.create(
      o.current,
      E,
      R,
      T,
      D
    );
  }, []), C = j(() => be({
    height: "100%"
  }, e.containerStyle || {}), [e.containerStyle]), w = de((v) => {
    d.current ? v() : l.current.push(v);
  }, []);
  return Be(() => {
    const v = wv(a.current, e);
    a.current = e, w(() => {
      s.current && Zr.processOnChange(v, s.current);
    });
  }, [e]), /* @__PURE__ */ P.createElement("div", { style: C, className: e.className, ref: m }, c && !c.isDestroyed() ? /* @__PURE__ */ P.createElement(vv, { context: c }) : null, (i = (t = r.current) == null ? void 0 : t.getPortals()) != null ? i : null);
};
function wv(e, t) {
  const i = {};
  return Object.keys(t).forEach((s) => {
    const o = t[s];
    e[s] !== o && (i[s] = o);
  }), i;
}
var Sv = class extends Lm {
  constructor(e, t) {
    super(), this.parent = e, this.reactiveCustomComponents = t;
  }
  createWrapper(e, t) {
    if (this.reactiveCustomComponents) {
      const o = ((r) => {
        switch (r) {
          case "filter":
            return AC;
          case "floatingFilterComponent":
            return FC;
          case "dateComponent":
            return bC;
          case "loadingOverlayComponent":
            return LC;
          case "noRowsOverlayComponent":
            return MC;
          case "statusPanel":
            return xC;
          case "toolPanel":
            return NC;
          case "menuItem":
            return IC;
        }
      })(t.propertyName);
      if (o)
        return new o(e, this.parent, t);
    } else
      switch (t.propertyName) {
        case "filter":
        case "floatingFilterComponent":
        case "dateComponent":
        case "loadingOverlayComponent":
        case "noRowsOverlayComponent":
        case "statusPanel":
        case "toolPanel":
        case "menuItem":
          md();
          break;
      }
    const i = !t.cellRenderer && t.propertyName !== "toolPanel";
    return new op(e, this.parent, t, i);
  }
}, Ev = _i((e, t) => {
  const { ctrlsFactory: i, context: s, gos: o, resizeObserverService: r, clientSideRowModel: n, serverSideRowModel: l } = Et(pt), [a, d] = G(() => new xt()), [c, h] = G(() => new xt()), [g, m] = G(), [C, w] = G(), v = N(), y = N(null), E = N(), D = j(() => le.__getGridRegisteredModules(e.api.getGridId()), [e]), R = j(() => a.toString() + " ag-details-row", [a]), T = j(() => c.toString() + " ag-details-grid", [c]);
  t && Es(t, () => ({
    refresh() {
      var V, x;
      return (x = (V = v.current) == null ? void 0 : V.refresh()) != null ? x : !1;
    }
  })), e.template && W.warnOnce("detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://ag-grid.com/react-data-grid/master-detail-custom-detail/");
  const I = de((V) => {
    if (y.current = V, !y.current) {
      s.destroyBean(v.current), E.current && E.current();
      return;
    }
    const x = {
      addOrRemoveCssClass: (B, Q) => d((U) => U.setClass(B, Q)),
      addOrRemoveDetailGridCssClass: (B, Q) => h((U) => U.setClass(B, Q)),
      setDetailGrid: (B) => m(B),
      setRowData: (B) => w(B),
      getGui: () => y.current
    }, k = i.getInstance("detailCellRenderer");
    if (k && (s.createBean(k), k.init(x, e), v.current = k, o.get("detailRowAutoHeight"))) {
      const B = () => {
        if (y.current == null)
          return;
        const Q = y.current.clientHeight;
        Q != null && Q > 0 && setTimeout(() => {
          e.node.setRowHeight(Q), n ? n.onRowHeightChanged() : l && l.onRowHeightChanged();
        }, 0);
      };
      E.current = r.observeResize(y.current, B), B();
    }
  }, []), A = de((V, x) => {
    var k;
    (k = v.current) == null || k.registerDetailWithMaster(V, x);
  }, []);
  return /* @__PURE__ */ P.createElement("div", { className: R, ref: I }, g && /* @__PURE__ */ P.createElement(up, at(be({ className: T }, g), { modules: D, rowData: C, setGridApi: A })));
}), yv = class extends Vh {
  constructor() {
    super("react"), this.frameworkComponents = {
      agGroupCellRenderer: eu,
      agGroupRowRenderer: eu,
      agDetailCellRenderer: Ev
    }, this.wrapIncoming = (e, t) => t === "ensureVisible" ? _C(e) : e(), this.renderingEngine = "react";
  }
  frameworkComponent(e) {
    return this.frameworkComponents[e];
  }
  isFrameworkComponent(e) {
    if (!e)
      return !1;
    const t = e.prototype;
    return !(t && "getGui" in t);
  }
}, Rv = class extends mp {
  constructor() {
    super(...arguments), this.apiListeners = [], this.setGridApi = (e, t) => {
      this.api = e, this.columnApi = t, this.apiListeners.forEach((i) => i(e));
    };
  }
  registerApiListener(e) {
    this.apiListeners.push(e);
  }
  componentWillUnmount() {
    this.apiListeners.length = 0;
  }
  render() {
    return /* @__PURE__ */ P.createElement(up, at(be({}, this.props), { setGridApi: this.setGridApi }));
  }
};
const Dv = ys()(({ mode: e, palette: t, typography: i, constructs: s, spacing: o }, { rowCount: r }, n) => {
  var l;
  return {
    root: {
      outline: e === Ir.Dye ? `1px solid ${Mr.main}` : void 0,
      "& .ag-header": {
        backgroundColor: t.gray[100]
      },
      "& .ag-header-row": {
        backgroundColor: ie.ifFeature("encore", s.surface.neutral.xxWeak)
      },
      "& .ag-header-cell": {
        textAlign: "center",
        fontFamily: i.fontFamily,
        fontWeight: i.fontWeightRegular,
        fontSize: (l = i.medium) == null ? void 0 : l.fontSize,
        paddingRight: ie.ifFeature("encore", o(1)),
        paddingLeft: ie.ifFeature("encore", o(1)),
        "--ag-header-column-separator-display": "block",
        "--ag-header-column-separator-height": "100%",
        "--ag-header-column-separator-width": "1px",
        "--ag-header-column-separator-color": ie.ifFeature("encore", s.border.neutral.weak, t.gray[200]),
        "--ag-header-column-resize-handle-display": "block",
        "--ag-header-column-resize-handle-height": "100%",
        "--ag-header-column-resize-handle-width": "1px",
        "--ag-header-column-resize-handle-color": e === Ir.Dye ? Mr.main : ie.ifFeature("encore", s.border.neutral.weak, t.gray[200])
      },
      ".ag-theme-alpine &": {
        "--ag-border-color": ie.ifFeature("encore", s.border.neutral.weak, t.gray[200]),
        "--ag-row-border-color": e === Ir.Dye ? Mr.main : ie.ifFeature("encore", s.border.neutral.weak, t.gray[200]),
        "--ag-header-column-separator-display": "block"
      },
      "& .ag-ltr .ag-cell": {
        paddingRight: ie.ifFeature("encore", o(1)),
        paddingLeft: ie.ifFeature("encore", o(1)),
        borderRight: `solid 1px ${e === Ir.Dye ? Mr.main : ie.ifFeature("encore", s.border.neutral.weak, t.gray[200])}`,
        "& > *": {
          fontFamily: i.fontFamily,
          fontSize: i.medium.fontSize
        },
        [`&.ag-cell-focus:not(.${n.delete}, .error-col, .warning-col, .info-col)`]: ie.ifFeature("encore", {
          borderRadius: 0,
          outline: `${s.border.info.medium} solid 2px !important`,
          outlineOffset: "-2px"
        })
      },
      [`& .${n.delete}`]: {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        padding: 0
      },
      "& .ag-cell.error-col": {
        outline: `${ie.ifFeature("encore", s.border.error.medium, t.error.main)} solid 1px !important`,
        backgroundColor: ie.ifFeature("encore", s.surface.error.weak, "#fbeeee"),
        outlineOffset: "-2px",
        "&.ag-cell-focus": ie.ifFeature("encore", {
          borderRadius: 0,
          outline: `${s.border.error.medium} solid 2px !important`
        })
      },
      "& .ag-cell.warning-col": {
        outline: `${ie.ifFeature("encore", s.border.warning.medium, t.warning.main)} solid 1px !important`,
        backgroundColor: ie.ifFeature("encore", s.surface.warning.weak, "#f3e9db"),
        outlineOffset: "-2px",
        "&.ag-cell-focus": ie.ifFeature("encore", {
          borderRadius: 0,
          outline: `${s.border.warning.medium} solid 2px !important`
        })
      },
      "& .ag-cell.info-col": {
        outline: `${ie.ifFeature("encore", s.border.info.medium, t.info.main)} solid 1px !important`,
        backgroundColor: ie.ifFeature("encore", s.surface.info.weak, "#e6f1f7"),
        outlineOffset: "-2px",
        "&.ag-cell-focus": ie.ifFeature("encore", {
          borderRadius: 0,
          outline: `${s.border.info.medium} solid 2px !important`
        })
      },
      // AG Grid has a default 150px min-height when using `domLayout="autoHeight"`. This can cause an ugly space between the last row and the bottom border, so we disable it, unless there is no data to show, in which case we leave it so the "no data" message can be displayed.
      // See bottom of this section: https://www.ag-grid.com/javascript-data-grid/grid-size/#grid-auto-height
      "&& .ag-layout-auto-height .ag-center-cols-clipper": {
        minHeight: r > 0 ? "unset" : void 0
      }
    },
    rowCol: {
      backgroundColor: ie.ifFeature("encore", s.surface.neutral.xxWeak, t.gray[100]),
      textAlign: "center"
    },
    delete: {
      "&:focus-within": {
        borderColor: "transparent !important",
        borderRightColor: `${ie.ifFeature("encore", s.border.neutral.weak, t.gray[200])} !important`
      }
    }
  };
}), Tv = ys()((e) => {
  const { palette: t, spacing: i, typography: s } = e;
  return {
    icon: {
      fill: t.error.main
    },
    subtitle: {
      lineHeight: s.body1.lineHeight,
      marginTop: i(0.5)
    }
  };
});
function bv({ biId: e, isOpen: t, onCancel: i, onSubmit: s }) {
  const { classes: o } = Tv();
  return /* @__PURE__ */ Z.jsx(Di, { "data-bi-id": e, isOpen: t, onRequestClose: i, children: /* @__PURE__ */ Z.jsx(
    Di.Body,
    {
      renderFooter: /* @__PURE__ */ Z.jsx(
        Di.Footer,
        {
          actions: ie.ifFeature(
            "encore",
            [
              /* @__PURE__ */ Z.jsx(
                Sd,
                {
                  "data-bi-id": e ? `${e}-cancel-button` : void 0,
                  onClick: i,
                  children: "Cancel"
                },
                "cancel-button"
              ),
              /* @__PURE__ */ Z.jsx(Ed, { "data-bi-id": e ? `${e}-submit-button` : void 0, onClick: s, children: window.jQuery ? $.__("Delete Row") : "Delete Row" }, "submit-button")
            ],
            [
              /* @__PURE__ */ Z.jsx(Ed, { "data-bi-id": e ? `${e}-submit-button` : void 0, onClick: s, children: window.jQuery ? $.__("Delete Row") : "Delete Row" }, "submit-button"),
              /* @__PURE__ */ Z.jsx(
                Sd,
                {
                  "data-bi-id": e ? `${e}-cancel-button` : void 0,
                  onClick: i,
                  children: "Cancel"
                },
                "cancel-button"
              )
            ]
          )
        }
      ),
      renderHeader: /* @__PURE__ */ Z.jsx(Di.Header, { title: window.jQuery ? $.__("Just Checking...") : "Just Checking..." }),
      children: /* @__PURE__ */ Z.jsx(
        Di.Constraint,
        {
          spacingOverrides: {
            top: Di.Constraint.Spacing.LARGE,
            bottom: Di.Constraint.Spacing.LARGE
          },
          children: /* @__PURE__ */ Z.jsx(
            Di.HeroHeadline,
            {
              icon: ie.ifFeature("encore", "trash-can-solid", /* @__PURE__ */ Z.jsx(au, { className: o.icon })),
              iconColor: "error-strong",
              text: window.jQuery ? $.__("Are you sure you want to delete this row?") : "Are you sure you want to delete this row?",
              children: /* @__PURE__ */ Z.jsx("p", { className: o.subtitle, children: window.jQuery ? $.__("Once deleted, we can't bring it back. However, you can always start over!") : "Once deleted, we can't bring it back. However, you can always start over!" })
            }
          )
        }
      )
    }
  ) });
}
const Av = ys()((e, t) => {
  const { palette: i } = e, { status: s } = t;
  let o;
  switch (s) {
    case "error":
      o = i.error.main;
      break;
    case "warning":
      o = i.warning.main;
      break;
    case "info":
      o = i.info.main;
      break;
    default:
      o = i.primary.main;
      break;
  }
  return {
    text: {
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    icon: {
      alignSelf: "center",
      fill: o,
      flex: "0 0 auto",
      marginLeft: "2px"
    }
  };
}), Pv = ys()(({ typography: e, constructs: t }) => ({
  dataGridCellValue: {
    color: t.text.neutral.strong,
    flex: 1,
    fontSize: e.medium.fontSize,
    fontWeight: e.fontWeightRegular,
    lineHeight: e.medium.lineHeight,
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
})), Fv = (e) => {
  switch (e) {
    case "error":
      return Tp;
    case "warning":
      return lu;
    case "info":
      return nu;
    default:
      return null;
  }
}, Lv = (e) => {
  switch (e) {
    case "error":
      return { name: "circle-exclamation-solid", color: "error-medium" };
    case "warning":
      return { name: "triangle-exclamation-solid", color: "warning-medium" };
    case "info":
      return { name: "circle-info-solid", color: "info-medium" };
    default:
      return null;
  }
}, cp = (e) => {
  const { eGridCell: t, getStatus: i, value: s, valueFormatted: o, colDef: r } = e, { status: n, message: l, title: a } = (i == null ? void 0 : i(e)) ?? {}, [d, c] = G(null), [h, g] = G(!1), m = o ?? s, { classes: C } = Av({ status: n }), { classes: w } = Pv(), v = () => {
    g(!0);
  }, y = () => {
    g(!1);
  }, E = () => n ? /* @__PURE__ */ Z.jsx(Rp, { anchorEl: d, content: l, open: h, title: a }) : null;
  Be(() => {
    const R = (T) => {
      T.key === "Escape" && y();
    };
    return t.addEventListener("focus", v), t.addEventListener("blur", y), t.addEventListener("mouseenter", v), t.addEventListener("mouseleave", y), t.addEventListener("keydown", R), () => {
      t.removeEventListener("focus", v), t.removeEventListener("blur", y), t.removeEventListener("mouseenter", v), t.removeEventListener("mouseleave", y), t.removeEventListener("keydown", R);
    };
  }, [t]), Be(() => {
    if (!n || m === void 0) {
      t.classList.remove("info-col", "error-col", "warning-col");
      return;
    }
    switch (n) {
      case "error":
        t.classList.add("error-col"), t.classList.remove("info-col", "warning-col");
        break;
      case "info":
        t.classList.add("info-col"), t.classList.remove("error-col", "warning-col");
        break;
      case "warning":
        t.classList.add("warning-col"), t.classList.remove("info-col", "error-col");
        break;
      default:
        throw new Error(`Unknown status: ${n}`);
    }
  }, [t, m, n]);
  const D = ie.ifFeature(
    "encore",
    () => {
      if (!n)
        return null;
      const R = Lv(n);
      return R ? /* @__PURE__ */ Z.jsx(Dl, { ariaLabel: ou(n), color: R.color, name: R.name, size: 16 }) : null;
    },
    () => {
      if (!n)
        return null;
      const R = Fv(n);
      return R ? /* @__PURE__ */ Z.jsx(R, { "aria-label": ou(n), className: C.icon, role: "img" }) : null;
    }
  );
  return /* @__PURE__ */ Z.jsxs(
    Dp,
    {
      alignItems: "center",
      columnGap: ie.ifFeature("encore", "8px"),
      height: "100%",
      justifyContent: "space-between",
      ref: c,
      width: "100%",
      children: [
        ie.ifFeature(
          "encore",
          /* @__PURE__ */ Z.jsx(Z.Fragment, { children: m === void 0 ? /* @__PURE__ */ Z.jsx(bp, { marginRight: "auto", children: /* @__PURE__ */ Z.jsx(yd, { small: !0 }) }) : /* @__PURE__ */ Z.jsx("div", { className: w.dataGridCellValue, children: m }) }),
          /* @__PURE__ */ Z.jsx("span", { className: C.text, children: m === void 0 ? /* @__PURE__ */ Z.jsx(yd, { small: !0 }) : m })
        ),
        D(),
        ie.ifFeature("encore", (r == null ? void 0 : r.type) === "dropdown" && /* @__PURE__ */ Z.jsx(Dl, { color: "neutral-strong", name: "caret-down-solid", size: 16 })),
        E()
      ]
    }
  );
};
function Iv() {
  const e = N(!1);
  return Be(() => (e.current = !0, () => {
    e.current = !1;
  }), []), de(() => e.current, []);
}
const Mv = ys()(() => ({
  root: {
    background: "none",
    color: "inherit",
    border: "none",
    font: "inherit",
    cursor: "pointer",
    outline: "inherit",
    textAlign: "inherit",
    width: "100%",
    height: "100%",
    padding: ie.ifFeature("encore", 0, "0 17px"),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  formattedValue: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  menuWrapper: {
    height: "100%",
    "& > div": {
      height: "100%"
    }
  }
})), xv = _i((e, t) => {
  const {
    colDef: i,
    data: s,
    eGridCell: o,
    formatValue: r,
    parseValue: n,
    value: l,
    options: a,
    onSearch: d,
    showSearch: c,
    stopEditing: h
  } = e, g = N(null), [m, C] = G(a), [w, v] = G(m.find((x) => x.value === l)), [y, E] = G(!1), [D, R] = G(""), { classes: T } = Mv(), I = Iv();
  Es(
    t,
    () => ({
      getValue() {
        return n(w ? w.value : l);
      }
    }),
    [n, w, l]
  );
  const A = d && (async (x) => {
    R(x);
    const k = await Promise.resolve(d(x, m));
    C(k);
  }), V = (x) => {
    v(x), E(!1), setTimeout(() => {
      I() && h();
    });
  };
  return Be(() => {
    var x;
    (x = g.current) == null || x.focus();
  }, []), Be(() => {
    const x = setTimeout(() => {
      E(!0);
    });
    return () => clearTimeout(x);
  }, []), /* @__PURE__ */ Z.jsx("div", { className: T.menuWrapper, children: /* @__PURE__ */ Z.jsx(
    yp,
    {
      isFullWidth: !0,
      isOpen: y,
      items: m,
      onClose: () => {
        E(!1);
      },
      onOpen: () => E(!0),
      onSearch: A,
      onSelect: V,
      renderToggle: (x, k) => {
        const { ref: B, style: Q, ...U } = k;
        return /* @__PURE__ */ Z.jsx("button", { ...U, className: T.root, ref: Ep(g, B), type: "button", children: ie.ifFeature(
          "encore",
          /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
            /* @__PURE__ */ Z.jsxs("span", { className: T.formattedValue, children: [
              " ",
              r(l) ?? l
            ] }),
            /* @__PURE__ */ Z.jsx(Dl, { color: "neutral-strong", name: "caret-up-solid", size: 16 })
          ] }),
          /* @__PURE__ */ Z.jsx(
            cp,
            {
              ...i.cellRendererParams,
              colDef: i,
              data: s,
              eGridCell: o,
              value: l,
              valueFormatted: r(l)
            }
          )
        ) });
      },
      searchText: d ? D : void 0,
      selectedItems: w ? [w] : [],
      showSearch: c
    }
  ) });
}), Nv = ys()(({ typography: e }) => ({
  textInput: {
    backgroundColor: "transparent",
    boxSizing: "border-box",
    border: "none",
    display: "flex",
    fontSize: e.medium.fontSize,
    height: "100%",
    padding: ie.ifFeature("encore", 0, "0 17px"),
    width: "100%",
    "&:focus": {
      outline: "none"
    }
  }
})), su = _i((e, t) => {
  const { parseValue: i, value: s } = e, [o, r] = G(s), { classes: n } = Nv(), l = N(null);
  Be(() => {
    var d;
    (d = l.current) == null || d.focus();
  }, []), Es(t, () => ({
    getValue() {
      return i(o);
    }
  }));
  const a = (d) => {
    r(d.target.value);
  };
  return /* @__PURE__ */ Z.jsx("input", { className: n.textInput, onChange: a, ref: l, type: "text", value: o });
}), Gv = ys()(() => ({
  datePicker: ie.ifFeature(
    "encore",
    {
      "& > .fabInternal-DatePickerInput .MuiInputBase-root": {
        backgroundColor: "var(--ag-control-panel-background-color)",
        border: "var(--ag-borders) var(--ag-border-color)",
        borderRadius: "var(--ag-card-radius)",
        boxShadow: "none",
        "&&:focus-within": {
          boxShadow: "none"
        }
      }
    },
    {
      backgroundColor: "transparent",
      display: "block",
      height: "100%",
      padding: "0 6px",
      "&& div": {
        backgroundColor: "transparent",
        border: "none",
        height: "100%",
        width: "100%",
        "&:focus-within": {
          boxShadow: "none"
        }
      },
      // Targets containing div of the Datepicker input
      "& > div > div > div > div > div:first-of-type": {
        alignItems: "baseline",
        boxShadow: "none",
        display: "flex",
        height: "100%",
        padding: "0 16px",
        width: "50%",
        marginLeft: "0"
      }
    }
  )
})), Ov = _i((e, t) => {
  const { parseValue: i, stopEditing: s, value: o } = e, { classes: r } = Gv(), n = N(null), [l, a] = G(!1), [d, c] = G({ value: o });
  return Be(() => {
    var h;
    return (h = n.current) == null ? void 0 : h.focus();
  }, []), Be(() => {
    l && s();
  }, [l, s]), Es(
    t,
    () => ({
      getValue() {
        let h;
        const { text: g, value: m } = d || {};
        return m ? h = m : g ? h = o : h = null, i(h);
      }
    }),
    [d, o, i]
  ), /* @__PURE__ */ Z.jsx(
    Sp,
    {
      className: r.datePicker,
      inputProps: {
        ref: n
      },
      onCalendarDateSelect: ({ text: h = "", value: g = "" }) => {
        c({ text: h, value: g }), a(!0);
      },
      onChange: Rl.noop,
      onInputChange: ({ text: h = "", value: g = "" }) => {
        (g || !(h && g)) && c({ text: h, value: g });
      },
      value: d.value
    }
  );
}), _v = _i((e, t) => {
  const { colDef: i, getType: s } = e;
  switch ((s == null ? void 0 : s(e)) ?? (i == null ? void 0 : i.type)) {
    case "text":
      return /* @__PURE__ */ Z.jsx(su, { ...e, ref: t });
    case "dropdown":
      return /* @__PURE__ */ Z.jsx(xv, { ...e, ref: t });
    case "date":
      return /* @__PURE__ */ Z.jsx(Ov, { ...e, ref: t });
    default:
      return /* @__PURE__ */ Z.jsx(su, { ...e, ref: t });
  }
}), Vv = {
  cellDataType: !1,
  resizable: !0,
  suppressMovable: !0,
  initialWidth: 190,
  editable: !0
}, hp = "dataGridDelete", Hv = "dataGridRowId", kv = (e) => ({ ...Vv, cellEditor: _v, cellRenderer: cp, ...e }), Bv = ({ api: e, data: t, node: i, onDeleteRow: s, rowIndex: o, eGridCell: r }) => {
  const n = N(null), l = window.jQuery ? $.__("Delete row %s", o + 1) : `Delete row ${o + 1}`, a = () => {
    const d = () => {
      const c = e.getModel().getRowCount() - 1, h = o === c ? c - 1 : o;
      e.applyTransaction({ remove: [i] }), h > -1 && requestAnimationFrame(() => {
        e.setFocusedCell(h, hp);
      });
    };
    s == null || s(t, d);
  };
  return Be(() => {
    const d = () => {
      var c;
      return (c = n.current) == null ? void 0 : c.focus();
    };
    return r.addEventListener("focus", d), () => r.removeEventListener("focus", d);
  }, [r]), ie.ifFeature(
    "encore",
    /* @__PURE__ */ Z.jsx(
      Dd,
      {
        ariaLabel: l,
        color: "secondary",
        floatingIcon: !0,
        icon: "xmark-solid",
        noBoundingBox: !0,
        onClick: a,
        ref: n,
        size: "small",
        tabindex: -1
      }
    ),
    /* @__PURE__ */ Z.jsx(
      Dd,
      {
        ariaLabel: l,
        color: "secondary",
        floatingIcon: !0,
        icon: /* @__PURE__ */ Z.jsx(Ap, {}),
        onClick: a,
        ref: n,
        tabindex: -1,
        variant: "outlined"
      }
    )
  );
}, Wv = ({
  columnDefs: e,
  deletionColumnClass: t,
  getRowNumber: i,
  hideRowNumbers: s,
  onDeleteRow: o,
  rowNumberColumnClass: r
}) => {
  const n = {
    cellClass: r,
    cellRenderer: (d) => i(d),
    editable: !1,
    field: Hv,
    headerComponent: Rd,
    headerComponentParams: {
      children: window.jQuery ? $.__("Row number") : "Row number"
    },
    resizable: !1,
    suppressAutoSize: !0,
    width: 70
  }, l = {
    cellClass: t,
    cellRenderer: Bv,
    cellRendererParams: {
      onDeleteRow: o
    },
    editable: !1,
    field: hp,
    headerComponent: Rd,
    headerComponentParams: {
      children: window.jQuery ? $.__("Row deletion") : "Row deletion"
    },
    resizable: !1,
    suppressAutoSize: !0,
    width: 34
  };
  let a = [...e];
  return s || (a = [n, ...a]), o && (a = [l, ...a]), a;
};
function Uv(e) {
  return () => {
    var i;
    const t = [];
    return (i = e.current) == null || i.api.forEachNode((s) => {
      t.push(s.data);
    }), t;
  };
}
function zv(e) {
  if (!Pp(e.data))
    throw new Error(`Row data should be an object but got: ${JSON.stringify(e.data)}.`);
  if (typeof e.data.id != "string")
    throw new Error(
      `The "id" property for your row data must be a string type: ${JSON.stringify(
        e.data
      )}. Update the "id" property to be a string or supply your own "getRowId" function to use a different property for your row ID.`
    );
  return e.data.id;
}
function Kv(e) {
  return e.rowIndex + 1;
}
const ou = (e) => {
  switch (e) {
    case "error":
      return window.jQuery ? $.__("error") : "error";
    case "warning":
      return window.jQuery ? $.__("warning") : "warning";
    case "info":
      return window.jQuery ? $.__("info") : "info";
    default:
      return "";
  }
}, $v = (e) => ({ value: t }) => {
  const i = Cp.fromISO(t);
  return i.isValid ? wp(e, i) ?? t : t;
}, jv = () => {
  const e = /* @__PURE__ */ new WeakMap();
  return ({ colDef: t, value: i }) => {
    var n, l;
    const s = (n = t.cellEditorParams) == null ? void 0 : n.options;
    if (!(s != null && s.length))
      return i;
    const o = e.get(s);
    if (o != null && o.has(i))
      return o.get(i);
    let r = i;
    for (let a = 0; a < s.length; a++) {
      const d = s[a];
      if (d.value === i) {
        r = d.text;
        break;
      }
    }
    return (l = o ?? e.set(s, /* @__PURE__ */ new Map()).get(s)) == null || l.set(i, r), r;
  };
};
function Yv(e, t) {
  const {
    columnDefs: i,
    columnTypes: s,
    infiniteLoadingChunkSize: o,
    infinite: r = !1,
    defaultColDef: n = {},
    domLayout: l,
    getRowId: a = zv,
    getRowNumber: d = Kv,
    hideRowNumbers: c = !1,
    initialRowData: h = [],
    onCellClicked: g,
    onCellEditingStarted: m,
    onCellEditingStopped: C,
    onDeleteRow: w,
    onGridReady: v
  } = e, [y, E] = G(r ? [] : () => Rl.cloneDeep(h)), { classes: D } = Dv({ rowCount: y.length }), R = j(() => kv(n), [n]), T = j(
    () => Wv({
      columnDefs: i,
      deletionColumnClass: D.delete,
      getRowNumber: d,
      hideRowNumbers: c,
      onDeleteRow: w,
      rowNumberColumnClass: D.rowCol
    }),
    [D.delete, D.rowCol, i, c, w, d]
  ), I = N(null);
  Es(t, () => ({
    getAllRowData: Uv(I),
    getEditingCells: () => {
      var V, x;
      return ((x = (V = I.current) == null ? void 0 : V.api) == null ? void 0 : x.getEditingCells()) || [];
    },
    setRowData: (V) => (
      // rows is copied to preserve the initial data since the data is mutated by ag-grid
      E(Rl.cloneDeep(typeof V == "function" ? V(y) : V))
    )
  }));
  const A = vp();
  return /* @__PURE__ */ Z.jsx("div", { className: "ag-theme-alpine", "data-fabric-component": "DataGrid", style: { height: "100%", width: "100%" }, children: i && y && /* @__PURE__ */ Z.jsx(
    Rv,
    {
      cacheBlockSize: o,
      className: D.root,
      columnDefs: T,
      columnTypes: {
        text: {},
        dropdown: { valueFormatter: jv() },
        date: {
          valueFormatter: $v(A),
          cellEditorPopup: ie.ifFeature("encore", !0, !1)
        },
        ...s
      },
      defaultColDef: R,
      domLayout: l,
      getRowId: a,
      headerHeight: 34,
      onCellClicked: g,
      onCellEditingStarted: m,
      onCellEditingStopped: C,
      onGridReady: v,
      overlayNoRowsTemplate: window.jQuery ? $.__("No Rows To Show") : "No Rows To Show",
      ref: I,
      rowData: y,
      rowHeight: ie.ifFeature("encore", 34),
      rowModelType: r ? "infinite" : "clientSide",
      singleClickEdit: !0,
      tooltipHideDelay: 15e3,
      tooltipShowDelay: 500
    }
  ) });
}
const qv = _i(Yv), Qv = qv;
Qv.DeletionModal = bv;
export {
  Qv as D
};
//# sourceMappingURL=data-grid-BGIjX6ka.mjs.map
